export const chickenRecipes = {
    "from": 1,
    "to": 20,
    "count": 10000,
    "_links": {
        "next": {
            "href": "https://api.edamam.com/api/recipes/v2?q=chicken&app_key=fd382a172ba8d6668c0430dc9c14a181&_cont=CHcVQBtNNQphDmgVQntAEX4BYldtBAAGRmxGC2ERYVJ2BwoVX3cVBWQSY1EhBQcGEmNHVmMTYFEgDQQCFTNJBGQUMQZxVhFqX3cWQT1OcV9xBB8VADQWVhFCPwoxXVZEITQeVDcBaR4-SQ%3D%3D&type=public&app_id=ea1d37d5",
            "title": "Next page"
        }
    },
    "hits": [
        {
            "recipe": {
                "uri": "http://www.edamam.com/ontologies/edamam.owl#recipe_b79327d05b8e5b838ad6cfd9576b30b6",
                "label": "Chicken Vesuvio",
                "image": "https://www.edamam.com/web-img/e42/e42f9119813e890af34c259785ae1cfb.jpg",
                "source": "Serious Eats",
                "url": "http://www.seriouseats.com/recipes/2011/12/chicken-vesuvio-recipe.html",
                "shareAs": "http://www.edamam.com/recipe/chicken-vesuvio-b79327d05b8e5b838ad6cfd9576b30b6/chicken",
                "yield": 4,
                "dietLabels": [
                    "Low-Carb"
                ],
                "healthLabels": [
                    "Mediterranean",
                    "Dairy-Free",
                    "Gluten-Free",
                    "Wheat-Free",
                    "Egg-Free",
                    "Peanut-Free",
                    "Tree-Nut-Free",
                    "Soy-Free",
                    "Fish-Free",
                    "Shellfish-Free",
                    "Pork-Free",
                    "Red-Meat-Free",
                    "Crustacean-Free",
                    "Celery-Free",
                    "Mustard-Free",
                    "Sesame-Free",
                    "Lupine-Free",
                    "Mollusk-Free",
                    "Kosher"
                ],
                "cautions": [
                    "Sulfites"
                ],
                "ingredientLines": [
                    "1/2 cup olive oil",
                    "5 cloves garlic, peeled",
                    "2 large russet potatoes, peeled and cut into chunks",
                    "1 3-4 pound chicken, cut into 8 pieces (or 3 pound chicken legs)",
                    "3/4 cup white wine",
                    "3/4 cup chicken stock",
                    "3 tablespoons chopped parsley",
                    "1 tablespoon dried oregano",
                    "Salt and pepper",
                    "1 cup frozen peas, thawed"
                ],
                "ingredients": [
                    {
                        "text": "1/2 cup olive oil",
                        "weight": 108,
                        "foodCategory": "Oils",
                        "foodId": "food_b1d1icuad3iktrbqby0hiagafaz7",
                        "image": "https://www.edamam.com/food-img/4d6/4d651eaa8a353647746290c7a9b29d84.jpg"
                    },
                    {
                        "text": "5 cloves garlic, peeled",
                        "weight": 15,
                        "foodCategory": "vegetables",
                        "foodId": "food_avtcmx6bgjv1jvay6s6stan8dnyp",
                        "image": "https://www.edamam.com/food-img/6ee/6ee142951f48aaf94f4312409f8d133d.jpg"
                    },
                    {
                        "text": "2 large russet potatoes, peeled and cut into chunks",
                        "weight": 738,
                        "foodCategory": "vegetables",
                        "foodId": "food_brsjy86bq09pzgbmr4ri8bnohrf7",
                        "image": "https://www.edamam.com/food-img/71b/71b3756ecfd3d1efa075874377038b67.jpg"
                    },
                    {
                        "text": "1 3-4 pound chicken, cut into 8 pieces (or 3 pound chicken legs)",
                        "weight": 1587.5732950000001,
                        "foodCategory": "Poultry",
                        "foodId": "food_bmyxrshbfao9s1amjrvhoauob6mo",
                        "image": "https://www.edamam.com/food-img/d33/d338229d774a743f7858f6764e095878.jpg"
                    },
                    {
                        "text": "3/4 cup white wine",
                        "weight": 176.39999999999998,
                        "foodCategory": "wines",
                        "foodId": "food_bn44h7baron9ufaoxinmya8l0yye",
                        "image": "https://www.edamam.com/food-img/a71/a718cf3c52add522128929f1f324d2ab.jpg"
                    },
                    {
                        "text": "3/4 cup chicken stock",
                        "weight": 180,
                        "foodCategory": "canned soup",
                        "foodId": "food_bptblvzambd16nbhewqmhaw1rnh5",
                        "image": "https://www.edamam.com/food-img/26a/26a10c4cb4e07bab54d8a687ef5ac7d8.jpg"
                    },
                    {
                        "text": "3 tablespoons chopped parsley",
                        "weight": 11.399999999999999,
                        "foodCategory": "vegetables",
                        "foodId": "food_b244pqdazw24zobr5vqu2bf0uid8",
                        "image": "https://www.edamam.com/food-img/46a/46a132e96626d7989b4d6ed8c91f4da0.jpg"
                    },
                    {
                        "text": "1 tablespoon dried oregano",
                        "weight": 2.9999999997971143,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_bkkw6v3bdf0sqiazmzyuiax7i8jr",
                        "image": "https://www.edamam.com/food-img/1b0/1b0eaffb1c261606e0d82fed8e9747a7.jpg"
                    },
                    {
                        "text": "Salt and pepper",
                        "weight": 17.720239769998784,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_btxz81db72hwbra2pncvebzzzum9",
                        "image": "https://www.edamam.com/food-img/694/6943ea510918c6025795e8dc6e6eaaeb.jpg"
                    },
                    {
                        "text": "Salt and pepper",
                        "weight": 8.860119884999392,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_b6ywzluaaxv02wad7s1r9ag4py89",
                        "image": "https://www.edamam.com/food-img/c6e/c6e5c3bd8d3bc15175d9766971a4d1b2.jpg"
                    },
                    {
                        "text": "1 cup frozen peas, thawed",
                        "weight": 134,
                        "foodCategory": "vegetables",
                        "foodId": "food_aqrct01b4nxw5eaxoo8woaxc3xd7",
                        "image": "https://www.edamam.com/food-img/c91/c9130a361d5c5b279bf48c69e2466ec2.jpg"
                    }
                ],
                "calories": 4228.043058200812,
                "totalWeight": 2976.8664549004047,
                "totalTime": 60,
                "cuisineType": [
                    "american"
                ],
                "mealType": [
                    "lunch/dinner"
                ],
                "dishType": [
                    "main course"
                ],
                "totalNutrients": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 4228.043058200812,
                        "unit": "kcal"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 274.4489059026023,
                        "unit": "g"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 62.497618998656044,
                        "unit": "g"
                    },
                    "FATRN": {
                        "label": "Trans",
                        "quantity": 1.047163345382,
                        "unit": "g"
                    },
                    "FAMS": {
                        "label": "Monounsaturated",
                        "quantity": 147.39060633938868,
                        "unit": "g"
                    },
                    "FAPU": {
                        "label": "Polyunsaturated",
                        "quantity": 47.35051984782951,
                        "unit": "g"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 175.96206666631727,
                        "unit": "g"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 19.83181033081862,
                        "unit": "g"
                    },
                    "SUGAR": {
                        "label": "Sugars",
                        "quantity": 16.239344767255698,
                        "unit": "g"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 230.72689680763318,
                        "unit": "g"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 815.06238045,
                        "unit": "mg"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 6888.614561646296,
                        "unit": "mg"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 400.0807431570531,
                        "unit": "mg"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 478.1771035229573,
                        "unit": "mg"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 5918.1808352043345,
                        "unit": "mg"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 22.546435238210286,
                        "unit": "mg"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 18.341531378501646,
                        "unit": "mg"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 2231.0712550999992,
                        "unit": "mg"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 635.3716670147774,
                        "unit": "µg"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 103.72979744959534,
                        "unit": "mg"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 1.7264528338354403,
                        "unit": "mg"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 1.9119200245119274,
                        "unit": "mg"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 86.90416982948213,
                        "unit": "mg"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 6.886357390963229,
                        "unit": "mg"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 276.2712108159691,
                        "unit": "µg"
                    },
                    "FOLFD": {
                        "label": "Folate (food)",
                        "quantity": 276.2712108159691,
                        "unit": "µg"
                    },
                    "FOLAC": {
                        "label": "Folic acid",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 3.34660450586,
                        "unit": "µg"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 2.1590996812000003,
                        "unit": "µg"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 19.62869476856695,
                        "unit": "mg"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 353.31486385948267,
                        "unit": "µg"
                    },
                    "WATER": {
                        "label": "Water",
                        "quantity": 1738.7966568296217,
                        "unit": "g"
                    }
                },
                "totalDaily": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 211.4021529100406,
                        "unit": "%"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 422.2290860040035,
                        "unit": "%"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 312.48809499328024,
                        "unit": "%"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 58.65402222210575,
                        "unit": "%"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 79.32724132327448,
                        "unit": "%"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 461.4537936152663,
                        "unit": "%"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 271.68746015,
                        "unit": "%"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 287.0256067352624,
                        "unit": "%"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 40.008074315705315,
                        "unit": "%"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 113.85169131498982,
                        "unit": "%"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 125.9187411745603,
                        "unit": "%"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 125.25797354561271,
                        "unit": "%"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 166.74119435001495,
                        "unit": "%"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 318.7244650142856,
                        "unit": "%"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 70.59685189053081,
                        "unit": "%"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 115.25533049955037,
                        "unit": "%"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 143.8710694862867,
                        "unit": "%"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 147.0707711163021,
                        "unit": "%"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 543.1510614342633,
                        "unit": "%"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 529.7197993048637,
                        "unit": "%"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 69.06780270399227,
                        "unit": "%"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 139.44185441083332,
                        "unit": "%"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 14.393997874666669,
                        "unit": "%"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 130.85796512377968,
                        "unit": "%"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 294.42905321623556,
                        "unit": "%"
                    }
                },
                "digest": [
                    {
                        "label": "Fat",
                        "tag": "FAT",
                        "schemaOrgTag": "fatContent",
                        "total": 274.4489059026023,
                        "hasRDI": true,
                        "daily": 422.2290860040035,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Saturated",
                                "tag": "FASAT",
                                "schemaOrgTag": "saturatedFatContent",
                                "total": 62.497618998656044,
                                "hasRDI": true,
                                "daily": 312.48809499328024,
                                "unit": "g"
                            },
                            {
                                "label": "Trans",
                                "tag": "FATRN",
                                "schemaOrgTag": "transFatContent",
                                "total": 1.047163345382,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Monounsaturated",
                                "tag": "FAMS",
                                "schemaOrgTag": null,
                                "total": 147.39060633938868,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Polyunsaturated",
                                "tag": "FAPU",
                                "schemaOrgTag": null,
                                "total": 47.35051984782951,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Carbs",
                        "tag": "CHOCDF",
                        "schemaOrgTag": "carbohydrateContent",
                        "total": 175.96206666631727,
                        "hasRDI": true,
                        "daily": 58.65402222210575,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Carbs (net)",
                                "tag": "CHOCDF.net",
                                "schemaOrgTag": null,
                                "total": 156.13025633549864,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Fiber",
                                "tag": "FIBTG",
                                "schemaOrgTag": "fiberContent",
                                "total": 19.83181033081862,
                                "hasRDI": true,
                                "daily": 79.32724132327448,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars",
                                "tag": "SUGAR",
                                "schemaOrgTag": "sugarContent",
                                "total": 16.239344767255698,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars, added",
                                "tag": "SUGAR.added",
                                "schemaOrgTag": null,
                                "total": 0,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Protein",
                        "tag": "PROCNT",
                        "schemaOrgTag": "proteinContent",
                        "total": 230.72689680763318,
                        "hasRDI": true,
                        "daily": 461.4537936152663,
                        "unit": "g"
                    },
                    {
                        "label": "Cholesterol",
                        "tag": "CHOLE",
                        "schemaOrgTag": "cholesterolContent",
                        "total": 815.06238045,
                        "hasRDI": true,
                        "daily": 271.68746015,
                        "unit": "mg"
                    },
                    {
                        "label": "Sodium",
                        "tag": "NA",
                        "schemaOrgTag": "sodiumContent",
                        "total": 6888.614561646296,
                        "hasRDI": true,
                        "daily": 287.0256067352624,
                        "unit": "mg"
                    },
                    {
                        "label": "Calcium",
                        "tag": "CA",
                        "schemaOrgTag": null,
                        "total": 400.0807431570531,
                        "hasRDI": true,
                        "daily": 40.008074315705315,
                        "unit": "mg"
                    },
                    {
                        "label": "Magnesium",
                        "tag": "MG",
                        "schemaOrgTag": null,
                        "total": 478.1771035229573,
                        "hasRDI": true,
                        "daily": 113.85169131498982,
                        "unit": "mg"
                    },
                    {
                        "label": "Potassium",
                        "tag": "K",
                        "schemaOrgTag": null,
                        "total": 5918.1808352043345,
                        "hasRDI": true,
                        "daily": 125.9187411745603,
                        "unit": "mg"
                    },
                    {
                        "label": "Iron",
                        "tag": "FE",
                        "schemaOrgTag": null,
                        "total": 22.546435238210286,
                        "hasRDI": true,
                        "daily": 125.25797354561271,
                        "unit": "mg"
                    },
                    {
                        "label": "Zinc",
                        "tag": "ZN",
                        "schemaOrgTag": null,
                        "total": 18.341531378501646,
                        "hasRDI": true,
                        "daily": 166.74119435001495,
                        "unit": "mg"
                    },
                    {
                        "label": "Phosphorus",
                        "tag": "P",
                        "schemaOrgTag": null,
                        "total": 2231.0712550999992,
                        "hasRDI": true,
                        "daily": 318.7244650142856,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin A",
                        "tag": "VITA_RAE",
                        "schemaOrgTag": null,
                        "total": 635.3716670147774,
                        "hasRDI": true,
                        "daily": 70.59685189053081,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin C",
                        "tag": "VITC",
                        "schemaOrgTag": null,
                        "total": 103.72979744959534,
                        "hasRDI": true,
                        "daily": 115.25533049955037,
                        "unit": "mg"
                    },
                    {
                        "label": "Thiamin (B1)",
                        "tag": "THIA",
                        "schemaOrgTag": null,
                        "total": 1.7264528338354403,
                        "hasRDI": true,
                        "daily": 143.8710694862867,
                        "unit": "mg"
                    },
                    {
                        "label": "Riboflavin (B2)",
                        "tag": "RIBF",
                        "schemaOrgTag": null,
                        "total": 1.9119200245119274,
                        "hasRDI": true,
                        "daily": 147.0707711163021,
                        "unit": "mg"
                    },
                    {
                        "label": "Niacin (B3)",
                        "tag": "NIA",
                        "schemaOrgTag": null,
                        "total": 86.90416982948213,
                        "hasRDI": true,
                        "daily": 543.1510614342633,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin B6",
                        "tag": "VITB6A",
                        "schemaOrgTag": null,
                        "total": 6.886357390963229,
                        "hasRDI": true,
                        "daily": 529.7197993048637,
                        "unit": "mg"
                    },
                    {
                        "label": "Folate equivalent (total)",
                        "tag": "FOLDFE",
                        "schemaOrgTag": null,
                        "total": 276.2712108159691,
                        "hasRDI": true,
                        "daily": 69.06780270399227,
                        "unit": "µg"
                    },
                    {
                        "label": "Folate (food)",
                        "tag": "FOLFD",
                        "schemaOrgTag": null,
                        "total": 276.2712108159691,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Folic acid",
                        "tag": "FOLAC",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin B12",
                        "tag": "VITB12",
                        "schemaOrgTag": null,
                        "total": 3.34660450586,
                        "hasRDI": true,
                        "daily": 139.44185441083332,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin D",
                        "tag": "VITD",
                        "schemaOrgTag": null,
                        "total": 2.1590996812000003,
                        "hasRDI": true,
                        "daily": 14.393997874666669,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin E",
                        "tag": "TOCPHA",
                        "schemaOrgTag": null,
                        "total": 19.62869476856695,
                        "hasRDI": true,
                        "daily": 130.85796512377968,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin K",
                        "tag": "VITK1",
                        "schemaOrgTag": null,
                        "total": 353.31486385948267,
                        "hasRDI": true,
                        "daily": 294.42905321623556,
                        "unit": "µg"
                    },
                    {
                        "label": "Sugar alcohols",
                        "tag": "Sugar.alcohol",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    },
                    {
                        "label": "Water",
                        "tag": "WATER",
                        "schemaOrgTag": null,
                        "total": 1738.7966568296217,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    }
                ]
            },
            "_links": {
                "self": {
                    "href": "https://api.edamam.com/api/recipes/v2/b79327d05b8e5b838ad6cfd9576b30b6?type=public&app_id=ea1d37d5&app_key=fd382a172ba8d6668c0430dc9c14a181",
                    "title": "Self"
                }
            }
        },
        {
            "recipe": {
                "uri": "http://www.edamam.com/ontologies/edamam.owl#recipe_8275bb28647abcedef0baaf2dcf34f8b",
                "label": "Chicken Paprikash",
                "image": "https://www.edamam.com/web-img/e12/e12b8c5581226d7639168f41d126f2ff.jpg",
                "source": "No Recipes",
                "url": "http://norecipes.com/recipe/chicken-paprikash/",
                "shareAs": "http://www.edamam.com/recipe/chicken-paprikash-8275bb28647abcedef0baaf2dcf34f8b/chicken",
                "yield": 4,
                "dietLabels": [
                    "Low-Carb"
                ],
                "healthLabels": [
                    "Egg-Free",
                    "Peanut-Free",
                    "Tree-Nut-Free",
                    "Soy-Free",
                    "Fish-Free",
                    "Shellfish-Free",
                    "Pork-Free",
                    "Red-Meat-Free",
                    "Crustacean-Free",
                    "Celery-Free",
                    "Mustard-Free",
                    "Sesame-Free",
                    "Lupine-Free",
                    "Mollusk-Free",
                    "Alcohol-Free",
                    "Sulfite-Free"
                ],
                "cautions": [
                    "Sulfites",
                    "FODMAP"
                ],
                "ingredientLines": [
                    "640 grams chicken - drumsticks and thighs ( 3 whole chicken legs cut apart)",
                    "1/2 teaspoon salt",
                    "1/4 teaspoon black pepper",
                    "1 tablespoon butter – cultured unsalted (or olive oil)",
                    "240 grams onion sliced thin (1 large onion)",
                    "70 grams Anaheim pepper chopped (1 large pepper)",
                    "25 grams paprika (about 1/4 cup)",
                    "1 cup chicken stock",
                    "1/2 teaspoon salt",
                    "1/2 cup sour cream",
                    "1 tablespoon flour – all-purpose"
                ],
                "ingredients": [
                    {
                        "text": "640 grams chicken - drumsticks and thighs ( 3 whole chicken legs cut apart)",
                        "weight": 640,
                        "foodCategory": "Poultry",
                        "foodId": "food_agzvc6lbxg03stab195szars32lx",
                        "image": "https://www.edamam.com/food-img/491/4916353c22bd1ac381ac81d55597ddbe.jpg"
                    },
                    {
                        "text": "640 grams chicken - drumsticks and thighs ( 3 whole chicken legs cut apart)",
                        "weight": 640,
                        "foodCategory": "Poultry",
                        "foodId": "food_bsarl08be0gwarb34bpviafna9d4",
                        "image": "https://www.edamam.com/food-img/007/00792642367e1f55de680762f85cfb3b.jpg"
                    },
                    {
                        "text": "1/2 teaspoon salt",
                        "weight": 3,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_btxz81db72hwbra2pncvebzzzum9",
                        "image": "https://www.edamam.com/food-img/694/6943ea510918c6025795e8dc6e6eaaeb.jpg"
                    },
                    {
                        "text": "1/4 teaspoon black pepper",
                        "weight": 0.725,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_b6ywzluaaxv02wad7s1r9ag4py89",
                        "image": "https://www.edamam.com/food-img/c6e/c6e5c3bd8d3bc15175d9766971a4d1b2.jpg"
                    },
                    {
                        "text": "1 tablespoon butter – cultured unsalted (or olive oil)",
                        "weight": 13.5,
                        "foodCategory": "Oils",
                        "foodId": "food_b1d1icuad3iktrbqby0hiagafaz7",
                        "image": "https://www.edamam.com/food-img/4d6/4d651eaa8a353647746290c7a9b29d84.jpg"
                    },
                    {
                        "text": "240 grams onion sliced thin (1 large onion)",
                        "weight": 78.125,
                        "foodCategory": "vegetables",
                        "foodId": "food_bmrvi4ob4binw9a5m7l07amlfcoy",
                        "image": "https://www.edamam.com/food-img/205/205e6bf2399b85d34741892ef91cc603.jpg"
                    },
                    {
                        "text": "70 grams Anaheim pepper chopped (1 large pepper)",
                        "weight": 56.25,
                        "foodCategory": "vegetables",
                        "foodId": "food_bv2gevdbd1orbiarnp1vfaez1r85",
                        "image": "https://www.edamam.com/food-img/73f/73ff2eeb21372fe15b0ec51f9ecf368d.jpeg"
                    },
                    {
                        "text": "25 grams paprika (about 1/4 cup)",
                        "weight": 27.200000000459866,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_a9dpcnjb883g67b3lq82ca0421ql",
                        "image": "https://www.edamam.com/food-img/474/474d63763b9d8b9da98c5f43a114648c.jpg"
                    },
                    {
                        "text": "1 cup chicken stock",
                        "weight": 240,
                        "foodCategory": "canned soup",
                        "foodId": "food_bptblvzambd16nbhewqmhaw1rnh5",
                        "image": "https://www.edamam.com/food-img/26a/26a10c4cb4e07bab54d8a687ef5ac7d8.jpg"
                    },
                    {
                        "text": "1/2 teaspoon salt",
                        "weight": 3,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_btxz81db72hwbra2pncvebzzzum9",
                        "image": "https://www.edamam.com/food-img/694/6943ea510918c6025795e8dc6e6eaaeb.jpg"
                    },
                    {
                        "text": "1/2 cup sour cream",
                        "weight": 115,
                        "foodCategory": "Dairy",
                        "foodId": "food_adp9fcubzl3lr7bcvzn3rbfiiiwq",
                        "image": "https://www.edamam.com/food-img/f9d/f9d6183267b041b0aff9a10b89c9c15f.jpg"
                    },
                    {
                        "text": "1 tablespoon flour – all-purpose",
                        "weight": 7.8124999998679145,
                        "foodCategory": "grains",
                        "foodId": "food_ahebfs0a985an4aubqaebbipra58",
                        "image": "https://www.edamam.com/food-img/b4c/b4c739e76a6f2172b7ad49d0aa41d5aa.jpg"
                    }
                ],
                "calories": 3033.2012500008163,
                "totalWeight": 1824.6125000003276,
                "totalTime": 0,
                "cuisineType": [
                    "central europe"
                ],
                "mealType": [
                    "lunch/dinner"
                ],
                "dishType": [
                    "main course"
                ],
                "totalNutrients": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 3033.2012500008163,
                        "unit": "kcal"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 208.05040250005803,
                        "unit": "g"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 61.207636375009635,
                        "unit": "g"
                    },
                    "FATRN": {
                        "label": "Trans",
                        "quantity": 0.8448,
                        "unit": "g"
                    },
                    "FAMS": {
                        "label": "Monounsaturated",
                        "quantity": 85.78187337500766,
                        "unit": "g"
                    },
                    "FAPU": {
                        "label": "Polyunsaturated",
                        "quantity": 39.88905187503517,
                        "unit": "g"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 47.816761250147486,
                        "unit": "g"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 12.059037500156926,
                        "unit": "g"
                    },
                    "SUGAR": {
                        "label": "Sugars",
                        "quantity": 16.123463750047193,
                        "unit": "g"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 236.58131375005138,
                        "unit": "g"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 1283,
                        "unit": "mg"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 3945.65975000031,
                        "unit": "mg"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 326.0403750010333,
                        "unit": "mg"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 324.8095000007895,
                        "unit": "mg"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 4014.232125010343,
                        "unit": "mg"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 16.44184625009567,
                        "unit": "mg"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 22.48163750001899,
                        "unit": "mg"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 2388.5722500013017,
                        "unit": "mg"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 1144.9192500113265,
                        "unit": "µg"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 143.94730000000413,
                        "unit": "mg"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 1.310280500001359,
                        "unit": "mg"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 2.988508750005604,
                        "unit": "mg"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 67.97661300004462,
                        "unit": "mg"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 5.478774250009787,
                        "unit": "mg"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 101.71375000019098,
                        "unit": "µg"
                    },
                    "FOLFD": {
                        "label": "Folate (food)",
                        "quantity": 101.71375000019098,
                        "unit": "µg"
                    },
                    "FOLAC": {
                        "label": "Folic acid",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 7.682,
                        "unit": "µg"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 1.7400000000000002,
                        "unit": "µg"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 13.406427500133741,
                        "unit": "mg"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 71.52511250036889,
                        "unit": "µg"
                    },
                    "WATER": {
                        "label": "Water",
                        "quantity": 1319.0028025000358,
                        "unit": "g"
                    }
                },
                "totalDaily": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 151.6600625000408,
                        "unit": "%"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 320.0775423077816,
                        "unit": "%"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 306.03818187504817,
                        "unit": "%"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 15.938920416715828,
                        "unit": "%"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 48.2361500006277,
                        "unit": "%"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 473.16262750010276,
                        "unit": "%"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 427.6666666666667,
                        "unit": "%"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 164.40248958334624,
                        "unit": "%"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 32.60403750010333,
                        "unit": "%"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 77.33559523828322,
                        "unit": "%"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 85.40919414915624,
                        "unit": "%"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 91.34359027830926,
                        "unit": "%"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 204.3785227274454,
                        "unit": "%"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 341.2246071430431,
                        "unit": "%"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 127.2132500012585,
                        "unit": "%"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 159.94144444444905,
                        "unit": "%"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 109.19004166677993,
                        "unit": "%"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 229.88528846196954,
                        "unit": "%"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 424.8538312502789,
                        "unit": "%"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 421.4441730776759,
                        "unit": "%"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 25.428437500047743,
                        "unit": "%"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 320.08333333333337,
                        "unit": "%"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 11.600000000000001,
                        "unit": "%"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 89.37618333422493,
                        "unit": "%"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 59.60426041697407,
                        "unit": "%"
                    }
                },
                "digest": [
                    {
                        "label": "Fat",
                        "tag": "FAT",
                        "schemaOrgTag": "fatContent",
                        "total": 208.05040250005803,
                        "hasRDI": true,
                        "daily": 320.0775423077816,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Saturated",
                                "tag": "FASAT",
                                "schemaOrgTag": "saturatedFatContent",
                                "total": 61.207636375009635,
                                "hasRDI": true,
                                "daily": 306.03818187504817,
                                "unit": "g"
                            },
                            {
                                "label": "Trans",
                                "tag": "FATRN",
                                "schemaOrgTag": "transFatContent",
                                "total": 0.8448,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Monounsaturated",
                                "tag": "FAMS",
                                "schemaOrgTag": null,
                                "total": 85.78187337500766,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Polyunsaturated",
                                "tag": "FAPU",
                                "schemaOrgTag": null,
                                "total": 39.88905187503517,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Carbs",
                        "tag": "CHOCDF",
                        "schemaOrgTag": "carbohydrateContent",
                        "total": 47.816761250147486,
                        "hasRDI": true,
                        "daily": 15.938920416715828,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Carbs (net)",
                                "tag": "CHOCDF.net",
                                "schemaOrgTag": null,
                                "total": 35.75772374999056,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Fiber",
                                "tag": "FIBTG",
                                "schemaOrgTag": "fiberContent",
                                "total": 12.059037500156926,
                                "hasRDI": true,
                                "daily": 48.2361500006277,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars",
                                "tag": "SUGAR",
                                "schemaOrgTag": "sugarContent",
                                "total": 16.123463750047193,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars, added",
                                "tag": "SUGAR.added",
                                "schemaOrgTag": null,
                                "total": 0,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Protein",
                        "tag": "PROCNT",
                        "schemaOrgTag": "proteinContent",
                        "total": 236.58131375005138,
                        "hasRDI": true,
                        "daily": 473.16262750010276,
                        "unit": "g"
                    },
                    {
                        "label": "Cholesterol",
                        "tag": "CHOLE",
                        "schemaOrgTag": "cholesterolContent",
                        "total": 1283,
                        "hasRDI": true,
                        "daily": 427.6666666666667,
                        "unit": "mg"
                    },
                    {
                        "label": "Sodium",
                        "tag": "NA",
                        "schemaOrgTag": "sodiumContent",
                        "total": 3945.65975000031,
                        "hasRDI": true,
                        "daily": 164.40248958334624,
                        "unit": "mg"
                    },
                    {
                        "label": "Calcium",
                        "tag": "CA",
                        "schemaOrgTag": null,
                        "total": 326.0403750010333,
                        "hasRDI": true,
                        "daily": 32.60403750010333,
                        "unit": "mg"
                    },
                    {
                        "label": "Magnesium",
                        "tag": "MG",
                        "schemaOrgTag": null,
                        "total": 324.8095000007895,
                        "hasRDI": true,
                        "daily": 77.33559523828322,
                        "unit": "mg"
                    },
                    {
                        "label": "Potassium",
                        "tag": "K",
                        "schemaOrgTag": null,
                        "total": 4014.232125010343,
                        "hasRDI": true,
                        "daily": 85.40919414915624,
                        "unit": "mg"
                    },
                    {
                        "label": "Iron",
                        "tag": "FE",
                        "schemaOrgTag": null,
                        "total": 16.44184625009567,
                        "hasRDI": true,
                        "daily": 91.34359027830926,
                        "unit": "mg"
                    },
                    {
                        "label": "Zinc",
                        "tag": "ZN",
                        "schemaOrgTag": null,
                        "total": 22.48163750001899,
                        "hasRDI": true,
                        "daily": 204.3785227274454,
                        "unit": "mg"
                    },
                    {
                        "label": "Phosphorus",
                        "tag": "P",
                        "schemaOrgTag": null,
                        "total": 2388.5722500013017,
                        "hasRDI": true,
                        "daily": 341.2246071430431,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin A",
                        "tag": "VITA_RAE",
                        "schemaOrgTag": null,
                        "total": 1144.9192500113265,
                        "hasRDI": true,
                        "daily": 127.2132500012585,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin C",
                        "tag": "VITC",
                        "schemaOrgTag": null,
                        "total": 143.94730000000413,
                        "hasRDI": true,
                        "daily": 159.94144444444905,
                        "unit": "mg"
                    },
                    {
                        "label": "Thiamin (B1)",
                        "tag": "THIA",
                        "schemaOrgTag": null,
                        "total": 1.310280500001359,
                        "hasRDI": true,
                        "daily": 109.19004166677993,
                        "unit": "mg"
                    },
                    {
                        "label": "Riboflavin (B2)",
                        "tag": "RIBF",
                        "schemaOrgTag": null,
                        "total": 2.988508750005604,
                        "hasRDI": true,
                        "daily": 229.88528846196954,
                        "unit": "mg"
                    },
                    {
                        "label": "Niacin (B3)",
                        "tag": "NIA",
                        "schemaOrgTag": null,
                        "total": 67.97661300004462,
                        "hasRDI": true,
                        "daily": 424.8538312502789,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin B6",
                        "tag": "VITB6A",
                        "schemaOrgTag": null,
                        "total": 5.478774250009787,
                        "hasRDI": true,
                        "daily": 421.4441730776759,
                        "unit": "mg"
                    },
                    {
                        "label": "Folate equivalent (total)",
                        "tag": "FOLDFE",
                        "schemaOrgTag": null,
                        "total": 101.71375000019098,
                        "hasRDI": true,
                        "daily": 25.428437500047743,
                        "unit": "µg"
                    },
                    {
                        "label": "Folate (food)",
                        "tag": "FOLFD",
                        "schemaOrgTag": null,
                        "total": 101.71375000019098,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Folic acid",
                        "tag": "FOLAC",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin B12",
                        "tag": "VITB12",
                        "schemaOrgTag": null,
                        "total": 7.682,
                        "hasRDI": true,
                        "daily": 320.08333333333337,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin D",
                        "tag": "VITD",
                        "schemaOrgTag": null,
                        "total": 1.7400000000000002,
                        "hasRDI": true,
                        "daily": 11.600000000000001,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin E",
                        "tag": "TOCPHA",
                        "schemaOrgTag": null,
                        "total": 13.406427500133741,
                        "hasRDI": true,
                        "daily": 89.37618333422493,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin K",
                        "tag": "VITK1",
                        "schemaOrgTag": null,
                        "total": 71.52511250036889,
                        "hasRDI": true,
                        "daily": 59.60426041697407,
                        "unit": "µg"
                    },
                    {
                        "label": "Sugar alcohols",
                        "tag": "Sugar.alcohol",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    },
                    {
                        "label": "Water",
                        "tag": "WATER",
                        "schemaOrgTag": null,
                        "total": 1319.0028025000358,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    }
                ]
            },
            "_links": {
                "self": {
                    "href": "https://api.edamam.com/api/recipes/v2/8275bb28647abcedef0baaf2dcf34f8b?type=public&app_id=ea1d37d5&app_key=fd382a172ba8d6668c0430dc9c14a181",
                    "title": "Self"
                }
            }
        },
        {
            "recipe": {
                "uri": "http://www.edamam.com/ontologies/edamam.owl#recipe_be3ba087e212f13672b553ecfa876333",
                "label": "Baked Chicken",
                "image": "https://www.edamam.com/web-img/01c/01cacb70890274fb7b7cebb975a93231.jpg",
                "source": "Martha Stewart",
                "url": "http://www.marthastewart.com/318981/baked-chicken",
                "shareAs": "http://www.edamam.com/recipe/baked-chicken-be3ba087e212f13672b553ecfa876333/chicken",
                "yield": 4,
                "dietLabels": [
                    "Low-Carb"
                ],
                "healthLabels": [
                    "Sugar-Conscious",
                    "Keto-Friendly",
                    "Paleo",
                    "Mediterranean",
                    "Dairy-Free",
                    "Gluten-Free",
                    "Wheat-Free",
                    "Egg-Free",
                    "Peanut-Free",
                    "Tree-Nut-Free",
                    "Soy-Free",
                    "Fish-Free",
                    "Shellfish-Free",
                    "Pork-Free",
                    "Red-Meat-Free",
                    "Crustacean-Free",
                    "Celery-Free",
                    "Mustard-Free",
                    "Sesame-Free",
                    "Lupine-Free",
                    "Mollusk-Free",
                    "Alcohol-Free",
                    "No oil added",
                    "Sulfite-Free",
                    "FODMAP-Free",
                    "Kosher"
                ],
                "cautions": [
                    "FODMAP"
                ],
                "ingredientLines": [
                    "6 bone-in chicken breast halves, or 6 chicken thighs and wings, skin-on",
                    "1/2 teaspoon coarse salt",
                    "1/2 teaspoon Mrs. Dash seasoning",
                    "1/4 teaspoon freshly ground black pepper"
                ],
                "ingredients": [
                    {
                        "text": "6 bone-in chicken breast halves, or 6 chicken thighs and wings, skin-on",
                        "weight": 522,
                        "foodCategory": "Poultry",
                        "foodId": "food_a9hdg97b1sqqs5aj1al75bbo5iyt",
                        "image": "https://www.edamam.com/food-img/093/093749f4c93e448119fc81976d2c3067.jpg"
                    },
                    {
                        "text": "1/2 teaspoon coarse salt",
                        "weight": 2.4270833334564377,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_a1vgrj1bs8rd1majvmd9ubz8ttkg",
                        "image": "https://www.edamam.com/food-img/694/6943ea510918c6025795e8dc6e6eaaeb.jpg"
                    },
                    {
                        "text": "1/2 teaspoon Mrs. Dash seasoning",
                        "weight": 0.75,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_aj7w3xab0epj7cbgkbkpwadysovd",
                        "image": "https://www.edamam.com/food-img/c23/c23e20823b442067307aa436969358f1.jpg"
                    },
                    {
                        "text": "1/4 teaspoon freshly ground black pepper",
                        "weight": 0.575,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_b6ywzluaaxv02wad7s1r9ag4py89",
                        "image": "https://www.edamam.com/food-img/c6e/c6e5c3bd8d3bc15175d9766971a4d1b2.jpg"
                    }
                ],
                "calories": 901.58575,
                "totalWeight": 525.6156350198669,
                "totalTime": 0,
                "cuisineType": [
                    "american"
                ],
                "mealType": [
                    "lunch/dinner"
                ],
                "dishType": [
                    "starter"
                ],
                "totalNutrients": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 901.58575,
                        "unit": "kcal"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 48.36022,
                        "unit": "g"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 13.917879,
                        "unit": "g"
                    },
                    "FATRN": {
                        "label": "Trans",
                        "quantity": 0.5480999999999999,
                        "unit": "g"
                    },
                    "FAMS": {
                        "label": "Monounsaturated",
                        "quantity": 19.953694249999998,
                        "unit": "g"
                    },
                    "FAPU": {
                        "label": "Polyunsaturated",
                        "quantity": 10.251458499999998,
                        "unit": "g"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 0.8596375,
                        "unit": "g"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 0.230225,
                        "unit": "g"
                    },
                    "SUGAR": {
                        "label": "Sugars",
                        "quantity": 0.01718,
                        "unit": "g"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 108.9686675,
                        "unit": "g"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 334.08,
                        "unit": "mg"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 1216.981821,
                        "unit": "mg"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 67.98700240476805,
                        "unit": "mg"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 133.18615635019867,
                        "unit": "mg"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 1161.3550008015893,
                        "unit": "mg"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 4.19094159556556,
                        "unit": "mg"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 4.208683135019868,
                        "unit": "mg"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 910.471,
                        "unit": "mg"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 126.42524999999999,
                        "unit": "µg"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 0.09,
                        "unit": "mg"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 0.33146099999999995,
                        "unit": "mg"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 0.4461675,
                        "unit": "mg"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 51.74860724999999,
                        "unit": "mg"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 2.77817325,
                        "unit": "mg"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 22.01275,
                        "unit": "µg"
                    },
                    "FOLFD": {
                        "label": "Folate (food)",
                        "quantity": 22.01275,
                        "unit": "µg"
                    },
                    "FOLAC": {
                        "label": "Folic acid",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 1.7748,
                        "unit": "µg"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 2.088,
                        "unit": "µg"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 1.42528,
                        "unit": "mg"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 6.981775,
                        "unit": "µg"
                    },
                    "WATER": {
                        "label": "Water",
                        "quantity": 362.7272512700397,
                        "unit": "g"
                    }
                },
                "totalDaily": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 45.0792875,
                        "unit": "%"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 74.40033846153847,
                        "unit": "%"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 69.589395,
                        "unit": "%"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 0.28654583333333333,
                        "unit": "%"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 0.9209,
                        "unit": "%"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 217.937335,
                        "unit": "%"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 111.36,
                        "unit": "%"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 50.707575875,
                        "unit": "%"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 6.798700240476805,
                        "unit": "%"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 31.71098960719016,
                        "unit": "%"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 24.709680868118923,
                        "unit": "%"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 23.283008864253112,
                        "unit": "%"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 38.26075577290789,
                        "unit": "%"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 130.06728571428573,
                        "unit": "%"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 14.04725,
                        "unit": "%"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 0.1,
                        "unit": "%"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 27.62175,
                        "unit": "%"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 34.32057692307692,
                        "unit": "%"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 323.4287953125,
                        "unit": "%"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 213.70563461538458,
                        "unit": "%"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 5.5031875,
                        "unit": "%"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 73.95,
                        "unit": "%"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 13.92,
                        "unit": "%"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 9.501866666666668,
                        "unit": "%"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 5.818145833333333,
                        "unit": "%"
                    }
                },
                "digest": [
                    {
                        "label": "Fat",
                        "tag": "FAT",
                        "schemaOrgTag": "fatContent",
                        "total": 48.36022,
                        "hasRDI": true,
                        "daily": 74.40033846153847,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Saturated",
                                "tag": "FASAT",
                                "schemaOrgTag": "saturatedFatContent",
                                "total": 13.917879,
                                "hasRDI": true,
                                "daily": 69.589395,
                                "unit": "g"
                            },
                            {
                                "label": "Trans",
                                "tag": "FATRN",
                                "schemaOrgTag": "transFatContent",
                                "total": 0.5480999999999999,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Monounsaturated",
                                "tag": "FAMS",
                                "schemaOrgTag": null,
                                "total": 19.953694249999998,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Polyunsaturated",
                                "tag": "FAPU",
                                "schemaOrgTag": null,
                                "total": 10.251458499999998,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Carbs",
                        "tag": "CHOCDF",
                        "schemaOrgTag": "carbohydrateContent",
                        "total": 0.8596375,
                        "hasRDI": true,
                        "daily": 0.28654583333333333,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Carbs (net)",
                                "tag": "CHOCDF.net",
                                "schemaOrgTag": null,
                                "total": 0.6294125,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Fiber",
                                "tag": "FIBTG",
                                "schemaOrgTag": "fiberContent",
                                "total": 0.230225,
                                "hasRDI": true,
                                "daily": 0.9209,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars",
                                "tag": "SUGAR",
                                "schemaOrgTag": "sugarContent",
                                "total": 0.01718,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars, added",
                                "tag": "SUGAR.added",
                                "schemaOrgTag": null,
                                "total": 0,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Protein",
                        "tag": "PROCNT",
                        "schemaOrgTag": "proteinContent",
                        "total": 108.9686675,
                        "hasRDI": true,
                        "daily": 217.937335,
                        "unit": "g"
                    },
                    {
                        "label": "Cholesterol",
                        "tag": "CHOLE",
                        "schemaOrgTag": "cholesterolContent",
                        "total": 334.08,
                        "hasRDI": true,
                        "daily": 111.36,
                        "unit": "mg"
                    },
                    {
                        "label": "Sodium",
                        "tag": "NA",
                        "schemaOrgTag": "sodiumContent",
                        "total": 1216.981821,
                        "hasRDI": true,
                        "daily": 50.707575875,
                        "unit": "mg"
                    },
                    {
                        "label": "Calcium",
                        "tag": "CA",
                        "schemaOrgTag": null,
                        "total": 67.98700240476805,
                        "hasRDI": true,
                        "daily": 6.798700240476805,
                        "unit": "mg"
                    },
                    {
                        "label": "Magnesium",
                        "tag": "MG",
                        "schemaOrgTag": null,
                        "total": 133.18615635019867,
                        "hasRDI": true,
                        "daily": 31.71098960719016,
                        "unit": "mg"
                    },
                    {
                        "label": "Potassium",
                        "tag": "K",
                        "schemaOrgTag": null,
                        "total": 1161.3550008015893,
                        "hasRDI": true,
                        "daily": 24.709680868118923,
                        "unit": "mg"
                    },
                    {
                        "label": "Iron",
                        "tag": "FE",
                        "schemaOrgTag": null,
                        "total": 4.19094159556556,
                        "hasRDI": true,
                        "daily": 23.283008864253112,
                        "unit": "mg"
                    },
                    {
                        "label": "Zinc",
                        "tag": "ZN",
                        "schemaOrgTag": null,
                        "total": 4.208683135019868,
                        "hasRDI": true,
                        "daily": 38.26075577290789,
                        "unit": "mg"
                    },
                    {
                        "label": "Phosphorus",
                        "tag": "P",
                        "schemaOrgTag": null,
                        "total": 910.471,
                        "hasRDI": true,
                        "daily": 130.06728571428573,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin A",
                        "tag": "VITA_RAE",
                        "schemaOrgTag": null,
                        "total": 126.42524999999999,
                        "hasRDI": true,
                        "daily": 14.04725,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin C",
                        "tag": "VITC",
                        "schemaOrgTag": null,
                        "total": 0.09,
                        "hasRDI": true,
                        "daily": 0.1,
                        "unit": "mg"
                    },
                    {
                        "label": "Thiamin (B1)",
                        "tag": "THIA",
                        "schemaOrgTag": null,
                        "total": 0.33146099999999995,
                        "hasRDI": true,
                        "daily": 27.62175,
                        "unit": "mg"
                    },
                    {
                        "label": "Riboflavin (B2)",
                        "tag": "RIBF",
                        "schemaOrgTag": null,
                        "total": 0.4461675,
                        "hasRDI": true,
                        "daily": 34.32057692307692,
                        "unit": "mg"
                    },
                    {
                        "label": "Niacin (B3)",
                        "tag": "NIA",
                        "schemaOrgTag": null,
                        "total": 51.74860724999999,
                        "hasRDI": true,
                        "daily": 323.4287953125,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin B6",
                        "tag": "VITB6A",
                        "schemaOrgTag": null,
                        "total": 2.77817325,
                        "hasRDI": true,
                        "daily": 213.70563461538458,
                        "unit": "mg"
                    },
                    {
                        "label": "Folate equivalent (total)",
                        "tag": "FOLDFE",
                        "schemaOrgTag": null,
                        "total": 22.01275,
                        "hasRDI": true,
                        "daily": 5.5031875,
                        "unit": "µg"
                    },
                    {
                        "label": "Folate (food)",
                        "tag": "FOLFD",
                        "schemaOrgTag": null,
                        "total": 22.01275,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Folic acid",
                        "tag": "FOLAC",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin B12",
                        "tag": "VITB12",
                        "schemaOrgTag": null,
                        "total": 1.7748,
                        "hasRDI": true,
                        "daily": 73.95,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin D",
                        "tag": "VITD",
                        "schemaOrgTag": null,
                        "total": 2.088,
                        "hasRDI": true,
                        "daily": 13.92,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin E",
                        "tag": "TOCPHA",
                        "schemaOrgTag": null,
                        "total": 1.42528,
                        "hasRDI": true,
                        "daily": 9.501866666666668,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin K",
                        "tag": "VITK1",
                        "schemaOrgTag": null,
                        "total": 6.981775,
                        "hasRDI": true,
                        "daily": 5.818145833333333,
                        "unit": "µg"
                    },
                    {
                        "label": "Sugar alcohols",
                        "tag": "Sugar.alcohol",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    },
                    {
                        "label": "Water",
                        "tag": "WATER",
                        "schemaOrgTag": null,
                        "total": 362.7272512700397,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    }
                ]
            },
            "_links": {
                "self": {
                    "href": "https://api.edamam.com/api/recipes/v2/be3ba087e212f13672b553ecfa876333?type=public&app_id=ea1d37d5&app_key=fd382a172ba8d6668c0430dc9c14a181",
                    "title": "Self"
                }
            }
        },
        {
            "recipe": {
                "uri": "http://www.edamam.com/ontologies/edamam.owl#recipe_2463f2482609d7a471dbbf3b268bd956",
                "label": "Catalan Chicken",
                "image": "https://www.edamam.com/web-img/4d9/4d9084cbc170789caa9e997108b595de.jpg",
                "source": "Bon Appetit",
                "url": "http://www.bonappetit.com/columns/breadwinner/article/how-to-get-your-kids-to-eat-sauce-let-them-cook-it-themselves",
                "shareAs": "http://www.edamam.com/recipe/catalan-chicken-2463f2482609d7a471dbbf3b268bd956/chicken",
                "yield": 14,
                "dietLabels": [
                    "Low-Carb"
                ],
                "healthLabels": [
                    "Sugar-Conscious",
                    "Keto-Friendly",
                    "Paleo",
                    "Dairy-Free",
                    "Gluten-Free",
                    "Wheat-Free",
                    "Egg-Free",
                    "Peanut-Free",
                    "Tree-Nut-Free",
                    "Soy-Free",
                    "Fish-Free",
                    "Shellfish-Free",
                    "Crustacean-Free",
                    "Celery-Free",
                    "Mustard-Free",
                    "Sesame-Free",
                    "Lupine-Free",
                    "Mollusk-Free",
                    "No oil added",
                    "Sulfite-Free"
                ],
                "cautions": [
                    "Sulfites"
                ],
                "ingredientLines": [
                    "1 whole 4-pound chicken, quartered",
                    "8 slices bacon",
                    "30 cloves garlic",
                    "3 lemons, peeled, rinds thinly sliced and reserved",
                    "½ cup Banyuls or another fortified dessert wine",
                    "1 cup veal or chicken stock"
                ],
                "ingredients": [
                    {
                        "text": "1 whole 4-pound chicken, quartered",
                        "weight": 1200,
                        "foodCategory": "Poultry",
                        "foodId": "food_bmyxrshbfao9s1amjrvhoauob6mo",
                        "image": "https://www.edamam.com/food-img/d33/d338229d774a743f7858f6764e095878.jpg"
                    },
                    {
                        "text": "8 slices bacon",
                        "weight": 232,
                        "foodCategory": "cured meats",
                        "foodId": "food_av0awb0bgs18qub01sd9kbx44b61",
                        "image": "https://www.edamam.com/food-img/d42/d426884a125fa39a70d5a5d7217864ec.jpg"
                    },
                    {
                        "text": "30 cloves garlic",
                        "weight": 90,
                        "foodCategory": "vegetables",
                        "foodId": "food_avtcmx6bgjv1jvay6s6stan8dnyp",
                        "image": "https://www.edamam.com/food-img/6ee/6ee142951f48aaf94f4312409f8d133d.jpg"
                    },
                    {
                        "text": "3 lemons, peeled, rinds thinly sliced and reserved",
                        "weight": 174,
                        "foodCategory": "fruit",
                        "foodId": "food_a6uzc62astrxcgbtzyq59b6fncrr",
                        "image": "https://www.edamam.com/food-img/70a/70acba3d4c734d7c70ef4efeed85dc8f.jpg"
                    },
                    {
                        "text": "½ cup Banyuls or another fortified dessert wine",
                        "weight": 51.5,
                        "foodCategory": "wines",
                        "foodId": "food_a9b1edjayi2e3kae6qvpvb0l2zaf",
                        "image": "https://www.edamam.com/food-img/ea0/ea026d474cb3f9c0b3302eeaa5232151.jpg"
                    },
                    {
                        "text": "1 cup veal or chicken stock",
                        "weight": 240,
                        "foodCategory": "canned soup",
                        "foodId": "food_bptblvzambd16nbhewqmhaw1rnh5",
                        "image": "https://www.edamam.com/food-img/26a/26a10c4cb4e07bab54d8a687ef5ac7d8.jpg"
                    }
                ],
                "calories": 3900.8,
                "totalWeight": 1987.5,
                "totalTime": 0,
                "cuisineType": [
                    "french"
                ],
                "mealType": [
                    "lunch/dinner"
                ],
                "dishType": [
                    "condiments and sauces"
                ],
                "totalNutrients": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 3900.8,
                        "unit": "kcal"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 276.65279999999996,
                        "unit": "g"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 83.48508,
                        "unit": "g"
                    },
                    "FATRN": {
                        "label": "Trans",
                        "quantity": 1.47256,
                        "unit": "g"
                    },
                    "FAMS": {
                        "label": "Monounsaturated",
                        "quantity": 116.76431999999998,
                        "unit": "g"
                    },
                    "FAPU": {
                        "label": "Polyunsaturated",
                        "quantity": 54.623439999999995,
                        "unit": "g"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 64.46275,
                        "unit": "g"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 6.7620000000000005,
                        "unit": "g"
                    },
                    "SUGAR": {
                        "label": "Sugars",
                        "quantity": 15.368699999999999,
                        "unit": "g"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 266.2674,
                        "unit": "g"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 1060.32,
                        "unit": "mg"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 2742.4550000000004,
                        "unit": "mg"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 363.06,
                        "unit": "mg"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 318.495,
                        "unit": "mg"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 3627.76,
                        "unit": "mg"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 14.9528,
                        "unit": "mg"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 19.978049999999996,
                        "unit": "mg"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 2333.0550000000003,
                        "unit": "mg"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 521.66,
                        "unit": "µg"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 139.98,
                        "unit": "mg"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 1.7031899999999998,
                        "unit": "mg"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 1.9749899999999998,
                        "unit": "mg"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 95.658335,
                        "unit": "mg"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 6.214219999999999,
                        "unit": "mg"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 105.84,
                        "unit": "µg"
                    },
                    "FOLFD": {
                        "label": "Folate (food)",
                        "quantity": 105.84,
                        "unit": "µg"
                    },
                    "FOLAC": {
                        "label": "Folic acid",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 4.88,
                        "unit": "µg"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 3.3280000000000003,
                        "unit": "µg"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 5.0026,
                        "unit": "mg"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 20.01,
                        "unit": "µg"
                    },
                    "WATER": {
                        "label": "Water",
                        "quantity": 1359.53665,
                        "unit": "g"
                    }
                },
                "totalDaily": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 195.04,
                        "unit": "%"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 425.6196923076922,
                        "unit": "%"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 417.42539999999997,
                        "unit": "%"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 21.487583333333333,
                        "unit": "%"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 27.048000000000002,
                        "unit": "%"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 532.5348,
                        "unit": "%"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 353.44,
                        "unit": "%"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 114.26895833333336,
                        "unit": "%"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 36.306,
                        "unit": "%"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 75.83214285714286,
                        "unit": "%"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 77.1863829787234,
                        "unit": "%"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 83.07111111111111,
                        "unit": "%"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 181.61863636363634,
                        "unit": "%"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 333.29357142857145,
                        "unit": "%"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 57.96222222222222,
                        "unit": "%"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 155.5333333333333,
                        "unit": "%"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 141.9325,
                        "unit": "%"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 151.92230769230767,
                        "unit": "%"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 597.8645937499999,
                        "unit": "%"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 478.016923076923,
                        "unit": "%"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 26.46,
                        "unit": "%"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 203.33333333333334,
                        "unit": "%"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 22.186666666666667,
                        "unit": "%"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 33.35066666666667,
                        "unit": "%"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 16.675,
                        "unit": "%"
                    }
                },
                "digest": [
                    {
                        "label": "Fat",
                        "tag": "FAT",
                        "schemaOrgTag": "fatContent",
                        "total": 276.65279999999996,
                        "hasRDI": true,
                        "daily": 425.6196923076922,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Saturated",
                                "tag": "FASAT",
                                "schemaOrgTag": "saturatedFatContent",
                                "total": 83.48508,
                                "hasRDI": true,
                                "daily": 417.42539999999997,
                                "unit": "g"
                            },
                            {
                                "label": "Trans",
                                "tag": "FATRN",
                                "schemaOrgTag": "transFatContent",
                                "total": 1.47256,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Monounsaturated",
                                "tag": "FAMS",
                                "schemaOrgTag": null,
                                "total": 116.76431999999998,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Polyunsaturated",
                                "tag": "FAPU",
                                "schemaOrgTag": null,
                                "total": 54.623439999999995,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Carbs",
                        "tag": "CHOCDF",
                        "schemaOrgTag": "carbohydrateContent",
                        "total": 64.46275,
                        "hasRDI": true,
                        "daily": 21.487583333333333,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Carbs (net)",
                                "tag": "CHOCDF.net",
                                "schemaOrgTag": null,
                                "total": 57.70075,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Fiber",
                                "tag": "FIBTG",
                                "schemaOrgTag": "fiberContent",
                                "total": 6.7620000000000005,
                                "hasRDI": true,
                                "daily": 27.048000000000002,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars",
                                "tag": "SUGAR",
                                "schemaOrgTag": "sugarContent",
                                "total": 15.368699999999999,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars, added",
                                "tag": "SUGAR.added",
                                "schemaOrgTag": null,
                                "total": 0,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Protein",
                        "tag": "PROCNT",
                        "schemaOrgTag": "proteinContent",
                        "total": 266.2674,
                        "hasRDI": true,
                        "daily": 532.5348,
                        "unit": "g"
                    },
                    {
                        "label": "Cholesterol",
                        "tag": "CHOLE",
                        "schemaOrgTag": "cholesterolContent",
                        "total": 1060.32,
                        "hasRDI": true,
                        "daily": 353.44,
                        "unit": "mg"
                    },
                    {
                        "label": "Sodium",
                        "tag": "NA",
                        "schemaOrgTag": "sodiumContent",
                        "total": 2742.4550000000004,
                        "hasRDI": true,
                        "daily": 114.26895833333336,
                        "unit": "mg"
                    },
                    {
                        "label": "Calcium",
                        "tag": "CA",
                        "schemaOrgTag": null,
                        "total": 363.06,
                        "hasRDI": true,
                        "daily": 36.306,
                        "unit": "mg"
                    },
                    {
                        "label": "Magnesium",
                        "tag": "MG",
                        "schemaOrgTag": null,
                        "total": 318.495,
                        "hasRDI": true,
                        "daily": 75.83214285714286,
                        "unit": "mg"
                    },
                    {
                        "label": "Potassium",
                        "tag": "K",
                        "schemaOrgTag": null,
                        "total": 3627.76,
                        "hasRDI": true,
                        "daily": 77.1863829787234,
                        "unit": "mg"
                    },
                    {
                        "label": "Iron",
                        "tag": "FE",
                        "schemaOrgTag": null,
                        "total": 14.9528,
                        "hasRDI": true,
                        "daily": 83.07111111111111,
                        "unit": "mg"
                    },
                    {
                        "label": "Zinc",
                        "tag": "ZN",
                        "schemaOrgTag": null,
                        "total": 19.978049999999996,
                        "hasRDI": true,
                        "daily": 181.61863636363634,
                        "unit": "mg"
                    },
                    {
                        "label": "Phosphorus",
                        "tag": "P",
                        "schemaOrgTag": null,
                        "total": 2333.0550000000003,
                        "hasRDI": true,
                        "daily": 333.29357142857145,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin A",
                        "tag": "VITA_RAE",
                        "schemaOrgTag": null,
                        "total": 521.66,
                        "hasRDI": true,
                        "daily": 57.96222222222222,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin C",
                        "tag": "VITC",
                        "schemaOrgTag": null,
                        "total": 139.98,
                        "hasRDI": true,
                        "daily": 155.5333333333333,
                        "unit": "mg"
                    },
                    {
                        "label": "Thiamin (B1)",
                        "tag": "THIA",
                        "schemaOrgTag": null,
                        "total": 1.7031899999999998,
                        "hasRDI": true,
                        "daily": 141.9325,
                        "unit": "mg"
                    },
                    {
                        "label": "Riboflavin (B2)",
                        "tag": "RIBF",
                        "schemaOrgTag": null,
                        "total": 1.9749899999999998,
                        "hasRDI": true,
                        "daily": 151.92230769230767,
                        "unit": "mg"
                    },
                    {
                        "label": "Niacin (B3)",
                        "tag": "NIA",
                        "schemaOrgTag": null,
                        "total": 95.658335,
                        "hasRDI": true,
                        "daily": 597.8645937499999,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin B6",
                        "tag": "VITB6A",
                        "schemaOrgTag": null,
                        "total": 6.214219999999999,
                        "hasRDI": true,
                        "daily": 478.016923076923,
                        "unit": "mg"
                    },
                    {
                        "label": "Folate equivalent (total)",
                        "tag": "FOLDFE",
                        "schemaOrgTag": null,
                        "total": 105.84,
                        "hasRDI": true,
                        "daily": 26.46,
                        "unit": "µg"
                    },
                    {
                        "label": "Folate (food)",
                        "tag": "FOLFD",
                        "schemaOrgTag": null,
                        "total": 105.84,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Folic acid",
                        "tag": "FOLAC",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin B12",
                        "tag": "VITB12",
                        "schemaOrgTag": null,
                        "total": 4.88,
                        "hasRDI": true,
                        "daily": 203.33333333333334,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin D",
                        "tag": "VITD",
                        "schemaOrgTag": null,
                        "total": 3.3280000000000003,
                        "hasRDI": true,
                        "daily": 22.186666666666667,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin E",
                        "tag": "TOCPHA",
                        "schemaOrgTag": null,
                        "total": 5.0026,
                        "hasRDI": true,
                        "daily": 33.35066666666667,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin K",
                        "tag": "VITK1",
                        "schemaOrgTag": null,
                        "total": 20.01,
                        "hasRDI": true,
                        "daily": 16.675,
                        "unit": "µg"
                    },
                    {
                        "label": "Sugar alcohols",
                        "tag": "Sugar.alcohol",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    },
                    {
                        "label": "Water",
                        "tag": "WATER",
                        "schemaOrgTag": null,
                        "total": 1359.53665,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    }
                ]
            },
            "_links": {
                "self": {
                    "href": "https://api.edamam.com/api/recipes/v2/2463f2482609d7a471dbbf3b268bd956?type=public&app_id=ea1d37d5&app_key=fd382a172ba8d6668c0430dc9c14a181",
                    "title": "Self"
                }
            }
        },
        {
            "recipe": {
                "uri": "http://www.edamam.com/ontologies/edamam.owl#recipe_4caf01683bf99ddc7c08c35774aae54c",
                "label": "Persian Chicken",
                "image": "https://www.edamam.com/web-img/8f8/8f810dfe198fa3e520d291f3fcf62bbf.jpg",
                "source": "BBC Good Food",
                "url": "http://www.bbcgoodfood.com/recipes/7343/",
                "shareAs": "http://www.edamam.com/recipe/persian-chicken-4caf01683bf99ddc7c08c35774aae54c/chicken",
                "yield": 5,
                "dietLabels": [
                    "Low-Carb"
                ],
                "healthLabels": [
                    "Gluten-Free",
                    "Wheat-Free",
                    "Peanut-Free",
                    "Tree-Nut-Free",
                    "Soy-Free",
                    "Fish-Free",
                    "Shellfish-Free",
                    "Pork-Free",
                    "Red-Meat-Free",
                    "Crustacean-Free",
                    "Celery-Free",
                    "Sesame-Free",
                    "Lupine-Free",
                    "Mollusk-Free"
                ],
                "cautions": [
                    "Sulfites"
                ],
                "ingredientLines": [
                    "2 large onions",
                    "750 g chicken",
                    "500 g mushrooms",
                    "1 cup water",
                    "1 cup red wine",
                    "2 teaspoons chicken stock",
                    "200 ml mayonnaise",
                    "200 ml cream",
                    "small bunch of parsley",
                    "1 teaspoon curry powder"
                ],
                "ingredients": [
                    {
                        "text": "2 large onions",
                        "weight": 300,
                        "foodCategory": "vegetables",
                        "foodId": "food_bmrvi4ob4binw9a5m7l07amlfcoy",
                        "image": "https://www.edamam.com/food-img/205/205e6bf2399b85d34741892ef91cc603.jpg"
                    },
                    {
                        "text": "750 g chicken",
                        "weight": 750,
                        "foodCategory": "Poultry",
                        "foodId": "food_bmyxrshbfao9s1amjrvhoauob6mo",
                        "image": "https://www.edamam.com/food-img/d33/d338229d774a743f7858f6764e095878.jpg"
                    },
                    {
                        "text": "500 g mushrooms",
                        "weight": 500,
                        "foodCategory": "vegetables",
                        "foodId": "food_bvlose6arfl26ra396sjrb7hetqh",
                        "image": "https://www.edamam.com/food-img/d63/d639cf4a2afc7407c1d1ce286028136b.jpg"
                    },
                    {
                        "text": "1 cup water",
                        "weight": 237,
                        "foodCategory": "water",
                        "foodId": "food_a99vzubbk1ayrsad318rvbzr3dh0",
                        "image": "https://www.edamam.com/food-img/5dd/5dd9d1361847b2ca53c4b19a8f92627e.jpg"
                    },
                    {
                        "text": "1 cup red wine",
                        "weight": 235.2,
                        "foodCategory": "wines",
                        "foodId": "food_b5q0xv2ba8la5hbzdfzdgaca3fwu",
                        "image": "https://www.edamam.com/food-img/82b/82b8d0db2d5c38fc7498a657c0afc4ee.JPG"
                    },
                    {
                        "text": "2 teaspoons chicken stock",
                        "weight": 10.00000000050721,
                        "foodCategory": "canned soup",
                        "foodId": "food_bptblvzambd16nbhewqmhaw1rnh5",
                        "image": "https://www.edamam.com/food-img/26a/26a10c4cb4e07bab54d8a687ef5ac7d8.jpg"
                    },
                    {
                        "text": "200 ml mayonnaise",
                        "weight": 195.2759811031433,
                        "foodCategory": "condiments and sauces",
                        "foodId": "food_bu8t61zaplle7dbrzk81dbygq0qj",
                        "image": "https://www.edamam.com/food-img/577/577308a0422357885c94cc9b5f1f1862.jpg"
                    },
                    {
                        "text": "200 ml cream",
                        "weight": 201.53157530298427,
                        "foodCategory": "Dairy",
                        "foodId": "food_bvhbvd7bwy6a7wamfrmvmbmen1sz",
                        "image": "https://www.edamam.com/food-img/484/4848d71f6a14dd5076083f5e17925420.jpg"
                    },
                    {
                        "text": "small bunch of parsley",
                        "weight": 45,
                        "foodCategory": "vegetables",
                        "foodId": "food_b244pqdazw24zobr5vqu2bf0uid8",
                        "image": "https://www.edamam.com/food-img/46a/46a132e96626d7989b4d6ed8c91f4da0.jpg"
                    },
                    {
                        "text": "1 teaspoon curry powder",
                        "weight": 2,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_ao4koeoajh7yjxaq2knzrbv55y8o",
                        "image": "https://www.edamam.com/food-img/9ce/9ce02a2887385fd2adaec8dd8adcf9c5.jpg"
                    }
                ],
                "calories": 4115.31372402923,
                "totalWeight": 2476.0075564066346,
                "totalTime": 0,
                "cuisineType": [
                    "middle eastern"
                ],
                "mealType": [
                    "lunch/dinner"
                ],
                "dishType": [
                    "main course"
                ],
                "totalNutrients": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 4115.31372402923,
                        "unit": "kcal"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 340.63488831153063,
                        "unit": "g"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 101.69895025064643,
                        "unit": "g"
                    },
                    "FATRN": {
                        "label": "Trans",
                        "quantity": 0.7275,
                        "unit": "g"
                    },
                    "FAMS": {
                        "label": "Monounsaturated",
                        "quantity": 106.42951848978652,
                        "unit": "g"
                    },
                    "FAPU": {
                        "label": "Polyunsaturated",
                        "quantity": 118.2007671143163,
                        "unit": "g"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 60.39955095097116,
                        "unit": "g"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 12.649,
                        "unit": "g"
                    },
                    "SUGAR": {
                        "label": "Sugars",
                        "quantity": 30.296670950961275,
                        "unit": "g"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 164.42033729372395,
                        "unit": "g"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 915.0558907953296,
                        "unit": "mg"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 1824.7524095809965,
                        "unit": "mg"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 396.32152394695504,
                        "unit": "mg"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 297.70121027122923,
                        "unit": "mg"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 4178.55268147777,
                        "unit": "mg"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 14.21537947259196,
                        "unit": "mg"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 14.341002623197575,
                        "unit": "mg"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 1834.685576687987,
                        "unit": "mg"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 1325.3647744952705,
                        "unit": "µg"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 105.79318945181892,
                        "unit": "mg"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 1.094816946566834,
                        "unit": "mg"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 3.3421967328337137,
                        "unit": "mg"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 70.81039531437621,
                        "unit": "mg"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 3.7401622095790854,
                        "unit": "mg"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 267.4332630121447,
                        "unit": "µg"
                    },
                    "FOLFD": {
                        "label": "Folate (food)",
                        "quantity": 267.4332630121447,
                        "unit": "µg"
                    },
                    "FOLAC": {
                        "label": "Folic acid",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 2.887756835545372,
                        "unit": "µg"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 3.91072102712089,
                        "unit": "µg"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 5.3415346982117855,
                        "unit": "mg"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 759.8558104096965,
                        "unit": "µg"
                    },
                    "WATER": {
                        "label": "Water",
                        "quantity": 1829.8568521078193,
                        "unit": "g"
                    }
                },
                "totalDaily": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 205.7656862014615,
                        "unit": "%"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 524.0536743254318,
                        "unit": "%"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 508.49475125323215,
                        "unit": "%"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 20.13318365032372,
                        "unit": "%"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 50.596,
                        "unit": "%"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 328.8406745874479,
                        "unit": "%"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 305.0186302651099,
                        "unit": "%"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 76.0313503992082,
                        "unit": "%"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 39.6321523946955,
                        "unit": "%"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 70.88124054076886,
                        "unit": "%"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 88.90537620165469,
                        "unit": "%"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 78.97433040328866,
                        "unit": "%"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 130.37275111997795,
                        "unit": "%"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 262.09793952685527,
                        "unit": "%"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 147.2627527216967,
                        "unit": "%"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 117.5479882797988,
                        "unit": "%"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 91.23474554723617,
                        "unit": "%"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 257.0920563718241,
                        "unit": "%"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 442.5649707148513,
                        "unit": "%"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 287.70478535223737,
                        "unit": "%"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 66.85831575303618,
                        "unit": "%"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 120.32320148105717,
                        "unit": "%"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 26.071473514139267,
                        "unit": "%"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 35.6102313214119,
                        "unit": "%"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 633.2131753414137,
                        "unit": "%"
                    }
                },
                "digest": [
                    {
                        "label": "Fat",
                        "tag": "FAT",
                        "schemaOrgTag": "fatContent",
                        "total": 340.63488831153063,
                        "hasRDI": true,
                        "daily": 524.0536743254318,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Saturated",
                                "tag": "FASAT",
                                "schemaOrgTag": "saturatedFatContent",
                                "total": 101.69895025064643,
                                "hasRDI": true,
                                "daily": 508.49475125323215,
                                "unit": "g"
                            },
                            {
                                "label": "Trans",
                                "tag": "FATRN",
                                "schemaOrgTag": "transFatContent",
                                "total": 0.7275,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Monounsaturated",
                                "tag": "FAMS",
                                "schemaOrgTag": null,
                                "total": 106.42951848978652,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Polyunsaturated",
                                "tag": "FAPU",
                                "schemaOrgTag": null,
                                "total": 118.2007671143163,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Carbs",
                        "tag": "CHOCDF",
                        "schemaOrgTag": "carbohydrateContent",
                        "total": 60.39955095097116,
                        "hasRDI": true,
                        "daily": 20.13318365032372,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Carbs (net)",
                                "tag": "CHOCDF.net",
                                "schemaOrgTag": null,
                                "total": 47.75055095097116,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Fiber",
                                "tag": "FIBTG",
                                "schemaOrgTag": "fiberContent",
                                "total": 12.649,
                                "hasRDI": true,
                                "daily": 50.596,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars",
                                "tag": "SUGAR",
                                "schemaOrgTag": "sugarContent",
                                "total": 30.296670950961275,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars, added",
                                "tag": "SUGAR.added",
                                "schemaOrgTag": null,
                                "total": 0,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Protein",
                        "tag": "PROCNT",
                        "schemaOrgTag": "proteinContent",
                        "total": 164.42033729372395,
                        "hasRDI": true,
                        "daily": 328.8406745874479,
                        "unit": "g"
                    },
                    {
                        "label": "Cholesterol",
                        "tag": "CHOLE",
                        "schemaOrgTag": "cholesterolContent",
                        "total": 915.0558907953296,
                        "hasRDI": true,
                        "daily": 305.0186302651099,
                        "unit": "mg"
                    },
                    {
                        "label": "Sodium",
                        "tag": "NA",
                        "schemaOrgTag": "sodiumContent",
                        "total": 1824.7524095809965,
                        "hasRDI": true,
                        "daily": 76.0313503992082,
                        "unit": "mg"
                    },
                    {
                        "label": "Calcium",
                        "tag": "CA",
                        "schemaOrgTag": null,
                        "total": 396.32152394695504,
                        "hasRDI": true,
                        "daily": 39.6321523946955,
                        "unit": "mg"
                    },
                    {
                        "label": "Magnesium",
                        "tag": "MG",
                        "schemaOrgTag": null,
                        "total": 297.70121027122923,
                        "hasRDI": true,
                        "daily": 70.88124054076886,
                        "unit": "mg"
                    },
                    {
                        "label": "Potassium",
                        "tag": "K",
                        "schemaOrgTag": null,
                        "total": 4178.55268147777,
                        "hasRDI": true,
                        "daily": 88.90537620165469,
                        "unit": "mg"
                    },
                    {
                        "label": "Iron",
                        "tag": "FE",
                        "schemaOrgTag": null,
                        "total": 14.21537947259196,
                        "hasRDI": true,
                        "daily": 78.97433040328866,
                        "unit": "mg"
                    },
                    {
                        "label": "Zinc",
                        "tag": "ZN",
                        "schemaOrgTag": null,
                        "total": 14.341002623197575,
                        "hasRDI": true,
                        "daily": 130.37275111997795,
                        "unit": "mg"
                    },
                    {
                        "label": "Phosphorus",
                        "tag": "P",
                        "schemaOrgTag": null,
                        "total": 1834.685576687987,
                        "hasRDI": true,
                        "daily": 262.09793952685527,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin A",
                        "tag": "VITA_RAE",
                        "schemaOrgTag": null,
                        "total": 1325.3647744952705,
                        "hasRDI": true,
                        "daily": 147.2627527216967,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin C",
                        "tag": "VITC",
                        "schemaOrgTag": null,
                        "total": 105.79318945181892,
                        "hasRDI": true,
                        "daily": 117.5479882797988,
                        "unit": "mg"
                    },
                    {
                        "label": "Thiamin (B1)",
                        "tag": "THIA",
                        "schemaOrgTag": null,
                        "total": 1.094816946566834,
                        "hasRDI": true,
                        "daily": 91.23474554723617,
                        "unit": "mg"
                    },
                    {
                        "label": "Riboflavin (B2)",
                        "tag": "RIBF",
                        "schemaOrgTag": null,
                        "total": 3.3421967328337137,
                        "hasRDI": true,
                        "daily": 257.0920563718241,
                        "unit": "mg"
                    },
                    {
                        "label": "Niacin (B3)",
                        "tag": "NIA",
                        "schemaOrgTag": null,
                        "total": 70.81039531437621,
                        "hasRDI": true,
                        "daily": 442.5649707148513,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin B6",
                        "tag": "VITB6A",
                        "schemaOrgTag": null,
                        "total": 3.7401622095790854,
                        "hasRDI": true,
                        "daily": 287.70478535223737,
                        "unit": "mg"
                    },
                    {
                        "label": "Folate equivalent (total)",
                        "tag": "FOLDFE",
                        "schemaOrgTag": null,
                        "total": 267.4332630121447,
                        "hasRDI": true,
                        "daily": 66.85831575303618,
                        "unit": "µg"
                    },
                    {
                        "label": "Folate (food)",
                        "tag": "FOLFD",
                        "schemaOrgTag": null,
                        "total": 267.4332630121447,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Folic acid",
                        "tag": "FOLAC",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin B12",
                        "tag": "VITB12",
                        "schemaOrgTag": null,
                        "total": 2.887756835545372,
                        "hasRDI": true,
                        "daily": 120.32320148105717,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin D",
                        "tag": "VITD",
                        "schemaOrgTag": null,
                        "total": 3.91072102712089,
                        "hasRDI": true,
                        "daily": 26.071473514139267,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin E",
                        "tag": "TOCPHA",
                        "schemaOrgTag": null,
                        "total": 5.3415346982117855,
                        "hasRDI": true,
                        "daily": 35.6102313214119,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin K",
                        "tag": "VITK1",
                        "schemaOrgTag": null,
                        "total": 759.8558104096965,
                        "hasRDI": true,
                        "daily": 633.2131753414137,
                        "unit": "µg"
                    },
                    {
                        "label": "Sugar alcohols",
                        "tag": "Sugar.alcohol",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    },
                    {
                        "label": "Water",
                        "tag": "WATER",
                        "schemaOrgTag": null,
                        "total": 1829.8568521078193,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    }
                ]
            },
            "_links": {
                "self": {
                    "href": "https://api.edamam.com/api/recipes/v2/4caf01683bf99ddc7c08c35774aae54c?type=public&app_id=ea1d37d5&app_key=fd382a172ba8d6668c0430dc9c14a181",
                    "title": "Self"
                }
            }
        },
        {
            "recipe": {
                "uri": "http://www.edamam.com/ontologies/edamam.owl#recipe_a7c379c59775dd0c7c88710f7fecff81",
                "label": "Chicken Stew",
                "image": "https://www.edamam.com/web-img/74b/74bfb16655500083c4af92bcf45889f7.jpg",
                "source": "Food52",
                "url": "https://food52.com/recipes/83097-chicken-stew",
                "shareAs": "http://www.edamam.com/recipe/chicken-stew-a7c379c59775dd0c7c88710f7fecff81/chicken",
                "yield": 4,
                "dietLabels": [],
                "healthLabels": [
                    "Paleo",
                    "Mediterranean",
                    "Dairy-Free",
                    "Gluten-Free",
                    "Wheat-Free",
                    "Egg-Free",
                    "Peanut-Free",
                    "Tree-Nut-Free",
                    "Soy-Free",
                    "Fish-Free",
                    "Shellfish-Free",
                    "Pork-Free",
                    "Red-Meat-Free",
                    "Crustacean-Free",
                    "Celery-Free",
                    "Mustard-Free",
                    "Sesame-Free",
                    "Lupine-Free",
                    "Mollusk-Free",
                    "Kosher"
                ],
                "cautions": [
                    "Sulfites"
                ],
                "ingredientLines": [
                    "1 pound chicken cut in pieces",
                    "4 carrots",
                    "1 onion",
                    "1 leek",
                    "1 green pepper",
                    "kosher salt",
                    "Freshly ground black pepper",
                    "Extra Virgin Olive Oil",
                    "1 cup white wine",
                    "Chicken broth"
                ],
                "ingredients": [
                    {
                        "text": "1 pound chicken cut in pieces",
                        "weight": 453.59237,
                        "foodCategory": "Poultry",
                        "foodId": "food_bmyxrshbfao9s1amjrvhoauob6mo",
                        "image": "https://www.edamam.com/food-img/d33/d338229d774a743f7858f6764e095878.jpg"
                    },
                    {
                        "text": "4 carrots",
                        "weight": 244,
                        "foodCategory": "vegetables",
                        "foodId": "food_ai215e5b85pdh5ajd4aafa3w2zm8",
                        "image": "https://www.edamam.com/food-img/121/121e33fce0bb9546ed7d060b6c114e29.jpg"
                    },
                    {
                        "text": "1 onion",
                        "weight": 125,
                        "foodCategory": "vegetables",
                        "foodId": "food_bmrvi4ob4binw9a5m7l07amlfcoy",
                        "image": "https://www.edamam.com/food-img/205/205e6bf2399b85d34741892ef91cc603.jpg"
                    },
                    {
                        "text": "1 leek",
                        "weight": 89,
                        "foodCategory": "vegetables",
                        "foodId": "food_a27jevnb06c1m9ax7k41xbbcwcuo",
                        "image": "https://www.edamam.com/food-img/4ae/4ae9e09d029a28e0e2c64bdfdbf3f6ae.jpg"
                    },
                    {
                        "text": "1 green pepper",
                        "weight": 116.28888888888889,
                        "foodCategory": "vegetables",
                        "foodId": "food_bz8rcwobbzm7zhb3wh2n7aznivou",
                        "image": "https://www.edamam.com/food-img/629/629dc9fddc1f8aec27fa337dd6ce2b7c.jpg"
                    },
                    {
                        "text": "kosher salt",
                        "weight": 7.578487553333335,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_a1vgrj1bs8rd1majvmd9ubz8ttkg",
                        "image": "https://www.edamam.com/food-img/694/6943ea510918c6025795e8dc6e6eaaeb.jpg"
                    },
                    {
                        "text": "Freshly ground black pepper",
                        "weight": 3.7892437766666673,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_b6ywzluaaxv02wad7s1r9ag4py89",
                        "image": "https://www.edamam.com/food-img/c6e/c6e5c3bd8d3bc15175d9766971a4d1b2.jpg"
                    },
                    {
                        "text": "Extra Virgin Olive Oil",
                        "weight": 17.17790512088889,
                        "foodCategory": "Oils",
                        "foodId": "food_b1d1icuad3iktrbqby0hiagafaz7",
                        "image": "https://www.edamam.com/food-img/4d6/4d651eaa8a353647746290c7a9b29d84.jpg"
                    },
                    {
                        "text": "1 cup white wine",
                        "weight": 235.2,
                        "foodCategory": "wines",
                        "foodId": "food_bn44h7baron9ufaoxinmya8l0yye",
                        "image": "https://www.edamam.com/food-img/a71/a718cf3c52add522128929f1f324d2ab.jpg"
                    },
                    {
                        "text": "Chicken broth",
                        "weight": 252.61625177777785,
                        "foodCategory": "canned soup",
                        "foodId": "food_bptblvzambd16nbhewqmhaw1rnh5",
                        "image": "https://www.edamam.com/food-img/26a/26a10c4cb4e07bab54d8a687ef5ac7d8.jpg"
                    }
                ],
                "calories": 1647.980907065869,
                "totalWeight": 1543.5979816137524,
                "totalTime": 70,
                "cuisineType": [
                    "american"
                ],
                "mealType": [
                    "lunch/dinner"
                ],
                "dishType": [
                    "main course"
                ],
                "totalNutrients": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 1647.980907065869,
                        "unit": "kcal"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 89.81913152245268,
                        "unit": "g"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 23.031228283225754,
                        "unit": "g"
                    },
                    "FATRN": {
                        "label": "Trans",
                        "quantity": 0.4399845989000001,
                        "unit": "g"
                    },
                    "FAMS": {
                        "label": "Monounsaturated",
                        "quantity": 42.398837451219094,
                        "unit": "g"
                    },
                    "FAPU": {
                        "label": "Polyunsaturated",
                        "quantity": 17.56112288716005,
                        "unit": "g"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 70.49527952737833,
                        "unit": "g"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 13.49458978660778,
                        "unit": "g"
                    },
                    "SUGAR": {
                        "label": "Sugars",
                        "quantity": 29.401041271592888,
                        "unit": "g"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 97.27173723764012,
                        "unit": "g"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 347.7727650533334,
                        "unit": "mg"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 3573.482932523408,
                        "unit": "mg"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 270.6726634159516,
                        "unit": "mg"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 209.22095303859533,
                        "unit": "mg"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 2667.6196938292937,
                        "unit": "mg"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 8.993759483110317,
                        "unit": "mg"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 7.68606367803631,
                        "unit": "mg"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 959.3679548249112,
                        "unit": "mg"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 2321.724130037477,
                        "unit": "µg"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 135.58497709022222,
                        "unit": "mg"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 0.7146481600676889,
                        "unit": "mg"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 1.035666185698,
                        "unit": "mg"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 38.60529223489397,
                        "unit": "mg"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 2.8248730190856555,
                        "unit": "mg"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 181.54141511981112,
                        "unit": "µg"
                    },
                    "FOLFD": {
                        "label": "Folate (food)",
                        "quantity": 181.54141511981112,
                        "unit": "µg"
                    },
                    "FOLAC": {
                        "label": "Folic acid",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 1.4061363470000001,
                        "unit": "µg"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 0.9071847400000002,
                        "unit": "µg"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 6.825468394547111,
                        "unit": "mg"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 107.93738677651179,
                        "unit": "µg"
                    },
                    "WATER": {
                        "label": "Water",
                        "quantity": 1246.7609451726719,
                        "unit": "g"
                    }
                },
                "totalDaily": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 82.39904535329345,
                        "unit": "%"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 138.18327926531182,
                        "unit": "%"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 115.15614141612878,
                        "unit": "%"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 23.498426509126112,
                        "unit": "%"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 53.978359146431124,
                        "unit": "%"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 194.54347447528025,
                        "unit": "%"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 115.92425501777781,
                        "unit": "%"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 148.89512218847534,
                        "unit": "%"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 27.06726634159516,
                        "unit": "%"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 49.81451262823698,
                        "unit": "%"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 56.75786582615519,
                        "unit": "%"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 49.96533046172399,
                        "unit": "%"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 69.87330616396645,
                        "unit": "%"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 137.05256497498732,
                        "unit": "%"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 257.9693477819419,
                        "unit": "%"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 150.64997454469136,
                        "unit": "%"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 59.55401333897409,
                        "unit": "%"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 79.66662966907693,
                        "unit": "%"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 241.28307646808733,
                        "unit": "%"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 217.29792454505042,
                        "unit": "%"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 45.38535377995279,
                        "unit": "%"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 58.58901445833334,
                        "unit": "%"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 6.047898266666667,
                        "unit": "%"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 45.50312263031408,
                        "unit": "%"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 89.94782231375983,
                        "unit": "%"
                    }
                },
                "digest": [
                    {
                        "label": "Fat",
                        "tag": "FAT",
                        "schemaOrgTag": "fatContent",
                        "total": 89.81913152245268,
                        "hasRDI": true,
                        "daily": 138.18327926531182,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Saturated",
                                "tag": "FASAT",
                                "schemaOrgTag": "saturatedFatContent",
                                "total": 23.031228283225754,
                                "hasRDI": true,
                                "daily": 115.15614141612878,
                                "unit": "g"
                            },
                            {
                                "label": "Trans",
                                "tag": "FATRN",
                                "schemaOrgTag": "transFatContent",
                                "total": 0.4399845989000001,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Monounsaturated",
                                "tag": "FAMS",
                                "schemaOrgTag": null,
                                "total": 42.398837451219094,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Polyunsaturated",
                                "tag": "FAPU",
                                "schemaOrgTag": null,
                                "total": 17.56112288716005,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Carbs",
                        "tag": "CHOCDF",
                        "schemaOrgTag": "carbohydrateContent",
                        "total": 70.49527952737833,
                        "hasRDI": true,
                        "daily": 23.498426509126112,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Carbs (net)",
                                "tag": "CHOCDF.net",
                                "schemaOrgTag": null,
                                "total": 57.000689740770554,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Fiber",
                                "tag": "FIBTG",
                                "schemaOrgTag": "fiberContent",
                                "total": 13.49458978660778,
                                "hasRDI": true,
                                "daily": 53.978359146431124,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars",
                                "tag": "SUGAR",
                                "schemaOrgTag": "sugarContent",
                                "total": 29.401041271592888,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars, added",
                                "tag": "SUGAR.added",
                                "schemaOrgTag": null,
                                "total": 0,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Protein",
                        "tag": "PROCNT",
                        "schemaOrgTag": "proteinContent",
                        "total": 97.27173723764012,
                        "hasRDI": true,
                        "daily": 194.54347447528025,
                        "unit": "g"
                    },
                    {
                        "label": "Cholesterol",
                        "tag": "CHOLE",
                        "schemaOrgTag": "cholesterolContent",
                        "total": 347.7727650533334,
                        "hasRDI": true,
                        "daily": 115.92425501777781,
                        "unit": "mg"
                    },
                    {
                        "label": "Sodium",
                        "tag": "NA",
                        "schemaOrgTag": "sodiumContent",
                        "total": 3573.482932523408,
                        "hasRDI": true,
                        "daily": 148.89512218847534,
                        "unit": "mg"
                    },
                    {
                        "label": "Calcium",
                        "tag": "CA",
                        "schemaOrgTag": null,
                        "total": 270.6726634159516,
                        "hasRDI": true,
                        "daily": 27.06726634159516,
                        "unit": "mg"
                    },
                    {
                        "label": "Magnesium",
                        "tag": "MG",
                        "schemaOrgTag": null,
                        "total": 209.22095303859533,
                        "hasRDI": true,
                        "daily": 49.81451262823698,
                        "unit": "mg"
                    },
                    {
                        "label": "Potassium",
                        "tag": "K",
                        "schemaOrgTag": null,
                        "total": 2667.6196938292937,
                        "hasRDI": true,
                        "daily": 56.75786582615519,
                        "unit": "mg"
                    },
                    {
                        "label": "Iron",
                        "tag": "FE",
                        "schemaOrgTag": null,
                        "total": 8.993759483110317,
                        "hasRDI": true,
                        "daily": 49.96533046172399,
                        "unit": "mg"
                    },
                    {
                        "label": "Zinc",
                        "tag": "ZN",
                        "schemaOrgTag": null,
                        "total": 7.68606367803631,
                        "hasRDI": true,
                        "daily": 69.87330616396645,
                        "unit": "mg"
                    },
                    {
                        "label": "Phosphorus",
                        "tag": "P",
                        "schemaOrgTag": null,
                        "total": 959.3679548249112,
                        "hasRDI": true,
                        "daily": 137.05256497498732,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin A",
                        "tag": "VITA_RAE",
                        "schemaOrgTag": null,
                        "total": 2321.724130037477,
                        "hasRDI": true,
                        "daily": 257.9693477819419,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin C",
                        "tag": "VITC",
                        "schemaOrgTag": null,
                        "total": 135.58497709022222,
                        "hasRDI": true,
                        "daily": 150.64997454469136,
                        "unit": "mg"
                    },
                    {
                        "label": "Thiamin (B1)",
                        "tag": "THIA",
                        "schemaOrgTag": null,
                        "total": 0.7146481600676889,
                        "hasRDI": true,
                        "daily": 59.55401333897409,
                        "unit": "mg"
                    },
                    {
                        "label": "Riboflavin (B2)",
                        "tag": "RIBF",
                        "schemaOrgTag": null,
                        "total": 1.035666185698,
                        "hasRDI": true,
                        "daily": 79.66662966907693,
                        "unit": "mg"
                    },
                    {
                        "label": "Niacin (B3)",
                        "tag": "NIA",
                        "schemaOrgTag": null,
                        "total": 38.60529223489397,
                        "hasRDI": true,
                        "daily": 241.28307646808733,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin B6",
                        "tag": "VITB6A",
                        "schemaOrgTag": null,
                        "total": 2.8248730190856555,
                        "hasRDI": true,
                        "daily": 217.29792454505042,
                        "unit": "mg"
                    },
                    {
                        "label": "Folate equivalent (total)",
                        "tag": "FOLDFE",
                        "schemaOrgTag": null,
                        "total": 181.54141511981112,
                        "hasRDI": true,
                        "daily": 45.38535377995279,
                        "unit": "µg"
                    },
                    {
                        "label": "Folate (food)",
                        "tag": "FOLFD",
                        "schemaOrgTag": null,
                        "total": 181.54141511981112,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Folic acid",
                        "tag": "FOLAC",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin B12",
                        "tag": "VITB12",
                        "schemaOrgTag": null,
                        "total": 1.4061363470000001,
                        "hasRDI": true,
                        "daily": 58.58901445833334,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin D",
                        "tag": "VITD",
                        "schemaOrgTag": null,
                        "total": 0.9071847400000002,
                        "hasRDI": true,
                        "daily": 6.047898266666667,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin E",
                        "tag": "TOCPHA",
                        "schemaOrgTag": null,
                        "total": 6.825468394547111,
                        "hasRDI": true,
                        "daily": 45.50312263031408,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin K",
                        "tag": "VITK1",
                        "schemaOrgTag": null,
                        "total": 107.93738677651179,
                        "hasRDI": true,
                        "daily": 89.94782231375983,
                        "unit": "µg"
                    },
                    {
                        "label": "Sugar alcohols",
                        "tag": "Sugar.alcohol",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    },
                    {
                        "label": "Water",
                        "tag": "WATER",
                        "schemaOrgTag": null,
                        "total": 1246.7609451726719,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    }
                ]
            },
            "_links": {
                "self": {
                    "href": "https://api.edamam.com/api/recipes/v2/a7c379c59775dd0c7c88710f7fecff81?type=public&app_id=ea1d37d5&app_key=fd382a172ba8d6668c0430dc9c14a181",
                    "title": "Self"
                }
            }
        },
        {
            "recipe": {
                "uri": "http://www.edamam.com/ontologies/edamam.owl#recipe_690c3797b4f56fc1e119c14096d651c5",
                "label": "Roast Chicken",
                "image": "https://www.edamam.com/web-img/25f/25feccd2eed4722604be4a9ffa1ac768.jpg",
                "source": "San Francisco Gate",
                "url": "http://www.sfgate.com/food/recipes/detail.html?rid=18229&sorig=qs",
                "shareAs": "http://www.edamam.com/recipe/roast-chicken-690c3797b4f56fc1e119c14096d651c5/chicken",
                "yield": 10,
                "dietLabels": [
                    "Low-Carb"
                ],
                "healthLabels": [
                    "Sugar-Conscious",
                    "Kidney-Friendly",
                    "Keto-Friendly",
                    "Paleo",
                    "Mediterranean",
                    "Dairy-Free",
                    "Gluten-Free",
                    "Wheat-Free",
                    "Egg-Free",
                    "Peanut-Free",
                    "Tree-Nut-Free",
                    "Soy-Free",
                    "Fish-Free",
                    "Shellfish-Free",
                    "Pork-Free",
                    "Red-Meat-Free",
                    "Crustacean-Free",
                    "Celery-Free",
                    "Mustard-Free",
                    "Sesame-Free",
                    "Lupine-Free",
                    "Mollusk-Free",
                    "Alcohol-Free",
                    "Sulfite-Free",
                    "Kosher",
                    "Immuno-Supportive"
                ],
                "cautions": [
                    "Sulfites"
                ],
                "ingredientLines": [
                    "1 whole chicken, about 3-4 pounds",
                    "-- Salt and fresh-ground pepper, to taste",
                    "3 to 4 sprigs thyme, or other herbs",
                    "-- Olive oil, to taste",
                    "-- Chicken stock (optional)"
                ],
                "ingredients": [
                    {
                        "text": "1 whole chicken, about 3-4 pounds",
                        "weight": 1587.5732950000001,
                        "foodCategory": "Poultry",
                        "foodId": "food_bmyxrshbfao9s1amjrvhoauob6mo",
                        "image": "https://www.edamam.com/food-img/d33/d338229d774a743f7858f6764e095878.jpg"
                    },
                    {
                        "text": "-- Salt and fresh-ground pepper, to taste",
                        "weight": 9.58843977,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_btxz81db72hwbra2pncvebzzzum9",
                        "image": "https://www.edamam.com/food-img/694/6943ea510918c6025795e8dc6e6eaaeb.jpg"
                    },
                    {
                        "text": "3 to 4 sprigs thyme, or other herbs",
                        "weight": 10.5,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_b3o3cj7a5gskecb0ufphtadnbfqb",
                        "image": "https://www.edamam.com/food-img/3e7/3e7cf3c8d767a90b906447f5e74059f7.jpg"
                    },
                    {
                        "text": "-- Olive oil, to taste",
                        "weight": 21.733796812,
                        "foodCategory": "Oils",
                        "foodId": "food_b1d1icuad3iktrbqby0hiagafaz7",
                        "image": "https://www.edamam.com/food-img/4d6/4d651eaa8a353647746290c7a9b29d84.jpg"
                    },
                    {
                        "text": "-- Chicken stock (optional)",
                        "weight": 319.6146590000001,
                        "foodCategory": "canned soup",
                        "foodId": "food_bptblvzambd16nbhewqmhaw1rnh5",
                        "image": "https://www.edamam.com/food-img/26a/26a10c4cb4e07bab54d8a687ef5ac7d8.jpg"
                    }
                ],
                "calories": 2638.8251983480804,
                "totalWeight": 1947.9257318387613,
                "totalTime": 0,
                "cuisineType": [
                    "american"
                ],
                "mealType": [
                    "lunch/dinner"
                ],
                "dishType": [
                    "main course"
                ],
                "totalNutrients": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 2638.8251983480804,
                        "unit": "kcal"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 188.32577871436,
                        "unit": "g"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 50.60459884905096,
                        "unit": "g"
                    },
                    "FATRN": {
                        "label": "Trans",
                        "quantity": 1.047163345382,
                        "unit": "g"
                    },
                    "FAMS": {
                        "label": "Monounsaturated",
                        "quantity": 85.08976786082334,
                        "unit": "g"
                    },
                    "FAPU": {
                        "label": "Polyunsaturated",
                        "quantity": 37.89314651357677,
                        "unit": "g"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 13.849647462700002,
                        "unit": "g"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 1.47,
                        "unit": "g"
                    },
                    "SUGAR": {
                        "label": "Sugars",
                        "quantity": 5.049911612200002,
                        "unit": "g"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 209.4343597584,
                        "unit": "g"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 819.25082022,
                        "unit": "mg"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 4510.086493078291,
                        "unit": "mg"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 173.12221565054267,
                        "unit": "mg"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 245.5795942902676,
                        "unit": "mg"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 2440.787247134261,
                        "unit": "mg"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 12.369161748835513,
                        "unit": "mg"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 14.788117415486761,
                        "unit": "mg"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 1684.3642236120002,
                        "unit": "mg"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 470.801581236,
                        "unit": "µg"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 34.722526767599994,
                        "unit": "mg"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 0.7646350350100001,
                        "unit": "mg"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 1.61658726887,
                        "unit": "mg"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 78.674400857766,
                        "unit": "mg"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 4.00992938409,
                        "unit": "mg"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 85.478723386,
                        "unit": "µg"
                    },
                    "FOLFD": {
                        "label": "Folate (food)",
                        "quantity": 85.478723386,
                        "unit": "µg"
                    },
                    "FOLAC": {
                        "label": "Folic acid",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 3.34660450586,
                        "unit": "µg"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 2.1590996812000003,
                        "unit": "µg"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 6.453333762022,
                        "unit": "mg"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 29.916222607824004,
                        "unit": "µg"
                    },
                    "WATER": {
                        "label": "Water",
                        "quantity": 1013.7734060424935,
                        "unit": "g"
                    }
                },
                "totalDaily": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 131.94125991740404,
                        "unit": "%"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 289.7319672528616,
                        "unit": "%"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 253.0229942452548,
                        "unit": "%"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 4.616549154233334,
                        "unit": "%"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 5.88,
                        "unit": "%"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 418.86871951680007,
                        "unit": "%"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 273.08360674,
                        "unit": "%"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 187.9202705449288,
                        "unit": "%"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 17.31222156505427,
                        "unit": "%"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 58.471331973873234,
                        "unit": "%"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 51.93164355604811,
                        "unit": "%"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 68.7175652713084,
                        "unit": "%"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 134.43743104987965,
                        "unit": "%"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 240.623460516,
                        "unit": "%"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 52.311286804,
                        "unit": "%"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 38.58058529733333,
                        "unit": "%"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 63.71958625083334,
                        "unit": "%"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 124.35286683615384,
                        "unit": "%"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 491.7150053610375,
                        "unit": "%"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 308.45610646846154,
                        "unit": "%"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 21.3696808465,
                        "unit": "%"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 139.44185441083332,
                        "unit": "%"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 14.393997874666669,
                        "unit": "%"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 43.02222508014667,
                        "unit": "%"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 24.93018550652,
                        "unit": "%"
                    }
                },
                "digest": [
                    {
                        "label": "Fat",
                        "tag": "FAT",
                        "schemaOrgTag": "fatContent",
                        "total": 188.32577871436,
                        "hasRDI": true,
                        "daily": 289.7319672528616,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Saturated",
                                "tag": "FASAT",
                                "schemaOrgTag": "saturatedFatContent",
                                "total": 50.60459884905096,
                                "hasRDI": true,
                                "daily": 253.0229942452548,
                                "unit": "g"
                            },
                            {
                                "label": "Trans",
                                "tag": "FATRN",
                                "schemaOrgTag": "transFatContent",
                                "total": 1.047163345382,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Monounsaturated",
                                "tag": "FAMS",
                                "schemaOrgTag": null,
                                "total": 85.08976786082334,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Polyunsaturated",
                                "tag": "FAPU",
                                "schemaOrgTag": null,
                                "total": 37.89314651357677,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Carbs",
                        "tag": "CHOCDF",
                        "schemaOrgTag": "carbohydrateContent",
                        "total": 13.849647462700002,
                        "hasRDI": true,
                        "daily": 4.616549154233334,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Carbs (net)",
                                "tag": "CHOCDF.net",
                                "schemaOrgTag": null,
                                "total": 12.379647462700001,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Fiber",
                                "tag": "FIBTG",
                                "schemaOrgTag": "fiberContent",
                                "total": 1.47,
                                "hasRDI": true,
                                "daily": 5.88,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars",
                                "tag": "SUGAR",
                                "schemaOrgTag": "sugarContent",
                                "total": 5.049911612200002,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars, added",
                                "tag": "SUGAR.added",
                                "schemaOrgTag": null,
                                "total": 0,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Protein",
                        "tag": "PROCNT",
                        "schemaOrgTag": "proteinContent",
                        "total": 209.4343597584,
                        "hasRDI": true,
                        "daily": 418.86871951680007,
                        "unit": "g"
                    },
                    {
                        "label": "Cholesterol",
                        "tag": "CHOLE",
                        "schemaOrgTag": "cholesterolContent",
                        "total": 819.25082022,
                        "hasRDI": true,
                        "daily": 273.08360674,
                        "unit": "mg"
                    },
                    {
                        "label": "Sodium",
                        "tag": "NA",
                        "schemaOrgTag": "sodiumContent",
                        "total": 4510.086493078291,
                        "hasRDI": true,
                        "daily": 187.9202705449288,
                        "unit": "mg"
                    },
                    {
                        "label": "Calcium",
                        "tag": "CA",
                        "schemaOrgTag": null,
                        "total": 173.12221565054267,
                        "hasRDI": true,
                        "daily": 17.31222156505427,
                        "unit": "mg"
                    },
                    {
                        "label": "Magnesium",
                        "tag": "MG",
                        "schemaOrgTag": null,
                        "total": 245.5795942902676,
                        "hasRDI": true,
                        "daily": 58.471331973873234,
                        "unit": "mg"
                    },
                    {
                        "label": "Potassium",
                        "tag": "K",
                        "schemaOrgTag": null,
                        "total": 2440.787247134261,
                        "hasRDI": true,
                        "daily": 51.93164355604811,
                        "unit": "mg"
                    },
                    {
                        "label": "Iron",
                        "tag": "FE",
                        "schemaOrgTag": null,
                        "total": 12.369161748835513,
                        "hasRDI": true,
                        "daily": 68.7175652713084,
                        "unit": "mg"
                    },
                    {
                        "label": "Zinc",
                        "tag": "ZN",
                        "schemaOrgTag": null,
                        "total": 14.788117415486761,
                        "hasRDI": true,
                        "daily": 134.43743104987965,
                        "unit": "mg"
                    },
                    {
                        "label": "Phosphorus",
                        "tag": "P",
                        "schemaOrgTag": null,
                        "total": 1684.3642236120002,
                        "hasRDI": true,
                        "daily": 240.623460516,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin A",
                        "tag": "VITA_RAE",
                        "schemaOrgTag": null,
                        "total": 470.801581236,
                        "hasRDI": true,
                        "daily": 52.311286804,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin C",
                        "tag": "VITC",
                        "schemaOrgTag": null,
                        "total": 34.722526767599994,
                        "hasRDI": true,
                        "daily": 38.58058529733333,
                        "unit": "mg"
                    },
                    {
                        "label": "Thiamin (B1)",
                        "tag": "THIA",
                        "schemaOrgTag": null,
                        "total": 0.7646350350100001,
                        "hasRDI": true,
                        "daily": 63.71958625083334,
                        "unit": "mg"
                    },
                    {
                        "label": "Riboflavin (B2)",
                        "tag": "RIBF",
                        "schemaOrgTag": null,
                        "total": 1.61658726887,
                        "hasRDI": true,
                        "daily": 124.35286683615384,
                        "unit": "mg"
                    },
                    {
                        "label": "Niacin (B3)",
                        "tag": "NIA",
                        "schemaOrgTag": null,
                        "total": 78.674400857766,
                        "hasRDI": true,
                        "daily": 491.7150053610375,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin B6",
                        "tag": "VITB6A",
                        "schemaOrgTag": null,
                        "total": 4.00992938409,
                        "hasRDI": true,
                        "daily": 308.45610646846154,
                        "unit": "mg"
                    },
                    {
                        "label": "Folate equivalent (total)",
                        "tag": "FOLDFE",
                        "schemaOrgTag": null,
                        "total": 85.478723386,
                        "hasRDI": true,
                        "daily": 21.3696808465,
                        "unit": "µg"
                    },
                    {
                        "label": "Folate (food)",
                        "tag": "FOLFD",
                        "schemaOrgTag": null,
                        "total": 85.478723386,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Folic acid",
                        "tag": "FOLAC",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin B12",
                        "tag": "VITB12",
                        "schemaOrgTag": null,
                        "total": 3.34660450586,
                        "hasRDI": true,
                        "daily": 139.44185441083332,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin D",
                        "tag": "VITD",
                        "schemaOrgTag": null,
                        "total": 2.1590996812000003,
                        "hasRDI": true,
                        "daily": 14.393997874666669,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin E",
                        "tag": "TOCPHA",
                        "schemaOrgTag": null,
                        "total": 6.453333762022,
                        "hasRDI": true,
                        "daily": 43.02222508014667,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin K",
                        "tag": "VITK1",
                        "schemaOrgTag": null,
                        "total": 29.916222607824004,
                        "hasRDI": true,
                        "daily": 24.93018550652,
                        "unit": "µg"
                    },
                    {
                        "label": "Sugar alcohols",
                        "tag": "Sugar.alcohol",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    },
                    {
                        "label": "Water",
                        "tag": "WATER",
                        "schemaOrgTag": null,
                        "total": 1013.7734060424935,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    }
                ]
            },
            "_links": {
                "self": {
                    "href": "https://api.edamam.com/api/recipes/v2/690c3797b4f56fc1e119c14096d651c5?type=public&app_id=ea1d37d5&app_key=fd382a172ba8d6668c0430dc9c14a181",
                    "title": "Self"
                }
            }
        },
        {
            "recipe": {
                "uri": "http://www.edamam.com/ontologies/edamam.owl#recipe_9ca0499f2ac7f1e4cae63bdf4671c1b3",
                "label": "Chicken Liver Pâté",
                "image": "https://www.edamam.com/web-img/480/480000e79dbdd4648c4acd65630ff654.jpg",
                "source": "Saveur",
                "url": "http://www.saveur.com/article/Recipes/Classic-Chicken-Pate",
                "shareAs": "http://www.edamam.com/recipe/chicken-liver-p%C3%A2t%C3%A9-9ca0499f2ac7f1e4cae63bdf4671c1b3/chicken",
                "yield": 6,
                "dietLabels": [],
                "healthLabels": [
                    "Sugar-Conscious",
                    "Peanut-Free",
                    "Tree-Nut-Free",
                    "Soy-Free",
                    "Fish-Free",
                    "Shellfish-Free",
                    "Crustacean-Free",
                    "Celery-Free",
                    "Mustard-Free",
                    "Sesame-Free",
                    "Lupine-Free",
                    "Mollusk-Free",
                    "Sulfite-Free"
                ],
                "cautions": [
                    "Sulfites"
                ],
                "ingredientLines": [
                    "8 oz. chicken livers, cleaned",
                    "4 cups chicken stock",
                    "2 tbsp. rendered chicken fat or unsalted butter",
                    "½ medium yellow onion, minced",
                    "1½ tbsp. cognac or brandy",
                    "2 hard-boiled eggs",
                    "Kosher salt and freshly ground black pepper, to taste",
                    "Toast points, for serving"
                ],
                "ingredients": [
                    {
                        "text": "8 oz. chicken livers, cleaned",
                        "weight": 226.796185,
                        "foodCategory": "Poultry",
                        "foodId": "food_a9xs7abb632dn3aozv3w4a9351fh",
                        "image": "https://www.edamam.com/food-img/9aa/9aa4760ac12b682555a37a1cdc91150b.jpg"
                    },
                    {
                        "text": "4 cups chicken stock",
                        "weight": 960,
                        "foodCategory": "canned soup",
                        "foodId": "food_bptblvzambd16nbhewqmhaw1rnh5",
                        "image": "https://www.edamam.com/food-img/26a/26a10c4cb4e07bab54d8a687ef5ac7d8.jpg"
                    },
                    {
                        "text": "2 tbsp. rendered chicken fat or unsalted butter",
                        "weight": 28.2499999995224,
                        "foodCategory": "cured meats",
                        "foodId": "food_a146ueba4s2j2ya6rknjeaum2mko",
                        "image": null
                    },
                    {
                        "text": "½ medium yellow onion, minced",
                        "weight": 55,
                        "foodCategory": "vegetables",
                        "foodId": "food_bmrvi4ob4binw9a5m7l07amlfcoy",
                        "image": "https://www.edamam.com/food-img/205/205e6bf2399b85d34741892ef91cc603.jpg"
                    },
                    {
                        "text": "1½ tbsp. cognac or brandy",
                        "weight": 20.9999999995266,
                        "foodCategory": "liquors and cocktails",
                        "foodId": "food_ajguqpia53yz3oah6w2frad3tz65",
                        "image": "https://www.edamam.com/food-img/c7f/c7fcc63de96b349534aade3de3f9fa7d.jpg"
                    },
                    {
                        "text": "2 hard-boiled eggs",
                        "weight": 80,
                        "foodCategory": "Eggs",
                        "foodId": "food_a2y52zfbr22uq1ah5thnqac607ft",
                        "image": "https://www.edamam.com/food-img/e54/e54c012fabed0f9cf211a817d1e23c5c.jpg"
                    },
                    {
                        "text": "Kosher salt and freshly ground black pepper, to taste",
                        "weight": 8.370277109994293,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_a1vgrj1bs8rd1majvmd9ubz8ttkg",
                        "image": "https://www.edamam.com/food-img/694/6943ea510918c6025795e8dc6e6eaaeb.jpg"
                    },
                    {
                        "text": "Kosher salt and freshly ground black pepper, to taste",
                        "weight": 4.185138554997146,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_b6ywzluaaxv02wad7s1r9ag4py89",
                        "image": "https://www.edamam.com/food-img/c6e/c6e5c3bd8d3bc15175d9766971a4d1b2.jpg"
                    },
                    {
                        "text": "Toast points, for serving",
                        "weight": 24,
                        "foodCategory": "bread, rolls and tortillas",
                        "foodId": "food_apk1psxaqtsilfbfxoa5hbxfgdg4",
                        "image": "https://www.edamam.com/food-img/6c0/6c0c1e866e0106b960d1463a9bdc54db.jpg"
                    }
                ],
                "calories": 1149.3071579176606,
                "totalWeight": 1403.013109609151,
                "totalTime": 0,
                "cuisineType": [
                    "french"
                ],
                "mealType": [
                    "brunch"
                ],
                "dishType": [
                    "starter"
                ],
                "totalNutrients": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 1149.3071579176606,
                        "unit": "kcal"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 60.2872412519177,
                        "unit": "g"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 18.59619900008277,
                        "unit": "g"
                    },
                    "FATRN": {
                        "label": "Trans",
                        "quantity": 0.14741752025000002,
                        "unit": "g"
                    },
                    "FAMS": {
                        "label": "Monounsaturated",
                        "quantity": 23.669510024373537,
                        "unit": "g"
                    },
                    "FAPU": {
                        "label": "Polyunsaturated",
                        "quantity": 9.578013358828558,
                        "unit": "g"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 57.63780825642067,
                        "unit": "g"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 3.121840054414278,
                        "unit": "g"
                    },
                    "SUGAR": {
                        "label": "Sugars",
                        "quantity": 19.963584886751985,
                        "unit": "g"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 76.79992539786387,
                        "unit": "g"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 1137.0493382495367,
                        "unit": "mg"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 3253.8844582984625,
                        "unit": "mg"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 158.9239872518578,
                        "unit": "mg"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 116.34567993959617,
                        "unit": "mg"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 1824.8317597802393,
                        "unit": "mg"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 24.918058879171266,
                        "unit": "mg"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 8.764693074359098,
                        "unit": "mg"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 1141.4496883668335,
                        "unit": "mg"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 7608.239745009798,
                        "unit": "µg"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 46.63451711500001,
                        "unit": "mg"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 1.2180983138893495,
                        "unit": "mg"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 5.377976918698905,
                        "unit": "mg"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 39.13951151048009,
                        "unit": "mg"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 2.733492711245013,
                        "unit": "mg"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 1451.9230413543498,
                        "unit": "µg"
                    },
                    "FOLFD": {
                        "label": "Folate (food)",
                        "quantity": 1443.5230413543497,
                        "unit": "µg"
                    },
                    "FOLAC": {
                        "label": "Folic acid",
                        "quantity": 4.8,
                        "unit": "µg"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 38.51623247299957,
                        "unit": "µg"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 1.7600000000000002,
                        "unit": "µg"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 2.8116987359719703,
                        "unit": "mg"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 10.599071814530328,
                        "unit": "µg"
                    },
                    "WATER": {
                        "label": "Water",
                        "quantity": 1187.1557198867463,
                        "unit": "g"
                    }
                },
                "totalDaily": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 57.465357895883024,
                        "unit": "%"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 92.74960192602724,
                        "unit": "%"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 92.98099500041386,
                        "unit": "%"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 19.21260275214022,
                        "unit": "%"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 12.487360217657113,
                        "unit": "%"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 153.59985079572775,
                        "unit": "%"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 379.0164460831789,
                        "unit": "%"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 135.57851909576928,
                        "unit": "%"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 15.89239872518578,
                        "unit": "%"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 27.701352366570518,
                        "unit": "%"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 38.82620765489871,
                        "unit": "%"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 138.43366043984037,
                        "unit": "%"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 79.67902794871907,
                        "unit": "%"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 163.06424119526193,
                        "unit": "%"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 845.3599716677553,
                        "unit": "%"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 51.81613012777779,
                        "unit": "%"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 101.50819282411247,
                        "unit": "%"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 413.6905322076081,
                        "unit": "%"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 244.62194694050058,
                        "unit": "%"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 210.26867009577026,
                        "unit": "%"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 362.9807603385874,
                        "unit": "%"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 1604.8430197083153,
                        "unit": "%"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 11.733333333333336,
                        "unit": "%"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 18.744658239813134,
                        "unit": "%"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 8.83255984544194,
                        "unit": "%"
                    }
                },
                "digest": [
                    {
                        "label": "Fat",
                        "tag": "FAT",
                        "schemaOrgTag": "fatContent",
                        "total": 60.2872412519177,
                        "hasRDI": true,
                        "daily": 92.74960192602724,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Saturated",
                                "tag": "FASAT",
                                "schemaOrgTag": "saturatedFatContent",
                                "total": 18.59619900008277,
                                "hasRDI": true,
                                "daily": 92.98099500041386,
                                "unit": "g"
                            },
                            {
                                "label": "Trans",
                                "tag": "FATRN",
                                "schemaOrgTag": "transFatContent",
                                "total": 0.14741752025000002,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Monounsaturated",
                                "tag": "FAMS",
                                "schemaOrgTag": null,
                                "total": 23.669510024373537,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Polyunsaturated",
                                "tag": "FAPU",
                                "schemaOrgTag": null,
                                "total": 9.578013358828558,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Carbs",
                        "tag": "CHOCDF",
                        "schemaOrgTag": "carbohydrateContent",
                        "total": 57.63780825642067,
                        "hasRDI": true,
                        "daily": 19.21260275214022,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Carbs (net)",
                                "tag": "CHOCDF.net",
                                "schemaOrgTag": null,
                                "total": 54.51596820200639,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Fiber",
                                "tag": "FIBTG",
                                "schemaOrgTag": "fiberContent",
                                "total": 3.121840054414278,
                                "hasRDI": true,
                                "daily": 12.487360217657113,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars",
                                "tag": "SUGAR",
                                "schemaOrgTag": "sugarContent",
                                "total": 19.963584886751985,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars, added",
                                "tag": "SUGAR.added",
                                "schemaOrgTag": null,
                                "total": 0,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Protein",
                        "tag": "PROCNT",
                        "schemaOrgTag": "proteinContent",
                        "total": 76.79992539786387,
                        "hasRDI": true,
                        "daily": 153.59985079572775,
                        "unit": "g"
                    },
                    {
                        "label": "Cholesterol",
                        "tag": "CHOLE",
                        "schemaOrgTag": "cholesterolContent",
                        "total": 1137.0493382495367,
                        "hasRDI": true,
                        "daily": 379.0164460831789,
                        "unit": "mg"
                    },
                    {
                        "label": "Sodium",
                        "tag": "NA",
                        "schemaOrgTag": "sodiumContent",
                        "total": 3253.8844582984625,
                        "hasRDI": true,
                        "daily": 135.57851909576928,
                        "unit": "mg"
                    },
                    {
                        "label": "Calcium",
                        "tag": "CA",
                        "schemaOrgTag": null,
                        "total": 158.9239872518578,
                        "hasRDI": true,
                        "daily": 15.89239872518578,
                        "unit": "mg"
                    },
                    {
                        "label": "Magnesium",
                        "tag": "MG",
                        "schemaOrgTag": null,
                        "total": 116.34567993959617,
                        "hasRDI": true,
                        "daily": 27.701352366570518,
                        "unit": "mg"
                    },
                    {
                        "label": "Potassium",
                        "tag": "K",
                        "schemaOrgTag": null,
                        "total": 1824.8317597802393,
                        "hasRDI": true,
                        "daily": 38.82620765489871,
                        "unit": "mg"
                    },
                    {
                        "label": "Iron",
                        "tag": "FE",
                        "schemaOrgTag": null,
                        "total": 24.918058879171266,
                        "hasRDI": true,
                        "daily": 138.43366043984037,
                        "unit": "mg"
                    },
                    {
                        "label": "Zinc",
                        "tag": "ZN",
                        "schemaOrgTag": null,
                        "total": 8.764693074359098,
                        "hasRDI": true,
                        "daily": 79.67902794871907,
                        "unit": "mg"
                    },
                    {
                        "label": "Phosphorus",
                        "tag": "P",
                        "schemaOrgTag": null,
                        "total": 1141.4496883668335,
                        "hasRDI": true,
                        "daily": 163.06424119526193,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin A",
                        "tag": "VITA_RAE",
                        "schemaOrgTag": null,
                        "total": 7608.239745009798,
                        "hasRDI": true,
                        "daily": 845.3599716677553,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin C",
                        "tag": "VITC",
                        "schemaOrgTag": null,
                        "total": 46.63451711500001,
                        "hasRDI": true,
                        "daily": 51.81613012777779,
                        "unit": "mg"
                    },
                    {
                        "label": "Thiamin (B1)",
                        "tag": "THIA",
                        "schemaOrgTag": null,
                        "total": 1.2180983138893495,
                        "hasRDI": true,
                        "daily": 101.50819282411247,
                        "unit": "mg"
                    },
                    {
                        "label": "Riboflavin (B2)",
                        "tag": "RIBF",
                        "schemaOrgTag": null,
                        "total": 5.377976918698905,
                        "hasRDI": true,
                        "daily": 413.6905322076081,
                        "unit": "mg"
                    },
                    {
                        "label": "Niacin (B3)",
                        "tag": "NIA",
                        "schemaOrgTag": null,
                        "total": 39.13951151048009,
                        "hasRDI": true,
                        "daily": 244.62194694050058,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin B6",
                        "tag": "VITB6A",
                        "schemaOrgTag": null,
                        "total": 2.733492711245013,
                        "hasRDI": true,
                        "daily": 210.26867009577026,
                        "unit": "mg"
                    },
                    {
                        "label": "Folate equivalent (total)",
                        "tag": "FOLDFE",
                        "schemaOrgTag": null,
                        "total": 1451.9230413543498,
                        "hasRDI": true,
                        "daily": 362.9807603385874,
                        "unit": "µg"
                    },
                    {
                        "label": "Folate (food)",
                        "tag": "FOLFD",
                        "schemaOrgTag": null,
                        "total": 1443.5230413543497,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Folic acid",
                        "tag": "FOLAC",
                        "schemaOrgTag": null,
                        "total": 4.8,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin B12",
                        "tag": "VITB12",
                        "schemaOrgTag": null,
                        "total": 38.51623247299957,
                        "hasRDI": true,
                        "daily": 1604.8430197083153,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin D",
                        "tag": "VITD",
                        "schemaOrgTag": null,
                        "total": 1.7600000000000002,
                        "hasRDI": true,
                        "daily": 11.733333333333336,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin E",
                        "tag": "TOCPHA",
                        "schemaOrgTag": null,
                        "total": 2.8116987359719703,
                        "hasRDI": true,
                        "daily": 18.744658239813134,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin K",
                        "tag": "VITK1",
                        "schemaOrgTag": null,
                        "total": 10.599071814530328,
                        "hasRDI": true,
                        "daily": 8.83255984544194,
                        "unit": "µg"
                    },
                    {
                        "label": "Sugar alcohols",
                        "tag": "Sugar.alcohol",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    },
                    {
                        "label": "Water",
                        "tag": "WATER",
                        "schemaOrgTag": null,
                        "total": 1187.1557198867463,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    }
                ]
            },
            "_links": {
                "self": {
                    "href": "https://api.edamam.com/api/recipes/v2/9ca0499f2ac7f1e4cae63bdf4671c1b3?type=public&app_id=ea1d37d5&app_key=fd382a172ba8d6668c0430dc9c14a181",
                    "title": "Self"
                }
            }
        },
        {
            "recipe": {
                "uri": "http://www.edamam.com/ontologies/edamam.owl#recipe_1817e7fccea9ae39d09c0e2c7fb86cb2",
                "label": "Kreplach (Chicken Dumplings)",
                "image": "https://www.edamam.com/web-img/4dd/4dd1c7a0d8b00e8929bd6babf0968ba2.jpg",
                "source": "Tasting Table",
                "url": "https://www.tastingtable.com/entry_detail/chefs_recipes/10154/Matzo_balls_watch_your_back.htm",
                "shareAs": "http://www.edamam.com/recipe/kreplach-chicken-dumplings-1817e7fccea9ae39d09c0e2c7fb86cb2/chicken",
                "yield": 8,
                "dietLabels": [],
                "healthLabels": [
                    "Mediterranean",
                    "Dairy-Free",
                    "Peanut-Free",
                    "Tree-Nut-Free",
                    "Soy-Free",
                    "Fish-Free",
                    "Shellfish-Free",
                    "Pork-Free",
                    "Red-Meat-Free",
                    "Crustacean-Free",
                    "Celery-Free",
                    "Mustard-Free",
                    "Sesame-Free",
                    "Lupine-Free",
                    "Mollusk-Free",
                    "Alcohol-Free",
                    "Sulfite-Free",
                    "Kosher"
                ],
                "cautions": [
                    "Sulfites"
                ],
                "ingredientLines": [
                    "1½ teaspoons canola oil",
                    "½ small shallot, finely chopped",
                    "1 cup (about ½ pound) raw, boneless chicken meat (preferably from 3 boneless chicken thighs), roughly chopped",
                    "⅔ cup (about ¼ pound) chicken skin and fat (reserved from the 3 chicken thighs)",
                    "2 chicken livers (optional)",
                    "2 garlic cloves, finely chopped",
                    "¼ cup finely chopped chives, plus extra for serving",
                    "1¼ teaspoons kosher salt",
                    "¾ teaspoon freshly ground black pepper",
                    "30 to 34 square wonton wrappers",
                    "8 cups store-bought or homemade chicken broth"
                ],
                "ingredients": [
                    {
                        "text": "1½ teaspoons canola oil",
                        "weight": 6.75,
                        "foodCategory": "Oils",
                        "foodId": "food_bk9p9aaavhvoq4bqsnprobpsiuxs",
                        "image": "https://www.edamam.com/food-img/07e/07e106ab3536d57428e5c46d009038f8.jpg"
                    },
                    {
                        "text": "½ small shallot, finely chopped",
                        "weight": 20,
                        "foodCategory": "vegetables",
                        "foodId": "food_bu2ver7a5f52dfap8q9f0bn085qb",
                        "image": "https://www.edamam.com/food-img/d23/d23e3be21df05e9e16c05eadb12341e7.jpeg"
                    },
                    {
                        "text": "1 cup (about ½ pound) raw, boneless chicken meat (preferably from 3 boneless chicken thighs), roughly chopped",
                        "weight": 226.796185,
                        "foodCategory": "Poultry",
                        "foodId": "food_bm8j53kbu73enhamxkr92a7x5nq6",
                        "image": "https://www.edamam.com/food-img/e54/e546d27ffc3d338f99031ce1423cd331.jpg"
                    },
                    {
                        "text": "⅔ cup (about ¼ pound) chicken skin and fat (reserved from the 3 chicken thighs)",
                        "weight": 113.3980925,
                        "foodCategory": "Poultry",
                        "foodId": "food_bsarl08be0gwarb34bpviafna9d4",
                        "image": "https://www.edamam.com/food-img/007/00792642367e1f55de680762f85cfb3b.jpg"
                    },
                    {
                        "text": "2 chicken livers (optional)",
                        "weight": 88,
                        "foodCategory": "Poultry",
                        "foodId": "food_a9xs7abb632dn3aozv3w4a9351fh",
                        "image": "https://www.edamam.com/food-img/9aa/9aa4760ac12b682555a37a1cdc91150b.jpg"
                    },
                    {
                        "text": "2 garlic cloves, finely chopped",
                        "weight": 6,
                        "foodCategory": "vegetables",
                        "foodId": "food_avtcmx6bgjv1jvay6s6stan8dnyp",
                        "image": "https://www.edamam.com/food-img/6ee/6ee142951f48aaf94f4312409f8d133d.jpg"
                    },
                    {
                        "text": "¼ cup finely chopped chives, plus extra for serving",
                        "weight": 12.000000000202874,
                        "foodCategory": "vegetables",
                        "foodId": "food_btg1uzjak79lawbirsitkaeai60l",
                        "image": "https://www.edamam.com/food-img/f3f/f3f48643a924ba174b894e979cb48620.jpg"
                    },
                    {
                        "text": "1¼ teaspoons kosher salt",
                        "weight": 6.067708333641094,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_a1vgrj1bs8rd1majvmd9ubz8ttkg",
                        "image": "https://www.edamam.com/food-img/694/6943ea510918c6025795e8dc6e6eaaeb.jpg"
                    },
                    {
                        "text": "¾ teaspoon freshly ground black pepper",
                        "weight": 1.7249999999999999,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_b6ywzluaaxv02wad7s1r9ag4py89",
                        "image": "https://www.edamam.com/food-img/c6e/c6e5c3bd8d3bc15175d9766971a4d1b2.jpg"
                    },
                    {
                        "text": "30 to 34 square wonton wrappers",
                        "weight": 1024,
                        "foodCategory": "quick breads and pastries",
                        "foodId": "food_aciwn4ebx5qeeobklsjebb6s408x",
                        "image": "https://www.edamam.com/food-img/64e/64e52edbb86d08069012c6a331738ace.jpg"
                    },
                    {
                        "text": "8 cups store-bought or homemade chicken broth",
                        "weight": 1920,
                        "foodCategory": "canned soup",
                        "foodId": "food_bptblvzambd16nbhewqmhaw1rnh5",
                        "image": "https://www.edamam.com/food-img/26a/26a10c4cb4e07bab54d8a687ef5ac7d8.jpg"
                    }
                ],
                "calories": 4387.196994575062,
                "totalWeight": 3418.669277500203,
                "totalTime": 10,
                "cuisineType": [
                    "italian"
                ],
                "mealType": [
                    "lunch/dinner"
                ],
                "dishType": [
                    "main course"
                ],
                "totalNutrients": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 4387.196994575062,
                        "unit": "kcal"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 75.41498066225148,
                        "unit": "g"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 17.7009890662003,
                        "unit": "g"
                    },
                    "FATRN": {
                        "label": "Trans",
                        "quantity": 0.18025087862500003,
                        "unit": "g"
                    },
                    "FAMS": {
                        "label": "Monounsaturated",
                        "quantity": 28.480051034500192,
                        "unit": "g"
                    },
                    "FAPU": {
                        "label": "Polyunsaturated",
                        "quantity": 19.089343754475543,
                        "unit": "g"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 668.5666327312588,
                        "unit": "g"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 19.934425000005074,
                        "unit": "g"
                    },
                    "SUGAR": {
                        "label": "Sugars",
                        "quantity": 32.20304000000375,
                        "unit": "g"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 232.32389635250667,
                        "unit": "g"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 723.24746015,
                        "unit": "mg"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 8935.970517375006,
                        "unit": "mg"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 618.0151586751867,
                        "unit": "mg"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 389.12045290008524,
                        "unit": "mg"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 3958.0806223506006,
                        "unit": "mg"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 49.840690575503245,
                        "unit": "mg"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 17.500824142251137,
                        "unit": "mg"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 2210.457905275118,
                        "unit": "mg"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 3049.634700875442,
                        "unit": "µg"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 35.25231225511787,
                        "unit": "mg"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 6.538524822575158,
                        "unit": "mg"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 7.581342816825234,
                        "unit": "mg"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 118.62495621027632,
                        "unit": "mg"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 3.7624347264752798,
                        "unit": "mg"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 2024.7509257252132,
                        "unit": "µg"
                    },
                    "FOLFD": {
                        "label": "Folate (food)",
                        "quantity": 826.6709257252131,
                        "unit": "µg"
                    },
                    "FOLAC": {
                        "label": "Folic acid",
                        "quantity": 706.5600000000001,
                        "unit": "µg"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 16.337414057999997,
                        "unit": "µg"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 0.3401942775000001,
                        "unit": "µg"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 3.140897982750426,
                        "unit": "mg"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 43.72626627293151,
                        "unit": "µg"
                    },
                    "WATER": {
                        "label": "Water",
                        "quantity": 2408.560648285934,
                        "unit": "g"
                    }
                },
                "totalDaily": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 219.3598497287531,
                        "unit": "%"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 116.02304717269459,
                        "unit": "%"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 88.5049453310015,
                        "unit": "%"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 222.85554424375292,
                        "unit": "%"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 79.7377000000203,
                        "unit": "%"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 464.64779270501333,
                        "unit": "%"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 241.0824867166667,
                        "unit": "%"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 372.33210489062526,
                        "unit": "%"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 61.801515867518674,
                        "unit": "%"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 92.64772688097267,
                        "unit": "%"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 84.21448132660852,
                        "unit": "%"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 276.8927254194625,
                        "unit": "%"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 159.09840129319215,
                        "unit": "%"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 315.77970075358826,
                        "unit": "%"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 338.8483000972713,
                        "unit": "%"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 39.169235839019855,
                        "unit": "%"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 544.8770685479299,
                        "unit": "%"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 583.1802166788642,
                        "unit": "%"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 741.405976314227,
                        "unit": "%"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 289.4180558827138,
                        "unit": "%"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 506.18773143130323,
                        "unit": "%"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 680.7255857499999,
                        "unit": "%"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 2.2679618500000003,
                        "unit": "%"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 20.93931988500284,
                        "unit": "%"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 36.438555227442926,
                        "unit": "%"
                    }
                },
                "digest": [
                    {
                        "label": "Fat",
                        "tag": "FAT",
                        "schemaOrgTag": "fatContent",
                        "total": 75.41498066225148,
                        "hasRDI": true,
                        "daily": 116.02304717269459,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Saturated",
                                "tag": "FASAT",
                                "schemaOrgTag": "saturatedFatContent",
                                "total": 17.7009890662003,
                                "hasRDI": true,
                                "daily": 88.5049453310015,
                                "unit": "g"
                            },
                            {
                                "label": "Trans",
                                "tag": "FATRN",
                                "schemaOrgTag": "transFatContent",
                                "total": 0.18025087862500003,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Monounsaturated",
                                "tag": "FAMS",
                                "schemaOrgTag": null,
                                "total": 28.480051034500192,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Polyunsaturated",
                                "tag": "FAPU",
                                "schemaOrgTag": null,
                                "total": 19.089343754475543,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Carbs",
                        "tag": "CHOCDF",
                        "schemaOrgTag": "carbohydrateContent",
                        "total": 668.5666327312588,
                        "hasRDI": true,
                        "daily": 222.85554424375292,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Carbs (net)",
                                "tag": "CHOCDF.net",
                                "schemaOrgTag": null,
                                "total": 648.6322077312537,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Fiber",
                                "tag": "FIBTG",
                                "schemaOrgTag": "fiberContent",
                                "total": 19.934425000005074,
                                "hasRDI": true,
                                "daily": 79.7377000000203,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars",
                                "tag": "SUGAR",
                                "schemaOrgTag": "sugarContent",
                                "total": 32.20304000000375,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars, added",
                                "tag": "SUGAR.added",
                                "schemaOrgTag": null,
                                "total": 0,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Protein",
                        "tag": "PROCNT",
                        "schemaOrgTag": "proteinContent",
                        "total": 232.32389635250667,
                        "hasRDI": true,
                        "daily": 464.64779270501333,
                        "unit": "g"
                    },
                    {
                        "label": "Cholesterol",
                        "tag": "CHOLE",
                        "schemaOrgTag": "cholesterolContent",
                        "total": 723.24746015,
                        "hasRDI": true,
                        "daily": 241.0824867166667,
                        "unit": "mg"
                    },
                    {
                        "label": "Sodium",
                        "tag": "NA",
                        "schemaOrgTag": "sodiumContent",
                        "total": 8935.970517375006,
                        "hasRDI": true,
                        "daily": 372.33210489062526,
                        "unit": "mg"
                    },
                    {
                        "label": "Calcium",
                        "tag": "CA",
                        "schemaOrgTag": null,
                        "total": 618.0151586751867,
                        "hasRDI": true,
                        "daily": 61.801515867518674,
                        "unit": "mg"
                    },
                    {
                        "label": "Magnesium",
                        "tag": "MG",
                        "schemaOrgTag": null,
                        "total": 389.12045290008524,
                        "hasRDI": true,
                        "daily": 92.64772688097267,
                        "unit": "mg"
                    },
                    {
                        "label": "Potassium",
                        "tag": "K",
                        "schemaOrgTag": null,
                        "total": 3958.0806223506006,
                        "hasRDI": true,
                        "daily": 84.21448132660852,
                        "unit": "mg"
                    },
                    {
                        "label": "Iron",
                        "tag": "FE",
                        "schemaOrgTag": null,
                        "total": 49.840690575503245,
                        "hasRDI": true,
                        "daily": 276.8927254194625,
                        "unit": "mg"
                    },
                    {
                        "label": "Zinc",
                        "tag": "ZN",
                        "schemaOrgTag": null,
                        "total": 17.500824142251137,
                        "hasRDI": true,
                        "daily": 159.09840129319215,
                        "unit": "mg"
                    },
                    {
                        "label": "Phosphorus",
                        "tag": "P",
                        "schemaOrgTag": null,
                        "total": 2210.457905275118,
                        "hasRDI": true,
                        "daily": 315.77970075358826,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin A",
                        "tag": "VITA_RAE",
                        "schemaOrgTag": null,
                        "total": 3049.634700875442,
                        "hasRDI": true,
                        "daily": 338.8483000972713,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin C",
                        "tag": "VITC",
                        "schemaOrgTag": null,
                        "total": 35.25231225511787,
                        "hasRDI": true,
                        "daily": 39.169235839019855,
                        "unit": "mg"
                    },
                    {
                        "label": "Thiamin (B1)",
                        "tag": "THIA",
                        "schemaOrgTag": null,
                        "total": 6.538524822575158,
                        "hasRDI": true,
                        "daily": 544.8770685479299,
                        "unit": "mg"
                    },
                    {
                        "label": "Riboflavin (B2)",
                        "tag": "RIBF",
                        "schemaOrgTag": null,
                        "total": 7.581342816825234,
                        "hasRDI": true,
                        "daily": 583.1802166788642,
                        "unit": "mg"
                    },
                    {
                        "label": "Niacin (B3)",
                        "tag": "NIA",
                        "schemaOrgTag": null,
                        "total": 118.62495621027632,
                        "hasRDI": true,
                        "daily": 741.405976314227,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin B6",
                        "tag": "VITB6A",
                        "schemaOrgTag": null,
                        "total": 3.7624347264752798,
                        "hasRDI": true,
                        "daily": 289.4180558827138,
                        "unit": "mg"
                    },
                    {
                        "label": "Folate equivalent (total)",
                        "tag": "FOLDFE",
                        "schemaOrgTag": null,
                        "total": 2024.7509257252132,
                        "hasRDI": true,
                        "daily": 506.18773143130323,
                        "unit": "µg"
                    },
                    {
                        "label": "Folate (food)",
                        "tag": "FOLFD",
                        "schemaOrgTag": null,
                        "total": 826.6709257252131,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Folic acid",
                        "tag": "FOLAC",
                        "schemaOrgTag": null,
                        "total": 706.5600000000001,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin B12",
                        "tag": "VITB12",
                        "schemaOrgTag": null,
                        "total": 16.337414057999997,
                        "hasRDI": true,
                        "daily": 680.7255857499999,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin D",
                        "tag": "VITD",
                        "schemaOrgTag": null,
                        "total": 0.3401942775000001,
                        "hasRDI": true,
                        "daily": 2.2679618500000003,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin E",
                        "tag": "TOCPHA",
                        "schemaOrgTag": null,
                        "total": 3.140897982750426,
                        "hasRDI": true,
                        "daily": 20.93931988500284,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin K",
                        "tag": "VITK1",
                        "schemaOrgTag": null,
                        "total": 43.72626627293151,
                        "hasRDI": true,
                        "daily": 36.438555227442926,
                        "unit": "µg"
                    },
                    {
                        "label": "Sugar alcohols",
                        "tag": "Sugar.alcohol",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    },
                    {
                        "label": "Water",
                        "tag": "WATER",
                        "schemaOrgTag": null,
                        "total": 2408.560648285934,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    }
                ]
            },
            "_links": {
                "self": {
                    "href": "https://api.edamam.com/api/recipes/v2/1817e7fccea9ae39d09c0e2c7fb86cb2?type=public&app_id=ea1d37d5&app_key=fd382a172ba8d6668c0430dc9c14a181",
                    "title": "Self"
                }
            }
        },
        {
            "recipe": {
                "uri": "http://www.edamam.com/ontologies/edamam.owl#recipe_a6ee2e431ba83557209f48e1cf194f2f",
                "label": "Chicken cacciatore",
                "image": "https://www.edamam.com/web-img/2ca/2ca946a40338e9b93c1d14dec518e1b8.jpg",
                "source": "BBC",
                "url": "http://www.bbc.co.uk/food/recipes/chickenalocacciatore_70349",
                "shareAs": "http://www.edamam.com/recipe/chicken-cacciatore-a6ee2e431ba83557209f48e1cf194f2f/chicken",
                "yield": 6,
                "dietLabels": [],
                "healthLabels": [
                    "Gluten-Free",
                    "Wheat-Free",
                    "Egg-Free",
                    "Peanut-Free",
                    "Tree-Nut-Free",
                    "Soy-Free",
                    "Fish-Free",
                    "Shellfish-Free",
                    "Pork-Free",
                    "Red-Meat-Free",
                    "Crustacean-Free",
                    "Mustard-Free",
                    "Sesame-Free",
                    "Lupine-Free",
                    "Mollusk-Free"
                ],
                "cautions": [
                    "Sulfites",
                    "FODMAP"
                ],
                "ingredientLines": [
                    "8 tbsp olive oil",
                    "1 onion, sliced",
                    "2 celery stalks, roughly chopped",
                    "2 medium carrots, roughly chopped",
                    "6 chicken breasts, or chicken thighs, bones removed",
                    "175ml/6fl oz white wine",
                    "3 tbsp tomato purée",
                    "500ml/17 fl oz chicken stock",
                    "2 bay leaves",
                    "2-3 sage leaves",
                    "1 rosemary sprig",
                    "250g/9oz easy-cook polenta",
                    "Knob of butter",
                    "25g/1oz parmesan"
                ],
                "ingredients": [
                    {
                        "text": "8 tbsp olive oil",
                        "weight": 108,
                        "foodCategory": "Oils",
                        "foodId": "food_b1d1icuad3iktrbqby0hiagafaz7",
                        "image": "https://www.edamam.com/food-img/4d6/4d651eaa8a353647746290c7a9b29d84.jpg"
                    },
                    {
                        "text": "1 onion, sliced",
                        "weight": 125,
                        "foodCategory": "vegetables",
                        "foodId": "food_bmrvi4ob4binw9a5m7l07amlfcoy",
                        "image": "https://www.edamam.com/food-img/205/205e6bf2399b85d34741892ef91cc603.jpg"
                    },
                    {
                        "text": "2 celery stalks, roughly chopped",
                        "weight": 80,
                        "foodCategory": "vegetables",
                        "foodId": "food_bffeoksbyyur8ja4da73ub2xs57g",
                        "image": "https://www.edamam.com/food-img/d91/d91d2aed1c36d8fad54c4d7dc58f5a18.jpg"
                    },
                    {
                        "text": "2 medium carrots, roughly chopped",
                        "weight": 122,
                        "foodCategory": "vegetables",
                        "foodId": "food_ai215e5b85pdh5ajd4aafa3w2zm8",
                        "image": "https://www.edamam.com/food-img/121/121e33fce0bb9546ed7d060b6c114e29.jpg"
                    },
                    {
                        "text": "6 chicken breasts, or chicken thighs, bones removed",
                        "weight": 1044,
                        "foodCategory": "Poultry",
                        "foodId": "food_a9hdg97b1sqqs5aj1al75bbo5iyt",
                        "image": "https://www.edamam.com/food-img/093/093749f4c93e448119fc81976d2c3067.jpg"
                    },
                    {
                        "text": "175ml/6fl oz white wine",
                        "weight": 173.97314680098222,
                        "foodCategory": "wines",
                        "foodId": "food_bn44h7baron9ufaoxinmya8l0yye",
                        "image": "https://www.edamam.com/food-img/a71/a718cf3c52add522128929f1f324d2ab.jpg"
                    },
                    {
                        "text": "3 tbsp tomato purée",
                        "weight": 45.3749999992329,
                        "foodCategory": "canned vegetables",
                        "foodId": "food_aqqtb83adjyq8ybf51yo8bsjetdh",
                        "image": null
                    },
                    {
                        "text": "500ml/17 fl oz chicken stock",
                        "weight": 507.21034052764503,
                        "foodCategory": "canned soup",
                        "foodId": "food_bptblvzambd16nbhewqmhaw1rnh5",
                        "image": "https://www.edamam.com/food-img/26a/26a10c4cb4e07bab54d8a687ef5ac7d8.jpg"
                    },
                    {
                        "text": "2 bay leaves",
                        "weight": 1.2,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_asx39x4ayja4jab6ivj6zayvkblo",
                        "image": "https://www.edamam.com/food-img/0f9/0f9f5f95df173e9ffaaff2977bef88f3.jpg"
                    },
                    {
                        "text": "2-3 sage leaves",
                        "weight": 2.5,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_b00mwy0bne9gs4au15ja8ab10h0e",
                        "image": "https://www.edamam.com/food-img/509/50984580e9aad4b4ddd5b7ed45a64bf4.jpg"
                    },
                    {
                        "text": "1 rosemary sprig",
                        "weight": 5,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_b6tm2t2blxi7okaeiv91wb8bmygq",
                        "image": "https://www.edamam.com/food-img/0ac/0ac8f7cf6f2d0ad7b1a2f9900fae44f3.jpg"
                    },
                    {
                        "text": "250g/9oz easy-cook polenta",
                        "weight": 250,
                        "foodCategory": "grains",
                        "foodId": "food_b05sp8gagykqhgb4uo2jhbsbfftc",
                        "image": null
                    },
                    {
                        "text": "Knob of butter",
                        "weight": 28.4,
                        "foodCategory": "Dairy",
                        "foodId": "food_awz3iefajbk1fwahq9logahmgltj",
                        "image": "https://www.edamam.com/food-img/713/71397239b670d88c04faa8d05035cab4.jpg"
                    },
                    {
                        "text": "25g/1oz parmesan",
                        "weight": 25,
                        "foodCategory": "Cheese",
                        "foodId": "food_a104ppxa06d3emb272fkcab3cugd",
                        "image": "https://www.edamam.com/food-img/f58/f588658627c59d5041e4664119829aa9.jpg"
                    }
                ],
                "calories": 4447.802702966512,
                "totalWeight": 2517.6584873278603,
                "totalTime": 60,
                "cuisineType": [
                    "italian"
                ],
                "mealType": [
                    "lunch/dinner"
                ],
                "dishType": [
                    "main course",
                    "starter"
                ],
                "totalNutrients": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 4447.802702966512,
                        "unit": "kcal"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 245.9171840863296,
                        "unit": "g"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 64.04659719309343,
                        "unit": "g"
                    },
                    "FATRN": {
                        "label": "Trans",
                        "quantity": 2.0271519999999996,
                        "unit": "g"
                    },
                    "FAMS": {
                        "label": "Monounsaturated",
                        "quantity": 130.65722943187055,
                        "unit": "g"
                    },
                    "FAPU": {
                        "label": "Polyunsaturated",
                        "quantity": 36.37905377532301,
                        "unit": "g"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 254.3741943373955,
                        "unit": "g"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 19.461224999985426,
                        "unit": "g"
                    },
                    "SUGAR": {
                        "label": "Sugars",
                        "quantity": 28.120155589592475,
                        "unit": "g"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 261.8597017840448,
                        "unit": "g"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 761.4363102158293,
                        "unit": "mg"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 1997.9419442931546,
                        "unit": "mg"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 640.7053934276569,
                        "unit": "mg"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 451.9587283010506,
                        "unit": "mg"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 4319.134541780476,
                        "unit": "mg"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 15.755824211460732,
                        "unit": "mg"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 12.57413475289781,
                        "unit": "mg"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 2532.2389583663958,
                        "unit": "mg"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 1588.812353405192,
                        "unit": "µg"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 26.574920680984718,
                        "unit": "mg"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 1.4147215265241497,
                        "unit": "mg"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 1.7570377614682466,
                        "unit": "mg"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 116.60870329249357,
                        "unit": "mg"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 6.958739381121204,
                        "unit": "mg"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 242.55099849429232,
                        "unit": "µg"
                    },
                    "FOLFD": {
                        "label": "Folate (food)",
                        "quantity": 242.55099849429232,
                        "unit": "µg"
                    },
                    "FOLAC": {
                        "label": "Folic acid",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 3.89788,
                        "unit": "µg"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 4.727,
                        "unit": "µg"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 21.283230602148706,
                        "unit": "mg"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 154.45068826821858,
                        "unit": "µg"
                    },
                    "WATER": {
                        "label": "Water",
                        "quantity": 1723.6862441068722,
                        "unit": "g"
                    }
                },
                "totalDaily": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 222.39013514832558,
                        "unit": "%"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 378.334129363584,
                        "unit": "%"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 320.23298596546715,
                        "unit": "%"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 84.79139811246516,
                        "unit": "%"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 77.8448999999417,
                        "unit": "%"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 523.7194035680895,
                        "unit": "%"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 253.81210340527642,
                        "unit": "%"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 83.24758101221477,
                        "unit": "%"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 64.07053934276568,
                        "unit": "%"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 107.60922102405966,
                        "unit": "%"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 91.89647961235055,
                        "unit": "%"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 87.5323567303374,
                        "unit": "%"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 114.31031593543463,
                        "unit": "%"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 361.7484226237708,
                        "unit": "%"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 176.53470593391023,
                        "unit": "%"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 29.527689645538576,
                        "unit": "%"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 117.89346054367914,
                        "unit": "%"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 135.15675088217282,
                        "unit": "%"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 728.8043955780848,
                        "unit": "%"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 535.287644701631,
                        "unit": "%"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 60.63774962357308,
                        "unit": "%"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 162.41166666666666,
                        "unit": "%"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 31.513333333333335,
                        "unit": "%"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 141.8882040143247,
                        "unit": "%"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 128.70890689018216,
                        "unit": "%"
                    }
                },
                "digest": [
                    {
                        "label": "Fat",
                        "tag": "FAT",
                        "schemaOrgTag": "fatContent",
                        "total": 245.9171840863296,
                        "hasRDI": true,
                        "daily": 378.334129363584,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Saturated",
                                "tag": "FASAT",
                                "schemaOrgTag": "saturatedFatContent",
                                "total": 64.04659719309343,
                                "hasRDI": true,
                                "daily": 320.23298596546715,
                                "unit": "g"
                            },
                            {
                                "label": "Trans",
                                "tag": "FATRN",
                                "schemaOrgTag": "transFatContent",
                                "total": 2.0271519999999996,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Monounsaturated",
                                "tag": "FAMS",
                                "schemaOrgTag": null,
                                "total": 130.65722943187055,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Polyunsaturated",
                                "tag": "FAPU",
                                "schemaOrgTag": null,
                                "total": 36.37905377532301,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Carbs",
                        "tag": "CHOCDF",
                        "schemaOrgTag": "carbohydrateContent",
                        "total": 254.3741943373955,
                        "hasRDI": true,
                        "daily": 84.79139811246516,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Carbs (net)",
                                "tag": "CHOCDF.net",
                                "schemaOrgTag": null,
                                "total": 234.91296933741006,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Fiber",
                                "tag": "FIBTG",
                                "schemaOrgTag": "fiberContent",
                                "total": 19.461224999985426,
                                "hasRDI": true,
                                "daily": 77.8448999999417,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars",
                                "tag": "SUGAR",
                                "schemaOrgTag": "sugarContent",
                                "total": 28.120155589592475,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars, added",
                                "tag": "SUGAR.added",
                                "schemaOrgTag": null,
                                "total": 0,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Protein",
                        "tag": "PROCNT",
                        "schemaOrgTag": "proteinContent",
                        "total": 261.8597017840448,
                        "hasRDI": true,
                        "daily": 523.7194035680895,
                        "unit": "g"
                    },
                    {
                        "label": "Cholesterol",
                        "tag": "CHOLE",
                        "schemaOrgTag": "cholesterolContent",
                        "total": 761.4363102158293,
                        "hasRDI": true,
                        "daily": 253.81210340527642,
                        "unit": "mg"
                    },
                    {
                        "label": "Sodium",
                        "tag": "NA",
                        "schemaOrgTag": "sodiumContent",
                        "total": 1997.9419442931546,
                        "hasRDI": true,
                        "daily": 83.24758101221477,
                        "unit": "mg"
                    },
                    {
                        "label": "Calcium",
                        "tag": "CA",
                        "schemaOrgTag": null,
                        "total": 640.7053934276569,
                        "hasRDI": true,
                        "daily": 64.07053934276568,
                        "unit": "mg"
                    },
                    {
                        "label": "Magnesium",
                        "tag": "MG",
                        "schemaOrgTag": null,
                        "total": 451.9587283010506,
                        "hasRDI": true,
                        "daily": 107.60922102405966,
                        "unit": "mg"
                    },
                    {
                        "label": "Potassium",
                        "tag": "K",
                        "schemaOrgTag": null,
                        "total": 4319.134541780476,
                        "hasRDI": true,
                        "daily": 91.89647961235055,
                        "unit": "mg"
                    },
                    {
                        "label": "Iron",
                        "tag": "FE",
                        "schemaOrgTag": null,
                        "total": 15.755824211460732,
                        "hasRDI": true,
                        "daily": 87.5323567303374,
                        "unit": "mg"
                    },
                    {
                        "label": "Zinc",
                        "tag": "ZN",
                        "schemaOrgTag": null,
                        "total": 12.57413475289781,
                        "hasRDI": true,
                        "daily": 114.31031593543463,
                        "unit": "mg"
                    },
                    {
                        "label": "Phosphorus",
                        "tag": "P",
                        "schemaOrgTag": null,
                        "total": 2532.2389583663958,
                        "hasRDI": true,
                        "daily": 361.7484226237708,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin A",
                        "tag": "VITA_RAE",
                        "schemaOrgTag": null,
                        "total": 1588.812353405192,
                        "hasRDI": true,
                        "daily": 176.53470593391023,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin C",
                        "tag": "VITC",
                        "schemaOrgTag": null,
                        "total": 26.574920680984718,
                        "hasRDI": true,
                        "daily": 29.527689645538576,
                        "unit": "mg"
                    },
                    {
                        "label": "Thiamin (B1)",
                        "tag": "THIA",
                        "schemaOrgTag": null,
                        "total": 1.4147215265241497,
                        "hasRDI": true,
                        "daily": 117.89346054367914,
                        "unit": "mg"
                    },
                    {
                        "label": "Riboflavin (B2)",
                        "tag": "RIBF",
                        "schemaOrgTag": null,
                        "total": 1.7570377614682466,
                        "hasRDI": true,
                        "daily": 135.15675088217282,
                        "unit": "mg"
                    },
                    {
                        "label": "Niacin (B3)",
                        "tag": "NIA",
                        "schemaOrgTag": null,
                        "total": 116.60870329249357,
                        "hasRDI": true,
                        "daily": 728.8043955780848,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin B6",
                        "tag": "VITB6A",
                        "schemaOrgTag": null,
                        "total": 6.958739381121204,
                        "hasRDI": true,
                        "daily": 535.287644701631,
                        "unit": "mg"
                    },
                    {
                        "label": "Folate equivalent (total)",
                        "tag": "FOLDFE",
                        "schemaOrgTag": null,
                        "total": 242.55099849429232,
                        "hasRDI": true,
                        "daily": 60.63774962357308,
                        "unit": "µg"
                    },
                    {
                        "label": "Folate (food)",
                        "tag": "FOLFD",
                        "schemaOrgTag": null,
                        "total": 242.55099849429232,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Folic acid",
                        "tag": "FOLAC",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin B12",
                        "tag": "VITB12",
                        "schemaOrgTag": null,
                        "total": 3.89788,
                        "hasRDI": true,
                        "daily": 162.41166666666666,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin D",
                        "tag": "VITD",
                        "schemaOrgTag": null,
                        "total": 4.727,
                        "hasRDI": true,
                        "daily": 31.513333333333335,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin E",
                        "tag": "TOCPHA",
                        "schemaOrgTag": null,
                        "total": 21.283230602148706,
                        "hasRDI": true,
                        "daily": 141.8882040143247,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin K",
                        "tag": "VITK1",
                        "schemaOrgTag": null,
                        "total": 154.45068826821858,
                        "hasRDI": true,
                        "daily": 128.70890689018216,
                        "unit": "µg"
                    },
                    {
                        "label": "Sugar alcohols",
                        "tag": "Sugar.alcohol",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    },
                    {
                        "label": "Water",
                        "tag": "WATER",
                        "schemaOrgTag": null,
                        "total": 1723.6862441068722,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    }
                ]
            },
            "_links": {
                "self": {
                    "href": "https://api.edamam.com/api/recipes/v2/a6ee2e431ba83557209f48e1cf194f2f?type=public&app_id=ea1d37d5&app_key=fd382a172ba8d6668c0430dc9c14a181",
                    "title": "Self"
                }
            }
        },
        {
            "recipe": {
                "uri": "http://www.edamam.com/ontologies/edamam.owl#recipe_1da54064d59fe6e63b11823593ae6dc2",
                "label": "Chicken Soup",
                "image": "https://www.edamam.com/web-img/e20/e20d522d53088284fc5a31f365cbdebd.jpg",
                "source": "Cookstr",
                "url": "http://www.cookstr.com/recipes/chicken-soup-3-sharon-lebewohl",
                "shareAs": "http://www.edamam.com/recipe/chicken-soup-1da54064d59fe6e63b11823593ae6dc2/chicken",
                "yield": 8,
                "dietLabels": [
                    "Low-Carb"
                ],
                "healthLabels": [
                    "Sugar-Conscious",
                    "Keto-Friendly",
                    "Mediterranean",
                    "Dairy-Free",
                    "Gluten-Free",
                    "Wheat-Free",
                    "Egg-Free",
                    "Peanut-Free",
                    "Tree-Nut-Free",
                    "Soy-Free",
                    "Fish-Free",
                    "Shellfish-Free",
                    "Pork-Free",
                    "Red-Meat-Free",
                    "Crustacean-Free",
                    "Mustard-Free",
                    "Sesame-Free",
                    "Lupine-Free",
                    "Mollusk-Free",
                    "Alcohol-Free",
                    "No oil added",
                    "Sulfite-Free",
                    "Kosher"
                ],
                "cautions": [
                    "FODMAP"
                ],
                "ingredientLines": [
                    "1 pound chicken parts",
                    "2 stalks celery, including leafy tops, cut into 3-inch pieces",
                    "1 whole chicken, thoroughly rinsed",
                    "Salt to rub inside the chicken",
                    "1 large whole onion, unpeeled (find one with a firm, golden-brown peel)",
                    "1 large whole carrot, peeled",
                    "1 medium parsnip, peeled",
                    "2 teaspoons salt",
                    "¼ teaspoon pepper",
                    "1 bunch dill, cleaned and tied with a string"
                ],
                "ingredients": [
                    {
                        "text": "1 pound chicken parts",
                        "weight": 453.59237,
                        "foodCategory": "Poultry",
                        "foodId": "food_bsarl08be0gwarb34bpviafna9d4",
                        "image": "https://www.edamam.com/food-img/007/00792642367e1f55de680762f85cfb3b.jpg"
                    },
                    {
                        "text": "2 stalks celery, including leafy tops, cut into 3-inch pieces",
                        "weight": 80,
                        "foodCategory": "vegetables",
                        "foodId": "food_bffeoksbyyur8ja4da73ub2xs57g",
                        "image": "https://www.edamam.com/food-img/d91/d91d2aed1c36d8fad54c4d7dc58f5a18.jpg"
                    },
                    {
                        "text": "1 whole chicken, thoroughly rinsed",
                        "weight": 1200,
                        "foodCategory": "Poultry",
                        "foodId": "food_bmyxrshbfao9s1amjrvhoauob6mo",
                        "image": "https://www.edamam.com/food-img/d33/d338229d774a743f7858f6764e095878.jpg"
                    },
                    {
                        "text": "Salt to rub inside the chicken",
                        "weight": 12.622304220000002,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_btxz81db72hwbra2pncvebzzzum9",
                        "image": "https://www.edamam.com/food-img/694/6943ea510918c6025795e8dc6e6eaaeb.jpg"
                    },
                    {
                        "text": "1 large whole onion, unpeeled (find one with a firm, golden-brown peel)",
                        "weight": 150,
                        "foodCategory": "vegetables",
                        "foodId": "food_bmrvi4ob4binw9a5m7l07amlfcoy",
                        "image": "https://www.edamam.com/food-img/205/205e6bf2399b85d34741892ef91cc603.jpg"
                    },
                    {
                        "text": "1 large whole carrot, peeled",
                        "weight": 72,
                        "foodCategory": "vegetables",
                        "foodId": "food_ai215e5b85pdh5ajd4aafa3w2zm8",
                        "image": "https://www.edamam.com/food-img/121/121e33fce0bb9546ed7d060b6c114e29.jpg"
                    },
                    {
                        "text": "1 medium parsnip, peeled",
                        "weight": 133,
                        "foodCategory": "vegetables",
                        "foodId": "food_admr9qdb3d66y9blt7afaazt0dbq",
                        "image": "https://www.edamam.com/food-img/ec2/ec2f9c27d98c2ca45687f96e3e487868.jpg"
                    },
                    {
                        "text": "2 teaspoons salt",
                        "weight": 12,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_btxz81db72hwbra2pncvebzzzum9",
                        "image": "https://www.edamam.com/food-img/694/6943ea510918c6025795e8dc6e6eaaeb.jpg"
                    },
                    {
                        "text": "¼ teaspoon pepper",
                        "weight": 0.725,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_b6ywzluaaxv02wad7s1r9ag4py89",
                        "image": "https://www.edamam.com/food-img/c6e/c6e5c3bd8d3bc15175d9766971a4d1b2.jpg"
                    },
                    {
                        "text": "1 bunch dill, cleaned and tied with a string",
                        "weight": 2.4,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_avhhd2padkkzx8a9swnmlb1km3qb",
                        "image": "https://www.edamam.com/food-img/874/8740aacb8e1a348cd5eead1f0bb552d4.jpg"
                    }
                ],
                "calories": 3787.3608877000006,
                "totalWeight": 2100.805166299829,
                "totalTime": 120,
                "cuisineType": [
                    "kosher"
                ],
                "mealType": [
                    "lunch/dinner"
                ],
                "dishType": [
                    "soup"
                ],
                "totalNutrients": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 3787.3608877000006,
                        "unit": "kcal"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 256.970007657,
                        "unit": "g"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 72.44179081880002,
                        "unit": "g"
                    },
                    "FATRN": {
                        "label": "Trans",
                        "quantity": 1.5495535145000003,
                        "unit": "g"
                    },
                    "FAMS": {
                        "label": "Monounsaturated",
                        "quantity": 106.588056228,
                        "unit": "g"
                    },
                    "FAPU": {
                        "label": "Polyunsaturated",
                        "quantity": 54.73101296790001,
                        "unit": "g"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 48.976398425,
                        "unit": "g"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 12.596825,
                        "unit": "g"
                    },
                    "SUGAR": {
                        "label": "Sugars",
                        "quantity": 17.233439999999998,
                        "unit": "g"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 302.75942702400005,
                        "unit": "g"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 1344.5205226,
                        "unit": "mg"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 4864.246909587601,
                        "unit": "mg"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 312.2762870119589,
                        "unit": "mg"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 395.30725456299825,
                        "unit": "mg"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 4377.552708503988,
                        "unit": "mg"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 15.618675343789437,
                        "unit": "mg"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 22.927396869299827,
                        "unit": "mg"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 2661.1995208999997,
                        "unit": "mg"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 1224.5859950999998,
                        "unit": "µg"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 61.678,
                        "unit": "mg"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 1.3063174300999998,
                        "unit": "mg"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 2.3004779365,
                        "unit": "mg"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 104.70537386249998,
                        "unit": "mg"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 6.238775273899998,
                        "unit": "mg"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 249.42102110000002,
                        "unit": "µg"
                    },
                    "FOLFD": {
                        "label": "Folate (food)",
                        "quantity": 249.42102110000002,
                        "unit": "µg"
                    },
                    "FOLAC": {
                        "label": "Folic acid",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 6.5322726939999995,
                        "unit": "µg"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 2.8535923700000003,
                        "unit": "µg"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 7.262983977,
                        "unit": "mg"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 92.18126477,
                        "unit": "µg"
                    },
                    "WATER": {
                        "label": "Water",
                        "quantity": 1474.9068589315993,
                        "unit": "g"
                    }
                },
                "totalDaily": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 189.36804438500002,
                        "unit": "%"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 395.3384733184615,
                        "unit": "%"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 362.2089540940001,
                        "unit": "%"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 16.325466141666666,
                        "unit": "%"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 50.3873,
                        "unit": "%"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 605.5188540480001,
                        "unit": "%"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 448.17350753333335,
                        "unit": "%"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 202.67695456615007,
                        "unit": "%"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 31.227628701195894,
                        "unit": "%"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 94.12077489595197,
                        "unit": "%"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 93.13941932987207,
                        "unit": "%"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 86.77041857660798,
                        "unit": "%"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 208.43088062999843,
                        "unit": "%"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 380.1713601285714,
                        "unit": "%"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 136.06511056666665,
                        "unit": "%"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 68.5311111111111,
                        "unit": "%"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 108.85978584166665,
                        "unit": "%"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 176.95984126923076,
                        "unit": "%"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 654.4085866406249,
                        "unit": "%"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 479.90579029999986,
                        "unit": "%"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 62.35525527500001,
                        "unit": "%"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 272.1780289166667,
                        "unit": "%"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 19.023949133333335,
                        "unit": "%"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 48.41989318,
                        "unit": "%"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 76.81772064166667,
                        "unit": "%"
                    }
                },
                "digest": [
                    {
                        "label": "Fat",
                        "tag": "FAT",
                        "schemaOrgTag": "fatContent",
                        "total": 256.970007657,
                        "hasRDI": true,
                        "daily": 395.3384733184615,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Saturated",
                                "tag": "FASAT",
                                "schemaOrgTag": "saturatedFatContent",
                                "total": 72.44179081880002,
                                "hasRDI": true,
                                "daily": 362.2089540940001,
                                "unit": "g"
                            },
                            {
                                "label": "Trans",
                                "tag": "FATRN",
                                "schemaOrgTag": "transFatContent",
                                "total": 1.5495535145000003,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Monounsaturated",
                                "tag": "FAMS",
                                "schemaOrgTag": null,
                                "total": 106.588056228,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Polyunsaturated",
                                "tag": "FAPU",
                                "schemaOrgTag": null,
                                "total": 54.73101296790001,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Carbs",
                        "tag": "CHOCDF",
                        "schemaOrgTag": "carbohydrateContent",
                        "total": 48.976398425,
                        "hasRDI": true,
                        "daily": 16.325466141666666,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Carbs (net)",
                                "tag": "CHOCDF.net",
                                "schemaOrgTag": null,
                                "total": 36.379573425,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Fiber",
                                "tag": "FIBTG",
                                "schemaOrgTag": "fiberContent",
                                "total": 12.596825,
                                "hasRDI": true,
                                "daily": 50.3873,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars",
                                "tag": "SUGAR",
                                "schemaOrgTag": "sugarContent",
                                "total": 17.233439999999998,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars, added",
                                "tag": "SUGAR.added",
                                "schemaOrgTag": null,
                                "total": 0,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Protein",
                        "tag": "PROCNT",
                        "schemaOrgTag": "proteinContent",
                        "total": 302.75942702400005,
                        "hasRDI": true,
                        "daily": 605.5188540480001,
                        "unit": "g"
                    },
                    {
                        "label": "Cholesterol",
                        "tag": "CHOLE",
                        "schemaOrgTag": "cholesterolContent",
                        "total": 1344.5205226,
                        "hasRDI": true,
                        "daily": 448.17350753333335,
                        "unit": "mg"
                    },
                    {
                        "label": "Sodium",
                        "tag": "NA",
                        "schemaOrgTag": "sodiumContent",
                        "total": 4864.246909587601,
                        "hasRDI": true,
                        "daily": 202.67695456615007,
                        "unit": "mg"
                    },
                    {
                        "label": "Calcium",
                        "tag": "CA",
                        "schemaOrgTag": null,
                        "total": 312.2762870119589,
                        "hasRDI": true,
                        "daily": 31.227628701195894,
                        "unit": "mg"
                    },
                    {
                        "label": "Magnesium",
                        "tag": "MG",
                        "schemaOrgTag": null,
                        "total": 395.30725456299825,
                        "hasRDI": true,
                        "daily": 94.12077489595197,
                        "unit": "mg"
                    },
                    {
                        "label": "Potassium",
                        "tag": "K",
                        "schemaOrgTag": null,
                        "total": 4377.552708503988,
                        "hasRDI": true,
                        "daily": 93.13941932987207,
                        "unit": "mg"
                    },
                    {
                        "label": "Iron",
                        "tag": "FE",
                        "schemaOrgTag": null,
                        "total": 15.618675343789437,
                        "hasRDI": true,
                        "daily": 86.77041857660798,
                        "unit": "mg"
                    },
                    {
                        "label": "Zinc",
                        "tag": "ZN",
                        "schemaOrgTag": null,
                        "total": 22.927396869299827,
                        "hasRDI": true,
                        "daily": 208.43088062999843,
                        "unit": "mg"
                    },
                    {
                        "label": "Phosphorus",
                        "tag": "P",
                        "schemaOrgTag": null,
                        "total": 2661.1995208999997,
                        "hasRDI": true,
                        "daily": 380.1713601285714,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin A",
                        "tag": "VITA_RAE",
                        "schemaOrgTag": null,
                        "total": 1224.5859950999998,
                        "hasRDI": true,
                        "daily": 136.06511056666665,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin C",
                        "tag": "VITC",
                        "schemaOrgTag": null,
                        "total": 61.678,
                        "hasRDI": true,
                        "daily": 68.5311111111111,
                        "unit": "mg"
                    },
                    {
                        "label": "Thiamin (B1)",
                        "tag": "THIA",
                        "schemaOrgTag": null,
                        "total": 1.3063174300999998,
                        "hasRDI": true,
                        "daily": 108.85978584166665,
                        "unit": "mg"
                    },
                    {
                        "label": "Riboflavin (B2)",
                        "tag": "RIBF",
                        "schemaOrgTag": null,
                        "total": 2.3004779365,
                        "hasRDI": true,
                        "daily": 176.95984126923076,
                        "unit": "mg"
                    },
                    {
                        "label": "Niacin (B3)",
                        "tag": "NIA",
                        "schemaOrgTag": null,
                        "total": 104.70537386249998,
                        "hasRDI": true,
                        "daily": 654.4085866406249,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin B6",
                        "tag": "VITB6A",
                        "schemaOrgTag": null,
                        "total": 6.238775273899998,
                        "hasRDI": true,
                        "daily": 479.90579029999986,
                        "unit": "mg"
                    },
                    {
                        "label": "Folate equivalent (total)",
                        "tag": "FOLDFE",
                        "schemaOrgTag": null,
                        "total": 249.42102110000002,
                        "hasRDI": true,
                        "daily": 62.35525527500001,
                        "unit": "µg"
                    },
                    {
                        "label": "Folate (food)",
                        "tag": "FOLFD",
                        "schemaOrgTag": null,
                        "total": 249.42102110000002,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Folic acid",
                        "tag": "FOLAC",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin B12",
                        "tag": "VITB12",
                        "schemaOrgTag": null,
                        "total": 6.5322726939999995,
                        "hasRDI": true,
                        "daily": 272.1780289166667,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin D",
                        "tag": "VITD",
                        "schemaOrgTag": null,
                        "total": 2.8535923700000003,
                        "hasRDI": true,
                        "daily": 19.023949133333335,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin E",
                        "tag": "TOCPHA",
                        "schemaOrgTag": null,
                        "total": 7.262983977,
                        "hasRDI": true,
                        "daily": 48.41989318,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin K",
                        "tag": "VITK1",
                        "schemaOrgTag": null,
                        "total": 92.18126477,
                        "hasRDI": true,
                        "daily": 76.81772064166667,
                        "unit": "µg"
                    },
                    {
                        "label": "Sugar alcohols",
                        "tag": "Sugar.alcohol",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    },
                    {
                        "label": "Water",
                        "tag": "WATER",
                        "schemaOrgTag": null,
                        "total": 1474.9068589315993,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    }
                ]
            },
            "_links": {
                "self": {
                    "href": "https://api.edamam.com/api/recipes/v2/1da54064d59fe6e63b11823593ae6dc2?type=public&app_id=ea1d37d5&app_key=fd382a172ba8d6668c0430dc9c14a181",
                    "title": "Self"
                }
            }
        },
        {
            "recipe": {
                "uri": "http://www.edamam.com/ontologies/edamam.owl#recipe_7879614ad1d3687818ba7a494ef0bab9",
                "label": "Roast Chicken With Chicken Livers",
                "image": "https://www.edamam.com/web-img/b32/b324978429b9e75525848eae95912c73.jpg",
                "source": "Food & Wine",
                "url": "http://www.foodandwine.com/recipes/roast-chicken-with-chicken-livers",
                "shareAs": "http://www.edamam.com/recipe/roast-chicken-with-chicken-livers-7879614ad1d3687818ba7a494ef0bab9/chicken",
                "yield": 12,
                "dietLabels": [
                    "Low-Carb"
                ],
                "healthLabels": [
                    "Sugar-Conscious",
                    "Kidney-Friendly",
                    "Keto-Friendly",
                    "Paleo",
                    "Mediterranean",
                    "Dairy-Free",
                    "Gluten-Free",
                    "Wheat-Free",
                    "Egg-Free",
                    "Peanut-Free",
                    "Tree-Nut-Free",
                    "Soy-Free",
                    "Fish-Free",
                    "Shellfish-Free",
                    "Pork-Free",
                    "Red-Meat-Free",
                    "Crustacean-Free",
                    "Celery-Free",
                    "Mustard-Free",
                    "Sesame-Free",
                    "Lupine-Free",
                    "Mollusk-Free",
                    "Alcohol-Free",
                    "Sulfite-Free",
                    "Kosher"
                ],
                "cautions": [
                    "Sulfites"
                ],
                "ingredientLines": [
                    "One 3 3/4- to 4-pound chicken",
                    "1 teaspoon coarsely chopped thyme",
                    "Salt",
                    "1/2 cup extra-virgin olive oil",
                    "20 garlic cloves, peeled",
                    "2 teaspoons coarsely crushed black peppercorns",
                    "1/4 pound chicken livers, trimmed and cut into 1-inch pieces",
                    "Freshly ground pepper",
                    "2 tablespoons chopped Gaeta olives",
                    "1 tablespoon minced flat-leaf parsley"
                ],
                "ingredients": [
                    {
                        "text": "One 3 3/4- to 4-pound chicken",
                        "weight": 1757.67043375,
                        "foodCategory": "Poultry",
                        "foodId": "food_bmyxrshbfao9s1amjrvhoauob6mo",
                        "image": "https://www.edamam.com/food-img/d33/d338229d774a743f7858f6764e095878.jpg"
                    },
                    {
                        "text": "1 teaspoon coarsely chopped thyme",
                        "weight": 0.8,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_b3o3cj7a5gskecb0ufphtadnbfqb",
                        "image": "https://www.edamam.com/food-img/3e7/3e7cf3c8d767a90b906447f5e74059f7.jpg"
                    },
                    {
                        "text": "Salt",
                        "weight": 12.397611157500002,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_btxz81db72hwbra2pncvebzzzum9",
                        "image": "https://www.edamam.com/food-img/694/6943ea510918c6025795e8dc6e6eaaeb.jpg"
                    },
                    {
                        "text": "1/2 cup extra-virgin olive oil",
                        "weight": 108,
                        "foodCategory": "Oils",
                        "foodId": "food_b1d1icuad3iktrbqby0hiagafaz7",
                        "image": "https://www.edamam.com/food-img/4d6/4d651eaa8a353647746290c7a9b29d84.jpg"
                    },
                    {
                        "text": "20 garlic cloves, peeled",
                        "weight": 60,
                        "foodCategory": "vegetables",
                        "foodId": "food_avtcmx6bgjv1jvay6s6stan8dnyp",
                        "image": "https://www.edamam.com/food-img/6ee/6ee142951f48aaf94f4312409f8d133d.jpg"
                    },
                    {
                        "text": "2 teaspoons coarsely crushed black peppercorns",
                        "weight": 5.8,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_b6ywzluaaxv02wad7s1r9ag4py89",
                        "image": "https://www.edamam.com/food-img/c6e/c6e5c3bd8d3bc15175d9766971a4d1b2.jpg"
                    },
                    {
                        "text": "1/4 pound chicken livers, trimmed and cut into 1-inch pieces",
                        "weight": 113.3980925,
                        "foodCategory": "Poultry",
                        "foodId": "food_a9xs7abb632dn3aozv3w4a9351fh",
                        "image": "https://www.edamam.com/food-img/9aa/9aa4760ac12b682555a37a1cdc91150b.jpg"
                    },
                    {
                        "text": "Freshly ground pepper",
                        "weight": 6.198805578750001,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_b6ywzluaaxv02wad7s1r9ag4py89",
                        "image": "https://www.edamam.com/food-img/c6e/c6e5c3bd8d3bc15175d9766971a4d1b2.jpg"
                    },
                    {
                        "text": "2 tablespoons chopped Gaeta olives",
                        "weight": 16.8,
                        "foodCategory": "canned fruit",
                        "foodId": "food_bt7u5w5a064gusa46msxfb38ag06",
                        "image": "https://www.edamam.com/food-img/822/8221f2141e8dafd469414b20777735ca.jpg"
                    },
                    {
                        "text": "1 tablespoon minced flat-leaf parsley",
                        "weight": 3.8,
                        "foodCategory": "vegetables",
                        "foodId": "food_b244pqdazw24zobr5vqu2bf0uid8",
                        "image": "https://www.edamam.com/food-img/46a/46a132e96626d7989b4d6ed8c91f4da0.jpg"
                    }
                ],
                "calories": 3800.3909062201624,
                "totalWeight": 2082.17339973103,
                "totalTime": 0,
                "cuisineType": [
                    "french"
                ],
                "mealType": [
                    "lunch/dinner"
                ],
                "dishType": [
                    "main course"
                ],
                "totalNutrients": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 3800.3909062201624,
                        "unit": "kcal"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 296.00550270908724,
                        "unit": "g"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 68.66575263177619,
                        "unit": "g"
                    },
                    "FATRN": {
                        "label": "Trans",
                        "quantity": 1.2330681782264998,
                        "unit": "g"
                    },
                    "FAMS": {
                        "label": "Monounsaturated",
                        "quantity": 156.22800719343198,
                        "unit": "g"
                    },
                    "FAPU": {
                        "label": "Polyunsaturated",
                        "quantity": 51.88245657461092,
                        "unit": "g"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 29.824862242860625,
                        "unit": "g"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 5.07069781142375,
                        "unit": "g"
                    },
                    "SUGAR": {
                        "label": "Sugars",
                        "quantity": 0.709092355704,
                        "unit": "g"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 246.85824961133213,
                        "unit": "g"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 1287.6353403374999,
                        "unit": "mg"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 4819.481330821121,
                        "unit": "mg"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 328.97776085490955,
                        "unit": "mg"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 300.0558347836853,
                        "unit": "mg"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 2948.9622657792693,
                        "unit": "mg"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 24.70294561607415,
                        "unit": "mg"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 19.625649147884403,
                        "unit": "mg"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 2208.0738131159246,
                        "unit": "mg"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 4252.141323235763,
                        "unit": "µg"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 64.6277128767,
                        "unit": "mg"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 1.2001084291200501,
                        "unit": "mg"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 3.54556700863175,
                        "unit": "mg"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 92.94584780171459,
                        "unit": "mg"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 5.934173885584162,
                        "unit": "mg"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 748.4695345453874,
                        "unit": "µg"
                    },
                    "FOLFD": {
                        "label": "Folate (food)",
                        "quantity": 748.4695345453874,
                        "unit": "µg"
                    },
                    "FOLAC": {
                        "label": "Folic acid",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 22.506573010845,
                        "unit": "µg"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 2.3904317899,
                        "unit": "µg"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 20.355921910369,
                        "unit": "mg"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 166.16148315666373,
                        "unit": "µg"
                    },
                    "WATER": {
                        "label": "Water",
                        "quantity": 929.3817939139217,
                        "unit": "g"
                    }
                },
                "totalDaily": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 190.0195453110081,
                        "unit": "%"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 455.3930810909034,
                        "unit": "%"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 343.3287631588809,
                        "unit": "%"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 9.94162074762021,
                        "unit": "%"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 20.282791245695,
                        "unit": "%"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 493.71649922266425,
                        "unit": "%"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 429.2117801125,
                        "unit": "%"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 200.8117221175467,
                        "unit": "%"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 32.89777608549096,
                        "unit": "%"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 71.44186542468698,
                        "unit": "%"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 62.743877995303606,
                        "unit": "%"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 137.2385867559675,
                        "unit": "%"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 178.41499225349457,
                        "unit": "%"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 315.43911615941784,
                        "unit": "%"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 472.46014702619584,
                        "unit": "%"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 71.808569863,
                        "unit": "%"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 100.00903576000418,
                        "unit": "%"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 272.73592374090384,
                        "unit": "%"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 580.9115487607162,
                        "unit": "%"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 456.47491427570475,
                        "unit": "%"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 187.11738363634686,
                        "unit": "%"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 937.773875451875,
                        "unit": "%"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 15.936211932666668,
                        "unit": "%"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 135.70614606912665,
                        "unit": "%"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 138.4679026305531,
                        "unit": "%"
                    }
                },
                "digest": [
                    {
                        "label": "Fat",
                        "tag": "FAT",
                        "schemaOrgTag": "fatContent",
                        "total": 296.00550270908724,
                        "hasRDI": true,
                        "daily": 455.3930810909034,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Saturated",
                                "tag": "FASAT",
                                "schemaOrgTag": "saturatedFatContent",
                                "total": 68.66575263177619,
                                "hasRDI": true,
                                "daily": 343.3287631588809,
                                "unit": "g"
                            },
                            {
                                "label": "Trans",
                                "tag": "FATRN",
                                "schemaOrgTag": "transFatContent",
                                "total": 1.2330681782264998,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Monounsaturated",
                                "tag": "FAMS",
                                "schemaOrgTag": null,
                                "total": 156.22800719343198,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Polyunsaturated",
                                "tag": "FAPU",
                                "schemaOrgTag": null,
                                "total": 51.88245657461092,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Carbs",
                        "tag": "CHOCDF",
                        "schemaOrgTag": "carbohydrateContent",
                        "total": 29.824862242860625,
                        "hasRDI": true,
                        "daily": 9.94162074762021,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Carbs (net)",
                                "tag": "CHOCDF.net",
                                "schemaOrgTag": null,
                                "total": 24.754164431436877,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Fiber",
                                "tag": "FIBTG",
                                "schemaOrgTag": "fiberContent",
                                "total": 5.07069781142375,
                                "hasRDI": true,
                                "daily": 20.282791245695,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars",
                                "tag": "SUGAR",
                                "schemaOrgTag": "sugarContent",
                                "total": 0.709092355704,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars, added",
                                "tag": "SUGAR.added",
                                "schemaOrgTag": null,
                                "total": 0,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Protein",
                        "tag": "PROCNT",
                        "schemaOrgTag": "proteinContent",
                        "total": 246.85824961133213,
                        "hasRDI": true,
                        "daily": 493.71649922266425,
                        "unit": "g"
                    },
                    {
                        "label": "Cholesterol",
                        "tag": "CHOLE",
                        "schemaOrgTag": "cholesterolContent",
                        "total": 1287.6353403374999,
                        "hasRDI": true,
                        "daily": 429.2117801125,
                        "unit": "mg"
                    },
                    {
                        "label": "Sodium",
                        "tag": "NA",
                        "schemaOrgTag": "sodiumContent",
                        "total": 4819.481330821121,
                        "hasRDI": true,
                        "daily": 200.8117221175467,
                        "unit": "mg"
                    },
                    {
                        "label": "Calcium",
                        "tag": "CA",
                        "schemaOrgTag": null,
                        "total": 328.97776085490955,
                        "hasRDI": true,
                        "daily": 32.89777608549096,
                        "unit": "mg"
                    },
                    {
                        "label": "Magnesium",
                        "tag": "MG",
                        "schemaOrgTag": null,
                        "total": 300.0558347836853,
                        "hasRDI": true,
                        "daily": 71.44186542468698,
                        "unit": "mg"
                    },
                    {
                        "label": "Potassium",
                        "tag": "K",
                        "schemaOrgTag": null,
                        "total": 2948.9622657792693,
                        "hasRDI": true,
                        "daily": 62.743877995303606,
                        "unit": "mg"
                    },
                    {
                        "label": "Iron",
                        "tag": "FE",
                        "schemaOrgTag": null,
                        "total": 24.70294561607415,
                        "hasRDI": true,
                        "daily": 137.2385867559675,
                        "unit": "mg"
                    },
                    {
                        "label": "Zinc",
                        "tag": "ZN",
                        "schemaOrgTag": null,
                        "total": 19.625649147884403,
                        "hasRDI": true,
                        "daily": 178.41499225349457,
                        "unit": "mg"
                    },
                    {
                        "label": "Phosphorus",
                        "tag": "P",
                        "schemaOrgTag": null,
                        "total": 2208.0738131159246,
                        "hasRDI": true,
                        "daily": 315.43911615941784,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin A",
                        "tag": "VITA_RAE",
                        "schemaOrgTag": null,
                        "total": 4252.141323235763,
                        "hasRDI": true,
                        "daily": 472.46014702619584,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin C",
                        "tag": "VITC",
                        "schemaOrgTag": null,
                        "total": 64.6277128767,
                        "hasRDI": true,
                        "daily": 71.808569863,
                        "unit": "mg"
                    },
                    {
                        "label": "Thiamin (B1)",
                        "tag": "THIA",
                        "schemaOrgTag": null,
                        "total": 1.2001084291200501,
                        "hasRDI": true,
                        "daily": 100.00903576000418,
                        "unit": "mg"
                    },
                    {
                        "label": "Riboflavin (B2)",
                        "tag": "RIBF",
                        "schemaOrgTag": null,
                        "total": 3.54556700863175,
                        "hasRDI": true,
                        "daily": 272.73592374090384,
                        "unit": "mg"
                    },
                    {
                        "label": "Niacin (B3)",
                        "tag": "NIA",
                        "schemaOrgTag": null,
                        "total": 92.94584780171459,
                        "hasRDI": true,
                        "daily": 580.9115487607162,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin B6",
                        "tag": "VITB6A",
                        "schemaOrgTag": null,
                        "total": 5.934173885584162,
                        "hasRDI": true,
                        "daily": 456.47491427570475,
                        "unit": "mg"
                    },
                    {
                        "label": "Folate equivalent (total)",
                        "tag": "FOLDFE",
                        "schemaOrgTag": null,
                        "total": 748.4695345453874,
                        "hasRDI": true,
                        "daily": 187.11738363634686,
                        "unit": "µg"
                    },
                    {
                        "label": "Folate (food)",
                        "tag": "FOLFD",
                        "schemaOrgTag": null,
                        "total": 748.4695345453874,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Folic acid",
                        "tag": "FOLAC",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin B12",
                        "tag": "VITB12",
                        "schemaOrgTag": null,
                        "total": 22.506573010845,
                        "hasRDI": true,
                        "daily": 937.773875451875,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin D",
                        "tag": "VITD",
                        "schemaOrgTag": null,
                        "total": 2.3904317899,
                        "hasRDI": true,
                        "daily": 15.936211932666668,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin E",
                        "tag": "TOCPHA",
                        "schemaOrgTag": null,
                        "total": 20.355921910369,
                        "hasRDI": true,
                        "daily": 135.70614606912665,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin K",
                        "tag": "VITK1",
                        "schemaOrgTag": null,
                        "total": 166.16148315666373,
                        "hasRDI": true,
                        "daily": 138.4679026305531,
                        "unit": "µg"
                    },
                    {
                        "label": "Sugar alcohols",
                        "tag": "Sugar.alcohol",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    },
                    {
                        "label": "Water",
                        "tag": "WATER",
                        "schemaOrgTag": null,
                        "total": 929.3817939139217,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    }
                ]
            },
            "_links": {
                "self": {
                    "href": "https://api.edamam.com/api/recipes/v2/7879614ad1d3687818ba7a494ef0bab9?type=public&app_id=ea1d37d5&app_key=fd382a172ba8d6668c0430dc9c14a181",
                    "title": "Self"
                }
            }
        },
        {
            "recipe": {
                "uri": "http://www.edamam.com/ontologies/edamam.owl#recipe_9b6f45c3bcb793ba4663ee4c712d7759",
                "label": "Chicken Vesuvio",
                "image": "https://www.edamam.com/web-img/85c/85c7885563809941210ad7180fcd2c54.jpg",
                "source": "PBS Food",
                "url": "http://www.pbs.org/food/recipes/chicken-vesuvio/",
                "shareAs": "http://www.edamam.com/recipe/chicken-vesuvio-9b6f45c3bcb793ba4663ee4c712d7759/chicken",
                "yield": 6,
                "dietLabels": [
                    "Low-Sodium"
                ],
                "healthLabels": [
                    "Sugar-Conscious",
                    "Low Potassium",
                    "Kidney-Friendly",
                    "Egg-Free",
                    "Peanut-Free",
                    "Tree-Nut-Free",
                    "Soy-Free",
                    "Fish-Free",
                    "Shellfish-Free",
                    "Pork-Free",
                    "Red-Meat-Free",
                    "Crustacean-Free",
                    "Celery-Free",
                    "Mustard-Free",
                    "Sesame-Free",
                    "Lupine-Free",
                    "Mollusk-Free"
                ],
                "cautions": [
                    "Sulfites"
                ],
                "ingredientLines": [
                    "3 tablespoons olive oil",
                    "4 - 4 oz. boneless skinless chicken breasts, pounded and lightly floured",
                    "2 tablespoons chopped garlic",
                    "1/4 cup dry white wine",
                    "1/8 cup chicken stock",
                    "2 ounces salted butter",
                    "8 ounces cooked rotini"
                ],
                "ingredients": [
                    {
                        "text": "3 tablespoons olive oil",
                        "weight": 40.5,
                        "foodCategory": "Oils",
                        "foodId": "food_b1d1icuad3iktrbqby0hiagafaz7",
                        "image": "https://www.edamam.com/food-img/4d6/4d651eaa8a353647746290c7a9b29d84.jpg"
                    },
                    {
                        "text": "4 - 4 oz. boneless skinless chicken breasts, pounded and lightly floured",
                        "weight": 113.3980925,
                        "foodCategory": "Poultry",
                        "foodId": "food_bdrxu94aj3x2djbpur8dhagfhkcn",
                        "image": "https://www.edamam.com/food-img/da5/da510379d3650787338ca16fb69f4c94.jpg"
                    },
                    {
                        "text": "2 tablespoons chopped garlic",
                        "weight": 16.999999999712582,
                        "foodCategory": "vegetables",
                        "foodId": "food_avtcmx6bgjv1jvay6s6stan8dnyp",
                        "image": "https://www.edamam.com/food-img/6ee/6ee142951f48aaf94f4312409f8d133d.jpg"
                    },
                    {
                        "text": "1/4 cup dry white wine",
                        "weight": 58.8,
                        "foodCategory": "wines",
                        "foodId": "food_a656mk2a5dmqb2adiamu6beihduu",
                        "image": "https://www.edamam.com/food-img/a71/a718cf3c52add522128929f1f324d2ab.jpg"
                    },
                    {
                        "text": "1/8 cup chicken stock",
                        "weight": 30,
                        "foodCategory": "canned soup",
                        "foodId": "food_bptblvzambd16nbhewqmhaw1rnh5",
                        "image": "https://www.edamam.com/food-img/26a/26a10c4cb4e07bab54d8a687ef5ac7d8.jpg"
                    },
                    {
                        "text": "2 ounces salted butter",
                        "weight": 56.69904625,
                        "foodCategory": "Dairy",
                        "foodId": "food_axwam0ga2lqqlabfq1kqtbloozm3",
                        "image": "https://www.edamam.com/food-img/515/515af390107678fce1533a31ee4cc35b.jpeg"
                    },
                    {
                        "text": "8 ounces cooked rotini",
                        "weight": 226.796185,
                        "foodCategory": "grains",
                        "foodId": "food_bcwokz3b2oo23xbi9zcjiav8mo2n",
                        "image": "https://www.edamam.com/food-img/222/22205c8592e82a675d90e3673d710bb5.jpg"
                    }
                ],
                "calories": 1343.3138449120718,
                "totalWeight": 543.1933237497126,
                "totalTime": 150,
                "cuisineType": [
                    "italian"
                ],
                "mealType": [
                    "lunch/dinner"
                ],
                "dishType": [
                    "main course"
                ],
                "totalNutrients": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 1343.3138449120718,
                        "unit": "kcal"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 92.01383095737357,
                        "unit": "g"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 35.86642862407475,
                        "unit": "g"
                    },
                    "FATRN": {
                        "label": "Trans",
                        "quantity": 1.8665326025500002,
                        "unit": "g"
                    },
                    "FAMS": {
                        "label": "Monounsaturated",
                        "quantity": 42.72279737188747,
                        "unit": "g"
                    },
                    "FAPU": {
                        "label": "Polyunsaturated",
                        "quantity": 7.297684719736786,
                        "unit": "g"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 78.23132211865499,
                        "unit": "g"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 4.439331329993965,
                        "unit": "g"
                    },
                    "SUGAR": {
                        "label": "Sugars",
                        "quantity": 2.512558063747126,
                        "unit": "g"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 41.02905143560673,
                        "unit": "g"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 205.58355696250004,
                        "unit": "mg"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 467.4119708624512,
                        "unit": "mg"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 72.52040867447978,
                        "unit": "mg"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 85.03876012492816,
                        "unit": "mg"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 633.9707214488476,
                        "unit": "mg"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 2.302453676495114,
                        "unit": "mg"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 2.2885567141216665,
                        "unit": "mg"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 431.3814954245603,
                        "unit": "mg"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 396.05934282500004,
                        "unit": "µg"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 5.363999999910325,
                        "unit": "mg"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 0.20222839626192518,
                        "unit": "mg"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 0.31837153644968386,
                        "unit": "mg"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 12.47491921942299,
                        "unit": "mg"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 1.290139632208951,
                        "unit": "mg"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 30.380532662491376,
                        "unit": "µg"
                    },
                    "FOLFD": {
                        "label": "Folate (food)",
                        "quantity": 30.380532662491376,
                        "unit": "µg"
                    },
                    "FOLAC": {
                        "label": "Folic acid",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 0.33452437287500003,
                        "unit": "µg"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 0.85048569375,
                        "unit": "µg"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 7.920874901999771,
                        "unit": "mg"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 29.160929422495116,
                        "unit": "µg"
                    },
                    "WATER": {
                        "label": "Water",
                        "quantity": 322.38507873770664,
                        "unit": "g"
                    }
                },
                "totalDaily": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 67.16569224560358,
                        "unit": "%"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 141.5597399344209,
                        "unit": "%"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 179.33214312037376,
                        "unit": "%"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 26.077107372884996,
                        "unit": "%"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 17.75732531997586,
                        "unit": "%"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 82.05810287121346,
                        "unit": "%"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 68.52785232083335,
                        "unit": "%"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 19.475498785935468,
                        "unit": "%"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 7.252040867447978,
                        "unit": "%"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 20.24732383926861,
                        "unit": "%"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 13.4887387542308,
                        "unit": "%"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 12.791409313861744,
                        "unit": "%"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 20.805061037469695,
                        "unit": "%"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 61.62592791779432,
                        "unit": "%"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 44.00659364722223,
                        "unit": "%"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 5.959999999900361,
                        "unit": "%"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 16.85236635516043,
                        "unit": "%"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 24.49011818843722,
                        "unit": "%"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 77.9682451213937,
                        "unit": "%"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 99.2415101699193,
                        "unit": "%"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 7.595133165622844,
                        "unit": "%"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 13.938515536458336,
                        "unit": "%"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 5.669904625,
                        "unit": "%"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 52.805832679998474,
                        "unit": "%"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 24.30077451874593,
                        "unit": "%"
                    }
                },
                "digest": [
                    {
                        "label": "Fat",
                        "tag": "FAT",
                        "schemaOrgTag": "fatContent",
                        "total": 92.01383095737357,
                        "hasRDI": true,
                        "daily": 141.5597399344209,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Saturated",
                                "tag": "FASAT",
                                "schemaOrgTag": "saturatedFatContent",
                                "total": 35.86642862407475,
                                "hasRDI": true,
                                "daily": 179.33214312037376,
                                "unit": "g"
                            },
                            {
                                "label": "Trans",
                                "tag": "FATRN",
                                "schemaOrgTag": "transFatContent",
                                "total": 1.8665326025500002,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Monounsaturated",
                                "tag": "FAMS",
                                "schemaOrgTag": null,
                                "total": 42.72279737188747,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Polyunsaturated",
                                "tag": "FAPU",
                                "schemaOrgTag": null,
                                "total": 7.297684719736786,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Carbs",
                        "tag": "CHOCDF",
                        "schemaOrgTag": "carbohydrateContent",
                        "total": 78.23132211865499,
                        "hasRDI": true,
                        "daily": 26.077107372884996,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Carbs (net)",
                                "tag": "CHOCDF.net",
                                "schemaOrgTag": null,
                                "total": 73.79199078866102,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Fiber",
                                "tag": "FIBTG",
                                "schemaOrgTag": "fiberContent",
                                "total": 4.439331329993965,
                                "hasRDI": true,
                                "daily": 17.75732531997586,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars",
                                "tag": "SUGAR",
                                "schemaOrgTag": "sugarContent",
                                "total": 2.512558063747126,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars, added",
                                "tag": "SUGAR.added",
                                "schemaOrgTag": null,
                                "total": 0,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Protein",
                        "tag": "PROCNT",
                        "schemaOrgTag": "proteinContent",
                        "total": 41.02905143560673,
                        "hasRDI": true,
                        "daily": 82.05810287121346,
                        "unit": "g"
                    },
                    {
                        "label": "Cholesterol",
                        "tag": "CHOLE",
                        "schemaOrgTag": "cholesterolContent",
                        "total": 205.58355696250004,
                        "hasRDI": true,
                        "daily": 68.52785232083335,
                        "unit": "mg"
                    },
                    {
                        "label": "Sodium",
                        "tag": "NA",
                        "schemaOrgTag": "sodiumContent",
                        "total": 467.4119708624512,
                        "hasRDI": true,
                        "daily": 19.475498785935468,
                        "unit": "mg"
                    },
                    {
                        "label": "Calcium",
                        "tag": "CA",
                        "schemaOrgTag": null,
                        "total": 72.52040867447978,
                        "hasRDI": true,
                        "daily": 7.252040867447978,
                        "unit": "mg"
                    },
                    {
                        "label": "Magnesium",
                        "tag": "MG",
                        "schemaOrgTag": null,
                        "total": 85.03876012492816,
                        "hasRDI": true,
                        "daily": 20.24732383926861,
                        "unit": "mg"
                    },
                    {
                        "label": "Potassium",
                        "tag": "K",
                        "schemaOrgTag": null,
                        "total": 633.9707214488476,
                        "hasRDI": true,
                        "daily": 13.4887387542308,
                        "unit": "mg"
                    },
                    {
                        "label": "Iron",
                        "tag": "FE",
                        "schemaOrgTag": null,
                        "total": 2.302453676495114,
                        "hasRDI": true,
                        "daily": 12.791409313861744,
                        "unit": "mg"
                    },
                    {
                        "label": "Zinc",
                        "tag": "ZN",
                        "schemaOrgTag": null,
                        "total": 2.2885567141216665,
                        "hasRDI": true,
                        "daily": 20.805061037469695,
                        "unit": "mg"
                    },
                    {
                        "label": "Phosphorus",
                        "tag": "P",
                        "schemaOrgTag": null,
                        "total": 431.3814954245603,
                        "hasRDI": true,
                        "daily": 61.62592791779432,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin A",
                        "tag": "VITA_RAE",
                        "schemaOrgTag": null,
                        "total": 396.05934282500004,
                        "hasRDI": true,
                        "daily": 44.00659364722223,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin C",
                        "tag": "VITC",
                        "schemaOrgTag": null,
                        "total": 5.363999999910325,
                        "hasRDI": true,
                        "daily": 5.959999999900361,
                        "unit": "mg"
                    },
                    {
                        "label": "Thiamin (B1)",
                        "tag": "THIA",
                        "schemaOrgTag": null,
                        "total": 0.20222839626192518,
                        "hasRDI": true,
                        "daily": 16.85236635516043,
                        "unit": "mg"
                    },
                    {
                        "label": "Riboflavin (B2)",
                        "tag": "RIBF",
                        "schemaOrgTag": null,
                        "total": 0.31837153644968386,
                        "hasRDI": true,
                        "daily": 24.49011818843722,
                        "unit": "mg"
                    },
                    {
                        "label": "Niacin (B3)",
                        "tag": "NIA",
                        "schemaOrgTag": null,
                        "total": 12.47491921942299,
                        "hasRDI": true,
                        "daily": 77.9682451213937,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin B6",
                        "tag": "VITB6A",
                        "schemaOrgTag": null,
                        "total": 1.290139632208951,
                        "hasRDI": true,
                        "daily": 99.2415101699193,
                        "unit": "mg"
                    },
                    {
                        "label": "Folate equivalent (total)",
                        "tag": "FOLDFE",
                        "schemaOrgTag": null,
                        "total": 30.380532662491376,
                        "hasRDI": true,
                        "daily": 7.595133165622844,
                        "unit": "µg"
                    },
                    {
                        "label": "Folate (food)",
                        "tag": "FOLFD",
                        "schemaOrgTag": null,
                        "total": 30.380532662491376,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Folic acid",
                        "tag": "FOLAC",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin B12",
                        "tag": "VITB12",
                        "schemaOrgTag": null,
                        "total": 0.33452437287500003,
                        "hasRDI": true,
                        "daily": 13.938515536458336,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin D",
                        "tag": "VITD",
                        "schemaOrgTag": null,
                        "total": 0.85048569375,
                        "hasRDI": true,
                        "daily": 5.669904625,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin E",
                        "tag": "TOCPHA",
                        "schemaOrgTag": null,
                        "total": 7.920874901999771,
                        "hasRDI": true,
                        "daily": 52.805832679998474,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin K",
                        "tag": "VITK1",
                        "schemaOrgTag": null,
                        "total": 29.160929422495116,
                        "hasRDI": true,
                        "daily": 24.30077451874593,
                        "unit": "µg"
                    },
                    {
                        "label": "Sugar alcohols",
                        "tag": "Sugar.alcohol",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    },
                    {
                        "label": "Water",
                        "tag": "WATER",
                        "schemaOrgTag": null,
                        "total": 322.38507873770664,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    }
                ]
            },
            "_links": {
                "self": {
                    "href": "https://api.edamam.com/api/recipes/v2/9b6f45c3bcb793ba4663ee4c712d7759?type=public&app_id=ea1d37d5&app_key=fd382a172ba8d6668c0430dc9c14a181",
                    "title": "Self"
                }
            }
        },
        {
            "recipe": {
                "uri": "http://www.edamam.com/ontologies/edamam.owl#recipe_b4dadfbd094da0086d5759f92e9db359",
                "label": "Smothered Chicken",
                "image": "https://www.edamam.com/web-img/65a/65a7ad1b644869cd901aafd23aa3bf11.jpeg",
                "source": "Food Network",
                "url": "https://www.foodnetwork.com/recipes/sandra-lee/smothered-chicken-recipe-1950282",
                "shareAs": "http://www.edamam.com/recipe/smothered-chicken-b4dadfbd094da0086d5759f92e9db359/chicken",
                "yield": 4,
                "dietLabels": [
                    "Low-Carb"
                ],
                "healthLabels": [
                    "Sugar-Conscious",
                    "Dairy-Free",
                    "Egg-Free",
                    "Peanut-Free",
                    "Tree-Nut-Free",
                    "Soy-Free",
                    "Fish-Free",
                    "Shellfish-Free",
                    "Pork-Free",
                    "Red-Meat-Free",
                    "Crustacean-Free",
                    "Celery-Free",
                    "Mustard-Free",
                    "Sesame-Free",
                    "Lupine-Free",
                    "Mollusk-Free",
                    "Alcohol-Free",
                    "Sulfite-Free",
                    "Kosher"
                ],
                "cautions": [
                    "Sulfites",
                    "FODMAP"
                ],
                "ingredientLines": [
                    "3 1/2 pounds whole cut-up chicken",
                    "2 (5-ounce) packets chicken fry coating (recommended: Dixie Fry)",
                    "2 tablespoons salt-free chicken seasoning, divided (recommended: McCormick Grill Mates)",
                    "Canola oil, for frying",
                    "2 (12-ounce) jars roasted chicken gravy (recommended: Franco American)",
                    "1 teaspoon crushed garlic"
                ],
                "ingredients": [
                    {
                        "text": "3 1/2 pounds whole cut-up chicken",
                        "weight": 1587.5732950000001,
                        "foodCategory": "Poultry",
                        "foodId": "food_bmyxrshbfao9s1amjrvhoauob6mo",
                        "image": "https://www.edamam.com/food-img/d33/d338229d774a743f7858f6764e095878.jpg"
                    },
                    {
                        "text": "2 (5-ounce) packets chicken fry coating (recommended: Dixie Fry)",
                        "weight": 283.49523125,
                        "foodCategory": "Poultry",
                        "foodId": "food_bmyxrshbfao9s1amjrvhoauob6mo",
                        "image": "https://www.edamam.com/food-img/d33/d338229d774a743f7858f6764e095878.jpg"
                    },
                    {
                        "text": "2 tablespoons salt-free chicken seasoning, divided (recommended: McCormick Grill Mates)",
                        "weight": 4.1999999997159625,
                        "foodCategory": "condiments and sauces",
                        "foodId": "food_aa3k2msbdflu7valodjaoafcozsu",
                        "image": "https://www.edamam.com/food-img/98a/98af5a0918f05f04e85b0b9ab4a10006.jpg"
                    },
                    {
                        "text": "Canola oil, for frying",
                        "weight": 34.79501630499614,
                        "foodCategory": "Oils",
                        "foodId": "food_bk9p9aaavhvoq4bqsnprobpsiuxs",
                        "image": "https://www.edamam.com/food-img/07e/07e106ab3536d57428e5c46d009038f8.jpg"
                    },
                    {
                        "text": "2 (12-ounce) jars roasted chicken gravy (recommended: Franco American)",
                        "weight": 680.388555,
                        "foodCategory": "canned soup",
                        "foodId": "food_af7ntcsa84dhrzaxbewf2arvso4x",
                        "image": "https://www.edamam.com/food-img/d00/d003966a07a0a523f0761c1e159b0ed1.jpg"
                    },
                    {
                        "text": "1 teaspoon crushed garlic",
                        "weight": 2.8,
                        "foodCategory": "vegetables",
                        "foodId": "food_avtcmx6bgjv1jvay6s6stan8dnyp",
                        "image": "https://www.edamam.com/food-img/6ee/6ee142951f48aaf94f4312409f8d133d.jpg"
                    }
                ],
                "calories": 7964.760379624098,
                "totalWeight": 2942.225643437174,
                "totalTime": 50,
                "cuisineType": [
                    "mediterranean"
                ],
                "mealType": [
                    "lunch/dinner"
                ],
                "dishType": [
                    "starter"
                ],
                "totalNutrients": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 7964.760379624098,
                        "unit": "kcal"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 704.67606873119,
                        "unit": "g"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 118.54557871197841,
                        "unit": "g"
                    },
                    "FATRN": {
                        "label": "Trans",
                        "quantity": 3.3308222911029572,
                        "unit": "g"
                    },
                    "FAMS": {
                        "label": "Monounsaturated",
                        "quantity": 376.93828760023564,
                        "unit": "g"
                    },
                    "FAPU": {
                        "label": "Polyunsaturated",
                        "quantity": 178.64846249366926,
                        "unit": "g"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 38.558739680948875,
                        "unit": "g"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 3.380954219959383,
                        "unit": "g"
                    },
                    "SUGAR": {
                        "label": "Sugars",
                        "quantity": 5.528230728986934,
                        "unit": "g"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 361.6349249939793,
                        "unit": "g"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 1416.9091657875001,
                        "unit": "mg"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 4952.331441523788,
                        "unit": "mg"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 346.9632488875,
                        "unit": "mg"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 388.52147635,
                        "unit": "mg"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 4289.1710395625005,
                        "unit": "mg"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 20.08504294475,
                        "unit": "mg"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 29.986586133875004,
                        "unit": "mg"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 2952.0674145375006,
                        "unit": "mg"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 773.9419813125,
                        "unit": "µg"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 30.810696420000006,
                        "unit": "mg"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 1.2439071701000002,
                        "unit": "mg"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 2.54092931015,
                        "unit": "mg"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 130.2850917689125,
                        "unit": "mg"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 6.6513586973750005,
                        "unit": "mg"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 125.95588267500003,
                        "unit": "µg"
                    },
                    "FOLFD": {
                        "label": "Folate (food)",
                        "quantity": 125.95588267500003,
                        "unit": "µg"
                    },
                    "FOLAC": {
                        "label": "Folic acid",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 6.480700986375001,
                        "unit": "µg"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 3.742137052500001,
                        "unit": "µg"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 73.50594165818008,
                        "unit": "mg"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 303.10138984340716,
                        "unit": "µg"
                    },
                    "WATER": {
                        "label": "Water",
                        "quantity": 1817.0019533093748,
                        "unit": "g"
                    }
                },
                "totalDaily": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 398.2380189812049,
                        "unit": "%"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 1084.1170288172154,
                        "unit": "%"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 592.7278935598921,
                        "unit": "%"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 12.852913226982958,
                        "unit": "%"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 13.523816879837533,
                        "unit": "%"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 723.2698499879585,
                        "unit": "%"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 472.30305526250004,
                        "unit": "%"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 206.34714339682452,
                        "unit": "%"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 34.69632488875,
                        "unit": "%"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 92.50511341666667,
                        "unit": "%"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 91.25895828856385,
                        "unit": "%"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 111.58357191527779,
                        "unit": "%"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 272.6053284897728,
                        "unit": "%"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 421.72391636250006,
                        "unit": "%"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 85.99355347916666,
                        "unit": "%"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 34.234107133333346,
                        "unit": "%"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 103.65893084166669,
                        "unit": "%"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 195.45610078076922,
                        "unit": "%"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 814.2818235557032,
                        "unit": "%"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 511.64297672115384,
                        "unit": "%"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 31.488970668750007,
                        "unit": "%"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 270.0292077656251,
                        "unit": "%"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 24.947580350000006,
                        "unit": "%"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 490.03961105453385,
                        "unit": "%"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 252.58449153617264,
                        "unit": "%"
                    }
                },
                "digest": [
                    {
                        "label": "Fat",
                        "tag": "FAT",
                        "schemaOrgTag": "fatContent",
                        "total": 704.67606873119,
                        "hasRDI": true,
                        "daily": 1084.1170288172154,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Saturated",
                                "tag": "FASAT",
                                "schemaOrgTag": "saturatedFatContent",
                                "total": 118.54557871197841,
                                "hasRDI": true,
                                "daily": 592.7278935598921,
                                "unit": "g"
                            },
                            {
                                "label": "Trans",
                                "tag": "FATRN",
                                "schemaOrgTag": "transFatContent",
                                "total": 3.3308222911029572,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Monounsaturated",
                                "tag": "FAMS",
                                "schemaOrgTag": null,
                                "total": 376.93828760023564,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Polyunsaturated",
                                "tag": "FAPU",
                                "schemaOrgTag": null,
                                "total": 178.64846249366926,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Carbs",
                        "tag": "CHOCDF",
                        "schemaOrgTag": "carbohydrateContent",
                        "total": 38.558739680948875,
                        "hasRDI": true,
                        "daily": 12.852913226982958,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Carbs (net)",
                                "tag": "CHOCDF.net",
                                "schemaOrgTag": null,
                                "total": 35.17778546098949,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Fiber",
                                "tag": "FIBTG",
                                "schemaOrgTag": "fiberContent",
                                "total": 3.380954219959383,
                                "hasRDI": true,
                                "daily": 13.523816879837533,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars",
                                "tag": "SUGAR",
                                "schemaOrgTag": "sugarContent",
                                "total": 5.528230728986934,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars, added",
                                "tag": "SUGAR.added",
                                "schemaOrgTag": null,
                                "total": 0,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Protein",
                        "tag": "PROCNT",
                        "schemaOrgTag": "proteinContent",
                        "total": 361.6349249939793,
                        "hasRDI": true,
                        "daily": 723.2698499879585,
                        "unit": "g"
                    },
                    {
                        "label": "Cholesterol",
                        "tag": "CHOLE",
                        "schemaOrgTag": "cholesterolContent",
                        "total": 1416.9091657875001,
                        "hasRDI": true,
                        "daily": 472.30305526250004,
                        "unit": "mg"
                    },
                    {
                        "label": "Sodium",
                        "tag": "NA",
                        "schemaOrgTag": "sodiumContent",
                        "total": 4952.331441523788,
                        "hasRDI": true,
                        "daily": 206.34714339682452,
                        "unit": "mg"
                    },
                    {
                        "label": "Calcium",
                        "tag": "CA",
                        "schemaOrgTag": null,
                        "total": 346.9632488875,
                        "hasRDI": true,
                        "daily": 34.69632488875,
                        "unit": "mg"
                    },
                    {
                        "label": "Magnesium",
                        "tag": "MG",
                        "schemaOrgTag": null,
                        "total": 388.52147635,
                        "hasRDI": true,
                        "daily": 92.50511341666667,
                        "unit": "mg"
                    },
                    {
                        "label": "Potassium",
                        "tag": "K",
                        "schemaOrgTag": null,
                        "total": 4289.1710395625005,
                        "hasRDI": true,
                        "daily": 91.25895828856385,
                        "unit": "mg"
                    },
                    {
                        "label": "Iron",
                        "tag": "FE",
                        "schemaOrgTag": null,
                        "total": 20.08504294475,
                        "hasRDI": true,
                        "daily": 111.58357191527779,
                        "unit": "mg"
                    },
                    {
                        "label": "Zinc",
                        "tag": "ZN",
                        "schemaOrgTag": null,
                        "total": 29.986586133875004,
                        "hasRDI": true,
                        "daily": 272.6053284897728,
                        "unit": "mg"
                    },
                    {
                        "label": "Phosphorus",
                        "tag": "P",
                        "schemaOrgTag": null,
                        "total": 2952.0674145375006,
                        "hasRDI": true,
                        "daily": 421.72391636250006,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin A",
                        "tag": "VITA_RAE",
                        "schemaOrgTag": null,
                        "total": 773.9419813125,
                        "hasRDI": true,
                        "daily": 85.99355347916666,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin C",
                        "tag": "VITC",
                        "schemaOrgTag": null,
                        "total": 30.810696420000006,
                        "hasRDI": true,
                        "daily": 34.234107133333346,
                        "unit": "mg"
                    },
                    {
                        "label": "Thiamin (B1)",
                        "tag": "THIA",
                        "schemaOrgTag": null,
                        "total": 1.2439071701000002,
                        "hasRDI": true,
                        "daily": 103.65893084166669,
                        "unit": "mg"
                    },
                    {
                        "label": "Riboflavin (B2)",
                        "tag": "RIBF",
                        "schemaOrgTag": null,
                        "total": 2.54092931015,
                        "hasRDI": true,
                        "daily": 195.45610078076922,
                        "unit": "mg"
                    },
                    {
                        "label": "Niacin (B3)",
                        "tag": "NIA",
                        "schemaOrgTag": null,
                        "total": 130.2850917689125,
                        "hasRDI": true,
                        "daily": 814.2818235557032,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin B6",
                        "tag": "VITB6A",
                        "schemaOrgTag": null,
                        "total": 6.6513586973750005,
                        "hasRDI": true,
                        "daily": 511.64297672115384,
                        "unit": "mg"
                    },
                    {
                        "label": "Folate equivalent (total)",
                        "tag": "FOLDFE",
                        "schemaOrgTag": null,
                        "total": 125.95588267500003,
                        "hasRDI": true,
                        "daily": 31.488970668750007,
                        "unit": "µg"
                    },
                    {
                        "label": "Folate (food)",
                        "tag": "FOLFD",
                        "schemaOrgTag": null,
                        "total": 125.95588267500003,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Folic acid",
                        "tag": "FOLAC",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin B12",
                        "tag": "VITB12",
                        "schemaOrgTag": null,
                        "total": 6.480700986375001,
                        "hasRDI": true,
                        "daily": 270.0292077656251,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin D",
                        "tag": "VITD",
                        "schemaOrgTag": null,
                        "total": 3.742137052500001,
                        "hasRDI": true,
                        "daily": 24.947580350000006,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin E",
                        "tag": "TOCPHA",
                        "schemaOrgTag": null,
                        "total": 73.50594165818008,
                        "hasRDI": true,
                        "daily": 490.03961105453385,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin K",
                        "tag": "VITK1",
                        "schemaOrgTag": null,
                        "total": 303.10138984340716,
                        "hasRDI": true,
                        "daily": 252.58449153617264,
                        "unit": "µg"
                    },
                    {
                        "label": "Sugar alcohols",
                        "tag": "Sugar.alcohol",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    },
                    {
                        "label": "Water",
                        "tag": "WATER",
                        "schemaOrgTag": null,
                        "total": 1817.0019533093748,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    }
                ]
            },
            "_links": {
                "self": {
                    "href": "https://api.edamam.com/api/recipes/v2/b4dadfbd094da0086d5759f92e9db359?type=public&app_id=ea1d37d5&app_key=fd382a172ba8d6668c0430dc9c14a181",
                    "title": "Self"
                }
            }
        },
        {
            "recipe": {
                "uri": "http://www.edamam.com/ontologies/edamam.owl#recipe_45adb4461e9a05cb82f436b9ea4cdcbd",
                "label": "Chicken & peppers",
                "image": "https://www.edamam.com/web-img/adf/adf0d1e50d6ab82c373984230682fb3e.jpg",
                "source": "The Stone Soup",
                "url": "http://thestonesoup.com/blog/2012/05/the-1-thing-you-should-never-do-when-combining-flavours/",
                "shareAs": "http://www.edamam.com/recipe/chicken-peppers-45adb4461e9a05cb82f436b9ea4cdcbd/chicken",
                "yield": 2,
                "dietLabels": [
                    "Low-Carb"
                ],
                "healthLabels": [
                    "Paleo",
                    "Mediterranean",
                    "Dairy-Free",
                    "Gluten-Free",
                    "Wheat-Free",
                    "Egg-Free",
                    "Peanut-Free",
                    "Tree-Nut-Free",
                    "Soy-Free",
                    "Fish-Free",
                    "Shellfish-Free",
                    "Pork-Free",
                    "Red-Meat-Free",
                    "Crustacean-Free",
                    "Celery-Free",
                    "Mustard-Free",
                    "Sesame-Free",
                    "Lupine-Free",
                    "Mollusk-Free",
                    "Alcohol-Free",
                    "No oil added",
                    "Sulfite-Free",
                    "FODMAP-Free",
                    "Kosher"
                ],
                "cautions": [],
                "ingredientLines": [
                    "4-6 chicken drumsticks",
                    "2-3 large red capsicum (bell peppers), chopped"
                ],
                "ingredients": [
                    {
                        "text": "4-6 chicken drumsticks",
                        "weight": 665,
                        "foodCategory": "Poultry",
                        "foodId": "food_agzvc6lbxg03stab195szars32lx",
                        "image": "https://www.edamam.com/food-img/491/4916353c22bd1ac381ac81d55597ddbe.jpg"
                    },
                    {
                        "text": "2-3 large red capsicum (bell peppers), chopped",
                        "weight": 410,
                        "foodCategory": "vegetables",
                        "foodId": "food_a8g63g7ak6bnmvbu7agxibp4a0dy",
                        "image": "https://www.edamam.com/food-img/4dc/4dc48b1a506d334b4ab6671b9d56a18f.jpeg"
                    }
                ],
                "calories": 1197.75,
                "totalWeight": 1075,
                "totalTime": 130,
                "cuisineType": [
                    "american"
                ],
                "mealType": [
                    "lunch/dinner"
                ],
                "dishType": [
                    "condiments and sauces"
                ],
                "totalNutrients": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 1197.75,
                        "unit": "kcal"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 62.41,
                        "unit": "g"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 16.463050000000003,
                        "unit": "g"
                    },
                    "FATRN": {
                        "label": "Trans",
                        "quantity": 0.31255,
                        "unit": "g"
                    },
                    "FAMS": {
                        "label": "Monounsaturated",
                        "quantity": 24.74365,
                        "unit": "g"
                    },
                    "FAPU": {
                        "label": "Polyunsaturated",
                        "quantity": 13.354250000000002,
                        "unit": "g"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 25.4545,
                        "unit": "g"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 8.61,
                        "unit": "g"
                    },
                    "SUGAR": {
                        "label": "Sugars",
                        "quantity": 17.22,
                        "unit": "g"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 124.291,
                        "unit": "g"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 611.8000000000001,
                        "unit": "mg"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 721.3000000000001,
                        "unit": "mg"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 81.9,
                        "unit": "mg"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 168.9,
                        "unit": "mg"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 2268.25,
                        "unit": "mg"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 6.4845,
                        "unit": "mg"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 13.394000000000002,
                        "unit": "mg"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 1190.55,
                        "unit": "mg"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 736.8,
                        "unit": "µg"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 523.5699999999999,
                        "unit": "mg"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 0.77335,
                        "unit": "mg"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 1.64525,
                        "unit": "mg"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 36.20655,
                        "unit": "mg"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 3.4873499999999997,
                        "unit": "mg"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 208.55,
                        "unit": "µg"
                    },
                    "FOLFD": {
                        "label": "Folate (food)",
                        "quantity": 208.55,
                        "unit": "µg"
                    },
                    "FOLAC": {
                        "label": "Folic acid",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 3.5245,
                        "unit": "µg"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 0.665,
                        "unit": "µg"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 7.7415,
                        "unit": "mg"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 36.715,
                        "unit": "µg"
                    },
                    "WATER": {
                        "label": "Water",
                        "quantity": 859.9199999999998,
                        "unit": "g"
                    }
                },
                "totalDaily": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 59.8875,
                        "unit": "%"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 96.01538461538462,
                        "unit": "%"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 82.31525000000002,
                        "unit": "%"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 8.484833333333333,
                        "unit": "%"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 34.44,
                        "unit": "%"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 248.582,
                        "unit": "%"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 203.93333333333337,
                        "unit": "%"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 30.054166666666667,
                        "unit": "%"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 8.190000000000001,
                        "unit": "%"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 40.214285714285715,
                        "unit": "%"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 48.26063829787234,
                        "unit": "%"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 36.025,
                        "unit": "%"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 121.76363636363637,
                        "unit": "%"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 170.07857142857142,
                        "unit": "%"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 81.86666666666666,
                        "unit": "%"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 581.7444444444444,
                        "unit": "%"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 64.44583333333333,
                        "unit": "%"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 126.5576923076923,
                        "unit": "%"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 226.2909375,
                        "unit": "%"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 268.25769230769225,
                        "unit": "%"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 52.1375,
                        "unit": "%"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 146.85416666666669,
                        "unit": "%"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 4.433333333333334,
                        "unit": "%"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 51.61,
                        "unit": "%"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 30.59583333333334,
                        "unit": "%"
                    }
                },
                "digest": [
                    {
                        "label": "Fat",
                        "tag": "FAT",
                        "schemaOrgTag": "fatContent",
                        "total": 62.41,
                        "hasRDI": true,
                        "daily": 96.01538461538462,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Saturated",
                                "tag": "FASAT",
                                "schemaOrgTag": "saturatedFatContent",
                                "total": 16.463050000000003,
                                "hasRDI": true,
                                "daily": 82.31525000000002,
                                "unit": "g"
                            },
                            {
                                "label": "Trans",
                                "tag": "FATRN",
                                "schemaOrgTag": "transFatContent",
                                "total": 0.31255,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Monounsaturated",
                                "tag": "FAMS",
                                "schemaOrgTag": null,
                                "total": 24.74365,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Polyunsaturated",
                                "tag": "FAPU",
                                "schemaOrgTag": null,
                                "total": 13.354250000000002,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Carbs",
                        "tag": "CHOCDF",
                        "schemaOrgTag": "carbohydrateContent",
                        "total": 25.4545,
                        "hasRDI": true,
                        "daily": 8.484833333333333,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Carbs (net)",
                                "tag": "CHOCDF.net",
                                "schemaOrgTag": null,
                                "total": 16.8445,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Fiber",
                                "tag": "FIBTG",
                                "schemaOrgTag": "fiberContent",
                                "total": 8.61,
                                "hasRDI": true,
                                "daily": 34.44,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars",
                                "tag": "SUGAR",
                                "schemaOrgTag": "sugarContent",
                                "total": 17.22,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars, added",
                                "tag": "SUGAR.added",
                                "schemaOrgTag": null,
                                "total": 0,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Protein",
                        "tag": "PROCNT",
                        "schemaOrgTag": "proteinContent",
                        "total": 124.291,
                        "hasRDI": true,
                        "daily": 248.582,
                        "unit": "g"
                    },
                    {
                        "label": "Cholesterol",
                        "tag": "CHOLE",
                        "schemaOrgTag": "cholesterolContent",
                        "total": 611.8000000000001,
                        "hasRDI": true,
                        "daily": 203.93333333333337,
                        "unit": "mg"
                    },
                    {
                        "label": "Sodium",
                        "tag": "NA",
                        "schemaOrgTag": "sodiumContent",
                        "total": 721.3000000000001,
                        "hasRDI": true,
                        "daily": 30.054166666666667,
                        "unit": "mg"
                    },
                    {
                        "label": "Calcium",
                        "tag": "CA",
                        "schemaOrgTag": null,
                        "total": 81.9,
                        "hasRDI": true,
                        "daily": 8.190000000000001,
                        "unit": "mg"
                    },
                    {
                        "label": "Magnesium",
                        "tag": "MG",
                        "schemaOrgTag": null,
                        "total": 168.9,
                        "hasRDI": true,
                        "daily": 40.214285714285715,
                        "unit": "mg"
                    },
                    {
                        "label": "Potassium",
                        "tag": "K",
                        "schemaOrgTag": null,
                        "total": 2268.25,
                        "hasRDI": true,
                        "daily": 48.26063829787234,
                        "unit": "mg"
                    },
                    {
                        "label": "Iron",
                        "tag": "FE",
                        "schemaOrgTag": null,
                        "total": 6.4845,
                        "hasRDI": true,
                        "daily": 36.025,
                        "unit": "mg"
                    },
                    {
                        "label": "Zinc",
                        "tag": "ZN",
                        "schemaOrgTag": null,
                        "total": 13.394000000000002,
                        "hasRDI": true,
                        "daily": 121.76363636363637,
                        "unit": "mg"
                    },
                    {
                        "label": "Phosphorus",
                        "tag": "P",
                        "schemaOrgTag": null,
                        "total": 1190.55,
                        "hasRDI": true,
                        "daily": 170.07857142857142,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin A",
                        "tag": "VITA_RAE",
                        "schemaOrgTag": null,
                        "total": 736.8,
                        "hasRDI": true,
                        "daily": 81.86666666666666,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin C",
                        "tag": "VITC",
                        "schemaOrgTag": null,
                        "total": 523.5699999999999,
                        "hasRDI": true,
                        "daily": 581.7444444444444,
                        "unit": "mg"
                    },
                    {
                        "label": "Thiamin (B1)",
                        "tag": "THIA",
                        "schemaOrgTag": null,
                        "total": 0.77335,
                        "hasRDI": true,
                        "daily": 64.44583333333333,
                        "unit": "mg"
                    },
                    {
                        "label": "Riboflavin (B2)",
                        "tag": "RIBF",
                        "schemaOrgTag": null,
                        "total": 1.64525,
                        "hasRDI": true,
                        "daily": 126.5576923076923,
                        "unit": "mg"
                    },
                    {
                        "label": "Niacin (B3)",
                        "tag": "NIA",
                        "schemaOrgTag": null,
                        "total": 36.20655,
                        "hasRDI": true,
                        "daily": 226.2909375,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin B6",
                        "tag": "VITB6A",
                        "schemaOrgTag": null,
                        "total": 3.4873499999999997,
                        "hasRDI": true,
                        "daily": 268.25769230769225,
                        "unit": "mg"
                    },
                    {
                        "label": "Folate equivalent (total)",
                        "tag": "FOLDFE",
                        "schemaOrgTag": null,
                        "total": 208.55,
                        "hasRDI": true,
                        "daily": 52.1375,
                        "unit": "µg"
                    },
                    {
                        "label": "Folate (food)",
                        "tag": "FOLFD",
                        "schemaOrgTag": null,
                        "total": 208.55,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Folic acid",
                        "tag": "FOLAC",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin B12",
                        "tag": "VITB12",
                        "schemaOrgTag": null,
                        "total": 3.5245,
                        "hasRDI": true,
                        "daily": 146.85416666666669,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin D",
                        "tag": "VITD",
                        "schemaOrgTag": null,
                        "total": 0.665,
                        "hasRDI": true,
                        "daily": 4.433333333333334,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin E",
                        "tag": "TOCPHA",
                        "schemaOrgTag": null,
                        "total": 7.7415,
                        "hasRDI": true,
                        "daily": 51.61,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin K",
                        "tag": "VITK1",
                        "schemaOrgTag": null,
                        "total": 36.715,
                        "hasRDI": true,
                        "daily": 30.59583333333334,
                        "unit": "µg"
                    },
                    {
                        "label": "Sugar alcohols",
                        "tag": "Sugar.alcohol",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    },
                    {
                        "label": "Water",
                        "tag": "WATER",
                        "schemaOrgTag": null,
                        "total": 859.9199999999998,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    }
                ]
            },
            "_links": {
                "self": {
                    "href": "https://api.edamam.com/api/recipes/v2/45adb4461e9a05cb82f436b9ea4cdcbd?type=public&app_id=ea1d37d5&app_key=fd382a172ba8d6668c0430dc9c14a181",
                    "title": "Self"
                }
            }
        },
        {
            "recipe": {
                "uri": "http://www.edamam.com/ontologies/edamam.owl#recipe_0806132207b0892f5670d9d70078c694",
                "label": "Chicken Hash",
                "image": "https://www.edamam.com/web-img/b50/b500b287cd791d8c431bbd9c504f7e80.jpg",
                "source": "Delish",
                "url": "http://www.delish.com/cooking/recipe-ideas/recipes/a33713/chicken-hash-recipe-122305/",
                "shareAs": "http://www.edamam.com/recipe/chicken-hash-0806132207b0892f5670d9d70078c694/chicken",
                "yield": 4,
                "dietLabels": [
                    "High-Fiber",
                    "Low-Carb"
                ],
                "healthLabels": [
                    "Dairy-Free",
                    "Egg-Free",
                    "Peanut-Free",
                    "Tree-Nut-Free",
                    "Soy-Free",
                    "Fish-Free",
                    "Shellfish-Free",
                    "Pork-Free",
                    "Red-Meat-Free",
                    "Crustacean-Free",
                    "Celery-Free",
                    "Mustard-Free",
                    "Sesame-Free",
                    "Lupine-Free",
                    "Mollusk-Free",
                    "Alcohol-Free",
                    "Sulfite-Free",
                    "Kosher"
                ],
                "cautions": [],
                "ingredientLines": [
                    "1 tbsp. oil",
                    "2 large baked potatoes",
                    "2 c. shredded cooked chicken",
                    "3 medium carrots",
                    "1 medium onion",
                    "1 jar chicken gravy"
                ],
                "ingredients": [
                    {
                        "text": "1 tbsp. oil",
                        "weight": 14,
                        "foodCategory": "Oils",
                        "foodId": "food_bk9p9aaavhvoq4bqsnprobpsiuxs",
                        "image": "https://www.edamam.com/food-img/07e/07e106ab3536d57428e5c46d009038f8.jpg"
                    },
                    {
                        "text": "2 large baked potatoes",
                        "weight": 598,
                        "foodCategory": "vegetables",
                        "foodId": "food_als7tunbnyz9uqayc3mkqarb8m6m",
                        "image": "https://www.edamam.com/food-img/bec/bec2a265c41dd4319dcd9b8a4a3777f5.jpg"
                    },
                    {
                        "text": "2 c. shredded cooked chicken",
                        "weight": 280,
                        "foodCategory": "Poultry",
                        "foodId": "food_a59p480aae04fubjz0yo7a5auh4m",
                        "image": "https://www.edamam.com/food-img/c81/c81b9affb7c9c29a861e8566bd2d0829.jpg"
                    },
                    {
                        "text": "3 medium carrots",
                        "weight": 183,
                        "foodCategory": "vegetables",
                        "foodId": "food_ai215e5b85pdh5ajd4aafa3w2zm8",
                        "image": "https://www.edamam.com/food-img/121/121e33fce0bb9546ed7d060b6c114e29.jpg"
                    },
                    {
                        "text": "1 medium onion",
                        "weight": 110,
                        "foodCategory": "vegetables",
                        "foodId": "food_bmrvi4ob4binw9a5m7l07amlfcoy",
                        "image": "https://www.edamam.com/food-img/205/205e6bf2399b85d34741892ef91cc603.jpg"
                    },
                    {
                        "text": "1 jar chicken gravy",
                        "weight": 1200,
                        "foodCategory": "Poultry",
                        "foodId": "food_bmyxrshbfao9s1amjrvhoauob6mo",
                        "image": "https://www.edamam.com/food-img/d33/d338229d774a743f7858f6764e095878.jpg"
                    }
                ],
                "calories": 3870.45,
                "totalWeight": 2385,
                "totalTime": 25,
                "cuisineType": [
                    "american"
                ],
                "mealType": [
                    "lunch/dinner"
                ],
                "dishType": [
                    "main course"
                ],
                "totalNutrients": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 3870.45,
                        "unit": "kcal"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 214.6106,
                        "unit": "g"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 58.13633,
                        "unit": "g"
                    },
                    "FATRN": {
                        "label": "Trans",
                        "quantity": 1.2193,
                        "unit": "g"
                    },
                    "FAMS": {
                        "label": "Monounsaturated",
                        "quantity": 90.7965,
                        "unit": "g"
                    },
                    "FAPU": {
                        "label": "Polyunsaturated",
                        "quantity": 47.49557,
                        "unit": "g"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 156.0166,
                        "unit": "g"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 20.748,
                        "unit": "g"
                    },
                    "SUGAR": {
                        "label": "Sugars",
                        "quantity": 19.7966,
                        "unit": "g"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 311.8673,
                        "unit": "g"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 1110,
                        "unit": "mg"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 1264.3899999999999,
                        "unit": "mg"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 358.93,
                        "unit": "mg"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 511.16,
                        "unit": "mg"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 6944.4000000000015,
                        "unit": "mg"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 21.366600000000002,
                        "unit": "mg"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 22.6952,
                        "unit": "mg"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 2822.13,
                        "unit": "mg"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 2059.63,
                        "unit": "µg"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 87.77100000000002,
                        "unit": "mg"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 1.46564,
                        "unit": "mg"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 2.27448,
                        "unit": "mg"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 113.66633,
                        "unit": "mg"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 7.84946,
                        "unit": "mg"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 297.15000000000003,
                        "unit": "µg"
                    },
                    "FOLFD": {
                        "label": "Folate (food)",
                        "quantity": 297.15000000000003,
                        "unit": "µg"
                    },
                    "FOLAC": {
                        "label": "Folic acid",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 4.532,
                        "unit": "µg"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 2.4000000000000004,
                        "unit": "µg"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 7.6928,
                        "unit": "mg"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 64.538,
                        "unit": "µg"
                    },
                    "WATER": {
                        "label": "Water",
                        "quantity": 1685.4307,
                        "unit": "g"
                    }
                },
                "totalDaily": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 193.5225,
                        "unit": "%"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 330.1701538461539,
                        "unit": "%"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 290.68165,
                        "unit": "%"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 52.00553333333334,
                        "unit": "%"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 82.992,
                        "unit": "%"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 623.7346,
                        "unit": "%"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 370,
                        "unit": "%"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 52.682916666666664,
                        "unit": "%"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 35.893,
                        "unit": "%"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 121.70476190476191,
                        "unit": "%"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 147.75319148936174,
                        "unit": "%"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 118.70333333333335,
                        "unit": "%"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 206.32,
                        "unit": "%"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 403.1614285714286,
                        "unit": "%"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 228.84777777777776,
                        "unit": "%"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 97.52333333333335,
                        "unit": "%"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 122.13666666666667,
                        "unit": "%"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 174.96,
                        "unit": "%"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 710.4145625,
                        "unit": "%"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 603.8046153846153,
                        "unit": "%"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 74.28750000000001,
                        "unit": "%"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 188.83333333333334,
                        "unit": "%"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 16.000000000000004,
                        "unit": "%"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 51.285333333333334,
                        "unit": "%"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 53.78166666666666,
                        "unit": "%"
                    }
                },
                "digest": [
                    {
                        "label": "Fat",
                        "tag": "FAT",
                        "schemaOrgTag": "fatContent",
                        "total": 214.6106,
                        "hasRDI": true,
                        "daily": 330.1701538461539,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Saturated",
                                "tag": "FASAT",
                                "schemaOrgTag": "saturatedFatContent",
                                "total": 58.13633,
                                "hasRDI": true,
                                "daily": 290.68165,
                                "unit": "g"
                            },
                            {
                                "label": "Trans",
                                "tag": "FATRN",
                                "schemaOrgTag": "transFatContent",
                                "total": 1.2193,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Monounsaturated",
                                "tag": "FAMS",
                                "schemaOrgTag": null,
                                "total": 90.7965,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Polyunsaturated",
                                "tag": "FAPU",
                                "schemaOrgTag": null,
                                "total": 47.49557,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Carbs",
                        "tag": "CHOCDF",
                        "schemaOrgTag": "carbohydrateContent",
                        "total": 156.0166,
                        "hasRDI": true,
                        "daily": 52.00553333333334,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Carbs (net)",
                                "tag": "CHOCDF.net",
                                "schemaOrgTag": null,
                                "total": 135.26860000000002,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Fiber",
                                "tag": "FIBTG",
                                "schemaOrgTag": "fiberContent",
                                "total": 20.748,
                                "hasRDI": true,
                                "daily": 82.992,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars",
                                "tag": "SUGAR",
                                "schemaOrgTag": "sugarContent",
                                "total": 19.7966,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars, added",
                                "tag": "SUGAR.added",
                                "schemaOrgTag": null,
                                "total": 0,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Protein",
                        "tag": "PROCNT",
                        "schemaOrgTag": "proteinContent",
                        "total": 311.8673,
                        "hasRDI": true,
                        "daily": 623.7346,
                        "unit": "g"
                    },
                    {
                        "label": "Cholesterol",
                        "tag": "CHOLE",
                        "schemaOrgTag": "cholesterolContent",
                        "total": 1110,
                        "hasRDI": true,
                        "daily": 370,
                        "unit": "mg"
                    },
                    {
                        "label": "Sodium",
                        "tag": "NA",
                        "schemaOrgTag": "sodiumContent",
                        "total": 1264.3899999999999,
                        "hasRDI": true,
                        "daily": 52.682916666666664,
                        "unit": "mg"
                    },
                    {
                        "label": "Calcium",
                        "tag": "CA",
                        "schemaOrgTag": null,
                        "total": 358.93,
                        "hasRDI": true,
                        "daily": 35.893,
                        "unit": "mg"
                    },
                    {
                        "label": "Magnesium",
                        "tag": "MG",
                        "schemaOrgTag": null,
                        "total": 511.16,
                        "hasRDI": true,
                        "daily": 121.70476190476191,
                        "unit": "mg"
                    },
                    {
                        "label": "Potassium",
                        "tag": "K",
                        "schemaOrgTag": null,
                        "total": 6944.4000000000015,
                        "hasRDI": true,
                        "daily": 147.75319148936174,
                        "unit": "mg"
                    },
                    {
                        "label": "Iron",
                        "tag": "FE",
                        "schemaOrgTag": null,
                        "total": 21.366600000000002,
                        "hasRDI": true,
                        "daily": 118.70333333333335,
                        "unit": "mg"
                    },
                    {
                        "label": "Zinc",
                        "tag": "ZN",
                        "schemaOrgTag": null,
                        "total": 22.6952,
                        "hasRDI": true,
                        "daily": 206.32,
                        "unit": "mg"
                    },
                    {
                        "label": "Phosphorus",
                        "tag": "P",
                        "schemaOrgTag": null,
                        "total": 2822.13,
                        "hasRDI": true,
                        "daily": 403.1614285714286,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin A",
                        "tag": "VITA_RAE",
                        "schemaOrgTag": null,
                        "total": 2059.63,
                        "hasRDI": true,
                        "daily": 228.84777777777776,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin C",
                        "tag": "VITC",
                        "schemaOrgTag": null,
                        "total": 87.77100000000002,
                        "hasRDI": true,
                        "daily": 97.52333333333335,
                        "unit": "mg"
                    },
                    {
                        "label": "Thiamin (B1)",
                        "tag": "THIA",
                        "schemaOrgTag": null,
                        "total": 1.46564,
                        "hasRDI": true,
                        "daily": 122.13666666666667,
                        "unit": "mg"
                    },
                    {
                        "label": "Riboflavin (B2)",
                        "tag": "RIBF",
                        "schemaOrgTag": null,
                        "total": 2.27448,
                        "hasRDI": true,
                        "daily": 174.96,
                        "unit": "mg"
                    },
                    {
                        "label": "Niacin (B3)",
                        "tag": "NIA",
                        "schemaOrgTag": null,
                        "total": 113.66633,
                        "hasRDI": true,
                        "daily": 710.4145625,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin B6",
                        "tag": "VITB6A",
                        "schemaOrgTag": null,
                        "total": 7.84946,
                        "hasRDI": true,
                        "daily": 603.8046153846153,
                        "unit": "mg"
                    },
                    {
                        "label": "Folate equivalent (total)",
                        "tag": "FOLDFE",
                        "schemaOrgTag": null,
                        "total": 297.15000000000003,
                        "hasRDI": true,
                        "daily": 74.28750000000001,
                        "unit": "µg"
                    },
                    {
                        "label": "Folate (food)",
                        "tag": "FOLFD",
                        "schemaOrgTag": null,
                        "total": 297.15000000000003,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Folic acid",
                        "tag": "FOLAC",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin B12",
                        "tag": "VITB12",
                        "schemaOrgTag": null,
                        "total": 4.532,
                        "hasRDI": true,
                        "daily": 188.83333333333334,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin D",
                        "tag": "VITD",
                        "schemaOrgTag": null,
                        "total": 2.4000000000000004,
                        "hasRDI": true,
                        "daily": 16.000000000000004,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin E",
                        "tag": "TOCPHA",
                        "schemaOrgTag": null,
                        "total": 7.6928,
                        "hasRDI": true,
                        "daily": 51.285333333333334,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin K",
                        "tag": "VITK1",
                        "schemaOrgTag": null,
                        "total": 64.538,
                        "hasRDI": true,
                        "daily": 53.78166666666666,
                        "unit": "µg"
                    },
                    {
                        "label": "Sugar alcohols",
                        "tag": "Sugar.alcohol",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    },
                    {
                        "label": "Water",
                        "tag": "WATER",
                        "schemaOrgTag": null,
                        "total": 1685.4307,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    }
                ]
            },
            "_links": {
                "self": {
                    "href": "https://api.edamam.com/api/recipes/v2/0806132207b0892f5670d9d70078c694?type=public&app_id=ea1d37d5&app_key=fd382a172ba8d6668c0430dc9c14a181",
                    "title": "Self"
                }
            }
        },
        {
            "recipe": {
                "uri": "http://www.edamam.com/ontologies/edamam.owl#recipe_6379680892262fe72b7daf2cfcb24965",
                "label": "Southwestern Chicken Soup",
                "image": "https://www.edamam.com/web-img/216/216f2d87bd0921a4059ca89aeecad473.jpg",
                "source": "Real Simple",
                "url": "https://www.realsimple.com/food-recipes/browse-all-recipes/southwestern-chicken-soup",
                "shareAs": "http://www.edamam.com/recipe/southwestern-chicken-soup-6379680892262fe72b7daf2cfcb24965/chicken",
                "yield": 4,
                "dietLabels": [],
                "healthLabels": [
                    "Gluten-Free",
                    "Wheat-Free",
                    "Egg-Free",
                    "Peanut-Free",
                    "Tree-Nut-Free",
                    "Soy-Free",
                    "Fish-Free",
                    "Shellfish-Free",
                    "Pork-Free",
                    "Red-Meat-Free",
                    "Crustacean-Free",
                    "Celery-Free",
                    "Mustard-Free",
                    "Sesame-Free",
                    "Lupine-Free",
                    "Mollusk-Free",
                    "Alcohol-Free",
                    "Sulfite-Free"
                ],
                "cautions": [
                    "Sulfites"
                ],
                "ingredientLines": [
                    "1 12-ounce jar salsa verde",
                    "3 cups cooked chicken pieces (1 small deli-counter rotisserie chicken or leftovers)",
                    "1 15-ounce can cannellini beans, drained",
                    "3 cups chicken broth",
                    "1 teaspoon ground cumin (optional)",
                    "2 green onions, chopped",
                    "1/2 cup sour cream",
                    "tortilla chips (optional)"
                ],
                "ingredients": [
                    {
                        "text": "1 12-ounce jar salsa verde",
                        "weight": 340.1942775,
                        "foodCategory": "condiments and sauces",
                        "foodId": "food_ax6tfr7a1hlbwpbkyaytlbkxaub2",
                        "image": "https://www.edamam.com/food-img/205/205d9e349c3b7e60d4886c5ab4e27a92.jpg"
                    },
                    {
                        "text": "3 cups cooked chicken pieces (1 small deli-counter rotisserie chicken or leftovers)",
                        "weight": 420,
                        "foodCategory": "Poultry",
                        "foodId": "food_bmyxrshbfao9s1amjrvhoauob6mo",
                        "image": "https://www.edamam.com/food-img/d33/d338229d774a743f7858f6764e095878.jpg"
                    },
                    {
                        "text": "1 15-ounce can cannellini beans, drained",
                        "weight": 425.242846875,
                        "foodCategory": "plant-based protein",
                        "foodId": "food_bggwvu5a6s0gniamjy6r1aoknilo",
                        "image": "https://www.edamam.com/food-img/a39/a39102018ed39c6008134e0570af8a6c.jpg"
                    },
                    {
                        "text": "3 cups chicken broth",
                        "weight": 720,
                        "foodCategory": "canned soup",
                        "foodId": "food_bptblvzambd16nbhewqmhaw1rnh5",
                        "image": "https://www.edamam.com/food-img/26a/26a10c4cb4e07bab54d8a687ef5ac7d8.jpg"
                    },
                    {
                        "text": "1 teaspoon ground cumin (optional)",
                        "weight": 2.1,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_a8jjbx4biqndasapojdb5by3e92e",
                        "image": "https://www.edamam.com/food-img/07e/07e2a4eb77ce46591033846504817d35.jpg"
                    },
                    {
                        "text": "2 green onions, chopped",
                        "weight": 30,
                        "foodCategory": "vegetables",
                        "foodId": "food_bknlkyzbuzo27pb11whr4bttkuy6",
                        "image": "https://www.edamam.com/food-img/b89/b89986ed6aa466285bdd99bac34b3c46.jpg"
                    },
                    {
                        "text": "1/2 cup sour cream",
                        "weight": 115,
                        "foodCategory": "Dairy",
                        "foodId": "food_adp9fcubzl3lr7bcvzn3rbfiiiwq",
                        "image": "https://www.edamam.com/food-img/f9d/f9d6183267b041b0aff9a10b89c9c15f.jpg"
                    },
                    {
                        "text": "tortilla chips (optional)",
                        "weight": 0,
                        "foodCategory": "savory snacks",
                        "foodId": "food_bkxl9s9bpcxmenbef89qbbofifnr",
                        "image": "https://www.edamam.com/food-img/24e/24eea039cad825c1745263674e9879df.jpg"
                    }
                ],
                "calories": 2015.6756708875,
                "totalWeight": 2052.5371243749996,
                "totalTime": 15,
                "cuisineType": [
                    "american"
                ],
                "mealType": [
                    "lunch/dinner"
                ],
                "dishType": [
                    "soup"
                ],
                "totalNutrients": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 2015.6756708875,
                        "unit": "kcal"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 99.36710332568751,
                        "unit": "g"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 34.011269563625,
                        "unit": "g"
                    },
                    "FATRN": {
                        "label": "Trans",
                        "quantity": 0.40740000000000004,
                        "unit": "g"
                    },
                    "FAMS": {
                        "label": "Monounsaturated",
                        "quantity": 36.640103140187506,
                        "unit": "g"
                    },
                    "FAPU": {
                        "label": "Polyunsaturated",
                        "quantity": 16.6924649870625,
                        "unit": "g"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 143.6468795865,
                        "unit": "g"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 27.8758479225,
                        "unit": "g"
                    },
                    "SUGAR": {
                        "label": "Sugars",
                        "quantity": 28.574253968437503,
                        "unit": "g"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 134.28433601887502,
                        "unit": "g"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 396.40000000000003,
                        "unit": "mg"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 3448.4058073437504,
                        "unit": "mg"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 576.49576319375,
                        "unit": "mg"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 419.49676463125,
                        "unit": "mg"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 4644.0037035375,
                        "unit": "mg"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 22.2510839253125,
                        "unit": "mg"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 12.77800557875,
                        "unit": "mg"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 1492.07964443125,
                        "unit": "mg"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 435.56537052500005,
                        "unit": "µg"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 56.84059613250001,
                        "unit": "mg"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 1.1398105006500001,
                        "unit": "mg"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 1.62447679324375,
                        "unit": "mg"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 46.32267099859375,
                        "unit": "mg"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 2.60347838548125,
                        "unit": "mg"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 392.28339266874997,
                        "unit": "µg"
                    },
                    "FOLFD": {
                        "label": "Folate (food)",
                        "quantity": 392.28339266874997,
                        "unit": "µg"
                    },
                    "FOLAC": {
                        "label": "Folic acid",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 1.624,
                        "unit": "µg"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 1.3000000000000003,
                        "unit": "µg"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 7.039183883562501,
                        "unit": "mg"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 130.62186429937498,
                        "unit": "µg"
                    },
                    "WATER": {
                        "label": "Water",
                        "quantity": 1656.0224128773748,
                        "unit": "g"
                    }
                },
                "totalDaily": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 100.78378354437501,
                        "unit": "%"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 152.87246665490386,
                        "unit": "%"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 170.056347818125,
                        "unit": "%"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 47.8822931955,
                        "unit": "%"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 111.50339169,
                        "unit": "%"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 268.56867203775005,
                        "unit": "%"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 132.13333333333333,
                        "unit": "%"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 143.6835753059896,
                        "unit": "%"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 57.649576319375,
                        "unit": "%"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 99.88018205505954,
                        "unit": "%"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 98.80858943696809,
                        "unit": "%"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 123.61713291840277,
                        "unit": "%"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 116.16368707954544,
                        "unit": "%"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 213.15423491875,
                        "unit": "%"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 48.39615228055556,
                        "unit": "%"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 63.156217925000014,
                        "unit": "%"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 94.9842083875,
                        "unit": "%"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 124.95975332644231,
                        "unit": "%"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 289.51669374121093,
                        "unit": "%"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 200.26756811394233,
                        "unit": "%"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 98.07084816718749,
                        "unit": "%"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 67.66666666666667,
                        "unit": "%"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 8.666666666666668,
                        "unit": "%"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 46.92789255708333,
                        "unit": "%"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 108.85155358281249,
                        "unit": "%"
                    }
                },
                "digest": [
                    {
                        "label": "Fat",
                        "tag": "FAT",
                        "schemaOrgTag": "fatContent",
                        "total": 99.36710332568751,
                        "hasRDI": true,
                        "daily": 152.87246665490386,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Saturated",
                                "tag": "FASAT",
                                "schemaOrgTag": "saturatedFatContent",
                                "total": 34.011269563625,
                                "hasRDI": true,
                                "daily": 170.056347818125,
                                "unit": "g"
                            },
                            {
                                "label": "Trans",
                                "tag": "FATRN",
                                "schemaOrgTag": "transFatContent",
                                "total": 0.40740000000000004,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Monounsaturated",
                                "tag": "FAMS",
                                "schemaOrgTag": null,
                                "total": 36.640103140187506,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Polyunsaturated",
                                "tag": "FAPU",
                                "schemaOrgTag": null,
                                "total": 16.6924649870625,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Carbs",
                        "tag": "CHOCDF",
                        "schemaOrgTag": "carbohydrateContent",
                        "total": 143.6468795865,
                        "hasRDI": true,
                        "daily": 47.8822931955,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Carbs (net)",
                                "tag": "CHOCDF.net",
                                "schemaOrgTag": null,
                                "total": 115.771031664,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Fiber",
                                "tag": "FIBTG",
                                "schemaOrgTag": "fiberContent",
                                "total": 27.8758479225,
                                "hasRDI": true,
                                "daily": 111.50339169,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars",
                                "tag": "SUGAR",
                                "schemaOrgTag": "sugarContent",
                                "total": 28.574253968437503,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars, added",
                                "tag": "SUGAR.added",
                                "schemaOrgTag": null,
                                "total": 0,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Protein",
                        "tag": "PROCNT",
                        "schemaOrgTag": "proteinContent",
                        "total": 134.28433601887502,
                        "hasRDI": true,
                        "daily": 268.56867203775005,
                        "unit": "g"
                    },
                    {
                        "label": "Cholesterol",
                        "tag": "CHOLE",
                        "schemaOrgTag": "cholesterolContent",
                        "total": 396.40000000000003,
                        "hasRDI": true,
                        "daily": 132.13333333333333,
                        "unit": "mg"
                    },
                    {
                        "label": "Sodium",
                        "tag": "NA",
                        "schemaOrgTag": "sodiumContent",
                        "total": 3448.4058073437504,
                        "hasRDI": true,
                        "daily": 143.6835753059896,
                        "unit": "mg"
                    },
                    {
                        "label": "Calcium",
                        "tag": "CA",
                        "schemaOrgTag": null,
                        "total": 576.49576319375,
                        "hasRDI": true,
                        "daily": 57.649576319375,
                        "unit": "mg"
                    },
                    {
                        "label": "Magnesium",
                        "tag": "MG",
                        "schemaOrgTag": null,
                        "total": 419.49676463125,
                        "hasRDI": true,
                        "daily": 99.88018205505954,
                        "unit": "mg"
                    },
                    {
                        "label": "Potassium",
                        "tag": "K",
                        "schemaOrgTag": null,
                        "total": 4644.0037035375,
                        "hasRDI": true,
                        "daily": 98.80858943696809,
                        "unit": "mg"
                    },
                    {
                        "label": "Iron",
                        "tag": "FE",
                        "schemaOrgTag": null,
                        "total": 22.2510839253125,
                        "hasRDI": true,
                        "daily": 123.61713291840277,
                        "unit": "mg"
                    },
                    {
                        "label": "Zinc",
                        "tag": "ZN",
                        "schemaOrgTag": null,
                        "total": 12.77800557875,
                        "hasRDI": true,
                        "daily": 116.16368707954544,
                        "unit": "mg"
                    },
                    {
                        "label": "Phosphorus",
                        "tag": "P",
                        "schemaOrgTag": null,
                        "total": 1492.07964443125,
                        "hasRDI": true,
                        "daily": 213.15423491875,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin A",
                        "tag": "VITA_RAE",
                        "schemaOrgTag": null,
                        "total": 435.56537052500005,
                        "hasRDI": true,
                        "daily": 48.39615228055556,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin C",
                        "tag": "VITC",
                        "schemaOrgTag": null,
                        "total": 56.84059613250001,
                        "hasRDI": true,
                        "daily": 63.156217925000014,
                        "unit": "mg"
                    },
                    {
                        "label": "Thiamin (B1)",
                        "tag": "THIA",
                        "schemaOrgTag": null,
                        "total": 1.1398105006500001,
                        "hasRDI": true,
                        "daily": 94.9842083875,
                        "unit": "mg"
                    },
                    {
                        "label": "Riboflavin (B2)",
                        "tag": "RIBF",
                        "schemaOrgTag": null,
                        "total": 1.62447679324375,
                        "hasRDI": true,
                        "daily": 124.95975332644231,
                        "unit": "mg"
                    },
                    {
                        "label": "Niacin (B3)",
                        "tag": "NIA",
                        "schemaOrgTag": null,
                        "total": 46.32267099859375,
                        "hasRDI": true,
                        "daily": 289.51669374121093,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin B6",
                        "tag": "VITB6A",
                        "schemaOrgTag": null,
                        "total": 2.60347838548125,
                        "hasRDI": true,
                        "daily": 200.26756811394233,
                        "unit": "mg"
                    },
                    {
                        "label": "Folate equivalent (total)",
                        "tag": "FOLDFE",
                        "schemaOrgTag": null,
                        "total": 392.28339266874997,
                        "hasRDI": true,
                        "daily": 98.07084816718749,
                        "unit": "µg"
                    },
                    {
                        "label": "Folate (food)",
                        "tag": "FOLFD",
                        "schemaOrgTag": null,
                        "total": 392.28339266874997,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Folic acid",
                        "tag": "FOLAC",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin B12",
                        "tag": "VITB12",
                        "schemaOrgTag": null,
                        "total": 1.624,
                        "hasRDI": true,
                        "daily": 67.66666666666667,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin D",
                        "tag": "VITD",
                        "schemaOrgTag": null,
                        "total": 1.3000000000000003,
                        "hasRDI": true,
                        "daily": 8.666666666666668,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin E",
                        "tag": "TOCPHA",
                        "schemaOrgTag": null,
                        "total": 7.039183883562501,
                        "hasRDI": true,
                        "daily": 46.92789255708333,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin K",
                        "tag": "VITK1",
                        "schemaOrgTag": null,
                        "total": 130.62186429937498,
                        "hasRDI": true,
                        "daily": 108.85155358281249,
                        "unit": "µg"
                    },
                    {
                        "label": "Sugar alcohols",
                        "tag": "Sugar.alcohol",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    },
                    {
                        "label": "Water",
                        "tag": "WATER",
                        "schemaOrgTag": null,
                        "total": 1656.0224128773748,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    }
                ]
            },
            "_links": {
                "self": {
                    "href": "https://api.edamam.com/api/recipes/v2/6379680892262fe72b7daf2cfcb24965?type=public&app_id=ea1d37d5&app_key=fd382a172ba8d6668c0430dc9c14a181",
                    "title": "Self"
                }
            }
        },
        {
            "recipe": {
                "uri": "http://www.edamam.com/ontologies/edamam.owl#recipe_8868b222a71cadfa850a188c6b9d2123",
                "label": "Crispy Chicken Dippers",
                "image": "https://www.edamam.com/web-img/c7b/c7bec34abe4f37580a4b5ffec912a956.jpg",
                "source": "The Daily Meal",
                "url": "http://www.thedailymeal.com/recipes/crispy-chicken-dippers-recipe",
                "shareAs": "http://www.edamam.com/recipe/crispy-chicken-dippers-8868b222a71cadfa850a188c6b9d2123/chicken",
                "yield": 4,
                "dietLabels": [
                    "Balanced",
                    "High-Fiber"
                ],
                "healthLabels": [
                    "Peanut-Free",
                    "Tree-Nut-Free",
                    "Soy-Free",
                    "Fish-Free",
                    "Shellfish-Free",
                    "Pork-Free",
                    "Red-Meat-Free",
                    "Crustacean-Free",
                    "Mustard-Free",
                    "Sesame-Free",
                    "Lupine-Free",
                    "Mollusk-Free",
                    "Alcohol-Free",
                    "Sulfite-Free"
                ],
                "cautions": [
                    "Soy",
                    "Sulfites",
                    "FODMAP"
                ],
                "ingredientLines": [
                    "24 Ounces Tyson Crispy Chicken Strips",
                    "2 cans crescent rolls",
                    "21½ Ounces Cream of Chicken soup",
                    "½ Teaspoon pepper",
                    "16 baby carrots",
                    "16 sticks celery"
                ],
                "ingredients": [
                    {
                        "text": "24 Ounces Tyson Crispy Chicken Strips",
                        "weight": 680.388555,
                        "foodCategory": "sandwhiches",
                        "foodId": "food_bpbsk7zaearxssa39q2fia84qudv",
                        "image": "https://www.edamam.com/food-img/cc3/cc359f770f8f4d9ab2eeb40cc7bf6768.jpg"
                    },
                    {
                        "text": "2 cans crescent rolls",
                        "weight": 936,
                        "foodCategory": "quick breads and pastries",
                        "foodId": "food_br1iu0yblw2iwjbsgy3gsavhjfx1",
                        "image": "https://www.edamam.com/food-img/c14/c14c034b0ab6ed147cefae5469e5dc39.jpg"
                    },
                    {
                        "text": "21½ Ounces Cream of Chicken soup",
                        "weight": 609.5147471875,
                        "foodCategory": "canned soup",
                        "foodId": "food_ai0spvcaict4osbmml7erbrgckhv",
                        "image": "https://www.edamam.com/food-img/cdb/cdb46a22081917716e631ef03e519e52.jpg"
                    },
                    {
                        "text": "½ Teaspoon pepper",
                        "weight": 1.45,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_b6ywzluaaxv02wad7s1r9ag4py89",
                        "image": "https://www.edamam.com/food-img/c6e/c6e5c3bd8d3bc15175d9766971a4d1b2.jpg"
                    },
                    {
                        "text": "16 baby carrots",
                        "weight": 160,
                        "foodCategory": "vegetables",
                        "foodId": "food_bg0rlw7bt25ojiavi5k7dbv51765",
                        "image": "https://www.edamam.com/food-img/954/9546f1fd29336cab2ecf552935d03206.jpg"
                    },
                    {
                        "text": "16 sticks celery",
                        "weight": 640,
                        "foodCategory": "vegetables",
                        "foodId": "food_bffeoksbyyur8ja4da73ub2xs57g",
                        "image": "https://www.edamam.com/food-img/d91/d91d2aed1c36d8fad54c4d7dc58f5a18.jpg"
                    }
                ],
                "calories": 5040.9395627,
                "totalWeight": 3027.3533021875,
                "totalTime": 0,
                "cuisineType": [
                    "american"
                ],
                "mealType": [
                    "lunch/dinner"
                ],
                "dishType": [
                    "main course"
                ],
                "totalNutrients": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 5040.9395627,
                        "unit": "kcal"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 220.80721878756248,
                        "unit": "g"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 60.563946027243745,
                        "unit": "g"
                    },
                    "FATRN": {
                        "label": "Trans",
                        "quantity": 8.5906020486,
                        "unit": "g"
                    },
                    "FAMS": {
                        "label": "Monounsaturated",
                        "quantity": 41.25698031881251,
                        "unit": "g"
                    },
                    "FAPU": {
                        "label": "Polyunsaturated",
                        "quantity": 43.68898109349376,
                        "unit": "g"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 570.6054611306249,
                        "unit": "g"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 38.061027407187495,
                        "unit": "g"
                    },
                    "SUGAR": {
                        "label": "Sugars",
                        "quantity": 61.978834219999996,
                        "unit": "g"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 202.61309320634376,
                        "unit": "g"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 350.9670962875,
                        "unit": "mg"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 17962.054160690626,
                        "unit": "mg"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 729.90161895625,
                        "unit": "mg"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 285.483442871875,
                        "unit": "mg"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 4819.7451191375,
                        "unit": "mg"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 31.237818319468747,
                        "unit": "mg"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 7.5367520831875,
                        "unit": "mg"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 2210.813937178125,
                        "unit": "mg"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 1673.978037265625,
                        "unit": "µg"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 32.0937888521875,
                        "unit": "mg"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 1.0055351801625,
                        "unit": "mg"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 1.7952842002468752,
                        "unit": "mg"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 60.90967061490001,
                        "unit": "mg"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 3.586940776603125,
                        "unit": "mg"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 436.431015121875,
                        "unit": "µg"
                    },
                    "FOLFD": {
                        "label": "Folate (food)",
                        "quantity": 368.392159621875,
                        "unit": "µg"
                    },
                    "FOLAC": {
                        "label": "Folic acid",
                        "quantity": 40.8233133,
                        "unit": "µg"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 1.3324275868750002,
                        "unit": "µg"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 1.3607771100000001,
                        "unit": "µg"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 23.311397193500003,
                        "unit": "mg"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 259.36473440000003,
                        "unit": "µg"
                    },
                    "WATER": {
                        "label": "Water",
                        "quantity": 1963.2513559533127,
                        "unit": "g"
                    }
                },
                "totalDaily": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 252.04697813500002,
                        "unit": "%"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 339.7034135193269,
                        "unit": "%"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 302.8197301362187,
                        "unit": "%"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 190.20182037687496,
                        "unit": "%"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 152.24410962874998,
                        "unit": "%"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 405.2261864126875,
                        "unit": "%"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 116.98903209583334,
                        "unit": "%"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 748.4189233621095,
                        "unit": "%"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 72.99016189562501,
                        "unit": "%"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 67.97224830282738,
                        "unit": "%"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 102.54776849228725,
                        "unit": "%"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 173.5434351081597,
                        "unit": "%"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 68.51592802897727,
                        "unit": "%"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 315.83056245401787,
                        "unit": "%"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 185.99755969618056,
                        "unit": "%"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 35.659765391319446,
                        "unit": "%"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 83.794598346875,
                        "unit": "%"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 138.098784634375,
                        "unit": "%"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 380.68544134312504,
                        "unit": "%"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 275.91852127716345,
                        "unit": "%"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 109.10775378046876,
                        "unit": "%"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 55.517816119791675,
                        "unit": "%"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 9.071847400000001,
                        "unit": "%"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 155.40931462333336,
                        "unit": "%"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 216.13727866666667,
                        "unit": "%"
                    }
                },
                "digest": [
                    {
                        "label": "Fat",
                        "tag": "FAT",
                        "schemaOrgTag": "fatContent",
                        "total": 220.80721878756248,
                        "hasRDI": true,
                        "daily": 339.7034135193269,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Saturated",
                                "tag": "FASAT",
                                "schemaOrgTag": "saturatedFatContent",
                                "total": 60.563946027243745,
                                "hasRDI": true,
                                "daily": 302.8197301362187,
                                "unit": "g"
                            },
                            {
                                "label": "Trans",
                                "tag": "FATRN",
                                "schemaOrgTag": "transFatContent",
                                "total": 8.5906020486,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Monounsaturated",
                                "tag": "FAMS",
                                "schemaOrgTag": null,
                                "total": 41.25698031881251,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Polyunsaturated",
                                "tag": "FAPU",
                                "schemaOrgTag": null,
                                "total": 43.68898109349376,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Carbs",
                        "tag": "CHOCDF",
                        "schemaOrgTag": "carbohydrateContent",
                        "total": 570.6054611306249,
                        "hasRDI": true,
                        "daily": 190.20182037687496,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Carbs (net)",
                                "tag": "CHOCDF.net",
                                "schemaOrgTag": null,
                                "total": 532.5444337234375,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Fiber",
                                "tag": "FIBTG",
                                "schemaOrgTag": "fiberContent",
                                "total": 38.061027407187495,
                                "hasRDI": true,
                                "daily": 152.24410962874998,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars",
                                "tag": "SUGAR",
                                "schemaOrgTag": "sugarContent",
                                "total": 61.978834219999996,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars, added",
                                "tag": "SUGAR.added",
                                "schemaOrgTag": null,
                                "total": 0,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Protein",
                        "tag": "PROCNT",
                        "schemaOrgTag": "proteinContent",
                        "total": 202.61309320634376,
                        "hasRDI": true,
                        "daily": 405.2261864126875,
                        "unit": "g"
                    },
                    {
                        "label": "Cholesterol",
                        "tag": "CHOLE",
                        "schemaOrgTag": "cholesterolContent",
                        "total": 350.9670962875,
                        "hasRDI": true,
                        "daily": 116.98903209583334,
                        "unit": "mg"
                    },
                    {
                        "label": "Sodium",
                        "tag": "NA",
                        "schemaOrgTag": "sodiumContent",
                        "total": 17962.054160690626,
                        "hasRDI": true,
                        "daily": 748.4189233621095,
                        "unit": "mg"
                    },
                    {
                        "label": "Calcium",
                        "tag": "CA",
                        "schemaOrgTag": null,
                        "total": 729.90161895625,
                        "hasRDI": true,
                        "daily": 72.99016189562501,
                        "unit": "mg"
                    },
                    {
                        "label": "Magnesium",
                        "tag": "MG",
                        "schemaOrgTag": null,
                        "total": 285.483442871875,
                        "hasRDI": true,
                        "daily": 67.97224830282738,
                        "unit": "mg"
                    },
                    {
                        "label": "Potassium",
                        "tag": "K",
                        "schemaOrgTag": null,
                        "total": 4819.7451191375,
                        "hasRDI": true,
                        "daily": 102.54776849228725,
                        "unit": "mg"
                    },
                    {
                        "label": "Iron",
                        "tag": "FE",
                        "schemaOrgTag": null,
                        "total": 31.237818319468747,
                        "hasRDI": true,
                        "daily": 173.5434351081597,
                        "unit": "mg"
                    },
                    {
                        "label": "Zinc",
                        "tag": "ZN",
                        "schemaOrgTag": null,
                        "total": 7.5367520831875,
                        "hasRDI": true,
                        "daily": 68.51592802897727,
                        "unit": "mg"
                    },
                    {
                        "label": "Phosphorus",
                        "tag": "P",
                        "schemaOrgTag": null,
                        "total": 2210.813937178125,
                        "hasRDI": true,
                        "daily": 315.83056245401787,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin A",
                        "tag": "VITA_RAE",
                        "schemaOrgTag": null,
                        "total": 1673.978037265625,
                        "hasRDI": true,
                        "daily": 185.99755969618056,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin C",
                        "tag": "VITC",
                        "schemaOrgTag": null,
                        "total": 32.0937888521875,
                        "hasRDI": true,
                        "daily": 35.659765391319446,
                        "unit": "mg"
                    },
                    {
                        "label": "Thiamin (B1)",
                        "tag": "THIA",
                        "schemaOrgTag": null,
                        "total": 1.0055351801625,
                        "hasRDI": true,
                        "daily": 83.794598346875,
                        "unit": "mg"
                    },
                    {
                        "label": "Riboflavin (B2)",
                        "tag": "RIBF",
                        "schemaOrgTag": null,
                        "total": 1.7952842002468752,
                        "hasRDI": true,
                        "daily": 138.098784634375,
                        "unit": "mg"
                    },
                    {
                        "label": "Niacin (B3)",
                        "tag": "NIA",
                        "schemaOrgTag": null,
                        "total": 60.90967061490001,
                        "hasRDI": true,
                        "daily": 380.68544134312504,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin B6",
                        "tag": "VITB6A",
                        "schemaOrgTag": null,
                        "total": 3.586940776603125,
                        "hasRDI": true,
                        "daily": 275.91852127716345,
                        "unit": "mg"
                    },
                    {
                        "label": "Folate equivalent (total)",
                        "tag": "FOLDFE",
                        "schemaOrgTag": null,
                        "total": 436.431015121875,
                        "hasRDI": true,
                        "daily": 109.10775378046876,
                        "unit": "µg"
                    },
                    {
                        "label": "Folate (food)",
                        "tag": "FOLFD",
                        "schemaOrgTag": null,
                        "total": 368.392159621875,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Folic acid",
                        "tag": "FOLAC",
                        "schemaOrgTag": null,
                        "total": 40.8233133,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin B12",
                        "tag": "VITB12",
                        "schemaOrgTag": null,
                        "total": 1.3324275868750002,
                        "hasRDI": true,
                        "daily": 55.517816119791675,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin D",
                        "tag": "VITD",
                        "schemaOrgTag": null,
                        "total": 1.3607771100000001,
                        "hasRDI": true,
                        "daily": 9.071847400000001,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin E",
                        "tag": "TOCPHA",
                        "schemaOrgTag": null,
                        "total": 23.311397193500003,
                        "hasRDI": true,
                        "daily": 155.40931462333336,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin K",
                        "tag": "VITK1",
                        "schemaOrgTag": null,
                        "total": 259.36473440000003,
                        "hasRDI": true,
                        "daily": 216.13727866666667,
                        "unit": "µg"
                    },
                    {
                        "label": "Sugar alcohols",
                        "tag": "Sugar.alcohol",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    },
                    {
                        "label": "Water",
                        "tag": "WATER",
                        "schemaOrgTag": null,
                        "total": 1963.2513559533127,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    }
                ]
            },
            "_links": {
                "self": {
                    "href": "https://api.edamam.com/api/recipes/v2/8868b222a71cadfa850a188c6b9d2123?type=public&app_id=ea1d37d5&app_key=fd382a172ba8d6668c0430dc9c14a181",
                    "title": "Self"
                }
            }
        },
        {
            "recipe": {
                "uri": "http://www.edamam.com/ontologies/edamam.owl#recipe_b8af944c52674f962ad4b9743b99423a",
                "label": "Ultimate Roast Chicken",
                "image": "https://www.edamam.com/web-img/f61/f61dcb579d45dcf7624346abd71eac1b.jpg",
                "source": "My Recipes",
                "url": "http://www.myrecipes.com/recipe/ultimate-roast-chicken",
                "shareAs": "http://www.edamam.com/recipe/ultimate-roast-chicken-b8af944c52674f962ad4b9743b99423a/chicken",
                "yield": 6,
                "dietLabels": [
                    "Low-Carb"
                ],
                "healthLabels": [
                    "Sugar-Conscious",
                    "Keto-Friendly",
                    "Paleo",
                    "Mediterranean",
                    "Dairy-Free",
                    "Gluten-Free",
                    "Wheat-Free",
                    "Egg-Free",
                    "Peanut-Free",
                    "Tree-Nut-Free",
                    "Soy-Free",
                    "Fish-Free",
                    "Shellfish-Free",
                    "Pork-Free",
                    "Red-Meat-Free",
                    "Crustacean-Free",
                    "Celery-Free",
                    "Mustard-Free",
                    "Sesame-Free",
                    "Lupine-Free",
                    "Mollusk-Free",
                    "Alcohol-Free",
                    "Sulfite-Free",
                    "FODMAP-Free",
                    "Kosher",
                    "Immuno-Supportive"
                ],
                "cautions": [],
                "ingredientLines": [
                    "1 chicken, 3* to 4 1/2 lbs., lumps of fat and tail removed, rinsed and patted very dry",
                    "Fine sea salt (1 1/2 tsp. for a 3- to 3 3/4-lb. chicken or 2 tsp. for a 4- to 4 1/2-lb. chicken)",
                    "Pepper (3/4 tsp. for a smaller chicken or 1 tsp. for a larger one)",
                    "French Herb Seasoning Rub or",
                    "Mediterranean Coriander Seasoning Rub (optional)",
                    "About 1 tbsp. olive oil (for plain or French Herb chicken)"
                ],
                "ingredients": [
                    {
                        "text": "1 chicken, 3* to 4 1/2 lbs., lumps of fat and tail removed, rinsed and patted very dry",
                        "weight": 1360.77711,
                        "foodCategory": "Poultry",
                        "foodId": "food_bmyxrshbfao9s1amjrvhoauob6mo",
                        "image": "https://www.edamam.com/food-img/d33/d338229d774a743f7858f6764e095878.jpg"
                    },
                    {
                        "text": "Fine sea salt (1 1/2 tsp. for a 3- to 3 3/4-lb. chicken or 2 tsp. for a 4- to 4 1/2-lb. chicken)",
                        "weight": 3,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_btxz81db72hwbra2pncvebzzzum9",
                        "image": "https://www.edamam.com/food-img/694/6943ea510918c6025795e8dc6e6eaaeb.jpg"
                    },
                    {
                        "text": "Pepper (3/4 tsp. for a smaller chicken or 1 tsp. for a larger one)",
                        "weight": 11.6,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_b6ywzluaaxv02wad7s1r9ag4py89",
                        "image": "https://www.edamam.com/food-img/c6e/c6e5c3bd8d3bc15175d9766971a4d1b2.jpg"
                    },
                    {
                        "text": "French Herb Seasoning Rub or",
                        "weight": 13.8887711,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_avsq22zadwyb5cb5sl1byaa4mbo8",
                        "image": "https://www.edamam.com/food-img/89b/89b37a04e46e052671d73addcb84aa51.jpg"
                    },
                    {
                        "text": "Mediterranean Coriander Seasoning Rub (optional)",
                        "weight": 6.94438555,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_afpcy6rb44nx6gbfff63ga2cqksw",
                        "image": "https://www.edamam.com/food-img/a90/a901cee0b9028841d258f5d07b5924e7.jpg"
                    },
                    {
                        "text": "About 1 tbsp. olive oil (for plain or French Herb chicken)",
                        "weight": 13.5,
                        "foodCategory": "Oils",
                        "foodId": "food_b1d1icuad3iktrbqby0hiagafaz7",
                        "image": "https://www.edamam.com/food-img/4d6/4d651eaa8a353647746290c7a9b29d84.jpg"
                    }
                ],
                "calories": 2196.939411995,
                "totalWeight": 1409.71026665,
                "totalTime": 0,
                "cuisineType": [
                    "french"
                ],
                "mealType": [
                    "lunch/dinner"
                ],
                "dishType": [
                    "main course"
                ],
                "totalNutrients": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 2196.939411995,
                        "unit": "kcal"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 155.49857528584502,
                        "unit": "g"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 42.355120407855004,
                        "unit": "g"
                    },
                    "FATRN": {
                        "label": "Trans",
                        "quantity": 0.897568581756,
                        "unit": "g"
                    },
                    "FAMS": {
                        "label": "Monounsaturated",
                        "quantity": 68.68427811338,
                        "unit": "g"
                    },
                    "FAPU": {
                        "label": "Polyunsaturated",
                        "quantity": 31.711284567254992,
                        "unit": "g"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 20.117397855285,
                        "unit": "g"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 10.983342852449999,
                        "unit": "g"
                    },
                    "SUGAR": {
                        "label": "Sugars",
                        "quantity": 0.31173798581,
                        "unit": "g"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 175.44061641254498,
                        "unit": "g"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 693.9963260999999,
                        "unit": "mg"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 1823.1292634074996,
                        "unit": "mg"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 465.7625951675,
                        "unit": "mg"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 258.403455695,
                        "unit": "mg"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 2104.4497034445003,
                        "unit": "mg"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 27.83966071456,
                        "unit": "mg"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 13.447554670709998,
                        "unit": "mg"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 1434.8797659665,
                        "unit": "mg"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 408.905323358,
                        "unit": "µg"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 23.2079614723,
                        "unit": "mg"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 0.6555715380875,
                        "unit": "mg"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 1.206829036544,
                        "unit": "mg"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 63.898195555303,
                        "unit": "mg"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 3.3487937628499997,
                        "unit": "mg"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 95.546938902,
                        "unit": "µg"
                    },
                    "FOLFD": {
                        "label": "Folate (food)",
                        "quantity": 95.546938902,
                        "unit": "µg"
                    },
                    "FOLAC": {
                        "label": "Folic acid",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 2.8685181478799997,
                        "unit": "µg"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 1.8506568695999999,
                        "unit": "µg"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 5.872755382679999,
                        "unit": "mg"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 279.1191070315,
                        "unit": "µg"
                    },
                    "WATER": {
                        "label": "Water",
                        "quantity": 613.77280195294,
                        "unit": "g"
                    }
                },
                "totalDaily": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 109.84697059974998,
                        "unit": "%"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 239.22857736283848,
                        "unit": "%"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 211.77560203927501,
                        "unit": "%"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 6.705799285095,
                        "unit": "%"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 43.933371409799996,
                        "unit": "%"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 350.88123282508997,
                        "unit": "%"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 231.33210869999996,
                        "unit": "%"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 75.9637193086458,
                        "unit": "%"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 46.57625951675001,
                        "unit": "%"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 61.52463230833333,
                        "unit": "%"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 44.775525605202134,
                        "unit": "%"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 154.66478174755557,
                        "unit": "%"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 122.25049700645454,
                        "unit": "%"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 204.9828237095,
                        "unit": "%"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 45.43392481755555,
                        "unit": "%"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 25.78662385811111,
                        "unit": "%"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 54.63096150729167,
                        "unit": "%"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 92.83300281107691,
                        "unit": "%"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 399.36372222064375,
                        "unit": "%"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 257.5995202192307,
                        "unit": "%"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 23.886734725500002,
                        "unit": "%"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 119.52158949499999,
                        "unit": "%"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 12.337712463999999,
                        "unit": "%"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 39.151702551199996,
                        "unit": "%"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 232.59925585958334,
                        "unit": "%"
                    }
                },
                "digest": [
                    {
                        "label": "Fat",
                        "tag": "FAT",
                        "schemaOrgTag": "fatContent",
                        "total": 155.49857528584502,
                        "hasRDI": true,
                        "daily": 239.22857736283848,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Saturated",
                                "tag": "FASAT",
                                "schemaOrgTag": "saturatedFatContent",
                                "total": 42.355120407855004,
                                "hasRDI": true,
                                "daily": 211.77560203927501,
                                "unit": "g"
                            },
                            {
                                "label": "Trans",
                                "tag": "FATRN",
                                "schemaOrgTag": "transFatContent",
                                "total": 0.897568581756,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Monounsaturated",
                                "tag": "FAMS",
                                "schemaOrgTag": null,
                                "total": 68.68427811338,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Polyunsaturated",
                                "tag": "FAPU",
                                "schemaOrgTag": null,
                                "total": 31.711284567254992,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Carbs",
                        "tag": "CHOCDF",
                        "schemaOrgTag": "carbohydrateContent",
                        "total": 20.117397855285,
                        "hasRDI": true,
                        "daily": 6.705799285095,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Carbs (net)",
                                "tag": "CHOCDF.net",
                                "schemaOrgTag": null,
                                "total": 9.134055002835,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Fiber",
                                "tag": "FIBTG",
                                "schemaOrgTag": "fiberContent",
                                "total": 10.983342852449999,
                                "hasRDI": true,
                                "daily": 43.933371409799996,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars",
                                "tag": "SUGAR",
                                "schemaOrgTag": "sugarContent",
                                "total": 0.31173798581,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars, added",
                                "tag": "SUGAR.added",
                                "schemaOrgTag": null,
                                "total": 0,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Protein",
                        "tag": "PROCNT",
                        "schemaOrgTag": "proteinContent",
                        "total": 175.44061641254498,
                        "hasRDI": true,
                        "daily": 350.88123282508997,
                        "unit": "g"
                    },
                    {
                        "label": "Cholesterol",
                        "tag": "CHOLE",
                        "schemaOrgTag": "cholesterolContent",
                        "total": 693.9963260999999,
                        "hasRDI": true,
                        "daily": 231.33210869999996,
                        "unit": "mg"
                    },
                    {
                        "label": "Sodium",
                        "tag": "NA",
                        "schemaOrgTag": "sodiumContent",
                        "total": 1823.1292634074996,
                        "hasRDI": true,
                        "daily": 75.9637193086458,
                        "unit": "mg"
                    },
                    {
                        "label": "Calcium",
                        "tag": "CA",
                        "schemaOrgTag": null,
                        "total": 465.7625951675,
                        "hasRDI": true,
                        "daily": 46.57625951675001,
                        "unit": "mg"
                    },
                    {
                        "label": "Magnesium",
                        "tag": "MG",
                        "schemaOrgTag": null,
                        "total": 258.403455695,
                        "hasRDI": true,
                        "daily": 61.52463230833333,
                        "unit": "mg"
                    },
                    {
                        "label": "Potassium",
                        "tag": "K",
                        "schemaOrgTag": null,
                        "total": 2104.4497034445003,
                        "hasRDI": true,
                        "daily": 44.775525605202134,
                        "unit": "mg"
                    },
                    {
                        "label": "Iron",
                        "tag": "FE",
                        "schemaOrgTag": null,
                        "total": 27.83966071456,
                        "hasRDI": true,
                        "daily": 154.66478174755557,
                        "unit": "mg"
                    },
                    {
                        "label": "Zinc",
                        "tag": "ZN",
                        "schemaOrgTag": null,
                        "total": 13.447554670709998,
                        "hasRDI": true,
                        "daily": 122.25049700645454,
                        "unit": "mg"
                    },
                    {
                        "label": "Phosphorus",
                        "tag": "P",
                        "schemaOrgTag": null,
                        "total": 1434.8797659665,
                        "hasRDI": true,
                        "daily": 204.9828237095,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin A",
                        "tag": "VITA_RAE",
                        "schemaOrgTag": null,
                        "total": 408.905323358,
                        "hasRDI": true,
                        "daily": 45.43392481755555,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin C",
                        "tag": "VITC",
                        "schemaOrgTag": null,
                        "total": 23.2079614723,
                        "hasRDI": true,
                        "daily": 25.78662385811111,
                        "unit": "mg"
                    },
                    {
                        "label": "Thiamin (B1)",
                        "tag": "THIA",
                        "schemaOrgTag": null,
                        "total": 0.6555715380875,
                        "hasRDI": true,
                        "daily": 54.63096150729167,
                        "unit": "mg"
                    },
                    {
                        "label": "Riboflavin (B2)",
                        "tag": "RIBF",
                        "schemaOrgTag": null,
                        "total": 1.206829036544,
                        "hasRDI": true,
                        "daily": 92.83300281107691,
                        "unit": "mg"
                    },
                    {
                        "label": "Niacin (B3)",
                        "tag": "NIA",
                        "schemaOrgTag": null,
                        "total": 63.898195555303,
                        "hasRDI": true,
                        "daily": 399.36372222064375,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin B6",
                        "tag": "VITB6A",
                        "schemaOrgTag": null,
                        "total": 3.3487937628499997,
                        "hasRDI": true,
                        "daily": 257.5995202192307,
                        "unit": "mg"
                    },
                    {
                        "label": "Folate equivalent (total)",
                        "tag": "FOLDFE",
                        "schemaOrgTag": null,
                        "total": 95.546938902,
                        "hasRDI": true,
                        "daily": 23.886734725500002,
                        "unit": "µg"
                    },
                    {
                        "label": "Folate (food)",
                        "tag": "FOLFD",
                        "schemaOrgTag": null,
                        "total": 95.546938902,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Folic acid",
                        "tag": "FOLAC",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin B12",
                        "tag": "VITB12",
                        "schemaOrgTag": null,
                        "total": 2.8685181478799997,
                        "hasRDI": true,
                        "daily": 119.52158949499999,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin D",
                        "tag": "VITD",
                        "schemaOrgTag": null,
                        "total": 1.8506568695999999,
                        "hasRDI": true,
                        "daily": 12.337712463999999,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin E",
                        "tag": "TOCPHA",
                        "schemaOrgTag": null,
                        "total": 5.872755382679999,
                        "hasRDI": true,
                        "daily": 39.151702551199996,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin K",
                        "tag": "VITK1",
                        "schemaOrgTag": null,
                        "total": 279.1191070315,
                        "hasRDI": true,
                        "daily": 232.59925585958334,
                        "unit": "µg"
                    },
                    {
                        "label": "Sugar alcohols",
                        "tag": "Sugar.alcohol",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    },
                    {
                        "label": "Water",
                        "tag": "WATER",
                        "schemaOrgTag": null,
                        "total": 613.77280195294,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    }
                ]
            },
            "_links": {
                "self": {
                    "href": "https://api.edamam.com/api/recipes/v2/b8af944c52674f962ad4b9743b99423a?type=public&app_id=ea1d37d5&app_key=fd382a172ba8d6668c0430dc9c14a181",
                    "title": "Self"
                }
            }
        },
        {
            "recipe": {
                "uri": "http://www.edamam.com/ontologies/edamam.owl#recipe_10abfbc20e802c832453500bcc50e1bd",
                "label": "Chicken Piccata",
                "image": "https://www.edamam.com/web-img/ce0/ce0601eba5b5a77a2dcb359a0051c68c.jpg",
                "source": "No Recipes",
                "url": "http://norecipes.com/blog/chicken-piccata-recipe/",
                "shareAs": "http://www.edamam.com/recipe/chicken-piccata-10abfbc20e802c832453500bcc50e1bd/chicken",
                "yield": 2,
                "dietLabels": [
                    "Low-Carb"
                ],
                "healthLabels": [
                    "Egg-Free",
                    "Peanut-Free",
                    "Tree-Nut-Free",
                    "Soy-Free",
                    "Fish-Free",
                    "Shellfish-Free",
                    "Pork-Free",
                    "Red-Meat-Free",
                    "Crustacean-Free",
                    "Celery-Free",
                    "Mustard-Free",
                    "Sesame-Free",
                    "Lupine-Free",
                    "Mollusk-Free",
                    "Alcohol-Free"
                ],
                "cautions": [
                    "Sulfites"
                ],
                "ingredientLines": [
                    "2 large chicken breasts",
                    "1/2 cup flour",
                    "3 tablespoons vegetable oil",
                    "2 scallions white part only, minced",
                    "3 tablespoons lemon juice",
                    "1 cup chicken stock",
                    "1 teaspoon honey",
                    "2 tablespoons unsalted butter cut into small pieces",
                    "2 tablespoons parsley minced",
                    "2 tablespoons capers",
                    "1 teaspoon lemon zest finely zested"
                ],
                "ingredients": [
                    {
                        "text": "2 large chicken breasts",
                        "weight": 435,
                        "foodCategory": "Poultry",
                        "foodId": "food_a9hdg97b1sqqs5aj1al75bbo5iyt",
                        "image": "https://www.edamam.com/food-img/093/093749f4c93e448119fc81976d2c3067.jpg"
                    },
                    {
                        "text": "1/2 cup flour",
                        "weight": 62.5,
                        "foodCategory": "grains",
                        "foodId": "food_ahebfs0a985an4aubqaebbipra58",
                        "image": "https://www.edamam.com/food-img/b4c/b4c739e76a6f2172b7ad49d0aa41d5aa.jpg"
                    },
                    {
                        "text": "3 tablespoons vegetable oil",
                        "weight": 42,
                        "foodCategory": "Oils",
                        "foodId": "food_bt1mzi2ah2sfg8bv7no1qai83w8s",
                        "image": "https://www.edamam.com/food-img/6e5/6e51a63a6300a8ea1b4c4cc68dfaba33.jpg"
                    },
                    {
                        "text": "2 scallions white part only, minced",
                        "weight": 30,
                        "foodCategory": "vegetables",
                        "foodId": "food_bknlkyzbuzo27pb11whr4bttkuy6",
                        "image": "https://www.edamam.com/food-img/b89/b89986ed6aa466285bdd99bac34b3c46.jpg"
                    },
                    {
                        "text": "3 tablespoons lemon juice",
                        "weight": 45.7499999992266,
                        "foodCategory": "100% juice",
                        "foodId": "food_bglm6vxahuauteb0n6ynfbg9eryu",
                        "image": "https://www.edamam.com/food-img/e31/e310952d214e78a4cb8b73f30ceeaaf2.jpg"
                    },
                    {
                        "text": "1 cup chicken stock",
                        "weight": 240,
                        "foodCategory": "canned soup",
                        "foodId": "food_bptblvzambd16nbhewqmhaw1rnh5",
                        "image": "https://www.edamam.com/food-img/26a/26a10c4cb4e07bab54d8a687ef5ac7d8.jpg"
                    },
                    {
                        "text": "1 teaspoon honey",
                        "weight": 7.0625000003582175,
                        "foodCategory": null,
                        "foodId": "food_bn6aoj9atkqx8fbkli859bbbxx62",
                        "image": "https://www.edamam.com/food-img/198/198c7b25c23b4235b4cc33818c7b335f.jpg"
                    },
                    {
                        "text": "2 tablespoons unsalted butter cut into small pieces",
                        "weight": 28.4,
                        "foodCategory": "Dairy",
                        "foodId": "food_awz3iefajbk1fwahq9logahmgltj",
                        "image": "https://www.edamam.com/food-img/713/71397239b670d88c04faa8d05035cab4.jpg"
                    },
                    {
                        "text": "2 tablespoons parsley minced",
                        "weight": 7.6,
                        "foodCategory": "vegetables",
                        "foodId": "food_b244pqdazw24zobr5vqu2bf0uid8",
                        "image": "https://www.edamam.com/food-img/46a/46a132e96626d7989b4d6ed8c91f4da0.jpg"
                    },
                    {
                        "text": "2 tablespoons capers",
                        "weight": 17.2,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_ak4s9lna3rmnfeaz93ni0blu823w",
                        "image": "https://www.edamam.com/food-img/627/627582f390a350d98c367f89c3a943fe.jpg"
                    },
                    {
                        "text": "1 teaspoon lemon zest finely zested",
                        "weight": 2,
                        "foodCategory": "fruit",
                        "foodId": "food_bpg66j3a5vjuuga36uiiyaqeazpd",
                        "image": "https://www.edamam.com/food-img/540/5405605c8e9b284243f06c0b1587ab6f.jpg"
                    }
                ],
                "calories": 1685.7750000009187,
                "totalWeight": 917.5124999995849,
                "totalTime": 0,
                "cuisineType": [
                    "italian"
                ],
                "mealType": [
                    "lunch/dinner"
                ],
                "dishType": [
                    "condiments and sauces"
                ],
                "totalNutrients": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 1685.7750000009187,
                        "unit": "kcal"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 109.14599999999814,
                        "unit": "g"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 29.840194999999692,
                        "unit": "g"
                    },
                    "FATRN": {
                        "label": "Trans",
                        "quantity": 1.709842,
                        "unit": "g"
                    },
                    "FAMS": {
                        "label": "Monounsaturated",
                        "quantity": 54.318679999999944,
                        "unit": "g"
                    },
                    "FAPU": {
                        "label": "Polyunsaturated",
                        "quantity": 17.43599649999984,
                        "unit": "g"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 69.0032000002418,
                        "unit": "g"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 3.632074999998397,
                        "unit": "g"
                    },
                    "SUGAR": {
                        "label": "Sugars",
                        "quantity": 11.847935000274678,
                        "unit": "g"
                    },
                    "SUGAR.added": {
                        "label": "Sugars, added",
                        "quantity": 5.799725000294168,
                        "unit": "g"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 104.83510249999838,
                        "unit": "g"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 346.66,
                        "unit": "mg"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 1035.3960000000066,
                        "unit": "mg"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 116.0577499999751,
                        "unit": "mg"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 151.33024999996078,
                        "unit": "mg"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 1468.4699999993902,
                        "unit": "mg"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 5.744632500000884,
                        "unit": "mg"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 4.575832500000402,
                        "unit": "mg"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 917.4264999999526,
                        "unit": "mg"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 349.316,
                        "unit": "µg"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 37.28816249970249,
                        "unit": "mg"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 0.47278199999981435,
                        "unit": "mg"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 0.6749082500000203,
                        "unit": "mg"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 48.12218812499973,
                        "unit": "mg"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 2.53552799999973,
                        "unit": "mg"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 90.76124999985251,
                        "unit": "µg"
                    },
                    "FOLFD": {
                        "label": "Folate (food)",
                        "quantity": 90.76124999985251,
                        "unit": "µg"
                    },
                    "FOLAC": {
                        "label": "Folic acid",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 1.5272800000000004,
                        "unit": "µg"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 2.1660000000000004,
                        "unit": "µg"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 11.54586499999884,
                        "unit": "mg"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 193.6267,
                        "unit": "µg"
                    },
                    "WATER": {
                        "label": "Water",
                        "quantity": 628.9646324993473,
                        "unit": "g"
                    }
                },
                "totalDaily": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 84.28875000004594,
                        "unit": "%"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 167.9169230769202,
                        "unit": "%"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 149.20097499999846,
                        "unit": "%"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 23.001066666747267,
                        "unit": "%"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 14.528299999993587,
                        "unit": "%"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 209.6702049999968,
                        "unit": "%"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 115.55333333333333,
                        "unit": "%"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 43.14150000000028,
                        "unit": "%"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 11.605774999997509,
                        "unit": "%"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 36.03101190475257,
                        "unit": "%"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 31.244042553178517,
                        "unit": "%"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 31.914625000004914,
                        "unit": "%"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 41.598477272730925,
                        "unit": "%"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 131.0609285714218,
                        "unit": "%"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 38.812888888888885,
                        "unit": "%"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 41.4312916663361,
                        "unit": "%"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 39.39849999998453,
                        "unit": "%"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 51.91601923077079,
                        "unit": "%"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 300.7636757812483,
                        "unit": "%"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 195.04061538459462,
                        "unit": "%"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 22.690312499963127,
                        "unit": "%"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 63.636666666666684,
                        "unit": "%"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 14.440000000000001,
                        "unit": "%"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 76.9724333333256,
                        "unit": "%"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 161.35558333333333,
                        "unit": "%"
                    }
                },
                "digest": [
                    {
                        "label": "Fat",
                        "tag": "FAT",
                        "schemaOrgTag": "fatContent",
                        "total": 109.14599999999814,
                        "hasRDI": true,
                        "daily": 167.9169230769202,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Saturated",
                                "tag": "FASAT",
                                "schemaOrgTag": "saturatedFatContent",
                                "total": 29.840194999999692,
                                "hasRDI": true,
                                "daily": 149.20097499999846,
                                "unit": "g"
                            },
                            {
                                "label": "Trans",
                                "tag": "FATRN",
                                "schemaOrgTag": "transFatContent",
                                "total": 1.709842,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Monounsaturated",
                                "tag": "FAMS",
                                "schemaOrgTag": null,
                                "total": 54.318679999999944,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Polyunsaturated",
                                "tag": "FAPU",
                                "schemaOrgTag": null,
                                "total": 17.43599649999984,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Carbs",
                        "tag": "CHOCDF",
                        "schemaOrgTag": "carbohydrateContent",
                        "total": 69.0032000002418,
                        "hasRDI": true,
                        "daily": 23.001066666747267,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Carbs (net)",
                                "tag": "CHOCDF.net",
                                "schemaOrgTag": null,
                                "total": 65.37112500024341,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Fiber",
                                "tag": "FIBTG",
                                "schemaOrgTag": "fiberContent",
                                "total": 3.632074999998397,
                                "hasRDI": true,
                                "daily": 14.528299999993587,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars",
                                "tag": "SUGAR",
                                "schemaOrgTag": "sugarContent",
                                "total": 11.847935000274678,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars, added",
                                "tag": "SUGAR.added",
                                "schemaOrgTag": null,
                                "total": 5.799725000294168,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Protein",
                        "tag": "PROCNT",
                        "schemaOrgTag": "proteinContent",
                        "total": 104.83510249999838,
                        "hasRDI": true,
                        "daily": 209.6702049999968,
                        "unit": "g"
                    },
                    {
                        "label": "Cholesterol",
                        "tag": "CHOLE",
                        "schemaOrgTag": "cholesterolContent",
                        "total": 346.66,
                        "hasRDI": true,
                        "daily": 115.55333333333333,
                        "unit": "mg"
                    },
                    {
                        "label": "Sodium",
                        "tag": "NA",
                        "schemaOrgTag": "sodiumContent",
                        "total": 1035.3960000000066,
                        "hasRDI": true,
                        "daily": 43.14150000000028,
                        "unit": "mg"
                    },
                    {
                        "label": "Calcium",
                        "tag": "CA",
                        "schemaOrgTag": null,
                        "total": 116.0577499999751,
                        "hasRDI": true,
                        "daily": 11.605774999997509,
                        "unit": "mg"
                    },
                    {
                        "label": "Magnesium",
                        "tag": "MG",
                        "schemaOrgTag": null,
                        "total": 151.33024999996078,
                        "hasRDI": true,
                        "daily": 36.03101190475257,
                        "unit": "mg"
                    },
                    {
                        "label": "Potassium",
                        "tag": "K",
                        "schemaOrgTag": null,
                        "total": 1468.4699999993902,
                        "hasRDI": true,
                        "daily": 31.244042553178517,
                        "unit": "mg"
                    },
                    {
                        "label": "Iron",
                        "tag": "FE",
                        "schemaOrgTag": null,
                        "total": 5.744632500000884,
                        "hasRDI": true,
                        "daily": 31.914625000004914,
                        "unit": "mg"
                    },
                    {
                        "label": "Zinc",
                        "tag": "ZN",
                        "schemaOrgTag": null,
                        "total": 4.575832500000402,
                        "hasRDI": true,
                        "daily": 41.598477272730925,
                        "unit": "mg"
                    },
                    {
                        "label": "Phosphorus",
                        "tag": "P",
                        "schemaOrgTag": null,
                        "total": 917.4264999999526,
                        "hasRDI": true,
                        "daily": 131.0609285714218,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin A",
                        "tag": "VITA_RAE",
                        "schemaOrgTag": null,
                        "total": 349.316,
                        "hasRDI": true,
                        "daily": 38.812888888888885,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin C",
                        "tag": "VITC",
                        "schemaOrgTag": null,
                        "total": 37.28816249970249,
                        "hasRDI": true,
                        "daily": 41.4312916663361,
                        "unit": "mg"
                    },
                    {
                        "label": "Thiamin (B1)",
                        "tag": "THIA",
                        "schemaOrgTag": null,
                        "total": 0.47278199999981435,
                        "hasRDI": true,
                        "daily": 39.39849999998453,
                        "unit": "mg"
                    },
                    {
                        "label": "Riboflavin (B2)",
                        "tag": "RIBF",
                        "schemaOrgTag": null,
                        "total": 0.6749082500000203,
                        "hasRDI": true,
                        "daily": 51.91601923077079,
                        "unit": "mg"
                    },
                    {
                        "label": "Niacin (B3)",
                        "tag": "NIA",
                        "schemaOrgTag": null,
                        "total": 48.12218812499973,
                        "hasRDI": true,
                        "daily": 300.7636757812483,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin B6",
                        "tag": "VITB6A",
                        "schemaOrgTag": null,
                        "total": 2.53552799999973,
                        "hasRDI": true,
                        "daily": 195.04061538459462,
                        "unit": "mg"
                    },
                    {
                        "label": "Folate equivalent (total)",
                        "tag": "FOLDFE",
                        "schemaOrgTag": null,
                        "total": 90.76124999985251,
                        "hasRDI": true,
                        "daily": 22.690312499963127,
                        "unit": "µg"
                    },
                    {
                        "label": "Folate (food)",
                        "tag": "FOLFD",
                        "schemaOrgTag": null,
                        "total": 90.76124999985251,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Folic acid",
                        "tag": "FOLAC",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin B12",
                        "tag": "VITB12",
                        "schemaOrgTag": null,
                        "total": 1.5272800000000004,
                        "hasRDI": true,
                        "daily": 63.636666666666684,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin D",
                        "tag": "VITD",
                        "schemaOrgTag": null,
                        "total": 2.1660000000000004,
                        "hasRDI": true,
                        "daily": 14.440000000000001,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin E",
                        "tag": "TOCPHA",
                        "schemaOrgTag": null,
                        "total": 11.54586499999884,
                        "hasRDI": true,
                        "daily": 76.9724333333256,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin K",
                        "tag": "VITK1",
                        "schemaOrgTag": null,
                        "total": 193.6267,
                        "hasRDI": true,
                        "daily": 161.35558333333333,
                        "unit": "µg"
                    },
                    {
                        "label": "Sugar alcohols",
                        "tag": "Sugar.alcohol",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    },
                    {
                        "label": "Water",
                        "tag": "WATER",
                        "schemaOrgTag": null,
                        "total": 628.9646324993473,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    }
                ]
            },
            "_links": {
                "self": {
                    "href": "https://api.edamam.com/api/recipes/v2/10abfbc20e802c832453500bcc50e1bd?type=public&app_id=ea1d37d5&app_key=fd382a172ba8d6668c0430dc9c14a181",
                    "title": "Self"
                }
            }
        }
    ]
};

export const beefRecipes = {
    "from": 1,
    "to": 20,
    "count": 10000,
    "_links": {
        "next": {
            "href": "https://api.edamam.com/api/recipes/v2?q=beef&app_key=fd382a172ba8d6668c0430dc9c14a181&_cont=CHcVQBtNNQphDmgVQntAEX4BYlJtBgQEQGBHCmcWalZxAgIAUXlSVmpHZ1J1AwIAF2JBV2cWagZwAAEBFWQRCzEVMlF7VQEVLnlSVSBMPkd5BgMbUSYRVTdgMgksRlpSAAcRXTVGcV84SU4%3D&type=public&app_id=ea1d37d5",
            "title": "Next page"
        }
    },
    "hits": [
        {
            "recipe": {
                "uri": "http://www.edamam.com/ontologies/edamam.owl#recipe_7eb3edfc916ebf0e4b028c8e5c04b81a",
                "label": "Roast sirloin of beef",
                "image": "https://www.edamam.com/web-img/207/2074a28ff50eba58d79304c9296438a1.jpg",
                "source": "BBC Good Food",
                "url": "http://www.bbcgoodfood.com/recipes/2558/roast-sirloin-of-beef",
                "shareAs": "http://www.edamam.com/recipe/roast-sirloin-of-beef-7eb3edfc916ebf0e4b028c8e5c04b81a/beef",
                "yield": 6,
                "dietLabels": [
                    "High-Protein",
                    "Low-Carb"
                ],
                "healthLabels": [
                    "Sugar-Conscious",
                    "Keto-Friendly",
                    "Dairy-Free",
                    "Gluten-Free",
                    "Wheat-Free",
                    "Egg-Free",
                    "Peanut-Free",
                    "Tree-Nut-Free",
                    "Soy-Free",
                    "Fish-Free",
                    "Shellfish-Free",
                    "Pork-Free",
                    "Crustacean-Free",
                    "Celery-Free",
                    "Mustard-Free",
                    "Sesame-Free",
                    "Lupine-Free",
                    "Mollusk-Free",
                    "Kosher"
                ],
                "cautions": [
                    "Gluten",
                    "Wheat",
                    "Sulfites"
                ],
                "ingredientLines": [
                    "2 tbsp vegetable oil or beef fat",
                    "1-1½kg/2lb 4-3lb 5oz sirloin of beef joint",
                    "1 glass red wine",
                    "400g can beef consommé"
                ],
                "ingredients": [
                    {
                        "text": "2 tbsp vegetable oil or beef fat",
                        "weight": 28,
                        "foodCategory": "Oils",
                        "foodId": "food_bt1mzi2ah2sfg8bv7no1qai83w8s",
                        "image": "https://www.edamam.com/food-img/6e5/6e51a63a6300a8ea1b4c4cc68dfaba33.jpg"
                    },
                    {
                        "text": "1-1½kg/2lb 4-3lb 5oz sirloin of beef joint",
                        "weight": 1250,
                        "foodCategory": "meats",
                        "foodId": "food_bknby1la98smrsbwnthinbam42nj",
                        "image": "https://www.edamam.com/food-img/bab/bab88ab3ea40d34e4c8ae35d6b30344a.jpg"
                    },
                    {
                        "text": "1 glass red wine",
                        "weight": 235.2,
                        "foodCategory": "wines",
                        "foodId": "food_b5q0xv2ba8la5hbzdfzdgaca3fwu",
                        "image": "https://www.edamam.com/food-img/82b/82b8d0db2d5c38fc7498a657c0afc4ee.JPG"
                    },
                    {
                        "text": "400g can beef consommé",
                        "weight": 400,
                        "foodCategory": "canned soup",
                        "foodId": "food_arlagstbtxcrk4ablvuh9b36no9m",
                        "image": "https://www.edamam.com/food-img/6a5/6a5f7cf073a7e70af946bfb4d558a914.jpg"
                    }
                ],
                "calories": 2120.44,
                "totalWeight": 1913.2,
                "totalTime": 160,
                "cuisineType": [
                    "mediterranean"
                ],
                "mealType": [
                    "lunch/dinner"
                ],
                "dishType": [
                    "main course"
                ],
                "totalNutrients": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 2120.44,
                        "unit": "kcal"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 88.125,
                        "unit": "g"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 26.673080000000002,
                        "unit": "g"
                    },
                    "FATRN": {
                        "label": "Trans",
                        "quantity": 3.33976,
                        "unit": "g"
                    },
                    "FAMS": {
                        "label": "Monounsaturated",
                        "quantity": 51.53248,
                        "unit": "g"
                    },
                    "FAPU": {
                        "label": "Polyunsaturated",
                        "quantity": 8.66244,
                        "unit": "g"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 10.55872,
                        "unit": "g"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 0,
                        "unit": "g"
                    },
                    "SUGAR": {
                        "label": "Sugars",
                        "quantity": 1.45824,
                        "unit": "g"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 279.54464,
                        "unit": "g"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 787.5,
                        "unit": "mg"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 2052.908,
                        "unit": "mg"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 197.316,
                        "unit": "mg"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 290.724,
                        "unit": "mg"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 5217.204,
                        "unit": "mg"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 28.08692,
                        "unit": "mg"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 68.55427999999999,
                        "unit": "mg"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 2818.596,
                        "unit": "mg"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 25,
                        "unit": "µg"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 1.6,
                        "unit": "mg"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 1.04776,
                        "unit": "mg"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 2.245912,
                        "unit": "mg"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 62.79434799999999,
                        "unit": "mg"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 7.274064,
                        "unit": "mg"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 43.852,
                        "unit": "µg"
                    },
                    "FOLFD": {
                        "label": "Folate (food)",
                        "quantity": 43.852,
                        "unit": "µg"
                    },
                    "FOLAC": {
                        "label": "Folic acid",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 28.375,
                        "unit": "µg"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 1.25,
                        "unit": "µg"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 8.354000000000001,
                        "unit": "mg"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 19.6908,
                        "unit": "µg"
                    },
                    "WATER": {
                        "label": "Water",
                        "quantity": 1492.38448,
                        "unit": "g"
                    }
                },
                "totalDaily": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 106.022,
                        "unit": "%"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 135.57692307692307,
                        "unit": "%"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 133.36540000000002,
                        "unit": "%"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 3.5195733333333328,
                        "unit": "%"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 0,
                        "unit": "%"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 559.08928,
                        "unit": "%"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 262.5,
                        "unit": "%"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 85.53783333333332,
                        "unit": "%"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 19.7316,
                        "unit": "%"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 69.22,
                        "unit": "%"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 111.00434042553191,
                        "unit": "%"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 156.03844444444445,
                        "unit": "%"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 623.2207272727272,
                        "unit": "%"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 402.6565714285714,
                        "unit": "%"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 2.7777777777777777,
                        "unit": "%"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 1.7777777777777777,
                        "unit": "%"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 87.31333333333333,
                        "unit": "%"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 172.76246153846154,
                        "unit": "%"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 392.46467499999994,
                        "unit": "%"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 559.5433846153845,
                        "unit": "%"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 10.963,
                        "unit": "%"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 1182.2916666666667,
                        "unit": "%"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 8.333333333333334,
                        "unit": "%"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 55.69333333333334,
                        "unit": "%"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 16.409,
                        "unit": "%"
                    }
                },
                "digest": [
                    {
                        "label": "Fat",
                        "tag": "FAT",
                        "schemaOrgTag": "fatContent",
                        "total": 88.125,
                        "hasRDI": true,
                        "daily": 135.57692307692307,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Saturated",
                                "tag": "FASAT",
                                "schemaOrgTag": "saturatedFatContent",
                                "total": 26.673080000000002,
                                "hasRDI": true,
                                "daily": 133.36540000000002,
                                "unit": "g"
                            },
                            {
                                "label": "Trans",
                                "tag": "FATRN",
                                "schemaOrgTag": "transFatContent",
                                "total": 3.33976,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Monounsaturated",
                                "tag": "FAMS",
                                "schemaOrgTag": null,
                                "total": 51.53248,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Polyunsaturated",
                                "tag": "FAPU",
                                "schemaOrgTag": null,
                                "total": 8.66244,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Carbs",
                        "tag": "CHOCDF",
                        "schemaOrgTag": "carbohydrateContent",
                        "total": 10.55872,
                        "hasRDI": true,
                        "daily": 3.5195733333333328,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Carbs (net)",
                                "tag": "CHOCDF.net",
                                "schemaOrgTag": null,
                                "total": 10.55872,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Fiber",
                                "tag": "FIBTG",
                                "schemaOrgTag": "fiberContent",
                                "total": 0,
                                "hasRDI": true,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars",
                                "tag": "SUGAR",
                                "schemaOrgTag": "sugarContent",
                                "total": 1.45824,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars, added",
                                "tag": "SUGAR.added",
                                "schemaOrgTag": null,
                                "total": 0,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Protein",
                        "tag": "PROCNT",
                        "schemaOrgTag": "proteinContent",
                        "total": 279.54464,
                        "hasRDI": true,
                        "daily": 559.08928,
                        "unit": "g"
                    },
                    {
                        "label": "Cholesterol",
                        "tag": "CHOLE",
                        "schemaOrgTag": "cholesterolContent",
                        "total": 787.5,
                        "hasRDI": true,
                        "daily": 262.5,
                        "unit": "mg"
                    },
                    {
                        "label": "Sodium",
                        "tag": "NA",
                        "schemaOrgTag": "sodiumContent",
                        "total": 2052.908,
                        "hasRDI": true,
                        "daily": 85.53783333333332,
                        "unit": "mg"
                    },
                    {
                        "label": "Calcium",
                        "tag": "CA",
                        "schemaOrgTag": null,
                        "total": 197.316,
                        "hasRDI": true,
                        "daily": 19.7316,
                        "unit": "mg"
                    },
                    {
                        "label": "Magnesium",
                        "tag": "MG",
                        "schemaOrgTag": null,
                        "total": 290.724,
                        "hasRDI": true,
                        "daily": 69.22,
                        "unit": "mg"
                    },
                    {
                        "label": "Potassium",
                        "tag": "K",
                        "schemaOrgTag": null,
                        "total": 5217.204,
                        "hasRDI": true,
                        "daily": 111.00434042553191,
                        "unit": "mg"
                    },
                    {
                        "label": "Iron",
                        "tag": "FE",
                        "schemaOrgTag": null,
                        "total": 28.08692,
                        "hasRDI": true,
                        "daily": 156.03844444444445,
                        "unit": "mg"
                    },
                    {
                        "label": "Zinc",
                        "tag": "ZN",
                        "schemaOrgTag": null,
                        "total": 68.55427999999999,
                        "hasRDI": true,
                        "daily": 623.2207272727272,
                        "unit": "mg"
                    },
                    {
                        "label": "Phosphorus",
                        "tag": "P",
                        "schemaOrgTag": null,
                        "total": 2818.596,
                        "hasRDI": true,
                        "daily": 402.6565714285714,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin A",
                        "tag": "VITA_RAE",
                        "schemaOrgTag": null,
                        "total": 25,
                        "hasRDI": true,
                        "daily": 2.7777777777777777,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin C",
                        "tag": "VITC",
                        "schemaOrgTag": null,
                        "total": 1.6,
                        "hasRDI": true,
                        "daily": 1.7777777777777777,
                        "unit": "mg"
                    },
                    {
                        "label": "Thiamin (B1)",
                        "tag": "THIA",
                        "schemaOrgTag": null,
                        "total": 1.04776,
                        "hasRDI": true,
                        "daily": 87.31333333333333,
                        "unit": "mg"
                    },
                    {
                        "label": "Riboflavin (B2)",
                        "tag": "RIBF",
                        "schemaOrgTag": null,
                        "total": 2.245912,
                        "hasRDI": true,
                        "daily": 172.76246153846154,
                        "unit": "mg"
                    },
                    {
                        "label": "Niacin (B3)",
                        "tag": "NIA",
                        "schemaOrgTag": null,
                        "total": 62.79434799999999,
                        "hasRDI": true,
                        "daily": 392.46467499999994,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin B6",
                        "tag": "VITB6A",
                        "schemaOrgTag": null,
                        "total": 7.274064,
                        "hasRDI": true,
                        "daily": 559.5433846153845,
                        "unit": "mg"
                    },
                    {
                        "label": "Folate equivalent (total)",
                        "tag": "FOLDFE",
                        "schemaOrgTag": null,
                        "total": 43.852,
                        "hasRDI": true,
                        "daily": 10.963,
                        "unit": "µg"
                    },
                    {
                        "label": "Folate (food)",
                        "tag": "FOLFD",
                        "schemaOrgTag": null,
                        "total": 43.852,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Folic acid",
                        "tag": "FOLAC",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin B12",
                        "tag": "VITB12",
                        "schemaOrgTag": null,
                        "total": 28.375,
                        "hasRDI": true,
                        "daily": 1182.2916666666667,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin D",
                        "tag": "VITD",
                        "schemaOrgTag": null,
                        "total": 1.25,
                        "hasRDI": true,
                        "daily": 8.333333333333334,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin E",
                        "tag": "TOCPHA",
                        "schemaOrgTag": null,
                        "total": 8.354000000000001,
                        "hasRDI": true,
                        "daily": 55.69333333333334,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin K",
                        "tag": "VITK1",
                        "schemaOrgTag": null,
                        "total": 19.6908,
                        "hasRDI": true,
                        "daily": 16.409,
                        "unit": "µg"
                    },
                    {
                        "label": "Sugar alcohols",
                        "tag": "Sugar.alcohol",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    },
                    {
                        "label": "Water",
                        "tag": "WATER",
                        "schemaOrgTag": null,
                        "total": 1492.38448,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    }
                ]
            },
            "_links": {
                "self": {
                    "href": "https://api.edamam.com/api/recipes/v2/7eb3edfc916ebf0e4b028c8e5c04b81a?type=public&app_id=ea1d37d5&app_key=fd382a172ba8d6668c0430dc9c14a181",
                    "title": "Self"
                }
            }
        },
        {
            "recipe": {
                "uri": "http://www.edamam.com/ontologies/edamam.owl#recipe_0f3a359371750f372c7ac3c1459751d9",
                "label": "Beef Tea",
                "image": "https://www.edamam.com/web-img/ad3/ad35ae4c847dcd39bad104838007f84a.jpg",
                "source": "Epicurious",
                "url": "https://www.epicurious.com/recipes/food/views/beef-tea-395253",
                "shareAs": "http://www.edamam.com/recipe/beef-tea-0f3a359371750f372c7ac3c1459751d9/beef",
                "yield": 2,
                "dietLabels": [
                    "Low-Carb"
                ],
                "healthLabels": [
                    "Sugar-Conscious",
                    "Low Sugar",
                    "Keto-Friendly",
                    "Paleo",
                    "Dairy-Free",
                    "Gluten-Free",
                    "Wheat-Free",
                    "Egg-Free",
                    "Peanut-Free",
                    "Tree-Nut-Free",
                    "Soy-Free",
                    "Fish-Free",
                    "Shellfish-Free",
                    "Pork-Free",
                    "Crustacean-Free",
                    "Celery-Free",
                    "Mustard-Free",
                    "Sesame-Free",
                    "Lupine-Free",
                    "Mollusk-Free",
                    "Alcohol-Free",
                    "No oil added",
                    "Sulfite-Free",
                    "FODMAP-Free",
                    "Kosher"
                ],
                "cautions": [],
                "ingredientLines": [
                    "8 ounces beef chuck steak, cut into 1/2-inch cubes",
                    "1/4 teaspoon salt",
                    "3 cups water"
                ],
                "ingredients": [
                    {
                        "text": "8 ounces beef chuck steak, cut into 1/2-inch cubes",
                        "weight": 226.796185,
                        "foodCategory": "meats",
                        "foodId": "food_ah7w61mayp8jqjbbgicxfaib9opa",
                        "image": "https://www.edamam.com/food-img/e53/e53f909f06b1a44972b9492a7604beee.jpg"
                    },
                    {
                        "text": "1/4 teaspoon salt",
                        "weight": 1.5,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_btxz81db72hwbra2pncvebzzzum9",
                        "image": "https://www.edamam.com/food-img/694/6943ea510918c6025795e8dc6e6eaaeb.jpg"
                    },
                    {
                        "text": "3 cups water",
                        "weight": 711,
                        "foodCategory": "water",
                        "foodId": "food_a99vzubbk1ayrsad318rvbzr3dh0",
                        "image": "https://www.edamam.com/food-img/5dd/5dd9d1361847b2ca53c4b19a8f92627e.jpg"
                    }
                ],
                "calories": 514.82733995,
                "totalWeight": 939.296185,
                "totalTime": 0,
                "cuisineType": [
                    "south american"
                ],
                "mealType": [
                    "lunch/dinner"
                ],
                "dishType": [
                    "condiments and sauces"
                ],
                "totalNutrients": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 514.82733995,
                        "unit": "kcal"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 38.21515717250001,
                        "unit": "g"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 16.2748942356,
                        "unit": "g"
                    },
                    "FATRN": {
                        "label": "Trans",
                        "quantity": 2.3949677136000003,
                        "unit": "g"
                    },
                    "FAMS": {
                        "label": "Monounsaturated",
                        "quantity": 18.093799639300002,
                        "unit": "g"
                    },
                    "FAPU": {
                        "label": "Polyunsaturated",
                        "quantity": 2.6058881656500006,
                        "unit": "g"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 0,
                        "unit": "g"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 0,
                        "unit": "g"
                    },
                    "SUGAR": {
                        "label": "Sugars",
                        "quantity": 0,
                        "unit": "g"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 42.773760491000004,
                        "unit": "g"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 154.2214058,
                        "unit": "mg"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 759.4954821000001,
                        "unit": "mg"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 53.44146590000001,
                        "unit": "mg"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 50.21627515000001,
                        "unit": "mg"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 748.5474105000001,
                        "unit": "mg"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 4.767669885000001,
                        "unit": "mg"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 16.628721505,
                        "unit": "mg"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 405.96517115000006,
                        "unit": "mg"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 9.071847400000001,
                        "unit": "µg"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 0,
                        "unit": "mg"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 0.15875732950000004,
                        "unit": "mg"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 0.31978262085000003,
                        "unit": "mg"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 9.842954429,
                        "unit": "mg"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 0.7393555631000002,
                        "unit": "mg"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 6.80388555,
                        "unit": "µg"
                    },
                    "FOLFD": {
                        "label": "Folate (food)",
                        "quantity": 6.80388555,
                        "unit": "µg"
                    },
                    "FOLAC": {
                        "label": "Folic acid",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 6.214215469000001,
                        "unit": "µg"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 0.22679618500000004,
                        "unit": "µg"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 0.34019427750000003,
                        "unit": "mg"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 3.401942775,
                        "unit": "µg"
                    },
                    "WATER": {
                        "label": "Water",
                        "quantity": 855.3961991630001,
                        "unit": "g"
                    }
                },
                "totalDaily": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 25.741366997500002,
                        "unit": "%"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 58.79254949615386,
                        "unit": "%"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 81.37447117800001,
                        "unit": "%"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 0,
                        "unit": "%"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 0,
                        "unit": "%"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 85.54752098200001,
                        "unit": "%"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 51.40713526666667,
                        "unit": "%"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 31.645645087500004,
                        "unit": "%"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 5.344146590000001,
                        "unit": "%"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 11.95625598809524,
                        "unit": "%"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 15.926540648936173,
                        "unit": "%"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 26.487054916666672,
                        "unit": "%"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 151.1701955,
                        "unit": "%"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 57.99502445000002,
                        "unit": "%"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 1.0079830444444446,
                        "unit": "%"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 0,
                        "unit": "%"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 13.229777458333338,
                        "unit": "%"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 24.598663142307696,
                        "unit": "%"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 61.51846518125,
                        "unit": "%"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 56.87350485384616,
                        "unit": "%"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 1.7009713875,
                        "unit": "%"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 258.9256445416667,
                        "unit": "%"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 1.5119745666666669,
                        "unit": "%"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 2.2679618500000003,
                        "unit": "%"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 2.8349523125,
                        "unit": "%"
                    }
                },
                "digest": [
                    {
                        "label": "Fat",
                        "tag": "FAT",
                        "schemaOrgTag": "fatContent",
                        "total": 38.21515717250001,
                        "hasRDI": true,
                        "daily": 58.79254949615386,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Saturated",
                                "tag": "FASAT",
                                "schemaOrgTag": "saturatedFatContent",
                                "total": 16.2748942356,
                                "hasRDI": true,
                                "daily": 81.37447117800001,
                                "unit": "g"
                            },
                            {
                                "label": "Trans",
                                "tag": "FATRN",
                                "schemaOrgTag": "transFatContent",
                                "total": 2.3949677136000003,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Monounsaturated",
                                "tag": "FAMS",
                                "schemaOrgTag": null,
                                "total": 18.093799639300002,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Polyunsaturated",
                                "tag": "FAPU",
                                "schemaOrgTag": null,
                                "total": 2.6058881656500006,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Carbs",
                        "tag": "CHOCDF",
                        "schemaOrgTag": "carbohydrateContent",
                        "total": 0,
                        "hasRDI": true,
                        "daily": 0,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Carbs (net)",
                                "tag": "CHOCDF.net",
                                "schemaOrgTag": null,
                                "total": 0,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Fiber",
                                "tag": "FIBTG",
                                "schemaOrgTag": "fiberContent",
                                "total": 0,
                                "hasRDI": true,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars",
                                "tag": "SUGAR",
                                "schemaOrgTag": "sugarContent",
                                "total": 0,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars, added",
                                "tag": "SUGAR.added",
                                "schemaOrgTag": null,
                                "total": 0,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Protein",
                        "tag": "PROCNT",
                        "schemaOrgTag": "proteinContent",
                        "total": 42.773760491000004,
                        "hasRDI": true,
                        "daily": 85.54752098200001,
                        "unit": "g"
                    },
                    {
                        "label": "Cholesterol",
                        "tag": "CHOLE",
                        "schemaOrgTag": "cholesterolContent",
                        "total": 154.2214058,
                        "hasRDI": true,
                        "daily": 51.40713526666667,
                        "unit": "mg"
                    },
                    {
                        "label": "Sodium",
                        "tag": "NA",
                        "schemaOrgTag": "sodiumContent",
                        "total": 759.4954821000001,
                        "hasRDI": true,
                        "daily": 31.645645087500004,
                        "unit": "mg"
                    },
                    {
                        "label": "Calcium",
                        "tag": "CA",
                        "schemaOrgTag": null,
                        "total": 53.44146590000001,
                        "hasRDI": true,
                        "daily": 5.344146590000001,
                        "unit": "mg"
                    },
                    {
                        "label": "Magnesium",
                        "tag": "MG",
                        "schemaOrgTag": null,
                        "total": 50.21627515000001,
                        "hasRDI": true,
                        "daily": 11.95625598809524,
                        "unit": "mg"
                    },
                    {
                        "label": "Potassium",
                        "tag": "K",
                        "schemaOrgTag": null,
                        "total": 748.5474105000001,
                        "hasRDI": true,
                        "daily": 15.926540648936173,
                        "unit": "mg"
                    },
                    {
                        "label": "Iron",
                        "tag": "FE",
                        "schemaOrgTag": null,
                        "total": 4.767669885000001,
                        "hasRDI": true,
                        "daily": 26.487054916666672,
                        "unit": "mg"
                    },
                    {
                        "label": "Zinc",
                        "tag": "ZN",
                        "schemaOrgTag": null,
                        "total": 16.628721505,
                        "hasRDI": true,
                        "daily": 151.1701955,
                        "unit": "mg"
                    },
                    {
                        "label": "Phosphorus",
                        "tag": "P",
                        "schemaOrgTag": null,
                        "total": 405.96517115000006,
                        "hasRDI": true,
                        "daily": 57.99502445000002,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin A",
                        "tag": "VITA_RAE",
                        "schemaOrgTag": null,
                        "total": 9.071847400000001,
                        "hasRDI": true,
                        "daily": 1.0079830444444446,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin C",
                        "tag": "VITC",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": true,
                        "daily": 0,
                        "unit": "mg"
                    },
                    {
                        "label": "Thiamin (B1)",
                        "tag": "THIA",
                        "schemaOrgTag": null,
                        "total": 0.15875732950000004,
                        "hasRDI": true,
                        "daily": 13.229777458333338,
                        "unit": "mg"
                    },
                    {
                        "label": "Riboflavin (B2)",
                        "tag": "RIBF",
                        "schemaOrgTag": null,
                        "total": 0.31978262085000003,
                        "hasRDI": true,
                        "daily": 24.598663142307696,
                        "unit": "mg"
                    },
                    {
                        "label": "Niacin (B3)",
                        "tag": "NIA",
                        "schemaOrgTag": null,
                        "total": 9.842954429,
                        "hasRDI": true,
                        "daily": 61.51846518125,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin B6",
                        "tag": "VITB6A",
                        "schemaOrgTag": null,
                        "total": 0.7393555631000002,
                        "hasRDI": true,
                        "daily": 56.87350485384616,
                        "unit": "mg"
                    },
                    {
                        "label": "Folate equivalent (total)",
                        "tag": "FOLDFE",
                        "schemaOrgTag": null,
                        "total": 6.80388555,
                        "hasRDI": true,
                        "daily": 1.7009713875,
                        "unit": "µg"
                    },
                    {
                        "label": "Folate (food)",
                        "tag": "FOLFD",
                        "schemaOrgTag": null,
                        "total": 6.80388555,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Folic acid",
                        "tag": "FOLAC",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin B12",
                        "tag": "VITB12",
                        "schemaOrgTag": null,
                        "total": 6.214215469000001,
                        "hasRDI": true,
                        "daily": 258.9256445416667,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin D",
                        "tag": "VITD",
                        "schemaOrgTag": null,
                        "total": 0.22679618500000004,
                        "hasRDI": true,
                        "daily": 1.5119745666666669,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin E",
                        "tag": "TOCPHA",
                        "schemaOrgTag": null,
                        "total": 0.34019427750000003,
                        "hasRDI": true,
                        "daily": 2.2679618500000003,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin K",
                        "tag": "VITK1",
                        "schemaOrgTag": null,
                        "total": 3.401942775,
                        "hasRDI": true,
                        "daily": 2.8349523125,
                        "unit": "µg"
                    },
                    {
                        "label": "Sugar alcohols",
                        "tag": "Sugar.alcohol",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    },
                    {
                        "label": "Water",
                        "tag": "WATER",
                        "schemaOrgTag": null,
                        "total": 855.3961991630001,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    }
                ]
            },
            "_links": {
                "self": {
                    "href": "https://api.edamam.com/api/recipes/v2/0f3a359371750f372c7ac3c1459751d9?type=public&app_id=ea1d37d5&app_key=fd382a172ba8d6668c0430dc9c14a181",
                    "title": "Self"
                }
            }
        },
        {
            "recipe": {
                "uri": "http://www.edamam.com/ontologies/edamam.owl#recipe_710678b0fae9d4fa004975ef91aae1a3",
                "label": "Beef Brisket",
                "image": "https://www.edamam.com/web-img/deb/debce0693c8d8a6988af80e1f94e4c4c.jpg",
                "source": "Simply Recipes",
                "url": "http://simplyrecipes.com/recipes/beef_brisket/",
                "shareAs": "http://www.edamam.com/recipe/beef-brisket-710678b0fae9d4fa004975ef91aae1a3/beef",
                "yield": 8,
                "dietLabels": [
                    "High-Protein",
                    "Low-Carb"
                ],
                "healthLabels": [
                    "Dairy-Free",
                    "Egg-Free",
                    "Peanut-Free",
                    "Tree-Nut-Free",
                    "Fish-Free",
                    "Shellfish-Free",
                    "Pork-Free",
                    "Crustacean-Free",
                    "Celery-Free",
                    "Mustard-Free",
                    "Sesame-Free",
                    "Lupine-Free",
                    "Mollusk-Free",
                    "Alcohol-Free",
                    "No oil added",
                    "Kosher"
                ],
                "cautions": [
                    "Gluten",
                    "Wheat",
                    "Sulfites",
                    "FODMAP"
                ],
                "ingredientLines": [
                    "3 to 4 lbs of a brisket cut of beef",
                    "3/4 cup barbeque sauce",
                    "1/4 cup soy sauce",
                    "1 cup of water"
                ],
                "ingredients": [
                    {
                        "text": "3 to 4 lbs of a brisket cut of beef",
                        "weight": 1587.5732950000001,
                        "foodCategory": "meats",
                        "foodId": "food_bknby1la98smrsbwnthinbam42nj",
                        "image": "https://www.edamam.com/food-img/bab/bab88ab3ea40d34e4c8ae35d6b30344a.jpg"
                    },
                    {
                        "text": "3/4 cup barbeque sauce",
                        "weight": 214.5,
                        "foodCategory": "canned soup",
                        "foodId": "food_avt8j2wabi4myjaafpo4makv3lqn",
                        "image": "https://www.edamam.com/food-img/7e3/7e303aa2cbb51e4bd70f71bf5cb4a754.jpg"
                    },
                    {
                        "text": "1/4 cup soy sauce",
                        "weight": 63.75,
                        "foodCategory": "plant-based protein",
                        "foodId": "food_a5g9yevb1iactoaiimbvjbkrxueh",
                        "image": "https://www.edamam.com/food-img/f56/f562e461eb0618f367f538b836c17b82.jpg"
                    },
                    {
                        "text": "1 cup of water",
                        "weight": 237,
                        "foodCategory": "water",
                        "foodId": "food_a99vzubbk1ayrsad318rvbzr3dh0",
                        "image": "https://www.edamam.com/food-img/5dd/5dd9d1361847b2ca53c4b19a8f92627e.jpg"
                    }
                ],
                "calories": 2466.5727835000002,
                "totalWeight": 2102.823295,
                "totalTime": 0,
                "cuisineType": [
                    "british"
                ],
                "mealType": [
                    "lunch/dinner"
                ],
                "dishType": [
                    "main course"
                ],
                "totalNutrients": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 2466.5727835000002,
                        "unit": "kcal"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 78.07700048950001,
                        "unit": "g"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 31.704019604600003,
                        "unit": "g"
                    },
                    "FATRN": {
                        "label": "Trans",
                        "quantity": 3.9689332375000004,
                        "unit": "g"
                    },
                    "FAMS": {
                        "label": "Monounsaturated",
                        "quantity": 40.0800797045,
                        "unit": "g"
                    },
                    "FAPU": {
                        "label": "Polyunsaturated",
                        "quantity": 5.3057847145,
                        "unit": "g"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 92.499612954,
                        "unit": "g"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 2.4405,
                        "unit": "g"
                    },
                    "SUGAR": {
                        "label": "Sugars",
                        "quantity": 71.5548,
                        "unit": "g"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 350.49901103800005,
                        "unit": "g"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 1000.17117585,
                        "unit": "mg"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 6968.36540305,
                        "unit": "mg"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 305.31702835000004,
                        "unit": "mg"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 410.82039195000004,
                        "unit": "mg"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 6696.600890350001,
                        "unit": "mg"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 35.477456865499995,
                        "unit": "mg"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 86.83069025950002,
                        "unit": "mg"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 3593.7590501500003,
                        "unit": "mg"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 55.3464659,
                        "unit": "µg"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 1.287,
                        "unit": "mg"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 1.3382861360000002,
                        "unit": "mg"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 2.9198921015000003,
                        "unit": "mg"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 80.26522192665,
                        "unit": "mg"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 9.272641315600001,
                        "unit": "mg"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 60.84219885,
                        "unit": "µg"
                    },
                    "FOLFD": {
                        "label": "Folate (food)",
                        "quantity": 60.84219885,
                        "unit": "µg"
                    },
                    "FOLAC": {
                        "label": "Folic acid",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 36.03791379650001,
                        "unit": "µg"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 1.5875732950000003,
                        "unit": "µg"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 4.573631931,
                        "unit": "mg"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 27.674599425000004,
                        "unit": "µg"
                    },
                    "WATER": {
                        "label": "Water",
                        "quantity": 1547.6070819440001,
                        "unit": "g"
                    }
                },
                "totalDaily": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 123.32863917500002,
                        "unit": "%"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 120.11846229153846,
                        "unit": "%"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 158.520098023,
                        "unit": "%"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 30.833204318,
                        "unit": "%"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 9.762,
                        "unit": "%"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 700.9980220760001,
                        "unit": "%"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 333.39039195,
                        "unit": "%"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 290.34855846041665,
                        "unit": "%"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 30.531702835000004,
                        "unit": "%"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 97.8143790357143,
                        "unit": "%"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 142.4808700074468,
                        "unit": "%"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 197.09698258611107,
                        "unit": "%"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 789.3699114500002,
                        "unit": "%"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 513.3941500214286,
                        "unit": "%"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 6.149607322222223,
                        "unit": "%"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 1.43,
                        "unit": "%"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 111.52384466666668,
                        "unit": "%"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 224.60708473076923,
                        "unit": "%"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 501.6576370415625,
                        "unit": "%"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 713.2801012000001,
                        "unit": "%"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 15.2105497125,
                        "unit": "%"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 1501.5797415208337,
                        "unit": "%"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 10.583821966666669,
                        "unit": "%"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 30.49087954,
                        "unit": "%"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 23.062166187500004,
                        "unit": "%"
                    }
                },
                "digest": [
                    {
                        "label": "Fat",
                        "tag": "FAT",
                        "schemaOrgTag": "fatContent",
                        "total": 78.07700048950001,
                        "hasRDI": true,
                        "daily": 120.11846229153846,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Saturated",
                                "tag": "FASAT",
                                "schemaOrgTag": "saturatedFatContent",
                                "total": 31.704019604600003,
                                "hasRDI": true,
                                "daily": 158.520098023,
                                "unit": "g"
                            },
                            {
                                "label": "Trans",
                                "tag": "FATRN",
                                "schemaOrgTag": "transFatContent",
                                "total": 3.9689332375000004,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Monounsaturated",
                                "tag": "FAMS",
                                "schemaOrgTag": null,
                                "total": 40.0800797045,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Polyunsaturated",
                                "tag": "FAPU",
                                "schemaOrgTag": null,
                                "total": 5.3057847145,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Carbs",
                        "tag": "CHOCDF",
                        "schemaOrgTag": "carbohydrateContent",
                        "total": 92.499612954,
                        "hasRDI": true,
                        "daily": 30.833204318,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Carbs (net)",
                                "tag": "CHOCDF.net",
                                "schemaOrgTag": null,
                                "total": 90.059112954,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Fiber",
                                "tag": "FIBTG",
                                "schemaOrgTag": "fiberContent",
                                "total": 2.4405,
                                "hasRDI": true,
                                "daily": 9.762,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars",
                                "tag": "SUGAR",
                                "schemaOrgTag": "sugarContent",
                                "total": 71.5548,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars, added",
                                "tag": "SUGAR.added",
                                "schemaOrgTag": null,
                                "total": 0,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Protein",
                        "tag": "PROCNT",
                        "schemaOrgTag": "proteinContent",
                        "total": 350.49901103800005,
                        "hasRDI": true,
                        "daily": 700.9980220760001,
                        "unit": "g"
                    },
                    {
                        "label": "Cholesterol",
                        "tag": "CHOLE",
                        "schemaOrgTag": "cholesterolContent",
                        "total": 1000.17117585,
                        "hasRDI": true,
                        "daily": 333.39039195,
                        "unit": "mg"
                    },
                    {
                        "label": "Sodium",
                        "tag": "NA",
                        "schemaOrgTag": "sodiumContent",
                        "total": 6968.36540305,
                        "hasRDI": true,
                        "daily": 290.34855846041665,
                        "unit": "mg"
                    },
                    {
                        "label": "Calcium",
                        "tag": "CA",
                        "schemaOrgTag": null,
                        "total": 305.31702835000004,
                        "hasRDI": true,
                        "daily": 30.531702835000004,
                        "unit": "mg"
                    },
                    {
                        "label": "Magnesium",
                        "tag": "MG",
                        "schemaOrgTag": null,
                        "total": 410.82039195000004,
                        "hasRDI": true,
                        "daily": 97.8143790357143,
                        "unit": "mg"
                    },
                    {
                        "label": "Potassium",
                        "tag": "K",
                        "schemaOrgTag": null,
                        "total": 6696.600890350001,
                        "hasRDI": true,
                        "daily": 142.4808700074468,
                        "unit": "mg"
                    },
                    {
                        "label": "Iron",
                        "tag": "FE",
                        "schemaOrgTag": null,
                        "total": 35.477456865499995,
                        "hasRDI": true,
                        "daily": 197.09698258611107,
                        "unit": "mg"
                    },
                    {
                        "label": "Zinc",
                        "tag": "ZN",
                        "schemaOrgTag": null,
                        "total": 86.83069025950002,
                        "hasRDI": true,
                        "daily": 789.3699114500002,
                        "unit": "mg"
                    },
                    {
                        "label": "Phosphorus",
                        "tag": "P",
                        "schemaOrgTag": null,
                        "total": 3593.7590501500003,
                        "hasRDI": true,
                        "daily": 513.3941500214286,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin A",
                        "tag": "VITA_RAE",
                        "schemaOrgTag": null,
                        "total": 55.3464659,
                        "hasRDI": true,
                        "daily": 6.149607322222223,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin C",
                        "tag": "VITC",
                        "schemaOrgTag": null,
                        "total": 1.287,
                        "hasRDI": true,
                        "daily": 1.43,
                        "unit": "mg"
                    },
                    {
                        "label": "Thiamin (B1)",
                        "tag": "THIA",
                        "schemaOrgTag": null,
                        "total": 1.3382861360000002,
                        "hasRDI": true,
                        "daily": 111.52384466666668,
                        "unit": "mg"
                    },
                    {
                        "label": "Riboflavin (B2)",
                        "tag": "RIBF",
                        "schemaOrgTag": null,
                        "total": 2.9198921015000003,
                        "hasRDI": true,
                        "daily": 224.60708473076923,
                        "unit": "mg"
                    },
                    {
                        "label": "Niacin (B3)",
                        "tag": "NIA",
                        "schemaOrgTag": null,
                        "total": 80.26522192665,
                        "hasRDI": true,
                        "daily": 501.6576370415625,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin B6",
                        "tag": "VITB6A",
                        "schemaOrgTag": null,
                        "total": 9.272641315600001,
                        "hasRDI": true,
                        "daily": 713.2801012000001,
                        "unit": "mg"
                    },
                    {
                        "label": "Folate equivalent (total)",
                        "tag": "FOLDFE",
                        "schemaOrgTag": null,
                        "total": 60.84219885,
                        "hasRDI": true,
                        "daily": 15.2105497125,
                        "unit": "µg"
                    },
                    {
                        "label": "Folate (food)",
                        "tag": "FOLFD",
                        "schemaOrgTag": null,
                        "total": 60.84219885,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Folic acid",
                        "tag": "FOLAC",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin B12",
                        "tag": "VITB12",
                        "schemaOrgTag": null,
                        "total": 36.03791379650001,
                        "hasRDI": true,
                        "daily": 1501.5797415208337,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin D",
                        "tag": "VITD",
                        "schemaOrgTag": null,
                        "total": 1.5875732950000003,
                        "hasRDI": true,
                        "daily": 10.583821966666669,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin E",
                        "tag": "TOCPHA",
                        "schemaOrgTag": null,
                        "total": 4.573631931,
                        "hasRDI": true,
                        "daily": 30.49087954,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin K",
                        "tag": "VITK1",
                        "schemaOrgTag": null,
                        "total": 27.674599425000004,
                        "hasRDI": true,
                        "daily": 23.062166187500004,
                        "unit": "µg"
                    },
                    {
                        "label": "Sugar alcohols",
                        "tag": "Sugar.alcohol",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    },
                    {
                        "label": "Water",
                        "tag": "WATER",
                        "schemaOrgTag": null,
                        "total": 1547.6070819440001,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    }
                ]
            },
            "_links": {
                "self": {
                    "href": "https://api.edamam.com/api/recipes/v2/710678b0fae9d4fa004975ef91aae1a3?type=public&app_id=ea1d37d5&app_key=fd382a172ba8d6668c0430dc9c14a181",
                    "title": "Self"
                }
            }
        },
        {
            "recipe": {
                "uri": "http://www.edamam.com/ontologies/edamam.owl#recipe_333e271a3dc26d367d4f6c1776cd0b13",
                "label": "Barbecued Beef Brisket",
                "image": "https://www.edamam.com/web-img/b64/b64005809d54d818e6ded326347b07c8.jpg",
                "source": "Saveur",
                "url": "http://www.saveur.com/article/Recipes/Barbecued-Beef-Brisket",
                "shareAs": "http://www.edamam.com/recipe/barbecued-beef-brisket-333e271a3dc26d367d4f6c1776cd0b13/beef",
                "yield": 30,
                "dietLabels": [
                    "Low-Carb",
                    "Low-Sodium"
                ],
                "healthLabels": [
                    "Sugar-Conscious",
                    "Keto-Friendly",
                    "Dairy-Free",
                    "Gluten-Free",
                    "Wheat-Free",
                    "Egg-Free",
                    "Peanut-Free",
                    "Tree-Nut-Free",
                    "Soy-Free",
                    "Fish-Free",
                    "Shellfish-Free",
                    "Pork-Free",
                    "Crustacean-Free",
                    "Celery-Free",
                    "Mustard-Free",
                    "Sesame-Free",
                    "Lupine-Free",
                    "Mollusk-Free",
                    "Alcohol-Free",
                    "No oil added",
                    "Sulfite-Free",
                    "Kosher"
                ],
                "cautions": [
                    "Sulfites"
                ],
                "ingredientLines": [
                    "2 tbsp. chili powder",
                    "1 tbsp. cayenne",
                    "1 8-10-lb. beef brisket",
                    "1 cup apple juice"
                ],
                "ingredients": [
                    {
                        "text": "2 tbsp. chili powder",
                        "weight": 16,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_aii2sclb4r123rbfr2ybjasrl3nc",
                        "image": "https://www.edamam.com/food-img/e6f/e6f19043caefc23b5feda5520076617e.jpg"
                    },
                    {
                        "text": "1 tbsp. cayenne",
                        "weight": 5.3,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_a8iooz3aris8gba605l07brngnrx",
                        "image": "https://www.edamam.com/food-img/374/3742b9434a0fb66a45e0dd6d227ba669.jpg"
                    },
                    {
                        "text": "1 8-10-lb. beef brisket",
                        "weight": 4082.33133,
                        "foodCategory": "meats",
                        "foodId": "food_akcl1lrbxwowcrai1l6xkbtvxhsn",
                        "image": "https://www.edamam.com/food-img/e0d/e0dd59302a5bf4ff2d2e4797cdfe4160.jpg"
                    },
                    {
                        "text": "1 cup apple juice",
                        "weight": 248,
                        "foodCategory": "fruit",
                        "foodId": "food_ai7w4okaoeknd5b5j9o66bm6nu10",
                        "image": "https://www.edamam.com/food-img/324/32497d8cd6291a6f03acc032e1da7676.jpg"
                    }
                ],
                "calories": 11443.2884708,
                "totalWeight": 4351.63133,
                "totalTime": 0,
                "cuisineType": [
                    "american"
                ],
                "mealType": [
                    "lunch/dinner"
                ],
                "dishType": [
                    "main course"
                ],
                "totalNutrients": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 11443.2884708,
                        "unit": "kcal"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 910.2082983930001,
                        "unit": "g"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 366.5206171079,
                        "unit": "g"
                    },
                    "FATRN": {
                        "label": "Trans",
                        "quantity": 0,
                        "unit": "g"
                    },
                    "FAMS": {
                        "label": "Monounsaturated",
                        "quantity": 388.94492279630003,
                        "unit": "g"
                    },
                    "FAPU": {
                        "label": "Polyunsaturated",
                        "quantity": 36.3169897385,
                        "unit": "g"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 38.97739,
                        "unit": "g"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 7.505599999999999,
                        "unit": "g"
                    },
                    "SUGAR": {
                        "label": "Sugars",
                        "quantity": 25.556019999999997,
                        "unit": "g"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 728.4684073410001,
                        "unit": "g"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 3837.3914502000002,
                        "unit": "mg"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 2837.9821714,
                        "unit": "mg"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 774.4803261000001,
                        "unit": "mg"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 779.1156394,
                        "unit": "mg"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 11732.3399043,
                        "unit": "mg"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 64.71396995,
                        "unit": "mg"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 173.551655259,
                        "unit": "mg"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 6775.912381200001,
                        "unit": "mg"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 347.573,
                        "unit": "µg"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 6.3932,
                        "unit": "mg"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 2.9670959310000002,
                        "unit": "mg"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 5.3033578492,
                        "unit": "mg"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 165.13827318719999,
                        "unit": "mg"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 18.716727731800002,
                        "unit": "mg"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 377.5078197,
                        "unit": "µg"
                    },
                    "FOLFD": {
                        "label": "Folate (food)",
                        "quantity": 377.5078197,
                        "unit": "µg"
                    },
                    "FOLAC": {
                        "label": "Folic acid",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 56.336172354,
                        "unit": "µg"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 25.262214719,
                        "unit": "mg"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 90.56753261,
                        "unit": "µg"
                    },
                    "WATER": {
                        "label": "Water",
                        "quantity": 2643.4372612220004,
                        "unit": "g"
                    }
                },
                "totalDaily": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 572.16442354,
                        "unit": "%"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 1400.320459066154,
                        "unit": "%"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 1832.6030855395002,
                        "unit": "%"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 12.992463333333333,
                        "unit": "%"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 30.022399999999998,
                        "unit": "%"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 1456.9368146820002,
                        "unit": "%"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 1279.1304834,
                        "unit": "%"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 118.24925714166667,
                        "unit": "%"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 77.44803261000001,
                        "unit": "%"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 185.50372366666664,
                        "unit": "%"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 249.6242532829787,
                        "unit": "%"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 359.52205527777784,
                        "unit": "%"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 1577.7423205363636,
                        "unit": "%"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 967.9874830285715,
                        "unit": "%"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 38.61922222222222,
                        "unit": "%"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 7.103555555555556,
                        "unit": "%"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 247.25799425000002,
                        "unit": "%"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 407.9506037846154,
                        "unit": "%"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 1032.11420742,
                        "unit": "%"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 1439.7482870615386,
                        "unit": "%"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 94.376954925,
                        "unit": "%"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 2347.3405147500002,
                        "unit": "%"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 0,
                        "unit": "%"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 168.41476479333332,
                        "unit": "%"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 75.47294384166666,
                        "unit": "%"
                    }
                },
                "digest": [
                    {
                        "label": "Fat",
                        "tag": "FAT",
                        "schemaOrgTag": "fatContent",
                        "total": 910.2082983930001,
                        "hasRDI": true,
                        "daily": 1400.320459066154,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Saturated",
                                "tag": "FASAT",
                                "schemaOrgTag": "saturatedFatContent",
                                "total": 366.5206171079,
                                "hasRDI": true,
                                "daily": 1832.6030855395002,
                                "unit": "g"
                            },
                            {
                                "label": "Trans",
                                "tag": "FATRN",
                                "schemaOrgTag": "transFatContent",
                                "total": 0,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Monounsaturated",
                                "tag": "FAMS",
                                "schemaOrgTag": null,
                                "total": 388.94492279630003,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Polyunsaturated",
                                "tag": "FAPU",
                                "schemaOrgTag": null,
                                "total": 36.3169897385,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Carbs",
                        "tag": "CHOCDF",
                        "schemaOrgTag": "carbohydrateContent",
                        "total": 38.97739,
                        "hasRDI": true,
                        "daily": 12.992463333333333,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Carbs (net)",
                                "tag": "CHOCDF.net",
                                "schemaOrgTag": null,
                                "total": 31.47179,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Fiber",
                                "tag": "FIBTG",
                                "schemaOrgTag": "fiberContent",
                                "total": 7.505599999999999,
                                "hasRDI": true,
                                "daily": 30.022399999999998,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars",
                                "tag": "SUGAR",
                                "schemaOrgTag": "sugarContent",
                                "total": 25.556019999999997,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars, added",
                                "tag": "SUGAR.added",
                                "schemaOrgTag": null,
                                "total": 0,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Protein",
                        "tag": "PROCNT",
                        "schemaOrgTag": "proteinContent",
                        "total": 728.4684073410001,
                        "hasRDI": true,
                        "daily": 1456.9368146820002,
                        "unit": "g"
                    },
                    {
                        "label": "Cholesterol",
                        "tag": "CHOLE",
                        "schemaOrgTag": "cholesterolContent",
                        "total": 3837.3914502000002,
                        "hasRDI": true,
                        "daily": 1279.1304834,
                        "unit": "mg"
                    },
                    {
                        "label": "Sodium",
                        "tag": "NA",
                        "schemaOrgTag": "sodiumContent",
                        "total": 2837.9821714,
                        "hasRDI": true,
                        "daily": 118.24925714166667,
                        "unit": "mg"
                    },
                    {
                        "label": "Calcium",
                        "tag": "CA",
                        "schemaOrgTag": null,
                        "total": 774.4803261000001,
                        "hasRDI": true,
                        "daily": 77.44803261000001,
                        "unit": "mg"
                    },
                    {
                        "label": "Magnesium",
                        "tag": "MG",
                        "schemaOrgTag": null,
                        "total": 779.1156394,
                        "hasRDI": true,
                        "daily": 185.50372366666664,
                        "unit": "mg"
                    },
                    {
                        "label": "Potassium",
                        "tag": "K",
                        "schemaOrgTag": null,
                        "total": 11732.3399043,
                        "hasRDI": true,
                        "daily": 249.6242532829787,
                        "unit": "mg"
                    },
                    {
                        "label": "Iron",
                        "tag": "FE",
                        "schemaOrgTag": null,
                        "total": 64.71396995,
                        "hasRDI": true,
                        "daily": 359.52205527777784,
                        "unit": "mg"
                    },
                    {
                        "label": "Zinc",
                        "tag": "ZN",
                        "schemaOrgTag": null,
                        "total": 173.551655259,
                        "hasRDI": true,
                        "daily": 1577.7423205363636,
                        "unit": "mg"
                    },
                    {
                        "label": "Phosphorus",
                        "tag": "P",
                        "schemaOrgTag": null,
                        "total": 6775.912381200001,
                        "hasRDI": true,
                        "daily": 967.9874830285715,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin A",
                        "tag": "VITA_RAE",
                        "schemaOrgTag": null,
                        "total": 347.573,
                        "hasRDI": true,
                        "daily": 38.61922222222222,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin C",
                        "tag": "VITC",
                        "schemaOrgTag": null,
                        "total": 6.3932,
                        "hasRDI": true,
                        "daily": 7.103555555555556,
                        "unit": "mg"
                    },
                    {
                        "label": "Thiamin (B1)",
                        "tag": "THIA",
                        "schemaOrgTag": null,
                        "total": 2.9670959310000002,
                        "hasRDI": true,
                        "daily": 247.25799425000002,
                        "unit": "mg"
                    },
                    {
                        "label": "Riboflavin (B2)",
                        "tag": "RIBF",
                        "schemaOrgTag": null,
                        "total": 5.3033578492,
                        "hasRDI": true,
                        "daily": 407.9506037846154,
                        "unit": "mg"
                    },
                    {
                        "label": "Niacin (B3)",
                        "tag": "NIA",
                        "schemaOrgTag": null,
                        "total": 165.13827318719999,
                        "hasRDI": true,
                        "daily": 1032.11420742,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin B6",
                        "tag": "VITB6A",
                        "schemaOrgTag": null,
                        "total": 18.716727731800002,
                        "hasRDI": true,
                        "daily": 1439.7482870615386,
                        "unit": "mg"
                    },
                    {
                        "label": "Folate equivalent (total)",
                        "tag": "FOLDFE",
                        "schemaOrgTag": null,
                        "total": 377.5078197,
                        "hasRDI": true,
                        "daily": 94.376954925,
                        "unit": "µg"
                    },
                    {
                        "label": "Folate (food)",
                        "tag": "FOLFD",
                        "schemaOrgTag": null,
                        "total": 377.5078197,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Folic acid",
                        "tag": "FOLAC",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin B12",
                        "tag": "VITB12",
                        "schemaOrgTag": null,
                        "total": 56.336172354,
                        "hasRDI": true,
                        "daily": 2347.3405147500002,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin D",
                        "tag": "VITD",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": true,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin E",
                        "tag": "TOCPHA",
                        "schemaOrgTag": null,
                        "total": 25.262214719,
                        "hasRDI": true,
                        "daily": 168.41476479333332,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin K",
                        "tag": "VITK1",
                        "schemaOrgTag": null,
                        "total": 90.56753261,
                        "hasRDI": true,
                        "daily": 75.47294384166666,
                        "unit": "µg"
                    },
                    {
                        "label": "Sugar alcohols",
                        "tag": "Sugar.alcohol",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    },
                    {
                        "label": "Water",
                        "tag": "WATER",
                        "schemaOrgTag": null,
                        "total": 2643.4372612220004,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    }
                ]
            },
            "_links": {
                "self": {
                    "href": "https://api.edamam.com/api/recipes/v2/333e271a3dc26d367d4f6c1776cd0b13?type=public&app_id=ea1d37d5&app_key=fd382a172ba8d6668c0430dc9c14a181",
                    "title": "Self"
                }
            }
        },
        {
            "recipe": {
                "uri": "http://www.edamam.com/ontologies/edamam.owl#recipe_321f22ade4bdf65d6166eca828bb53fc",
                "label": "Beef Tacos",
                "image": "https://www.edamam.com/web-img/219/219b9268b0f84eecf0cab133498b7ef3.jpg",
                "source": "No Recipes",
                "url": "http://norecipes.com/blog/2009/05/28/beef-tacos-recipe/",
                "shareAs": "http://www.edamam.com/recipe/beef-tacos-321f22ade4bdf65d6166eca828bb53fc/beef",
                "yield": 8,
                "dietLabels": [],
                "healthLabels": [
                    "Sugar-Conscious",
                    "Dairy-Free",
                    "Gluten-Free",
                    "Wheat-Free",
                    "Egg-Free",
                    "Peanut-Free",
                    "Tree-Nut-Free",
                    "Soy-Free",
                    "Fish-Free",
                    "Shellfish-Free",
                    "Pork-Free",
                    "Crustacean-Free",
                    "Celery-Free",
                    "Mustard-Free",
                    "Sesame-Free",
                    "Lupine-Free",
                    "Mollusk-Free",
                    "Alcohol-Free",
                    "Kosher"
                ],
                "cautions": [
                    "Eggs",
                    "Milk",
                    "Sulfites"
                ],
                "ingredientLines": [
                    "1/2 medium onion chopped",
                    "2 cloves garlic minced",
                    "1 lbs sliced or lean ground beef",
                    "2 Tbs chili powder",
                    "1 tsp kosher salt",
                    "1/2 tsp sugar",
                    "12 corn tortillas",
                    "1 recipe salsa verde",
                    "cilantro",
                    "lime wedges"
                ],
                "ingredients": [
                    {
                        "text": "1/2 medium onion chopped",
                        "weight": 55,
                        "foodCategory": "vegetables",
                        "foodId": "food_bmrvi4ob4binw9a5m7l07amlfcoy",
                        "image": "https://www.edamam.com/food-img/205/205e6bf2399b85d34741892ef91cc603.jpg"
                    },
                    {
                        "text": "2 cloves garlic minced",
                        "weight": 6,
                        "foodCategory": "vegetables",
                        "foodId": "food_avtcmx6bgjv1jvay6s6stan8dnyp",
                        "image": "https://www.edamam.com/food-img/6ee/6ee142951f48aaf94f4312409f8d133d.jpg"
                    },
                    {
                        "text": "1 lbs sliced or lean ground beef",
                        "weight": 453.59237,
                        "foodCategory": "meats",
                        "foodId": "food_boq91pbbhklr6sb0d9sbybzgklkm",
                        "image": "https://www.edamam.com/food-img/cfa/cfae8f9276eaf8f0d9349ba662744a0c.jpg"
                    },
                    {
                        "text": "2 Tbs chili powder",
                        "weight": 16,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_aii2sclb4r123rbfr2ybjasrl3nc",
                        "image": "https://www.edamam.com/food-img/e6f/e6f19043caefc23b5feda5520076617e.jpg"
                    },
                    {
                        "text": "1 tsp kosher salt",
                        "weight": 4.854166666912875,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_a1vgrj1bs8rd1majvmd9ubz8ttkg",
                        "image": "https://www.edamam.com/food-img/694/6943ea510918c6025795e8dc6e6eaaeb.jpg"
                    },
                    {
                        "text": "1/2 tsp sugar",
                        "weight": 2.1,
                        "foodCategory": "sugars",
                        "foodId": "food_axi2ijobrk819yb0adceobnhm1c2",
                        "image": "https://www.edamam.com/food-img/ecb/ecb3f5aaed96d0188c21b8369be07765.jpg"
                    },
                    {
                        "text": "12 corn tortillas",
                        "weight": 288,
                        "foodCategory": "quick breads and pastries",
                        "foodId": "food_bhw0b95agm97s0abfignnb8fsvb3",
                        "image": "https://www.edamam.com/food-img/b8a/b8ad23dcc06f2324f944e47eb579d644.jpg"
                    },
                    {
                        "text": "1 recipe salsa verde",
                        "weight": 8.9,
                        "foodCategory": "canned soup",
                        "foodId": "food_b0t3obfawlm5k2b6erxscacez35u",
                        "image": "https://www.edamam.com/food-img/995/995d0f166754a0475c181b9c156fec43.jpg"
                    },
                    {
                        "text": "cilantro",
                        "weight": 8.42821536666913,
                        "foodCategory": "vegetables",
                        "foodId": "food_alhzhuwb4lc7jnb5s6f02by60bzp",
                        "image": "https://www.edamam.com/food-img/d57/d57e375b6ff99a90c7ee2b1990a1af36.jpg"
                    },
                    {
                        "text": "lime wedges",
                        "weight": 8.375,
                        "foodCategory": "fruit",
                        "foodId": "food_av58muyb8kg92fbk0g8g8aui5knv",
                        "image": "https://www.edamam.com/food-img/48a/48a123c9576647c4ada6a41df5eeb22a.jpg"
                    }
                ],
                "calories": 1871.1836093343338,
                "totalWeight": 849.002929818369,
                "totalTime": 0,
                "cuisineType": [
                    "mexican"
                ],
                "mealType": [
                    "lunch/dinner"
                ],
                "dishType": [
                    "sandwiches"
                ],
                "totalNutrients": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 1871.1836093343338,
                        "unit": "kcal"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 101.37198071990669,
                        "unit": "g"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 36.11953001985135,
                        "unit": "g"
                    },
                    "FATRN": {
                        "label": "Trans",
                        "quantity": 5.3523899660000005,
                        "unit": "g"
                    },
                    "FAMS": {
                        "label": "Monounsaturated",
                        "quantity": 42.67537673985834,
                        "unit": "g"
                    },
                    "FAPU": {
                        "label": "Polyunsaturated",
                        "quantity": 7.773398783846668,
                        "unit": "g"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 147.52550050395675,
                        "unit": "g"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 25.40369003026673,
                        "unit": "g"
                    },
                    "SUGAR": {
                        "label": "Sugars",
                        "quantity": 8.738122973690022,
                        "unit": "g"
                    },
                    "SUGAR.added": {
                        "label": "Sugars, added",
                        "quantity": 2.0958,
                        "unit": "g"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 97.81321591631007,
                        "unit": "g"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 322.05058270000006,
                        "unit": "mg"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 1968.2760058584822,
                        "unit": "mg"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 402.96404356407635,
                        "unit": "mg"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 319.36561233985094,
                        "unit": "mg"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 2254.808488616482,
                        "unit": "mg"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 15.572275626680653,
                        "unit": "mg"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 23.655141987285045,
                        "unit": "mg"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 1702.7049879760011,
                        "unit": "mg"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 286.130280585675,
                        "unit": "µg"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 10.935843149000666,
                        "unit": "mg"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 0.5543391233956683,
                        "unit": "mg"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 1.0625501875940042,
                        "unit": "mg"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 25.65970979908469,
                        "unit": "mg"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 2.602786645996337,
                        "unit": "mg"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 67.51295942733486,
                        "unit": "µg"
                    },
                    "FOLFD": {
                        "label": "Folate (food)",
                        "quantity": 67.51295942733486,
                        "unit": "µg"
                    },
                    "FOLAC": {
                        "label": "Folic acid",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 9.706876718000002,
                        "unit": "µg"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 0.4535923700000001,
                        "unit": "µg"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 8.03341741316673,
                        "unit": "mg"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 51.950180296674304,
                        "unit": "µg"
                    },
                    "WATER": {
                        "label": "Water",
                        "quantity": 490.152186397509,
                        "unit": "g"
                    }
                },
                "totalDaily": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 93.55918046671668,
                        "unit": "%"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 155.95689341524107,
                        "unit": "%"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 180.59765009925673,
                        "unit": "%"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 49.17516683465225,
                        "unit": "%"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 101.61476012106692,
                        "unit": "%"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 195.62643183262014,
                        "unit": "%"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 107.35019423333335,
                        "unit": "%"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 82.01150024410342,
                        "unit": "%"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 40.296404356407635,
                        "unit": "%"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 76.03943150948831,
                        "unit": "%"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 47.9746486939677,
                        "unit": "%"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 86.51264237044808,
                        "unit": "%"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 215.04674533895496,
                        "unit": "%"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 243.2435697108573,
                        "unit": "%"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 31.79225339840833,
                        "unit": "%"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 12.150936832222962,
                        "unit": "%"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 46.19492694963902,
                        "unit": "%"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 81.73462981492341,
                        "unit": "%"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 160.3731862442793,
                        "unit": "%"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 200.21435738433362,
                        "unit": "%"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 16.878239856833716,
                        "unit": "%"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 404.4531965833334,
                        "unit": "%"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 3.0239491333333337,
                        "unit": "%"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 53.55611608777819,
                        "unit": "%"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 43.29181691389525,
                        "unit": "%"
                    }
                },
                "digest": [
                    {
                        "label": "Fat",
                        "tag": "FAT",
                        "schemaOrgTag": "fatContent",
                        "total": 101.37198071990669,
                        "hasRDI": true,
                        "daily": 155.95689341524107,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Saturated",
                                "tag": "FASAT",
                                "schemaOrgTag": "saturatedFatContent",
                                "total": 36.11953001985135,
                                "hasRDI": true,
                                "daily": 180.59765009925673,
                                "unit": "g"
                            },
                            {
                                "label": "Trans",
                                "tag": "FATRN",
                                "schemaOrgTag": "transFatContent",
                                "total": 5.3523899660000005,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Monounsaturated",
                                "tag": "FAMS",
                                "schemaOrgTag": null,
                                "total": 42.67537673985834,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Polyunsaturated",
                                "tag": "FAPU",
                                "schemaOrgTag": null,
                                "total": 7.773398783846668,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Carbs",
                        "tag": "CHOCDF",
                        "schemaOrgTag": "carbohydrateContent",
                        "total": 147.52550050395675,
                        "hasRDI": true,
                        "daily": 49.17516683465225,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Carbs (net)",
                                "tag": "CHOCDF.net",
                                "schemaOrgTag": null,
                                "total": 122.12181047369002,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Fiber",
                                "tag": "FIBTG",
                                "schemaOrgTag": "fiberContent",
                                "total": 25.40369003026673,
                                "hasRDI": true,
                                "daily": 101.61476012106692,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars",
                                "tag": "SUGAR",
                                "schemaOrgTag": "sugarContent",
                                "total": 8.738122973690022,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars, added",
                                "tag": "SUGAR.added",
                                "schemaOrgTag": null,
                                "total": 2.0958,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Protein",
                        "tag": "PROCNT",
                        "schemaOrgTag": "proteinContent",
                        "total": 97.81321591631007,
                        "hasRDI": true,
                        "daily": 195.62643183262014,
                        "unit": "g"
                    },
                    {
                        "label": "Cholesterol",
                        "tag": "CHOLE",
                        "schemaOrgTag": "cholesterolContent",
                        "total": 322.05058270000006,
                        "hasRDI": true,
                        "daily": 107.35019423333335,
                        "unit": "mg"
                    },
                    {
                        "label": "Sodium",
                        "tag": "NA",
                        "schemaOrgTag": "sodiumContent",
                        "total": 1968.2760058584822,
                        "hasRDI": true,
                        "daily": 82.01150024410342,
                        "unit": "mg"
                    },
                    {
                        "label": "Calcium",
                        "tag": "CA",
                        "schemaOrgTag": null,
                        "total": 402.96404356407635,
                        "hasRDI": true,
                        "daily": 40.296404356407635,
                        "unit": "mg"
                    },
                    {
                        "label": "Magnesium",
                        "tag": "MG",
                        "schemaOrgTag": null,
                        "total": 319.36561233985094,
                        "hasRDI": true,
                        "daily": 76.03943150948831,
                        "unit": "mg"
                    },
                    {
                        "label": "Potassium",
                        "tag": "K",
                        "schemaOrgTag": null,
                        "total": 2254.808488616482,
                        "hasRDI": true,
                        "daily": 47.9746486939677,
                        "unit": "mg"
                    },
                    {
                        "label": "Iron",
                        "tag": "FE",
                        "schemaOrgTag": null,
                        "total": 15.572275626680653,
                        "hasRDI": true,
                        "daily": 86.51264237044808,
                        "unit": "mg"
                    },
                    {
                        "label": "Zinc",
                        "tag": "ZN",
                        "schemaOrgTag": null,
                        "total": 23.655141987285045,
                        "hasRDI": true,
                        "daily": 215.04674533895496,
                        "unit": "mg"
                    },
                    {
                        "label": "Phosphorus",
                        "tag": "P",
                        "schemaOrgTag": null,
                        "total": 1702.7049879760011,
                        "hasRDI": true,
                        "daily": 243.2435697108573,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin A",
                        "tag": "VITA_RAE",
                        "schemaOrgTag": null,
                        "total": 286.130280585675,
                        "hasRDI": true,
                        "daily": 31.79225339840833,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin C",
                        "tag": "VITC",
                        "schemaOrgTag": null,
                        "total": 10.935843149000666,
                        "hasRDI": true,
                        "daily": 12.150936832222962,
                        "unit": "mg"
                    },
                    {
                        "label": "Thiamin (B1)",
                        "tag": "THIA",
                        "schemaOrgTag": null,
                        "total": 0.5543391233956683,
                        "hasRDI": true,
                        "daily": 46.19492694963902,
                        "unit": "mg"
                    },
                    {
                        "label": "Riboflavin (B2)",
                        "tag": "RIBF",
                        "schemaOrgTag": null,
                        "total": 1.0625501875940042,
                        "hasRDI": true,
                        "daily": 81.73462981492341,
                        "unit": "mg"
                    },
                    {
                        "label": "Niacin (B3)",
                        "tag": "NIA",
                        "schemaOrgTag": null,
                        "total": 25.65970979908469,
                        "hasRDI": true,
                        "daily": 160.3731862442793,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin B6",
                        "tag": "VITB6A",
                        "schemaOrgTag": null,
                        "total": 2.602786645996337,
                        "hasRDI": true,
                        "daily": 200.21435738433362,
                        "unit": "mg"
                    },
                    {
                        "label": "Folate equivalent (total)",
                        "tag": "FOLDFE",
                        "schemaOrgTag": null,
                        "total": 67.51295942733486,
                        "hasRDI": true,
                        "daily": 16.878239856833716,
                        "unit": "µg"
                    },
                    {
                        "label": "Folate (food)",
                        "tag": "FOLFD",
                        "schemaOrgTag": null,
                        "total": 67.51295942733486,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Folic acid",
                        "tag": "FOLAC",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin B12",
                        "tag": "VITB12",
                        "schemaOrgTag": null,
                        "total": 9.706876718000002,
                        "hasRDI": true,
                        "daily": 404.4531965833334,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin D",
                        "tag": "VITD",
                        "schemaOrgTag": null,
                        "total": 0.4535923700000001,
                        "hasRDI": true,
                        "daily": 3.0239491333333337,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin E",
                        "tag": "TOCPHA",
                        "schemaOrgTag": null,
                        "total": 8.03341741316673,
                        "hasRDI": true,
                        "daily": 53.55611608777819,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin K",
                        "tag": "VITK1",
                        "schemaOrgTag": null,
                        "total": 51.950180296674304,
                        "hasRDI": true,
                        "daily": 43.29181691389525,
                        "unit": "µg"
                    },
                    {
                        "label": "Sugar alcohols",
                        "tag": "Sugar.alcohol",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    },
                    {
                        "label": "Water",
                        "tag": "WATER",
                        "schemaOrgTag": null,
                        "total": 490.152186397509,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    }
                ]
            },
            "_links": {
                "self": {
                    "href": "https://api.edamam.com/api/recipes/v2/321f22ade4bdf65d6166eca828bb53fc?type=public&app_id=ea1d37d5&app_key=fd382a172ba8d6668c0430dc9c14a181",
                    "title": "Self"
                }
            }
        },
        {
            "recipe": {
                "uri": "http://www.edamam.com/ontologies/edamam.owl#recipe_d61fd8290e964a2d1bb159a34ea942ae",
                "label": "Pioneer Woman’s Beef Brisket",
                "image": "https://www.edamam.com/web-img/c60/c60e420c3450c7eccd833271153f896e.jpg",
                "source": "Pioneer Woman",
                "url": "http://thepioneerwoman.com/cooking/2007/06/brisket_baby/",
                "shareAs": "http://www.edamam.com/recipe/pioneer-woman-s-beef-brisket-d61fd8290e964a2d1bb159a34ea942ae/beef",
                "yield": 12,
                "dietLabels": [
                    "Low-Carb"
                ],
                "healthLabels": [
                    "Sugar-Conscious",
                    "Keto-Friendly",
                    "Dairy-Free",
                    "Egg-Free",
                    "Peanut-Free",
                    "Tree-Nut-Free",
                    "Fish-Free",
                    "Shellfish-Free",
                    "Pork-Free",
                    "Crustacean-Free",
                    "Celery-Free",
                    "Mustard-Free",
                    "Sesame-Free",
                    "Lupine-Free",
                    "Mollusk-Free",
                    "Alcohol-Free",
                    "No oil added",
                    "Kosher"
                ],
                "cautions": [
                    "Gluten",
                    "Wheat",
                    "Sulfites"
                ],
                "ingredientLines": [
                    "2 cans Beef Consomme",
                    "1/2 cup Lemon Juice",
                    "1 1/2 cup Soy Sauce",
                    "5 cloves Chopped Garlic",
                    "2 tbsp Liquid Smoke",
                    "10 pounds Beef Brisket"
                ],
                "ingredients": [
                    {
                        "text": "2 cans Beef Consomme",
                        "weight": 1172,
                        "foodCategory": "canned soup",
                        "foodId": "food_arlagstbtxcrk4ablvuh9b36no9m",
                        "image": "https://www.edamam.com/food-img/6a5/6a5f7cf073a7e70af946bfb4d558a914.jpg"
                    },
                    {
                        "text": "1/2 cup Lemon Juice",
                        "weight": 122,
                        "foodCategory": "100% juice",
                        "foodId": "food_bglm6vxahuauteb0n6ynfbg9eryu",
                        "image": "https://www.edamam.com/food-img/e31/e310952d214e78a4cb8b73f30ceeaaf2.jpg"
                    },
                    {
                        "text": "1 1/2 cup Soy Sauce",
                        "weight": 382.5,
                        "foodCategory": "plant-based protein",
                        "foodId": "food_a5g9yevb1iactoaiimbvjbkrxueh",
                        "image": "https://www.edamam.com/food-img/f56/f562e461eb0618f367f538b836c17b82.jpg"
                    },
                    {
                        "text": "5 cloves Chopped Garlic",
                        "weight": 15,
                        "foodCategory": "vegetables",
                        "foodId": "food_avtcmx6bgjv1jvay6s6stan8dnyp",
                        "image": "https://www.edamam.com/food-img/6ee/6ee142951f48aaf94f4312409f8d133d.jpg"
                    },
                    {
                        "text": "2 tbsp Liquid Smoke",
                        "weight": 29.573529562,
                        "foodCategory": "water",
                        "foodId": "food_a99vzubbk1ayrsad318rvbzr3dh0",
                        "image": "https://www.edamam.com/food-img/5dd/5dd9d1361847b2ca53c4b19a8f92627e.jpg"
                    },
                    {
                        "text": "10 pounds Beef Brisket",
                        "weight": 4535.9237,
                        "foodCategory": "meats",
                        "foodId": "food_akcl1lrbxwowcrai1l6xkbtvxhsn",
                        "image": "https://www.edamam.com/food-img/e0d/e0dd59302a5bf4ff2d2e4797cdfe4160.jpg"
                    }
                ],
                "calories": 12911.704412000001,
                "totalWeight": 6256.997229562,
                "totalTime": 0,
                "cuisineType": [
                    "american"
                ],
                "mealType": [
                    "lunch/dinner"
                ],
                "dishType": [
                    "main course"
                ],
                "totalNutrients": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 12911.704412000001,
                        "unit": "kcal"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 1009.9767037700001,
                        "unit": "g"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 406.896216231,
                        "unit": "g"
                    },
                    "FATRN": {
                        "label": "Trans",
                        "quantity": 0,
                        "unit": "g"
                    },
                    "FAMS": {
                        "label": "Monounsaturated",
                        "quantity": 431.757273107,
                        "unit": "g"
                    },
                    "FAPU": {
                        "label": "Polyunsaturated",
                        "quantity": 39.397500265,
                        "unit": "g"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 40.78985,
                        "unit": "g"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 3.7410000000000005,
                        "unit": "g"
                    },
                    "SUGAR": {
                        "label": "Sugars",
                        "quantity": 4.7544,
                        "unit": "g"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 864.56854149,
                        "unit": "g"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 4263.7682780000005,
                        "unit": "mg"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 26740.59368718248,
                        "unit": "mg"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 979.56923488686,
                        "unit": "mg"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 1110.88200129562,
                        "unit": "mg"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 14892.118226999999,
                        "unit": "mg"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 76.5161055,
                        "unit": "mg"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 197.19327986295622,
                        "unit": "mg"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 8258.934868,
                        "unit": "mg"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 56.58200000000001,
                        "unit": "mg"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 3.4661315900000003,
                        "unit": "mg"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 6.431110388,
                        "unit": "mg"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 192.784320208,
                        "unit": "mg"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 21.154889702,
                        "unit": "mg"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 498.353133,
                        "unit": "µg"
                    },
                    "FOLFD": {
                        "label": "Folate (food)",
                        "quantity": 498.353133,
                        "unit": "µg"
                    },
                    "FOLAC": {
                        "label": "Folic acid",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 62.595747059999994,
                        "unit": "µg"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 19.69947191,
                        "unit": "mg"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 77.36570289999999,
                        "unit": "µg"
                    },
                    "WATER": {
                        "label": "Water",
                        "quantity": 4242.647829612439,
                        "unit": "g"
                    }
                },
                "totalDaily": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 645.5852206,
                        "unit": "%"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 1553.8103134923076,
                        "unit": "%"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 2034.481081155,
                        "unit": "%"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 13.596616666666668,
                        "unit": "%"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 14.964000000000004,
                        "unit": "%"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 1729.13708298,
                        "unit": "%"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 1421.2560926666667,
                        "unit": "%"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 1114.1914036326034,
                        "unit": "%"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 97.956923488686,
                        "unit": "%"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 264.49571459419525,
                        "unit": "%"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 316.85357929787233,
                        "unit": "%"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 425.089475,
                        "unit": "%"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 1792.6661805723293,
                        "unit": "%"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 1179.8478382857145,
                        "unit": "%"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 0,
                        "unit": "%"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 62.8688888888889,
                        "unit": "%"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 288.8442991666667,
                        "unit": "%"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 494.70079907692303,
                        "unit": "%"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 1204.9020013,
                        "unit": "%"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 1627.2992078461539,
                        "unit": "%"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 124.58828325,
                        "unit": "%"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 2608.1561275,
                        "unit": "%"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 0,
                        "unit": "%"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 131.32981273333334,
                        "unit": "%"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 64.47141908333332,
                        "unit": "%"
                    }
                },
                "digest": [
                    {
                        "label": "Fat",
                        "tag": "FAT",
                        "schemaOrgTag": "fatContent",
                        "total": 1009.9767037700001,
                        "hasRDI": true,
                        "daily": 1553.8103134923076,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Saturated",
                                "tag": "FASAT",
                                "schemaOrgTag": "saturatedFatContent",
                                "total": 406.896216231,
                                "hasRDI": true,
                                "daily": 2034.481081155,
                                "unit": "g"
                            },
                            {
                                "label": "Trans",
                                "tag": "FATRN",
                                "schemaOrgTag": "transFatContent",
                                "total": 0,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Monounsaturated",
                                "tag": "FAMS",
                                "schemaOrgTag": null,
                                "total": 431.757273107,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Polyunsaturated",
                                "tag": "FAPU",
                                "schemaOrgTag": null,
                                "total": 39.397500265,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Carbs",
                        "tag": "CHOCDF",
                        "schemaOrgTag": "carbohydrateContent",
                        "total": 40.78985,
                        "hasRDI": true,
                        "daily": 13.596616666666668,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Carbs (net)",
                                "tag": "CHOCDF.net",
                                "schemaOrgTag": null,
                                "total": 37.04885,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Fiber",
                                "tag": "FIBTG",
                                "schemaOrgTag": "fiberContent",
                                "total": 3.7410000000000005,
                                "hasRDI": true,
                                "daily": 14.964000000000004,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars",
                                "tag": "SUGAR",
                                "schemaOrgTag": "sugarContent",
                                "total": 4.7544,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars, added",
                                "tag": "SUGAR.added",
                                "schemaOrgTag": null,
                                "total": 0,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Protein",
                        "tag": "PROCNT",
                        "schemaOrgTag": "proteinContent",
                        "total": 864.56854149,
                        "hasRDI": true,
                        "daily": 1729.13708298,
                        "unit": "g"
                    },
                    {
                        "label": "Cholesterol",
                        "tag": "CHOLE",
                        "schemaOrgTag": "cholesterolContent",
                        "total": 4263.7682780000005,
                        "hasRDI": true,
                        "daily": 1421.2560926666667,
                        "unit": "mg"
                    },
                    {
                        "label": "Sodium",
                        "tag": "NA",
                        "schemaOrgTag": "sodiumContent",
                        "total": 26740.59368718248,
                        "hasRDI": true,
                        "daily": 1114.1914036326034,
                        "unit": "mg"
                    },
                    {
                        "label": "Calcium",
                        "tag": "CA",
                        "schemaOrgTag": null,
                        "total": 979.56923488686,
                        "hasRDI": true,
                        "daily": 97.956923488686,
                        "unit": "mg"
                    },
                    {
                        "label": "Magnesium",
                        "tag": "MG",
                        "schemaOrgTag": null,
                        "total": 1110.88200129562,
                        "hasRDI": true,
                        "daily": 264.49571459419525,
                        "unit": "mg"
                    },
                    {
                        "label": "Potassium",
                        "tag": "K",
                        "schemaOrgTag": null,
                        "total": 14892.118226999999,
                        "hasRDI": true,
                        "daily": 316.85357929787233,
                        "unit": "mg"
                    },
                    {
                        "label": "Iron",
                        "tag": "FE",
                        "schemaOrgTag": null,
                        "total": 76.5161055,
                        "hasRDI": true,
                        "daily": 425.089475,
                        "unit": "mg"
                    },
                    {
                        "label": "Zinc",
                        "tag": "ZN",
                        "schemaOrgTag": null,
                        "total": 197.19327986295622,
                        "hasRDI": true,
                        "daily": 1792.6661805723293,
                        "unit": "mg"
                    },
                    {
                        "label": "Phosphorus",
                        "tag": "P",
                        "schemaOrgTag": null,
                        "total": 8258.934868,
                        "hasRDI": true,
                        "daily": 1179.8478382857145,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin A",
                        "tag": "VITA_RAE",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": true,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin C",
                        "tag": "VITC",
                        "schemaOrgTag": null,
                        "total": 56.58200000000001,
                        "hasRDI": true,
                        "daily": 62.8688888888889,
                        "unit": "mg"
                    },
                    {
                        "label": "Thiamin (B1)",
                        "tag": "THIA",
                        "schemaOrgTag": null,
                        "total": 3.4661315900000003,
                        "hasRDI": true,
                        "daily": 288.8442991666667,
                        "unit": "mg"
                    },
                    {
                        "label": "Riboflavin (B2)",
                        "tag": "RIBF",
                        "schemaOrgTag": null,
                        "total": 6.431110388,
                        "hasRDI": true,
                        "daily": 494.70079907692303,
                        "unit": "mg"
                    },
                    {
                        "label": "Niacin (B3)",
                        "tag": "NIA",
                        "schemaOrgTag": null,
                        "total": 192.784320208,
                        "hasRDI": true,
                        "daily": 1204.9020013,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin B6",
                        "tag": "VITB6A",
                        "schemaOrgTag": null,
                        "total": 21.154889702,
                        "hasRDI": true,
                        "daily": 1627.2992078461539,
                        "unit": "mg"
                    },
                    {
                        "label": "Folate equivalent (total)",
                        "tag": "FOLDFE",
                        "schemaOrgTag": null,
                        "total": 498.353133,
                        "hasRDI": true,
                        "daily": 124.58828325,
                        "unit": "µg"
                    },
                    {
                        "label": "Folate (food)",
                        "tag": "FOLFD",
                        "schemaOrgTag": null,
                        "total": 498.353133,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Folic acid",
                        "tag": "FOLAC",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin B12",
                        "tag": "VITB12",
                        "schemaOrgTag": null,
                        "total": 62.595747059999994,
                        "hasRDI": true,
                        "daily": 2608.1561275,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin D",
                        "tag": "VITD",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": true,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin E",
                        "tag": "TOCPHA",
                        "schemaOrgTag": null,
                        "total": 19.69947191,
                        "hasRDI": true,
                        "daily": 131.32981273333334,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin K",
                        "tag": "VITK1",
                        "schemaOrgTag": null,
                        "total": 77.36570289999999,
                        "hasRDI": true,
                        "daily": 64.47141908333332,
                        "unit": "µg"
                    },
                    {
                        "label": "Sugar alcohols",
                        "tag": "Sugar.alcohol",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    },
                    {
                        "label": "Water",
                        "tag": "WATER",
                        "schemaOrgTag": null,
                        "total": 4242.647829612439,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    }
                ]
            },
            "_links": {
                "self": {
                    "href": "https://api.edamam.com/api/recipes/v2/d61fd8290e964a2d1bb159a34ea942ae?type=public&app_id=ea1d37d5&app_key=fd382a172ba8d6668c0430dc9c14a181",
                    "title": "Self"
                }
            }
        },
        {
            "recipe": {
                "uri": "http://www.edamam.com/ontologies/edamam.owl#recipe_fb3b9d088cb51202c3a0510ffd0f8556",
                "label": "Beef and Noodles recipes",
                "image": "https://www.edamam.com/web-img/cd3/cd3674a92bbb3797632a65e2df7bd7f7",
                "source": "Chez Us",
                "url": "http://www.chezus.com/2009/04/04/beef-and-noodles/",
                "shareAs": "http://www.edamam.com/recipe/beef-and-noodles-recipes-fb3b9d088cb51202c3a0510ffd0f8556/beef",
                "yield": 4,
                "dietLabels": [
                    "Low-Carb"
                ],
                "healthLabels": [
                    "Sugar-Conscious",
                    "Dairy-Free",
                    "Gluten-Free",
                    "Wheat-Free",
                    "Egg-Free",
                    "Peanut-Free",
                    "Tree-Nut-Free",
                    "Fish-Free",
                    "Shellfish-Free",
                    "Pork-Free",
                    "Crustacean-Free",
                    "Celery-Free",
                    "Mustard-Free",
                    "Sesame-Free",
                    "Lupine-Free",
                    "Mollusk-Free",
                    "Alcohol-Free",
                    "Sulfite-Free",
                    "Kosher"
                ],
                "cautions": [
                    "Sulfites",
                    "FODMAP"
                ],
                "ingredientLines": [
                    "1/2 yellow onion, thinly sliced",
                    "knob fresh ginger, minced",
                    "1/2 stick of lemon grass, minced",
                    "zest from 1 lime",
                    "2 tablespoons olive oil",
                    "1/2 pound beef flank, thinly sliced",
                    "3 cups of beef stock, preferabley homemade",
                    "2 cups edamame",
                    "lime"
                ],
                "ingredients": [
                    {
                        "text": "1/2 yellow onion, thinly sliced",
                        "weight": 62.5,
                        "foodCategory": "vegetables",
                        "foodId": "food_bmrvi4ob4binw9a5m7l07amlfcoy",
                        "image": "https://www.edamam.com/food-img/205/205e6bf2399b85d34741892ef91cc603.jpg"
                    },
                    {
                        "text": "knob fresh ginger, minced",
                        "weight": 15,
                        "foodCategory": "vegetables",
                        "foodId": "food_bi2ki2xb5zmmvbaiwf7ztbgktzp6",
                        "image": "https://www.edamam.com/food-img/b9c/b9c06ef451ef29513880af0a53ebbaa6.jpg"
                    },
                    {
                        "text": "1/2 stick of lemon grass, minced",
                        "weight": 10,
                        "foodCategory": "vegetables",
                        "foodId": "food_b3l1z8na3dy8qfaht3yubbrdu94h",
                        "image": "https://www.edamam.com/food-img/a6e/a6ef38b461759334bbdc4d25ca678ad1.jpg"
                    },
                    {
                        "text": "zest from 1 lime",
                        "weight": 67,
                        "foodCategory": "fruit",
                        "foodId": "food_av58muyb8kg92fbk0g8g8aui5knv",
                        "image": "https://www.edamam.com/food-img/48a/48a123c9576647c4ada6a41df5eeb22a.jpg"
                    },
                    {
                        "text": "2 tablespoons olive oil",
                        "weight": 27,
                        "foodCategory": "Oils",
                        "foodId": "food_b1d1icuad3iktrbqby0hiagafaz7",
                        "image": "https://www.edamam.com/food-img/4d6/4d651eaa8a353647746290c7a9b29d84.jpg"
                    },
                    {
                        "text": "1/2 pound beef flank, thinly sliced",
                        "weight": 226.796185,
                        "foodCategory": "meats",
                        "foodId": "food_abhe6ejbfw25i1a4u0iiwbi0aw6s",
                        "image": "https://www.edamam.com/food-img/f8d/f8dedaeb7292857a4d92019961fb91fb.jpg"
                    },
                    {
                        "text": "3 cups of beef stock, preferabley homemade",
                        "weight": 720,
                        "foodCategory": "canned soup",
                        "foodId": "food_bxd832fblxgfaibgn0zk0b6dg6dh",
                        "image": "https://www.edamam.com/food-img/428/4284513ddbf46e51f0f33566c0d61715.jpg"
                    },
                    {
                        "text": "2 cups edamame",
                        "weight": 236,
                        "foodCategory": "vegetables",
                        "foodId": "food_bx3fkcubyl2t7ha8jfdm5anoirlx",
                        "image": "https://www.edamam.com/food-img/325/325e012901331f9860df07f755adf197.jpg"
                    },
                    {
                        "text": "lime",
                        "weight": 91.40784439500001,
                        "foodCategory": "fruit",
                        "foodId": "food_av58muyb8kg92fbk0g8g8aui5knv",
                        "image": "https://www.edamam.com/food-img/48a/48a123c9576647c4ada6a41df5eeb22a.jpg"
                    }
                ],
                "calories": 1060.5160585685,
                "totalWeight": 1455.7040293950001,
                "totalTime": 75,
                "cuisineType": [
                    "asian"
                ],
                "mealType": [
                    "lunch/dinner"
                ],
                "dishType": [
                    "main course"
                ],
                "totalNutrients": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 1060.5160585685,
                        "unit": "kcal"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 58.15301942529,
                        "unit": "g"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 11.892202375316904,
                        "unit": "g"
                    },
                    "FAMS": {
                        "label": "Monounsaturated",
                        "quantity": 27.741503543435048,
                        "unit": "g"
                    },
                    "FAPU": {
                        "label": "Polyunsaturated",
                        "quantity": 3.7748265341672504,
                        "unit": "g"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 56.618986799233,
                        "unit": "g"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 17.12591964306,
                        "unit": "g"
                    },
                    "SUGAR": {
                        "label": "Sugars",
                        "quantity": 15.3228925702755,
                        "unit": "g"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 88.75150536776499,
                        "unit": "g"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 154.2214058,
                        "unit": "mg"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 1570.9880967879,
                        "unit": "mg"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 336.25455860035004,
                        "unit": "mg"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 272.45963136369994,
                        "unit": "mg"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 3605.5934117829,
                        "unit": "mg"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 12.57883793387,
                        "unit": "mg"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 13.534633277334503,
                        "unit": "mg"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 1102.7150490411,
                        "unit": "mg"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 3.1681568879000004,
                        "unit": "µg"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 74.623682718945,
                        "unit": "mg"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 0.8051282169185,
                        "unit": "mg"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 1.5518731353789998,
                        "unit": "mg"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 24.59071066649,
                        "unit": "mg"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 2.18472158943985,
                        "unit": "mg"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 790.3931697516,
                        "unit": "µg"
                    },
                    "FOLFD": {
                        "label": "Folate (food)",
                        "quantity": 790.3931697516,
                        "unit": "µg"
                    },
                    "FOLAC": {
                        "label": "Folic acid",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 2.6761949830000002,
                        "unit": "µg"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 0.22679618500000004,
                        "unit": "µg"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 6.794124668169001,
                        "unit": "mg"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 95.24179747137,
                        "unit": "µg"
                    },
                    "WATER": {
                        "label": "Water",
                        "quantity": 1239.737843564027,
                        "unit": "g"
                    }
                },
                "totalDaily": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 53.025802928425,
                        "unit": "%"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 89.46618373121538,
                        "unit": "%"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 59.46101187658452,
                        "unit": "%"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 18.872995599744332,
                        "unit": "%"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 68.50367857224,
                        "unit": "%"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 177.50301073552998,
                        "unit": "%"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 51.40713526666667,
                        "unit": "%"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 65.45783736616251,
                        "unit": "%"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 33.625455860035004,
                        "unit": "%"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 64.87134080088094,
                        "unit": "%"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 76.71475344218936,
                        "unit": "%"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 69.88243296594445,
                        "unit": "%"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 123.04212070304094,
                        "unit": "%"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 157.5307212915857,
                        "unit": "%"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 0.3520174319888889,
                        "unit": "%"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 82.91520302105,
                        "unit": "%"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 67.09401807654167,
                        "unit": "%"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 119.37485656761538,
                        "unit": "%"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 153.6919416655625,
                        "unit": "%"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 168.05550687998846,
                        "unit": "%"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 197.59829243790003,
                        "unit": "%"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 111.50812429166669,
                        "unit": "%"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 1.5119745666666669,
                        "unit": "%"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 45.29416445446,
                        "unit": "%"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 79.368164559475,
                        "unit": "%"
                    }
                },
                "digest": [
                    {
                        "label": "Fat",
                        "tag": "FAT",
                        "schemaOrgTag": "fatContent",
                        "total": 58.15301942529,
                        "hasRDI": true,
                        "daily": 89.46618373121538,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Saturated",
                                "tag": "FASAT",
                                "schemaOrgTag": "saturatedFatContent",
                                "total": 11.892202375316904,
                                "hasRDI": true,
                                "daily": 59.46101187658452,
                                "unit": "g"
                            },
                            {
                                "label": "Trans",
                                "tag": "FATRN",
                                "schemaOrgTag": "transFatContent",
                                "total": 0,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Monounsaturated",
                                "tag": "FAMS",
                                "schemaOrgTag": null,
                                "total": 27.741503543435048,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Polyunsaturated",
                                "tag": "FAPU",
                                "schemaOrgTag": null,
                                "total": 3.7748265341672504,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Carbs",
                        "tag": "CHOCDF",
                        "schemaOrgTag": "carbohydrateContent",
                        "total": 56.618986799233,
                        "hasRDI": true,
                        "daily": 18.872995599744332,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Carbs (net)",
                                "tag": "CHOCDF.net",
                                "schemaOrgTag": null,
                                "total": 39.493067156173,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Fiber",
                                "tag": "FIBTG",
                                "schemaOrgTag": "fiberContent",
                                "total": 17.12591964306,
                                "hasRDI": true,
                                "daily": 68.50367857224,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars",
                                "tag": "SUGAR",
                                "schemaOrgTag": "sugarContent",
                                "total": 15.3228925702755,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars, added",
                                "tag": "SUGAR.added",
                                "schemaOrgTag": null,
                                "total": 0,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Protein",
                        "tag": "PROCNT",
                        "schemaOrgTag": "proteinContent",
                        "total": 88.75150536776499,
                        "hasRDI": true,
                        "daily": 177.50301073552998,
                        "unit": "g"
                    },
                    {
                        "label": "Cholesterol",
                        "tag": "CHOLE",
                        "schemaOrgTag": "cholesterolContent",
                        "total": 154.2214058,
                        "hasRDI": true,
                        "daily": 51.40713526666667,
                        "unit": "mg"
                    },
                    {
                        "label": "Sodium",
                        "tag": "NA",
                        "schemaOrgTag": "sodiumContent",
                        "total": 1570.9880967879,
                        "hasRDI": true,
                        "daily": 65.45783736616251,
                        "unit": "mg"
                    },
                    {
                        "label": "Calcium",
                        "tag": "CA",
                        "schemaOrgTag": null,
                        "total": 336.25455860035004,
                        "hasRDI": true,
                        "daily": 33.625455860035004,
                        "unit": "mg"
                    },
                    {
                        "label": "Magnesium",
                        "tag": "MG",
                        "schemaOrgTag": null,
                        "total": 272.45963136369994,
                        "hasRDI": true,
                        "daily": 64.87134080088094,
                        "unit": "mg"
                    },
                    {
                        "label": "Potassium",
                        "tag": "K",
                        "schemaOrgTag": null,
                        "total": 3605.5934117829,
                        "hasRDI": true,
                        "daily": 76.71475344218936,
                        "unit": "mg"
                    },
                    {
                        "label": "Iron",
                        "tag": "FE",
                        "schemaOrgTag": null,
                        "total": 12.57883793387,
                        "hasRDI": true,
                        "daily": 69.88243296594445,
                        "unit": "mg"
                    },
                    {
                        "label": "Zinc",
                        "tag": "ZN",
                        "schemaOrgTag": null,
                        "total": 13.534633277334503,
                        "hasRDI": true,
                        "daily": 123.04212070304094,
                        "unit": "mg"
                    },
                    {
                        "label": "Phosphorus",
                        "tag": "P",
                        "schemaOrgTag": null,
                        "total": 1102.7150490411,
                        "hasRDI": true,
                        "daily": 157.5307212915857,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin A",
                        "tag": "VITA_RAE",
                        "schemaOrgTag": null,
                        "total": 3.1681568879000004,
                        "hasRDI": true,
                        "daily": 0.3520174319888889,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin C",
                        "tag": "VITC",
                        "schemaOrgTag": null,
                        "total": 74.623682718945,
                        "hasRDI": true,
                        "daily": 82.91520302105,
                        "unit": "mg"
                    },
                    {
                        "label": "Thiamin (B1)",
                        "tag": "THIA",
                        "schemaOrgTag": null,
                        "total": 0.8051282169185,
                        "hasRDI": true,
                        "daily": 67.09401807654167,
                        "unit": "mg"
                    },
                    {
                        "label": "Riboflavin (B2)",
                        "tag": "RIBF",
                        "schemaOrgTag": null,
                        "total": 1.5518731353789998,
                        "hasRDI": true,
                        "daily": 119.37485656761538,
                        "unit": "mg"
                    },
                    {
                        "label": "Niacin (B3)",
                        "tag": "NIA",
                        "schemaOrgTag": null,
                        "total": 24.59071066649,
                        "hasRDI": true,
                        "daily": 153.6919416655625,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin B6",
                        "tag": "VITB6A",
                        "schemaOrgTag": null,
                        "total": 2.18472158943985,
                        "hasRDI": true,
                        "daily": 168.05550687998846,
                        "unit": "mg"
                    },
                    {
                        "label": "Folate equivalent (total)",
                        "tag": "FOLDFE",
                        "schemaOrgTag": null,
                        "total": 790.3931697516,
                        "hasRDI": true,
                        "daily": 197.59829243790003,
                        "unit": "µg"
                    },
                    {
                        "label": "Folate (food)",
                        "tag": "FOLFD",
                        "schemaOrgTag": null,
                        "total": 790.3931697516,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Folic acid",
                        "tag": "FOLAC",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin B12",
                        "tag": "VITB12",
                        "schemaOrgTag": null,
                        "total": 2.6761949830000002,
                        "hasRDI": true,
                        "daily": 111.50812429166669,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin D",
                        "tag": "VITD",
                        "schemaOrgTag": null,
                        "total": 0.22679618500000004,
                        "hasRDI": true,
                        "daily": 1.5119745666666669,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin E",
                        "tag": "TOCPHA",
                        "schemaOrgTag": null,
                        "total": 6.794124668169001,
                        "hasRDI": true,
                        "daily": 45.29416445446,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin K",
                        "tag": "VITK1",
                        "schemaOrgTag": null,
                        "total": 95.24179747137,
                        "hasRDI": true,
                        "daily": 79.368164559475,
                        "unit": "µg"
                    },
                    {
                        "label": "Sugar alcohols",
                        "tag": "Sugar.alcohol",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    },
                    {
                        "label": "Water",
                        "tag": "WATER",
                        "schemaOrgTag": null,
                        "total": 1239.737843564027,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    }
                ]
            },
            "_links": {
                "self": {
                    "href": "https://api.edamam.com/api/recipes/v2/fb3b9d088cb51202c3a0510ffd0f8556?type=public&app_id=ea1d37d5&app_key=fd382a172ba8d6668c0430dc9c14a181",
                    "title": "Self"
                }
            }
        },
        {
            "recipe": {
                "uri": "http://www.edamam.com/ontologies/edamam.owl#recipe_54197d5c51861eb539d4a8c2f59efbc8",
                "label": "Hachee - Dutch Beef Stew",
                "image": "https://www.edamam.com/web-img/bf3/bf3783ccb2c4c7e4a97ef81652f5be6b.jpg",
                "source": "Honest Cooking",
                "url": "http://honestcooking.com/hachee-dutch-beef-stew-recipe/",
                "shareAs": "http://www.edamam.com/recipe/hachee-dutch-beef-stew-54197d5c51861eb539d4a8c2f59efbc8/beef",
                "yield": 4,
                "dietLabels": [
                    "Low-Carb"
                ],
                "healthLabels": [
                    "Egg-Free",
                    "Peanut-Free",
                    "Tree-Nut-Free",
                    "Soy-Free",
                    "Fish-Free",
                    "Shellfish-Free",
                    "Pork-Free",
                    "Crustacean-Free",
                    "Celery-Free",
                    "Mustard-Free",
                    "Sesame-Free",
                    "Lupine-Free",
                    "Mollusk-Free",
                    "Alcohol-Free",
                    "Sulfite-Free"
                ],
                "cautions": [
                    "Gluten",
                    "Wheat",
                    "Sulfites"
                ],
                "ingredientLines": [
                    "50 g butter",
                    "600 g beef (suitable for stewing), cubed",
                    "3 large onions, chopped",
                    "2 tbsp flour",
                    "1 beef stock cube",
                    "3 tbsp red wine vinegar",
                    "3 bay leaves",
                    "4 cloves",
                    "Salt and pepper"
                ],
                "ingredients": [
                    {
                        "text": "50 g butter",
                        "weight": 50,
                        "foodCategory": "Dairy",
                        "foodId": "food_awz3iefajbk1fwahq9logahmgltj",
                        "image": "https://www.edamam.com/food-img/713/71397239b670d88c04faa8d05035cab4.jpg"
                    },
                    {
                        "text": "600 g beef (suitable for stewing), cubed",
                        "weight": 600,
                        "foodCategory": "meats",
                        "foodId": "food_bknby1la98smrsbwnthinbam42nj",
                        "image": "https://www.edamam.com/food-img/bab/bab88ab3ea40d34e4c8ae35d6b30344a.jpg"
                    },
                    {
                        "text": "3 large onions, chopped",
                        "weight": 450,
                        "foodCategory": "vegetables",
                        "foodId": "food_bmrvi4ob4binw9a5m7l07amlfcoy",
                        "image": "https://www.edamam.com/food-img/205/205e6bf2399b85d34741892ef91cc603.jpg"
                    },
                    {
                        "text": "2 tbsp flour",
                        "weight": 15.624999999735829,
                        "foodCategory": "grains",
                        "foodId": "food_ahebfs0a985an4aubqaebbipra58",
                        "image": "https://www.edamam.com/food-img/b4c/b4c739e76a6f2172b7ad49d0aa41d5aa.jpg"
                    },
                    {
                        "text": "1 beef stock cube",
                        "weight": 3.6,
                        "foodCategory": "canned soup",
                        "foodId": "food_ap9dxwla8dska7bcd54orbisfahg",
                        "image": null
                    },
                    {
                        "text": "3 tbsp red wine vinegar",
                        "weight": 44.7,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_ad6iyy1anmzb49a817rgnabnz8c9",
                        "image": "https://www.edamam.com/food-img/dc8/dc8e998b32b8d45ba15c1b1e6711e958.jpg"
                    },
                    {
                        "text": "3 bay leaves",
                        "weight": 1.7999999999999998,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_asx39x4ayja4jab6ivj6zayvkblo",
                        "image": "https://www.edamam.com/food-img/0f9/0f9f5f95df173e9ffaaff2977bef88f3.jpg"
                    },
                    {
                        "text": "4 cloves",
                        "weight": 0.6,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_abb00nxbw761ggavcuto7b3mw1s0",
                        "image": "https://www.edamam.com/food-img/8bc/8bc63f9742815a245d37e5f346674ca4.jpg"
                    },
                    {
                        "text": "Salt and pepper",
                        "weight": 6.997949999998414,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_btxz81db72hwbra2pncvebzzzum9",
                        "image": "https://www.edamam.com/food-img/694/6943ea510918c6025795e8dc6e6eaaeb.jpg"
                    },
                    {
                        "text": "Salt and pepper",
                        "weight": 3.498974999999207,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_b6ywzluaaxv02wad7s1r9ag4py89",
                        "image": "https://www.edamam.com/food-img/c6e/c6e5c3bd8d3bc15175d9766971a4d1b2.jpg"
                    }
                ],
                "calories": 1406.0484272490362,
                "totalWeight": 1173.3129010598577,
                "totalTime": 210,
                "cuisineType": [
                    "central europe"
                ],
                "mealType": [
                    "lunch/dinner"
                ],
                "dishType": [
                    "main course"
                ],
                "totalNutrients": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 1406.0484272490362,
                        "unit": "kcal"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 70.5046715849974,
                        "unit": "g"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 38.01031648199959,
                        "unit": "g"
                    },
                    "FATRN": {
                        "label": "Trans",
                        "quantity": 3.140524,
                        "unit": "g"
                    },
                    "FAMS": {
                        "label": "Monounsaturated",
                        "quantity": 25.766449175249768,
                        "unit": "g"
                    },
                    "FAPU": {
                        "label": "Polyunsaturated",
                        "quantity": 3.626067020498901,
                        "unit": "g"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 59.38396201229791,
                        "unit": "g"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 9.633915674992666,
                        "unit": "g"
                    },
                    "SUGAR": {
                        "label": "Sugars",
                        "quantity": 19.711220939999283,
                        "unit": "g"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 138.0060860024726,
                        "unit": "g"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 485.644,
                        "unit": "mg"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 2720.4022573823836,
                        "unit": "mg"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 235.82755150438632,
                        "unit": "mg"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 188.75763651054177,
                        "unit": "mg"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 3018.082241834516,
                        "unit": "mg"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 15.155486428495237,
                        "unit": "mg"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 33.52599172855827,
                        "unit": "mg"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 1481.2373804997135,
                        "unit": "mg"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 360.5547232499998,
                        "unit": "µg"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 34.361700000000006,
                        "unit": "mg"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 0.720338892999682,
                        "unit": "mg"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 1.1885861549998928,
                        "unit": "mg"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 30.26455578424669,
                        "unit": "mg"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 4.007423017249881,
                        "unit": "mg"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 114.19932574993119,
                        "unit": "µg"
                    },
                    "FOLFD": {
                        "label": "Folate (food)",
                        "quantity": 114.19932574993119,
                        "unit": "µg"
                    },
                    "FOLAC": {
                        "label": "Folic acid",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 13.741000000000001,
                        "unit": "µg"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 1.35,
                        "unit": "µg"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 2.4286843399998332,
                        "unit": "mg"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 20.92549707499791,
                        "unit": "µg"
                    },
                    "WATER": {
                        "label": "Water",
                        "quantity": 888.6944801370886,
                        "unit": "g"
                    }
                },
                "totalDaily": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 70.30242136245181,
                        "unit": "%"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 108.46872551538061,
                        "unit": "%"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 190.05158240999793,
                        "unit": "%"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 19.794654004099304,
                        "unit": "%"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 38.535662699970665,
                        "unit": "%"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 276.0121720049452,
                        "unit": "%"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 161.88133333333334,
                        "unit": "%"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 113.35009405759932,
                        "unit": "%"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 23.582755150438633,
                        "unit": "%"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 44.94229440727185,
                        "unit": "%"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 64.21451578371311,
                        "unit": "%"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 84.19714682497354,
                        "unit": "%"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 304.78174298689333,
                        "unit": "%"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 211.60534007138764,
                        "unit": "%"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 40.061635916666646,
                        "unit": "%"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 38.17966666666667,
                        "unit": "%"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 60.02824108330683,
                        "unit": "%"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 91.42970423076099,
                        "unit": "%"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 189.15347365154182,
                        "unit": "%"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 308.2633090192216,
                        "unit": "%"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 28.549831437482798,
                        "unit": "%"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 572.5416666666667,
                        "unit": "%"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 9,
                        "unit": "%"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 16.191228933332223,
                        "unit": "%"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 17.437914229164925,
                        "unit": "%"
                    }
                },
                "digest": [
                    {
                        "label": "Fat",
                        "tag": "FAT",
                        "schemaOrgTag": "fatContent",
                        "total": 70.5046715849974,
                        "hasRDI": true,
                        "daily": 108.46872551538061,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Saturated",
                                "tag": "FASAT",
                                "schemaOrgTag": "saturatedFatContent",
                                "total": 38.01031648199959,
                                "hasRDI": true,
                                "daily": 190.05158240999793,
                                "unit": "g"
                            },
                            {
                                "label": "Trans",
                                "tag": "FATRN",
                                "schemaOrgTag": "transFatContent",
                                "total": 3.140524,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Monounsaturated",
                                "tag": "FAMS",
                                "schemaOrgTag": null,
                                "total": 25.766449175249768,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Polyunsaturated",
                                "tag": "FAPU",
                                "schemaOrgTag": null,
                                "total": 3.626067020498901,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Carbs",
                        "tag": "CHOCDF",
                        "schemaOrgTag": "carbohydrateContent",
                        "total": 59.38396201229791,
                        "hasRDI": true,
                        "daily": 19.794654004099304,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Carbs (net)",
                                "tag": "CHOCDF.net",
                                "schemaOrgTag": null,
                                "total": 49.75004633730524,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Fiber",
                                "tag": "FIBTG",
                                "schemaOrgTag": "fiberContent",
                                "total": 9.633915674992666,
                                "hasRDI": true,
                                "daily": 38.535662699970665,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars",
                                "tag": "SUGAR",
                                "schemaOrgTag": "sugarContent",
                                "total": 19.711220939999283,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars, added",
                                "tag": "SUGAR.added",
                                "schemaOrgTag": null,
                                "total": 0,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Protein",
                        "tag": "PROCNT",
                        "schemaOrgTag": "proteinContent",
                        "total": 138.0060860024726,
                        "hasRDI": true,
                        "daily": 276.0121720049452,
                        "unit": "g"
                    },
                    {
                        "label": "Cholesterol",
                        "tag": "CHOLE",
                        "schemaOrgTag": "cholesterolContent",
                        "total": 485.644,
                        "hasRDI": true,
                        "daily": 161.88133333333334,
                        "unit": "mg"
                    },
                    {
                        "label": "Sodium",
                        "tag": "NA",
                        "schemaOrgTag": "sodiumContent",
                        "total": 2720.4022573823836,
                        "hasRDI": true,
                        "daily": 113.35009405759932,
                        "unit": "mg"
                    },
                    {
                        "label": "Calcium",
                        "tag": "CA",
                        "schemaOrgTag": null,
                        "total": 235.82755150438632,
                        "hasRDI": true,
                        "daily": 23.582755150438633,
                        "unit": "mg"
                    },
                    {
                        "label": "Magnesium",
                        "tag": "MG",
                        "schemaOrgTag": null,
                        "total": 188.75763651054177,
                        "hasRDI": true,
                        "daily": 44.94229440727185,
                        "unit": "mg"
                    },
                    {
                        "label": "Potassium",
                        "tag": "K",
                        "schemaOrgTag": null,
                        "total": 3018.082241834516,
                        "hasRDI": true,
                        "daily": 64.21451578371311,
                        "unit": "mg"
                    },
                    {
                        "label": "Iron",
                        "tag": "FE",
                        "schemaOrgTag": null,
                        "total": 15.155486428495237,
                        "hasRDI": true,
                        "daily": 84.19714682497354,
                        "unit": "mg"
                    },
                    {
                        "label": "Zinc",
                        "tag": "ZN",
                        "schemaOrgTag": null,
                        "total": 33.52599172855827,
                        "hasRDI": true,
                        "daily": 304.78174298689333,
                        "unit": "mg"
                    },
                    {
                        "label": "Phosphorus",
                        "tag": "P",
                        "schemaOrgTag": null,
                        "total": 1481.2373804997135,
                        "hasRDI": true,
                        "daily": 211.60534007138764,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin A",
                        "tag": "VITA_RAE",
                        "schemaOrgTag": null,
                        "total": 360.5547232499998,
                        "hasRDI": true,
                        "daily": 40.061635916666646,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin C",
                        "tag": "VITC",
                        "schemaOrgTag": null,
                        "total": 34.361700000000006,
                        "hasRDI": true,
                        "daily": 38.17966666666667,
                        "unit": "mg"
                    },
                    {
                        "label": "Thiamin (B1)",
                        "tag": "THIA",
                        "schemaOrgTag": null,
                        "total": 0.720338892999682,
                        "hasRDI": true,
                        "daily": 60.02824108330683,
                        "unit": "mg"
                    },
                    {
                        "label": "Riboflavin (B2)",
                        "tag": "RIBF",
                        "schemaOrgTag": null,
                        "total": 1.1885861549998928,
                        "hasRDI": true,
                        "daily": 91.42970423076099,
                        "unit": "mg"
                    },
                    {
                        "label": "Niacin (B3)",
                        "tag": "NIA",
                        "schemaOrgTag": null,
                        "total": 30.26455578424669,
                        "hasRDI": true,
                        "daily": 189.15347365154182,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin B6",
                        "tag": "VITB6A",
                        "schemaOrgTag": null,
                        "total": 4.007423017249881,
                        "hasRDI": true,
                        "daily": 308.2633090192216,
                        "unit": "mg"
                    },
                    {
                        "label": "Folate equivalent (total)",
                        "tag": "FOLDFE",
                        "schemaOrgTag": null,
                        "total": 114.19932574993119,
                        "hasRDI": true,
                        "daily": 28.549831437482798,
                        "unit": "µg"
                    },
                    {
                        "label": "Folate (food)",
                        "tag": "FOLFD",
                        "schemaOrgTag": null,
                        "total": 114.19932574993119,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Folic acid",
                        "tag": "FOLAC",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin B12",
                        "tag": "VITB12",
                        "schemaOrgTag": null,
                        "total": 13.741000000000001,
                        "hasRDI": true,
                        "daily": 572.5416666666667,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin D",
                        "tag": "VITD",
                        "schemaOrgTag": null,
                        "total": 1.35,
                        "hasRDI": true,
                        "daily": 9,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin E",
                        "tag": "TOCPHA",
                        "schemaOrgTag": null,
                        "total": 2.4286843399998332,
                        "hasRDI": true,
                        "daily": 16.191228933332223,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin K",
                        "tag": "VITK1",
                        "schemaOrgTag": null,
                        "total": 20.92549707499791,
                        "hasRDI": true,
                        "daily": 17.437914229164925,
                        "unit": "µg"
                    },
                    {
                        "label": "Sugar alcohols",
                        "tag": "Sugar.alcohol",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    },
                    {
                        "label": "Water",
                        "tag": "WATER",
                        "schemaOrgTag": null,
                        "total": 888.6944801370886,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    }
                ]
            },
            "_links": {
                "self": {
                    "href": "https://api.edamam.com/api/recipes/v2/54197d5c51861eb539d4a8c2f59efbc8?type=public&app_id=ea1d37d5&app_key=fd382a172ba8d6668c0430dc9c14a181",
                    "title": "Self"
                }
            }
        },
        {
            "recipe": {
                "uri": "http://www.edamam.com/ontologies/edamam.owl#recipe_14c68e61108cc0829ee6ef279f79b860",
                "label": "Portabello Beef Stew",
                "image": "https://www.edamam.com/web-img/72f/72fd32d089fdc211a0b35a7e41ed47e2.JPG",
                "source": "Food52",
                "url": "https://food52.com/recipes/14484-portabello-beef-stew",
                "shareAs": "http://www.edamam.com/recipe/portabello-beef-stew-14c68e61108cc0829ee6ef279f79b860/beef",
                "yield": 3,
                "dietLabels": [],
                "healthLabels": [
                    "Dairy-Free",
                    "Egg-Free",
                    "Peanut-Free",
                    "Tree-Nut-Free",
                    "Soy-Free",
                    "Fish-Free",
                    "Shellfish-Free",
                    "Pork-Free",
                    "Crustacean-Free",
                    "Celery-Free",
                    "Mustard-Free",
                    "Sesame-Free",
                    "Lupine-Free",
                    "Mollusk-Free",
                    "Kosher"
                ],
                "cautions": [
                    "Gluten",
                    "Wheat",
                    "Sulfites"
                ],
                "ingredientLines": [
                    "1 pound beef stew meat",
                    "2 tablespoons flour",
                    "1 onion, sliced",
                    "1 teaspoon dried thyme",
                    "1/2 cup red wine",
                    "15 ounces beef broth (1 can)",
                    "2 carrots, sliced",
                    "10 ounces baby portabello mushrooms"
                ],
                "ingredients": [
                    {
                        "text": "1 pound beef stew meat",
                        "weight": 453.59237,
                        "foodCategory": "meats",
                        "foodId": "food_bknby1la98smrsbwnthinbam42nj",
                        "image": "https://www.edamam.com/food-img/bab/bab88ab3ea40d34e4c8ae35d6b30344a.jpg"
                    },
                    {
                        "text": "2 tablespoons flour",
                        "weight": 15.624999999735829,
                        "foodCategory": "grains",
                        "foodId": "food_ahebfs0a985an4aubqaebbipra58",
                        "image": "https://www.edamam.com/food-img/b4c/b4c739e76a6f2172b7ad49d0aa41d5aa.jpg"
                    },
                    {
                        "text": "1 onion, sliced",
                        "weight": 125,
                        "foodCategory": "vegetables",
                        "foodId": "food_bmrvi4ob4binw9a5m7l07amlfcoy",
                        "image": "https://www.edamam.com/food-img/205/205e6bf2399b85d34741892ef91cc603.jpg"
                    },
                    {
                        "text": "1 teaspoon dried thyme",
                        "weight": 1,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_avsq22zadwyb5cb5sl1byaa4mbo8",
                        "image": "https://www.edamam.com/food-img/89b/89b37a04e46e052671d73addcb84aa51.jpg"
                    },
                    {
                        "text": "1/2 cup red wine",
                        "weight": 117.6,
                        "foodCategory": "wines",
                        "foodId": "food_b5q0xv2ba8la5hbzdfzdgaca3fwu",
                        "image": "https://www.edamam.com/food-img/82b/82b8d0db2d5c38fc7498a657c0afc4ee.JPG"
                    },
                    {
                        "text": "15 ounces beef broth (1 can)",
                        "weight": 450.00000000000006,
                        "foodCategory": "canned soup",
                        "foodId": "food_a4blma9bmbzb9aa6dt0qmbzeb1o1",
                        "image": "https://www.edamam.com/food-img/6f7/6f71425571cb38887c2287f9860d33bd.jpg"
                    },
                    {
                        "text": "2 carrots, sliced",
                        "weight": 122,
                        "foodCategory": "vegetables",
                        "foodId": "food_ai215e5b85pdh5ajd4aafa3w2zm8",
                        "image": "https://www.edamam.com/food-img/121/121e33fce0bb9546ed7d060b6c114e29.jpg"
                    },
                    {
                        "text": "10 ounces baby portabello mushrooms",
                        "weight": 283.49523125,
                        "foodCategory": "vegetables",
                        "foodId": "food_bikaydza0r1y3ja1c2nxxbqnynlg",
                        "image": "https://www.edamam.com/food-img/245/2457f8850f43817dfeb967825467ef1e.jpg"
                    }
                ],
                "calories": 943.1540318740385,
                "totalWeight": 1568.312601249736,
                "totalTime": 195,
                "cuisineType": [
                    "chinese"
                ],
                "mealType": [
                    "lunch/dinner"
                ],
                "dishType": [
                    "main course"
                ],
                "totalNutrients": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 943.1540318740385,
                        "unit": "kcal"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 24.445251306372416,
                        "unit": "g"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 9.831672204349593,
                        "unit": "g"
                    },
                    "FATRN": {
                        "label": "Trans",
                        "quantity": 1.1453207342500002,
                        "unit": "g"
                    },
                    "FAMS": {
                        "label": "Monounsaturated",
                        "quantity": 11.898491283249768,
                        "unit": "g"
                    },
                    "FAPU": {
                        "label": "Polyunsaturated",
                        "quantity": 2.0232470175614092,
                        "unit": "g"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 50.69037379317341,
                        "unit": "g"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 10.018313006242867,
                        "unit": "g"
                    },
                    "SUGAR": {
                        "label": "Sugars",
                        "quantity": 18.958588281249288,
                        "unit": "g"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 113.56622074734773,
                        "unit": "g"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 285.7631931,
                        "unit": "mg"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 2152.599043112495,
                        "unit": "mg"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 194.13361503746037,
                        "unit": "mg"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 151.14389769994187,
                        "unit": "mg"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 3713.9329318497175,
                        "unit": "mg"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 13.712188249871911,
                        "unit": "mg"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 26.882986942623152,
                        "unit": "mg"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 1473.8532926497148,
                        "unit": "mg"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 1029.6718474,
                        "unit": "µg"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 16.948,
                        "unit": "mg"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 0.7069160824371831,
                        "unit": "mg"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 1.3853568296248948,
                        "unit": "mg"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 40.269731314271695,
                        "unit": "mg"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 3.4387446038498837,
                        "unit": "mg"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 156.8949358499313,
                        "unit": "µg"
                    },
                    "FOLFD": {
                        "label": "Folate (food)",
                        "quantity": 156.8949358499313,
                        "unit": "µg"
                    },
                    "FOLAC": {
                        "label": "Folic acid",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 10.753294414625001,
                        "unit": "µg"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 1.30407806375,
                        "unit": "µg"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 1.7875403122498417,
                        "unit": "mg"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 41.07016054999921,
                        "unit": "µg"
                    },
                    "WATER": {
                        "label": "Water",
                        "quantity": 1352.9072156302186,
                        "unit": "g"
                    }
                },
                "totalDaily": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 47.15770159370192,
                        "unit": "%"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 37.60807893288064,
                        "unit": "%"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 49.158361021747965,
                        "unit": "%"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 16.896791264391133,
                        "unit": "%"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 40.07325202497147,
                        "unit": "%"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 227.13244149469546,
                        "unit": "%"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 95.25439770000001,
                        "unit": "%"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 89.69162679635396,
                        "unit": "%"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 19.413361503746035,
                        "unit": "%"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 35.986642309509975,
                        "unit": "%"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 79.01984961382377,
                        "unit": "%"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 76.1788236103995,
                        "unit": "%"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 244.3907903874832,
                        "unit": "%"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 210.5504703785307,
                        "unit": "%"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 114.40798304444444,
                        "unit": "%"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 18.83111111111111,
                        "unit": "%"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 58.909673536431924,
                        "unit": "%"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 106.56590997114576,
                        "unit": "%"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 251.6858207141981,
                        "unit": "%"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 264.51881568076027,
                        "unit": "%"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 39.223733962482825,
                        "unit": "%"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 448.05393394270845,
                        "unit": "%"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 8.693853758333335,
                        "unit": "%"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 11.916935414998944,
                        "unit": "%"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 34.22513379166601,
                        "unit": "%"
                    }
                },
                "digest": [
                    {
                        "label": "Fat",
                        "tag": "FAT",
                        "schemaOrgTag": "fatContent",
                        "total": 24.445251306372416,
                        "hasRDI": true,
                        "daily": 37.60807893288064,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Saturated",
                                "tag": "FASAT",
                                "schemaOrgTag": "saturatedFatContent",
                                "total": 9.831672204349593,
                                "hasRDI": true,
                                "daily": 49.158361021747965,
                                "unit": "g"
                            },
                            {
                                "label": "Trans",
                                "tag": "FATRN",
                                "schemaOrgTag": "transFatContent",
                                "total": 1.1453207342500002,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Monounsaturated",
                                "tag": "FAMS",
                                "schemaOrgTag": null,
                                "total": 11.898491283249768,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Polyunsaturated",
                                "tag": "FAPU",
                                "schemaOrgTag": null,
                                "total": 2.0232470175614092,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Carbs",
                        "tag": "CHOCDF",
                        "schemaOrgTag": "carbohydrateContent",
                        "total": 50.69037379317341,
                        "hasRDI": true,
                        "daily": 16.896791264391133,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Carbs (net)",
                                "tag": "CHOCDF.net",
                                "schemaOrgTag": null,
                                "total": 40.672060786930544,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Fiber",
                                "tag": "FIBTG",
                                "schemaOrgTag": "fiberContent",
                                "total": 10.018313006242867,
                                "hasRDI": true,
                                "daily": 40.07325202497147,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars",
                                "tag": "SUGAR",
                                "schemaOrgTag": "sugarContent",
                                "total": 18.958588281249288,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars, added",
                                "tag": "SUGAR.added",
                                "schemaOrgTag": null,
                                "total": 0,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Protein",
                        "tag": "PROCNT",
                        "schemaOrgTag": "proteinContent",
                        "total": 113.56622074734773,
                        "hasRDI": true,
                        "daily": 227.13244149469546,
                        "unit": "g"
                    },
                    {
                        "label": "Cholesterol",
                        "tag": "CHOLE",
                        "schemaOrgTag": "cholesterolContent",
                        "total": 285.7631931,
                        "hasRDI": true,
                        "daily": 95.25439770000001,
                        "unit": "mg"
                    },
                    {
                        "label": "Sodium",
                        "tag": "NA",
                        "schemaOrgTag": "sodiumContent",
                        "total": 2152.599043112495,
                        "hasRDI": true,
                        "daily": 89.69162679635396,
                        "unit": "mg"
                    },
                    {
                        "label": "Calcium",
                        "tag": "CA",
                        "schemaOrgTag": null,
                        "total": 194.13361503746037,
                        "hasRDI": true,
                        "daily": 19.413361503746035,
                        "unit": "mg"
                    },
                    {
                        "label": "Magnesium",
                        "tag": "MG",
                        "schemaOrgTag": null,
                        "total": 151.14389769994187,
                        "hasRDI": true,
                        "daily": 35.986642309509975,
                        "unit": "mg"
                    },
                    {
                        "label": "Potassium",
                        "tag": "K",
                        "schemaOrgTag": null,
                        "total": 3713.9329318497175,
                        "hasRDI": true,
                        "daily": 79.01984961382377,
                        "unit": "mg"
                    },
                    {
                        "label": "Iron",
                        "tag": "FE",
                        "schemaOrgTag": null,
                        "total": 13.712188249871911,
                        "hasRDI": true,
                        "daily": 76.1788236103995,
                        "unit": "mg"
                    },
                    {
                        "label": "Zinc",
                        "tag": "ZN",
                        "schemaOrgTag": null,
                        "total": 26.882986942623152,
                        "hasRDI": true,
                        "daily": 244.3907903874832,
                        "unit": "mg"
                    },
                    {
                        "label": "Phosphorus",
                        "tag": "P",
                        "schemaOrgTag": null,
                        "total": 1473.8532926497148,
                        "hasRDI": true,
                        "daily": 210.5504703785307,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin A",
                        "tag": "VITA_RAE",
                        "schemaOrgTag": null,
                        "total": 1029.6718474,
                        "hasRDI": true,
                        "daily": 114.40798304444444,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin C",
                        "tag": "VITC",
                        "schemaOrgTag": null,
                        "total": 16.948,
                        "hasRDI": true,
                        "daily": 18.83111111111111,
                        "unit": "mg"
                    },
                    {
                        "label": "Thiamin (B1)",
                        "tag": "THIA",
                        "schemaOrgTag": null,
                        "total": 0.7069160824371831,
                        "hasRDI": true,
                        "daily": 58.909673536431924,
                        "unit": "mg"
                    },
                    {
                        "label": "Riboflavin (B2)",
                        "tag": "RIBF",
                        "schemaOrgTag": null,
                        "total": 1.3853568296248948,
                        "hasRDI": true,
                        "daily": 106.56590997114576,
                        "unit": "mg"
                    },
                    {
                        "label": "Niacin (B3)",
                        "tag": "NIA",
                        "schemaOrgTag": null,
                        "total": 40.269731314271695,
                        "hasRDI": true,
                        "daily": 251.6858207141981,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin B6",
                        "tag": "VITB6A",
                        "schemaOrgTag": null,
                        "total": 3.4387446038498837,
                        "hasRDI": true,
                        "daily": 264.51881568076027,
                        "unit": "mg"
                    },
                    {
                        "label": "Folate equivalent (total)",
                        "tag": "FOLDFE",
                        "schemaOrgTag": null,
                        "total": 156.8949358499313,
                        "hasRDI": true,
                        "daily": 39.223733962482825,
                        "unit": "µg"
                    },
                    {
                        "label": "Folate (food)",
                        "tag": "FOLFD",
                        "schemaOrgTag": null,
                        "total": 156.8949358499313,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Folic acid",
                        "tag": "FOLAC",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin B12",
                        "tag": "VITB12",
                        "schemaOrgTag": null,
                        "total": 10.753294414625001,
                        "hasRDI": true,
                        "daily": 448.05393394270845,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin D",
                        "tag": "VITD",
                        "schemaOrgTag": null,
                        "total": 1.30407806375,
                        "hasRDI": true,
                        "daily": 8.693853758333335,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin E",
                        "tag": "TOCPHA",
                        "schemaOrgTag": null,
                        "total": 1.7875403122498417,
                        "hasRDI": true,
                        "daily": 11.916935414998944,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin K",
                        "tag": "VITK1",
                        "schemaOrgTag": null,
                        "total": 41.07016054999921,
                        "hasRDI": true,
                        "daily": 34.22513379166601,
                        "unit": "µg"
                    },
                    {
                        "label": "Sugar alcohols",
                        "tag": "Sugar.alcohol",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    },
                    {
                        "label": "Water",
                        "tag": "WATER",
                        "schemaOrgTag": null,
                        "total": 1352.9072156302186,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    }
                ]
            },
            "_links": {
                "self": {
                    "href": "https://api.edamam.com/api/recipes/v2/14c68e61108cc0829ee6ef279f79b860?type=public&app_id=ea1d37d5&app_key=fd382a172ba8d6668c0430dc9c14a181",
                    "title": "Self"
                }
            }
        },
        {
            "recipe": {
                "uri": "http://www.edamam.com/ontologies/edamam.owl#recipe_7b4793955f7d5f6c61e2e16b95c5d714",
                "label": "Beef Goulash",
                "image": "https://www.edamam.com/web-img/229/2292adfebf71a994fc515cd5895012fe.jpg",
                "source": "Martha Stewart",
                "url": "http://www.marthastewart.com/350032/beef-goulash",
                "shareAs": "http://www.edamam.com/recipe/beef-goulash-7b4793955f7d5f6c61e2e16b95c5d714/beef",
                "yield": 8,
                "dietLabels": [],
                "healthLabels": [
                    "Peanut-Free",
                    "Tree-Nut-Free",
                    "Soy-Free",
                    "Fish-Free",
                    "Shellfish-Free",
                    "Pork-Free",
                    "Crustacean-Free",
                    "Celery-Free",
                    "Mustard-Free",
                    "Sesame-Free",
                    "Lupine-Free",
                    "Mollusk-Free",
                    "Alcohol-Free",
                    "Sulfite-Free"
                ],
                "cautions": [
                    "Sulfites"
                ],
                "ingredientLines": [
                    "1/4 cup unsalted butter",
                    "1/4 cup olive oil",
                    "5 pounds beef chuck, well trimmed, cut into 1-inch cubes",
                    "Salt and freshly ground black pepper",
                    "5 pounds yellow onions, chopped",
                    "1/4 cup hungarian paprika",
                    "3 cups homemade beef stock",
                    "Sour cream, for garnish",
                    "2 pounds broad egg noodles, cooked",
                    "Chopped chives, for garnish"
                ],
                "ingredients": [
                    {
                        "text": "1/4 cup unsalted butter",
                        "weight": 56.75,
                        "foodCategory": "Dairy",
                        "foodId": "food_awz3iefajbk1fwahq9logahmgltj",
                        "image": "https://www.edamam.com/food-img/713/71397239b670d88c04faa8d05035cab4.jpg"
                    },
                    {
                        "text": "1/4 cup olive oil",
                        "weight": 54,
                        "foodCategory": "Oils",
                        "foodId": "food_b1d1icuad3iktrbqby0hiagafaz7",
                        "image": "https://www.edamam.com/food-img/4d6/4d651eaa8a353647746290c7a9b29d84.jpg"
                    },
                    {
                        "text": "5 pounds beef chuck, well trimmed, cut into 1-inch cubes",
                        "weight": 2267.96185,
                        "foodCategory": "meats",
                        "foodId": "food_bknby1la98smrsbwnthinbam42nj",
                        "image": "https://www.edamam.com/food-img/bab/bab88ab3ea40d34e4c8ae35d6b30344a.jpg"
                    },
                    {
                        "text": "Salt and freshly ground black pepper",
                        "weight": 37.80635064000276,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_btxz81db72hwbra2pncvebzzzum9",
                        "image": "https://www.edamam.com/food-img/694/6943ea510918c6025795e8dc6e6eaaeb.jpg"
                    },
                    {
                        "text": "Salt and freshly ground black pepper",
                        "weight": 18.90317532000138,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_b6ywzluaaxv02wad7s1r9ag4py89",
                        "image": "https://www.edamam.com/food-img/c6e/c6e5c3bd8d3bc15175d9766971a4d1b2.jpg"
                    },
                    {
                        "text": "5 pounds yellow onions, chopped",
                        "weight": 2267.96185,
                        "foodCategory": "vegetables",
                        "foodId": "food_bmrvi4ob4binw9a5m7l07amlfcoy",
                        "image": "https://www.edamam.com/food-img/205/205e6bf2399b85d34741892ef91cc603.jpg"
                    },
                    {
                        "text": "1/4 cup hungarian paprika",
                        "weight": 27.200000000459866,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_a9dpcnjb883g67b3lq82ca0421ql",
                        "image": "https://www.edamam.com/food-img/474/474d63763b9d8b9da98c5f43a114648c.jpg"
                    },
                    {
                        "text": "3 cups homemade beef stock",
                        "weight": 720,
                        "foodCategory": "canned soup",
                        "foodId": "food_bxd832fblxgfaibgn0zk0b6dg6dh",
                        "image": "https://www.edamam.com/food-img/428/4284513ddbf46e51f0f33566c0d61715.jpg"
                    },
                    {
                        "text": "Sour cream, for garnish",
                        "weight": 0,
                        "foodCategory": "Dairy",
                        "foodId": "food_adp9fcubzl3lr7bcvzn3rbfiiiwq",
                        "image": "https://www.edamam.com/food-img/f9d/f9d6183267b041b0aff9a10b89c9c15f.jpg"
                    },
                    {
                        "text": "2 pounds broad egg noodles, cooked",
                        "weight": 907.18474,
                        "foodCategory": "grains",
                        "foodId": "food_aefg3gqa71nrtpbhjfo3yb36kd81",
                        "image": "https://www.edamam.com/food-img/800/800c9c0d7cef6b5474723682ffa2878d.jpg"
                    },
                    {
                        "text": "Chopped chives, for garnish",
                        "weight": 0,
                        "foodCategory": "vegetables",
                        "foodId": "food_btg1uzjak79lawbirsitkaeai60l",
                        "image": "https://www.edamam.com/food-img/f3f/f3f48643a924ba174b894e979cb48620.jpg"
                    }
                ],
                "calories": 8441.133016654501,
                "totalWeight": 6348.778448158149,
                "totalTime": 218,
                "cuisineType": [
                    "central europe"
                ],
                "mealType": [
                    "lunch/dinner"
                ],
                "dishType": [
                    "main course"
                ],
                "totalNutrients": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 8441.133016654501,
                        "unit": "kcal"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 256.43617780649134,
                        "unit": "g"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 94.44927768746427,
                        "unit": "g"
                    },
                    "FATRN": {
                        "label": "Trans",
                        "quantity": 8.0835523164,
                        "unit": "g"
                    },
                    "FAMS": {
                        "label": "Monounsaturated",
                        "quantity": 120.81732238592262,
                        "unit": "g"
                    },
                    "FAPU": {
                        "label": "Polyunsaturated",
                        "quantity": 29.237192328629334,
                        "unit": "g"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 896.5476658253892,
                        "unit": "g"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 82.76775122612085,
                        "unit": "g"
                    },
                    "SUGAR": {
                        "label": "Sugars",
                        "quantity": 120.07216587409556,
                        "unit": "g"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 664.6683787898131,
                        "unit": "g"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 2312.8636471,
                        "unit": "mg"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 14696.944337195426,
                        "unit": "mg"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 1358.6860315497042,
                        "unit": "mg"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 1361.798920826398,
                        "unit": "mg"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 16204.101313740319,
                        "unit": "mg"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 98.47965449603372,
                        "unit": "mg"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 146.67681785716562,
                        "unit": "mg"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 8117.596391407045,
                        "unit": "mg"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 1262.790500147727,
                        "unit": "µg"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 168.07397690000417,
                        "unit": "mg"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 13.486647964547121,
                        "unit": "mg"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 9.375572552481659,
                        "unit": "mg"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 198.80633379325388,
                        "unit": "mg"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 18.59815930659105,
                        "unit": "mg"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 3888.179184804626,
                        "unit": "µg"
                    },
                    "FOLFD": {
                        "label": "Folate (food)",
                        "quantity": 794.6792214046255,
                        "unit": "µg"
                    },
                    "FOLAC": {
                        "label": "Folic acid",
                        "quantity": 1823.4413274000003,
                        "unit": "µg"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 54.210044741000004,
                        "unit": "µg"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 5.840766070000001,
                        "unit": "µg"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 25.141900261461835,
                        "unit": "mg"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 137.61379684921155,
                        "unit": "µg"
                    },
                    "WATER": {
                        "label": "Water",
                        "quantity": 4448.967358839599,
                        "unit": "g"
                    }
                },
                "totalDaily": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 422.05665083272504,
                        "unit": "%"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 394.5171966253713,
                        "unit": "%"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 472.24638843732134,
                        "unit": "%"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 298.84922194179643,
                        "unit": "%"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 331.0710049044834,
                        "unit": "%"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 1329.3367575796262,
                        "unit": "%"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 770.9545490333334,
                        "unit": "%"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 612.3726807164761,
                        "unit": "%"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 135.86860315497043,
                        "unit": "%"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 324.23783829199954,
                        "unit": "%"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 344.7681130583046,
                        "unit": "%"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 547.1091916446317,
                        "unit": "%"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 1333.4256168833238,
                        "unit": "%"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 1159.6566273438636,
                        "unit": "%"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 140.31005557196966,
                        "unit": "%"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 186.74886322222684,
                        "unit": "%"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 1123.887330378927,
                        "unit": "%"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 721.1978886524353,
                        "unit": "%"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 1242.5395862078367,
                        "unit": "%"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 1430.6276389685424,
                        "unit": "%"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 972.0447962011564,
                        "unit": "%"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 2258.7518642083337,
                        "unit": "%"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 38.93844046666667,
                        "unit": "%"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 167.61266840974557,
                        "unit": "%"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 114.67816404100964,
                        "unit": "%"
                    }
                },
                "digest": [
                    {
                        "label": "Fat",
                        "tag": "FAT",
                        "schemaOrgTag": "fatContent",
                        "total": 256.43617780649134,
                        "hasRDI": true,
                        "daily": 394.5171966253713,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Saturated",
                                "tag": "FASAT",
                                "schemaOrgTag": "saturatedFatContent",
                                "total": 94.44927768746427,
                                "hasRDI": true,
                                "daily": 472.24638843732134,
                                "unit": "g"
                            },
                            {
                                "label": "Trans",
                                "tag": "FATRN",
                                "schemaOrgTag": "transFatContent",
                                "total": 8.0835523164,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Monounsaturated",
                                "tag": "FAMS",
                                "schemaOrgTag": null,
                                "total": 120.81732238592262,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Polyunsaturated",
                                "tag": "FAPU",
                                "schemaOrgTag": null,
                                "total": 29.237192328629334,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Carbs",
                        "tag": "CHOCDF",
                        "schemaOrgTag": "carbohydrateContent",
                        "total": 896.5476658253892,
                        "hasRDI": true,
                        "daily": 298.84922194179643,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Carbs (net)",
                                "tag": "CHOCDF.net",
                                "schemaOrgTag": null,
                                "total": 813.7799145992684,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Fiber",
                                "tag": "FIBTG",
                                "schemaOrgTag": "fiberContent",
                                "total": 82.76775122612085,
                                "hasRDI": true,
                                "daily": 331.0710049044834,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars",
                                "tag": "SUGAR",
                                "schemaOrgTag": "sugarContent",
                                "total": 120.07216587409556,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars, added",
                                "tag": "SUGAR.added",
                                "schemaOrgTag": null,
                                "total": 0,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Protein",
                        "tag": "PROCNT",
                        "schemaOrgTag": "proteinContent",
                        "total": 664.6683787898131,
                        "hasRDI": true,
                        "daily": 1329.3367575796262,
                        "unit": "g"
                    },
                    {
                        "label": "Cholesterol",
                        "tag": "CHOLE",
                        "schemaOrgTag": "cholesterolContent",
                        "total": 2312.8636471,
                        "hasRDI": true,
                        "daily": 770.9545490333334,
                        "unit": "mg"
                    },
                    {
                        "label": "Sodium",
                        "tag": "NA",
                        "schemaOrgTag": "sodiumContent",
                        "total": 14696.944337195426,
                        "hasRDI": true,
                        "daily": 612.3726807164761,
                        "unit": "mg"
                    },
                    {
                        "label": "Calcium",
                        "tag": "CA",
                        "schemaOrgTag": null,
                        "total": 1358.6860315497042,
                        "hasRDI": true,
                        "daily": 135.86860315497043,
                        "unit": "mg"
                    },
                    {
                        "label": "Magnesium",
                        "tag": "MG",
                        "schemaOrgTag": null,
                        "total": 1361.798920826398,
                        "hasRDI": true,
                        "daily": 324.23783829199954,
                        "unit": "mg"
                    },
                    {
                        "label": "Potassium",
                        "tag": "K",
                        "schemaOrgTag": null,
                        "total": 16204.101313740319,
                        "hasRDI": true,
                        "daily": 344.7681130583046,
                        "unit": "mg"
                    },
                    {
                        "label": "Iron",
                        "tag": "FE",
                        "schemaOrgTag": null,
                        "total": 98.47965449603372,
                        "hasRDI": true,
                        "daily": 547.1091916446317,
                        "unit": "mg"
                    },
                    {
                        "label": "Zinc",
                        "tag": "ZN",
                        "schemaOrgTag": null,
                        "total": 146.67681785716562,
                        "hasRDI": true,
                        "daily": 1333.4256168833238,
                        "unit": "mg"
                    },
                    {
                        "label": "Phosphorus",
                        "tag": "P",
                        "schemaOrgTag": null,
                        "total": 8117.596391407045,
                        "hasRDI": true,
                        "daily": 1159.6566273438636,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin A",
                        "tag": "VITA_RAE",
                        "schemaOrgTag": null,
                        "total": 1262.790500147727,
                        "hasRDI": true,
                        "daily": 140.31005557196966,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin C",
                        "tag": "VITC",
                        "schemaOrgTag": null,
                        "total": 168.07397690000417,
                        "hasRDI": true,
                        "daily": 186.74886322222684,
                        "unit": "mg"
                    },
                    {
                        "label": "Thiamin (B1)",
                        "tag": "THIA",
                        "schemaOrgTag": null,
                        "total": 13.486647964547121,
                        "hasRDI": true,
                        "daily": 1123.887330378927,
                        "unit": "mg"
                    },
                    {
                        "label": "Riboflavin (B2)",
                        "tag": "RIBF",
                        "schemaOrgTag": null,
                        "total": 9.375572552481659,
                        "hasRDI": true,
                        "daily": 721.1978886524353,
                        "unit": "mg"
                    },
                    {
                        "label": "Niacin (B3)",
                        "tag": "NIA",
                        "schemaOrgTag": null,
                        "total": 198.80633379325388,
                        "hasRDI": true,
                        "daily": 1242.5395862078367,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin B6",
                        "tag": "VITB6A",
                        "schemaOrgTag": null,
                        "total": 18.59815930659105,
                        "hasRDI": true,
                        "daily": 1430.6276389685424,
                        "unit": "mg"
                    },
                    {
                        "label": "Folate equivalent (total)",
                        "tag": "FOLDFE",
                        "schemaOrgTag": null,
                        "total": 3888.179184804626,
                        "hasRDI": true,
                        "daily": 972.0447962011564,
                        "unit": "µg"
                    },
                    {
                        "label": "Folate (food)",
                        "tag": "FOLFD",
                        "schemaOrgTag": null,
                        "total": 794.6792214046255,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Folic acid",
                        "tag": "FOLAC",
                        "schemaOrgTag": null,
                        "total": 1823.4413274000003,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin B12",
                        "tag": "VITB12",
                        "schemaOrgTag": null,
                        "total": 54.210044741000004,
                        "hasRDI": true,
                        "daily": 2258.7518642083337,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin D",
                        "tag": "VITD",
                        "schemaOrgTag": null,
                        "total": 5.840766070000001,
                        "hasRDI": true,
                        "daily": 38.93844046666667,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin E",
                        "tag": "TOCPHA",
                        "schemaOrgTag": null,
                        "total": 25.141900261461835,
                        "hasRDI": true,
                        "daily": 167.61266840974557,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin K",
                        "tag": "VITK1",
                        "schemaOrgTag": null,
                        "total": 137.61379684921155,
                        "hasRDI": true,
                        "daily": 114.67816404100964,
                        "unit": "µg"
                    },
                    {
                        "label": "Sugar alcohols",
                        "tag": "Sugar.alcohol",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    },
                    {
                        "label": "Water",
                        "tag": "WATER",
                        "schemaOrgTag": null,
                        "total": 4448.967358839599,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    }
                ]
            },
            "_links": {
                "self": {
                    "href": "https://api.edamam.com/api/recipes/v2/7b4793955f7d5f6c61e2e16b95c5d714?type=public&app_id=ea1d37d5&app_key=fd382a172ba8d6668c0430dc9c14a181",
                    "title": "Self"
                }
            }
        },
        {
            "recipe": {
                "uri": "http://www.edamam.com/ontologies/edamam.owl#recipe_535e5146345790b3965f98ace4ec873f",
                "label": "Beef stew",
                "image": "https://www.edamam.com/web-img/501/501a9b12d18f5cbcaad0d00263ec2f7b.jpg",
                "source": "Jamie Oliver",
                "url": "http://www.jamieoliver.com/recipes/beef-recipes/beef-stew/",
                "shareAs": "http://www.edamam.com/recipe/beef-stew-535e5146345790b3965f98ace4ec873f/beef",
                "yield": 6,
                "dietLabels": [],
                "healthLabels": [
                    "Dairy-Free",
                    "Egg-Free",
                    "Peanut-Free",
                    "Tree-Nut-Free",
                    "Soy-Free",
                    "Shellfish-Free",
                    "Pork-Free",
                    "Crustacean-Free",
                    "Mustard-Free",
                    "Sesame-Free",
                    "Lupine-Free",
                    "Mollusk-Free",
                    "Kosher"
                ],
                "cautions": [
                    "Sulfites",
                    "FODMAP"
                ],
                "ingredientLines": [
                    "800 g lean stewing beef",
                    "2 tablespoons plain flour",
                    "olive oil",
                    "2 cloves of garlic",
                    "1 handful of shallots",
                    "2 sticks of celery",
                    "4 carrots",
                    "1 small bunch of thyme , (15g)",
                    "4 ripe vine tomatoes",
                    "150 ml red wine",
                    "500 ml organic beef stock",
                    "2 bay leaves",
                    "Worcestershire sauce"
                ],
                "ingredients": [
                    {
                        "text": "800 g lean stewing beef",
                        "weight": 800,
                        "foodCategory": "meats",
                        "foodId": "food_bknby1la98smrsbwnthinbam42nj",
                        "image": "https://www.edamam.com/food-img/bab/bab88ab3ea40d34e4c8ae35d6b30344a.jpg"
                    },
                    {
                        "text": "2 tablespoons plain flour",
                        "weight": 15.624999999735829,
                        "foodCategory": "grains",
                        "foodId": "food_ahebfs0a985an4aubqaebbipra58",
                        "image": "https://www.edamam.com/food-img/b4c/b4c739e76a6f2172b7ad49d0aa41d5aa.jpg"
                    },
                    {
                        "text": "olive oil",
                        "weight": 31.690110456742705,
                        "foodCategory": "Oils",
                        "foodId": "food_b1d1icuad3iktrbqby0hiagafaz7",
                        "image": "https://www.edamam.com/food-img/4d6/4d651eaa8a353647746290c7a9b29d84.jpg"
                    },
                    {
                        "text": "2 cloves of garlic",
                        "weight": 6,
                        "foodCategory": "vegetables",
                        "foodId": "food_avtcmx6bgjv1jvay6s6stan8dnyp",
                        "image": "https://www.edamam.com/food-img/6ee/6ee142951f48aaf94f4312409f8d133d.jpg"
                    },
                    {
                        "text": "1 handful of shallots",
                        "weight": 20.00000000033814,
                        "foodCategory": "vegetables",
                        "foodId": "food_bu2ver7a5f52dfap8q9f0bn085qb",
                        "image": "https://www.edamam.com/food-img/d23/d23e3be21df05e9e16c05eadb12341e7.jpeg"
                    },
                    {
                        "text": "2 sticks of celery",
                        "weight": 80,
                        "foodCategory": "vegetables",
                        "foodId": "food_bffeoksbyyur8ja4da73ub2xs57g",
                        "image": "https://www.edamam.com/food-img/d91/d91d2aed1c36d8fad54c4d7dc58f5a18.jpg"
                    },
                    {
                        "text": "4 carrots",
                        "weight": 244,
                        "foodCategory": "vegetables",
                        "foodId": "food_ai215e5b85pdh5ajd4aafa3w2zm8",
                        "image": "https://www.edamam.com/food-img/121/121e33fce0bb9546ed7d060b6c114e29.jpg"
                    },
                    {
                        "text": "1 small bunch of thyme , (15g)",
                        "weight": 15,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_b3o3cj7a5gskecb0ufphtadnbfqb",
                        "image": "https://www.edamam.com/food-img/3e7/3e7cf3c8d767a90b906447f5e74059f7.jpg"
                    },
                    {
                        "text": "4 ripe vine tomatoes",
                        "weight": 492,
                        "foodCategory": "vegetables",
                        "foodId": "food_a6k79rrahp8fe2b26zussa3wtkqh",
                        "image": "https://www.edamam.com/food-img/23e/23e727a14f1035bdc2733bb0477efbd2.jpg"
                    },
                    {
                        "text": "150 ml red wine",
                        "weight": 149.11984011512763,
                        "foodCategory": "wines",
                        "foodId": "food_b5q0xv2ba8la5hbzdfzdgaca3fwu",
                        "image": "https://www.edamam.com/food-img/82b/82b8d0db2d5c38fc7498a657c0afc4ee.JPG"
                    },
                    {
                        "text": "500 ml organic beef stock",
                        "weight": 507.21034052764503,
                        "foodCategory": "canned soup",
                        "foodId": "food_bxd832fblxgfaibgn0zk0b6dg6dh",
                        "image": "https://www.edamam.com/food-img/428/4284513ddbf46e51f0f33566c0d61715.jpg"
                    },
                    {
                        "text": "2 bay leaves",
                        "weight": 1.2,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_asx39x4ayja4jab6ivj6zayvkblo",
                        "image": "https://www.edamam.com/food-img/0f9/0f9f5f95df173e9ffaaff2977bef88f3.jpg"
                    },
                    {
                        "text": "Worcestershire sauce",
                        "weight": 0,
                        "foodCategory": "canned soup",
                        "foodId": "food_ahb8mscbejo58ubexo0itam1i74g",
                        "image": "https://www.edamam.com/food-img/072/072b61dd1ad5bb641f05b14f716ba6d0.jpg"
                    }
                ],
                "calories": 1813.3507848033398,
                "totalWeight": 2361.845291099589,
                "totalTime": 0,
                "cuisineType": [
                    "french"
                ],
                "mealType": [
                    "lunch/dinner"
                ],
                "dishType": [
                    "main course"
                ],
                "totalNutrients": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 1813.3507848033398,
                        "unit": "kcal"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 72.8876447632153,
                        "unit": "g"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 20.849302821051356,
                        "unit": "g"
                    },
                    "FATRN": {
                        "label": "Trans",
                        "quantity": 2,
                        "unit": "g"
                    },
                    "FAMS": {
                        "label": "Monounsaturated",
                        "quantity": 43.68068568677076,
                        "unit": "g"
                    },
                    "FAPU": {
                        "label": "Polyunsaturated",
                        "quantity": 6.7917020903884575,
                        "unit": "g"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 77.66272941319178,
                        "unit": "g"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 17.619475000003685,
                        "unit": "g"
                    },
                    "SUGAR": {
                        "label": "Sugars",
                        "quantity": 30.91686634758897,
                        "unit": "g"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 193.78821009645634,
                        "unit": "g"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 504,
                        "unit": "mg"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 1905.1935700585125,
                        "unit": "mg"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 409.90506555607465,
                        "unit": "mg"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 348.17660465076335,
                        "unit": "mg"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 6472.15497802777,
                        "unit": "mg"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 24.831596302512956,
                        "unit": "mg"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 46.45190035505769,
                        "unit": "mg"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 2205.523768789967,
                        "unit": "mg"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 2317.048,
                        "unit": "µg"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 112.32500000002706,
                        "unit": "mg"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 1.2247734043797651,
                        "unit": "mg"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 2.2409405603158086,
                        "unit": "mg"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 50.00487511125632,
                        "unit": "mg"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 5.920538996156877,
                        "unit": "mg"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 204.54790521175045,
                        "unit": "µg"
                    },
                    "FOLFD": {
                        "label": "Folate (food)",
                        "quantity": 204.54790521175045,
                        "unit": "µg"
                    },
                    "FOLAC": {
                        "label": "Folic acid",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 18.16,
                        "unit": "µg"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 0.8,
                        "unit": "µg"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 10.543626884595321,
                        "unit": "mg"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 127.00601119594918,
                        "unit": "µg"
                    },
                    "WATER": {
                        "label": "Water",
                        "quantity": 1981.876825247771,
                        "unit": "g"
                    }
                },
                "totalDaily": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 90.667539240167,
                        "unit": "%"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 112.13483809725432,
                        "unit": "%"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 104.24651410525678,
                        "unit": "%"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 25.887576471063927,
                        "unit": "%"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 70.47790000001474,
                        "unit": "%"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 387.5764201929127,
                        "unit": "%"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 168,
                        "unit": "%"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 79.3830654191047,
                        "unit": "%"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 40.99050655560746,
                        "unit": "%"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 82.89919158351508,
                        "unit": "%"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 137.70542506442064,
                        "unit": "%"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 137.95331279173865,
                        "unit": "%"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 422.2900032277972,
                        "unit": "%"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 315.0748241128524,
                        "unit": "%"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 257.44977777777774,
                        "unit": "%"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 124.80555555558563,
                        "unit": "%"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 102.06445036498043,
                        "unit": "%"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 172.38004310121605,
                        "unit": "%"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 312.53046944535197,
                        "unit": "%"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 455.42607662745206,
                        "unit": "%"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 51.13697630293761,
                        "unit": "%"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 756.6666666666667,
                        "unit": "%"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 5.333333333333333,
                        "unit": "%"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 70.29084589730215,
                        "unit": "%"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 105.83834266329099,
                        "unit": "%"
                    }
                },
                "digest": [
                    {
                        "label": "Fat",
                        "tag": "FAT",
                        "schemaOrgTag": "fatContent",
                        "total": 72.8876447632153,
                        "hasRDI": true,
                        "daily": 112.13483809725432,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Saturated",
                                "tag": "FASAT",
                                "schemaOrgTag": "saturatedFatContent",
                                "total": 20.849302821051356,
                                "hasRDI": true,
                                "daily": 104.24651410525678,
                                "unit": "g"
                            },
                            {
                                "label": "Trans",
                                "tag": "FATRN",
                                "schemaOrgTag": "transFatContent",
                                "total": 2,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Monounsaturated",
                                "tag": "FAMS",
                                "schemaOrgTag": null,
                                "total": 43.68068568677076,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Polyunsaturated",
                                "tag": "FAPU",
                                "schemaOrgTag": null,
                                "total": 6.7917020903884575,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Carbs",
                        "tag": "CHOCDF",
                        "schemaOrgTag": "carbohydrateContent",
                        "total": 77.66272941319178,
                        "hasRDI": true,
                        "daily": 25.887576471063927,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Carbs (net)",
                                "tag": "CHOCDF.net",
                                "schemaOrgTag": null,
                                "total": 60.043254413188095,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Fiber",
                                "tag": "FIBTG",
                                "schemaOrgTag": "fiberContent",
                                "total": 17.619475000003685,
                                "hasRDI": true,
                                "daily": 70.47790000001474,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars",
                                "tag": "SUGAR",
                                "schemaOrgTag": "sugarContent",
                                "total": 30.91686634758897,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars, added",
                                "tag": "SUGAR.added",
                                "schemaOrgTag": null,
                                "total": 0,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Protein",
                        "tag": "PROCNT",
                        "schemaOrgTag": "proteinContent",
                        "total": 193.78821009645634,
                        "hasRDI": true,
                        "daily": 387.5764201929127,
                        "unit": "g"
                    },
                    {
                        "label": "Cholesterol",
                        "tag": "CHOLE",
                        "schemaOrgTag": "cholesterolContent",
                        "total": 504,
                        "hasRDI": true,
                        "daily": 168,
                        "unit": "mg"
                    },
                    {
                        "label": "Sodium",
                        "tag": "NA",
                        "schemaOrgTag": "sodiumContent",
                        "total": 1905.1935700585125,
                        "hasRDI": true,
                        "daily": 79.3830654191047,
                        "unit": "mg"
                    },
                    {
                        "label": "Calcium",
                        "tag": "CA",
                        "schemaOrgTag": null,
                        "total": 409.90506555607465,
                        "hasRDI": true,
                        "daily": 40.99050655560746,
                        "unit": "mg"
                    },
                    {
                        "label": "Magnesium",
                        "tag": "MG",
                        "schemaOrgTag": null,
                        "total": 348.17660465076335,
                        "hasRDI": true,
                        "daily": 82.89919158351508,
                        "unit": "mg"
                    },
                    {
                        "label": "Potassium",
                        "tag": "K",
                        "schemaOrgTag": null,
                        "total": 6472.15497802777,
                        "hasRDI": true,
                        "daily": 137.70542506442064,
                        "unit": "mg"
                    },
                    {
                        "label": "Iron",
                        "tag": "FE",
                        "schemaOrgTag": null,
                        "total": 24.831596302512956,
                        "hasRDI": true,
                        "daily": 137.95331279173865,
                        "unit": "mg"
                    },
                    {
                        "label": "Zinc",
                        "tag": "ZN",
                        "schemaOrgTag": null,
                        "total": 46.45190035505769,
                        "hasRDI": true,
                        "daily": 422.2900032277972,
                        "unit": "mg"
                    },
                    {
                        "label": "Phosphorus",
                        "tag": "P",
                        "schemaOrgTag": null,
                        "total": 2205.523768789967,
                        "hasRDI": true,
                        "daily": 315.0748241128524,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin A",
                        "tag": "VITA_RAE",
                        "schemaOrgTag": null,
                        "total": 2317.048,
                        "hasRDI": true,
                        "daily": 257.44977777777774,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin C",
                        "tag": "VITC",
                        "schemaOrgTag": null,
                        "total": 112.32500000002706,
                        "hasRDI": true,
                        "daily": 124.80555555558563,
                        "unit": "mg"
                    },
                    {
                        "label": "Thiamin (B1)",
                        "tag": "THIA",
                        "schemaOrgTag": null,
                        "total": 1.2247734043797651,
                        "hasRDI": true,
                        "daily": 102.06445036498043,
                        "unit": "mg"
                    },
                    {
                        "label": "Riboflavin (B2)",
                        "tag": "RIBF",
                        "schemaOrgTag": null,
                        "total": 2.2409405603158086,
                        "hasRDI": true,
                        "daily": 172.38004310121605,
                        "unit": "mg"
                    },
                    {
                        "label": "Niacin (B3)",
                        "tag": "NIA",
                        "schemaOrgTag": null,
                        "total": 50.00487511125632,
                        "hasRDI": true,
                        "daily": 312.53046944535197,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin B6",
                        "tag": "VITB6A",
                        "schemaOrgTag": null,
                        "total": 5.920538996156877,
                        "hasRDI": true,
                        "daily": 455.42607662745206,
                        "unit": "mg"
                    },
                    {
                        "label": "Folate equivalent (total)",
                        "tag": "FOLDFE",
                        "schemaOrgTag": null,
                        "total": 204.54790521175045,
                        "hasRDI": true,
                        "daily": 51.13697630293761,
                        "unit": "µg"
                    },
                    {
                        "label": "Folate (food)",
                        "tag": "FOLFD",
                        "schemaOrgTag": null,
                        "total": 204.54790521175045,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Folic acid",
                        "tag": "FOLAC",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin B12",
                        "tag": "VITB12",
                        "schemaOrgTag": null,
                        "total": 18.16,
                        "hasRDI": true,
                        "daily": 756.6666666666667,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin D",
                        "tag": "VITD",
                        "schemaOrgTag": null,
                        "total": 0.8,
                        "hasRDI": true,
                        "daily": 5.333333333333333,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin E",
                        "tag": "TOCPHA",
                        "schemaOrgTag": null,
                        "total": 10.543626884595321,
                        "hasRDI": true,
                        "daily": 70.29084589730215,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin K",
                        "tag": "VITK1",
                        "schemaOrgTag": null,
                        "total": 127.00601119594918,
                        "hasRDI": true,
                        "daily": 105.83834266329099,
                        "unit": "µg"
                    },
                    {
                        "label": "Sugar alcohols",
                        "tag": "Sugar.alcohol",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    },
                    {
                        "label": "Water",
                        "tag": "WATER",
                        "schemaOrgTag": null,
                        "total": 1981.876825247771,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    }
                ]
            },
            "_links": {
                "self": {
                    "href": "https://api.edamam.com/api/recipes/v2/535e5146345790b3965f98ace4ec873f?type=public&app_id=ea1d37d5&app_key=fd382a172ba8d6668c0430dc9c14a181",
                    "title": "Self"
                }
            }
        },
        {
            "recipe": {
                "uri": "http://www.edamam.com/ontologies/edamam.owl#recipe_d36094487933c7d2c124c6d3742e49f6",
                "label": "Quick Beef Stroganoff",
                "image": "https://www.edamam.com/web-img/552/5524f65e427c421bb0127a322da13570.jpg",
                "source": "Food & Wine",
                "url": "http://www.foodandwine.com/recipes/quick-beef-stroganoff",
                "shareAs": "http://www.edamam.com/recipe/quick-beef-stroganoff-d36094487933c7d2c124c6d3742e49f6/beef",
                "yield": 8,
                "dietLabels": [
                    "Balanced"
                ],
                "healthLabels": [
                    "Sugar-Conscious",
                    "Peanut-Free",
                    "Tree-Nut-Free",
                    "Soy-Free",
                    "Fish-Free",
                    "Shellfish-Free",
                    "Pork-Free",
                    "Crustacean-Free",
                    "Celery-Free",
                    "Mustard-Free",
                    "Sesame-Free",
                    "Lupine-Free",
                    "Mollusk-Free",
                    "Alcohol-Free",
                    "Sulfite-Free"
                ],
                "cautions": [
                    "Sulfites"
                ],
                "ingredientLines": [
                    "2 tablespoons extra-virgin olive oil",
                    "1 onion, thinly sliced",
                    "8 ounces cremini mushrooms, thinly sliced",
                    "1 teaspoon chopped thyme",
                    "Kosher salt and freshly ground pepper",
                    "Coriander-Dusted Roast Beef",
                    "1/4 cup sour cream",
                    "Half of the Coriander-Dusted Roast Beef or 12 ounces roast beef, sliced 1/4 inch thick and cut into strips",
                    "Buttered noodles, for serving"
                ],
                "ingredients": [
                    {
                        "text": "2 tablespoons extra-virgin olive oil",
                        "weight": 27,
                        "foodCategory": "Oils",
                        "foodId": "food_b1d1icuad3iktrbqby0hiagafaz7",
                        "image": "https://www.edamam.com/food-img/4d6/4d651eaa8a353647746290c7a9b29d84.jpg"
                    },
                    {
                        "text": "1 onion, thinly sliced",
                        "weight": 125,
                        "foodCategory": "vegetables",
                        "foodId": "food_bmrvi4ob4binw9a5m7l07amlfcoy",
                        "image": "https://www.edamam.com/food-img/205/205e6bf2399b85d34741892ef91cc603.jpg"
                    },
                    {
                        "text": "8 ounces cremini mushrooms, thinly sliced",
                        "weight": 226.796185,
                        "foodCategory": "vegetables",
                        "foodId": "food_bizlqkfby3d954bfyuxhsbhybslp",
                        "image": "https://www.edamam.com/food-img/17a/17a9ef54308a434004be9ba16c0eea03.jpg"
                    },
                    {
                        "text": "1 teaspoon chopped thyme",
                        "weight": 0.8,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_b3o3cj7a5gskecb0ufphtadnbfqb",
                        "image": "https://www.edamam.com/food-img/3e7/3e7cf3c8d767a90b906447f5e74059f7.jpg"
                    },
                    {
                        "text": "Kosher salt and freshly ground pepper",
                        "weight": 4.842577110000001,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_a1vgrj1bs8rd1majvmd9ubz8ttkg",
                        "image": "https://www.edamam.com/food-img/694/6943ea510918c6025795e8dc6e6eaaeb.jpg"
                    },
                    {
                        "text": "Kosher salt and freshly ground pepper",
                        "weight": 2.4212885550000003,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_b6ywzluaaxv02wad7s1r9ag4py89",
                        "image": "https://www.edamam.com/food-img/c6e/c6e5c3bd8d3bc15175d9766971a4d1b2.jpg"
                    },
                    {
                        "text": "Coriander-Dusted Roast Beef",
                        "weight": 4.035480925000001,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_afpcy6rb44nx6gbfff63ga2cqksw",
                        "image": "https://www.edamam.com/food-img/a90/a901cee0b9028841d258f5d07b5924e7.jpg"
                    },
                    {
                        "text": "1/4 cup sour cream",
                        "weight": 57.5,
                        "foodCategory": "Dairy",
                        "foodId": "food_adp9fcubzl3lr7bcvzn3rbfiiiwq",
                        "image": "https://www.edamam.com/food-img/f9d/f9d6183267b041b0aff9a10b89c9c15f.jpg"
                    },
                    {
                        "text": "Half of the Coriander-Dusted Roast Beef or 12 ounces roast beef, sliced 1/4 inch thick and cut into strips",
                        "weight": 170,
                        "foodCategory": "meats",
                        "foodId": "food_a94xddzbba3iwnax9cx3nan3xvea",
                        "image": "https://www.edamam.com/food-img/634/634aa9adfb65afb5fef3df13d7334985.jpg"
                    },
                    {
                        "text": "Buttered noodles, for serving",
                        "weight": 200,
                        "foodCategory": "grains",
                        "foodId": "food_aefg3gqa71nrtpbhjfo3yb36kd81",
                        "image": "https://www.edamam.com/food-img/800/800c9c0d7cef6b5474723682ffa2878d.jpg"
                    }
                ],
                "calories": 1573.06132812955,
                "totalWeight": 817.9692289973884,
                "totalTime": 0,
                "cuisineType": [
                    "eastern europe"
                ],
                "mealType": [
                    "lunch/dinner"
                ],
                "dishType": [
                    "main course"
                ],
                "totalNutrients": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 1573.06132812955,
                        "unit": "kcal"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 69.0410251522655,
                        "unit": "g"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 20.9991280637431,
                        "unit": "g"
                    },
                    "FATRN": {
                        "label": "Trans",
                        "quantity": 0.122,
                        "unit": "g"
                    },
                    "FAMS": {
                        "label": "Monounsaturated",
                        "quantity": 34.63161555573645,
                        "unit": "g"
                    },
                    "FAPU": {
                        "label": "Polyunsaturated",
                        "quantity": 6.990555773666401,
                        "unit": "g"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 169.58636094658,
                        "unit": "g"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 12.50122962199,
                        "unit": "g"
                    },
                    "SUGAR": {
                        "label": "Sugars",
                        "quantity": 14.632390628752002,
                        "unit": "g"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 72.557395496287,
                        "unit": "g"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 325.4,
                        "unit": "mg"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 1891.9011245841507,
                        "unit": "mg"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 273.9310872410732,
                        "unit": "mg"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 210.84330987672388,
                        "unit": "mg"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 2398.7256789770913,
                        "unit": "mg"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 13.614506051557882,
                        "unit": "mg"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 13.463135246796888,
                        "unit": "mg"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 1212.60917490015,
                        "unit": "mg"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 137.75774790985002,
                        "unit": "µg"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 11.89575099425,
                        "unit": "mg"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 2.70660016680015,
                        "unit": "mg"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 2.3588805205814998,
                        "unit": "mg"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 36.42795310188615,
                        "unit": "mg"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 1.91278075319505,
                        "unit": "mg"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 843.94566530435,
                        "unit": "µg"
                    },
                    "FOLFD": {
                        "label": "Folate (food)",
                        "quantity": 161.94566530435003,
                        "unit": "µg"
                    },
                    "FOLAC": {
                        "label": "Folic acid",
                        "quantity": 402,
                        "unit": "µg"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 3.959796185,
                        "unit": "µg"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 1.056796185,
                        "unit": "µg"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 5.552361019472,
                        "unit": "mg"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 25.132649364535002,
                        "unit": "µg"
                    },
                    "WATER": {
                        "label": "Water",
                        "quantity": 495.0795943349427,
                        "unit": "g"
                    }
                },
                "totalDaily": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 78.6530664064775,
                        "unit": "%"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 106.21696177271616,
                        "unit": "%"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 104.9956403187155,
                        "unit": "%"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 56.52878698219333,
                        "unit": "%"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 50.00491848796,
                        "unit": "%"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 145.114790992574,
                        "unit": "%"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 108.46666666666665,
                        "unit": "%"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 78.82921352433961,
                        "unit": "%"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 27.39310872410732,
                        "unit": "%"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 50.200788065886634,
                        "unit": "%"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 51.03671657398067,
                        "unit": "%"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 75.63614473087712,
                        "unit": "%"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 122.39213860724443,
                        "unit": "%"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 173.22988212859286,
                        "unit": "%"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 15.30641643442778,
                        "unit": "%"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 13.217501104722222,
                        "unit": "%"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 225.55001390001252,
                        "unit": "%"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 181.45234773703845,
                        "unit": "%"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 227.67470688678847,
                        "unit": "%"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 147.13698101500384,
                        "unit": "%"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 210.9864163260875,
                        "unit": "%"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 164.99150770833336,
                        "unit": "%"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 7.0453079,
                        "unit": "%"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 37.01574012981334,
                        "unit": "%"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 20.943874470445834,
                        "unit": "%"
                    }
                },
                "digest": [
                    {
                        "label": "Fat",
                        "tag": "FAT",
                        "schemaOrgTag": "fatContent",
                        "total": 69.0410251522655,
                        "hasRDI": true,
                        "daily": 106.21696177271616,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Saturated",
                                "tag": "FASAT",
                                "schemaOrgTag": "saturatedFatContent",
                                "total": 20.9991280637431,
                                "hasRDI": true,
                                "daily": 104.9956403187155,
                                "unit": "g"
                            },
                            {
                                "label": "Trans",
                                "tag": "FATRN",
                                "schemaOrgTag": "transFatContent",
                                "total": 0.122,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Monounsaturated",
                                "tag": "FAMS",
                                "schemaOrgTag": null,
                                "total": 34.63161555573645,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Polyunsaturated",
                                "tag": "FAPU",
                                "schemaOrgTag": null,
                                "total": 6.990555773666401,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Carbs",
                        "tag": "CHOCDF",
                        "schemaOrgTag": "carbohydrateContent",
                        "total": 169.58636094658,
                        "hasRDI": true,
                        "daily": 56.52878698219333,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Carbs (net)",
                                "tag": "CHOCDF.net",
                                "schemaOrgTag": null,
                                "total": 157.08513132458998,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Fiber",
                                "tag": "FIBTG",
                                "schemaOrgTag": "fiberContent",
                                "total": 12.50122962199,
                                "hasRDI": true,
                                "daily": 50.00491848796,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars",
                                "tag": "SUGAR",
                                "schemaOrgTag": "sugarContent",
                                "total": 14.632390628752002,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars, added",
                                "tag": "SUGAR.added",
                                "schemaOrgTag": null,
                                "total": 0,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Protein",
                        "tag": "PROCNT",
                        "schemaOrgTag": "proteinContent",
                        "total": 72.557395496287,
                        "hasRDI": true,
                        "daily": 145.114790992574,
                        "unit": "g"
                    },
                    {
                        "label": "Cholesterol",
                        "tag": "CHOLE",
                        "schemaOrgTag": "cholesterolContent",
                        "total": 325.4,
                        "hasRDI": true,
                        "daily": 108.46666666666665,
                        "unit": "mg"
                    },
                    {
                        "label": "Sodium",
                        "tag": "NA",
                        "schemaOrgTag": "sodiumContent",
                        "total": 1891.9011245841507,
                        "hasRDI": true,
                        "daily": 78.82921352433961,
                        "unit": "mg"
                    },
                    {
                        "label": "Calcium",
                        "tag": "CA",
                        "schemaOrgTag": null,
                        "total": 273.9310872410732,
                        "hasRDI": true,
                        "daily": 27.39310872410732,
                        "unit": "mg"
                    },
                    {
                        "label": "Magnesium",
                        "tag": "MG",
                        "schemaOrgTag": null,
                        "total": 210.84330987672388,
                        "hasRDI": true,
                        "daily": 50.200788065886634,
                        "unit": "mg"
                    },
                    {
                        "label": "Potassium",
                        "tag": "K",
                        "schemaOrgTag": null,
                        "total": 2398.7256789770913,
                        "hasRDI": true,
                        "daily": 51.03671657398067,
                        "unit": "mg"
                    },
                    {
                        "label": "Iron",
                        "tag": "FE",
                        "schemaOrgTag": null,
                        "total": 13.614506051557882,
                        "hasRDI": true,
                        "daily": 75.63614473087712,
                        "unit": "mg"
                    },
                    {
                        "label": "Zinc",
                        "tag": "ZN",
                        "schemaOrgTag": null,
                        "total": 13.463135246796888,
                        "hasRDI": true,
                        "daily": 122.39213860724443,
                        "unit": "mg"
                    },
                    {
                        "label": "Phosphorus",
                        "tag": "P",
                        "schemaOrgTag": null,
                        "total": 1212.60917490015,
                        "hasRDI": true,
                        "daily": 173.22988212859286,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin A",
                        "tag": "VITA_RAE",
                        "schemaOrgTag": null,
                        "total": 137.75774790985002,
                        "hasRDI": true,
                        "daily": 15.30641643442778,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin C",
                        "tag": "VITC",
                        "schemaOrgTag": null,
                        "total": 11.89575099425,
                        "hasRDI": true,
                        "daily": 13.217501104722222,
                        "unit": "mg"
                    },
                    {
                        "label": "Thiamin (B1)",
                        "tag": "THIA",
                        "schemaOrgTag": null,
                        "total": 2.70660016680015,
                        "hasRDI": true,
                        "daily": 225.55001390001252,
                        "unit": "mg"
                    },
                    {
                        "label": "Riboflavin (B2)",
                        "tag": "RIBF",
                        "schemaOrgTag": null,
                        "total": 2.3588805205814998,
                        "hasRDI": true,
                        "daily": 181.45234773703845,
                        "unit": "mg"
                    },
                    {
                        "label": "Niacin (B3)",
                        "tag": "NIA",
                        "schemaOrgTag": null,
                        "total": 36.42795310188615,
                        "hasRDI": true,
                        "daily": 227.67470688678847,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin B6",
                        "tag": "VITB6A",
                        "schemaOrgTag": null,
                        "total": 1.91278075319505,
                        "hasRDI": true,
                        "daily": 147.13698101500384,
                        "unit": "mg"
                    },
                    {
                        "label": "Folate equivalent (total)",
                        "tag": "FOLDFE",
                        "schemaOrgTag": null,
                        "total": 843.94566530435,
                        "hasRDI": true,
                        "daily": 210.9864163260875,
                        "unit": "µg"
                    },
                    {
                        "label": "Folate (food)",
                        "tag": "FOLFD",
                        "schemaOrgTag": null,
                        "total": 161.94566530435003,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Folic acid",
                        "tag": "FOLAC",
                        "schemaOrgTag": null,
                        "total": 402,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin B12",
                        "tag": "VITB12",
                        "schemaOrgTag": null,
                        "total": 3.959796185,
                        "hasRDI": true,
                        "daily": 164.99150770833336,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin D",
                        "tag": "VITD",
                        "schemaOrgTag": null,
                        "total": 1.056796185,
                        "hasRDI": true,
                        "daily": 7.0453079,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin E",
                        "tag": "TOCPHA",
                        "schemaOrgTag": null,
                        "total": 5.552361019472,
                        "hasRDI": true,
                        "daily": 37.01574012981334,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin K",
                        "tag": "VITK1",
                        "schemaOrgTag": null,
                        "total": 25.132649364535002,
                        "hasRDI": true,
                        "daily": 20.943874470445834,
                        "unit": "µg"
                    },
                    {
                        "label": "Sugar alcohols",
                        "tag": "Sugar.alcohol",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    },
                    {
                        "label": "Water",
                        "tag": "WATER",
                        "schemaOrgTag": null,
                        "total": 495.0795943349427,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    }
                ]
            },
            "_links": {
                "self": {
                    "href": "https://api.edamam.com/api/recipes/v2/d36094487933c7d2c124c6d3742e49f6?type=public&app_id=ea1d37d5&app_key=fd382a172ba8d6668c0430dc9c14a181",
                    "title": "Self"
                }
            }
        },
        {
            "recipe": {
                "uri": "http://www.edamam.com/ontologies/edamam.owl#recipe_cdccdf512c73703a2fa3236044e29ff0",
                "label": "Beef Jerky",
                "image": "https://www.edamam.com/web-img/346/3464d06a3fa4f31b0d898b714dbfd5c4.jpg",
                "source": "The Daily Meal",
                "url": "https://www.thedailymeal.com/recipes/beef-jerky",
                "shareAs": "http://www.edamam.com/recipe/beef-jerky-cdccdf512c73703a2fa3236044e29ff0/beef",
                "yield": 4,
                "dietLabels": [
                    "High-Protein",
                    "Low-Carb",
                    "Low-Sodium"
                ],
                "healthLabels": [
                    "Sugar-Conscious",
                    "Paleo",
                    "Dairy-Free",
                    "Gluten-Free",
                    "Wheat-Free",
                    "Egg-Free",
                    "Peanut-Free",
                    "Tree-Nut-Free",
                    "Soy-Free",
                    "Fish-Free",
                    "Shellfish-Free",
                    "Pork-Free",
                    "Crustacean-Free",
                    "Celery-Free",
                    "Mustard-Free",
                    "Sesame-Free",
                    "Lupine-Free",
                    "Mollusk-Free",
                    "Alcohol-Free",
                    "No oil added",
                    "Sulfite-Free",
                    "FODMAP-Free",
                    "Kosher",
                    "Immuno-Supportive"
                ],
                "cautions": [
                    "FODMAP"
                ],
                "ingredientLines": [
                    "1 Pound beef",
                    "1 Cup seasoning"
                ],
                "ingredients": [
                    {
                        "text": "1 Pound beef",
                        "weight": 453.59237,
                        "foodCategory": "meats",
                        "foodId": "food_bknby1la98smrsbwnthinbam42nj",
                        "image": "https://www.edamam.com/food-img/bab/bab88ab3ea40d34e4c8ae35d6b30344a.jpg"
                    },
                    {
                        "text": "1 Cup seasoning",
                        "weight": 70.40000000119026,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_aj7w3xab0epj7cbgkbkpwadysovd",
                        "image": "https://www.edamam.com/food-img/c23/c23e20823b442067307aa436969358f1.jpg"
                    }
                ],
                "calories": 805.7980810036543,
                "totalWeight": 523.9923700011902,
                "totalTime": 0,
                "cuisineType": [
                    "american"
                ],
                "mealType": [
                    "lunch/dinner"
                ],
                "dishType": [
                    "starter"
                ],
                "totalNutrients": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 805.7980810036543,
                        "unit": "kcal"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 27.11891299708963,
                        "unit": "g"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 11.33357631563916,
                        "unit": "g"
                    },
                    "FATRN": {
                        "label": "Trans",
                        "quantity": 1.1339809250000001,
                        "unit": "g"
                    },
                    "FAMS": {
                        "label": "Monounsaturated",
                        "quantity": 12.234192487014354,
                        "unit": "g"
                    },
                    "FAPU": {
                        "label": "Polyunsaturated",
                        "quantity": 2.769080347023044,
                        "unit": "g"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 46.7196708447807,
                        "unit": "g"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 7.955200000134501,
                        "unit": "g"
                    },
                    "SUGAR": {
                        "label": "Sugars",
                        "quantity": 1.2672000000214247,
                        "unit": "g"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 104.90874886811416,
                        "unit": "g"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 285.7631931,
                        "unit": "mg"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 377.3459723003214,
                        "unit": "mg"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 760.151008111855,
                        "unit": "mg"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 252.95039770266624,
                        "unit": "mg"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 2173.4355401081416,
                        "unit": "mg"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 34.33128053342016,
                        "unit": "mg"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 26.74990721703738,
                        "unit": "mg"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 1104.6794429020356,
                        "unit": "mg"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 101.99984740157115,
                        "unit": "µg"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 8.448000000142832,
                        "unit": "mg"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 0.5487298960031424,
                        "unit": "mg"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 0.9055710290022736,
                        "unit": "mg"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 24.25793912193535,
                        "unit": "mg"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 3.505684661615712,
                        "unit": "mg"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 110.75977110164257,
                        "unit": "µg"
                    },
                    "FOLFD": {
                        "label": "Folate (food)",
                        "quantity": 110.75977110164257,
                        "unit": "µg"
                    },
                    "FOLAC": {
                        "label": "Folic acid",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 10.296546799000001,
                        "unit": "µg"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 0.4535923700000001,
                        "unit": "µg"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 1.7457462660157117,
                        "unit": "mg"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 573.8054855595864,
                        "unit": "µg"
                    },
                    "WATER": {
                        "label": "Water",
                        "quantity": 334.59224198411084,
                        "unit": "g"
                    }
                },
                "totalDaily": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 40.28990405018271,
                        "unit": "%"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 41.72140461090712,
                        "unit": "%"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 56.6678815781958,
                        "unit": "%"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 15.573223614926901,
                        "unit": "%"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 31.820800000538,
                        "unit": "%"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 209.81749773622832,
                        "unit": "%"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 95.25439770000001,
                        "unit": "%"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 15.722748845846727,
                        "unit": "%"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 76.0151008111855,
                        "unit": "%"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 60.226285167301484,
                        "unit": "%"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 46.24330936400302,
                        "unit": "%"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 190.72933629677868,
                        "unit": "%"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 243.18097470033982,
                        "unit": "%"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 157.8113489860051,
                        "unit": "%"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 11.33331637795235,
                        "unit": "%"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 9.38666666682537,
                        "unit": "%"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 45.7274913335952,
                        "unit": "%"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 69.65930992325181,
                        "unit": "%"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 151.61211951209594,
                        "unit": "%"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 269.6680508935163,
                        "unit": "%"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 27.689942775410643,
                        "unit": "%"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 429.02278329166677,
                        "unit": "%"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 3.0239491333333337,
                        "unit": "%"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 11.638308440104744,
                        "unit": "%"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 478.171237966322,
                        "unit": "%"
                    }
                },
                "digest": [
                    {
                        "label": "Fat",
                        "tag": "FAT",
                        "schemaOrgTag": "fatContent",
                        "total": 27.11891299708963,
                        "hasRDI": true,
                        "daily": 41.72140461090712,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Saturated",
                                "tag": "FASAT",
                                "schemaOrgTag": "saturatedFatContent",
                                "total": 11.33357631563916,
                                "hasRDI": true,
                                "daily": 56.6678815781958,
                                "unit": "g"
                            },
                            {
                                "label": "Trans",
                                "tag": "FATRN",
                                "schemaOrgTag": "transFatContent",
                                "total": 1.1339809250000001,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Monounsaturated",
                                "tag": "FAMS",
                                "schemaOrgTag": null,
                                "total": 12.234192487014354,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Polyunsaturated",
                                "tag": "FAPU",
                                "schemaOrgTag": null,
                                "total": 2.769080347023044,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Carbs",
                        "tag": "CHOCDF",
                        "schemaOrgTag": "carbohydrateContent",
                        "total": 46.7196708447807,
                        "hasRDI": true,
                        "daily": 15.573223614926901,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Carbs (net)",
                                "tag": "CHOCDF.net",
                                "schemaOrgTag": null,
                                "total": 38.7644708446462,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Fiber",
                                "tag": "FIBTG",
                                "schemaOrgTag": "fiberContent",
                                "total": 7.955200000134501,
                                "hasRDI": true,
                                "daily": 31.820800000538,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars",
                                "tag": "SUGAR",
                                "schemaOrgTag": "sugarContent",
                                "total": 1.2672000000214247,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars, added",
                                "tag": "SUGAR.added",
                                "schemaOrgTag": null,
                                "total": 0,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Protein",
                        "tag": "PROCNT",
                        "schemaOrgTag": "proteinContent",
                        "total": 104.90874886811416,
                        "hasRDI": true,
                        "daily": 209.81749773622832,
                        "unit": "g"
                    },
                    {
                        "label": "Cholesterol",
                        "tag": "CHOLE",
                        "schemaOrgTag": "cholesterolContent",
                        "total": 285.7631931,
                        "hasRDI": true,
                        "daily": 95.25439770000001,
                        "unit": "mg"
                    },
                    {
                        "label": "Sodium",
                        "tag": "NA",
                        "schemaOrgTag": "sodiumContent",
                        "total": 377.3459723003214,
                        "hasRDI": true,
                        "daily": 15.722748845846727,
                        "unit": "mg"
                    },
                    {
                        "label": "Calcium",
                        "tag": "CA",
                        "schemaOrgTag": null,
                        "total": 760.151008111855,
                        "hasRDI": true,
                        "daily": 76.0151008111855,
                        "unit": "mg"
                    },
                    {
                        "label": "Magnesium",
                        "tag": "MG",
                        "schemaOrgTag": null,
                        "total": 252.95039770266624,
                        "hasRDI": true,
                        "daily": 60.226285167301484,
                        "unit": "mg"
                    },
                    {
                        "label": "Potassium",
                        "tag": "K",
                        "schemaOrgTag": null,
                        "total": 2173.4355401081416,
                        "hasRDI": true,
                        "daily": 46.24330936400302,
                        "unit": "mg"
                    },
                    {
                        "label": "Iron",
                        "tag": "FE",
                        "schemaOrgTag": null,
                        "total": 34.33128053342016,
                        "hasRDI": true,
                        "daily": 190.72933629677868,
                        "unit": "mg"
                    },
                    {
                        "label": "Zinc",
                        "tag": "ZN",
                        "schemaOrgTag": null,
                        "total": 26.74990721703738,
                        "hasRDI": true,
                        "daily": 243.18097470033982,
                        "unit": "mg"
                    },
                    {
                        "label": "Phosphorus",
                        "tag": "P",
                        "schemaOrgTag": null,
                        "total": 1104.6794429020356,
                        "hasRDI": true,
                        "daily": 157.8113489860051,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin A",
                        "tag": "VITA_RAE",
                        "schemaOrgTag": null,
                        "total": 101.99984740157115,
                        "hasRDI": true,
                        "daily": 11.33331637795235,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin C",
                        "tag": "VITC",
                        "schemaOrgTag": null,
                        "total": 8.448000000142832,
                        "hasRDI": true,
                        "daily": 9.38666666682537,
                        "unit": "mg"
                    },
                    {
                        "label": "Thiamin (B1)",
                        "tag": "THIA",
                        "schemaOrgTag": null,
                        "total": 0.5487298960031424,
                        "hasRDI": true,
                        "daily": 45.7274913335952,
                        "unit": "mg"
                    },
                    {
                        "label": "Riboflavin (B2)",
                        "tag": "RIBF",
                        "schemaOrgTag": null,
                        "total": 0.9055710290022736,
                        "hasRDI": true,
                        "daily": 69.65930992325181,
                        "unit": "mg"
                    },
                    {
                        "label": "Niacin (B3)",
                        "tag": "NIA",
                        "schemaOrgTag": null,
                        "total": 24.25793912193535,
                        "hasRDI": true,
                        "daily": 151.61211951209594,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin B6",
                        "tag": "VITB6A",
                        "schemaOrgTag": null,
                        "total": 3.505684661615712,
                        "hasRDI": true,
                        "daily": 269.6680508935163,
                        "unit": "mg"
                    },
                    {
                        "label": "Folate equivalent (total)",
                        "tag": "FOLDFE",
                        "schemaOrgTag": null,
                        "total": 110.75977110164257,
                        "hasRDI": true,
                        "daily": 27.689942775410643,
                        "unit": "µg"
                    },
                    {
                        "label": "Folate (food)",
                        "tag": "FOLFD",
                        "schemaOrgTag": null,
                        "total": 110.75977110164257,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Folic acid",
                        "tag": "FOLAC",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin B12",
                        "tag": "VITB12",
                        "schemaOrgTag": null,
                        "total": 10.296546799000001,
                        "hasRDI": true,
                        "daily": 429.02278329166677,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin D",
                        "tag": "VITD",
                        "schemaOrgTag": null,
                        "total": 0.4535923700000001,
                        "hasRDI": true,
                        "daily": 3.0239491333333337,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin E",
                        "tag": "TOCPHA",
                        "schemaOrgTag": null,
                        "total": 1.7457462660157117,
                        "hasRDI": true,
                        "daily": 11.638308440104744,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin K",
                        "tag": "VITK1",
                        "schemaOrgTag": null,
                        "total": 573.8054855595864,
                        "hasRDI": true,
                        "daily": 478.171237966322,
                        "unit": "µg"
                    },
                    {
                        "label": "Sugar alcohols",
                        "tag": "Sugar.alcohol",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    },
                    {
                        "label": "Water",
                        "tag": "WATER",
                        "schemaOrgTag": null,
                        "total": 334.59224198411084,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    }
                ]
            },
            "_links": {
                "self": {
                    "href": "https://api.edamam.com/api/recipes/v2/cdccdf512c73703a2fa3236044e29ff0?type=public&app_id=ea1d37d5&app_key=fd382a172ba8d6668c0430dc9c14a181",
                    "title": "Self"
                }
            }
        },
        {
            "recipe": {
                "uri": "http://www.edamam.com/ontologies/edamam.owl#recipe_552d62b578c9e13d3a3ef6bc7132ce88",
                "label": "Minced beef pie",
                "image": "https://www.edamam.com/web-img/1df/1df187d15010ccca062e88102dcf7af1.jpg",
                "source": "BBC",
                "url": "http://www.bbc.co.uk/food/recipes/mincedbeefpie_89198",
                "shareAs": "http://www.edamam.com/recipe/minced-beef-pie-552d62b578c9e13d3a3ef6bc7132ce88/beef",
                "yield": 4,
                "dietLabels": [],
                "healthLabels": [
                    "Sugar-Conscious",
                    "Peanut-Free",
                    "Tree-Nut-Free",
                    "Soy-Free",
                    "Shellfish-Free",
                    "Pork-Free",
                    "Crustacean-Free",
                    "Celery-Free",
                    "Mustard-Free",
                    "Sesame-Free",
                    "Lupine-Free",
                    "Mollusk-Free"
                ],
                "cautions": [
                    "Sulfites"
                ],
                "ingredientLines": [
                    "2 tbsp vegetable oil",
                    "500g/1lb 2oz beef mince",
                    "1 onion, chopped",
                    "1 tbsp tomato purée 1½ tbsp plain flour, plus extra for dusting",
                    "75g/2½oz mushrooms, chopped",
                    "250ml/9fl oz stout or beef stock",
                    "Dash worcestershire sauce",
                    "400g/14oz ready-made shortcrust pastry",
                    "1 free-range egg, yolk only, lightly beaten"
                ],
                "ingredients": [
                    {
                        "text": "2 tbsp vegetable oil",
                        "weight": 28,
                        "foodCategory": "Oils",
                        "foodId": "food_bt1mzi2ah2sfg8bv7no1qai83w8s",
                        "image": "https://www.edamam.com/food-img/6e5/6e51a63a6300a8ea1b4c4cc68dfaba33.jpg"
                    },
                    {
                        "text": "500g/1lb 2oz beef mince",
                        "weight": 500,
                        "foodCategory": "meats",
                        "foodId": "food_boq91pbbhklr6sb0d9sbybzgklkm",
                        "image": "https://www.edamam.com/food-img/cfa/cfae8f9276eaf8f0d9349ba662744a0c.jpg"
                    },
                    {
                        "text": "1 onion, chopped",
                        "weight": 125,
                        "foodCategory": "vegetables",
                        "foodId": "food_bmrvi4ob4binw9a5m7l07amlfcoy",
                        "image": "https://www.edamam.com/food-img/205/205e6bf2399b85d34741892ef91cc603.jpg"
                    },
                    {
                        "text": "1 tbsp tomato purée 1½ tbsp plain flour, plus extra for dusting",
                        "weight": 7.8124999998679145,
                        "foodCategory": "grains",
                        "foodId": "food_ahebfs0a985an4aubqaebbipra58",
                        "image": "https://www.edamam.com/food-img/b4c/b4c739e76a6f2172b7ad49d0aa41d5aa.jpg"
                    },
                    {
                        "text": "75g/2½oz mushrooms, chopped",
                        "weight": 75,
                        "foodCategory": "vegetables",
                        "foodId": "food_bvlose6arfl26ra396sjrb7hetqh",
                        "image": "https://www.edamam.com/food-img/d63/d639cf4a2afc7407c1d1ce286028136b.jpg"
                    },
                    {
                        "text": "250ml/9fl oz stout or beef stock",
                        "weight": 253.60517026382252,
                        "foodCategory": "canned soup",
                        "foodId": "food_bxd832fblxgfaibgn0zk0b6dg6dh",
                        "image": "https://www.edamam.com/food-img/428/4284513ddbf46e51f0f33566c0d61715.jpg"
                    },
                    {
                        "text": "Dash worcestershire sauce",
                        "weight": 0.7161458330790678,
                        "foodCategory": "canned soup",
                        "foodId": "food_ahb8mscbejo58ubexo0itam1i74g",
                        "image": "https://www.edamam.com/food-img/072/072b61dd1ad5bb641f05b14f716ba6d0.jpg"
                    },
                    {
                        "text": "400g/14oz ready-made shortcrust pastry",
                        "weight": 400,
                        "foodCategory": "quick breads and pastries",
                        "foodId": "food_bdy019nbzjeni3atliworbbgahrk",
                        "image": "https://www.edamam.com/food-img/bc7/bc7dc9b99ce87d5a6dc136e30d6aadd1.jpg"
                    },
                    {
                        "text": "1 free-range egg, yolk only, lightly beaten",
                        "weight": 43,
                        "foodCategory": "Eggs",
                        "foodId": "food_bhpradua77pk16aipcvzeayg732r",
                        "image": "https://www.edamam.com/food-img/a7e/a7ec7c337cb47c6550b3b118e357f077.jpg"
                    }
                ],
                "calories": 3911.4747658836177,
                "totalWeight": 1433.1338160967694,
                "totalTime": 60,
                "cuisineType": [
                    "british"
                ],
                "mealType": [
                    "lunch/dinner"
                ],
                "dishType": [
                    "desserts"
                ],
                "totalNutrients": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 3911.4747658836177,
                        "unit": "kcal"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 285.17410715323615,
                        "unit": "g"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 79.83513118459213,
                        "unit": "g"
                    },
                    "FATRN": {
                        "label": "Trans",
                        "quantity": 6.131099999999999,
                        "unit": "g"
                    },
                    "FAMS": {
                        "label": "Monounsaturated",
                        "quantity": 152.4905170982133,
                        "unit": "g"
                    },
                    "FAPU": {
                        "label": "Polyunsaturated",
                        "quantity": 27.976365883512646,
                        "unit": "g"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 203.97394277218226,
                        "unit": "g"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 9.085937499996433,
                        "unit": "g"
                    },
                    "SUGAR": {
                        "label": "Sugars",
                        "quantity": 11.366491096482116,
                        "unit": "g"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 129.94635310418366,
                        "unit": "g"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 514.96,
                        "unit": "mg"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 1905.1227162865407,
                        "unit": "mg"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 207.30656466248058,
                        "unit": "mg"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 192.9742108767388,
                        "unit": "mg"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 2557.598106652563,
                        "unit": "mg"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 22.144095938863966,
                        "unit": "mg"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 24.664376966530423,
                        "unit": "mg"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 1303.3747902814898,
                        "unit": "mg"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 88.83580729165395,
                        "unit": "µg"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 10.918098958300279,
                        "unit": "mg"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 2.036016008270058,
                        "unit": "mg"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 2.6535966945230283,
                        "unit": "mg"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 43.00360635553043,
                        "unit": "mg"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 2.1430203436450443,
                        "unit": "mg"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 594.8706450718885,
                        "unit": "µg"
                    },
                    "FOLFD": {
                        "label": "Folate (food)",
                        "quantity": 150.87064507188845,
                        "unit": "µg"
                    },
                    "FOLAC": {
                        "label": "Folic acid",
                        "quantity": 260,
                        "unit": "µg"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 11.1127,
                        "unit": "µg"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 1.51,
                        "unit": "µg"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 9.628620933692769,
                        "unit": "mg"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 74.31320412859422,
                        "unit": "µg"
                    },
                    "WATER": {
                        "label": "Water",
                        "quantity": 801.495208703264,
                        "unit": "g"
                    }
                },
                "totalDaily": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 195.57373829418088,
                        "unit": "%"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 438.7293956203633,
                        "unit": "%"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 399.17565592296063,
                        "unit": "%"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 67.9913142573941,
                        "unit": "%"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 36.34374999998573,
                        "unit": "%"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 259.8927062083673,
                        "unit": "%"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 171.65333333333334,
                        "unit": "%"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 79.38011317860587,
                        "unit": "%"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 20.73065646624806,
                        "unit": "%"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 45.946240684937806,
                        "unit": "%"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 54.41698099260772,
                        "unit": "%"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 123.02275521591092,
                        "unit": "%"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 224.2216087866402,
                        "unit": "%"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 186.1963986116414,
                        "unit": "%"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 9.870645254628217,
                        "unit": "%"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 12.131221064778089,
                        "unit": "%"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 169.6680006891715,
                        "unit": "%"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 204.12282265561757,
                        "unit": "%"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 268.7725397220652,
                        "unit": "%"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 164.84771874192649,
                        "unit": "%"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 148.71766126797212,
                        "unit": "%"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 463.0291666666667,
                        "unit": "%"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 10.066666666666666,
                        "unit": "%"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 64.19080622461846,
                        "unit": "%"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 61.92767010716185,
                        "unit": "%"
                    }
                },
                "digest": [
                    {
                        "label": "Fat",
                        "tag": "FAT",
                        "schemaOrgTag": "fatContent",
                        "total": 285.17410715323615,
                        "hasRDI": true,
                        "daily": 438.7293956203633,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Saturated",
                                "tag": "FASAT",
                                "schemaOrgTag": "saturatedFatContent",
                                "total": 79.83513118459213,
                                "hasRDI": true,
                                "daily": 399.17565592296063,
                                "unit": "g"
                            },
                            {
                                "label": "Trans",
                                "tag": "FATRN",
                                "schemaOrgTag": "transFatContent",
                                "total": 6.131099999999999,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Monounsaturated",
                                "tag": "FAMS",
                                "schemaOrgTag": null,
                                "total": 152.4905170982133,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Polyunsaturated",
                                "tag": "FAPU",
                                "schemaOrgTag": null,
                                "total": 27.976365883512646,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Carbs",
                        "tag": "CHOCDF",
                        "schemaOrgTag": "carbohydrateContent",
                        "total": 203.97394277218226,
                        "hasRDI": true,
                        "daily": 67.9913142573941,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Carbs (net)",
                                "tag": "CHOCDF.net",
                                "schemaOrgTag": null,
                                "total": 194.8880052721858,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Fiber",
                                "tag": "FIBTG",
                                "schemaOrgTag": "fiberContent",
                                "total": 9.085937499996433,
                                "hasRDI": true,
                                "daily": 36.34374999998573,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars",
                                "tag": "SUGAR",
                                "schemaOrgTag": "sugarContent",
                                "total": 11.366491096482116,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars, added",
                                "tag": "SUGAR.added",
                                "schemaOrgTag": null,
                                "total": 0,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Protein",
                        "tag": "PROCNT",
                        "schemaOrgTag": "proteinContent",
                        "total": 129.94635310418366,
                        "hasRDI": true,
                        "daily": 259.8927062083673,
                        "unit": "g"
                    },
                    {
                        "label": "Cholesterol",
                        "tag": "CHOLE",
                        "schemaOrgTag": "cholesterolContent",
                        "total": 514.96,
                        "hasRDI": true,
                        "daily": 171.65333333333334,
                        "unit": "mg"
                    },
                    {
                        "label": "Sodium",
                        "tag": "NA",
                        "schemaOrgTag": "sodiumContent",
                        "total": 1905.1227162865407,
                        "hasRDI": true,
                        "daily": 79.38011317860587,
                        "unit": "mg"
                    },
                    {
                        "label": "Calcium",
                        "tag": "CA",
                        "schemaOrgTag": null,
                        "total": 207.30656466248058,
                        "hasRDI": true,
                        "daily": 20.73065646624806,
                        "unit": "mg"
                    },
                    {
                        "label": "Magnesium",
                        "tag": "MG",
                        "schemaOrgTag": null,
                        "total": 192.9742108767388,
                        "hasRDI": true,
                        "daily": 45.946240684937806,
                        "unit": "mg"
                    },
                    {
                        "label": "Potassium",
                        "tag": "K",
                        "schemaOrgTag": null,
                        "total": 2557.598106652563,
                        "hasRDI": true,
                        "daily": 54.41698099260772,
                        "unit": "mg"
                    },
                    {
                        "label": "Iron",
                        "tag": "FE",
                        "schemaOrgTag": null,
                        "total": 22.144095938863966,
                        "hasRDI": true,
                        "daily": 123.02275521591092,
                        "unit": "mg"
                    },
                    {
                        "label": "Zinc",
                        "tag": "ZN",
                        "schemaOrgTag": null,
                        "total": 24.664376966530423,
                        "hasRDI": true,
                        "daily": 224.2216087866402,
                        "unit": "mg"
                    },
                    {
                        "label": "Phosphorus",
                        "tag": "P",
                        "schemaOrgTag": null,
                        "total": 1303.3747902814898,
                        "hasRDI": true,
                        "daily": 186.1963986116414,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin A",
                        "tag": "VITA_RAE",
                        "schemaOrgTag": null,
                        "total": 88.83580729165395,
                        "hasRDI": true,
                        "daily": 9.870645254628217,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin C",
                        "tag": "VITC",
                        "schemaOrgTag": null,
                        "total": 10.918098958300279,
                        "hasRDI": true,
                        "daily": 12.131221064778089,
                        "unit": "mg"
                    },
                    {
                        "label": "Thiamin (B1)",
                        "tag": "THIA",
                        "schemaOrgTag": null,
                        "total": 2.036016008270058,
                        "hasRDI": true,
                        "daily": 169.6680006891715,
                        "unit": "mg"
                    },
                    {
                        "label": "Riboflavin (B2)",
                        "tag": "RIBF",
                        "schemaOrgTag": null,
                        "total": 2.6535966945230283,
                        "hasRDI": true,
                        "daily": 204.12282265561757,
                        "unit": "mg"
                    },
                    {
                        "label": "Niacin (B3)",
                        "tag": "NIA",
                        "schemaOrgTag": null,
                        "total": 43.00360635553043,
                        "hasRDI": true,
                        "daily": 268.7725397220652,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin B6",
                        "tag": "VITB6A",
                        "schemaOrgTag": null,
                        "total": 2.1430203436450443,
                        "hasRDI": true,
                        "daily": 164.84771874192649,
                        "unit": "mg"
                    },
                    {
                        "label": "Folate equivalent (total)",
                        "tag": "FOLDFE",
                        "schemaOrgTag": null,
                        "total": 594.8706450718885,
                        "hasRDI": true,
                        "daily": 148.71766126797212,
                        "unit": "µg"
                    },
                    {
                        "label": "Folate (food)",
                        "tag": "FOLFD",
                        "schemaOrgTag": null,
                        "total": 150.87064507188845,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Folic acid",
                        "tag": "FOLAC",
                        "schemaOrgTag": null,
                        "total": 260,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin B12",
                        "tag": "VITB12",
                        "schemaOrgTag": null,
                        "total": 11.1127,
                        "hasRDI": true,
                        "daily": 463.0291666666667,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin D",
                        "tag": "VITD",
                        "schemaOrgTag": null,
                        "total": 1.51,
                        "hasRDI": true,
                        "daily": 10.066666666666666,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin E",
                        "tag": "TOCPHA",
                        "schemaOrgTag": null,
                        "total": 9.628620933692769,
                        "hasRDI": true,
                        "daily": 64.19080622461846,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin K",
                        "tag": "VITK1",
                        "schemaOrgTag": null,
                        "total": 74.31320412859422,
                        "hasRDI": true,
                        "daily": 61.92767010716185,
                        "unit": "µg"
                    },
                    {
                        "label": "Sugar alcohols",
                        "tag": "Sugar.alcohol",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    },
                    {
                        "label": "Water",
                        "tag": "WATER",
                        "schemaOrgTag": null,
                        "total": 801.495208703264,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    }
                ]
            },
            "_links": {
                "self": {
                    "href": "https://api.edamam.com/api/recipes/v2/552d62b578c9e13d3a3ef6bc7132ce88?type=public&app_id=ea1d37d5&app_key=fd382a172ba8d6668c0430dc9c14a181",
                    "title": "Self"
                }
            }
        },
        {
            "recipe": {
                "uri": "http://www.edamam.com/ontologies/edamam.owl#recipe_5654cf49386d9e00a5ace93b2c3c7b52",
                "label": "Miso Beef Noodle Soup",
                "image": "https://www.edamam.com/web-img/d11/d117b9774b1cefa60bf27cc58dfd742a.jpg",
                "source": "San Francisco Gate",
                "url": "http://www.sfgate.com/food/recipes/detail.html?rid=18945&sorig=qs",
                "shareAs": "http://www.edamam.com/recipe/miso-beef-noodle-soup-5654cf49386d9e00a5ace93b2c3c7b52/beef",
                "yield": 10,
                "dietLabels": [
                    "Low-Fat"
                ],
                "healthLabels": [
                    "Sugar-Conscious",
                    "Dairy-Free",
                    "Egg-Free",
                    "Peanut-Free",
                    "Tree-Nut-Free",
                    "Fish-Free",
                    "Shellfish-Free",
                    "Pork-Free",
                    "Crustacean-Free",
                    "Celery-Free",
                    "Mustard-Free",
                    "Sesame-Free",
                    "Lupine-Free",
                    "Mollusk-Free",
                    "Alcohol-Free",
                    "No oil added",
                    "Sulfite-Free",
                    "Kosher"
                ],
                "cautions": [
                    "Gluten",
                    "Wheat",
                    "Sulfites"
                ],
                "ingredientLines": [
                    "6 cups low-sodium beef broth",
                    "2 tablespoons red miso paste",
                    "1 pound lean beef, cut into thin slices",
                    "2 cups thinly sliced green onions",
                    "1 pound udon noodles",
                    "Kosher salt and freshly ground black pepper"
                ],
                "ingredients": [
                    {
                        "text": "6 cups low-sodium beef broth",
                        "weight": 1440,
                        "foodCategory": "canned soup",
                        "foodId": "food_bxd832fblxgfaibgn0zk0b6dg6dh",
                        "image": "https://www.edamam.com/food-img/428/4284513ddbf46e51f0f33566c0d61715.jpg"
                    },
                    {
                        "text": "2 tablespoons red miso paste",
                        "weight": 34,
                        "foodCategory": "plant-based protein",
                        "foodId": "food_agp37bpbhswz7sa7hlwj7b8vzcbt",
                        "image": "https://www.edamam.com/food-img/352/3525e5a38bb13c74aa34ef6c0273bf33.jpg"
                    },
                    {
                        "text": "1 pound lean beef, cut into thin slices",
                        "weight": 453.59237,
                        "foodCategory": "meats",
                        "foodId": "food_aorkcwpb5mij33awfffroag0z8j1",
                        "image": "https://www.edamam.com/food-img/e74/e7477c29517cdc4bcfcc1a0592b54613.jpg"
                    },
                    {
                        "text": "2 cups thinly sliced green onions",
                        "weight": 200,
                        "foodCategory": "vegetables",
                        "foodId": "food_bknlkyzbuzo27pb11whr4bttkuy6",
                        "image": "https://www.edamam.com/food-img/b89/b89986ed6aa466285bdd99bac34b3c46.jpg"
                    },
                    {
                        "text": "1 pound udon noodles",
                        "weight": 453.59237,
                        "foodCategory": "grains",
                        "foodId": "food_a8hs60uayl5icia1qe8qoba1kwp8",
                        "image": "https://www.edamam.com/food-img/296/296ff2b02ef3822928c3c923e22c7d19.jpg"
                    },
                    {
                        "text": "Kosher salt and freshly ground black pepper",
                        "weight": 15.487108440000002,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_a1vgrj1bs8rd1majvmd9ubz8ttkg",
                        "image": "https://www.edamam.com/food-img/694/6943ea510918c6025795e8dc6e6eaaeb.jpg"
                    },
                    {
                        "text": "Kosher salt and freshly ground black pepper",
                        "weight": 7.743554220000001,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_b6ywzluaaxv02wad7s1r9ag4py89",
                        "image": "https://www.edamam.com/food-img/c6e/c6e5c3bd8d3bc15175d9766971a4d1b2.jpg"
                    }
                ],
                "calories": 2583.5785525922,
                "totalWeight": 2592.730365784319,
                "totalTime": 0,
                "cuisineType": [
                    "japanese"
                ],
                "mealType": [
                    "lunch/dinner"
                ],
                "dishType": [
                    "soup"
                ],
                "totalNutrients": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 2583.5785525922,
                        "unit": "kcal"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 28.919420217572004,
                        "unit": "g"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 10.248295767242402,
                        "unit": "g"
                    },
                    "FATRN": {
                        "label": "Trans",
                        "quantity": 0.9661517481,
                        "unit": "g"
                    },
                    "FAMS": {
                        "label": "Monounsaturated",
                        "quantity": 11.725943010385802,
                        "unit": "g"
                    },
                    "FAPU": {
                        "label": "Polyunsaturated",
                        "quantity": 5.246711739815601,
                        "unit": "g"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 385.56176957969,
                        "unit": "g"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 23.510075057660003,
                        "unit": "g"
                    },
                    "SUGAR": {
                        "label": "Sugars",
                        "quantity": 26.704475026008,
                        "unit": "g"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 195.292329361458,
                        "unit": "g"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 299.37096420000006,
                        "unit": "mg"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 6020.500969642726,
                        "unit": "mg"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 472.5537718700366,
                        "unit": "mg"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 501.52192853184323,
                        "unit": "mg"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 6030.523594708945,
                        "unit": "mg"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 24.334778900924256,
                        "unit": "mg"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 35.58294237078232,
                        "unit": "mg"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 2391.9924482676,
                        "unit": "mg"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 112.5226070394,
                        "unit": "µg"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 37.6,
                        "unit": "mg"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 1.3979900675576,
                        "unit": "mg"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 2.6068208485960005,
                        "unit": "mg"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 45.25586311773461,
                        "unit": "mg"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 4.224699569780201,
                        "unit": "mg"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 264.36672561740005,
                        "unit": "µg"
                    },
                    "FOLFD": {
                        "label": "Folate (food)",
                        "quantity": 264.36672561740005,
                        "unit": "µg"
                    },
                    "FOLAC": {
                        "label": "Folic acid",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 11.004135354000002,
                        "unit": "µg"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 0.4535923700000001,
                        "unit": "µg"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 2.507273125888,
                        "unit": "mg"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 445.33567617814003,
                        "unit": "µg"
                    },
                    "WATER": {
                        "label": "Water",
                        "quantity": 1951.150781751941,
                        "unit": "g"
                    }
                },
                "totalDaily": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 129.17892762961,
                        "unit": "%"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 44.491415719341546,
                        "unit": "%"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 51.24147883621201,
                        "unit": "%"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 128.52058985989666,
                        "unit": "%"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 94.04030023064003,
                        "unit": "%"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 390.584658722916,
                        "unit": "%"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 99.79032140000002,
                        "unit": "%"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 250.8542070684469,
                        "unit": "%"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 47.25537718700366,
                        "unit": "%"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 119.4099829837722,
                        "unit": "%"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 128.30901265338179,
                        "unit": "%"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 135.19321611624588,
                        "unit": "%"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 323.4812942798393,
                        "unit": "%"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 341.71320689537146,
                        "unit": "%"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 12.502511893266668,
                        "unit": "%"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 41.77777777777778,
                        "unit": "%"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 116.49917229646667,
                        "unit": "%"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 200.52468066123078,
                        "unit": "%"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 282.84914448584135,
                        "unit": "%"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 324.97688998309235,
                        "unit": "%"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 66.09168140435001,
                        "unit": "%"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 458.5056397500001,
                        "unit": "%"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 3.0239491333333337,
                        "unit": "%"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 16.71515417258667,
                        "unit": "%"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 371.1130634817834,
                        "unit": "%"
                    }
                },
                "digest": [
                    {
                        "label": "Fat",
                        "tag": "FAT",
                        "schemaOrgTag": "fatContent",
                        "total": 28.919420217572004,
                        "hasRDI": true,
                        "daily": 44.491415719341546,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Saturated",
                                "tag": "FASAT",
                                "schemaOrgTag": "saturatedFatContent",
                                "total": 10.248295767242402,
                                "hasRDI": true,
                                "daily": 51.24147883621201,
                                "unit": "g"
                            },
                            {
                                "label": "Trans",
                                "tag": "FATRN",
                                "schemaOrgTag": "transFatContent",
                                "total": 0.9661517481,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Monounsaturated",
                                "tag": "FAMS",
                                "schemaOrgTag": null,
                                "total": 11.725943010385802,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Polyunsaturated",
                                "tag": "FAPU",
                                "schemaOrgTag": null,
                                "total": 5.246711739815601,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Carbs",
                        "tag": "CHOCDF",
                        "schemaOrgTag": "carbohydrateContent",
                        "total": 385.56176957969,
                        "hasRDI": true,
                        "daily": 128.52058985989666,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Carbs (net)",
                                "tag": "CHOCDF.net",
                                "schemaOrgTag": null,
                                "total": 362.05169452203,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Fiber",
                                "tag": "FIBTG",
                                "schemaOrgTag": "fiberContent",
                                "total": 23.510075057660003,
                                "hasRDI": true,
                                "daily": 94.04030023064003,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars",
                                "tag": "SUGAR",
                                "schemaOrgTag": "sugarContent",
                                "total": 26.704475026008,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars, added",
                                "tag": "SUGAR.added",
                                "schemaOrgTag": null,
                                "total": 0,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Protein",
                        "tag": "PROCNT",
                        "schemaOrgTag": "proteinContent",
                        "total": 195.292329361458,
                        "hasRDI": true,
                        "daily": 390.584658722916,
                        "unit": "g"
                    },
                    {
                        "label": "Cholesterol",
                        "tag": "CHOLE",
                        "schemaOrgTag": "cholesterolContent",
                        "total": 299.37096420000006,
                        "hasRDI": true,
                        "daily": 99.79032140000002,
                        "unit": "mg"
                    },
                    {
                        "label": "Sodium",
                        "tag": "NA",
                        "schemaOrgTag": "sodiumContent",
                        "total": 6020.500969642726,
                        "hasRDI": true,
                        "daily": 250.8542070684469,
                        "unit": "mg"
                    },
                    {
                        "label": "Calcium",
                        "tag": "CA",
                        "schemaOrgTag": null,
                        "total": 472.5537718700366,
                        "hasRDI": true,
                        "daily": 47.25537718700366,
                        "unit": "mg"
                    },
                    {
                        "label": "Magnesium",
                        "tag": "MG",
                        "schemaOrgTag": null,
                        "total": 501.52192853184323,
                        "hasRDI": true,
                        "daily": 119.4099829837722,
                        "unit": "mg"
                    },
                    {
                        "label": "Potassium",
                        "tag": "K",
                        "schemaOrgTag": null,
                        "total": 6030.523594708945,
                        "hasRDI": true,
                        "daily": 128.30901265338179,
                        "unit": "mg"
                    },
                    {
                        "label": "Iron",
                        "tag": "FE",
                        "schemaOrgTag": null,
                        "total": 24.334778900924256,
                        "hasRDI": true,
                        "daily": 135.19321611624588,
                        "unit": "mg"
                    },
                    {
                        "label": "Zinc",
                        "tag": "ZN",
                        "schemaOrgTag": null,
                        "total": 35.58294237078232,
                        "hasRDI": true,
                        "daily": 323.4812942798393,
                        "unit": "mg"
                    },
                    {
                        "label": "Phosphorus",
                        "tag": "P",
                        "schemaOrgTag": null,
                        "total": 2391.9924482676,
                        "hasRDI": true,
                        "daily": 341.71320689537146,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin A",
                        "tag": "VITA_RAE",
                        "schemaOrgTag": null,
                        "total": 112.5226070394,
                        "hasRDI": true,
                        "daily": 12.502511893266668,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin C",
                        "tag": "VITC",
                        "schemaOrgTag": null,
                        "total": 37.6,
                        "hasRDI": true,
                        "daily": 41.77777777777778,
                        "unit": "mg"
                    },
                    {
                        "label": "Thiamin (B1)",
                        "tag": "THIA",
                        "schemaOrgTag": null,
                        "total": 1.3979900675576,
                        "hasRDI": true,
                        "daily": 116.49917229646667,
                        "unit": "mg"
                    },
                    {
                        "label": "Riboflavin (B2)",
                        "tag": "RIBF",
                        "schemaOrgTag": null,
                        "total": 2.6068208485960005,
                        "hasRDI": true,
                        "daily": 200.52468066123078,
                        "unit": "mg"
                    },
                    {
                        "label": "Niacin (B3)",
                        "tag": "NIA",
                        "schemaOrgTag": null,
                        "total": 45.25586311773461,
                        "hasRDI": true,
                        "daily": 282.84914448584135,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin B6",
                        "tag": "VITB6A",
                        "schemaOrgTag": null,
                        "total": 4.224699569780201,
                        "hasRDI": true,
                        "daily": 324.97688998309235,
                        "unit": "mg"
                    },
                    {
                        "label": "Folate equivalent (total)",
                        "tag": "FOLDFE",
                        "schemaOrgTag": null,
                        "total": 264.36672561740005,
                        "hasRDI": true,
                        "daily": 66.09168140435001,
                        "unit": "µg"
                    },
                    {
                        "label": "Folate (food)",
                        "tag": "FOLFD",
                        "schemaOrgTag": null,
                        "total": 264.36672561740005,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Folic acid",
                        "tag": "FOLAC",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin B12",
                        "tag": "VITB12",
                        "schemaOrgTag": null,
                        "total": 11.004135354000002,
                        "hasRDI": true,
                        "daily": 458.5056397500001,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin D",
                        "tag": "VITD",
                        "schemaOrgTag": null,
                        "total": 0.4535923700000001,
                        "hasRDI": true,
                        "daily": 3.0239491333333337,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin E",
                        "tag": "TOCPHA",
                        "schemaOrgTag": null,
                        "total": 2.507273125888,
                        "hasRDI": true,
                        "daily": 16.71515417258667,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin K",
                        "tag": "VITK1",
                        "schemaOrgTag": null,
                        "total": 445.33567617814003,
                        "hasRDI": true,
                        "daily": 371.1130634817834,
                        "unit": "µg"
                    },
                    {
                        "label": "Sugar alcohols",
                        "tag": "Sugar.alcohol",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    },
                    {
                        "label": "Water",
                        "tag": "WATER",
                        "schemaOrgTag": null,
                        "total": 1951.150781751941,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    }
                ]
            },
            "_links": {
                "self": {
                    "href": "https://api.edamam.com/api/recipes/v2/5654cf49386d9e00a5ace93b2c3c7b52?type=public&app_id=ea1d37d5&app_key=fd382a172ba8d6668c0430dc9c14a181",
                    "title": "Self"
                }
            }
        },
        {
            "recipe": {
                "uri": "http://www.edamam.com/ontologies/edamam.owl#recipe_991232a409facc297814cbd1acf50038",
                "label": "Corned Beef Hash",
                "image": "https://www.edamam.com/web-img/7a7/7a766341f9356d2a29e11a458ad64e2a.jpg",
                "source": "Cookstr",
                "url": "http://www.cookstr.com/recipes/corned-beef-hash-james-beard",
                "shareAs": "http://www.edamam.com/recipe/corned-beef-hash-991232a409facc297814cbd1acf50038/beef",
                "yield": 12,
                "dietLabels": [],
                "healthLabels": [
                    "Sugar-Conscious",
                    "Gluten-Free",
                    "Wheat-Free",
                    "Egg-Free",
                    "Peanut-Free",
                    "Tree-Nut-Free",
                    "Soy-Free",
                    "Fish-Free",
                    "Shellfish-Free",
                    "Pork-Free",
                    "Crustacean-Free",
                    "Celery-Free",
                    "Mustard-Free",
                    "Sesame-Free",
                    "Lupine-Free",
                    "Mollusk-Free",
                    "Alcohol-Free",
                    "Sulfite-Free",
                    "Immuno-Supportive"
                ],
                "cautions": [],
                "ingredientLines": [
                    "2 pounds cold corned beef",
                    "4 to 6 cold boiled potatoes of medium size, coarsely chopped",
                    "1 medium size onion, finely chopped",
                    "Freshly ground pepper",
                    "¼ teaspoon nutmeg",
                    "Butter or beef drippings",
                    "Heavy cream or boiling water (optional)"
                ],
                "ingredients": [
                    {
                        "text": "2 pounds cold corned beef",
                        "weight": 907.18474,
                        "foodCategory": "cured meats",
                        "foodId": "food_aejgdv3a562bk6a89mn8fbatgvvy",
                        "image": "https://www.edamam.com/food-img/398/3987556d40b795424aca4c832bce1c4a.jpg"
                    },
                    {
                        "text": "4 to 6 cold boiled potatoes of medium size, coarsely chopped",
                        "weight": 1065,
                        "foodCategory": "vegetables",
                        "foodId": "food_abiw5baauresjmb6xpap2bg3otzu",
                        "image": "https://www.edamam.com/food-img/651/6512e82417bce15c2899630c1a2799df.jpg"
                    },
                    {
                        "text": "1 medium size onion, finely chopped",
                        "weight": 110,
                        "foodCategory": "vegetables",
                        "foodId": "food_bmrvi4ob4binw9a5m7l07amlfcoy",
                        "image": "https://www.edamam.com/food-img/205/205e6bf2399b85d34741892ef91cc603.jpg"
                    },
                    {
                        "text": "Freshly ground pepper",
                        "weight": 6.248204220000001,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_b6ywzluaaxv02wad7s1r9ag4py89",
                        "image": "https://www.edamam.com/food-img/c6e/c6e5c3bd8d3bc15175d9766971a4d1b2.jpg"
                    },
                    {
                        "text": "¼ teaspoon nutmeg",
                        "weight": 0.55,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_aa8vp2kadkkiiubgpp48fazrqiq2",
                        "image": "https://www.edamam.com/food-img/b9e/b9e54f78ae18cf99a6504b472ba25e7b.jpg"
                    },
                    {
                        "text": "Butter or beef drippings",
                        "weight": 28.325192464000004,
                        "foodCategory": "Dairy",
                        "foodId": "food_awz3iefajbk1fwahq9logahmgltj",
                        "image": "https://www.edamam.com/food-img/713/71397239b670d88c04faa8d05035cab4.jpg"
                    },
                    {
                        "text": "Heavy cream or boiling water (optional)",
                        "weight": 62.48204220000001,
                        "foodCategory": "Dairy",
                        "foodId": "food_bgtkr21b5v16mca246x9ebnaswyo",
                        "image": "https://www.edamam.com/food-img/484/4848d71f6a14dd5076083f5e17925420.jpg"
                    }
                ],
                "calories": 3097.5009533490806,
                "totalWeight": 2179.790178884,
                "totalTime": 240,
                "cuisineType": [
                    "american"
                ],
                "mealType": [
                    "lunch/dinner"
                ],
                "dishType": [
                    "main course"
                ],
                "totalNutrients": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 3097.5009533490806,
                        "unit": "kcal"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 182.73534193912243,
                        "unit": "g"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 72.40353202915394,
                        "unit": "g"
                    },
                    "FATRN": {
                        "label": "Trans",
                        "quantity": 0.9284998089699201,
                        "unit": "g"
                    },
                    "FAMS": {
                        "label": "Monounsaturated",
                        "quantity": 77.86641829853525,
                        "unit": "g"
                    },
                    "FAPU": {
                        "label": "Polyunsaturated",
                        "quantity": 7.069450066623121,
                        "unit": "g"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 203.6266243275484,
                        "unit": "g"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 26.995195667660003,
                        "unit": "g"
                    },
                    "SUGAR": {
                        "label": "Sugars",
                        "quantity": 14.787677599866399,
                        "unit": "g"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 158.10067425150206,
                        "unit": "g"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 636.3793212116,
                        "unit": "mg"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 11136.93487385104,
                        "unit": "mg"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 292.70585011596006,
                        "unit": "mg"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 399.5870396194801,
                        "unit": "mg"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 7477.211889725162,
                        "unit": "mg"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 24.5172523869148,
                        "unit": "mg"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 29.385645090495604,
                        "unit": "mg"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 1756.9367208229603,
                        "unit": "mg"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 452.2600250351601,
                        "unit": "µg"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 463.27627205320005,
                        "unit": "mg"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 1.3165028076648,
                        "unit": "mg"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 1.88470112125376,
                        "unit": "mg"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 44.67048753552749,
                        "unit": "mg"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 5.940743107026121,
                        "unit": "mg"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 241.48846917932002,
                        "unit": "µg"
                    },
                    "FOLFD": {
                        "label": "Folate (food)",
                        "quantity": 241.48846917932002,
                        "unit": "µg"
                    },
                    "FOLAC": {
                        "label": "Folic acid",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 16.308508875148803,
                        "unit": "µg"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 0.8622521823600001,
                        "unit": "µg"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 1.5129354363728003,
                        "unit": "mg"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 34.885499131020005,
                        "unit": "µg"
                    },
                    "WATER": {
                        "label": "Water",
                        "quantity": 1588.7668802714736,
                        "unit": "g"
                    }
                },
                "totalDaily": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 154.87504766745403,
                        "unit": "%"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 281.1312952909576,
                        "unit": "%"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 362.0176601457697,
                        "unit": "%"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 67.87554144251614,
                        "unit": "%"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 107.98078267064002,
                        "unit": "%"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 316.2013485030041,
                        "unit": "%"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 212.12644040386667,
                        "unit": "%"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 464.0389530771266,
                        "unit": "%"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 29.270585011596005,
                        "unit": "%"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 95.13977133797145,
                        "unit": "%"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 159.08961467500345,
                        "unit": "%"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 136.20695770508223,
                        "unit": "%"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 267.14222809541457,
                        "unit": "%"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 250.99096011756575,
                        "unit": "%"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 50.251113892795566,
                        "unit": "%"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 514.7514133924445,
                        "unit": "%"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 109.7085673054,
                        "unit": "%"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 144.9770093272123,
                        "unit": "%"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 279.1905470970468,
                        "unit": "%"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 456.9802390020092,
                        "unit": "%"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 60.372117294830005,
                        "unit": "%"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 679.5212031312001,
                        "unit": "%"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 5.748347882400001,
                        "unit": "%"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 10.086236242485336,
                        "unit": "%"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 29.071249275850004,
                        "unit": "%"
                    }
                },
                "digest": [
                    {
                        "label": "Fat",
                        "tag": "FAT",
                        "schemaOrgTag": "fatContent",
                        "total": 182.73534193912243,
                        "hasRDI": true,
                        "daily": 281.1312952909576,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Saturated",
                                "tag": "FASAT",
                                "schemaOrgTag": "saturatedFatContent",
                                "total": 72.40353202915394,
                                "hasRDI": true,
                                "daily": 362.0176601457697,
                                "unit": "g"
                            },
                            {
                                "label": "Trans",
                                "tag": "FATRN",
                                "schemaOrgTag": "transFatContent",
                                "total": 0.9284998089699201,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Monounsaturated",
                                "tag": "FAMS",
                                "schemaOrgTag": null,
                                "total": 77.86641829853525,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Polyunsaturated",
                                "tag": "FAPU",
                                "schemaOrgTag": null,
                                "total": 7.069450066623121,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Carbs",
                        "tag": "CHOCDF",
                        "schemaOrgTag": "carbohydrateContent",
                        "total": 203.6266243275484,
                        "hasRDI": true,
                        "daily": 67.87554144251614,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Carbs (net)",
                                "tag": "CHOCDF.net",
                                "schemaOrgTag": null,
                                "total": 176.6314286598884,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Fiber",
                                "tag": "FIBTG",
                                "schemaOrgTag": "fiberContent",
                                "total": 26.995195667660003,
                                "hasRDI": true,
                                "daily": 107.98078267064002,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars",
                                "tag": "SUGAR",
                                "schemaOrgTag": "sugarContent",
                                "total": 14.787677599866399,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars, added",
                                "tag": "SUGAR.added",
                                "schemaOrgTag": null,
                                "total": 0,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Protein",
                        "tag": "PROCNT",
                        "schemaOrgTag": "proteinContent",
                        "total": 158.10067425150206,
                        "hasRDI": true,
                        "daily": 316.2013485030041,
                        "unit": "g"
                    },
                    {
                        "label": "Cholesterol",
                        "tag": "CHOLE",
                        "schemaOrgTag": "cholesterolContent",
                        "total": 636.3793212116,
                        "hasRDI": true,
                        "daily": 212.12644040386667,
                        "unit": "mg"
                    },
                    {
                        "label": "Sodium",
                        "tag": "NA",
                        "schemaOrgTag": "sodiumContent",
                        "total": 11136.93487385104,
                        "hasRDI": true,
                        "daily": 464.0389530771266,
                        "unit": "mg"
                    },
                    {
                        "label": "Calcium",
                        "tag": "CA",
                        "schemaOrgTag": null,
                        "total": 292.70585011596006,
                        "hasRDI": true,
                        "daily": 29.270585011596005,
                        "unit": "mg"
                    },
                    {
                        "label": "Magnesium",
                        "tag": "MG",
                        "schemaOrgTag": null,
                        "total": 399.5870396194801,
                        "hasRDI": true,
                        "daily": 95.13977133797145,
                        "unit": "mg"
                    },
                    {
                        "label": "Potassium",
                        "tag": "K",
                        "schemaOrgTag": null,
                        "total": 7477.211889725162,
                        "hasRDI": true,
                        "daily": 159.08961467500345,
                        "unit": "mg"
                    },
                    {
                        "label": "Iron",
                        "tag": "FE",
                        "schemaOrgTag": null,
                        "total": 24.5172523869148,
                        "hasRDI": true,
                        "daily": 136.20695770508223,
                        "unit": "mg"
                    },
                    {
                        "label": "Zinc",
                        "tag": "ZN",
                        "schemaOrgTag": null,
                        "total": 29.385645090495604,
                        "hasRDI": true,
                        "daily": 267.14222809541457,
                        "unit": "mg"
                    },
                    {
                        "label": "Phosphorus",
                        "tag": "P",
                        "schemaOrgTag": null,
                        "total": 1756.9367208229603,
                        "hasRDI": true,
                        "daily": 250.99096011756575,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin A",
                        "tag": "VITA_RAE",
                        "schemaOrgTag": null,
                        "total": 452.2600250351601,
                        "hasRDI": true,
                        "daily": 50.251113892795566,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin C",
                        "tag": "VITC",
                        "schemaOrgTag": null,
                        "total": 463.27627205320005,
                        "hasRDI": true,
                        "daily": 514.7514133924445,
                        "unit": "mg"
                    },
                    {
                        "label": "Thiamin (B1)",
                        "tag": "THIA",
                        "schemaOrgTag": null,
                        "total": 1.3165028076648,
                        "hasRDI": true,
                        "daily": 109.7085673054,
                        "unit": "mg"
                    },
                    {
                        "label": "Riboflavin (B2)",
                        "tag": "RIBF",
                        "schemaOrgTag": null,
                        "total": 1.88470112125376,
                        "hasRDI": true,
                        "daily": 144.9770093272123,
                        "unit": "mg"
                    },
                    {
                        "label": "Niacin (B3)",
                        "tag": "NIA",
                        "schemaOrgTag": null,
                        "total": 44.67048753552749,
                        "hasRDI": true,
                        "daily": 279.1905470970468,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin B6",
                        "tag": "VITB6A",
                        "schemaOrgTag": null,
                        "total": 5.940743107026121,
                        "hasRDI": true,
                        "daily": 456.9802390020092,
                        "unit": "mg"
                    },
                    {
                        "label": "Folate equivalent (total)",
                        "tag": "FOLDFE",
                        "schemaOrgTag": null,
                        "total": 241.48846917932002,
                        "hasRDI": true,
                        "daily": 60.372117294830005,
                        "unit": "µg"
                    },
                    {
                        "label": "Folate (food)",
                        "tag": "FOLFD",
                        "schemaOrgTag": null,
                        "total": 241.48846917932002,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Folic acid",
                        "tag": "FOLAC",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin B12",
                        "tag": "VITB12",
                        "schemaOrgTag": null,
                        "total": 16.308508875148803,
                        "hasRDI": true,
                        "daily": 679.5212031312001,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin D",
                        "tag": "VITD",
                        "schemaOrgTag": null,
                        "total": 0.8622521823600001,
                        "hasRDI": true,
                        "daily": 5.748347882400001,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin E",
                        "tag": "TOCPHA",
                        "schemaOrgTag": null,
                        "total": 1.5129354363728003,
                        "hasRDI": true,
                        "daily": 10.086236242485336,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin K",
                        "tag": "VITK1",
                        "schemaOrgTag": null,
                        "total": 34.885499131020005,
                        "hasRDI": true,
                        "daily": 29.071249275850004,
                        "unit": "µg"
                    },
                    {
                        "label": "Sugar alcohols",
                        "tag": "Sugar.alcohol",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    },
                    {
                        "label": "Water",
                        "tag": "WATER",
                        "schemaOrgTag": null,
                        "total": 1588.7668802714736,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    }
                ]
            },
            "_links": {
                "self": {
                    "href": "https://api.edamam.com/api/recipes/v2/991232a409facc297814cbd1acf50038?type=public&app_id=ea1d37d5&app_key=fd382a172ba8d6668c0430dc9c14a181",
                    "title": "Self"
                }
            }
        },
        {
            "recipe": {
                "uri": "http://www.edamam.com/ontologies/edamam.owl#recipe_4b618d914641134be87084c4cb217a3f",
                "label": "Beef Carnitas",
                "image": "https://www.edamam.com/web-img/431/431ea8ed1e8b779dc8644e0c3a8d5c19.jpg",
                "source": "Men's Health",
                "url": "https://www.menshealth.com/recipes/beef-carnitas",
                "shareAs": "http://www.edamam.com/recipe/beef-carnitas-4b618d914641134be87084c4cb217a3f/beef",
                "yield": 4,
                "dietLabels": [
                    "High-Protein",
                    "Low-Carb"
                ],
                "healthLabels": [
                    "Sugar-Conscious",
                    "Keto-Friendly",
                    "Paleo",
                    "Dairy-Free",
                    "Gluten-Free",
                    "Wheat-Free",
                    "Egg-Free",
                    "Peanut-Free",
                    "Tree-Nut-Free",
                    "Soy-Free",
                    "Fish-Free",
                    "Shellfish-Free",
                    "Pork-Free",
                    "Crustacean-Free",
                    "Celery-Free",
                    "Mustard-Free",
                    "Sesame-Free",
                    "Lupine-Free",
                    "Mollusk-Free",
                    "Alcohol-Free",
                    "No oil added",
                    "Sulfite-Free",
                    "Kosher"
                ],
                "cautions": [
                    "Sulfites",
                    "FODMAP"
                ],
                "ingredientLines": [
                    "2 lb lb lean beef stew meat, cut into 1/2\" pieces",
                    "3/4 cup mild salsa",
                    "2 tbsp chopped chipotle chili peppers in adobo sauce",
                    "1/2 tsp salt",
                    "tsp black pepper",
                    "1 C beef stock (we used Kitchen Basics) or water"
                ],
                "ingredients": [
                    {
                        "text": "2 lb lb lean beef stew meat, cut into 1/2\" pieces",
                        "weight": 453.59237,
                        "foodCategory": "meats",
                        "foodId": "food_aorkcwpb5mij33awfffroag0z8j1",
                        "image": "https://www.edamam.com/food-img/e74/e7477c29517cdc4bcfcc1a0592b54613.jpg"
                    },
                    {
                        "text": "3/4 cup mild salsa",
                        "weight": 195,
                        "foodCategory": "canned soup",
                        "foodId": "food_b0t3obfawlm5k2b6erxscacez35u",
                        "image": "https://www.edamam.com/food-img/995/995d0f166754a0475c181b9c156fec43.jpg"
                    },
                    {
                        "text": "2 tbsp chopped chipotle chili peppers in adobo sauce",
                        "weight": 16.99999999971258,
                        "foodCategory": "canned vegetables",
                        "foodId": "food_bumzpysb5k05cibmscqp2a0fwgpa",
                        "image": "https://www.edamam.com/food-img/c34/c343c40fbfe50bd72bbb3890c83a4315.jpeg"
                    },
                    {
                        "text": "1/2 tsp salt",
                        "weight": 3,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_btxz81db72hwbra2pncvebzzzum9",
                        "image": "https://www.edamam.com/food-img/694/6943ea510918c6025795e8dc6e6eaaeb.jpg"
                    },
                    {
                        "text": "tsp black pepper",
                        "weight": 2.9,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_b6ywzluaaxv02wad7s1r9ag4py89",
                        "image": "https://www.edamam.com/food-img/c6e/c6e5c3bd8d3bc15175d9766971a4d1b2.jpg"
                    },
                    {
                        "text": "1 C beef stock (we used Kitchen Basics) or water",
                        "weight": 240,
                        "foodCategory": "canned soup",
                        "foodId": "food_bxd832fblxgfaibgn0zk0b6dg6dh",
                        "image": "https://www.edamam.com/food-img/428/4284513ddbf46e51f0f33566c0d61715.jpg"
                    }
                ],
                "calories": 661.0535387999397,
                "totalWeight": 908.4923699997127,
                "totalTime": 10,
                "cuisineType": [
                    "mexican"
                ],
                "mealType": [
                    "lunch/dinner"
                ],
                "dishType": [
                    "main course"
                ],
                "totalNutrients": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 661.0535387999397,
                        "unit": "kcal"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 18.757375562999712,
                        "unit": "g"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 8.113362627599972,
                        "unit": "g"
                    },
                    "FATRN": {
                        "label": "Trans",
                        "quantity": 0.9661517481,
                        "unit": "g"
                    },
                    "FAMS": {
                        "label": "Monounsaturated",
                        "quantity": 9.971996191999983,
                        "unit": "g"
                    },
                    "FAPU": {
                        "label": "Polyunsaturated",
                        "quantity": 1.576352101899842,
                        "unit": "g"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 19.658093976985338,
                        "unit": "g"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 4.464699999996263,
                        "unit": "g"
                    },
                    "SUGAR": {
                        "label": "Sugars",
                        "quantity": 9.561959999990458,
                        "unit": "g"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 107.52203902999742,
                        "unit": "g"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 299.37096420000006,
                        "unit": "mg"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 2417.3498196966284,
                        "unit": "mg"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 155.23993179997987,
                        "unit": "mg"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 144.10747399995978,
                        "unit": "mg"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 2698.477608299463,
                        "unit": "mg"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 11.773622139998563,
                        "unit": "mg"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 25.834849586999514,
                        "unit": "mg"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 1096.1800532999512,
                        "unit": "mg"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 157.80484739828984,
                        "unit": "µg"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 15.264999999804553,
                        "unit": "mg"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 0.5168558959999425,
                        "unit": "mg"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 1.0656270289998564,
                        "unit": "mg"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 27.987391002997708,
                        "unit": "mg"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 3.0860536615995606,
                        "unit": "mg"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 32.93669479997126,
                        "unit": "µg"
                    },
                    "FOLFD": {
                        "label": "Folate (food)",
                        "quantity": 32.93669479997126,
                        "unit": "µg"
                    },
                    "FOLAC": {
                        "label": "Folic acid",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 10.976935354000002,
                        "unit": "µg"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 0.4535923700000001,
                        "unit": "µg"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 3.230848554998017,
                        "unit": "mg"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 21.46018554997499,
                        "unit": "µg"
                    },
                    "WATER": {
                        "label": "Water",
                        "quantity": 750.2932261227343,
                        "unit": "g"
                    }
                },
                "totalDaily": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 33.052676939996985,
                        "unit": "%"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 28.8575008661534,
                        "unit": "%"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 40.56681313799986,
                        "unit": "%"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 6.552697992328446,
                        "unit": "%"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 17.858799999985052,
                        "unit": "%"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 215.04407805999483,
                        "unit": "%"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 99.79032140000002,
                        "unit": "%"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 100.72290915402618,
                        "unit": "%"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 15.523993179997987,
                        "unit": "%"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 34.31130333332376,
                        "unit": "%"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 57.41441719786092,
                        "unit": "%"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 65.40901188888091,
                        "unit": "%"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 234.86226897272283,
                        "unit": "%"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 156.5971504714216,
                        "unit": "%"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 17.533871933143317,
                        "unit": "%"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 16.96111111089395,
                        "unit": "%"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 43.07132466666188,
                        "unit": "%"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 81.97130992306587,
                        "unit": "%"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 174.92119376873566,
                        "unit": "%"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 237.3887431999662,
                        "unit": "%"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 8.234173699992814,
                        "unit": "%"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 457.3723064166668,
                        "unit": "%"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 3.0239491333333337,
                        "unit": "%"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 21.538990366653444,
                        "unit": "%"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 17.883487958312493,
                        "unit": "%"
                    }
                },
                "digest": [
                    {
                        "label": "Fat",
                        "tag": "FAT",
                        "schemaOrgTag": "fatContent",
                        "total": 18.757375562999712,
                        "hasRDI": true,
                        "daily": 28.8575008661534,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Saturated",
                                "tag": "FASAT",
                                "schemaOrgTag": "saturatedFatContent",
                                "total": 8.113362627599972,
                                "hasRDI": true,
                                "daily": 40.56681313799986,
                                "unit": "g"
                            },
                            {
                                "label": "Trans",
                                "tag": "FATRN",
                                "schemaOrgTag": "transFatContent",
                                "total": 0.9661517481,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Monounsaturated",
                                "tag": "FAMS",
                                "schemaOrgTag": null,
                                "total": 9.971996191999983,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Polyunsaturated",
                                "tag": "FAPU",
                                "schemaOrgTag": null,
                                "total": 1.576352101899842,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Carbs",
                        "tag": "CHOCDF",
                        "schemaOrgTag": "carbohydrateContent",
                        "total": 19.658093976985338,
                        "hasRDI": true,
                        "daily": 6.552697992328446,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Carbs (net)",
                                "tag": "CHOCDF.net",
                                "schemaOrgTag": null,
                                "total": 15.193393976989075,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Fiber",
                                "tag": "FIBTG",
                                "schemaOrgTag": "fiberContent",
                                "total": 4.464699999996263,
                                "hasRDI": true,
                                "daily": 17.858799999985052,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars",
                                "tag": "SUGAR",
                                "schemaOrgTag": "sugarContent",
                                "total": 9.561959999990458,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars, added",
                                "tag": "SUGAR.added",
                                "schemaOrgTag": null,
                                "total": 0,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Protein",
                        "tag": "PROCNT",
                        "schemaOrgTag": "proteinContent",
                        "total": 107.52203902999742,
                        "hasRDI": true,
                        "daily": 215.04407805999483,
                        "unit": "g"
                    },
                    {
                        "label": "Cholesterol",
                        "tag": "CHOLE",
                        "schemaOrgTag": "cholesterolContent",
                        "total": 299.37096420000006,
                        "hasRDI": true,
                        "daily": 99.79032140000002,
                        "unit": "mg"
                    },
                    {
                        "label": "Sodium",
                        "tag": "NA",
                        "schemaOrgTag": "sodiumContent",
                        "total": 2417.3498196966284,
                        "hasRDI": true,
                        "daily": 100.72290915402618,
                        "unit": "mg"
                    },
                    {
                        "label": "Calcium",
                        "tag": "CA",
                        "schemaOrgTag": null,
                        "total": 155.23993179997987,
                        "hasRDI": true,
                        "daily": 15.523993179997987,
                        "unit": "mg"
                    },
                    {
                        "label": "Magnesium",
                        "tag": "MG",
                        "schemaOrgTag": null,
                        "total": 144.10747399995978,
                        "hasRDI": true,
                        "daily": 34.31130333332376,
                        "unit": "mg"
                    },
                    {
                        "label": "Potassium",
                        "tag": "K",
                        "schemaOrgTag": null,
                        "total": 2698.477608299463,
                        "hasRDI": true,
                        "daily": 57.41441719786092,
                        "unit": "mg"
                    },
                    {
                        "label": "Iron",
                        "tag": "FE",
                        "schemaOrgTag": null,
                        "total": 11.773622139998563,
                        "hasRDI": true,
                        "daily": 65.40901188888091,
                        "unit": "mg"
                    },
                    {
                        "label": "Zinc",
                        "tag": "ZN",
                        "schemaOrgTag": null,
                        "total": 25.834849586999514,
                        "hasRDI": true,
                        "daily": 234.86226897272283,
                        "unit": "mg"
                    },
                    {
                        "label": "Phosphorus",
                        "tag": "P",
                        "schemaOrgTag": null,
                        "total": 1096.1800532999512,
                        "hasRDI": true,
                        "daily": 156.5971504714216,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin A",
                        "tag": "VITA_RAE",
                        "schemaOrgTag": null,
                        "total": 157.80484739828984,
                        "hasRDI": true,
                        "daily": 17.533871933143317,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin C",
                        "tag": "VITC",
                        "schemaOrgTag": null,
                        "total": 15.264999999804553,
                        "hasRDI": true,
                        "daily": 16.96111111089395,
                        "unit": "mg"
                    },
                    {
                        "label": "Thiamin (B1)",
                        "tag": "THIA",
                        "schemaOrgTag": null,
                        "total": 0.5168558959999425,
                        "hasRDI": true,
                        "daily": 43.07132466666188,
                        "unit": "mg"
                    },
                    {
                        "label": "Riboflavin (B2)",
                        "tag": "RIBF",
                        "schemaOrgTag": null,
                        "total": 1.0656270289998564,
                        "hasRDI": true,
                        "daily": 81.97130992306587,
                        "unit": "mg"
                    },
                    {
                        "label": "Niacin (B3)",
                        "tag": "NIA",
                        "schemaOrgTag": null,
                        "total": 27.987391002997708,
                        "hasRDI": true,
                        "daily": 174.92119376873566,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin B6",
                        "tag": "VITB6A",
                        "schemaOrgTag": null,
                        "total": 3.0860536615995606,
                        "hasRDI": true,
                        "daily": 237.3887431999662,
                        "unit": "mg"
                    },
                    {
                        "label": "Folate equivalent (total)",
                        "tag": "FOLDFE",
                        "schemaOrgTag": null,
                        "total": 32.93669479997126,
                        "hasRDI": true,
                        "daily": 8.234173699992814,
                        "unit": "µg"
                    },
                    {
                        "label": "Folate (food)",
                        "tag": "FOLFD",
                        "schemaOrgTag": null,
                        "total": 32.93669479997126,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Folic acid",
                        "tag": "FOLAC",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin B12",
                        "tag": "VITB12",
                        "schemaOrgTag": null,
                        "total": 10.976935354000002,
                        "hasRDI": true,
                        "daily": 457.3723064166668,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin D",
                        "tag": "VITD",
                        "schemaOrgTag": null,
                        "total": 0.4535923700000001,
                        "hasRDI": true,
                        "daily": 3.0239491333333337,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin E",
                        "tag": "TOCPHA",
                        "schemaOrgTag": null,
                        "total": 3.230848554998017,
                        "hasRDI": true,
                        "daily": 21.538990366653444,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin K",
                        "tag": "VITK1",
                        "schemaOrgTag": null,
                        "total": 21.46018554997499,
                        "hasRDI": true,
                        "daily": 17.883487958312493,
                        "unit": "µg"
                    },
                    {
                        "label": "Sugar alcohols",
                        "tag": "Sugar.alcohol",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    },
                    {
                        "label": "Water",
                        "tag": "WATER",
                        "schemaOrgTag": null,
                        "total": 750.2932261227343,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    }
                ]
            },
            "_links": {
                "self": {
                    "href": "https://api.edamam.com/api/recipes/v2/4b618d914641134be87084c4cb217a3f?type=public&app_id=ea1d37d5&app_key=fd382a172ba8d6668c0430dc9c14a181",
                    "title": "Self"
                }
            }
        },
        {
            "recipe": {
                "uri": "http://www.edamam.com/ontologies/edamam.owl#recipe_62ebc9d43ec31eace0c035db993eb1f5",
                "label": "Roast sirloin of beef",
                "image": "https://www.edamam.com/web-img/889/88989a61c8c566b8d29ed6b982fb06d8.jpg",
                "source": "BBC Good Food",
                "url": "https://www.bbcgoodfood.com/recipes/roast-sirloin-beef",
                "shareAs": "http://www.edamam.com/recipe/roast-sirloin-of-beef-62ebc9d43ec31eace0c035db993eb1f5/beef",
                "yield": 6,
                "dietLabels": [
                    "High-Protein",
                    "Low-Carb"
                ],
                "healthLabels": [
                    "Sugar-Conscious",
                    "Keto-Friendly",
                    "Dairy-Free",
                    "Gluten-Free",
                    "Wheat-Free",
                    "Egg-Free",
                    "Peanut-Free",
                    "Tree-Nut-Free",
                    "Soy-Free",
                    "Fish-Free",
                    "Shellfish-Free",
                    "Pork-Free",
                    "Crustacean-Free",
                    "Celery-Free",
                    "Mustard-Free",
                    "Sesame-Free",
                    "Lupine-Free",
                    "Mollusk-Free",
                    "Kosher"
                ],
                "cautions": [
                    "Gluten",
                    "Wheat",
                    "Sulfites"
                ],
                "ingredientLines": [
                    "2 tbsp vegetable oil or beef fat",
                    "1-1.5kg/2lb 4-3lb 5oz sirloin of beef joint",
                    "1 glass red wine",
                    "400g can beef consommé"
                ],
                "ingredients": [
                    {
                        "text": "2 tbsp vegetable oil or beef fat",
                        "weight": 28,
                        "foodCategory": "Oils",
                        "foodId": "food_bt1mzi2ah2sfg8bv7no1qai83w8s",
                        "image": "https://www.edamam.com/food-img/6e5/6e51a63a6300a8ea1b4c4cc68dfaba33.jpg"
                    },
                    {
                        "text": "1-1.5kg/2lb 4-3lb 5oz sirloin of beef joint",
                        "weight": 1250,
                        "foodCategory": "meats",
                        "foodId": "food_bknby1la98smrsbwnthinbam42nj",
                        "image": "https://www.edamam.com/food-img/bab/bab88ab3ea40d34e4c8ae35d6b30344a.jpg"
                    },
                    {
                        "text": "1 glass red wine",
                        "weight": 235.2,
                        "foodCategory": "wines",
                        "foodId": "food_b5q0xv2ba8la5hbzdfzdgaca3fwu",
                        "image": "https://www.edamam.com/food-img/82b/82b8d0db2d5c38fc7498a657c0afc4ee.JPG"
                    },
                    {
                        "text": "400g can beef consommé",
                        "weight": 400,
                        "foodCategory": "canned soup",
                        "foodId": "food_arlagstbtxcrk4ablvuh9b36no9m",
                        "image": "https://www.edamam.com/food-img/6a5/6a5f7cf073a7e70af946bfb4d558a914.jpg"
                    }
                ],
                "calories": 2120.44,
                "totalWeight": 1913.2,
                "totalTime": 160,
                "cuisineType": [
                    "mediterranean"
                ],
                "mealType": [
                    "lunch/dinner"
                ],
                "dishType": [
                    "main course"
                ],
                "totalNutrients": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 2120.44,
                        "unit": "kcal"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 88.125,
                        "unit": "g"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 26.673080000000002,
                        "unit": "g"
                    },
                    "FATRN": {
                        "label": "Trans",
                        "quantity": 3.33976,
                        "unit": "g"
                    },
                    "FAMS": {
                        "label": "Monounsaturated",
                        "quantity": 51.53248,
                        "unit": "g"
                    },
                    "FAPU": {
                        "label": "Polyunsaturated",
                        "quantity": 8.66244,
                        "unit": "g"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 10.55872,
                        "unit": "g"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 0,
                        "unit": "g"
                    },
                    "SUGAR": {
                        "label": "Sugars",
                        "quantity": 1.45824,
                        "unit": "g"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 279.54464,
                        "unit": "g"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 787.5,
                        "unit": "mg"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 2052.908,
                        "unit": "mg"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 197.316,
                        "unit": "mg"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 290.724,
                        "unit": "mg"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 5217.204,
                        "unit": "mg"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 28.08692,
                        "unit": "mg"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 68.55427999999999,
                        "unit": "mg"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 2818.596,
                        "unit": "mg"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 25,
                        "unit": "µg"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 1.6,
                        "unit": "mg"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 1.04776,
                        "unit": "mg"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 2.245912,
                        "unit": "mg"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 62.79434799999999,
                        "unit": "mg"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 7.274064,
                        "unit": "mg"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 43.852,
                        "unit": "µg"
                    },
                    "FOLFD": {
                        "label": "Folate (food)",
                        "quantity": 43.852,
                        "unit": "µg"
                    },
                    "FOLAC": {
                        "label": "Folic acid",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 28.375,
                        "unit": "µg"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 1.25,
                        "unit": "µg"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 8.354000000000001,
                        "unit": "mg"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 19.6908,
                        "unit": "µg"
                    },
                    "WATER": {
                        "label": "Water",
                        "quantity": 1492.38448,
                        "unit": "g"
                    }
                },
                "totalDaily": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 106.022,
                        "unit": "%"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 135.57692307692307,
                        "unit": "%"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 133.36540000000002,
                        "unit": "%"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 3.5195733333333328,
                        "unit": "%"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 0,
                        "unit": "%"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 559.08928,
                        "unit": "%"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 262.5,
                        "unit": "%"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 85.53783333333332,
                        "unit": "%"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 19.7316,
                        "unit": "%"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 69.22,
                        "unit": "%"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 111.00434042553191,
                        "unit": "%"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 156.03844444444445,
                        "unit": "%"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 623.2207272727272,
                        "unit": "%"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 402.6565714285714,
                        "unit": "%"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 2.7777777777777777,
                        "unit": "%"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 1.7777777777777777,
                        "unit": "%"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 87.31333333333333,
                        "unit": "%"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 172.76246153846154,
                        "unit": "%"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 392.46467499999994,
                        "unit": "%"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 559.5433846153845,
                        "unit": "%"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 10.963,
                        "unit": "%"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 1182.2916666666667,
                        "unit": "%"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 8.333333333333334,
                        "unit": "%"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 55.69333333333334,
                        "unit": "%"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 16.409,
                        "unit": "%"
                    }
                },
                "digest": [
                    {
                        "label": "Fat",
                        "tag": "FAT",
                        "schemaOrgTag": "fatContent",
                        "total": 88.125,
                        "hasRDI": true,
                        "daily": 135.57692307692307,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Saturated",
                                "tag": "FASAT",
                                "schemaOrgTag": "saturatedFatContent",
                                "total": 26.673080000000002,
                                "hasRDI": true,
                                "daily": 133.36540000000002,
                                "unit": "g"
                            },
                            {
                                "label": "Trans",
                                "tag": "FATRN",
                                "schemaOrgTag": "transFatContent",
                                "total": 3.33976,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Monounsaturated",
                                "tag": "FAMS",
                                "schemaOrgTag": null,
                                "total": 51.53248,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Polyunsaturated",
                                "tag": "FAPU",
                                "schemaOrgTag": null,
                                "total": 8.66244,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Carbs",
                        "tag": "CHOCDF",
                        "schemaOrgTag": "carbohydrateContent",
                        "total": 10.55872,
                        "hasRDI": true,
                        "daily": 3.5195733333333328,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Carbs (net)",
                                "tag": "CHOCDF.net",
                                "schemaOrgTag": null,
                                "total": 10.55872,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Fiber",
                                "tag": "FIBTG",
                                "schemaOrgTag": "fiberContent",
                                "total": 0,
                                "hasRDI": true,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars",
                                "tag": "SUGAR",
                                "schemaOrgTag": "sugarContent",
                                "total": 1.45824,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars, added",
                                "tag": "SUGAR.added",
                                "schemaOrgTag": null,
                                "total": 0,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Protein",
                        "tag": "PROCNT",
                        "schemaOrgTag": "proteinContent",
                        "total": 279.54464,
                        "hasRDI": true,
                        "daily": 559.08928,
                        "unit": "g"
                    },
                    {
                        "label": "Cholesterol",
                        "tag": "CHOLE",
                        "schemaOrgTag": "cholesterolContent",
                        "total": 787.5,
                        "hasRDI": true,
                        "daily": 262.5,
                        "unit": "mg"
                    },
                    {
                        "label": "Sodium",
                        "tag": "NA",
                        "schemaOrgTag": "sodiumContent",
                        "total": 2052.908,
                        "hasRDI": true,
                        "daily": 85.53783333333332,
                        "unit": "mg"
                    },
                    {
                        "label": "Calcium",
                        "tag": "CA",
                        "schemaOrgTag": null,
                        "total": 197.316,
                        "hasRDI": true,
                        "daily": 19.7316,
                        "unit": "mg"
                    },
                    {
                        "label": "Magnesium",
                        "tag": "MG",
                        "schemaOrgTag": null,
                        "total": 290.724,
                        "hasRDI": true,
                        "daily": 69.22,
                        "unit": "mg"
                    },
                    {
                        "label": "Potassium",
                        "tag": "K",
                        "schemaOrgTag": null,
                        "total": 5217.204,
                        "hasRDI": true,
                        "daily": 111.00434042553191,
                        "unit": "mg"
                    },
                    {
                        "label": "Iron",
                        "tag": "FE",
                        "schemaOrgTag": null,
                        "total": 28.08692,
                        "hasRDI": true,
                        "daily": 156.03844444444445,
                        "unit": "mg"
                    },
                    {
                        "label": "Zinc",
                        "tag": "ZN",
                        "schemaOrgTag": null,
                        "total": 68.55427999999999,
                        "hasRDI": true,
                        "daily": 623.2207272727272,
                        "unit": "mg"
                    },
                    {
                        "label": "Phosphorus",
                        "tag": "P",
                        "schemaOrgTag": null,
                        "total": 2818.596,
                        "hasRDI": true,
                        "daily": 402.6565714285714,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin A",
                        "tag": "VITA_RAE",
                        "schemaOrgTag": null,
                        "total": 25,
                        "hasRDI": true,
                        "daily": 2.7777777777777777,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin C",
                        "tag": "VITC",
                        "schemaOrgTag": null,
                        "total": 1.6,
                        "hasRDI": true,
                        "daily": 1.7777777777777777,
                        "unit": "mg"
                    },
                    {
                        "label": "Thiamin (B1)",
                        "tag": "THIA",
                        "schemaOrgTag": null,
                        "total": 1.04776,
                        "hasRDI": true,
                        "daily": 87.31333333333333,
                        "unit": "mg"
                    },
                    {
                        "label": "Riboflavin (B2)",
                        "tag": "RIBF",
                        "schemaOrgTag": null,
                        "total": 2.245912,
                        "hasRDI": true,
                        "daily": 172.76246153846154,
                        "unit": "mg"
                    },
                    {
                        "label": "Niacin (B3)",
                        "tag": "NIA",
                        "schemaOrgTag": null,
                        "total": 62.79434799999999,
                        "hasRDI": true,
                        "daily": 392.46467499999994,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin B6",
                        "tag": "VITB6A",
                        "schemaOrgTag": null,
                        "total": 7.274064,
                        "hasRDI": true,
                        "daily": 559.5433846153845,
                        "unit": "mg"
                    },
                    {
                        "label": "Folate equivalent (total)",
                        "tag": "FOLDFE",
                        "schemaOrgTag": null,
                        "total": 43.852,
                        "hasRDI": true,
                        "daily": 10.963,
                        "unit": "µg"
                    },
                    {
                        "label": "Folate (food)",
                        "tag": "FOLFD",
                        "schemaOrgTag": null,
                        "total": 43.852,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Folic acid",
                        "tag": "FOLAC",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin B12",
                        "tag": "VITB12",
                        "schemaOrgTag": null,
                        "total": 28.375,
                        "hasRDI": true,
                        "daily": 1182.2916666666667,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin D",
                        "tag": "VITD",
                        "schemaOrgTag": null,
                        "total": 1.25,
                        "hasRDI": true,
                        "daily": 8.333333333333334,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin E",
                        "tag": "TOCPHA",
                        "schemaOrgTag": null,
                        "total": 8.354000000000001,
                        "hasRDI": true,
                        "daily": 55.69333333333334,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin K",
                        "tag": "VITK1",
                        "schemaOrgTag": null,
                        "total": 19.6908,
                        "hasRDI": true,
                        "daily": 16.409,
                        "unit": "µg"
                    },
                    {
                        "label": "Sugar alcohols",
                        "tag": "Sugar.alcohol",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    },
                    {
                        "label": "Water",
                        "tag": "WATER",
                        "schemaOrgTag": null,
                        "total": 1492.38448,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    }
                ]
            },
            "_links": {
                "self": {
                    "href": "https://api.edamam.com/api/recipes/v2/62ebc9d43ec31eace0c035db993eb1f5?type=public&app_id=ea1d37d5&app_key=fd382a172ba8d6668c0430dc9c14a181",
                    "title": "Self"
                }
            }
        },
        {
            "recipe": {
                "uri": "http://www.edamam.com/ontologies/edamam.owl#recipe_320278f6f05727827764697c0330f5cd",
                "label": "Beef Stroganoff",
                "image": "https://www.edamam.com/web-img/39c/39cc04c5b4b8c7a5ee471bb1910ad14f.jpg",
                "source": "My Recipes",
                "url": "http://www.myrecipes.com/recipe/beef-stroganoff-8",
                "shareAs": "http://www.edamam.com/recipe/beef-stroganoff-320278f6f05727827764697c0330f5cd/beef",
                "yield": 4,
                "dietLabels": [
                    "Low-Carb"
                ],
                "healthLabels": [
                    "Gluten-Free",
                    "Wheat-Free",
                    "Egg-Free",
                    "Peanut-Free",
                    "Tree-Nut-Free",
                    "Soy-Free",
                    "Fish-Free",
                    "Shellfish-Free",
                    "Pork-Free",
                    "Crustacean-Free",
                    "Celery-Free",
                    "Mustard-Free",
                    "Sesame-Free",
                    "Lupine-Free",
                    "Mollusk-Free",
                    "Alcohol-Free",
                    "Sulfite-Free",
                    "Immuno-Supportive"
                ],
                "cautions": [
                    "Sulfites"
                ],
                "ingredientLines": [
                    "Salt and pepper",
                    "2 teaspoons paprika",
                    "1 1/2 pounds beef stew meat, cut into cubes",
                    "1 tablespoon vegetable oil",
                    "2 cups sliced shitake mushrooms (6 oz.) or white mushrooms",
                    "3 shallots, thinly sliced",
                    "1 1/2 cups low-sodium beef broth",
                    "1/2 cup sour cream"
                ],
                "ingredients": [
                    {
                        "text": "Salt and pepper",
                        "weight": 9.1285141625,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_btxz81db72hwbra2pncvebzzzum9",
                        "image": "https://www.edamam.com/food-img/694/6943ea510918c6025795e8dc6e6eaaeb.jpg"
                    },
                    {
                        "text": "Salt and pepper",
                        "weight": 4.56425708125,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_b6ywzluaaxv02wad7s1r9ag4py89",
                        "image": "https://www.edamam.com/food-img/c6e/c6e5c3bd8d3bc15175d9766971a4d1b2.jpg"
                    },
                    {
                        "text": "2 teaspoons paprika",
                        "weight": 4.6,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_a9dpcnjb883g67b3lq82ca0421ql",
                        "image": "https://www.edamam.com/food-img/474/474d63763b9d8b9da98c5f43a114648c.jpg"
                    },
                    {
                        "text": "1 1/2 pounds beef stew meat, cut into cubes",
                        "weight": 680.388555,
                        "foodCategory": "meats",
                        "foodId": "food_bknby1la98smrsbwnthinbam42nj",
                        "image": "https://www.edamam.com/food-img/bab/bab88ab3ea40d34e4c8ae35d6b30344a.jpg"
                    },
                    {
                        "text": "1 tablespoon vegetable oil",
                        "weight": 14,
                        "foodCategory": "Oils",
                        "foodId": "food_bt1mzi2ah2sfg8bv7no1qai83w8s",
                        "image": "https://www.edamam.com/food-img/6e5/6e51a63a6300a8ea1b4c4cc68dfaba33.jpg"
                    },
                    {
                        "text": "2 cups sliced shitake mushrooms (6 oz.) or white mushrooms",
                        "weight": 170.09713875,
                        "foodCategory": "vegetables",
                        "foodId": "food_aq85j07b3arnn3bjy9gribye1mpm",
                        "image": "https://www.edamam.com/food-img/e1e/e1e021cc92b36fa5d19571c2a331d53b.jpg"
                    },
                    {
                        "text": "3 shallots, thinly sliced",
                        "weight": 177.33333333333334,
                        "foodCategory": "vegetables",
                        "foodId": "food_bu2ver7a5f52dfap8q9f0bn085qb",
                        "image": "https://www.edamam.com/food-img/d23/d23e3be21df05e9e16c05eadb12341e7.jpeg"
                    },
                    {
                        "text": "1 1/2 cups low-sodium beef broth",
                        "weight": 360,
                        "foodCategory": "canned soup",
                        "foodId": "food_bxd832fblxgfaibgn0zk0b6dg6dh",
                        "image": "https://www.edamam.com/food-img/428/4284513ddbf46e51f0f33566c0d61715.jpg"
                    },
                    {
                        "text": "1/2 cup sour cream",
                        "weight": 115,
                        "foodCategory": "Dairy",
                        "foodId": "food_adp9fcubzl3lr7bcvzn3rbfiiiwq",
                        "image": "https://www.edamam.com/food-img/f9d/f9d6183267b041b0aff9a10b89c9c15f.jpg"
                    }
                ],
                "calories": 1486.9564339489377,
                "totalWeight": 1531.6689672630541,
                "totalTime": 0,
                "cuisineType": [
                    "eastern europe"
                ],
                "mealType": [
                    "lunch/dinner"
                ],
                "dishType": [
                    "main course"
                ],
                "totalNutrients": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 1486.9564339489377,
                        "unit": "kcal"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 71.49273358955708,
                        "unit": "g"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 27.98883559863767,
                        "unit": "g"
                    },
                    "FATRN": {
                        "label": "Trans",
                        "quantity": 1.8083513875000001,
                        "unit": "g"
                    },
                    "FAMS": {
                        "label": "Monounsaturated",
                        "quantity": 33.2760192569971,
                        "unit": "g"
                    },
                    "FAPU": {
                        "label": "Polyunsaturated",
                        "quantity": 5.958871806170875,
                        "unit": "g"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 55.19244439058438,
                        "unit": "g"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 12.687252176972917,
                        "unit": "g"
                    },
                    "SUGAR": {
                        "label": "Sugars",
                        "quantity": 23.765296480903334,
                        "unit": "g"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 166.07675885407525,
                        "unit": "g"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 488.44478965,
                        "unit": "mg"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 3548.643607659056,
                        "unit": "mg"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 344.88401107190384,
                        "unit": "mg"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 266.89076073992226,
                        "unit": "mg"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 4641.381776541024,
                        "unit": "mg"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 19.647411185189327,
                        "unit": "mg"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 40.578535030323685,
                        "unit": "mg"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 2038.8574859383752,
                        "unit": "mg"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 330.53812051193756,
                        "unit": "µg"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 15.263066666666667,
                        "unit": "mg"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 0.8565348124602501,
                        "unit": "mg"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 2.151433664000417,
                        "unit": "mg"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 43.97940087729285,
                        "unit": "mg"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 5.350109597043938,
                        "unit": "mg"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 121.09754172464584,
                        "unit": "µg"
                    },
                    "FOLFD": {
                        "label": "Folate (food)",
                        "quantity": 121.09754172464584,
                        "unit": "µg"
                    },
                    "FOLAC": {
                        "label": "Folic acid",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 15.7668201985,
                        "unit": "µg"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 1.8207771100000003,
                        "unit": "µg"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 6.275701005978334,
                        "unit": "mg"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 25.219983833672917,
                        "unit": "µg"
                    },
                    "WATER": {
                        "label": "Water",
                        "quantity": 1218.1442930887706,
                        "unit": "g"
                    }
                },
                "totalDaily": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 74.34782169744688,
                        "unit": "%"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 109.98882090701089,
                        "unit": "%"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 139.94417799318836,
                        "unit": "%"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 18.397481463528127,
                        "unit": "%"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 50.74900870789167,
                        "unit": "%"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 332.15351770815045,
                        "unit": "%"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 162.81492988333335,
                        "unit": "%"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 147.86015031912734,
                        "unit": "%"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 34.48840110719038,
                        "unit": "%"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 63.545419223791015,
                        "unit": "%"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 98.752803756192,
                        "unit": "%"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 109.15228436216292,
                        "unit": "%"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 368.89577300294263,
                        "unit": "%"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 291.2653551340536,
                        "unit": "%"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 36.72645783465973,
                        "unit": "%"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 16.958962962962964,
                        "unit": "%"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 71.37790103835418,
                        "unit": "%"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 165.49489723080129,
                        "unit": "%"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 274.87125548308035,
                        "unit": "%"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 411.5468920803028,
                        "unit": "%"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 30.27438543116146,
                        "unit": "%"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 656.9508416041667,
                        "unit": "%"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 12.138514066666668,
                        "unit": "%"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 41.83800670652223,
                        "unit": "%"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 21.016653194727432,
                        "unit": "%"
                    }
                },
                "digest": [
                    {
                        "label": "Fat",
                        "tag": "FAT",
                        "schemaOrgTag": "fatContent",
                        "total": 71.49273358955708,
                        "hasRDI": true,
                        "daily": 109.98882090701089,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Saturated",
                                "tag": "FASAT",
                                "schemaOrgTag": "saturatedFatContent",
                                "total": 27.98883559863767,
                                "hasRDI": true,
                                "daily": 139.94417799318836,
                                "unit": "g"
                            },
                            {
                                "label": "Trans",
                                "tag": "FATRN",
                                "schemaOrgTag": "transFatContent",
                                "total": 1.8083513875000001,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Monounsaturated",
                                "tag": "FAMS",
                                "schemaOrgTag": null,
                                "total": 33.2760192569971,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Polyunsaturated",
                                "tag": "FAPU",
                                "schemaOrgTag": null,
                                "total": 5.958871806170875,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Carbs",
                        "tag": "CHOCDF",
                        "schemaOrgTag": "carbohydrateContent",
                        "total": 55.19244439058438,
                        "hasRDI": true,
                        "daily": 18.397481463528127,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Carbs (net)",
                                "tag": "CHOCDF.net",
                                "schemaOrgTag": null,
                                "total": 42.50519221361146,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Fiber",
                                "tag": "FIBTG",
                                "schemaOrgTag": "fiberContent",
                                "total": 12.687252176972917,
                                "hasRDI": true,
                                "daily": 50.74900870789167,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars",
                                "tag": "SUGAR",
                                "schemaOrgTag": "sugarContent",
                                "total": 23.765296480903334,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars, added",
                                "tag": "SUGAR.added",
                                "schemaOrgTag": null,
                                "total": 0,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Protein",
                        "tag": "PROCNT",
                        "schemaOrgTag": "proteinContent",
                        "total": 166.07675885407525,
                        "hasRDI": true,
                        "daily": 332.15351770815045,
                        "unit": "g"
                    },
                    {
                        "label": "Cholesterol",
                        "tag": "CHOLE",
                        "schemaOrgTag": "cholesterolContent",
                        "total": 488.44478965,
                        "hasRDI": true,
                        "daily": 162.81492988333335,
                        "unit": "mg"
                    },
                    {
                        "label": "Sodium",
                        "tag": "NA",
                        "schemaOrgTag": "sodiumContent",
                        "total": 3548.643607659056,
                        "hasRDI": true,
                        "daily": 147.86015031912734,
                        "unit": "mg"
                    },
                    {
                        "label": "Calcium",
                        "tag": "CA",
                        "schemaOrgTag": null,
                        "total": 344.88401107190384,
                        "hasRDI": true,
                        "daily": 34.48840110719038,
                        "unit": "mg"
                    },
                    {
                        "label": "Magnesium",
                        "tag": "MG",
                        "schemaOrgTag": null,
                        "total": 266.89076073992226,
                        "hasRDI": true,
                        "daily": 63.545419223791015,
                        "unit": "mg"
                    },
                    {
                        "label": "Potassium",
                        "tag": "K",
                        "schemaOrgTag": null,
                        "total": 4641.381776541024,
                        "hasRDI": true,
                        "daily": 98.752803756192,
                        "unit": "mg"
                    },
                    {
                        "label": "Iron",
                        "tag": "FE",
                        "schemaOrgTag": null,
                        "total": 19.647411185189327,
                        "hasRDI": true,
                        "daily": 109.15228436216292,
                        "unit": "mg"
                    },
                    {
                        "label": "Zinc",
                        "tag": "ZN",
                        "schemaOrgTag": null,
                        "total": 40.578535030323685,
                        "hasRDI": true,
                        "daily": 368.89577300294263,
                        "unit": "mg"
                    },
                    {
                        "label": "Phosphorus",
                        "tag": "P",
                        "schemaOrgTag": null,
                        "total": 2038.8574859383752,
                        "hasRDI": true,
                        "daily": 291.2653551340536,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin A",
                        "tag": "VITA_RAE",
                        "schemaOrgTag": null,
                        "total": 330.53812051193756,
                        "hasRDI": true,
                        "daily": 36.72645783465973,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin C",
                        "tag": "VITC",
                        "schemaOrgTag": null,
                        "total": 15.263066666666667,
                        "hasRDI": true,
                        "daily": 16.958962962962964,
                        "unit": "mg"
                    },
                    {
                        "label": "Thiamin (B1)",
                        "tag": "THIA",
                        "schemaOrgTag": null,
                        "total": 0.8565348124602501,
                        "hasRDI": true,
                        "daily": 71.37790103835418,
                        "unit": "mg"
                    },
                    {
                        "label": "Riboflavin (B2)",
                        "tag": "RIBF",
                        "schemaOrgTag": null,
                        "total": 2.151433664000417,
                        "hasRDI": true,
                        "daily": 165.49489723080129,
                        "unit": "mg"
                    },
                    {
                        "label": "Niacin (B3)",
                        "tag": "NIA",
                        "schemaOrgTag": null,
                        "total": 43.97940087729285,
                        "hasRDI": true,
                        "daily": 274.87125548308035,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin B6",
                        "tag": "VITB6A",
                        "schemaOrgTag": null,
                        "total": 5.350109597043938,
                        "hasRDI": true,
                        "daily": 411.5468920803028,
                        "unit": "mg"
                    },
                    {
                        "label": "Folate equivalent (total)",
                        "tag": "FOLDFE",
                        "schemaOrgTag": null,
                        "total": 121.09754172464584,
                        "hasRDI": true,
                        "daily": 30.27438543116146,
                        "unit": "µg"
                    },
                    {
                        "label": "Folate (food)",
                        "tag": "FOLFD",
                        "schemaOrgTag": null,
                        "total": 121.09754172464584,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Folic acid",
                        "tag": "FOLAC",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin B12",
                        "tag": "VITB12",
                        "schemaOrgTag": null,
                        "total": 15.7668201985,
                        "hasRDI": true,
                        "daily": 656.9508416041667,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin D",
                        "tag": "VITD",
                        "schemaOrgTag": null,
                        "total": 1.8207771100000003,
                        "hasRDI": true,
                        "daily": 12.138514066666668,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin E",
                        "tag": "TOCPHA",
                        "schemaOrgTag": null,
                        "total": 6.275701005978334,
                        "hasRDI": true,
                        "daily": 41.83800670652223,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin K",
                        "tag": "VITK1",
                        "schemaOrgTag": null,
                        "total": 25.219983833672917,
                        "hasRDI": true,
                        "daily": 21.016653194727432,
                        "unit": "µg"
                    },
                    {
                        "label": "Sugar alcohols",
                        "tag": "Sugar.alcohol",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    },
                    {
                        "label": "Water",
                        "tag": "WATER",
                        "schemaOrgTag": null,
                        "total": 1218.1442930887706,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    }
                ]
            },
            "_links": {
                "self": {
                    "href": "https://api.edamam.com/api/recipes/v2/320278f6f05727827764697c0330f5cd?type=public&app_id=ea1d37d5&app_key=fd382a172ba8d6668c0430dc9c14a181",
                    "title": "Self"
                }
            }
        },
        {
            "recipe": {
                "uri": "http://www.edamam.com/ontologies/edamam.owl#recipe_5cc235e2ae6319b854f0ecadae1c8105",
                "label": "Beef Medallions",
                "image": "https://www.edamam.com/web-img/3aa/3aa1aace88f3f4d388663b1443ea1d17.jpg",
                "source": "Delish",
                "url": "http://www.delish.com/cooking/recipe-ideas/recipes/a32308/beef-medallions-120718/",
                "shareAs": "http://www.edamam.com/recipe/beef-medallions-5cc235e2ae6319b854f0ecadae1c8105/beef",
                "yield": 4,
                "dietLabels": [
                    "Low-Carb"
                ],
                "healthLabels": [
                    "Sugar-Conscious",
                    "Keto-Friendly",
                    "Egg-Free",
                    "Peanut-Free",
                    "Tree-Nut-Free",
                    "Soy-Free",
                    "Fish-Free",
                    "Shellfish-Free",
                    "Pork-Free",
                    "Crustacean-Free",
                    "Celery-Free",
                    "Mustard-Free",
                    "Sesame-Free",
                    "Lupine-Free",
                    "Mollusk-Free"
                ],
                "cautions": [
                    "Sulfites",
                    "FODMAP"
                ],
                "ingredientLines": [
                    "1½ lb. center-cut beef tenderloin",
                    "¼ tsp. salt",
                    "¼ tsp. Freshly ground pepper",
                    "1¼ c. beef broth",
                    "1 tbsp. tomato paste",
                    "1 tbsp. quick-mixing flour",
                    "2 tsp. dried thyme",
                    "½ c. dry Madeira wine",
                    "Browning and seasoning sauce",
                    "1 tbsp. stick butter",
                    "1 package assorted wild mushrooms"
                ],
                "ingredients": [
                    {
                        "text": "1½ lb. center-cut beef tenderloin",
                        "weight": 680.388555,
                        "foodCategory": "meats",
                        "foodId": "food_au8m3zia67rlqoavmsp0cbvzhwiq",
                        "image": "https://www.edamam.com/food-img/f70/f70890fe73fc9e333aa584a88a61e351.jpg"
                    },
                    {
                        "text": "¼ tsp. salt",
                        "weight": 1.5,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_btxz81db72hwbra2pncvebzzzum9",
                        "image": "https://www.edamam.com/food-img/694/6943ea510918c6025795e8dc6e6eaaeb.jpg"
                    },
                    {
                        "text": "¼ tsp. Freshly ground pepper",
                        "weight": 0.725,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_b6ywzluaaxv02wad7s1r9ag4py89",
                        "image": "https://www.edamam.com/food-img/c6e/c6e5c3bd8d3bc15175d9766971a4d1b2.jpg"
                    },
                    {
                        "text": "1¼ c. beef broth",
                        "weight": 300,
                        "foodCategory": "canned soup",
                        "foodId": "food_bxd832fblxgfaibgn0zk0b6dg6dh",
                        "image": "https://www.edamam.com/food-img/428/4284513ddbf46e51f0f33566c0d61715.jpg"
                    },
                    {
                        "text": "1 tbsp. tomato paste",
                        "weight": 16,
                        "foodCategory": "canned vegetables",
                        "foodId": "food_auu2atfal07b6gbd1a5wsawy7u0s",
                        "image": "https://www.edamam.com/food-img/aef/aef4e029118da71388e526086506053a.jpg"
                    },
                    {
                        "text": "1 tbsp. quick-mixing flour",
                        "weight": 7.8124999998679145,
                        "foodCategory": "grains",
                        "foodId": "food_ahebfs0a985an4aubqaebbipra58",
                        "image": "https://www.edamam.com/food-img/b4c/b4c739e76a6f2172b7ad49d0aa41d5aa.jpg"
                    },
                    {
                        "text": "2 tsp. dried thyme",
                        "weight": 2,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_avsq22zadwyb5cb5sl1byaa4mbo8",
                        "image": "https://www.edamam.com/food-img/89b/89b37a04e46e052671d73addcb84aa51.jpg"
                    },
                    {
                        "text": "½ c. dry Madeira wine",
                        "weight": 118,
                        "foodCategory": "wines",
                        "foodId": "food_bw5p1agbubb4dubpm8r0yax8fjco",
                        "image": "https://www.edamam.com/food-img/aeb/aebdd2e72bc13fa8ca762a408b6e58b6.jpg"
                    },
                    {
                        "text": "Browning and seasoning sauce",
                        "weight": 11.460260549998681,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_aj7w3xab0epj7cbgkbkpwadysovd",
                        "image": "https://www.edamam.com/food-img/c23/c23e20823b442067307aa436969358f1.jpg"
                    },
                    {
                        "text": "1 tbsp. stick butter",
                        "weight": 14.2,
                        "foodCategory": "Dairy",
                        "foodId": "food_awz3iefajbk1fwahq9logahmgltj",
                        "image": "https://www.edamam.com/food-img/713/71397239b670d88c04faa8d05035cab4.jpg"
                    },
                    {
                        "text": "1 package assorted wild mushrooms",
                        "weight": 5.4,
                        "foodCategory": "vegetables",
                        "foodId": "food_bi2oq7wabjac9ra4ata3sb8e5yc9",
                        "image": "https://www.edamam.com/food-img/b91/b91ff356529731d28ffa0b2b55ea7976.jpg"
                    }
                ],
                "calories": 1998.6420951880152,
                "totalWeight": 1157.486315549867,
                "totalTime": 27,
                "cuisineType": [
                    "mediterranean"
                ],
                "mealType": [
                    "snack"
                ],
                "dishType": [
                    "condiments and sauces"
                ],
                "totalNutrients": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 1998.6420951880152,
                        "unit": "kcal"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 134.65666875341358,
                        "unit": "g"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 56.95233030479475,
                        "unit": "g"
                    },
                    "FATRN": {
                        "label": "Trans",
                        "quantity": 0.46547599999999995,
                        "unit": "g"
                    },
                    "FAMS": {
                        "label": "Monounsaturated",
                        "quantity": 55.36821125248287,
                        "unit": "g"
                    },
                    "FAPU": {
                        "label": "Polyunsaturated",
                        "quantity": 5.3843599432474285,
                        "unit": "g"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 25.43510114464334,
                        "unit": "g"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 3.290571942146285,
                        "unit": "g"
                    },
                    "SUGAR": {
                        "label": "Sugars",
                        "quantity": 4.8383784398996195,
                        "unit": "g"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 143.90156933773125,
                        "unit": "g"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 608.86027175,
                        "unit": "mg"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 1654.407797848497,
                        "unit": "mg"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 370.20295882796705,
                        "unit": "mg"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 210.80819463196798,
                        "unit": "mg"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 3039.15212881185,
                        "unit": "mg"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 18.32740206064799,
                        "unit": "mg"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 25.177186606269036,
                        "unit": "mg"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 1373.853787890355,
                        "unit": "mg"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 128.41129392599825,
                        "unit": "µg"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 5.879231265999842,
                        "unit": "mg"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 0.520495136451838,
                        "unit": "mg"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 0.9468834838504449,
                        "unit": "mg"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 47.56614317393332,
                        "unit": "mg"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 4.067179572959924,
                        "unit": "mg"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 107.92640060896385,
                        "unit": "µg"
                    },
                    "FOLFD": {
                        "label": "Folate (food)",
                        "quantity": 107.92640060896385,
                        "unit": "µg"
                    },
                    "FOLAC": {
                        "label": "Folic acid",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 7.508414105000001,
                        "unit": "µg"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 0.4992,
                        "unit": "µg"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 4.150136014759903,
                        "unit": "mg"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 141.80541784968898,
                        "unit": "µg"
                    },
                    "WATER": {
                        "label": "Water",
                        "quantity": 830.9728148366892,
                        "unit": "g"
                    }
                },
                "totalDaily": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 99.93210475940076,
                        "unit": "%"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 207.16410577448244,
                        "unit": "%"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 284.76165152397374,
                        "unit": "%"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 8.478367048214446,
                        "unit": "%"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 13.16228776858514,
                        "unit": "%"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 287.8031386754625,
                        "unit": "%"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 202.95342391666668,
                        "unit": "%"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 68.93365824368738,
                        "unit": "%"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 37.02029588279671,
                        "unit": "%"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 50.19242729332571,
                        "unit": "%"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 64.66281125131596,
                        "unit": "%"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 101.81890033693328,
                        "unit": "%"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 228.88351460244579,
                        "unit": "%"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 196.2648268414793,
                        "unit": "%"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 14.26792154733314,
                        "unit": "%"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 6.532479184444268,
                        "unit": "%"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 43.37459470431983,
                        "unit": "%"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 72.83719106541884,
                        "unit": "%"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 297.2883948370833,
                        "unit": "%"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 312.8599671507634,
                        "unit": "%"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 26.98160015224096,
                        "unit": "%"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 312.85058770833336,
                        "unit": "%"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 3.328,
                        "unit": "%"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 27.66757343173269,
                        "unit": "%"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 118.17118154140749,
                        "unit": "%"
                    }
                },
                "digest": [
                    {
                        "label": "Fat",
                        "tag": "FAT",
                        "schemaOrgTag": "fatContent",
                        "total": 134.65666875341358,
                        "hasRDI": true,
                        "daily": 207.16410577448244,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Saturated",
                                "tag": "FASAT",
                                "schemaOrgTag": "saturatedFatContent",
                                "total": 56.95233030479475,
                                "hasRDI": true,
                                "daily": 284.76165152397374,
                                "unit": "g"
                            },
                            {
                                "label": "Trans",
                                "tag": "FATRN",
                                "schemaOrgTag": "transFatContent",
                                "total": 0.46547599999999995,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Monounsaturated",
                                "tag": "FAMS",
                                "schemaOrgTag": null,
                                "total": 55.36821125248287,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Polyunsaturated",
                                "tag": "FAPU",
                                "schemaOrgTag": null,
                                "total": 5.3843599432474285,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Carbs",
                        "tag": "CHOCDF",
                        "schemaOrgTag": "carbohydrateContent",
                        "total": 25.43510114464334,
                        "hasRDI": true,
                        "daily": 8.478367048214446,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Carbs (net)",
                                "tag": "CHOCDF.net",
                                "schemaOrgTag": null,
                                "total": 22.144529202497054,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Fiber",
                                "tag": "FIBTG",
                                "schemaOrgTag": "fiberContent",
                                "total": 3.290571942146285,
                                "hasRDI": true,
                                "daily": 13.16228776858514,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars",
                                "tag": "SUGAR",
                                "schemaOrgTag": "sugarContent",
                                "total": 4.8383784398996195,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars, added",
                                "tag": "SUGAR.added",
                                "schemaOrgTag": null,
                                "total": 0,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Protein",
                        "tag": "PROCNT",
                        "schemaOrgTag": "proteinContent",
                        "total": 143.90156933773125,
                        "hasRDI": true,
                        "daily": 287.8031386754625,
                        "unit": "g"
                    },
                    {
                        "label": "Cholesterol",
                        "tag": "CHOLE",
                        "schemaOrgTag": "cholesterolContent",
                        "total": 608.86027175,
                        "hasRDI": true,
                        "daily": 202.95342391666668,
                        "unit": "mg"
                    },
                    {
                        "label": "Sodium",
                        "tag": "NA",
                        "schemaOrgTag": "sodiumContent",
                        "total": 1654.407797848497,
                        "hasRDI": true,
                        "daily": 68.93365824368738,
                        "unit": "mg"
                    },
                    {
                        "label": "Calcium",
                        "tag": "CA",
                        "schemaOrgTag": null,
                        "total": 370.20295882796705,
                        "hasRDI": true,
                        "daily": 37.02029588279671,
                        "unit": "mg"
                    },
                    {
                        "label": "Magnesium",
                        "tag": "MG",
                        "schemaOrgTag": null,
                        "total": 210.80819463196798,
                        "hasRDI": true,
                        "daily": 50.19242729332571,
                        "unit": "mg"
                    },
                    {
                        "label": "Potassium",
                        "tag": "K",
                        "schemaOrgTag": null,
                        "total": 3039.15212881185,
                        "hasRDI": true,
                        "daily": 64.66281125131596,
                        "unit": "mg"
                    },
                    {
                        "label": "Iron",
                        "tag": "FE",
                        "schemaOrgTag": null,
                        "total": 18.32740206064799,
                        "hasRDI": true,
                        "daily": 101.81890033693328,
                        "unit": "mg"
                    },
                    {
                        "label": "Zinc",
                        "tag": "ZN",
                        "schemaOrgTag": null,
                        "total": 25.177186606269036,
                        "hasRDI": true,
                        "daily": 228.88351460244579,
                        "unit": "mg"
                    },
                    {
                        "label": "Phosphorus",
                        "tag": "P",
                        "schemaOrgTag": null,
                        "total": 1373.853787890355,
                        "hasRDI": true,
                        "daily": 196.2648268414793,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin A",
                        "tag": "VITA_RAE",
                        "schemaOrgTag": null,
                        "total": 128.41129392599825,
                        "hasRDI": true,
                        "daily": 14.26792154733314,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin C",
                        "tag": "VITC",
                        "schemaOrgTag": null,
                        "total": 5.879231265999842,
                        "hasRDI": true,
                        "daily": 6.532479184444268,
                        "unit": "mg"
                    },
                    {
                        "label": "Thiamin (B1)",
                        "tag": "THIA",
                        "schemaOrgTag": null,
                        "total": 0.520495136451838,
                        "hasRDI": true,
                        "daily": 43.37459470431983,
                        "unit": "mg"
                    },
                    {
                        "label": "Riboflavin (B2)",
                        "tag": "RIBF",
                        "schemaOrgTag": null,
                        "total": 0.9468834838504449,
                        "hasRDI": true,
                        "daily": 72.83719106541884,
                        "unit": "mg"
                    },
                    {
                        "label": "Niacin (B3)",
                        "tag": "NIA",
                        "schemaOrgTag": null,
                        "total": 47.56614317393332,
                        "hasRDI": true,
                        "daily": 297.2883948370833,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin B6",
                        "tag": "VITB6A",
                        "schemaOrgTag": null,
                        "total": 4.067179572959924,
                        "hasRDI": true,
                        "daily": 312.8599671507634,
                        "unit": "mg"
                    },
                    {
                        "label": "Folate equivalent (total)",
                        "tag": "FOLDFE",
                        "schemaOrgTag": null,
                        "total": 107.92640060896385,
                        "hasRDI": true,
                        "daily": 26.98160015224096,
                        "unit": "µg"
                    },
                    {
                        "label": "Folate (food)",
                        "tag": "FOLFD",
                        "schemaOrgTag": null,
                        "total": 107.92640060896385,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Folic acid",
                        "tag": "FOLAC",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin B12",
                        "tag": "VITB12",
                        "schemaOrgTag": null,
                        "total": 7.508414105000001,
                        "hasRDI": true,
                        "daily": 312.85058770833336,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin D",
                        "tag": "VITD",
                        "schemaOrgTag": null,
                        "total": 0.4992,
                        "hasRDI": true,
                        "daily": 3.328,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin E",
                        "tag": "TOCPHA",
                        "schemaOrgTag": null,
                        "total": 4.150136014759903,
                        "hasRDI": true,
                        "daily": 27.66757343173269,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin K",
                        "tag": "VITK1",
                        "schemaOrgTag": null,
                        "total": 141.80541784968898,
                        "hasRDI": true,
                        "daily": 118.17118154140749,
                        "unit": "µg"
                    },
                    {
                        "label": "Sugar alcohols",
                        "tag": "Sugar.alcohol",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    },
                    {
                        "label": "Water",
                        "tag": "WATER",
                        "schemaOrgTag": null,
                        "total": 830.9728148366892,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    }
                ]
            },
            "_links": {
                "self": {
                    "href": "https://api.edamam.com/api/recipes/v2/5cc235e2ae6319b854f0ecadae1c8105?type=public&app_id=ea1d37d5&app_key=fd382a172ba8d6668c0430dc9c14a181",
                    "title": "Self"
                }
            }
        }
    ]
};

export const fishRecipes = {
    "from": 1,
    "to": 20,
    "count": 10000,
    "_links": {
        "next": {
            "href": "https://api.edamam.com/api/recipes/v2?q=fish&app_key=fd382a172ba8d6668c0430dc9c14a181&_cont=CHcVQBtNNQphDmgVQntAEX4BYVRtAgAOR2ZCBWQRalNwDAUBUXlSAGsSNVQgVwsAR2NBBmBCa117BwoOQDZDBDYbYgEiBFcVLnlSVSBMPkd5BgMbUSYRVTdgMgksRlpSAAcRXTVGcV84SU4%3D&type=public&app_id=ea1d37d5",
            "title": "Next page"
        }
    },
    "hits": [
        {
            "recipe": {
                "uri": "http://www.edamam.com/ontologies/edamam.owl#recipe_672c9e7e3fbc6240477d99152ba8f6b3",
                "label": "Burnt-Scallion Fish",
                "image": "https://www.edamam.com/web-img/a96/a967fbe797803dbe8418a668cf304b53.jpg",
                "source": "Saveur",
                "url": "http://www.saveur.com/article/Recipes/Burnt-Scallion-Fish",
                "shareAs": "http://www.edamam.com/recipe/burnt-scallion-fish-672c9e7e3fbc6240477d99152ba8f6b3/fish",
                "yield": 6,
                "dietLabels": [
                    "Low-Carb",
                    "Low-Sodium"
                ],
                "healthLabels": [
                    "Sugar-Conscious",
                    "Keto-Friendly",
                    "Pescatarian",
                    "Gluten-Free",
                    "Wheat-Free",
                    "Egg-Free",
                    "Peanut-Free",
                    "Tree-Nut-Free",
                    "Soy-Free",
                    "Shellfish-Free",
                    "Pork-Free",
                    "Red-Meat-Free",
                    "Crustacean-Free",
                    "Celery-Free",
                    "Mustard-Free",
                    "Sesame-Free",
                    "Lupine-Free",
                    "Mollusk-Free",
                    "Alcohol-Free",
                    "Sulfite-Free",
                    "Kosher",
                    "Immuno-Supportive"
                ],
                "cautions": [],
                "ingredientLines": [
                    "2 bunches scallions",
                    "8 tbsp. butter",
                    "2 8-oz. fish filets"
                ],
                "ingredients": [
                    {
                        "text": "2 bunches scallions",
                        "weight": 226,
                        "foodCategory": "vegetables",
                        "foodId": "food_bknlkyzbuzo27pb11whr4bttkuy6",
                        "image": "https://www.edamam.com/food-img/b89/b89986ed6aa466285bdd99bac34b3c46.jpg"
                    },
                    {
                        "text": "8 tbsp. butter",
                        "weight": 113.6,
                        "foodCategory": "Dairy",
                        "foodId": "food_awz3iefajbk1fwahq9logahmgltj",
                        "image": "https://www.edamam.com/food-img/713/71397239b670d88c04faa8d05035cab4.jpg"
                    },
                    {
                        "text": "2 8-oz. fish filets",
                        "weight": 453.59237,
                        "foodCategory": "seafood",
                        "foodId": "food_ar6pjbvaxqtlqia7jewa4brld7p9",
                        "image": "https://www.edamam.com/food-img/717/717cb400eb49626bb7c95cd29292cef4.jpg"
                    }
                ],
                "calories": 1322.2806752000001,
                "totalWeight": 793.19237,
                "totalTime": 0,
                "cuisineType": [
                    "british"
                ],
                "mealType": [
                    "lunch/dinner"
                ],
                "dishType": [
                    "condiments and sauces"
                ],
                "totalNutrients": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 1322.2806752000001,
                        "unit": "kcal"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 100.28143028999999,
                        "unit": "g"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 61.0798833645,
                        "unit": "g"
                    },
                    "FATRN": {
                        "label": "Trans",
                        "quantity": 3.7238079999999996,
                        "unit": "g"
                    },
                    "FAMS": {
                        "label": "Monounsaturated",
                        "quantity": 26.1997660026,
                        "unit": "g"
                    },
                    "FAPU": {
                        "label": "Polyunsaturated",
                        "quantity": 5.2706283031000005,
                        "unit": "g"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 16.65656,
                        "unit": "g"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 5.876000000000001,
                        "unit": "g"
                    },
                    "SUGAR": {
                        "label": "Sugars",
                        "quantity": 5.33396,
                        "unit": "g"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 96.182747896,
                        "unit": "g"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 471.03618500000005,
                        "unit": "mg"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 284.5240324,
                        "unit": "mg"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 235.34323700000004,
                        "unit": "mg"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 169.94193990000002,
                        "unit": "mg"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 2020.8729574000004,
                        "unit": "mg"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 5.9076372720000006,
                        "unit": "mg"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 2.4804948210000006,
                        "unit": "mg"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 881.9910290000001,
                        "unit": "mg"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 890.0239999999999,
                        "unit": "µg"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 42.48800000000001,
                        "unit": "mg"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 0.3159528717000001,
                        "unit": "mg"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 0.5051871931,
                        "unit": "mg"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 18.9379222011,
                        "unit": "mg"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 0.8760876394000001,
                        "unit": "mg"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 256.9101688,
                        "unit": "µg"
                    },
                    "FOLFD": {
                        "label": "Folate (food)",
                        "quantity": 256.9101688,
                        "unit": "µg"
                    },
                    "FOLAC": {
                        "label": "Folic acid",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 7.359879446000002,
                        "unit": "µg"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 15.76536347,
                        "unit": "µg"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 5.69288948,
                        "unit": "mg"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 482.12229318000004,
                        "unit": "µg"
                    },
                    "WATER": {
                        "label": "Water",
                        "quantity": 577.5605624960001,
                        "unit": "g"
                    }
                },
                "totalDaily": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 66.11403376000001,
                        "unit": "%"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 154.27912352307692,
                        "unit": "%"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 305.39941682250003,
                        "unit": "%"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 5.552186666666667,
                        "unit": "%"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 23.504000000000005,
                        "unit": "%"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 192.365495792,
                        "unit": "%"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 157.01206166666668,
                        "unit": "%"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 11.855168016666667,
                        "unit": "%"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 23.534323700000005,
                        "unit": "%"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 40.46236664285715,
                        "unit": "%"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 42.99729696595745,
                        "unit": "%"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 32.82020706666667,
                        "unit": "%"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 22.549952918181823,
                        "unit": "%"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 125.99871842857145,
                        "unit": "%"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 98.89155555555556,
                        "unit": "%"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 47.2088888888889,
                        "unit": "%"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 26.329405975000007,
                        "unit": "%"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 38.860553315384614,
                        "unit": "%"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 118.362013756875,
                        "unit": "%"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 67.39135687692308,
                        "unit": "%"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 64.2275422,
                        "unit": "%"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 306.66164358333344,
                        "unit": "%"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 105.10242313333333,
                        "unit": "%"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 37.952596533333335,
                        "unit": "%"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 401.76857765000005,
                        "unit": "%"
                    }
                },
                "digest": [
                    {
                        "label": "Fat",
                        "tag": "FAT",
                        "schemaOrgTag": "fatContent",
                        "total": 100.28143028999999,
                        "hasRDI": true,
                        "daily": 154.27912352307692,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Saturated",
                                "tag": "FASAT",
                                "schemaOrgTag": "saturatedFatContent",
                                "total": 61.0798833645,
                                "hasRDI": true,
                                "daily": 305.39941682250003,
                                "unit": "g"
                            },
                            {
                                "label": "Trans",
                                "tag": "FATRN",
                                "schemaOrgTag": "transFatContent",
                                "total": 3.7238079999999996,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Monounsaturated",
                                "tag": "FAMS",
                                "schemaOrgTag": null,
                                "total": 26.1997660026,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Polyunsaturated",
                                "tag": "FAPU",
                                "schemaOrgTag": null,
                                "total": 5.2706283031000005,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Carbs",
                        "tag": "CHOCDF",
                        "schemaOrgTag": "carbohydrateContent",
                        "total": 16.65656,
                        "hasRDI": true,
                        "daily": 5.552186666666667,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Carbs (net)",
                                "tag": "CHOCDF.net",
                                "schemaOrgTag": null,
                                "total": 10.780559999999998,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Fiber",
                                "tag": "FIBTG",
                                "schemaOrgTag": "fiberContent",
                                "total": 5.876000000000001,
                                "hasRDI": true,
                                "daily": 23.504000000000005,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars",
                                "tag": "SUGAR",
                                "schemaOrgTag": "sugarContent",
                                "total": 5.33396,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars, added",
                                "tag": "SUGAR.added",
                                "schemaOrgTag": null,
                                "total": 0,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Protein",
                        "tag": "PROCNT",
                        "schemaOrgTag": "proteinContent",
                        "total": 96.182747896,
                        "hasRDI": true,
                        "daily": 192.365495792,
                        "unit": "g"
                    },
                    {
                        "label": "Cholesterol",
                        "tag": "CHOLE",
                        "schemaOrgTag": "cholesterolContent",
                        "total": 471.03618500000005,
                        "hasRDI": true,
                        "daily": 157.01206166666668,
                        "unit": "mg"
                    },
                    {
                        "label": "Sodium",
                        "tag": "NA",
                        "schemaOrgTag": "sodiumContent",
                        "total": 284.5240324,
                        "hasRDI": true,
                        "daily": 11.855168016666667,
                        "unit": "mg"
                    },
                    {
                        "label": "Calcium",
                        "tag": "CA",
                        "schemaOrgTag": null,
                        "total": 235.34323700000004,
                        "hasRDI": true,
                        "daily": 23.534323700000005,
                        "unit": "mg"
                    },
                    {
                        "label": "Magnesium",
                        "tag": "MG",
                        "schemaOrgTag": null,
                        "total": 169.94193990000002,
                        "hasRDI": true,
                        "daily": 40.46236664285715,
                        "unit": "mg"
                    },
                    {
                        "label": "Potassium",
                        "tag": "K",
                        "schemaOrgTag": null,
                        "total": 2020.8729574000004,
                        "hasRDI": true,
                        "daily": 42.99729696595745,
                        "unit": "mg"
                    },
                    {
                        "label": "Iron",
                        "tag": "FE",
                        "schemaOrgTag": null,
                        "total": 5.9076372720000006,
                        "hasRDI": true,
                        "daily": 32.82020706666667,
                        "unit": "mg"
                    },
                    {
                        "label": "Zinc",
                        "tag": "ZN",
                        "schemaOrgTag": null,
                        "total": 2.4804948210000006,
                        "hasRDI": true,
                        "daily": 22.549952918181823,
                        "unit": "mg"
                    },
                    {
                        "label": "Phosphorus",
                        "tag": "P",
                        "schemaOrgTag": null,
                        "total": 881.9910290000001,
                        "hasRDI": true,
                        "daily": 125.99871842857145,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin A",
                        "tag": "VITA_RAE",
                        "schemaOrgTag": null,
                        "total": 890.0239999999999,
                        "hasRDI": true,
                        "daily": 98.89155555555556,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin C",
                        "tag": "VITC",
                        "schemaOrgTag": null,
                        "total": 42.48800000000001,
                        "hasRDI": true,
                        "daily": 47.2088888888889,
                        "unit": "mg"
                    },
                    {
                        "label": "Thiamin (B1)",
                        "tag": "THIA",
                        "schemaOrgTag": null,
                        "total": 0.3159528717000001,
                        "hasRDI": true,
                        "daily": 26.329405975000007,
                        "unit": "mg"
                    },
                    {
                        "label": "Riboflavin (B2)",
                        "tag": "RIBF",
                        "schemaOrgTag": null,
                        "total": 0.5051871931,
                        "hasRDI": true,
                        "daily": 38.860553315384614,
                        "unit": "mg"
                    },
                    {
                        "label": "Niacin (B3)",
                        "tag": "NIA",
                        "schemaOrgTag": null,
                        "total": 18.9379222011,
                        "hasRDI": true,
                        "daily": 118.362013756875,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin B6",
                        "tag": "VITB6A",
                        "schemaOrgTag": null,
                        "total": 0.8760876394000001,
                        "hasRDI": true,
                        "daily": 67.39135687692308,
                        "unit": "mg"
                    },
                    {
                        "label": "Folate equivalent (total)",
                        "tag": "FOLDFE",
                        "schemaOrgTag": null,
                        "total": 256.9101688,
                        "hasRDI": true,
                        "daily": 64.2275422,
                        "unit": "µg"
                    },
                    {
                        "label": "Folate (food)",
                        "tag": "FOLFD",
                        "schemaOrgTag": null,
                        "total": 256.9101688,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Folic acid",
                        "tag": "FOLAC",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin B12",
                        "tag": "VITB12",
                        "schemaOrgTag": null,
                        "total": 7.359879446000002,
                        "hasRDI": true,
                        "daily": 306.66164358333344,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin D",
                        "tag": "VITD",
                        "schemaOrgTag": null,
                        "total": 15.76536347,
                        "hasRDI": true,
                        "daily": 105.10242313333333,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin E",
                        "tag": "TOCPHA",
                        "schemaOrgTag": null,
                        "total": 5.69288948,
                        "hasRDI": true,
                        "daily": 37.952596533333335,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin K",
                        "tag": "VITK1",
                        "schemaOrgTag": null,
                        "total": 482.12229318000004,
                        "hasRDI": true,
                        "daily": 401.76857765000005,
                        "unit": "µg"
                    },
                    {
                        "label": "Sugar alcohols",
                        "tag": "Sugar.alcohol",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    },
                    {
                        "label": "Water",
                        "tag": "WATER",
                        "schemaOrgTag": null,
                        "total": 577.5605624960001,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    }
                ]
            },
            "_links": {
                "self": {
                    "href": "https://api.edamam.com/api/recipes/v2/672c9e7e3fbc6240477d99152ba8f6b3?type=public&app_id=ea1d37d5&app_key=fd382a172ba8d6668c0430dc9c14a181",
                    "title": "Self"
                }
            }
        },
        {
            "recipe": {
                "uri": "http://www.edamam.com/ontologies/edamam.owl#recipe_1297c760f06e7c47e77387cdcafae687",
                "label": "Fish Fumet recipes",
                "image": "https://www.edamam.com/web-img/eb5/eb58edb23bf93ebc4ea94abdd95c14ee",
                "source": "Martha Stewart",
                "url": "http://www.marthastewart.com/352662/fish-fumet",
                "shareAs": "http://www.edamam.com/recipe/fish-fumet-recipes-1297c760f06e7c47e77387cdcafae687/fish",
                "yield": 4,
                "dietLabels": [
                    "High-Protein",
                    "Low-Fat"
                ],
                "healthLabels": [
                    "Sugar-Conscious",
                    "Keto-Friendly",
                    "Paleo",
                    "Dairy-Free",
                    "Gluten-Free",
                    "Wheat-Free",
                    "Egg-Free",
                    "Peanut-Free",
                    "Tree-Nut-Free",
                    "Soy-Free",
                    "Shellfish-Free",
                    "Pork-Free",
                    "Crustacean-Free",
                    "Celery-Free",
                    "Mustard-Free",
                    "Sesame-Free",
                    "Lupine-Free",
                    "Mollusk-Free",
                    "No oil added",
                    "Kosher"
                ],
                "cautions": [],
                "ingredientLines": [
                    "1 pound fish bones, preferably from halibut or turbot, cut from tail to stomach",
                    "coarse salt",
                    "1 shallot, thinly sliced",
                    "1/2 cup white wine"
                ],
                "ingredients": [
                    {
                        "text": "1 pound fish bones, preferably from halibut or turbot, cut from tail to stomach",
                        "weight": 453.59237,
                        "foodCategory": "seafood",
                        "foodId": "food_ac67s7dbn8nrr4ackhixearqoe7p",
                        "image": "https://www.edamam.com/food-img/7e8/7e8bc8e9579e124e37cf406e42d10c05.jpg"
                    },
                    {
                        "text": "coarse salt",
                        "weight": 3.7818208866666674,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_a1vgrj1bs8rd1majvmd9ubz8ttkg",
                        "image": "https://www.edamam.com/food-img/694/6943ea510918c6025795e8dc6e6eaaeb.jpg"
                    },
                    {
                        "text": "1 shallot, thinly sliced",
                        "weight": 59.111111111111114,
                        "foodCategory": "vegetables",
                        "foodId": "food_bu2ver7a5f52dfap8q9f0bn085qb",
                        "image": "https://www.edamam.com/food-img/d23/d23e3be21df05e9e16c05eadb12341e7.jpeg"
                    },
                    {
                        "text": "1/2 cup white wine",
                        "weight": 117.6,
                        "foodCategory": "wines",
                        "foodId": "food_bn44h7baron9ufaoxinmya8l0yye",
                        "image": "https://www.edamam.com/food-img/a71/a718cf3c52add522128929f1f324d2ab.jpg"
                    }
                ],
                "calories": 551.7610567,
                "totalWeight": 633.256012186814,
                "totalTime": 80,
                "cuisineType": [
                    "south east asian"
                ],
                "mealType": [
                    "lunch/dinner"
                ],
                "dishType": [
                    "condiments and sauces"
                ],
                "totalNutrients": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 551.7610567,
                        "unit": "kcal"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 6.091889632111112,
                        "unit": "g"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 1.3345386092888891,
                        "unit": "g"
                    },
                    "FAMS": {
                        "label": "Monounsaturated",
                        "quantity": 2.1446956182555557,
                        "unit": "g"
                    },
                    "FAPU": {
                        "label": "Polyunsaturated",
                        "quantity": 1.3384712063333335,
                        "unit": "g"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 12.988266666666668,
                        "unit": "g"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 1.8915555555555557,
                        "unit": "g"
                    },
                    "SUGAR": {
                        "label": "Sugars",
                        "quantity": 5.781004444444445,
                        "unit": "g"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 85.74684164977778,
                        "unit": "g"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 222.26026130000002,
                        "unit": "mg"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 1465.758139254267,
                        "unit": "mg"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 64.91518446927981,
                        "unit": "mg"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 128.52910374409035,
                        "unit": "mg"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 2254.290123097168,
                        "unit": "mg"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 1.7623444778831532,
                        "unit": "mg"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 2.0134495075201473,
                        "unit": "mg"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 1127.1126598666667,
                        "unit": "mg"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 90.71847400000001,
                        "unit": "µg"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 4.728888888888889,
                        "unit": "mg"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 0.2681428516666667,
                        "unit": "mg"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 0.16553993322222224,
                        "unit": "mg"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 29.787701280322224,
                        "unit": "mg"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 2.7484195209333344,
                        "unit": "mg"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 75.70486217777778,
                        "unit": "µg"
                    },
                    "FOLFD": {
                        "label": "Folate (food)",
                        "quantity": 75.70486217777778,
                        "unit": "µg"
                    },
                    "FOLAC": {
                        "label": "Folic acid",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 4.989516070000001,
                        "unit": "µg"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 21.318841390000003,
                        "unit": "µg"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 2.7905579014444446,
                        "unit": "mg"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 0.9432888888888888,
                        "unit": "µg"
                    },
                    "WATER": {
                        "label": "Water",
                        "quantity": 513.7400417868181,
                        "unit": "g"
                    }
                },
                "totalDaily": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 27.588052835000003,
                        "unit": "%"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 9.372137895555557,
                        "unit": "%"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 6.672693046444445,
                        "unit": "%"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 4.329422222222223,
                        "unit": "%"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 7.566222222222223,
                        "unit": "%"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 171.49368329955556,
                        "unit": "%"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 74.08675376666667,
                        "unit": "%"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 61.073255802261116,
                        "unit": "%"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 6.491518446927981,
                        "unit": "%"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 30.60216755811675,
                        "unit": "%"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 47.96361964036527,
                        "unit": "%"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 9.790802654906408,
                        "unit": "%"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 18.30408643200134,
                        "unit": "%"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 161.01609426666667,
                        "unit": "%"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 10.079830444444447,
                        "unit": "%"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 5.254320987654321,
                        "unit": "%"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 22.34523763888889,
                        "unit": "%"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 12.733841017094017,
                        "unit": "%"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 186.1731330020139,
                        "unit": "%"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 211.4168862256411,
                        "unit": "%"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 18.926215544444446,
                        "unit": "%"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 207.89650291666672,
                        "unit": "%"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 142.1256092666667,
                        "unit": "%"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 18.603719342962965,
                        "unit": "%"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 0.786074074074074,
                        "unit": "%"
                    }
                },
                "digest": [
                    {
                        "label": "Fat",
                        "tag": "FAT",
                        "schemaOrgTag": "fatContent",
                        "total": 6.091889632111112,
                        "hasRDI": true,
                        "daily": 9.372137895555557,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Saturated",
                                "tag": "FASAT",
                                "schemaOrgTag": "saturatedFatContent",
                                "total": 1.3345386092888891,
                                "hasRDI": true,
                                "daily": 6.672693046444445,
                                "unit": "g"
                            },
                            {
                                "label": "Trans",
                                "tag": "FATRN",
                                "schemaOrgTag": "transFatContent",
                                "total": 0,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Monounsaturated",
                                "tag": "FAMS",
                                "schemaOrgTag": null,
                                "total": 2.1446956182555557,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Polyunsaturated",
                                "tag": "FAPU",
                                "schemaOrgTag": null,
                                "total": 1.3384712063333335,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Carbs",
                        "tag": "CHOCDF",
                        "schemaOrgTag": "carbohydrateContent",
                        "total": 12.988266666666668,
                        "hasRDI": true,
                        "daily": 4.329422222222223,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Carbs (net)",
                                "tag": "CHOCDF.net",
                                "schemaOrgTag": null,
                                "total": 11.096711111111112,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Fiber",
                                "tag": "FIBTG",
                                "schemaOrgTag": "fiberContent",
                                "total": 1.8915555555555557,
                                "hasRDI": true,
                                "daily": 7.566222222222223,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars",
                                "tag": "SUGAR",
                                "schemaOrgTag": "sugarContent",
                                "total": 5.781004444444445,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars, added",
                                "tag": "SUGAR.added",
                                "schemaOrgTag": null,
                                "total": 0,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Protein",
                        "tag": "PROCNT",
                        "schemaOrgTag": "proteinContent",
                        "total": 85.74684164977778,
                        "hasRDI": true,
                        "daily": 171.49368329955556,
                        "unit": "g"
                    },
                    {
                        "label": "Cholesterol",
                        "tag": "CHOLE",
                        "schemaOrgTag": "cholesterolContent",
                        "total": 222.26026130000002,
                        "hasRDI": true,
                        "daily": 74.08675376666667,
                        "unit": "mg"
                    },
                    {
                        "label": "Sodium",
                        "tag": "NA",
                        "schemaOrgTag": "sodiumContent",
                        "total": 1465.758139254267,
                        "hasRDI": true,
                        "daily": 61.073255802261116,
                        "unit": "mg"
                    },
                    {
                        "label": "Calcium",
                        "tag": "CA",
                        "schemaOrgTag": null,
                        "total": 64.91518446927981,
                        "hasRDI": true,
                        "daily": 6.491518446927981,
                        "unit": "mg"
                    },
                    {
                        "label": "Magnesium",
                        "tag": "MG",
                        "schemaOrgTag": null,
                        "total": 128.52910374409035,
                        "hasRDI": true,
                        "daily": 30.60216755811675,
                        "unit": "mg"
                    },
                    {
                        "label": "Potassium",
                        "tag": "K",
                        "schemaOrgTag": null,
                        "total": 2254.290123097168,
                        "hasRDI": true,
                        "daily": 47.96361964036527,
                        "unit": "mg"
                    },
                    {
                        "label": "Iron",
                        "tag": "FE",
                        "schemaOrgTag": null,
                        "total": 1.7623444778831532,
                        "hasRDI": true,
                        "daily": 9.790802654906408,
                        "unit": "mg"
                    },
                    {
                        "label": "Zinc",
                        "tag": "ZN",
                        "schemaOrgTag": null,
                        "total": 2.0134495075201473,
                        "hasRDI": true,
                        "daily": 18.30408643200134,
                        "unit": "mg"
                    },
                    {
                        "label": "Phosphorus",
                        "tag": "P",
                        "schemaOrgTag": null,
                        "total": 1127.1126598666667,
                        "hasRDI": true,
                        "daily": 161.01609426666667,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin A",
                        "tag": "VITA_RAE",
                        "schemaOrgTag": null,
                        "total": 90.71847400000001,
                        "hasRDI": true,
                        "daily": 10.079830444444447,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin C",
                        "tag": "VITC",
                        "schemaOrgTag": null,
                        "total": 4.728888888888889,
                        "hasRDI": true,
                        "daily": 5.254320987654321,
                        "unit": "mg"
                    },
                    {
                        "label": "Thiamin (B1)",
                        "tag": "THIA",
                        "schemaOrgTag": null,
                        "total": 0.2681428516666667,
                        "hasRDI": true,
                        "daily": 22.34523763888889,
                        "unit": "mg"
                    },
                    {
                        "label": "Riboflavin (B2)",
                        "tag": "RIBF",
                        "schemaOrgTag": null,
                        "total": 0.16553993322222224,
                        "hasRDI": true,
                        "daily": 12.733841017094017,
                        "unit": "mg"
                    },
                    {
                        "label": "Niacin (B3)",
                        "tag": "NIA",
                        "schemaOrgTag": null,
                        "total": 29.787701280322224,
                        "hasRDI": true,
                        "daily": 186.1731330020139,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin B6",
                        "tag": "VITB6A",
                        "schemaOrgTag": null,
                        "total": 2.7484195209333344,
                        "hasRDI": true,
                        "daily": 211.4168862256411,
                        "unit": "mg"
                    },
                    {
                        "label": "Folate equivalent (total)",
                        "tag": "FOLDFE",
                        "schemaOrgTag": null,
                        "total": 75.70486217777778,
                        "hasRDI": true,
                        "daily": 18.926215544444446,
                        "unit": "µg"
                    },
                    {
                        "label": "Folate (food)",
                        "tag": "FOLFD",
                        "schemaOrgTag": null,
                        "total": 75.70486217777778,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Folic acid",
                        "tag": "FOLAC",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin B12",
                        "tag": "VITB12",
                        "schemaOrgTag": null,
                        "total": 4.989516070000001,
                        "hasRDI": true,
                        "daily": 207.89650291666672,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin D",
                        "tag": "VITD",
                        "schemaOrgTag": null,
                        "total": 21.318841390000003,
                        "hasRDI": true,
                        "daily": 142.1256092666667,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin E",
                        "tag": "TOCPHA",
                        "schemaOrgTag": null,
                        "total": 2.7905579014444446,
                        "hasRDI": true,
                        "daily": 18.603719342962965,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin K",
                        "tag": "VITK1",
                        "schemaOrgTag": null,
                        "total": 0.9432888888888888,
                        "hasRDI": true,
                        "daily": 0.786074074074074,
                        "unit": "µg"
                    },
                    {
                        "label": "Sugar alcohols",
                        "tag": "Sugar.alcohol",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    },
                    {
                        "label": "Water",
                        "tag": "WATER",
                        "schemaOrgTag": null,
                        "total": 513.7400417868181,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    }
                ]
            },
            "_links": {
                "self": {
                    "href": "https://api.edamam.com/api/recipes/v2/1297c760f06e7c47e77387cdcafae687?type=public&app_id=ea1d37d5&app_key=fd382a172ba8d6668c0430dc9c14a181",
                    "title": "Self"
                }
            }
        },
        {
            "recipe": {
                "uri": "http://www.edamam.com/ontologies/edamam.owl#recipe_ad0e583f5f88accd3ce54037a62c84ad",
                "label": "Fish Head Curry",
                "image": "https://www.edamam.com/web-img/453/45377df0aa09dfc2b19bdaad0dda0683.jpg",
                "source": "Serious Eats",
                "url": "http://www.seriouseats.com/recipes/2011/04/fish-head-curry-recipe.html",
                "shareAs": "http://www.edamam.com/recipe/fish-head-curry-ad0e583f5f88accd3ce54037a62c84ad/fish",
                "yield": 4,
                "dietLabels": [
                    "High-Fiber"
                ],
                "healthLabels": [
                    "Pescatarian",
                    "Dairy-Free",
                    "Gluten-Free",
                    "Wheat-Free",
                    "Egg-Free",
                    "Peanut-Free",
                    "Tree-Nut-Free",
                    "Soy-Free",
                    "Shellfish-Free",
                    "Pork-Free",
                    "Red-Meat-Free",
                    "Celery-Free",
                    "Mustard-Free",
                    "Sesame-Free",
                    "Lupine-Free",
                    "Alcohol-Free",
                    "Kosher"
                ],
                "cautions": [
                    "Tree-Nuts",
                    "Shellfish",
                    "Sulfites",
                    "FODMAP"
                ],
                "ingredientLines": [
                    "1/2 to 2 fish heads, depending on size, about 5 pounds total",
                    "2 tablespoons vegetable oil",
                    "1/4 cup red or green thai curry paste",
                    "3 tablespoons fish sauce or anchovy sauce",
                    "1 tablespoon sugar",
                    "1 can coconut milk, about 12 ounces",
                    "3 medium size asian eggplants, cut int 1 inch rounds",
                    "Handful of bird's eye chilies",
                    "1/2 cup thai basil leaves",
                    "Juice of 3 limes"
                ],
                "ingredients": [
                    {
                        "text": "1/2 to 2 fish heads, depending on size, about 5 pounds total",
                        "weight": 200,
                        "foodCategory": "seafood",
                        "foodId": "food_ar6pjbvaxqtlqia7jewa4brld7p9",
                        "image": "https://www.edamam.com/food-img/717/717cb400eb49626bb7c95cd29292cef4.jpg"
                    },
                    {
                        "text": "2 tablespoons vegetable oil",
                        "weight": 28,
                        "foodCategory": "Oils",
                        "foodId": "food_bt1mzi2ah2sfg8bv7no1qai83w8s",
                        "image": "https://www.edamam.com/food-img/6e5/6e51a63a6300a8ea1b4c4cc68dfaba33.jpg"
                    },
                    {
                        "text": "1/4 cup red or green thai curry paste",
                        "weight": 64.00000000108204,
                        "foodCategory": "condiments and sauces",
                        "foodId": "food_aojdol2are6zg7af2nincbe87jot",
                        "image": "https://www.edamam.com/food-img/b6a/b6a9ebae5850f42eca0253827603ef9c.jpg"
                    },
                    {
                        "text": "3 tablespoons fish sauce or anchovy sauce",
                        "weight": 54,
                        "foodCategory": "canned soup",
                        "foodId": "food_ahlu6u3ab8bu1wap7cbqua3s1quk",
                        "image": "https://www.edamam.com/food-img/7b5/7b58b769d8bf7b79acf12a76b79ea9bc.jpg"
                    },
                    {
                        "text": "1 tablespoon sugar",
                        "weight": 12.4999999997887,
                        "foodCategory": "sugars",
                        "foodId": "food_axi2ijobrk819yb0adceobnhm1c2",
                        "image": "https://www.edamam.com/food-img/ecb/ecb3f5aaed96d0188c21b8369be07765.jpg"
                    },
                    {
                        "text": "1 can coconut milk, about 12 ounces",
                        "weight": 423.75000000000006,
                        "foodCategory": "non-dairy beverages",
                        "foodId": "food_by1k6v2adj7drhbq9w1rpbpen9ms",
                        "image": "https://www.edamam.com/food-img/671/671f7528eadb1b01efb53243d0ef0f80.JPG"
                    },
                    {
                        "text": "3 medium size asian eggplants, cut int 1 inch rounds",
                        "weight": 1644,
                        "foodCategory": "vegetables",
                        "foodId": "food_ac9n68caswlpggbp7727varlyjk5",
                        "image": "https://www.edamam.com/food-img/da5/da5978d61b89a363147a6d13c36e3b54.jpg"
                    },
                    {
                        "text": "Handful of bird's eye chilies",
                        "weight": 13.125,
                        "foodCategory": "vegetables",
                        "foodId": "food_akybxs9atrgwona5nz3jgbo3vor5",
                        "image": "https://www.edamam.com/food-img/e3d/e3d161d6cfe5ef287053aed5461738ba.jpg"
                    },
                    {
                        "text": "1/2 cup thai basil leaves",
                        "weight": 12,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_bfeht3obd58c3gak5ehpibxgbbs6",
                        "image": "https://www.edamam.com/food-img/5f1/5f1b05685ac2b404236a5d1c1f3c8c10.jpg"
                    },
                    {
                        "text": "Juice of 3 limes",
                        "weight": 201,
                        "foodCategory": "fruit",
                        "foodId": "food_av58muyb8kg92fbk0g8g8aui5knv",
                        "image": "https://www.edamam.com/food-img/48a/48a123c9576647c4ada6a41df5eeb22a.jpg"
                    }
                ],
                "calories": 1896.422150240477,
                "totalWeight": 2652.375000000871,
                "totalTime": 30,
                "cuisineType": [
                    "south east asian"
                ],
                "mealType": [
                    "lunch/dinner"
                ],
                "dishType": [
                    "main course"
                ],
                "totalNutrients": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 1896.422150240477,
                        "unit": "kcal"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 128.82823320997989,
                        "unit": "g"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 84.23491736232799,
                        "unit": "g"
                    },
                    "FATRN": {
                        "label": "Trans",
                        "quantity": 0.21476000000000003,
                        "unit": "g"
                    },
                    "FAMS": {
                        "label": "Monounsaturated",
                        "quantity": 26.99581129674846,
                        "unit": "g"
                    },
                    "FAPU": {
                        "label": "Polyunsaturated",
                        "quantity": 9.042704916818673,
                        "unit": "g"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 156.5229500255765,
                        "unit": "g"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 58.42169465252728,
                        "unit": "g"
                    },
                    "SUGAR": {
                        "label": "Sugars",
                        "quantity": 77.3128303926044,
                        "unit": "g"
                    },
                    "SUGAR.added": {
                        "label": "Sugars, added",
                        "quantity": 12.474999999789123,
                        "unit": "g"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 72.89773412069614,
                        "unit": "g"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 105.88779927561954,
                        "unit": "mg"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 4761.615533061478,
                        "unit": "mg"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 415.13655117858775,
                        "unit": "mg"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 629.7540936389671,
                        "unit": "mg"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 6004.433626068514,
                        "unit": "mg"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 23.851242925807906,
                        "unit": "mg"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 6.909628177613245,
                        "unit": "mg"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 1260.7977381771416,
                        "unit": "mg"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 113.5421739560973,
                        "unit": "µg"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 116.04036736814913,
                        "unit": "mg"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 0.9688926004812607,
                        "unit": "mg"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 0.8942921636010911,
                        "unit": "mg"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 24.309595994179848,
                        "unit": "mg"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 2.3629743821626077,
                        "unit": "mg"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 549.4861671908342,
                        "unit": "µg"
                    },
                    "FOLFD": {
                        "label": "Folate (food)",
                        "quantity": 549.4861671908342,
                        "unit": "µg"
                    },
                    "FOLAC": {
                        "label": "Folic acid",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 3.436489569280292,
                        "unit": "µg"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 6.2,
                        "unit": "µg"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 13.636231138739808,
                        "unit": "mg"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 118.27249210761133,
                        "unit": "µg"
                    },
                    "WATER": {
                        "label": "Water",
                        "quantity": 2265.402423259149,
                        "unit": "g"
                    }
                },
                "totalDaily": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 94.82110751202386,
                        "unit": "%"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 198.19728186150752,
                        "unit": "%"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 421.17458681164,
                        "unit": "%"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 52.174316675192166,
                        "unit": "%"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 233.68677861010912,
                        "unit": "%"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 145.79546824139229,
                        "unit": "%"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 35.29593309187318,
                        "unit": "%"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 198.40064721089493,
                        "unit": "%"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 41.513655117858775,
                        "unit": "%"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 149.94145086642072,
                        "unit": "%"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 127.75390693762796,
                        "unit": "%"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 132.50690514337725,
                        "unit": "%"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 62.81480161466586,
                        "unit": "%"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 180.11396259673452,
                        "unit": "%"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 12.615797106233034,
                        "unit": "%"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 128.9337415201657,
                        "unit": "%"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 80.74105004010507,
                        "unit": "%"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 68.79170489239162,
                        "unit": "%"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 151.93497496362406,
                        "unit": "%"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 181.76726016635442,
                        "unit": "%"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 137.37154179770855,
                        "unit": "%"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 143.18706538667885,
                        "unit": "%"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 41.333333333333336,
                        "unit": "%"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 90.90820759159872,
                        "unit": "%"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 98.5604100896761,
                        "unit": "%"
                    }
                },
                "digest": [
                    {
                        "label": "Fat",
                        "tag": "FAT",
                        "schemaOrgTag": "fatContent",
                        "total": 128.82823320997989,
                        "hasRDI": true,
                        "daily": 198.19728186150752,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Saturated",
                                "tag": "FASAT",
                                "schemaOrgTag": "saturatedFatContent",
                                "total": 84.23491736232799,
                                "hasRDI": true,
                                "daily": 421.17458681164,
                                "unit": "g"
                            },
                            {
                                "label": "Trans",
                                "tag": "FATRN",
                                "schemaOrgTag": "transFatContent",
                                "total": 0.21476000000000003,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Monounsaturated",
                                "tag": "FAMS",
                                "schemaOrgTag": null,
                                "total": 26.99581129674846,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Polyunsaturated",
                                "tag": "FAPU",
                                "schemaOrgTag": null,
                                "total": 9.042704916818673,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Carbs",
                        "tag": "CHOCDF",
                        "schemaOrgTag": "carbohydrateContent",
                        "total": 156.5229500255765,
                        "hasRDI": true,
                        "daily": 52.174316675192166,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Carbs (net)",
                                "tag": "CHOCDF.net",
                                "schemaOrgTag": null,
                                "total": 98.10125537304923,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Fiber",
                                "tag": "FIBTG",
                                "schemaOrgTag": "fiberContent",
                                "total": 58.42169465252728,
                                "hasRDI": true,
                                "daily": 233.68677861010912,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars",
                                "tag": "SUGAR",
                                "schemaOrgTag": "sugarContent",
                                "total": 77.3128303926044,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars, added",
                                "tag": "SUGAR.added",
                                "schemaOrgTag": null,
                                "total": 12.474999999789123,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Protein",
                        "tag": "PROCNT",
                        "schemaOrgTag": "proteinContent",
                        "total": 72.89773412069614,
                        "hasRDI": true,
                        "daily": 145.79546824139229,
                        "unit": "g"
                    },
                    {
                        "label": "Cholesterol",
                        "tag": "CHOLE",
                        "schemaOrgTag": "cholesterolContent",
                        "total": 105.88779927561954,
                        "hasRDI": true,
                        "daily": 35.29593309187318,
                        "unit": "mg"
                    },
                    {
                        "label": "Sodium",
                        "tag": "NA",
                        "schemaOrgTag": "sodiumContent",
                        "total": 4761.615533061478,
                        "hasRDI": true,
                        "daily": 198.40064721089493,
                        "unit": "mg"
                    },
                    {
                        "label": "Calcium",
                        "tag": "CA",
                        "schemaOrgTag": null,
                        "total": 415.13655117858775,
                        "hasRDI": true,
                        "daily": 41.513655117858775,
                        "unit": "mg"
                    },
                    {
                        "label": "Magnesium",
                        "tag": "MG",
                        "schemaOrgTag": null,
                        "total": 629.7540936389671,
                        "hasRDI": true,
                        "daily": 149.94145086642072,
                        "unit": "mg"
                    },
                    {
                        "label": "Potassium",
                        "tag": "K",
                        "schemaOrgTag": null,
                        "total": 6004.433626068514,
                        "hasRDI": true,
                        "daily": 127.75390693762796,
                        "unit": "mg"
                    },
                    {
                        "label": "Iron",
                        "tag": "FE",
                        "schemaOrgTag": null,
                        "total": 23.851242925807906,
                        "hasRDI": true,
                        "daily": 132.50690514337725,
                        "unit": "mg"
                    },
                    {
                        "label": "Zinc",
                        "tag": "ZN",
                        "schemaOrgTag": null,
                        "total": 6.909628177613245,
                        "hasRDI": true,
                        "daily": 62.81480161466586,
                        "unit": "mg"
                    },
                    {
                        "label": "Phosphorus",
                        "tag": "P",
                        "schemaOrgTag": null,
                        "total": 1260.7977381771416,
                        "hasRDI": true,
                        "daily": 180.11396259673452,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin A",
                        "tag": "VITA_RAE",
                        "schemaOrgTag": null,
                        "total": 113.5421739560973,
                        "hasRDI": true,
                        "daily": 12.615797106233034,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin C",
                        "tag": "VITC",
                        "schemaOrgTag": null,
                        "total": 116.04036736814913,
                        "hasRDI": true,
                        "daily": 128.9337415201657,
                        "unit": "mg"
                    },
                    {
                        "label": "Thiamin (B1)",
                        "tag": "THIA",
                        "schemaOrgTag": null,
                        "total": 0.9688926004812607,
                        "hasRDI": true,
                        "daily": 80.74105004010507,
                        "unit": "mg"
                    },
                    {
                        "label": "Riboflavin (B2)",
                        "tag": "RIBF",
                        "schemaOrgTag": null,
                        "total": 0.8942921636010911,
                        "hasRDI": true,
                        "daily": 68.79170489239162,
                        "unit": "mg"
                    },
                    {
                        "label": "Niacin (B3)",
                        "tag": "NIA",
                        "schemaOrgTag": null,
                        "total": 24.309595994179848,
                        "hasRDI": true,
                        "daily": 151.93497496362406,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin B6",
                        "tag": "VITB6A",
                        "schemaOrgTag": null,
                        "total": 2.3629743821626077,
                        "hasRDI": true,
                        "daily": 181.76726016635442,
                        "unit": "mg"
                    },
                    {
                        "label": "Folate equivalent (total)",
                        "tag": "FOLDFE",
                        "schemaOrgTag": null,
                        "total": 549.4861671908342,
                        "hasRDI": true,
                        "daily": 137.37154179770855,
                        "unit": "µg"
                    },
                    {
                        "label": "Folate (food)",
                        "tag": "FOLFD",
                        "schemaOrgTag": null,
                        "total": 549.4861671908342,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Folic acid",
                        "tag": "FOLAC",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin B12",
                        "tag": "VITB12",
                        "schemaOrgTag": null,
                        "total": 3.436489569280292,
                        "hasRDI": true,
                        "daily": 143.18706538667885,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin D",
                        "tag": "VITD",
                        "schemaOrgTag": null,
                        "total": 6.2,
                        "hasRDI": true,
                        "daily": 41.333333333333336,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin E",
                        "tag": "TOCPHA",
                        "schemaOrgTag": null,
                        "total": 13.636231138739808,
                        "hasRDI": true,
                        "daily": 90.90820759159872,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin K",
                        "tag": "VITK1",
                        "schemaOrgTag": null,
                        "total": 118.27249210761133,
                        "hasRDI": true,
                        "daily": 98.5604100896761,
                        "unit": "µg"
                    },
                    {
                        "label": "Sugar alcohols",
                        "tag": "Sugar.alcohol",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    },
                    {
                        "label": "Water",
                        "tag": "WATER",
                        "schemaOrgTag": null,
                        "total": 2265.402423259149,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    }
                ]
            },
            "_links": {
                "self": {
                    "href": "https://api.edamam.com/api/recipes/v2/ad0e583f5f88accd3ce54037a62c84ad?type=public&app_id=ea1d37d5&app_key=fd382a172ba8d6668c0430dc9c14a181",
                    "title": "Self"
                }
            }
        },
        {
            "recipe": {
                "uri": "http://www.edamam.com/ontologies/edamam.owl#recipe_80f49564a588ad6ba3f2748327b127e6",
                "label": "Homemade fish fingers",
                "image": "https://www.edamam.com/web-img/798/79872b022c279ee76b9bee7421481e5f.jpg",
                "source": "BBC",
                "url": "http://www.bbc.co.uk/food/recipes/homemade_fish_fingers_85938",
                "shareAs": "http://www.edamam.com/recipe/homemade-fish-fingers-80f49564a588ad6ba3f2748327b127e6/fish",
                "yield": 4,
                "dietLabels": [
                    "Low-Carb"
                ],
                "healthLabels": [
                    "Sugar-Conscious",
                    "Pescatarian",
                    "Dairy-Free",
                    "Peanut-Free",
                    "Tree-Nut-Free",
                    "Soy-Free",
                    "Shellfish-Free",
                    "Pork-Free",
                    "Red-Meat-Free",
                    "Crustacean-Free",
                    "Celery-Free",
                    "Mustard-Free",
                    "Sesame-Free",
                    "Lupine-Free",
                    "Mollusk-Free",
                    "Alcohol-Free",
                    "Sulfite-Free",
                    "Kosher"
                ],
                "cautions": [],
                "ingredientLines": [
                    "3 tbsp plain flour",
                    "1 large free-range egg, beaten",
                    "50g/1¾oz golden breadcrumbs (if not available, substitute with 30g/1oz fresh white breadcrumbs mixed with 20g/½oz easy-cook polenta)",
                    "500g/1lb2oz thick skinless fish fillets (salmon, cod, haddock or other white fish), cut into 4 or 8 thick pieces",
                    "3 tbsp sunflower oil",
                    "Salt and freshly ground black pepper"
                ],
                "ingredients": [
                    {
                        "text": "3 tbsp plain flour",
                        "weight": 23.437499999603745,
                        "foodCategory": "grains",
                        "foodId": "food_ahebfs0a985an4aubqaebbipra58",
                        "image": "https://www.edamam.com/food-img/b4c/b4c739e76a6f2172b7ad49d0aa41d5aa.jpg"
                    },
                    {
                        "text": "1 large free-range egg, beaten",
                        "weight": 50,
                        "foodCategory": "Eggs",
                        "foodId": "food_bhpradua77pk16aipcvzeayg732r",
                        "image": "https://www.edamam.com/food-img/a7e/a7ec7c337cb47c6550b3b118e357f077.jpg"
                    },
                    {
                        "text": "50g/1¾oz golden breadcrumbs (if not available, substitute with 30g/1oz fresh white breadcrumbs mixed with 20g/½oz easy-cook polenta)",
                        "weight": 50,
                        "foodCategory": "bread, rolls and tortillas",
                        "foodId": "food_ata1dxza443wfda7jb4e5b3zwt9p",
                        "image": "https://www.edamam.com/food-img/349/349f852497885b9d9c0b195ad0d0db8f.jpg"
                    },
                    {
                        "text": "500g/1lb2oz thick skinless fish fillets (salmon, cod, haddock or other white fish), cut into 4 or 8 thick pieces",
                        "weight": 500,
                        "foodCategory": "seafood",
                        "foodId": "food_ar6pjbvaxqtlqia7jewa4brld7p9",
                        "image": "https://www.edamam.com/food-img/717/717cb400eb49626bb7c95cd29292cef4.jpg"
                    },
                    {
                        "text": "3 tbsp sunflower oil",
                        "weight": 40.8,
                        "foodCategory": "Oils",
                        "foodId": "food_b09yz1nbx49rv1bss5kgxat77cvn",
                        "image": "https://www.edamam.com/food-img/be4/be4dba2bb618ecda2213ac422ae05289.jpg"
                    },
                    {
                        "text": "Salt and freshly ground black pepper",
                        "weight": 3.985424999997622,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_btxz81db72hwbra2pncvebzzzum9",
                        "image": "https://www.edamam.com/food-img/694/6943ea510918c6025795e8dc6e6eaaeb.jpg"
                    },
                    {
                        "text": "Salt and freshly ground black pepper",
                        "weight": 1.992712499998811,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_b6ywzluaaxv02wad7s1r9ag4py89",
                        "image": "https://www.edamam.com/food-img/c6e/c6e5c3bd8d3bc15175d9766971a4d1b2.jpg"
                    }
                ],
                "calories": 1199.9862083735545,
                "totalWeight": 668.4270176548313,
                "totalTime": 60,
                "cuisineType": [
                    "british"
                ],
                "mealType": [
                    "lunch/dinner"
                ],
                "dishType": [
                    "condiments and sauces"
                ],
                "totalNutrients": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 1199.9862083735545,
                        "unit": "kcal"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 56.99964992749608,
                        "unit": "g"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 10.457566682999369,
                        "unit": "g"
                    },
                    "FATRN": {
                        "label": "Trans",
                        "quantity": 0.019,
                        "unit": "g"
                    },
                    "FAMS": {
                        "label": "Monounsaturated",
                        "quantity": 23.715216770374642,
                        "unit": "g"
                    },
                    "FAPU": {
                        "label": "Polyunsaturated",
                        "quantity": 18.76838414574835,
                        "unit": "g"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 55.50949589344686,
                        "unit": "g"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 3.3869687624890004,
                        "unit": "g"
                    },
                    "SUGAR": {
                        "label": "Sugars",
                        "quantity": 3.3610346099989226,
                        "unit": "g"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 115.98313657870894,
                        "unit": "g"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 436,
                        "unit": "mg"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 1549.3050345635756,
                        "unit": "mg"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 182.3705746121902,
                        "unit": "mg"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 171.08575642646306,
                        "unit": "mg"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 1728.7370185369784,
                        "unit": "mg"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 6.564960590757504,
                        "unit": "mg"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 3.209972583902441,
                        "unit": "mg"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 1059.9609857495702,
                        "unit": "mg"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 80.53803237499967,
                        "unit": "µg"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 0,
                        "unit": "mg"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 0.7387771294995232,
                        "unit": "mg"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 0.7579618824998393,
                        "unit": "mg"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 23.18524545387003,
                        "unit": "mg"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 0.9716112933748222,
                        "unit": "mg"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 231.93251112489676,
                        "unit": "µg"
                    },
                    "FOLFD": {
                        "label": "Folate (food)",
                        "quantity": 162.43251112489676,
                        "unit": "µg"
                    },
                    "FOLAC": {
                        "label": "Folic acid",
                        "quantity": 41,
                        "unit": "µg"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 8.52,
                        "unit": "µg"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 16.5,
                        "unit": "µg"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 19.360426709999746,
                        "unit": "mg"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 15.985582862496866,
                        "unit": "µg"
                    },
                    "WATER": {
                        "label": "Water",
                        "quantity": 434.77643558776305,
                        "unit": "g"
                    }
                },
                "totalDaily": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 59.99931041867773,
                        "unit": "%"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 87.69176911922474,
                        "unit": "%"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 52.28783341499684,
                        "unit": "%"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 18.50316529781562,
                        "unit": "%"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 13.547875049956001,
                        "unit": "%"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 231.9662731574179,
                        "unit": "%"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 145.33333333333334,
                        "unit": "%"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 64.55437644014899,
                        "unit": "%"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 18.23705746121902,
                        "unit": "%"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 40.73470391106263,
                        "unit": "%"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 36.78163869227614,
                        "unit": "%"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 36.47200328198613,
                        "unit": "%"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 29.181568944567644,
                        "unit": "%"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 151.42299796422432,
                        "unit": "%"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 8.948670263888852,
                        "unit": "%"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 0,
                        "unit": "%"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 61.56476079162694,
                        "unit": "%"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 58.304760192295326,
                        "unit": "%"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 144.90778408668768,
                        "unit": "%"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 74.7393302596017,
                        "unit": "%"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 57.98312778122419,
                        "unit": "%"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 355,
                        "unit": "%"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 110,
                        "unit": "%"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 129.0695113999983,
                        "unit": "%"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 13.321319052080721,
                        "unit": "%"
                    }
                },
                "digest": [
                    {
                        "label": "Fat",
                        "tag": "FAT",
                        "schemaOrgTag": "fatContent",
                        "total": 56.99964992749608,
                        "hasRDI": true,
                        "daily": 87.69176911922474,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Saturated",
                                "tag": "FASAT",
                                "schemaOrgTag": "saturatedFatContent",
                                "total": 10.457566682999369,
                                "hasRDI": true,
                                "daily": 52.28783341499684,
                                "unit": "g"
                            },
                            {
                                "label": "Trans",
                                "tag": "FATRN",
                                "schemaOrgTag": "transFatContent",
                                "total": 0.019,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Monounsaturated",
                                "tag": "FAMS",
                                "schemaOrgTag": null,
                                "total": 23.715216770374642,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Polyunsaturated",
                                "tag": "FAPU",
                                "schemaOrgTag": null,
                                "total": 18.76838414574835,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Carbs",
                        "tag": "CHOCDF",
                        "schemaOrgTag": "carbohydrateContent",
                        "total": 55.50949589344686,
                        "hasRDI": true,
                        "daily": 18.50316529781562,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Carbs (net)",
                                "tag": "CHOCDF.net",
                                "schemaOrgTag": null,
                                "total": 52.12252713095786,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Fiber",
                                "tag": "FIBTG",
                                "schemaOrgTag": "fiberContent",
                                "total": 3.3869687624890004,
                                "hasRDI": true,
                                "daily": 13.547875049956001,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars",
                                "tag": "SUGAR",
                                "schemaOrgTag": "sugarContent",
                                "total": 3.3610346099989226,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars, added",
                                "tag": "SUGAR.added",
                                "schemaOrgTag": null,
                                "total": 0,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Protein",
                        "tag": "PROCNT",
                        "schemaOrgTag": "proteinContent",
                        "total": 115.98313657870894,
                        "hasRDI": true,
                        "daily": 231.9662731574179,
                        "unit": "g"
                    },
                    {
                        "label": "Cholesterol",
                        "tag": "CHOLE",
                        "schemaOrgTag": "cholesterolContent",
                        "total": 436,
                        "hasRDI": true,
                        "daily": 145.33333333333334,
                        "unit": "mg"
                    },
                    {
                        "label": "Sodium",
                        "tag": "NA",
                        "schemaOrgTag": "sodiumContent",
                        "total": 1549.3050345635756,
                        "hasRDI": true,
                        "daily": 64.55437644014899,
                        "unit": "mg"
                    },
                    {
                        "label": "Calcium",
                        "tag": "CA",
                        "schemaOrgTag": null,
                        "total": 182.3705746121902,
                        "hasRDI": true,
                        "daily": 18.23705746121902,
                        "unit": "mg"
                    },
                    {
                        "label": "Magnesium",
                        "tag": "MG",
                        "schemaOrgTag": null,
                        "total": 171.08575642646306,
                        "hasRDI": true,
                        "daily": 40.73470391106263,
                        "unit": "mg"
                    },
                    {
                        "label": "Potassium",
                        "tag": "K",
                        "schemaOrgTag": null,
                        "total": 1728.7370185369784,
                        "hasRDI": true,
                        "daily": 36.78163869227614,
                        "unit": "mg"
                    },
                    {
                        "label": "Iron",
                        "tag": "FE",
                        "schemaOrgTag": null,
                        "total": 6.564960590757504,
                        "hasRDI": true,
                        "daily": 36.47200328198613,
                        "unit": "mg"
                    },
                    {
                        "label": "Zinc",
                        "tag": "ZN",
                        "schemaOrgTag": null,
                        "total": 3.209972583902441,
                        "hasRDI": true,
                        "daily": 29.181568944567644,
                        "unit": "mg"
                    },
                    {
                        "label": "Phosphorus",
                        "tag": "P",
                        "schemaOrgTag": null,
                        "total": 1059.9609857495702,
                        "hasRDI": true,
                        "daily": 151.42299796422432,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin A",
                        "tag": "VITA_RAE",
                        "schemaOrgTag": null,
                        "total": 80.53803237499967,
                        "hasRDI": true,
                        "daily": 8.948670263888852,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin C",
                        "tag": "VITC",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": true,
                        "daily": 0,
                        "unit": "mg"
                    },
                    {
                        "label": "Thiamin (B1)",
                        "tag": "THIA",
                        "schemaOrgTag": null,
                        "total": 0.7387771294995232,
                        "hasRDI": true,
                        "daily": 61.56476079162694,
                        "unit": "mg"
                    },
                    {
                        "label": "Riboflavin (B2)",
                        "tag": "RIBF",
                        "schemaOrgTag": null,
                        "total": 0.7579618824998393,
                        "hasRDI": true,
                        "daily": 58.304760192295326,
                        "unit": "mg"
                    },
                    {
                        "label": "Niacin (B3)",
                        "tag": "NIA",
                        "schemaOrgTag": null,
                        "total": 23.18524545387003,
                        "hasRDI": true,
                        "daily": 144.90778408668768,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin B6",
                        "tag": "VITB6A",
                        "schemaOrgTag": null,
                        "total": 0.9716112933748222,
                        "hasRDI": true,
                        "daily": 74.7393302596017,
                        "unit": "mg"
                    },
                    {
                        "label": "Folate equivalent (total)",
                        "tag": "FOLDFE",
                        "schemaOrgTag": null,
                        "total": 231.93251112489676,
                        "hasRDI": true,
                        "daily": 57.98312778122419,
                        "unit": "µg"
                    },
                    {
                        "label": "Folate (food)",
                        "tag": "FOLFD",
                        "schemaOrgTag": null,
                        "total": 162.43251112489676,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Folic acid",
                        "tag": "FOLAC",
                        "schemaOrgTag": null,
                        "total": 41,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin B12",
                        "tag": "VITB12",
                        "schemaOrgTag": null,
                        "total": 8.52,
                        "hasRDI": true,
                        "daily": 355,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin D",
                        "tag": "VITD",
                        "schemaOrgTag": null,
                        "total": 16.5,
                        "hasRDI": true,
                        "daily": 110,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin E",
                        "tag": "TOCPHA",
                        "schemaOrgTag": null,
                        "total": 19.360426709999746,
                        "hasRDI": true,
                        "daily": 129.0695113999983,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin K",
                        "tag": "VITK1",
                        "schemaOrgTag": null,
                        "total": 15.985582862496866,
                        "hasRDI": true,
                        "daily": 13.321319052080721,
                        "unit": "µg"
                    },
                    {
                        "label": "Sugar alcohols",
                        "tag": "Sugar.alcohol",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    },
                    {
                        "label": "Water",
                        "tag": "WATER",
                        "schemaOrgTag": null,
                        "total": 434.77643558776305,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    }
                ]
            },
            "_links": {
                "self": {
                    "href": "https://api.edamam.com/api/recipes/v2/80f49564a588ad6ba3f2748327b127e6?type=public&app_id=ea1d37d5&app_key=fd382a172ba8d6668c0430dc9c14a181",
                    "title": "Self"
                }
            }
        },
        {
            "recipe": {
                "uri": "http://www.edamam.com/ontologies/edamam.owl#recipe_9b4b3972ae2d7ebcb88f37abfbb65a33",
                "label": "Fish And Chips",
                "image": "https://www.edamam.com/web-img/e2a/e2a26f70fb6440b093ba5afb1560772b.jpg",
                "source": "No Recipes",
                "url": "http://norecipes.com/blog/fish-and-chips-recipe/",
                "shareAs": "http://www.edamam.com/recipe/fish-and-chips-9b4b3972ae2d7ebcb88f37abfbb65a33/fish",
                "yield": 2,
                "dietLabels": [
                    "High-Fiber"
                ],
                "healthLabels": [
                    "Sugar-Conscious",
                    "Pescatarian",
                    "Mediterranean",
                    "Dairy-Free",
                    "Egg-Free",
                    "Peanut-Free",
                    "Tree-Nut-Free",
                    "Soy-Free",
                    "Shellfish-Free",
                    "Pork-Free",
                    "Red-Meat-Free",
                    "Crustacean-Free",
                    "Celery-Free",
                    "Mustard-Free",
                    "Sesame-Free",
                    "Lupine-Free",
                    "Mollusk-Free",
                    "Kosher"
                ],
                "cautions": [
                    "Gluten",
                    "Wheat"
                ],
                "ingredientLines": [
                    "4 medium potatoes I used a mix of yukon gold and russet",
                    "4 medium fish fillets cod, haddock and albacore work well",
                    "1/2 cup + 2 tablespoons flour",
                    "2 tablespoons cornstarch",
                    "1/4 teaspoon paprika",
                    "1/4 teaspoon onion powder",
                    "vegetable oil for frying",
                    "1/4 teaspoon baking powder",
                    "1/2 cup very cold beer you may need a little more"
                ],
                "ingredients": [
                    {
                        "text": "4 medium potatoes I used a mix of yukon gold and russet",
                        "weight": 852,
                        "foodCategory": "vegetables",
                        "foodId": "food_abiw5baauresjmb6xpap2bg3otzu",
                        "image": "https://www.edamam.com/food-img/651/6512e82417bce15c2899630c1a2799df.jpg"
                    },
                    {
                        "text": "4 medium fish fillets cod, haddock and albacore work well",
                        "weight": 231,
                        "foodCategory": "seafood",
                        "foodId": "food_a3z8tuub0gc30kaqthfuibcqz9os",
                        "image": "https://www.edamam.com/food-img/d58/d58d0ccfc3a15f1dfb7877f17a068d4d.jpg"
                    },
                    {
                        "text": "4 medium fish fillets cod, haddock and albacore work well",
                        "weight": 193,
                        "foodCategory": "seafood",
                        "foodId": "food_ayfi958a1oqf07brviufabx7rhho",
                        "image": "https://www.edamam.com/food-img/25c/25c7b9d6948bbee0d9e3d2c130a4b3f1.jpg"
                    },
                    {
                        "text": "4 medium fish fillets cod, haddock and albacore work well",
                        "weight": 170,
                        "foodCategory": "seafood",
                        "foodId": "food_bu5s7alaj4fjv8bf9qxvnba38oay",
                        "image": "https://www.edamam.com/food-img/022/022db6571bd5b3dfbd3ef8941c775d12.jpg"
                    },
                    {
                        "text": "1/2 cup + 2 tablespoons flour",
                        "weight": 62.5,
                        "foodCategory": "grains",
                        "foodId": "food_ahebfs0a985an4aubqaebbipra58",
                        "image": "https://www.edamam.com/food-img/b4c/b4c739e76a6f2172b7ad49d0aa41d5aa.jpg"
                    },
                    {
                        "text": "1/2 cup + 2 tablespoons flour",
                        "weight": 15.624999999735829,
                        "foodCategory": "grains",
                        "foodId": "food_ahebfs0a985an4aubqaebbipra58",
                        "image": "https://www.edamam.com/food-img/b4c/b4c739e76a6f2172b7ad49d0aa41d5aa.jpg"
                    },
                    {
                        "text": "2 tablespoons cornstarch",
                        "weight": 15.99999999972949,
                        "foodCategory": null,
                        "foodId": "food_bevnfkfbvjm45pbbgj9nsb3ypntm",
                        "image": "https://www.edamam.com/food-img/f9b/f9b74d9495b40c0aea955c37a1fc39dc.jpg"
                    },
                    {
                        "text": "1/4 teaspoon paprika",
                        "weight": 0.575,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_a9dpcnjb883g67b3lq82ca0421ql",
                        "image": "https://www.edamam.com/food-img/474/474d63763b9d8b9da98c5f43a114648c.jpg"
                    },
                    {
                        "text": "1/4 teaspoon onion powder",
                        "weight": 0.6,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_bmv8z27b1o25vcbu41ooyawd2zj4",
                        "image": "https://www.edamam.com/food-img/1e7/1e73e6f5dd96bb233abc0fcc05fb0ec8.jpg"
                    },
                    {
                        "text": "vegetable oil for frying",
                        "weight": 22.592999999992724,
                        "foodCategory": "Oils",
                        "foodId": "food_bt1mzi2ah2sfg8bv7no1qai83w8s",
                        "image": "https://www.edamam.com/food-img/6e5/6e51a63a6300a8ea1b4c4cc68dfaba33.jpg"
                    },
                    {
                        "text": "1/4 teaspoon baking powder",
                        "weight": 1.15,
                        "foodCategory": "condiments and sauces",
                        "foodId": "food_bad4zycbt4w60dbut111vaub2g3e",
                        "image": "https://www.edamam.com/food-img/a84/a8410ec57a2e62a1ad9955ac14d40af6.jpg"
                    },
                    {
                        "text": "1/2 cup very cold beer you may need a little more",
                        "weight": 118.8,
                        "foodCategory": "beer",
                        "foodId": "food_b3ieo81b7uf59ya5529oobsaaqbu",
                        "image": "https://www.edamam.com/food-img/7f8/7f82e3944cd8fcba3ffad7b6ce741c62.jpg"
                    }
                ],
                "calories": 3777.070499997298,
                "totalWeight": 1910.437499999385,
                "totalTime": 0,
                "cuisineType": [
                    "british"
                ],
                "mealType": [
                    "lunch/dinner"
                ],
                "dishType": [
                    "main course"
                ],
                "totalNutrients": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 3777.070499997298,
                        "unit": "kcal"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 254.057482499917,
                        "unit": "g"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 17.35291087499434,
                        "unit": "g"
                    },
                    "FATRN": {
                        "label": "Trans",
                        "quantity": 1.9461881249993844,
                        "unit": "g"
                    },
                    "FAMS": {
                        "label": "Monounsaturated",
                        "quantity": 180.02317012494197,
                        "unit": "g"
                    },
                    "FAPU": {
                        "label": "Polyunsaturated",
                        "quantity": 44.449499499985116,
                        "unit": "g"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 228.3444999995515,
                        "unit": "g"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 21.291549999990433,
                        "unit": "g"
                    },
                    "SUGAR": {
                        "label": "Sugars",
                        "quantity": 6.955772499999287,
                        "unit": "g"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 140.13240749997198,
                        "unit": "g"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 269.85,
                        "unit": "mg"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 762.8029999999703,
                        "unit": "mg"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 272.32749999995497,
                        "unit": "mg"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 396.8554999999338,
                        "unit": "mg"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 5977.857249999709,
                        "unit": "mg"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 10.448082499995637,
                        "unit": "mg"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 5.374682499997988,
                        "unit": "mg"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 2086.161499999679,
                        "unit": "mg"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 105.29225,
                        "unit": "µg"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 170.299575,
                        "unit": "mg"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 1.2006894999996829,
                        "unit": "mg"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 0.7968024999998943,
                        "unit": "mg"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 53.2894774999967,
                        "unit": "mg"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 5.3134217499998835,
                        "unit": "mg"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 207.15624999993128,
                        "unit": "µg"
                    },
                    "FOLFD": {
                        "label": "Folate (food)",
                        "quantity": 207.15624999993128,
                        "unit": "µg"
                    },
                    "FOLAC": {
                        "label": "Folic acid",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 9.19376,
                        "unit": "µg"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 5.933999999999999,
                        "unit": "µg"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 57.37879499998235,
                        "unit": "mg"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 17.502699999999212,
                        "unit": "µg"
                    },
                    "WATER": {
                        "label": "Water",
                        "quantity": 1270.4045499999463,
                        "unit": "g"
                    }
                },
                "totalDaily": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 188.8535249998649,
                        "unit": "%"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 390.8576653844877,
                        "unit": "%"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 86.76455437497171,
                        "unit": "%"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 76.11483333318382,
                        "unit": "%"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 85.16619999996173,
                        "unit": "%"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 280.26481499994395,
                        "unit": "%"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 89.95000000000002,
                        "unit": "%"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 31.7834583333321,
                        "unit": "%"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 27.232749999995495,
                        "unit": "%"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 94.489404761889,
                        "unit": "%"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 127.18845212765338,
                        "unit": "%"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 58.04490277775354,
                        "unit": "%"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 48.86074999998171,
                        "unit": "%"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 298.0230714285256,
                        "unit": "%"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 11.69913888888889,
                        "unit": "%"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 189.22175000000001,
                        "unit": "%"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 100.05745833330691,
                        "unit": "%"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 61.29249999999187,
                        "unit": "%"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 333.0592343749794,
                        "unit": "%"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 408.72474999999105,
                        "unit": "%"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 51.78906249998282,
                        "unit": "%"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 383.0733333333333,
                        "unit": "%"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 39.559999999999995,
                        "unit": "%"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 382.5252999998823,
                        "unit": "%"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 14.585583333332677,
                        "unit": "%"
                    }
                },
                "digest": [
                    {
                        "label": "Fat",
                        "tag": "FAT",
                        "schemaOrgTag": "fatContent",
                        "total": 254.057482499917,
                        "hasRDI": true,
                        "daily": 390.8576653844877,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Saturated",
                                "tag": "FASAT",
                                "schemaOrgTag": "saturatedFatContent",
                                "total": 17.35291087499434,
                                "hasRDI": true,
                                "daily": 86.76455437497171,
                                "unit": "g"
                            },
                            {
                                "label": "Trans",
                                "tag": "FATRN",
                                "schemaOrgTag": "transFatContent",
                                "total": 1.9461881249993844,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Monounsaturated",
                                "tag": "FAMS",
                                "schemaOrgTag": null,
                                "total": 180.02317012494197,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Polyunsaturated",
                                "tag": "FAPU",
                                "schemaOrgTag": null,
                                "total": 44.449499499985116,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Carbs",
                        "tag": "CHOCDF",
                        "schemaOrgTag": "carbohydrateContent",
                        "total": 228.3444999995515,
                        "hasRDI": true,
                        "daily": 76.11483333318382,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Carbs (net)",
                                "tag": "CHOCDF.net",
                                "schemaOrgTag": null,
                                "total": 207.05294999956106,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Fiber",
                                "tag": "FIBTG",
                                "schemaOrgTag": "fiberContent",
                                "total": 21.291549999990433,
                                "hasRDI": true,
                                "daily": 85.16619999996173,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars",
                                "tag": "SUGAR",
                                "schemaOrgTag": "sugarContent",
                                "total": 6.955772499999287,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars, added",
                                "tag": "SUGAR.added",
                                "schemaOrgTag": null,
                                "total": 0,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Protein",
                        "tag": "PROCNT",
                        "schemaOrgTag": "proteinContent",
                        "total": 140.13240749997198,
                        "hasRDI": true,
                        "daily": 280.26481499994395,
                        "unit": "g"
                    },
                    {
                        "label": "Cholesterol",
                        "tag": "CHOLE",
                        "schemaOrgTag": "cholesterolContent",
                        "total": 269.85,
                        "hasRDI": true,
                        "daily": 89.95000000000002,
                        "unit": "mg"
                    },
                    {
                        "label": "Sodium",
                        "tag": "NA",
                        "schemaOrgTag": "sodiumContent",
                        "total": 762.8029999999703,
                        "hasRDI": true,
                        "daily": 31.7834583333321,
                        "unit": "mg"
                    },
                    {
                        "label": "Calcium",
                        "tag": "CA",
                        "schemaOrgTag": null,
                        "total": 272.32749999995497,
                        "hasRDI": true,
                        "daily": 27.232749999995495,
                        "unit": "mg"
                    },
                    {
                        "label": "Magnesium",
                        "tag": "MG",
                        "schemaOrgTag": null,
                        "total": 396.8554999999338,
                        "hasRDI": true,
                        "daily": 94.489404761889,
                        "unit": "mg"
                    },
                    {
                        "label": "Potassium",
                        "tag": "K",
                        "schemaOrgTag": null,
                        "total": 5977.857249999709,
                        "hasRDI": true,
                        "daily": 127.18845212765338,
                        "unit": "mg"
                    },
                    {
                        "label": "Iron",
                        "tag": "FE",
                        "schemaOrgTag": null,
                        "total": 10.448082499995637,
                        "hasRDI": true,
                        "daily": 58.04490277775354,
                        "unit": "mg"
                    },
                    {
                        "label": "Zinc",
                        "tag": "ZN",
                        "schemaOrgTag": null,
                        "total": 5.374682499997988,
                        "hasRDI": true,
                        "daily": 48.86074999998171,
                        "unit": "mg"
                    },
                    {
                        "label": "Phosphorus",
                        "tag": "P",
                        "schemaOrgTag": null,
                        "total": 2086.161499999679,
                        "hasRDI": true,
                        "daily": 298.0230714285256,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin A",
                        "tag": "VITA_RAE",
                        "schemaOrgTag": null,
                        "total": 105.29225,
                        "hasRDI": true,
                        "daily": 11.69913888888889,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin C",
                        "tag": "VITC",
                        "schemaOrgTag": null,
                        "total": 170.299575,
                        "hasRDI": true,
                        "daily": 189.22175000000001,
                        "unit": "mg"
                    },
                    {
                        "label": "Thiamin (B1)",
                        "tag": "THIA",
                        "schemaOrgTag": null,
                        "total": 1.2006894999996829,
                        "hasRDI": true,
                        "daily": 100.05745833330691,
                        "unit": "mg"
                    },
                    {
                        "label": "Riboflavin (B2)",
                        "tag": "RIBF",
                        "schemaOrgTag": null,
                        "total": 0.7968024999998943,
                        "hasRDI": true,
                        "daily": 61.29249999999187,
                        "unit": "mg"
                    },
                    {
                        "label": "Niacin (B3)",
                        "tag": "NIA",
                        "schemaOrgTag": null,
                        "total": 53.2894774999967,
                        "hasRDI": true,
                        "daily": 333.0592343749794,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin B6",
                        "tag": "VITB6A",
                        "schemaOrgTag": null,
                        "total": 5.3134217499998835,
                        "hasRDI": true,
                        "daily": 408.72474999999105,
                        "unit": "mg"
                    },
                    {
                        "label": "Folate equivalent (total)",
                        "tag": "FOLDFE",
                        "schemaOrgTag": null,
                        "total": 207.15624999993128,
                        "hasRDI": true,
                        "daily": 51.78906249998282,
                        "unit": "µg"
                    },
                    {
                        "label": "Folate (food)",
                        "tag": "FOLFD",
                        "schemaOrgTag": null,
                        "total": 207.15624999993128,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Folic acid",
                        "tag": "FOLAC",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin B12",
                        "tag": "VITB12",
                        "schemaOrgTag": null,
                        "total": 9.19376,
                        "hasRDI": true,
                        "daily": 383.0733333333333,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin D",
                        "tag": "VITD",
                        "schemaOrgTag": null,
                        "total": 5.933999999999999,
                        "hasRDI": true,
                        "daily": 39.559999999999995,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin E",
                        "tag": "TOCPHA",
                        "schemaOrgTag": null,
                        "total": 57.37879499998235,
                        "hasRDI": true,
                        "daily": 382.5252999998823,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin K",
                        "tag": "VITK1",
                        "schemaOrgTag": null,
                        "total": 17.502699999999212,
                        "hasRDI": true,
                        "daily": 14.585583333332677,
                        "unit": "µg"
                    },
                    {
                        "label": "Sugar alcohols",
                        "tag": "Sugar.alcohol",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    },
                    {
                        "label": "Water",
                        "tag": "WATER",
                        "schemaOrgTag": null,
                        "total": 1270.4045499999463,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    }
                ]
            },
            "_links": {
                "self": {
                    "href": "https://api.edamam.com/api/recipes/v2/9b4b3972ae2d7ebcb88f37abfbb65a33?type=public&app_id=ea1d37d5&app_key=fd382a172ba8d6668c0430dc9c14a181",
                    "title": "Self"
                }
            }
        },
        {
            "recipe": {
                "uri": "http://www.edamam.com/ontologies/edamam.owl#recipe_d1e03cfc1c475f279d80ab26fdbdf778",
                "label": "Gefilte Fish",
                "image": "https://www.edamam.com/web-img/dff/dffce9a5278556e68789d3e6bff9eda9.jpg",
                "source": "Food52",
                "url": "https://food52.com/recipes/50619-gefilte-fish",
                "shareAs": "http://www.edamam.com/recipe/gefilte-fish-d1e03cfc1c475f279d80ab26fdbdf778/fish",
                "yield": 10,
                "dietLabels": [
                    "Low-Carb"
                ],
                "healthLabels": [
                    "Sugar-Conscious",
                    "Keto-Friendly",
                    "Dairy-Free",
                    "Peanut-Free",
                    "Tree-Nut-Free",
                    "Soy-Free",
                    "Shellfish-Free",
                    "Crustacean-Free",
                    "Mustard-Free",
                    "Sesame-Free",
                    "Lupine-Free",
                    "Mollusk-Free"
                ],
                "cautions": [
                    "Sulfites",
                    "FODMAP"
                ],
                "ingredientLines": [
                    "32 ounces fish stock",
                    "32 ounces water (substitute fish stock for water if your stock is homemade)",
                    "1 large carrot, diced",
                    "1 rib of celery, diced",
                    "8 sprigs fresh thyme",
                    "1 leek (trimmed, cleaned, and sliced into thin slivers)",
                    "1 cup dry white wine",
                    "4 sprigs tarragon",
                    "Olive oil",
                    "1/2 medium yellow onion, finely diced",
                    "1/3 cup matzo meal",
                    "1 cup reinforced fish stock",
                    "2 pounds fish, boneless and skinless fillets (see author’s note for details)",
                    "1/8 teaspoon white pepper",
                    "1/8 teaspoon cayenne",
                    "4 eggs, separated",
                    "3 teaspoons salt",
                    "2 teaspoons sugar"
                ],
                "ingredients": [
                    {
                        "text": "32 ounces fish stock",
                        "weight": 907.18474,
                        "foodCategory": "canned soup",
                        "foodId": "food_a00wj3maedk41kbwmbl4hb3s5gua",
                        "image": "https://www.edamam.com/food-img/e07/e07d7b7a8320da9f235be9d663b7a9f4.jpg"
                    },
                    {
                        "text": "32 ounces water (substitute fish stock for water if your stock is homemade)",
                        "weight": 907.18474,
                        "foodCategory": "canned soup",
                        "foodId": "food_a00wj3maedk41kbwmbl4hb3s5gua",
                        "image": "https://www.edamam.com/food-img/e07/e07d7b7a8320da9f235be9d663b7a9f4.jpg"
                    },
                    {
                        "text": "1 large carrot, diced",
                        "weight": 72,
                        "foodCategory": "vegetables",
                        "foodId": "food_ai215e5b85pdh5ajd4aafa3w2zm8",
                        "image": "https://www.edamam.com/food-img/121/121e33fce0bb9546ed7d060b6c114e29.jpg"
                    },
                    {
                        "text": "1 rib of celery, diced",
                        "weight": 40,
                        "foodCategory": "vegetables",
                        "foodId": "food_bffeoksbyyur8ja4da73ub2xs57g",
                        "image": "https://www.edamam.com/food-img/d91/d91d2aed1c36d8fad54c4d7dc58f5a18.jpg"
                    },
                    {
                        "text": "8 sprigs fresh thyme",
                        "weight": 24,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_b3o3cj7a5gskecb0ufphtadnbfqb",
                        "image": "https://www.edamam.com/food-img/3e7/3e7cf3c8d767a90b906447f5e74059f7.jpg"
                    },
                    {
                        "text": "1 leek (trimmed, cleaned, and sliced into thin slivers)",
                        "weight": 89,
                        "foodCategory": "vegetables",
                        "foodId": "food_a27jevnb06c1m9ax7k41xbbcwcuo",
                        "image": "https://www.edamam.com/food-img/4ae/4ae9e09d029a28e0e2c64bdfdbf3f6ae.jpg"
                    },
                    {
                        "text": "1 cup dry white wine",
                        "weight": 235.2,
                        "foodCategory": "wines",
                        "foodId": "food_a656mk2a5dmqb2adiamu6beihduu",
                        "image": "https://www.edamam.com/food-img/a71/a718cf3c52add522128929f1f324d2ab.jpg"
                    },
                    {
                        "text": "4 sprigs tarragon",
                        "weight": 7.2,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_bcae9pdaob9i69bo94oxramms336",
                        "image": "https://www.edamam.com/food-img/22f/22f8945d157d8b759c30e6738639991b.jpg"
                    },
                    {
                        "text": "Olive oil",
                        "weight": 50.241290725333336,
                        "foodCategory": "Oils",
                        "foodId": "food_b1d1icuad3iktrbqby0hiagafaz7",
                        "image": "https://www.edamam.com/food-img/4d6/4d651eaa8a353647746290c7a9b29d84.jpg"
                    },
                    {
                        "text": "1/2 medium yellow onion, finely diced",
                        "weight": 55,
                        "foodCategory": "vegetables",
                        "foodId": "food_bmrvi4ob4binw9a5m7l07amlfcoy",
                        "image": "https://www.edamam.com/food-img/205/205e6bf2399b85d34741892ef91cc603.jpg"
                    },
                    {
                        "text": "1/3 cup matzo meal",
                        "weight": 18.333333333333332,
                        "foodCategory": "crackers",
                        "foodId": "food_a7qwjpbarote7sbjmkrfiaovtoo3",
                        "image": "https://www.edamam.com/food-img/656/656d9f10022c99adde7b67b03b5b17b2.jpg"
                    },
                    {
                        "text": "1 cup reinforced fish stock",
                        "weight": 233,
                        "foodCategory": "canned soup",
                        "foodId": "food_a00wj3maedk41kbwmbl4hb3s5gua",
                        "image": "https://www.edamam.com/food-img/e07/e07d7b7a8320da9f235be9d663b7a9f4.jpg"
                    },
                    {
                        "text": "2 pounds fish, boneless and skinless fillets (see author’s note for details)",
                        "weight": 907.18474,
                        "foodCategory": "seafood",
                        "foodId": "food_ar6pjbvaxqtlqia7jewa4brld7p9",
                        "image": "https://www.edamam.com/food-img/717/717cb400eb49626bb7c95cd29292cef4.jpg"
                    },
                    {
                        "text": "1/8 teaspoon white pepper",
                        "weight": 0.3,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_a443px0bncpqa5avv80p3anrp26k",
                        "image": "https://www.edamam.com/food-img/4f0/4f0e35fe6c042996408b337fb550324a.jpg"
                    },
                    {
                        "text": "1/8 teaspoon cayenne",
                        "weight": 0.225,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_a8iooz3aris8gba605l07brngnrx",
                        "image": "https://www.edamam.com/food-img/374/3742b9434a0fb66a45e0dd6d227ba669.jpg"
                    },
                    {
                        "text": "4 eggs, separated",
                        "weight": 172,
                        "foodCategory": "Eggs",
                        "foodId": "food_bhpradua77pk16aipcvzeayg732r",
                        "image": "https://www.edamam.com/food-img/a7e/a7ec7c337cb47c6550b3b118e357f077.jpg"
                    },
                    {
                        "text": "3 teaspoons salt",
                        "weight": 18,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_btxz81db72hwbra2pncvebzzzum9",
                        "image": "https://www.edamam.com/food-img/694/6943ea510918c6025795e8dc6e6eaaeb.jpg"
                    },
                    {
                        "text": "2 teaspoons sugar",
                        "weight": 8.4,
                        "foodCategory": "sugars",
                        "foodId": "food_axi2ijobrk819yb0adceobnhm1c2",
                        "image": "https://www.edamam.com/food-img/ecb/ecb3f5aaed96d0188c21b8369be07765.jpg"
                    }
                ],
                "calories": 2345.651643878613,
                "totalWeight": 3738.4118555811065,
                "totalTime": 0,
                "cuisineType": [
                    "mediterranean"
                ],
                "mealType": [
                    "lunch/dinner"
                ],
                "dishType": [
                    "condiments and sauces"
                ],
                "totalNutrients": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 2345.651643878613,
                        "unit": "kcal"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 100.39348826,
                        "unit": "g"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 22.177526530087363,
                        "unit": "g"
                    },
                    "FATRN": {
                        "label": "Trans",
                        "quantity": 0.06536,
                        "unit": "g"
                    },
                    "FAMS": {
                        "label": "Monounsaturated",
                        "quantity": 52.41687593744379,
                        "unit": "g"
                    },
                    "FAPU": {
                        "label": "Polyunsaturated",
                        "quantity": 15.49035801162683,
                        "unit": "g"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 66.7301075,
                        "unit": "g"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 9.7756,
                        "unit": "g"
                    },
                    "SUGAR": {
                        "label": "Sugars",
                        "quantity": 21.10575166666667,
                        "unit": "g"
                    },
                    "SUGAR.added": {
                        "label": "Sugars, added",
                        "quantity": 8.3832,
                        "unit": "g"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 257.9520818733333,
                        "unit": "g"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 1113.9060648,
                        "unit": "mg"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 8665.793885281548,
                        "unit": "mg"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 560.7232274059721,
                        "unit": "mg"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 544.5746568485577,
                        "unit": "mg"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 7057.672853162382,
                        "unit": "mg"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 18.68893749141925,
                        "unit": "mg"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 8.009906008189107,
                        "unit": "mg"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 3219.016883466667,
                        "unit": "mg"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 1076.9396395999997,
                        "unit": "µg"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 64.54426948000001,
                        "unit": "mg"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 1.3641036718,
                        "unit": "mg"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 3.3217969410000006,
                        "unit": "mg"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 63.14370501833334,
                        "unit": "mg"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 3.323431819733334,
                        "unit": "mg"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 471.2668938666667,
                        "unit": "µg"
                    },
                    "FOLFD": {
                        "label": "Folate (food)",
                        "quantity": 471.2668938666667,
                        "unit": "µg"
                    },
                    "FOLAC": {
                        "label": "Folic acid",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 29.991168304000002,
                        "unit": "µg"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 31.562726940000005,
                        "unit": "µg"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 17.616009795085333,
                        "unit": "mg"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 107.91231837665067,
                        "unit": "µg"
                    },
                    "WATER": {
                        "label": "Water",
                        "quantity": 3263.032764528378,
                        "unit": "g"
                    }
                },
                "totalDaily": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 117.28258219393065,
                        "unit": "%"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 154.4515204,
                        "unit": "%"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 110.88763265043681,
                        "unit": "%"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 22.243369166666668,
                        "unit": "%"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 39.1024,
                        "unit": "%"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 515.9041637466667,
                        "unit": "%"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 371.3020216,
                        "unit": "%"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 361.07474522006453,
                        "unit": "%"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 56.072322740597215,
                        "unit": "%"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 129.6606325829899,
                        "unit": "%"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 150.1632521949443,
                        "unit": "%"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 103.82743050788471,
                        "unit": "%"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 72.8173273471737,
                        "unit": "%"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 459.8595547809524,
                        "unit": "%"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 119.65995995555554,
                        "unit": "%"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 71.7158549777778,
                        "unit": "%"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 113.67530598333332,
                        "unit": "%"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 255.52284161538466,
                        "unit": "%"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 394.6481563645834,
                        "unit": "%"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 255.64860151794875,
                        "unit": "%"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 117.81672346666669,
                        "unit": "%"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 1249.632012666667,
                        "unit": "%"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 210.4181796,
                        "unit": "%"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 117.44006530056889,
                        "unit": "%"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 89.92693198054222,
                        "unit": "%"
                    }
                },
                "digest": [
                    {
                        "label": "Fat",
                        "tag": "FAT",
                        "schemaOrgTag": "fatContent",
                        "total": 100.39348826,
                        "hasRDI": true,
                        "daily": 154.4515204,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Saturated",
                                "tag": "FASAT",
                                "schemaOrgTag": "saturatedFatContent",
                                "total": 22.177526530087363,
                                "hasRDI": true,
                                "daily": 110.88763265043681,
                                "unit": "g"
                            },
                            {
                                "label": "Trans",
                                "tag": "FATRN",
                                "schemaOrgTag": "transFatContent",
                                "total": 0.06536,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Monounsaturated",
                                "tag": "FAMS",
                                "schemaOrgTag": null,
                                "total": 52.41687593744379,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Polyunsaturated",
                                "tag": "FAPU",
                                "schemaOrgTag": null,
                                "total": 15.49035801162683,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Carbs",
                        "tag": "CHOCDF",
                        "schemaOrgTag": "carbohydrateContent",
                        "total": 66.7301075,
                        "hasRDI": true,
                        "daily": 22.243369166666668,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Carbs (net)",
                                "tag": "CHOCDF.net",
                                "schemaOrgTag": null,
                                "total": 56.954507500000005,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Fiber",
                                "tag": "FIBTG",
                                "schemaOrgTag": "fiberContent",
                                "total": 9.7756,
                                "hasRDI": true,
                                "daily": 39.1024,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars",
                                "tag": "SUGAR",
                                "schemaOrgTag": "sugarContent",
                                "total": 21.10575166666667,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars, added",
                                "tag": "SUGAR.added",
                                "schemaOrgTag": null,
                                "total": 8.3832,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Protein",
                        "tag": "PROCNT",
                        "schemaOrgTag": "proteinContent",
                        "total": 257.9520818733333,
                        "hasRDI": true,
                        "daily": 515.9041637466667,
                        "unit": "g"
                    },
                    {
                        "label": "Cholesterol",
                        "tag": "CHOLE",
                        "schemaOrgTag": "cholesterolContent",
                        "total": 1113.9060648,
                        "hasRDI": true,
                        "daily": 371.3020216,
                        "unit": "mg"
                    },
                    {
                        "label": "Sodium",
                        "tag": "NA",
                        "schemaOrgTag": "sodiumContent",
                        "total": 8665.793885281548,
                        "hasRDI": true,
                        "daily": 361.07474522006453,
                        "unit": "mg"
                    },
                    {
                        "label": "Calcium",
                        "tag": "CA",
                        "schemaOrgTag": null,
                        "total": 560.7232274059721,
                        "hasRDI": true,
                        "daily": 56.072322740597215,
                        "unit": "mg"
                    },
                    {
                        "label": "Magnesium",
                        "tag": "MG",
                        "schemaOrgTag": null,
                        "total": 544.5746568485577,
                        "hasRDI": true,
                        "daily": 129.6606325829899,
                        "unit": "mg"
                    },
                    {
                        "label": "Potassium",
                        "tag": "K",
                        "schemaOrgTag": null,
                        "total": 7057.672853162382,
                        "hasRDI": true,
                        "daily": 150.1632521949443,
                        "unit": "mg"
                    },
                    {
                        "label": "Iron",
                        "tag": "FE",
                        "schemaOrgTag": null,
                        "total": 18.68893749141925,
                        "hasRDI": true,
                        "daily": 103.82743050788471,
                        "unit": "mg"
                    },
                    {
                        "label": "Zinc",
                        "tag": "ZN",
                        "schemaOrgTag": null,
                        "total": 8.009906008189107,
                        "hasRDI": true,
                        "daily": 72.8173273471737,
                        "unit": "mg"
                    },
                    {
                        "label": "Phosphorus",
                        "tag": "P",
                        "schemaOrgTag": null,
                        "total": 3219.016883466667,
                        "hasRDI": true,
                        "daily": 459.8595547809524,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin A",
                        "tag": "VITA_RAE",
                        "schemaOrgTag": null,
                        "total": 1076.9396395999997,
                        "hasRDI": true,
                        "daily": 119.65995995555554,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin C",
                        "tag": "VITC",
                        "schemaOrgTag": null,
                        "total": 64.54426948000001,
                        "hasRDI": true,
                        "daily": 71.7158549777778,
                        "unit": "mg"
                    },
                    {
                        "label": "Thiamin (B1)",
                        "tag": "THIA",
                        "schemaOrgTag": null,
                        "total": 1.3641036718,
                        "hasRDI": true,
                        "daily": 113.67530598333332,
                        "unit": "mg"
                    },
                    {
                        "label": "Riboflavin (B2)",
                        "tag": "RIBF",
                        "schemaOrgTag": null,
                        "total": 3.3217969410000006,
                        "hasRDI": true,
                        "daily": 255.52284161538466,
                        "unit": "mg"
                    },
                    {
                        "label": "Niacin (B3)",
                        "tag": "NIA",
                        "schemaOrgTag": null,
                        "total": 63.14370501833334,
                        "hasRDI": true,
                        "daily": 394.6481563645834,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin B6",
                        "tag": "VITB6A",
                        "schemaOrgTag": null,
                        "total": 3.323431819733334,
                        "hasRDI": true,
                        "daily": 255.64860151794875,
                        "unit": "mg"
                    },
                    {
                        "label": "Folate equivalent (total)",
                        "tag": "FOLDFE",
                        "schemaOrgTag": null,
                        "total": 471.2668938666667,
                        "hasRDI": true,
                        "daily": 117.81672346666669,
                        "unit": "µg"
                    },
                    {
                        "label": "Folate (food)",
                        "tag": "FOLFD",
                        "schemaOrgTag": null,
                        "total": 471.2668938666667,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Folic acid",
                        "tag": "FOLAC",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin B12",
                        "tag": "VITB12",
                        "schemaOrgTag": null,
                        "total": 29.991168304000002,
                        "hasRDI": true,
                        "daily": 1249.632012666667,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin D",
                        "tag": "VITD",
                        "schemaOrgTag": null,
                        "total": 31.562726940000005,
                        "hasRDI": true,
                        "daily": 210.4181796,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin E",
                        "tag": "TOCPHA",
                        "schemaOrgTag": null,
                        "total": 17.616009795085333,
                        "hasRDI": true,
                        "daily": 117.44006530056889,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin K",
                        "tag": "VITK1",
                        "schemaOrgTag": null,
                        "total": 107.91231837665067,
                        "hasRDI": true,
                        "daily": 89.92693198054222,
                        "unit": "µg"
                    },
                    {
                        "label": "Sugar alcohols",
                        "tag": "Sugar.alcohol",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    },
                    {
                        "label": "Water",
                        "tag": "WATER",
                        "schemaOrgTag": null,
                        "total": 3263.032764528378,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    }
                ]
            },
            "_links": {
                "self": {
                    "href": "https://api.edamam.com/api/recipes/v2/d1e03cfc1c475f279d80ab26fdbdf778?type=public&app_id=ea1d37d5&app_key=fd382a172ba8d6668c0430dc9c14a181",
                    "title": "Self"
                }
            }
        },
        {
            "recipe": {
                "uri": "http://www.edamam.com/ontologies/edamam.owl#recipe_be2008ebd11bd56881e4bb78c5b45a35",
                "label": "Fish pie mac ’n’ cheese",
                "image": "https://www.edamam.com/web-img/ba7/ba7ac47c592c7562cbf64ba833b12878.jpg",
                "source": "BBC Good Food",
                "url": "https://www.bbcgoodfood.com/recipes/fish-pie-mac-n-cheese",
                "shareAs": "http://www.edamam.com/recipe/fish-pie-mac-n-cheese-be2008ebd11bd56881e4bb78c5b45a35/fish",
                "yield": 6,
                "dietLabels": [],
                "healthLabels": [
                    "Pescatarian",
                    "Egg-Free",
                    "Peanut-Free",
                    "Tree-Nut-Free",
                    "Soy-Free",
                    "Shellfish-Free",
                    "Pork-Free",
                    "Red-Meat-Free",
                    "Crustacean-Free",
                    "Celery-Free",
                    "Sesame-Free",
                    "Lupine-Free",
                    "Mollusk-Free",
                    "Alcohol-Free",
                    "Sulfite-Free"
                ],
                "cautions": [
                    "Sulfites"
                ],
                "ingredientLines": [
                    "650ml milk",
                    "40g plain flour",
                    "40g butter",
                    "2 tsp Dijon mustard",
                    "150g mature cheddar , grated",
                    "180g frozen peas",
                    "handful of parsley , chopped",
                    "300g macaroni",
                    "300g fish pie mix (smoked fish, white fish and salmon)",
                    "green salad , to serve (optional)"
                ],
                "ingredients": [
                    {
                        "text": "650ml milk",
                        "weight": 670.3630000640374,
                        "foodCategory": "Milk",
                        "foodId": "food_b49rs1kaw0jktabzkg2vvanvvsis",
                        "image": "https://www.edamam.com/food-img/7c9/7c9962acf83654a8d98ea6a2ade93735.jpg"
                    },
                    {
                        "text": "40g plain flour",
                        "weight": 40,
                        "foodCategory": "grains",
                        "foodId": "food_ahebfs0a985an4aubqaebbipra58",
                        "image": "https://www.edamam.com/food-img/b4c/b4c739e76a6f2172b7ad49d0aa41d5aa.jpg"
                    },
                    {
                        "text": "40g butter",
                        "weight": 40,
                        "foodCategory": "Dairy",
                        "foodId": "food_awz3iefajbk1fwahq9logahmgltj",
                        "image": "https://www.edamam.com/food-img/713/71397239b670d88c04faa8d05035cab4.jpg"
                    },
                    {
                        "text": "2 tsp Dijon mustard",
                        "weight": 10,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_a34cdj5b0kyuhfbov30xcb50u4dv",
                        "image": "https://www.edamam.com/food-img/e23/e238f2e4cfa6aa1a30f46dc73e7344eb.jpg"
                    },
                    {
                        "text": "150g mature cheddar , grated",
                        "weight": 150,
                        "foodCategory": "Cheese",
                        "foodId": "food_bhppgmha1u27voagb8eptbp9g376",
                        "image": "https://www.edamam.com/food-img/bcd/bcd94dde1fcde1475b5bf0540f821c5d.jpg"
                    },
                    {
                        "text": "180g frozen peas",
                        "weight": 180,
                        "foodCategory": "vegetables",
                        "foodId": "food_aqrct01b4nxw5eaxoo8woaxc3xd7",
                        "image": "https://www.edamam.com/food-img/c91/c9130a361d5c5b279bf48c69e2466ec2.jpg"
                    },
                    {
                        "text": "handful of parsley , chopped",
                        "weight": 7.5,
                        "foodCategory": "vegetables",
                        "foodId": "food_b244pqdazw24zobr5vqu2bf0uid8",
                        "image": "https://www.edamam.com/food-img/46a/46a132e96626d7989b4d6ed8c91f4da0.jpg"
                    },
                    {
                        "text": "300g macaroni",
                        "weight": 300,
                        "foodCategory": "grains",
                        "foodId": "food_a8hs60uayl5icia1qe8qoba1kwp8",
                        "image": "https://www.edamam.com/food-img/296/296ff2b02ef3822928c3c923e22c7d19.jpg"
                    },
                    {
                        "text": "300g fish pie mix (smoked fish, white fish and salmon)",
                        "weight": 160,
                        "foodCategory": "seafood",
                        "foodId": "food_ar6pjbvaxqtlqia7jewa4brld7p9",
                        "image": "https://www.edamam.com/food-img/717/717cb400eb49626bb7c95cd29292cef4.jpg"
                    },
                    {
                        "text": "300g fish pie mix (smoked fish, white fish and salmon)",
                        "weight": 0,
                        "foodCategory": "seafood",
                        "foodId": "food_bhncugnadgibupafbeeapbislbom",
                        "image": "https://www.edamam.com/food-img/9a0/9a0f38422e9f21dcedbc2dca0d8209ac.jpg"
                    },
                    {
                        "text": "green salad , to serve (optional)",
                        "weight": 0,
                        "foodCategory": "vegetables",
                        "foodId": "food_bqalyxzbzu04hcb8xj930bzar7xg",
                        "image": "https://www.edamam.com/food-img/b6d/b6d9f3052d27a3c71220cfa55c6f0a42.jpg"
                    }
                ],
                "calories": 2864.221430039063,
                "totalWeight": 1557.8630000640374,
                "totalTime": 50,
                "cuisineType": [
                    "american"
                ],
                "mealType": [
                    "lunch/dinner"
                ],
                "dishType": [
                    "desserts"
                ],
                "totalNutrients": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 2864.221430039063,
                        "unit": "kcal"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 113.71604750208122,
                        "unit": "g"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 64.0805699511943,
                        "unit": "g"
                    },
                    "FATRN": {
                        "label": "Trans",
                        "quantity": 3.0806,
                        "unit": "g"
                    },
                    "FAMS": {
                        "label": "Monounsaturated",
                        "quantity": 28.138072560519987,
                        "unit": "g"
                    },
                    "FAPU": {
                        "label": "Polyunsaturated",
                        "quantity": 7.513607850124872,
                        "unit": "g"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 314.30417400307374,
                        "unit": "g"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 19.427500000000002,
                        "unit": "g"
                    },
                    "SUGAR": {
                        "label": "Sugars",
                        "quantity": 51.57108150323388,
                        "unit": "g"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 142.8891845020172,
                        "unit": "g"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 386.03630000640374,
                        "unit": "mg"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 1669.6560900275363,
                        "unit": "mg"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 1920.860190072362,
                        "unit": "mg"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 374.6863000064037,
                        "unit": "mg"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 2535.629160084529,
                        "unit": "mg"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 9.093108900019212,
                        "unit": "mg"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 14.319593100236938,
                        "unit": "mg"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 2327.154920053791,
                        "unit": "mg"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 1193.9419800294572,
                        "unit": "µg"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 42.405,
                        "unit": "mg"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 1.224816980029457,
                        "unit": "mg"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 2.2886634701082236,
                        "unit": "mg"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 15.773098070056992,
                        "unit": "mg"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 1.1819806800230535,
                        "unit": "mg"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 284.01815000320187,
                        "unit": "µg"
                    },
                    "FOLFD": {
                        "label": "Folate (food)",
                        "quantity": 284.01815000320187,
                        "unit": "µg"
                    },
                    "FOLAC": {
                        "label": "Folic acid",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 6.932633500288169,
                        "unit": "µg"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 15.174719000832487,
                        "unit": "µg"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 3.6895041000448265,
                        "unit": "mg"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 185.18108900019212,
                        "unit": "µg"
                    },
                    "WATER": {
                        "label": "Water",
                        "quantity": 971.9271619564362,
                        "unit": "g"
                    }
                },
                "totalDaily": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 143.21107150195314,
                        "unit": "%"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 174.94776538781727,
                        "unit": "%"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 320.4028497559715,
                        "unit": "%"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 104.76805800102458,
                        "unit": "%"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 77.71000000000001,
                        "unit": "%"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 285.7783690040344,
                        "unit": "%"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 128.67876666880125,
                        "unit": "%"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 69.56900375114735,
                        "unit": "%"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 192.0860190072362,
                        "unit": "%"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 89.21102381104849,
                        "unit": "%"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 53.949556597543165,
                        "unit": "%"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 50.5172716667734,
                        "unit": "%"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 130.1781190930631,
                        "unit": "%"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 332.4507028648273,
                        "unit": "%"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 132.66022000327303,
                        "unit": "%"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 47.11666666666667,
                        "unit": "%"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 102.06808166912143,
                        "unit": "%"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 176.05103616217104,
                        "unit": "%"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 98.5818629378562,
                        "unit": "%"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 90.9215907710041,
                        "unit": "%"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 71.00453750080047,
                        "unit": "%"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 288.8597291786737,
                        "unit": "%"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 101.16479333888326,
                        "unit": "%"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 24.596694000298843,
                        "unit": "%"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 154.31757416682677,
                        "unit": "%"
                    }
                },
                "digest": [
                    {
                        "label": "Fat",
                        "tag": "FAT",
                        "schemaOrgTag": "fatContent",
                        "total": 113.71604750208122,
                        "hasRDI": true,
                        "daily": 174.94776538781727,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Saturated",
                                "tag": "FASAT",
                                "schemaOrgTag": "saturatedFatContent",
                                "total": 64.0805699511943,
                                "hasRDI": true,
                                "daily": 320.4028497559715,
                                "unit": "g"
                            },
                            {
                                "label": "Trans",
                                "tag": "FATRN",
                                "schemaOrgTag": "transFatContent",
                                "total": 3.0806,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Monounsaturated",
                                "tag": "FAMS",
                                "schemaOrgTag": null,
                                "total": 28.138072560519987,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Polyunsaturated",
                                "tag": "FAPU",
                                "schemaOrgTag": null,
                                "total": 7.513607850124872,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Carbs",
                        "tag": "CHOCDF",
                        "schemaOrgTag": "carbohydrateContent",
                        "total": 314.30417400307374,
                        "hasRDI": true,
                        "daily": 104.76805800102458,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Carbs (net)",
                                "tag": "CHOCDF.net",
                                "schemaOrgTag": null,
                                "total": 294.87667400307373,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Fiber",
                                "tag": "FIBTG",
                                "schemaOrgTag": "fiberContent",
                                "total": 19.427500000000002,
                                "hasRDI": true,
                                "daily": 77.71000000000001,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars",
                                "tag": "SUGAR",
                                "schemaOrgTag": "sugarContent",
                                "total": 51.57108150323388,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars, added",
                                "tag": "SUGAR.added",
                                "schemaOrgTag": null,
                                "total": 0,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Protein",
                        "tag": "PROCNT",
                        "schemaOrgTag": "proteinContent",
                        "total": 142.8891845020172,
                        "hasRDI": true,
                        "daily": 285.7783690040344,
                        "unit": "g"
                    },
                    {
                        "label": "Cholesterol",
                        "tag": "CHOLE",
                        "schemaOrgTag": "cholesterolContent",
                        "total": 386.03630000640374,
                        "hasRDI": true,
                        "daily": 128.67876666880125,
                        "unit": "mg"
                    },
                    {
                        "label": "Sodium",
                        "tag": "NA",
                        "schemaOrgTag": "sodiumContent",
                        "total": 1669.6560900275363,
                        "hasRDI": true,
                        "daily": 69.56900375114735,
                        "unit": "mg"
                    },
                    {
                        "label": "Calcium",
                        "tag": "CA",
                        "schemaOrgTag": null,
                        "total": 1920.860190072362,
                        "hasRDI": true,
                        "daily": 192.0860190072362,
                        "unit": "mg"
                    },
                    {
                        "label": "Magnesium",
                        "tag": "MG",
                        "schemaOrgTag": null,
                        "total": 374.6863000064037,
                        "hasRDI": true,
                        "daily": 89.21102381104849,
                        "unit": "mg"
                    },
                    {
                        "label": "Potassium",
                        "tag": "K",
                        "schemaOrgTag": null,
                        "total": 2535.629160084529,
                        "hasRDI": true,
                        "daily": 53.949556597543165,
                        "unit": "mg"
                    },
                    {
                        "label": "Iron",
                        "tag": "FE",
                        "schemaOrgTag": null,
                        "total": 9.093108900019212,
                        "hasRDI": true,
                        "daily": 50.5172716667734,
                        "unit": "mg"
                    },
                    {
                        "label": "Zinc",
                        "tag": "ZN",
                        "schemaOrgTag": null,
                        "total": 14.319593100236938,
                        "hasRDI": true,
                        "daily": 130.1781190930631,
                        "unit": "mg"
                    },
                    {
                        "label": "Phosphorus",
                        "tag": "P",
                        "schemaOrgTag": null,
                        "total": 2327.154920053791,
                        "hasRDI": true,
                        "daily": 332.4507028648273,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin A",
                        "tag": "VITA_RAE",
                        "schemaOrgTag": null,
                        "total": 1193.9419800294572,
                        "hasRDI": true,
                        "daily": 132.66022000327303,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin C",
                        "tag": "VITC",
                        "schemaOrgTag": null,
                        "total": 42.405,
                        "hasRDI": true,
                        "daily": 47.11666666666667,
                        "unit": "mg"
                    },
                    {
                        "label": "Thiamin (B1)",
                        "tag": "THIA",
                        "schemaOrgTag": null,
                        "total": 1.224816980029457,
                        "hasRDI": true,
                        "daily": 102.06808166912143,
                        "unit": "mg"
                    },
                    {
                        "label": "Riboflavin (B2)",
                        "tag": "RIBF",
                        "schemaOrgTag": null,
                        "total": 2.2886634701082236,
                        "hasRDI": true,
                        "daily": 176.05103616217104,
                        "unit": "mg"
                    },
                    {
                        "label": "Niacin (B3)",
                        "tag": "NIA",
                        "schemaOrgTag": null,
                        "total": 15.773098070056992,
                        "hasRDI": true,
                        "daily": 98.5818629378562,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin B6",
                        "tag": "VITB6A",
                        "schemaOrgTag": null,
                        "total": 1.1819806800230535,
                        "hasRDI": true,
                        "daily": 90.9215907710041,
                        "unit": "mg"
                    },
                    {
                        "label": "Folate equivalent (total)",
                        "tag": "FOLDFE",
                        "schemaOrgTag": null,
                        "total": 284.01815000320187,
                        "hasRDI": true,
                        "daily": 71.00453750080047,
                        "unit": "µg"
                    },
                    {
                        "label": "Folate (food)",
                        "tag": "FOLFD",
                        "schemaOrgTag": null,
                        "total": 284.01815000320187,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Folic acid",
                        "tag": "FOLAC",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin B12",
                        "tag": "VITB12",
                        "schemaOrgTag": null,
                        "total": 6.932633500288169,
                        "hasRDI": true,
                        "daily": 288.8597291786737,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin D",
                        "tag": "VITD",
                        "schemaOrgTag": null,
                        "total": 15.174719000832487,
                        "hasRDI": true,
                        "daily": 101.16479333888326,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin E",
                        "tag": "TOCPHA",
                        "schemaOrgTag": null,
                        "total": 3.6895041000448265,
                        "hasRDI": true,
                        "daily": 24.596694000298843,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin K",
                        "tag": "VITK1",
                        "schemaOrgTag": null,
                        "total": 185.18108900019212,
                        "hasRDI": true,
                        "daily": 154.31757416682677,
                        "unit": "µg"
                    },
                    {
                        "label": "Sugar alcohols",
                        "tag": "Sugar.alcohol",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    },
                    {
                        "label": "Water",
                        "tag": "WATER",
                        "schemaOrgTag": null,
                        "total": 971.9271619564362,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    }
                ]
            },
            "_links": {
                "self": {
                    "href": "https://api.edamam.com/api/recipes/v2/be2008ebd11bd56881e4bb78c5b45a35?type=public&app_id=ea1d37d5&app_key=fd382a172ba8d6668c0430dc9c14a181",
                    "title": "Self"
                }
            }
        },
        {
            "recipe": {
                "uri": "http://www.edamam.com/ontologies/edamam.owl#recipe_d4287fe5a333f3d32e29a77a085a1492",
                "label": "Portuguese Fish Stew recipes",
                "image": "https://www.edamam.com/web-img/8c3/8c3fa76434ed247063fcb73cedb9688d",
                "source": "Food Republic",
                "url": "http://www.foodrepublic.com/recipes/portuguese-fish-stew/",
                "shareAs": "http://www.edamam.com/recipe/portuguese-fish-stew-recipes-d4287fe5a333f3d32e29a77a085a1492/fish",
                "yield": 6,
                "dietLabels": [],
                "healthLabels": [
                    "Sugar-Conscious",
                    "Dairy-Free",
                    "Gluten-Free",
                    "Wheat-Free",
                    "Egg-Free",
                    "Peanut-Free",
                    "Tree-Nut-Free",
                    "Soy-Free",
                    "Shellfish-Free",
                    "Crustacean-Free",
                    "Celery-Free",
                    "Mustard-Free",
                    "Sesame-Free",
                    "Lupine-Free",
                    "Mollusk-Free"
                ],
                "cautions": [
                    "Sulfites"
                ],
                "ingredientLines": [
                    "3 ripe plum tomatoes",
                    "7 ounces Savoy cabbage, outer leaves removed",
                    "2 tablespoons extra virgin olive oil",
                    "7 ounces chorizo sausage (cooked or uncooked), skinned, and cut into chunks",
                    "2 pounds new potatoes, peeled and cut into 1/2 inch dice",
                    "1/2 cup white wine",
                    "6 cups fish stock",
                    "2 pounds mixed white fish fillets, skinned and cut into 1-inch pieces",
                    "extra-virgin olive oil",
                    "chopped cilantro"
                ],
                "ingredients": [
                    {
                        "text": "3 ripe plum tomatoes",
                        "weight": 186,
                        "foodCategory": "vegetables",
                        "foodId": "food_ab8jymba5i5xv3apgymg7a90bxb5",
                        "image": "https://www.edamam.com/food-img/23e/23e727a14f1035bdc2733bb0477efbd2.jpg"
                    },
                    {
                        "text": "7 ounces Savoy cabbage, outer leaves removed",
                        "weight": 198.44666187500002,
                        "foodCategory": "vegetables",
                        "foodId": "food_aqdc0pjbbr7wddbvgrka4bihwsm7",
                        "image": "https://www.edamam.com/food-img/29b/29bb6909e03f31b43bf7417e74e7981a.jpg"
                    },
                    {
                        "text": "2 tablespoons extra virgin olive oil",
                        "weight": 27,
                        "foodCategory": "Oils",
                        "foodId": "food_b1d1icuad3iktrbqby0hiagafaz7",
                        "image": "https://www.edamam.com/food-img/4d6/4d651eaa8a353647746290c7a9b29d84.jpg"
                    },
                    {
                        "text": "7 ounces chorizo sausage (cooked or uncooked), skinned, and cut into chunks",
                        "weight": 198.44666187500002,
                        "foodCategory": "Cured meats",
                        "foodId": "food_a011ctbbqlxv1ebqtemvla9v6mpa",
                        "image": "https://www.edamam.com/food-img/c01/c0139ae7ad8a0334a23365b6284a5819.jpg"
                    },
                    {
                        "text": "2 pounds new potatoes, peeled and cut into 1/2 inch dice",
                        "weight": 907.18474,
                        "foodCategory": "vegetables",
                        "foodId": "food_b5m473aabh39qbbre3ypaa4uwd7j",
                        "image": "https://www.edamam.com/food-img/651/6512e82417bce15c2899630c1a2799df.jpg"
                    },
                    {
                        "text": "1/2 cup white wine",
                        "weight": 117.6,
                        "foodCategory": "wines",
                        "foodId": "food_bn44h7baron9ufaoxinmya8l0yye",
                        "image": "https://www.edamam.com/food-img/a71/a718cf3c52add522128929f1f324d2ab.jpg"
                    },
                    {
                        "text": "6 cups fish stock",
                        "weight": 1398,
                        "foodCategory": "canned soup",
                        "foodId": "food_a00wj3maedk41kbwmbl4hb3s5gua",
                        "image": "https://www.edamam.com/food-img/e07/e07d7b7a8320da9f235be9d663b7a9f4.jpg"
                    },
                    {
                        "text": "2 pounds mixed white fish fillets, skinned and cut into 1-inch pieces",
                        "weight": 907.18474,
                        "foodCategory": "seafood",
                        "foodId": "food_ar6pjbvaxqtlqia7jewa4brld7p9",
                        "image": "https://www.edamam.com/food-img/717/717cb400eb49626bb7c95cd29292cef4.jpg"
                    },
                    {
                        "text": "extra-virgin olive oil",
                        "weight": 53.582134131000004,
                        "foodCategory": "Oils",
                        "foodId": "food_b1d1icuad3iktrbqby0hiagafaz7",
                        "image": "https://www.edamam.com/food-img/4d6/4d651eaa8a353647746290c7a9b29d84.jpg"
                    },
                    {
                        "text": "chopped cilantro",
                        "weight": 39.3986280375,
                        "foodCategory": "vegetables",
                        "foodId": "food_alhzhuwb4lc7jnb5s6f02by60bzp",
                        "image": "https://www.edamam.com/food-img/d57/d57e375b6ff99a90c7ee2b1990a1af36.jpg"
                    }
                ],
                "calories": 3600.9422606041653,
                "totalWeight": 4032.8435659185006,
                "totalTime": 60,
                "cuisineType": [
                    "mediterranean"
                ],
                "mealType": [
                    "lunch/dinner"
                ],
                "dishType": [
                    "main course"
                ],
                "totalNutrients": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 3600.9422606041653,
                        "unit": "kcal"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 184.86539800423253,
                        "unit": "g"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 48.12764369380248,
                        "unit": "g"
                    },
                    "FAMS": {
                        "label": "Monounsaturated",
                        "quantity": 103.32281786175331,
                        "unit": "g"
                    },
                    "FAPU": {
                        "label": "Polyunsaturated",
                        "quantity": 21.225700835413882,
                        "unit": "g"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 186.02045801222627,
                        "unit": "g"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 29.445072383175006,
                        "unit": "g"
                    },
                    "SUGAR": {
                        "label": "Sugars",
                        "quantity": 17.944308260488754,
                        "unit": "g"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 286.43551706657377,
                        "unit": "g"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 642.2054324500001,
                        "unit": "mg"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 5248.343500261121,
                        "unit": "mg"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 383.239609532685,
                        "unit": "mg"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 685.2014777522502,
                        "unit": "mg"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 10548.699380191687,
                        "unit": "mg"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 18.213499754709854,
                        "unit": "mg"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 14.420495685187504,
                        "unit": "mg"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 3307.9262920580004,
                        "unit": "mg"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 338.07670742387506,
                        "unit": "µg"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 277.75148853137506,
                        "unit": "mg"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 3.049257249310125,
                        "unit": "mg"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 2.6959852646082503,
                        "unit": "mg"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 73.99781448456902,
                        "unit": "mg"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 6.358214183075876,
                        "unit": "mg"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 607.0633081207501,
                        "unit": "µg"
                    },
                    "FOLFD": {
                        "label": "Folate (food)",
                        "quantity": 607.0633081207501,
                        "unit": "µg"
                    },
                    "FOLAC": {
                        "label": "Folic acid",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 27.948652129500005,
                        "unit": "µg"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 31.099426868125004,
                        "unit": "µg"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 20.422901364048503,
                        "unit": "mg"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 355.45413804311204,
                        "unit": "µg"
                    },
                    "WATER": {
                        "label": "Water",
                        "quantity": 3336.6339767348168,
                        "unit": "g"
                    }
                },
                "totalDaily": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 180.04711303020827,
                        "unit": "%"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 284.4083046218962,
                        "unit": "%"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 240.63821846901243,
                        "unit": "%"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 62.00681933740876,
                        "unit": "%"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 117.78028953270002,
                        "unit": "%"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 572.8710341331475,
                        "unit": "%"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 214.06847748333337,
                        "unit": "%"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 218.68097917754673,
                        "unit": "%"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 38.3239609532685,
                        "unit": "%"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 163.14320898863102,
                        "unit": "%"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 224.440412344504,
                        "unit": "%"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 101.18610974838808,
                        "unit": "%"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 131.0954153198864,
                        "unit": "%"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 472.5608988654286,
                        "unit": "%"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 37.564078602652785,
                        "unit": "%"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 308.6127650348612,
                        "unit": "%"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 254.10477077584375,
                        "unit": "%"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 207.38348189294234,
                        "unit": "%"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 462.48634052855635,
                        "unit": "%"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 489.09339869814426,
                        "unit": "%"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 151.76582703018752,
                        "unit": "%"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 1164.5271720625003,
                        "unit": "%"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 207.32951245416672,
                        "unit": "%"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 136.15267576032335,
                        "unit": "%"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 296.2117817025934,
                        "unit": "%"
                    }
                },
                "digest": [
                    {
                        "label": "Fat",
                        "tag": "FAT",
                        "schemaOrgTag": "fatContent",
                        "total": 184.86539800423253,
                        "hasRDI": true,
                        "daily": 284.4083046218962,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Saturated",
                                "tag": "FASAT",
                                "schemaOrgTag": "saturatedFatContent",
                                "total": 48.12764369380248,
                                "hasRDI": true,
                                "daily": 240.63821846901243,
                                "unit": "g"
                            },
                            {
                                "label": "Trans",
                                "tag": "FATRN",
                                "schemaOrgTag": "transFatContent",
                                "total": 0,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Monounsaturated",
                                "tag": "FAMS",
                                "schemaOrgTag": null,
                                "total": 103.32281786175331,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Polyunsaturated",
                                "tag": "FAPU",
                                "schemaOrgTag": null,
                                "total": 21.225700835413882,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Carbs",
                        "tag": "CHOCDF",
                        "schemaOrgTag": "carbohydrateContent",
                        "total": 186.02045801222627,
                        "hasRDI": true,
                        "daily": 62.00681933740876,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Carbs (net)",
                                "tag": "CHOCDF.net",
                                "schemaOrgTag": null,
                                "total": 156.57538562905125,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Fiber",
                                "tag": "FIBTG",
                                "schemaOrgTag": "fiberContent",
                                "total": 29.445072383175006,
                                "hasRDI": true,
                                "daily": 117.78028953270002,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars",
                                "tag": "SUGAR",
                                "schemaOrgTag": "sugarContent",
                                "total": 17.944308260488754,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars, added",
                                "tag": "SUGAR.added",
                                "schemaOrgTag": null,
                                "total": 0,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Protein",
                        "tag": "PROCNT",
                        "schemaOrgTag": "proteinContent",
                        "total": 286.43551706657377,
                        "hasRDI": true,
                        "daily": 572.8710341331475,
                        "unit": "g"
                    },
                    {
                        "label": "Cholesterol",
                        "tag": "CHOLE",
                        "schemaOrgTag": "cholesterolContent",
                        "total": 642.2054324500001,
                        "hasRDI": true,
                        "daily": 214.06847748333337,
                        "unit": "mg"
                    },
                    {
                        "label": "Sodium",
                        "tag": "NA",
                        "schemaOrgTag": "sodiumContent",
                        "total": 5248.343500261121,
                        "hasRDI": true,
                        "daily": 218.68097917754673,
                        "unit": "mg"
                    },
                    {
                        "label": "Calcium",
                        "tag": "CA",
                        "schemaOrgTag": null,
                        "total": 383.239609532685,
                        "hasRDI": true,
                        "daily": 38.3239609532685,
                        "unit": "mg"
                    },
                    {
                        "label": "Magnesium",
                        "tag": "MG",
                        "schemaOrgTag": null,
                        "total": 685.2014777522502,
                        "hasRDI": true,
                        "daily": 163.14320898863102,
                        "unit": "mg"
                    },
                    {
                        "label": "Potassium",
                        "tag": "K",
                        "schemaOrgTag": null,
                        "total": 10548.699380191687,
                        "hasRDI": true,
                        "daily": 224.440412344504,
                        "unit": "mg"
                    },
                    {
                        "label": "Iron",
                        "tag": "FE",
                        "schemaOrgTag": null,
                        "total": 18.213499754709854,
                        "hasRDI": true,
                        "daily": 101.18610974838808,
                        "unit": "mg"
                    },
                    {
                        "label": "Zinc",
                        "tag": "ZN",
                        "schemaOrgTag": null,
                        "total": 14.420495685187504,
                        "hasRDI": true,
                        "daily": 131.0954153198864,
                        "unit": "mg"
                    },
                    {
                        "label": "Phosphorus",
                        "tag": "P",
                        "schemaOrgTag": null,
                        "total": 3307.9262920580004,
                        "hasRDI": true,
                        "daily": 472.5608988654286,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin A",
                        "tag": "VITA_RAE",
                        "schemaOrgTag": null,
                        "total": 338.07670742387506,
                        "hasRDI": true,
                        "daily": 37.564078602652785,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin C",
                        "tag": "VITC",
                        "schemaOrgTag": null,
                        "total": 277.75148853137506,
                        "hasRDI": true,
                        "daily": 308.6127650348612,
                        "unit": "mg"
                    },
                    {
                        "label": "Thiamin (B1)",
                        "tag": "THIA",
                        "schemaOrgTag": null,
                        "total": 3.049257249310125,
                        "hasRDI": true,
                        "daily": 254.10477077584375,
                        "unit": "mg"
                    },
                    {
                        "label": "Riboflavin (B2)",
                        "tag": "RIBF",
                        "schemaOrgTag": null,
                        "total": 2.6959852646082503,
                        "hasRDI": true,
                        "daily": 207.38348189294234,
                        "unit": "mg"
                    },
                    {
                        "label": "Niacin (B3)",
                        "tag": "NIA",
                        "schemaOrgTag": null,
                        "total": 73.99781448456902,
                        "hasRDI": true,
                        "daily": 462.48634052855635,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin B6",
                        "tag": "VITB6A",
                        "schemaOrgTag": null,
                        "total": 6.358214183075876,
                        "hasRDI": true,
                        "daily": 489.09339869814426,
                        "unit": "mg"
                    },
                    {
                        "label": "Folate equivalent (total)",
                        "tag": "FOLDFE",
                        "schemaOrgTag": null,
                        "total": 607.0633081207501,
                        "hasRDI": true,
                        "daily": 151.76582703018752,
                        "unit": "µg"
                    },
                    {
                        "label": "Folate (food)",
                        "tag": "FOLFD",
                        "schemaOrgTag": null,
                        "total": 607.0633081207501,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Folic acid",
                        "tag": "FOLAC",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin B12",
                        "tag": "VITB12",
                        "schemaOrgTag": null,
                        "total": 27.948652129500005,
                        "hasRDI": true,
                        "daily": 1164.5271720625003,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin D",
                        "tag": "VITD",
                        "schemaOrgTag": null,
                        "total": 31.099426868125004,
                        "hasRDI": true,
                        "daily": 207.32951245416672,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin E",
                        "tag": "TOCPHA",
                        "schemaOrgTag": null,
                        "total": 20.422901364048503,
                        "hasRDI": true,
                        "daily": 136.15267576032335,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin K",
                        "tag": "VITK1",
                        "schemaOrgTag": null,
                        "total": 355.45413804311204,
                        "hasRDI": true,
                        "daily": 296.2117817025934,
                        "unit": "µg"
                    },
                    {
                        "label": "Sugar alcohols",
                        "tag": "Sugar.alcohol",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    },
                    {
                        "label": "Water",
                        "tag": "WATER",
                        "schemaOrgTag": null,
                        "total": 3336.6339767348168,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    }
                ]
            },
            "_links": {
                "self": {
                    "href": "https://api.edamam.com/api/recipes/v2/d4287fe5a333f3d32e29a77a085a1492?type=public&app_id=ea1d37d5&app_key=fd382a172ba8d6668c0430dc9c14a181",
                    "title": "Self"
                }
            }
        },
        {
            "recipe": {
                "uri": "http://www.edamam.com/ontologies/edamam.owl#recipe_9899a97323159ebb63ccfab80f5ad46c",
                "label": "Breaded Sicilian Fish",
                "image": "https://www.edamam.com/web-img/45d/45de2b6de121abebac834f030f5516bc.jpg",
                "source": "In Jennie's Kitchen",
                "url": "http://www.injennieskitchen.com/2009/08/bread-glorious-bread.html",
                "shareAs": "http://www.edamam.com/recipe/breaded-sicilian-fish-9899a97323159ebb63ccfab80f5ad46c/fish",
                "yield": 4,
                "dietLabels": [],
                "healthLabels": [
                    "Sugar-Conscious",
                    "Pescatarian",
                    "Mediterranean",
                    "Dairy-Free",
                    "Egg-Free",
                    "Peanut-Free",
                    "Tree-Nut-Free",
                    "Soy-Free",
                    "Shellfish-Free",
                    "Pork-Free",
                    "Red-Meat-Free",
                    "Crustacean-Free",
                    "Celery-Free",
                    "Mustard-Free",
                    "Sesame-Free",
                    "Lupine-Free",
                    "Mollusk-Free",
                    "Alcohol-Free",
                    "Sulfite-Free",
                    "Kosher",
                    "Immuno-Supportive"
                ],
                "cautions": [
                    "Sulfites"
                ],
                "ingredientLines": [
                    "1 cup breadcrumbs, unseasoned",
                    "1 tsp Italian Seasoning",
                    "1/4 cup Italian flat leaf parsley, fresh chopped",
                    "1 tsp garlic salt",
                    "Salt and pepper, to taste",
                    "Olive Oil",
                    "4 x boneless fillets, fresh fish (I like to use swordfish, petrale sole, rock fish or tuna but this does not work on salmon or other thick cut fish)",
                    "4-6 x lemon wedges (optional)"
                ],
                "ingredients": [
                    {
                        "text": "1 cup breadcrumbs, unseasoned",
                        "weight": 108,
                        "foodCategory": "bread, rolls and tortillas",
                        "foodId": "food_ata1dxza443wfda7jb4e5b3zwt9p",
                        "image": "https://www.edamam.com/food-img/349/349f852497885b9d9c0b195ad0d0db8f.jpg"
                    },
                    {
                        "text": "1 tsp Italian Seasoning",
                        "weight": 1,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_avsq22zadwyb5cb5sl1byaa4mbo8",
                        "image": "https://www.edamam.com/food-img/89b/89b37a04e46e052671d73addcb84aa51.jpg"
                    },
                    {
                        "text": "1/4 cup Italian flat leaf parsley, fresh chopped",
                        "weight": 15,
                        "foodCategory": null,
                        "foodId": "food_av1k4v6asr2ew9ae0d01danb6k25",
                        "image": "https://www.edamam.com/food-img/46a/46a132e96626d7989b4d6ed8c91f4da0.jpg"
                    },
                    {
                        "text": "1 tsp garlic salt",
                        "weight": 3.1,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_boq94r1a036492bdup9u1beyph0l",
                        "image": "https://www.edamam.com/food-img/5c3/5c3db1d5a1a16b1f0a74796f74dd5985.jpg"
                    },
                    {
                        "text": "Salt and pepper, to taste",
                        "weight": 3.7566,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_btxz81db72hwbra2pncvebzzzum9",
                        "image": "https://www.edamam.com/food-img/694/6943ea510918c6025795e8dc6e6eaaeb.jpg"
                    },
                    {
                        "text": "Salt and pepper, to taste",
                        "weight": 1.8783,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_b6ywzluaaxv02wad7s1r9ag4py89",
                        "image": "https://www.edamam.com/food-img/c6e/c6e5c3bd8d3bc15175d9766971a4d1b2.jpg"
                    },
                    {
                        "text": "Olive Oil",
                        "weight": 8.51496,
                        "foodCategory": "Oils",
                        "foodId": "food_b1d1icuad3iktrbqby0hiagafaz7",
                        "image": "https://www.edamam.com/food-img/4d6/4d651eaa8a353647746290c7a9b29d84.jpg"
                    },
                    {
                        "text": "4 x boneless fillets, fresh fish (I like to use swordfish, petrale sole, rock fish or tuna but this does not work on salmon or other thick cut fish)",
                        "weight": 464,
                        "foodCategory": "seafood",
                        "foodId": "food_ar6pjbvaxqtlqia7jewa4brld7p9",
                        "image": "https://www.edamam.com/food-img/717/717cb400eb49626bb7c95cd29292cef4.jpg"
                    },
                    {
                        "text": "4-6 x lemon wedges (optional)",
                        "weight": 35,
                        "foodCategory": "fruit",
                        "foodId": "food_a6uzc62astrxcgbtzyq59b6fncrr",
                        "image": "https://www.edamam.com/food-img/70a/70acba3d4c734d7c70ef4efeed85dc8f.jpg"
                    }
                ],
                "calories": 980.5977793999999,
                "totalWeight": 637.6188505543753,
                "totalTime": 0,
                "cuisineType": [
                    "british"
                ],
                "mealType": [
                    "lunch/dinner"
                ],
                "dishType": [
                    "sandwiches"
                ],
                "totalNutrients": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 980.5977793999999,
                        "unit": "kcal"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 22.50862258,
                        "unit": "g"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 5.2840006128,
                        "unit": "g"
                    },
                    "FATRN": {
                        "label": "Trans",
                        "quantity": 0,
                        "unit": "g"
                    },
                    "FAMS": {
                        "label": "Monounsaturated",
                        "quantity": 9.6984056026,
                        "unit": "g"
                    },
                    "FAPU": {
                        "label": "Polyunsaturated",
                        "quantity": 4.8910626748,
                        "unit": "g"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 86.04510285000002,
                        "unit": "g"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 7.459209900000001,
                        "unit": "g"
                    },
                    "SUGAR": {
                        "label": "Sugars",
                        "quantity": 7.802951120000001,
                        "unit": "g"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 109.21900536999999,
                        "unit": "g"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 231.99999999999997,
                        "unit": "mg"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 1480.1523462648,
                        "unit": "mg"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 303.8651603330501,
                        "unit": "mg"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 189.83014890554375,
                        "unit": "mg"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 1814.62080384435,
                        "unit": "mg"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 10.59973115482944,
                        "unit": "mg"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 3.456667360554375,
                        "unit": "mg"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 999.111714,
                        "unit": "mg"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 65.907141,
                        "unit": "µg"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 39.0372,
                        "unit": "mg"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 1.2821435639999998,
                        "unit": "mg"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 0.76100194,
                        "unit": "mg"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 25.602134969,
                        "unit": "mg"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 0.986099853,
                        "unit": "mg"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 319.646311,
                        "unit": "µg"
                    },
                    "FOLFD": {
                        "label": "Folate (food)",
                        "quantity": 169.526311,
                        "unit": "µg"
                    },
                    "FOLAC": {
                        "label": "Folic acid",
                        "quantity": 88.56,
                        "unit": "µg"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 7.7092,
                        "unit": "µg"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 14.383999999999999,
                        "unit": "µg"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 3.4444010800000004,
                        "unit": "mg"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 284.98218302000004,
                        "unit": "µg"
                    },
                    "WATER": {
                        "label": "Water",
                        "quantity": 414.1356373611087,
                        "unit": "g"
                    }
                },
                "totalDaily": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 49.029888969999995,
                        "unit": "%"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 34.62865012307692,
                        "unit": "%"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 26.420003064000003,
                        "unit": "%"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 28.681700950000007,
                        "unit": "%"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 29.836839600000005,
                        "unit": "%"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 218.43801073999998,
                        "unit": "%"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 77.33333333333331,
                        "unit": "%"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 61.6730144277,
                        "unit": "%"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 30.386516033305007,
                        "unit": "%"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 45.19765450131994,
                        "unit": "%"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 38.60895327328404,
                        "unit": "%"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 58.887395304608,
                        "unit": "%"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 31.424248732312503,
                        "unit": "%"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 142.73024485714288,
                        "unit": "%"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 7.323015666666666,
                        "unit": "%"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 43.37466666666666,
                        "unit": "%"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 106.84529699999999,
                        "unit": "%"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 58.53861076923077,
                        "unit": "%"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 160.01334355625002,
                        "unit": "%"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 75.85383484615384,
                        "unit": "%"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 79.91157775,
                        "unit": "%"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 321.21666666666664,
                        "unit": "%"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 95.89333333333333,
                        "unit": "%"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 22.96267386666667,
                        "unit": "%"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 237.48515251666672,
                        "unit": "%"
                    }
                },
                "digest": [
                    {
                        "label": "Fat",
                        "tag": "FAT",
                        "schemaOrgTag": "fatContent",
                        "total": 22.50862258,
                        "hasRDI": true,
                        "daily": 34.62865012307692,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Saturated",
                                "tag": "FASAT",
                                "schemaOrgTag": "saturatedFatContent",
                                "total": 5.2840006128,
                                "hasRDI": true,
                                "daily": 26.420003064000003,
                                "unit": "g"
                            },
                            {
                                "label": "Trans",
                                "tag": "FATRN",
                                "schemaOrgTag": "transFatContent",
                                "total": 0,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Monounsaturated",
                                "tag": "FAMS",
                                "schemaOrgTag": null,
                                "total": 9.6984056026,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Polyunsaturated",
                                "tag": "FAPU",
                                "schemaOrgTag": null,
                                "total": 4.8910626748,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Carbs",
                        "tag": "CHOCDF",
                        "schemaOrgTag": "carbohydrateContent",
                        "total": 86.04510285000002,
                        "hasRDI": true,
                        "daily": 28.681700950000007,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Carbs (net)",
                                "tag": "CHOCDF.net",
                                "schemaOrgTag": null,
                                "total": 78.58589295000002,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Fiber",
                                "tag": "FIBTG",
                                "schemaOrgTag": "fiberContent",
                                "total": 7.459209900000001,
                                "hasRDI": true,
                                "daily": 29.836839600000005,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars",
                                "tag": "SUGAR",
                                "schemaOrgTag": "sugarContent",
                                "total": 7.802951120000001,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars, added",
                                "tag": "SUGAR.added",
                                "schemaOrgTag": null,
                                "total": 0,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Protein",
                        "tag": "PROCNT",
                        "schemaOrgTag": "proteinContent",
                        "total": 109.21900536999999,
                        "hasRDI": true,
                        "daily": 218.43801073999998,
                        "unit": "g"
                    },
                    {
                        "label": "Cholesterol",
                        "tag": "CHOLE",
                        "schemaOrgTag": "cholesterolContent",
                        "total": 231.99999999999997,
                        "hasRDI": true,
                        "daily": 77.33333333333331,
                        "unit": "mg"
                    },
                    {
                        "label": "Sodium",
                        "tag": "NA",
                        "schemaOrgTag": "sodiumContent",
                        "total": 1480.1523462648,
                        "hasRDI": true,
                        "daily": 61.6730144277,
                        "unit": "mg"
                    },
                    {
                        "label": "Calcium",
                        "tag": "CA",
                        "schemaOrgTag": null,
                        "total": 303.8651603330501,
                        "hasRDI": true,
                        "daily": 30.386516033305007,
                        "unit": "mg"
                    },
                    {
                        "label": "Magnesium",
                        "tag": "MG",
                        "schemaOrgTag": null,
                        "total": 189.83014890554375,
                        "hasRDI": true,
                        "daily": 45.19765450131994,
                        "unit": "mg"
                    },
                    {
                        "label": "Potassium",
                        "tag": "K",
                        "schemaOrgTag": null,
                        "total": 1814.62080384435,
                        "hasRDI": true,
                        "daily": 38.60895327328404,
                        "unit": "mg"
                    },
                    {
                        "label": "Iron",
                        "tag": "FE",
                        "schemaOrgTag": null,
                        "total": 10.59973115482944,
                        "hasRDI": true,
                        "daily": 58.887395304608,
                        "unit": "mg"
                    },
                    {
                        "label": "Zinc",
                        "tag": "ZN",
                        "schemaOrgTag": null,
                        "total": 3.456667360554375,
                        "hasRDI": true,
                        "daily": 31.424248732312503,
                        "unit": "mg"
                    },
                    {
                        "label": "Phosphorus",
                        "tag": "P",
                        "schemaOrgTag": null,
                        "total": 999.111714,
                        "hasRDI": true,
                        "daily": 142.73024485714288,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin A",
                        "tag": "VITA_RAE",
                        "schemaOrgTag": null,
                        "total": 65.907141,
                        "hasRDI": true,
                        "daily": 7.323015666666666,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin C",
                        "tag": "VITC",
                        "schemaOrgTag": null,
                        "total": 39.0372,
                        "hasRDI": true,
                        "daily": 43.37466666666666,
                        "unit": "mg"
                    },
                    {
                        "label": "Thiamin (B1)",
                        "tag": "THIA",
                        "schemaOrgTag": null,
                        "total": 1.2821435639999998,
                        "hasRDI": true,
                        "daily": 106.84529699999999,
                        "unit": "mg"
                    },
                    {
                        "label": "Riboflavin (B2)",
                        "tag": "RIBF",
                        "schemaOrgTag": null,
                        "total": 0.76100194,
                        "hasRDI": true,
                        "daily": 58.53861076923077,
                        "unit": "mg"
                    },
                    {
                        "label": "Niacin (B3)",
                        "tag": "NIA",
                        "schemaOrgTag": null,
                        "total": 25.602134969,
                        "hasRDI": true,
                        "daily": 160.01334355625002,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin B6",
                        "tag": "VITB6A",
                        "schemaOrgTag": null,
                        "total": 0.986099853,
                        "hasRDI": true,
                        "daily": 75.85383484615384,
                        "unit": "mg"
                    },
                    {
                        "label": "Folate equivalent (total)",
                        "tag": "FOLDFE",
                        "schemaOrgTag": null,
                        "total": 319.646311,
                        "hasRDI": true,
                        "daily": 79.91157775,
                        "unit": "µg"
                    },
                    {
                        "label": "Folate (food)",
                        "tag": "FOLFD",
                        "schemaOrgTag": null,
                        "total": 169.526311,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Folic acid",
                        "tag": "FOLAC",
                        "schemaOrgTag": null,
                        "total": 88.56,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin B12",
                        "tag": "VITB12",
                        "schemaOrgTag": null,
                        "total": 7.7092,
                        "hasRDI": true,
                        "daily": 321.21666666666664,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin D",
                        "tag": "VITD",
                        "schemaOrgTag": null,
                        "total": 14.383999999999999,
                        "hasRDI": true,
                        "daily": 95.89333333333333,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin E",
                        "tag": "TOCPHA",
                        "schemaOrgTag": null,
                        "total": 3.4444010800000004,
                        "hasRDI": true,
                        "daily": 22.96267386666667,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin K",
                        "tag": "VITK1",
                        "schemaOrgTag": null,
                        "total": 284.98218302000004,
                        "hasRDI": true,
                        "daily": 237.48515251666672,
                        "unit": "µg"
                    },
                    {
                        "label": "Sugar alcohols",
                        "tag": "Sugar.alcohol",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    },
                    {
                        "label": "Water",
                        "tag": "WATER",
                        "schemaOrgTag": null,
                        "total": 414.1356373611087,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    }
                ]
            },
            "_links": {
                "self": {
                    "href": "https://api.edamam.com/api/recipes/v2/9899a97323159ebb63ccfab80f5ad46c?type=public&app_id=ea1d37d5&app_key=fd382a172ba8d6668c0430dc9c14a181",
                    "title": "Self"
                }
            }
        },
        {
            "recipe": {
                "uri": "http://www.edamam.com/ontologies/edamam.owl#recipe_1eaf58bbc25d7e627aa57ea14e038055",
                "label": "Fish soup",
                "image": "https://www.edamam.com/web-img/ab1/ab11873e5da76b62c489b0c76eac920d.jpg",
                "source": "Jamie Oliver",
                "url": "http://www.jamieoliver.com/recipes/fish-recipes/fish-soup/",
                "shareAs": "http://www.edamam.com/recipe/fish-soup-1eaf58bbc25d7e627aa57ea14e038055/fish",
                "yield": 6,
                "dietLabels": [],
                "healthLabels": [
                    "Pescatarian",
                    "Paleo",
                    "Mediterranean",
                    "Dairy-Free",
                    "Gluten-Free",
                    "Wheat-Free",
                    "Egg-Free",
                    "Peanut-Free",
                    "Tree-Nut-Free",
                    "Soy-Free",
                    "Pork-Free",
                    "Red-Meat-Free",
                    "Mustard-Free",
                    "Sesame-Free",
                    "Lupine-Free"
                ],
                "cautions": [
                    "FODMAP"
                ],
                "ingredientLines": [
                    "1 small bulb of fennel",
                    "1 leek",
                    "3 sticks of celery",
                    "1 fresh red chilli",
                    "4 cloves of garlic",
                    "3-4 tomatoes",
                    "1 bunch of fresh thyme",
                    "440 g white fish, from sustainable sources",
                    "olive oil",
                    "1 small glass of white wine",
                    "400 g prawns, mussels or clams, from sustainable sources",
                    "extra virgin olive oil"
                ],
                "ingredients": [
                    {
                        "text": "1 small bulb of fennel",
                        "weight": 175.5,
                        "foodCategory": "vegetables",
                        "foodId": "food_a4sdbkob8ixokpb07a42dbt3typw",
                        "image": "https://www.edamam.com/food-img/038/038c19f86af781e925c97991e17b90ed.jpeg"
                    },
                    {
                        "text": "1 leek",
                        "weight": 89,
                        "foodCategory": "vegetables",
                        "foodId": "food_a27jevnb06c1m9ax7k41xbbcwcuo",
                        "image": "https://www.edamam.com/food-img/4ae/4ae9e09d029a28e0e2c64bdfdbf3f6ae.jpg"
                    },
                    {
                        "text": "3 sticks of celery",
                        "weight": 120,
                        "foodCategory": "vegetables",
                        "foodId": "food_bffeoksbyyur8ja4da73ub2xs57g",
                        "image": "https://www.edamam.com/food-img/d91/d91d2aed1c36d8fad54c4d7dc58f5a18.jpg"
                    },
                    {
                        "text": "1 fresh red chilli",
                        "weight": 45,
                        "foodCategory": "vegetables",
                        "foodId": "food_a6g98mqatzj7vca6ms3bnbzqxf3s",
                        "image": "https://www.edamam.com/food-img/469/469213672957a242638e20c27e3e8acd.jpeg"
                    },
                    {
                        "text": "4 cloves of garlic",
                        "weight": 12,
                        "foodCategory": "vegetables",
                        "foodId": "food_avtcmx6bgjv1jvay6s6stan8dnyp",
                        "image": "https://www.edamam.com/food-img/6ee/6ee142951f48aaf94f4312409f8d133d.jpg"
                    },
                    {
                        "text": "3-4 tomatoes",
                        "weight": 430.5,
                        "foodCategory": "vegetables",
                        "foodId": "food_a6k79rrahp8fe2b26zussa3wtkqh",
                        "image": "https://www.edamam.com/food-img/23e/23e727a14f1035bdc2733bb0477efbd2.jpg"
                    },
                    {
                        "text": "1 bunch of fresh thyme",
                        "weight": 15,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_b3o3cj7a5gskecb0ufphtadnbfqb",
                        "image": "https://www.edamam.com/food-img/3e7/3e7cf3c8d767a90b906447f5e74059f7.jpg"
                    },
                    {
                        "text": "440 g white fish, from sustainable sources",
                        "weight": 440,
                        "foodCategory": "seafood",
                        "foodId": "food_ar6pjbvaxqtlqia7jewa4brld7p9",
                        "image": "https://www.edamam.com/food-img/717/717cb400eb49626bb7c95cd29292cef4.jpg"
                    },
                    {
                        "text": "olive oil",
                        "weight": 25.88624,
                        "foodCategory": "Oils",
                        "foodId": "food_b1d1icuad3iktrbqby0hiagafaz7",
                        "image": "https://www.edamam.com/food-img/4d6/4d651eaa8a353647746290c7a9b29d84.jpg"
                    },
                    {
                        "text": "1 small glass of white wine",
                        "weight": 176.39999999999998,
                        "foodCategory": "wines",
                        "foodId": "food_bn44h7baron9ufaoxinmya8l0yye",
                        "image": "https://www.edamam.com/food-img/a71/a718cf3c52add522128929f1f324d2ab.jpg"
                    },
                    {
                        "text": "400 g prawns, mussels or clams, from sustainable sources",
                        "weight": 400,
                        "foodCategory": "seafood",
                        "foodId": "food_b38bejhbq9loe2bbb7bnmbcpteft",
                        "image": "https://www.edamam.com/food-img/ebe/ebe2888b894f48d19762e1d606db0206.jpg"
                    },
                    {
                        "text": "extra virgin olive oil",
                        "weight": 25.88624,
                        "foodCategory": "Oils",
                        "foodId": "food_b1d1icuad3iktrbqby0hiagafaz7",
                        "image": "https://www.edamam.com/food-img/4d6/4d651eaa8a353647746290c7a9b29d84.jpg"
                    }
                ],
                "calories": 1565.1317232,
                "totalWeight": 1955.17248,
                "totalTime": 30,
                "cuisineType": [
                    "american"
                ],
                "mealType": [
                    "lunch/dinner"
                ],
                "dishType": [
                    "soup"
                ],
                "totalNutrients": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 1565.1317232,
                        "unit": "kcal"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 65.48548,
                        "unit": "g"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 11.2308640384,
                        "unit": "g"
                    },
                    "FATRN": {
                        "label": "Trans",
                        "quantity": 0.072,
                        "unit": "g"
                    },
                    "FAMS": {
                        "label": "Monounsaturated",
                        "quantity": 41.00794413279999,
                        "unit": "g"
                    },
                    "FAPU": {
                        "label": "Polyunsaturated",
                        "quantity": 9.338898070399999,
                        "unit": "g"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 65.54104999999998,
                        "unit": "g"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 17.155500000000004,
                        "unit": "g"
                    },
                    "SUGAR": {
                        "label": "Sugars",
                        "quantity": 27.49674,
                        "unit": "g"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 153.48178000000001,
                        "unit": "g"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 724,
                        "unit": "mg"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 2736.6804496,
                        "unit": "mg"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 594.7187248,
                        "unit": "mg"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 377.1,
                        "unit": "mg"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 4409.9867248,
                        "unit": "mg"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 11.907705887999999,
                        "unit": "mg"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 7.4170300000000005,
                        "unit": "mg"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 2060.382,
                        "unit": "mg"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 638.62,
                        "unit": "µg"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 186.86249999999998,
                        "unit": "mg"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 0.588255,
                        "unit": "mg"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 0.719265,
                        "unit": "mg"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 29.813482,
                        "unit": "mg"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 2.596155,
                        "unit": "mg"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 412.944,
                        "unit": "µg"
                    },
                    "FOLFD": {
                        "label": "Folate (food)",
                        "quantity": 412.944,
                        "unit": "µg"
                    },
                    "FOLAC": {
                        "label": "Folic acid",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 11.392000000000001,
                        "unit": "µg"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 14.040000000000003,
                        "unit": "µg"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 19.274850880000002,
                        "unit": "mg"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 266.95013296,
                        "unit": "µg"
                    },
                    "WATER": {
                        "label": "Water",
                        "quantity": 1638.8312899999996,
                        "unit": "g"
                    }
                },
                "totalDaily": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 78.25658616,
                        "unit": "%"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 100.7468923076923,
                        "unit": "%"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 56.154320192,
                        "unit": "%"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 21.84701666666666,
                        "unit": "%"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 68.62200000000001,
                        "unit": "%"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 306.96356000000003,
                        "unit": "%"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 241.33333333333334,
                        "unit": "%"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 114.02835206666666,
                        "unit": "%"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 59.47187248000001,
                        "unit": "%"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 89.78571428571429,
                        "unit": "%"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 93.82950478297873,
                        "unit": "%"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 66.15392159999999,
                        "unit": "%"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 67.42754545454547,
                        "unit": "%"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 294.34028571428576,
                        "unit": "%"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 70.95777777777778,
                        "unit": "%"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 207.625,
                        "unit": "%"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 49.02125,
                        "unit": "%"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 55.32807692307693,
                        "unit": "%"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 186.3342625,
                        "unit": "%"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 199.70423076923075,
                        "unit": "%"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 103.236,
                        "unit": "%"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 474.6666666666667,
                        "unit": "%"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 93.60000000000001,
                        "unit": "%"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 128.4990058666667,
                        "unit": "%"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 222.45844413333333,
                        "unit": "%"
                    }
                },
                "digest": [
                    {
                        "label": "Fat",
                        "tag": "FAT",
                        "schemaOrgTag": "fatContent",
                        "total": 65.48548,
                        "hasRDI": true,
                        "daily": 100.7468923076923,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Saturated",
                                "tag": "FASAT",
                                "schemaOrgTag": "saturatedFatContent",
                                "total": 11.2308640384,
                                "hasRDI": true,
                                "daily": 56.154320192,
                                "unit": "g"
                            },
                            {
                                "label": "Trans",
                                "tag": "FATRN",
                                "schemaOrgTag": "transFatContent",
                                "total": 0.072,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Monounsaturated",
                                "tag": "FAMS",
                                "schemaOrgTag": null,
                                "total": 41.00794413279999,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Polyunsaturated",
                                "tag": "FAPU",
                                "schemaOrgTag": null,
                                "total": 9.338898070399999,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Carbs",
                        "tag": "CHOCDF",
                        "schemaOrgTag": "carbohydrateContent",
                        "total": 65.54104999999998,
                        "hasRDI": true,
                        "daily": 21.84701666666666,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Carbs (net)",
                                "tag": "CHOCDF.net",
                                "schemaOrgTag": null,
                                "total": 48.38554999999998,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Fiber",
                                "tag": "FIBTG",
                                "schemaOrgTag": "fiberContent",
                                "total": 17.155500000000004,
                                "hasRDI": true,
                                "daily": 68.62200000000001,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars",
                                "tag": "SUGAR",
                                "schemaOrgTag": "sugarContent",
                                "total": 27.49674,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars, added",
                                "tag": "SUGAR.added",
                                "schemaOrgTag": null,
                                "total": 0,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Protein",
                        "tag": "PROCNT",
                        "schemaOrgTag": "proteinContent",
                        "total": 153.48178000000001,
                        "hasRDI": true,
                        "daily": 306.96356000000003,
                        "unit": "g"
                    },
                    {
                        "label": "Cholesterol",
                        "tag": "CHOLE",
                        "schemaOrgTag": "cholesterolContent",
                        "total": 724,
                        "hasRDI": true,
                        "daily": 241.33333333333334,
                        "unit": "mg"
                    },
                    {
                        "label": "Sodium",
                        "tag": "NA",
                        "schemaOrgTag": "sodiumContent",
                        "total": 2736.6804496,
                        "hasRDI": true,
                        "daily": 114.02835206666666,
                        "unit": "mg"
                    },
                    {
                        "label": "Calcium",
                        "tag": "CA",
                        "schemaOrgTag": null,
                        "total": 594.7187248,
                        "hasRDI": true,
                        "daily": 59.47187248000001,
                        "unit": "mg"
                    },
                    {
                        "label": "Magnesium",
                        "tag": "MG",
                        "schemaOrgTag": null,
                        "total": 377.1,
                        "hasRDI": true,
                        "daily": 89.78571428571429,
                        "unit": "mg"
                    },
                    {
                        "label": "Potassium",
                        "tag": "K",
                        "schemaOrgTag": null,
                        "total": 4409.9867248,
                        "hasRDI": true,
                        "daily": 93.82950478297873,
                        "unit": "mg"
                    },
                    {
                        "label": "Iron",
                        "tag": "FE",
                        "schemaOrgTag": null,
                        "total": 11.907705887999999,
                        "hasRDI": true,
                        "daily": 66.15392159999999,
                        "unit": "mg"
                    },
                    {
                        "label": "Zinc",
                        "tag": "ZN",
                        "schemaOrgTag": null,
                        "total": 7.4170300000000005,
                        "hasRDI": true,
                        "daily": 67.42754545454547,
                        "unit": "mg"
                    },
                    {
                        "label": "Phosphorus",
                        "tag": "P",
                        "schemaOrgTag": null,
                        "total": 2060.382,
                        "hasRDI": true,
                        "daily": 294.34028571428576,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin A",
                        "tag": "VITA_RAE",
                        "schemaOrgTag": null,
                        "total": 638.62,
                        "hasRDI": true,
                        "daily": 70.95777777777778,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin C",
                        "tag": "VITC",
                        "schemaOrgTag": null,
                        "total": 186.86249999999998,
                        "hasRDI": true,
                        "daily": 207.625,
                        "unit": "mg"
                    },
                    {
                        "label": "Thiamin (B1)",
                        "tag": "THIA",
                        "schemaOrgTag": null,
                        "total": 0.588255,
                        "hasRDI": true,
                        "daily": 49.02125,
                        "unit": "mg"
                    },
                    {
                        "label": "Riboflavin (B2)",
                        "tag": "RIBF",
                        "schemaOrgTag": null,
                        "total": 0.719265,
                        "hasRDI": true,
                        "daily": 55.32807692307693,
                        "unit": "mg"
                    },
                    {
                        "label": "Niacin (B3)",
                        "tag": "NIA",
                        "schemaOrgTag": null,
                        "total": 29.813482,
                        "hasRDI": true,
                        "daily": 186.3342625,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin B6",
                        "tag": "VITB6A",
                        "schemaOrgTag": null,
                        "total": 2.596155,
                        "hasRDI": true,
                        "daily": 199.70423076923075,
                        "unit": "mg"
                    },
                    {
                        "label": "Folate equivalent (total)",
                        "tag": "FOLDFE",
                        "schemaOrgTag": null,
                        "total": 412.944,
                        "hasRDI": true,
                        "daily": 103.236,
                        "unit": "µg"
                    },
                    {
                        "label": "Folate (food)",
                        "tag": "FOLFD",
                        "schemaOrgTag": null,
                        "total": 412.944,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Folic acid",
                        "tag": "FOLAC",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin B12",
                        "tag": "VITB12",
                        "schemaOrgTag": null,
                        "total": 11.392000000000001,
                        "hasRDI": true,
                        "daily": 474.6666666666667,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin D",
                        "tag": "VITD",
                        "schemaOrgTag": null,
                        "total": 14.040000000000003,
                        "hasRDI": true,
                        "daily": 93.60000000000001,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin E",
                        "tag": "TOCPHA",
                        "schemaOrgTag": null,
                        "total": 19.274850880000002,
                        "hasRDI": true,
                        "daily": 128.4990058666667,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin K",
                        "tag": "VITK1",
                        "schemaOrgTag": null,
                        "total": 266.95013296,
                        "hasRDI": true,
                        "daily": 222.45844413333333,
                        "unit": "µg"
                    },
                    {
                        "label": "Sugar alcohols",
                        "tag": "Sugar.alcohol",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    },
                    {
                        "label": "Water",
                        "tag": "WATER",
                        "schemaOrgTag": null,
                        "total": 1638.8312899999996,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    }
                ]
            },
            "_links": {
                "self": {
                    "href": "https://api.edamam.com/api/recipes/v2/1eaf58bbc25d7e627aa57ea14e038055?type=public&app_id=ea1d37d5&app_key=fd382a172ba8d6668c0430dc9c14a181",
                    "title": "Self"
                }
            }
        },
        {
            "recipe": {
                "uri": "http://www.edamam.com/ontologies/edamam.owl#recipe_06da4c0d8b1cabca809b4a9a6ad1e5ef",
                "label": "Baked Gefilte Fish",
                "image": "https://www.edamam.com/web-img/30b/30bc8ba581e8df430cff2a22c5e32abf.jpg",
                "source": "Epicurious",
                "url": "https://www.epicurious.com/recipes/food/views/baked-gefilte-fish-51154400",
                "shareAs": "http://www.edamam.com/recipe/baked-gefilte-fish-06da4c0d8b1cabca809b4a9a6ad1e5ef/fish",
                "yield": 6,
                "dietLabels": [],
                "healthLabels": [
                    "Dairy-Free",
                    "Peanut-Free",
                    "Tree-Nut-Free",
                    "Soy-Free",
                    "Shellfish-Free",
                    "Pork-Free",
                    "Red-Meat-Free",
                    "Crustacean-Free",
                    "Celery-Free",
                    "Mustard-Free",
                    "Sesame-Free",
                    "Lupine-Free",
                    "Mollusk-Free",
                    "Alcohol-Free",
                    "No oil added"
                ],
                "cautions": [
                    "Sulfites"
                ],
                "ingredientLines": [
                    "1 1/2 pounds rockfish fillet",
                    "1/2 pound pike fillet",
                    "1/2 pound flounder fillet",
                    "8 cups fish stock, preferably homemade",
                    "3/4 cup matzo meal",
                    "4 large eggs, lightly beaten",
                    "2 tablespoons sugar",
                    "1 tablespoon chopped fresh thyme leaves",
                    "2 tablespoons chopped fresh parsley",
                    "1 teaspoon freshly grated lemon zest",
                    "2 1/2 teaspoons salt",
                    "1/8 teaspoon freshly ground black pepper",
                    "Boiled Carrots with Prepared Horseradish for serving",
                    "Vegetable stock or water can be used instead of fish stock."
                ],
                "ingredients": [
                    {
                        "text": "1 1/2 pounds rockfish fillet",
                        "weight": 680.388555,
                        "foodCategory": "seafood",
                        "foodId": "food_aqoqlhtb7ntegebr9nr74autpr3m",
                        "image": "https://www.edamam.com/food-img/28c/28c25f526318336b06586c40fa82b618.jpg"
                    },
                    {
                        "text": "1/2 pound pike fillet",
                        "weight": 226.796185,
                        "foodCategory": "seafood",
                        "foodId": "food_bvnnd03br3vl93bc7pbg6bnmohib",
                        "image": "https://www.edamam.com/food-img/d37/d37ff6013651a187e9d095346c347d56.jpg"
                    },
                    {
                        "text": "1/2 pound flounder fillet",
                        "weight": 226.796185,
                        "foodCategory": "seafood",
                        "foodId": "food_aa1htwzathrzkzbmybiqgajtgbyz",
                        "image": "https://www.edamam.com/food-img/90a/90a1ec5eb03e114e7cbef1d05df3f8af.jpg"
                    },
                    {
                        "text": "8 cups fish stock, preferably homemade",
                        "weight": 1864,
                        "foodCategory": "canned soup",
                        "foodId": "food_a00wj3maedk41kbwmbl4hb3s5gua",
                        "image": "https://www.edamam.com/food-img/e07/e07d7b7a8320da9f235be9d663b7a9f4.jpg"
                    },
                    {
                        "text": "3/4 cup matzo meal",
                        "weight": 41.25,
                        "foodCategory": "crackers",
                        "foodId": "food_a7qwjpbarote7sbjmkrfiaovtoo3",
                        "image": "https://www.edamam.com/food-img/656/656d9f10022c99adde7b67b03b5b17b2.jpg"
                    },
                    {
                        "text": "4 large eggs, lightly beaten",
                        "weight": 200,
                        "foodCategory": "Eggs",
                        "foodId": "food_bhpradua77pk16aipcvzeayg732r",
                        "image": "https://www.edamam.com/food-img/a7e/a7ec7c337cb47c6550b3b118e357f077.jpg"
                    },
                    {
                        "text": "2 tablespoons sugar",
                        "weight": 24.9999999995774,
                        "foodCategory": "sugars",
                        "foodId": "food_axi2ijobrk819yb0adceobnhm1c2",
                        "image": "https://www.edamam.com/food-img/ecb/ecb3f5aaed96d0188c21b8369be07765.jpg"
                    },
                    {
                        "text": "1 tablespoon chopped fresh thyme leaves",
                        "weight": 2.3999999998376933,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_b3o3cj7a5gskecb0ufphtadnbfqb",
                        "image": "https://www.edamam.com/food-img/3e7/3e7cf3c8d767a90b906447f5e74059f7.jpg"
                    },
                    {
                        "text": "2 tablespoons chopped fresh parsley",
                        "weight": 7.6,
                        "foodCategory": "vegetables",
                        "foodId": "food_b244pqdazw24zobr5vqu2bf0uid8",
                        "image": "https://www.edamam.com/food-img/46a/46a132e96626d7989b4d6ed8c91f4da0.jpg"
                    },
                    {
                        "text": "1 teaspoon freshly grated lemon zest",
                        "weight": 2,
                        "foodCategory": "fruit",
                        "foodId": "food_bpg66j3a5vjuuga36uiiyaqeazpd",
                        "image": "https://www.edamam.com/food-img/540/5405605c8e9b284243f06c0b1587ab6f.jpg"
                    },
                    {
                        "text": "2 1/2 teaspoons salt",
                        "weight": 15,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_btxz81db72hwbra2pncvebzzzum9",
                        "image": "https://www.edamam.com/food-img/694/6943ea510918c6025795e8dc6e6eaaeb.jpg"
                    },
                    {
                        "text": "1/8 teaspoon freshly ground black pepper",
                        "weight": 0.2875,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_b6ywzluaaxv02wad7s1r9ag4py89",
                        "image": "https://www.edamam.com/food-img/c6e/c6e5c3bd8d3bc15175d9766971a4d1b2.jpg"
                    },
                    {
                        "text": "Boiled Carrots with Prepared Horseradish for serving",
                        "weight": 0,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_bt10wq1burha64az05cdka9pweff",
                        "image": "https://www.edamam.com/food-img/cc8/cc83e12eb36bdcc3015201c1cfac8656.jpg"
                    },
                    {
                        "text": "Vegetable stock or water can be used instead of fish stock.",
                        "weight": 440.62500000000006,
                        "foodCategory": "canned soup",
                        "foodId": "food_axnge37bb3pfgua5u0iz9agn86ay",
                        "image": null
                    }
                ],
                "calories": 1854.8078560482006,
                "totalWeight": 3723.3213312363664,
                "totalTime": 0,
                "cuisineType": [
                    "mediterranean"
                ],
                "mealType": [
                    "lunch/dinner"
                ],
                "dishType": [
                    "main course"
                ],
                "totalNutrients": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 1854.8078560482006,
                        "unit": "kcal"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 51.07291896449727,
                        "unit": "g"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 14.081008962349243,
                        "unit": "g"
                    },
                    "FATRN": {
                        "label": "Trans",
                        "quantity": 0.23702529135,
                        "unit": "g"
                    },
                    "FAMS": {
                        "label": "Monounsaturated",
                        "quantity": 16.29377243539987,
                        "unit": "g"
                    },
                    "FAPU": {
                        "label": "Polyunsaturated",
                        "quantity": 11.260253534399135,
                        "unit": "g"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 68.1729862495378,
                        "unit": "g"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 2.109037499977277,
                        "unit": "g"
                    },
                    "SUGAR": {
                        "label": "Sugars",
                        "quantity": 29.70477749957825,
                        "unit": "g"
                    },
                    "SUGAR.added": {
                        "label": "Sugars, added",
                        "quantity": 24.949999999578246,
                        "unit": "g"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 268.26396631549096,
                        "unit": "g"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 1399.93727985,
                        "unit": "mg"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 8644.14269196764,
                        "unit": "mg"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 591.5342225462068,
                        "unit": "mg"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 465.8529827121099,
                        "unit": "mg"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 6942.50598544796,
                        "unit": "mg"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 11.354452543553405,
                        "unit": "mg"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 8.702042093233972,
                        "unit": "mg"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 3926.793662449828,
                        "unit": "mg"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 492.64798454961374,
                        "unit": "µg"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 18.394399999740145,
                        "unit": "mg"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 1.6826902278499225,
                        "unit": "mg"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 4.156856730849155,
                        "unit": "mg"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 47.87403082514704,
                        "unit": "mg"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 3.0198177737994345,
                        "unit": "mg"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 257.827581949927,
                        "unit": "µg"
                    },
                    "FOLFD": {
                        "label": "Folate (food)",
                        "quantity": 257.827581949927,
                        "unit": "µg"
                    },
                    "FOLAC": {
                        "label": "Folic acid",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 31.197721505,
                        "unit": "µg"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 36.20505827,
                        "unit": "µg"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 9.236754763500002,
                        "unit": "mg"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 126.06118368499999,
                        "unit": "µg"
                    },
                    "WATER": {
                        "label": "Water",
                        "quantity": 3304.522463295368,
                        "unit": "g"
                    }
                },
                "totalDaily": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 92.74039280241003,
                        "unit": "%"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 78.57372148384195,
                        "unit": "%"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 70.40504481174621,
                        "unit": "%"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 22.724328749845935,
                        "unit": "%"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 8.436149999909109,
                        "unit": "%"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 536.5279326309819,
                        "unit": "%"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 466.64575995,
                        "unit": "%"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 360.1726121653183,
                        "unit": "%"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 59.15342225462068,
                        "unit": "%"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 110.91737683621663,
                        "unit": "%"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 147.7128933074034,
                        "unit": "%"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 63.080291908630024,
                        "unit": "%"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 79.10947357485429,
                        "unit": "%"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 560.9705232071183,
                        "unit": "%"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 54.738664949957084,
                        "unit": "%"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 20.438222221933493,
                        "unit": "%"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 140.2241856541602,
                        "unit": "%"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 319.7582100653196,
                        "unit": "%"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 299.212692657169,
                        "unit": "%"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 232.29367490764878,
                        "unit": "%"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 64.45689548748175,
                        "unit": "%"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 1299.9050627083334,
                        "unit": "%"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 241.36705513333337,
                        "unit": "%"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 61.57836509000002,
                        "unit": "%"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 105.05098640416666,
                        "unit": "%"
                    }
                },
                "digest": [
                    {
                        "label": "Fat",
                        "tag": "FAT",
                        "schemaOrgTag": "fatContent",
                        "total": 51.07291896449727,
                        "hasRDI": true,
                        "daily": 78.57372148384195,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Saturated",
                                "tag": "FASAT",
                                "schemaOrgTag": "saturatedFatContent",
                                "total": 14.081008962349243,
                                "hasRDI": true,
                                "daily": 70.40504481174621,
                                "unit": "g"
                            },
                            {
                                "label": "Trans",
                                "tag": "FATRN",
                                "schemaOrgTag": "transFatContent",
                                "total": 0.23702529135,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Monounsaturated",
                                "tag": "FAMS",
                                "schemaOrgTag": null,
                                "total": 16.29377243539987,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Polyunsaturated",
                                "tag": "FAPU",
                                "schemaOrgTag": null,
                                "total": 11.260253534399135,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Carbs",
                        "tag": "CHOCDF",
                        "schemaOrgTag": "carbohydrateContent",
                        "total": 68.1729862495378,
                        "hasRDI": true,
                        "daily": 22.724328749845935,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Carbs (net)",
                                "tag": "CHOCDF.net",
                                "schemaOrgTag": null,
                                "total": 66.06394874956052,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Fiber",
                                "tag": "FIBTG",
                                "schemaOrgTag": "fiberContent",
                                "total": 2.109037499977277,
                                "hasRDI": true,
                                "daily": 8.436149999909109,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars",
                                "tag": "SUGAR",
                                "schemaOrgTag": "sugarContent",
                                "total": 29.70477749957825,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars, added",
                                "tag": "SUGAR.added",
                                "schemaOrgTag": null,
                                "total": 24.949999999578246,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Protein",
                        "tag": "PROCNT",
                        "schemaOrgTag": "proteinContent",
                        "total": 268.26396631549096,
                        "hasRDI": true,
                        "daily": 536.5279326309819,
                        "unit": "g"
                    },
                    {
                        "label": "Cholesterol",
                        "tag": "CHOLE",
                        "schemaOrgTag": "cholesterolContent",
                        "total": 1399.93727985,
                        "hasRDI": true,
                        "daily": 466.64575995,
                        "unit": "mg"
                    },
                    {
                        "label": "Sodium",
                        "tag": "NA",
                        "schemaOrgTag": "sodiumContent",
                        "total": 8644.14269196764,
                        "hasRDI": true,
                        "daily": 360.1726121653183,
                        "unit": "mg"
                    },
                    {
                        "label": "Calcium",
                        "tag": "CA",
                        "schemaOrgTag": null,
                        "total": 591.5342225462068,
                        "hasRDI": true,
                        "daily": 59.15342225462068,
                        "unit": "mg"
                    },
                    {
                        "label": "Magnesium",
                        "tag": "MG",
                        "schemaOrgTag": null,
                        "total": 465.8529827121099,
                        "hasRDI": true,
                        "daily": 110.91737683621663,
                        "unit": "mg"
                    },
                    {
                        "label": "Potassium",
                        "tag": "K",
                        "schemaOrgTag": null,
                        "total": 6942.50598544796,
                        "hasRDI": true,
                        "daily": 147.7128933074034,
                        "unit": "mg"
                    },
                    {
                        "label": "Iron",
                        "tag": "FE",
                        "schemaOrgTag": null,
                        "total": 11.354452543553405,
                        "hasRDI": true,
                        "daily": 63.080291908630024,
                        "unit": "mg"
                    },
                    {
                        "label": "Zinc",
                        "tag": "ZN",
                        "schemaOrgTag": null,
                        "total": 8.702042093233972,
                        "hasRDI": true,
                        "daily": 79.10947357485429,
                        "unit": "mg"
                    },
                    {
                        "label": "Phosphorus",
                        "tag": "P",
                        "schemaOrgTag": null,
                        "total": 3926.793662449828,
                        "hasRDI": true,
                        "daily": 560.9705232071183,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin A",
                        "tag": "VITA_RAE",
                        "schemaOrgTag": null,
                        "total": 492.64798454961374,
                        "hasRDI": true,
                        "daily": 54.738664949957084,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin C",
                        "tag": "VITC",
                        "schemaOrgTag": null,
                        "total": 18.394399999740145,
                        "hasRDI": true,
                        "daily": 20.438222221933493,
                        "unit": "mg"
                    },
                    {
                        "label": "Thiamin (B1)",
                        "tag": "THIA",
                        "schemaOrgTag": null,
                        "total": 1.6826902278499225,
                        "hasRDI": true,
                        "daily": 140.2241856541602,
                        "unit": "mg"
                    },
                    {
                        "label": "Riboflavin (B2)",
                        "tag": "RIBF",
                        "schemaOrgTag": null,
                        "total": 4.156856730849155,
                        "hasRDI": true,
                        "daily": 319.7582100653196,
                        "unit": "mg"
                    },
                    {
                        "label": "Niacin (B3)",
                        "tag": "NIA",
                        "schemaOrgTag": null,
                        "total": 47.87403082514704,
                        "hasRDI": true,
                        "daily": 299.212692657169,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin B6",
                        "tag": "VITB6A",
                        "schemaOrgTag": null,
                        "total": 3.0198177737994345,
                        "hasRDI": true,
                        "daily": 232.29367490764878,
                        "unit": "mg"
                    },
                    {
                        "label": "Folate equivalent (total)",
                        "tag": "FOLDFE",
                        "schemaOrgTag": null,
                        "total": 257.827581949927,
                        "hasRDI": true,
                        "daily": 64.45689548748175,
                        "unit": "µg"
                    },
                    {
                        "label": "Folate (food)",
                        "tag": "FOLFD",
                        "schemaOrgTag": null,
                        "total": 257.827581949927,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Folic acid",
                        "tag": "FOLAC",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin B12",
                        "tag": "VITB12",
                        "schemaOrgTag": null,
                        "total": 31.197721505,
                        "hasRDI": true,
                        "daily": 1299.9050627083334,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin D",
                        "tag": "VITD",
                        "schemaOrgTag": null,
                        "total": 36.20505827,
                        "hasRDI": true,
                        "daily": 241.36705513333337,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin E",
                        "tag": "TOCPHA",
                        "schemaOrgTag": null,
                        "total": 9.236754763500002,
                        "hasRDI": true,
                        "daily": 61.57836509000002,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin K",
                        "tag": "VITK1",
                        "schemaOrgTag": null,
                        "total": 126.06118368499999,
                        "hasRDI": true,
                        "daily": 105.05098640416666,
                        "unit": "µg"
                    },
                    {
                        "label": "Sugar alcohols",
                        "tag": "Sugar.alcohol",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    },
                    {
                        "label": "Water",
                        "tag": "WATER",
                        "schemaOrgTag": null,
                        "total": 3304.522463295368,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    }
                ]
            },
            "_links": {
                "self": {
                    "href": "https://api.edamam.com/api/recipes/v2/06da4c0d8b1cabca809b4a9a6ad1e5ef?type=public&app_id=ea1d37d5&app_key=fd382a172ba8d6668c0430dc9c14a181",
                    "title": "Self"
                }
            }
        },
        {
            "recipe": {
                "uri": "http://www.edamam.com/ontologies/edamam.owl#recipe_153422abe8bef3f0a7ca1856a26357d6",
                "label": "Gefilte Fish",
                "image": "https://www.edamam.com/web-img/f47/f474b766365ea7d1a1741632916cafdc.jpg",
                "source": "Cookstr",
                "url": "http://www.cookstr.com/recipes/gefilte-fish-sharon-lebewohl",
                "shareAs": "http://www.edamam.com/recipe/gefilte-fish-153422abe8bef3f0a7ca1856a26357d6/fish",
                "yield": 12,
                "dietLabels": [],
                "healthLabels": [
                    "Pescatarian",
                    "Dairy-Free",
                    "Peanut-Free",
                    "Tree-Nut-Free",
                    "Soy-Free",
                    "Shellfish-Free",
                    "Pork-Free",
                    "Red-Meat-Free",
                    "Crustacean-Free",
                    "Mustard-Free",
                    "Sesame-Free",
                    "Lupine-Free",
                    "Mollusk-Free",
                    "Alcohol-Free",
                    "Kosher"
                ],
                "cautions": [
                    "FODMAP"
                ],
                "ingredientLines": [
                    "One 1 ½-pound fillet of whitefish and one ½-pound fillet of carp or pike (at fish store, ask for whole fish, filleted and skinned. Retain the heads and bones. Many stores will also grind the fish for you)",
                    "2 large onions (about 2 cups when grated; don’t tamp it down)",
                    "1 stalk celery",
                    "½ medium carrot",
                    "6 eggs, beaten",
                    "4 teaspoons sugar",
                    "2 ½ teaspoons salt",
                    "3/8 teaspoon pepper",
                    "¾ cup corn oil",
                    "1 cup matzo meal",
                    "Heads and bones from fish",
                    "4 medium onions, peeled and quartered",
                    "2 stalks celery, trimmed and chopped into 3-inch pieces",
                    "2 medium carrots, peeled"
                ],
                "ingredients": [
                    {
                        "text": "One 1 ½-pound fillet of whitefish and one ½-pound fillet of carp or pike (at fish store, ask for whole fish, filleted and skinned. Retain the heads and bones. Many stores will also grind the fish for you)",
                        "weight": 680.388555,
                        "foodCategory": "seafood",
                        "foodId": "food_bb1pfncbc3in4oah7evxxbqm5jto",
                        "image": "https://www.edamam.com/food-img/e1d/e1d5bd23d0f91c83654ca8dff839e658.jpg"
                    },
                    {
                        "text": "One 1 ½-pound fillet of whitefish and one ½-pound fillet of carp or pike (at fish store, ask for whole fish, filleted and skinned. Retain the heads and bones. Many stores will also grind the fish for you)",
                        "weight": 226.796185,
                        "foodCategory": "seafood",
                        "foodId": "food_bix81n0bxzg81cav7eoccb0w7826",
                        "image": "https://www.edamam.com/food-img/e59/e59950f1e05a1d0555a38f2e42f8002c.jpg"
                    },
                    {
                        "text": "2 large onions (about 2 cups when grated; don’t tamp it down)",
                        "weight": 300,
                        "foodCategory": "vegetables",
                        "foodId": "food_bmrvi4ob4binw9a5m7l07amlfcoy",
                        "image": "https://www.edamam.com/food-img/205/205e6bf2399b85d34741892ef91cc603.jpg"
                    },
                    {
                        "text": "1 stalk celery",
                        "weight": 40,
                        "foodCategory": "vegetables",
                        "foodId": "food_bffeoksbyyur8ja4da73ub2xs57g",
                        "image": "https://www.edamam.com/food-img/d91/d91d2aed1c36d8fad54c4d7dc58f5a18.jpg"
                    },
                    {
                        "text": "½ medium carrot",
                        "weight": 30.5,
                        "foodCategory": "vegetables",
                        "foodId": "food_ai215e5b85pdh5ajd4aafa3w2zm8",
                        "image": "https://www.edamam.com/food-img/121/121e33fce0bb9546ed7d060b6c114e29.jpg"
                    },
                    {
                        "text": "6 eggs, beaten",
                        "weight": 258,
                        "foodCategory": "Eggs",
                        "foodId": "food_bhpradua77pk16aipcvzeayg732r",
                        "image": "https://www.edamam.com/food-img/a7e/a7ec7c337cb47c6550b3b118e357f077.jpg"
                    },
                    {
                        "text": "4 teaspoons sugar",
                        "weight": 16.8,
                        "foodCategory": "sugars",
                        "foodId": "food_axi2ijobrk819yb0adceobnhm1c2",
                        "image": "https://www.edamam.com/food-img/ecb/ecb3f5aaed96d0188c21b8369be07765.jpg"
                    },
                    {
                        "text": "2 ½ teaspoons salt",
                        "weight": 15,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_btxz81db72hwbra2pncvebzzzum9",
                        "image": "https://www.edamam.com/food-img/694/6943ea510918c6025795e8dc6e6eaaeb.jpg"
                    },
                    {
                        "text": "3/8 teaspoon pepper",
                        "weight": 1.0875,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_b6ywzluaaxv02wad7s1r9ag4py89",
                        "image": "https://www.edamam.com/food-img/c6e/c6e5c3bd8d3bc15175d9766971a4d1b2.jpg"
                    },
                    {
                        "text": "¾ cup corn oil",
                        "weight": 163.5,
                        "foodCategory": "Oils",
                        "foodId": "food_a95yektamj1kj1boxuadmae6p9l4",
                        "image": "https://www.edamam.com/food-img/cd4/cd4ea698cb19a1eb94569a09121dbbd2.jpg"
                    },
                    {
                        "text": "1 cup matzo meal",
                        "weight": 55,
                        "foodCategory": "crackers",
                        "foodId": "food_a7qwjpbarote7sbjmkrfiaovtoo3",
                        "image": "https://www.edamam.com/food-img/656/656d9f10022c99adde7b67b03b5b17b2.jpg"
                    },
                    {
                        "text": "Heads and bones from fish",
                        "weight": 0,
                        "foodCategory": "seafood",
                        "foodId": "food_ar6pjbvaxqtlqia7jewa4brld7p9",
                        "image": "https://www.edamam.com/food-img/717/717cb400eb49626bb7c95cd29292cef4.jpg"
                    },
                    {
                        "text": "Heads and bones from fish",
                        "weight": 0,
                        "foodCategory": "seafood",
                        "foodId": "food_ar6pjbvaxqtlqia7jewa4brld7p9",
                        "image": "https://www.edamam.com/food-img/717/717cb400eb49626bb7c95cd29292cef4.jpg"
                    },
                    {
                        "text": "4 medium onions, peeled and quartered",
                        "weight": 440,
                        "foodCategory": "vegetables",
                        "foodId": "food_bmrvi4ob4binw9a5m7l07amlfcoy",
                        "image": "https://www.edamam.com/food-img/205/205e6bf2399b85d34741892ef91cc603.jpg"
                    },
                    {
                        "text": "2 stalks celery, trimmed and chopped into 3-inch pieces",
                        "weight": 80,
                        "foodCategory": "vegetables",
                        "foodId": "food_bffeoksbyyur8ja4da73ub2xs57g",
                        "image": "https://www.edamam.com/food-img/d91/d91d2aed1c36d8fad54c4d7dc58f5a18.jpg"
                    },
                    {
                        "text": "2 medium carrots, peeled",
                        "weight": 122,
                        "foodCategory": "vegetables",
                        "foodId": "food_ai215e5b85pdh5ajd4aafa3w2zm8",
                        "image": "https://www.edamam.com/food-img/121/121e33fce0bb9546ed7d060b6c114e29.jpg"
                    }
                ],
                "calories": 3682.5007870000004,
                "totalWeight": 2425.8328517936307,
                "totalTime": 0.5,
                "cuisineType": [
                    "mediterranean"
                ],
                "mealType": [
                    "lunch/dinner"
                ],
                "dishType": [
                    "condiments and sauces"
                ],
                "totalNutrients": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 3682.5007870000004,
                        "unit": "kcal"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 244.35554071500002,
                        "unit": "g"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 41.56964888705001,
                        "unit": "g"
                    },
                    "FATRN": {
                        "label": "Trans",
                        "quantity": 0.09804,
                        "unit": "g"
                    },
                    "FAMS": {
                        "label": "Monounsaturated",
                        "quantity": 77.4559988198,
                        "unit": "g"
                    },
                    "FAPU": {
                        "label": "Polyunsaturated",
                        "quantity": 110.69732835834999,
                        "unit": "g"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 152.67419625000002,
                        "unit": "g"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 20.6951375,
                        "unit": "g"
                    },
                    "SUGAR": {
                        "label": "Sugars",
                        "quantity": 58.09996,
                        "unit": "g"
                    },
                    "SUGAR.added": {
                        "label": "Sugars, added",
                        "quantity": 16.7664,
                        "unit": "g"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 217.4352379305,
                        "unit": "g"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 1483.6591873500001,
                        "unit": "mg"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 5613.876712675201,
                        "unit": "mg"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 520.9496076804713,
                        "unit": "mg"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 442.48634791793626,
                        "unit": "mg"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 5225.83273934349,
                        "unit": "mg"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 13.442705772418979,
                        "unit": "mg"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 15.60101209429363,
                        "unit": "mg"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 3704.5753717499997,
                        "unit": "mg"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 1733.28028165,
                        "unit": "µg"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 71.10623896000001,
                        "unit": "mg"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 1.9287952342499999,
                        "unit": "mg"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 2.7101525232499997,
                        "unit": "mg"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 8.807462559000001,
                        "unit": "mg"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 2.1231773764999997,
                        "unit": "mg"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 377.58930275000006,
                        "unit": "µg"
                    },
                    "FOLFD": {
                        "label": "Folate (food)",
                        "quantity": 377.58930275000006,
                        "unit": "µg"
                    },
                    "FOLAC": {
                        "label": "Folic acid",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 5.7661816305,
                        "unit": "µg"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 61.17865769500001,
                        "unit": "µg"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 29.041125965500004,
                        "unit": "mg"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 64.302533685,
                        "unit": "µg"
                    },
                    "WATER": {
                        "label": "Water",
                        "quantity": 1775.9576705370873,
                        "unit": "g"
                    }
                },
                "totalDaily": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 184.12503935,
                        "unit": "%"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 375.9316011,
                        "unit": "%"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 207.84824443525002,
                        "unit": "%"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 50.89139875000001,
                        "unit": "%"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 82.78055,
                        "unit": "%"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 434.870475861,
                        "unit": "%"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 494.55306245,
                        "unit": "%"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 233.9115296948,
                        "unit": "%"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 52.09496076804713,
                        "unit": "%"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 105.3538923614134,
                        "unit": "%"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 111.18793062432958,
                        "unit": "%"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 74.68169873566099,
                        "unit": "%"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 141.82738267539665,
                        "unit": "%"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 529.2250531071428,
                        "unit": "%"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 192.5866979611111,
                        "unit": "%"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 79.00693217777778,
                        "unit": "%"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 160.7329361875,
                        "unit": "%"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 208.47327101923074,
                        "unit": "%"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 55.04664099375,
                        "unit": "%"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 163.32133665384612,
                        "unit": "%"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 94.39732568750001,
                        "unit": "%"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 240.25756793750003,
                        "unit": "%"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 407.8577179666667,
                        "unit": "%"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 193.6075064366667,
                        "unit": "%"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 53.5854447375,
                        "unit": "%"
                    }
                },
                "digest": [
                    {
                        "label": "Fat",
                        "tag": "FAT",
                        "schemaOrgTag": "fatContent",
                        "total": 244.35554071500002,
                        "hasRDI": true,
                        "daily": 375.9316011,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Saturated",
                                "tag": "FASAT",
                                "schemaOrgTag": "saturatedFatContent",
                                "total": 41.56964888705001,
                                "hasRDI": true,
                                "daily": 207.84824443525002,
                                "unit": "g"
                            },
                            {
                                "label": "Trans",
                                "tag": "FATRN",
                                "schemaOrgTag": "transFatContent",
                                "total": 0.09804,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Monounsaturated",
                                "tag": "FAMS",
                                "schemaOrgTag": null,
                                "total": 77.4559988198,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Polyunsaturated",
                                "tag": "FAPU",
                                "schemaOrgTag": null,
                                "total": 110.69732835834999,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Carbs",
                        "tag": "CHOCDF",
                        "schemaOrgTag": "carbohydrateContent",
                        "total": 152.67419625000002,
                        "hasRDI": true,
                        "daily": 50.89139875000001,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Carbs (net)",
                                "tag": "CHOCDF.net",
                                "schemaOrgTag": null,
                                "total": 131.97905875000004,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Fiber",
                                "tag": "FIBTG",
                                "schemaOrgTag": "fiberContent",
                                "total": 20.6951375,
                                "hasRDI": true,
                                "daily": 82.78055,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars",
                                "tag": "SUGAR",
                                "schemaOrgTag": "sugarContent",
                                "total": 58.09996,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars, added",
                                "tag": "SUGAR.added",
                                "schemaOrgTag": null,
                                "total": 16.7664,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Protein",
                        "tag": "PROCNT",
                        "schemaOrgTag": "proteinContent",
                        "total": 217.4352379305,
                        "hasRDI": true,
                        "daily": 434.870475861,
                        "unit": "g"
                    },
                    {
                        "label": "Cholesterol",
                        "tag": "CHOLE",
                        "schemaOrgTag": "cholesterolContent",
                        "total": 1483.6591873500001,
                        "hasRDI": true,
                        "daily": 494.55306245,
                        "unit": "mg"
                    },
                    {
                        "label": "Sodium",
                        "tag": "NA",
                        "schemaOrgTag": "sodiumContent",
                        "total": 5613.876712675201,
                        "hasRDI": true,
                        "daily": 233.9115296948,
                        "unit": "mg"
                    },
                    {
                        "label": "Calcium",
                        "tag": "CA",
                        "schemaOrgTag": null,
                        "total": 520.9496076804713,
                        "hasRDI": true,
                        "daily": 52.09496076804713,
                        "unit": "mg"
                    },
                    {
                        "label": "Magnesium",
                        "tag": "MG",
                        "schemaOrgTag": null,
                        "total": 442.48634791793626,
                        "hasRDI": true,
                        "daily": 105.3538923614134,
                        "unit": "mg"
                    },
                    {
                        "label": "Potassium",
                        "tag": "K",
                        "schemaOrgTag": null,
                        "total": 5225.83273934349,
                        "hasRDI": true,
                        "daily": 111.18793062432958,
                        "unit": "mg"
                    },
                    {
                        "label": "Iron",
                        "tag": "FE",
                        "schemaOrgTag": null,
                        "total": 13.442705772418979,
                        "hasRDI": true,
                        "daily": 74.68169873566099,
                        "unit": "mg"
                    },
                    {
                        "label": "Zinc",
                        "tag": "ZN",
                        "schemaOrgTag": null,
                        "total": 15.60101209429363,
                        "hasRDI": true,
                        "daily": 141.82738267539665,
                        "unit": "mg"
                    },
                    {
                        "label": "Phosphorus",
                        "tag": "P",
                        "schemaOrgTag": null,
                        "total": 3704.5753717499997,
                        "hasRDI": true,
                        "daily": 529.2250531071428,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin A",
                        "tag": "VITA_RAE",
                        "schemaOrgTag": null,
                        "total": 1733.28028165,
                        "hasRDI": true,
                        "daily": 192.5866979611111,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin C",
                        "tag": "VITC",
                        "schemaOrgTag": null,
                        "total": 71.10623896000001,
                        "hasRDI": true,
                        "daily": 79.00693217777778,
                        "unit": "mg"
                    },
                    {
                        "label": "Thiamin (B1)",
                        "tag": "THIA",
                        "schemaOrgTag": null,
                        "total": 1.9287952342499999,
                        "hasRDI": true,
                        "daily": 160.7329361875,
                        "unit": "mg"
                    },
                    {
                        "label": "Riboflavin (B2)",
                        "tag": "RIBF",
                        "schemaOrgTag": null,
                        "total": 2.7101525232499997,
                        "hasRDI": true,
                        "daily": 208.47327101923074,
                        "unit": "mg"
                    },
                    {
                        "label": "Niacin (B3)",
                        "tag": "NIA",
                        "schemaOrgTag": null,
                        "total": 8.807462559000001,
                        "hasRDI": true,
                        "daily": 55.04664099375,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin B6",
                        "tag": "VITB6A",
                        "schemaOrgTag": null,
                        "total": 2.1231773764999997,
                        "hasRDI": true,
                        "daily": 163.32133665384612,
                        "unit": "mg"
                    },
                    {
                        "label": "Folate equivalent (total)",
                        "tag": "FOLDFE",
                        "schemaOrgTag": null,
                        "total": 377.58930275000006,
                        "hasRDI": true,
                        "daily": 94.39732568750001,
                        "unit": "µg"
                    },
                    {
                        "label": "Folate (food)",
                        "tag": "FOLFD",
                        "schemaOrgTag": null,
                        "total": 377.58930275000006,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Folic acid",
                        "tag": "FOLAC",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin B12",
                        "tag": "VITB12",
                        "schemaOrgTag": null,
                        "total": 5.7661816305,
                        "hasRDI": true,
                        "daily": 240.25756793750003,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin D",
                        "tag": "VITD",
                        "schemaOrgTag": null,
                        "total": 61.17865769500001,
                        "hasRDI": true,
                        "daily": 407.8577179666667,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin E",
                        "tag": "TOCPHA",
                        "schemaOrgTag": null,
                        "total": 29.041125965500004,
                        "hasRDI": true,
                        "daily": 193.6075064366667,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin K",
                        "tag": "VITK1",
                        "schemaOrgTag": null,
                        "total": 64.302533685,
                        "hasRDI": true,
                        "daily": 53.5854447375,
                        "unit": "µg"
                    },
                    {
                        "label": "Sugar alcohols",
                        "tag": "Sugar.alcohol",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    },
                    {
                        "label": "Water",
                        "tag": "WATER",
                        "schemaOrgTag": null,
                        "total": 1775.9576705370873,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    }
                ]
            },
            "_links": {
                "self": {
                    "href": "https://api.edamam.com/api/recipes/v2/153422abe8bef3f0a7ca1856a26357d6?type=public&app_id=ea1d37d5&app_key=fd382a172ba8d6668c0430dc9c14a181",
                    "title": "Self"
                }
            }
        },
        {
            "recipe": {
                "uri": "http://www.edamam.com/ontologies/edamam.owl#recipe_3f7248b6cc70bfc977bddfa4f5943c72",
                "label": "Caramelised Fish Clay Pot",
                "image": "https://www.edamam.com/web-img/5dc/5dc06862abccac60100757a771b1103c.jpg",
                "source": "Donna Hay",
                "url": "http://www.donnahay.com.au/recipes/onepot/seafood/caramelised-fish-clay-pot",
                "shareAs": "http://www.edamam.com/recipe/caramelised-fish-clay-pot-3f7248b6cc70bfc977bddfa4f5943c72/fish",
                "yield": 8,
                "dietLabels": [
                    "High-Protein"
                ],
                "healthLabels": [
                    "Pescatarian",
                    "Dairy-Free",
                    "Gluten-Free",
                    "Wheat-Free",
                    "Egg-Free",
                    "Peanut-Free",
                    "Tree-Nut-Free",
                    "Soy-Free",
                    "Pork-Free",
                    "Red-Meat-Free",
                    "Celery-Free",
                    "Mustard-Free",
                    "Sesame-Free",
                    "Lupine-Free",
                    "Alcohol-Free"
                ],
                "cautions": [
                    "Shellfish",
                    "Sulfites",
                    "FODMAP"
                ],
                "ingredientLines": [
                    "½ cup (75g) caster (superfine) sugar",
                    "600 g firm white fish fillets, skin on and chopped",
                    "600 g clams (vongole), soaked and drained+",
                    "1 ½ tablespoon vegetable oil",
                    "4 cloves garlic, crushed",
                    "4 green onions (scallions), chopped",
                    "⅓ cup (80ml) fish sauce",
                    "2 long red chillies, sliced",
                    "¼ cup mint leaves",
                    "¼ cup Vietnamese mint leaves",
                    "lime wedges, to serve"
                ],
                "ingredients": [
                    {
                        "text": "½ cup (75g) caster (superfine) sugar",
                        "weight": 75,
                        "foodCategory": "sugars",
                        "foodId": "food_axi2ijobrk819yb0adceobnhm1c2",
                        "image": "https://www.edamam.com/food-img/ecb/ecb3f5aaed96d0188c21b8369be07765.jpg"
                    },
                    {
                        "text": "600 g firm white fish fillets, skin on and chopped",
                        "weight": 600,
                        "foodCategory": "seafood",
                        "foodId": "food_ar6pjbvaxqtlqia7jewa4brld7p9",
                        "image": "https://www.edamam.com/food-img/717/717cb400eb49626bb7c95cd29292cef4.jpg"
                    },
                    {
                        "text": "600 g clams (vongole), soaked and drained+",
                        "weight": 600,
                        "foodCategory": "seafood",
                        "foodId": "food_b12syzgajx227eahiup7wb240d41",
                        "image": "https://www.edamam.com/food-img/cdb/cdb6d4a1acc0b81c643ba1a52c5cd95b.jpg"
                    },
                    {
                        "text": "1 ½ tablespoon vegetable oil",
                        "weight": 21,
                        "foodCategory": "Oils",
                        "foodId": "food_bt1mzi2ah2sfg8bv7no1qai83w8s",
                        "image": "https://www.edamam.com/food-img/6e5/6e51a63a6300a8ea1b4c4cc68dfaba33.jpg"
                    },
                    {
                        "text": "4 cloves garlic, crushed",
                        "weight": 12,
                        "foodCategory": "vegetables",
                        "foodId": "food_avtcmx6bgjv1jvay6s6stan8dnyp",
                        "image": "https://www.edamam.com/food-img/6ee/6ee142951f48aaf94f4312409f8d133d.jpg"
                    },
                    {
                        "text": "4 green onions (scallions), chopped",
                        "weight": 60,
                        "foodCategory": "vegetables",
                        "foodId": "food_bknlkyzbuzo27pb11whr4bttkuy6",
                        "image": "https://www.edamam.com/food-img/b89/b89986ed6aa466285bdd99bac34b3c46.jpg"
                    },
                    {
                        "text": "⅓ cup (80ml) fish sauce",
                        "weight": 97.38438538295429,
                        "foodCategory": "canned soup",
                        "foodId": "food_ahlu6u3ab8bu1wap7cbqua3s1quk",
                        "image": "https://www.edamam.com/food-img/7b5/7b58b769d8bf7b79acf12a76b79ea9bc.jpg"
                    },
                    {
                        "text": "2 long red chillies, sliced",
                        "weight": 90,
                        "foodCategory": "vegetables",
                        "foodId": "food_a6g98mqatzj7vca6ms3bnbzqxf3s",
                        "image": "https://www.edamam.com/food-img/469/469213672957a242638e20c27e3e8acd.jpeg"
                    },
                    {
                        "text": "¼ cup mint leaves",
                        "weight": 22.800000000385474,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_bxl4xoga4owdkeay51sy8anesxj5",
                        "image": "https://www.edamam.com/food-img/7f0/7f01cc4f71c5c6ad31051ed74b9c058b.jpg"
                    },
                    {
                        "text": "¼ cup Vietnamese mint leaves",
                        "weight": 22.800000000385474,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_bxl4xoga4owdkeay51sy8anesxj5",
                        "image": "https://www.edamam.com/food-img/7f0/7f01cc4f71c5c6ad31051ed74b9c058b.jpg"
                    },
                    {
                        "text": "lime wedges, to serve",
                        "weight": 8.375,
                        "foodCategory": "fruit",
                        "foodId": "food_av58muyb8kg92fbk0g8g8aui5knv",
                        "image": "https://www.edamam.com/food-img/48a/48a123c9576647c4ada6a41df5eeb22a.jpg"
                    }
                ],
                "calories": 1697.631034884373,
                "totalWeight": 1609.3593853837256,
                "totalTime": 0,
                "cuisineType": [
                    "french"
                ],
                "mealType": [
                    "lunch/dinner"
                ],
                "dishType": [
                    "condiments and sauces"
                ],
                "totalNutrients": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 1697.631034884373,
                        "unit": "kcal"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 37.889368438543926,
                        "unit": "g"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 6.158850031562961,
                        "unit": "g"
                    },
                    "FATRN": {
                        "label": "Trans",
                        "quantity": 0.25107,
                        "unit": "g"
                    },
                    "FAMS": {
                        "label": "Monounsaturated",
                        "quantity": 18.880168937707854,
                        "unit": "g"
                    },
                    "FAPU": {
                        "label": "Polyunsaturated",
                        "quantity": 7.397151781564526,
                        "unit": "g"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 120.96767662800436,
                        "unit": "g"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 6.497300000052424,
                        "unit": "g"
                    },
                    "SUGAR": {
                        "label": "Sugars",
                        "quantity": 84.82432912793952,
                        "unit": "g"
                    },
                    "SUGAR.added": {
                        "label": "Sugars, added",
                        "quantity": 74.85,
                        "unit": "g"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 218.53071490040287,
                        "unit": "g"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 480,
                        "unit": "mg"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 11597.98559641597,
                        "unit": "mg"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 507.6530357162046,
                        "unit": "mg"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 511.3531744206557,
                        "unit": "mg"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 3090.877529906439,
                        "unit": "mg"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 21.359068206078554,
                        "unit": "mg"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 6.355721270774313,
                        "unit": "mg"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 2322.9444069772694,
                        "unit": "mg"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 709.8308754168833,
                        "unit": "µg"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 153.3428469270173,
                        "unit": "mg"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 0.5075666262465559,
                        "unit": "mg"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 0.9078340996696332,
                        "unit": "mg"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 29.73813883391504,
                        "unit": "mg"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 2.1334914161177174,
                        "unit": "mg"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 331.67603654611617,
                        "unit": "µg"
                    },
                    "FOLFD": {
                        "label": "Folate (food)",
                        "quantity": 331.67603654611617,
                        "unit": "µg"
                    },
                    "FOLAC": {
                        "label": "Folic acid",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 77.62744504983817,
                        "unit": "µg"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 18.6,
                        "unit": "µg"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 12.037025000000002,
                        "unit": "mg"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 146.65425,
                        "unit": "µg"
                    },
                    "WATER": {
                        "label": "Water",
                        "quantity": 1198.134257692325,
                        "unit": "g"
                    }
                },
                "totalDaily": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 84.88155174421865,
                        "unit": "%"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 58.291336059298345,
                        "unit": "%"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 30.794250157814805,
                        "unit": "%"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 40.32255887600145,
                        "unit": "%"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 25.989200000209692,
                        "unit": "%"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 437.0614298008057,
                        "unit": "%"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 160,
                        "unit": "%"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 483.24939985066544,
                        "unit": "%"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 50.765303571620464,
                        "unit": "%"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 121.75075581444183,
                        "unit": "%"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 65.763351700137,
                        "unit": "%"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 118.66149003376975,
                        "unit": "%"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 57.779284279766486,
                        "unit": "%"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 331.84920099675276,
                        "unit": "%"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 78.87009726854258,
                        "unit": "%"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 170.38094103001922,
                        "unit": "%"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 42.29721885387966,
                        "unit": "%"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 69.83339228227948,
                        "unit": "%"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 185.863367711969,
                        "unit": "%"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 164.1147243167475,
                        "unit": "%"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 82.91900913652904,
                        "unit": "%"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 3234.4768770765904,
                        "unit": "%"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 124.00000000000001,
                        "unit": "%"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 80.24683333333334,
                        "unit": "%"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 122.21187499999999,
                        "unit": "%"
                    }
                },
                "digest": [
                    {
                        "label": "Fat",
                        "tag": "FAT",
                        "schemaOrgTag": "fatContent",
                        "total": 37.889368438543926,
                        "hasRDI": true,
                        "daily": 58.291336059298345,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Saturated",
                                "tag": "FASAT",
                                "schemaOrgTag": "saturatedFatContent",
                                "total": 6.158850031562961,
                                "hasRDI": true,
                                "daily": 30.794250157814805,
                                "unit": "g"
                            },
                            {
                                "label": "Trans",
                                "tag": "FATRN",
                                "schemaOrgTag": "transFatContent",
                                "total": 0.25107,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Monounsaturated",
                                "tag": "FAMS",
                                "schemaOrgTag": null,
                                "total": 18.880168937707854,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Polyunsaturated",
                                "tag": "FAPU",
                                "schemaOrgTag": null,
                                "total": 7.397151781564526,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Carbs",
                        "tag": "CHOCDF",
                        "schemaOrgTag": "carbohydrateContent",
                        "total": 120.96767662800436,
                        "hasRDI": true,
                        "daily": 40.32255887600145,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Carbs (net)",
                                "tag": "CHOCDF.net",
                                "schemaOrgTag": null,
                                "total": 114.47037662795194,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Fiber",
                                "tag": "FIBTG",
                                "schemaOrgTag": "fiberContent",
                                "total": 6.497300000052424,
                                "hasRDI": true,
                                "daily": 25.989200000209692,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars",
                                "tag": "SUGAR",
                                "schemaOrgTag": "sugarContent",
                                "total": 84.82432912793952,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars, added",
                                "tag": "SUGAR.added",
                                "schemaOrgTag": null,
                                "total": 74.85,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Protein",
                        "tag": "PROCNT",
                        "schemaOrgTag": "proteinContent",
                        "total": 218.53071490040287,
                        "hasRDI": true,
                        "daily": 437.0614298008057,
                        "unit": "g"
                    },
                    {
                        "label": "Cholesterol",
                        "tag": "CHOLE",
                        "schemaOrgTag": "cholesterolContent",
                        "total": 480,
                        "hasRDI": true,
                        "daily": 160,
                        "unit": "mg"
                    },
                    {
                        "label": "Sodium",
                        "tag": "NA",
                        "schemaOrgTag": "sodiumContent",
                        "total": 11597.98559641597,
                        "hasRDI": true,
                        "daily": 483.24939985066544,
                        "unit": "mg"
                    },
                    {
                        "label": "Calcium",
                        "tag": "CA",
                        "schemaOrgTag": null,
                        "total": 507.6530357162046,
                        "hasRDI": true,
                        "daily": 50.765303571620464,
                        "unit": "mg"
                    },
                    {
                        "label": "Magnesium",
                        "tag": "MG",
                        "schemaOrgTag": null,
                        "total": 511.3531744206557,
                        "hasRDI": true,
                        "daily": 121.75075581444183,
                        "unit": "mg"
                    },
                    {
                        "label": "Potassium",
                        "tag": "K",
                        "schemaOrgTag": null,
                        "total": 3090.877529906439,
                        "hasRDI": true,
                        "daily": 65.763351700137,
                        "unit": "mg"
                    },
                    {
                        "label": "Iron",
                        "tag": "FE",
                        "schemaOrgTag": null,
                        "total": 21.359068206078554,
                        "hasRDI": true,
                        "daily": 118.66149003376975,
                        "unit": "mg"
                    },
                    {
                        "label": "Zinc",
                        "tag": "ZN",
                        "schemaOrgTag": null,
                        "total": 6.355721270774313,
                        "hasRDI": true,
                        "daily": 57.779284279766486,
                        "unit": "mg"
                    },
                    {
                        "label": "Phosphorus",
                        "tag": "P",
                        "schemaOrgTag": null,
                        "total": 2322.9444069772694,
                        "hasRDI": true,
                        "daily": 331.84920099675276,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin A",
                        "tag": "VITA_RAE",
                        "schemaOrgTag": null,
                        "total": 709.8308754168833,
                        "hasRDI": true,
                        "daily": 78.87009726854258,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin C",
                        "tag": "VITC",
                        "schemaOrgTag": null,
                        "total": 153.3428469270173,
                        "hasRDI": true,
                        "daily": 170.38094103001922,
                        "unit": "mg"
                    },
                    {
                        "label": "Thiamin (B1)",
                        "tag": "THIA",
                        "schemaOrgTag": null,
                        "total": 0.5075666262465559,
                        "hasRDI": true,
                        "daily": 42.29721885387966,
                        "unit": "mg"
                    },
                    {
                        "label": "Riboflavin (B2)",
                        "tag": "RIBF",
                        "schemaOrgTag": null,
                        "total": 0.9078340996696332,
                        "hasRDI": true,
                        "daily": 69.83339228227948,
                        "unit": "mg"
                    },
                    {
                        "label": "Niacin (B3)",
                        "tag": "NIA",
                        "schemaOrgTag": null,
                        "total": 29.73813883391504,
                        "hasRDI": true,
                        "daily": 185.863367711969,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin B6",
                        "tag": "VITB6A",
                        "schemaOrgTag": null,
                        "total": 2.1334914161177174,
                        "hasRDI": true,
                        "daily": 164.1147243167475,
                        "unit": "mg"
                    },
                    {
                        "label": "Folate equivalent (total)",
                        "tag": "FOLDFE",
                        "schemaOrgTag": null,
                        "total": 331.67603654611617,
                        "hasRDI": true,
                        "daily": 82.91900913652904,
                        "unit": "µg"
                    },
                    {
                        "label": "Folate (food)",
                        "tag": "FOLFD",
                        "schemaOrgTag": null,
                        "total": 331.67603654611617,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Folic acid",
                        "tag": "FOLAC",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin B12",
                        "tag": "VITB12",
                        "schemaOrgTag": null,
                        "total": 77.62744504983817,
                        "hasRDI": true,
                        "daily": 3234.4768770765904,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin D",
                        "tag": "VITD",
                        "schemaOrgTag": null,
                        "total": 18.6,
                        "hasRDI": true,
                        "daily": 124.00000000000001,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin E",
                        "tag": "TOCPHA",
                        "schemaOrgTag": null,
                        "total": 12.037025000000002,
                        "hasRDI": true,
                        "daily": 80.24683333333334,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin K",
                        "tag": "VITK1",
                        "schemaOrgTag": null,
                        "total": 146.65425,
                        "hasRDI": true,
                        "daily": 122.21187499999999,
                        "unit": "µg"
                    },
                    {
                        "label": "Sugar alcohols",
                        "tag": "Sugar.alcohol",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    },
                    {
                        "label": "Water",
                        "tag": "WATER",
                        "schemaOrgTag": null,
                        "total": 1198.134257692325,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    }
                ]
            },
            "_links": {
                "self": {
                    "href": "https://api.edamam.com/api/recipes/v2/3f7248b6cc70bfc977bddfa4f5943c72?type=public&app_id=ea1d37d5&app_key=fd382a172ba8d6668c0430dc9c14a181",
                    "title": "Self"
                }
            }
        },
        {
            "recipe": {
                "uri": "http://www.edamam.com/ontologies/edamam.owl#recipe_ca4b9c788a47825fcad7e5f5cbad716d",
                "label": "Fish Sticks",
                "image": "https://www.edamam.com/web-img/df4/df4b369889556c6c2f9df613b979a730.jpg",
                "source": "Elana's Pantry",
                "url": "http://www.elanaspantry.com/fish-sticks/",
                "shareAs": "http://www.edamam.com/recipe/fish-sticks-ca4b9c788a47825fcad7e5f5cbad716d/fish",
                "yield": 4,
                "dietLabels": [
                    "Low-Carb"
                ],
                "healthLabels": [
                    "Sugar-Conscious",
                    "Keto-Friendly",
                    "Pescatarian",
                    "Dairy-Free",
                    "Gluten-Free",
                    "Wheat-Free",
                    "Peanut-Free",
                    "Soy-Free",
                    "Shellfish-Free",
                    "Pork-Free",
                    "Red-Meat-Free",
                    "Crustacean-Free",
                    "Celery-Free",
                    "Mustard-Free",
                    "Sesame-Free",
                    "Lupine-Free",
                    "Mollusk-Free",
                    "Alcohol-Free",
                    "Sulfite-Free",
                    "FODMAP-Free",
                    "Kosher"
                ],
                "cautions": [
                    "FODMAP"
                ],
                "ingredientLines": [
                    "1 pound white fish",
                    "2 x eggs, whisked",
                    "1 cup blanched almond flour",
                    "1 tsp Celtic Sea Salt",
                    "1/4 cup Olive Oil",
                    "1/4 cup grapeseed oil"
                ],
                "ingredients": [
                    {
                        "text": "1 pound white fish",
                        "weight": 453.59237,
                        "foodCategory": "seafood",
                        "foodId": "food_ar6pjbvaxqtlqia7jewa4brld7p9",
                        "image": "https://www.edamam.com/food-img/717/717cb400eb49626bb7c95cd29292cef4.jpg"
                    },
                    {
                        "text": "2 x eggs, whisked",
                        "weight": 86,
                        "foodCategory": "Eggs",
                        "foodId": "food_bhpradua77pk16aipcvzeayg732r",
                        "image": "https://www.edamam.com/food-img/a7e/a7ec7c337cb47c6550b3b118e357f077.jpg"
                    },
                    {
                        "text": "1 cup blanched almond flour",
                        "weight": 112,
                        "foodCategory": "grains",
                        "foodId": "food_aquymekalw81cfbcaho71btv3lnt",
                        "image": "https://www.edamam.com/food-img/4ce/4ce26863cf14ffeb473cc6f9edcc60f0.jpg"
                    },
                    {
                        "text": "1 tsp Celtic Sea Salt",
                        "weight": 4.854166666912875,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_a1vgrj1bs8rd1majvmd9ubz8ttkg",
                        "image": "https://www.edamam.com/food-img/694/6943ea510918c6025795e8dc6e6eaaeb.jpg"
                    },
                    {
                        "text": "1/4 cup Olive Oil",
                        "weight": 54,
                        "foodCategory": "Oils",
                        "foodId": "food_b1d1icuad3iktrbqby0hiagafaz7",
                        "image": "https://www.edamam.com/food-img/4d6/4d651eaa8a353647746290c7a9b29d84.jpg"
                    },
                    {
                        "text": "1/4 cup grapeseed oil",
                        "weight": 54.5,
                        "foodCategory": "Oils",
                        "foodId": "food_br8vwihb5tm7wybd4ppzjaox5089",
                        "image": "https://www.edamam.com/food-img/88b/88bb3399c7bf214d2bce6bd86780eaf2.jpg"
                    }
                ],
                "calories": 2173.1046752,
                "totalWeight": 763.7213156942763,
                "totalTime": 0,
                "cuisineType": [
                    "mexican"
                ],
                "mealType": [
                    "lunch/dinner"
                ],
                "dishType": [
                    "sandwiches"
                ],
                "totalNutrients": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 2173.1046752,
                        "unit": "kcal"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 180.34487029000002,
                        "unit": "g"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 21.8941953645,
                        "unit": "g"
                    },
                    "FATRN": {
                        "label": "Trans",
                        "quantity": 0.03268,
                        "unit": "g"
                    },
                    "FAMS": {
                        "label": "Monounsaturated",
                        "quantity": 53.57821000260001,
                        "unit": "g"
                    },
                    "FAPU": {
                        "label": "Polyunsaturated",
                        "quantity": 47.06792030310001,
                        "unit": "g"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 21.944,
                        "unit": "g"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 11.592,
                        "unit": "g"
                    },
                    "SUGAR": {
                        "label": "Sugars",
                        "quantity": 4.182200000000001,
                        "unit": "g"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 126.93734789599999,
                        "unit": "g"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 546.716185,
                        "unit": "mg"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 1767.5796045876002,
                        "unit": "mg"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 173.33018396662632,
                        "unit": "mg"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 132.82622935694278,
                        "unit": "mg"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 2305.0328730555425,
                        "unit": "mg"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 5.569092792791113,
                        "unit": "mg"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 2.6098837666942765,
                        "unit": "mg"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 1473.1742290000002,
                        "unit": "mg"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 137.6,
                        "unit": "µg"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 0,
                        "unit": "mg"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 0.22037287170000003,
                        "unit": "mg"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 0.6787831931000001,
                        "unit": "mg"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 17.7682102011,
                        "unit": "mg"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 0.8810196394000002,
                        "unit": "mg"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 149.28216880000002,
                        "unit": "µg"
                    },
                    "FOLFD": {
                        "label": "Folate (food)",
                        "quantity": 149.28216880000002,
                        "unit": "µg"
                    },
                    "FOLAC": {
                        "label": "Folic acid",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 7.932159446000001,
                        "unit": "µg"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 15.781363470000002,
                        "unit": "µg"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 26.162369480000002,
                        "unit": "mg"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 39.11629318,
                        "unit": "µg"
                    },
                    "WATER": {
                        "label": "Water",
                        "quantity": 419.66118038738864,
                        "unit": "g"
                    }
                },
                "totalDaily": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 108.65523376,
                        "unit": "%"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 277.45364660000007,
                        "unit": "%"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 109.4709768225,
                        "unit": "%"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 7.314666666666667,
                        "unit": "%"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 46.368,
                        "unit": "%"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 253.87469579199998,
                        "unit": "%"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 182.2387283333333,
                        "unit": "%"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 73.64915019115001,
                        "unit": "%"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 17.33301839666263,
                        "unit": "%"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 31.625292704033992,
                        "unit": "%"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 49.043252618203034,
                        "unit": "%"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 30.93940440439507,
                        "unit": "%"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 23.726216060857055,
                        "unit": "%"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 210.4534612857143,
                        "unit": "%"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 15.28888888888889,
                        "unit": "%"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 0,
                        "unit": "%"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 18.364405975000004,
                        "unit": "%"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 52.214091776923084,
                        "unit": "%"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 111.051313756875,
                        "unit": "%"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 67.7707414923077,
                        "unit": "%"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 37.320542200000006,
                        "unit": "%"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 330.50664358333336,
                        "unit": "%"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 105.2090898,
                        "unit": "%"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 174.41579653333335,
                        "unit": "%"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 32.59691098333333,
                        "unit": "%"
                    }
                },
                "digest": [
                    {
                        "label": "Fat",
                        "tag": "FAT",
                        "schemaOrgTag": "fatContent",
                        "total": 180.34487029000002,
                        "hasRDI": true,
                        "daily": 277.45364660000007,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Saturated",
                                "tag": "FASAT",
                                "schemaOrgTag": "saturatedFatContent",
                                "total": 21.8941953645,
                                "hasRDI": true,
                                "daily": 109.4709768225,
                                "unit": "g"
                            },
                            {
                                "label": "Trans",
                                "tag": "FATRN",
                                "schemaOrgTag": "transFatContent",
                                "total": 0.03268,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Monounsaturated",
                                "tag": "FAMS",
                                "schemaOrgTag": null,
                                "total": 53.57821000260001,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Polyunsaturated",
                                "tag": "FAPU",
                                "schemaOrgTag": null,
                                "total": 47.06792030310001,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Carbs",
                        "tag": "CHOCDF",
                        "schemaOrgTag": "carbohydrateContent",
                        "total": 21.944,
                        "hasRDI": true,
                        "daily": 7.314666666666667,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Carbs (net)",
                                "tag": "CHOCDF.net",
                                "schemaOrgTag": null,
                                "total": 10.351999999999999,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Fiber",
                                "tag": "FIBTG",
                                "schemaOrgTag": "fiberContent",
                                "total": 11.592,
                                "hasRDI": true,
                                "daily": 46.368,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars",
                                "tag": "SUGAR",
                                "schemaOrgTag": "sugarContent",
                                "total": 4.182200000000001,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars, added",
                                "tag": "SUGAR.added",
                                "schemaOrgTag": null,
                                "total": 0,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Protein",
                        "tag": "PROCNT",
                        "schemaOrgTag": "proteinContent",
                        "total": 126.93734789599999,
                        "hasRDI": true,
                        "daily": 253.87469579199998,
                        "unit": "g"
                    },
                    {
                        "label": "Cholesterol",
                        "tag": "CHOLE",
                        "schemaOrgTag": "cholesterolContent",
                        "total": 546.716185,
                        "hasRDI": true,
                        "daily": 182.2387283333333,
                        "unit": "mg"
                    },
                    {
                        "label": "Sodium",
                        "tag": "NA",
                        "schemaOrgTag": "sodiumContent",
                        "total": 1767.5796045876002,
                        "hasRDI": true,
                        "daily": 73.64915019115001,
                        "unit": "mg"
                    },
                    {
                        "label": "Calcium",
                        "tag": "CA",
                        "schemaOrgTag": null,
                        "total": 173.33018396662632,
                        "hasRDI": true,
                        "daily": 17.33301839666263,
                        "unit": "mg"
                    },
                    {
                        "label": "Magnesium",
                        "tag": "MG",
                        "schemaOrgTag": null,
                        "total": 132.82622935694278,
                        "hasRDI": true,
                        "daily": 31.625292704033992,
                        "unit": "mg"
                    },
                    {
                        "label": "Potassium",
                        "tag": "K",
                        "schemaOrgTag": null,
                        "total": 2305.0328730555425,
                        "hasRDI": true,
                        "daily": 49.043252618203034,
                        "unit": "mg"
                    },
                    {
                        "label": "Iron",
                        "tag": "FE",
                        "schemaOrgTag": null,
                        "total": 5.569092792791113,
                        "hasRDI": true,
                        "daily": 30.93940440439507,
                        "unit": "mg"
                    },
                    {
                        "label": "Zinc",
                        "tag": "ZN",
                        "schemaOrgTag": null,
                        "total": 2.6098837666942765,
                        "hasRDI": true,
                        "daily": 23.726216060857055,
                        "unit": "mg"
                    },
                    {
                        "label": "Phosphorus",
                        "tag": "P",
                        "schemaOrgTag": null,
                        "total": 1473.1742290000002,
                        "hasRDI": true,
                        "daily": 210.4534612857143,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin A",
                        "tag": "VITA_RAE",
                        "schemaOrgTag": null,
                        "total": 137.6,
                        "hasRDI": true,
                        "daily": 15.28888888888889,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin C",
                        "tag": "VITC",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": true,
                        "daily": 0,
                        "unit": "mg"
                    },
                    {
                        "label": "Thiamin (B1)",
                        "tag": "THIA",
                        "schemaOrgTag": null,
                        "total": 0.22037287170000003,
                        "hasRDI": true,
                        "daily": 18.364405975000004,
                        "unit": "mg"
                    },
                    {
                        "label": "Riboflavin (B2)",
                        "tag": "RIBF",
                        "schemaOrgTag": null,
                        "total": 0.6787831931000001,
                        "hasRDI": true,
                        "daily": 52.214091776923084,
                        "unit": "mg"
                    },
                    {
                        "label": "Niacin (B3)",
                        "tag": "NIA",
                        "schemaOrgTag": null,
                        "total": 17.7682102011,
                        "hasRDI": true,
                        "daily": 111.051313756875,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin B6",
                        "tag": "VITB6A",
                        "schemaOrgTag": null,
                        "total": 0.8810196394000002,
                        "hasRDI": true,
                        "daily": 67.7707414923077,
                        "unit": "mg"
                    },
                    {
                        "label": "Folate equivalent (total)",
                        "tag": "FOLDFE",
                        "schemaOrgTag": null,
                        "total": 149.28216880000002,
                        "hasRDI": true,
                        "daily": 37.320542200000006,
                        "unit": "µg"
                    },
                    {
                        "label": "Folate (food)",
                        "tag": "FOLFD",
                        "schemaOrgTag": null,
                        "total": 149.28216880000002,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Folic acid",
                        "tag": "FOLAC",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin B12",
                        "tag": "VITB12",
                        "schemaOrgTag": null,
                        "total": 7.932159446000001,
                        "hasRDI": true,
                        "daily": 330.50664358333336,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin D",
                        "tag": "VITD",
                        "schemaOrgTag": null,
                        "total": 15.781363470000002,
                        "hasRDI": true,
                        "daily": 105.2090898,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin E",
                        "tag": "TOCPHA",
                        "schemaOrgTag": null,
                        "total": 26.162369480000002,
                        "hasRDI": true,
                        "daily": 174.41579653333335,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin K",
                        "tag": "VITK1",
                        "schemaOrgTag": null,
                        "total": 39.11629318,
                        "hasRDI": true,
                        "daily": 32.59691098333333,
                        "unit": "µg"
                    },
                    {
                        "label": "Sugar alcohols",
                        "tag": "Sugar.alcohol",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    },
                    {
                        "label": "Water",
                        "tag": "WATER",
                        "schemaOrgTag": null,
                        "total": 419.66118038738864,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    }
                ]
            },
            "_links": {
                "self": {
                    "href": "https://api.edamam.com/api/recipes/v2/ca4b9c788a47825fcad7e5f5cbad716d?type=public&app_id=ea1d37d5&app_key=fd382a172ba8d6668c0430dc9c14a181",
                    "title": "Self"
                }
            }
        },
        {
            "recipe": {
                "uri": "http://www.edamam.com/ontologies/edamam.owl#recipe_b8d126947d802def1f795016d75297c4",
                "label": "Curry-Crusted Fish",
                "image": "https://www.edamam.com/web-img/5e3/5e367b107d760d0c0be9e409c0ab07dd.jpg",
                "source": "BBC Good Food",
                "url": "http://www.bbcgoodfood.com/recipes/4717/",
                "shareAs": "http://www.edamam.com/recipe/curry-crusted-fish-b8d126947d802def1f795016d75297c4/fish",
                "yield": 4,
                "dietLabels": [
                    "High-Protein",
                    "Low-Fat"
                ],
                "healthLabels": [
                    "Sugar-Conscious",
                    "Pescatarian",
                    "Dairy-Free",
                    "Egg-Free",
                    "Peanut-Free",
                    "Tree-Nut-Free",
                    "Soy-Free",
                    "Shellfish-Free",
                    "Pork-Free",
                    "Red-Meat-Free",
                    "Crustacean-Free",
                    "Celery-Free",
                    "Mustard-Free",
                    "Sesame-Free",
                    "Lupine-Free",
                    "Mollusk-Free",
                    "Alcohol-Free",
                    "Sulfite-Free",
                    "Kosher"
                ],
                "cautions": [
                    "Sulfites",
                    "FODMAP"
                ],
                "ingredientLines": [
                    "3 slices bread , about 85g/3oz in total",
                    "1 lime",
                    "1.0 tbsp Korma curry paste",
                    "4 thick white fish fillets"
                ],
                "ingredients": [
                    {
                        "text": "3 slices bread , about 85g/3oz in total",
                        "weight": 87,
                        "foodCategory": "bread, rolls and tortillas",
                        "foodId": "food_a3049hmbqj5wstaeeb3udaz6uaqv",
                        "image": "https://www.edamam.com/food-img/886/886960f6ce6ccec5b9163bacf2996853.jpg"
                    },
                    {
                        "text": "1 lime",
                        "weight": 67,
                        "foodCategory": "fruit",
                        "foodId": "food_av58muyb8kg92fbk0g8g8aui5knv",
                        "image": "https://www.edamam.com/food-img/48a/48a123c9576647c4ada6a41df5eeb22a.jpg"
                    },
                    {
                        "text": "1.0 tbsp Korma curry paste",
                        "weight": 16,
                        "foodCategory": "condiments and sauces",
                        "foodId": "food_aojdol2are6zg7af2nincbe87jot",
                        "image": "https://www.edamam.com/food-img/b6a/b6a9ebae5850f42eca0253827603ef9c.jpg"
                    },
                    {
                        "text": "4 thick white fish fillets",
                        "weight": 464,
                        "foodCategory": "seafood",
                        "foodId": "food_ar6pjbvaxqtlqia7jewa4brld7p9",
                        "image": "https://www.edamam.com/food-img/717/717cb400eb49626bb7c95cd29292cef4.jpg"
                    }
                ],
                "calories": 716.9749125599999,
                "totalWeight": 634,
                "totalTime": 0,
                "cuisineType": [
                    "south east asian"
                ],
                "mealType": [
                    "lunch/dinner"
                ],
                "dishType": [
                    "main course"
                ],
                "totalNutrients": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 716.9749125599999,
                        "unit": "kcal"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 11.726102052479998,
                        "unit": "g"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 3.5231452780799994,
                        "unit": "g"
                    },
                    "FATRN": {
                        "label": "Trans",
                        "quantity": 0.022619999999999998,
                        "unit": "g"
                    },
                    "FAMS": {
                        "label": "Monounsaturated",
                        "quantity": 3.2722975116799997,
                        "unit": "g"
                    },
                    "FAPU": {
                        "label": "Polyunsaturated",
                        "quantity": 3.3014249792,
                        "unit": "g"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 52.189025006399994,
                        "unit": "g"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 6.05501741312,
                        "unit": "g"
                    },
                    "SUGAR": {
                        "label": "Sugars",
                        "quantity": 6.4998607232,
                        "unit": "g"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 103.79685228015998,
                        "unit": "g"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 233.47194981887998,
                        "unit": "mg"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 765.6226332639999,
                        "unit": "mg"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 198.8557002944,
                        "unit": "mg"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 176.83539840959997,
                        "unit": "mg"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 1690.410594016,
                        "unit": "mg"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 6.74659198144,
                        "unit": "mg"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 2.8363382944,
                        "unit": "mg"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 947.366934544,
                        "unit": "mg"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 14.6083559888,
                        "unit": "µg"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 21.876185592000002,
                        "unit": "mg"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 0.59003002512,
                        "unit": "mg"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 0.5425564784,
                        "unit": "mg"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 23.42675931104,
                        "unit": "mg"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 0.91561328304,
                        "unit": "mg"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 209.2706042976,
                        "unit": "µg"
                    },
                    "FOLFD": {
                        "label": "Folate (food)",
                        "quantity": 179.69060429759998,
                        "unit": "µg"
                    },
                    "FOLAC": {
                        "label": "Folic acid",
                        "quantity": 17.4,
                        "unit": "µg"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 7.33552239232,
                        "unit": "µg"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 14.383999999999999,
                        "unit": "µg"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 2.46156715968,
                        "unit": "mg"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 12.51143552688,
                        "unit": "µg"
                    },
                    "WATER": {
                        "label": "Water",
                        "quantity": 463.13090268959996,
                        "unit": "g"
                    }
                },
                "totalDaily": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 35.848745627999996,
                        "unit": "%"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 18.04015700381538,
                        "unit": "%"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 17.615726390399995,
                        "unit": "%"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 17.396341668799998,
                        "unit": "%"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 24.220069652480003,
                        "unit": "%"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 207.59370456031996,
                        "unit": "%"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 77.82398327295999,
                        "unit": "%"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 31.900943052666662,
                        "unit": "%"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 19.88557002944,
                        "unit": "%"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 42.103666288,
                        "unit": "%"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 35.966182851404255,
                        "unit": "%"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 37.48106656355556,
                        "unit": "%"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 25.784893585454544,
                        "unit": "%"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 135.33813350628571,
                        "unit": "%"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 1.623150665422222,
                        "unit": "%"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 24.30687288,
                        "unit": "%"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 49.169168760000005,
                        "unit": "%"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 41.73511372307692,
                        "unit": "%"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 146.417245694,
                        "unit": "%"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 70.43179100307692,
                        "unit": "%"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 52.317651074400004,
                        "unit": "%"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 305.64676634666665,
                        "unit": "%"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 95.89333333333333,
                        "unit": "%"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 16.410447731199998,
                        "unit": "%"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 10.4261962724,
                        "unit": "%"
                    }
                },
                "digest": [
                    {
                        "label": "Fat",
                        "tag": "FAT",
                        "schemaOrgTag": "fatContent",
                        "total": 11.726102052479998,
                        "hasRDI": true,
                        "daily": 18.04015700381538,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Saturated",
                                "tag": "FASAT",
                                "schemaOrgTag": "saturatedFatContent",
                                "total": 3.5231452780799994,
                                "hasRDI": true,
                                "daily": 17.615726390399995,
                                "unit": "g"
                            },
                            {
                                "label": "Trans",
                                "tag": "FATRN",
                                "schemaOrgTag": "transFatContent",
                                "total": 0.022619999999999998,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Monounsaturated",
                                "tag": "FAMS",
                                "schemaOrgTag": null,
                                "total": 3.2722975116799997,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Polyunsaturated",
                                "tag": "FAPU",
                                "schemaOrgTag": null,
                                "total": 3.3014249792,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Carbs",
                        "tag": "CHOCDF",
                        "schemaOrgTag": "carbohydrateContent",
                        "total": 52.189025006399994,
                        "hasRDI": true,
                        "daily": 17.396341668799998,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Carbs (net)",
                                "tag": "CHOCDF.net",
                                "schemaOrgTag": null,
                                "total": 46.134007593279996,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Fiber",
                                "tag": "FIBTG",
                                "schemaOrgTag": "fiberContent",
                                "total": 6.05501741312,
                                "hasRDI": true,
                                "daily": 24.220069652480003,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars",
                                "tag": "SUGAR",
                                "schemaOrgTag": "sugarContent",
                                "total": 6.4998607232,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars, added",
                                "tag": "SUGAR.added",
                                "schemaOrgTag": null,
                                "total": 0,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Protein",
                        "tag": "PROCNT",
                        "schemaOrgTag": "proteinContent",
                        "total": 103.79685228015998,
                        "hasRDI": true,
                        "daily": 207.59370456031996,
                        "unit": "g"
                    },
                    {
                        "label": "Cholesterol",
                        "tag": "CHOLE",
                        "schemaOrgTag": "cholesterolContent",
                        "total": 233.47194981887998,
                        "hasRDI": true,
                        "daily": 77.82398327295999,
                        "unit": "mg"
                    },
                    {
                        "label": "Sodium",
                        "tag": "NA",
                        "schemaOrgTag": "sodiumContent",
                        "total": 765.6226332639999,
                        "hasRDI": true,
                        "daily": 31.900943052666662,
                        "unit": "mg"
                    },
                    {
                        "label": "Calcium",
                        "tag": "CA",
                        "schemaOrgTag": null,
                        "total": 198.8557002944,
                        "hasRDI": true,
                        "daily": 19.88557002944,
                        "unit": "mg"
                    },
                    {
                        "label": "Magnesium",
                        "tag": "MG",
                        "schemaOrgTag": null,
                        "total": 176.83539840959997,
                        "hasRDI": true,
                        "daily": 42.103666288,
                        "unit": "mg"
                    },
                    {
                        "label": "Potassium",
                        "tag": "K",
                        "schemaOrgTag": null,
                        "total": 1690.410594016,
                        "hasRDI": true,
                        "daily": 35.966182851404255,
                        "unit": "mg"
                    },
                    {
                        "label": "Iron",
                        "tag": "FE",
                        "schemaOrgTag": null,
                        "total": 6.74659198144,
                        "hasRDI": true,
                        "daily": 37.48106656355556,
                        "unit": "mg"
                    },
                    {
                        "label": "Zinc",
                        "tag": "ZN",
                        "schemaOrgTag": null,
                        "total": 2.8363382944,
                        "hasRDI": true,
                        "daily": 25.784893585454544,
                        "unit": "mg"
                    },
                    {
                        "label": "Phosphorus",
                        "tag": "P",
                        "schemaOrgTag": null,
                        "total": 947.366934544,
                        "hasRDI": true,
                        "daily": 135.33813350628571,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin A",
                        "tag": "VITA_RAE",
                        "schemaOrgTag": null,
                        "total": 14.6083559888,
                        "hasRDI": true,
                        "daily": 1.623150665422222,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin C",
                        "tag": "VITC",
                        "schemaOrgTag": null,
                        "total": 21.876185592000002,
                        "hasRDI": true,
                        "daily": 24.30687288,
                        "unit": "mg"
                    },
                    {
                        "label": "Thiamin (B1)",
                        "tag": "THIA",
                        "schemaOrgTag": null,
                        "total": 0.59003002512,
                        "hasRDI": true,
                        "daily": 49.169168760000005,
                        "unit": "mg"
                    },
                    {
                        "label": "Riboflavin (B2)",
                        "tag": "RIBF",
                        "schemaOrgTag": null,
                        "total": 0.5425564784,
                        "hasRDI": true,
                        "daily": 41.73511372307692,
                        "unit": "mg"
                    },
                    {
                        "label": "Niacin (B3)",
                        "tag": "NIA",
                        "schemaOrgTag": null,
                        "total": 23.42675931104,
                        "hasRDI": true,
                        "daily": 146.417245694,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin B6",
                        "tag": "VITB6A",
                        "schemaOrgTag": null,
                        "total": 0.91561328304,
                        "hasRDI": true,
                        "daily": 70.43179100307692,
                        "unit": "mg"
                    },
                    {
                        "label": "Folate equivalent (total)",
                        "tag": "FOLDFE",
                        "schemaOrgTag": null,
                        "total": 209.2706042976,
                        "hasRDI": true,
                        "daily": 52.317651074400004,
                        "unit": "µg"
                    },
                    {
                        "label": "Folate (food)",
                        "tag": "FOLFD",
                        "schemaOrgTag": null,
                        "total": 179.69060429759998,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Folic acid",
                        "tag": "FOLAC",
                        "schemaOrgTag": null,
                        "total": 17.4,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin B12",
                        "tag": "VITB12",
                        "schemaOrgTag": null,
                        "total": 7.33552239232,
                        "hasRDI": true,
                        "daily": 305.64676634666665,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin D",
                        "tag": "VITD",
                        "schemaOrgTag": null,
                        "total": 14.383999999999999,
                        "hasRDI": true,
                        "daily": 95.89333333333333,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin E",
                        "tag": "TOCPHA",
                        "schemaOrgTag": null,
                        "total": 2.46156715968,
                        "hasRDI": true,
                        "daily": 16.410447731199998,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin K",
                        "tag": "VITK1",
                        "schemaOrgTag": null,
                        "total": 12.51143552688,
                        "hasRDI": true,
                        "daily": 10.4261962724,
                        "unit": "µg"
                    },
                    {
                        "label": "Sugar alcohols",
                        "tag": "Sugar.alcohol",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    },
                    {
                        "label": "Water",
                        "tag": "WATER",
                        "schemaOrgTag": null,
                        "total": 463.13090268959996,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    }
                ]
            },
            "_links": {
                "self": {
                    "href": "https://api.edamam.com/api/recipes/v2/b8d126947d802def1f795016d75297c4?type=public&app_id=ea1d37d5&app_key=fd382a172ba8d6668c0430dc9c14a181",
                    "title": "Self"
                }
            }
        },
        {
            "recipe": {
                "uri": "http://www.edamam.com/ontologies/edamam.owl#recipe_d528496e76bd29004497986e90e56c17",
                "label": "Baked Fish from Iceland",
                "image": "https://www.edamam.com/web-img/629/629af16aa679adfe0d67164d442b720f.jpg",
                "source": "The Daily Meal",
                "url": "http://www.thedailymeal.com/recipes/baked-fish-iceland-recipe-0",
                "shareAs": "http://www.edamam.com/recipe/baked-fish-from-iceland-d528496e76bd29004497986e90e56c17/fish",
                "yield": 6,
                "dietLabels": [
                    "Low-Carb"
                ],
                "healthLabels": [
                    "Sugar-Conscious",
                    "Pescatarian",
                    "Egg-Free",
                    "Peanut-Free",
                    "Tree-Nut-Free",
                    "Soy-Free",
                    "Shellfish-Free",
                    "Pork-Free",
                    "Red-Meat-Free",
                    "Crustacean-Free",
                    "Celery-Free",
                    "Sesame-Free",
                    "Lupine-Free",
                    "Mollusk-Free",
                    "Alcohol-Free",
                    "Sulfite-Free",
                    "Kosher"
                ],
                "cautions": [
                    "Sulfites"
                ],
                "ingredientLines": [
                    "1 Tablespoon butter",
                    "6 fish fillets or six cod fish fillets",
                    "1 lemon",
                    "200 Grams Emmenthal cheese or two hundred grams tilsiter cheese, grated",
                    "1 Tablespoon mustard",
                    "1 Cup cream",
                    "1/2 Cup breadcrumbs"
                ],
                "ingredients": [
                    {
                        "text": "1 Tablespoon butter",
                        "weight": 14.2,
                        "foodCategory": "Dairy",
                        "foodId": "food_awz3iefajbk1fwahq9logahmgltj",
                        "image": "https://www.edamam.com/food-img/713/71397239b670d88c04faa8d05035cab4.jpg"
                    },
                    {
                        "text": "6 fish fillets or six cod fish fillets",
                        "weight": 231,
                        "foodCategory": "seafood",
                        "foodId": "food_a3z8tuub0gc30kaqthfuibcqz9os",
                        "image": "https://www.edamam.com/food-img/d58/d58d0ccfc3a15f1dfb7877f17a068d4d.jpg"
                    },
                    {
                        "text": "1 lemon",
                        "weight": 58,
                        "foodCategory": "fruit",
                        "foodId": "food_a6uzc62astrxcgbtzyq59b6fncrr",
                        "image": "https://www.edamam.com/food-img/70a/70acba3d4c734d7c70ef4efeed85dc8f.jpg"
                    },
                    {
                        "text": "200 Grams Emmenthal cheese or two hundred grams tilsiter cheese, grated",
                        "weight": 200,
                        "foodCategory": "Cheese",
                        "foodId": "food_bhppgmha1u27voagb8eptbp9g376",
                        "image": "https://www.edamam.com/food-img/bcd/bcd94dde1fcde1475b5bf0540f821c5d.jpg"
                    },
                    {
                        "text": "1 Tablespoon mustard",
                        "weight": 15.5624999997369,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_a34cdj5b0kyuhfbov30xcb50u4dv",
                        "image": "https://www.edamam.com/food-img/e23/e238f2e4cfa6aa1a30f46dc73e7344eb.jpg"
                    },
                    {
                        "text": "1 Cup cream",
                        "weight": 238,
                        "foodCategory": "Dairy",
                        "foodId": "food_bvhbvd7bwy6a7wamfrmvmbmen1sz",
                        "image": "https://www.edamam.com/food-img/484/4848d71f6a14dd5076083f5e17925420.jpg"
                    },
                    {
                        "text": "1/2 Cup breadcrumbs",
                        "weight": 54,
                        "foodCategory": "bread, rolls and tortillas",
                        "foodId": "food_ata1dxza443wfda7jb4e5b3zwt9p",
                        "image": "https://www.edamam.com/food-img/349/349f852497885b9d9c0b195ad0d0db8f.jpg"
                    }
                ],
                "calories": 2163.791499999842,
                "totalWeight": 810.7624999997369,
                "totalTime": 0,
                "cuisineType": [
                    "american"
                ],
                "mealType": [
                    "lunch/dinner"
                ],
                "dishType": [
                    "main course"
                ],
                "totalNutrients": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 2163.791499999842,
                        "unit": "kcal"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 172.3211074999912,
                        "unit": "g"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 101.85456974999943,
                        "unit": "g"
                    },
                    "FATRN": {
                        "label": "Trans",
                        "quantity": 2.8248766249999764,
                        "unit": "g"
                    },
                    "FAMS": {
                        "label": "Monounsaturated",
                        "quantity": 46.38917574999425,
                        "unit": "g"
                    },
                    "FAPU": {
                        "label": "Polyunsaturated",
                        "quantity": 8.386309749997963,
                        "unit": "g"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 54.49081374998467,
                        "unit": "g"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 4.676499999989476,
                        "unit": "g"
                    },
                    "SUGAR": {
                        "label": "Sugars",
                        "quantity": 12.14989499999758,
                        "unit": "g"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 102.64983749999016,
                        "unit": "g"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 659.9200000000001,
                        "unit": "mg"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 2072.9919999970957,
                        "unit": "mg"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 1668.7723749998343,
                        "unit": "mg"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 180.1939999998737,
                        "unit": "mg"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 1497.4729999996,
                        "unit": "mg"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 4.478796249995764,
                        "unit": "mg"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 9.377079999998315,
                        "unit": "mg"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 1681.0854999997157,
                        "unit": "mg"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 1630.3861249999868,
                        "unit": "µg"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 34.5246874999992,
                        "unit": "mg"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 0.8555556249995343,
                        "unit": "mg"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 1.5248917499998158,
                        "unit": "mg"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 8.670602124998513,
                        "unit": "mg"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 0.8488897499998158,
                        "unit": "mg"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 174.14537499998158,
                        "unit": "µg"
                    },
                    "FOLFD": {
                        "label": "Folate (food)",
                        "quantity": 99.08537499998158,
                        "unit": "µg"
                    },
                    "FOLAC": {
                        "label": "Folic acid",
                        "quantity": 44.28,
                        "unit": "µg"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 4.50364,
                        "unit": "µg"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 5.1579999999999995,
                        "unit": "µg"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 6.076864999999052,
                        "unit": "mg"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 18.422874999996317,
                        "unit": "µg"
                    },
                    "WATER": {
                        "label": "Water",
                        "quantity": 469.8682049997798,
                        "unit": "g"
                    }
                },
                "totalDaily": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 108.18957499999209,
                        "unit": "%"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 265.1093961538326,
                        "unit": "%"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 509.27284874999714,
                        "unit": "%"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 18.163604583328222,
                        "unit": "%"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 18.705999999957903,
                        "unit": "%"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 205.2996749999803,
                        "unit": "%"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 219.97333333333333,
                        "unit": "%"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 86.37466666654566,
                        "unit": "%"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 166.87723749998344,
                        "unit": "%"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 42.903333333303266,
                        "unit": "%"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 31.86112765956596,
                        "unit": "%"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 24.882201388865354,
                        "unit": "%"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 85.2461818181665,
                        "unit": "%"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 240.15507142853085,
                        "unit": "%"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 181.15401388888742,
                        "unit": "%"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 38.360763888888,
                        "unit": "%"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 71.29630208329452,
                        "unit": "%"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 117.2993653846012,
                        "unit": "%"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 54.19126328124071,
                        "unit": "%"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 65.29921153844737,
                        "unit": "%"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 43.536343749995396,
                        "unit": "%"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 187.65166666666667,
                        "unit": "%"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 34.38666666666666,
                        "unit": "%"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 40.51243333332702,
                        "unit": "%"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 15.352395833330265,
                        "unit": "%"
                    }
                },
                "digest": [
                    {
                        "label": "Fat",
                        "tag": "FAT",
                        "schemaOrgTag": "fatContent",
                        "total": 172.3211074999912,
                        "hasRDI": true,
                        "daily": 265.1093961538326,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Saturated",
                                "tag": "FASAT",
                                "schemaOrgTag": "saturatedFatContent",
                                "total": 101.85456974999943,
                                "hasRDI": true,
                                "daily": 509.27284874999714,
                                "unit": "g"
                            },
                            {
                                "label": "Trans",
                                "tag": "FATRN",
                                "schemaOrgTag": "transFatContent",
                                "total": 2.8248766249999764,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Monounsaturated",
                                "tag": "FAMS",
                                "schemaOrgTag": null,
                                "total": 46.38917574999425,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Polyunsaturated",
                                "tag": "FAPU",
                                "schemaOrgTag": null,
                                "total": 8.386309749997963,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Carbs",
                        "tag": "CHOCDF",
                        "schemaOrgTag": "carbohydrateContent",
                        "total": 54.49081374998467,
                        "hasRDI": true,
                        "daily": 18.163604583328222,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Carbs (net)",
                                "tag": "CHOCDF.net",
                                "schemaOrgTag": null,
                                "total": 49.81431374999519,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Fiber",
                                "tag": "FIBTG",
                                "schemaOrgTag": "fiberContent",
                                "total": 4.676499999989476,
                                "hasRDI": true,
                                "daily": 18.705999999957903,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars",
                                "tag": "SUGAR",
                                "schemaOrgTag": "sugarContent",
                                "total": 12.14989499999758,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars, added",
                                "tag": "SUGAR.added",
                                "schemaOrgTag": null,
                                "total": 0,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Protein",
                        "tag": "PROCNT",
                        "schemaOrgTag": "proteinContent",
                        "total": 102.64983749999016,
                        "hasRDI": true,
                        "daily": 205.2996749999803,
                        "unit": "g"
                    },
                    {
                        "label": "Cholesterol",
                        "tag": "CHOLE",
                        "schemaOrgTag": "cholesterolContent",
                        "total": 659.9200000000001,
                        "hasRDI": true,
                        "daily": 219.97333333333333,
                        "unit": "mg"
                    },
                    {
                        "label": "Sodium",
                        "tag": "NA",
                        "schemaOrgTag": "sodiumContent",
                        "total": 2072.9919999970957,
                        "hasRDI": true,
                        "daily": 86.37466666654566,
                        "unit": "mg"
                    },
                    {
                        "label": "Calcium",
                        "tag": "CA",
                        "schemaOrgTag": null,
                        "total": 1668.7723749998343,
                        "hasRDI": true,
                        "daily": 166.87723749998344,
                        "unit": "mg"
                    },
                    {
                        "label": "Magnesium",
                        "tag": "MG",
                        "schemaOrgTag": null,
                        "total": 180.1939999998737,
                        "hasRDI": true,
                        "daily": 42.903333333303266,
                        "unit": "mg"
                    },
                    {
                        "label": "Potassium",
                        "tag": "K",
                        "schemaOrgTag": null,
                        "total": 1497.4729999996,
                        "hasRDI": true,
                        "daily": 31.86112765956596,
                        "unit": "mg"
                    },
                    {
                        "label": "Iron",
                        "tag": "FE",
                        "schemaOrgTag": null,
                        "total": 4.478796249995764,
                        "hasRDI": true,
                        "daily": 24.882201388865354,
                        "unit": "mg"
                    },
                    {
                        "label": "Zinc",
                        "tag": "ZN",
                        "schemaOrgTag": null,
                        "total": 9.377079999998315,
                        "hasRDI": true,
                        "daily": 85.2461818181665,
                        "unit": "mg"
                    },
                    {
                        "label": "Phosphorus",
                        "tag": "P",
                        "schemaOrgTag": null,
                        "total": 1681.0854999997157,
                        "hasRDI": true,
                        "daily": 240.15507142853085,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin A",
                        "tag": "VITA_RAE",
                        "schemaOrgTag": null,
                        "total": 1630.3861249999868,
                        "hasRDI": true,
                        "daily": 181.15401388888742,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin C",
                        "tag": "VITC",
                        "schemaOrgTag": null,
                        "total": 34.5246874999992,
                        "hasRDI": true,
                        "daily": 38.360763888888,
                        "unit": "mg"
                    },
                    {
                        "label": "Thiamin (B1)",
                        "tag": "THIA",
                        "schemaOrgTag": null,
                        "total": 0.8555556249995343,
                        "hasRDI": true,
                        "daily": 71.29630208329452,
                        "unit": "mg"
                    },
                    {
                        "label": "Riboflavin (B2)",
                        "tag": "RIBF",
                        "schemaOrgTag": null,
                        "total": 1.5248917499998158,
                        "hasRDI": true,
                        "daily": 117.2993653846012,
                        "unit": "mg"
                    },
                    {
                        "label": "Niacin (B3)",
                        "tag": "NIA",
                        "schemaOrgTag": null,
                        "total": 8.670602124998513,
                        "hasRDI": true,
                        "daily": 54.19126328124071,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin B6",
                        "tag": "VITB6A",
                        "schemaOrgTag": null,
                        "total": 0.8488897499998158,
                        "hasRDI": true,
                        "daily": 65.29921153844737,
                        "unit": "mg"
                    },
                    {
                        "label": "Folate equivalent (total)",
                        "tag": "FOLDFE",
                        "schemaOrgTag": null,
                        "total": 174.14537499998158,
                        "hasRDI": true,
                        "daily": 43.536343749995396,
                        "unit": "µg"
                    },
                    {
                        "label": "Folate (food)",
                        "tag": "FOLFD",
                        "schemaOrgTag": null,
                        "total": 99.08537499998158,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Folic acid",
                        "tag": "FOLAC",
                        "schemaOrgTag": null,
                        "total": 44.28,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin B12",
                        "tag": "VITB12",
                        "schemaOrgTag": null,
                        "total": 4.50364,
                        "hasRDI": true,
                        "daily": 187.65166666666667,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin D",
                        "tag": "VITD",
                        "schemaOrgTag": null,
                        "total": 5.1579999999999995,
                        "hasRDI": true,
                        "daily": 34.38666666666666,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin E",
                        "tag": "TOCPHA",
                        "schemaOrgTag": null,
                        "total": 6.076864999999052,
                        "hasRDI": true,
                        "daily": 40.51243333332702,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin K",
                        "tag": "VITK1",
                        "schemaOrgTag": null,
                        "total": 18.422874999996317,
                        "hasRDI": true,
                        "daily": 15.352395833330265,
                        "unit": "µg"
                    },
                    {
                        "label": "Sugar alcohols",
                        "tag": "Sugar.alcohol",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    },
                    {
                        "label": "Water",
                        "tag": "WATER",
                        "schemaOrgTag": null,
                        "total": 469.8682049997798,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    }
                ]
            },
            "_links": {
                "self": {
                    "href": "https://api.edamam.com/api/recipes/v2/d528496e76bd29004497986e90e56c17?type=public&app_id=ea1d37d5&app_key=fd382a172ba8d6668c0430dc9c14a181",
                    "title": "Self"
                }
            }
        },
        {
            "recipe": {
                "uri": "http://www.edamam.com/ontologies/edamam.owl#recipe_a78de61b0b31e1f0ca8753899987bdf3",
                "label": "Fried Rock Fish",
                "image": "https://www.edamam.com/web-img/df4/df41dee7354c94eea623a5bf863026b4.jpeg",
                "source": "Food Network",
                "url": "https://www.foodnetwork.com/recipes/fried-rock-fish-recipe-2013184",
                "shareAs": "http://www.edamam.com/recipe/fried-rock-fish-a78de61b0b31e1f0ca8753899987bdf3/fish",
                "yield": 2,
                "dietLabels": [
                    "Low-Carb"
                ],
                "healthLabels": [
                    "Sugar-Conscious",
                    "Pescatarian",
                    "Peanut-Free",
                    "Tree-Nut-Free",
                    "Soy-Free",
                    "Shellfish-Free",
                    "Pork-Free",
                    "Red-Meat-Free",
                    "Crustacean-Free",
                    "Celery-Free",
                    "Mustard-Free",
                    "Sesame-Free",
                    "Lupine-Free",
                    "Mollusk-Free",
                    "Alcohol-Free",
                    "Sulfite-Free",
                    "Kosher",
                    "Immuno-Supportive"
                ],
                "cautions": [
                    "FODMAP"
                ],
                "ingredientLines": [
                    "1/2 cup flour",
                    "Salt and pepper",
                    "Old Bay spice seasoning",
                    "2 beaten eggs",
                    "2 Rock fish",
                    "1/4 stick butter",
                    "1/2 cup oil"
                ],
                "ingredients": [
                    {
                        "text": "1/2 cup flour",
                        "weight": 62.5,
                        "foodCategory": "grains",
                        "foodId": "food_ahebfs0a985an4aubqaebbipra58",
                        "image": "https://www.edamam.com/food-img/b4c/b4c739e76a6f2172b7ad49d0aa41d5aa.jpg"
                    },
                    {
                        "text": "Salt and pepper",
                        "weight": 3.6345,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_btxz81db72hwbra2pncvebzzzum9",
                        "image": "https://www.edamam.com/food-img/694/6943ea510918c6025795e8dc6e6eaaeb.jpg"
                    },
                    {
                        "text": "Salt and pepper",
                        "weight": 1.81725,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_b6ywzluaaxv02wad7s1r9ag4py89",
                        "image": "https://www.edamam.com/food-img/c6e/c6e5c3bd8d3bc15175d9766971a4d1b2.jpg"
                    },
                    {
                        "text": "Old Bay spice seasoning",
                        "weight": 6.0575,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_aj7w3xab0epj7cbgkbkpwadysovd",
                        "image": "https://www.edamam.com/food-img/c23/c23e20823b442067307aa436969358f1.jpg"
                    },
                    {
                        "text": "2 beaten eggs",
                        "weight": 86,
                        "foodCategory": "Eggs",
                        "foodId": "food_bhpradua77pk16aipcvzeayg732r",
                        "image": "https://www.edamam.com/food-img/a7e/a7ec7c337cb47c6550b3b118e357f077.jpg"
                    },
                    {
                        "text": "2 Rock fish",
                        "weight": 320,
                        "foodCategory": "seafood",
                        "foodId": "food_ar6pjbvaxqtlqia7jewa4brld7p9",
                        "image": "https://www.edamam.com/food-img/717/717cb400eb49626bb7c95cd29292cef4.jpg"
                    },
                    {
                        "text": "1/4 stick butter",
                        "weight": 28.25,
                        "foodCategory": "Dairy",
                        "foodId": "food_awz3iefajbk1fwahq9logahmgltj",
                        "image": "https://www.edamam.com/food-img/713/71397239b670d88c04faa8d05035cab4.jpg"
                    },
                    {
                        "text": "1/2 cup oil",
                        "weight": 109,
                        "foodCategory": "Oils",
                        "foodId": "food_bk9p9aaavhvoq4bqsnprobpsiuxs",
                        "image": "https://www.edamam.com/food-img/07e/07e106ab3536d57428e5c46d009038f8.jpg"
                    }
                ],
                "calories": 1519.882588,
                "totalWeight": 579.3250798479888,
                "totalTime": 0,
                "cuisineType": [
                    "french"
                ],
                "mealType": [
                    "lunch/dinner"
                ],
                "dishType": [
                    "sandwiches"
                ],
                "totalNutrients": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 1519.882588,
                        "unit": "kcal"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 109.66143459999999,
                        "unit": "g"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 24.696185059375,
                        "unit": "g"
                    },
                    "FATRN": {
                        "label": "Trans",
                        "quantity": 1.243120480625,
                        "unit": "g"
                    },
                    "FAMS": {
                        "label": "Monounsaturated",
                        "quantity": 56.378368382000005,
                        "unit": "g"
                    },
                    "FAPU": {
                        "label": "Polyunsaturated",
                        "quantity": 24.32087232525,
                        "unit": "g"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 53.465145625000005,
                        "unit": "g"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 2.83176175,
                        "unit": "g"
                    },
                    "SUGAR": {
                        "label": "Sugars",
                        "quantity": 0.6245654,
                        "unit": "g"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 82.523701525,
                        "unit": "g"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 540.6575,
                        "unit": "mg"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 1340.9325502335,
                        "unit": "mg"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 165.34586366351732,
                        "unit": "mg"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 127.73828692347989,
                        "unit": "mg"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 1224.535467887839,
                        "unit": "mg"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 6.357558984748363,
                        "unit": "mg"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 2.8428547173479886,
                        "unit": "mg"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 801.78958,
                        "unit": "mg"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 339.31655750000004,
                        "unit": "µg"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 0.7269000000000001,
                        "unit": "mg"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 0.25996693,
                        "unit": "mg"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 0.644065875,
                        "unit": "mg"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 13.547893917500001,
                        "unit": "mg"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 0.7781946975000001,
                        "unit": "mg"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 142.9857825,
                        "unit": "µg"
                    },
                    "FOLFD": {
                        "label": "Folate (food)",
                        "quantity": 142.9857825,
                        "unit": "µg"
                    },
                    "FOLAC": {
                        "label": "Folic acid",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 5.869425000000001,
                        "unit": "µg"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 12.063750000000002,
                        "unit": "µg"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 15.5462006575,
                        "unit": "mg"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 110.00193253749998,
                        "unit": "µg"
                    },
                    "WATER": {
                        "label": "Water",
                        "quantity": 328.658830484696,
                        "unit": "g"
                    }
                },
                "totalDaily": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 75.99412939999999,
                        "unit": "%"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 168.70989938461537,
                        "unit": "%"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 123.48092529687501,
                        "unit": "%"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 17.821715208333334,
                        "unit": "%"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 11.327047,
                        "unit": "%"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 165.04740305000004,
                        "unit": "%"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 180.21916666666667,
                        "unit": "%"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 55.8721895930625,
                        "unit": "%"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 16.53458636635173,
                        "unit": "%"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 30.41387783892378,
                        "unit": "%"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 26.05394612527317,
                        "unit": "%"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 35.3197721374909,
                        "unit": "%"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 25.844133794072626,
                        "unit": "%"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 114.54136857142856,
                        "unit": "%"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 37.701839722222225,
                        "unit": "%"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 0.8076666666666668,
                        "unit": "%"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 21.663910833333333,
                        "unit": "%"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 49.54352884615385,
                        "unit": "%"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 84.674336984375,
                        "unit": "%"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 59.86113057692308,
                        "unit": "%"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 35.746445625,
                        "unit": "%"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 244.55937500000005,
                        "unit": "%"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 80.42500000000001,
                        "unit": "%"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 103.64133771666667,
                        "unit": "%"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 91.66827711458332,
                        "unit": "%"
                    }
                },
                "digest": [
                    {
                        "label": "Fat",
                        "tag": "FAT",
                        "schemaOrgTag": "fatContent",
                        "total": 109.66143459999999,
                        "hasRDI": true,
                        "daily": 168.70989938461537,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Saturated",
                                "tag": "FASAT",
                                "schemaOrgTag": "saturatedFatContent",
                                "total": 24.696185059375,
                                "hasRDI": true,
                                "daily": 123.48092529687501,
                                "unit": "g"
                            },
                            {
                                "label": "Trans",
                                "tag": "FATRN",
                                "schemaOrgTag": "transFatContent",
                                "total": 1.243120480625,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Monounsaturated",
                                "tag": "FAMS",
                                "schemaOrgTag": null,
                                "total": 56.378368382000005,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Polyunsaturated",
                                "tag": "FAPU",
                                "schemaOrgTag": null,
                                "total": 24.32087232525,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Carbs",
                        "tag": "CHOCDF",
                        "schemaOrgTag": "carbohydrateContent",
                        "total": 53.465145625000005,
                        "hasRDI": true,
                        "daily": 17.821715208333334,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Carbs (net)",
                                "tag": "CHOCDF.net",
                                "schemaOrgTag": null,
                                "total": 50.63338387500001,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Fiber",
                                "tag": "FIBTG",
                                "schemaOrgTag": "fiberContent",
                                "total": 2.83176175,
                                "hasRDI": true,
                                "daily": 11.327047,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars",
                                "tag": "SUGAR",
                                "schemaOrgTag": "sugarContent",
                                "total": 0.6245654,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars, added",
                                "tag": "SUGAR.added",
                                "schemaOrgTag": null,
                                "total": 0,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Protein",
                        "tag": "PROCNT",
                        "schemaOrgTag": "proteinContent",
                        "total": 82.523701525,
                        "hasRDI": true,
                        "daily": 165.04740305000004,
                        "unit": "g"
                    },
                    {
                        "label": "Cholesterol",
                        "tag": "CHOLE",
                        "schemaOrgTag": "cholesterolContent",
                        "total": 540.6575,
                        "hasRDI": true,
                        "daily": 180.21916666666667,
                        "unit": "mg"
                    },
                    {
                        "label": "Sodium",
                        "tag": "NA",
                        "schemaOrgTag": "sodiumContent",
                        "total": 1340.9325502335,
                        "hasRDI": true,
                        "daily": 55.8721895930625,
                        "unit": "mg"
                    },
                    {
                        "label": "Calcium",
                        "tag": "CA",
                        "schemaOrgTag": null,
                        "total": 165.34586366351732,
                        "hasRDI": true,
                        "daily": 16.53458636635173,
                        "unit": "mg"
                    },
                    {
                        "label": "Magnesium",
                        "tag": "MG",
                        "schemaOrgTag": null,
                        "total": 127.73828692347989,
                        "hasRDI": true,
                        "daily": 30.41387783892378,
                        "unit": "mg"
                    },
                    {
                        "label": "Potassium",
                        "tag": "K",
                        "schemaOrgTag": null,
                        "total": 1224.535467887839,
                        "hasRDI": true,
                        "daily": 26.05394612527317,
                        "unit": "mg"
                    },
                    {
                        "label": "Iron",
                        "tag": "FE",
                        "schemaOrgTag": null,
                        "total": 6.357558984748363,
                        "hasRDI": true,
                        "daily": 35.3197721374909,
                        "unit": "mg"
                    },
                    {
                        "label": "Zinc",
                        "tag": "ZN",
                        "schemaOrgTag": null,
                        "total": 2.8428547173479886,
                        "hasRDI": true,
                        "daily": 25.844133794072626,
                        "unit": "mg"
                    },
                    {
                        "label": "Phosphorus",
                        "tag": "P",
                        "schemaOrgTag": null,
                        "total": 801.78958,
                        "hasRDI": true,
                        "daily": 114.54136857142856,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin A",
                        "tag": "VITA_RAE",
                        "schemaOrgTag": null,
                        "total": 339.31655750000004,
                        "hasRDI": true,
                        "daily": 37.701839722222225,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin C",
                        "tag": "VITC",
                        "schemaOrgTag": null,
                        "total": 0.7269000000000001,
                        "hasRDI": true,
                        "daily": 0.8076666666666668,
                        "unit": "mg"
                    },
                    {
                        "label": "Thiamin (B1)",
                        "tag": "THIA",
                        "schemaOrgTag": null,
                        "total": 0.25996693,
                        "hasRDI": true,
                        "daily": 21.663910833333333,
                        "unit": "mg"
                    },
                    {
                        "label": "Riboflavin (B2)",
                        "tag": "RIBF",
                        "schemaOrgTag": null,
                        "total": 0.644065875,
                        "hasRDI": true,
                        "daily": 49.54352884615385,
                        "unit": "mg"
                    },
                    {
                        "label": "Niacin (B3)",
                        "tag": "NIA",
                        "schemaOrgTag": null,
                        "total": 13.547893917500001,
                        "hasRDI": true,
                        "daily": 84.674336984375,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin B6",
                        "tag": "VITB6A",
                        "schemaOrgTag": null,
                        "total": 0.7781946975000001,
                        "hasRDI": true,
                        "daily": 59.86113057692308,
                        "unit": "mg"
                    },
                    {
                        "label": "Folate equivalent (total)",
                        "tag": "FOLDFE",
                        "schemaOrgTag": null,
                        "total": 142.9857825,
                        "hasRDI": true,
                        "daily": 35.746445625,
                        "unit": "µg"
                    },
                    {
                        "label": "Folate (food)",
                        "tag": "FOLFD",
                        "schemaOrgTag": null,
                        "total": 142.9857825,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Folic acid",
                        "tag": "FOLAC",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin B12",
                        "tag": "VITB12",
                        "schemaOrgTag": null,
                        "total": 5.869425000000001,
                        "hasRDI": true,
                        "daily": 244.55937500000005,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin D",
                        "tag": "VITD",
                        "schemaOrgTag": null,
                        "total": 12.063750000000002,
                        "hasRDI": true,
                        "daily": 80.42500000000001,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin E",
                        "tag": "TOCPHA",
                        "schemaOrgTag": null,
                        "total": 15.5462006575,
                        "hasRDI": true,
                        "daily": 103.64133771666667,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin K",
                        "tag": "VITK1",
                        "schemaOrgTag": null,
                        "total": 110.00193253749998,
                        "hasRDI": true,
                        "daily": 91.66827711458332,
                        "unit": "µg"
                    },
                    {
                        "label": "Sugar alcohols",
                        "tag": "Sugar.alcohol",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    },
                    {
                        "label": "Water",
                        "tag": "WATER",
                        "schemaOrgTag": null,
                        "total": 328.658830484696,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    }
                ]
            },
            "_links": {
                "self": {
                    "href": "https://api.edamam.com/api/recipes/v2/a78de61b0b31e1f0ca8753899987bdf3?type=public&app_id=ea1d37d5&app_key=fd382a172ba8d6668c0430dc9c14a181",
                    "title": "Self"
                }
            }
        },
        {
            "recipe": {
                "uri": "http://www.edamam.com/ontologies/edamam.owl#recipe_22890985b1fb5e6529f40a2481d94618",
                "label": "Moroccan Fish",
                "image": "https://www.edamam.com/web-img/bc9/bc95da578b0d39b2dbfb0cb052ff7cd6.jpg",
                "source": "Delish",
                "url": "http://www.delish.com/cooking/recipe-ideas/recipes/a34193/moroccan-fish-recipe-122416/",
                "shareAs": "http://www.edamam.com/recipe/moroccan-fish-22890985b1fb5e6529f40a2481d94618/fish",
                "yield": 4,
                "dietLabels": [
                    "High-Protein",
                    "Low-Carb",
                    "Low-Sodium"
                ],
                "healthLabels": [
                    "Sugar-Conscious",
                    "Keto-Friendly",
                    "Pescatarian",
                    "Mediterranean",
                    "DASH",
                    "Dairy-Free",
                    "Gluten-Free",
                    "Wheat-Free",
                    "Egg-Free",
                    "Peanut-Free",
                    "Tree-Nut-Free",
                    "Soy-Free",
                    "Shellfish-Free",
                    "Pork-Free",
                    "Red-Meat-Free",
                    "Crustacean-Free",
                    "Celery-Free",
                    "Mustard-Free",
                    "Sesame-Free",
                    "Lupine-Free",
                    "Mollusk-Free",
                    "Alcohol-Free",
                    "Sulfite-Free",
                    "Kosher"
                ],
                "cautions": [
                    "Sulfites"
                ],
                "ingredientLines": [
                    "1 lb. frozen fish fillets or steaks",
                    "4 tsp. olive oil",
                    "¼ tsp. Pepper",
                    "1 c. chopped onion",
                    "2 tsp. minced garlic",
                    "½ tsp. ground cumin",
                    "¼ tsp. cinnamon",
                    "1 can diced tomatoes",
                    "¼ c. pitted Kalamata or other olives"
                ],
                "ingredients": [
                    {
                        "text": "1 lb. frozen fish fillets or steaks",
                        "weight": 453.59237,
                        "foodCategory": "seafood",
                        "foodId": "food_ar6pjbvaxqtlqia7jewa4brld7p9",
                        "image": "https://www.edamam.com/food-img/717/717cb400eb49626bb7c95cd29292cef4.jpg"
                    },
                    {
                        "text": "4 tsp. olive oil",
                        "weight": 18,
                        "foodCategory": "Oils",
                        "foodId": "food_b1d1icuad3iktrbqby0hiagafaz7",
                        "image": "https://www.edamam.com/food-img/4d6/4d651eaa8a353647746290c7a9b29d84.jpg"
                    },
                    {
                        "text": "¼ tsp. Pepper",
                        "weight": 0.725,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_b6ywzluaaxv02wad7s1r9ag4py89",
                        "image": "https://www.edamam.com/food-img/c6e/c6e5c3bd8d3bc15175d9766971a4d1b2.jpg"
                    },
                    {
                        "text": "1 c. chopped onion",
                        "weight": 160,
                        "foodCategory": "vegetables",
                        "foodId": "food_bmrvi4ob4binw9a5m7l07amlfcoy",
                        "image": "https://www.edamam.com/food-img/205/205e6bf2399b85d34741892ef91cc603.jpg"
                    },
                    {
                        "text": "2 tsp. minced garlic",
                        "weight": 5.6,
                        "foodCategory": "vegetables",
                        "foodId": "food_avtcmx6bgjv1jvay6s6stan8dnyp",
                        "image": "https://www.edamam.com/food-img/6ee/6ee142951f48aaf94f4312409f8d133d.jpg"
                    },
                    {
                        "text": "½ tsp. ground cumin",
                        "weight": 1.05,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_a8jjbx4biqndasapojdb5by3e92e",
                        "image": "https://www.edamam.com/food-img/07e/07e2a4eb77ce46591033846504817d35.jpg"
                    },
                    {
                        "text": "¼ tsp. cinnamon",
                        "weight": 0.65,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_atjxtznauw5zabaixm24xa787onz",
                        "image": "https://www.edamam.com/food-img/d4d/d4daa18b92c596a1c99c08537c38e65b.jpg"
                    },
                    {
                        "text": "1 can diced tomatoes",
                        "weight": 190,
                        "foodCategory": "canned vegetables",
                        "foodId": "food_a0edr25b8gjzxdbxcvus4blkd8b8",
                        "image": "https://www.edamam.com/food-img/645/6455f54947348b60ec6557fcc0ef5121.jpeg"
                    },
                    {
                        "text": "¼ c. pitted Kalamata or other olives",
                        "weight": 33.600000000568,
                        "foodCategory": "canned fruit",
                        "foodId": "food_bt7u5w5a064gusa46msxfb38ag06",
                        "image": "https://www.edamam.com/food-img/822/8221f2141e8dafd469414b20777735ca.jpg"
                    }
                ],
                "calories": 743.3154252006533,
                "totalWeight": 863.2173700005679,
                "totalTime": 20,
                "cuisineType": [
                    "american"
                ],
                "mealType": [
                    "lunch/dinner"
                ],
                "totalNutrients": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 743.3154252006533,
                        "unit": "kcal"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 30.228080290060664,
                        "unit": "g"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 5.779631364508038,
                        "unit": "g"
                    },
                    "FATRN": {
                        "label": "Trans",
                        "quantity": 0,
                        "unit": "g"
                    },
                    "FAMS": {
                        "label": "Monounsaturated",
                        "quantity": 18.294030752644808,
                        "unit": "g"
                    },
                    "FAPU": {
                        "label": "Polyunsaturated",
                        "quantity": 4.121927303105175,
                        "unit": "g"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 26.943712500035563,
                        "unit": "g"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 8.161625000018176,
                        "unit": "g"
                    },
                    "SUGAR": {
                        "label": "Sugars",
                        "quantity": 11.72737,
                        "unit": "g"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 95.26901539600479,
                        "unit": "g"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 226.79618500000004,
                        "unit": "mg"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 511.51403240417494,
                        "unit": "mg"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 204.24348700049987,
                        "unit": "mg"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 165.6866899000227,
                        "unit": "mg"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 2022.883707400046,
                        "unit": "mg"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 6.085174772018744,
                        "unit": "mg"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 2.20665732100125,
                        "unit": "mg"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 866.1840290000172,
                        "unit": "mg"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 49.4852500001136,
                        "unit": "µg"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 37.935150000005116,
                        "unit": "mg"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 1.371800871700017,
                        "unit": "mg"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 0.4446281931,
                        "unit": "mg"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 19.358766451100212,
                        "unit": "mg"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 1.2176078894000513,
                        "unit": "mg"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 154.89741879999997,
                        "unit": "µg"
                    },
                    "FOLFD": {
                        "label": "Folate (food)",
                        "quantity": 154.89741879999997,
                        "unit": "µg"
                    },
                    "FOLAC": {
                        "label": "Folic acid",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 7.166759446000001,
                        "unit": "µg"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 14.061363470000002,
                        "unit": "µg"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 6.1668344800093715,
                        "unit": "mg"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 25.34821818000795,
                        "unit": "µg"
                    },
                    "WATER": {
                        "label": "Water",
                        "quantity": 707.1667774964544,
                        "unit": "g"
                    }
                },
                "totalDaily": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 37.16577126003266,
                        "unit": "%"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 46.50473890778564,
                        "unit": "%"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 28.898156822540194,
                        "unit": "%"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 8.981237500011854,
                        "unit": "%"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 32.646500000072706,
                        "unit": "%"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 190.5380307920096,
                        "unit": "%"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 75.59872833333334,
                        "unit": "%"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 21.313084683507288,
                        "unit": "%"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 20.42434870004999,
                        "unit": "%"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 39.44921188095779,
                        "unit": "%"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 43.04007888085204,
                        "unit": "%"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 33.806526511215246,
                        "unit": "%"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 20.06052110001136,
                        "unit": "%"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 123.74057557143102,
                        "unit": "%"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 5.498361111123733,
                        "unit": "%"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 42.15016666667235,
                        "unit": "%"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 114.31673930833475,
                        "unit": "%"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 34.2021687,
                        "unit": "%"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 120.99229031937632,
                        "unit": "%"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 93.66214533846548,
                        "unit": "%"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 38.72435469999999,
                        "unit": "%"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 298.6149769166667,
                        "unit": "%"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 93.74242313333335,
                        "unit": "%"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 41.112229866729145,
                        "unit": "%"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 21.12351515000663,
                        "unit": "%"
                    }
                },
                "digest": [
                    {
                        "label": "Fat",
                        "tag": "FAT",
                        "schemaOrgTag": "fatContent",
                        "total": 30.228080290060664,
                        "hasRDI": true,
                        "daily": 46.50473890778564,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Saturated",
                                "tag": "FASAT",
                                "schemaOrgTag": "saturatedFatContent",
                                "total": 5.779631364508038,
                                "hasRDI": true,
                                "daily": 28.898156822540194,
                                "unit": "g"
                            },
                            {
                                "label": "Trans",
                                "tag": "FATRN",
                                "schemaOrgTag": "transFatContent",
                                "total": 0,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Monounsaturated",
                                "tag": "FAMS",
                                "schemaOrgTag": null,
                                "total": 18.294030752644808,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Polyunsaturated",
                                "tag": "FAPU",
                                "schemaOrgTag": null,
                                "total": 4.121927303105175,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Carbs",
                        "tag": "CHOCDF",
                        "schemaOrgTag": "carbohydrateContent",
                        "total": 26.943712500035563,
                        "hasRDI": true,
                        "daily": 8.981237500011854,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Carbs (net)",
                                "tag": "CHOCDF.net",
                                "schemaOrgTag": null,
                                "total": 18.782087500017386,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Fiber",
                                "tag": "FIBTG",
                                "schemaOrgTag": "fiberContent",
                                "total": 8.161625000018176,
                                "hasRDI": true,
                                "daily": 32.646500000072706,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars",
                                "tag": "SUGAR",
                                "schemaOrgTag": "sugarContent",
                                "total": 11.72737,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars, added",
                                "tag": "SUGAR.added",
                                "schemaOrgTag": null,
                                "total": 0,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Protein",
                        "tag": "PROCNT",
                        "schemaOrgTag": "proteinContent",
                        "total": 95.26901539600479,
                        "hasRDI": true,
                        "daily": 190.5380307920096,
                        "unit": "g"
                    },
                    {
                        "label": "Cholesterol",
                        "tag": "CHOLE",
                        "schemaOrgTag": "cholesterolContent",
                        "total": 226.79618500000004,
                        "hasRDI": true,
                        "daily": 75.59872833333334,
                        "unit": "mg"
                    },
                    {
                        "label": "Sodium",
                        "tag": "NA",
                        "schemaOrgTag": "sodiumContent",
                        "total": 511.51403240417494,
                        "hasRDI": true,
                        "daily": 21.313084683507288,
                        "unit": "mg"
                    },
                    {
                        "label": "Calcium",
                        "tag": "CA",
                        "schemaOrgTag": null,
                        "total": 204.24348700049987,
                        "hasRDI": true,
                        "daily": 20.42434870004999,
                        "unit": "mg"
                    },
                    {
                        "label": "Magnesium",
                        "tag": "MG",
                        "schemaOrgTag": null,
                        "total": 165.6866899000227,
                        "hasRDI": true,
                        "daily": 39.44921188095779,
                        "unit": "mg"
                    },
                    {
                        "label": "Potassium",
                        "tag": "K",
                        "schemaOrgTag": null,
                        "total": 2022.883707400046,
                        "hasRDI": true,
                        "daily": 43.04007888085204,
                        "unit": "mg"
                    },
                    {
                        "label": "Iron",
                        "tag": "FE",
                        "schemaOrgTag": null,
                        "total": 6.085174772018744,
                        "hasRDI": true,
                        "daily": 33.806526511215246,
                        "unit": "mg"
                    },
                    {
                        "label": "Zinc",
                        "tag": "ZN",
                        "schemaOrgTag": null,
                        "total": 2.20665732100125,
                        "hasRDI": true,
                        "daily": 20.06052110001136,
                        "unit": "mg"
                    },
                    {
                        "label": "Phosphorus",
                        "tag": "P",
                        "schemaOrgTag": null,
                        "total": 866.1840290000172,
                        "hasRDI": true,
                        "daily": 123.74057557143102,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin A",
                        "tag": "VITA_RAE",
                        "schemaOrgTag": null,
                        "total": 49.4852500001136,
                        "hasRDI": true,
                        "daily": 5.498361111123733,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin C",
                        "tag": "VITC",
                        "schemaOrgTag": null,
                        "total": 37.935150000005116,
                        "hasRDI": true,
                        "daily": 42.15016666667235,
                        "unit": "mg"
                    },
                    {
                        "label": "Thiamin (B1)",
                        "tag": "THIA",
                        "schemaOrgTag": null,
                        "total": 1.371800871700017,
                        "hasRDI": true,
                        "daily": 114.31673930833475,
                        "unit": "mg"
                    },
                    {
                        "label": "Riboflavin (B2)",
                        "tag": "RIBF",
                        "schemaOrgTag": null,
                        "total": 0.4446281931,
                        "hasRDI": true,
                        "daily": 34.2021687,
                        "unit": "mg"
                    },
                    {
                        "label": "Niacin (B3)",
                        "tag": "NIA",
                        "schemaOrgTag": null,
                        "total": 19.358766451100212,
                        "hasRDI": true,
                        "daily": 120.99229031937632,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin B6",
                        "tag": "VITB6A",
                        "schemaOrgTag": null,
                        "total": 1.2176078894000513,
                        "hasRDI": true,
                        "daily": 93.66214533846548,
                        "unit": "mg"
                    },
                    {
                        "label": "Folate equivalent (total)",
                        "tag": "FOLDFE",
                        "schemaOrgTag": null,
                        "total": 154.89741879999997,
                        "hasRDI": true,
                        "daily": 38.72435469999999,
                        "unit": "µg"
                    },
                    {
                        "label": "Folate (food)",
                        "tag": "FOLFD",
                        "schemaOrgTag": null,
                        "total": 154.89741879999997,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Folic acid",
                        "tag": "FOLAC",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin B12",
                        "tag": "VITB12",
                        "schemaOrgTag": null,
                        "total": 7.166759446000001,
                        "hasRDI": true,
                        "daily": 298.6149769166667,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin D",
                        "tag": "VITD",
                        "schemaOrgTag": null,
                        "total": 14.061363470000002,
                        "hasRDI": true,
                        "daily": 93.74242313333335,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin E",
                        "tag": "TOCPHA",
                        "schemaOrgTag": null,
                        "total": 6.1668344800093715,
                        "hasRDI": true,
                        "daily": 41.112229866729145,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin K",
                        "tag": "VITK1",
                        "schemaOrgTag": null,
                        "total": 25.34821818000795,
                        "hasRDI": true,
                        "daily": 21.12351515000663,
                        "unit": "µg"
                    },
                    {
                        "label": "Sugar alcohols",
                        "tag": "Sugar.alcohol",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    },
                    {
                        "label": "Water",
                        "tag": "WATER",
                        "schemaOrgTag": null,
                        "total": 707.1667774964544,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    }
                ]
            },
            "_links": {
                "self": {
                    "href": "https://api.edamam.com/api/recipes/v2/22890985b1fb5e6529f40a2481d94618?type=public&app_id=ea1d37d5&app_key=fd382a172ba8d6668c0430dc9c14a181",
                    "title": "Self"
                }
            }
        },
        {
            "recipe": {
                "uri": "http://www.edamam.com/ontologies/edamam.owl#recipe_a7f3df990d986c3f48a1c0a6c557f37a",
                "label": "Simple fish stew",
                "image": "https://www.edamam.com/web-img/096/096d48eb86c2bd75ed8adf4d68c5be54.jpg",
                "source": "The Stone Soup",
                "url": "http://thestonesoup.com/blog/2012/06/the-secret-to-eating-more-fish-even-when-you-live-far-form-the-sea/",
                "shareAs": "http://www.edamam.com/recipe/simple-fish-stew-a7f3df990d986c3f48a1c0a6c557f37a/fish",
                "yield": 3,
                "dietLabels": [
                    "High-Protein",
                    "High-Fiber"
                ],
                "healthLabels": [
                    "Pescatarian",
                    "Dairy-Free",
                    "Gluten-Free",
                    "Wheat-Free",
                    "Egg-Free",
                    "Peanut-Free",
                    "Tree-Nut-Free",
                    "Soy-Free",
                    "Shellfish-Free",
                    "Pork-Free",
                    "Red-Meat-Free",
                    "Crustacean-Free",
                    "Celery-Free",
                    "Mustard-Free",
                    "Sesame-Free",
                    "Lupine-Free",
                    "Mollusk-Free",
                    "Alcohol-Free",
                    "Sulfite-Free",
                    "Kosher"
                ],
                "cautions": [
                    "Sulfites",
                    "FODMAP"
                ],
                "ingredientLines": [
                    "2 onions, peeled & chopped",
                    "1 large bulb fennel,trimmed & finely sliced crosswise, green fronds reserved",
                    "1 jar commercial tomato pasta sauce or tomato puree (about 1 1/2cups)",
                    "Large pinch saffron threads",
                    "500g (1lb) white fish fillets such as flathead, chopped"
                ],
                "ingredients": [
                    {
                        "text": "2 onions, peeled & chopped",
                        "weight": 250,
                        "foodCategory": "vegetables",
                        "foodId": "food_bmrvi4ob4binw9a5m7l07amlfcoy",
                        "image": "https://www.edamam.com/food-img/205/205e6bf2399b85d34741892ef91cc603.jpg"
                    },
                    {
                        "text": "1 large bulb fennel,trimmed & finely sliced crosswise, green fronds reserved",
                        "weight": 292.5,
                        "foodCategory": "vegetables",
                        "foodId": "food_a4sdbkob8ixokpb07a42dbt3typw",
                        "image": "https://www.edamam.com/food-img/038/038c19f86af781e925c97991e17b90ed.jpeg"
                    },
                    {
                        "text": "1 jar commercial tomato pasta sauce or tomato puree (about 1 1/2cups)",
                        "weight": 396,
                        "foodCategory": "canned soup",
                        "foodId": "food_a7hv5mybkkrs3ub78yhtxafs67bu",
                        "image": "https://www.edamam.com/food-img/08b/08b3bb49c006689a458a8b9c4a4e0057.jpg"
                    },
                    {
                        "text": "Large pinch saffron threads",
                        "weight": 0.05468750007026976,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_atxgj9uaraga9oa96ntw4bu7o2sy",
                        "image": "https://www.edamam.com/food-img/b7c/b7c71604d7d5e7f54ac461079e6fe175.jpg"
                    },
                    {
                        "text": "500g (1lb) white fish fillets such as flathead, chopped",
                        "weight": 500,
                        "foodCategory": "seafood",
                        "foodId": "food_ar6pjbvaxqtlqia7jewa4brld7p9",
                        "image": "https://www.edamam.com/food-img/717/717cb400eb49626bb7c95cd29292cef4.jpg"
                    }
                ],
                "calories": 864.8845312502178,
                "totalWeight": 1438.5546875000703,
                "totalTime": 312,
                "cuisineType": [
                    "french"
                ],
                "mealType": [
                    "lunch/dinner"
                ],
                "dishType": [
                    "main course"
                ],
                "totalNutrients": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 864.8845312502178,
                        "unit": "kcal"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 15.19899921875411,
                        "unit": "g"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 3.9673173437511142,
                        "unit": "g"
                    },
                    "FATRN": {
                        "label": "Trans",
                        "quantity": 0.0198,
                        "unit": "g"
                    },
                    "FAMS": {
                        "label": "Monounsaturated",
                        "quantity": 4.214554609375302,
                        "unit": "g"
                    },
                    "FAPU": {
                        "label": "Polyunsaturated",
                        "quantity": 4.364635390626453,
                        "unit": "g"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 74.55704921879594,
                        "unit": "g"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 20.447632812502743,
                        "unit": "g"
                    },
                    "SUGAR": {
                        "label": "Sugars",
                        "quantity": 43.87525000000001,
                        "unit": "g"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 112.36685078125802,
                        "unit": "g"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 257.92,
                        "unit": "mg"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 2081.420937500104,
                        "unit": "mg"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 357.805703125078,
                        "unit": "mg"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 281.1493750001855,
                        "unit": "mg"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 4350.132812501211,
                        "unit": "mg"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 8.555120312507801,
                        "unit": "mg"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 3.452596093750766,
                        "unit": "mg"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 1203.527812500177,
                        "unit": "mg"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 271.094765625019,
                        "unit": "µg"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 61.56418750005678,
                        "unit": "mg"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 0.4443528906250808,
                        "unit": "mg"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 0.7178060156251876,
                        "unit": "mg"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 37.18911843750102,
                        "unit": "mg"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 1.9331073437507098,
                        "unit": "mg"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 298.00585937506537,
                        "unit": "µg"
                    },
                    "FOLFD": {
                        "label": "Folate (food)",
                        "quantity": 298.00585937506537,
                        "unit": "µg"
                    },
                    "FOLAC": {
                        "label": "Folic acid",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 7.9,
                        "unit": "µg"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 15.5,
                        "unit": "µg"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 13.250499999999999,
                        "unit": "mg"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 246.734,
                        "unit": "µg"
                    },
                    "WATER": {
                        "label": "Water",
                        "quantity": 1223.1101578125085,
                        "unit": "g"
                    }
                },
                "totalDaily": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 43.24422656251089,
                        "unit": "%"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 23.38307572116017,
                        "unit": "%"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 19.836586718755573,
                        "unit": "%"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 24.852349739598647,
                        "unit": "%"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 81.79053125001097,
                        "unit": "%"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 224.73370156251605,
                        "unit": "%"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 85.97333333333333,
                        "unit": "%"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 86.72587239583767,
                        "unit": "%"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 35.7805703125078,
                        "unit": "%"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 66.94032738099655,
                        "unit": "%"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 92.55601728725982,
                        "unit": "%"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 47.5284461805989,
                        "unit": "%"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 31.387237215916056,
                        "unit": "%"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 171.93254464288245,
                        "unit": "%"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 30.121640625002115,
                        "unit": "%"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 68.40465277784087,
                        "unit": "%"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 37.02940755209007,
                        "unit": "%"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 55.215847355783666,
                        "unit": "%"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 232.4319902343814,
                        "unit": "%"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 148.70056490390076,
                        "unit": "%"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 74.50146484376634,
                        "unit": "%"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 329.1666666666667,
                        "unit": "%"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 103.33333333333333,
                        "unit": "%"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 88.33666666666666,
                        "unit": "%"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 205.61166666666668,
                        "unit": "%"
                    }
                },
                "digest": [
                    {
                        "label": "Fat",
                        "tag": "FAT",
                        "schemaOrgTag": "fatContent",
                        "total": 15.19899921875411,
                        "hasRDI": true,
                        "daily": 23.38307572116017,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Saturated",
                                "tag": "FASAT",
                                "schemaOrgTag": "saturatedFatContent",
                                "total": 3.9673173437511142,
                                "hasRDI": true,
                                "daily": 19.836586718755573,
                                "unit": "g"
                            },
                            {
                                "label": "Trans",
                                "tag": "FATRN",
                                "schemaOrgTag": "transFatContent",
                                "total": 0.0198,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Monounsaturated",
                                "tag": "FAMS",
                                "schemaOrgTag": null,
                                "total": 4.214554609375302,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Polyunsaturated",
                                "tag": "FAPU",
                                "schemaOrgTag": null,
                                "total": 4.364635390626453,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Carbs",
                        "tag": "CHOCDF",
                        "schemaOrgTag": "carbohydrateContent",
                        "total": 74.55704921879594,
                        "hasRDI": true,
                        "daily": 24.852349739598647,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Carbs (net)",
                                "tag": "CHOCDF.net",
                                "schemaOrgTag": null,
                                "total": 54.10941640629319,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Fiber",
                                "tag": "FIBTG",
                                "schemaOrgTag": "fiberContent",
                                "total": 20.447632812502743,
                                "hasRDI": true,
                                "daily": 81.79053125001097,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars",
                                "tag": "SUGAR",
                                "schemaOrgTag": "sugarContent",
                                "total": 43.87525000000001,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars, added",
                                "tag": "SUGAR.added",
                                "schemaOrgTag": null,
                                "total": 0,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Protein",
                        "tag": "PROCNT",
                        "schemaOrgTag": "proteinContent",
                        "total": 112.36685078125802,
                        "hasRDI": true,
                        "daily": 224.73370156251605,
                        "unit": "g"
                    },
                    {
                        "label": "Cholesterol",
                        "tag": "CHOLE",
                        "schemaOrgTag": "cholesterolContent",
                        "total": 257.92,
                        "hasRDI": true,
                        "daily": 85.97333333333333,
                        "unit": "mg"
                    },
                    {
                        "label": "Sodium",
                        "tag": "NA",
                        "schemaOrgTag": "sodiumContent",
                        "total": 2081.420937500104,
                        "hasRDI": true,
                        "daily": 86.72587239583767,
                        "unit": "mg"
                    },
                    {
                        "label": "Calcium",
                        "tag": "CA",
                        "schemaOrgTag": null,
                        "total": 357.805703125078,
                        "hasRDI": true,
                        "daily": 35.7805703125078,
                        "unit": "mg"
                    },
                    {
                        "label": "Magnesium",
                        "tag": "MG",
                        "schemaOrgTag": null,
                        "total": 281.1493750001855,
                        "hasRDI": true,
                        "daily": 66.94032738099655,
                        "unit": "mg"
                    },
                    {
                        "label": "Potassium",
                        "tag": "K",
                        "schemaOrgTag": null,
                        "total": 4350.132812501211,
                        "hasRDI": true,
                        "daily": 92.55601728725982,
                        "unit": "mg"
                    },
                    {
                        "label": "Iron",
                        "tag": "FE",
                        "schemaOrgTag": null,
                        "total": 8.555120312507801,
                        "hasRDI": true,
                        "daily": 47.5284461805989,
                        "unit": "mg"
                    },
                    {
                        "label": "Zinc",
                        "tag": "ZN",
                        "schemaOrgTag": null,
                        "total": 3.452596093750766,
                        "hasRDI": true,
                        "daily": 31.387237215916056,
                        "unit": "mg"
                    },
                    {
                        "label": "Phosphorus",
                        "tag": "P",
                        "schemaOrgTag": null,
                        "total": 1203.527812500177,
                        "hasRDI": true,
                        "daily": 171.93254464288245,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin A",
                        "tag": "VITA_RAE",
                        "schemaOrgTag": null,
                        "total": 271.094765625019,
                        "hasRDI": true,
                        "daily": 30.121640625002115,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin C",
                        "tag": "VITC",
                        "schemaOrgTag": null,
                        "total": 61.56418750005678,
                        "hasRDI": true,
                        "daily": 68.40465277784087,
                        "unit": "mg"
                    },
                    {
                        "label": "Thiamin (B1)",
                        "tag": "THIA",
                        "schemaOrgTag": null,
                        "total": 0.4443528906250808,
                        "hasRDI": true,
                        "daily": 37.02940755209007,
                        "unit": "mg"
                    },
                    {
                        "label": "Riboflavin (B2)",
                        "tag": "RIBF",
                        "schemaOrgTag": null,
                        "total": 0.7178060156251876,
                        "hasRDI": true,
                        "daily": 55.215847355783666,
                        "unit": "mg"
                    },
                    {
                        "label": "Niacin (B3)",
                        "tag": "NIA",
                        "schemaOrgTag": null,
                        "total": 37.18911843750102,
                        "hasRDI": true,
                        "daily": 232.4319902343814,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin B6",
                        "tag": "VITB6A",
                        "schemaOrgTag": null,
                        "total": 1.9331073437507098,
                        "hasRDI": true,
                        "daily": 148.70056490390076,
                        "unit": "mg"
                    },
                    {
                        "label": "Folate equivalent (total)",
                        "tag": "FOLDFE",
                        "schemaOrgTag": null,
                        "total": 298.00585937506537,
                        "hasRDI": true,
                        "daily": 74.50146484376634,
                        "unit": "µg"
                    },
                    {
                        "label": "Folate (food)",
                        "tag": "FOLFD",
                        "schemaOrgTag": null,
                        "total": 298.00585937506537,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Folic acid",
                        "tag": "FOLAC",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin B12",
                        "tag": "VITB12",
                        "schemaOrgTag": null,
                        "total": 7.9,
                        "hasRDI": true,
                        "daily": 329.1666666666667,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin D",
                        "tag": "VITD",
                        "schemaOrgTag": null,
                        "total": 15.5,
                        "hasRDI": true,
                        "daily": 103.33333333333333,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin E",
                        "tag": "TOCPHA",
                        "schemaOrgTag": null,
                        "total": 13.250499999999999,
                        "hasRDI": true,
                        "daily": 88.33666666666666,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin K",
                        "tag": "VITK1",
                        "schemaOrgTag": null,
                        "total": 246.734,
                        "hasRDI": true,
                        "daily": 205.61166666666668,
                        "unit": "µg"
                    },
                    {
                        "label": "Sugar alcohols",
                        "tag": "Sugar.alcohol",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    },
                    {
                        "label": "Water",
                        "tag": "WATER",
                        "schemaOrgTag": null,
                        "total": 1223.1101578125085,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    }
                ]
            },
            "_links": {
                "self": {
                    "href": "https://api.edamam.com/api/recipes/v2/a7f3df990d986c3f48a1c0a6c557f37a?type=public&app_id=ea1d37d5&app_key=fd382a172ba8d6668c0430dc9c14a181",
                    "title": "Self"
                }
            }
        },
        {
            "recipe": {
                "uri": "http://www.edamam.com/ontologies/edamam.owl#recipe_2b99f00063b585a1345d1cfdc148d51d",
                "label": "Tamarind Fish Curry Recipe",
                "image": "https://www.edamam.com/web-img/dae/dae1e072437351b4e28f9fe24324a45a.jpg",
                "source": "Serious Eats",
                "url": "http://www.seriouseats.com/recipes/2013/09/tamarind-fish-curry-recipe.html",
                "shareAs": "http://www.edamam.com/recipe/tamarind-fish-curry-recipe-2b99f00063b585a1345d1cfdc148d51d/fish",
                "yield": 2,
                "dietLabels": [
                    "Low-Carb"
                ],
                "healthLabels": [
                    "Sugar-Conscious",
                    "Pescatarian",
                    "Mediterranean",
                    "Dairy-Free",
                    "Gluten-Free",
                    "Wheat-Free",
                    "Egg-Free",
                    "Peanut-Free",
                    "Tree-Nut-Free",
                    "Soy-Free",
                    "Shellfish-Free",
                    "Pork-Free",
                    "Red-Meat-Free",
                    "Crustacean-Free",
                    "Celery-Free",
                    "Mustard-Free",
                    "Sesame-Free",
                    "Lupine-Free",
                    "Mollusk-Free",
                    "Alcohol-Free",
                    "Sulfite-Free",
                    "Kosher"
                ],
                "cautions": [
                    "Sulfites",
                    "FODMAP"
                ],
                "ingredientLines": [
                    "4 fillets king fish (or any firm fleshed sea fish) about 6 ounces each",
                    "1 teaspoon turmeric powder",
                    "Kosher salt",
                    "11/2 tablespoons vegetable oil",
                    "3 medium cloves garlic sliced fine",
                    "6 curry leaves",
                    "1 1/2 teaspoon red chilli powder",
                    "1 teaspoon coriander powder",
                    "2 teaspoons cumin powder",
                    "1 teaspoon toasted and ground fennel seeds",
                    "1 tablespoon tamarind soaked in 1 1/2 cup water",
                    "2 teaspoons rice flour dissolved in 1/4 cup water"
                ],
                "ingredients": [
                    {
                        "text": "4 fillets king fish (or any firm fleshed sea fish) about 6 ounces each",
                        "weight": 680.388555,
                        "foodCategory": "seafood",
                        "foodId": "food_ar6pjbvaxqtlqia7jewa4brld7p9",
                        "image": "https://www.edamam.com/food-img/717/717cb400eb49626bb7c95cd29292cef4.jpg"
                    },
                    {
                        "text": "1 teaspoon turmeric powder",
                        "weight": 3,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_bc3ig84amucgmwba3vixyatnyd9b",
                        "image": "https://www.edamam.com/food-img/03e/03eb469286b3caf1ae9c13e4eba13587.jpg"
                    },
                    {
                        "text": "Kosher salt",
                        "weight": 4.794731330001243,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_a1vgrj1bs8rd1majvmd9ubz8ttkg",
                        "image": "https://www.edamam.com/food-img/694/6943ea510918c6025795e8dc6e6eaaeb.jpg"
                    },
                    {
                        "text": "11/2 tablespoons vegetable oil",
                        "weight": 77,
                        "foodCategory": "Oils",
                        "foodId": "food_bt1mzi2ah2sfg8bv7no1qai83w8s",
                        "image": "https://www.edamam.com/food-img/6e5/6e51a63a6300a8ea1b4c4cc68dfaba33.jpg"
                    },
                    {
                        "text": "3 medium cloves garlic sliced fine",
                        "weight": 9,
                        "foodCategory": "vegetables",
                        "foodId": "food_avtcmx6bgjv1jvay6s6stan8dnyp",
                        "image": "https://www.edamam.com/food-img/6ee/6ee142951f48aaf94f4312409f8d133d.jpg"
                    },
                    {
                        "text": "6 curry leaves",
                        "weight": 3.5999999999999996,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_asx39x4ayja4jab6ivj6zayvkblo",
                        "image": "https://www.edamam.com/food-img/0f9/0f9f5f95df173e9ffaaff2977bef88f3.jpg"
                    },
                    {
                        "text": "1 1/2 teaspoon red chilli powder",
                        "weight": 4.050000000000001,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_aii2sclb4r123rbfr2ybjasrl3nc",
                        "image": "https://www.edamam.com/food-img/e6f/e6f19043caefc23b5feda5520076617e.jpg"
                    },
                    {
                        "text": "1 teaspoon coriander powder",
                        "weight": 1.8,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_afpcy6rb44nx6gbfff63ga2cqksw",
                        "image": "https://www.edamam.com/food-img/a90/a901cee0b9028841d258f5d07b5924e7.jpg"
                    },
                    {
                        "text": "2 teaspoons cumin powder",
                        "weight": 4.2,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_a8jjbx4biqndasapojdb5by3e92e",
                        "image": "https://www.edamam.com/food-img/07e/07e2a4eb77ce46591033846504817d35.jpg"
                    },
                    {
                        "text": "1 teaspoon toasted and ground fennel seeds",
                        "weight": 2,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_a7gzoswb5qrepsa8xcla8bxm5wla",
                        "image": "https://www.edamam.com/food-img/a40/a4059150e503052ae5a390af6e666873.jpg"
                    },
                    {
                        "text": "1 tablespoon tamarind soaked in 1 1/2 cup water",
                        "weight": 7.499999999873198,
                        "foodCategory": "fruit",
                        "foodId": "food_b8wxjbga5zblgbada09f7b61mz7n",
                        "image": "https://www.edamam.com/food-img/dde/dded3ea24aeb0014358a92d524065b80.jpg"
                    },
                    {
                        "text": "2 teaspoons rice flour dissolved in 1/4 cup water",
                        "weight": 6.583333333667247,
                        "foodCategory": "grains",
                        "foodId": "food_aqhc4cvbkrr2jnai8i98zbrsuelh",
                        "image": "https://www.edamam.com/food-img/252/25233e59c8548d747b232000e7c3f939.jpg"
                    }
                ],
                "calories": 1449.3460128009194,
                "totalWeight": 802.6662209107682,
                "totalTime": 20,
                "cuisineType": [
                    "indian"
                ],
                "mealType": [
                    "lunch/dinner"
                ],
                "dishType": [
                    "main course"
                ],
                "totalNutrients": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 1449.3460128009194,
                        "unit": "kcal"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 91.2794887683373,
                        "unit": "g"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 9.37638571341761,
                        "unit": "g"
                    },
                    "FATRN": {
                        "label": "Trans",
                        "quantity": 0.5922700000000001,
                        "unit": "g"
                    },
                    "FAMS": {
                        "label": "Monounsaturated",
                        "quantity": 60.099943837234584,
                        "unit": "g"
                    },
                    "FAPU": {
                        "label": "Polyunsaturated",
                        "quantity": 16.319437287984528,
                        "unit": "g"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 23.557795000188314,
                        "unit": "g"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 5.7579000000015474,
                        "unit": "g"
                    },
                    "SUGAR": {
                        "label": "Sugars",
                        "quantity": 3.489894999951202,
                        "unit": "g"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 140.1923001773496,
                        "unit": "g"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 340.1942775,
                        "unit": "mg"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 1858.3419688818817,
                        "unit": "mg"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 215.60082865180755,
                        "unit": "mg"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 240.80101984243916,
                        "unit": "mg"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 2435.4513160389697,
                        "unit": "mg"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 11.558243872169136,
                        "unit": "mg"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 3.2159432307464386,
                        "unit": "mg"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 1248.605210166851,
                        "unit": "mg"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 74.16349999999747,
                        "unit": "µg"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 5.915249999995562,
                        "unit": "mg"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 0.38917130754991813,
                        "unit": "mg"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 0.5350672896498774,
                        "unit": "mg"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 27.868561634989526,
                        "unit": "mg"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 1.425359792434706,
                        "unit": "mg"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 173.51058653332893,
                        "unit": "µg"
                    },
                    "FOLFD": {
                        "label": "Folate (food)",
                        "quantity": 173.51058653332893,
                        "unit": "µg"
                    },
                    "FOLAC": {
                        "label": "Folic acid",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 10.750139169,
                        "unit": "µg"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 21.092045205,
                        "unit": "µg"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 21.34692588666691,
                        "unit": "mg"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 14.798089769996452,
                        "unit": "µg"
                    },
                    "WATER": {
                        "label": "Water",
                        "quantity": 541.3553457424878,
                        "unit": "g"
                    }
                },
                "totalDaily": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 72.46730064004598,
                        "unit": "%"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 140.42998272051892,
                        "unit": "%"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 46.88192856708805,
                        "unit": "%"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 7.852598333396104,
                        "unit": "%"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 23.031600000006186,
                        "unit": "%"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 280.3846003546992,
                        "unit": "%"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 113.3980925,
                        "unit": "%"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 77.4309153700784,
                        "unit": "%"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 21.560082865180753,
                        "unit": "%"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 57.333576152961705,
                        "unit": "%"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 51.81811310721212,
                        "unit": "%"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 64.21246595649521,
                        "unit": "%"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 29.23584755224035,
                        "unit": "%"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 178.37217288097872,
                        "unit": "%"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 8.240388888888607,
                        "unit": "%"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 6.5724999999950695,
                        "unit": "%"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 32.43094229582652,
                        "unit": "%"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 41.15902228075979,
                        "unit": "%"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 174.17851021868452,
                        "unit": "%"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 109.64306095651584,
                        "unit": "%"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 43.37764663333223,
                        "unit": "%"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 447.92246537500006,
                        "unit": "%"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 140.6136347,
                        "unit": "%"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 142.31283924444605,
                        "unit": "%"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 12.331741474997044,
                        "unit": "%"
                    }
                },
                "digest": [
                    {
                        "label": "Fat",
                        "tag": "FAT",
                        "schemaOrgTag": "fatContent",
                        "total": 91.2794887683373,
                        "hasRDI": true,
                        "daily": 140.42998272051892,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Saturated",
                                "tag": "FASAT",
                                "schemaOrgTag": "saturatedFatContent",
                                "total": 9.37638571341761,
                                "hasRDI": true,
                                "daily": 46.88192856708805,
                                "unit": "g"
                            },
                            {
                                "label": "Trans",
                                "tag": "FATRN",
                                "schemaOrgTag": "transFatContent",
                                "total": 0.5922700000000001,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Monounsaturated",
                                "tag": "FAMS",
                                "schemaOrgTag": null,
                                "total": 60.099943837234584,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Polyunsaturated",
                                "tag": "FAPU",
                                "schemaOrgTag": null,
                                "total": 16.319437287984528,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Carbs",
                        "tag": "CHOCDF",
                        "schemaOrgTag": "carbohydrateContent",
                        "total": 23.557795000188314,
                        "hasRDI": true,
                        "daily": 7.852598333396104,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Carbs (net)",
                                "tag": "CHOCDF.net",
                                "schemaOrgTag": null,
                                "total": 17.799895000186766,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Fiber",
                                "tag": "FIBTG",
                                "schemaOrgTag": "fiberContent",
                                "total": 5.7579000000015474,
                                "hasRDI": true,
                                "daily": 23.031600000006186,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars",
                                "tag": "SUGAR",
                                "schemaOrgTag": "sugarContent",
                                "total": 3.489894999951202,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars, added",
                                "tag": "SUGAR.added",
                                "schemaOrgTag": null,
                                "total": 0,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Protein",
                        "tag": "PROCNT",
                        "schemaOrgTag": "proteinContent",
                        "total": 140.1923001773496,
                        "hasRDI": true,
                        "daily": 280.3846003546992,
                        "unit": "g"
                    },
                    {
                        "label": "Cholesterol",
                        "tag": "CHOLE",
                        "schemaOrgTag": "cholesterolContent",
                        "total": 340.1942775,
                        "hasRDI": true,
                        "daily": 113.3980925,
                        "unit": "mg"
                    },
                    {
                        "label": "Sodium",
                        "tag": "NA",
                        "schemaOrgTag": "sodiumContent",
                        "total": 1858.3419688818817,
                        "hasRDI": true,
                        "daily": 77.4309153700784,
                        "unit": "mg"
                    },
                    {
                        "label": "Calcium",
                        "tag": "CA",
                        "schemaOrgTag": null,
                        "total": 215.60082865180755,
                        "hasRDI": true,
                        "daily": 21.560082865180753,
                        "unit": "mg"
                    },
                    {
                        "label": "Magnesium",
                        "tag": "MG",
                        "schemaOrgTag": null,
                        "total": 240.80101984243916,
                        "hasRDI": true,
                        "daily": 57.333576152961705,
                        "unit": "mg"
                    },
                    {
                        "label": "Potassium",
                        "tag": "K",
                        "schemaOrgTag": null,
                        "total": 2435.4513160389697,
                        "hasRDI": true,
                        "daily": 51.81811310721212,
                        "unit": "mg"
                    },
                    {
                        "label": "Iron",
                        "tag": "FE",
                        "schemaOrgTag": null,
                        "total": 11.558243872169136,
                        "hasRDI": true,
                        "daily": 64.21246595649521,
                        "unit": "mg"
                    },
                    {
                        "label": "Zinc",
                        "tag": "ZN",
                        "schemaOrgTag": null,
                        "total": 3.2159432307464386,
                        "hasRDI": true,
                        "daily": 29.23584755224035,
                        "unit": "mg"
                    },
                    {
                        "label": "Phosphorus",
                        "tag": "P",
                        "schemaOrgTag": null,
                        "total": 1248.605210166851,
                        "hasRDI": true,
                        "daily": 178.37217288097872,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin A",
                        "tag": "VITA_RAE",
                        "schemaOrgTag": null,
                        "total": 74.16349999999747,
                        "hasRDI": true,
                        "daily": 8.240388888888607,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin C",
                        "tag": "VITC",
                        "schemaOrgTag": null,
                        "total": 5.915249999995562,
                        "hasRDI": true,
                        "daily": 6.5724999999950695,
                        "unit": "mg"
                    },
                    {
                        "label": "Thiamin (B1)",
                        "tag": "THIA",
                        "schemaOrgTag": null,
                        "total": 0.38917130754991813,
                        "hasRDI": true,
                        "daily": 32.43094229582652,
                        "unit": "mg"
                    },
                    {
                        "label": "Riboflavin (B2)",
                        "tag": "RIBF",
                        "schemaOrgTag": null,
                        "total": 0.5350672896498774,
                        "hasRDI": true,
                        "daily": 41.15902228075979,
                        "unit": "mg"
                    },
                    {
                        "label": "Niacin (B3)",
                        "tag": "NIA",
                        "schemaOrgTag": null,
                        "total": 27.868561634989526,
                        "hasRDI": true,
                        "daily": 174.17851021868452,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin B6",
                        "tag": "VITB6A",
                        "schemaOrgTag": null,
                        "total": 1.425359792434706,
                        "hasRDI": true,
                        "daily": 109.64306095651584,
                        "unit": "mg"
                    },
                    {
                        "label": "Folate equivalent (total)",
                        "tag": "FOLDFE",
                        "schemaOrgTag": null,
                        "total": 173.51058653332893,
                        "hasRDI": true,
                        "daily": 43.37764663333223,
                        "unit": "µg"
                    },
                    {
                        "label": "Folate (food)",
                        "tag": "FOLFD",
                        "schemaOrgTag": null,
                        "total": 173.51058653332893,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Folic acid",
                        "tag": "FOLAC",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin B12",
                        "tag": "VITB12",
                        "schemaOrgTag": null,
                        "total": 10.750139169,
                        "hasRDI": true,
                        "daily": 447.92246537500006,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin D",
                        "tag": "VITD",
                        "schemaOrgTag": null,
                        "total": 21.092045205,
                        "hasRDI": true,
                        "daily": 140.6136347,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin E",
                        "tag": "TOCPHA",
                        "schemaOrgTag": null,
                        "total": 21.34692588666691,
                        "hasRDI": true,
                        "daily": 142.31283924444605,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin K",
                        "tag": "VITK1",
                        "schemaOrgTag": null,
                        "total": 14.798089769996452,
                        "hasRDI": true,
                        "daily": 12.331741474997044,
                        "unit": "µg"
                    },
                    {
                        "label": "Sugar alcohols",
                        "tag": "Sugar.alcohol",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    },
                    {
                        "label": "Water",
                        "tag": "WATER",
                        "schemaOrgTag": null,
                        "total": 541.3553457424878,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    }
                ]
            },
            "_links": {
                "self": {
                    "href": "https://api.edamam.com/api/recipes/v2/2b99f00063b585a1345d1cfdc148d51d?type=public&app_id=ea1d37d5&app_key=fd382a172ba8d6668c0430dc9c14a181",
                    "title": "Self"
                }
            }
        }
    ]
};

export const fruitRecipes = {
    "from": 1,
    "to": 20,
    "count": 10000,
    "_links": {
        "next": {
            "href": "https://api.edamam.com/api/recipes/v2?q=fruit&app_key=fd382a172ba8d6668c0430dc9c14a181&_cont=CHcVQBtNNQphDmgVQntAEX4BYVdtAgAERGFEAGcXYVF7BAcPUXlSADYSZ1FzBAUCFmBAAzQXMAd3AFBRSjNHUjESMlUmDVIVLnlSVSBMPkd5BgMbUSYRVTdgMgksRlpSAAcRXTVGcV84SU4%3D&type=public&app_id=ea1d37d5",
            "title": "Next page"
        }
    },
    "hits": [
        {
            "recipe": {
                "uri": "http://www.edamam.com/ontologies/edamam.owl#recipe_2093a125d3a71431e70d28c6ceddc539",
                "label": "Passion Fruit Sorbet Cups",
                "image": "https://www.edamam.com/web-img/06f/06ffc1e2ed4c20985af5774aada648a9.jpg",
                "source": "Martha Stewart",
                "url": "https://www.marthastewart.com/1050169/passion-fruit-sorbet",
                "shareAs": "http://www.edamam.com/recipe/passion-fruit-sorbet-cups-2093a125d3a71431e70d28c6ceddc539/fruit",
                "yield": 2,
                "dietLabels": [
                    "Low-Fat",
                    "Low-Sodium"
                ],
                "healthLabels": [
                    "Low Potassium",
                    "Kidney-Friendly",
                    "Vegan",
                    "Vegetarian",
                    "Pescatarian",
                    "Paleo",
                    "Dairy-Free",
                    "Gluten-Free",
                    "Wheat-Free",
                    "Egg-Free",
                    "Peanut-Free",
                    "Tree-Nut-Free",
                    "Soy-Free",
                    "Fish-Free",
                    "Shellfish-Free",
                    "Pork-Free",
                    "Red-Meat-Free",
                    "Crustacean-Free",
                    "Celery-Free",
                    "Mustard-Free",
                    "Sesame-Free",
                    "Lupine-Free",
                    "Mollusk-Free",
                    "Alcohol-Free",
                    "No oil added",
                    "Sulfite-Free",
                    "FODMAP-Free",
                    "Kosher"
                ],
                "cautions": [
                    "Sulfites",
                    "FODMAP"
                ],
                "ingredientLines": [
                    "2 ripe passion fruit",
                    "1 pint passion fruit sorbet"
                ],
                "ingredients": [
                    {
                        "text": "2 ripe passion fruit",
                        "weight": 36,
                        "foodCategory": "fruit",
                        "foodId": "food_b6nwerkagnmbhiac3tjmtasm5dwm",
                        "image": "https://www.edamam.com/food-img/393/393e886951f47632fedd2852531af6d2.jpg"
                    },
                    {
                        "text": "1 pint passion fruit sorbet",
                        "weight": 480,
                        "foodCategory": "frozen treats",
                        "foodId": "food_bb0gx1jbgwfbl6b7fnyhhbpoxd4h",
                        "image": "https://www.edamam.com/food-img/6f6/6f6caa41014c15fa613abef327a63b7e.jpg"
                    }
                ],
                "calories": 586.92,
                "totalWeight": 516,
                "totalTime": 0,
                "cuisineType": [
                    "italian"
                ],
                "mealType": [
                    "lunch/dinner"
                ],
                "dishType": [
                    "desserts"
                ],
                "totalNutrients": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 586.92,
                        "unit": "kcal"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 0.252,
                        "unit": "g"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 0.02124,
                        "unit": "g"
                    },
                    "FATRN": {
                        "label": "Trans",
                        "quantity": 0,
                        "unit": "g"
                    },
                    "FAMS": {
                        "label": "Monounsaturated",
                        "quantity": 0.030959999999999998,
                        "unit": "g"
                    },
                    "FAPU": {
                        "label": "Polyunsaturated",
                        "quantity": 0.14795999999999998,
                        "unit": "g"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 151.4568,
                        "unit": "g"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 8.544,
                        "unit": "g"
                    },
                    "SUGAR": {
                        "label": "Sugars",
                        "quantity": 142.27200000000002,
                        "unit": "g"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 0.792,
                        "unit": "g"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 0,
                        "unit": "mg"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 34.08,
                        "unit": "mg"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 4.32,
                        "unit": "mg"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 10.44,
                        "unit": "mg"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 125.28,
                        "unit": "mg"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 0.576,
                        "unit": "mg"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 0.036,
                        "unit": "mg"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 24.48,
                        "unit": "mg"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 23.04,
                        "unit": "µg"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 125.99999999999999,
                        "unit": "mg"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 0,
                        "unit": "mg"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 0.0468,
                        "unit": "mg"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 0.54,
                        "unit": "mg"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 0.036,
                        "unit": "mg"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 5.04,
                        "unit": "µg"
                    },
                    "FOLFD": {
                        "label": "Folate (food)",
                        "quantity": 5.04,
                        "unit": "µg"
                    },
                    "FOLAC": {
                        "label": "Folic acid",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 0.0072,
                        "unit": "mg"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 0.252,
                        "unit": "µg"
                    },
                    "WATER": {
                        "label": "Water",
                        "quantity": 26.254800000000003,
                        "unit": "g"
                    }
                },
                "totalDaily": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 29.345999999999997,
                        "unit": "%"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 0.38769230769230767,
                        "unit": "%"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 0.10619999999999999,
                        "unit": "%"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 50.4856,
                        "unit": "%"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 34.176,
                        "unit": "%"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 1.584,
                        "unit": "%"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 0,
                        "unit": "%"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 1.42,
                        "unit": "%"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 0.432,
                        "unit": "%"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 2.4857142857142858,
                        "unit": "%"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 2.665531914893617,
                        "unit": "%"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 3.1999999999999997,
                        "unit": "%"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 0.3272727272727272,
                        "unit": "%"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 3.4971428571428573,
                        "unit": "%"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 2.56,
                        "unit": "%"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 139.99999999999997,
                        "unit": "%"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 0,
                        "unit": "%"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 3.5999999999999996,
                        "unit": "%"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 3.375,
                        "unit": "%"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 2.7692307692307687,
                        "unit": "%"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 1.26,
                        "unit": "%"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 0,
                        "unit": "%"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 0,
                        "unit": "%"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 0.048,
                        "unit": "%"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 0.21,
                        "unit": "%"
                    }
                },
                "digest": [
                    {
                        "label": "Fat",
                        "tag": "FAT",
                        "schemaOrgTag": "fatContent",
                        "total": 0.252,
                        "hasRDI": true,
                        "daily": 0.38769230769230767,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Saturated",
                                "tag": "FASAT",
                                "schemaOrgTag": "saturatedFatContent",
                                "total": 0.02124,
                                "hasRDI": true,
                                "daily": 0.10619999999999999,
                                "unit": "g"
                            },
                            {
                                "label": "Trans",
                                "tag": "FATRN",
                                "schemaOrgTag": "transFatContent",
                                "total": 0,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Monounsaturated",
                                "tag": "FAMS",
                                "schemaOrgTag": null,
                                "total": 0.030959999999999998,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Polyunsaturated",
                                "tag": "FAPU",
                                "schemaOrgTag": null,
                                "total": 0.14795999999999998,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Carbs",
                        "tag": "CHOCDF",
                        "schemaOrgTag": "carbohydrateContent",
                        "total": 151.4568,
                        "hasRDI": true,
                        "daily": 50.4856,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Carbs (net)",
                                "tag": "CHOCDF.net",
                                "schemaOrgTag": null,
                                "total": 142.91279999999998,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Fiber",
                                "tag": "FIBTG",
                                "schemaOrgTag": "fiberContent",
                                "total": 8.544,
                                "hasRDI": true,
                                "daily": 34.176,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars",
                                "tag": "SUGAR",
                                "schemaOrgTag": "sugarContent",
                                "total": 142.27200000000002,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars, added",
                                "tag": "SUGAR.added",
                                "schemaOrgTag": null,
                                "total": 0,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Protein",
                        "tag": "PROCNT",
                        "schemaOrgTag": "proteinContent",
                        "total": 0.792,
                        "hasRDI": true,
                        "daily": 1.584,
                        "unit": "g"
                    },
                    {
                        "label": "Cholesterol",
                        "tag": "CHOLE",
                        "schemaOrgTag": "cholesterolContent",
                        "total": 0,
                        "hasRDI": true,
                        "daily": 0,
                        "unit": "mg"
                    },
                    {
                        "label": "Sodium",
                        "tag": "NA",
                        "schemaOrgTag": "sodiumContent",
                        "total": 34.08,
                        "hasRDI": true,
                        "daily": 1.42,
                        "unit": "mg"
                    },
                    {
                        "label": "Calcium",
                        "tag": "CA",
                        "schemaOrgTag": null,
                        "total": 4.32,
                        "hasRDI": true,
                        "daily": 0.432,
                        "unit": "mg"
                    },
                    {
                        "label": "Magnesium",
                        "tag": "MG",
                        "schemaOrgTag": null,
                        "total": 10.44,
                        "hasRDI": true,
                        "daily": 2.4857142857142858,
                        "unit": "mg"
                    },
                    {
                        "label": "Potassium",
                        "tag": "K",
                        "schemaOrgTag": null,
                        "total": 125.28,
                        "hasRDI": true,
                        "daily": 2.665531914893617,
                        "unit": "mg"
                    },
                    {
                        "label": "Iron",
                        "tag": "FE",
                        "schemaOrgTag": null,
                        "total": 0.576,
                        "hasRDI": true,
                        "daily": 3.1999999999999997,
                        "unit": "mg"
                    },
                    {
                        "label": "Zinc",
                        "tag": "ZN",
                        "schemaOrgTag": null,
                        "total": 0.036,
                        "hasRDI": true,
                        "daily": 0.3272727272727272,
                        "unit": "mg"
                    },
                    {
                        "label": "Phosphorus",
                        "tag": "P",
                        "schemaOrgTag": null,
                        "total": 24.48,
                        "hasRDI": true,
                        "daily": 3.4971428571428573,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin A",
                        "tag": "VITA_RAE",
                        "schemaOrgTag": null,
                        "total": 23.04,
                        "hasRDI": true,
                        "daily": 2.56,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin C",
                        "tag": "VITC",
                        "schemaOrgTag": null,
                        "total": 125.99999999999999,
                        "hasRDI": true,
                        "daily": 139.99999999999997,
                        "unit": "mg"
                    },
                    {
                        "label": "Thiamin (B1)",
                        "tag": "THIA",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": true,
                        "daily": 0,
                        "unit": "mg"
                    },
                    {
                        "label": "Riboflavin (B2)",
                        "tag": "RIBF",
                        "schemaOrgTag": null,
                        "total": 0.0468,
                        "hasRDI": true,
                        "daily": 3.5999999999999996,
                        "unit": "mg"
                    },
                    {
                        "label": "Niacin (B3)",
                        "tag": "NIA",
                        "schemaOrgTag": null,
                        "total": 0.54,
                        "hasRDI": true,
                        "daily": 3.375,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin B6",
                        "tag": "VITB6A",
                        "schemaOrgTag": null,
                        "total": 0.036,
                        "hasRDI": true,
                        "daily": 2.7692307692307687,
                        "unit": "mg"
                    },
                    {
                        "label": "Folate equivalent (total)",
                        "tag": "FOLDFE",
                        "schemaOrgTag": null,
                        "total": 5.04,
                        "hasRDI": true,
                        "daily": 1.26,
                        "unit": "µg"
                    },
                    {
                        "label": "Folate (food)",
                        "tag": "FOLFD",
                        "schemaOrgTag": null,
                        "total": 5.04,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Folic acid",
                        "tag": "FOLAC",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin B12",
                        "tag": "VITB12",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": true,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin D",
                        "tag": "VITD",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": true,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin E",
                        "tag": "TOCPHA",
                        "schemaOrgTag": null,
                        "total": 0.0072,
                        "hasRDI": true,
                        "daily": 0.048,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin K",
                        "tag": "VITK1",
                        "schemaOrgTag": null,
                        "total": 0.252,
                        "hasRDI": true,
                        "daily": 0.21,
                        "unit": "µg"
                    },
                    {
                        "label": "Sugar alcohols",
                        "tag": "Sugar.alcohol",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    },
                    {
                        "label": "Water",
                        "tag": "WATER",
                        "schemaOrgTag": null,
                        "total": 26.254800000000003,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    }
                ]
            },
            "_links": {
                "self": {
                    "href": "https://api.edamam.com/api/recipes/v2/2093a125d3a71431e70d28c6ceddc539?type=public&app_id=ea1d37d5&app_key=fd382a172ba8d6668c0430dc9c14a181",
                    "title": "Self"
                }
            }
        },
        {
            "recipe": {
                "uri": "http://www.edamam.com/ontologies/edamam.owl#recipe_8c82ea1621c65848dc331c4197b5df62",
                "label": "Fruit Juice \"Gummies\"",
                "image": "https://www.edamam.com/web-img/fc4/fc419f37ff8112378bb3cb409cb894c9.jpg",
                "source": "Epicurious",
                "url": "https://www.epicurious.com/recipes/food/views/fruit-juice-gummies-240066",
                "shareAs": "http://www.edamam.com/recipe/fruit-juice-gummies-8c82ea1621c65848dc331c4197b5df62/fruit",
                "yield": 16,
                "dietLabels": [
                    "High-Protein",
                    "Low-Fat",
                    "Low-Sodium"
                ],
                "healthLabels": [
                    "Low Potassium",
                    "Kidney-Friendly",
                    "Keto-Friendly",
                    "Dairy-Free",
                    "Gluten-Free",
                    "Wheat-Free",
                    "Egg-Free",
                    "Peanut-Free",
                    "Tree-Nut-Free",
                    "Soy-Free",
                    "Fish-Free",
                    "Shellfish-Free",
                    "Red-Meat-Free",
                    "Crustacean-Free",
                    "Celery-Free",
                    "Mustard-Free",
                    "Sesame-Free",
                    "Lupine-Free",
                    "Mollusk-Free",
                    "Alcohol-Free",
                    "No oil added"
                ],
                "cautions": [],
                "ingredientLines": [
                    "1 cup fruit juice (pure juice-not a fruit-flavored drink) or nectar, such as Goya, Mott's, or Kern's, chilled or at room temperature",
                    "1 1/4-ounce package gelatin"
                ],
                "ingredients": [
                    {
                        "text": "1 cup fruit juice (pure juice-not a fruit-flavored drink) or nectar, such as Goya, Mott's, or Kern's, chilled or at room temperature",
                        "weight": 234.4,
                        "foodCategory": "sweetened beverages",
                        "foodId": "food_a2sndz3b13ty72a1st6y8an7vq1t",
                        "image": "https://www.edamam.com/food-img/66e/66ebbfb337e3ba768925a2771b60cb49.jpg"
                    },
                    {
                        "text": "1 1/4-ounce package gelatin",
                        "weight": 35.43690390625,
                        "foodCategory": "candy",
                        "foodId": "food_bh3w81wbiqrfmhbaw9hgwa3u7lky",
                        "image": "https://www.edamam.com/food-img/47a/47a5b5c20c3cbfaf7332d572a5bfddbe.jpg"
                    }
                ],
                "calories": 217.1616280859375,
                "totalWeight": 269.83690390625003,
                "totalTime": 0,
                "cuisineType": [
                    "american"
                ],
                "mealType": [
                    "breakfast"
                ],
                "dishType": [
                    "drinks"
                ],
                "totalNutrients": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 217.1616280859375,
                        "unit": "kcal"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 0.43391690390625004,
                        "unit": "g"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 0.07402983273437501,
                        "unit": "g"
                    },
                    "FAMS": {
                        "label": "Monounsaturated",
                        "quantity": 0.07048614234375,
                        "unit": "g"
                    },
                    "FAPU": {
                        "label": "Polyunsaturated",
                        "quantity": 0.10199169039062503,
                        "unit": "g"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 26.721600000000006,
                        "unit": "g"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 0,
                        "unit": "g"
                    },
                    "SUGAR": {
                        "label": "Sugars",
                        "quantity": 26.721600000000006,
                        "unit": "g"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 30.498069743749998,
                        "unit": "g"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 0,
                        "unit": "mg"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 81.17633165625,
                        "unit": "mg"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 35.8982971484375,
                        "unit": "mg"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 14.828118859375001,
                        "unit": "mg"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 160.373904625,
                        "unit": "mg"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 0.8621496333593752,
                        "unit": "mg"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 0.44809166546875007,
                        "unit": "mg"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 20.8523925234375,
                        "unit": "mg"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 11.2512,
                        "unit": "mg"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 0.011203225976562502,
                        "unit": "mg"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 0.21276887898437502,
                        "unit": "mg"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 0.14732136832031253,
                        "unit": "mg"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 0.0282645832734375,
                        "unit": "mg"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 15.319071171875,
                        "unit": "µg"
                    },
                    "FOLFD": {
                        "label": "Folate (food)",
                        "quantity": 15.319071171875,
                        "unit": "µg"
                    },
                    "FOLAC": {
                        "label": "Folic acid",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 0,
                        "unit": "mg"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "WATER": {
                        "label": "Water",
                        "quantity": 213.57439750781253,
                        "unit": "g"
                    }
                },
                "totalDaily": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 10.858081404296875,
                        "unit": "%"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 0.667564467548077,
                        "unit": "%"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 0.37014916367187506,
                        "unit": "%"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 8.907200000000003,
                        "unit": "%"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 0,
                        "unit": "%"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 60.996139487499995,
                        "unit": "%"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 0,
                        "unit": "%"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 3.3823471523437503,
                        "unit": "%"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 3.58982971484375,
                        "unit": "%"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 3.5305044903273815,
                        "unit": "%"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 3.4122107367021277,
                        "unit": "%"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 4.7897201853298625,
                        "unit": "%"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 4.073560595170455,
                        "unit": "%"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 2.978913217633929,
                        "unit": "%"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 0,
                        "unit": "%"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 12.501333333333335,
                        "unit": "%"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 0.9336021647135417,
                        "unit": "%"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 16.366836844951923,
                        "unit": "%"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 0.9207585520019533,
                        "unit": "%"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 2.174198713341346,
                        "unit": "%"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 3.82976779296875,
                        "unit": "%"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 0,
                        "unit": "%"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 0,
                        "unit": "%"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 0,
                        "unit": "%"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 0,
                        "unit": "%"
                    }
                },
                "digest": [
                    {
                        "label": "Fat",
                        "tag": "FAT",
                        "schemaOrgTag": "fatContent",
                        "total": 0.43391690390625004,
                        "hasRDI": true,
                        "daily": 0.667564467548077,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Saturated",
                                "tag": "FASAT",
                                "schemaOrgTag": "saturatedFatContent",
                                "total": 0.07402983273437501,
                                "hasRDI": true,
                                "daily": 0.37014916367187506,
                                "unit": "g"
                            },
                            {
                                "label": "Trans",
                                "tag": "FATRN",
                                "schemaOrgTag": "transFatContent",
                                "total": 0,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Monounsaturated",
                                "tag": "FAMS",
                                "schemaOrgTag": null,
                                "total": 0.07048614234375,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Polyunsaturated",
                                "tag": "FAPU",
                                "schemaOrgTag": null,
                                "total": 0.10199169039062503,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Carbs",
                        "tag": "CHOCDF",
                        "schemaOrgTag": "carbohydrateContent",
                        "total": 26.721600000000006,
                        "hasRDI": true,
                        "daily": 8.907200000000003,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Carbs (net)",
                                "tag": "CHOCDF.net",
                                "schemaOrgTag": null,
                                "total": 26.721600000000006,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Fiber",
                                "tag": "FIBTG",
                                "schemaOrgTag": "fiberContent",
                                "total": 0,
                                "hasRDI": true,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars",
                                "tag": "SUGAR",
                                "schemaOrgTag": "sugarContent",
                                "total": 26.721600000000006,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars, added",
                                "tag": "SUGAR.added",
                                "schemaOrgTag": null,
                                "total": 0,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Protein",
                        "tag": "PROCNT",
                        "schemaOrgTag": "proteinContent",
                        "total": 30.498069743749998,
                        "hasRDI": true,
                        "daily": 60.996139487499995,
                        "unit": "g"
                    },
                    {
                        "label": "Cholesterol",
                        "tag": "CHOLE",
                        "schemaOrgTag": "cholesterolContent",
                        "total": 0,
                        "hasRDI": true,
                        "daily": 0,
                        "unit": "mg"
                    },
                    {
                        "label": "Sodium",
                        "tag": "NA",
                        "schemaOrgTag": "sodiumContent",
                        "total": 81.17633165625,
                        "hasRDI": true,
                        "daily": 3.3823471523437503,
                        "unit": "mg"
                    },
                    {
                        "label": "Calcium",
                        "tag": "CA",
                        "schemaOrgTag": null,
                        "total": 35.8982971484375,
                        "hasRDI": true,
                        "daily": 3.58982971484375,
                        "unit": "mg"
                    },
                    {
                        "label": "Magnesium",
                        "tag": "MG",
                        "schemaOrgTag": null,
                        "total": 14.828118859375001,
                        "hasRDI": true,
                        "daily": 3.5305044903273815,
                        "unit": "mg"
                    },
                    {
                        "label": "Potassium",
                        "tag": "K",
                        "schemaOrgTag": null,
                        "total": 160.373904625,
                        "hasRDI": true,
                        "daily": 3.4122107367021277,
                        "unit": "mg"
                    },
                    {
                        "label": "Iron",
                        "tag": "FE",
                        "schemaOrgTag": null,
                        "total": 0.8621496333593752,
                        "hasRDI": true,
                        "daily": 4.7897201853298625,
                        "unit": "mg"
                    },
                    {
                        "label": "Zinc",
                        "tag": "ZN",
                        "schemaOrgTag": null,
                        "total": 0.44809166546875007,
                        "hasRDI": true,
                        "daily": 4.073560595170455,
                        "unit": "mg"
                    },
                    {
                        "label": "Phosphorus",
                        "tag": "P",
                        "schemaOrgTag": null,
                        "total": 20.8523925234375,
                        "hasRDI": true,
                        "daily": 2.978913217633929,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin A",
                        "tag": "VITA_RAE",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": true,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin C",
                        "tag": "VITC",
                        "schemaOrgTag": null,
                        "total": 11.2512,
                        "hasRDI": true,
                        "daily": 12.501333333333335,
                        "unit": "mg"
                    },
                    {
                        "label": "Thiamin (B1)",
                        "tag": "THIA",
                        "schemaOrgTag": null,
                        "total": 0.011203225976562502,
                        "hasRDI": true,
                        "daily": 0.9336021647135417,
                        "unit": "mg"
                    },
                    {
                        "label": "Riboflavin (B2)",
                        "tag": "RIBF",
                        "schemaOrgTag": null,
                        "total": 0.21276887898437502,
                        "hasRDI": true,
                        "daily": 16.366836844951923,
                        "unit": "mg"
                    },
                    {
                        "label": "Niacin (B3)",
                        "tag": "NIA",
                        "schemaOrgTag": null,
                        "total": 0.14732136832031253,
                        "hasRDI": true,
                        "daily": 0.9207585520019533,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin B6",
                        "tag": "VITB6A",
                        "schemaOrgTag": null,
                        "total": 0.0282645832734375,
                        "hasRDI": true,
                        "daily": 2.174198713341346,
                        "unit": "mg"
                    },
                    {
                        "label": "Folate equivalent (total)",
                        "tag": "FOLDFE",
                        "schemaOrgTag": null,
                        "total": 15.319071171875,
                        "hasRDI": true,
                        "daily": 3.82976779296875,
                        "unit": "µg"
                    },
                    {
                        "label": "Folate (food)",
                        "tag": "FOLFD",
                        "schemaOrgTag": null,
                        "total": 15.319071171875,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Folic acid",
                        "tag": "FOLAC",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin B12",
                        "tag": "VITB12",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": true,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin D",
                        "tag": "VITD",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": true,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin E",
                        "tag": "TOCPHA",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": true,
                        "daily": 0,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin K",
                        "tag": "VITK1",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": true,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Sugar alcohols",
                        "tag": "Sugar.alcohol",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    },
                    {
                        "label": "Water",
                        "tag": "WATER",
                        "schemaOrgTag": null,
                        "total": 213.57439750781253,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    }
                ]
            },
            "_links": {
                "self": {
                    "href": "https://api.edamam.com/api/recipes/v2/8c82ea1621c65848dc331c4197b5df62?type=public&app_id=ea1d37d5&app_key=fd382a172ba8d6668c0430dc9c14a181",
                    "title": "Self"
                }
            }
        },
        {
            "recipe": {
                "uri": "http://www.edamam.com/ontologies/edamam.owl#recipe_434ae1d37430d3f1389fa33a52a87088",
                "label": "Frozen tropical fruit yogurt",
                "image": "https://www.edamam.com/web-img/a7c/a7cd5dd497222f146e923b7c8eca8c23.jpg",
                "source": "BBC Good Food",
                "url": "https://www.bbcgoodfood.com/recipes/frozen-tropical-fruit-yogurt",
                "shareAs": "http://www.edamam.com/recipe/frozen-tropical-fruit-yogurt-434ae1d37430d3f1389fa33a52a87088/fruit",
                "yield": 6,
                "dietLabels": [
                    "Low-Sodium"
                ],
                "healthLabels": [
                    "Kidney-Friendly",
                    "Vegetarian",
                    "Pescatarian",
                    "Gluten-Free",
                    "Wheat-Free",
                    "Egg-Free",
                    "Peanut-Free",
                    "Tree-Nut-Free",
                    "Soy-Free",
                    "Fish-Free",
                    "Shellfish-Free",
                    "Pork-Free",
                    "Red-Meat-Free",
                    "Crustacean-Free",
                    "Celery-Free",
                    "Mustard-Free",
                    "Sesame-Free",
                    "Lupine-Free",
                    "Mollusk-Free",
                    "Alcohol-Free",
                    "No oil added",
                    "Kosher"
                ],
                "cautions": [
                    "Sulfites"
                ],
                "ingredientLines": [
                    "480g frozen tropical fruit mix",
                    "170g Greek yogurt",
                    "2 tbsp maple syrup or honey",
                    "200g diced tropical fruit and passion fruit seeds, to serve"
                ],
                "ingredients": [
                    {
                        "text": "480g frozen tropical fruit mix",
                        "weight": 480,
                        "foodCategory": "sweetened beverages",
                        "foodId": "food_aaluhexb6hatm8a0x8eoaaf5v647",
                        "image": null
                    },
                    {
                        "text": "170g Greek yogurt",
                        "weight": 170,
                        "foodCategory": "yogurt",
                        "foodId": "food_bllzl82a5fkj4yanmzoztapdyryz",
                        "image": "https://www.edamam.com/food-img/689/6891387401f579242e7303ce8ec00e18.jpg"
                    },
                    {
                        "text": "2 tbsp maple syrup or honey",
                        "weight": 40,
                        "foodCategory": "sugars",
                        "foodId": "food_bo37p69bopqshvaul0bn4bv0kqni",
                        "image": "https://www.edamam.com/food-img/ced/ced25c45453a118e531c8aaf33e2ee38.jpg"
                    },
                    {
                        "text": "200g diced tropical fruit and passion fruit seeds, to serve",
                        "weight": 200,
                        "foodCategory": "sweetened beverages",
                        "foodId": "food_aaluhexb6hatm8a0x8eoaaf5v647",
                        "image": null
                    },
                    {
                        "text": "200g diced tropical fruit and passion fruit seeds, to serve",
                        "weight": 200,
                        "foodCategory": "fruit",
                        "foodId": "food_b6nwerkagnmbhiac3tjmtasm5dwm",
                        "image": "https://www.edamam.com/food-img/393/393e886951f47632fedd2852531af6d2.jpg"
                    }
                ],
                "calories": 649.9,
                "totalWeight": 1090,
                "totalTime": 15,
                "cuisineType": [
                    "american"
                ],
                "mealType": [
                    "lunch/dinner"
                ],
                "dishType": [
                    "desserts"
                ],
                "totalNutrients": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 649.9,
                        "unit": "kcal"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 10.91,
                        "unit": "g"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 5.791999999999999,
                        "unit": "g"
                    },
                    "FATRN": {
                        "label": "Trans",
                        "quantity": 0,
                        "unit": "g"
                    },
                    "FAMS": {
                        "label": "Monounsaturated",
                        "quantity": 0.2648,
                        "unit": "g"
                    },
                    "FAPU": {
                        "label": "Polyunsaturated",
                        "quantity": 1.0191999999999999,
                        "unit": "g"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 132.702,
                        "unit": "g"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 27.6,
                        "unit": "g"
                    },
                    "SUGAR": {
                        "label": "Sugars",
                        "quantity": 52.194,
                        "unit": "g"
                    },
                    "SUGAR.added": {
                        "label": "Sugars, added",
                        "quantity": 24.184,
                        "unit": "g"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 19.206,
                        "unit": "g"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 22.61,
                        "unit": "mg"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 160.539,
                        "unit": "mg"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 225.739,
                        "unit": "mg"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 100.4,
                        "unit": "mg"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 1311.2,
                        "unit": "mg"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 5.284000000000001,
                        "unit": "mg"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 1.3319999999999999,
                        "unit": "mg"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 198,
                        "unit": "mg"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 277.6,
                        "unit": "µg"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 72.92,
                        "unit": "mg"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 0.12840000000000001,
                        "unit": "mg"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 0.9108,
                        "unit": "mg"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 5.5756,
                        "unit": "mg"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 0.4184,
                        "unit": "mg"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 48.4,
                        "unit": "µg"
                    },
                    "FOLFD": {
                        "label": "Folate (food)",
                        "quantity": 48.4,
                        "unit": "µg"
                    },
                    "FOLAC": {
                        "label": "Folic acid",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 0.04,
                        "unit": "mg"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 1.4,
                        "unit": "µg"
                    },
                    "WATER": {
                        "label": "Water",
                        "quantity": 781.016,
                        "unit": "g"
                    }
                },
                "totalDaily": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 32.495,
                        "unit": "%"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 16.784615384615385,
                        "unit": "%"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 28.959999999999997,
                        "unit": "%"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 44.234,
                        "unit": "%"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 110.4,
                        "unit": "%"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 38.412,
                        "unit": "%"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 7.536666666666667,
                        "unit": "%"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 6.689124999999999,
                        "unit": "%"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 22.573900000000002,
                        "unit": "%"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 23.904761904761905,
                        "unit": "%"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 27.897872340425533,
                        "unit": "%"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 29.35555555555556,
                        "unit": "%"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 12.109090909090908,
                        "unit": "%"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 28.285714285714285,
                        "unit": "%"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 30.84444444444445,
                        "unit": "%"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 81.02222222222223,
                        "unit": "%"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 10.700000000000001,
                        "unit": "%"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 70.06153846153848,
                        "unit": "%"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 34.8475,
                        "unit": "%"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 32.184615384615384,
                        "unit": "%"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 12.1,
                        "unit": "%"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 0,
                        "unit": "%"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 0,
                        "unit": "%"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 0.26666666666666666,
                        "unit": "%"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 1.1666666666666667,
                        "unit": "%"
                    }
                },
                "digest": [
                    {
                        "label": "Fat",
                        "tag": "FAT",
                        "schemaOrgTag": "fatContent",
                        "total": 10.91,
                        "hasRDI": true,
                        "daily": 16.784615384615385,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Saturated",
                                "tag": "FASAT",
                                "schemaOrgTag": "saturatedFatContent",
                                "total": 5.791999999999999,
                                "hasRDI": true,
                                "daily": 28.959999999999997,
                                "unit": "g"
                            },
                            {
                                "label": "Trans",
                                "tag": "FATRN",
                                "schemaOrgTag": "transFatContent",
                                "total": 0,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Monounsaturated",
                                "tag": "FAMS",
                                "schemaOrgTag": null,
                                "total": 0.2648,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Polyunsaturated",
                                "tag": "FAPU",
                                "schemaOrgTag": null,
                                "total": 1.0191999999999999,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Carbs",
                        "tag": "CHOCDF",
                        "schemaOrgTag": "carbohydrateContent",
                        "total": 132.702,
                        "hasRDI": true,
                        "daily": 44.234,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Carbs (net)",
                                "tag": "CHOCDF.net",
                                "schemaOrgTag": null,
                                "total": 105.102,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Fiber",
                                "tag": "FIBTG",
                                "schemaOrgTag": "fiberContent",
                                "total": 27.6,
                                "hasRDI": true,
                                "daily": 110.4,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars",
                                "tag": "SUGAR",
                                "schemaOrgTag": "sugarContent",
                                "total": 52.194,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars, added",
                                "tag": "SUGAR.added",
                                "schemaOrgTag": null,
                                "total": 24.184,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Protein",
                        "tag": "PROCNT",
                        "schemaOrgTag": "proteinContent",
                        "total": 19.206,
                        "hasRDI": true,
                        "daily": 38.412,
                        "unit": "g"
                    },
                    {
                        "label": "Cholesterol",
                        "tag": "CHOLE",
                        "schemaOrgTag": "cholesterolContent",
                        "total": 22.61,
                        "hasRDI": true,
                        "daily": 7.536666666666667,
                        "unit": "mg"
                    },
                    {
                        "label": "Sodium",
                        "tag": "NA",
                        "schemaOrgTag": "sodiumContent",
                        "total": 160.539,
                        "hasRDI": true,
                        "daily": 6.689124999999999,
                        "unit": "mg"
                    },
                    {
                        "label": "Calcium",
                        "tag": "CA",
                        "schemaOrgTag": null,
                        "total": 225.739,
                        "hasRDI": true,
                        "daily": 22.573900000000002,
                        "unit": "mg"
                    },
                    {
                        "label": "Magnesium",
                        "tag": "MG",
                        "schemaOrgTag": null,
                        "total": 100.4,
                        "hasRDI": true,
                        "daily": 23.904761904761905,
                        "unit": "mg"
                    },
                    {
                        "label": "Potassium",
                        "tag": "K",
                        "schemaOrgTag": null,
                        "total": 1311.2,
                        "hasRDI": true,
                        "daily": 27.897872340425533,
                        "unit": "mg"
                    },
                    {
                        "label": "Iron",
                        "tag": "FE",
                        "schemaOrgTag": null,
                        "total": 5.284000000000001,
                        "hasRDI": true,
                        "daily": 29.35555555555556,
                        "unit": "mg"
                    },
                    {
                        "label": "Zinc",
                        "tag": "ZN",
                        "schemaOrgTag": null,
                        "total": 1.3319999999999999,
                        "hasRDI": true,
                        "daily": 12.109090909090908,
                        "unit": "mg"
                    },
                    {
                        "label": "Phosphorus",
                        "tag": "P",
                        "schemaOrgTag": null,
                        "total": 198,
                        "hasRDI": true,
                        "daily": 28.285714285714285,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin A",
                        "tag": "VITA_RAE",
                        "schemaOrgTag": null,
                        "total": 277.6,
                        "hasRDI": true,
                        "daily": 30.84444444444445,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin C",
                        "tag": "VITC",
                        "schemaOrgTag": null,
                        "total": 72.92,
                        "hasRDI": true,
                        "daily": 81.02222222222223,
                        "unit": "mg"
                    },
                    {
                        "label": "Thiamin (B1)",
                        "tag": "THIA",
                        "schemaOrgTag": null,
                        "total": 0.12840000000000001,
                        "hasRDI": true,
                        "daily": 10.700000000000001,
                        "unit": "mg"
                    },
                    {
                        "label": "Riboflavin (B2)",
                        "tag": "RIBF",
                        "schemaOrgTag": null,
                        "total": 0.9108,
                        "hasRDI": true,
                        "daily": 70.06153846153848,
                        "unit": "mg"
                    },
                    {
                        "label": "Niacin (B3)",
                        "tag": "NIA",
                        "schemaOrgTag": null,
                        "total": 5.5756,
                        "hasRDI": true,
                        "daily": 34.8475,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin B6",
                        "tag": "VITB6A",
                        "schemaOrgTag": null,
                        "total": 0.4184,
                        "hasRDI": true,
                        "daily": 32.184615384615384,
                        "unit": "mg"
                    },
                    {
                        "label": "Folate equivalent (total)",
                        "tag": "FOLDFE",
                        "schemaOrgTag": null,
                        "total": 48.4,
                        "hasRDI": true,
                        "daily": 12.1,
                        "unit": "µg"
                    },
                    {
                        "label": "Folate (food)",
                        "tag": "FOLFD",
                        "schemaOrgTag": null,
                        "total": 48.4,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Folic acid",
                        "tag": "FOLAC",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin B12",
                        "tag": "VITB12",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": true,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin D",
                        "tag": "VITD",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": true,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin E",
                        "tag": "TOCPHA",
                        "schemaOrgTag": null,
                        "total": 0.04,
                        "hasRDI": true,
                        "daily": 0.26666666666666666,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin K",
                        "tag": "VITK1",
                        "schemaOrgTag": null,
                        "total": 1.4,
                        "hasRDI": true,
                        "daily": 1.1666666666666667,
                        "unit": "µg"
                    },
                    {
                        "label": "Sugar alcohols",
                        "tag": "Sugar.alcohol",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    },
                    {
                        "label": "Water",
                        "tag": "WATER",
                        "schemaOrgTag": null,
                        "total": 781.016,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    }
                ]
            },
            "_links": {
                "self": {
                    "href": "https://api.edamam.com/api/recipes/v2/434ae1d37430d3f1389fa33a52a87088?type=public&app_id=ea1d37d5&app_key=fd382a172ba8d6668c0430dc9c14a181",
                    "title": "Self"
                }
            }
        },
        {
            "recipe": {
                "uri": "http://www.edamam.com/ontologies/edamam.owl#recipe_a6bc6e81535668b2cb5f3d91a8a69125",
                "label": "Fruit Lollipops",
                "image": "https://www.edamam.com/web-img/1a1/1a19fb5f77a25bf94d295a4b16cbbded.JPG",
                "source": "Food52",
                "url": "https://food52.com/recipes/2163-fruit-lollipops",
                "shareAs": "http://www.edamam.com/recipe/fruit-lollipops-a6bc6e81535668b2cb5f3d91a8a69125/fruit",
                "yield": 4,
                "dietLabels": [
                    "Low-Fat",
                    "Low-Sodium"
                ],
                "healthLabels": [
                    "Low Potassium",
                    "Kidney-Friendly",
                    "Vegan",
                    "Vegetarian",
                    "Pescatarian",
                    "Dairy-Free",
                    "Gluten-Free",
                    "Wheat-Free",
                    "Egg-Free",
                    "Peanut-Free",
                    "Tree-Nut-Free",
                    "Soy-Free",
                    "Fish-Free",
                    "Shellfish-Free",
                    "Pork-Free",
                    "Red-Meat-Free",
                    "Crustacean-Free",
                    "Celery-Free",
                    "Mustard-Free",
                    "Sesame-Free",
                    "Lupine-Free",
                    "Mollusk-Free",
                    "Alcohol-Free",
                    "Kosher"
                ],
                "cautions": [],
                "ingredientLines": [
                    "1 cup sugar",
                    "1 tablespoon light corn syrup",
                    "1/3 cup water",
                    "1/4-1/2 teaspoon natural fruit extract or oil",
                    "1 drop gel based food coloring"
                ],
                "ingredients": [
                    {
                        "text": "1 cup sugar",
                        "weight": 200,
                        "foodCategory": "sugars",
                        "foodId": "food_axi2ijobrk819yb0adceobnhm1c2",
                        "image": "https://www.edamam.com/food-img/ecb/ecb3f5aaed96d0188c21b8369be07765.jpg"
                    },
                    {
                        "text": "1 tablespoon light corn syrup",
                        "weight": 22,
                        "foodCategory": "sugars",
                        "foodId": "food_b8n4w6faic9hd1a7t9vx1bxq42wr",
                        "image": "https://www.edamam.com/food-img/148/1488bb6a128ff5142e0a52d5eeb36d36.jpg"
                    },
                    {
                        "text": "1/3 cup water",
                        "weight": 79,
                        "foodCategory": "water",
                        "foodId": "food_a99vzubbk1ayrsad318rvbzr3dh0",
                        "image": "https://www.edamam.com/food-img/5dd/5dd9d1361847b2ca53c4b19a8f92627e.jpg"
                    },
                    {
                        "text": "1/4-1/2 teaspoon natural fruit extract or oil",
                        "weight": 1.6875,
                        "foodCategory": "Oils",
                        "foodId": "food_bk9p9aaavhvoq4bqsnprobpsiuxs",
                        "image": "https://www.edamam.com/food-img/07e/07e106ab3536d57428e5c46d009038f8.jpg"
                    },
                    {
                        "text": "1 drop gel based food coloring",
                        "weight": 0.06161152,
                        "foodCategory": "water",
                        "foodId": "food_avcjo2fattdi8eafpf0ujatvwb7i",
                        "image": "https://www.edamam.com/food-img/5dd/5dd9d1361847b2ca53c4b19a8f92627e.jpg"
                    }
                ],
                "calories": 851.1775,
                "totalWeight": 302.74911152,
                "totalTime": 93,
                "cuisineType": [
                    "american"
                ],
                "mealType": [
                    "teatime"
                ],
                "dishType": [
                    "biscuits and cookies"
                ],
                "totalNutrients": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 851.1775,
                        "unit": "kcal"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 1.7315,
                        "unit": "g"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 0.12428437500000002,
                        "unit": "g"
                    },
                    "FATRN": {
                        "label": "Trans",
                        "quantity": 0.0066656250000000005,
                        "unit": "g"
                    },
                    "FAMS": {
                        "label": "Monounsaturated",
                        "quantity": 1.0677825,
                        "unit": "g"
                    },
                    "FAPU": {
                        "label": "Polyunsaturated",
                        "quantity": 0.47489625,
                        "unit": "g"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 216.8538,
                        "unit": "g"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 0,
                        "unit": "g"
                    },
                    "SUGAR": {
                        "label": "Sugars",
                        "quantity": 216.4894,
                        "unit": "g"
                    },
                    "SUGAR.added": {
                        "label": "Sugars, added",
                        "quantity": 216.4894,
                        "unit": "g"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 0,
                        "unit": "g"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 0,
                        "unit": "mg"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 18.8024644608,
                        "unit": "mg"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 7.2318483456,
                        "unit": "mg"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 1.0106161152,
                        "unit": "mg"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 4.22,
                        "unit": "mg"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 0.1,
                        "unit": "mg"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 0.124706161152,
                        "unit": "mg"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 0,
                        "unit": "mg"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 0,
                        "unit": "mg"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 0.01298,
                        "unit": "mg"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 0.038,
                        "unit": "mg"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 0,
                        "unit": "mg"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 0,
                        "unit": "mg"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "FOLFD": {
                        "label": "Folate (food)",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "FOLAC": {
                        "label": "Folic acid",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 0.29463750000000005,
                        "unit": "mg"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 1.2031875,
                        "unit": "µg"
                    },
                    "WATER": {
                        "label": "Water",
                        "quantity": 84.04074990848001,
                        "unit": "g"
                    }
                },
                "totalDaily": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 42.558875,
                        "unit": "%"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 2.663846153846154,
                        "unit": "%"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 0.621421875,
                        "unit": "%"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 72.2846,
                        "unit": "%"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 0,
                        "unit": "%"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 0,
                        "unit": "%"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 0,
                        "unit": "%"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 0.7834360192,
                        "unit": "%"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 0.7231848345599999,
                        "unit": "%"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 0.24062288457142858,
                        "unit": "%"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 0.08978723404255319,
                        "unit": "%"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 0.5555555555555556,
                        "unit": "%"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 1.133692374109091,
                        "unit": "%"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 0,
                        "unit": "%"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 0,
                        "unit": "%"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 0,
                        "unit": "%"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 1.0816666666666668,
                        "unit": "%"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 2.923076923076923,
                        "unit": "%"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 0,
                        "unit": "%"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 0,
                        "unit": "%"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 0,
                        "unit": "%"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 0,
                        "unit": "%"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 0,
                        "unit": "%"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 1.9642500000000003,
                        "unit": "%"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 1.00265625,
                        "unit": "%"
                    }
                },
                "digest": [
                    {
                        "label": "Fat",
                        "tag": "FAT",
                        "schemaOrgTag": "fatContent",
                        "total": 1.7315,
                        "hasRDI": true,
                        "daily": 2.663846153846154,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Saturated",
                                "tag": "FASAT",
                                "schemaOrgTag": "saturatedFatContent",
                                "total": 0.12428437500000002,
                                "hasRDI": true,
                                "daily": 0.621421875,
                                "unit": "g"
                            },
                            {
                                "label": "Trans",
                                "tag": "FATRN",
                                "schemaOrgTag": "transFatContent",
                                "total": 0.0066656250000000005,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Monounsaturated",
                                "tag": "FAMS",
                                "schemaOrgTag": null,
                                "total": 1.0677825,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Polyunsaturated",
                                "tag": "FAPU",
                                "schemaOrgTag": null,
                                "total": 0.47489625,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Carbs",
                        "tag": "CHOCDF",
                        "schemaOrgTag": "carbohydrateContent",
                        "total": 216.8538,
                        "hasRDI": true,
                        "daily": 72.2846,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Carbs (net)",
                                "tag": "CHOCDF.net",
                                "schemaOrgTag": null,
                                "total": 216.8538,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Fiber",
                                "tag": "FIBTG",
                                "schemaOrgTag": "fiberContent",
                                "total": 0,
                                "hasRDI": true,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars",
                                "tag": "SUGAR",
                                "schemaOrgTag": "sugarContent",
                                "total": 216.4894,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars, added",
                                "tag": "SUGAR.added",
                                "schemaOrgTag": null,
                                "total": 216.4894,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Protein",
                        "tag": "PROCNT",
                        "schemaOrgTag": "proteinContent",
                        "total": 0,
                        "hasRDI": true,
                        "daily": 0,
                        "unit": "g"
                    },
                    {
                        "label": "Cholesterol",
                        "tag": "CHOLE",
                        "schemaOrgTag": "cholesterolContent",
                        "total": 0,
                        "hasRDI": true,
                        "daily": 0,
                        "unit": "mg"
                    },
                    {
                        "label": "Sodium",
                        "tag": "NA",
                        "schemaOrgTag": "sodiumContent",
                        "total": 18.8024644608,
                        "hasRDI": true,
                        "daily": 0.7834360192,
                        "unit": "mg"
                    },
                    {
                        "label": "Calcium",
                        "tag": "CA",
                        "schemaOrgTag": null,
                        "total": 7.2318483456,
                        "hasRDI": true,
                        "daily": 0.7231848345599999,
                        "unit": "mg"
                    },
                    {
                        "label": "Magnesium",
                        "tag": "MG",
                        "schemaOrgTag": null,
                        "total": 1.0106161152,
                        "hasRDI": true,
                        "daily": 0.24062288457142858,
                        "unit": "mg"
                    },
                    {
                        "label": "Potassium",
                        "tag": "K",
                        "schemaOrgTag": null,
                        "total": 4.22,
                        "hasRDI": true,
                        "daily": 0.08978723404255319,
                        "unit": "mg"
                    },
                    {
                        "label": "Iron",
                        "tag": "FE",
                        "schemaOrgTag": null,
                        "total": 0.1,
                        "hasRDI": true,
                        "daily": 0.5555555555555556,
                        "unit": "mg"
                    },
                    {
                        "label": "Zinc",
                        "tag": "ZN",
                        "schemaOrgTag": null,
                        "total": 0.124706161152,
                        "hasRDI": true,
                        "daily": 1.133692374109091,
                        "unit": "mg"
                    },
                    {
                        "label": "Phosphorus",
                        "tag": "P",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": true,
                        "daily": 0,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin A",
                        "tag": "VITA_RAE",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": true,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin C",
                        "tag": "VITC",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": true,
                        "daily": 0,
                        "unit": "mg"
                    },
                    {
                        "label": "Thiamin (B1)",
                        "tag": "THIA",
                        "schemaOrgTag": null,
                        "total": 0.01298,
                        "hasRDI": true,
                        "daily": 1.0816666666666668,
                        "unit": "mg"
                    },
                    {
                        "label": "Riboflavin (B2)",
                        "tag": "RIBF",
                        "schemaOrgTag": null,
                        "total": 0.038,
                        "hasRDI": true,
                        "daily": 2.923076923076923,
                        "unit": "mg"
                    },
                    {
                        "label": "Niacin (B3)",
                        "tag": "NIA",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": true,
                        "daily": 0,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin B6",
                        "tag": "VITB6A",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": true,
                        "daily": 0,
                        "unit": "mg"
                    },
                    {
                        "label": "Folate equivalent (total)",
                        "tag": "FOLDFE",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": true,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Folate (food)",
                        "tag": "FOLFD",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Folic acid",
                        "tag": "FOLAC",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin B12",
                        "tag": "VITB12",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": true,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin D",
                        "tag": "VITD",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": true,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin E",
                        "tag": "TOCPHA",
                        "schemaOrgTag": null,
                        "total": 0.29463750000000005,
                        "hasRDI": true,
                        "daily": 1.9642500000000003,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin K",
                        "tag": "VITK1",
                        "schemaOrgTag": null,
                        "total": 1.2031875,
                        "hasRDI": true,
                        "daily": 1.00265625,
                        "unit": "µg"
                    },
                    {
                        "label": "Sugar alcohols",
                        "tag": "Sugar.alcohol",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    },
                    {
                        "label": "Water",
                        "tag": "WATER",
                        "schemaOrgTag": null,
                        "total": 84.04074990848001,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    }
                ]
            },
            "_links": {
                "self": {
                    "href": "https://api.edamam.com/api/recipes/v2/a6bc6e81535668b2cb5f3d91a8a69125?type=public&app_id=ea1d37d5&app_key=fd382a172ba8d6668c0430dc9c14a181",
                    "title": "Self"
                }
            }
        },
        {
            "recipe": {
                "uri": "http://www.edamam.com/ontologies/edamam.owl#recipe_b67134634ccc18bc13864e8dd08eca08",
                "label": "Passion Fruit Meyer Lemonade recipes",
                "image": "https://www.edamam.com/web-img/9e0/9e0fb17c4874563461c51fac8e95cade",
                "source": "Love & Olive Oil",
                "url": "http://www.loveandoliveoil.com/2014/11/passion-fruit-meyer-lemonade.html",
                "shareAs": "http://www.edamam.com/recipe/passion-fruit-meyer-lemonade-recipes-b67134634ccc18bc13864e8dd08eca08/fruit",
                "yield": 2,
                "dietLabels": [
                    "Low-Fat",
                    "Low-Sodium"
                ],
                "healthLabels": [
                    "Vegan",
                    "Vegetarian",
                    "Pescatarian",
                    "Dairy-Free",
                    "Gluten-Free",
                    "Wheat-Free",
                    "Egg-Free",
                    "Peanut-Free",
                    "Tree-Nut-Free",
                    "Soy-Free",
                    "Fish-Free",
                    "Shellfish-Free",
                    "Pork-Free",
                    "Red-Meat-Free",
                    "Crustacean-Free",
                    "Celery-Free",
                    "Mustard-Free",
                    "Sesame-Free",
                    "Lupine-Free",
                    "Mollusk-Free",
                    "Alcohol-Free",
                    "No oil added",
                    "Kosher"
                ],
                "cautions": [
                    "Sulfites"
                ],
                "ingredientLines": [
                    "1/2 cup fresh passion fruit juice (from 5-6 passion fruit)",
                    "1/2 cup Meyer lemon juice (form 2-3 large lemons)",
                    "1 cup water",
                    "4-6 tablespoons simple sugar syrup*"
                ],
                "ingredients": [
                    {
                        "text": "1/2 cup fresh passion fruit juice (from 5-6 passion fruit)",
                        "weight": 123.5,
                        "foodCategory": "fruit",
                        "foodId": "food_b743xxxbhanf9fasbvqpmaum0ve1",
                        "image": "https://www.edamam.com/food-img/beb/beb68df6d7d0d390949e1210eea86ec5.jpg"
                    },
                    {
                        "text": "1/2 cup Meyer lemon juice (form 2-3 large lemons)",
                        "weight": 122,
                        "foodCategory": "100% juice",
                        "foodId": "food_bglm6vxahuauteb0n6ynfbg9eryu",
                        "image": "https://www.edamam.com/food-img/e31/e310952d214e78a4cb8b73f30ceeaaf2.jpg"
                    },
                    {
                        "text": "1 cup water",
                        "weight": 237,
                        "foodCategory": "water",
                        "foodId": "food_a99vzubbk1ayrsad318rvbzr3dh0",
                        "image": "https://www.edamam.com/food-img/5dd/5dd9d1361847b2ca53c4b19a8f92627e.jpg"
                    },
                    {
                        "text": "4-6 tablespoons simple sugar syrup*",
                        "weight": 100,
                        "foodCategory": "sugars",
                        "foodId": "food_bo79gpza83y5i8a3ze96lb0pan32",
                        "image": "https://www.edamam.com/food-img/8c0/8c0be6812a605404c0bcebf2fd2a27cd.jpg"
                    }
                ],
                "calories": 419.94,
                "totalWeight": 582.5,
                "totalTime": 10,
                "cuisineType": [
                    "italian"
                ],
                "mealType": [
                    "lunch/dinner"
                ],
                "dishType": [
                    "drinks"
                ],
                "totalNutrients": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 419.94,
                        "unit": "kcal"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 0.5151,
                        "unit": "g"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 0.067325,
                        "unit": "g"
                    },
                    "FATRN": {
                        "label": "Trans",
                        "quantity": 0,
                        "unit": "g"
                    },
                    "FAMS": {
                        "label": "Monounsaturated",
                        "quantity": 0.03449,
                        "unit": "g"
                    },
                    "FAPU": {
                        "label": "Polyunsaturated",
                        "quantity": 0.15653,
                        "unit": "g"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 110.16375000000001,
                        "unit": "g"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 0.613,
                        "unit": "g"
                    },
                    "SUGAR": {
                        "label": "Sugars",
                        "quantity": 20.673150000000003,
                        "unit": "g"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 1.25445,
                        "unit": "g"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 0,
                        "unit": "mg"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 89.11,
                        "unit": "mg"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 42.370000000000005,
                        "unit": "mg"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 39.685,
                        "unit": "mg"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 531.99,
                        "unit": "mg"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 1.2822,
                        "unit": "mg"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 0.1888,
                        "unit": "mg"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 48.635000000000005,
                        "unit": "mg"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 58.045,
                        "unit": "µg"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 69.691,
                        "unit": "mg"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 0.03528,
                        "unit": "mg"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 0.190035,
                        "unit": "mg"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 2.8974200000000003,
                        "unit": "mg"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 0.13922,
                        "unit": "mg"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 37.28,
                        "unit": "µg"
                    },
                    "FOLFD": {
                        "label": "Folate (food)",
                        "quantity": 37.28,
                        "unit": "µg"
                    },
                    "FOLAC": {
                        "label": "Folic acid",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 0.19535,
                        "unit": "mg"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 0.49400000000000005,
                        "unit": "µg"
                    },
                    "WATER": {
                        "label": "Water",
                        "quantity": 468.98055000000005,
                        "unit": "g"
                    }
                },
                "totalDaily": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 20.997,
                        "unit": "%"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 0.7924615384615384,
                        "unit": "%"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 0.336625,
                        "unit": "%"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 36.72125,
                        "unit": "%"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 2.452,
                        "unit": "%"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 2.5089,
                        "unit": "%"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 0,
                        "unit": "%"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 3.7129166666666666,
                        "unit": "%"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 4.237,
                        "unit": "%"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 9.448809523809524,
                        "unit": "%"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 11.318936170212766,
                        "unit": "%"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 7.123333333333333,
                        "unit": "%"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 1.7163636363636363,
                        "unit": "%"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 6.947857142857144,
                        "unit": "%"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 6.4494444444444445,
                        "unit": "%"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 77.43444444444445,
                        "unit": "%"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 2.94,
                        "unit": "%"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 14.618076923076924,
                        "unit": "%"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 18.108875,
                        "unit": "%"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 10.70923076923077,
                        "unit": "%"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 9.32,
                        "unit": "%"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 0,
                        "unit": "%"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 0,
                        "unit": "%"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 1.3023333333333333,
                        "unit": "%"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 0.41166666666666674,
                        "unit": "%"
                    }
                },
                "digest": [
                    {
                        "label": "Fat",
                        "tag": "FAT",
                        "schemaOrgTag": "fatContent",
                        "total": 0.5151,
                        "hasRDI": true,
                        "daily": 0.7924615384615384,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Saturated",
                                "tag": "FASAT",
                                "schemaOrgTag": "saturatedFatContent",
                                "total": 0.067325,
                                "hasRDI": true,
                                "daily": 0.336625,
                                "unit": "g"
                            },
                            {
                                "label": "Trans",
                                "tag": "FATRN",
                                "schemaOrgTag": "transFatContent",
                                "total": 0,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Monounsaturated",
                                "tag": "FAMS",
                                "schemaOrgTag": null,
                                "total": 0.03449,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Polyunsaturated",
                                "tag": "FAPU",
                                "schemaOrgTag": null,
                                "total": 0.15653,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Carbs",
                        "tag": "CHOCDF",
                        "schemaOrgTag": "carbohydrateContent",
                        "total": 110.16375000000001,
                        "hasRDI": true,
                        "daily": 36.72125,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Carbs (net)",
                                "tag": "CHOCDF.net",
                                "schemaOrgTag": null,
                                "total": 109.55075000000001,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Fiber",
                                "tag": "FIBTG",
                                "schemaOrgTag": "fiberContent",
                                "total": 0.613,
                                "hasRDI": true,
                                "daily": 2.452,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars",
                                "tag": "SUGAR",
                                "schemaOrgTag": "sugarContent",
                                "total": 20.673150000000003,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars, added",
                                "tag": "SUGAR.added",
                                "schemaOrgTag": null,
                                "total": 0,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Protein",
                        "tag": "PROCNT",
                        "schemaOrgTag": "proteinContent",
                        "total": 1.25445,
                        "hasRDI": true,
                        "daily": 2.5089,
                        "unit": "g"
                    },
                    {
                        "label": "Cholesterol",
                        "tag": "CHOLE",
                        "schemaOrgTag": "cholesterolContent",
                        "total": 0,
                        "hasRDI": true,
                        "daily": 0,
                        "unit": "mg"
                    },
                    {
                        "label": "Sodium",
                        "tag": "NA",
                        "schemaOrgTag": "sodiumContent",
                        "total": 89.11,
                        "hasRDI": true,
                        "daily": 3.7129166666666666,
                        "unit": "mg"
                    },
                    {
                        "label": "Calcium",
                        "tag": "CA",
                        "schemaOrgTag": null,
                        "total": 42.370000000000005,
                        "hasRDI": true,
                        "daily": 4.237,
                        "unit": "mg"
                    },
                    {
                        "label": "Magnesium",
                        "tag": "MG",
                        "schemaOrgTag": null,
                        "total": 39.685,
                        "hasRDI": true,
                        "daily": 9.448809523809524,
                        "unit": "mg"
                    },
                    {
                        "label": "Potassium",
                        "tag": "K",
                        "schemaOrgTag": null,
                        "total": 531.99,
                        "hasRDI": true,
                        "daily": 11.318936170212766,
                        "unit": "mg"
                    },
                    {
                        "label": "Iron",
                        "tag": "FE",
                        "schemaOrgTag": null,
                        "total": 1.2822,
                        "hasRDI": true,
                        "daily": 7.123333333333333,
                        "unit": "mg"
                    },
                    {
                        "label": "Zinc",
                        "tag": "ZN",
                        "schemaOrgTag": null,
                        "total": 0.1888,
                        "hasRDI": true,
                        "daily": 1.7163636363636363,
                        "unit": "mg"
                    },
                    {
                        "label": "Phosphorus",
                        "tag": "P",
                        "schemaOrgTag": null,
                        "total": 48.635000000000005,
                        "hasRDI": true,
                        "daily": 6.947857142857144,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin A",
                        "tag": "VITA_RAE",
                        "schemaOrgTag": null,
                        "total": 58.045,
                        "hasRDI": true,
                        "daily": 6.4494444444444445,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin C",
                        "tag": "VITC",
                        "schemaOrgTag": null,
                        "total": 69.691,
                        "hasRDI": true,
                        "daily": 77.43444444444445,
                        "unit": "mg"
                    },
                    {
                        "label": "Thiamin (B1)",
                        "tag": "THIA",
                        "schemaOrgTag": null,
                        "total": 0.03528,
                        "hasRDI": true,
                        "daily": 2.94,
                        "unit": "mg"
                    },
                    {
                        "label": "Riboflavin (B2)",
                        "tag": "RIBF",
                        "schemaOrgTag": null,
                        "total": 0.190035,
                        "hasRDI": true,
                        "daily": 14.618076923076924,
                        "unit": "mg"
                    },
                    {
                        "label": "Niacin (B3)",
                        "tag": "NIA",
                        "schemaOrgTag": null,
                        "total": 2.8974200000000003,
                        "hasRDI": true,
                        "daily": 18.108875,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin B6",
                        "tag": "VITB6A",
                        "schemaOrgTag": null,
                        "total": 0.13922,
                        "hasRDI": true,
                        "daily": 10.70923076923077,
                        "unit": "mg"
                    },
                    {
                        "label": "Folate equivalent (total)",
                        "tag": "FOLDFE",
                        "schemaOrgTag": null,
                        "total": 37.28,
                        "hasRDI": true,
                        "daily": 9.32,
                        "unit": "µg"
                    },
                    {
                        "label": "Folate (food)",
                        "tag": "FOLFD",
                        "schemaOrgTag": null,
                        "total": 37.28,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Folic acid",
                        "tag": "FOLAC",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin B12",
                        "tag": "VITB12",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": true,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin D",
                        "tag": "VITD",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": true,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin E",
                        "tag": "TOCPHA",
                        "schemaOrgTag": null,
                        "total": 0.19535,
                        "hasRDI": true,
                        "daily": 1.3023333333333333,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin K",
                        "tag": "VITK1",
                        "schemaOrgTag": null,
                        "total": 0.49400000000000005,
                        "hasRDI": true,
                        "daily": 0.41166666666666674,
                        "unit": "µg"
                    },
                    {
                        "label": "Sugar alcohols",
                        "tag": "Sugar.alcohol",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    },
                    {
                        "label": "Water",
                        "tag": "WATER",
                        "schemaOrgTag": null,
                        "total": 468.98055000000005,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    }
                ]
            },
            "_links": {
                "self": {
                    "href": "https://api.edamam.com/api/recipes/v2/b67134634ccc18bc13864e8dd08eca08?type=public&app_id=ea1d37d5&app_key=fd382a172ba8d6668c0430dc9c14a181",
                    "title": "Self"
                }
            }
        },
        {
            "recipe": {
                "uri": "http://www.edamam.com/ontologies/edamam.owl#recipe_528d7d531dadda1ca854c659c78e8e02",
                "label": "Dry passion fruit daiquiri",
                "image": "https://www.edamam.com/web-img/ff4/ff418ed290f659e7709f19f8a95c715f.jpg",
                "source": "Jamie Oliver",
                "url": "http://www.jamieoliver.com/recipes/rum-recipes/dry-passion-fruit-daiquiri/",
                "shareAs": "http://www.edamam.com/recipe/dry-passion-fruit-daiquiri-528d7d531dadda1ca854c659c78e8e02/fruit",
                "yield": 1,
                "dietLabels": [
                    "Low-Fat",
                    "Low-Sodium"
                ],
                "healthLabels": [
                    "Low Potassium",
                    "Kidney-Friendly",
                    "Vegan",
                    "Vegetarian",
                    "Pescatarian",
                    "Dairy-Free",
                    "Gluten-Free",
                    "Wheat-Free",
                    "Egg-Free",
                    "Peanut-Free",
                    "Tree-Nut-Free",
                    "Soy-Free",
                    "Fish-Free",
                    "Shellfish-Free",
                    "Pork-Free",
                    "Red-Meat-Free",
                    "Crustacean-Free",
                    "Celery-Free",
                    "Mustard-Free",
                    "Sesame-Free",
                    "Lupine-Free",
                    "Mollusk-Free",
                    "No oil added",
                    "Kosher",
                    "Alcohol-Cocktail"
                ],
                "cautions": [
                    "Wheat",
                    "Sulfites"
                ],
                "ingredientLines": [
                    "caster sugar",
                    "50 ml Bacardi Superior rum",
                    "1 lime",
                    "10 ml Campari",
                    "1 passion fruit , plus extra to serve"
                ],
                "ingredients": [
                    {
                        "text": "caster sugar",
                        "weight": 1.6968214784000892,
                        "foodCategory": "sugars",
                        "foodId": "food_b83hz1dbrydiwzag8btahb15lu4l",
                        "image": "https://www.edamam.com/food-img/ecb/ecb3f5aaed96d0188c21b8369be07765.jpg"
                    },
                    {
                        "text": "50 ml Bacardi Superior rum",
                        "weight": 47.00149155556177,
                        "foodCategory": "liquors and cocktails",
                        "foodId": "food_bi9pqpkbrb86k8aowifmbbxwzgng",
                        "image": "https://www.edamam.com/food-img/eb5/eb51e606b36b62c66ea1a245ab0d4a8b.jpg"
                    },
                    {
                        "text": "1 lime",
                        "weight": 67,
                        "foodCategory": "fruit",
                        "foodId": "food_av58muyb8kg92fbk0g8g8aui5knv",
                        "image": "https://www.edamam.com/food-img/48a/48a123c9576647c4ada6a41df5eeb22a.jpg"
                    },
                    {
                        "text": "10 ml Campari",
                        "weight": 9.400298311112355,
                        "foodCategory": "liquors and cocktails",
                        "foodId": "food_ajguqpia53yz3oah6w2frad3tz65",
                        "image": "https://www.edamam.com/food-img/c7f/c7fcc63de96b349534aade3de3f9fa7d.jpg"
                    },
                    {
                        "text": "1 passion fruit , plus extra to serve",
                        "weight": 18,
                        "foodCategory": "fruit",
                        "foodId": "food_b6nwerkagnmbhiac3tjmtasm5dwm",
                        "image": "https://www.edamam.com/food-img/393/393e886951f47632fedd2852531af6d2.jpg"
                    }
                ],
                "calories": 174.4148337134256,
                "totalWeight": 143.0986113450742,
                "totalTime": 0,
                "cuisineType": [
                    "world"
                ],
                "mealType": [
                    "lunch/dinner"
                ],
                "dishType": [
                    "alcohol-cocktail"
                ],
                "totalNutrients": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 174.4148337134256,
                        "unit": "kcal"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 0.26,
                        "unit": "g"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 0.02536,
                        "unit": "g"
                    },
                    "FAMS": {
                        "label": "Monounsaturated",
                        "quantity": 0.02821,
                        "unit": "g"
                    },
                    "FAPU": {
                        "label": "Polyunsaturated",
                        "quantity": 0.11082999999999998,
                        "unit": "g"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 12.966682114104408,
                        "unit": "g"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 3.7479999999999998,
                        "unit": "g"
                    },
                    "SUGAR": {
                        "label": "Sugars",
                        "quantity": 4.841727835443289,
                        "unit": "g"
                    },
                    "SUGAR.added": {
                        "label": "Sugars, added",
                        "quantity": 1.6934278354432892,
                        "unit": "g"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 0.865,
                        "unit": "g"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 0,
                        "unit": "mg"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 6.960986113450742,
                        "unit": "mg"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 24.286968214784004,
                        "unit": "mg"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 9.24,
                        "unit": "mg"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 132.1419722269015,
                        "unit": "mg"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 0.7510103199303191,
                        "unit": "mg"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 0.1285308455611782,
                        "unit": "mg"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 27.026086510222584,
                        "unit": "mg"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 12.86,
                        "unit": "µg"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 24.897000000000002,
                        "unit": "mg"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 0.024424137223111684,
                        "unit": "mg"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 0.03749840801334051,
                        "unit": "mg"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 0.4052220387804446,
                        "unit": "mg"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 0.04690400298311112,
                        "unit": "mg"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 7.880000000000001,
                        "unit": "µg"
                    },
                    "FOLFD": {
                        "label": "Folate (food)",
                        "quantity": 7.880000000000001,
                        "unit": "µg"
                    },
                    "FOLAC": {
                        "label": "Folic acid",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 0.151,
                        "unit": "mg"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 0.528,
                        "unit": "µg"
                    },
                    "WATER": {
                        "label": "Water",
                        "quantity": 109.82553141550065,
                        "unit": "g"
                    }
                },
                "totalDaily": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 8.720741685671278,
                        "unit": "%"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 0.4,
                        "unit": "%"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 0.1268,
                        "unit": "%"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 4.322227371368136,
                        "unit": "%"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 14.991999999999997,
                        "unit": "%"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 1.73,
                        "unit": "%"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 0,
                        "unit": "%"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 0.2900410880604476,
                        "unit": "%"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 2.4286968214784004,
                        "unit": "%"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 2.2,
                        "unit": "%"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 2.8115313239766273,
                        "unit": "%"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 4.17227955516844,
                        "unit": "%"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 1.1684622323743472,
                        "unit": "%"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 3.8608695014603693,
                        "unit": "%"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 1.4288888888888889,
                        "unit": "%"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 27.663333333333338,
                        "unit": "%"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 2.0353447685926405,
                        "unit": "%"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 2.8844929241031165,
                        "unit": "%"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 2.5326377423777786,
                        "unit": "%"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 3.608000229470086,
                        "unit": "%"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 1.9700000000000002,
                        "unit": "%"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 0,
                        "unit": "%"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 0,
                        "unit": "%"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 1.0066666666666666,
                        "unit": "%"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 0.44000000000000006,
                        "unit": "%"
                    }
                },
                "digest": [
                    {
                        "label": "Fat",
                        "tag": "FAT",
                        "schemaOrgTag": "fatContent",
                        "total": 0.26,
                        "hasRDI": true,
                        "daily": 0.4,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Saturated",
                                "tag": "FASAT",
                                "schemaOrgTag": "saturatedFatContent",
                                "total": 0.02536,
                                "hasRDI": true,
                                "daily": 0.1268,
                                "unit": "g"
                            },
                            {
                                "label": "Trans",
                                "tag": "FATRN",
                                "schemaOrgTag": "transFatContent",
                                "total": 0,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Monounsaturated",
                                "tag": "FAMS",
                                "schemaOrgTag": null,
                                "total": 0.02821,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Polyunsaturated",
                                "tag": "FAPU",
                                "schemaOrgTag": null,
                                "total": 0.11082999999999998,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Carbs",
                        "tag": "CHOCDF",
                        "schemaOrgTag": "carbohydrateContent",
                        "total": 12.966682114104408,
                        "hasRDI": true,
                        "daily": 4.322227371368136,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Carbs (net)",
                                "tag": "CHOCDF.net",
                                "schemaOrgTag": null,
                                "total": 9.218682114104409,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Fiber",
                                "tag": "FIBTG",
                                "schemaOrgTag": "fiberContent",
                                "total": 3.7479999999999998,
                                "hasRDI": true,
                                "daily": 14.991999999999997,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars",
                                "tag": "SUGAR",
                                "schemaOrgTag": "sugarContent",
                                "total": 4.841727835443289,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars, added",
                                "tag": "SUGAR.added",
                                "schemaOrgTag": null,
                                "total": 1.6934278354432892,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Protein",
                        "tag": "PROCNT",
                        "schemaOrgTag": "proteinContent",
                        "total": 0.865,
                        "hasRDI": true,
                        "daily": 1.73,
                        "unit": "g"
                    },
                    {
                        "label": "Cholesterol",
                        "tag": "CHOLE",
                        "schemaOrgTag": "cholesterolContent",
                        "total": 0,
                        "hasRDI": true,
                        "daily": 0,
                        "unit": "mg"
                    },
                    {
                        "label": "Sodium",
                        "tag": "NA",
                        "schemaOrgTag": "sodiumContent",
                        "total": 6.960986113450742,
                        "hasRDI": true,
                        "daily": 0.2900410880604476,
                        "unit": "mg"
                    },
                    {
                        "label": "Calcium",
                        "tag": "CA",
                        "schemaOrgTag": null,
                        "total": 24.286968214784004,
                        "hasRDI": true,
                        "daily": 2.4286968214784004,
                        "unit": "mg"
                    },
                    {
                        "label": "Magnesium",
                        "tag": "MG",
                        "schemaOrgTag": null,
                        "total": 9.24,
                        "hasRDI": true,
                        "daily": 2.2,
                        "unit": "mg"
                    },
                    {
                        "label": "Potassium",
                        "tag": "K",
                        "schemaOrgTag": null,
                        "total": 132.1419722269015,
                        "hasRDI": true,
                        "daily": 2.8115313239766273,
                        "unit": "mg"
                    },
                    {
                        "label": "Iron",
                        "tag": "FE",
                        "schemaOrgTag": null,
                        "total": 0.7510103199303191,
                        "hasRDI": true,
                        "daily": 4.17227955516844,
                        "unit": "mg"
                    },
                    {
                        "label": "Zinc",
                        "tag": "ZN",
                        "schemaOrgTag": null,
                        "total": 0.1285308455611782,
                        "hasRDI": true,
                        "daily": 1.1684622323743472,
                        "unit": "mg"
                    },
                    {
                        "label": "Phosphorus",
                        "tag": "P",
                        "schemaOrgTag": null,
                        "total": 27.026086510222584,
                        "hasRDI": true,
                        "daily": 3.8608695014603693,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin A",
                        "tag": "VITA_RAE",
                        "schemaOrgTag": null,
                        "total": 12.86,
                        "hasRDI": true,
                        "daily": 1.4288888888888889,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin C",
                        "tag": "VITC",
                        "schemaOrgTag": null,
                        "total": 24.897000000000002,
                        "hasRDI": true,
                        "daily": 27.663333333333338,
                        "unit": "mg"
                    },
                    {
                        "label": "Thiamin (B1)",
                        "tag": "THIA",
                        "schemaOrgTag": null,
                        "total": 0.024424137223111684,
                        "hasRDI": true,
                        "daily": 2.0353447685926405,
                        "unit": "mg"
                    },
                    {
                        "label": "Riboflavin (B2)",
                        "tag": "RIBF",
                        "schemaOrgTag": null,
                        "total": 0.03749840801334051,
                        "hasRDI": true,
                        "daily": 2.8844929241031165,
                        "unit": "mg"
                    },
                    {
                        "label": "Niacin (B3)",
                        "tag": "NIA",
                        "schemaOrgTag": null,
                        "total": 0.4052220387804446,
                        "hasRDI": true,
                        "daily": 2.5326377423777786,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin B6",
                        "tag": "VITB6A",
                        "schemaOrgTag": null,
                        "total": 0.04690400298311112,
                        "hasRDI": true,
                        "daily": 3.608000229470086,
                        "unit": "mg"
                    },
                    {
                        "label": "Folate equivalent (total)",
                        "tag": "FOLDFE",
                        "schemaOrgTag": null,
                        "total": 7.880000000000001,
                        "hasRDI": true,
                        "daily": 1.9700000000000002,
                        "unit": "µg"
                    },
                    {
                        "label": "Folate (food)",
                        "tag": "FOLFD",
                        "schemaOrgTag": null,
                        "total": 7.880000000000001,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Folic acid",
                        "tag": "FOLAC",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin B12",
                        "tag": "VITB12",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": true,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin D",
                        "tag": "VITD",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": true,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin E",
                        "tag": "TOCPHA",
                        "schemaOrgTag": null,
                        "total": 0.151,
                        "hasRDI": true,
                        "daily": 1.0066666666666666,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin K",
                        "tag": "VITK1",
                        "schemaOrgTag": null,
                        "total": 0.528,
                        "hasRDI": true,
                        "daily": 0.44000000000000006,
                        "unit": "µg"
                    },
                    {
                        "label": "Sugar alcohols",
                        "tag": "Sugar.alcohol",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    },
                    {
                        "label": "Water",
                        "tag": "WATER",
                        "schemaOrgTag": null,
                        "total": 109.82553141550065,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    }
                ]
            },
            "_links": {
                "self": {
                    "href": "https://api.edamam.com/api/recipes/v2/528d7d531dadda1ca854c659c78e8e02?type=public&app_id=ea1d37d5&app_key=fd382a172ba8d6668c0430dc9c14a181",
                    "title": "Self"
                }
            }
        },
        {
            "recipe": {
                "uri": "http://www.edamam.com/ontologies/edamam.owl#recipe_6d9bb469133e00d8533575240e0b763f",
                "label": "Passion Fruit Sparklers",
                "image": "https://www.edamam.com/web-img/7a4/7a4122b1b2f52470a355064b4a078d90.jpg",
                "source": "Real Simple",
                "url": "https://www.realsimple.com/food-recipes/browse-all-recipes/passion-fruit-sparklers-0",
                "shareAs": "http://www.edamam.com/recipe/passion-fruit-sparklers-6d9bb469133e00d8533575240e0b763f/fruit",
                "yield": 4,
                "dietLabels": [
                    "Low-Fat",
                    "Low-Sodium"
                ],
                "healthLabels": [
                    "Sugar-Conscious",
                    "Kidney-Friendly",
                    "Vegan",
                    "Vegetarian",
                    "Pescatarian",
                    "Mediterranean",
                    "Dairy-Free",
                    "Gluten-Free",
                    "Wheat-Free",
                    "Egg-Free",
                    "Peanut-Free",
                    "Tree-Nut-Free",
                    "Soy-Free",
                    "Fish-Free",
                    "Shellfish-Free",
                    "Pork-Free",
                    "Red-Meat-Free",
                    "Crustacean-Free",
                    "Celery-Free",
                    "Mustard-Free",
                    "Sesame-Free",
                    "Lupine-Free",
                    "Mollusk-Free",
                    "No oil added",
                    "Kosher",
                    "Alcohol-Cocktail"
                ],
                "cautions": [
                    "Sulfites"
                ],
                "ingredientLines": [
                    "4 tablespoons passion fruit juice, chilled",
                    "1 bottle Prosecco, chilled"
                ],
                "ingredients": [
                    {
                        "text": "4 tablespoons passion fruit juice, chilled",
                        "weight": 61.799999998955144,
                        "foodCategory": "fruit",
                        "foodId": "food_b743xxxbhanf9fasbvqpmaum0ve1",
                        "image": "https://www.edamam.com/food-img/beb/beb68df6d7d0d390949e1210eea86ec5.jpg"
                    },
                    {
                        "text": "1 bottle Prosecco, chilled",
                        "weight": 745.599200575638,
                        "foodCategory": "wines",
                        "foodId": "food_a656mk2a5dmqb2adiamu6beihduu",
                        "image": "https://www.edamam.com/food-img/a71/a718cf3c52add522128929f1f324d2ab.jpg"
                    }
                ],
                "calories": 648.4713444713962,
                "totalWeight": 807.3992005745931,
                "totalTime": 5,
                "cuisineType": [
                    "world"
                ],
                "mealType": [
                    "lunch/dinner"
                ],
                "dishType": [
                    "alcohol-cocktail"
                ],
                "totalNutrients": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 648.4713444713962,
                        "unit": "kcal"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 0.11123999999811926,
                        "unit": "g"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 0.009269999999843272,
                        "unit": "g"
                    },
                    "FAMS": {
                        "label": "Monounsaturated",
                        "quantity": 0.013595999999770132,
                        "unit": "g"
                    },
                    "FAPU": {
                        "label": "Polyunsaturated",
                        "quantity": 0.06550799999889245,
                        "unit": "g"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 28.315679214815603,
                        "unit": "g"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 0.1235999999979103,
                        "unit": "g"
                    },
                    "SUGAR": {
                        "label": "Sugars",
                        "quantity": 15.964252325377233,
                        "unit": "g"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 0.935979440395946,
                        "unit": "g"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 0,
                        "unit": "mg"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 40.98796002871921,
                        "unit": "mg"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 69.57592805176562,
                        "unit": "mg"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 85.06592005738618,
                        "unit": "mg"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 701.1794324057983,
                        "unit": "mg"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 2.235597841550461,
                        "unit": "mg"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 0.9317990406901385,
                        "unit": "mg"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 149.65785610335362,
                        "unit": "mg"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 29.04599999950892,
                        "unit": "µg"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 11.247599999809836,
                        "unit": "mg"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 0.0372799600287819,
                        "unit": "mg"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 0.1742578800852904,
                        "unit": "mg"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 2.1895671365982845,
                        "unit": "mg"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 0.40987960028719206,
                        "unit": "mg"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 12.399992005672791,
                        "unit": "µg"
                    },
                    "FOLFD": {
                        "label": "Folate (food)",
                        "quantity": 12.399992005672791,
                        "unit": "µg"
                    },
                    "FOLAC": {
                        "label": "Folic acid",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 0.006179999999895515,
                        "unit": "mg"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 3.2295968022983725,
                        "unit": "µg"
                    },
                    "WATER": {
                        "label": "Water",
                        "quantity": 699.6692456191192,
                        "unit": "g"
                    }
                },
                "totalDaily": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 32.423567223569805,
                        "unit": "%"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 0.17113846153556808,
                        "unit": "%"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 0.04634999999921636,
                        "unit": "%"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 9.438559738271868,
                        "unit": "%"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 0.49439999999164125,
                        "unit": "%"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 1.871958880791892,
                        "unit": "%"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 0,
                        "unit": "%"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 1.7078316678633003,
                        "unit": "%"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 6.957592805176561,
                        "unit": "%"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 20.253790489853852,
                        "unit": "%"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 14.918711327782942,
                        "unit": "%"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 12.419988008613673,
                        "unit": "%"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 8.470900369910352,
                        "unit": "%"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 21.37969372905052,
                        "unit": "%"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 3.227333333278769,
                        "unit": "%"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 12.49733333312204,
                        "unit": "%"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 3.106663335731825,
                        "unit": "%"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 13.404452314253106,
                        "unit": "%"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 13.684794603739277,
                        "unit": "%"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 31.529200022091697,
                        "unit": "%"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 3.099998001418198,
                        "unit": "%"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 0,
                        "unit": "%"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 0,
                        "unit": "%"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 0.04119999999930343,
                        "unit": "%"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 2.691330668581977,
                        "unit": "%"
                    }
                },
                "digest": [
                    {
                        "label": "Fat",
                        "tag": "FAT",
                        "schemaOrgTag": "fatContent",
                        "total": 0.11123999999811926,
                        "hasRDI": true,
                        "daily": 0.17113846153556808,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Saturated",
                                "tag": "FASAT",
                                "schemaOrgTag": "saturatedFatContent",
                                "total": 0.009269999999843272,
                                "hasRDI": true,
                                "daily": 0.04634999999921636,
                                "unit": "g"
                            },
                            {
                                "label": "Trans",
                                "tag": "FATRN",
                                "schemaOrgTag": "transFatContent",
                                "total": 0,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Monounsaturated",
                                "tag": "FAMS",
                                "schemaOrgTag": null,
                                "total": 0.013595999999770132,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Polyunsaturated",
                                "tag": "FAPU",
                                "schemaOrgTag": null,
                                "total": 0.06550799999889245,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Carbs",
                        "tag": "CHOCDF",
                        "schemaOrgTag": "carbohydrateContent",
                        "total": 28.315679214815603,
                        "hasRDI": true,
                        "daily": 9.438559738271868,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Carbs (net)",
                                "tag": "CHOCDF.net",
                                "schemaOrgTag": null,
                                "total": 28.192079214817692,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Fiber",
                                "tag": "FIBTG",
                                "schemaOrgTag": "fiberContent",
                                "total": 0.1235999999979103,
                                "hasRDI": true,
                                "daily": 0.49439999999164125,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars",
                                "tag": "SUGAR",
                                "schemaOrgTag": "sugarContent",
                                "total": 15.964252325377233,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars, added",
                                "tag": "SUGAR.added",
                                "schemaOrgTag": null,
                                "total": 0,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Protein",
                        "tag": "PROCNT",
                        "schemaOrgTag": "proteinContent",
                        "total": 0.935979440395946,
                        "hasRDI": true,
                        "daily": 1.871958880791892,
                        "unit": "g"
                    },
                    {
                        "label": "Cholesterol",
                        "tag": "CHOLE",
                        "schemaOrgTag": "cholesterolContent",
                        "total": 0,
                        "hasRDI": true,
                        "daily": 0,
                        "unit": "mg"
                    },
                    {
                        "label": "Sodium",
                        "tag": "NA",
                        "schemaOrgTag": "sodiumContent",
                        "total": 40.98796002871921,
                        "hasRDI": true,
                        "daily": 1.7078316678633003,
                        "unit": "mg"
                    },
                    {
                        "label": "Calcium",
                        "tag": "CA",
                        "schemaOrgTag": null,
                        "total": 69.57592805176562,
                        "hasRDI": true,
                        "daily": 6.957592805176561,
                        "unit": "mg"
                    },
                    {
                        "label": "Magnesium",
                        "tag": "MG",
                        "schemaOrgTag": null,
                        "total": 85.06592005738618,
                        "hasRDI": true,
                        "daily": 20.253790489853852,
                        "unit": "mg"
                    },
                    {
                        "label": "Potassium",
                        "tag": "K",
                        "schemaOrgTag": null,
                        "total": 701.1794324057983,
                        "hasRDI": true,
                        "daily": 14.918711327782942,
                        "unit": "mg"
                    },
                    {
                        "label": "Iron",
                        "tag": "FE",
                        "schemaOrgTag": null,
                        "total": 2.235597841550461,
                        "hasRDI": true,
                        "daily": 12.419988008613673,
                        "unit": "mg"
                    },
                    {
                        "label": "Zinc",
                        "tag": "ZN",
                        "schemaOrgTag": null,
                        "total": 0.9317990406901385,
                        "hasRDI": true,
                        "daily": 8.470900369910352,
                        "unit": "mg"
                    },
                    {
                        "label": "Phosphorus",
                        "tag": "P",
                        "schemaOrgTag": null,
                        "total": 149.65785610335362,
                        "hasRDI": true,
                        "daily": 21.37969372905052,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin A",
                        "tag": "VITA_RAE",
                        "schemaOrgTag": null,
                        "total": 29.04599999950892,
                        "hasRDI": true,
                        "daily": 3.227333333278769,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin C",
                        "tag": "VITC",
                        "schemaOrgTag": null,
                        "total": 11.247599999809836,
                        "hasRDI": true,
                        "daily": 12.49733333312204,
                        "unit": "mg"
                    },
                    {
                        "label": "Thiamin (B1)",
                        "tag": "THIA",
                        "schemaOrgTag": null,
                        "total": 0.0372799600287819,
                        "hasRDI": true,
                        "daily": 3.106663335731825,
                        "unit": "mg"
                    },
                    {
                        "label": "Riboflavin (B2)",
                        "tag": "RIBF",
                        "schemaOrgTag": null,
                        "total": 0.1742578800852904,
                        "hasRDI": true,
                        "daily": 13.404452314253106,
                        "unit": "mg"
                    },
                    {
                        "label": "Niacin (B3)",
                        "tag": "NIA",
                        "schemaOrgTag": null,
                        "total": 2.1895671365982845,
                        "hasRDI": true,
                        "daily": 13.684794603739277,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin B6",
                        "tag": "VITB6A",
                        "schemaOrgTag": null,
                        "total": 0.40987960028719206,
                        "hasRDI": true,
                        "daily": 31.529200022091697,
                        "unit": "mg"
                    },
                    {
                        "label": "Folate equivalent (total)",
                        "tag": "FOLDFE",
                        "schemaOrgTag": null,
                        "total": 12.399992005672791,
                        "hasRDI": true,
                        "daily": 3.099998001418198,
                        "unit": "µg"
                    },
                    {
                        "label": "Folate (food)",
                        "tag": "FOLFD",
                        "schemaOrgTag": null,
                        "total": 12.399992005672791,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Folic acid",
                        "tag": "FOLAC",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin B12",
                        "tag": "VITB12",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": true,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin D",
                        "tag": "VITD",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": true,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin E",
                        "tag": "TOCPHA",
                        "schemaOrgTag": null,
                        "total": 0.006179999999895515,
                        "hasRDI": true,
                        "daily": 0.04119999999930343,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin K",
                        "tag": "VITK1",
                        "schemaOrgTag": null,
                        "total": 3.2295968022983725,
                        "hasRDI": true,
                        "daily": 2.691330668581977,
                        "unit": "µg"
                    },
                    {
                        "label": "Sugar alcohols",
                        "tag": "Sugar.alcohol",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    },
                    {
                        "label": "Water",
                        "tag": "WATER",
                        "schemaOrgTag": null,
                        "total": 699.6692456191192,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    }
                ]
            },
            "_links": {
                "self": {
                    "href": "https://api.edamam.com/api/recipes/v2/6d9bb469133e00d8533575240e0b763f?type=public&app_id=ea1d37d5&app_key=fd382a172ba8d6668c0430dc9c14a181",
                    "title": "Self"
                }
            }
        },
        {
            "recipe": {
                "uri": "http://www.edamam.com/ontologies/edamam.owl#recipe_662c06e0f33665a42df6f9dfc058c7c5",
                "label": "Passion Fruit Syrup recipes",
                "image": "https://www.edamam.com/web-img/a04/a040d911fe940b3f12fbb693eaa8ce91",
                "source": "PBS Food",
                "url": "http://www.pbs.org/food/fresh-tastes/passion-fruit-syrup/",
                "shareAs": "http://www.edamam.com/recipe/passion-fruit-syrup-recipes-662c06e0f33665a42df6f9dfc058c7c5/fruit",
                "yield": 4,
                "dietLabels": [
                    "Low-Fat",
                    "Low-Sodium"
                ],
                "healthLabels": [
                    "Low Potassium",
                    "Kidney-Friendly",
                    "Vegan",
                    "Vegetarian",
                    "Pescatarian",
                    "Dairy-Free",
                    "Gluten-Free",
                    "Wheat-Free",
                    "Egg-Free",
                    "Peanut-Free",
                    "Tree-Nut-Free",
                    "Soy-Free",
                    "Fish-Free",
                    "Shellfish-Free",
                    "Pork-Free",
                    "Red-Meat-Free",
                    "Crustacean-Free",
                    "Celery-Free",
                    "Mustard-Free",
                    "Sesame-Free",
                    "Lupine-Free",
                    "Mollusk-Free",
                    "Alcohol-Free",
                    "No oil added",
                    "Kosher"
                ],
                "cautions": [
                    "Sulfites"
                ],
                "ingredientLines": [
                    "7.55 ounces sugar (~1 cup)",
                    "7.55 ounces water (~1 cup)",
                    "1 1/2 cups passion fruit pulp (about 6 passion fruits)"
                ],
                "ingredients": [
                    {
                        "text": "7.55 ounces sugar (~1 cup)",
                        "weight": 214.03890500099243,
                        "foodCategory": "sugars",
                        "foodId": "food_axi2ijobrk819yb0adceobnhm1c2",
                        "image": "https://www.edamam.com/food-img/ecb/ecb3f5aaed96d0188c21b8369be07765.jpg"
                    },
                    {
                        "text": "7.55 ounces water (~1 cup)",
                        "weight": 214.03890500099243,
                        "foodCategory": "water",
                        "foodId": "food_a99vzubbk1ayrsad318rvbzr3dh0",
                        "image": "https://www.edamam.com/food-img/5dd/5dd9d1361847b2ca53c4b19a8f92627e.jpg"
                    },
                    {
                        "text": "1 1/2 cups passion fruit pulp (about 6 passion fruits)",
                        "weight": 108,
                        "foodCategory": "fruit",
                        "foodId": "food_b6nwerkagnmbhiac3tjmtasm5dwm",
                        "image": "https://www.edamam.com/food-img/393/393e886951f47632fedd2852531af6d2.jpg"
                    }
                ],
                "calories": 933.0905623538408,
                "totalWeight": 536.0778100019849,
                "totalTime": 20,
                "cuisineType": [
                    "american"
                ],
                "mealType": [
                    "breakfast"
                ],
                "dishType": [
                    "drinks"
                ],
                "totalNutrients": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 933.0905623538408,
                        "unit": "kcal"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 0.756,
                        "unit": "g"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 0.06372,
                        "unit": "g"
                    },
                    "FAMS": {
                        "label": "Monounsaturated",
                        "quantity": 0.09288,
                        "unit": "g"
                    },
                    "FAPU": {
                        "label": "Polyunsaturated",
                        "quantity": 0.44388,
                        "unit": "g"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 239.24649721999225,
                        "unit": "g"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 11.232000000000001,
                        "unit": "g"
                    },
                    "SUGAR": {
                        "label": "Sugars",
                        "quantity": 225.70682719099045,
                        "unit": "g"
                    },
                    "SUGAR.added": {
                        "label": "Sugars, added",
                        "quantity": 213.61082719099045,
                        "unit": "g"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 2.3760000000000003,
                        "unit": "g"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 0,
                        "unit": "mg"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 40.94194525004963,
                        "unit": "mg"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 21.521556200039697,
                        "unit": "mg"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 33.46038905000992,
                        "unit": "mg"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 380.1207781000199,
                        "unit": "mg"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 1.8350194525004964,
                        "unit": "mg"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 0.1508077810001985,
                        "unit": "mg"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 73.44,
                        "unit": "mg"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 69.12,
                        "unit": "µg"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 32.400000000000006,
                        "unit": "mg"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 0,
                        "unit": "mg"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 0.1810673919501886,
                        "unit": "mg"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 1.62,
                        "unit": "mg"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 0.10800000000000001,
                        "unit": "mg"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 15.120000000000001,
                        "unit": "µg"
                    },
                    "FOLFD": {
                        "label": "Folate (food)",
                        "quantity": 15.120000000000001,
                        "unit": "µg"
                    },
                    "FOLAC": {
                        "label": "Folic acid",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 0.0216,
                        "unit": "mg"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 0.756,
                        "unit": "µg"
                    },
                    "WATER": {
                        "label": "Water",
                        "quantity": 292.6320738769917,
                        "unit": "g"
                    }
                },
                "totalDaily": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 46.65452811769204,
                        "unit": "%"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 1.163076923076923,
                        "unit": "%"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 0.3186,
                        "unit": "%"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 79.74883240666408,
                        "unit": "%"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 44.928000000000004,
                        "unit": "%"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 4.752000000000001,
                        "unit": "%"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 0,
                        "unit": "%"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 1.7059143854187346,
                        "unit": "%"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 2.1521556200039695,
                        "unit": "%"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 7.96675929762141,
                        "unit": "%"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 8.087676129787658,
                        "unit": "%"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 10.194552513891646,
                        "unit": "%"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 1.370979827274532,
                        "unit": "%"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 10.491428571428571,
                        "unit": "%"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 7.68,
                        "unit": "%"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 36.00000000000001,
                        "unit": "%"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 0,
                        "unit": "%"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 13.928260919245274,
                        "unit": "%"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 10.125,
                        "unit": "%"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 8.307692307692308,
                        "unit": "%"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 3.78,
                        "unit": "%"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 0,
                        "unit": "%"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 0,
                        "unit": "%"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 0.14400000000000002,
                        "unit": "%"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 0.63,
                        "unit": "%"
                    }
                },
                "digest": [
                    {
                        "label": "Fat",
                        "tag": "FAT",
                        "schemaOrgTag": "fatContent",
                        "total": 0.756,
                        "hasRDI": true,
                        "daily": 1.163076923076923,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Saturated",
                                "tag": "FASAT",
                                "schemaOrgTag": "saturatedFatContent",
                                "total": 0.06372,
                                "hasRDI": true,
                                "daily": 0.3186,
                                "unit": "g"
                            },
                            {
                                "label": "Trans",
                                "tag": "FATRN",
                                "schemaOrgTag": "transFatContent",
                                "total": 0,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Monounsaturated",
                                "tag": "FAMS",
                                "schemaOrgTag": null,
                                "total": 0.09288,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Polyunsaturated",
                                "tag": "FAPU",
                                "schemaOrgTag": null,
                                "total": 0.44388,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Carbs",
                        "tag": "CHOCDF",
                        "schemaOrgTag": "carbohydrateContent",
                        "total": 239.24649721999225,
                        "hasRDI": true,
                        "daily": 79.74883240666408,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Carbs (net)",
                                "tag": "CHOCDF.net",
                                "schemaOrgTag": null,
                                "total": 228.01449721999225,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Fiber",
                                "tag": "FIBTG",
                                "schemaOrgTag": "fiberContent",
                                "total": 11.232000000000001,
                                "hasRDI": true,
                                "daily": 44.928000000000004,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars",
                                "tag": "SUGAR",
                                "schemaOrgTag": "sugarContent",
                                "total": 225.70682719099045,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars, added",
                                "tag": "SUGAR.added",
                                "schemaOrgTag": null,
                                "total": 213.61082719099045,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Protein",
                        "tag": "PROCNT",
                        "schemaOrgTag": "proteinContent",
                        "total": 2.3760000000000003,
                        "hasRDI": true,
                        "daily": 4.752000000000001,
                        "unit": "g"
                    },
                    {
                        "label": "Cholesterol",
                        "tag": "CHOLE",
                        "schemaOrgTag": "cholesterolContent",
                        "total": 0,
                        "hasRDI": true,
                        "daily": 0,
                        "unit": "mg"
                    },
                    {
                        "label": "Sodium",
                        "tag": "NA",
                        "schemaOrgTag": "sodiumContent",
                        "total": 40.94194525004963,
                        "hasRDI": true,
                        "daily": 1.7059143854187346,
                        "unit": "mg"
                    },
                    {
                        "label": "Calcium",
                        "tag": "CA",
                        "schemaOrgTag": null,
                        "total": 21.521556200039697,
                        "hasRDI": true,
                        "daily": 2.1521556200039695,
                        "unit": "mg"
                    },
                    {
                        "label": "Magnesium",
                        "tag": "MG",
                        "schemaOrgTag": null,
                        "total": 33.46038905000992,
                        "hasRDI": true,
                        "daily": 7.96675929762141,
                        "unit": "mg"
                    },
                    {
                        "label": "Potassium",
                        "tag": "K",
                        "schemaOrgTag": null,
                        "total": 380.1207781000199,
                        "hasRDI": true,
                        "daily": 8.087676129787658,
                        "unit": "mg"
                    },
                    {
                        "label": "Iron",
                        "tag": "FE",
                        "schemaOrgTag": null,
                        "total": 1.8350194525004964,
                        "hasRDI": true,
                        "daily": 10.194552513891646,
                        "unit": "mg"
                    },
                    {
                        "label": "Zinc",
                        "tag": "ZN",
                        "schemaOrgTag": null,
                        "total": 0.1508077810001985,
                        "hasRDI": true,
                        "daily": 1.370979827274532,
                        "unit": "mg"
                    },
                    {
                        "label": "Phosphorus",
                        "tag": "P",
                        "schemaOrgTag": null,
                        "total": 73.44,
                        "hasRDI": true,
                        "daily": 10.491428571428571,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin A",
                        "tag": "VITA_RAE",
                        "schemaOrgTag": null,
                        "total": 69.12,
                        "hasRDI": true,
                        "daily": 7.68,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin C",
                        "tag": "VITC",
                        "schemaOrgTag": null,
                        "total": 32.400000000000006,
                        "hasRDI": true,
                        "daily": 36.00000000000001,
                        "unit": "mg"
                    },
                    {
                        "label": "Thiamin (B1)",
                        "tag": "THIA",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": true,
                        "daily": 0,
                        "unit": "mg"
                    },
                    {
                        "label": "Riboflavin (B2)",
                        "tag": "RIBF",
                        "schemaOrgTag": null,
                        "total": 0.1810673919501886,
                        "hasRDI": true,
                        "daily": 13.928260919245274,
                        "unit": "mg"
                    },
                    {
                        "label": "Niacin (B3)",
                        "tag": "NIA",
                        "schemaOrgTag": null,
                        "total": 1.62,
                        "hasRDI": true,
                        "daily": 10.125,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin B6",
                        "tag": "VITB6A",
                        "schemaOrgTag": null,
                        "total": 0.10800000000000001,
                        "hasRDI": true,
                        "daily": 8.307692307692308,
                        "unit": "mg"
                    },
                    {
                        "label": "Folate equivalent (total)",
                        "tag": "FOLDFE",
                        "schemaOrgTag": null,
                        "total": 15.120000000000001,
                        "hasRDI": true,
                        "daily": 3.78,
                        "unit": "µg"
                    },
                    {
                        "label": "Folate (food)",
                        "tag": "FOLFD",
                        "schemaOrgTag": null,
                        "total": 15.120000000000001,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Folic acid",
                        "tag": "FOLAC",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin B12",
                        "tag": "VITB12",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": true,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin D",
                        "tag": "VITD",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": true,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin E",
                        "tag": "TOCPHA",
                        "schemaOrgTag": null,
                        "total": 0.0216,
                        "hasRDI": true,
                        "daily": 0.14400000000000002,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin K",
                        "tag": "VITK1",
                        "schemaOrgTag": null,
                        "total": 0.756,
                        "hasRDI": true,
                        "daily": 0.63,
                        "unit": "µg"
                    },
                    {
                        "label": "Sugar alcohols",
                        "tag": "Sugar.alcohol",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    },
                    {
                        "label": "Water",
                        "tag": "WATER",
                        "schemaOrgTag": null,
                        "total": 292.6320738769917,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    }
                ]
            },
            "_links": {
                "self": {
                    "href": "https://api.edamam.com/api/recipes/v2/662c06e0f33665a42df6f9dfc058c7c5?type=public&app_id=ea1d37d5&app_key=fd382a172ba8d6668c0430dc9c14a181",
                    "title": "Self"
                }
            }
        },
        {
            "recipe": {
                "uri": "http://www.edamam.com/ontologies/edamam.owl#recipe_63934dc565df7daf45a7f791f938f9fc",
                "label": "Tropical Fruit Ice",
                "image": "https://www.edamam.com/web-img/98c/98cb563dd3ec0e20c71bf0aaff194119.jpg",
                "source": "EatingWell",
                "url": "http://www.eatingwell.com/recipes/tropical_fruit_ice.html",
                "shareAs": "http://www.edamam.com/recipe/tropical-fruit-ice-63934dc565df7daf45a7f791f938f9fc/fruit",
                "yield": 8,
                "dietLabels": [
                    "Low-Fat",
                    "Low-Sodium"
                ],
                "healthLabels": [
                    "Low Potassium",
                    "Kidney-Friendly",
                    "Keto-Friendly",
                    "Vegan",
                    "Vegetarian",
                    "Pescatarian",
                    "Paleo",
                    "Mediterranean",
                    "Dairy-Free",
                    "Gluten-Free",
                    "Wheat-Free",
                    "Egg-Free",
                    "Peanut-Free",
                    "Tree-Nut-Free",
                    "Soy-Free",
                    "Fish-Free",
                    "Shellfish-Free",
                    "Pork-Free",
                    "Red-Meat-Free",
                    "Crustacean-Free",
                    "Celery-Free",
                    "Mustard-Free",
                    "Sesame-Free",
                    "Lupine-Free",
                    "Mollusk-Free",
                    "Alcohol-Free",
                    "No oil added",
                    "Sulfite-Free",
                    "FODMAP-Free",
                    "Kosher",
                    "Immuno-Supportive"
                ],
                "cautions": [
                    "Sulfites"
                ],
                "ingredientLines": [
                    "1 11-1/2-ounce can frozen passion fruit concentrate, (see Ingredient note)",
                    "2 cups water",
                    "2 tablespoons lime juice"
                ],
                "ingredients": [
                    {
                        "text": "1 11-1/2-ounce can frozen passion fruit concentrate, (see Ingredient note)",
                        "weight": 326.0195159375,
                        "foodCategory": "fruit",
                        "foodId": "food_b6nwerkagnmbhiac3tjmtasm5dwm",
                        "image": "https://www.edamam.com/food-img/393/393e886951f47632fedd2852531af6d2.jpg"
                    },
                    {
                        "text": "2 cups water",
                        "weight": 474,
                        "foodCategory": "water",
                        "foodId": "food_a99vzubbk1ayrsad318rvbzr3dh0",
                        "image": "https://www.edamam.com/food-img/5dd/5dd9d1361847b2ca53c4b19a8f92627e.jpg"
                    },
                    {
                        "text": "2 tablespoons lime juice",
                        "weight": 30.799999999479265,
                        "foodCategory": "fruit",
                        "foodId": "food_b0iywbmaujvd4eblrooo9bsvn7e6",
                        "image": "https://www.edamam.com/food-img/8f0/8f0c10eb3dbf476a05e61018e76ea220.jpg"
                    }
                ],
                "calories": 323.9389304592448,
                "totalWeight": 830.8195159369793,
                "totalTime": 0,
                "cuisineType": [
                    "caribbean"
                ],
                "mealType": [
                    "lunch/dinner"
                ],
                "dishType": [
                    "desserts"
                ],
                "totalNutrients": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 323.9389304592448,
                        "unit": "kcal"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 2.303696611562135,
                        "unit": "g"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 0.1948155144030833,
                        "unit": "g"
                    },
                    "FAMS": {
                        "label": "Monounsaturated",
                        "quantity": 0.2828407837062083,
                        "unit": "g"
                    },
                    "FAPU": {
                        "label": "Polyunsaturated",
                        "quantity": 1.347024210503005,
                        "unit": "g"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 78.81672282614365,
                        "unit": "g"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 34.029229657497915,
                        "unit": "g"
                    },
                    "SUGAR": {
                        "label": "Sugars",
                        "quantity": 37.034705784991196,
                        "unit": "g"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 7.301789350622813,
                        "unit": "g"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 0,
                        "unit": "mg"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 110.86146446248958,
                        "unit": "mg"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 57.65434191242709,
                        "unit": "mg"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 101.74965962183333,
                        "unit": "mg"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 1170.5839154618907,
                        "unit": "mg"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 5.2440322549995315,
                        "unit": "mg"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 0.39805951593708344,
                        "unit": "mg"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 226.0052708374271,
                        "unit": "mg"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 209.26849019998957,
                        "unit": "µg"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 107.04585478109377,
                        "unit": "mg"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 0.007699999999869817,
                        "unit": "mg"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 0.4284453707186719,
                        "unit": "mg"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 4.93402873906176,
                        "unit": "mg"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 0.3377235159373021,
                        "unit": "mg"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 48.722732231197924,
                        "unit": "µg"
                    },
                    "FOLFD": {
                        "label": "Folate (food)",
                        "quantity": 48.722732231197924,
                        "unit": "µg"
                    },
                    "FOLAC": {
                        "label": "Folic acid",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 0.13296390318635437,
                        "unit": "mg"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 2.466936611559375,
                        "unit": "µg"
                    },
                    "WATER": {
                        "label": "Water",
                        "quantity": 739.2553529727461,
                        "unit": "g"
                    }
                },
                "totalDaily": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 16.19694652296224,
                        "unit": "%"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 3.5441486331725156,
                        "unit": "%"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 0.9740775720154164,
                        "unit": "%"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 26.272240942047883,
                        "unit": "%"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 136.11691862999166,
                        "unit": "%"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 14.603578701245626,
                        "unit": "%"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 0,
                        "unit": "%"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 4.619227685937066,
                        "unit": "%"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 5.765434191242709,
                        "unit": "%"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 24.22610943376984,
                        "unit": "%"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 24.906040754508314,
                        "unit": "%"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 29.133512527775174,
                        "unit": "%"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 3.618722872155304,
                        "unit": "%"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 32.28646726248959,
                        "unit": "%"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 23.25205446666551,
                        "unit": "%"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 118.93983864565975,
                        "unit": "%"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 0.6416666666558181,
                        "unit": "%"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 32.957336209128606,
                        "unit": "%"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 30.837679619136,
                        "unit": "%"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 25.978731995177082,
                        "unit": "%"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 12.180683057799481,
                        "unit": "%"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 0,
                        "unit": "%"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 0,
                        "unit": "%"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 0.8864260212423625,
                        "unit": "%"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 2.055780509632813,
                        "unit": "%"
                    }
                },
                "digest": [
                    {
                        "label": "Fat",
                        "tag": "FAT",
                        "schemaOrgTag": "fatContent",
                        "total": 2.303696611562135,
                        "hasRDI": true,
                        "daily": 3.5441486331725156,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Saturated",
                                "tag": "FASAT",
                                "schemaOrgTag": "saturatedFatContent",
                                "total": 0.1948155144030833,
                                "hasRDI": true,
                                "daily": 0.9740775720154164,
                                "unit": "g"
                            },
                            {
                                "label": "Trans",
                                "tag": "FATRN",
                                "schemaOrgTag": "transFatContent",
                                "total": 0,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Monounsaturated",
                                "tag": "FAMS",
                                "schemaOrgTag": null,
                                "total": 0.2828407837062083,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Polyunsaturated",
                                "tag": "FAPU",
                                "schemaOrgTag": null,
                                "total": 1.347024210503005,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Carbs",
                        "tag": "CHOCDF",
                        "schemaOrgTag": "carbohydrateContent",
                        "total": 78.81672282614365,
                        "hasRDI": true,
                        "daily": 26.272240942047883,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Carbs (net)",
                                "tag": "CHOCDF.net",
                                "schemaOrgTag": null,
                                "total": 44.78749316864573,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Fiber",
                                "tag": "FIBTG",
                                "schemaOrgTag": "fiberContent",
                                "total": 34.029229657497915,
                                "hasRDI": true,
                                "daily": 136.11691862999166,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars",
                                "tag": "SUGAR",
                                "schemaOrgTag": "sugarContent",
                                "total": 37.034705784991196,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars, added",
                                "tag": "SUGAR.added",
                                "schemaOrgTag": null,
                                "total": 0,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Protein",
                        "tag": "PROCNT",
                        "schemaOrgTag": "proteinContent",
                        "total": 7.301789350622813,
                        "hasRDI": true,
                        "daily": 14.603578701245626,
                        "unit": "g"
                    },
                    {
                        "label": "Cholesterol",
                        "tag": "CHOLE",
                        "schemaOrgTag": "cholesterolContent",
                        "total": 0,
                        "hasRDI": true,
                        "daily": 0,
                        "unit": "mg"
                    },
                    {
                        "label": "Sodium",
                        "tag": "NA",
                        "schemaOrgTag": "sodiumContent",
                        "total": 110.86146446248958,
                        "hasRDI": true,
                        "daily": 4.619227685937066,
                        "unit": "mg"
                    },
                    {
                        "label": "Calcium",
                        "tag": "CA",
                        "schemaOrgTag": null,
                        "total": 57.65434191242709,
                        "hasRDI": true,
                        "daily": 5.765434191242709,
                        "unit": "mg"
                    },
                    {
                        "label": "Magnesium",
                        "tag": "MG",
                        "schemaOrgTag": null,
                        "total": 101.74965962183333,
                        "hasRDI": true,
                        "daily": 24.22610943376984,
                        "unit": "mg"
                    },
                    {
                        "label": "Potassium",
                        "tag": "K",
                        "schemaOrgTag": null,
                        "total": 1170.5839154618907,
                        "hasRDI": true,
                        "daily": 24.906040754508314,
                        "unit": "mg"
                    },
                    {
                        "label": "Iron",
                        "tag": "FE",
                        "schemaOrgTag": null,
                        "total": 5.2440322549995315,
                        "hasRDI": true,
                        "daily": 29.133512527775174,
                        "unit": "mg"
                    },
                    {
                        "label": "Zinc",
                        "tag": "ZN",
                        "schemaOrgTag": null,
                        "total": 0.39805951593708344,
                        "hasRDI": true,
                        "daily": 3.618722872155304,
                        "unit": "mg"
                    },
                    {
                        "label": "Phosphorus",
                        "tag": "P",
                        "schemaOrgTag": null,
                        "total": 226.0052708374271,
                        "hasRDI": true,
                        "daily": 32.28646726248959,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin A",
                        "tag": "VITA_RAE",
                        "schemaOrgTag": null,
                        "total": 209.26849019998957,
                        "hasRDI": true,
                        "daily": 23.25205446666551,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin C",
                        "tag": "VITC",
                        "schemaOrgTag": null,
                        "total": 107.04585478109377,
                        "hasRDI": true,
                        "daily": 118.93983864565975,
                        "unit": "mg"
                    },
                    {
                        "label": "Thiamin (B1)",
                        "tag": "THIA",
                        "schemaOrgTag": null,
                        "total": 0.007699999999869817,
                        "hasRDI": true,
                        "daily": 0.6416666666558181,
                        "unit": "mg"
                    },
                    {
                        "label": "Riboflavin (B2)",
                        "tag": "RIBF",
                        "schemaOrgTag": null,
                        "total": 0.4284453707186719,
                        "hasRDI": true,
                        "daily": 32.957336209128606,
                        "unit": "mg"
                    },
                    {
                        "label": "Niacin (B3)",
                        "tag": "NIA",
                        "schemaOrgTag": null,
                        "total": 4.93402873906176,
                        "hasRDI": true,
                        "daily": 30.837679619136,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin B6",
                        "tag": "VITB6A",
                        "schemaOrgTag": null,
                        "total": 0.3377235159373021,
                        "hasRDI": true,
                        "daily": 25.978731995177082,
                        "unit": "mg"
                    },
                    {
                        "label": "Folate equivalent (total)",
                        "tag": "FOLDFE",
                        "schemaOrgTag": null,
                        "total": 48.722732231197924,
                        "hasRDI": true,
                        "daily": 12.180683057799481,
                        "unit": "µg"
                    },
                    {
                        "label": "Folate (food)",
                        "tag": "FOLFD",
                        "schemaOrgTag": null,
                        "total": 48.722732231197924,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Folic acid",
                        "tag": "FOLAC",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin B12",
                        "tag": "VITB12",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": true,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin D",
                        "tag": "VITD",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": true,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin E",
                        "tag": "TOCPHA",
                        "schemaOrgTag": null,
                        "total": 0.13296390318635437,
                        "hasRDI": true,
                        "daily": 0.8864260212423625,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin K",
                        "tag": "VITK1",
                        "schemaOrgTag": null,
                        "total": 2.466936611559375,
                        "hasRDI": true,
                        "daily": 2.055780509632813,
                        "unit": "µg"
                    },
                    {
                        "label": "Sugar alcohols",
                        "tag": "Sugar.alcohol",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    },
                    {
                        "label": "Water",
                        "tag": "WATER",
                        "schemaOrgTag": null,
                        "total": 739.2553529727461,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    }
                ]
            },
            "_links": {
                "self": {
                    "href": "https://api.edamam.com/api/recipes/v2/63934dc565df7daf45a7f791f938f9fc?type=public&app_id=ea1d37d5&app_key=fd382a172ba8d6668c0430dc9c14a181",
                    "title": "Self"
                }
            }
        },
        {
            "recipe": {
                "uri": "http://www.edamam.com/ontologies/edamam.owl#recipe_37cd0fca0dfa04beecc560f9f3538253",
                "label": "Passion Fruit Batida",
                "image": "https://www.edamam.com/web-img/d5b/d5b27882bda2357634258fdd4aa6e540.jpg",
                "source": "Food & Wine",
                "url": "http://www.foodandwine.com/recipes/passion-fruit-batida",
                "shareAs": "http://www.edamam.com/recipe/passion-fruit-batida-37cd0fca0dfa04beecc560f9f3538253/fruit",
                "yield": 4,
                "dietLabels": [
                    "Low-Fat",
                    "Low-Sodium"
                ],
                "healthLabels": [
                    "Vegetarian",
                    "Pescatarian",
                    "Mediterranean",
                    "Gluten-Free",
                    "Wheat-Free",
                    "Egg-Free",
                    "Peanut-Free",
                    "Tree-Nut-Free",
                    "Soy-Free",
                    "Fish-Free",
                    "Shellfish-Free",
                    "Pork-Free",
                    "Red-Meat-Free",
                    "Crustacean-Free",
                    "Celery-Free",
                    "Mustard-Free",
                    "Sesame-Free",
                    "Lupine-Free",
                    "Mollusk-Free",
                    "No oil added",
                    "Sulfite-Free",
                    "Kosher",
                    "Alcohol-Cocktail"
                ],
                "cautions": [
                    "Wheat",
                    "Sulfites"
                ],
                "ingredientLines": [
                    "1 1/2 cups passion fruit juice",
                    "1/4 cup sweetened condensed milk",
                    "3 ounces cachaça or white rum (1/4 cup plus 2 tablespoons)",
                    "2 cups crushed ice"
                ],
                "ingredients": [
                    {
                        "text": "1 1/2 cups passion fruit juice",
                        "weight": 370.5,
                        "foodCategory": "fruit",
                        "foodId": "food_b743xxxbhanf9fasbvqpmaum0ve1",
                        "image": "https://www.edamam.com/food-img/beb/beb68df6d7d0d390949e1210eea86ec5.jpg"
                    },
                    {
                        "text": "1/4 cup sweetened condensed milk",
                        "weight": 76.5,
                        "foodCategory": "Milk",
                        "foodId": "food_a89byenbz1jssabxmx7i6aa77jz1",
                        "image": "https://www.edamam.com/food-img/bc9/bc97e9aa15ccef74dbad4d6267e30e3f.jpg"
                    },
                    {
                        "text": "3 ounces cachaça or white rum (1/4 cup plus 2 tablespoons)",
                        "weight": 55.9999999996845,
                        "foodCategory": "liquors and cocktails",
                        "foodId": "food_bi9pqpkbrb86k8aowifmbbxwzgng",
                        "image": "https://www.edamam.com/food-img/eb5/eb51e606b36b62c66ea1a245ab0d4a8b.jpg"
                    },
                    {
                        "text": "3 ounces cachaça or white rum (1/4 cup plus 2 tablespoons)",
                        "weight": 27.799999999529987,
                        "foodCategory": "liquors and cocktails",
                        "foodId": "food_bi9pqpkbrb86k8aowifmbbxwzgng",
                        "image": "https://www.edamam.com/food-img/eb5/eb51e606b36b62c66ea1a245ab0d4a8b.jpg"
                    },
                    {
                        "text": "2 cups crushed ice",
                        "weight": 474,
                        "foodCategory": "water",
                        "foodId": "food_a99vzubbk1ayrsad318rvbzr3dh0",
                        "image": "https://www.edamam.com/food-img/5dd/5dd9d1361847b2ca53c4b19a8f92627e.jpg"
                    }
                ],
                "calories": 661.4429999981854,
                "totalWeight": 1004.7999999992145,
                "totalTime": 0,
                "cuisineType": [
                    "world"
                ],
                "mealType": [
                    "lunch/dinner"
                ],
                "dishType": [
                    "alcohol-cocktail"
                ],
                "totalNutrients": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 661.4429999981854,
                        "unit": "kcal"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 7.3224,
                        "unit": "g"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 4.252365,
                        "unit": "g"
                    },
                    "FAMS": {
                        "label": "Monounsaturated",
                        "quantity": 1.9381650000000001,
                        "unit": "g"
                    },
                    "FAPU": {
                        "label": "Polyunsaturated",
                        "quantity": 0.6505350000000001,
                        "unit": "g"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 95.15325,
                        "unit": "g"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 0.7410000000000001,
                        "unit": "g"
                    },
                    "SUGAR": {
                        "label": "Sugars",
                        "quantity": 94.41225,
                        "unit": "g"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 8.5335,
                        "unit": "g"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 26.01,
                        "unit": "mg"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 139.18299999999215,
                        "unit": "mg"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 246.29999999999998,
                        "unit": "mg"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 87.615,
                        "unit": "mg"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 1315.4809999999843,
                        "unit": "mg"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 1.5797099999990574,
                        "unit": "mg"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 1.0474599999994503,
                        "unit": "mg"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 290.35999999996073,
                        "unit": "mg"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 230.745,
                        "unit": "µg"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 69.42,
                        "unit": "mg"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 0.07555399999993714,
                        "unit": "mg"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 0.692445,
                        "unit": "mg"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 8.459850000000001,
                        "unit": "mg"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 0.261315,
                        "unit": "mg"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 38.055,
                        "unit": "µg"
                    },
                    "FOLFD": {
                        "label": "Folate (food)",
                        "quantity": 38.055,
                        "unit": "µg"
                    },
                    "FOLAC": {
                        "label": "Folic acid",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 0.3366,
                        "unit": "µg"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 0.15300000000000002,
                        "unit": "µg"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 0.15945,
                        "unit": "mg"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 1.9410000000000003,
                        "unit": "µg"
                    },
                    "WATER": {
                        "label": "Water",
                        "quantity": 862.112249999477,
                        "unit": "g"
                    }
                },
                "totalDaily": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 33.07214999990927,
                        "unit": "%"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 11.265230769230769,
                        "unit": "%"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 21.261825,
                        "unit": "%"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 31.717750000000002,
                        "unit": "%"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 2.9640000000000004,
                        "unit": "%"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 17.067,
                        "unit": "%"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 8.67,
                        "unit": "%"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 5.79929166666634,
                        "unit": "%"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 24.63,
                        "unit": "%"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 20.860714285714284,
                        "unit": "%"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 27.98895744680818,
                        "unit": "%"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 8.77616666666143,
                        "unit": "%"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 9.522363636358639,
                        "unit": "%"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 41.47999999999439,
                        "unit": "%"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 25.638333333333332,
                        "unit": "%"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 77.13333333333334,
                        "unit": "%"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 6.296166666661429,
                        "unit": "%"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 53.265,
                        "unit": "%"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 52.87406250000001,
                        "unit": "%"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 20.101153846153846,
                        "unit": "%"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 9.51375,
                        "unit": "%"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 14.025000000000002,
                        "unit": "%"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 1.0200000000000002,
                        "unit": "%"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 1.063,
                        "unit": "%"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 1.6175000000000002,
                        "unit": "%"
                    }
                },
                "digest": [
                    {
                        "label": "Fat",
                        "tag": "FAT",
                        "schemaOrgTag": "fatContent",
                        "total": 7.3224,
                        "hasRDI": true,
                        "daily": 11.265230769230769,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Saturated",
                                "tag": "FASAT",
                                "schemaOrgTag": "saturatedFatContent",
                                "total": 4.252365,
                                "hasRDI": true,
                                "daily": 21.261825,
                                "unit": "g"
                            },
                            {
                                "label": "Trans",
                                "tag": "FATRN",
                                "schemaOrgTag": "transFatContent",
                                "total": 0,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Monounsaturated",
                                "tag": "FAMS",
                                "schemaOrgTag": null,
                                "total": 1.9381650000000001,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Polyunsaturated",
                                "tag": "FAPU",
                                "schemaOrgTag": null,
                                "total": 0.6505350000000001,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Carbs",
                        "tag": "CHOCDF",
                        "schemaOrgTag": "carbohydrateContent",
                        "total": 95.15325,
                        "hasRDI": true,
                        "daily": 31.717750000000002,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Carbs (net)",
                                "tag": "CHOCDF.net",
                                "schemaOrgTag": null,
                                "total": 94.41225,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Fiber",
                                "tag": "FIBTG",
                                "schemaOrgTag": "fiberContent",
                                "total": 0.7410000000000001,
                                "hasRDI": true,
                                "daily": 2.9640000000000004,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars",
                                "tag": "SUGAR",
                                "schemaOrgTag": "sugarContent",
                                "total": 94.41225,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars, added",
                                "tag": "SUGAR.added",
                                "schemaOrgTag": null,
                                "total": 0,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Protein",
                        "tag": "PROCNT",
                        "schemaOrgTag": "proteinContent",
                        "total": 8.5335,
                        "hasRDI": true,
                        "daily": 17.067,
                        "unit": "g"
                    },
                    {
                        "label": "Cholesterol",
                        "tag": "CHOLE",
                        "schemaOrgTag": "cholesterolContent",
                        "total": 26.01,
                        "hasRDI": true,
                        "daily": 8.67,
                        "unit": "mg"
                    },
                    {
                        "label": "Sodium",
                        "tag": "NA",
                        "schemaOrgTag": "sodiumContent",
                        "total": 139.18299999999215,
                        "hasRDI": true,
                        "daily": 5.79929166666634,
                        "unit": "mg"
                    },
                    {
                        "label": "Calcium",
                        "tag": "CA",
                        "schemaOrgTag": null,
                        "total": 246.29999999999998,
                        "hasRDI": true,
                        "daily": 24.63,
                        "unit": "mg"
                    },
                    {
                        "label": "Magnesium",
                        "tag": "MG",
                        "schemaOrgTag": null,
                        "total": 87.615,
                        "hasRDI": true,
                        "daily": 20.860714285714284,
                        "unit": "mg"
                    },
                    {
                        "label": "Potassium",
                        "tag": "K",
                        "schemaOrgTag": null,
                        "total": 1315.4809999999843,
                        "hasRDI": true,
                        "daily": 27.98895744680818,
                        "unit": "mg"
                    },
                    {
                        "label": "Iron",
                        "tag": "FE",
                        "schemaOrgTag": null,
                        "total": 1.5797099999990574,
                        "hasRDI": true,
                        "daily": 8.77616666666143,
                        "unit": "mg"
                    },
                    {
                        "label": "Zinc",
                        "tag": "ZN",
                        "schemaOrgTag": null,
                        "total": 1.0474599999994503,
                        "hasRDI": true,
                        "daily": 9.522363636358639,
                        "unit": "mg"
                    },
                    {
                        "label": "Phosphorus",
                        "tag": "P",
                        "schemaOrgTag": null,
                        "total": 290.35999999996073,
                        "hasRDI": true,
                        "daily": 41.47999999999439,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin A",
                        "tag": "VITA_RAE",
                        "schemaOrgTag": null,
                        "total": 230.745,
                        "hasRDI": true,
                        "daily": 25.638333333333332,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin C",
                        "tag": "VITC",
                        "schemaOrgTag": null,
                        "total": 69.42,
                        "hasRDI": true,
                        "daily": 77.13333333333334,
                        "unit": "mg"
                    },
                    {
                        "label": "Thiamin (B1)",
                        "tag": "THIA",
                        "schemaOrgTag": null,
                        "total": 0.07555399999993714,
                        "hasRDI": true,
                        "daily": 6.296166666661429,
                        "unit": "mg"
                    },
                    {
                        "label": "Riboflavin (B2)",
                        "tag": "RIBF",
                        "schemaOrgTag": null,
                        "total": 0.692445,
                        "hasRDI": true,
                        "daily": 53.265,
                        "unit": "mg"
                    },
                    {
                        "label": "Niacin (B3)",
                        "tag": "NIA",
                        "schemaOrgTag": null,
                        "total": 8.459850000000001,
                        "hasRDI": true,
                        "daily": 52.87406250000001,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin B6",
                        "tag": "VITB6A",
                        "schemaOrgTag": null,
                        "total": 0.261315,
                        "hasRDI": true,
                        "daily": 20.101153846153846,
                        "unit": "mg"
                    },
                    {
                        "label": "Folate equivalent (total)",
                        "tag": "FOLDFE",
                        "schemaOrgTag": null,
                        "total": 38.055,
                        "hasRDI": true,
                        "daily": 9.51375,
                        "unit": "µg"
                    },
                    {
                        "label": "Folate (food)",
                        "tag": "FOLFD",
                        "schemaOrgTag": null,
                        "total": 38.055,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Folic acid",
                        "tag": "FOLAC",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin B12",
                        "tag": "VITB12",
                        "schemaOrgTag": null,
                        "total": 0.3366,
                        "hasRDI": true,
                        "daily": 14.025000000000002,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin D",
                        "tag": "VITD",
                        "schemaOrgTag": null,
                        "total": 0.15300000000000002,
                        "hasRDI": true,
                        "daily": 1.0200000000000002,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin E",
                        "tag": "TOCPHA",
                        "schemaOrgTag": null,
                        "total": 0.15945,
                        "hasRDI": true,
                        "daily": 1.063,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin K",
                        "tag": "VITK1",
                        "schemaOrgTag": null,
                        "total": 1.9410000000000003,
                        "hasRDI": true,
                        "daily": 1.6175000000000002,
                        "unit": "µg"
                    },
                    {
                        "label": "Sugar alcohols",
                        "tag": "Sugar.alcohol",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    },
                    {
                        "label": "Water",
                        "tag": "WATER",
                        "schemaOrgTag": null,
                        "total": 862.112249999477,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    }
                ]
            },
            "_links": {
                "self": {
                    "href": "https://api.edamam.com/api/recipes/v2/37cd0fca0dfa04beecc560f9f3538253?type=public&app_id=ea1d37d5&app_key=fd382a172ba8d6668c0430dc9c14a181",
                    "title": "Self"
                }
            }
        },
        {
            "recipe": {
                "uri": "http://www.edamam.com/ontologies/edamam.owl#recipe_652403b8d24f805e730642451f4371a1",
                "label": "Mango and passion fruit sorbet",
                "image": "https://www.edamam.com/web-img/790/7904028f44e0b681f0c1ce9efa2267a1",
                "source": "LA Times",
                "url": "https://www.latimes.com/recipe/mango-and-passion-fruit-sorbet",
                "shareAs": "http://www.edamam.com/recipe/mango-and-passion-fruit-sorbet-652403b8d24f805e730642451f4371a1/fruit",
                "yield": 4,
                "dietLabels": [
                    "Low-Fat",
                    "Low-Sodium"
                ],
                "healthLabels": [
                    "Vegan",
                    "Vegetarian",
                    "Pescatarian",
                    "Dairy-Free",
                    "Gluten-Free",
                    "Wheat-Free",
                    "Egg-Free",
                    "Peanut-Free",
                    "Tree-Nut-Free",
                    "Soy-Free",
                    "Fish-Free",
                    "Shellfish-Free",
                    "Pork-Free",
                    "Red-Meat-Free",
                    "Crustacean-Free",
                    "Celery-Free",
                    "Mustard-Free",
                    "Sesame-Free",
                    "Lupine-Free",
                    "Mollusk-Free",
                    "Alcohol-Free",
                    "No oil added",
                    "Kosher"
                ],
                "cautions": [
                    "Sulfites"
                ],
                "ingredientLines": [
                    "2 mangoes, about 1 pound (450 grams) each",
                    "⅔ cup (135 g) sugar",
                    "⅓ cup (75 milliliters) lime juice, from about 2 limes",
                    "¼ cup (60 ml) water",
                    "Pinch of salt",
                    "¼ pound (115 g) passion fruit (2 to 4), or ½ cup (120 ml) passion fruit purée"
                ],
                "ingredients": [
                    {
                        "text": "2 mangoes, about 1 pound (450 grams) each",
                        "weight": 907.18474,
                        "foodCategory": "fruit",
                        "foodId": "food_an1dqoib8xj3tyb3pr7c0abi4rbw",
                        "image": "https://www.edamam.com/food-img/6e0/6e04857756d0876f14bfc035ff238e0b.png"
                    },
                    {
                        "text": "⅔ cup (135 g) sugar",
                        "weight": 135,
                        "foodCategory": "sugars",
                        "foodId": "food_axi2ijobrk819yb0adceobnhm1c2",
                        "image": "https://www.edamam.com/food-img/ecb/ecb3f5aaed96d0188c21b8369be07765.jpg"
                    },
                    {
                        "text": "⅓ cup (75 milliliters) lime juice, from about 2 limes",
                        "weight": 78.11039244125733,
                        "foodCategory": "fruit",
                        "foodId": "food_b0iywbmaujvd4eblrooo9bsvn7e6",
                        "image": "https://www.edamam.com/food-img/8f0/8f0c10eb3dbf476a05e61018e76ea220.jpg"
                    },
                    {
                        "text": "¼ cup (60 ml) water",
                        "weight": 60,
                        "foodCategory": "water",
                        "foodId": "food_a99vzubbk1ayrsad318rvbzr3dh0",
                        "image": "https://www.edamam.com/food-img/5dd/5dd9d1361847b2ca53c4b19a8f92627e.jpg"
                    },
                    {
                        "text": "Pinch of salt",
                        "weight": 0.380208333815447,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_btxz81db72hwbra2pncvebzzzum9",
                        "image": "https://www.edamam.com/food-img/694/6943ea510918c6025795e8dc6e6eaaeb.jpg"
                    },
                    {
                        "text": "¼ pound (115 g) passion fruit (2 to 4), or ½ cup (120 ml) passion fruit purée",
                        "weight": 113.3980925,
                        "foodCategory": "condiments and sauces",
                        "foodId": "food_a951gtdax5t9szap0t9f4a5wp6ut",
                        "image": null
                    }
                ],
                "calories": 1010.0849239503144,
                "totalWeight": 1294.073433275073,
                "totalTime": 0,
                "cuisineType": [
                    "italian"
                ],
                "mealType": [
                    "lunch/dinner"
                ],
                "dishType": [
                    "desserts"
                ],
                "totalNutrients": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 1010.0849239503144,
                        "unit": "kcal"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 2.8424559807288805,
                        "unit": "g"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 0.5988219035633007,
                        "unit": "g"
                    },
                    "FATRN": {
                        "label": "Trans",
                        "quantity": 0,
                        "unit": "g"
                    },
                    "FAMS": {
                        "label": "Monounsaturated",
                        "quantity": 0.9079904629553007,
                        "unit": "g"
                    },
                    "FAPU": {
                        "label": "Polyunsaturated",
                        "quantity": 0.4752772176954892,
                        "unit": "g"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 256.2933425129739,
                        "unit": "g"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 10.84485640116503,
                        "unit": "g"
                    },
                    "SUGAR": {
                        "label": "Sugars",
                        "quantity": 224.03428482589726,
                        "unit": "g"
                    },
                    "SUGAR.added": {
                        "label": "Sugars, added",
                        "quantity": 134.73000000000002,
                        "unit": "g"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 6.857072222033281,
                        "unit": "g"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 0,
                        "unit": "mg"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 159.1143655230161,
                        "unit": "mg"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 85.02783313589174,
                        "unit": "mg"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 71.26275001863874,
                        "unit": "mg"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 1176.2095336949762,
                        "unit": "mg"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 1.7207306348887228,
                        "unit": "mg"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 0.6620595711468213,
                        "unit": "mg"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 101.10961809777604,
                        "unit": "mg"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 349.3768371648252,
                        "unit": "µg"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 265.98256574247716,
                        "unit": "mg"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 0.19987592442231433,
                        "unit": "mg"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 0.2821250017181886,
                        "unit": "mg"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 4.419953553792586,
                        "unit": "mg"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 0.7961623359536778,
                        "unit": "mg"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 284.77454036612573,
                        "unit": "µg"
                    },
                    "FOLFD": {
                        "label": "Folate (food)",
                        "quantity": 284.77454036612573,
                        "unit": "µg"
                    },
                    "FOLAC": {
                        "label": "Folic acid",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 5.968753351970767,
                        "unit": "mg"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 27.520911301447548,
                        "unit": "µg"
                    },
                    "WATER": {
                        "label": "Water",
                        "quantity": 668.4510183569253,
                        "unit": "g"
                    }
                },
                "totalDaily": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 50.50424619751572,
                        "unit": "%"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 4.373009201121355,
                        "unit": "%"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 2.9941095178165034,
                        "unit": "%"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 85.4311141709913,
                        "unit": "%"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 43.37942560466012,
                        "unit": "%"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 13.714144444066562,
                        "unit": "%"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 0,
                        "unit": "%"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 6.62976523012567,
                        "unit": "%"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 8.502783313589175,
                        "unit": "%"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 16.967321433009225,
                        "unit": "%"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 25.02573475946758,
                        "unit": "%"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 9.559614638270682,
                        "unit": "%"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 6.018723374062012,
                        "unit": "%"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 14.444231156825149,
                        "unit": "%"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 38.819648573869465,
                        "unit": "%"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 295.53618415830795,
                        "unit": "%"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 16.656327035192863,
                        "unit": "%"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 21.70192320909143,
                        "unit": "%"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 27.62470971120366,
                        "unit": "%"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 61.243256611821366,
                        "unit": "%"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 71.19363509153143,
                        "unit": "%"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 0,
                        "unit": "%"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 0,
                        "unit": "%"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 39.791689013138445,
                        "unit": "%"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 22.93409275120629,
                        "unit": "%"
                    }
                },
                "digest": [
                    {
                        "label": "Fat",
                        "tag": "FAT",
                        "schemaOrgTag": "fatContent",
                        "total": 2.8424559807288805,
                        "hasRDI": true,
                        "daily": 4.373009201121355,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Saturated",
                                "tag": "FASAT",
                                "schemaOrgTag": "saturatedFatContent",
                                "total": 0.5988219035633007,
                                "hasRDI": true,
                                "daily": 2.9941095178165034,
                                "unit": "g"
                            },
                            {
                                "label": "Trans",
                                "tag": "FATRN",
                                "schemaOrgTag": "transFatContent",
                                "total": 0,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Monounsaturated",
                                "tag": "FAMS",
                                "schemaOrgTag": null,
                                "total": 0.9079904629553007,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Polyunsaturated",
                                "tag": "FAPU",
                                "schemaOrgTag": null,
                                "total": 0.4752772176954892,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Carbs",
                        "tag": "CHOCDF",
                        "schemaOrgTag": "carbohydrateContent",
                        "total": 256.2933425129739,
                        "hasRDI": true,
                        "daily": 85.4311141709913,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Carbs (net)",
                                "tag": "CHOCDF.net",
                                "schemaOrgTag": null,
                                "total": 245.44848611180885,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Fiber",
                                "tag": "FIBTG",
                                "schemaOrgTag": "fiberContent",
                                "total": 10.84485640116503,
                                "hasRDI": true,
                                "daily": 43.37942560466012,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars",
                                "tag": "SUGAR",
                                "schemaOrgTag": "sugarContent",
                                "total": 224.03428482589726,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars, added",
                                "tag": "SUGAR.added",
                                "schemaOrgTag": null,
                                "total": 134.73000000000002,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Protein",
                        "tag": "PROCNT",
                        "schemaOrgTag": "proteinContent",
                        "total": 6.857072222033281,
                        "hasRDI": true,
                        "daily": 13.714144444066562,
                        "unit": "g"
                    },
                    {
                        "label": "Cholesterol",
                        "tag": "CHOLE",
                        "schemaOrgTag": "cholesterolContent",
                        "total": 0,
                        "hasRDI": true,
                        "daily": 0,
                        "unit": "mg"
                    },
                    {
                        "label": "Sodium",
                        "tag": "NA",
                        "schemaOrgTag": "sodiumContent",
                        "total": 159.1143655230161,
                        "hasRDI": true,
                        "daily": 6.62976523012567,
                        "unit": "mg"
                    },
                    {
                        "label": "Calcium",
                        "tag": "CA",
                        "schemaOrgTag": null,
                        "total": 85.02783313589174,
                        "hasRDI": true,
                        "daily": 8.502783313589175,
                        "unit": "mg"
                    },
                    {
                        "label": "Magnesium",
                        "tag": "MG",
                        "schemaOrgTag": null,
                        "total": 71.26275001863874,
                        "hasRDI": true,
                        "daily": 16.967321433009225,
                        "unit": "mg"
                    },
                    {
                        "label": "Potassium",
                        "tag": "K",
                        "schemaOrgTag": null,
                        "total": 1176.2095336949762,
                        "hasRDI": true,
                        "daily": 25.02573475946758,
                        "unit": "mg"
                    },
                    {
                        "label": "Iron",
                        "tag": "FE",
                        "schemaOrgTag": null,
                        "total": 1.7207306348887228,
                        "hasRDI": true,
                        "daily": 9.559614638270682,
                        "unit": "mg"
                    },
                    {
                        "label": "Zinc",
                        "tag": "ZN",
                        "schemaOrgTag": null,
                        "total": 0.6620595711468213,
                        "hasRDI": true,
                        "daily": 6.018723374062012,
                        "unit": "mg"
                    },
                    {
                        "label": "Phosphorus",
                        "tag": "P",
                        "schemaOrgTag": null,
                        "total": 101.10961809777604,
                        "hasRDI": true,
                        "daily": 14.444231156825149,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin A",
                        "tag": "VITA_RAE",
                        "schemaOrgTag": null,
                        "total": 349.3768371648252,
                        "hasRDI": true,
                        "daily": 38.819648573869465,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin C",
                        "tag": "VITC",
                        "schemaOrgTag": null,
                        "total": 265.98256574247716,
                        "hasRDI": true,
                        "daily": 295.53618415830795,
                        "unit": "mg"
                    },
                    {
                        "label": "Thiamin (B1)",
                        "tag": "THIA",
                        "schemaOrgTag": null,
                        "total": 0.19987592442231433,
                        "hasRDI": true,
                        "daily": 16.656327035192863,
                        "unit": "mg"
                    },
                    {
                        "label": "Riboflavin (B2)",
                        "tag": "RIBF",
                        "schemaOrgTag": null,
                        "total": 0.2821250017181886,
                        "hasRDI": true,
                        "daily": 21.70192320909143,
                        "unit": "mg"
                    },
                    {
                        "label": "Niacin (B3)",
                        "tag": "NIA",
                        "schemaOrgTag": null,
                        "total": 4.419953553792586,
                        "hasRDI": true,
                        "daily": 27.62470971120366,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin B6",
                        "tag": "VITB6A",
                        "schemaOrgTag": null,
                        "total": 0.7961623359536778,
                        "hasRDI": true,
                        "daily": 61.243256611821366,
                        "unit": "mg"
                    },
                    {
                        "label": "Folate equivalent (total)",
                        "tag": "FOLDFE",
                        "schemaOrgTag": null,
                        "total": 284.77454036612573,
                        "hasRDI": true,
                        "daily": 71.19363509153143,
                        "unit": "µg"
                    },
                    {
                        "label": "Folate (food)",
                        "tag": "FOLFD",
                        "schemaOrgTag": null,
                        "total": 284.77454036612573,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Folic acid",
                        "tag": "FOLAC",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin B12",
                        "tag": "VITB12",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": true,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin D",
                        "tag": "VITD",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": true,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin E",
                        "tag": "TOCPHA",
                        "schemaOrgTag": null,
                        "total": 5.968753351970767,
                        "hasRDI": true,
                        "daily": 39.791689013138445,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin K",
                        "tag": "VITK1",
                        "schemaOrgTag": null,
                        "total": 27.520911301447548,
                        "hasRDI": true,
                        "daily": 22.93409275120629,
                        "unit": "µg"
                    },
                    {
                        "label": "Sugar alcohols",
                        "tag": "Sugar.alcohol",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    },
                    {
                        "label": "Water",
                        "tag": "WATER",
                        "schemaOrgTag": null,
                        "total": 668.4510183569253,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    }
                ]
            },
            "_links": {
                "self": {
                    "href": "https://api.edamam.com/api/recipes/v2/652403b8d24f805e730642451f4371a1?type=public&app_id=ea1d37d5&app_key=fd382a172ba8d6668c0430dc9c14a181",
                    "title": "Self"
                }
            }
        },
        {
            "recipe": {
                "uri": "http://www.edamam.com/ontologies/edamam.owl#recipe_b415e0b1434727d242d3cc7c41aacbd4",
                "label": "“Homemade Fruit Leather” recipes",
                "image": "https://www.edamam.com/web-img/f04/f04eae4c305a1b3d5492e89eacde4d76",
                "source": "Georgia Pellegrini",
                "url": "http://georgiapellegrini.com/2010/07/23/recipes/homemade-fruit-leather/",
                "shareAs": "http://www.edamam.com/recipe/homemade-fruit-leather-recipes-b415e0b1434727d242d3cc7c41aacbd4/fruit",
                "yield": 15,
                "dietLabels": [
                    "Low-Fat",
                    "Low-Sodium"
                ],
                "healthLabels": [
                    "Low Potassium",
                    "Kidney-Friendly",
                    "Keto-Friendly",
                    "Vegan",
                    "Vegetarian",
                    "Pescatarian",
                    "Dairy-Free",
                    "Gluten-Free",
                    "Wheat-Free",
                    "Egg-Free",
                    "Peanut-Free",
                    "Tree-Nut-Free",
                    "Soy-Free",
                    "Fish-Free",
                    "Shellfish-Free",
                    "Pork-Free",
                    "Red-Meat-Free",
                    "Crustacean-Free",
                    "Celery-Free",
                    "Mustard-Free",
                    "Sesame-Free",
                    "Lupine-Free",
                    "Mollusk-Free",
                    "Alcohol-Free",
                    "No oil added",
                    "Kosher"
                ],
                "cautions": [
                    "Sulfites"
                ],
                "ingredientLines": [
                    "2 cups fruit pulp",
                    "1 tablespoon lemon Juice",
                    "¼ cup sugar (optional, depending on the sweetness of your fruit)"
                ],
                "ingredients": [
                    {
                        "text": "2 cups fruit pulp",
                        "weight": 490,
                        "foodCategory": "sweetened beverages",
                        "foodId": "food_aaluhexb6hatm8a0x8eoaaf5v647",
                        "image": null
                    },
                    {
                        "text": "1 tablespoon lemon Juice",
                        "weight": 15.2499999997422,
                        "foodCategory": "100% juice",
                        "foodId": "food_bglm6vxahuauteb0n6ynfbg9eryu",
                        "image": "https://www.edamam.com/food-img/e31/e310952d214e78a4cb8b73f30ceeaaf2.jpg"
                    },
                    {
                        "text": "¼ cup sugar (optional, depending on the sweetness of your fruit)",
                        "weight": 50,
                        "foodCategory": "sugars",
                        "foodId": "food_axi2ijobrk819yb0adceobnhm1c2",
                        "image": "https://www.edamam.com/food-img/ecb/ecb3f5aaed96d0188c21b8369be07765.jpg"
                    }
                ],
                "calories": 343.8549999999433,
                "totalWeight": 555.2499999997422,
                "totalTime": 740,
                "cuisineType": [
                    "mediterranean"
                ],
                "mealType": [
                    "breakfast"
                ],
                "dishType": [
                    "biscuits and cookies"
                ],
                "totalNutrients": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 343.8549999999433,
                        "unit": "kcal"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 0.3795999999993814,
                        "unit": "g"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 0.05019999999989688,
                        "unit": "g"
                    },
                    "FATRN": {
                        "label": "Trans",
                        "quantity": 0,
                        "unit": "g"
                    },
                    "FAMS": {
                        "label": "Monounsaturated",
                        "quantity": 0.06461499999998453,
                        "unit": "g"
                    },
                    "FAPU": {
                        "label": "Polyunsaturated",
                        "quantity": 0.1404024999999459,
                        "unit": "g"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 89.60524999998222,
                        "unit": "g"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 4.945749999999227,
                        "unit": "g"
                    },
                    "SUGAR": {
                        "label": "Sugars",
                        "quantity": 50.2842999999935,
                        "unit": "g"
                    },
                    "SUGAR.added": {
                        "label": "Sugars, added",
                        "quantity": 49.9,
                        "unit": "g"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 1.7683749999990979,
                        "unit": "g"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 0,
                        "unit": "mg"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 15.352499999997423,
                        "unit": "mg"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 35.714999999984535,
                        "unit": "mg"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 25.41499999998453,
                        "unit": "mg"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 398.9074999997345,
                        "unit": "mg"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 1.5071999999997936,
                        "unit": "mg"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 0.4046249999998711,
                        "unit": "mg"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 45.31999999997938,
                        "unit": "mg"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 107.80000000000001,
                        "unit": "µg"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 15.211749999900231,
                        "unit": "mg"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 0.07715999999993813,
                        "unit": "mg"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 0.11468749999996135,
                        "unit": "mg"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 1.8464774999997657,
                        "unit": "mg"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 0.16381499999988144,
                        "unit": "mg"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 17.749999999948443,
                        "unit": "µg"
                    },
                    "FOLFD": {
                        "label": "Folate (food)",
                        "quantity": 17.749999999948443,
                        "unit": "µg"
                    },
                    "FOLAC": {
                        "label": "Folic acid",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 0.0228749999996133,
                        "unit": "mg"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "WATER": {
                        "label": "Water",
                        "quantity": 462.43727499976205,
                        "unit": "g"
                    }
                },
                "totalDaily": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 17.192749999997165,
                        "unit": "%"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 0.5839999999990483,
                        "unit": "%"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 0.2509999999994844,
                        "unit": "%"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 29.868416666660742,
                        "unit": "%"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 19.782999999996907,
                        "unit": "%"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 3.5367499999981957,
                        "unit": "%"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 0,
                        "unit": "%"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 0.6396874999998926,
                        "unit": "%"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 3.5714999999984536,
                        "unit": "%"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 6.051190476186793,
                        "unit": "%"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 8.487393617015627,
                        "unit": "%"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 8.373333333332187,
                        "unit": "%"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 3.6784090909079192,
                        "unit": "%"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 6.474285714282769,
                        "unit": "%"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 11.97777777777778,
                        "unit": "%"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 16.90194444433359,
                        "unit": "%"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 6.429999999994844,
                        "unit": "%"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 8.822115384612411,
                        "unit": "%"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 11.540484374998536,
                        "unit": "%"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 12.601153846144726,
                        "unit": "%"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 4.437499999987111,
                        "unit": "%"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 0,
                        "unit": "%"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 0,
                        "unit": "%"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 0.15249999999742198,
                        "unit": "%"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 0,
                        "unit": "%"
                    }
                },
                "digest": [
                    {
                        "label": "Fat",
                        "tag": "FAT",
                        "schemaOrgTag": "fatContent",
                        "total": 0.3795999999993814,
                        "hasRDI": true,
                        "daily": 0.5839999999990483,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Saturated",
                                "tag": "FASAT",
                                "schemaOrgTag": "saturatedFatContent",
                                "total": 0.05019999999989688,
                                "hasRDI": true,
                                "daily": 0.2509999999994844,
                                "unit": "g"
                            },
                            {
                                "label": "Trans",
                                "tag": "FATRN",
                                "schemaOrgTag": "transFatContent",
                                "total": 0,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Monounsaturated",
                                "tag": "FAMS",
                                "schemaOrgTag": null,
                                "total": 0.06461499999998453,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Polyunsaturated",
                                "tag": "FAPU",
                                "schemaOrgTag": null,
                                "total": 0.1404024999999459,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Carbs",
                        "tag": "CHOCDF",
                        "schemaOrgTag": "carbohydrateContent",
                        "total": 89.60524999998222,
                        "hasRDI": true,
                        "daily": 29.868416666660742,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Carbs (net)",
                                "tag": "CHOCDF.net",
                                "schemaOrgTag": null,
                                "total": 84.659499999983,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Fiber",
                                "tag": "FIBTG",
                                "schemaOrgTag": "fiberContent",
                                "total": 4.945749999999227,
                                "hasRDI": true,
                                "daily": 19.782999999996907,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars",
                                "tag": "SUGAR",
                                "schemaOrgTag": "sugarContent",
                                "total": 50.2842999999935,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars, added",
                                "tag": "SUGAR.added",
                                "schemaOrgTag": null,
                                "total": 49.9,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Protein",
                        "tag": "PROCNT",
                        "schemaOrgTag": "proteinContent",
                        "total": 1.7683749999990979,
                        "hasRDI": true,
                        "daily": 3.5367499999981957,
                        "unit": "g"
                    },
                    {
                        "label": "Cholesterol",
                        "tag": "CHOLE",
                        "schemaOrgTag": "cholesterolContent",
                        "total": 0,
                        "hasRDI": true,
                        "daily": 0,
                        "unit": "mg"
                    },
                    {
                        "label": "Sodium",
                        "tag": "NA",
                        "schemaOrgTag": "sodiumContent",
                        "total": 15.352499999997423,
                        "hasRDI": true,
                        "daily": 0.6396874999998926,
                        "unit": "mg"
                    },
                    {
                        "label": "Calcium",
                        "tag": "CA",
                        "schemaOrgTag": null,
                        "total": 35.714999999984535,
                        "hasRDI": true,
                        "daily": 3.5714999999984536,
                        "unit": "mg"
                    },
                    {
                        "label": "Magnesium",
                        "tag": "MG",
                        "schemaOrgTag": null,
                        "total": 25.41499999998453,
                        "hasRDI": true,
                        "daily": 6.051190476186793,
                        "unit": "mg"
                    },
                    {
                        "label": "Potassium",
                        "tag": "K",
                        "schemaOrgTag": null,
                        "total": 398.9074999997345,
                        "hasRDI": true,
                        "daily": 8.487393617015627,
                        "unit": "mg"
                    },
                    {
                        "label": "Iron",
                        "tag": "FE",
                        "schemaOrgTag": null,
                        "total": 1.5071999999997936,
                        "hasRDI": true,
                        "daily": 8.373333333332187,
                        "unit": "mg"
                    },
                    {
                        "label": "Zinc",
                        "tag": "ZN",
                        "schemaOrgTag": null,
                        "total": 0.4046249999998711,
                        "hasRDI": true,
                        "daily": 3.6784090909079192,
                        "unit": "mg"
                    },
                    {
                        "label": "Phosphorus",
                        "tag": "P",
                        "schemaOrgTag": null,
                        "total": 45.31999999997938,
                        "hasRDI": true,
                        "daily": 6.474285714282769,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin A",
                        "tag": "VITA_RAE",
                        "schemaOrgTag": null,
                        "total": 107.80000000000001,
                        "hasRDI": true,
                        "daily": 11.97777777777778,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin C",
                        "tag": "VITC",
                        "schemaOrgTag": null,
                        "total": 15.211749999900231,
                        "hasRDI": true,
                        "daily": 16.90194444433359,
                        "unit": "mg"
                    },
                    {
                        "label": "Thiamin (B1)",
                        "tag": "THIA",
                        "schemaOrgTag": null,
                        "total": 0.07715999999993813,
                        "hasRDI": true,
                        "daily": 6.429999999994844,
                        "unit": "mg"
                    },
                    {
                        "label": "Riboflavin (B2)",
                        "tag": "RIBF",
                        "schemaOrgTag": null,
                        "total": 0.11468749999996135,
                        "hasRDI": true,
                        "daily": 8.822115384612411,
                        "unit": "mg"
                    },
                    {
                        "label": "Niacin (B3)",
                        "tag": "NIA",
                        "schemaOrgTag": null,
                        "total": 1.8464774999997657,
                        "hasRDI": true,
                        "daily": 11.540484374998536,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin B6",
                        "tag": "VITB6A",
                        "schemaOrgTag": null,
                        "total": 0.16381499999988144,
                        "hasRDI": true,
                        "daily": 12.601153846144726,
                        "unit": "mg"
                    },
                    {
                        "label": "Folate equivalent (total)",
                        "tag": "FOLDFE",
                        "schemaOrgTag": null,
                        "total": 17.749999999948443,
                        "hasRDI": true,
                        "daily": 4.437499999987111,
                        "unit": "µg"
                    },
                    {
                        "label": "Folate (food)",
                        "tag": "FOLFD",
                        "schemaOrgTag": null,
                        "total": 17.749999999948443,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Folic acid",
                        "tag": "FOLAC",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin B12",
                        "tag": "VITB12",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": true,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin D",
                        "tag": "VITD",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": true,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin E",
                        "tag": "TOCPHA",
                        "schemaOrgTag": null,
                        "total": 0.0228749999996133,
                        "hasRDI": true,
                        "daily": 0.15249999999742198,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin K",
                        "tag": "VITK1",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": true,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Sugar alcohols",
                        "tag": "Sugar.alcohol",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    },
                    {
                        "label": "Water",
                        "tag": "WATER",
                        "schemaOrgTag": null,
                        "total": 462.43727499976205,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    }
                ]
            },
            "_links": {
                "self": {
                    "href": "https://api.edamam.com/api/recipes/v2/b415e0b1434727d242d3cc7c41aacbd4?type=public&app_id=ea1d37d5&app_key=fd382a172ba8d6668c0430dc9c14a181",
                    "title": "Self"
                }
            }
        },
        {
            "recipe": {
                "uri": "http://www.edamam.com/ontologies/edamam.owl#recipe_80b3e766d2e4ac54870bec0cd666c13c",
                "label": "Passion Fruit Ice Cream",
                "image": "https://www.edamam.com/web-img/9c1/9c11e63b0131e563e24b08aea90575bd.jpg",
                "source": "Use Real Butter",
                "url": "http://userealbutter.com/2010/06/09/passion-fruit-ice-cream-recipe/",
                "shareAs": "http://www.edamam.com/recipe/passion-fruit-ice-cream-80b3e766d2e4ac54870bec0cd666c13c/fruit",
                "yield": 3,
                "dietLabels": [
                    "High-Fiber"
                ],
                "healthLabels": [
                    "Vegetarian",
                    "Pescatarian",
                    "Gluten-Free",
                    "Wheat-Free",
                    "Peanut-Free",
                    "Tree-Nut-Free",
                    "Soy-Free",
                    "Fish-Free",
                    "Shellfish-Free",
                    "Pork-Free",
                    "Red-Meat-Free",
                    "Crustacean-Free",
                    "Celery-Free",
                    "Mustard-Free",
                    "Sesame-Free",
                    "Lupine-Free",
                    "Mollusk-Free",
                    "Alcohol-Free",
                    "No oil added",
                    "Kosher"
                ],
                "cautions": [
                    "Sulfites"
                ],
                "ingredientLines": [
                    "1/2 cup Frozen Passion Fruit Pulp",
                    "1 cup Heavy Cream",
                    "6 tbs Whole Milk",
                    "7 tbs Sugar",
                    "7 x Salt",
                    "3 x Egg Yolks",
                    "3 x Passion Fruit Seeds"
                ],
                "ingredients": [
                    {
                        "text": "1/2 cup Frozen Passion Fruit Pulp",
                        "weight": 118,
                        "foodCategory": "fruit",
                        "foodId": "food_b6nwerkagnmbhiac3tjmtasm5dwm",
                        "image": "https://www.edamam.com/food-img/393/393e886951f47632fedd2852531af6d2.jpg"
                    },
                    {
                        "text": "1 cup Heavy Cream",
                        "weight": 238,
                        "foodCategory": "Dairy",
                        "foodId": "food_bgtkr21b5v16mca246x9ebnaswyo",
                        "image": "https://www.edamam.com/food-img/484/4848d71f6a14dd5076083f5e17925420.jpg"
                    },
                    {
                        "text": "6 tbs Whole Milk",
                        "weight": 90,
                        "foodCategory": "Milk",
                        "foodId": "food_b49rs1kaw0jktabzkg2vvanvvsis",
                        "image": "https://www.edamam.com/food-img/7c9/7c9962acf83654a8d98ea6a2ade93735.jpg"
                    },
                    {
                        "text": "7 tbs Sugar",
                        "weight": 87.4999999985209,
                        "foodCategory": "sugars",
                        "foodId": "food_axi2ijobrk819yb0adceobnhm1c2",
                        "image": "https://www.edamam.com/food-img/ecb/ecb3f5aaed96d0188c21b8369be07765.jpg"
                    },
                    {
                        "text": "7 x Salt",
                        "weight": 3.7673999999911256,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_btxz81db72hwbra2pncvebzzzum9",
                        "image": "https://www.edamam.com/food-img/694/6943ea510918c6025795e8dc6e6eaaeb.jpg"
                    },
                    {
                        "text": "3 x Egg Yolks",
                        "weight": 40.4,
                        "foodCategory": "Eggs",
                        "foodId": "food_awlnigdb6qm6i1biwv7rlalfg2ni",
                        "image": "https://www.edamam.com/food-img/e3f/e3f697887aec0e8ecf09a9ca8ef3944a.jpg"
                    },
                    {
                        "text": "3 x Passion Fruit Seeds",
                        "weight": 54,
                        "foodCategory": "fruit",
                        "foodId": "food_b6nwerkagnmbhiac3tjmtasm5dwm",
                        "image": "https://www.edamam.com/food-img/393/393e886951f47632fedd2852531af6d2.jpg"
                    }
                ],
                "calories": 1511.552999994276,
                "totalWeight": 631.1576549136264,
                "totalTime": 0,
                "cuisineType": [
                    "italian"
                ],
                "mealType": [
                    "lunch/dinner"
                ],
                "dishType": [
                    "desserts"
                ],
                "totalNutrients": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 1511.552999994276,
                        "unit": "kcal"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 102.91116,
                        "unit": "g"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 60.454744,
                        "unit": "g"
                    },
                    "FAMS": {
                        "label": "Monounsaturated",
                        "quantity": 31.053551999999993,
                        "unit": "g"
                    },
                    "FAPU": {
                        "label": "Polyunsaturated",
                        "quantity": 5.850955999999999,
                        "unit": "g"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 140.1066599985212,
                        "unit": "g"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 17.888,
                        "unit": "g"
                    },
                    "SUGAR": {
                        "label": "Sugars",
                        "quantity": 118.00043999852387,
                        "unit": "g"
                    },
                    "SUGAR.added": {
                        "label": "Sugars, added",
                        "quantity": 87.32499999852386,
                        "unit": "g"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 17.905439999999995,
                        "unit": "g"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 773.4,
                        "unit": "mg"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 1460.1688919965604,
                        "unit": "mg"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 330.81283717961054,
                        "unit": "mg"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 77.59257654915105,
                        "unit": "mg"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 941.9066123931789,
                        "unit": "mg"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 4.007820261219108,
                        "unit": "mg"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 1.9936076549149575,
                        "unit": "mg"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 497.68000000000006,
                        "unit": "mg"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 1283.584,
                        "unit": "µg"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 53.028,
                        "unit": "mg"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 0.16486399999999998,
                        "unit": "mg"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 0.8674369999997191,
                        "unit": "mg"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 2.762616,
                        "unit": "mg"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 0.40767999999999993,
                        "unit": "mg"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 97.084,
                        "unit": "µg"
                    },
                    "FOLFD": {
                        "label": "Folate (food)",
                        "quantity": 97.084,
                        "unit": "µg"
                    },
                    "FOLAC": {
                        "label": "Folic acid",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 1.6212,
                        "unit": "µg"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 5.0176,
                        "unit": "µg"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 3.66252,
                        "unit": "mg"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 9.3728,
                        "unit": "µg"
                    },
                    "WATER": {
                        "label": "Water",
                        "quantity": 363.2636553098299,
                        "unit": "g"
                    }
                },
                "totalDaily": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 75.5776499997138,
                        "unit": "%"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 158.32486153846153,
                        "unit": "%"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 302.27372,
                        "unit": "%"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 46.702219999507065,
                        "unit": "%"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 71.552,
                        "unit": "%"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 35.81087999999999,
                        "unit": "%"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 257.8,
                        "unit": "%"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 60.84037049985669,
                        "unit": "%"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 33.08128371796105,
                        "unit": "%"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 18.474422987893107,
                        "unit": "%"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 20.040566221131463,
                        "unit": "%"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 22.265668117883934,
                        "unit": "%"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 18.12370595377234,
                        "unit": "%"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 71.09714285714287,
                        "unit": "%"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 142.62044444444444,
                        "unit": "%"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 58.92,
                        "unit": "%"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 13.738666666666667,
                        "unit": "%"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 66.72592307690147,
                        "unit": "%"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 17.26635,
                        "unit": "%"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 31.359999999999992,
                        "unit": "%"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 24.271,
                        "unit": "%"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 67.55000000000001,
                        "unit": "%"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 33.45066666666666,
                        "unit": "%"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 24.416800000000002,
                        "unit": "%"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 7.810666666666666,
                        "unit": "%"
                    }
                },
                "digest": [
                    {
                        "label": "Fat",
                        "tag": "FAT",
                        "schemaOrgTag": "fatContent",
                        "total": 102.91116,
                        "hasRDI": true,
                        "daily": 158.32486153846153,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Saturated",
                                "tag": "FASAT",
                                "schemaOrgTag": "saturatedFatContent",
                                "total": 60.454744,
                                "hasRDI": true,
                                "daily": 302.27372,
                                "unit": "g"
                            },
                            {
                                "label": "Trans",
                                "tag": "FATRN",
                                "schemaOrgTag": "transFatContent",
                                "total": 0,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Monounsaturated",
                                "tag": "FAMS",
                                "schemaOrgTag": null,
                                "total": 31.053551999999993,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Polyunsaturated",
                                "tag": "FAPU",
                                "schemaOrgTag": null,
                                "total": 5.850955999999999,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Carbs",
                        "tag": "CHOCDF",
                        "schemaOrgTag": "carbohydrateContent",
                        "total": 140.1066599985212,
                        "hasRDI": true,
                        "daily": 46.702219999507065,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Carbs (net)",
                                "tag": "CHOCDF.net",
                                "schemaOrgTag": null,
                                "total": 122.21865999852119,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Fiber",
                                "tag": "FIBTG",
                                "schemaOrgTag": "fiberContent",
                                "total": 17.888,
                                "hasRDI": true,
                                "daily": 71.552,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars",
                                "tag": "SUGAR",
                                "schemaOrgTag": "sugarContent",
                                "total": 118.00043999852387,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars, added",
                                "tag": "SUGAR.added",
                                "schemaOrgTag": null,
                                "total": 87.32499999852386,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Protein",
                        "tag": "PROCNT",
                        "schemaOrgTag": "proteinContent",
                        "total": 17.905439999999995,
                        "hasRDI": true,
                        "daily": 35.81087999999999,
                        "unit": "g"
                    },
                    {
                        "label": "Cholesterol",
                        "tag": "CHOLE",
                        "schemaOrgTag": "cholesterolContent",
                        "total": 773.4,
                        "hasRDI": true,
                        "daily": 257.8,
                        "unit": "mg"
                    },
                    {
                        "label": "Sodium",
                        "tag": "NA",
                        "schemaOrgTag": "sodiumContent",
                        "total": 1460.1688919965604,
                        "hasRDI": true,
                        "daily": 60.84037049985669,
                        "unit": "mg"
                    },
                    {
                        "label": "Calcium",
                        "tag": "CA",
                        "schemaOrgTag": null,
                        "total": 330.81283717961054,
                        "hasRDI": true,
                        "daily": 33.08128371796105,
                        "unit": "mg"
                    },
                    {
                        "label": "Magnesium",
                        "tag": "MG",
                        "schemaOrgTag": null,
                        "total": 77.59257654915105,
                        "hasRDI": true,
                        "daily": 18.474422987893107,
                        "unit": "mg"
                    },
                    {
                        "label": "Potassium",
                        "tag": "K",
                        "schemaOrgTag": null,
                        "total": 941.9066123931789,
                        "hasRDI": true,
                        "daily": 20.040566221131463,
                        "unit": "mg"
                    },
                    {
                        "label": "Iron",
                        "tag": "FE",
                        "schemaOrgTag": null,
                        "total": 4.007820261219108,
                        "hasRDI": true,
                        "daily": 22.265668117883934,
                        "unit": "mg"
                    },
                    {
                        "label": "Zinc",
                        "tag": "ZN",
                        "schemaOrgTag": null,
                        "total": 1.9936076549149575,
                        "hasRDI": true,
                        "daily": 18.12370595377234,
                        "unit": "mg"
                    },
                    {
                        "label": "Phosphorus",
                        "tag": "P",
                        "schemaOrgTag": null,
                        "total": 497.68000000000006,
                        "hasRDI": true,
                        "daily": 71.09714285714287,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin A",
                        "tag": "VITA_RAE",
                        "schemaOrgTag": null,
                        "total": 1283.584,
                        "hasRDI": true,
                        "daily": 142.62044444444444,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin C",
                        "tag": "VITC",
                        "schemaOrgTag": null,
                        "total": 53.028,
                        "hasRDI": true,
                        "daily": 58.92,
                        "unit": "mg"
                    },
                    {
                        "label": "Thiamin (B1)",
                        "tag": "THIA",
                        "schemaOrgTag": null,
                        "total": 0.16486399999999998,
                        "hasRDI": true,
                        "daily": 13.738666666666667,
                        "unit": "mg"
                    },
                    {
                        "label": "Riboflavin (B2)",
                        "tag": "RIBF",
                        "schemaOrgTag": null,
                        "total": 0.8674369999997191,
                        "hasRDI": true,
                        "daily": 66.72592307690147,
                        "unit": "mg"
                    },
                    {
                        "label": "Niacin (B3)",
                        "tag": "NIA",
                        "schemaOrgTag": null,
                        "total": 2.762616,
                        "hasRDI": true,
                        "daily": 17.26635,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin B6",
                        "tag": "VITB6A",
                        "schemaOrgTag": null,
                        "total": 0.40767999999999993,
                        "hasRDI": true,
                        "daily": 31.359999999999992,
                        "unit": "mg"
                    },
                    {
                        "label": "Folate equivalent (total)",
                        "tag": "FOLDFE",
                        "schemaOrgTag": null,
                        "total": 97.084,
                        "hasRDI": true,
                        "daily": 24.271,
                        "unit": "µg"
                    },
                    {
                        "label": "Folate (food)",
                        "tag": "FOLFD",
                        "schemaOrgTag": null,
                        "total": 97.084,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Folic acid",
                        "tag": "FOLAC",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin B12",
                        "tag": "VITB12",
                        "schemaOrgTag": null,
                        "total": 1.6212,
                        "hasRDI": true,
                        "daily": 67.55000000000001,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin D",
                        "tag": "VITD",
                        "schemaOrgTag": null,
                        "total": 5.0176,
                        "hasRDI": true,
                        "daily": 33.45066666666666,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin E",
                        "tag": "TOCPHA",
                        "schemaOrgTag": null,
                        "total": 3.66252,
                        "hasRDI": true,
                        "daily": 24.416800000000002,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin K",
                        "tag": "VITK1",
                        "schemaOrgTag": null,
                        "total": 9.3728,
                        "hasRDI": true,
                        "daily": 7.810666666666666,
                        "unit": "µg"
                    },
                    {
                        "label": "Sugar alcohols",
                        "tag": "Sugar.alcohol",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    },
                    {
                        "label": "Water",
                        "tag": "WATER",
                        "schemaOrgTag": null,
                        "total": 363.2636553098299,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    }
                ]
            },
            "_links": {
                "self": {
                    "href": "https://api.edamam.com/api/recipes/v2/80b3e766d2e4ac54870bec0cd666c13c?type=public&app_id=ea1d37d5&app_key=fd382a172ba8d6668c0430dc9c14a181",
                    "title": "Self"
                }
            }
        },
        {
            "recipe": {
                "uri": "http://www.edamam.com/ontologies/edamam.owl#recipe_28ec4e95b3b7af0c6d386469200126a6",
                "label": "Iced Fruit Punch",
                "image": "https://www.edamam.com/web-img/ffb/ffb0bc5db556089d4e111da635ff3e0c.jpg",
                "source": "Delish",
                "url": "http://www.delish.com/cooking/recipe-ideas/recipes/a27302/iced-fruit-punch-3644/",
                "shareAs": "http://www.edamam.com/recipe/iced-fruit-punch-28ec4e95b3b7af0c6d386469200126a6/fruit",
                "yield": 12,
                "dietLabels": [
                    "Low-Fat",
                    "Low-Sodium"
                ],
                "healthLabels": [
                    "Low Potassium",
                    "Kidney-Friendly",
                    "Vegan",
                    "Vegetarian",
                    "Pescatarian",
                    "Dairy-Free",
                    "Egg-Free",
                    "Peanut-Free",
                    "Tree-Nut-Free",
                    "Soy-Free",
                    "Fish-Free",
                    "Shellfish-Free",
                    "Pork-Free",
                    "Red-Meat-Free",
                    "Crustacean-Free",
                    "Celery-Free",
                    "Mustard-Free",
                    "Sesame-Free",
                    "Lupine-Free",
                    "Mollusk-Free",
                    "No oil added",
                    "Kosher"
                ],
                "cautions": [],
                "ingredientLines": [
                    "6 c. assorted fruit juices",
                    "3 c. ginger ale",
                    "3 c. Seltzer water"
                ],
                "ingredients": [
                    {
                        "text": "6 c. assorted fruit juices",
                        "weight": 1406.4,
                        "foodCategory": "sweetened beverages",
                        "foodId": "food_a2sndz3b13ty72a1st6y8an7vq1t",
                        "image": "https://www.edamam.com/food-img/66e/66ebbfb337e3ba768925a2771b60cb49.jpg"
                    },
                    {
                        "text": "3 c. ginger ale",
                        "weight": 732,
                        "foodCategory": "sweetened beverages",
                        "foodId": "food_ae09oqiazn7tlbb0x5yiebtmfslr",
                        "image": "https://www.edamam.com/food-img/81d/81d3a248c4ca048ffabc9551cc96217d.jpg"
                    },
                    {
                        "text": "3 c. Seltzer water",
                        "weight": 711,
                        "foodCategory": "water",
                        "foodId": "food_a99vzubbk1ayrsad318rvbzr3dh0",
                        "image": "https://www.edamam.com/food-img/5dd/5dd9d1361847b2ca53c4b19a8f92627e.jpg"
                    }
                ],
                "calories": 839.5680000000001,
                "totalWeight": 2849.4,
                "totalTime": 0,
                "cuisineType": [
                    "american"
                ],
                "mealType": [
                    "teatime"
                ],
                "dishType": [
                    "drinks"
                ],
                "totalNutrients": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 839.5680000000001,
                        "unit": "kcal"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 2.3908800000000006,
                        "unit": "g"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 0.29534400000000005,
                        "unit": "g"
                    },
                    "FAMS": {
                        "label": "Monounsaturated",
                        "quantity": 0.29534400000000005,
                        "unit": "g"
                    },
                    "FAPU": {
                        "label": "Polyunsaturated",
                        "quantity": 0.5906880000000001,
                        "unit": "g"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 224.526,
                        "unit": "g"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 0,
                        "unit": "g"
                    },
                    "SUGAR": {
                        "label": "Sugars",
                        "quantity": 224.01360000000003,
                        "unit": "g"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 0.9844800000000002,
                        "unit": "g"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 0,
                        "unit": "mg"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 150,
                        "unit": "mg"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 141.73800000000003,
                        "unit": "mg"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 56.62200000000001,
                        "unit": "mg"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 935.5440000000002,
                        "unit": "mg"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 4.130400000000001,
                        "unit": "mg"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 2.8279800000000006,
                        "unit": "mg"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 42.19200000000001,
                        "unit": "mg"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 67.50720000000001,
                        "unit": "mg"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 0.014064000000000002,
                        "unit": "mg"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 0.7875840000000002,
                        "unit": "mg"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 0.7032000000000002,
                        "unit": "mg"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 0.154704,
                        "unit": "mg"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 28.128000000000004,
                        "unit": "µg"
                    },
                    "FOLFD": {
                        "label": "Folate (food)",
                        "quantity": 28.128000000000004,
                        "unit": "µg"
                    },
                    "FOLAC": {
                        "label": "Folic acid",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 0,
                        "unit": "mg"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "WATER": {
                        "label": "Water",
                        "quantity": 2631.8982000000005,
                        "unit": "g"
                    }
                },
                "totalDaily": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 41.9784,
                        "unit": "%"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 3.6782769230769237,
                        "unit": "%"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 1.4767200000000003,
                        "unit": "%"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 74.84200000000001,
                        "unit": "%"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 0,
                        "unit": "%"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 1.9689600000000005,
                        "unit": "%"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 0,
                        "unit": "%"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 6.25,
                        "unit": "%"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 14.173800000000004,
                        "unit": "%"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 13.481428571428573,
                        "unit": "%"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 19.90519148936171,
                        "unit": "%"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 22.946666666666673,
                        "unit": "%"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 25.708909090909096,
                        "unit": "%"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 6.0274285714285725,
                        "unit": "%"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 0,
                        "unit": "%"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 75.00800000000001,
                        "unit": "%"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 1.1720000000000002,
                        "unit": "%"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 60.58338461538463,
                        "unit": "%"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 4.395000000000001,
                        "unit": "%"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 11.900307692307694,
                        "unit": "%"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 7.032,
                        "unit": "%"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 0,
                        "unit": "%"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 0,
                        "unit": "%"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 0,
                        "unit": "%"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 0,
                        "unit": "%"
                    }
                },
                "digest": [
                    {
                        "label": "Fat",
                        "tag": "FAT",
                        "schemaOrgTag": "fatContent",
                        "total": 2.3908800000000006,
                        "hasRDI": true,
                        "daily": 3.6782769230769237,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Saturated",
                                "tag": "FASAT",
                                "schemaOrgTag": "saturatedFatContent",
                                "total": 0.29534400000000005,
                                "hasRDI": true,
                                "daily": 1.4767200000000003,
                                "unit": "g"
                            },
                            {
                                "label": "Trans",
                                "tag": "FATRN",
                                "schemaOrgTag": "transFatContent",
                                "total": 0,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Monounsaturated",
                                "tag": "FAMS",
                                "schemaOrgTag": null,
                                "total": 0.29534400000000005,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Polyunsaturated",
                                "tag": "FAPU",
                                "schemaOrgTag": null,
                                "total": 0.5906880000000001,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Carbs",
                        "tag": "CHOCDF",
                        "schemaOrgTag": "carbohydrateContent",
                        "total": 224.526,
                        "hasRDI": true,
                        "daily": 74.84200000000001,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Carbs (net)",
                                "tag": "CHOCDF.net",
                                "schemaOrgTag": null,
                                "total": 224.526,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Fiber",
                                "tag": "FIBTG",
                                "schemaOrgTag": "fiberContent",
                                "total": 0,
                                "hasRDI": true,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars",
                                "tag": "SUGAR",
                                "schemaOrgTag": "sugarContent",
                                "total": 224.01360000000003,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars, added",
                                "tag": "SUGAR.added",
                                "schemaOrgTag": null,
                                "total": 0,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Protein",
                        "tag": "PROCNT",
                        "schemaOrgTag": "proteinContent",
                        "total": 0.9844800000000002,
                        "hasRDI": true,
                        "daily": 1.9689600000000005,
                        "unit": "g"
                    },
                    {
                        "label": "Cholesterol",
                        "tag": "CHOLE",
                        "schemaOrgTag": "cholesterolContent",
                        "total": 0,
                        "hasRDI": true,
                        "daily": 0,
                        "unit": "mg"
                    },
                    {
                        "label": "Sodium",
                        "tag": "NA",
                        "schemaOrgTag": "sodiumContent",
                        "total": 150,
                        "hasRDI": true,
                        "daily": 6.25,
                        "unit": "mg"
                    },
                    {
                        "label": "Calcium",
                        "tag": "CA",
                        "schemaOrgTag": null,
                        "total": 141.73800000000003,
                        "hasRDI": true,
                        "daily": 14.173800000000004,
                        "unit": "mg"
                    },
                    {
                        "label": "Magnesium",
                        "tag": "MG",
                        "schemaOrgTag": null,
                        "total": 56.62200000000001,
                        "hasRDI": true,
                        "daily": 13.481428571428573,
                        "unit": "mg"
                    },
                    {
                        "label": "Potassium",
                        "tag": "K",
                        "schemaOrgTag": null,
                        "total": 935.5440000000002,
                        "hasRDI": true,
                        "daily": 19.90519148936171,
                        "unit": "mg"
                    },
                    {
                        "label": "Iron",
                        "tag": "FE",
                        "schemaOrgTag": null,
                        "total": 4.130400000000001,
                        "hasRDI": true,
                        "daily": 22.946666666666673,
                        "unit": "mg"
                    },
                    {
                        "label": "Zinc",
                        "tag": "ZN",
                        "schemaOrgTag": null,
                        "total": 2.8279800000000006,
                        "hasRDI": true,
                        "daily": 25.708909090909096,
                        "unit": "mg"
                    },
                    {
                        "label": "Phosphorus",
                        "tag": "P",
                        "schemaOrgTag": null,
                        "total": 42.19200000000001,
                        "hasRDI": true,
                        "daily": 6.0274285714285725,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin A",
                        "tag": "VITA_RAE",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": true,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin C",
                        "tag": "VITC",
                        "schemaOrgTag": null,
                        "total": 67.50720000000001,
                        "hasRDI": true,
                        "daily": 75.00800000000001,
                        "unit": "mg"
                    },
                    {
                        "label": "Thiamin (B1)",
                        "tag": "THIA",
                        "schemaOrgTag": null,
                        "total": 0.014064000000000002,
                        "hasRDI": true,
                        "daily": 1.1720000000000002,
                        "unit": "mg"
                    },
                    {
                        "label": "Riboflavin (B2)",
                        "tag": "RIBF",
                        "schemaOrgTag": null,
                        "total": 0.7875840000000002,
                        "hasRDI": true,
                        "daily": 60.58338461538463,
                        "unit": "mg"
                    },
                    {
                        "label": "Niacin (B3)",
                        "tag": "NIA",
                        "schemaOrgTag": null,
                        "total": 0.7032000000000002,
                        "hasRDI": true,
                        "daily": 4.395000000000001,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin B6",
                        "tag": "VITB6A",
                        "schemaOrgTag": null,
                        "total": 0.154704,
                        "hasRDI": true,
                        "daily": 11.900307692307694,
                        "unit": "mg"
                    },
                    {
                        "label": "Folate equivalent (total)",
                        "tag": "FOLDFE",
                        "schemaOrgTag": null,
                        "total": 28.128000000000004,
                        "hasRDI": true,
                        "daily": 7.032,
                        "unit": "µg"
                    },
                    {
                        "label": "Folate (food)",
                        "tag": "FOLFD",
                        "schemaOrgTag": null,
                        "total": 28.128000000000004,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Folic acid",
                        "tag": "FOLAC",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin B12",
                        "tag": "VITB12",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": true,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin D",
                        "tag": "VITD",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": true,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin E",
                        "tag": "TOCPHA",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": true,
                        "daily": 0,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin K",
                        "tag": "VITK1",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": true,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Sugar alcohols",
                        "tag": "Sugar.alcohol",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    },
                    {
                        "label": "Water",
                        "tag": "WATER",
                        "schemaOrgTag": null,
                        "total": 2631.8982000000005,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    }
                ]
            },
            "_links": {
                "self": {
                    "href": "https://api.edamam.com/api/recipes/v2/28ec4e95b3b7af0c6d386469200126a6?type=public&app_id=ea1d37d5&app_key=fd382a172ba8d6668c0430dc9c14a181",
                    "title": "Self"
                }
            }
        },
        {
            "recipe": {
                "uri": "http://www.edamam.com/ontologies/edamam.owl#recipe_b2bf0be44b1de1bd67a8c0f63c3bbe23",
                "label": "Passion-Fruit Orangeade",
                "image": "https://www.edamam.com/web-img/2ab/2aba43e1807273fc0a7eddcb2a2ddaf1.jpg",
                "source": "Martha Stewart",
                "url": "https://www.marthastewart.com/1143190/passion-fruit-orangeade",
                "shareAs": "http://www.edamam.com/recipe/passion-fruit-orangeade-b2bf0be44b1de1bd67a8c0f63c3bbe23/fruit",
                "yield": 4,
                "dietLabels": [
                    "High-Fiber",
                    "Low-Fat",
                    "Low-Sodium"
                ],
                "healthLabels": [
                    "Vegan",
                    "Vegetarian",
                    "Pescatarian",
                    "Dairy-Free",
                    "Gluten-Free",
                    "Wheat-Free",
                    "Egg-Free",
                    "Peanut-Free",
                    "Tree-Nut-Free",
                    "Soy-Free",
                    "Fish-Free",
                    "Shellfish-Free",
                    "Pork-Free",
                    "Red-Meat-Free",
                    "Crustacean-Free",
                    "Celery-Free",
                    "Mustard-Free",
                    "Sesame-Free",
                    "Lupine-Free",
                    "Mollusk-Free",
                    "Alcohol-Free",
                    "No oil added",
                    "Kosher"
                ],
                "cautions": [
                    "Sulfites"
                ],
                "ingredientLines": [
                    "15 ripe passion fruit",
                    "1 1/2 cups freshly squeezed orange juice (about 4 oranges)",
                    "1/4 cup Simple Syrup for Passion-Fruit Orangeade"
                ],
                "ingredients": [
                    {
                        "text": "15 ripe passion fruit",
                        "weight": 270,
                        "foodCategory": "fruit",
                        "foodId": "food_b6nwerkagnmbhiac3tjmtasm5dwm",
                        "image": "https://www.edamam.com/food-img/393/393e886951f47632fedd2852531af6d2.jpg"
                    },
                    {
                        "text": "1 1/2 cups freshly squeezed orange juice (about 4 oranges)",
                        "weight": 372,
                        "foodCategory": "100% juice",
                        "foodId": "food_bn7zicravp7kdrb8h9knhadt6kei",
                        "image": "https://www.edamam.com/food-img/011/011c0c3b0f3865bde575f57c556439e4.jpg"
                    },
                    {
                        "text": "1/4 cup Simple Syrup for Passion-Fruit Orangeade",
                        "weight": 79,
                        "foodCategory": "sugars",
                        "foodId": "food_aftzb4hav0begxbvchpd3bhc9368",
                        "image": "https://www.edamam.com/food-img/198/198cf875b0112c3798592532e502e664.jpg"
                    }
                ],
                "calories": 641.8100000000001,
                "totalWeight": 721,
                "totalTime": 0,
                "cuisineType": [
                    "american"
                ],
                "mealType": [
                    "lunch/dinner"
                ],
                "dishType": [
                    "desserts"
                ],
                "totalNutrients": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 641.8100000000001,
                        "unit": "kcal"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 2.634,
                        "unit": "g"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 0.24858000000000002,
                        "unit": "g"
                    },
                    "FAMS": {
                        "label": "Monounsaturated",
                        "quantity": 0.36612,
                        "unit": "g"
                    },
                    "FAPU": {
                        "label": "Polyunsaturated",
                        "quantity": 1.2585,
                        "unit": "g"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 159.5946,
                        "unit": "g"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 28.824,
                        "unit": "g"
                    },
                    "SUGAR": {
                        "label": "Sugars",
                        "quantity": 119.316,
                        "unit": "g"
                    },
                    "SUGAR.added": {
                        "label": "Sugars, added",
                        "quantity": 57.828,
                        "unit": "g"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 8.544,
                        "unit": "g"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 0,
                        "unit": "mg"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 125.14000000000001,
                        "unit": "mg"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 83.59,
                        "unit": "mg"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 127.12000000000002,
                        "unit": "mg"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 1733.37,
                        "unit": "mg"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 7.908,
                        "unit": "mg"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 0.6061000000000001,
                        "unit": "mg"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 253.16000000000003,
                        "unit": "mg"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 210,
                        "unit": "µg"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 267,
                        "unit": "mg"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 0.4375,
                        "unit": "mg"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 0.51,
                        "unit": "mg"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 5.617000000000001,
                        "unit": "mg"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 0.41880000000000006,
                        "unit": "mg"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 149.4,
                        "unit": "µg"
                    },
                    "FOLFD": {
                        "label": "Folate (food)",
                        "quantity": 149.4,
                        "unit": "µg"
                    },
                    "FOLAC": {
                        "label": "Folic acid",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 0.20280000000000004,
                        "unit": "mg"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 2.262,
                        "unit": "µg"
                    },
                    "WATER": {
                        "label": "Water",
                        "quantity": 545.927,
                        "unit": "g"
                    }
                },
                "totalDaily": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 32.090500000000006,
                        "unit": "%"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 4.052307692307692,
                        "unit": "%"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 1.2429000000000001,
                        "unit": "%"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 53.1982,
                        "unit": "%"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 115.296,
                        "unit": "%"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 17.088,
                        "unit": "%"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 0,
                        "unit": "%"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 5.214166666666667,
                        "unit": "%"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 8.359,
                        "unit": "%"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 30.26666666666667,
                        "unit": "%"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 36.880212765957445,
                        "unit": "%"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 43.93333333333334,
                        "unit": "%"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 5.510000000000001,
                        "unit": "%"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 36.165714285714294,
                        "unit": "%"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 23.333333333333332,
                        "unit": "%"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 296.6666666666667,
                        "unit": "%"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 36.458333333333336,
                        "unit": "%"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 39.230769230769226,
                        "unit": "%"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 35.10625,
                        "unit": "%"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 32.21538461538462,
                        "unit": "%"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 37.35,
                        "unit": "%"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 0,
                        "unit": "%"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 0,
                        "unit": "%"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 1.3520000000000003,
                        "unit": "%"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 1.885,
                        "unit": "%"
                    }
                },
                "digest": [
                    {
                        "label": "Fat",
                        "tag": "FAT",
                        "schemaOrgTag": "fatContent",
                        "total": 2.634,
                        "hasRDI": true,
                        "daily": 4.052307692307692,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Saturated",
                                "tag": "FASAT",
                                "schemaOrgTag": "saturatedFatContent",
                                "total": 0.24858000000000002,
                                "hasRDI": true,
                                "daily": 1.2429000000000001,
                                "unit": "g"
                            },
                            {
                                "label": "Trans",
                                "tag": "FATRN",
                                "schemaOrgTag": "transFatContent",
                                "total": 0,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Monounsaturated",
                                "tag": "FAMS",
                                "schemaOrgTag": null,
                                "total": 0.36612,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Polyunsaturated",
                                "tag": "FAPU",
                                "schemaOrgTag": null,
                                "total": 1.2585,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Carbs",
                        "tag": "CHOCDF",
                        "schemaOrgTag": "carbohydrateContent",
                        "total": 159.5946,
                        "hasRDI": true,
                        "daily": 53.1982,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Carbs (net)",
                                "tag": "CHOCDF.net",
                                "schemaOrgTag": null,
                                "total": 130.7706,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Fiber",
                                "tag": "FIBTG",
                                "schemaOrgTag": "fiberContent",
                                "total": 28.824,
                                "hasRDI": true,
                                "daily": 115.296,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars",
                                "tag": "SUGAR",
                                "schemaOrgTag": "sugarContent",
                                "total": 119.316,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars, added",
                                "tag": "SUGAR.added",
                                "schemaOrgTag": null,
                                "total": 57.828,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Protein",
                        "tag": "PROCNT",
                        "schemaOrgTag": "proteinContent",
                        "total": 8.544,
                        "hasRDI": true,
                        "daily": 17.088,
                        "unit": "g"
                    },
                    {
                        "label": "Cholesterol",
                        "tag": "CHOLE",
                        "schemaOrgTag": "cholesterolContent",
                        "total": 0,
                        "hasRDI": true,
                        "daily": 0,
                        "unit": "mg"
                    },
                    {
                        "label": "Sodium",
                        "tag": "NA",
                        "schemaOrgTag": "sodiumContent",
                        "total": 125.14000000000001,
                        "hasRDI": true,
                        "daily": 5.214166666666667,
                        "unit": "mg"
                    },
                    {
                        "label": "Calcium",
                        "tag": "CA",
                        "schemaOrgTag": null,
                        "total": 83.59,
                        "hasRDI": true,
                        "daily": 8.359,
                        "unit": "mg"
                    },
                    {
                        "label": "Magnesium",
                        "tag": "MG",
                        "schemaOrgTag": null,
                        "total": 127.12000000000002,
                        "hasRDI": true,
                        "daily": 30.26666666666667,
                        "unit": "mg"
                    },
                    {
                        "label": "Potassium",
                        "tag": "K",
                        "schemaOrgTag": null,
                        "total": 1733.37,
                        "hasRDI": true,
                        "daily": 36.880212765957445,
                        "unit": "mg"
                    },
                    {
                        "label": "Iron",
                        "tag": "FE",
                        "schemaOrgTag": null,
                        "total": 7.908,
                        "hasRDI": true,
                        "daily": 43.93333333333334,
                        "unit": "mg"
                    },
                    {
                        "label": "Zinc",
                        "tag": "ZN",
                        "schemaOrgTag": null,
                        "total": 0.6061000000000001,
                        "hasRDI": true,
                        "daily": 5.510000000000001,
                        "unit": "mg"
                    },
                    {
                        "label": "Phosphorus",
                        "tag": "P",
                        "schemaOrgTag": null,
                        "total": 253.16000000000003,
                        "hasRDI": true,
                        "daily": 36.165714285714294,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin A",
                        "tag": "VITA_RAE",
                        "schemaOrgTag": null,
                        "total": 210,
                        "hasRDI": true,
                        "daily": 23.333333333333332,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin C",
                        "tag": "VITC",
                        "schemaOrgTag": null,
                        "total": 267,
                        "hasRDI": true,
                        "daily": 296.6666666666667,
                        "unit": "mg"
                    },
                    {
                        "label": "Thiamin (B1)",
                        "tag": "THIA",
                        "schemaOrgTag": null,
                        "total": 0.4375,
                        "hasRDI": true,
                        "daily": 36.458333333333336,
                        "unit": "mg"
                    },
                    {
                        "label": "Riboflavin (B2)",
                        "tag": "RIBF",
                        "schemaOrgTag": null,
                        "total": 0.51,
                        "hasRDI": true,
                        "daily": 39.230769230769226,
                        "unit": "mg"
                    },
                    {
                        "label": "Niacin (B3)",
                        "tag": "NIA",
                        "schemaOrgTag": null,
                        "total": 5.617000000000001,
                        "hasRDI": true,
                        "daily": 35.10625,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin B6",
                        "tag": "VITB6A",
                        "schemaOrgTag": null,
                        "total": 0.41880000000000006,
                        "hasRDI": true,
                        "daily": 32.21538461538462,
                        "unit": "mg"
                    },
                    {
                        "label": "Folate equivalent (total)",
                        "tag": "FOLDFE",
                        "schemaOrgTag": null,
                        "total": 149.4,
                        "hasRDI": true,
                        "daily": 37.35,
                        "unit": "µg"
                    },
                    {
                        "label": "Folate (food)",
                        "tag": "FOLFD",
                        "schemaOrgTag": null,
                        "total": 149.4,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Folic acid",
                        "tag": "FOLAC",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin B12",
                        "tag": "VITB12",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": true,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin D",
                        "tag": "VITD",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": true,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin E",
                        "tag": "TOCPHA",
                        "schemaOrgTag": null,
                        "total": 0.20280000000000004,
                        "hasRDI": true,
                        "daily": 1.3520000000000003,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin K",
                        "tag": "VITK1",
                        "schemaOrgTag": null,
                        "total": 2.262,
                        "hasRDI": true,
                        "daily": 1.885,
                        "unit": "µg"
                    },
                    {
                        "label": "Sugar alcohols",
                        "tag": "Sugar.alcohol",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    },
                    {
                        "label": "Water",
                        "tag": "WATER",
                        "schemaOrgTag": null,
                        "total": 545.927,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    }
                ]
            },
            "_links": {
                "self": {
                    "href": "https://api.edamam.com/api/recipes/v2/b2bf0be44b1de1bd67a8c0f63c3bbe23?type=public&app_id=ea1d37d5&app_key=fd382a172ba8d6668c0430dc9c14a181",
                    "title": "Self"
                }
            }
        },
        {
            "recipe": {
                "uri": "http://www.edamam.com/ontologies/edamam.owl#recipe_19d009f8db62500d36f3ba7b221c2357",
                "label": "Fruit Soufflé",
                "image": "https://www.edamam.com/web-img/d8d/d8d50af45d94b58c87d0f5d30d1f8df9.jpg",
                "source": "The Daily Meal",
                "url": "http://www.thedailymeal.com/recipes/fruit-souffl-recipe",
                "shareAs": "http://www.edamam.com/recipe/fruit-souffl%C3%A9-19d009f8db62500d36f3ba7b221c2357/fruit",
                "yield": 20,
                "dietLabels": [
                    "Low-Fat",
                    "Low-Sodium"
                ],
                "healthLabels": [
                    "Low Potassium",
                    "Kidney-Friendly",
                    "Vegetarian",
                    "Pescatarian",
                    "Dairy-Free",
                    "Gluten-Free",
                    "Wheat-Free",
                    "Peanut-Free",
                    "Tree-Nut-Free",
                    "Soy-Free",
                    "Fish-Free",
                    "Shellfish-Free",
                    "Pork-Free",
                    "Red-Meat-Free",
                    "Crustacean-Free",
                    "Celery-Free",
                    "Mustard-Free",
                    "Sesame-Free",
                    "Lupine-Free",
                    "Mollusk-Free",
                    "Alcohol-Free",
                    "No oil added",
                    "Kosher"
                ],
                "cautions": [
                    "Sulfites"
                ],
                "ingredientLines": [
                    "1 Cup fruit purée of your choice",
                    "4 Teaspoons apple pectin",
                    "1/4 Cup water",
                    "1/2 Cup sugar",
                    "8 egg whites",
                    "1/2 Cup sugar"
                ],
                "ingredients": [
                    {
                        "text": "1 Cup fruit purée of your choice",
                        "weight": 245,
                        "foodCategory": "sweetened beverages",
                        "foodId": "food_aaluhexb6hatm8a0x8eoaaf5v647",
                        "image": null
                    },
                    {
                        "text": "4 Teaspoons apple pectin",
                        "weight": 9.08333333379405,
                        "foodCategory": "fruit",
                        "foodId": "food_a1gb9ubb72c7snbuxr3weagwv0dd",
                        "image": "https://www.edamam.com/food-img/42c/42c006401027d35add93113548eeaae6.jpg"
                    },
                    {
                        "text": "1/4 Cup water",
                        "weight": 59.25,
                        "foodCategory": "water",
                        "foodId": "food_a99vzubbk1ayrsad318rvbzr3dh0",
                        "image": "https://www.edamam.com/food-img/5dd/5dd9d1361847b2ca53c4b19a8f92627e.jpg"
                    },
                    {
                        "text": "1/2 Cup sugar",
                        "weight": 100,
                        "foodCategory": "sugars",
                        "foodId": "food_axi2ijobrk819yb0adceobnhm1c2",
                        "image": "https://www.edamam.com/food-img/ecb/ecb3f5aaed96d0188c21b8369be07765.jpg"
                    },
                    {
                        "text": "8 egg whites",
                        "weight": 211.2,
                        "foodCategory": "Eggs",
                        "foodId": "food_a7hurbpb20zs42bnwg2p8bca3ihs",
                        "image": "https://www.edamam.com/food-img/b30/b304a020501418f9a63cf7f9359bc99d.jpg"
                    },
                    {
                        "text": "1/2 Cup sugar",
                        "weight": 100,
                        "foodCategory": "sugars",
                        "foodId": "food_axi2ijobrk819yb0adceobnhm1c2",
                        "image": "https://www.edamam.com/food-img/ecb/ecb3f5aaed96d0188c21b8369be07765.jpg"
                    }
                ],
                "calories": 962.0473333335729,
                "totalWeight": 724.533333333794,
                "totalTime": 0,
                "cuisineType": [
                    "american"
                ],
                "mealType": [
                    "lunch/dinner"
                ],
                "dishType": [
                    "desserts"
                ],
                "totalNutrients": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 962.0473333335729,
                        "unit": "kcal"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 0.54598166666745,
                        "unit": "g"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 0.024593333333462336,
                        "unit": "g"
                    },
                    "FAMS": {
                        "label": "Monounsaturated",
                        "quantity": 0.032485833333365584,
                        "unit": "g"
                    },
                    "FAPU": {
                        "label": "Polyunsaturated",
                        "quantity": 0.07323250000023497,
                        "unit": "g"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 222.03766833339697,
                        "unit": "g"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 2.6680000000110575,
                        "unit": "g"
                    },
                    "SUGAR": {
                        "label": "Sugars",
                        "quantity": 202.04327833338118,
                        "unit": "g"
                    },
                    "SUGAR.added": {
                        "label": "Sugars, added",
                        "quantity": 199.6,
                        "unit": "g"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 23.901916666667866,
                        "unit": "g"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 0,
                        "unit": "mg"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 362.402833333338,
                        "unit": "mg"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 36.25650000002764,
                        "unit": "mg"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 36.5286666666897,
                        "unit": "mg"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 549.0751666671597,
                        "unit": "mg"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 1.014860000000553,
                        "unit": "mg"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 0.2889183333335177,
                        "unit": "mg"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 54.72916666671735,
                        "unit": "mg"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 54.17250000001383,
                        "unit": "µg"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 5.072833333354526,
                        "unit": "mg"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 0.04674216666674498,
                        "unit": "mg"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 1.0189796666667863,
                        "unit": "mg"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 1.1463258333337527,
                        "unit": "mg"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 0.09268416666685557,
                        "unit": "mg"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 16.070500000013823,
                        "unit": "µg"
                    },
                    "FOLFD": {
                        "label": "Folate (food)",
                        "quantity": 16.070500000013823,
                        "unit": "µg"
                    },
                    "FOLAC": {
                        "label": "Folic acid",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 0.19008,
                        "unit": "µg"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 0.016350000000829288,
                        "unit": "mg"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 0.19983333334346912,
                        "unit": "µg"
                    },
                    "WATER": {
                        "label": "Water",
                        "quantity": 476.12529000039416,
                        "unit": "g"
                    }
                },
                "totalDaily": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 48.10236666667865,
                        "unit": "%"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 0.8399717948729999,
                        "unit": "%"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 0.12296666666731168,
                        "unit": "%"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 74.01255611113233,
                        "unit": "%"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 10.672000000044228,
                        "unit": "%"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 47.80383333333573,
                        "unit": "%"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 0,
                        "unit": "%"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 15.100118055555749,
                        "unit": "%"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 3.6256500000027647,
                        "unit": "%"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 8.697301587307072,
                        "unit": "%"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 11.68245035462042,
                        "unit": "%"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 5.638111111114183,
                        "unit": "%"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 2.626530303031979,
                        "unit": "%"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 7.818452380959621,
                        "unit": "%"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 6.019166666668203,
                        "unit": "%"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 5.6364814815050295,
                        "unit": "%"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 3.895180555562082,
                        "unit": "%"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 78.38305128206048,
                        "unit": "%"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 7.164536458335954,
                        "unit": "%"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 7.129551282065813,
                        "unit": "%"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 4.017625000003456,
                        "unit": "%"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 7.92,
                        "unit": "%"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 0,
                        "unit": "%"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 0.10900000000552859,
                        "unit": "%"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 0.16652777778622427,
                        "unit": "%"
                    }
                },
                "digest": [
                    {
                        "label": "Fat",
                        "tag": "FAT",
                        "schemaOrgTag": "fatContent",
                        "total": 0.54598166666745,
                        "hasRDI": true,
                        "daily": 0.8399717948729999,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Saturated",
                                "tag": "FASAT",
                                "schemaOrgTag": "saturatedFatContent",
                                "total": 0.024593333333462336,
                                "hasRDI": true,
                                "daily": 0.12296666666731168,
                                "unit": "g"
                            },
                            {
                                "label": "Trans",
                                "tag": "FATRN",
                                "schemaOrgTag": "transFatContent",
                                "total": 0,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Monounsaturated",
                                "tag": "FAMS",
                                "schemaOrgTag": null,
                                "total": 0.032485833333365584,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Polyunsaturated",
                                "tag": "FAPU",
                                "schemaOrgTag": null,
                                "total": 0.07323250000023497,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Carbs",
                        "tag": "CHOCDF",
                        "schemaOrgTag": "carbohydrateContent",
                        "total": 222.03766833339697,
                        "hasRDI": true,
                        "daily": 74.01255611113233,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Carbs (net)",
                                "tag": "CHOCDF.net",
                                "schemaOrgTag": null,
                                "total": 219.3696683333859,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Fiber",
                                "tag": "FIBTG",
                                "schemaOrgTag": "fiberContent",
                                "total": 2.6680000000110575,
                                "hasRDI": true,
                                "daily": 10.672000000044228,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars",
                                "tag": "SUGAR",
                                "schemaOrgTag": "sugarContent",
                                "total": 202.04327833338118,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars, added",
                                "tag": "SUGAR.added",
                                "schemaOrgTag": null,
                                "total": 199.6,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Protein",
                        "tag": "PROCNT",
                        "schemaOrgTag": "proteinContent",
                        "total": 23.901916666667866,
                        "hasRDI": true,
                        "daily": 47.80383333333573,
                        "unit": "g"
                    },
                    {
                        "label": "Cholesterol",
                        "tag": "CHOLE",
                        "schemaOrgTag": "cholesterolContent",
                        "total": 0,
                        "hasRDI": true,
                        "daily": 0,
                        "unit": "mg"
                    },
                    {
                        "label": "Sodium",
                        "tag": "NA",
                        "schemaOrgTag": "sodiumContent",
                        "total": 362.402833333338,
                        "hasRDI": true,
                        "daily": 15.100118055555749,
                        "unit": "mg"
                    },
                    {
                        "label": "Calcium",
                        "tag": "CA",
                        "schemaOrgTag": null,
                        "total": 36.25650000002764,
                        "hasRDI": true,
                        "daily": 3.6256500000027647,
                        "unit": "mg"
                    },
                    {
                        "label": "Magnesium",
                        "tag": "MG",
                        "schemaOrgTag": null,
                        "total": 36.5286666666897,
                        "hasRDI": true,
                        "daily": 8.697301587307072,
                        "unit": "mg"
                    },
                    {
                        "label": "Potassium",
                        "tag": "K",
                        "schemaOrgTag": null,
                        "total": 549.0751666671597,
                        "hasRDI": true,
                        "daily": 11.68245035462042,
                        "unit": "mg"
                    },
                    {
                        "label": "Iron",
                        "tag": "FE",
                        "schemaOrgTag": null,
                        "total": 1.014860000000553,
                        "hasRDI": true,
                        "daily": 5.638111111114183,
                        "unit": "mg"
                    },
                    {
                        "label": "Zinc",
                        "tag": "ZN",
                        "schemaOrgTag": null,
                        "total": 0.2889183333335177,
                        "hasRDI": true,
                        "daily": 2.626530303031979,
                        "unit": "mg"
                    },
                    {
                        "label": "Phosphorus",
                        "tag": "P",
                        "schemaOrgTag": null,
                        "total": 54.72916666671735,
                        "hasRDI": true,
                        "daily": 7.818452380959621,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin A",
                        "tag": "VITA_RAE",
                        "schemaOrgTag": null,
                        "total": 54.17250000001383,
                        "hasRDI": true,
                        "daily": 6.019166666668203,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin C",
                        "tag": "VITC",
                        "schemaOrgTag": null,
                        "total": 5.072833333354526,
                        "hasRDI": true,
                        "daily": 5.6364814815050295,
                        "unit": "mg"
                    },
                    {
                        "label": "Thiamin (B1)",
                        "tag": "THIA",
                        "schemaOrgTag": null,
                        "total": 0.04674216666674498,
                        "hasRDI": true,
                        "daily": 3.895180555562082,
                        "unit": "mg"
                    },
                    {
                        "label": "Riboflavin (B2)",
                        "tag": "RIBF",
                        "schemaOrgTag": null,
                        "total": 1.0189796666667863,
                        "hasRDI": true,
                        "daily": 78.38305128206048,
                        "unit": "mg"
                    },
                    {
                        "label": "Niacin (B3)",
                        "tag": "NIA",
                        "schemaOrgTag": null,
                        "total": 1.1463258333337527,
                        "hasRDI": true,
                        "daily": 7.164536458335954,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin B6",
                        "tag": "VITB6A",
                        "schemaOrgTag": null,
                        "total": 0.09268416666685557,
                        "hasRDI": true,
                        "daily": 7.129551282065813,
                        "unit": "mg"
                    },
                    {
                        "label": "Folate equivalent (total)",
                        "tag": "FOLDFE",
                        "schemaOrgTag": null,
                        "total": 16.070500000013823,
                        "hasRDI": true,
                        "daily": 4.017625000003456,
                        "unit": "µg"
                    },
                    {
                        "label": "Folate (food)",
                        "tag": "FOLFD",
                        "schemaOrgTag": null,
                        "total": 16.070500000013823,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Folic acid",
                        "tag": "FOLAC",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin B12",
                        "tag": "VITB12",
                        "schemaOrgTag": null,
                        "total": 0.19008,
                        "hasRDI": true,
                        "daily": 7.92,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin D",
                        "tag": "VITD",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": true,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin E",
                        "tag": "TOCPHA",
                        "schemaOrgTag": null,
                        "total": 0.016350000000829288,
                        "hasRDI": true,
                        "daily": 0.10900000000552859,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin K",
                        "tag": "VITK1",
                        "schemaOrgTag": null,
                        "total": 0.19983333334346912,
                        "hasRDI": true,
                        "daily": 0.16652777778622427,
                        "unit": "µg"
                    },
                    {
                        "label": "Sugar alcohols",
                        "tag": "Sugar.alcohol",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    },
                    {
                        "label": "Water",
                        "tag": "WATER",
                        "schemaOrgTag": null,
                        "total": 476.12529000039416,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    }
                ]
            },
            "_links": {
                "self": {
                    "href": "https://api.edamam.com/api/recipes/v2/19d009f8db62500d36f3ba7b221c2357?type=public&app_id=ea1d37d5&app_key=fd382a172ba8d6668c0430dc9c14a181",
                    "title": "Self"
                }
            }
        },
        {
            "recipe": {
                "uri": "http://www.edamam.com/ontologies/edamam.owl#recipe_6229daddde01c167e97dd08936d2d205",
                "label": "Tropical Fruit Slush",
                "image": "https://www.edamam.com/web-img/830/830993cc62fd36c34a5e3698f12de589.jpg",
                "source": "My Recipes",
                "url": "http://www.myrecipes.com/recipe/tropical-fruit-slush",
                "shareAs": "http://www.edamam.com/recipe/tropical-fruit-slush-6229daddde01c167e97dd08936d2d205/fruit",
                "yield": 4,
                "dietLabels": [],
                "healthLabels": [
                    "Vegan",
                    "Vegetarian",
                    "Pescatarian",
                    "Dairy-Free",
                    "Gluten-Free",
                    "Wheat-Free",
                    "Egg-Free",
                    "Peanut-Free",
                    "Tree-Nut-Free",
                    "Soy-Free",
                    "Fish-Free",
                    "Shellfish-Free",
                    "Pork-Free",
                    "Red-Meat-Free",
                    "Crustacean-Free",
                    "Celery-Free",
                    "Mustard-Free",
                    "Sesame-Free",
                    "Lupine-Free",
                    "Mollusk-Free",
                    "No oil added",
                    "Sulfite-Free",
                    "Kosher"
                ],
                "cautions": [
                    "Wheat",
                    "Sulfites",
                    "FODMAP"
                ],
                "ingredientLines": [
                    "1 pint passion-fruit sorbet",
                    "1 cup guava juice",
                    "1 cup papaya juice",
                    "1 cup passionfruit rum",
                    "3 cups crushed ice",
                    "Garnish: sliced star fruit"
                ],
                "ingredients": [
                    {
                        "text": "1 pint passion-fruit sorbet",
                        "weight": 480,
                        "foodCategory": "frozen treats",
                        "foodId": "food_bb0gx1jbgwfbl6b7fnyhhbpoxd4h",
                        "image": "https://www.edamam.com/food-img/6f6/6f6caa41014c15fa613abef327a63b7e.jpg"
                    },
                    {
                        "text": "1 cup guava juice",
                        "weight": 251,
                        "foodCategory": "canned fruit",
                        "foodId": "food_afijv2wb8e3xxaaiieqakbykjhge",
                        "image": "https://www.edamam.com/food-img/4ac/4ac4f1ed31a8963a68af90cab9681449.jpg"
                    },
                    {
                        "text": "1 cup papaya juice",
                        "weight": 250,
                        "foodCategory": "canned fruit",
                        "foodId": "food_bozf3vgb2r82bva85xj71a5apu30",
                        "image": "https://www.edamam.com/food-img/927/927c7564eab869219624fe3b0ba531ef.jpg"
                    },
                    {
                        "text": "1 cup passionfruit rum",
                        "weight": 223.999999998738,
                        "foodCategory": "liquors and cocktails",
                        "foodId": "food_bi9pqpkbrb86k8aowifmbbxwzgng",
                        "image": "https://www.edamam.com/food-img/eb5/eb51e606b36b62c66ea1a245ab0d4a8b.jpg"
                    },
                    {
                        "text": "3 cups crushed ice",
                        "weight": 711,
                        "foodCategory": "water",
                        "foodId": "food_a99vzubbk1ayrsad318rvbzr3dh0",
                        "image": "https://www.edamam.com/food-img/5dd/5dd9d1361847b2ca53c4b19a8f92627e.jpg"
                    },
                    {
                        "text": "Garnish: sliced star fruit",
                        "weight": 0,
                        "foodCategory": "fruit",
                        "foodId": "food_bho2lf2b0mb8uea94o2jcagdd26v",
                        "image": "https://www.edamam.com/food-img/800/800f2ce645428deb822bb648d8d57464.jpg"
                    }
                ],
                "calories": 1370.0699999970848,
                "totalWeight": 1915.999999998738,
                "totalTime": 0,
                "cuisineType": [
                    "caribbean"
                ],
                "mealType": [
                    "lunch/dinner"
                ],
                "dishType": [
                    "drinks"
                ],
                "totalNutrients": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 1370.0699999970848,
                        "unit": "kcal"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 0.5256000000000001,
                        "unit": "g"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 0.16770000000000002,
                        "unit": "g"
                    },
                    "FATRN": {
                        "label": "Trans",
                        "quantity": 0,
                        "unit": "g"
                    },
                    "FAMS": {
                        "label": "Monounsaturated",
                        "quantity": 0.1527,
                        "unit": "g"
                    },
                    "FAPU": {
                        "label": "Polyunsaturated",
                        "quantity": 0.1126,
                        "unit": "g"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 220.1025,
                        "unit": "g"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 8.81,
                        "unit": "g"
                    },
                    "SUGAR": {
                        "label": "Sugars",
                        "quantity": 205.51950000000002,
                        "unit": "g"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 0.6509,
                        "unit": "g"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 0,
                        "unit": "mg"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 82.23999999998739,
                        "unit": "mg"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 66.41,
                        "unit": "mg"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 19.63,
                        "unit": "mg"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 179.86999999997477,
                        "unit": "mg"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 2.072599999998486,
                        "unit": "mg"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 0.6781999999991167,
                        "unit": "mg"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 16.2199999999369,
                        "unit": "mg"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 45,
                        "unit": "µg"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 175.661,
                        "unit": "mg"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 0.04044999999989904,
                        "unit": "mg"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 0.01753,
                        "unit": "mg"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 0.8017000000000001,
                        "unit": "mg"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 0.0476,
                        "unit": "mg"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 12.530000000000001,
                        "unit": "µg"
                    },
                    "FOLFD": {
                        "label": "Folate (food)",
                        "quantity": 12.530000000000001,
                        "unit": "µg"
                    },
                    "FOLAC": {
                        "label": "Folic acid",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 0.7255,
                        "unit": "mg"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 4.51,
                        "unit": "µg"
                    },
                    "WATER": {
                        "label": "Water",
                        "quantity": 1281.6330999991596,
                        "unit": "g"
                    }
                },
                "totalDaily": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 68.50349999985423,
                        "unit": "%"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 0.8086153846153847,
                        "unit": "%"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 0.8385000000000001,
                        "unit": "%"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 73.3675,
                        "unit": "%"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 35.24,
                        "unit": "%"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 1.3018,
                        "unit": "%"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 0,
                        "unit": "%"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 3.4266666666661414,
                        "unit": "%"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 6.641,
                        "unit": "%"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 4.673809523809524,
                        "unit": "%"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 3.8270212765952074,
                        "unit": "%"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 11.514444444436034,
                        "unit": "%"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 6.165454545446516,
                        "unit": "%"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 2.3171428571338426,
                        "unit": "%"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 5,
                        "unit": "%"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 195.17888888888888,
                        "unit": "%"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 3.3708333333249203,
                        "unit": "%"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 1.3484615384615386,
                        "unit": "%"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 5.010625,
                        "unit": "%"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 3.661538461538462,
                        "unit": "%"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 3.1325,
                        "unit": "%"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 0,
                        "unit": "%"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 0,
                        "unit": "%"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 4.836666666666667,
                        "unit": "%"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 3.7583333333333333,
                        "unit": "%"
                    }
                },
                "digest": [
                    {
                        "label": "Fat",
                        "tag": "FAT",
                        "schemaOrgTag": "fatContent",
                        "total": 0.5256000000000001,
                        "hasRDI": true,
                        "daily": 0.8086153846153847,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Saturated",
                                "tag": "FASAT",
                                "schemaOrgTag": "saturatedFatContent",
                                "total": 0.16770000000000002,
                                "hasRDI": true,
                                "daily": 0.8385000000000001,
                                "unit": "g"
                            },
                            {
                                "label": "Trans",
                                "tag": "FATRN",
                                "schemaOrgTag": "transFatContent",
                                "total": 0,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Monounsaturated",
                                "tag": "FAMS",
                                "schemaOrgTag": null,
                                "total": 0.1527,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Polyunsaturated",
                                "tag": "FAPU",
                                "schemaOrgTag": null,
                                "total": 0.1126,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Carbs",
                        "tag": "CHOCDF",
                        "schemaOrgTag": "carbohydrateContent",
                        "total": 220.1025,
                        "hasRDI": true,
                        "daily": 73.3675,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Carbs (net)",
                                "tag": "CHOCDF.net",
                                "schemaOrgTag": null,
                                "total": 211.2925,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Fiber",
                                "tag": "FIBTG",
                                "schemaOrgTag": "fiberContent",
                                "total": 8.81,
                                "hasRDI": true,
                                "daily": 35.24,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars",
                                "tag": "SUGAR",
                                "schemaOrgTag": "sugarContent",
                                "total": 205.51950000000002,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars, added",
                                "tag": "SUGAR.added",
                                "schemaOrgTag": null,
                                "total": 0,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Protein",
                        "tag": "PROCNT",
                        "schemaOrgTag": "proteinContent",
                        "total": 0.6509,
                        "hasRDI": true,
                        "daily": 1.3018,
                        "unit": "g"
                    },
                    {
                        "label": "Cholesterol",
                        "tag": "CHOLE",
                        "schemaOrgTag": "cholesterolContent",
                        "total": 0,
                        "hasRDI": true,
                        "daily": 0,
                        "unit": "mg"
                    },
                    {
                        "label": "Sodium",
                        "tag": "NA",
                        "schemaOrgTag": "sodiumContent",
                        "total": 82.23999999998739,
                        "hasRDI": true,
                        "daily": 3.4266666666661414,
                        "unit": "mg"
                    },
                    {
                        "label": "Calcium",
                        "tag": "CA",
                        "schemaOrgTag": null,
                        "total": 66.41,
                        "hasRDI": true,
                        "daily": 6.641,
                        "unit": "mg"
                    },
                    {
                        "label": "Magnesium",
                        "tag": "MG",
                        "schemaOrgTag": null,
                        "total": 19.63,
                        "hasRDI": true,
                        "daily": 4.673809523809524,
                        "unit": "mg"
                    },
                    {
                        "label": "Potassium",
                        "tag": "K",
                        "schemaOrgTag": null,
                        "total": 179.86999999997477,
                        "hasRDI": true,
                        "daily": 3.8270212765952074,
                        "unit": "mg"
                    },
                    {
                        "label": "Iron",
                        "tag": "FE",
                        "schemaOrgTag": null,
                        "total": 2.072599999998486,
                        "hasRDI": true,
                        "daily": 11.514444444436034,
                        "unit": "mg"
                    },
                    {
                        "label": "Zinc",
                        "tag": "ZN",
                        "schemaOrgTag": null,
                        "total": 0.6781999999991167,
                        "hasRDI": true,
                        "daily": 6.165454545446516,
                        "unit": "mg"
                    },
                    {
                        "label": "Phosphorus",
                        "tag": "P",
                        "schemaOrgTag": null,
                        "total": 16.2199999999369,
                        "hasRDI": true,
                        "daily": 2.3171428571338426,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin A",
                        "tag": "VITA_RAE",
                        "schemaOrgTag": null,
                        "total": 45,
                        "hasRDI": true,
                        "daily": 5,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin C",
                        "tag": "VITC",
                        "schemaOrgTag": null,
                        "total": 175.661,
                        "hasRDI": true,
                        "daily": 195.17888888888888,
                        "unit": "mg"
                    },
                    {
                        "label": "Thiamin (B1)",
                        "tag": "THIA",
                        "schemaOrgTag": null,
                        "total": 0.04044999999989904,
                        "hasRDI": true,
                        "daily": 3.3708333333249203,
                        "unit": "mg"
                    },
                    {
                        "label": "Riboflavin (B2)",
                        "tag": "RIBF",
                        "schemaOrgTag": null,
                        "total": 0.01753,
                        "hasRDI": true,
                        "daily": 1.3484615384615386,
                        "unit": "mg"
                    },
                    {
                        "label": "Niacin (B3)",
                        "tag": "NIA",
                        "schemaOrgTag": null,
                        "total": 0.8017000000000001,
                        "hasRDI": true,
                        "daily": 5.010625,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin B6",
                        "tag": "VITB6A",
                        "schemaOrgTag": null,
                        "total": 0.0476,
                        "hasRDI": true,
                        "daily": 3.661538461538462,
                        "unit": "mg"
                    },
                    {
                        "label": "Folate equivalent (total)",
                        "tag": "FOLDFE",
                        "schemaOrgTag": null,
                        "total": 12.530000000000001,
                        "hasRDI": true,
                        "daily": 3.1325,
                        "unit": "µg"
                    },
                    {
                        "label": "Folate (food)",
                        "tag": "FOLFD",
                        "schemaOrgTag": null,
                        "total": 12.530000000000001,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Folic acid",
                        "tag": "FOLAC",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin B12",
                        "tag": "VITB12",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": true,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin D",
                        "tag": "VITD",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": true,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin E",
                        "tag": "TOCPHA",
                        "schemaOrgTag": null,
                        "total": 0.7255,
                        "hasRDI": true,
                        "daily": 4.836666666666667,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin K",
                        "tag": "VITK1",
                        "schemaOrgTag": null,
                        "total": 4.51,
                        "hasRDI": true,
                        "daily": 3.7583333333333333,
                        "unit": "µg"
                    },
                    {
                        "label": "Sugar alcohols",
                        "tag": "Sugar.alcohol",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    },
                    {
                        "label": "Water",
                        "tag": "WATER",
                        "schemaOrgTag": null,
                        "total": 1281.6330999991596,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    }
                ]
            },
            "_links": {
                "self": {
                    "href": "https://api.edamam.com/api/recipes/v2/6229daddde01c167e97dd08936d2d205?type=public&app_id=ea1d37d5&app_key=fd382a172ba8d6668c0430dc9c14a181",
                    "title": "Self"
                }
            }
        },
        {
            "recipe": {
                "uri": "http://www.edamam.com/ontologies/edamam.owl#recipe_c05724489efffb6d3cfc9b497fc9c2b5",
                "label": "Boozy Dried Fruit",
                "image": "https://www.edamam.com/web-img/956/95684e016446a5fd03982eabcc142218.jpg",
                "source": "Food52",
                "url": "https://food52.com/recipes/78284-boozy-dried-fruit",
                "shareAs": "http://www.edamam.com/recipe/boozy-dried-fruit-c05724489efffb6d3cfc9b497fc9c2b5/fruit",
                "yield": 4,
                "dietLabels": [
                    "Low-Fat",
                    "Low-Sodium"
                ],
                "healthLabels": [
                    "Vegan",
                    "Vegetarian",
                    "Pescatarian",
                    "Mediterranean",
                    "Dairy-Free",
                    "Gluten-Free",
                    "Wheat-Free",
                    "Egg-Free",
                    "Peanut-Free",
                    "Tree-Nut-Free",
                    "Soy-Free",
                    "Fish-Free",
                    "Shellfish-Free",
                    "Pork-Free",
                    "Red-Meat-Free",
                    "Crustacean-Free",
                    "Celery-Free",
                    "Mustard-Free",
                    "Sesame-Free",
                    "Lupine-Free",
                    "Mollusk-Free",
                    "No oil added",
                    "Kosher"
                ],
                "cautions": [
                    "Wheat",
                    "Sulfites"
                ],
                "ingredientLines": [
                    "175 grams (1 1/2 cups) mixed dried fruit of your choice, chopped 1/4-inch (e.g. a mixture of dark and golden raisins, dried figs, apricots, and cranberries)",
                    "50 grams (1/3 cup) candied lemon or orange peel (or more dried fruit), chopped 1/4-inch",
                    "75 grams (1/4 cup plus 1 tablespoon) light or dark rum or apple juice"
                ],
                "ingredients": [
                    {
                        "text": "175 grams (1 1/2 cups) mixed dried fruit of your choice, chopped 1/4-inch (e.g. a mixture of dark and golden raisins, dried figs, apricots, and cranberries)",
                        "weight": 175,
                        "foodCategory": "fruit",
                        "foodId": "food_bldu6vjaardup4b7jd52sbat4z6g",
                        "image": "https://www.edamam.com/food-img/eb3/eb345bd9c7f8242e479545e8146c8b35.jpg"
                    },
                    {
                        "text": "50 grams (1/3 cup) candied lemon or orange peel (or more dried fruit), chopped 1/4-inch",
                        "weight": 50,
                        "foodCategory": "fruit",
                        "foodId": "food_b4g0yyrb23ih2rajszgs8bjpe2nn",
                        "image": "https://www.edamam.com/food-img/cd4/cd456545c89e1e4c319f3cf1b5bff9e6.jpg"
                    },
                    {
                        "text": "75 grams (1/4 cup plus 1 tablespoon) light or dark rum or apple juice",
                        "weight": 75,
                        "foodCategory": "liquors and cocktails",
                        "foodId": "food_bi9pqpkbrb86k8aowifmbbxwzgng",
                        "image": "https://www.edamam.com/food-img/eb5/eb51e606b36b62c66ea1a245ab0d4a8b.jpg"
                    }
                ],
                "calories": 640,
                "totalWeight": 300,
                "totalTime": 10,
                "cuisineType": [
                    "american"
                ],
                "mealType": [
                    "lunch/dinner"
                ],
                "dishType": [
                    "cereals"
                ],
                "totalNutrients": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 640,
                        "unit": "kcal"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 1.4300000000000002,
                        "unit": "g"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 0.15550000000000003,
                        "unit": "g"
                    },
                    "FAMS": {
                        "label": "Monounsaturated",
                        "quantity": 0.5045000000000001,
                        "unit": "g"
                    },
                    "FAPU": {
                        "label": "Polyunsaturated",
                        "quantity": 0.66225,
                        "unit": "g"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 119.8275,
                        "unit": "g"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 19.65,
                        "unit": "g"
                    },
                    "SUGAR": {
                        "label": "Sugars",
                        "quantity": 73.045,
                        "unit": "g"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 7.0675,
                        "unit": "g"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 0,
                        "unit": "mg"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 14.5,
                        "unit": "mg"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 129.5,
                        "unit": "mg"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 84.5,
                        "unit": "mg"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 1850.5,
                        "unit": "mg"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 7.595,
                        "unit": "mg"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 1.175,
                        "unit": "mg"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 222.5,
                        "unit": "mg"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 199.5,
                        "unit": "µg"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 76.4,
                        "unit": "mg"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 0.0695,
                        "unit": "mg"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 0.416,
                        "unit": "mg"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 8.10625,
                        "unit": "mg"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 0.20525,
                        "unit": "mg"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 15,
                        "unit": "µg"
                    },
                    "FOLFD": {
                        "label": "Folate (food)",
                        "quantity": 15,
                        "unit": "µg"
                    },
                    "FOLAC": {
                        "label": "Folic acid",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 0.4575,
                        "unit": "mg"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 27.474999999999998,
                        "unit": "µg"
                    },
                    "WATER": {
                        "label": "Water",
                        "quantity": 141.85,
                        "unit": "g"
                    }
                },
                "totalDaily": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 32,
                        "unit": "%"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 2.2000000000000006,
                        "unit": "%"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 0.7775000000000001,
                        "unit": "%"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 39.9425,
                        "unit": "%"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 78.6,
                        "unit": "%"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 14.135,
                        "unit": "%"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 0,
                        "unit": "%"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 0.6041666666666666,
                        "unit": "%"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 12.95,
                        "unit": "%"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 20.11904761904762,
                        "unit": "%"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 39.37234042553192,
                        "unit": "%"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 42.19444444444444,
                        "unit": "%"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 10.681818181818182,
                        "unit": "%"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 31.785714285714285,
                        "unit": "%"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 22.166666666666668,
                        "unit": "%"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 84.8888888888889,
                        "unit": "%"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 5.791666666666668,
                        "unit": "%"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 32,
                        "unit": "%"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 50.66406249999999,
                        "unit": "%"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 15.788461538461537,
                        "unit": "%"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 3.75,
                        "unit": "%"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 0,
                        "unit": "%"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 0,
                        "unit": "%"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 3.05,
                        "unit": "%"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 22.895833333333332,
                        "unit": "%"
                    }
                },
                "digest": [
                    {
                        "label": "Fat",
                        "tag": "FAT",
                        "schemaOrgTag": "fatContent",
                        "total": 1.4300000000000002,
                        "hasRDI": true,
                        "daily": 2.2000000000000006,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Saturated",
                                "tag": "FASAT",
                                "schemaOrgTag": "saturatedFatContent",
                                "total": 0.15550000000000003,
                                "hasRDI": true,
                                "daily": 0.7775000000000001,
                                "unit": "g"
                            },
                            {
                                "label": "Trans",
                                "tag": "FATRN",
                                "schemaOrgTag": "transFatContent",
                                "total": 0,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Monounsaturated",
                                "tag": "FAMS",
                                "schemaOrgTag": null,
                                "total": 0.5045000000000001,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Polyunsaturated",
                                "tag": "FAPU",
                                "schemaOrgTag": null,
                                "total": 0.66225,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Carbs",
                        "tag": "CHOCDF",
                        "schemaOrgTag": "carbohydrateContent",
                        "total": 119.8275,
                        "hasRDI": true,
                        "daily": 39.9425,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Carbs (net)",
                                "tag": "CHOCDF.net",
                                "schemaOrgTag": null,
                                "total": 100.17750000000001,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Fiber",
                                "tag": "FIBTG",
                                "schemaOrgTag": "fiberContent",
                                "total": 19.65,
                                "hasRDI": true,
                                "daily": 78.6,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars",
                                "tag": "SUGAR",
                                "schemaOrgTag": "sugarContent",
                                "total": 73.045,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars, added",
                                "tag": "SUGAR.added",
                                "schemaOrgTag": null,
                                "total": 0,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Protein",
                        "tag": "PROCNT",
                        "schemaOrgTag": "proteinContent",
                        "total": 7.0675,
                        "hasRDI": true,
                        "daily": 14.135,
                        "unit": "g"
                    },
                    {
                        "label": "Cholesterol",
                        "tag": "CHOLE",
                        "schemaOrgTag": "cholesterolContent",
                        "total": 0,
                        "hasRDI": true,
                        "daily": 0,
                        "unit": "mg"
                    },
                    {
                        "label": "Sodium",
                        "tag": "NA",
                        "schemaOrgTag": "sodiumContent",
                        "total": 14.5,
                        "hasRDI": true,
                        "daily": 0.6041666666666666,
                        "unit": "mg"
                    },
                    {
                        "label": "Calcium",
                        "tag": "CA",
                        "schemaOrgTag": null,
                        "total": 129.5,
                        "hasRDI": true,
                        "daily": 12.95,
                        "unit": "mg"
                    },
                    {
                        "label": "Magnesium",
                        "tag": "MG",
                        "schemaOrgTag": null,
                        "total": 84.5,
                        "hasRDI": true,
                        "daily": 20.11904761904762,
                        "unit": "mg"
                    },
                    {
                        "label": "Potassium",
                        "tag": "K",
                        "schemaOrgTag": null,
                        "total": 1850.5,
                        "hasRDI": true,
                        "daily": 39.37234042553192,
                        "unit": "mg"
                    },
                    {
                        "label": "Iron",
                        "tag": "FE",
                        "schemaOrgTag": null,
                        "total": 7.595,
                        "hasRDI": true,
                        "daily": 42.19444444444444,
                        "unit": "mg"
                    },
                    {
                        "label": "Zinc",
                        "tag": "ZN",
                        "schemaOrgTag": null,
                        "total": 1.175,
                        "hasRDI": true,
                        "daily": 10.681818181818182,
                        "unit": "mg"
                    },
                    {
                        "label": "Phosphorus",
                        "tag": "P",
                        "schemaOrgTag": null,
                        "total": 222.5,
                        "hasRDI": true,
                        "daily": 31.785714285714285,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin A",
                        "tag": "VITA_RAE",
                        "schemaOrgTag": null,
                        "total": 199.5,
                        "hasRDI": true,
                        "daily": 22.166666666666668,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin C",
                        "tag": "VITC",
                        "schemaOrgTag": null,
                        "total": 76.4,
                        "hasRDI": true,
                        "daily": 84.8888888888889,
                        "unit": "mg"
                    },
                    {
                        "label": "Thiamin (B1)",
                        "tag": "THIA",
                        "schemaOrgTag": null,
                        "total": 0.0695,
                        "hasRDI": true,
                        "daily": 5.791666666666668,
                        "unit": "mg"
                    },
                    {
                        "label": "Riboflavin (B2)",
                        "tag": "RIBF",
                        "schemaOrgTag": null,
                        "total": 0.416,
                        "hasRDI": true,
                        "daily": 32,
                        "unit": "mg"
                    },
                    {
                        "label": "Niacin (B3)",
                        "tag": "NIA",
                        "schemaOrgTag": null,
                        "total": 8.10625,
                        "hasRDI": true,
                        "daily": 50.66406249999999,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin B6",
                        "tag": "VITB6A",
                        "schemaOrgTag": null,
                        "total": 0.20525,
                        "hasRDI": true,
                        "daily": 15.788461538461537,
                        "unit": "mg"
                    },
                    {
                        "label": "Folate equivalent (total)",
                        "tag": "FOLDFE",
                        "schemaOrgTag": null,
                        "total": 15,
                        "hasRDI": true,
                        "daily": 3.75,
                        "unit": "µg"
                    },
                    {
                        "label": "Folate (food)",
                        "tag": "FOLFD",
                        "schemaOrgTag": null,
                        "total": 15,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Folic acid",
                        "tag": "FOLAC",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin B12",
                        "tag": "VITB12",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": true,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin D",
                        "tag": "VITD",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": true,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin E",
                        "tag": "TOCPHA",
                        "schemaOrgTag": null,
                        "total": 0.4575,
                        "hasRDI": true,
                        "daily": 3.05,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin K",
                        "tag": "VITK1",
                        "schemaOrgTag": null,
                        "total": 27.474999999999998,
                        "hasRDI": true,
                        "daily": 22.895833333333332,
                        "unit": "µg"
                    },
                    {
                        "label": "Sugar alcohols",
                        "tag": "Sugar.alcohol",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    },
                    {
                        "label": "Water",
                        "tag": "WATER",
                        "schemaOrgTag": null,
                        "total": 141.85,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    }
                ]
            },
            "_links": {
                "self": {
                    "href": "https://api.edamam.com/api/recipes/v2/c05724489efffb6d3cfc9b497fc9c2b5?type=public&app_id=ea1d37d5&app_key=fd382a172ba8d6668c0430dc9c14a181",
                    "title": "Self"
                }
            }
        },
        {
            "recipe": {
                "uri": "http://www.edamam.com/ontologies/edamam.owl#recipe_38ca035df4107b51478c3e24c953fe69",
                "label": "Passion-Fruit Nieve",
                "image": "https://www.edamam.com/web-img/d44/d44aa7b5f57499bb80df7f5de2b0cbe4.jpg",
                "source": "Epicurious",
                "url": "https://www.epicurious.com/recipes/food/views/passion-fruit-nieve-232019",
                "shareAs": "http://www.edamam.com/recipe/passion-fruit-nieve-38ca035df4107b51478c3e24c953fe69/fruit",
                "yield": 6,
                "dietLabels": [
                    "High-Fiber",
                    "Low-Fat",
                    "Low-Sodium"
                ],
                "healthLabels": [
                    "Vegetarian",
                    "Pescatarian",
                    "Gluten-Free",
                    "Wheat-Free",
                    "Egg-Free",
                    "Peanut-Free",
                    "Tree-Nut-Free",
                    "Soy-Free",
                    "Fish-Free",
                    "Shellfish-Free",
                    "Pork-Free",
                    "Red-Meat-Free",
                    "Crustacean-Free",
                    "Celery-Free",
                    "Mustard-Free",
                    "Sesame-Free",
                    "Lupine-Free",
                    "Mollusk-Free",
                    "Alcohol-Free",
                    "Kosher"
                ],
                "cautions": [
                    "Sulfites"
                ],
                "ingredientLines": [
                    "3 cups passion-fruit nectar (24 fl oz), chilled",
                    "2/3 cup light corn syrup",
                    "2 tablespoons fresh lime juice",
                    "an ice cream maker"
                ],
                "ingredients": [
                    {
                        "text": "3 cups passion-fruit nectar (24 fl oz), chilled",
                        "weight": 708,
                        "foodCategory": "fruit",
                        "foodId": "food_b6nwerkagnmbhiac3tjmtasm5dwm",
                        "image": "https://www.edamam.com/food-img/393/393e886951f47632fedd2852531af6d2.jpg"
                    },
                    {
                        "text": "2/3 cup light corn syrup",
                        "weight": 227.33333333333331,
                        "foodCategory": "sugars",
                        "foodId": "food_b8n4w6faic9hd1a7t9vx1bxq42wr",
                        "image": "https://www.edamam.com/food-img/148/1488bb6a128ff5142e0a52d5eeb36d36.jpg"
                    },
                    {
                        "text": "2 tablespoons fresh lime juice",
                        "weight": 30.799999999479265,
                        "foodCategory": "fruit",
                        "foodId": "food_b0iywbmaujvd4eblrooo9bsvn7e6",
                        "image": "https://www.edamam.com/food-img/8f0/8f0c10eb3dbf476a05e61018e76ea220.jpg"
                    },
                    {
                        "text": "an ice cream maker",
                        "weight": 16.7379412374123,
                        "foodCategory": "frozen treats",
                        "foodId": "food_bsg87una16tr8waipd66na9drm1k",
                        "image": "https://www.edamam.com/food-img/1be/1be43587dc55730fc761aedf4f3df090.jpg"
                    }
                ],
                "calories": 1372.4608716946464,
                "totalWeight": 982.8712745702248,
                "totalTime": 0,
                "cuisineType": [
                    "american"
                ],
                "mealType": [
                    "lunch/dinner"
                ],
                "dishType": [
                    "desserts"
                ],
                "totalNutrients": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 1372.4608716946464,
                        "unit": "kcal"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 7.273400202781655,
                        "unit": "g"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 1.5566902100202535,
                        "unit": "g"
                    },
                    "FAMS": {
                        "label": "Monounsaturated",
                        "quantity": 1.1082934753387295,
                        "unit": "g"
                    },
                    "FAPU": {
                        "label": "Polyunsaturated",
                        "quantity": 2.992619494392984,
                        "unit": "g"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 346.64318079865205,
                        "unit": "g"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 73.87236558865982,
                        "unit": "g"
                    },
                    "SUGAR": {
                        "label": "Sugars",
                        "quantity": 257.89211113057,
                        "unit": "g"
                    },
                    "SUGAR.added": {
                        "label": "Sugars, added",
                        "quantity": 178.07559113057886,
                        "unit": "g"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 16.291187943307246,
                        "unit": "g"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 7.364694144461413,
                        "unit": "mg"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 353.1930196565861,
                        "unit": "mg"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 140.24989811714818,
                        "unit": "mg"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 212.4006451065294,
                        "unit": "mg"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 2535.457836395175,
                        "unit": "mg"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 11.370784147113204,
                        "unit": "mg"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 1.8483984612043947,
                        "unit": "mg"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 503.32683829921,
                        "unit": "mg"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 473.48677066013613,
                        "unit": "µg"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 221.74042764726826,
                        "unit": "mg"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 0.1486892225738755,
                        "unit": "mg"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 0.9651910589697115,
                        "unit": "mg"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 10.68315201183466,
                        "unit": "mg"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 0.7277382117937601,
                        "unit": "mg"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 103.03689706181855,
                        "unit": "µg"
                    },
                    "FOLFD": {
                        "label": "Folate (food)",
                        "quantity": 103.03689706181855,
                        "unit": "µg"
                    },
                    "FOLAC": {
                        "label": "Folic acid",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 0.06527797082590797,
                        "unit": "µg"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 0.0334758824748246,
                        "unit": "µg"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 0.25957382371109133,
                        "unit": "mg"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 5.1910138237091115,
                        "unit": "µg"
                    },
                    "WATER": {
                        "label": "Water",
                        "quantity": 606.3725974876821,
                        "unit": "g"
                    }
                },
                "totalDaily": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 68.62304358473233,
                        "unit": "%"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 11.189846465817931,
                        "unit": "%"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 7.7834510501012675,
                        "unit": "%"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 115.547726932884,
                        "unit": "%"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 295.4894623546393,
                        "unit": "%"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 32.58237588661449,
                        "unit": "%"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 2.454898048153804,
                        "unit": "%"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 14.716375819024421,
                        "unit": "%"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 14.02498981171482,
                        "unit": "%"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 50.57158216822129,
                        "unit": "%"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 53.9459114126633,
                        "unit": "%"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 63.1710230395178,
                        "unit": "%"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 16.803622374585405,
                        "unit": "%"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 71.90383404274428,
                        "unit": "%"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 52.60964118445957,
                        "unit": "%"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 246.3782529414092,
                        "unit": "%"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 12.39076854782296,
                        "unit": "%"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 74.24546607459318,
                        "unit": "%"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 66.76970007396662,
                        "unit": "%"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 55.97986244567385,
                        "unit": "%"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 25.759224265454638,
                        "unit": "%"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 2.719915451079499,
                        "unit": "%"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 0.22317254983216403,
                        "unit": "%"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 1.7304921580739423,
                        "unit": "%"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 4.325844853090926,
                        "unit": "%"
                    }
                },
                "digest": [
                    {
                        "label": "Fat",
                        "tag": "FAT",
                        "schemaOrgTag": "fatContent",
                        "total": 7.273400202781655,
                        "hasRDI": true,
                        "daily": 11.189846465817931,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Saturated",
                                "tag": "FASAT",
                                "schemaOrgTag": "saturatedFatContent",
                                "total": 1.5566902100202535,
                                "hasRDI": true,
                                "daily": 7.7834510501012675,
                                "unit": "g"
                            },
                            {
                                "label": "Trans",
                                "tag": "FATRN",
                                "schemaOrgTag": "transFatContent",
                                "total": 0,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Monounsaturated",
                                "tag": "FAMS",
                                "schemaOrgTag": null,
                                "total": 1.1082934753387295,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Polyunsaturated",
                                "tag": "FAPU",
                                "schemaOrgTag": null,
                                "total": 2.992619494392984,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Carbs",
                        "tag": "CHOCDF",
                        "schemaOrgTag": "carbohydrateContent",
                        "total": 346.64318079865205,
                        "hasRDI": true,
                        "daily": 115.547726932884,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Carbs (net)",
                                "tag": "CHOCDF.net",
                                "schemaOrgTag": null,
                                "total": 272.77081520999224,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Fiber",
                                "tag": "FIBTG",
                                "schemaOrgTag": "fiberContent",
                                "total": 73.87236558865982,
                                "hasRDI": true,
                                "daily": 295.4894623546393,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars",
                                "tag": "SUGAR",
                                "schemaOrgTag": "sugarContent",
                                "total": 257.89211113057,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars, added",
                                "tag": "SUGAR.added",
                                "schemaOrgTag": null,
                                "total": 178.07559113057886,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Protein",
                        "tag": "PROCNT",
                        "schemaOrgTag": "proteinContent",
                        "total": 16.291187943307246,
                        "hasRDI": true,
                        "daily": 32.58237588661449,
                        "unit": "g"
                    },
                    {
                        "label": "Cholesterol",
                        "tag": "CHOLE",
                        "schemaOrgTag": "cholesterolContent",
                        "total": 7.364694144461413,
                        "hasRDI": true,
                        "daily": 2.454898048153804,
                        "unit": "mg"
                    },
                    {
                        "label": "Sodium",
                        "tag": "NA",
                        "schemaOrgTag": "sodiumContent",
                        "total": 353.1930196565861,
                        "hasRDI": true,
                        "daily": 14.716375819024421,
                        "unit": "mg"
                    },
                    {
                        "label": "Calcium",
                        "tag": "CA",
                        "schemaOrgTag": null,
                        "total": 140.24989811714818,
                        "hasRDI": true,
                        "daily": 14.02498981171482,
                        "unit": "mg"
                    },
                    {
                        "label": "Magnesium",
                        "tag": "MG",
                        "schemaOrgTag": null,
                        "total": 212.4006451065294,
                        "hasRDI": true,
                        "daily": 50.57158216822129,
                        "unit": "mg"
                    },
                    {
                        "label": "Potassium",
                        "tag": "K",
                        "schemaOrgTag": null,
                        "total": 2535.457836395175,
                        "hasRDI": true,
                        "daily": 53.9459114126633,
                        "unit": "mg"
                    },
                    {
                        "label": "Iron",
                        "tag": "FE",
                        "schemaOrgTag": null,
                        "total": 11.370784147113204,
                        "hasRDI": true,
                        "daily": 63.1710230395178,
                        "unit": "mg"
                    },
                    {
                        "label": "Zinc",
                        "tag": "ZN",
                        "schemaOrgTag": null,
                        "total": 1.8483984612043947,
                        "hasRDI": true,
                        "daily": 16.803622374585405,
                        "unit": "mg"
                    },
                    {
                        "label": "Phosphorus",
                        "tag": "P",
                        "schemaOrgTag": null,
                        "total": 503.32683829921,
                        "hasRDI": true,
                        "daily": 71.90383404274428,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin A",
                        "tag": "VITA_RAE",
                        "schemaOrgTag": null,
                        "total": 473.48677066013613,
                        "hasRDI": true,
                        "daily": 52.60964118445957,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin C",
                        "tag": "VITC",
                        "schemaOrgTag": null,
                        "total": 221.74042764726826,
                        "hasRDI": true,
                        "daily": 246.3782529414092,
                        "unit": "mg"
                    },
                    {
                        "label": "Thiamin (B1)",
                        "tag": "THIA",
                        "schemaOrgTag": null,
                        "total": 0.1486892225738755,
                        "hasRDI": true,
                        "daily": 12.39076854782296,
                        "unit": "mg"
                    },
                    {
                        "label": "Riboflavin (B2)",
                        "tag": "RIBF",
                        "schemaOrgTag": null,
                        "total": 0.9651910589697115,
                        "hasRDI": true,
                        "daily": 74.24546607459318,
                        "unit": "mg"
                    },
                    {
                        "label": "Niacin (B3)",
                        "tag": "NIA",
                        "schemaOrgTag": null,
                        "total": 10.68315201183466,
                        "hasRDI": true,
                        "daily": 66.76970007396662,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin B6",
                        "tag": "VITB6A",
                        "schemaOrgTag": null,
                        "total": 0.7277382117937601,
                        "hasRDI": true,
                        "daily": 55.97986244567385,
                        "unit": "mg"
                    },
                    {
                        "label": "Folate equivalent (total)",
                        "tag": "FOLDFE",
                        "schemaOrgTag": null,
                        "total": 103.03689706181855,
                        "hasRDI": true,
                        "daily": 25.759224265454638,
                        "unit": "µg"
                    },
                    {
                        "label": "Folate (food)",
                        "tag": "FOLFD",
                        "schemaOrgTag": null,
                        "total": 103.03689706181855,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Folic acid",
                        "tag": "FOLAC",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin B12",
                        "tag": "VITB12",
                        "schemaOrgTag": null,
                        "total": 0.06527797082590797,
                        "hasRDI": true,
                        "daily": 2.719915451079499,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin D",
                        "tag": "VITD",
                        "schemaOrgTag": null,
                        "total": 0.0334758824748246,
                        "hasRDI": true,
                        "daily": 0.22317254983216403,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin E",
                        "tag": "TOCPHA",
                        "schemaOrgTag": null,
                        "total": 0.25957382371109133,
                        "hasRDI": true,
                        "daily": 1.7304921580739423,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin K",
                        "tag": "VITK1",
                        "schemaOrgTag": null,
                        "total": 5.1910138237091115,
                        "hasRDI": true,
                        "daily": 4.325844853090926,
                        "unit": "µg"
                    },
                    {
                        "label": "Sugar alcohols",
                        "tag": "Sugar.alcohol",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    },
                    {
                        "label": "Water",
                        "tag": "WATER",
                        "schemaOrgTag": null,
                        "total": 606.3725974876821,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    }
                ]
            },
            "_links": {
                "self": {
                    "href": "https://api.edamam.com/api/recipes/v2/38ca035df4107b51478c3e24c953fe69?type=public&app_id=ea1d37d5&app_key=fd382a172ba8d6668c0430dc9c14a181",
                    "title": "Self"
                }
            }
        },
        {
            "recipe": {
                "uri": "http://www.edamam.com/ontologies/edamam.owl#recipe_07fbab15f4532a58bf587f91d69189fd",
                "label": "Frozen fruit sticks with passion fruit & lime drizzle",
                "image": "https://www.edamam.com/web-img/99b/99be094930132c50bf9b7db822c60b71.jpg",
                "source": "BBC Good Food",
                "url": "http://www.bbcgoodfood.com/recipes/1507672/frozen-fruit-sticks-with-passion-fruit-and-lime-dr",
                "shareAs": "http://www.edamam.com/recipe/frozen-fruit-sticks-with-passion-fruit-lime-drizzle-07fbab15f4532a58bf587f91d69189fd/fruit",
                "yield": 8,
                "dietLabels": [
                    "Low-Fat",
                    "Low-Sodium"
                ],
                "healthLabels": [
                    "Kidney-Friendly",
                    "Vegan",
                    "Vegetarian",
                    "Pescatarian",
                    "Dairy-Free",
                    "Gluten-Free",
                    "Wheat-Free",
                    "Egg-Free",
                    "Peanut-Free",
                    "Tree-Nut-Free",
                    "Soy-Free",
                    "Fish-Free",
                    "Shellfish-Free",
                    "Pork-Free",
                    "Red-Meat-Free",
                    "Crustacean-Free",
                    "Celery-Free",
                    "Mustard-Free",
                    "Sesame-Free",
                    "Lupine-Free",
                    "Mollusk-Free",
                    "Alcohol-Free",
                    "No oil added",
                    "Kosher"
                ],
                "cautions": [
                    "Sulfites"
                ],
                "ingredientLines": [
                    "100g strawberries, hulled and halved",
                    "8 seedless grapes",
                    "100g/4oz mango chunks",
                    "100g/4oz melon chunks",
                    "2 kiwi fruit, peeled and cut into chunks",
                    "100g/4oz pineapple chunks",
                    "juice 2 limes",
                    "4 passion fruit, halved and seeds scraped out",
                    "1 tsp icing sugar"
                ],
                "ingredients": [
                    {
                        "text": "100g strawberries, hulled and halved",
                        "weight": 100,
                        "foodCategory": "fruit",
                        "foodId": "food_b4s2ibkbrrucmbabbaxhfau8ay42",
                        "image": "https://www.edamam.com/food-img/00c/00c8851e401bf7975be7f73499b4b573.jpg"
                    },
                    {
                        "text": "8 seedless grapes",
                        "weight": 39.2,
                        "foodCategory": "fruit",
                        "foodId": "food_bncple4a2uagu1b4hov92budz2vs",
                        "image": "https://www.edamam.com/food-img/ca5/ca55ac74deb991d159942c65777115df.jpg"
                    },
                    {
                        "text": "100g/4oz mango chunks",
                        "weight": 100,
                        "foodCategory": "fruit",
                        "foodId": "food_an1dqoib8xj3tyb3pr7c0abi4rbw",
                        "image": "https://www.edamam.com/food-img/6e0/6e04857756d0876f14bfc035ff238e0b.png"
                    },
                    {
                        "text": "100g/4oz melon chunks",
                        "weight": 100,
                        "foodCategory": "fruit",
                        "foodId": "food_b2eupkrbr3b81waz5nxitbdzdzde",
                        "image": "https://www.edamam.com/food-img/b1b/b1b603c35a63d662e3359d4e55b31653.jpg"
                    },
                    {
                        "text": "2 kiwi fruit, peeled and cut into chunks",
                        "weight": 138,
                        "foodCategory": "fruit",
                        "foodId": "food_bqj114aab4xnl6b6j3dt0bi4sznd",
                        "image": "https://www.edamam.com/food-img/dba/dbabbf58b6a43c9b65014f4c789d4409.jpg"
                    },
                    {
                        "text": "100g/4oz pineapple chunks",
                        "weight": 100,
                        "foodCategory": "fruit",
                        "foodId": "food_b5maw38amr54vpat8d5vhbgmqfxn",
                        "image": "https://www.edamam.com/food-img/2da/2da6f2397ab64ed185c082edebc4dd7c.jpg"
                    },
                    {
                        "text": "juice 2 limes",
                        "weight": 134,
                        "foodCategory": "fruit",
                        "foodId": "food_av58muyb8kg92fbk0g8g8aui5knv",
                        "image": "https://www.edamam.com/food-img/48a/48a123c9576647c4ada6a41df5eeb22a.jpg"
                    },
                    {
                        "text": "4 passion fruit, halved and seeds scraped out",
                        "weight": 72,
                        "foodCategory": "fruit",
                        "foodId": "food_b6nwerkagnmbhiac3tjmtasm5dwm",
                        "image": "https://www.edamam.com/food-img/393/393e886951f47632fedd2852531af6d2.jpg"
                    },
                    {
                        "text": "1 tsp icing sugar",
                        "weight": 2.5,
                        "foodCategory": "sugars",
                        "foodId": "food_b7rbtshahirxisbtyc77sbv8jdue",
                        "image": "https://www.edamam.com/food-img/290/290624aa4c0e279551e462443e38bb40.jpg"
                    }
                ],
                "calories": 406.99300000000005,
                "totalWeight": 785.7,
                "totalTime": 20,
                "cuisineType": [
                    "american"
                ],
                "mealType": [
                    "lunch/dinner"
                ],
                "dishType": [
                    "desserts"
                ],
                "totalNutrients": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 406.99300000000005,
                        "unit": "kcal"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 2.5423200000000006,
                        "unit": "g"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 0.300148,
                        "unit": "g"
                    },
                    "FAMS": {
                        "label": "Monounsaturated",
                        "quantity": 0.353984,
                        "unit": "g"
                    },
                    "FAPU": {
                        "label": "Polyunsaturated",
                        "quantity": 1.1314959999999998,
                        "unit": "g"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 104.71744999999999,
                        "unit": "g"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 21.6328,
                        "unit": "g"
                    },
                    "SUGAR": {
                        "label": "Sugars",
                        "quantity": 67.50821,
                        "unit": "g"
                    },
                    "SUGAR.added": {
                        "label": "Sugars, added",
                        "quantity": 2.44525,
                        "unit": "g"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 7.247439999999999,
                        "unit": "g"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 0,
                        "unit": "mg"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 46.81399999999999,
                        "unit": "mg"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 152.725,
                        "unit": "mg"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 102.12400000000001,
                        "unit": "mg"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 1589.7220000000002,
                        "unit": "mg"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 3.59642,
                        "unit": "mg"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 0.97029,
                        "unit": "mg"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 188.84,
                        "unit": "mg"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 282.456,
                        "unit": "µg"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 369.4744000000001,
                        "unit": "mg"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 0.27650800000000003,
                        "unit": "mg"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 0.293815,
                        "unit": "mg"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 4.181276,
                        "unit": "mg"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 0.6002719999999999,
                        "unit": "mg"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 162.084,
                        "unit": "µg"
                    },
                    "FOLFD": {
                        "label": "Folate (food)",
                        "quantity": 162.084,
                        "unit": "µg"
                    },
                    "FOLAC": {
                        "label": "Folic acid",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 3.6584800000000004,
                        "unit": "mg"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 72.24520000000001,
                        "unit": "µg"
                    },
                    "WATER": {
                        "label": "Water",
                        "quantity": 667.55203,
                        "unit": "g"
                    }
                },
                "totalDaily": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 20.34965,
                        "unit": "%"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 3.9112615384615395,
                        "unit": "%"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 1.50074,
                        "unit": "%"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 34.90581666666667,
                        "unit": "%"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 86.53119999999998,
                        "unit": "%"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 14.494879999999998,
                        "unit": "%"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 0,
                        "unit": "%"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 1.9505833333333331,
                        "unit": "%"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 15.2725,
                        "unit": "%"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 24.315238095238097,
                        "unit": "%"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 33.82387234042553,
                        "unit": "%"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 19.98011111111111,
                        "unit": "%"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 8.820818181818181,
                        "unit": "%"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 26.97714285714286,
                        "unit": "%"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 31.384000000000004,
                        "unit": "%"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 410.5271111111112,
                        "unit": "%"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 23.04233333333334,
                        "unit": "%"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 22.601153846153846,
                        "unit": "%"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 26.132975000000002,
                        "unit": "%"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 46.17476923076922,
                        "unit": "%"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 40.521,
                        "unit": "%"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 0,
                        "unit": "%"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 0,
                        "unit": "%"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 24.389866666666666,
                        "unit": "%"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 60.204333333333345,
                        "unit": "%"
                    }
                },
                "digest": [
                    {
                        "label": "Fat",
                        "tag": "FAT",
                        "schemaOrgTag": "fatContent",
                        "total": 2.5423200000000006,
                        "hasRDI": true,
                        "daily": 3.9112615384615395,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Saturated",
                                "tag": "FASAT",
                                "schemaOrgTag": "saturatedFatContent",
                                "total": 0.300148,
                                "hasRDI": true,
                                "daily": 1.50074,
                                "unit": "g"
                            },
                            {
                                "label": "Trans",
                                "tag": "FATRN",
                                "schemaOrgTag": "transFatContent",
                                "total": 0,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Monounsaturated",
                                "tag": "FAMS",
                                "schemaOrgTag": null,
                                "total": 0.353984,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Polyunsaturated",
                                "tag": "FAPU",
                                "schemaOrgTag": null,
                                "total": 1.1314959999999998,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Carbs",
                        "tag": "CHOCDF",
                        "schemaOrgTag": "carbohydrateContent",
                        "total": 104.71744999999999,
                        "hasRDI": true,
                        "daily": 34.90581666666667,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Carbs (net)",
                                "tag": "CHOCDF.net",
                                "schemaOrgTag": null,
                                "total": 83.08464999999998,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Fiber",
                                "tag": "FIBTG",
                                "schemaOrgTag": "fiberContent",
                                "total": 21.6328,
                                "hasRDI": true,
                                "daily": 86.53119999999998,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars",
                                "tag": "SUGAR",
                                "schemaOrgTag": "sugarContent",
                                "total": 67.50821,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars, added",
                                "tag": "SUGAR.added",
                                "schemaOrgTag": null,
                                "total": 2.44525,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Protein",
                        "tag": "PROCNT",
                        "schemaOrgTag": "proteinContent",
                        "total": 7.247439999999999,
                        "hasRDI": true,
                        "daily": 14.494879999999998,
                        "unit": "g"
                    },
                    {
                        "label": "Cholesterol",
                        "tag": "CHOLE",
                        "schemaOrgTag": "cholesterolContent",
                        "total": 0,
                        "hasRDI": true,
                        "daily": 0,
                        "unit": "mg"
                    },
                    {
                        "label": "Sodium",
                        "tag": "NA",
                        "schemaOrgTag": "sodiumContent",
                        "total": 46.81399999999999,
                        "hasRDI": true,
                        "daily": 1.9505833333333331,
                        "unit": "mg"
                    },
                    {
                        "label": "Calcium",
                        "tag": "CA",
                        "schemaOrgTag": null,
                        "total": 152.725,
                        "hasRDI": true,
                        "daily": 15.2725,
                        "unit": "mg"
                    },
                    {
                        "label": "Magnesium",
                        "tag": "MG",
                        "schemaOrgTag": null,
                        "total": 102.12400000000001,
                        "hasRDI": true,
                        "daily": 24.315238095238097,
                        "unit": "mg"
                    },
                    {
                        "label": "Potassium",
                        "tag": "K",
                        "schemaOrgTag": null,
                        "total": 1589.7220000000002,
                        "hasRDI": true,
                        "daily": 33.82387234042553,
                        "unit": "mg"
                    },
                    {
                        "label": "Iron",
                        "tag": "FE",
                        "schemaOrgTag": null,
                        "total": 3.59642,
                        "hasRDI": true,
                        "daily": 19.98011111111111,
                        "unit": "mg"
                    },
                    {
                        "label": "Zinc",
                        "tag": "ZN",
                        "schemaOrgTag": null,
                        "total": 0.97029,
                        "hasRDI": true,
                        "daily": 8.820818181818181,
                        "unit": "mg"
                    },
                    {
                        "label": "Phosphorus",
                        "tag": "P",
                        "schemaOrgTag": null,
                        "total": 188.84,
                        "hasRDI": true,
                        "daily": 26.97714285714286,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin A",
                        "tag": "VITA_RAE",
                        "schemaOrgTag": null,
                        "total": 282.456,
                        "hasRDI": true,
                        "daily": 31.384000000000004,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin C",
                        "tag": "VITC",
                        "schemaOrgTag": null,
                        "total": 369.4744000000001,
                        "hasRDI": true,
                        "daily": 410.5271111111112,
                        "unit": "mg"
                    },
                    {
                        "label": "Thiamin (B1)",
                        "tag": "THIA",
                        "schemaOrgTag": null,
                        "total": 0.27650800000000003,
                        "hasRDI": true,
                        "daily": 23.04233333333334,
                        "unit": "mg"
                    },
                    {
                        "label": "Riboflavin (B2)",
                        "tag": "RIBF",
                        "schemaOrgTag": null,
                        "total": 0.293815,
                        "hasRDI": true,
                        "daily": 22.601153846153846,
                        "unit": "mg"
                    },
                    {
                        "label": "Niacin (B3)",
                        "tag": "NIA",
                        "schemaOrgTag": null,
                        "total": 4.181276,
                        "hasRDI": true,
                        "daily": 26.132975000000002,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin B6",
                        "tag": "VITB6A",
                        "schemaOrgTag": null,
                        "total": 0.6002719999999999,
                        "hasRDI": true,
                        "daily": 46.17476923076922,
                        "unit": "mg"
                    },
                    {
                        "label": "Folate equivalent (total)",
                        "tag": "FOLDFE",
                        "schemaOrgTag": null,
                        "total": 162.084,
                        "hasRDI": true,
                        "daily": 40.521,
                        "unit": "µg"
                    },
                    {
                        "label": "Folate (food)",
                        "tag": "FOLFD",
                        "schemaOrgTag": null,
                        "total": 162.084,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Folic acid",
                        "tag": "FOLAC",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin B12",
                        "tag": "VITB12",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": true,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin D",
                        "tag": "VITD",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": true,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin E",
                        "tag": "TOCPHA",
                        "schemaOrgTag": null,
                        "total": 3.6584800000000004,
                        "hasRDI": true,
                        "daily": 24.389866666666666,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin K",
                        "tag": "VITK1",
                        "schemaOrgTag": null,
                        "total": 72.24520000000001,
                        "hasRDI": true,
                        "daily": 60.204333333333345,
                        "unit": "µg"
                    },
                    {
                        "label": "Sugar alcohols",
                        "tag": "Sugar.alcohol",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    },
                    {
                        "label": "Water",
                        "tag": "WATER",
                        "schemaOrgTag": null,
                        "total": 667.55203,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    }
                ]
            },
            "_links": {
                "self": {
                    "href": "https://api.edamam.com/api/recipes/v2/07fbab15f4532a58bf587f91d69189fd?type=public&app_id=ea1d37d5&app_key=fd382a172ba8d6668c0430dc9c14a181",
                    "title": "Self"
                }
            }
        }
    ]
};

export const saladRecipes = {
    "from": 1,
    "to": 20,
    "count": 10000,
    "_links": {
        "next": {
            "href": "https://api.edamam.com/api/recipes/v2?q=salad&app_key=fd382a172ba8d6668c0430dc9c14a181&_cont=CHcVQBtNNQphDmgVQntAEX4BYlNtBAoBRGREC2oaZld1BwUPUXlSBWVCagNzAVZWEm1CVTFFYgAlDAIFRWURUmcaZQN2AQIVLnlSVSBMPkd5BgMbUSYRVTdgMgksRlpSAAcRXTVGcV84SU4%3D&type=public&app_id=ea1d37d5",
            "title": "Next page"
        }
    },
    "hits": [
        {
            "recipe": {
                "uri": "http://www.edamam.com/ontologies/edamam.owl#recipe_b20815eac65ee2fa5f848f56c16056dd",
                "label": "Zuni-Inspired Grilled Chicken Salad",
                "image": "https://www.edamam.com/web-img/3ac/3accba1eeb5ac38d902d056050c05ead.jpg",
                "source": "Food52",
                "url": "https://food52.com/recipes/82361-zuni-inspired-grilled-chicken-salad-recipe",
                "shareAs": "http://www.edamam.com/recipe/zuni-inspired-grilled-chicken-salad-b20815eac65ee2fa5f848f56c16056dd/salad",
                "yield": 4,
                "dietLabels": [
                    "Low-Carb"
                ],
                "healthLabels": [
                    "Sugar-Conscious",
                    "Keto-Friendly",
                    "Paleo",
                    "Dairy-Free",
                    "Gluten-Free",
                    "Wheat-Free",
                    "Peanut-Free",
                    "Tree-Nut-Free",
                    "Soy-Free",
                    "Fish-Free",
                    "Shellfish-Free",
                    "Pork-Free",
                    "Red-Meat-Free",
                    "Crustacean-Free",
                    "Celery-Free",
                    "Sesame-Free",
                    "Lupine-Free",
                    "Mollusk-Free",
                    "Alcohol-Free",
                    "Sulfite-Free",
                    "Kosher"
                ],
                "cautions": [
                    "Sulfites"
                ],
                "ingredientLines": [
                    "1 pound boneless, skinless chicken breasts",
                    "3/4 teaspoon kosher salt, divided, plus more for salad",
                    "1 tablespoon olive oil, plus more for salad",
                    "1/4 cup aioli or 1/4 cup mayo + 1 small garlic clove, grated",
                    "Zest and juice of 1 lemon, plus more for salad",
                    "Your favorite greens and fresh herbs, for salad"
                ],
                "ingredients": [
                    {
                        "text": "1 pound boneless, skinless chicken breasts",
                        "weight": 453.59237,
                        "foodCategory": "Poultry",
                        "foodId": "food_bdrxu94aj3x2djbpur8dhagfhkcn",
                        "image": "https://www.edamam.com/food-img/da5/da510379d3650787338ca16fb69f4c94.jpg"
                    },
                    {
                        "text": "3/4 teaspoon kosher salt, divided, plus more for salad",
                        "weight": 3.6406250001846567,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_a1vgrj1bs8rd1majvmd9ubz8ttkg",
                        "image": "https://www.edamam.com/food-img/694/6943ea510918c6025795e8dc6e6eaaeb.jpg"
                    },
                    {
                        "text": "1 tablespoon olive oil, plus more for salad",
                        "weight": 13.5,
                        "foodCategory": "Oils",
                        "foodId": "food_b1d1icuad3iktrbqby0hiagafaz7",
                        "image": "https://www.edamam.com/food-img/4d6/4d651eaa8a353647746290c7a9b29d84.jpg"
                    },
                    {
                        "text": "1/4 cup aioli or 1/4 cup mayo + 1 small garlic clove, grated",
                        "weight": 57.75,
                        "foodCategory": "condiments and sauces",
                        "foodId": "food_bu8t61zaplle7dbrzk81dbygq0qj",
                        "image": "https://www.edamam.com/food-img/577/577308a0422357885c94cc9b5f1f1862.jpg"
                    },
                    {
                        "text": "Zest and juice of 1 lemon, plus more for salad",
                        "weight": 58,
                        "foodCategory": "fruit",
                        "foodId": "food_a6uzc62astrxcgbtzyq59b6fncrr",
                        "image": "https://www.edamam.com/food-img/70a/70acba3d4c734d7c70ef4efeed85dc8f.jpg"
                    },
                    {
                        "text": "Your favorite greens and fresh herbs, for salad",
                        "weight": 5.864829950001847,
                        "foodCategory": "vegetables",
                        "foodId": "food_b244pqdazw24zobr5vqu2bf0uid8",
                        "image": "https://www.edamam.com/food-img/46a/46a132e96626d7989b4d6ed8c91f4da0.jpg"
                    }
                ],
                "calories": 1082.2121827820008,
                "totalWeight": 590.8408973752244,
                "totalTime": 20,
                "cuisineType": [
                    "mediterranean"
                ],
                "mealType": [
                    "lunch/dinner"
                ],
                "dishType": [
                    "salad",
                    "main course"
                ],
                "totalNutrients": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 1082.2121827820008,
                        "unit": "kcal"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 70.07195225060502,
                        "unit": "g"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 11.089416618634003,
                        "unit": "g"
                    },
                    "FATRN": {
                        "label": "Trans",
                        "quantity": 0.031751465900000005,
                        "unit": "g"
                    },
                    "FAMS": {
                        "label": "Monounsaturated",
                        "quantity": 24.14441767765251,
                        "unit": "g"
                    },
                    "FAPU": {
                        "label": "Polyunsaturated",
                        "quantity": 30.083229037938004,
                        "unit": "g"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 5.776843735835117,
                        "unit": "g"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 1.8175393883500608,
                        "unit": "g"
                    },
                    "SUGAR": {
                        "label": "Sugars",
                        "quantity": 1.4998510545750157,
                        "unit": "g"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 102.87046869951507,
                        "unit": "g"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 353.6449301,
                        "unit": "mg"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 1369.0268193397305,
                        "unit": "mg"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 46.50017121305595,
                        "unit": "mg"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 134.59961554925314,
                        "unit": "mg"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 1627.835369517028,
                        "unit": "mg"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 2.472552427403349,
                        "unit": "mg"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 3.184115493890243,
                        "unit": "mg"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 978.8333494710012,
                        "unit": "mg"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 57.02239998950778,
                        "unit": "µg"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 38.54022383350245,
                        "unit": "mg"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 0.4546205815570017,
                        "unit": "mg"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 0.8202060282510018,
                        "unit": "mg"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 43.67987273724353,
                        "unit": "mg"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 3.730312467655003,
                        "unit": "mg"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 56.11785482400281,
                        "unit": "µg"
                    },
                    "FOLFD": {
                        "label": "Folate (food)",
                        "quantity": 56.11785482400281,
                        "unit": "µg"
                    },
                    "FOLAC": {
                        "label": "Folic acid",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 0.952543977,
                        "unit": "µg"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 4.608353496625014,
                        "unit": "mg"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 105.2173959200303,
                        "unit": "µg"
                    },
                    "WATER": {
                        "label": "Water",
                        "quantity": 391.96147117399715,
                        "unit": "g"
                    }
                },
                "totalDaily": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 54.110609139100035,
                        "unit": "%"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 107.80300346246928,
                        "unit": "%"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 55.44708309317001,
                        "unit": "%"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 1.9256145786117058,
                        "unit": "%"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 7.270157553400242,
                        "unit": "%"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 205.74093739903014,
                        "unit": "%"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 117.88164336666667,
                        "unit": "%"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 57.04278413915544,
                        "unit": "%"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 4.650017121305595,
                        "unit": "%"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 32.04752751172694,
                        "unit": "%"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 34.634795096106984,
                        "unit": "%"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 13.736402374463049,
                        "unit": "%"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 28.946504489911305,
                        "unit": "%"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 139.83333563871446,
                        "unit": "%"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 6.335822221056421,
                        "unit": "%"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 42.82247092611384,
                        "unit": "%"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 37.88504846308348,
                        "unit": "%"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 63.09277140392321,
                        "unit": "%"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 272.99920460777207,
                        "unit": "%"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 286.94711289653867,
                        "unit": "%"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 14.029463706000705,
                        "unit": "%"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 39.689332375,
                        "unit": "%"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 0,
                        "unit": "%"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 30.722356644166762,
                        "unit": "%"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 87.68116326669193,
                        "unit": "%"
                    }
                },
                "digest": [
                    {
                        "label": "Fat",
                        "tag": "FAT",
                        "schemaOrgTag": "fatContent",
                        "total": 70.07195225060502,
                        "hasRDI": true,
                        "daily": 107.80300346246928,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Saturated",
                                "tag": "FASAT",
                                "schemaOrgTag": "saturatedFatContent",
                                "total": 11.089416618634003,
                                "hasRDI": true,
                                "daily": 55.44708309317001,
                                "unit": "g"
                            },
                            {
                                "label": "Trans",
                                "tag": "FATRN",
                                "schemaOrgTag": "transFatContent",
                                "total": 0.031751465900000005,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Monounsaturated",
                                "tag": "FAMS",
                                "schemaOrgTag": null,
                                "total": 24.14441767765251,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Polyunsaturated",
                                "tag": "FAPU",
                                "schemaOrgTag": null,
                                "total": 30.083229037938004,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Carbs",
                        "tag": "CHOCDF",
                        "schemaOrgTag": "carbohydrateContent",
                        "total": 5.776843735835117,
                        "hasRDI": true,
                        "daily": 1.9256145786117058,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Carbs (net)",
                                "tag": "CHOCDF.net",
                                "schemaOrgTag": null,
                                "total": 3.959304347485056,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Fiber",
                                "tag": "FIBTG",
                                "schemaOrgTag": "fiberContent",
                                "total": 1.8175393883500608,
                                "hasRDI": true,
                                "daily": 7.270157553400242,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars",
                                "tag": "SUGAR",
                                "schemaOrgTag": "sugarContent",
                                "total": 1.4998510545750157,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars, added",
                                "tag": "SUGAR.added",
                                "schemaOrgTag": null,
                                "total": 0,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Protein",
                        "tag": "PROCNT",
                        "schemaOrgTag": "proteinContent",
                        "total": 102.87046869951507,
                        "hasRDI": true,
                        "daily": 205.74093739903014,
                        "unit": "g"
                    },
                    {
                        "label": "Cholesterol",
                        "tag": "CHOLE",
                        "schemaOrgTag": "cholesterolContent",
                        "total": 353.6449301,
                        "hasRDI": true,
                        "daily": 117.88164336666667,
                        "unit": "mg"
                    },
                    {
                        "label": "Sodium",
                        "tag": "NA",
                        "schemaOrgTag": "sodiumContent",
                        "total": 1369.0268193397305,
                        "hasRDI": true,
                        "daily": 57.04278413915544,
                        "unit": "mg"
                    },
                    {
                        "label": "Calcium",
                        "tag": "CA",
                        "schemaOrgTag": null,
                        "total": 46.50017121305595,
                        "hasRDI": true,
                        "daily": 4.650017121305595,
                        "unit": "mg"
                    },
                    {
                        "label": "Magnesium",
                        "tag": "MG",
                        "schemaOrgTag": null,
                        "total": 134.59961554925314,
                        "hasRDI": true,
                        "daily": 32.04752751172694,
                        "unit": "mg"
                    },
                    {
                        "label": "Potassium",
                        "tag": "K",
                        "schemaOrgTag": null,
                        "total": 1627.835369517028,
                        "hasRDI": true,
                        "daily": 34.634795096106984,
                        "unit": "mg"
                    },
                    {
                        "label": "Iron",
                        "tag": "FE",
                        "schemaOrgTag": null,
                        "total": 2.472552427403349,
                        "hasRDI": true,
                        "daily": 13.736402374463049,
                        "unit": "mg"
                    },
                    {
                        "label": "Zinc",
                        "tag": "ZN",
                        "schemaOrgTag": null,
                        "total": 3.184115493890243,
                        "hasRDI": true,
                        "daily": 28.946504489911305,
                        "unit": "mg"
                    },
                    {
                        "label": "Phosphorus",
                        "tag": "P",
                        "schemaOrgTag": null,
                        "total": 978.8333494710012,
                        "hasRDI": true,
                        "daily": 139.83333563871446,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin A",
                        "tag": "VITA_RAE",
                        "schemaOrgTag": null,
                        "total": 57.02239998950778,
                        "hasRDI": true,
                        "daily": 6.335822221056421,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin C",
                        "tag": "VITC",
                        "schemaOrgTag": null,
                        "total": 38.54022383350245,
                        "hasRDI": true,
                        "daily": 42.82247092611384,
                        "unit": "mg"
                    },
                    {
                        "label": "Thiamin (B1)",
                        "tag": "THIA",
                        "schemaOrgTag": null,
                        "total": 0.4546205815570017,
                        "hasRDI": true,
                        "daily": 37.88504846308348,
                        "unit": "mg"
                    },
                    {
                        "label": "Riboflavin (B2)",
                        "tag": "RIBF",
                        "schemaOrgTag": null,
                        "total": 0.8202060282510018,
                        "hasRDI": true,
                        "daily": 63.09277140392321,
                        "unit": "mg"
                    },
                    {
                        "label": "Niacin (B3)",
                        "tag": "NIA",
                        "schemaOrgTag": null,
                        "total": 43.67987273724353,
                        "hasRDI": true,
                        "daily": 272.99920460777207,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin B6",
                        "tag": "VITB6A",
                        "schemaOrgTag": null,
                        "total": 3.730312467655003,
                        "hasRDI": true,
                        "daily": 286.94711289653867,
                        "unit": "mg"
                    },
                    {
                        "label": "Folate equivalent (total)",
                        "tag": "FOLDFE",
                        "schemaOrgTag": null,
                        "total": 56.11785482400281,
                        "hasRDI": true,
                        "daily": 14.029463706000705,
                        "unit": "µg"
                    },
                    {
                        "label": "Folate (food)",
                        "tag": "FOLFD",
                        "schemaOrgTag": null,
                        "total": 56.11785482400281,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Folic acid",
                        "tag": "FOLAC",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin B12",
                        "tag": "VITB12",
                        "schemaOrgTag": null,
                        "total": 0.952543977,
                        "hasRDI": true,
                        "daily": 39.689332375,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin D",
                        "tag": "VITD",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": true,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin E",
                        "tag": "TOCPHA",
                        "schemaOrgTag": null,
                        "total": 4.608353496625014,
                        "hasRDI": true,
                        "daily": 30.722356644166762,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin K",
                        "tag": "VITK1",
                        "schemaOrgTag": null,
                        "total": 105.2173959200303,
                        "hasRDI": true,
                        "daily": 87.68116326669193,
                        "unit": "µg"
                    },
                    {
                        "label": "Sugar alcohols",
                        "tag": "Sugar.alcohol",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    },
                    {
                        "label": "Water",
                        "tag": "WATER",
                        "schemaOrgTag": null,
                        "total": 391.96147117399715,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    }
                ]
            },
            "_links": {
                "self": {
                    "href": "https://api.edamam.com/api/recipes/v2/b20815eac65ee2fa5f848f56c16056dd?type=public&app_id=ea1d37d5&app_key=fd382a172ba8d6668c0430dc9c14a181",
                    "title": "Self"
                }
            }
        },
        {
            "recipe": {
                "uri": "http://www.edamam.com/ontologies/edamam.owl#recipe_dd4a76ee9f4ce2efd21e40e3d620f8c4",
                "label": "Steak & Chips Salad",
                "image": "https://www.edamam.com/web-img/72e/72ebeef4f13b029165ce5fc4a675130e.jpg",
                "source": "BBC Good Food",
                "url": "http://www.bbcgoodfood.com/recipes/3076/",
                "shareAs": "http://www.edamam.com/recipe/steak-chips-salad-dd4a76ee9f4ce2efd21e40e3d620f8c4/salad",
                "yield": 4,
                "dietLabels": [
                    "High-Fiber"
                ],
                "healthLabels": [
                    "Dairy-Free",
                    "Gluten-Free",
                    "Wheat-Free",
                    "Egg-Free",
                    "Peanut-Free",
                    "Tree-Nut-Free",
                    "Soy-Free",
                    "Fish-Free",
                    "Shellfish-Free",
                    "Pork-Free",
                    "Crustacean-Free",
                    "Celery-Free",
                    "Sesame-Free",
                    "Lupine-Free",
                    "Mollusk-Free",
                    "Alcohol-Free"
                ],
                "cautions": [],
                "ingredientLines": [
                    "750.0g bag frozen potato wedges",
                    "1.0 tbsp olive oil",
                    "2 pieces sirloin steak , about 350g/12oz in total",
                    "120.0g bag herb salad",
                    "6.0 tbsp honey and mustard salad dessing , bought or homemade"
                ],
                "ingredients": [
                    {
                        "text": "750.0g bag frozen potato wedges",
                        "weight": 750,
                        "foodCategory": "vegetables",
                        "foodId": "food_abiw5baauresjmb6xpap2bg3otzu",
                        "image": "https://www.edamam.com/food-img/651/6512e82417bce15c2899630c1a2799df.jpg"
                    },
                    {
                        "text": "1.0 tbsp olive oil",
                        "weight": 13.5,
                        "foodCategory": "Oils",
                        "foodId": "food_b1d1icuad3iktrbqby0hiagafaz7",
                        "image": "https://www.edamam.com/food-img/4d6/4d651eaa8a353647746290c7a9b29d84.jpg"
                    },
                    {
                        "text": "2 pieces sirloin steak , about 350g/12oz in total",
                        "weight": 680,
                        "foodCategory": "meats",
                        "foodId": "food_aifm62daw1i6txalya881bcetyzn",
                        "image": "https://www.edamam.com/food-img/4f1/4f10105d5c8178f25590ca6dfcd37fca.jpg"
                    },
                    {
                        "text": "120.0g bag herb salad",
                        "weight": 120,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_avsq22zadwyb5cb5sl1byaa4mbo8",
                        "image": "https://www.edamam.com/food-img/89b/89b37a04e46e052671d73addcb84aa51.jpg"
                    },
                    {
                        "text": "6.0 tbsp honey and mustard salad dessing , bought or homemade",
                        "weight": 126,
                        "foodCategory": null,
                        "foodId": "food_bn6aoj9atkqx8fbkli859bbbxx62",
                        "image": "https://www.edamam.com/food-img/198/198c7b25c23b4235b4cc33818c7b335f.jpg"
                    },
                    {
                        "text": "6.0 tbsp honey and mustard salad dessing , bought or homemade",
                        "weight": 93.3749999984214,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_a34cdj5b0kyuhfbov30xcb50u4dv",
                        "image": "https://www.edamam.com/food-img/e23/e238f2e4cfa6aa1a30f46dc73e7344eb.jpg"
                    }
                ],
                "calories": 2922.3049999990526,
                "totalWeight": 1782.8749999984213,
                "totalTime": 0,
                "cuisineType": [
                    "american"
                ],
                "mealType": [
                    "lunch/dinner"
                ],
                "dishType": [
                    "salad"
                ],
                "totalNutrients": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 2922.3049999990526,
                        "unit": "kcal"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 123.31372499994727,
                        "unit": "g"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 44.72330249999663,
                        "unit": "g"
                    },
                    "FATRN": {
                        "label": "Trans",
                        "quantity": 0.008403749999857926,
                        "unit": "g"
                    },
                    "FAMS": {
                        "label": "Monounsaturated",
                        "quantity": 54.04817749996556,
                        "unit": "g"
                    },
                    "FAPU": {
                        "label": "Polyunsaturated",
                        "quantity": 7.586227499987782,
                        "unit": "g"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 317.02076249990796,
                        "unit": "g"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 64.88699999993686,
                        "unit": "g"
                    },
                    "SUGAR": {
                        "label": "Sugars",
                        "quantity": 112.23224999998548,
                        "unit": "g"
                    },
                    "SUGAR.added": {
                        "label": "Sugars, added",
                        "quantity": 103.47120000000001,
                        "unit": "g"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 165.40822499994096,
                        "unit": "g"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 530.4,
                        "unit": "mg"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 1493.9699999825725,
                        "unit": "mg"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 2594.5212499990057,
                        "unit": "mg"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 619.8399999992423,
                        "unit": "mg"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 6443.084999997601,
                        "unit": "mg"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 166.20613749997457,
                        "unit": "mg"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 34.741799999989894,
                        "unit": "mg"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 2005.3849999982951,
                        "unit": "mg"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 232.66874999992106,
                        "unit": "µg"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 208.66012499999525,
                        "unit": "mg"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 1.741273749997206,
                        "unit": "mg"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 1.4032424999988948,
                        "unit": "mg"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 58.20302874999108,
                        "unit": "mg"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 6.612902499998896,
                        "unit": "mg"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 532.6562499998895,
                        "unit": "µg"
                    },
                    "FOLFD": {
                        "label": "Folate (food)",
                        "quantity": 532.6562499998895,
                        "unit": "µg"
                    },
                    "FOLAC": {
                        "label": "Folic acid",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 7.548,
                        "unit": "µg"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 13.840399999994318,
                        "unit": "mg"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 2091.284249999978,
                        "unit": "µg"
                    },
                    "WATER": {
                        "label": "Water",
                        "quantity": 1145.2335499986787,
                        "unit": "g"
                    }
                },
                "totalDaily": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 146.11524999995262,
                        "unit": "%"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 189.71342307684193,
                        "unit": "%"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 223.61651249998312,
                        "unit": "%"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 105.67358749996932,
                        "unit": "%"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 259.54799999974745,
                        "unit": "%"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 330.81644999988185,
                        "unit": "%"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 176.8,
                        "unit": "%"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 62.24874999927386,
                        "unit": "%"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 259.4521249999006,
                        "unit": "%"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 147.58095238077198,
                        "unit": "%"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 137.08691489356596,
                        "unit": "%"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 923.3674305554143,
                        "unit": "%"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 315.8345454544536,
                        "unit": "%"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 286.4835714283279,
                        "unit": "%"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 25.85208333332456,
                        "unit": "%"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 231.84458333332805,
                        "unit": "%"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 145.1061458331005,
                        "unit": "%"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 107.94173076914575,
                        "unit": "%"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 363.76892968744426,
                        "unit": "%"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 508.6848076922227,
                        "unit": "%"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 133.16406249997237,
                        "unit": "%"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 314.5,
                        "unit": "%"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 0,
                        "unit": "%"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 92.26933333329545,
                        "unit": "%"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 1742.7368749999814,
                        "unit": "%"
                    }
                },
                "digest": [
                    {
                        "label": "Fat",
                        "tag": "FAT",
                        "schemaOrgTag": "fatContent",
                        "total": 123.31372499994727,
                        "hasRDI": true,
                        "daily": 189.71342307684193,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Saturated",
                                "tag": "FASAT",
                                "schemaOrgTag": "saturatedFatContent",
                                "total": 44.72330249999663,
                                "hasRDI": true,
                                "daily": 223.61651249998312,
                                "unit": "g"
                            },
                            {
                                "label": "Trans",
                                "tag": "FATRN",
                                "schemaOrgTag": "transFatContent",
                                "total": 0.008403749999857926,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Monounsaturated",
                                "tag": "FAMS",
                                "schemaOrgTag": null,
                                "total": 54.04817749996556,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Polyunsaturated",
                                "tag": "FAPU",
                                "schemaOrgTag": null,
                                "total": 7.586227499987782,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Carbs",
                        "tag": "CHOCDF",
                        "schemaOrgTag": "carbohydrateContent",
                        "total": 317.02076249990796,
                        "hasRDI": true,
                        "daily": 105.67358749996932,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Carbs (net)",
                                "tag": "CHOCDF.net",
                                "schemaOrgTag": null,
                                "total": 252.1337624999711,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Fiber",
                                "tag": "FIBTG",
                                "schemaOrgTag": "fiberContent",
                                "total": 64.88699999993686,
                                "hasRDI": true,
                                "daily": 259.54799999974745,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars",
                                "tag": "SUGAR",
                                "schemaOrgTag": "sugarContent",
                                "total": 112.23224999998548,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars, added",
                                "tag": "SUGAR.added",
                                "schemaOrgTag": null,
                                "total": 103.47120000000001,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Protein",
                        "tag": "PROCNT",
                        "schemaOrgTag": "proteinContent",
                        "total": 165.40822499994096,
                        "hasRDI": true,
                        "daily": 330.81644999988185,
                        "unit": "g"
                    },
                    {
                        "label": "Cholesterol",
                        "tag": "CHOLE",
                        "schemaOrgTag": "cholesterolContent",
                        "total": 530.4,
                        "hasRDI": true,
                        "daily": 176.8,
                        "unit": "mg"
                    },
                    {
                        "label": "Sodium",
                        "tag": "NA",
                        "schemaOrgTag": "sodiumContent",
                        "total": 1493.9699999825725,
                        "hasRDI": true,
                        "daily": 62.24874999927386,
                        "unit": "mg"
                    },
                    {
                        "label": "Calcium",
                        "tag": "CA",
                        "schemaOrgTag": null,
                        "total": 2594.5212499990057,
                        "hasRDI": true,
                        "daily": 259.4521249999006,
                        "unit": "mg"
                    },
                    {
                        "label": "Magnesium",
                        "tag": "MG",
                        "schemaOrgTag": null,
                        "total": 619.8399999992423,
                        "hasRDI": true,
                        "daily": 147.58095238077198,
                        "unit": "mg"
                    },
                    {
                        "label": "Potassium",
                        "tag": "K",
                        "schemaOrgTag": null,
                        "total": 6443.084999997601,
                        "hasRDI": true,
                        "daily": 137.08691489356596,
                        "unit": "mg"
                    },
                    {
                        "label": "Iron",
                        "tag": "FE",
                        "schemaOrgTag": null,
                        "total": 166.20613749997457,
                        "hasRDI": true,
                        "daily": 923.3674305554143,
                        "unit": "mg"
                    },
                    {
                        "label": "Zinc",
                        "tag": "ZN",
                        "schemaOrgTag": null,
                        "total": 34.741799999989894,
                        "hasRDI": true,
                        "daily": 315.8345454544536,
                        "unit": "mg"
                    },
                    {
                        "label": "Phosphorus",
                        "tag": "P",
                        "schemaOrgTag": null,
                        "total": 2005.3849999982951,
                        "hasRDI": true,
                        "daily": 286.4835714283279,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin A",
                        "tag": "VITA_RAE",
                        "schemaOrgTag": null,
                        "total": 232.66874999992106,
                        "hasRDI": true,
                        "daily": 25.85208333332456,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin C",
                        "tag": "VITC",
                        "schemaOrgTag": null,
                        "total": 208.66012499999525,
                        "hasRDI": true,
                        "daily": 231.84458333332805,
                        "unit": "mg"
                    },
                    {
                        "label": "Thiamin (B1)",
                        "tag": "THIA",
                        "schemaOrgTag": null,
                        "total": 1.741273749997206,
                        "hasRDI": true,
                        "daily": 145.1061458331005,
                        "unit": "mg"
                    },
                    {
                        "label": "Riboflavin (B2)",
                        "tag": "RIBF",
                        "schemaOrgTag": null,
                        "total": 1.4032424999988948,
                        "hasRDI": true,
                        "daily": 107.94173076914575,
                        "unit": "mg"
                    },
                    {
                        "label": "Niacin (B3)",
                        "tag": "NIA",
                        "schemaOrgTag": null,
                        "total": 58.20302874999108,
                        "hasRDI": true,
                        "daily": 363.76892968744426,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin B6",
                        "tag": "VITB6A",
                        "schemaOrgTag": null,
                        "total": 6.612902499998896,
                        "hasRDI": true,
                        "daily": 508.6848076922227,
                        "unit": "mg"
                    },
                    {
                        "label": "Folate equivalent (total)",
                        "tag": "FOLDFE",
                        "schemaOrgTag": null,
                        "total": 532.6562499998895,
                        "hasRDI": true,
                        "daily": 133.16406249997237,
                        "unit": "µg"
                    },
                    {
                        "label": "Folate (food)",
                        "tag": "FOLFD",
                        "schemaOrgTag": null,
                        "total": 532.6562499998895,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Folic acid",
                        "tag": "FOLAC",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin B12",
                        "tag": "VITB12",
                        "schemaOrgTag": null,
                        "total": 7.548,
                        "hasRDI": true,
                        "daily": 314.5,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin D",
                        "tag": "VITD",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": true,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin E",
                        "tag": "TOCPHA",
                        "schemaOrgTag": null,
                        "total": 13.840399999994318,
                        "hasRDI": true,
                        "daily": 92.26933333329545,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin K",
                        "tag": "VITK1",
                        "schemaOrgTag": null,
                        "total": 2091.284249999978,
                        "hasRDI": true,
                        "daily": 1742.7368749999814,
                        "unit": "µg"
                    },
                    {
                        "label": "Sugar alcohols",
                        "tag": "Sugar.alcohol",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    },
                    {
                        "label": "Water",
                        "tag": "WATER",
                        "schemaOrgTag": null,
                        "total": 1145.2335499986787,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    }
                ]
            },
            "_links": {
                "self": {
                    "href": "https://api.edamam.com/api/recipes/v2/dd4a76ee9f4ce2efd21e40e3d620f8c4?type=public&app_id=ea1d37d5&app_key=fd382a172ba8d6668c0430dc9c14a181",
                    "title": "Self"
                }
            }
        },
        {
            "recipe": {
                "uri": "http://www.edamam.com/ontologies/edamam.owl#recipe_f38bcef5962fcb27cb84a75fdf997942",
                "label": "Shrimp Salad",
                "image": "https://www.edamam.com/web-img/a35/a35a9ea5a5b0e712d8193b5ca61201d5.jpg",
                "source": "Cookstr",
                "url": "http://www.cookstr.com/recipes/shrimp-salad-mimi-sheraton",
                "shareAs": "http://www.edamam.com/recipe/shrimp-salad-f38bcef5962fcb27cb84a75fdf997942/salad",
                "yield": 6,
                "dietLabels": [
                    "Low-Carb"
                ],
                "healthLabels": [
                    "Sugar-Conscious",
                    "Low Potassium",
                    "Keto-Friendly",
                    "Pescatarian",
                    "Dairy-Free",
                    "Gluten-Free",
                    "Wheat-Free",
                    "Peanut-Free",
                    "Tree-Nut-Free",
                    "Soy-Free",
                    "Fish-Free",
                    "Pork-Free",
                    "Red-Meat-Free",
                    "Celery-Free",
                    "Sesame-Free",
                    "Lupine-Free",
                    "Mollusk-Free",
                    "Alcohol-Free"
                ],
                "cautions": [
                    "Sulfites"
                ],
                "ingredientLines": [
                    "1 pound medium-sized shrimp, cooked, shelled and de-veined",
                    "1 tablespoon minced onion",
                    "1 tablespoon minced parsley",
                    "Salt and pepper to taste",
                    "1 tablespoon lemon juice",
                    "½ cup mayonnaise",
                    "1½ tablespoons salad oil"
                ],
                "ingredients": [
                    {
                        "text": "1 pound medium-sized shrimp, cooked, shelled and de-veined",
                        "weight": 453.59237,
                        "foodCategory": "seafood",
                        "foodId": "food_b38bejhbq9loe2bbb7bnmbcpteft",
                        "image": "https://www.edamam.com/food-img/ebe/ebe2888b894f48d19762e1d606db0206.jpg"
                    },
                    {
                        "text": "1 tablespoon minced onion",
                        "weight": 10,
                        "foodCategory": "vegetables",
                        "foodId": "food_bmrvi4ob4binw9a5m7l07amlfcoy",
                        "image": "https://www.edamam.com/food-img/205/205e6bf2399b85d34741892ef91cc603.jpg"
                    },
                    {
                        "text": "1 tablespoon minced parsley",
                        "weight": 3.8,
                        "foodCategory": "vegetables",
                        "foodId": "food_b244pqdazw24zobr5vqu2bf0uid8",
                        "image": "https://www.edamam.com/food-img/46a/46a132e96626d7989b4d6ed8c91f4da0.jpg"
                    },
                    {
                        "text": "Salt and pepper to taste",
                        "weight": 3.714854219998453,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_btxz81db72hwbra2pncvebzzzum9",
                        "image": "https://www.edamam.com/food-img/694/6943ea510918c6025795e8dc6e6eaaeb.jpg"
                    },
                    {
                        "text": "Salt and pepper to taste",
                        "weight": 1.8574271099992266,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_b6ywzluaaxv02wad7s1r9ag4py89",
                        "image": "https://www.edamam.com/food-img/c6e/c6e5c3bd8d3bc15175d9766971a4d1b2.jpg"
                    },
                    {
                        "text": "1 tablespoon lemon juice",
                        "weight": 15.2499999997422,
                        "foodCategory": "100% juice",
                        "foodId": "food_bglm6vxahuauteb0n6ynfbg9eryu",
                        "image": "https://www.edamam.com/food-img/e31/e310952d214e78a4cb8b73f30ceeaaf2.jpg"
                    },
                    {
                        "text": "½ cup mayonnaise",
                        "weight": 115.5,
                        "foodCategory": "condiments and sauces",
                        "foodId": "food_bu8t61zaplle7dbrzk81dbygq0qj",
                        "image": "https://www.edamam.com/food-img/577/577308a0422357885c94cc9b5f1f1862.jpg"
                    },
                    {
                        "text": "1½ tablespoons salad oil",
                        "weight": 21,
                        "foodCategory": "Oils",
                        "foodId": "food_bk9p9aaavhvoq4bqsnprobpsiuxs",
                        "image": "https://www.edamam.com/food-img/07e/07e106ab3536d57428e5c46d009038f8.jpg"
                    }
                ],
                "calories": 1320.3357247460413,
                "totalWeight": 620.9997971097414,
                "totalTime": 60,
                "cuisineType": [
                    "american"
                ],
                "mealType": [
                    "lunch/dinner"
                ],
                "dishType": [
                    "salad"
                ],
                "totalNutrients": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 1320.3357247460413,
                        "unit": "kcal"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 114.65345506078536,
                        "unit": "g"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 16.054197471071088,
                        "unit": "g"
                    },
                    "FATRN": {
                        "label": "Trans",
                        "quantity": 0.16459662660000002,
                        "unit": "g"
                    },
                    "FAMS": {
                        "label": "Monounsaturated",
                        "quantity": 36.42761357604288,
                        "unit": "g"
                    },
                    "FAPU": {
                        "label": "Polyunsaturated",
                        "quantity": 60.63706911405774,
                        "unit": "g"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 7.542305203826718,
                        "unit": "g"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 0.8110790588290309,
                        "unit": "g"
                    },
                    "SUGAR": {
                        "label": "Sugars",
                        "quantity": 0.8524875334974986,
                        "unit": "g"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 62.20314323372802,
                        "unit": "g"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 616.5713862,
                        "unit": "mg"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 3236.819799621998,
                        "unit": "mg"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 261.6272818972812,
                        "unit": "mg"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 106.78152175808323,
                        "unit": "mg"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 588.6040843916244,
                        "unit": "mg"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 1.4017001493807186,
                        "unit": "mg"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 4.487234371608863,
                        "unit": "mg"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 1116.0241176337784,
                        "unit": "mg"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 261.4393851196998,
                        "unit": "µg"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 11.695749999900233,
                        "unit": "mg"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 0.1042524952787373,
                        "unit": "mg"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 0.08009372429795995,
                        "unit": "mg"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 8.161474230467057,
                        "unit": "mg"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 0.7581238285899792,
                        "unit": "mg"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 97.22431290864833,
                        "unit": "µg"
                    },
                    "FOLFD": {
                        "label": "Folate (food)",
                        "quantity": 97.22431290864833,
                        "unit": "µg"
                    },
                    "FOLAC": {
                        "label": "Folic acid",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 5.034875307000001,
                        "unit": "µg"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 0.4535923700000001,
                        "unit": "µg"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 9.726711525943607,
                        "unit": "mg"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 81.73438528906873,
                        "unit": "µg"
                    },
                    "WATER": {
                        "label": "Water",
                        "quantity": 403.079716754668,
                        "unit": "g"
                    }
                },
                "totalDaily": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 66.01678623730206,
                        "unit": "%"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 176.38993086274672,
                        "unit": "%"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 80.27098735535544,
                        "unit": "%"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 2.514101734608906,
                        "unit": "%"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 3.2443162353161235,
                        "unit": "%"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 124.40628646745604,
                        "unit": "%"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 205.52379539999998,
                        "unit": "%"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 134.86749165091658,
                        "unit": "%"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 26.16272818972812,
                        "unit": "%"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 25.424171847162675,
                        "unit": "%"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 12.523491157268603,
                        "unit": "%"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 7.787223052115103,
                        "unit": "%"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 40.79303974189875,
                        "unit": "%"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 159.43201680482548,
                        "unit": "%"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 29.048820568855533,
                        "unit": "%"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 12.995277777666926,
                        "unit": "%"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 8.687707939894775,
                        "unit": "%"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 6.161055715227689,
                        "unit": "%"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 51.00921394041911,
                        "unit": "%"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 58.31721758384455,
                        "unit": "%"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 24.306078227162082,
                        "unit": "%"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 209.78647112500005,
                        "unit": "%"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 3.0239491333333337,
                        "unit": "%"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 64.84474350629071,
                        "unit": "%"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 68.1119877408906,
                        "unit": "%"
                    }
                },
                "digest": [
                    {
                        "label": "Fat",
                        "tag": "FAT",
                        "schemaOrgTag": "fatContent",
                        "total": 114.65345506078536,
                        "hasRDI": true,
                        "daily": 176.38993086274672,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Saturated",
                                "tag": "FASAT",
                                "schemaOrgTag": "saturatedFatContent",
                                "total": 16.054197471071088,
                                "hasRDI": true,
                                "daily": 80.27098735535544,
                                "unit": "g"
                            },
                            {
                                "label": "Trans",
                                "tag": "FATRN",
                                "schemaOrgTag": "transFatContent",
                                "total": 0.16459662660000002,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Monounsaturated",
                                "tag": "FAMS",
                                "schemaOrgTag": null,
                                "total": 36.42761357604288,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Polyunsaturated",
                                "tag": "FAPU",
                                "schemaOrgTag": null,
                                "total": 60.63706911405774,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Carbs",
                        "tag": "CHOCDF",
                        "schemaOrgTag": "carbohydrateContent",
                        "total": 7.542305203826718,
                        "hasRDI": true,
                        "daily": 2.514101734608906,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Carbs (net)",
                                "tag": "CHOCDF.net",
                                "schemaOrgTag": null,
                                "total": 6.731226144997687,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Fiber",
                                "tag": "FIBTG",
                                "schemaOrgTag": "fiberContent",
                                "total": 0.8110790588290309,
                                "hasRDI": true,
                                "daily": 3.2443162353161235,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars",
                                "tag": "SUGAR",
                                "schemaOrgTag": "sugarContent",
                                "total": 0.8524875334974986,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars, added",
                                "tag": "SUGAR.added",
                                "schemaOrgTag": null,
                                "total": 0,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Protein",
                        "tag": "PROCNT",
                        "schemaOrgTag": "proteinContent",
                        "total": 62.20314323372802,
                        "hasRDI": true,
                        "daily": 124.40628646745604,
                        "unit": "g"
                    },
                    {
                        "label": "Cholesterol",
                        "tag": "CHOLE",
                        "schemaOrgTag": "cholesterolContent",
                        "total": 616.5713862,
                        "hasRDI": true,
                        "daily": 205.52379539999998,
                        "unit": "mg"
                    },
                    {
                        "label": "Sodium",
                        "tag": "NA",
                        "schemaOrgTag": "sodiumContent",
                        "total": 3236.819799621998,
                        "hasRDI": true,
                        "daily": 134.86749165091658,
                        "unit": "mg"
                    },
                    {
                        "label": "Calcium",
                        "tag": "CA",
                        "schemaOrgTag": null,
                        "total": 261.6272818972812,
                        "hasRDI": true,
                        "daily": 26.16272818972812,
                        "unit": "mg"
                    },
                    {
                        "label": "Magnesium",
                        "tag": "MG",
                        "schemaOrgTag": null,
                        "total": 106.78152175808323,
                        "hasRDI": true,
                        "daily": 25.424171847162675,
                        "unit": "mg"
                    },
                    {
                        "label": "Potassium",
                        "tag": "K",
                        "schemaOrgTag": null,
                        "total": 588.6040843916244,
                        "hasRDI": true,
                        "daily": 12.523491157268603,
                        "unit": "mg"
                    },
                    {
                        "label": "Iron",
                        "tag": "FE",
                        "schemaOrgTag": null,
                        "total": 1.4017001493807186,
                        "hasRDI": true,
                        "daily": 7.787223052115103,
                        "unit": "mg"
                    },
                    {
                        "label": "Zinc",
                        "tag": "ZN",
                        "schemaOrgTag": null,
                        "total": 4.487234371608863,
                        "hasRDI": true,
                        "daily": 40.79303974189875,
                        "unit": "mg"
                    },
                    {
                        "label": "Phosphorus",
                        "tag": "P",
                        "schemaOrgTag": null,
                        "total": 1116.0241176337784,
                        "hasRDI": true,
                        "daily": 159.43201680482548,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin A",
                        "tag": "VITA_RAE",
                        "schemaOrgTag": null,
                        "total": 261.4393851196998,
                        "hasRDI": true,
                        "daily": 29.048820568855533,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin C",
                        "tag": "VITC",
                        "schemaOrgTag": null,
                        "total": 11.695749999900233,
                        "hasRDI": true,
                        "daily": 12.995277777666926,
                        "unit": "mg"
                    },
                    {
                        "label": "Thiamin (B1)",
                        "tag": "THIA",
                        "schemaOrgTag": null,
                        "total": 0.1042524952787373,
                        "hasRDI": true,
                        "daily": 8.687707939894775,
                        "unit": "mg"
                    },
                    {
                        "label": "Riboflavin (B2)",
                        "tag": "RIBF",
                        "schemaOrgTag": null,
                        "total": 0.08009372429795995,
                        "hasRDI": true,
                        "daily": 6.161055715227689,
                        "unit": "mg"
                    },
                    {
                        "label": "Niacin (B3)",
                        "tag": "NIA",
                        "schemaOrgTag": null,
                        "total": 8.161474230467057,
                        "hasRDI": true,
                        "daily": 51.00921394041911,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin B6",
                        "tag": "VITB6A",
                        "schemaOrgTag": null,
                        "total": 0.7581238285899792,
                        "hasRDI": true,
                        "daily": 58.31721758384455,
                        "unit": "mg"
                    },
                    {
                        "label": "Folate equivalent (total)",
                        "tag": "FOLDFE",
                        "schemaOrgTag": null,
                        "total": 97.22431290864833,
                        "hasRDI": true,
                        "daily": 24.306078227162082,
                        "unit": "µg"
                    },
                    {
                        "label": "Folate (food)",
                        "tag": "FOLFD",
                        "schemaOrgTag": null,
                        "total": 97.22431290864833,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Folic acid",
                        "tag": "FOLAC",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin B12",
                        "tag": "VITB12",
                        "schemaOrgTag": null,
                        "total": 5.034875307000001,
                        "hasRDI": true,
                        "daily": 209.78647112500005,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin D",
                        "tag": "VITD",
                        "schemaOrgTag": null,
                        "total": 0.4535923700000001,
                        "hasRDI": true,
                        "daily": 3.0239491333333337,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin E",
                        "tag": "TOCPHA",
                        "schemaOrgTag": null,
                        "total": 9.726711525943607,
                        "hasRDI": true,
                        "daily": 64.84474350629071,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin K",
                        "tag": "VITK1",
                        "schemaOrgTag": null,
                        "total": 81.73438528906873,
                        "hasRDI": true,
                        "daily": 68.1119877408906,
                        "unit": "µg"
                    },
                    {
                        "label": "Sugar alcohols",
                        "tag": "Sugar.alcohol",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    },
                    {
                        "label": "Water",
                        "tag": "WATER",
                        "schemaOrgTag": null,
                        "total": 403.079716754668,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    }
                ]
            },
            "_links": {
                "self": {
                    "href": "https://api.edamam.com/api/recipes/v2/f38bcef5962fcb27cb84a75fdf997942?type=public&app_id=ea1d37d5&app_key=fd382a172ba8d6668c0430dc9c14a181",
                    "title": "Self"
                }
            }
        },
        {
            "recipe": {
                "uri": "http://www.edamam.com/ontologies/edamam.owl#recipe_ce6b0299ece2cd64868f7b1db5f98829",
                "label": "Strawberry Hazelnut Salad",
                "image": "https://www.edamam.com/web-img/832/832af8392d347d88705dedc503410ad7.jpg",
                "source": "Use Real Butter",
                "url": "http://userealbutter.com/2009/05/08/strawberry-hazelnut-salad-recipe/",
                "shareAs": "http://www.edamam.com/recipe/strawberry-hazelnut-salad-ce6b0299ece2cd64868f7b1db5f98829/salad",
                "yield": 6,
                "dietLabels": [
                    "Low-Carb",
                    "Low-Sodium"
                ],
                "healthLabels": [
                    "Vegan",
                    "Vegetarian",
                    "Pescatarian",
                    "Dairy-Free",
                    "Gluten-Free",
                    "Wheat-Free",
                    "Egg-Free",
                    "Peanut-Free",
                    "Soy-Free",
                    "Fish-Free",
                    "Shellfish-Free",
                    "Pork-Free",
                    "Red-Meat-Free",
                    "Crustacean-Free",
                    "Celery-Free",
                    "Mustard-Free",
                    "Sesame-Free",
                    "Lupine-Free",
                    "Mollusk-Free",
                    "Alcohol-Free",
                    "Kosher"
                ],
                "cautions": [
                    "Sulfites"
                ],
                "ingredientLines": [
                    "8 oz salad greens",
                    "8 oz strawberries",
                    "2 oz Hazelnuts",
                    "3 oz Balsamic Vinegar",
                    "1 tsp Sugar",
                    "4 oz Extra Virgin Olive Oil",
                    "4 x salt and pepper"
                ],
                "ingredients": [
                    {
                        "text": "8 oz salad greens",
                        "weight": 226.796185,
                        "foodCategory": "vegetables",
                        "foodId": "food_bqalyxzbzu04hcb8xj930bzar7xg",
                        "image": "https://www.edamam.com/food-img/b6d/b6d9f3052d27a3c71220cfa55c6f0a42.jpg"
                    },
                    {
                        "text": "8 oz strawberries",
                        "weight": 226.796185,
                        "foodCategory": "fruit",
                        "foodId": "food_b4s2ibkbrrucmbabbaxhfau8ay42",
                        "image": "https://www.edamam.com/food-img/00c/00c8851e401bf7975be7f73499b4b573.jpg"
                    },
                    {
                        "text": "2 oz Hazelnuts",
                        "weight": 56.69904625,
                        "foodCategory": "plant-based protein",
                        "foodId": "food_ahshk5kaw2j86lbtd1akiaxbiwc2",
                        "image": "https://www.edamam.com/food-img/136/13615074edcc12bf37a30987ebfec6dc.jpg"
                    },
                    {
                        "text": "3 oz Balsamic Vinegar",
                        "weight": 85.048569375,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_b1ic8tzapja8jubas1f8lbhpbn6x",
                        "image": "https://www.edamam.com/food-img/90a/90a1f211768e166ecfff19e8b4747498.jpg"
                    },
                    {
                        "text": "1 tsp Sugar",
                        "weight": 4.2,
                        "foodCategory": "sugars",
                        "foodId": "food_axi2ijobrk819yb0adceobnhm1c2",
                        "image": "https://www.edamam.com/food-img/ecb/ecb3f5aaed96d0188c21b8369be07765.jpg"
                    },
                    {
                        "text": "4 oz Extra Virgin Olive Oil",
                        "weight": 113.3980925,
                        "foodCategory": "Oils",
                        "foodId": "food_b1d1icuad3iktrbqby0hiagafaz7",
                        "image": "https://www.edamam.com/food-img/4d6/4d651eaa8a353647746290c7a9b29d84.jpg"
                    },
                    {
                        "text": "4 x salt and pepper",
                        "weight": 465.15555555555557,
                        "foodCategory": "vegetables",
                        "foodId": "food_bz8rcwobbzm7zhb3wh2n7aznivou",
                        "image": "https://www.edamam.com/food-img/629/629dc9fddc1f8aec27fa337dd6ce2b7c.jpg"
                    }
                ],
                "calories": 1649.2312072611114,
                "totalWeight": 1178.0936336805557,
                "totalTime": 0,
                "cuisineType": [
                    "mediterranean"
                ],
                "mealType": [
                    "lunch/dinner"
                ],
                "dishType": [
                    "salad"
                ],
                "totalNutrients": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 1649.2312072611114,
                        "unit": "kcal"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 149.65411037381946,
                        "unit": "g"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 18.538222923972224,
                        "unit": "g"
                    },
                    "FATRN": {
                        "label": "Trans",
                        "quantity": 0,
                        "unit": "g"
                    },
                    "FAMS": {
                        "label": "Monounsaturated",
                        "quantity": 108.76897343806947,
                        "unit": "g"
                    },
                    "FAPU": {
                        "label": "Polyunsaturated",
                        "quantity": 17.249349139669444,
                        "unit": "g"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 73.66188738359028,
                        "unit": "g"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 20.891726035694443,
                        "unit": "g"
                    },
                    "SUGAR": {
                        "label": "Sugars",
                        "quantity": 43.39017675164583,
                        "unit": "g"
                    },
                    "SUGAR.added": {
                        "label": "Sugars, added",
                        "quantity": 4.1916,
                        "unit": "g"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 17.49754573759028,
                        "unit": "g"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 0,
                        "unit": "mg"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 101.59669312291669,
                        "unit": "mg"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 253.22557913680555,
                        "unit": "mg"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 208.10783736805556,
                        "unit": "mg"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 2083.0308772972226,
                        "unit": "mg"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 8.37617462963889,
                        "unit": "mg"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 2.7880355028472232,
                        "unit": "mg"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 393.8195514673611,
                        "unit": "mg"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 925.7088368125001,
                        "unit": "µg"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 531.7785123804167,
                        "unit": "mg"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 0.8429019479541668,
                        "unit": "mg"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 0.4264435865180556,
                        "unit": "mg"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 4.979248467016667,
                        "unit": "mg"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 1.6718748482819445,
                        "unit": "mg"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 251.1991125180556,
                        "unit": "µg"
                    },
                    "FOLFD": {
                        "label": "Folate (food)",
                        "quantity": 251.1991125180556,
                        "unit": "µg"
                    },
                    "FOLAC": {
                        "label": "Folic acid",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 27.67222902418056,
                        "unit": "mg"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 402.17152508861113,
                        "unit": "µg"
                    },
                    "WATER": {
                        "label": "Water",
                        "quantity": 926.4478885246737,
                        "unit": "g"
                    }
                },
                "totalDaily": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 82.46156036305557,
                        "unit": "%"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 230.23709288279917,
                        "unit": "%"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 92.69111461986111,
                        "unit": "%"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 24.55396246119676,
                        "unit": "%"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 83.56690414277777,
                        "unit": "%"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 34.99509147518056,
                        "unit": "%"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 0,
                        "unit": "%"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 4.233195546788195,
                        "unit": "%"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 25.322557913680555,
                        "unit": "%"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 49.54948508763228,
                        "unit": "%"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 44.31980589994091,
                        "unit": "%"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 46.534303497993825,
                        "unit": "%"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 25.34577729861112,
                        "unit": "%"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 56.25993592390873,
                        "unit": "%"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 102.85653742361112,
                        "unit": "%"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 590.8650137560186,
                        "unit": "%"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 70.24182899618057,
                        "unit": "%"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 32.8033528090812,
                        "unit": "%"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 31.120302918854172,
                        "unit": "%"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 128.60575756014956,
                        "unit": "%"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 62.7997781295139,
                        "unit": "%"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 0,
                        "unit": "%"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 0,
                        "unit": "%"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 184.4815268278704,
                        "unit": "%"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 335.14293757384263,
                        "unit": "%"
                    }
                },
                "digest": [
                    {
                        "label": "Fat",
                        "tag": "FAT",
                        "schemaOrgTag": "fatContent",
                        "total": 149.65411037381946,
                        "hasRDI": true,
                        "daily": 230.23709288279917,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Saturated",
                                "tag": "FASAT",
                                "schemaOrgTag": "saturatedFatContent",
                                "total": 18.538222923972224,
                                "hasRDI": true,
                                "daily": 92.69111461986111,
                                "unit": "g"
                            },
                            {
                                "label": "Trans",
                                "tag": "FATRN",
                                "schemaOrgTag": "transFatContent",
                                "total": 0,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Monounsaturated",
                                "tag": "FAMS",
                                "schemaOrgTag": null,
                                "total": 108.76897343806947,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Polyunsaturated",
                                "tag": "FAPU",
                                "schemaOrgTag": null,
                                "total": 17.249349139669444,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Carbs",
                        "tag": "CHOCDF",
                        "schemaOrgTag": "carbohydrateContent",
                        "total": 73.66188738359028,
                        "hasRDI": true,
                        "daily": 24.55396246119676,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Carbs (net)",
                                "tag": "CHOCDF.net",
                                "schemaOrgTag": null,
                                "total": 52.77016134789584,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Fiber",
                                "tag": "FIBTG",
                                "schemaOrgTag": "fiberContent",
                                "total": 20.891726035694443,
                                "hasRDI": true,
                                "daily": 83.56690414277777,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars",
                                "tag": "SUGAR",
                                "schemaOrgTag": "sugarContent",
                                "total": 43.39017675164583,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars, added",
                                "tag": "SUGAR.added",
                                "schemaOrgTag": null,
                                "total": 4.1916,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Protein",
                        "tag": "PROCNT",
                        "schemaOrgTag": "proteinContent",
                        "total": 17.49754573759028,
                        "hasRDI": true,
                        "daily": 34.99509147518056,
                        "unit": "g"
                    },
                    {
                        "label": "Cholesterol",
                        "tag": "CHOLE",
                        "schemaOrgTag": "cholesterolContent",
                        "total": 0,
                        "hasRDI": true,
                        "daily": 0,
                        "unit": "mg"
                    },
                    {
                        "label": "Sodium",
                        "tag": "NA",
                        "schemaOrgTag": "sodiumContent",
                        "total": 101.59669312291669,
                        "hasRDI": true,
                        "daily": 4.233195546788195,
                        "unit": "mg"
                    },
                    {
                        "label": "Calcium",
                        "tag": "CA",
                        "schemaOrgTag": null,
                        "total": 253.22557913680555,
                        "hasRDI": true,
                        "daily": 25.322557913680555,
                        "unit": "mg"
                    },
                    {
                        "label": "Magnesium",
                        "tag": "MG",
                        "schemaOrgTag": null,
                        "total": 208.10783736805556,
                        "hasRDI": true,
                        "daily": 49.54948508763228,
                        "unit": "mg"
                    },
                    {
                        "label": "Potassium",
                        "tag": "K",
                        "schemaOrgTag": null,
                        "total": 2083.0308772972226,
                        "hasRDI": true,
                        "daily": 44.31980589994091,
                        "unit": "mg"
                    },
                    {
                        "label": "Iron",
                        "tag": "FE",
                        "schemaOrgTag": null,
                        "total": 8.37617462963889,
                        "hasRDI": true,
                        "daily": 46.534303497993825,
                        "unit": "mg"
                    },
                    {
                        "label": "Zinc",
                        "tag": "ZN",
                        "schemaOrgTag": null,
                        "total": 2.7880355028472232,
                        "hasRDI": true,
                        "daily": 25.34577729861112,
                        "unit": "mg"
                    },
                    {
                        "label": "Phosphorus",
                        "tag": "P",
                        "schemaOrgTag": null,
                        "total": 393.8195514673611,
                        "hasRDI": true,
                        "daily": 56.25993592390873,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin A",
                        "tag": "VITA_RAE",
                        "schemaOrgTag": null,
                        "total": 925.7088368125001,
                        "hasRDI": true,
                        "daily": 102.85653742361112,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin C",
                        "tag": "VITC",
                        "schemaOrgTag": null,
                        "total": 531.7785123804167,
                        "hasRDI": true,
                        "daily": 590.8650137560186,
                        "unit": "mg"
                    },
                    {
                        "label": "Thiamin (B1)",
                        "tag": "THIA",
                        "schemaOrgTag": null,
                        "total": 0.8429019479541668,
                        "hasRDI": true,
                        "daily": 70.24182899618057,
                        "unit": "mg"
                    },
                    {
                        "label": "Riboflavin (B2)",
                        "tag": "RIBF",
                        "schemaOrgTag": null,
                        "total": 0.4264435865180556,
                        "hasRDI": true,
                        "daily": 32.8033528090812,
                        "unit": "mg"
                    },
                    {
                        "label": "Niacin (B3)",
                        "tag": "NIA",
                        "schemaOrgTag": null,
                        "total": 4.979248467016667,
                        "hasRDI": true,
                        "daily": 31.120302918854172,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin B6",
                        "tag": "VITB6A",
                        "schemaOrgTag": null,
                        "total": 1.6718748482819445,
                        "hasRDI": true,
                        "daily": 128.60575756014956,
                        "unit": "mg"
                    },
                    {
                        "label": "Folate equivalent (total)",
                        "tag": "FOLDFE",
                        "schemaOrgTag": null,
                        "total": 251.1991125180556,
                        "hasRDI": true,
                        "daily": 62.7997781295139,
                        "unit": "µg"
                    },
                    {
                        "label": "Folate (food)",
                        "tag": "FOLFD",
                        "schemaOrgTag": null,
                        "total": 251.1991125180556,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Folic acid",
                        "tag": "FOLAC",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin B12",
                        "tag": "VITB12",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": true,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin D",
                        "tag": "VITD",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": true,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin E",
                        "tag": "TOCPHA",
                        "schemaOrgTag": null,
                        "total": 27.67222902418056,
                        "hasRDI": true,
                        "daily": 184.4815268278704,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin K",
                        "tag": "VITK1",
                        "schemaOrgTag": null,
                        "total": 402.17152508861113,
                        "hasRDI": true,
                        "daily": 335.14293757384263,
                        "unit": "µg"
                    },
                    {
                        "label": "Sugar alcohols",
                        "tag": "Sugar.alcohol",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    },
                    {
                        "label": "Water",
                        "tag": "WATER",
                        "schemaOrgTag": null,
                        "total": 926.4478885246737,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    }
                ]
            },
            "_links": {
                "self": {
                    "href": "https://api.edamam.com/api/recipes/v2/ce6b0299ece2cd64868f7b1db5f98829?type=public&app_id=ea1d37d5&app_key=fd382a172ba8d6668c0430dc9c14a181",
                    "title": "Self"
                }
            }
        },
        {
            "recipe": {
                "uri": "http://www.edamam.com/ontologies/edamam.owl#recipe_0657d391510851af8144901267a4c26a",
                "label": "Grilled Tofu Salad With Miso Dressing",
                "image": "https://www.edamam.com/web-img/272/2724347f1843a7c437faacf837326676.jpg",
                "source": "Steamy Kitchen",
                "url": "http://steamykitchen.com/20074-grilled-tofu-with-miso-dressing-recip.html",
                "shareAs": "http://www.edamam.com/recipe/grilled-tofu-salad-with-miso-dressing-0657d391510851af8144901267a4c26a/salad",
                "yield": 4,
                "dietLabels": [
                    "Low-Carb"
                ],
                "healthLabels": [
                    "Sugar-Conscious",
                    "Keto-Friendly",
                    "Vegan",
                    "Vegetarian",
                    "Pescatarian",
                    "Dairy-Free",
                    "Egg-Free",
                    "Peanut-Free",
                    "Tree-Nut-Free",
                    "Fish-Free",
                    "Shellfish-Free",
                    "Pork-Free",
                    "Red-Meat-Free",
                    "Crustacean-Free",
                    "Celery-Free",
                    "Mustard-Free",
                    "Lupine-Free",
                    "Mollusk-Free",
                    "Alcohol-Free",
                    "Kosher"
                ],
                "cautions": [
                    "Gluten",
                    "Wheat",
                    "Sulfites"
                ],
                "ingredientLines": [
                    "14 ounces extra firm tofu",
                    "2 teaspoons cooking oil",
                    "2 tablespoons Miso & Easy (3 teaspoons miso paste + 3 teaspoons hot water), divided",
                    "1 teaspoon soy sauce",
                    "1/2 teaspoon grated fresh ginger",
                    "1 tablespoon water",
                    "1/2 teaspoon sesame oil",
                    "1/2 teaspoon sugar",
                    "1 tablespoon oil for salad (olive, canola, vegetable, grapeseed)",
                    "4 handfuls of salad greens + any other salad vegetables of your choice"
                ],
                "ingredients": [
                    {
                        "text": "14 ounces extra firm tofu",
                        "weight": 396.89332375000004,
                        "foodCategory": "plant-based protein",
                        "foodId": "food_bu9fz3paqr6xcebft7onna22v8ve",
                        "image": "https://www.edamam.com/food-img/c44/c44799e4beb77540acad305ac9f9ef7e.jpg"
                    },
                    {
                        "text": "2 teaspoons cooking oil",
                        "weight": 9,
                        "foodCategory": "Oils",
                        "foodId": "food_bk9p9aaavhvoq4bqsnprobpsiuxs",
                        "image": "https://www.edamam.com/food-img/07e/07e106ab3536d57428e5c46d009038f8.jpg"
                    },
                    {
                        "text": "2 tablespoons Miso & Easy (3 teaspoons miso paste + 3 teaspoons hot water), divided",
                        "weight": 34,
                        "foodCategory": "plant-based protein",
                        "foodId": "food_agp37bpbhswz7sa7hlwj7b8vzcbt",
                        "image": "https://www.edamam.com/food-img/352/3525e5a38bb13c74aa34ef6c0273bf33.jpg"
                    },
                    {
                        "text": "1 teaspoon soy sauce",
                        "weight": 5.3,
                        "foodCategory": "plant-based protein",
                        "foodId": "food_a5g9yevb1iactoaiimbvjbkrxueh",
                        "image": "https://www.edamam.com/food-img/f56/f562e461eb0618f367f538b836c17b82.jpg"
                    },
                    {
                        "text": "1/2 teaspoon grated fresh ginger",
                        "weight": 1,
                        "foodCategory": "vegetables",
                        "foodId": "food_bi2ki2xb5zmmvbaiwf7ztbgktzp6",
                        "image": "https://www.edamam.com/food-img/b9c/b9c06ef451ef29513880af0a53ebbaa6.jpg"
                    },
                    {
                        "text": "1 tablespoon water",
                        "weight": 14.786764781,
                        "foodCategory": "water",
                        "foodId": "food_a99vzubbk1ayrsad318rvbzr3dh0",
                        "image": "https://www.edamam.com/food-img/5dd/5dd9d1361847b2ca53c4b19a8f92627e.jpg"
                    },
                    {
                        "text": "1/2 teaspoon sesame oil",
                        "weight": 2.25,
                        "foodCategory": "Oils",
                        "foodId": "food_b2id9opa0l5afvbw2do5xa1fnz4q",
                        "image": "https://www.edamam.com/food-img/b87/b874ddcfb6770adc7a155355a902ffb8.jpg"
                    },
                    {
                        "text": "1/2 teaspoon sugar",
                        "weight": 2.1,
                        "foodCategory": "sugars",
                        "foodId": "food_axi2ijobrk819yb0adceobnhm1c2",
                        "image": "https://www.edamam.com/food-img/ecb/ecb3f5aaed96d0188c21b8369be07765.jpg"
                    },
                    {
                        "text": "1 tablespoon oil for salad (olive, canola, vegetable, grapeseed)",
                        "weight": 14,
                        "foodCategory": "Oils",
                        "foodId": "food_bk9p9aaavhvoq4bqsnprobpsiuxs",
                        "image": "https://www.edamam.com/food-img/07e/07e106ab3536d57428e5c46d009038f8.jpg"
                    },
                    {
                        "text": "4 handfuls of salad greens + any other salad vegetables of your choice",
                        "weight": 18,
                        "foodCategory": "vegetables",
                        "foodId": "food_bqalyxzbzu04hcb8xj930bzar7xg",
                        "image": "https://www.edamam.com/food-img/b6d/b6d9f3052d27a3c71220cfa55c6f0a42.jpg"
                    }
                ],
                "calories": 880.8013194374998,
                "totalWeight": 497.33008853100006,
                "totalTime": 0,
                "cuisineType": [
                    "japanese"
                ],
                "mealType": [
                    "lunch/dinner"
                ],
                "dishType": [
                    "salad"
                ],
                "totalNutrients": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 880.8013194374998,
                        "unit": "kcal"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 61.967207831,
                        "unit": "g"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 7.4150338124875,
                        "unit": "g"
                    },
                    "FATRN": {
                        "label": "Trans",
                        "quantity": 0.09085000000000001,
                        "unit": "g"
                    },
                    "FAMS": {
                        "label": "Monounsaturated",
                        "quantity": 23.516490482187507,
                        "unit": "g"
                    },
                    "FAPU": {
                        "label": "Polyunsaturated",
                        "quantity": 28.0616294617375,
                        "unit": "g"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 29.002314924125002,
                        "unit": "g"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 11.260946446250001,
                        "unit": "g"
                    },
                    "SUGAR": {
                        "label": "Sugars",
                        "quantity": 4.3824,
                        "unit": "g"
                    },
                    "SUGAR.added": {
                        "label": "Sugars, added",
                        "quantity": 2.0958,
                        "unit": "g"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 67.29878648775,
                        "unit": "g"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 0,
                        "unit": "mg"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 1619.99653591624,
                        "unit": "mg"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 2739.0150041559305,
                        "unit": "mg"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 253.35799542281,
                        "unit": "mg"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 1074.2041772875002,
                        "unit": "mg"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 11.642662411750003,
                        "unit": "mg"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 7.1852238593531,
                        "unit": "mg"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 822.515315125,
                        "unit": "mg"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 67.96,
                        "unit": "µg"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 2.4997866475,
                        "unit": "mg"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 0.6750104515250002,
                        "unit": "mg"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 0.507935190225,
                        "unit": "mg"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 2.0115915634875003,
                        "unit": "mg"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 0.45844585785,
                        "unit": "mg"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 129.2510638875,
                        "unit": "µg"
                    },
                    "FOLFD": {
                        "label": "Folate (food)",
                        "quantity": 129.2510638875,
                        "unit": "µg"
                    },
                    "FOLAC": {
                        "label": "Folic acid",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 0.027200000000000002,
                        "unit": "µg"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 4.0929,
                        "unit": "mg"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 49.402,
                        "unit": "µg"
                    },
                    "WATER": {
                        "label": "Water",
                        "quantity": 328.2060559908441,
                        "unit": "g"
                    }
                },
                "totalDaily": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 44.040065971874995,
                        "unit": "%"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 95.33416589384616,
                        "unit": "%"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 37.075169062437496,
                        "unit": "%"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 9.667438308041667,
                        "unit": "%"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 45.043785785,
                        "unit": "%"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 134.5975729755,
                        "unit": "%"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 0,
                        "unit": "%"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 67.49985566317666,
                        "unit": "%"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 273.90150041559303,
                        "unit": "%"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 60.323332243526195,
                        "unit": "%"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 22.855408027393622,
                        "unit": "%"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 64.68145784305557,
                        "unit": "%"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 65.32021690321,
                        "unit": "%"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 117.502187875,
                        "unit": "%"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 7.55111111111111,
                        "unit": "%"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 2.7775407194444446,
                        "unit": "%"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 56.25087096041668,
                        "unit": "%"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 39.07193770961538,
                        "unit": "%"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 12.572447271796877,
                        "unit": "%"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 35.26506598846154,
                        "unit": "%"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 32.312765971875,
                        "unit": "%"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 1.1333333333333335,
                        "unit": "%"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 0,
                        "unit": "%"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 27.286,
                        "unit": "%"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 41.16833333333333,
                        "unit": "%"
                    }
                },
                "digest": [
                    {
                        "label": "Fat",
                        "tag": "FAT",
                        "schemaOrgTag": "fatContent",
                        "total": 61.967207831,
                        "hasRDI": true,
                        "daily": 95.33416589384616,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Saturated",
                                "tag": "FASAT",
                                "schemaOrgTag": "saturatedFatContent",
                                "total": 7.4150338124875,
                                "hasRDI": true,
                                "daily": 37.075169062437496,
                                "unit": "g"
                            },
                            {
                                "label": "Trans",
                                "tag": "FATRN",
                                "schemaOrgTag": "transFatContent",
                                "total": 0.09085000000000001,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Monounsaturated",
                                "tag": "FAMS",
                                "schemaOrgTag": null,
                                "total": 23.516490482187507,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Polyunsaturated",
                                "tag": "FAPU",
                                "schemaOrgTag": null,
                                "total": 28.0616294617375,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Carbs",
                        "tag": "CHOCDF",
                        "schemaOrgTag": "carbohydrateContent",
                        "total": 29.002314924125002,
                        "hasRDI": true,
                        "daily": 9.667438308041667,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Carbs (net)",
                                "tag": "CHOCDF.net",
                                "schemaOrgTag": null,
                                "total": 17.741368477875,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Fiber",
                                "tag": "FIBTG",
                                "schemaOrgTag": "fiberContent",
                                "total": 11.260946446250001,
                                "hasRDI": true,
                                "daily": 45.043785785,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars",
                                "tag": "SUGAR",
                                "schemaOrgTag": "sugarContent",
                                "total": 4.3824,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars, added",
                                "tag": "SUGAR.added",
                                "schemaOrgTag": null,
                                "total": 2.0958,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Protein",
                        "tag": "PROCNT",
                        "schemaOrgTag": "proteinContent",
                        "total": 67.29878648775,
                        "hasRDI": true,
                        "daily": 134.5975729755,
                        "unit": "g"
                    },
                    {
                        "label": "Cholesterol",
                        "tag": "CHOLE",
                        "schemaOrgTag": "cholesterolContent",
                        "total": 0,
                        "hasRDI": true,
                        "daily": 0,
                        "unit": "mg"
                    },
                    {
                        "label": "Sodium",
                        "tag": "NA",
                        "schemaOrgTag": "sodiumContent",
                        "total": 1619.99653591624,
                        "hasRDI": true,
                        "daily": 67.49985566317666,
                        "unit": "mg"
                    },
                    {
                        "label": "Calcium",
                        "tag": "CA",
                        "schemaOrgTag": null,
                        "total": 2739.0150041559305,
                        "hasRDI": true,
                        "daily": 273.90150041559303,
                        "unit": "mg"
                    },
                    {
                        "label": "Magnesium",
                        "tag": "MG",
                        "schemaOrgTag": null,
                        "total": 253.35799542281,
                        "hasRDI": true,
                        "daily": 60.323332243526195,
                        "unit": "mg"
                    },
                    {
                        "label": "Potassium",
                        "tag": "K",
                        "schemaOrgTag": null,
                        "total": 1074.2041772875002,
                        "hasRDI": true,
                        "daily": 22.855408027393622,
                        "unit": "mg"
                    },
                    {
                        "label": "Iron",
                        "tag": "FE",
                        "schemaOrgTag": null,
                        "total": 11.642662411750003,
                        "hasRDI": true,
                        "daily": 64.68145784305557,
                        "unit": "mg"
                    },
                    {
                        "label": "Zinc",
                        "tag": "ZN",
                        "schemaOrgTag": null,
                        "total": 7.1852238593531,
                        "hasRDI": true,
                        "daily": 65.32021690321,
                        "unit": "mg"
                    },
                    {
                        "label": "Phosphorus",
                        "tag": "P",
                        "schemaOrgTag": null,
                        "total": 822.515315125,
                        "hasRDI": true,
                        "daily": 117.502187875,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin A",
                        "tag": "VITA_RAE",
                        "schemaOrgTag": null,
                        "total": 67.96,
                        "hasRDI": true,
                        "daily": 7.55111111111111,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin C",
                        "tag": "VITC",
                        "schemaOrgTag": null,
                        "total": 2.4997866475,
                        "hasRDI": true,
                        "daily": 2.7775407194444446,
                        "unit": "mg"
                    },
                    {
                        "label": "Thiamin (B1)",
                        "tag": "THIA",
                        "schemaOrgTag": null,
                        "total": 0.6750104515250002,
                        "hasRDI": true,
                        "daily": 56.25087096041668,
                        "unit": "mg"
                    },
                    {
                        "label": "Riboflavin (B2)",
                        "tag": "RIBF",
                        "schemaOrgTag": null,
                        "total": 0.507935190225,
                        "hasRDI": true,
                        "daily": 39.07193770961538,
                        "unit": "mg"
                    },
                    {
                        "label": "Niacin (B3)",
                        "tag": "NIA",
                        "schemaOrgTag": null,
                        "total": 2.0115915634875003,
                        "hasRDI": true,
                        "daily": 12.572447271796877,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin B6",
                        "tag": "VITB6A",
                        "schemaOrgTag": null,
                        "total": 0.45844585785,
                        "hasRDI": true,
                        "daily": 35.26506598846154,
                        "unit": "mg"
                    },
                    {
                        "label": "Folate equivalent (total)",
                        "tag": "FOLDFE",
                        "schemaOrgTag": null,
                        "total": 129.2510638875,
                        "hasRDI": true,
                        "daily": 32.312765971875,
                        "unit": "µg"
                    },
                    {
                        "label": "Folate (food)",
                        "tag": "FOLFD",
                        "schemaOrgTag": null,
                        "total": 129.2510638875,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Folic acid",
                        "tag": "FOLAC",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin B12",
                        "tag": "VITB12",
                        "schemaOrgTag": null,
                        "total": 0.027200000000000002,
                        "hasRDI": true,
                        "daily": 1.1333333333333335,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin D",
                        "tag": "VITD",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": true,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin E",
                        "tag": "TOCPHA",
                        "schemaOrgTag": null,
                        "total": 4.0929,
                        "hasRDI": true,
                        "daily": 27.286,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin K",
                        "tag": "VITK1",
                        "schemaOrgTag": null,
                        "total": 49.402,
                        "hasRDI": true,
                        "daily": 41.16833333333333,
                        "unit": "µg"
                    },
                    {
                        "label": "Sugar alcohols",
                        "tag": "Sugar.alcohol",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    },
                    {
                        "label": "Water",
                        "tag": "WATER",
                        "schemaOrgTag": null,
                        "total": 328.2060559908441,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    }
                ]
            },
            "_links": {
                "self": {
                    "href": "https://api.edamam.com/api/recipes/v2/0657d391510851af8144901267a4c26a?type=public&app_id=ea1d37d5&app_key=fd382a172ba8d6668c0430dc9c14a181",
                    "title": "Self"
                }
            }
        },
        {
            "recipe": {
                "uri": "http://www.edamam.com/ontologies/edamam.owl#recipe_3abffa587abb91c3ce9956da629448ee",
                "label": "Chicken Salad-Stuffed Tomatoes",
                "image": "https://www.edamam.com/web-img/86c/86c21bdb5ea3e2868b5ce9761a31ebc5.jpg",
                "source": "EatingWell",
                "url": "http://www.eatingwell.com/recipes/chicken_salad_stuffed_tomatoes.html",
                "shareAs": "http://www.edamam.com/recipe/chicken-salad-stuffed-tomatoes-3abffa587abb91c3ce9956da629448ee/salad",
                "yield": 4,
                "dietLabels": [
                    "Low-Sodium"
                ],
                "healthLabels": [
                    "Sugar-Conscious",
                    "Kidney-Friendly",
                    "Keto-Friendly",
                    "Paleo",
                    "Mediterranean",
                    "Dairy-Free",
                    "Gluten-Free",
                    "Wheat-Free",
                    "Egg-Free",
                    "Peanut-Free",
                    "Tree-Nut-Free",
                    "Soy-Free",
                    "Fish-Free",
                    "Shellfish-Free",
                    "Pork-Free",
                    "Red-Meat-Free",
                    "Crustacean-Free",
                    "Celery-Free",
                    "Mustard-Free",
                    "Sesame-Free",
                    "Lupine-Free",
                    "Mollusk-Free",
                    "Alcohol-Free",
                    "No oil added",
                    "Sulfite-Free",
                    "FODMAP-Free",
                    "Kosher",
                    "Immuno-Supportive"
                ],
                "cautions": [],
                "ingredientLines": [
                    "4 plum tomatoes, halved",
                    "2 teaspoons sliced fresh chives",
                    "Freshly ground pepper, to taste",
                    "1/4 cup chicken salad"
                ],
                "ingredients": [
                    {
                        "text": "4 plum tomatoes, halved",
                        "weight": 248,
                        "foodCategory": "vegetables",
                        "foodId": "food_ab8jymba5i5xv3apgymg7a90bxb5",
                        "image": "https://www.edamam.com/food-img/23e/23e727a14f1035bdc2733bb0477efbd2.jpg"
                    },
                    {
                        "text": "2 teaspoons sliced fresh chives",
                        "weight": 2,
                        "foodCategory": "vegetables",
                        "foodId": "food_btg1uzjak79lawbirsitkaeai60l",
                        "image": "https://www.edamam.com/food-img/f3f/f3f48643a924ba174b894e979cb48620.jpg"
                    },
                    {
                        "text": "Freshly ground pepper, to taste",
                        "weight": 0.855,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_b6ywzluaaxv02wad7s1r9ag4py89",
                        "image": "https://www.edamam.com/food-img/c6e/c6e5c3bd8d3bc15175d9766971a4d1b2.jpg"
                    },
                    {
                        "text": "1/4 cup chicken salad",
                        "weight": 35,
                        "foodCategory": "Poultry",
                        "foodId": "food_bmyxrshbfao9s1amjrvhoauob6mo",
                        "image": "https://www.edamam.com/food-img/d33/d338229d774a743f7858f6764e095878.jpg"
                    }
                ],
                "calories": 122.63605000000001,
                "totalWeight": 285.855,
                "totalTime": 0,
                "cuisineType": [
                    "mediterranean"
                ],
                "mealType": [
                    "lunch/dinner"
                ],
                "dishType": [
                    "salad"
                ],
                "totalNutrients": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 122.63605000000001,
                        "unit": "kcal"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 5.8094730000000006,
                        "unit": "g"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 1.5927616,
                        "unit": "g"
                    },
                    "FATRN": {
                        "label": "Trans",
                        "quantity": 0.03395,
                        "unit": "g"
                    },
                    "FAMS": {
                        "label": "Monounsaturated",
                        "quantity": 2.26909845,
                        "unit": "g"
                    },
                    "FAPU": {
                        "label": "Polyunsaturated",
                        "quantity": 1.3502129,
                        "unit": "g"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 10.280972499999999,
                        "unit": "g"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 3.2423149999999996,
                        "unit": "g"
                    },
                    "SUGAR": {
                        "label": "Sugars",
                        "quantity": 6.564871999999999,
                        "unit": "g"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 8.8466345,
                        "unit": "g"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 26.250000000000004,
                        "unit": "mg"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 37.131,
                        "unit": "mg"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 34.27765,
                        "unit": "mg"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 36.58205,
                        "unit": "mg"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 671.1929499999999,
                        "unit": "mg"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 1.0996205000000003,
                        "unit": "mg"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 0.9014745000000001,
                        "unit": "mg"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 113.48089999999999,
                        "unit": "mg"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 123.10085000000001,
                        "unit": "µg"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 35.698,
                        "unit": "mg"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 0.11524340000000001,
                        "unit": "mg"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 0.09295899999999999,
                        "unit": "mg"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 3.8761826500000005,
                        "unit": "mg"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 0.32614805,
                        "unit": "mg"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 41.545350000000006,
                        "unit": "µg"
                    },
                    "FOLFD": {
                        "label": "Folate (food)",
                        "quantity": 41.545350000000006,
                        "unit": "µg"
                    },
                    "FOLAC": {
                        "label": "Folic acid",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 0.10850000000000001,
                        "unit": "µg"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 0.07,
                        "unit": "µg"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 1.457292,
                        "unit": "mg"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 25.770635000000002,
                        "unit": "µg"
                    },
                    "WATER": {
                        "label": "Water",
                        "quantity": 259.425633,
                        "unit": "g"
                    }
                },
                "totalDaily": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 6.131802500000001,
                        "unit": "%"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 8.93765076923077,
                        "unit": "%"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 7.963808,
                        "unit": "%"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 3.4269908333333325,
                        "unit": "%"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 12.969259999999998,
                        "unit": "%"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 17.693269,
                        "unit": "%"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 8.750000000000002,
                        "unit": "%"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 1.5471249999999999,
                        "unit": "%"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 3.4277650000000004,
                        "unit": "%"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 8.710011904761906,
                        "unit": "%"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 14.280701063829783,
                        "unit": "%"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 6.109002777777779,
                        "unit": "%"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 8.195222727272728,
                        "unit": "%"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 16.211557142857142,
                        "unit": "%"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 13.677872222222224,
                        "unit": "%"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 39.66444444444445,
                        "unit": "%"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 9.603616666666667,
                        "unit": "%"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 7.150692307692306,
                        "unit": "%"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 24.226141562500004,
                        "unit": "%"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 25.08831153846154,
                        "unit": "%"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 10.386337500000002,
                        "unit": "%"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 4.520833333333334,
                        "unit": "%"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 0.46666666666666673,
                        "unit": "%"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 9.71528,
                        "unit": "%"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 21.475529166666668,
                        "unit": "%"
                    }
                },
                "digest": [
                    {
                        "label": "Fat",
                        "tag": "FAT",
                        "schemaOrgTag": "fatContent",
                        "total": 5.8094730000000006,
                        "hasRDI": true,
                        "daily": 8.93765076923077,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Saturated",
                                "tag": "FASAT",
                                "schemaOrgTag": "saturatedFatContent",
                                "total": 1.5927616,
                                "hasRDI": true,
                                "daily": 7.963808,
                                "unit": "g"
                            },
                            {
                                "label": "Trans",
                                "tag": "FATRN",
                                "schemaOrgTag": "transFatContent",
                                "total": 0.03395,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Monounsaturated",
                                "tag": "FAMS",
                                "schemaOrgTag": null,
                                "total": 2.26909845,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Polyunsaturated",
                                "tag": "FAPU",
                                "schemaOrgTag": null,
                                "total": 1.3502129,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Carbs",
                        "tag": "CHOCDF",
                        "schemaOrgTag": "carbohydrateContent",
                        "total": 10.280972499999999,
                        "hasRDI": true,
                        "daily": 3.4269908333333325,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Carbs (net)",
                                "tag": "CHOCDF.net",
                                "schemaOrgTag": null,
                                "total": 7.038657499999999,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Fiber",
                                "tag": "FIBTG",
                                "schemaOrgTag": "fiberContent",
                                "total": 3.2423149999999996,
                                "hasRDI": true,
                                "daily": 12.969259999999998,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars",
                                "tag": "SUGAR",
                                "schemaOrgTag": "sugarContent",
                                "total": 6.564871999999999,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars, added",
                                "tag": "SUGAR.added",
                                "schemaOrgTag": null,
                                "total": 0,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Protein",
                        "tag": "PROCNT",
                        "schemaOrgTag": "proteinContent",
                        "total": 8.8466345,
                        "hasRDI": true,
                        "daily": 17.693269,
                        "unit": "g"
                    },
                    {
                        "label": "Cholesterol",
                        "tag": "CHOLE",
                        "schemaOrgTag": "cholesterolContent",
                        "total": 26.250000000000004,
                        "hasRDI": true,
                        "daily": 8.750000000000002,
                        "unit": "mg"
                    },
                    {
                        "label": "Sodium",
                        "tag": "NA",
                        "schemaOrgTag": "sodiumContent",
                        "total": 37.131,
                        "hasRDI": true,
                        "daily": 1.5471249999999999,
                        "unit": "mg"
                    },
                    {
                        "label": "Calcium",
                        "tag": "CA",
                        "schemaOrgTag": null,
                        "total": 34.27765,
                        "hasRDI": true,
                        "daily": 3.4277650000000004,
                        "unit": "mg"
                    },
                    {
                        "label": "Magnesium",
                        "tag": "MG",
                        "schemaOrgTag": null,
                        "total": 36.58205,
                        "hasRDI": true,
                        "daily": 8.710011904761906,
                        "unit": "mg"
                    },
                    {
                        "label": "Potassium",
                        "tag": "K",
                        "schemaOrgTag": null,
                        "total": 671.1929499999999,
                        "hasRDI": true,
                        "daily": 14.280701063829783,
                        "unit": "mg"
                    },
                    {
                        "label": "Iron",
                        "tag": "FE",
                        "schemaOrgTag": null,
                        "total": 1.0996205000000003,
                        "hasRDI": true,
                        "daily": 6.109002777777779,
                        "unit": "mg"
                    },
                    {
                        "label": "Zinc",
                        "tag": "ZN",
                        "schemaOrgTag": null,
                        "total": 0.9014745000000001,
                        "hasRDI": true,
                        "daily": 8.195222727272728,
                        "unit": "mg"
                    },
                    {
                        "label": "Phosphorus",
                        "tag": "P",
                        "schemaOrgTag": null,
                        "total": 113.48089999999999,
                        "hasRDI": true,
                        "daily": 16.211557142857142,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin A",
                        "tag": "VITA_RAE",
                        "schemaOrgTag": null,
                        "total": 123.10085000000001,
                        "hasRDI": true,
                        "daily": 13.677872222222224,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin C",
                        "tag": "VITC",
                        "schemaOrgTag": null,
                        "total": 35.698,
                        "hasRDI": true,
                        "daily": 39.66444444444445,
                        "unit": "mg"
                    },
                    {
                        "label": "Thiamin (B1)",
                        "tag": "THIA",
                        "schemaOrgTag": null,
                        "total": 0.11524340000000001,
                        "hasRDI": true,
                        "daily": 9.603616666666667,
                        "unit": "mg"
                    },
                    {
                        "label": "Riboflavin (B2)",
                        "tag": "RIBF",
                        "schemaOrgTag": null,
                        "total": 0.09295899999999999,
                        "hasRDI": true,
                        "daily": 7.150692307692306,
                        "unit": "mg"
                    },
                    {
                        "label": "Niacin (B3)",
                        "tag": "NIA",
                        "schemaOrgTag": null,
                        "total": 3.8761826500000005,
                        "hasRDI": true,
                        "daily": 24.226141562500004,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin B6",
                        "tag": "VITB6A",
                        "schemaOrgTag": null,
                        "total": 0.32614805,
                        "hasRDI": true,
                        "daily": 25.08831153846154,
                        "unit": "mg"
                    },
                    {
                        "label": "Folate equivalent (total)",
                        "tag": "FOLDFE",
                        "schemaOrgTag": null,
                        "total": 41.545350000000006,
                        "hasRDI": true,
                        "daily": 10.386337500000002,
                        "unit": "µg"
                    },
                    {
                        "label": "Folate (food)",
                        "tag": "FOLFD",
                        "schemaOrgTag": null,
                        "total": 41.545350000000006,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Folic acid",
                        "tag": "FOLAC",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin B12",
                        "tag": "VITB12",
                        "schemaOrgTag": null,
                        "total": 0.10850000000000001,
                        "hasRDI": true,
                        "daily": 4.520833333333334,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin D",
                        "tag": "VITD",
                        "schemaOrgTag": null,
                        "total": 0.07,
                        "hasRDI": true,
                        "daily": 0.46666666666666673,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin E",
                        "tag": "TOCPHA",
                        "schemaOrgTag": null,
                        "total": 1.457292,
                        "hasRDI": true,
                        "daily": 9.71528,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin K",
                        "tag": "VITK1",
                        "schemaOrgTag": null,
                        "total": 25.770635000000002,
                        "hasRDI": true,
                        "daily": 21.475529166666668,
                        "unit": "µg"
                    },
                    {
                        "label": "Sugar alcohols",
                        "tag": "Sugar.alcohol",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    },
                    {
                        "label": "Water",
                        "tag": "WATER",
                        "schemaOrgTag": null,
                        "total": 259.425633,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    }
                ]
            },
            "_links": {
                "self": {
                    "href": "https://api.edamam.com/api/recipes/v2/3abffa587abb91c3ce9956da629448ee?type=public&app_id=ea1d37d5&app_key=fd382a172ba8d6668c0430dc9c14a181",
                    "title": "Self"
                }
            }
        },
        {
            "recipe": {
                "uri": "http://www.edamam.com/ontologies/edamam.owl#recipe_decb658ec24b765db6a2dc5c7c592932",
                "label": "Buffalo Chicken Salad",
                "image": "https://www.edamam.com/web-img/745/745f3cfed84767d39dc2b7f7d5161904.jpg",
                "source": "Delish",
                "url": "http://www.delish.com/cooking/recipe-ideas/recipes/a23965/buffalo-chicken-salad/",
                "shareAs": "http://www.edamam.com/recipe/buffalo-chicken-salad-decb658ec24b765db6a2dc5c7c592932/salad",
                "yield": 6,
                "dietLabels": [],
                "healthLabels": [
                    "Gluten-Free",
                    "Wheat-Free",
                    "Egg-Free",
                    "Peanut-Free",
                    "Tree-Nut-Free",
                    "Soy-Free",
                    "Fish-Free",
                    "Shellfish-Free",
                    "Pork-Free",
                    "Red-Meat-Free",
                    "Crustacean-Free",
                    "Mustard-Free",
                    "Sesame-Free",
                    "Lupine-Free",
                    "Mollusk-Free",
                    "Alcohol-Free",
                    "Sulfite-Free"
                ],
                "cautions": [
                    "Sulfites",
                    "FODMAP"
                ],
                "ingredientLines": [
                    "2 bag romaine salad mix",
                    "1 container Carrot and celery sticks",
                    "1 takeout order chicken fingers",
                    "2 tbsp. cayenne pepper sauce",
                    "½ c. blue cheese salad dressing"
                ],
                "ingredients": [
                    {
                        "text": "2 bag romaine salad mix",
                        "weight": 520,
                        "foodCategory": "vegetables",
                        "foodId": "food_bqalyxzbzu04hcb8xj930bzar7xg",
                        "image": "https://www.edamam.com/food-img/b6d/b6d9f3052d27a3c71220cfa55c6f0a42.jpg"
                    },
                    {
                        "text": "1 container Carrot and celery sticks",
                        "weight": 0,
                        "foodCategory": "vegetables",
                        "foodId": "food_ai215e5b85pdh5ajd4aafa3w2zm8",
                        "image": "https://www.edamam.com/food-img/121/121e33fce0bb9546ed7d060b6c114e29.jpg"
                    },
                    {
                        "text": "1 container Carrot and celery sticks",
                        "weight": 40,
                        "foodCategory": "vegetables",
                        "foodId": "food_bffeoksbyyur8ja4da73ub2xs57g",
                        "image": "https://www.edamam.com/food-img/d91/d91d2aed1c36d8fad54c4d7dc58f5a18.jpg"
                    },
                    {
                        "text": "1 takeout order chicken fingers",
                        "weight": 1200,
                        "foodCategory": "Poultry",
                        "foodId": "food_bmyxrshbfao9s1amjrvhoauob6mo",
                        "image": "https://www.edamam.com/food-img/d33/d338229d774a743f7858f6764e095878.jpg"
                    },
                    {
                        "text": "2 tbsp. cayenne pepper sauce",
                        "weight": 28.19999999809289,
                        "foodCategory": "canned soup",
                        "foodId": "food_a6201h1bu1m0tfbrvis6ma6nvhzv",
                        "image": "https://www.edamam.com/food-img/946/946c38a4c278da4361d2615d653d685a.jpg"
                    },
                    {
                        "text": "½ c. blue cheese salad dressing",
                        "weight": 122.5,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_a7uejbga4bjcztbe4naceb72mnwf",
                        "image": "https://www.edamam.com/food-img/06f/06fde1f5c1a30fbc87e0a5c0052ba4dd.jpg"
                    }
                ],
                "calories": 3260.4019999997904,
                "totalWeight": 1910.6999999980928,
                "totalTime": 10,
                "cuisineType": [
                    "american"
                ],
                "mealType": [
                    "lunch/dinner"
                ],
                "dishType": [
                    "salad"
                ],
                "totalNutrients": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 3260.4019999997904,
                        "unit": "kcal"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 244.26983999999294,
                        "unit": "g"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 61.99233899999901,
                        "unit": "g"
                    },
                    "FATRN": {
                        "label": "Trans",
                        "quantity": 2.8055000000000003,
                        "unit": "g"
                    },
                    "FAMS": {
                        "label": "Monounsaturated",
                        "quantity": 91.19923499999942,
                        "unit": "g"
                    },
                    "FAPU": {
                        "label": "Polyunsaturated",
                        "quantity": 73.01589699999627,
                        "unit": "g"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 22.44874999996663,
                        "unit": "g"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 7.974599999994279,
                        "unit": "g"
                    },
                    "SUGAR": {
                        "label": "Sugars",
                        "quantity": 9.21031999997597,
                        "unit": "g"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 232.3700699999903,
                        "unit": "g"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 937.975,
                        "unit": "mg"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 2549.375999949595,
                        "unit": "mg"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 382.78099999984744,
                        "unit": "mg"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 323.20999999990465,
                        "unit": "mg"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 3529.2079999972543,
                        "unit": "mg"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 15.597609999990846,
                        "unit": "mg"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 16.996269999997903,
                        "unit": "mg"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 2018.1519999997904,
                        "unit": "mg"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 2444.205999999848,
                        "unit": "µg"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 90.23109999857348,
                        "unit": "mg"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 1.1148019999993135,
                        "unit": "mg"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 2.024423999998436,
                        "unit": "mg"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 83.88412799999516,
                        "unit": "mg"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 4.787198999997005,
                        "unit": "mg"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 291.8169999998856,
                        "unit": "µg"
                    },
                    "FOLFD": {
                        "label": "Folate (food)",
                        "quantity": 291.8169999998856,
                        "unit": "µg"
                    },
                    "FOLAC": {
                        "label": "Folic acid",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 4.05075,
                        "unit": "µg"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 2.5225000000000004,
                        "unit": "µg"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 10.128839999997712,
                        "unit": "mg"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 792.3842999999542,
                        "unit": "µg"
                    },
                    "WATER": {
                        "label": "Water",
                        "quantity": 1397.9671099982838,
                        "unit": "g"
                    }
                },
                "totalDaily": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 163.02009999998953,
                        "unit": "%"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 375.799753846143,
                        "unit": "%"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 309.9616949999951,
                        "unit": "%"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 7.482916666655544,
                        "unit": "%"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 31.898399999977116,
                        "unit": "%"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 464.7401399999806,
                        "unit": "%"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 312.65833333333336,
                        "unit": "%"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 106.2239999978998,
                        "unit": "%"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 38.27809999998474,
                        "unit": "%"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 76.9547619047392,
                        "unit": "%"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 75.08953191483519,
                        "unit": "%"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 86.65338888883804,
                        "unit": "%"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 154.51154545452638,
                        "unit": "%"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 288.3074285713986,
                        "unit": "%"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 271.57844444442753,
                        "unit": "%"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 100.25677777619276,
                        "unit": "%"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 92.90016666660946,
                        "unit": "%"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 155.72492307680278,
                        "unit": "%"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 524.2757999999698,
                        "unit": "%"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 368.24607692284656,
                        "unit": "%"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 72.9542499999714,
                        "unit": "%"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 168.78125,
                        "unit": "%"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 16.81666666666667,
                        "unit": "%"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 67.52559999998475,
                        "unit": "%"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 660.3202499999619,
                        "unit": "%"
                    }
                },
                "digest": [
                    {
                        "label": "Fat",
                        "tag": "FAT",
                        "schemaOrgTag": "fatContent",
                        "total": 244.26983999999294,
                        "hasRDI": true,
                        "daily": 375.799753846143,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Saturated",
                                "tag": "FASAT",
                                "schemaOrgTag": "saturatedFatContent",
                                "total": 61.99233899999901,
                                "hasRDI": true,
                                "daily": 309.9616949999951,
                                "unit": "g"
                            },
                            {
                                "label": "Trans",
                                "tag": "FATRN",
                                "schemaOrgTag": "transFatContent",
                                "total": 2.8055000000000003,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Monounsaturated",
                                "tag": "FAMS",
                                "schemaOrgTag": null,
                                "total": 91.19923499999942,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Polyunsaturated",
                                "tag": "FAPU",
                                "schemaOrgTag": null,
                                "total": 73.01589699999627,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Carbs",
                        "tag": "CHOCDF",
                        "schemaOrgTag": "carbohydrateContent",
                        "total": 22.44874999996663,
                        "hasRDI": true,
                        "daily": 7.482916666655544,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Carbs (net)",
                                "tag": "CHOCDF.net",
                                "schemaOrgTag": null,
                                "total": 14.47414999997235,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Fiber",
                                "tag": "FIBTG",
                                "schemaOrgTag": "fiberContent",
                                "total": 7.974599999994279,
                                "hasRDI": true,
                                "daily": 31.898399999977116,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars",
                                "tag": "SUGAR",
                                "schemaOrgTag": "sugarContent",
                                "total": 9.21031999997597,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars, added",
                                "tag": "SUGAR.added",
                                "schemaOrgTag": null,
                                "total": 0,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Protein",
                        "tag": "PROCNT",
                        "schemaOrgTag": "proteinContent",
                        "total": 232.3700699999903,
                        "hasRDI": true,
                        "daily": 464.7401399999806,
                        "unit": "g"
                    },
                    {
                        "label": "Cholesterol",
                        "tag": "CHOLE",
                        "schemaOrgTag": "cholesterolContent",
                        "total": 937.975,
                        "hasRDI": true,
                        "daily": 312.65833333333336,
                        "unit": "mg"
                    },
                    {
                        "label": "Sodium",
                        "tag": "NA",
                        "schemaOrgTag": "sodiumContent",
                        "total": 2549.375999949595,
                        "hasRDI": true,
                        "daily": 106.2239999978998,
                        "unit": "mg"
                    },
                    {
                        "label": "Calcium",
                        "tag": "CA",
                        "schemaOrgTag": null,
                        "total": 382.78099999984744,
                        "hasRDI": true,
                        "daily": 38.27809999998474,
                        "unit": "mg"
                    },
                    {
                        "label": "Magnesium",
                        "tag": "MG",
                        "schemaOrgTag": null,
                        "total": 323.20999999990465,
                        "hasRDI": true,
                        "daily": 76.9547619047392,
                        "unit": "mg"
                    },
                    {
                        "label": "Potassium",
                        "tag": "K",
                        "schemaOrgTag": null,
                        "total": 3529.2079999972543,
                        "hasRDI": true,
                        "daily": 75.08953191483519,
                        "unit": "mg"
                    },
                    {
                        "label": "Iron",
                        "tag": "FE",
                        "schemaOrgTag": null,
                        "total": 15.597609999990846,
                        "hasRDI": true,
                        "daily": 86.65338888883804,
                        "unit": "mg"
                    },
                    {
                        "label": "Zinc",
                        "tag": "ZN",
                        "schemaOrgTag": null,
                        "total": 16.996269999997903,
                        "hasRDI": true,
                        "daily": 154.51154545452638,
                        "unit": "mg"
                    },
                    {
                        "label": "Phosphorus",
                        "tag": "P",
                        "schemaOrgTag": null,
                        "total": 2018.1519999997904,
                        "hasRDI": true,
                        "daily": 288.3074285713986,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin A",
                        "tag": "VITA_RAE",
                        "schemaOrgTag": null,
                        "total": 2444.205999999848,
                        "hasRDI": true,
                        "daily": 271.57844444442753,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin C",
                        "tag": "VITC",
                        "schemaOrgTag": null,
                        "total": 90.23109999857348,
                        "hasRDI": true,
                        "daily": 100.25677777619276,
                        "unit": "mg"
                    },
                    {
                        "label": "Thiamin (B1)",
                        "tag": "THIA",
                        "schemaOrgTag": null,
                        "total": 1.1148019999993135,
                        "hasRDI": true,
                        "daily": 92.90016666660946,
                        "unit": "mg"
                    },
                    {
                        "label": "Riboflavin (B2)",
                        "tag": "RIBF",
                        "schemaOrgTag": null,
                        "total": 2.024423999998436,
                        "hasRDI": true,
                        "daily": 155.72492307680278,
                        "unit": "mg"
                    },
                    {
                        "label": "Niacin (B3)",
                        "tag": "NIA",
                        "schemaOrgTag": null,
                        "total": 83.88412799999516,
                        "hasRDI": true,
                        "daily": 524.2757999999698,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin B6",
                        "tag": "VITB6A",
                        "schemaOrgTag": null,
                        "total": 4.787198999997005,
                        "hasRDI": true,
                        "daily": 368.24607692284656,
                        "unit": "mg"
                    },
                    {
                        "label": "Folate equivalent (total)",
                        "tag": "FOLDFE",
                        "schemaOrgTag": null,
                        "total": 291.8169999998856,
                        "hasRDI": true,
                        "daily": 72.9542499999714,
                        "unit": "µg"
                    },
                    {
                        "label": "Folate (food)",
                        "tag": "FOLFD",
                        "schemaOrgTag": null,
                        "total": 291.8169999998856,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Folic acid",
                        "tag": "FOLAC",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin B12",
                        "tag": "VITB12",
                        "schemaOrgTag": null,
                        "total": 4.05075,
                        "hasRDI": true,
                        "daily": 168.78125,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin D",
                        "tag": "VITD",
                        "schemaOrgTag": null,
                        "total": 2.5225000000000004,
                        "hasRDI": true,
                        "daily": 16.81666666666667,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin E",
                        "tag": "TOCPHA",
                        "schemaOrgTag": null,
                        "total": 10.128839999997712,
                        "hasRDI": true,
                        "daily": 67.52559999998475,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin K",
                        "tag": "VITK1",
                        "schemaOrgTag": null,
                        "total": 792.3842999999542,
                        "hasRDI": true,
                        "daily": 660.3202499999619,
                        "unit": "µg"
                    },
                    {
                        "label": "Sugar alcohols",
                        "tag": "Sugar.alcohol",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    },
                    {
                        "label": "Water",
                        "tag": "WATER",
                        "schemaOrgTag": null,
                        "total": 1397.9671099982838,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    }
                ]
            },
            "_links": {
                "self": {
                    "href": "https://api.edamam.com/api/recipes/v2/decb658ec24b765db6a2dc5c7c592932?type=public&app_id=ea1d37d5&app_key=fd382a172ba8d6668c0430dc9c14a181",
                    "title": "Self"
                }
            }
        },
        {
            "recipe": {
                "uri": "http://www.edamam.com/ontologies/edamam.owl#recipe_087a8931b23d89b0e64236e7b3b52e2e",
                "label": "Buffalo Chicken Salad recipes",
                "image": "https://www.edamam.com/web-img/b5b/b5baa361c0a1dfdf08d13f13c3a513d9",
                "source": "Good Housekeeping",
                "url": "http://www.goodhousekeeping.com/food-recipes/a3338/buffalo-chicken-salad/",
                "shareAs": "http://www.edamam.com/recipe/buffalo-chicken-salad-recipes-087a8931b23d89b0e64236e7b3b52e2e/salad",
                "yield": 6,
                "dietLabels": [],
                "healthLabels": [
                    "Gluten-Free",
                    "Wheat-Free",
                    "Egg-Free",
                    "Peanut-Free",
                    "Tree-Nut-Free",
                    "Soy-Free",
                    "Fish-Free",
                    "Shellfish-Free",
                    "Pork-Free",
                    "Red-Meat-Free",
                    "Crustacean-Free",
                    "Mustard-Free",
                    "Sesame-Free",
                    "Lupine-Free",
                    "Mollusk-Free",
                    "Alcohol-Free",
                    "Sulfite-Free"
                ],
                "cautions": [
                    "Sulfites",
                    "FODMAP"
                ],
                "ingredientLines": [
                    "2 bag romaine salad mix",
                    "1 container Carrot and celery sticks",
                    "1 takeout order chicken fingers",
                    "2 tbsp. cayenne pepper sauce",
                    "0.50 c. blue cheese salad dressing"
                ],
                "ingredients": [
                    {
                        "text": "2 bag romaine salad mix",
                        "weight": 520,
                        "foodCategory": "vegetables",
                        "foodId": "food_bqalyxzbzu04hcb8xj930bzar7xg",
                        "image": "https://www.edamam.com/food-img/b6d/b6d9f3052d27a3c71220cfa55c6f0a42.jpg"
                    },
                    {
                        "text": "1 container Carrot and celery sticks",
                        "weight": 0,
                        "foodCategory": "vegetables",
                        "foodId": "food_ai215e5b85pdh5ajd4aafa3w2zm8",
                        "image": "https://www.edamam.com/food-img/121/121e33fce0bb9546ed7d060b6c114e29.jpg"
                    },
                    {
                        "text": "1 container Carrot and celery sticks",
                        "weight": 40,
                        "foodCategory": "vegetables",
                        "foodId": "food_bffeoksbyyur8ja4da73ub2xs57g",
                        "image": "https://www.edamam.com/food-img/d91/d91d2aed1c36d8fad54c4d7dc58f5a18.jpg"
                    },
                    {
                        "text": "1 takeout order chicken fingers",
                        "weight": 1200,
                        "foodCategory": "Poultry",
                        "foodId": "food_bmyxrshbfao9s1amjrvhoauob6mo",
                        "image": "https://www.edamam.com/food-img/d33/d338229d774a743f7858f6764e095878.jpg"
                    },
                    {
                        "text": "2 tbsp. cayenne pepper sauce",
                        "weight": 28.19999999809289,
                        "foodCategory": "canned soup",
                        "foodId": "food_a6201h1bu1m0tfbrvis6ma6nvhzv",
                        "image": "https://www.edamam.com/food-img/946/946c38a4c278da4361d2615d653d685a.jpg"
                    },
                    {
                        "text": "0.50 c. blue cheese salad dressing",
                        "weight": 122.5,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_a7uejbga4bjcztbe4naceb72mnwf",
                        "image": "https://www.edamam.com/food-img/06f/06fde1f5c1a30fbc87e0a5c0052ba4dd.jpg"
                    }
                ],
                "calories": 3260.4019999997904,
                "totalWeight": 1910.6999999980928,
                "totalTime": 10,
                "cuisineType": [
                    "american"
                ],
                "mealType": [
                    "lunch/dinner"
                ],
                "dishType": [
                    "salad"
                ],
                "totalNutrients": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 3260.4019999997904,
                        "unit": "kcal"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 244.26983999999294,
                        "unit": "g"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 61.99233899999901,
                        "unit": "g"
                    },
                    "FATRN": {
                        "label": "Trans",
                        "quantity": 2.8055000000000003,
                        "unit": "g"
                    },
                    "FAMS": {
                        "label": "Monounsaturated",
                        "quantity": 91.19923499999942,
                        "unit": "g"
                    },
                    "FAPU": {
                        "label": "Polyunsaturated",
                        "quantity": 73.01589699999627,
                        "unit": "g"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 22.44874999996663,
                        "unit": "g"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 7.974599999994279,
                        "unit": "g"
                    },
                    "SUGAR": {
                        "label": "Sugars",
                        "quantity": 9.21031999997597,
                        "unit": "g"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 232.3700699999903,
                        "unit": "g"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 937.975,
                        "unit": "mg"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 2549.375999949595,
                        "unit": "mg"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 382.78099999984744,
                        "unit": "mg"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 323.20999999990465,
                        "unit": "mg"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 3529.2079999972543,
                        "unit": "mg"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 15.597609999990846,
                        "unit": "mg"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 16.996269999997903,
                        "unit": "mg"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 2018.1519999997904,
                        "unit": "mg"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 2444.205999999848,
                        "unit": "µg"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 90.23109999857348,
                        "unit": "mg"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 1.1148019999993135,
                        "unit": "mg"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 2.024423999998436,
                        "unit": "mg"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 83.88412799999516,
                        "unit": "mg"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 4.787198999997005,
                        "unit": "mg"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 291.8169999998856,
                        "unit": "µg"
                    },
                    "FOLFD": {
                        "label": "Folate (food)",
                        "quantity": 291.8169999998856,
                        "unit": "µg"
                    },
                    "FOLAC": {
                        "label": "Folic acid",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 4.05075,
                        "unit": "µg"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 2.5225000000000004,
                        "unit": "µg"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 10.128839999997712,
                        "unit": "mg"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 792.3842999999542,
                        "unit": "µg"
                    },
                    "WATER": {
                        "label": "Water",
                        "quantity": 1397.9671099982838,
                        "unit": "g"
                    }
                },
                "totalDaily": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 163.02009999998953,
                        "unit": "%"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 375.799753846143,
                        "unit": "%"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 309.9616949999951,
                        "unit": "%"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 7.482916666655544,
                        "unit": "%"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 31.898399999977116,
                        "unit": "%"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 464.7401399999806,
                        "unit": "%"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 312.65833333333336,
                        "unit": "%"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 106.2239999978998,
                        "unit": "%"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 38.27809999998474,
                        "unit": "%"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 76.9547619047392,
                        "unit": "%"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 75.08953191483519,
                        "unit": "%"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 86.65338888883804,
                        "unit": "%"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 154.51154545452638,
                        "unit": "%"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 288.3074285713986,
                        "unit": "%"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 271.57844444442753,
                        "unit": "%"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 100.25677777619276,
                        "unit": "%"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 92.90016666660946,
                        "unit": "%"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 155.72492307680278,
                        "unit": "%"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 524.2757999999698,
                        "unit": "%"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 368.24607692284656,
                        "unit": "%"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 72.9542499999714,
                        "unit": "%"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 168.78125,
                        "unit": "%"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 16.81666666666667,
                        "unit": "%"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 67.52559999998475,
                        "unit": "%"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 660.3202499999619,
                        "unit": "%"
                    }
                },
                "digest": [
                    {
                        "label": "Fat",
                        "tag": "FAT",
                        "schemaOrgTag": "fatContent",
                        "total": 244.26983999999294,
                        "hasRDI": true,
                        "daily": 375.799753846143,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Saturated",
                                "tag": "FASAT",
                                "schemaOrgTag": "saturatedFatContent",
                                "total": 61.99233899999901,
                                "hasRDI": true,
                                "daily": 309.9616949999951,
                                "unit": "g"
                            },
                            {
                                "label": "Trans",
                                "tag": "FATRN",
                                "schemaOrgTag": "transFatContent",
                                "total": 2.8055000000000003,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Monounsaturated",
                                "tag": "FAMS",
                                "schemaOrgTag": null,
                                "total": 91.19923499999942,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Polyunsaturated",
                                "tag": "FAPU",
                                "schemaOrgTag": null,
                                "total": 73.01589699999627,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Carbs",
                        "tag": "CHOCDF",
                        "schemaOrgTag": "carbohydrateContent",
                        "total": 22.44874999996663,
                        "hasRDI": true,
                        "daily": 7.482916666655544,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Carbs (net)",
                                "tag": "CHOCDF.net",
                                "schemaOrgTag": null,
                                "total": 14.47414999997235,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Fiber",
                                "tag": "FIBTG",
                                "schemaOrgTag": "fiberContent",
                                "total": 7.974599999994279,
                                "hasRDI": true,
                                "daily": 31.898399999977116,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars",
                                "tag": "SUGAR",
                                "schemaOrgTag": "sugarContent",
                                "total": 9.21031999997597,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars, added",
                                "tag": "SUGAR.added",
                                "schemaOrgTag": null,
                                "total": 0,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Protein",
                        "tag": "PROCNT",
                        "schemaOrgTag": "proteinContent",
                        "total": 232.3700699999903,
                        "hasRDI": true,
                        "daily": 464.7401399999806,
                        "unit": "g"
                    },
                    {
                        "label": "Cholesterol",
                        "tag": "CHOLE",
                        "schemaOrgTag": "cholesterolContent",
                        "total": 937.975,
                        "hasRDI": true,
                        "daily": 312.65833333333336,
                        "unit": "mg"
                    },
                    {
                        "label": "Sodium",
                        "tag": "NA",
                        "schemaOrgTag": "sodiumContent",
                        "total": 2549.375999949595,
                        "hasRDI": true,
                        "daily": 106.2239999978998,
                        "unit": "mg"
                    },
                    {
                        "label": "Calcium",
                        "tag": "CA",
                        "schemaOrgTag": null,
                        "total": 382.78099999984744,
                        "hasRDI": true,
                        "daily": 38.27809999998474,
                        "unit": "mg"
                    },
                    {
                        "label": "Magnesium",
                        "tag": "MG",
                        "schemaOrgTag": null,
                        "total": 323.20999999990465,
                        "hasRDI": true,
                        "daily": 76.9547619047392,
                        "unit": "mg"
                    },
                    {
                        "label": "Potassium",
                        "tag": "K",
                        "schemaOrgTag": null,
                        "total": 3529.2079999972543,
                        "hasRDI": true,
                        "daily": 75.08953191483519,
                        "unit": "mg"
                    },
                    {
                        "label": "Iron",
                        "tag": "FE",
                        "schemaOrgTag": null,
                        "total": 15.597609999990846,
                        "hasRDI": true,
                        "daily": 86.65338888883804,
                        "unit": "mg"
                    },
                    {
                        "label": "Zinc",
                        "tag": "ZN",
                        "schemaOrgTag": null,
                        "total": 16.996269999997903,
                        "hasRDI": true,
                        "daily": 154.51154545452638,
                        "unit": "mg"
                    },
                    {
                        "label": "Phosphorus",
                        "tag": "P",
                        "schemaOrgTag": null,
                        "total": 2018.1519999997904,
                        "hasRDI": true,
                        "daily": 288.3074285713986,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin A",
                        "tag": "VITA_RAE",
                        "schemaOrgTag": null,
                        "total": 2444.205999999848,
                        "hasRDI": true,
                        "daily": 271.57844444442753,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin C",
                        "tag": "VITC",
                        "schemaOrgTag": null,
                        "total": 90.23109999857348,
                        "hasRDI": true,
                        "daily": 100.25677777619276,
                        "unit": "mg"
                    },
                    {
                        "label": "Thiamin (B1)",
                        "tag": "THIA",
                        "schemaOrgTag": null,
                        "total": 1.1148019999993135,
                        "hasRDI": true,
                        "daily": 92.90016666660946,
                        "unit": "mg"
                    },
                    {
                        "label": "Riboflavin (B2)",
                        "tag": "RIBF",
                        "schemaOrgTag": null,
                        "total": 2.024423999998436,
                        "hasRDI": true,
                        "daily": 155.72492307680278,
                        "unit": "mg"
                    },
                    {
                        "label": "Niacin (B3)",
                        "tag": "NIA",
                        "schemaOrgTag": null,
                        "total": 83.88412799999516,
                        "hasRDI": true,
                        "daily": 524.2757999999698,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin B6",
                        "tag": "VITB6A",
                        "schemaOrgTag": null,
                        "total": 4.787198999997005,
                        "hasRDI": true,
                        "daily": 368.24607692284656,
                        "unit": "mg"
                    },
                    {
                        "label": "Folate equivalent (total)",
                        "tag": "FOLDFE",
                        "schemaOrgTag": null,
                        "total": 291.8169999998856,
                        "hasRDI": true,
                        "daily": 72.9542499999714,
                        "unit": "µg"
                    },
                    {
                        "label": "Folate (food)",
                        "tag": "FOLFD",
                        "schemaOrgTag": null,
                        "total": 291.8169999998856,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Folic acid",
                        "tag": "FOLAC",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin B12",
                        "tag": "VITB12",
                        "schemaOrgTag": null,
                        "total": 4.05075,
                        "hasRDI": true,
                        "daily": 168.78125,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin D",
                        "tag": "VITD",
                        "schemaOrgTag": null,
                        "total": 2.5225000000000004,
                        "hasRDI": true,
                        "daily": 16.81666666666667,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin E",
                        "tag": "TOCPHA",
                        "schemaOrgTag": null,
                        "total": 10.128839999997712,
                        "hasRDI": true,
                        "daily": 67.52559999998475,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin K",
                        "tag": "VITK1",
                        "schemaOrgTag": null,
                        "total": 792.3842999999542,
                        "hasRDI": true,
                        "daily": 660.3202499999619,
                        "unit": "µg"
                    },
                    {
                        "label": "Sugar alcohols",
                        "tag": "Sugar.alcohol",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    },
                    {
                        "label": "Water",
                        "tag": "WATER",
                        "schemaOrgTag": null,
                        "total": 1397.9671099982838,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    }
                ]
            },
            "_links": {
                "self": {
                    "href": "https://api.edamam.com/api/recipes/v2/087a8931b23d89b0e64236e7b3b52e2e?type=public&app_id=ea1d37d5&app_key=fd382a172ba8d6668c0430dc9c14a181",
                    "title": "Self"
                }
            }
        },
        {
            "recipe": {
                "uri": "http://www.edamam.com/ontologies/edamam.owl#recipe_db1dda0c057461fa2eb49211bbfd4f4b",
                "label": "Washing up free salad",
                "image": "https://www.edamam.com/web-img/5f4/5f4e0c670a283159486de0b6d3e04284.jpg",
                "source": "The Stone Soup",
                "url": "http://thestonesoup.com/blog/2011/01/reduce-reuse-recycle-how-the-3rs-can-help-you-with-the-washing-up/",
                "shareAs": "http://www.edamam.com/recipe/washing-up-free-salad-db1dda0c057461fa2eb49211bbfd4f4b/salad",
                "yield": 1,
                "dietLabels": [
                    "High-Fiber",
                    "Low-Carb"
                ],
                "healthLabels": [
                    "Pescatarian",
                    "Paleo",
                    "Mediterranean",
                    "DASH",
                    "Dairy-Free",
                    "Gluten-Free",
                    "Wheat-Free",
                    "Egg-Free",
                    "Peanut-Free",
                    "Soy-Free",
                    "Fish-Free",
                    "Shellfish-Free",
                    "Pork-Free",
                    "Red-Meat-Free",
                    "Crustacean-Free",
                    "Celery-Free",
                    "Mustard-Free",
                    "Sesame-Free",
                    "Lupine-Free",
                    "Mollusk-Free",
                    "Alcohol-Free",
                    "Sulfite-Free",
                    "Kosher"
                ],
                "cautions": [
                    "Sulfites"
                ],
                "ingredientLines": [
                    "1 can sardines, preferably in olive oil",
                    "1 bag washed salad leaves",
                    "1 lemon",
                    "Small handful pinenuts, optional"
                ],
                "ingredients": [
                    {
                        "text": "1 can sardines, preferably in olive oil",
                        "weight": 252.00000000426004,
                        "foodCategory": "canned fruit",
                        "foodId": "food_bt7u5w5a064gusa46msxfb38ag06",
                        "image": "https://www.edamam.com/food-img/822/8221f2141e8dafd469414b20777735ca.jpg"
                    },
                    {
                        "text": "1 bag washed salad leaves",
                        "weight": 313,
                        "foodCategory": "vegetables",
                        "foodId": "food_bfmb5cybk1o247bmrmry4a6jvp60",
                        "image": "https://www.edamam.com/food-img/79e/79e8dd0ee229cbc32171ec362ce93a37.jpg"
                    },
                    {
                        "text": "1 lemon",
                        "weight": 58,
                        "foodCategory": "fruit",
                        "foodId": "food_a6uzc62astrxcgbtzyq59b6fncrr",
                        "image": "https://www.edamam.com/food-img/70a/70acba3d4c734d7c70ef4efeed85dc8f.jpg"
                    },
                    {
                        "text": "Small handful pinenuts, optional",
                        "weight": 12.65625,
                        "foodCategory": "plant-based protein",
                        "foodId": "food_b5d59t6bhqudbqalw7k4fb6ncio8",
                        "image": "https://www.edamam.com/food-img/52f/52fa29cb9d1ab6502f137a98c8a63f09.jpg"
                    }
                ],
                "calories": 445.006562504899,
                "totalWeight": 635.6562500042601,
                "totalTime": 6,
                "cuisineType": [
                    "american"
                ],
                "mealType": [
                    "lunch/dinner"
                ],
                "dishType": [
                    "salad"
                ],
                "totalNutrients": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 445.006562504899,
                        "unit": "kcal"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 36.67967812545497,
                        "unit": "g"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 4.33051968756028,
                        "unit": "g"
                    },
                    "FAMS": {
                        "label": "Monounsaturated",
                        "quantity": 22.29651875033603,
                        "unit": "g"
                    },
                    "FAPU": {
                        "label": "Polyunsaturated",
                        "quantity": 7.160250937538809,
                        "unit": "g"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 33.133937500266676,
                        "unit": "g"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 16.729281250136324,
                        "unit": "g"
                    },
                    "SUGAR": {
                        "label": "Sugars",
                        "quantity": 5.629059375,
                        "unit": "g"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 8.337340625035784,
                        "unit": "g"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 0,
                        "unit": "mg"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 1878.6531250313114,
                        "unit": "mg"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 342.1550000037488,
                        "unit": "mg"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 90.3071875001704,
                        "unit": "mg"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 948.8678125003407,
                        "unit": "mg"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 12.399990625140582,
                        "unit": "mg"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 2.125428125009372,
                        "unit": "mg"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 183.5134375001278,
                        "unit": "mg"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 1415.7865625008521,
                        "unit": "µg"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 45.62925000003834,
                        "unit": "mg"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 0.3021887500001278,
                        "unit": "mg"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 0.2500396875,
                        "unit": "mg"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 1.686159687501576,
                        "unit": "mg"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 0.31259687500038336,
                        "unit": "mg"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 436.363125,
                        "unit": "µg"
                    },
                    "FOLFD": {
                        "label": "Folate (food)",
                        "quantity": 436.363125,
                        "unit": "µg"
                    },
                    "FOLAC": {
                        "label": "Folic acid",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 5.8327281250702905,
                        "unit": "mg"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 331.17471875005964,
                        "unit": "µg"
                    },
                    "WATER": {
                        "label": "Water",
                        "quantity": 549.6010625034075,
                        "unit": "g"
                    }
                },
                "totalDaily": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 22.250328125244952,
                        "unit": "%"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 56.430274039161496,
                        "unit": "%"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 21.652598437801398,
                        "unit": "%"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 11.044645833422225,
                        "unit": "%"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 66.9171250005453,
                        "unit": "%"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 16.67468125007157,
                        "unit": "%"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 0,
                        "unit": "%"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 78.27721354297131,
                        "unit": "%"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 34.21550000037488,
                        "unit": "%"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 21.50171130956438,
                        "unit": "%"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 20.18867686170938,
                        "unit": "%"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 68.88883680633656,
                        "unit": "%"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 19.322073863721563,
                        "unit": "%"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 26.216205357161115,
                        "unit": "%"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 157.30961805565025,
                        "unit": "%"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 50.69916666670926,
                        "unit": "%"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 25.182395833343985,
                        "unit": "%"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 19.233822115384612,
                        "unit": "%"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 10.53849804688485,
                        "unit": "%"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 24.04591346156795,
                        "unit": "%"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 109.09078125,
                        "unit": "%"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 0,
                        "unit": "%"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 0,
                        "unit": "%"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 38.884854167135266,
                        "unit": "%"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 275.9789322917164,
                        "unit": "%"
                    }
                },
                "digest": [
                    {
                        "label": "Fat",
                        "tag": "FAT",
                        "schemaOrgTag": "fatContent",
                        "total": 36.67967812545497,
                        "hasRDI": true,
                        "daily": 56.430274039161496,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Saturated",
                                "tag": "FASAT",
                                "schemaOrgTag": "saturatedFatContent",
                                "total": 4.33051968756028,
                                "hasRDI": true,
                                "daily": 21.652598437801398,
                                "unit": "g"
                            },
                            {
                                "label": "Trans",
                                "tag": "FATRN",
                                "schemaOrgTag": "transFatContent",
                                "total": 0,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Monounsaturated",
                                "tag": "FAMS",
                                "schemaOrgTag": null,
                                "total": 22.29651875033603,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Polyunsaturated",
                                "tag": "FAPU",
                                "schemaOrgTag": null,
                                "total": 7.160250937538809,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Carbs",
                        "tag": "CHOCDF",
                        "schemaOrgTag": "carbohydrateContent",
                        "total": 33.133937500266676,
                        "hasRDI": true,
                        "daily": 11.044645833422225,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Carbs (net)",
                                "tag": "CHOCDF.net",
                                "schemaOrgTag": null,
                                "total": 16.40465625013035,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Fiber",
                                "tag": "FIBTG",
                                "schemaOrgTag": "fiberContent",
                                "total": 16.729281250136324,
                                "hasRDI": true,
                                "daily": 66.9171250005453,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars",
                                "tag": "SUGAR",
                                "schemaOrgTag": "sugarContent",
                                "total": 5.629059375,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars, added",
                                "tag": "SUGAR.added",
                                "schemaOrgTag": null,
                                "total": 0,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Protein",
                        "tag": "PROCNT",
                        "schemaOrgTag": "proteinContent",
                        "total": 8.337340625035784,
                        "hasRDI": true,
                        "daily": 16.67468125007157,
                        "unit": "g"
                    },
                    {
                        "label": "Cholesterol",
                        "tag": "CHOLE",
                        "schemaOrgTag": "cholesterolContent",
                        "total": 0,
                        "hasRDI": true,
                        "daily": 0,
                        "unit": "mg"
                    },
                    {
                        "label": "Sodium",
                        "tag": "NA",
                        "schemaOrgTag": "sodiumContent",
                        "total": 1878.6531250313114,
                        "hasRDI": true,
                        "daily": 78.27721354297131,
                        "unit": "mg"
                    },
                    {
                        "label": "Calcium",
                        "tag": "CA",
                        "schemaOrgTag": null,
                        "total": 342.1550000037488,
                        "hasRDI": true,
                        "daily": 34.21550000037488,
                        "unit": "mg"
                    },
                    {
                        "label": "Magnesium",
                        "tag": "MG",
                        "schemaOrgTag": null,
                        "total": 90.3071875001704,
                        "hasRDI": true,
                        "daily": 21.50171130956438,
                        "unit": "mg"
                    },
                    {
                        "label": "Potassium",
                        "tag": "K",
                        "schemaOrgTag": null,
                        "total": 948.8678125003407,
                        "hasRDI": true,
                        "daily": 20.18867686170938,
                        "unit": "mg"
                    },
                    {
                        "label": "Iron",
                        "tag": "FE",
                        "schemaOrgTag": null,
                        "total": 12.399990625140582,
                        "hasRDI": true,
                        "daily": 68.88883680633656,
                        "unit": "mg"
                    },
                    {
                        "label": "Zinc",
                        "tag": "ZN",
                        "schemaOrgTag": null,
                        "total": 2.125428125009372,
                        "hasRDI": true,
                        "daily": 19.322073863721563,
                        "unit": "mg"
                    },
                    {
                        "label": "Phosphorus",
                        "tag": "P",
                        "schemaOrgTag": null,
                        "total": 183.5134375001278,
                        "hasRDI": true,
                        "daily": 26.216205357161115,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin A",
                        "tag": "VITA_RAE",
                        "schemaOrgTag": null,
                        "total": 1415.7865625008521,
                        "hasRDI": true,
                        "daily": 157.30961805565025,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin C",
                        "tag": "VITC",
                        "schemaOrgTag": null,
                        "total": 45.62925000003834,
                        "hasRDI": true,
                        "daily": 50.69916666670926,
                        "unit": "mg"
                    },
                    {
                        "label": "Thiamin (B1)",
                        "tag": "THIA",
                        "schemaOrgTag": null,
                        "total": 0.3021887500001278,
                        "hasRDI": true,
                        "daily": 25.182395833343985,
                        "unit": "mg"
                    },
                    {
                        "label": "Riboflavin (B2)",
                        "tag": "RIBF",
                        "schemaOrgTag": null,
                        "total": 0.2500396875,
                        "hasRDI": true,
                        "daily": 19.233822115384612,
                        "unit": "mg"
                    },
                    {
                        "label": "Niacin (B3)",
                        "tag": "NIA",
                        "schemaOrgTag": null,
                        "total": 1.686159687501576,
                        "hasRDI": true,
                        "daily": 10.53849804688485,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin B6",
                        "tag": "VITB6A",
                        "schemaOrgTag": null,
                        "total": 0.31259687500038336,
                        "hasRDI": true,
                        "daily": 24.04591346156795,
                        "unit": "mg"
                    },
                    {
                        "label": "Folate equivalent (total)",
                        "tag": "FOLDFE",
                        "schemaOrgTag": null,
                        "total": 436.363125,
                        "hasRDI": true,
                        "daily": 109.09078125,
                        "unit": "µg"
                    },
                    {
                        "label": "Folate (food)",
                        "tag": "FOLFD",
                        "schemaOrgTag": null,
                        "total": 436.363125,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Folic acid",
                        "tag": "FOLAC",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin B12",
                        "tag": "VITB12",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": true,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin D",
                        "tag": "VITD",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": true,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin E",
                        "tag": "TOCPHA",
                        "schemaOrgTag": null,
                        "total": 5.8327281250702905,
                        "hasRDI": true,
                        "daily": 38.884854167135266,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin K",
                        "tag": "VITK1",
                        "schemaOrgTag": null,
                        "total": 331.17471875005964,
                        "hasRDI": true,
                        "daily": 275.9789322917164,
                        "unit": "µg"
                    },
                    {
                        "label": "Sugar alcohols",
                        "tag": "Sugar.alcohol",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    },
                    {
                        "label": "Water",
                        "tag": "WATER",
                        "schemaOrgTag": null,
                        "total": 549.6010625034075,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    }
                ]
            },
            "_links": {
                "self": {
                    "href": "https://api.edamam.com/api/recipes/v2/db1dda0c057461fa2eb49211bbfd4f4b?type=public&app_id=ea1d37d5&app_key=fd382a172ba8d6668c0430dc9c14a181",
                    "title": "Self"
                }
            }
        },
        {
            "recipe": {
                "uri": "http://www.edamam.com/ontologies/edamam.owl#recipe_0f4ef6f5fb420dc465d7f4a83120f340",
                "label": "Quinoa Salad",
                "image": "https://www.edamam.com/web-img/159/1597abd059f43b5f813d9f4f123425a8.jpeg",
                "source": "Food Network",
                "url": "https://www.foodnetwork.com/recipes/sandra-lee/quinoa-salad-recipe-1917726",
                "shareAs": "http://www.edamam.com/recipe/quinoa-salad-0f4ef6f5fb420dc465d7f4a83120f340/salad",
                "yield": 6,
                "dietLabels": [
                    "Balanced"
                ],
                "healthLabels": [
                    "Sugar-Conscious",
                    "Gluten-Free",
                    "Wheat-Free",
                    "Egg-Free",
                    "Peanut-Free",
                    "Soy-Free",
                    "Fish-Free",
                    "Shellfish-Free",
                    "Pork-Free",
                    "Red-Meat-Free",
                    "Crustacean-Free",
                    "Celery-Free",
                    "Mustard-Free",
                    "Sesame-Free",
                    "Lupine-Free",
                    "Mollusk-Free",
                    "Alcohol-Free",
                    "Sulfite-Free"
                ],
                "cautions": [
                    "Sulfites",
                    "FODMAP"
                ],
                "ingredientLines": [
                    "1 cup quinoa",
                    "2 cups chicken or vegetable stock",
                    "1 hothouse cucumber, diced",
                    "2 scallions",
                    "1/2 cup roasted red pepper, diced",
                    "1/4 cup flat leaf parsley, finely chopped",
                    "1 tablespoon fines herbs (recommended: Spice Island)",
                    "1/4 cup crumbled feta cheese",
                    "3 tablespoons slivered almonds",
                    "9 cups spring salad mix",
                    "1/4 cup light roasted garlic and balsamic salad dressing"
                ],
                "ingredients": [
                    {
                        "text": "1 cup quinoa",
                        "weight": 170,
                        "foodCategory": "grains",
                        "foodId": "food_a0d1h1cbporq98adlzq8tadghm2a",
                        "image": "https://www.edamam.com/food-img/b62/b622239a214b3bd9f63c8e93e6e9cde6.jpg"
                    },
                    {
                        "text": "2 cups chicken or vegetable stock",
                        "weight": 480,
                        "foodCategory": "canned soup",
                        "foodId": "food_bptblvzambd16nbhewqmhaw1rnh5",
                        "image": "https://www.edamam.com/food-img/26a/26a10c4cb4e07bab54d8a687ef5ac7d8.jpg"
                    },
                    {
                        "text": "1 hothouse cucumber, diced",
                        "weight": 301,
                        "foodCategory": "vegetables",
                        "foodId": "food_bv7aggjag9rxsaatklqzobca5fzn",
                        "image": "https://www.edamam.com/food-img/501/5015da0e5fc2b384696b3d949aefef86.jpg"
                    },
                    {
                        "text": "2 scallions",
                        "weight": 30,
                        "foodCategory": "vegetables",
                        "foodId": "food_bknlkyzbuzo27pb11whr4bttkuy6",
                        "image": "https://www.edamam.com/food-img/b89/b89986ed6aa466285bdd99bac34b3c46.jpg"
                    },
                    {
                        "text": "1/2 cup roasted red pepper, diced",
                        "weight": 67.5,
                        "foodCategory": "vegetables",
                        "foodId": "food_b3qdnlvaxpt1i3ayle41la3mow3z",
                        "image": "https://www.edamam.com/food-img/7f8/7f874d848dbb46bf1dfa5418564a736c.jpeg"
                    },
                    {
                        "text": "1/4 cup flat leaf parsley, finely chopped",
                        "weight": 15,
                        "foodCategory": "vegetables",
                        "foodId": "food_b244pqdazw24zobr5vqu2bf0uid8",
                        "image": "https://www.edamam.com/food-img/46a/46a132e96626d7989b4d6ed8c91f4da0.jpg"
                    },
                    {
                        "text": "1 tablespoon fines herbs (recommended: Spice Island)",
                        "weight": 2.7,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_avsq22zadwyb5cb5sl1byaa4mbo8",
                        "image": "https://www.edamam.com/food-img/89b/89b37a04e46e052671d73addcb84aa51.jpg"
                    },
                    {
                        "text": "1/4 cup crumbled feta cheese",
                        "weight": 37.5,
                        "foodCategory": "Cheese",
                        "foodId": "food_biry7gubtkpad3a7qkz6uba5acn9",
                        "image": "https://www.edamam.com/food-img/37e/37ef3e404b1c02bf4707cb82010732b8.jpg"
                    },
                    {
                        "text": "3 tablespoons slivered almonds",
                        "weight": 26.812499999546674,
                        "foodCategory": "plant-based protein",
                        "foodId": "food_bq4d2wras281i0br37nrnaglo3yc",
                        "image": "https://www.edamam.com/food-img/6c2/6c2dc21adf11afc4c8d390ee2f651e56.jpg"
                    },
                    {
                        "text": "9 cups spring salad mix",
                        "weight": 324,
                        "foodCategory": "vegetables",
                        "foodId": "food_bqalyxzbzu04hcb8xj930bzar7xg",
                        "image": "https://www.edamam.com/food-img/b6d/b6d9f3052d27a3c71220cfa55c6f0a42.jpg"
                    },
                    {
                        "text": "1/4 cup light roasted garlic and balsamic salad dressing",
                        "weight": 62.5,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_a67f1v3boelh4wasob4qib34t5bv",
                        "image": "https://www.edamam.com/food-img/241/24178db68d42001caf980f8f209534cb.jpg"
                    }
                ],
                "calories": 1468.3713749973751,
                "totalWeight": 1517.0124999995467,
                "totalTime": 22,
                "cuisineType": [
                    "south american"
                ],
                "mealType": [
                    "lunch/dinner"
                ],
                "dishType": [
                    "salad"
                ],
                "totalNutrients": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 1468.3713749973751,
                        "unit": "kcal"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 70.08719124977365,
                        "unit": "g"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 15.351516249982765,
                        "unit": "g"
                    },
                    "FATRN": {
                        "label": "Trans",
                        "quantity": 0.004021874999932001,
                        "unit": "g"
                    },
                    "FAMS": {
                        "label": "Monounsaturated",
                        "quantity": 25.08724187485697,
                        "unit": "g"
                    },
                    "FAPU": {
                        "label": "Polyunsaturated",
                        "quantity": 25.715118124944112,
                        "unit": "g"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 164.5158237499023,
                        "unit": "g"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 24.052562499943335,
                        "unit": "g"
                    },
                    "SUGAR": {
                        "label": "Sugars",
                        "quantity": 23.236413749980283,
                        "unit": "g"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 55.32396374990412,
                        "unit": "g"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 47.775,
                        "unit": "mg"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 1152.4431249999955,
                        "unit": "mg"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 615.5056249987805,
                        "unit": "mg"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 541.058749998776,
                        "unit": "mg"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 3056.843624996677,
                        "unit": "mg"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 18.666393749983182,
                        "unit": "mg"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 9.569109999985855,
                        "unit": "mg"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 1365.4201249978198,
                        "unit": "mg"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 1449.7300000000002,
                        "unit": "µg"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 181.56099999999998,
                        "unit": "mg"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 1.2838616249990706,
                        "unit": "mg"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 1.9984792499948412,
                        "unit": "mg"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 13.8486862499836,
                        "unit": "mg"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 1.9323581249993793,
                        "unit": "mg"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 564.9854999998006,
                        "unit": "µg"
                    },
                    "FOLFD": {
                        "label": "Folate (food)",
                        "quantity": 564.9854999998006,
                        "unit": "µg"
                    },
                    "FOLAC": {
                        "label": "Folic acid",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 0.63375,
                        "unit": "µg"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 0.15000000000000002,
                        "unit": "µg"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 16.50910374988381,
                        "unit": "mg"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 879.7950000000001,
                        "unit": "µg"
                    },
                    "WATER": {
                        "label": "Water",
                        "quantity": 1213.11651124998,
                        "unit": "g"
                    }
                },
                "totalDaily": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 73.41856874986877,
                        "unit": "%"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 107.82644807657485,
                        "unit": "%"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 76.75758124991383,
                        "unit": "%"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 54.8386079166341,
                        "unit": "%"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 96.21024999977334,
                        "unit": "%"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 110.64792749980823,
                        "unit": "%"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 15.925,
                        "unit": "%"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 48.01846354166648,
                        "unit": "%"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 61.55056249987805,
                        "unit": "%"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 128.82351190447048,
                        "unit": "%"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 65.03922606375909,
                        "unit": "%"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 103.70218749990657,
                        "unit": "%"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 86.99190909078051,
                        "unit": "%"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 195.06001785683142,
                        "unit": "%"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 161.08111111111114,
                        "unit": "%"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 201.73444444444442,
                        "unit": "%"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 106.98846874992256,
                        "unit": "%"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 153.72917307652625,
                        "unit": "%"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 86.5542890623975,
                        "unit": "%"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 148.64293269225993,
                        "unit": "%"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 141.24637499995015,
                        "unit": "%"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 26.40625,
                        "unit": "%"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 1.0000000000000002,
                        "unit": "%"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 110.06069166589207,
                        "unit": "%"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 733.1625,
                        "unit": "%"
                    }
                },
                "digest": [
                    {
                        "label": "Fat",
                        "tag": "FAT",
                        "schemaOrgTag": "fatContent",
                        "total": 70.08719124977365,
                        "hasRDI": true,
                        "daily": 107.82644807657485,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Saturated",
                                "tag": "FASAT",
                                "schemaOrgTag": "saturatedFatContent",
                                "total": 15.351516249982765,
                                "hasRDI": true,
                                "daily": 76.75758124991383,
                                "unit": "g"
                            },
                            {
                                "label": "Trans",
                                "tag": "FATRN",
                                "schemaOrgTag": "transFatContent",
                                "total": 0.004021874999932001,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Monounsaturated",
                                "tag": "FAMS",
                                "schemaOrgTag": null,
                                "total": 25.08724187485697,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Polyunsaturated",
                                "tag": "FAPU",
                                "schemaOrgTag": null,
                                "total": 25.715118124944112,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Carbs",
                        "tag": "CHOCDF",
                        "schemaOrgTag": "carbohydrateContent",
                        "total": 164.5158237499023,
                        "hasRDI": true,
                        "daily": 54.8386079166341,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Carbs (net)",
                                "tag": "CHOCDF.net",
                                "schemaOrgTag": null,
                                "total": 140.46326124995898,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Fiber",
                                "tag": "FIBTG",
                                "schemaOrgTag": "fiberContent",
                                "total": 24.052562499943335,
                                "hasRDI": true,
                                "daily": 96.21024999977334,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars",
                                "tag": "SUGAR",
                                "schemaOrgTag": "sugarContent",
                                "total": 23.236413749980283,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars, added",
                                "tag": "SUGAR.added",
                                "schemaOrgTag": null,
                                "total": 0,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Protein",
                        "tag": "PROCNT",
                        "schemaOrgTag": "proteinContent",
                        "total": 55.32396374990412,
                        "hasRDI": true,
                        "daily": 110.64792749980823,
                        "unit": "g"
                    },
                    {
                        "label": "Cholesterol",
                        "tag": "CHOLE",
                        "schemaOrgTag": "cholesterolContent",
                        "total": 47.775,
                        "hasRDI": true,
                        "daily": 15.925,
                        "unit": "mg"
                    },
                    {
                        "label": "Sodium",
                        "tag": "NA",
                        "schemaOrgTag": "sodiumContent",
                        "total": 1152.4431249999955,
                        "hasRDI": true,
                        "daily": 48.01846354166648,
                        "unit": "mg"
                    },
                    {
                        "label": "Calcium",
                        "tag": "CA",
                        "schemaOrgTag": null,
                        "total": 615.5056249987805,
                        "hasRDI": true,
                        "daily": 61.55056249987805,
                        "unit": "mg"
                    },
                    {
                        "label": "Magnesium",
                        "tag": "MG",
                        "schemaOrgTag": null,
                        "total": 541.058749998776,
                        "hasRDI": true,
                        "daily": 128.82351190447048,
                        "unit": "mg"
                    },
                    {
                        "label": "Potassium",
                        "tag": "K",
                        "schemaOrgTag": null,
                        "total": 3056.843624996677,
                        "hasRDI": true,
                        "daily": 65.03922606375909,
                        "unit": "mg"
                    },
                    {
                        "label": "Iron",
                        "tag": "FE",
                        "schemaOrgTag": null,
                        "total": 18.666393749983182,
                        "hasRDI": true,
                        "daily": 103.70218749990657,
                        "unit": "mg"
                    },
                    {
                        "label": "Zinc",
                        "tag": "ZN",
                        "schemaOrgTag": null,
                        "total": 9.569109999985855,
                        "hasRDI": true,
                        "daily": 86.99190909078051,
                        "unit": "mg"
                    },
                    {
                        "label": "Phosphorus",
                        "tag": "P",
                        "schemaOrgTag": null,
                        "total": 1365.4201249978198,
                        "hasRDI": true,
                        "daily": 195.06001785683142,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin A",
                        "tag": "VITA_RAE",
                        "schemaOrgTag": null,
                        "total": 1449.7300000000002,
                        "hasRDI": true,
                        "daily": 161.08111111111114,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin C",
                        "tag": "VITC",
                        "schemaOrgTag": null,
                        "total": 181.56099999999998,
                        "hasRDI": true,
                        "daily": 201.73444444444442,
                        "unit": "mg"
                    },
                    {
                        "label": "Thiamin (B1)",
                        "tag": "THIA",
                        "schemaOrgTag": null,
                        "total": 1.2838616249990706,
                        "hasRDI": true,
                        "daily": 106.98846874992256,
                        "unit": "mg"
                    },
                    {
                        "label": "Riboflavin (B2)",
                        "tag": "RIBF",
                        "schemaOrgTag": null,
                        "total": 1.9984792499948412,
                        "hasRDI": true,
                        "daily": 153.72917307652625,
                        "unit": "mg"
                    },
                    {
                        "label": "Niacin (B3)",
                        "tag": "NIA",
                        "schemaOrgTag": null,
                        "total": 13.8486862499836,
                        "hasRDI": true,
                        "daily": 86.5542890623975,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin B6",
                        "tag": "VITB6A",
                        "schemaOrgTag": null,
                        "total": 1.9323581249993793,
                        "hasRDI": true,
                        "daily": 148.64293269225993,
                        "unit": "mg"
                    },
                    {
                        "label": "Folate equivalent (total)",
                        "tag": "FOLDFE",
                        "schemaOrgTag": null,
                        "total": 564.9854999998006,
                        "hasRDI": true,
                        "daily": 141.24637499995015,
                        "unit": "µg"
                    },
                    {
                        "label": "Folate (food)",
                        "tag": "FOLFD",
                        "schemaOrgTag": null,
                        "total": 564.9854999998006,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Folic acid",
                        "tag": "FOLAC",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin B12",
                        "tag": "VITB12",
                        "schemaOrgTag": null,
                        "total": 0.63375,
                        "hasRDI": true,
                        "daily": 26.40625,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin D",
                        "tag": "VITD",
                        "schemaOrgTag": null,
                        "total": 0.15000000000000002,
                        "hasRDI": true,
                        "daily": 1.0000000000000002,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin E",
                        "tag": "TOCPHA",
                        "schemaOrgTag": null,
                        "total": 16.50910374988381,
                        "hasRDI": true,
                        "daily": 110.06069166589207,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin K",
                        "tag": "VITK1",
                        "schemaOrgTag": null,
                        "total": 879.7950000000001,
                        "hasRDI": true,
                        "daily": 733.1625,
                        "unit": "µg"
                    },
                    {
                        "label": "Sugar alcohols",
                        "tag": "Sugar.alcohol",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    },
                    {
                        "label": "Water",
                        "tag": "WATER",
                        "schemaOrgTag": null,
                        "total": 1213.11651124998,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    }
                ]
            },
            "_links": {
                "self": {
                    "href": "https://api.edamam.com/api/recipes/v2/0f4ef6f5fb420dc465d7f4a83120f340?type=public&app_id=ea1d37d5&app_key=fd382a172ba8d6668c0430dc9c14a181",
                    "title": "Self"
                }
            }
        },
        {
            "recipe": {
                "uri": "http://www.edamam.com/ontologies/edamam.owl#recipe_7db5997d6132896155b9ebeb0bc596ad",
                "label": "Steak & chips salad",
                "image": "https://www.edamam.com/web-img/4a2/4a2bc6e663b5fb8fcc91f425398ef0f0.jpg",
                "source": "BBC Good Food",
                "url": "https://www.bbcgoodfood.com/recipes/steak-chips-salad",
                "shareAs": "http://www.edamam.com/recipe/steak-chips-salad-7db5997d6132896155b9ebeb0bc596ad/salad",
                "yield": 4,
                "dietLabels": [
                    "High-Fiber",
                    "Low-Sodium"
                ],
                "healthLabels": [
                    "Sugar-Conscious",
                    "Dairy-Free",
                    "Gluten-Free",
                    "Wheat-Free",
                    "Egg-Free",
                    "Peanut-Free",
                    "Tree-Nut-Free",
                    "Soy-Free",
                    "Fish-Free",
                    "Shellfish-Free",
                    "Pork-Free",
                    "Crustacean-Free",
                    "Celery-Free",
                    "Sesame-Free",
                    "Lupine-Free",
                    "Mollusk-Free",
                    "Alcohol-Free"
                ],
                "cautions": [
                    "Sulfites",
                    "FODMAP"
                ],
                "ingredientLines": [
                    "750g bag frozen potato wedges",
                    "1 tbsp olive oil",
                    "2 pieces sirloin steak , about 350g/12oz in total",
                    "120g bag herb salad",
                    "6 tbsp honey and mustard salad dressing , bought or homemade"
                ],
                "ingredients": [
                    {
                        "text": "750g bag frozen potato wedges",
                        "weight": 750,
                        "foodCategory": "vegetables",
                        "foodId": "food_abiw5baauresjmb6xpap2bg3otzu",
                        "image": "https://www.edamam.com/food-img/651/6512e82417bce15c2899630c1a2799df.jpg"
                    },
                    {
                        "text": "1 tbsp olive oil",
                        "weight": 13.5,
                        "foodCategory": "Oils",
                        "foodId": "food_b1d1icuad3iktrbqby0hiagafaz7",
                        "image": "https://www.edamam.com/food-img/4d6/4d651eaa8a353647746290c7a9b29d84.jpg"
                    },
                    {
                        "text": "2 pieces sirloin steak , about 350g/12oz in total",
                        "weight": 680,
                        "foodCategory": "meats",
                        "foodId": "food_aifm62daw1i6txalya881bcetyzn",
                        "image": "https://www.edamam.com/food-img/4f1/4f10105d5c8178f25590ca6dfcd37fca.jpg"
                    },
                    {
                        "text": "120g bag herb salad",
                        "weight": 120,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_avsq22zadwyb5cb5sl1byaa4mbo8",
                        "image": "https://www.edamam.com/food-img/89b/89b37a04e46e052671d73addcb84aa51.jpg"
                    },
                    {
                        "text": "6 tbsp honey and mustard salad dressing , bought or homemade",
                        "weight": 96,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_a67f1v3boelh4wasob4qib34t5bv",
                        "image": "https://www.edamam.com/food-img/241/24178db68d42001caf980f8f209534cb.jpg"
                    }
                ],
                "calories": 2914.2799999999997,
                "totalWeight": 1659.5,
                "totalTime": 0,
                "cuisineType": [
                    "american"
                ],
                "mealType": [
                    "lunch/dinner"
                ],
                "dishType": [
                    "salad"
                ],
                "totalNutrients": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 2914.2799999999997,
                        "unit": "kcal"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 168.291,
                        "unit": "g"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 53.25948,
                        "unit": "g"
                    },
                    "FAMS": {
                        "label": "Monounsaturated",
                        "quantity": 66.21873500000001,
                        "unit": "g"
                    },
                    "FAPU": {
                        "label": "Polyunsaturated",
                        "quantity": 29.999505,
                        "unit": "g"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 210.153,
                        "unit": "g"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 60.9,
                        "unit": "g"
                    },
                    "SUGAR": {
                        "label": "Sugars",
                        "quantity": 10.302000000000001,
                        "unit": "g"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 161.538,
                        "unit": "g"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 530.4,
                        "unit": "mg"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 459.03,
                        "unit": "mg"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 2528.135,
                        "unit": "mg"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 572.5,
                        "unit": "mg"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 6243.3150000000005,
                        "unit": "mg"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 164.1736,
                        "unit": "mg"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 33.867,
                        "unit": "mg"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 1899.5,
                        "unit": "mg"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 228,
                        "unit": "µg"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 207.75,
                        "unit": "mg"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 1.576,
                        "unit": "mg"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 1.29,
                        "unit": "mg"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 57.522999999999996,
                        "unit": "mg"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 6.5173000000000005,
                        "unit": "mg"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 523.6,
                        "unit": "µg"
                    },
                    "FOLFD": {
                        "label": "Folate (food)",
                        "quantity": 523.6,
                        "unit": "µg"
                    },
                    "FOLAC": {
                        "label": "Folic acid",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 7.548,
                        "unit": "µg"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 17.929850000000002,
                        "unit": "mg"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 2184.825,
                        "unit": "µg"
                    },
                    "WATER": {
                        "label": "Water",
                        "quantity": 1091.018,
                        "unit": "g"
                    }
                },
                "totalDaily": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 145.714,
                        "unit": "%"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 258.90923076923076,
                        "unit": "%"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 266.29740000000004,
                        "unit": "%"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 70.051,
                        "unit": "%"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 243.6,
                        "unit": "%"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 323.076,
                        "unit": "%"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 176.8,
                        "unit": "%"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 19.12625,
                        "unit": "%"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 252.81350000000003,
                        "unit": "%"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 136.3095238095238,
                        "unit": "%"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 132.83648936170212,
                        "unit": "%"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 912.0755555555556,
                        "unit": "%"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 307.8818181818182,
                        "unit": "%"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 271.35714285714283,
                        "unit": "%"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 25.333333333333332,
                        "unit": "%"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 230.83333333333334,
                        "unit": "%"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 131.33333333333334,
                        "unit": "%"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 99.23076923076923,
                        "unit": "%"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 359.51874999999995,
                        "unit": "%"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 501.33076923076925,
                        "unit": "%"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 130.9,
                        "unit": "%"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 314.5,
                        "unit": "%"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 0,
                        "unit": "%"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 119.53233333333334,
                        "unit": "%"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 1820.6874999999998,
                        "unit": "%"
                    }
                },
                "digest": [
                    {
                        "label": "Fat",
                        "tag": "FAT",
                        "schemaOrgTag": "fatContent",
                        "total": 168.291,
                        "hasRDI": true,
                        "daily": 258.90923076923076,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Saturated",
                                "tag": "FASAT",
                                "schemaOrgTag": "saturatedFatContent",
                                "total": 53.25948,
                                "hasRDI": true,
                                "daily": 266.29740000000004,
                                "unit": "g"
                            },
                            {
                                "label": "Trans",
                                "tag": "FATRN",
                                "schemaOrgTag": "transFatContent",
                                "total": 0,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Monounsaturated",
                                "tag": "FAMS",
                                "schemaOrgTag": null,
                                "total": 66.21873500000001,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Polyunsaturated",
                                "tag": "FAPU",
                                "schemaOrgTag": null,
                                "total": 29.999505,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Carbs",
                        "tag": "CHOCDF",
                        "schemaOrgTag": "carbohydrateContent",
                        "total": 210.153,
                        "hasRDI": true,
                        "daily": 70.051,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Carbs (net)",
                                "tag": "CHOCDF.net",
                                "schemaOrgTag": null,
                                "total": 149.253,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Fiber",
                                "tag": "FIBTG",
                                "schemaOrgTag": "fiberContent",
                                "total": 60.9,
                                "hasRDI": true,
                                "daily": 243.6,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars",
                                "tag": "SUGAR",
                                "schemaOrgTag": "sugarContent",
                                "total": 10.302000000000001,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars, added",
                                "tag": "SUGAR.added",
                                "schemaOrgTag": null,
                                "total": 0,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Protein",
                        "tag": "PROCNT",
                        "schemaOrgTag": "proteinContent",
                        "total": 161.538,
                        "hasRDI": true,
                        "daily": 323.076,
                        "unit": "g"
                    },
                    {
                        "label": "Cholesterol",
                        "tag": "CHOLE",
                        "schemaOrgTag": "cholesterolContent",
                        "total": 530.4,
                        "hasRDI": true,
                        "daily": 176.8,
                        "unit": "mg"
                    },
                    {
                        "label": "Sodium",
                        "tag": "NA",
                        "schemaOrgTag": "sodiumContent",
                        "total": 459.03,
                        "hasRDI": true,
                        "daily": 19.12625,
                        "unit": "mg"
                    },
                    {
                        "label": "Calcium",
                        "tag": "CA",
                        "schemaOrgTag": null,
                        "total": 2528.135,
                        "hasRDI": true,
                        "daily": 252.81350000000003,
                        "unit": "mg"
                    },
                    {
                        "label": "Magnesium",
                        "tag": "MG",
                        "schemaOrgTag": null,
                        "total": 572.5,
                        "hasRDI": true,
                        "daily": 136.3095238095238,
                        "unit": "mg"
                    },
                    {
                        "label": "Potassium",
                        "tag": "K",
                        "schemaOrgTag": null,
                        "total": 6243.3150000000005,
                        "hasRDI": true,
                        "daily": 132.83648936170212,
                        "unit": "mg"
                    },
                    {
                        "label": "Iron",
                        "tag": "FE",
                        "schemaOrgTag": null,
                        "total": 164.1736,
                        "hasRDI": true,
                        "daily": 912.0755555555556,
                        "unit": "mg"
                    },
                    {
                        "label": "Zinc",
                        "tag": "ZN",
                        "schemaOrgTag": null,
                        "total": 33.867,
                        "hasRDI": true,
                        "daily": 307.8818181818182,
                        "unit": "mg"
                    },
                    {
                        "label": "Phosphorus",
                        "tag": "P",
                        "schemaOrgTag": null,
                        "total": 1899.5,
                        "hasRDI": true,
                        "daily": 271.35714285714283,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin A",
                        "tag": "VITA_RAE",
                        "schemaOrgTag": null,
                        "total": 228,
                        "hasRDI": true,
                        "daily": 25.333333333333332,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin C",
                        "tag": "VITC",
                        "schemaOrgTag": null,
                        "total": 207.75,
                        "hasRDI": true,
                        "daily": 230.83333333333334,
                        "unit": "mg"
                    },
                    {
                        "label": "Thiamin (B1)",
                        "tag": "THIA",
                        "schemaOrgTag": null,
                        "total": 1.576,
                        "hasRDI": true,
                        "daily": 131.33333333333334,
                        "unit": "mg"
                    },
                    {
                        "label": "Riboflavin (B2)",
                        "tag": "RIBF",
                        "schemaOrgTag": null,
                        "total": 1.29,
                        "hasRDI": true,
                        "daily": 99.23076923076923,
                        "unit": "mg"
                    },
                    {
                        "label": "Niacin (B3)",
                        "tag": "NIA",
                        "schemaOrgTag": null,
                        "total": 57.522999999999996,
                        "hasRDI": true,
                        "daily": 359.51874999999995,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin B6",
                        "tag": "VITB6A",
                        "schemaOrgTag": null,
                        "total": 6.5173000000000005,
                        "hasRDI": true,
                        "daily": 501.33076923076925,
                        "unit": "mg"
                    },
                    {
                        "label": "Folate equivalent (total)",
                        "tag": "FOLDFE",
                        "schemaOrgTag": null,
                        "total": 523.6,
                        "hasRDI": true,
                        "daily": 130.9,
                        "unit": "µg"
                    },
                    {
                        "label": "Folate (food)",
                        "tag": "FOLFD",
                        "schemaOrgTag": null,
                        "total": 523.6,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Folic acid",
                        "tag": "FOLAC",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin B12",
                        "tag": "VITB12",
                        "schemaOrgTag": null,
                        "total": 7.548,
                        "hasRDI": true,
                        "daily": 314.5,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin D",
                        "tag": "VITD",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": true,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin E",
                        "tag": "TOCPHA",
                        "schemaOrgTag": null,
                        "total": 17.929850000000002,
                        "hasRDI": true,
                        "daily": 119.53233333333334,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin K",
                        "tag": "VITK1",
                        "schemaOrgTag": null,
                        "total": 2184.825,
                        "hasRDI": true,
                        "daily": 1820.6874999999998,
                        "unit": "µg"
                    },
                    {
                        "label": "Sugar alcohols",
                        "tag": "Sugar.alcohol",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    },
                    {
                        "label": "Water",
                        "tag": "WATER",
                        "schemaOrgTag": null,
                        "total": 1091.018,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    }
                ]
            },
            "_links": {
                "self": {
                    "href": "https://api.edamam.com/api/recipes/v2/7db5997d6132896155b9ebeb0bc596ad?type=public&app_id=ea1d37d5&app_key=fd382a172ba8d6668c0430dc9c14a181",
                    "title": "Self"
                }
            }
        },
        {
            "recipe": {
                "uri": "http://www.edamam.com/ontologies/edamam.owl#recipe_1aae863595a9c94fe1c0a34b39abb03a",
                "label": "Radicchio, Fennel & Pear Salad",
                "image": "https://www.edamam.com/web-img/15e/15e56a86571b33cb9bef98d23b7fb31a.jpg",
                "source": "Whole Foods",
                "url": "http://www.wholefoodsmarket.com/recipes/2668",
                "shareAs": "http://www.edamam.com/recipe/radicchio-fennel-pear-salad-1aae863595a9c94fe1c0a34b39abb03a/salad",
                "yield": 4,
                "dietLabels": [
                    "High-Fiber",
                    "Low-Sodium"
                ],
                "healthLabels": [
                    "Vegan",
                    "Vegetarian",
                    "Pescatarian",
                    "DASH",
                    "Dairy-Free",
                    "Gluten-Free",
                    "Wheat-Free",
                    "Egg-Free",
                    "Peanut-Free",
                    "Tree-Nut-Free",
                    "Soy-Free",
                    "Fish-Free",
                    "Shellfish-Free",
                    "Pork-Free",
                    "Red-Meat-Free",
                    "Crustacean-Free",
                    "Celery-Free",
                    "Sesame-Free",
                    "Lupine-Free",
                    "Mollusk-Free",
                    "Alcohol-Free",
                    "Sulfite-Free",
                    "Kosher"
                ],
                "cautions": [
                    "Sulfites",
                    "FODMAP"
                ],
                "ingredientLines": [
                    "1 bulb fennel, halved and thinly sliced",
                    "1/4 cup honey mustard dressing or other salad dressing",
                    "1 head radicchio, cored, leaves torn into bite-size pieces",
                    "2 Bosc or Asian pears, cored and chopped",
                    "4 cups spring salad greens"
                ],
                "ingredients": [
                    {
                        "text": "1 bulb fennel, halved and thinly sliced",
                        "weight": 234,
                        "foodCategory": "vegetables",
                        "foodId": "food_a4sdbkob8ixokpb07a42dbt3typw",
                        "image": "https://www.edamam.com/food-img/038/038c19f86af781e925c97991e17b90ed.jpeg"
                    },
                    {
                        "text": "1/4 cup honey mustard dressing or other salad dressing",
                        "weight": 62.5,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_a67f1v3boelh4wasob4qib34t5bv",
                        "image": "https://www.edamam.com/food-img/241/24178db68d42001caf980f8f209534cb.jpg"
                    },
                    {
                        "text": "1 head radicchio, cored, leaves torn into bite-size pieces",
                        "weight": 120,
                        "foodCategory": "vegetables",
                        "foodId": "food_av0qglzbwy5sirb81jxfeavj2eoo",
                        "image": "https://www.edamam.com/food-img/fa6/fa6cd4d4541e9ea70cafd1f244f51597.jpeg"
                    },
                    {
                        "text": "2 Bosc or Asian pears, cored and chopped",
                        "weight": 372.8888888888889,
                        "foodCategory": "fruit",
                        "foodId": "food_bq6stkiaxkwhxia9q4v7wanjnew0",
                        "image": "https://www.edamam.com/food-img/65a/65aec51d264db28bbe27117c9fdaaca7.jpg"
                    },
                    {
                        "text": "4 cups spring salad greens",
                        "weight": 144,
                        "foodCategory": "vegetables",
                        "foodId": "food_bqalyxzbzu04hcb8xj930bzar7xg",
                        "image": "https://www.edamam.com/food-img/b6d/b6d9f3052d27a3c71220cfa55c6f0a42.jpg"
                    }
                ],
                "calories": 614.9116666666667,
                "totalWeight": 933.3888888888889,
                "totalTime": 0,
                "cuisineType": [
                    "asian"
                ],
                "mealType": [
                    "lunch/dinner"
                ],
                "dishType": [
                    "salad"
                ],
                "totalNutrients": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 614.9116666666667,
                        "unit": "kcal"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 32.81854444444445,
                        "unit": "g"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 6.080935555555556,
                        "unit": "g"
                    },
                    "FAMS": {
                        "label": "Monounsaturated",
                        "quantity": 9.742986666666667,
                        "unit": "g"
                    },
                    "FAPU": {
                        "label": "Polyunsaturated",
                        "quantity": 16.058555555555554,
                        "unit": "g"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 84.94427777777778,
                        "unit": "g"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 21.765555555555558,
                        "unit": "g"
                    },
                    "SUGAR": {
                        "label": "Sugars",
                        "quantity": 48.95856666666667,
                        "unit": "g"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 7.918399999999999,
                        "unit": "g"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 0,
                        "unit": "mg"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 192.75388888888887,
                        "unit": "mg"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 222.86,
                        "unit": "mg"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 100.20222222222222,
                        "unit": "mg"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 2048.071111111111,
                        "unit": "mg"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 4.3018,
                        "unit": "mg"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 1.8440888888888889,
                        "unit": "mg"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 251.50666666666666,
                        "unit": "mg"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 650.0488888888889,
                        "unit": "µg"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 66.96222222222222,
                        "unit": "mg"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 0.18814666666666668,
                        "unit": "mg"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 0.3206311111111111,
                        "unit": "mg"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 2.943951111111111,
                        "unit": "mg"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 0.41611777777777775,
                        "unit": "mg"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 216.00222222222223,
                        "unit": "µg"
                    },
                    "FOLFD": {
                        "label": "Folate (food)",
                        "quantity": 216.00222222222223,
                        "unit": "µg"
                    },
                    "FOLAC": {
                        "label": "Folic acid",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 7.714716666666667,
                        "unit": "mg"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 713.2211111111111,
                        "unit": "µg"
                    },
                    "WATER": {
                        "label": "Water",
                        "quantity": 802.3331111111111,
                        "unit": "g"
                    }
                },
                "totalDaily": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 30.745583333333336,
                        "unit": "%"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 50.49006837606838,
                        "unit": "%"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 30.404677777777785,
                        "unit": "%"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 28.31475925925926,
                        "unit": "%"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 87.06222222222223,
                        "unit": "%"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 15.836799999999998,
                        "unit": "%"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 0,
                        "unit": "%"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 8.031412037037036,
                        "unit": "%"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 22.286,
                        "unit": "%"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 23.857671957671958,
                        "unit": "%"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 43.575981087470446,
                        "unit": "%"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 23.89888888888889,
                        "unit": "%"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 16.764444444444447,
                        "unit": "%"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 35.92952380952381,
                        "unit": "%"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 72.22765432098765,
                        "unit": "%"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 74.40246913580248,
                        "unit": "%"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 15.67888888888889,
                        "unit": "%"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 24.663931623931624,
                        "unit": "%"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 18.399694444444446,
                        "unit": "%"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 32.00905982905982,
                        "unit": "%"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 54.00055555555556,
                        "unit": "%"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 0,
                        "unit": "%"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 0,
                        "unit": "%"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 51.431444444444445,
                        "unit": "%"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 594.3509259259259,
                        "unit": "%"
                    }
                },
                "digest": [
                    {
                        "label": "Fat",
                        "tag": "FAT",
                        "schemaOrgTag": "fatContent",
                        "total": 32.81854444444445,
                        "hasRDI": true,
                        "daily": 50.49006837606838,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Saturated",
                                "tag": "FASAT",
                                "schemaOrgTag": "saturatedFatContent",
                                "total": 6.080935555555556,
                                "hasRDI": true,
                                "daily": 30.404677777777785,
                                "unit": "g"
                            },
                            {
                                "label": "Trans",
                                "tag": "FATRN",
                                "schemaOrgTag": "transFatContent",
                                "total": 0,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Monounsaturated",
                                "tag": "FAMS",
                                "schemaOrgTag": null,
                                "total": 9.742986666666667,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Polyunsaturated",
                                "tag": "FAPU",
                                "schemaOrgTag": null,
                                "total": 16.058555555555554,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Carbs",
                        "tag": "CHOCDF",
                        "schemaOrgTag": "carbohydrateContent",
                        "total": 84.94427777777778,
                        "hasRDI": true,
                        "daily": 28.31475925925926,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Carbs (net)",
                                "tag": "CHOCDF.net",
                                "schemaOrgTag": null,
                                "total": 63.17872222222223,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Fiber",
                                "tag": "FIBTG",
                                "schemaOrgTag": "fiberContent",
                                "total": 21.765555555555558,
                                "hasRDI": true,
                                "daily": 87.06222222222223,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars",
                                "tag": "SUGAR",
                                "schemaOrgTag": "sugarContent",
                                "total": 48.95856666666667,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars, added",
                                "tag": "SUGAR.added",
                                "schemaOrgTag": null,
                                "total": 0,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Protein",
                        "tag": "PROCNT",
                        "schemaOrgTag": "proteinContent",
                        "total": 7.918399999999999,
                        "hasRDI": true,
                        "daily": 15.836799999999998,
                        "unit": "g"
                    },
                    {
                        "label": "Cholesterol",
                        "tag": "CHOLE",
                        "schemaOrgTag": "cholesterolContent",
                        "total": 0,
                        "hasRDI": true,
                        "daily": 0,
                        "unit": "mg"
                    },
                    {
                        "label": "Sodium",
                        "tag": "NA",
                        "schemaOrgTag": "sodiumContent",
                        "total": 192.75388888888887,
                        "hasRDI": true,
                        "daily": 8.031412037037036,
                        "unit": "mg"
                    },
                    {
                        "label": "Calcium",
                        "tag": "CA",
                        "schemaOrgTag": null,
                        "total": 222.86,
                        "hasRDI": true,
                        "daily": 22.286,
                        "unit": "mg"
                    },
                    {
                        "label": "Magnesium",
                        "tag": "MG",
                        "schemaOrgTag": null,
                        "total": 100.20222222222222,
                        "hasRDI": true,
                        "daily": 23.857671957671958,
                        "unit": "mg"
                    },
                    {
                        "label": "Potassium",
                        "tag": "K",
                        "schemaOrgTag": null,
                        "total": 2048.071111111111,
                        "hasRDI": true,
                        "daily": 43.575981087470446,
                        "unit": "mg"
                    },
                    {
                        "label": "Iron",
                        "tag": "FE",
                        "schemaOrgTag": null,
                        "total": 4.3018,
                        "hasRDI": true,
                        "daily": 23.89888888888889,
                        "unit": "mg"
                    },
                    {
                        "label": "Zinc",
                        "tag": "ZN",
                        "schemaOrgTag": null,
                        "total": 1.8440888888888889,
                        "hasRDI": true,
                        "daily": 16.764444444444447,
                        "unit": "mg"
                    },
                    {
                        "label": "Phosphorus",
                        "tag": "P",
                        "schemaOrgTag": null,
                        "total": 251.50666666666666,
                        "hasRDI": true,
                        "daily": 35.92952380952381,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin A",
                        "tag": "VITA_RAE",
                        "schemaOrgTag": null,
                        "total": 650.0488888888889,
                        "hasRDI": true,
                        "daily": 72.22765432098765,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin C",
                        "tag": "VITC",
                        "schemaOrgTag": null,
                        "total": 66.96222222222222,
                        "hasRDI": true,
                        "daily": 74.40246913580248,
                        "unit": "mg"
                    },
                    {
                        "label": "Thiamin (B1)",
                        "tag": "THIA",
                        "schemaOrgTag": null,
                        "total": 0.18814666666666668,
                        "hasRDI": true,
                        "daily": 15.67888888888889,
                        "unit": "mg"
                    },
                    {
                        "label": "Riboflavin (B2)",
                        "tag": "RIBF",
                        "schemaOrgTag": null,
                        "total": 0.3206311111111111,
                        "hasRDI": true,
                        "daily": 24.663931623931624,
                        "unit": "mg"
                    },
                    {
                        "label": "Niacin (B3)",
                        "tag": "NIA",
                        "schemaOrgTag": null,
                        "total": 2.943951111111111,
                        "hasRDI": true,
                        "daily": 18.399694444444446,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin B6",
                        "tag": "VITB6A",
                        "schemaOrgTag": null,
                        "total": 0.41611777777777775,
                        "hasRDI": true,
                        "daily": 32.00905982905982,
                        "unit": "mg"
                    },
                    {
                        "label": "Folate equivalent (total)",
                        "tag": "FOLDFE",
                        "schemaOrgTag": null,
                        "total": 216.00222222222223,
                        "hasRDI": true,
                        "daily": 54.00055555555556,
                        "unit": "µg"
                    },
                    {
                        "label": "Folate (food)",
                        "tag": "FOLFD",
                        "schemaOrgTag": null,
                        "total": 216.00222222222223,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Folic acid",
                        "tag": "FOLAC",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin B12",
                        "tag": "VITB12",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": true,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin D",
                        "tag": "VITD",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": true,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin E",
                        "tag": "TOCPHA",
                        "schemaOrgTag": null,
                        "total": 7.714716666666667,
                        "hasRDI": true,
                        "daily": 51.431444444444445,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin K",
                        "tag": "VITK1",
                        "schemaOrgTag": null,
                        "total": 713.2211111111111,
                        "hasRDI": true,
                        "daily": 594.3509259259259,
                        "unit": "µg"
                    },
                    {
                        "label": "Sugar alcohols",
                        "tag": "Sugar.alcohol",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    },
                    {
                        "label": "Water",
                        "tag": "WATER",
                        "schemaOrgTag": null,
                        "total": 802.3331111111111,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    }
                ]
            },
            "_links": {
                "self": {
                    "href": "https://api.edamam.com/api/recipes/v2/1aae863595a9c94fe1c0a34b39abb03a?type=public&app_id=ea1d37d5&app_key=fd382a172ba8d6668c0430dc9c14a181",
                    "title": "Self"
                }
            }
        },
        {
            "recipe": {
                "uri": "http://www.edamam.com/ontologies/edamam.owl#recipe_bd76f186805e4a9f4312516038f07e0e",
                "label": "Chicken Salad With Mango & Basil",
                "image": "https://www.edamam.com/web-img/a44/a44d07f61756a1be3766687067e5eb36.jpg",
                "source": "San Francisco Gate",
                "url": "http://www.sfgate.com/food/recipes/detail.html?rid=14131&sorig=qs",
                "shareAs": "http://www.edamam.com/recipe/chicken-salad-with-mango-basil-bd76f186805e4a9f4312516038f07e0e/salad",
                "yield": 8,
                "dietLabels": [],
                "healthLabels": [
                    "Dairy-Free",
                    "Egg-Free",
                    "Peanut-Free",
                    "Tree-Nut-Free",
                    "Soy-Free",
                    "Fish-Free",
                    "Shellfish-Free",
                    "Pork-Free",
                    "Red-Meat-Free",
                    "Crustacean-Free",
                    "Celery-Free",
                    "Mustard-Free",
                    "Sesame-Free",
                    "Lupine-Free",
                    "Mollusk-Free",
                    "Kosher"
                ],
                "cautions": [
                    "Sulfites"
                ],
                "ingredientLines": [
                    "Dressing:",
                    "1 small cooked rotisserie chicken (about 1 1/2 pounds)",
                    "3 tablespoons red wine or raspberry vinegar",
                    "3 tablespoons fresh basil, minced",
                    "Pinch sugar",
                    "3 tablespoons vegetable oil",
                    "Salt and pepper, to taste",
                    "Salad:",
                    "1 mango, mostly ripe but still firm",
                    "10-ounce bag hearty salad mix, including radicchio",
                    "1 1/2 cups garlic croutons"
                ],
                "ingredients": [
                    {
                        "text": "1 small cooked rotisserie chicken (about 1 1/2 pounds)",
                        "weight": 680.388555,
                        "foodCategory": "Poultry",
                        "foodId": "food_bmyxrshbfao9s1amjrvhoauob6mo",
                        "image": "https://www.edamam.com/food-img/d33/d338229d774a743f7858f6764e095878.jpg"
                    },
                    {
                        "text": "3 tablespoons red wine or raspberry vinegar",
                        "weight": 44.0999999992544,
                        "foodCategory": "wines",
                        "foodId": "food_b5q0xv2ba8la5hbzdfzdgaca3fwu",
                        "image": "https://www.edamam.com/food-img/82b/82b8d0db2d5c38fc7498a657c0afc4ee.JPG"
                    },
                    {
                        "text": "3 tablespoons fresh basil, minced",
                        "weight": 7.949999999999999,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_bfeht3obd58c3gak5ehpibxgbbs6",
                        "image": "https://www.edamam.com/food-img/5f1/5f1b05685ac2b404236a5d1c1f3c8c10.jpg"
                    },
                    {
                        "text": "Pinch sugar",
                        "weight": 0.2604166669968817,
                        "foodCategory": "sugars",
                        "foodId": "food_axi2ijobrk819yb0adceobnhm1c2",
                        "image": "https://www.edamam.com/food-img/ecb/ecb3f5aaed96d0188c21b8369be07765.jpg"
                    },
                    {
                        "text": "3 tablespoons vegetable oil",
                        "weight": 42,
                        "foodCategory": "Oils",
                        "foodId": "food_bt1mzi2ah2sfg8bv7no1qai83w8s",
                        "image": "https://www.edamam.com/food-img/6e5/6e51a63a6300a8ea1b4c4cc68dfaba33.jpg"
                    },
                    {
                        "text": "Salt and pepper, to taste",
                        "weight": 8.725165217497509,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_btxz81db72hwbra2pncvebzzzum9",
                        "image": "https://www.edamam.com/food-img/694/6943ea510918c6025795e8dc6e6eaaeb.jpg"
                    },
                    {
                        "text": "Salt and pepper, to taste",
                        "weight": 4.362582608748754,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_b6ywzluaaxv02wad7s1r9ag4py89",
                        "image": "https://www.edamam.com/food-img/c6e/c6e5c3bd8d3bc15175d9766971a4d1b2.jpg"
                    },
                    {
                        "text": "1 mango, mostly ripe but still firm",
                        "weight": 336,
                        "foodCategory": "fruit",
                        "foodId": "food_an1dqoib8xj3tyb3pr7c0abi4rbw",
                        "image": "https://www.edamam.com/food-img/6e0/6e04857756d0876f14bfc035ff238e0b.png"
                    },
                    {
                        "text": "10-ounce bag hearty salad mix, including radicchio",
                        "weight": 283.49523125,
                        "foodCategory": "vegetables",
                        "foodId": "food_bqalyxzbzu04hcb8xj930bzar7xg",
                        "image": "https://www.edamam.com/food-img/b6d/b6d9f3052d27a3c71220cfa55c6f0a42.jpg"
                    },
                    {
                        "text": "1 1/2 cups garlic croutons",
                        "weight": 60,
                        "foodCategory": "bread, rolls and tortillas",
                        "foodId": "food_ad9psyqap98pmrar3z9qvaw0qpio",
                        "image": "https://www.edamam.com/food-img/6f2/6f298bb7171f1c62384d9489bb60d45a.jpg"
                    }
                ],
                "calories": 1940.4037469461034,
                "totalWeight": 1464.5655679595536,
                "totalTime": 0,
                "cuisineType": [
                    "american"
                ],
                "mealType": [
                    "lunch/dinner"
                ],
                "dishType": [
                    "salad"
                ],
                "totalNutrients": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 1940.4037469461034,
                        "unit": "kcal"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 124.5523741803602,
                        "unit": "g"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 26.253453466103775,
                        "unit": "g"
                    },
                    "FATRN": {
                        "label": "Trans",
                        "quantity": 0.770924290878,
                        "unit": "g"
                    },
                    "FAMS": {
                        "label": "Monounsaturated",
                        "quantity": 65.33191236511365,
                        "unit": "g"
                    },
                    "FAPU": {
                        "label": "Polyunsaturated",
                        "quantity": 24.09150438608031,
                        "unit": "g"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 100.98103429881385,
                        "unit": "g"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 13.292371406263435,
                        "unit": "g"
                    },
                    "SUGAR": {
                        "label": "Sugars",
                        "quantity": 51.33994916610426,
                        "unit": "g"
                    },
                    "SUGAR.added": {
                        "label": "Sugars, added",
                        "quantity": 0.25989583366288793,
                        "unit": "g"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 99.8808469144485,
                        "unit": "g"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 351.19816304999995,
                        "unit": "mg"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 3391.8446336026777,
                        "unit": "mg"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 285.8818000716602,
                        "unit": "mg"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 206.08732762771643,
                        "unit": "mg"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 2235.420253308428,
                        "unit": "mg"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 9.730077907023599,
                        "unit": "mg"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 7.62167722133432,
                        "unit": "mg"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 914.8578971621514,
                        "unit": "mg"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 1446.430582063362,
                        "unit": "µg"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 157.21918875339998,
                        "unit": "mg"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 0.8833447815324114,
                        "unit": "mg"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 1.1898883737422459,
                        "unit": "mg"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 37.78469786177782,
                        "unit": "mg"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 2.374265084416034,
                        "unit": "mg"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 377.15667996247987,
                        "unit": "µg"
                    },
                    "FOLFD": {
                        "label": "Folate (food)",
                        "quantity": 310.55667996247985,
                        "unit": "µg"
                    },
                    "FOLAC": {
                        "label": "Folic acid",
                        "quantity": 39,
                        "unit": "µg"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 1.51825907394,
                        "unit": "µg"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 0.9253284347999999,
                        "unit": "µg"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 14.540653020080988,
                        "unit": "mg"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 423.96098806026873,
                        "unit": "µg"
                    },
                    "WATER": {
                        "label": "Water",
                        "quantity": 903.1779951441175,
                        "unit": "g"
                    }
                },
                "totalDaily": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 97.02018734730517,
                        "unit": "%"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 191.61903720055415,
                        "unit": "%"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 131.26726733051888,
                        "unit": "%"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 33.66034476627128,
                        "unit": "%"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 53.16948562505374,
                        "unit": "%"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 199.761693828897,
                        "unit": "%"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 117.06605434999997,
                        "unit": "%"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 141.3268597334449,
                        "unit": "%"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 28.58818000716602,
                        "unit": "%"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 49.06841133993249,
                        "unit": "%"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 47.562133049115495,
                        "unit": "%"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 54.055988372353326,
                        "unit": "%"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 69.28797473940291,
                        "unit": "%"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 130.69398530887875,
                        "unit": "%"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 160.71450911815134,
                        "unit": "%"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 174.68798750377775,
                        "unit": "%"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 73.61206512770094,
                        "unit": "%"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 91.52987490324968,
                        "unit": "%"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 236.1543616361114,
                        "unit": "%"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 182.6357757243103,
                        "unit": "%"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 94.28916999061998,
                        "unit": "%"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 63.26079474749999,
                        "unit": "%"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 6.1688562319999996,
                        "unit": "%"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 96.93768680053992,
                        "unit": "%"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 353.30082338355726,
                        "unit": "%"
                    }
                },
                "digest": [
                    {
                        "label": "Fat",
                        "tag": "FAT",
                        "schemaOrgTag": "fatContent",
                        "total": 124.5523741803602,
                        "hasRDI": true,
                        "daily": 191.61903720055415,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Saturated",
                                "tag": "FASAT",
                                "schemaOrgTag": "saturatedFatContent",
                                "total": 26.253453466103775,
                                "hasRDI": true,
                                "daily": 131.26726733051888,
                                "unit": "g"
                            },
                            {
                                "label": "Trans",
                                "tag": "FATRN",
                                "schemaOrgTag": "transFatContent",
                                "total": 0.770924290878,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Monounsaturated",
                                "tag": "FAMS",
                                "schemaOrgTag": null,
                                "total": 65.33191236511365,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Polyunsaturated",
                                "tag": "FAPU",
                                "schemaOrgTag": null,
                                "total": 24.09150438608031,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Carbs",
                        "tag": "CHOCDF",
                        "schemaOrgTag": "carbohydrateContent",
                        "total": 100.98103429881385,
                        "hasRDI": true,
                        "daily": 33.66034476627128,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Carbs (net)",
                                "tag": "CHOCDF.net",
                                "schemaOrgTag": null,
                                "total": 87.68866289255041,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Fiber",
                                "tag": "FIBTG",
                                "schemaOrgTag": "fiberContent",
                                "total": 13.292371406263435,
                                "hasRDI": true,
                                "daily": 53.16948562505374,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars",
                                "tag": "SUGAR",
                                "schemaOrgTag": "sugarContent",
                                "total": 51.33994916610426,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars, added",
                                "tag": "SUGAR.added",
                                "schemaOrgTag": null,
                                "total": 0.25989583366288793,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Protein",
                        "tag": "PROCNT",
                        "schemaOrgTag": "proteinContent",
                        "total": 99.8808469144485,
                        "hasRDI": true,
                        "daily": 199.761693828897,
                        "unit": "g"
                    },
                    {
                        "label": "Cholesterol",
                        "tag": "CHOLE",
                        "schemaOrgTag": "cholesterolContent",
                        "total": 351.19816304999995,
                        "hasRDI": true,
                        "daily": 117.06605434999997,
                        "unit": "mg"
                    },
                    {
                        "label": "Sodium",
                        "tag": "NA",
                        "schemaOrgTag": "sodiumContent",
                        "total": 3391.8446336026777,
                        "hasRDI": true,
                        "daily": 141.3268597334449,
                        "unit": "mg"
                    },
                    {
                        "label": "Calcium",
                        "tag": "CA",
                        "schemaOrgTag": null,
                        "total": 285.8818000716602,
                        "hasRDI": true,
                        "daily": 28.58818000716602,
                        "unit": "mg"
                    },
                    {
                        "label": "Magnesium",
                        "tag": "MG",
                        "schemaOrgTag": null,
                        "total": 206.08732762771643,
                        "hasRDI": true,
                        "daily": 49.06841133993249,
                        "unit": "mg"
                    },
                    {
                        "label": "Potassium",
                        "tag": "K",
                        "schemaOrgTag": null,
                        "total": 2235.420253308428,
                        "hasRDI": true,
                        "daily": 47.562133049115495,
                        "unit": "mg"
                    },
                    {
                        "label": "Iron",
                        "tag": "FE",
                        "schemaOrgTag": null,
                        "total": 9.730077907023599,
                        "hasRDI": true,
                        "daily": 54.055988372353326,
                        "unit": "mg"
                    },
                    {
                        "label": "Zinc",
                        "tag": "ZN",
                        "schemaOrgTag": null,
                        "total": 7.62167722133432,
                        "hasRDI": true,
                        "daily": 69.28797473940291,
                        "unit": "mg"
                    },
                    {
                        "label": "Phosphorus",
                        "tag": "P",
                        "schemaOrgTag": null,
                        "total": 914.8578971621514,
                        "hasRDI": true,
                        "daily": 130.69398530887875,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin A",
                        "tag": "VITA_RAE",
                        "schemaOrgTag": null,
                        "total": 1446.430582063362,
                        "hasRDI": true,
                        "daily": 160.71450911815134,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin C",
                        "tag": "VITC",
                        "schemaOrgTag": null,
                        "total": 157.21918875339998,
                        "hasRDI": true,
                        "daily": 174.68798750377775,
                        "unit": "mg"
                    },
                    {
                        "label": "Thiamin (B1)",
                        "tag": "THIA",
                        "schemaOrgTag": null,
                        "total": 0.8833447815324114,
                        "hasRDI": true,
                        "daily": 73.61206512770094,
                        "unit": "mg"
                    },
                    {
                        "label": "Riboflavin (B2)",
                        "tag": "RIBF",
                        "schemaOrgTag": null,
                        "total": 1.1898883737422459,
                        "hasRDI": true,
                        "daily": 91.52987490324968,
                        "unit": "mg"
                    },
                    {
                        "label": "Niacin (B3)",
                        "tag": "NIA",
                        "schemaOrgTag": null,
                        "total": 37.78469786177782,
                        "hasRDI": true,
                        "daily": 236.1543616361114,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin B6",
                        "tag": "VITB6A",
                        "schemaOrgTag": null,
                        "total": 2.374265084416034,
                        "hasRDI": true,
                        "daily": 182.6357757243103,
                        "unit": "mg"
                    },
                    {
                        "label": "Folate equivalent (total)",
                        "tag": "FOLDFE",
                        "schemaOrgTag": null,
                        "total": 377.15667996247987,
                        "hasRDI": true,
                        "daily": 94.28916999061998,
                        "unit": "µg"
                    },
                    {
                        "label": "Folate (food)",
                        "tag": "FOLFD",
                        "schemaOrgTag": null,
                        "total": 310.55667996247985,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Folic acid",
                        "tag": "FOLAC",
                        "schemaOrgTag": null,
                        "total": 39,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin B12",
                        "tag": "VITB12",
                        "schemaOrgTag": null,
                        "total": 1.51825907394,
                        "hasRDI": true,
                        "daily": 63.26079474749999,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin D",
                        "tag": "VITD",
                        "schemaOrgTag": null,
                        "total": 0.9253284347999999,
                        "hasRDI": true,
                        "daily": 6.1688562319999996,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin E",
                        "tag": "TOCPHA",
                        "schemaOrgTag": null,
                        "total": 14.540653020080988,
                        "hasRDI": true,
                        "daily": 96.93768680053992,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin K",
                        "tag": "VITK1",
                        "schemaOrgTag": null,
                        "total": 423.96098806026873,
                        "hasRDI": true,
                        "daily": 353.30082338355726,
                        "unit": "µg"
                    },
                    {
                        "label": "Sugar alcohols",
                        "tag": "Sugar.alcohol",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    },
                    {
                        "label": "Water",
                        "tag": "WATER",
                        "schemaOrgTag": null,
                        "total": 903.1779951441175,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    }
                ]
            },
            "_links": {
                "self": {
                    "href": "https://api.edamam.com/api/recipes/v2/bd76f186805e4a9f4312516038f07e0e?type=public&app_id=ea1d37d5&app_key=fd382a172ba8d6668c0430dc9c14a181",
                    "title": "Self"
                }
            }
        },
        {
            "recipe": {
                "uri": "http://www.edamam.com/ontologies/edamam.owl#recipe_903e3d14f32e06031851e102b3226073",
                "label": "Asparagus Sesame Salad",
                "image": "https://www.edamam.com/web-img/769/769ecb5881aa7e69a2e104fd8a1ef21b.jpg",
                "source": "Real Simple",
                "url": "https://www.realsimple.com/food-recipes/browse-all-recipes/asparagus-sesame-salad",
                "shareAs": "http://www.edamam.com/recipe/asparagus-sesame-salad-903e3d14f32e06031851e102b3226073/salad",
                "yield": 4,
                "dietLabels": [],
                "healthLabels": [
                    "Sugar-Conscious",
                    "Keto-Friendly",
                    "Vegan",
                    "Vegetarian",
                    "Pescatarian",
                    "Dairy-Free",
                    "Egg-Free",
                    "Peanut-Free",
                    "Tree-Nut-Free",
                    "Fish-Free",
                    "Shellfish-Free",
                    "Pork-Free",
                    "Red-Meat-Free",
                    "Crustacean-Free",
                    "Celery-Free",
                    "Mustard-Free",
                    "Lupine-Free",
                    "Mollusk-Free",
                    "Alcohol-Free",
                    "Kosher"
                ],
                "cautions": [],
                "ingredientLines": [
                    "1 pound asparagus",
                    "1/4 cup rice vinegar",
                    "2 tablespoons soy sauce",
                    "1 tablespoon roasted sesame oil",
                    "2 tablespoons chopped fresh cilantro",
                    "1/8 teaspoon coarse salt",
                    "1 1/2 cups baby arugula or mesclun salad",
                    "2 tablespoons sesame seeds"
                ],
                "ingredients": [
                    {
                        "text": "1 pound asparagus",
                        "weight": 453.59237,
                        "foodCategory": "vegetables",
                        "foodId": "food_b7bgzddbqq26mia27xpv7acn083m",
                        "image": "https://www.edamam.com/food-img/159/159dec8bbcabf7ed641a57b40a2d2eb9.jpg"
                    },
                    {
                        "text": "1/4 cup rice vinegar",
                        "weight": 59.5,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_axlcd4tack2d20bveizm4ayu0h2w",
                        "image": "https://www.edamam.com/food-img/5f6/5f69b84c399d778c4728e9ab4f8065a2.jpg"
                    },
                    {
                        "text": "2 tablespoons soy sauce",
                        "weight": 32,
                        "foodCategory": "plant-based protein",
                        "foodId": "food_a5g9yevb1iactoaiimbvjbkrxueh",
                        "image": "https://www.edamam.com/food-img/f56/f562e461eb0618f367f538b836c17b82.jpg"
                    },
                    {
                        "text": "1 tablespoon roasted sesame oil",
                        "weight": 13.6,
                        "foodCategory": "Oils",
                        "foodId": "food_b2id9opa0l5afvbw2do5xa1fnz4q",
                        "image": "https://www.edamam.com/food-img/b87/b874ddcfb6770adc7a155355a902ffb8.jpg"
                    },
                    {
                        "text": "2 tablespoons chopped fresh cilantro",
                        "weight": 1.999999999966186,
                        "foodCategory": "vegetables",
                        "foodId": "food_alhzhuwb4lc7jnb5s6f02by60bzp",
                        "image": "https://www.edamam.com/food-img/d57/d57e375b6ff99a90c7ee2b1990a1af36.jpg"
                    },
                    {
                        "text": "1/8 teaspoon coarse salt",
                        "weight": 0.6067708333641094,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_a1vgrj1bs8rd1majvmd9ubz8ttkg",
                        "image": "https://www.edamam.com/food-img/694/6943ea510918c6025795e8dc6e6eaaeb.jpg"
                    },
                    {
                        "text": "1 1/2 cups baby arugula or mesclun salad",
                        "weight": 9.99999999999999,
                        "foodCategory": "vegetables",
                        "foodId": "food_a8z1kzrawhksuzav2g1irb6zf4zc",
                        "image": "https://www.edamam.com/food-img/fa7/fa761a311efc0ec361a5eba4ed71870e.jpeg"
                    },
                    {
                        "text": "2 tablespoons sesame seeds",
                        "weight": 18,
                        "foodCategory": "plant-based protein",
                        "foodId": "food_bvxfnx8bwz2q3abs04kd6bbuf9w8",
                        "image": "https://www.edamam.com/food-img/291/291b355a7a0948716243164427697279.jpg"
                    }
                ],
                "calories": 344.71247399999226,
                "totalWeight": 588.6923699999663,
                "totalTime": 15,
                "cuisineType": [
                    "chinese"
                ],
                "mealType": [
                    "lunch/dinner"
                ],
                "dishType": [
                    "salad"
                ],
                "totalNutrients": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 344.71247399999226,
                        "unit": "kcal"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 23.343710843999826,
                        "unit": "g"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 3.3971369479999947,
                        "unit": "g"
                    },
                    "FATRN": {
                        "label": "Trans",
                        "quantity": 0,
                        "unit": "g"
                    },
                    "FAMS": {
                        "label": "Monounsaturated",
                        "quantity": 8.814379999999908,
                        "unit": "g"
                    },
                    "FAPU": {
                        "label": "Polyunsaturated",
                        "quantity": 9.933996184999987,
                        "unit": "g"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 23.86018395599876,
                        "unit": "g"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 12.121439769999055,
                        "unit": "g"
                    },
                    "SUGAR": {
                        "label": "Sugars",
                        "quantity": 8.955736555999707,
                        "unit": "g"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 16.07583213999928,
                        "unit": "g"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 0,
                        "unit": "mg"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 1773.6218473999845,
                        "unit": "mg"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 315.83216879997735,
                        "unit": "mg"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 156.1779317999912,
                        "unit": "mg"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 1188.2065873998238,
                        "unit": "mg"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 12.989126717999403,
                        "unit": "mg"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 4.185748797999832,
                        "unit": "mg"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 410.7480323999838,
                        "unit": "mg"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 191.00510059988605,
                        "unit": "µg"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 27.44117271999087,
                        "unit": "mg"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 0.8073170890999775,
                        "unit": "mg"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 0.7486652416999451,
                        "unit": "mg"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 6.004333378599624,
                        "unit": "mg"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 0.6126090566999496,
                        "unit": "mg"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 268.748032399979,
                        "unit": "µg"
                    },
                    "FOLFD": {
                        "label": "Folate (food)",
                        "quantity": 268.748032399979,
                        "unit": "µg"
                    },
                    "FOLAC": {
                        "label": "Folic acid",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 5.453993780999155,
                        "unit": "mg"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 207.6040259198952,
                        "unit": "µg"
                    },
                    "WATER": {
                        "label": "Water",
                        "quantity": 513.8603073139689,
                        "unit": "g"
                    }
                },
                "totalDaily": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 17.235623699999614,
                        "unit": "%"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 35.91340129846127,
                        "unit": "%"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 16.985684739999975,
                        "unit": "%"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 7.953394651999586,
                        "unit": "%"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 48.48575907999622,
                        "unit": "%"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 32.15166427999856,
                        "unit": "%"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 0,
                        "unit": "%"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 73.90091030833268,
                        "unit": "%"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 31.58321687999774,
                        "unit": "%"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 37.18522185714076,
                        "unit": "%"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 25.280991221272846,
                        "unit": "%"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 72.16181509999667,
                        "unit": "%"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 38.05226179999847,
                        "unit": "%"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 58.67829034285483,
                        "unit": "%"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 21.222788955542896,
                        "unit": "%"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 30.490191911100965,
                        "unit": "%"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 67.2764240916648,
                        "unit": "%"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 57.58963397691885,
                        "unit": "%"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 37.527083616247644,
                        "unit": "%"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 47.12377359230381,
                        "unit": "%"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 67.18700809999476,
                        "unit": "%"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 0,
                        "unit": "%"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 0,
                        "unit": "%"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 36.359958539994366,
                        "unit": "%"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 173.00335493324602,
                        "unit": "%"
                    }
                },
                "digest": [
                    {
                        "label": "Fat",
                        "tag": "FAT",
                        "schemaOrgTag": "fatContent",
                        "total": 23.343710843999826,
                        "hasRDI": true,
                        "daily": 35.91340129846127,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Saturated",
                                "tag": "FASAT",
                                "schemaOrgTag": "saturatedFatContent",
                                "total": 3.3971369479999947,
                                "hasRDI": true,
                                "daily": 16.985684739999975,
                                "unit": "g"
                            },
                            {
                                "label": "Trans",
                                "tag": "FATRN",
                                "schemaOrgTag": "transFatContent",
                                "total": 0,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Monounsaturated",
                                "tag": "FAMS",
                                "schemaOrgTag": null,
                                "total": 8.814379999999908,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Polyunsaturated",
                                "tag": "FAPU",
                                "schemaOrgTag": null,
                                "total": 9.933996184999987,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Carbs",
                        "tag": "CHOCDF",
                        "schemaOrgTag": "carbohydrateContent",
                        "total": 23.86018395599876,
                        "hasRDI": true,
                        "daily": 7.953394651999586,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Carbs (net)",
                                "tag": "CHOCDF.net",
                                "schemaOrgTag": null,
                                "total": 11.738744185999705,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Fiber",
                                "tag": "FIBTG",
                                "schemaOrgTag": "fiberContent",
                                "total": 12.121439769999055,
                                "hasRDI": true,
                                "daily": 48.48575907999622,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars",
                                "tag": "SUGAR",
                                "schemaOrgTag": "sugarContent",
                                "total": 8.955736555999707,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars, added",
                                "tag": "SUGAR.added",
                                "schemaOrgTag": null,
                                "total": 0,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Protein",
                        "tag": "PROCNT",
                        "schemaOrgTag": "proteinContent",
                        "total": 16.07583213999928,
                        "hasRDI": true,
                        "daily": 32.15166427999856,
                        "unit": "g"
                    },
                    {
                        "label": "Cholesterol",
                        "tag": "CHOLE",
                        "schemaOrgTag": "cholesterolContent",
                        "total": 0,
                        "hasRDI": true,
                        "daily": 0,
                        "unit": "mg"
                    },
                    {
                        "label": "Sodium",
                        "tag": "NA",
                        "schemaOrgTag": "sodiumContent",
                        "total": 1773.6218473999845,
                        "hasRDI": true,
                        "daily": 73.90091030833268,
                        "unit": "mg"
                    },
                    {
                        "label": "Calcium",
                        "tag": "CA",
                        "schemaOrgTag": null,
                        "total": 315.83216879997735,
                        "hasRDI": true,
                        "daily": 31.58321687999774,
                        "unit": "mg"
                    },
                    {
                        "label": "Magnesium",
                        "tag": "MG",
                        "schemaOrgTag": null,
                        "total": 156.1779317999912,
                        "hasRDI": true,
                        "daily": 37.18522185714076,
                        "unit": "mg"
                    },
                    {
                        "label": "Potassium",
                        "tag": "K",
                        "schemaOrgTag": null,
                        "total": 1188.2065873998238,
                        "hasRDI": true,
                        "daily": 25.280991221272846,
                        "unit": "mg"
                    },
                    {
                        "label": "Iron",
                        "tag": "FE",
                        "schemaOrgTag": null,
                        "total": 12.989126717999403,
                        "hasRDI": true,
                        "daily": 72.16181509999667,
                        "unit": "mg"
                    },
                    {
                        "label": "Zinc",
                        "tag": "ZN",
                        "schemaOrgTag": null,
                        "total": 4.185748797999832,
                        "hasRDI": true,
                        "daily": 38.05226179999847,
                        "unit": "mg"
                    },
                    {
                        "label": "Phosphorus",
                        "tag": "P",
                        "schemaOrgTag": null,
                        "total": 410.7480323999838,
                        "hasRDI": true,
                        "daily": 58.67829034285483,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin A",
                        "tag": "VITA_RAE",
                        "schemaOrgTag": null,
                        "total": 191.00510059988605,
                        "hasRDI": true,
                        "daily": 21.222788955542896,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin C",
                        "tag": "VITC",
                        "schemaOrgTag": null,
                        "total": 27.44117271999087,
                        "hasRDI": true,
                        "daily": 30.490191911100965,
                        "unit": "mg"
                    },
                    {
                        "label": "Thiamin (B1)",
                        "tag": "THIA",
                        "schemaOrgTag": null,
                        "total": 0.8073170890999775,
                        "hasRDI": true,
                        "daily": 67.2764240916648,
                        "unit": "mg"
                    },
                    {
                        "label": "Riboflavin (B2)",
                        "tag": "RIBF",
                        "schemaOrgTag": null,
                        "total": 0.7486652416999451,
                        "hasRDI": true,
                        "daily": 57.58963397691885,
                        "unit": "mg"
                    },
                    {
                        "label": "Niacin (B3)",
                        "tag": "NIA",
                        "schemaOrgTag": null,
                        "total": 6.004333378599624,
                        "hasRDI": true,
                        "daily": 37.527083616247644,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin B6",
                        "tag": "VITB6A",
                        "schemaOrgTag": null,
                        "total": 0.6126090566999496,
                        "hasRDI": true,
                        "daily": 47.12377359230381,
                        "unit": "mg"
                    },
                    {
                        "label": "Folate equivalent (total)",
                        "tag": "FOLDFE",
                        "schemaOrgTag": null,
                        "total": 268.748032399979,
                        "hasRDI": true,
                        "daily": 67.18700809999476,
                        "unit": "µg"
                    },
                    {
                        "label": "Folate (food)",
                        "tag": "FOLFD",
                        "schemaOrgTag": null,
                        "total": 268.748032399979,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Folic acid",
                        "tag": "FOLAC",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin B12",
                        "tag": "VITB12",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": true,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin D",
                        "tag": "VITD",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": true,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin E",
                        "tag": "TOCPHA",
                        "schemaOrgTag": null,
                        "total": 5.453993780999155,
                        "hasRDI": true,
                        "daily": 36.359958539994366,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin K",
                        "tag": "VITK1",
                        "schemaOrgTag": null,
                        "total": 207.6040259198952,
                        "hasRDI": true,
                        "daily": 173.00335493324602,
                        "unit": "µg"
                    },
                    {
                        "label": "Sugar alcohols",
                        "tag": "Sugar.alcohol",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    },
                    {
                        "label": "Water",
                        "tag": "WATER",
                        "schemaOrgTag": null,
                        "total": 513.8603073139689,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    }
                ]
            },
            "_links": {
                "self": {
                    "href": "https://api.edamam.com/api/recipes/v2/903e3d14f32e06031851e102b3226073?type=public&app_id=ea1d37d5&app_key=fd382a172ba8d6668c0430dc9c14a181",
                    "title": "Self"
                }
            }
        },
        {
            "recipe": {
                "uri": "http://www.edamam.com/ontologies/edamam.owl#recipe_169b0594408ee42bc0585fe140b74883",
                "label": "Egg Salad Recipe",
                "image": "https://www.edamam.com/web-img/834/8340e195c1ddf6aba72e40da0236211f.jpg",
                "source": "The Daily Meal",
                "url": "http://www.thedailymeal.com/egg-salad-0-recipe",
                "shareAs": "http://www.edamam.com/recipe/egg-salad-recipe-169b0594408ee42bc0585fe140b74883/salad",
                "yield": 1,
                "dietLabels": [],
                "healthLabels": [
                    "Vegetarian",
                    "Pescatarian",
                    "Peanut-Free",
                    "Tree-Nut-Free",
                    "Soy-Free",
                    "Fish-Free",
                    "Shellfish-Free",
                    "Pork-Free",
                    "Red-Meat-Free",
                    "Crustacean-Free",
                    "Sesame-Free",
                    "Lupine-Free",
                    "Mollusk-Free",
                    "Alcohol-Free",
                    "Sulfite-Free",
                    "Kosher",
                    "Immuno-Supportive"
                ],
                "cautions": [
                    "FODMAP"
                ],
                "ingredientLines": [
                    "2 hard-boiled eggs",
                    "1-2 tablespoons finely chopped celery",
                    "1-2 tablespoons finely chopped jalapeño",
                    "3 tablespoons mayonnaise (you can cut it with half Greek yogurt for a lighter, tangy salad)",
                    "Salt, to taste",
                    "Salad greens (optional)",
                    "2 slices whole wheat bread (optional)"
                ],
                "ingredients": [
                    {
                        "text": "2 hard-boiled eggs",
                        "weight": 80,
                        "foodCategory": "Eggs",
                        "foodId": "food_a2y52zfbr22uq1ah5thnqac607ft",
                        "image": "https://www.edamam.com/food-img/e54/e54c012fabed0f9cf211a817d1e23c5c.jpg"
                    },
                    {
                        "text": "1-2 tablespoons finely chopped celery",
                        "weight": 11.25,
                        "foodCategory": "vegetables",
                        "foodId": "food_bffeoksbyyur8ja4da73ub2xs57g",
                        "image": "https://www.edamam.com/food-img/d91/d91d2aed1c36d8fad54c4d7dc58f5a18.jpg"
                    },
                    {
                        "text": "1-2 tablespoons finely chopped jalapeño",
                        "weight": 8.437499999857348,
                        "foodCategory": "vegetables",
                        "foodId": "food_b7txsnbadj6plsbq27zvwah80r6y",
                        "image": "https://www.edamam.com/food-img/0df/0df9aa459870a6d477b0925c1fdb6d4c.jpg"
                    },
                    {
                        "text": "3 tablespoons mayonnaise (you can cut it with half Greek yogurt for a lighter, tangy salad)",
                        "weight": 53.999999999087095,
                        "foodCategory": "yogurt",
                        "foodId": "food_bllzl82a5fkj4yanmzoztapdyryz",
                        "image": "https://www.edamam.com/food-img/689/6891387401f579242e7303ce8ec00e18.jpg"
                    },
                    {
                        "text": "Salt, to taste",
                        "weight": 1.3061249999936666,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_btxz81db72hwbra2pncvebzzzum9",
                        "image": "https://www.edamam.com/food-img/694/6943ea510918c6025795e8dc6e6eaaeb.jpg"
                    },
                    {
                        "text": "Salad greens (optional)",
                        "weight": 0,
                        "foodCategory": "vegetables",
                        "foodId": "food_bqalyxzbzu04hcb8xj930bzar7xg",
                        "image": "https://www.edamam.com/food-img/b6d/b6d9f3052d27a3c71220cfa55c6f0a42.jpg"
                    },
                    {
                        "text": "2 slices whole wheat bread (optional)",
                        "weight": 64,
                        "foodCategory": "bread, rolls and tortillas",
                        "foodId": "food_bavo9dwb2qgylob09j84nbhpxsg9",
                        "image": "https://www.edamam.com/food-img/83a/83a9f144371e7967bdaa4ee50cdb4eaa.jpg"
                    }
                ],
                "calories": 336.50687499916444,
                "totalWeight": 217.89745149927464,
                "totalTime": 0,
                "cuisineType": [
                    "american"
                ],
                "mealType": [
                    "lunch/dinner"
                ],
                "dishType": [
                    "sandwiches",
                    "salad"
                ],
                "totalNutrients": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 336.50687499916444,
                        "unit": "kcal"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 13.640343749951088,
                        "unit": "g"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 4.870167499969743,
                        "unit": "g"
                    },
                    "FATRN": {
                        "label": "Trans",
                        "quantity": 0.0128,
                        "unit": "g"
                    },
                    "FAMS": {
                        "label": "Monounsaturated",
                        "quantity": 3.6644468749999586,
                        "unit": "g"
                    },
                    "FAPU": {
                        "label": "Polyunsaturated",
                        "quantity": 2.1684174999998405,
                        "unit": "g"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 30.894962499960606,
                        "unit": "g"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 4.2562499999960055,
                        "unit": "g"
                    },
                    "SUGAR": {
                        "label": "Sugars",
                        "quantity": 5.953974999963997,
                        "unit": "g"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 22.12840624993206,
                        "unit": "g"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 305.58199999987863,
                        "unit": "mg"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 506.22792749754535,
                        "unit": "mg"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 184.60468835945352,
                        "unit": "mg"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 58.505224514981904,
                        "unit": "mg"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 313.55179611967264,
                        "unit": "mg"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 2.577086589950733,
                        "unit": "mg"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 1.9994474515001306,
                        "unit": "mg"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 278.17374999996287,
                        "unit": "mg"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 126.23124999992297,
                        "unit": "µg"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 10.355624999830814,
                        "unit": "mg"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 0.31069749999994295,
                        "unit": "mg"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 0.5295987499999002,
                        "unit": "mg"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 3.035519999998174,
                        "unit": "mg"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 0.2780781249994023,
                        "unit": "mg"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 68.40812499996149,
                        "unit": "µg"
                    },
                    "FOLFD": {
                        "label": "Folate (food)",
                        "quantity": 68.40812499996149,
                        "unit": "µg"
                    },
                    "FOLAC": {
                        "label": "Folic acid",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 0.8880000000000001,
                        "unit": "µg"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 1.7600000000000002,
                        "unit": "µg"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 2.8588374999948933,
                        "unit": "mg"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 10.089187499973608,
                        "unit": "µg"
                    },
                    "WATER": {
                        "label": "Water",
                        "quantity": 103.13503865286987,
                        "unit": "g"
                    }
                },
                "totalDaily": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 16.825343749958222,
                        "unit": "%"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 20.98514423069398,
                        "unit": "%"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 24.350837499848716,
                        "unit": "%"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 10.298320833320203,
                        "unit": "%"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 17.024999999984022,
                        "unit": "%"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 44.25681249986412,
                        "unit": "%"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 101.86066666662622,
                        "unit": "%"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 21.092830312397723,
                        "unit": "%"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 18.46046883594535,
                        "unit": "%"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 13.929815360709977,
                        "unit": "%"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 6.671314811056865,
                        "unit": "%"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 14.317147721948519,
                        "unit": "%"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 18.176795013637552,
                        "unit": "%"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 39.739107142851836,
                        "unit": "%"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 14.025694444435885,
                        "unit": "%"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 11.506249999812015,
                        "unit": "%"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 25.89145833332858,
                        "unit": "%"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 40.738365384607704,
                        "unit": "%"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 18.971999999988586,
                        "unit": "%"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 21.390624999954024,
                        "unit": "%"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 17.10203124999037,
                        "unit": "%"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 37.00000000000001,
                        "unit": "%"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 11.733333333333336,
                        "unit": "%"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 19.058916666632623,
                        "unit": "%"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 8.407656249978007,
                        "unit": "%"
                    }
                },
                "digest": [
                    {
                        "label": "Fat",
                        "tag": "FAT",
                        "schemaOrgTag": "fatContent",
                        "total": 13.640343749951088,
                        "hasRDI": true,
                        "daily": 20.98514423069398,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Saturated",
                                "tag": "FASAT",
                                "schemaOrgTag": "saturatedFatContent",
                                "total": 4.870167499969743,
                                "hasRDI": true,
                                "daily": 24.350837499848716,
                                "unit": "g"
                            },
                            {
                                "label": "Trans",
                                "tag": "FATRN",
                                "schemaOrgTag": "transFatContent",
                                "total": 0.0128,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Monounsaturated",
                                "tag": "FAMS",
                                "schemaOrgTag": null,
                                "total": 3.6644468749999586,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Polyunsaturated",
                                "tag": "FAPU",
                                "schemaOrgTag": null,
                                "total": 2.1684174999998405,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Carbs",
                        "tag": "CHOCDF",
                        "schemaOrgTag": "carbohydrateContent",
                        "total": 30.894962499960606,
                        "hasRDI": true,
                        "daily": 10.298320833320203,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Carbs (net)",
                                "tag": "CHOCDF.net",
                                "schemaOrgTag": null,
                                "total": 26.6387124999646,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Fiber",
                                "tag": "FIBTG",
                                "schemaOrgTag": "fiberContent",
                                "total": 4.2562499999960055,
                                "hasRDI": true,
                                "daily": 17.024999999984022,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars",
                                "tag": "SUGAR",
                                "schemaOrgTag": "sugarContent",
                                "total": 5.953974999963997,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars, added",
                                "tag": "SUGAR.added",
                                "schemaOrgTag": null,
                                "total": 0,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Protein",
                        "tag": "PROCNT",
                        "schemaOrgTag": "proteinContent",
                        "total": 22.12840624993206,
                        "hasRDI": true,
                        "daily": 44.25681249986412,
                        "unit": "g"
                    },
                    {
                        "label": "Cholesterol",
                        "tag": "CHOLE",
                        "schemaOrgTag": "cholesterolContent",
                        "total": 305.58199999987863,
                        "hasRDI": true,
                        "daily": 101.86066666662622,
                        "unit": "mg"
                    },
                    {
                        "label": "Sodium",
                        "tag": "NA",
                        "schemaOrgTag": "sodiumContent",
                        "total": 506.22792749754535,
                        "hasRDI": true,
                        "daily": 21.092830312397723,
                        "unit": "mg"
                    },
                    {
                        "label": "Calcium",
                        "tag": "CA",
                        "schemaOrgTag": null,
                        "total": 184.60468835945352,
                        "hasRDI": true,
                        "daily": 18.46046883594535,
                        "unit": "mg"
                    },
                    {
                        "label": "Magnesium",
                        "tag": "MG",
                        "schemaOrgTag": null,
                        "total": 58.505224514981904,
                        "hasRDI": true,
                        "daily": 13.929815360709977,
                        "unit": "mg"
                    },
                    {
                        "label": "Potassium",
                        "tag": "K",
                        "schemaOrgTag": null,
                        "total": 313.55179611967264,
                        "hasRDI": true,
                        "daily": 6.671314811056865,
                        "unit": "mg"
                    },
                    {
                        "label": "Iron",
                        "tag": "FE",
                        "schemaOrgTag": null,
                        "total": 2.577086589950733,
                        "hasRDI": true,
                        "daily": 14.317147721948519,
                        "unit": "mg"
                    },
                    {
                        "label": "Zinc",
                        "tag": "ZN",
                        "schemaOrgTag": null,
                        "total": 1.9994474515001306,
                        "hasRDI": true,
                        "daily": 18.176795013637552,
                        "unit": "mg"
                    },
                    {
                        "label": "Phosphorus",
                        "tag": "P",
                        "schemaOrgTag": null,
                        "total": 278.17374999996287,
                        "hasRDI": true,
                        "daily": 39.739107142851836,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin A",
                        "tag": "VITA_RAE",
                        "schemaOrgTag": null,
                        "total": 126.23124999992297,
                        "hasRDI": true,
                        "daily": 14.025694444435885,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin C",
                        "tag": "VITC",
                        "schemaOrgTag": null,
                        "total": 10.355624999830814,
                        "hasRDI": true,
                        "daily": 11.506249999812015,
                        "unit": "mg"
                    },
                    {
                        "label": "Thiamin (B1)",
                        "tag": "THIA",
                        "schemaOrgTag": null,
                        "total": 0.31069749999994295,
                        "hasRDI": true,
                        "daily": 25.89145833332858,
                        "unit": "mg"
                    },
                    {
                        "label": "Riboflavin (B2)",
                        "tag": "RIBF",
                        "schemaOrgTag": null,
                        "total": 0.5295987499999002,
                        "hasRDI": true,
                        "daily": 40.738365384607704,
                        "unit": "mg"
                    },
                    {
                        "label": "Niacin (B3)",
                        "tag": "NIA",
                        "schemaOrgTag": null,
                        "total": 3.035519999998174,
                        "hasRDI": true,
                        "daily": 18.971999999988586,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin B6",
                        "tag": "VITB6A",
                        "schemaOrgTag": null,
                        "total": 0.2780781249994023,
                        "hasRDI": true,
                        "daily": 21.390624999954024,
                        "unit": "mg"
                    },
                    {
                        "label": "Folate equivalent (total)",
                        "tag": "FOLDFE",
                        "schemaOrgTag": null,
                        "total": 68.40812499996149,
                        "hasRDI": true,
                        "daily": 17.10203124999037,
                        "unit": "µg"
                    },
                    {
                        "label": "Folate (food)",
                        "tag": "FOLFD",
                        "schemaOrgTag": null,
                        "total": 68.40812499996149,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Folic acid",
                        "tag": "FOLAC",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin B12",
                        "tag": "VITB12",
                        "schemaOrgTag": null,
                        "total": 0.8880000000000001,
                        "hasRDI": true,
                        "daily": 37.00000000000001,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin D",
                        "tag": "VITD",
                        "schemaOrgTag": null,
                        "total": 1.7600000000000002,
                        "hasRDI": true,
                        "daily": 11.733333333333336,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin E",
                        "tag": "TOCPHA",
                        "schemaOrgTag": null,
                        "total": 2.8588374999948933,
                        "hasRDI": true,
                        "daily": 19.058916666632623,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin K",
                        "tag": "VITK1",
                        "schemaOrgTag": null,
                        "total": 10.089187499973608,
                        "hasRDI": true,
                        "daily": 8.407656249978007,
                        "unit": "µg"
                    },
                    {
                        "label": "Sugar alcohols",
                        "tag": "Sugar.alcohol",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    },
                    {
                        "label": "Water",
                        "tag": "WATER",
                        "schemaOrgTag": null,
                        "total": 103.13503865286987,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    }
                ]
            },
            "_links": {
                "self": {
                    "href": "https://api.edamam.com/api/recipes/v2/169b0594408ee42bc0585fe140b74883?type=public&app_id=ea1d37d5&app_key=fd382a172ba8d6668c0430dc9c14a181",
                    "title": "Self"
                }
            }
        },
        {
            "recipe": {
                "uri": "http://www.edamam.com/ontologies/edamam.owl#recipe_2fc519ae22c91af3acdc64590549311f",
                "label": "Citrus-Avocado Salad",
                "image": "https://www.edamam.com/web-img/154/1546fef87cf2da994d31ced8eb064d31.jpg",
                "source": "Men's Health",
                "url": "https://www.menshealth.com/recipes/citrus-avocado-salad",
                "shareAs": "http://www.edamam.com/recipe/citrus-avocado-salad-2fc519ae22c91af3acdc64590549311f/salad",
                "yield": 4,
                "dietLabels": [
                    "High-Fiber"
                ],
                "healthLabels": [
                    "Vegan",
                    "Vegetarian",
                    "Pescatarian",
                    "Paleo",
                    "Mediterranean",
                    "DASH",
                    "Dairy-Free",
                    "Gluten-Free",
                    "Wheat-Free",
                    "Egg-Free",
                    "Peanut-Free",
                    "Soy-Free",
                    "Fish-Free",
                    "Shellfish-Free",
                    "Pork-Free",
                    "Red-Meat-Free",
                    "Crustacean-Free",
                    "Celery-Free",
                    "Mustard-Free",
                    "Sesame-Free",
                    "Lupine-Free",
                    "Mollusk-Free",
                    "Alcohol-Free",
                    "Sulfite-Free",
                    "FODMAP-Free",
                    "Kosher"
                ],
                "cautions": [
                    "Sulfites"
                ],
                "ingredientLines": [
                    "SALAD:",
                    "8 cups mixed salad greens",
                    "2 navel oranges, separated into segments and chopped",
                    "1 avocado, chopped",
                    "1 tablespoon chopped walnuts",
                    "DRESSING:",
                    "2 tablespoons lime juice",
                    "2 tablespoons extra-virgin olive oil",
                    "1 tablespoon finely chopped cilantro",
                    "1/4 teaspoon salt",
                    "teaspoon ground red pepper"
                ],
                "ingredients": [
                    {
                        "text": "8 cups mixed salad greens",
                        "weight": 288,
                        "foodCategory": "vegetables",
                        "foodId": "food_bqalyxzbzu04hcb8xj930bzar7xg",
                        "image": "https://www.edamam.com/food-img/b6d/b6d9f3052d27a3c71220cfa55c6f0a42.jpg"
                    },
                    {
                        "text": "2 navel oranges, separated into segments and chopped",
                        "weight": 280,
                        "foodCategory": "fruit",
                        "foodId": "food_agbq12basb38ixb00moxbahrx6f9",
                        "image": "https://www.edamam.com/food-img/ffc/ffcb7b039bfc783fcfb417489160366e.jpg"
                    },
                    {
                        "text": "1 avocado, chopped",
                        "weight": 201,
                        "foodCategory": "fruit",
                        "foodId": "food_b0yuze4b1g3afpanijno5abtiu28",
                        "image": "https://www.edamam.com/food-img/984/984a707ea8e9c6bf5f6498970a9e6d9d.jpg"
                    },
                    {
                        "text": "1 tablespoon chopped walnuts",
                        "weight": 7.31249999987637,
                        "foodCategory": "plant-based protein",
                        "foodId": "food_acqkmojaw4fltga9jad8mb85u9z2",
                        "image": "https://www.edamam.com/food-img/624/6243d320d94b15ebaece2634cc5b40c5.jpg"
                    },
                    {
                        "text": "2 tablespoons lime juice",
                        "weight": 30.799999999479265,
                        "foodCategory": "fruit",
                        "foodId": "food_b0iywbmaujvd4eblrooo9bsvn7e6",
                        "image": "https://www.edamam.com/food-img/8f0/8f0c10eb3dbf476a05e61018e76ea220.jpg"
                    },
                    {
                        "text": "2 tablespoons extra-virgin olive oil",
                        "weight": 27,
                        "foodCategory": "Oils",
                        "foodId": "food_b1d1icuad3iktrbqby0hiagafaz7",
                        "image": "https://www.edamam.com/food-img/4d6/4d651eaa8a353647746290c7a9b29d84.jpg"
                    },
                    {
                        "text": "1 tablespoon finely chopped cilantro",
                        "weight": 0.999999999983093,
                        "foodCategory": "vegetables",
                        "foodId": "food_alhzhuwb4lc7jnb5s6f02by60bzp",
                        "image": "https://www.edamam.com/food-img/d57/d57e375b6ff99a90c7ee2b1990a1af36.jpg"
                    },
                    {
                        "text": "1/4 teaspoon salt",
                        "weight": 1.5,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_btxz81db72hwbra2pncvebzzzum9",
                        "image": "https://www.edamam.com/food-img/694/6943ea510918c6025795e8dc6e6eaaeb.jpg"
                    },
                    {
                        "text": "teaspoon ground red pepper",
                        "weight": 3.104166666824113,
                        "foodCategory": "vegetables",
                        "foodId": "food_a8g63g7ak6bnmvbu7agxibp4a0dy",
                        "image": "https://www.edamam.com/food-img/4dc/4dc48b1a506d334b4ab6671b9d56a18f.jpeg"
                    }
                ],
                "calories": 797.3960416657729,
                "totalWeight": 839.7166666661628,
                "totalTime": 10,
                "cuisineType": [
                    "caribbean"
                ],
                "mealType": [
                    "lunch/dinner"
                ],
                "dishType": [
                    "salad"
                ],
                "totalNutrients": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 797.3960416657729,
                        "unit": "kcal"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 62.1231537499194,
                        "unit": "g"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 8.558025874992426,
                        "unit": "g"
                    },
                    "FAMS": {
                        "label": "Monounsaturated",
                        "quantity": 40.155272749988875,
                        "unit": "g"
                    },
                    "FAPU": {
                        "label": "Polyunsaturated",
                        "quantity": 10.27358566660833,
                        "unit": "g"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 64.34268499994808,
                        "unit": "g"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 24.077324999992474,
                        "unit": "g"
                    },
                    "SUGAR": {
                        "label": "Sugars",
                        "quantity": 28.22345124999444,
                        "unit": "g"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 11.779884999980183,
                        "unit": "g"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 0,
                        "unit": "mg"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 680.7664166666523,
                        "unit": "mg"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 261.19554166647225,
                        "unit": "mg"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 141.19524999977753,
                        "unit": "mg"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 2078.8039166657563,
                        "unit": "mg"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 4.3740116666629785,
                        "unit": "mg"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 2.293656666662739,
                        "unit": "mg"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 283.34033333286555,
                        "unit": "mg"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 1122.2026666668448,
                        "unit": "µg"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 225.645083333372,
                        "unit": "mg"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 0.5616518749995218,
                        "unit": "mg"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 0.6543472916665096,
                        "unit": "mg"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 5.93091141666589,
                        "unit": "mg"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 1.0584652499995715,
                        "unit": "mg"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 379.74416666655543,
                        "unit": "µg"
                    },
                    "FOLFD": {
                        "label": "Folate (food)",
                        "quantity": 379.74416666655543,
                        "unit": "µg"
                    },
                    "FOLAC": {
                        "label": "Folic acid",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 9.281793333333388,
                        "unit": "mg"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 425.84234166661554,
                        "unit": "µg"
                    },
                    "WATER": {
                        "label": "Water",
                        "quantity": 693.4990908329852,
                        "unit": "g"
                    }
                },
                "totalDaily": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 39.86980208328865,
                        "unit": "%"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 95.5740826921837,
                        "unit": "%"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 42.79012937496213,
                        "unit": "%"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 21.44756166664936,
                        "unit": "%"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 96.3092999999699,
                        "unit": "%"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 23.559769999960366,
                        "unit": "%"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 0,
                        "unit": "%"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 28.365267361110508,
                        "unit": "%"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 26.119554166647223,
                        "unit": "%"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 33.617916666613695,
                        "unit": "%"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 44.229870567356514,
                        "unit": "%"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 24.300064814794325,
                        "unit": "%"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 20.851424242388536,
                        "unit": "%"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 40.47719047612365,
                        "unit": "%"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 124.68918518520499,
                        "unit": "%"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 250.71675925930225,
                        "unit": "%"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 46.80432291662682,
                        "unit": "%"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 50.33440705126997,
                        "unit": "%"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 37.06819635416181,
                        "unit": "%"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 81.42040384612089,
                        "unit": "%"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 94.93604166663884,
                        "unit": "%"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 0,
                        "unit": "%"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 0,
                        "unit": "%"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 61.87862222222259,
                        "unit": "%"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 354.86861805551297,
                        "unit": "%"
                    }
                },
                "digest": [
                    {
                        "label": "Fat",
                        "tag": "FAT",
                        "schemaOrgTag": "fatContent",
                        "total": 62.1231537499194,
                        "hasRDI": true,
                        "daily": 95.5740826921837,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Saturated",
                                "tag": "FASAT",
                                "schemaOrgTag": "saturatedFatContent",
                                "total": 8.558025874992426,
                                "hasRDI": true,
                                "daily": 42.79012937496213,
                                "unit": "g"
                            },
                            {
                                "label": "Trans",
                                "tag": "FATRN",
                                "schemaOrgTag": "transFatContent",
                                "total": 0,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Monounsaturated",
                                "tag": "FAMS",
                                "schemaOrgTag": null,
                                "total": 40.155272749988875,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Polyunsaturated",
                                "tag": "FAPU",
                                "schemaOrgTag": null,
                                "total": 10.27358566660833,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Carbs",
                        "tag": "CHOCDF",
                        "schemaOrgTag": "carbohydrateContent",
                        "total": 64.34268499994808,
                        "hasRDI": true,
                        "daily": 21.44756166664936,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Carbs (net)",
                                "tag": "CHOCDF.net",
                                "schemaOrgTag": null,
                                "total": 40.265359999955606,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Fiber",
                                "tag": "FIBTG",
                                "schemaOrgTag": "fiberContent",
                                "total": 24.077324999992474,
                                "hasRDI": true,
                                "daily": 96.3092999999699,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars",
                                "tag": "SUGAR",
                                "schemaOrgTag": "sugarContent",
                                "total": 28.22345124999444,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars, added",
                                "tag": "SUGAR.added",
                                "schemaOrgTag": null,
                                "total": 0,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Protein",
                        "tag": "PROCNT",
                        "schemaOrgTag": "proteinContent",
                        "total": 11.779884999980183,
                        "hasRDI": true,
                        "daily": 23.559769999960366,
                        "unit": "g"
                    },
                    {
                        "label": "Cholesterol",
                        "tag": "CHOLE",
                        "schemaOrgTag": "cholesterolContent",
                        "total": 0,
                        "hasRDI": true,
                        "daily": 0,
                        "unit": "mg"
                    },
                    {
                        "label": "Sodium",
                        "tag": "NA",
                        "schemaOrgTag": "sodiumContent",
                        "total": 680.7664166666523,
                        "hasRDI": true,
                        "daily": 28.365267361110508,
                        "unit": "mg"
                    },
                    {
                        "label": "Calcium",
                        "tag": "CA",
                        "schemaOrgTag": null,
                        "total": 261.19554166647225,
                        "hasRDI": true,
                        "daily": 26.119554166647223,
                        "unit": "mg"
                    },
                    {
                        "label": "Magnesium",
                        "tag": "MG",
                        "schemaOrgTag": null,
                        "total": 141.19524999977753,
                        "hasRDI": true,
                        "daily": 33.617916666613695,
                        "unit": "mg"
                    },
                    {
                        "label": "Potassium",
                        "tag": "K",
                        "schemaOrgTag": null,
                        "total": 2078.8039166657563,
                        "hasRDI": true,
                        "daily": 44.229870567356514,
                        "unit": "mg"
                    },
                    {
                        "label": "Iron",
                        "tag": "FE",
                        "schemaOrgTag": null,
                        "total": 4.3740116666629785,
                        "hasRDI": true,
                        "daily": 24.300064814794325,
                        "unit": "mg"
                    },
                    {
                        "label": "Zinc",
                        "tag": "ZN",
                        "schemaOrgTag": null,
                        "total": 2.293656666662739,
                        "hasRDI": true,
                        "daily": 20.851424242388536,
                        "unit": "mg"
                    },
                    {
                        "label": "Phosphorus",
                        "tag": "P",
                        "schemaOrgTag": null,
                        "total": 283.34033333286555,
                        "hasRDI": true,
                        "daily": 40.47719047612365,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin A",
                        "tag": "VITA_RAE",
                        "schemaOrgTag": null,
                        "total": 1122.2026666668448,
                        "hasRDI": true,
                        "daily": 124.68918518520499,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin C",
                        "tag": "VITC",
                        "schemaOrgTag": null,
                        "total": 225.645083333372,
                        "hasRDI": true,
                        "daily": 250.71675925930225,
                        "unit": "mg"
                    },
                    {
                        "label": "Thiamin (B1)",
                        "tag": "THIA",
                        "schemaOrgTag": null,
                        "total": 0.5616518749995218,
                        "hasRDI": true,
                        "daily": 46.80432291662682,
                        "unit": "mg"
                    },
                    {
                        "label": "Riboflavin (B2)",
                        "tag": "RIBF",
                        "schemaOrgTag": null,
                        "total": 0.6543472916665096,
                        "hasRDI": true,
                        "daily": 50.33440705126997,
                        "unit": "mg"
                    },
                    {
                        "label": "Niacin (B3)",
                        "tag": "NIA",
                        "schemaOrgTag": null,
                        "total": 5.93091141666589,
                        "hasRDI": true,
                        "daily": 37.06819635416181,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin B6",
                        "tag": "VITB6A",
                        "schemaOrgTag": null,
                        "total": 1.0584652499995715,
                        "hasRDI": true,
                        "daily": 81.42040384612089,
                        "unit": "mg"
                    },
                    {
                        "label": "Folate equivalent (total)",
                        "tag": "FOLDFE",
                        "schemaOrgTag": null,
                        "total": 379.74416666655543,
                        "hasRDI": true,
                        "daily": 94.93604166663884,
                        "unit": "µg"
                    },
                    {
                        "label": "Folate (food)",
                        "tag": "FOLFD",
                        "schemaOrgTag": null,
                        "total": 379.74416666655543,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Folic acid",
                        "tag": "FOLAC",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin B12",
                        "tag": "VITB12",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": true,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin D",
                        "tag": "VITD",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": true,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin E",
                        "tag": "TOCPHA",
                        "schemaOrgTag": null,
                        "total": 9.281793333333388,
                        "hasRDI": true,
                        "daily": 61.87862222222259,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin K",
                        "tag": "VITK1",
                        "schemaOrgTag": null,
                        "total": 425.84234166661554,
                        "hasRDI": true,
                        "daily": 354.86861805551297,
                        "unit": "µg"
                    },
                    {
                        "label": "Sugar alcohols",
                        "tag": "Sugar.alcohol",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    },
                    {
                        "label": "Water",
                        "tag": "WATER",
                        "schemaOrgTag": null,
                        "total": 693.4990908329852,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    }
                ]
            },
            "_links": {
                "self": {
                    "href": "https://api.edamam.com/api/recipes/v2/2fc519ae22c91af3acdc64590549311f?type=public&app_id=ea1d37d5&app_key=fd382a172ba8d6668c0430dc9c14a181",
                    "title": "Self"
                }
            }
        },
        {
            "recipe": {
                "uri": "http://www.edamam.com/ontologies/edamam.owl#recipe_807a9503ee9abeaa79935d89a5667257",
                "label": "Green Salad with Hazelnut Vinaigrette",
                "image": "https://www.edamam.com/web-img/262/262e45305accd188e0a46c1bcc23ca0d.jpg",
                "source": "My Recipes",
                "url": "http://www.myrecipes.com/recipe/green-salad-with-hazelnut",
                "shareAs": "http://www.edamam.com/recipe/green-salad-with-hazelnut-vinaigrette-807a9503ee9abeaa79935d89a5667257/salad",
                "yield": 4,
                "dietLabels": [
                    "High-Fiber",
                    "Low-Sodium"
                ],
                "healthLabels": [
                    "Sugar-Conscious",
                    "Vegan",
                    "Vegetarian",
                    "Pescatarian",
                    "DASH",
                    "Dairy-Free",
                    "Gluten-Free",
                    "Wheat-Free",
                    "Egg-Free",
                    "Peanut-Free",
                    "Soy-Free",
                    "Fish-Free",
                    "Shellfish-Free",
                    "Pork-Free",
                    "Red-Meat-Free",
                    "Crustacean-Free",
                    "Celery-Free",
                    "Sesame-Free",
                    "Lupine-Free",
                    "Mollusk-Free",
                    "Alcohol-Free",
                    "Sulfite-Free",
                    "Kosher",
                    "Immuno-Supportive"
                ],
                "cautions": [],
                "ingredientLines": [
                    "Hazelnut Vinaigrette:",
                    "1 1/2 teaspoons red wine vinegar",
                    "1/4 teaspoon Dijon mustard",
                    "1/8 teaspoon fine sea salt",
                    "1/8 teaspoon freshly ground black pepper",
                    "1 1/2 tablespoons toasted hazelnut oil",
                    "Salad:",
                    "4 cups packaged herb salad blend (such as Fresh Express)",
                    "1/2 shallot, thinly sliced"
                ],
                "ingredients": [
                    {
                        "text": "1 1/2 teaspoons red wine vinegar",
                        "weight": 7.5,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_ad6iyy1anmzb49a817rgnabnz8c9",
                        "image": "https://www.edamam.com/food-img/dc8/dc8e998b32b8d45ba15c1b1e6711e958.jpg"
                    },
                    {
                        "text": "1/4 teaspoon Dijon mustard",
                        "weight": 1.25,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_a34cdj5b0kyuhfbov30xcb50u4dv",
                        "image": "https://www.edamam.com/food-img/e23/e238f2e4cfa6aa1a30f46dc73e7344eb.jpg"
                    },
                    {
                        "text": "1/8 teaspoon fine sea salt",
                        "weight": 0.75,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_btxz81db72hwbra2pncvebzzzum9",
                        "image": "https://www.edamam.com/food-img/694/6943ea510918c6025795e8dc6e6eaaeb.jpg"
                    },
                    {
                        "text": "1/8 teaspoon freshly ground black pepper",
                        "weight": 0.2875,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_b6ywzluaaxv02wad7s1r9ag4py89",
                        "image": "https://www.edamam.com/food-img/c6e/c6e5c3bd8d3bc15175d9766971a4d1b2.jpg"
                    },
                    {
                        "text": "1 1/2 tablespoons toasted hazelnut oil",
                        "weight": 20.4,
                        "foodCategory": "Oils",
                        "foodId": "food_bmgo201ag4gz0waauxms1axzgubt",
                        "image": "https://www.edamam.com/food-img/552/5526f976e3f5447aac0c4e03f575dd4c.jpg"
                    },
                    {
                        "text": "4 cups packaged herb salad blend (such as Fresh Express)",
                        "weight": 172.8000000029216,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_avsq22zadwyb5cb5sl1byaa4mbo8",
                        "image": "https://www.edamam.com/food-img/89b/89b37a04e46e052671d73addcb84aa51.jpg"
                    },
                    {
                        "text": "1/2 shallot, thinly sliced",
                        "weight": 29.555555555555557,
                        "foodCategory": "vegetables",
                        "foodId": "food_bu2ver7a5f52dfap8q9f0bn085qb",
                        "image": "https://www.edamam.com/food-img/d23/d23e3be21df05e9e16c05eadb12341e7.jpeg"
                    }
                ],
                "calories": 681.4406250080635,
                "totalWeight": 232.54305555847714,
                "totalTime": 8,
                "cuisineType": [
                    "mediterranean"
                ],
                "mealType": [
                    "lunch/dinner"
                ],
                "dishType": [
                    "salad"
                ],
                "totalNutrients": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 681.4406250080635,
                        "unit": "kcal"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 33.319718055772626,
                        "unit": "g"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 6.238741444524203,
                        "unit": "g"
                    },
                    "FATRN": {
                        "label": "Trans",
                        "quantity": 0.0001125,
                        "unit": "g"
                    },
                    "FAMS": {
                        "label": "Monounsaturated",
                        "quantity": 16.757697402791507,
                        "unit": "g"
                    },
                    "FAPU": {
                        "label": "Polyunsaturated",
                        "quantity": 4.1611909167014325,
                        "unit": "g"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 115.7306345852014,
                        "unit": "g"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 65.00451527885878,
                        "unit": "g"
                    },
                    "SUGAR": {
                        "label": "Sugars",
                        "quantity": 5.294242222272182,
                        "unit": "g"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 16.560590139155046,
                        "unit": "g"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 0,
                        "unit": "mg"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 403.72916666827354,
                        "unit": "mg"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 3279.546680610774,
                        "unit": "mg"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 387.76579167309416,
                        "unit": "mg"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 1514.0134305793374,
                        "unit": "mg"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 214.01973292027776,
                        "unit": "mg"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 10.811683472402777,
                        "unit": "mg"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 367.46558333920575,
                        "unit": "mg"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 328.46012500555105,
                        "unit": "µg"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 88.80569444590525,
                        "unit": "mg"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 0.9067203333483213,
                        "unit": "mg"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 0.6967756111227683,
                        "unit": "mg"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 8.605779736255439,
                        "unit": "mg"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 1.0540782916827356,
                        "unit": "mg"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 483.65726389689405,
                        "unit": "µg"
                    },
                    "FOLFD": {
                        "label": "Folate (food)",
                        "quantity": 483.65726389689405,
                        "unit": "µg"
                    },
                    "FOLAC": {
                        "label": "Folic acid",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 22.57355222244076,
                        "unit": "mg"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 2963.380581994535,
                        "unit": "µg"
                    },
                    "WATER": {
                        "label": "Water",
                        "quantity": 45.21552583356093,
                        "unit": "g"
                    }
                },
                "totalDaily": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 34.07203125040318,
                        "unit": "%"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 51.26110470118866,
                        "unit": "%"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 31.193707222621015,
                        "unit": "%"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 38.57687819506714,
                        "unit": "%"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 260.0180611154351,
                        "unit": "%"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 33.12118027831009,
                        "unit": "%"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 0,
                        "unit": "%"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 16.822048611178065,
                        "unit": "%"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 327.95466806107737,
                        "unit": "%"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 92.32518849359384,
                        "unit": "%"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 32.21305171445398,
                        "unit": "%"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 1188.9985162237654,
                        "unit": "%"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 98.28803156729796,
                        "unit": "%"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 52.49508333417225,
                        "unit": "%"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 36.49556944506122,
                        "unit": "%"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 98.6729938287836,
                        "unit": "%"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 75.56002777902677,
                        "unit": "%"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 53.59812393252064,
                        "unit": "%"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 53.786123351596494,
                        "unit": "%"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 81.08294551405659,
                        "unit": "%"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 120.91431597422351,
                        "unit": "%"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 0,
                        "unit": "%"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 0,
                        "unit": "%"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 150.49034814960507,
                        "unit": "%"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 2469.4838183287793,
                        "unit": "%"
                    }
                },
                "digest": [
                    {
                        "label": "Fat",
                        "tag": "FAT",
                        "schemaOrgTag": "fatContent",
                        "total": 33.319718055772626,
                        "hasRDI": true,
                        "daily": 51.26110470118866,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Saturated",
                                "tag": "FASAT",
                                "schemaOrgTag": "saturatedFatContent",
                                "total": 6.238741444524203,
                                "hasRDI": true,
                                "daily": 31.193707222621015,
                                "unit": "g"
                            },
                            {
                                "label": "Trans",
                                "tag": "FATRN",
                                "schemaOrgTag": "transFatContent",
                                "total": 0.0001125,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Monounsaturated",
                                "tag": "FAMS",
                                "schemaOrgTag": null,
                                "total": 16.757697402791507,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Polyunsaturated",
                                "tag": "FAPU",
                                "schemaOrgTag": null,
                                "total": 4.1611909167014325,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Carbs",
                        "tag": "CHOCDF",
                        "schemaOrgTag": "carbohydrateContent",
                        "total": 115.7306345852014,
                        "hasRDI": true,
                        "daily": 38.57687819506714,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Carbs (net)",
                                "tag": "CHOCDF.net",
                                "schemaOrgTag": null,
                                "total": 50.726119306342625,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Fiber",
                                "tag": "FIBTG",
                                "schemaOrgTag": "fiberContent",
                                "total": 65.00451527885878,
                                "hasRDI": true,
                                "daily": 260.0180611154351,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars",
                                "tag": "SUGAR",
                                "schemaOrgTag": "sugarContent",
                                "total": 5.294242222272182,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars, added",
                                "tag": "SUGAR.added",
                                "schemaOrgTag": null,
                                "total": 0,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Protein",
                        "tag": "PROCNT",
                        "schemaOrgTag": "proteinContent",
                        "total": 16.560590139155046,
                        "hasRDI": true,
                        "daily": 33.12118027831009,
                        "unit": "g"
                    },
                    {
                        "label": "Cholesterol",
                        "tag": "CHOLE",
                        "schemaOrgTag": "cholesterolContent",
                        "total": 0,
                        "hasRDI": true,
                        "daily": 0,
                        "unit": "mg"
                    },
                    {
                        "label": "Sodium",
                        "tag": "NA",
                        "schemaOrgTag": "sodiumContent",
                        "total": 403.72916666827354,
                        "hasRDI": true,
                        "daily": 16.822048611178065,
                        "unit": "mg"
                    },
                    {
                        "label": "Calcium",
                        "tag": "CA",
                        "schemaOrgTag": null,
                        "total": 3279.546680610774,
                        "hasRDI": true,
                        "daily": 327.95466806107737,
                        "unit": "mg"
                    },
                    {
                        "label": "Magnesium",
                        "tag": "MG",
                        "schemaOrgTag": null,
                        "total": 387.76579167309416,
                        "hasRDI": true,
                        "daily": 92.32518849359384,
                        "unit": "mg"
                    },
                    {
                        "label": "Potassium",
                        "tag": "K",
                        "schemaOrgTag": null,
                        "total": 1514.0134305793374,
                        "hasRDI": true,
                        "daily": 32.21305171445398,
                        "unit": "mg"
                    },
                    {
                        "label": "Iron",
                        "tag": "FE",
                        "schemaOrgTag": null,
                        "total": 214.01973292027776,
                        "hasRDI": true,
                        "daily": 1188.9985162237654,
                        "unit": "mg"
                    },
                    {
                        "label": "Zinc",
                        "tag": "ZN",
                        "schemaOrgTag": null,
                        "total": 10.811683472402777,
                        "hasRDI": true,
                        "daily": 98.28803156729796,
                        "unit": "mg"
                    },
                    {
                        "label": "Phosphorus",
                        "tag": "P",
                        "schemaOrgTag": null,
                        "total": 367.46558333920575,
                        "hasRDI": true,
                        "daily": 52.49508333417225,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin A",
                        "tag": "VITA_RAE",
                        "schemaOrgTag": null,
                        "total": 328.46012500555105,
                        "hasRDI": true,
                        "daily": 36.49556944506122,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin C",
                        "tag": "VITC",
                        "schemaOrgTag": null,
                        "total": 88.80569444590525,
                        "hasRDI": true,
                        "daily": 98.6729938287836,
                        "unit": "mg"
                    },
                    {
                        "label": "Thiamin (B1)",
                        "tag": "THIA",
                        "schemaOrgTag": null,
                        "total": 0.9067203333483213,
                        "hasRDI": true,
                        "daily": 75.56002777902677,
                        "unit": "mg"
                    },
                    {
                        "label": "Riboflavin (B2)",
                        "tag": "RIBF",
                        "schemaOrgTag": null,
                        "total": 0.6967756111227683,
                        "hasRDI": true,
                        "daily": 53.59812393252064,
                        "unit": "mg"
                    },
                    {
                        "label": "Niacin (B3)",
                        "tag": "NIA",
                        "schemaOrgTag": null,
                        "total": 8.605779736255439,
                        "hasRDI": true,
                        "daily": 53.786123351596494,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin B6",
                        "tag": "VITB6A",
                        "schemaOrgTag": null,
                        "total": 1.0540782916827356,
                        "hasRDI": true,
                        "daily": 81.08294551405659,
                        "unit": "mg"
                    },
                    {
                        "label": "Folate equivalent (total)",
                        "tag": "FOLDFE",
                        "schemaOrgTag": null,
                        "total": 483.65726389689405,
                        "hasRDI": true,
                        "daily": 120.91431597422351,
                        "unit": "µg"
                    },
                    {
                        "label": "Folate (food)",
                        "tag": "FOLFD",
                        "schemaOrgTag": null,
                        "total": 483.65726389689405,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Folic acid",
                        "tag": "FOLAC",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin B12",
                        "tag": "VITB12",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": true,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin D",
                        "tag": "VITD",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": true,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin E",
                        "tag": "TOCPHA",
                        "schemaOrgTag": null,
                        "total": 22.57355222244076,
                        "hasRDI": true,
                        "daily": 150.49034814960507,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin K",
                        "tag": "VITK1",
                        "schemaOrgTag": null,
                        "total": 2963.380581994535,
                        "hasRDI": true,
                        "daily": 2469.4838183287793,
                        "unit": "µg"
                    },
                    {
                        "label": "Sugar alcohols",
                        "tag": "Sugar.alcohol",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    },
                    {
                        "label": "Water",
                        "tag": "WATER",
                        "schemaOrgTag": null,
                        "total": 45.21552583356093,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    }
                ]
            },
            "_links": {
                "self": {
                    "href": "https://api.edamam.com/api/recipes/v2/807a9503ee9abeaa79935d89a5667257?type=public&app_id=ea1d37d5&app_key=fd382a172ba8d6668c0430dc9c14a181",
                    "title": "Self"
                }
            }
        },
        {
            "recipe": {
                "uri": "http://www.edamam.com/ontologies/edamam.owl#recipe_e2a04a8cd05720a8105047614b73dd9c",
                "label": "Mango and Shrimp Salad",
                "image": "https://www.edamam.com/web-img/2a9/2a93083acb831389089ff87659cf5039.jpg",
                "source": "Food52",
                "url": "https://food52.com/recipes/1976-mango-and-shrimp-salad",
                "shareAs": "http://www.edamam.com/recipe/mango-and-shrimp-salad-e2a04a8cd05720a8105047614b73dd9c/salad",
                "yield": 6,
                "dietLabels": [],
                "healthLabels": [
                    "Kidney-Friendly",
                    "Pescatarian",
                    "Mediterranean",
                    "Dairy-Free",
                    "Gluten-Free",
                    "Wheat-Free",
                    "Egg-Free",
                    "Peanut-Free",
                    "Tree-Nut-Free",
                    "Soy-Free",
                    "Fish-Free",
                    "Pork-Free",
                    "Red-Meat-Free",
                    "Celery-Free",
                    "Mustard-Free",
                    "Sesame-Free",
                    "Lupine-Free",
                    "Mollusk-Free",
                    "Alcohol-Free",
                    "Immuno-Supportive"
                ],
                "cautions": [
                    "Sulfites",
                    "FODMAP"
                ],
                "ingredientLines": [
                    "1 big ripe mango",
                    "1/3 cup canola oil",
                    "1 lime - juice",
                    "1 tablespoon fresh ginger juice (grate the ginger and then squeeze the juice)",
                    "2 teaspoons curry powder",
                    "Sechuan pepper",
                    "Salt",
                    "30 fresh shrimps, skin removed and deveined",
                    "3 tablespoons extra virgin olive oil",
                    "Sechuan pepper",
                    "2 cups mixed salad",
                    "Salad seasoning",
                    "1 small ripe mango cut in little cubes",
                    "Black hawaian salt for garnish"
                ],
                "ingredients": [
                    {
                        "text": "1 big ripe mango",
                        "weight": 336,
                        "foodCategory": "fruit",
                        "foodId": "food_an1dqoib8xj3tyb3pr7c0abi4rbw",
                        "image": "https://www.edamam.com/food-img/6e0/6e04857756d0876f14bfc035ff238e0b.png"
                    },
                    {
                        "text": "1/3 cup canola oil",
                        "weight": 72.66666666666666,
                        "foodCategory": "Oils",
                        "foodId": "food_bk9p9aaavhvoq4bqsnprobpsiuxs",
                        "image": "https://www.edamam.com/food-img/07e/07e106ab3536d57428e5c46d009038f8.jpg"
                    },
                    {
                        "text": "1 lime - juice",
                        "weight": 44,
                        "foodCategory": "fruit",
                        "foodId": "food_b0iywbmaujvd4eblrooo9bsvn7e6",
                        "image": "https://www.edamam.com/food-img/8f0/8f0c10eb3dbf476a05e61018e76ea220.jpg"
                    },
                    {
                        "text": "1 tablespoon fresh ginger juice (grate the ginger and then squeeze the juice)",
                        "weight": 5.99999999989856,
                        "foodCategory": "vegetables",
                        "foodId": "food_bi2ki2xb5zmmvbaiwf7ztbgktzp6",
                        "image": "https://www.edamam.com/food-img/b9c/b9c06ef451ef29513880af0a53ebbaa6.jpg"
                    },
                    {
                        "text": "2 teaspoons curry powder",
                        "weight": 4,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_ao4koeoajh7yjxaq2knzrbv55y8o",
                        "image": "https://www.edamam.com/food-img/9ce/9ce02a2887385fd2adaec8dd8adcf9c5.jpg"
                    },
                    {
                        "text": "Sechuan pepper",
                        "weight": 2.8054999999996952,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_b6ywzluaaxv02wad7s1r9ag4py89",
                        "image": "https://www.edamam.com/food-img/c6e/c6e5c3bd8d3bc15175d9766971a4d1b2.jpg"
                    },
                    {
                        "text": "Salt",
                        "weight": 5.6109999999993905,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_btxz81db72hwbra2pncvebzzzum9",
                        "image": "https://www.edamam.com/food-img/694/6943ea510918c6025795e8dc6e6eaaeb.jpg"
                    },
                    {
                        "text": "30 fresh shrimps, skin removed and deveined",
                        "weight": 180,
                        "foodCategory": "seafood",
                        "foodId": "food_b38bejhbq9loe2bbb7bnmbcpteft",
                        "image": "https://www.edamam.com/food-img/ebe/ebe2888b894f48d19762e1d606db0206.jpg"
                    },
                    {
                        "text": "3 tablespoons extra virgin olive oil",
                        "weight": 40.5,
                        "foodCategory": "Oils",
                        "foodId": "food_b1d1icuad3iktrbqby0hiagafaz7",
                        "image": "https://www.edamam.com/food-img/4d6/4d651eaa8a353647746290c7a9b29d84.jpg"
                    },
                    {
                        "text": "Sechuan pepper",
                        "weight": 2.8054999999996952,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_b6ywzluaaxv02wad7s1r9ag4py89",
                        "image": "https://www.edamam.com/food-img/c6e/c6e5c3bd8d3bc15175d9766971a4d1b2.jpg"
                    },
                    {
                        "text": "Salad seasoning",
                        "weight": 9.35166666666565,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_aj7w3xab0epj7cbgkbkpwadysovd",
                        "image": "https://www.edamam.com/food-img/c23/c23e20823b442067307aa436969358f1.jpg"
                    },
                    {
                        "text": "1 small ripe mango cut in little cubes",
                        "weight": 252,
                        "foodCategory": "fruit",
                        "foodId": "food_an1dqoib8xj3tyb3pr7c0abi4rbw",
                        "image": "https://www.edamam.com/food-img/6e0/6e04857756d0876f14bfc035ff238e0b.png"
                    },
                    {
                        "text": "Black hawaian salt for garnish",
                        "weight": 5.6109999999993905,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_btxz81db72hwbra2pncvebzzzum9",
                        "image": "https://www.edamam.com/food-img/694/6943ea510918c6025795e8dc6e6eaaeb.jpg"
                    }
                ],
                "calories": 1552.5865599999142,
                "totalWeight": 953.1651700948788,
                "totalTime": 83,
                "cuisineType": [
                    "mediterranean"
                ],
                "mealType": [
                    "lunch/dinner"
                ],
                "dishType": [
                    "salad"
                ],
                "totalNutrients": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 1552.5865599999142,
                        "unit": "kcal"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 118.7423657666658,
                        "unit": "g"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 12.422294953333086,
                        "unit": "g"
                    },
                    "FATRN": {
                        "label": "Trans",
                        "quantity": 0.3194333333333333,
                        "unit": "g"
                    },
                    "FAMS": {
                        "label": "Monounsaturated",
                        "quantity": 77.19705138999983,
                        "unit": "g"
                    },
                    "FAPU": {
                        "label": "Polyunsaturated",
                        "quantity": 26.03879437999981,
                        "unit": "g"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 106.44659266664759,
                        "unit": "g"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 14.308321333331037,
                        "unit": "g"
                    },
                    "SUGAR": {
                        "label": "Sugars",
                        "quantity": 81.48104039999825,
                        "unit": "g"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 31.66500773333133,
                        "unit": "g"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 226.8,
                        "unit": "mg"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 2209.5067620797604,
                        "unit": "mg"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 309.13293082276664,
                        "unit": "mg"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 145.27290170090288,
                        "unit": "mg"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 1453.603456940496,
                        "unit": "mg"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 6.241184694645747,
                        "unit": "mg"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 2.882249070094598,
                        "unit": "mg"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 569.2567299999628,
                        "unit": "mg"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 429.49916999999846,
                        "unit": "µg"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 228.6821999999948,
                        "unit": "mg"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 0.2509282799999713,
                        "unit": "mg"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 0.2950414833332958,
                        "unit": "mg"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 7.713878229999202,
                        "unit": "mg"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 1.1598100099998225,
                        "unit": "mg"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 308.1991699999873,
                        "unit": "µg"
                    },
                    "FOLFD": {
                        "label": "Folate (food)",
                        "quantity": 308.1991699999873,
                        "unit": "µg"
                    },
                    "FOLAC": {
                        "label": "Folic acid",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 1.9980000000000002,
                        "unit": "µg"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 0.18000000000000002,
                        "unit": "µg"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 27.471146399999718,
                        "unit": "mg"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 190.19386366665736,
                        "unit": "µg"
                    },
                    "WATER": {
                        "label": "Water",
                        "quantity": 686.7716424401098,
                        "unit": "g"
                    }
                },
                "totalDaily": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 77.62932799999571,
                        "unit": "%"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 182.6805627179474,
                        "unit": "%"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 62.11147476666544,
                        "unit": "%"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 35.4821975555492,
                        "unit": "%"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 57.23328533332415,
                        "unit": "%"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 63.330015466662665,
                        "unit": "%"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 75.6,
                        "unit": "%"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 92.06278175332335,
                        "unit": "%"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 30.913293082276663,
                        "unit": "%"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 34.588786119262586,
                        "unit": "%"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 30.927733126393534,
                        "unit": "%"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 34.673248303587485,
                        "unit": "%"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 26.202264273587254,
                        "unit": "%"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 81.32238999999468,
                        "unit": "%"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 47.72212999999983,
                        "unit": "%"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 254.09133333332755,
                        "unit": "%"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 20.910689999997608,
                        "unit": "%"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 22.695498717945828,
                        "unit": "%"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 48.211738937495014,
                        "unit": "%"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 89.21615461537097,
                        "unit": "%"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 77.04979249999683,
                        "unit": "%"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 83.25000000000001,
                        "unit": "%"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 1.2000000000000002,
                        "unit": "%"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 183.14097599999812,
                        "unit": "%"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 158.49488638888116,
                        "unit": "%"
                    }
                },
                "digest": [
                    {
                        "label": "Fat",
                        "tag": "FAT",
                        "schemaOrgTag": "fatContent",
                        "total": 118.7423657666658,
                        "hasRDI": true,
                        "daily": 182.6805627179474,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Saturated",
                                "tag": "FASAT",
                                "schemaOrgTag": "saturatedFatContent",
                                "total": 12.422294953333086,
                                "hasRDI": true,
                                "daily": 62.11147476666544,
                                "unit": "g"
                            },
                            {
                                "label": "Trans",
                                "tag": "FATRN",
                                "schemaOrgTag": "transFatContent",
                                "total": 0.3194333333333333,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Monounsaturated",
                                "tag": "FAMS",
                                "schemaOrgTag": null,
                                "total": 77.19705138999983,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Polyunsaturated",
                                "tag": "FAPU",
                                "schemaOrgTag": null,
                                "total": 26.03879437999981,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Carbs",
                        "tag": "CHOCDF",
                        "schemaOrgTag": "carbohydrateContent",
                        "total": 106.44659266664759,
                        "hasRDI": true,
                        "daily": 35.4821975555492,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Carbs (net)",
                                "tag": "CHOCDF.net",
                                "schemaOrgTag": null,
                                "total": 92.13827133331655,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Fiber",
                                "tag": "FIBTG",
                                "schemaOrgTag": "fiberContent",
                                "total": 14.308321333331037,
                                "hasRDI": true,
                                "daily": 57.23328533332415,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars",
                                "tag": "SUGAR",
                                "schemaOrgTag": "sugarContent",
                                "total": 81.48104039999825,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars, added",
                                "tag": "SUGAR.added",
                                "schemaOrgTag": null,
                                "total": 0,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Protein",
                        "tag": "PROCNT",
                        "schemaOrgTag": "proteinContent",
                        "total": 31.66500773333133,
                        "hasRDI": true,
                        "daily": 63.330015466662665,
                        "unit": "g"
                    },
                    {
                        "label": "Cholesterol",
                        "tag": "CHOLE",
                        "schemaOrgTag": "cholesterolContent",
                        "total": 226.8,
                        "hasRDI": true,
                        "daily": 75.6,
                        "unit": "mg"
                    },
                    {
                        "label": "Sodium",
                        "tag": "NA",
                        "schemaOrgTag": "sodiumContent",
                        "total": 2209.5067620797604,
                        "hasRDI": true,
                        "daily": 92.06278175332335,
                        "unit": "mg"
                    },
                    {
                        "label": "Calcium",
                        "tag": "CA",
                        "schemaOrgTag": null,
                        "total": 309.13293082276664,
                        "hasRDI": true,
                        "daily": 30.913293082276663,
                        "unit": "mg"
                    },
                    {
                        "label": "Magnesium",
                        "tag": "MG",
                        "schemaOrgTag": null,
                        "total": 145.27290170090288,
                        "hasRDI": true,
                        "daily": 34.588786119262586,
                        "unit": "mg"
                    },
                    {
                        "label": "Potassium",
                        "tag": "K",
                        "schemaOrgTag": null,
                        "total": 1453.603456940496,
                        "hasRDI": true,
                        "daily": 30.927733126393534,
                        "unit": "mg"
                    },
                    {
                        "label": "Iron",
                        "tag": "FE",
                        "schemaOrgTag": null,
                        "total": 6.241184694645747,
                        "hasRDI": true,
                        "daily": 34.673248303587485,
                        "unit": "mg"
                    },
                    {
                        "label": "Zinc",
                        "tag": "ZN",
                        "schemaOrgTag": null,
                        "total": 2.882249070094598,
                        "hasRDI": true,
                        "daily": 26.202264273587254,
                        "unit": "mg"
                    },
                    {
                        "label": "Phosphorus",
                        "tag": "P",
                        "schemaOrgTag": null,
                        "total": 569.2567299999628,
                        "hasRDI": true,
                        "daily": 81.32238999999468,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin A",
                        "tag": "VITA_RAE",
                        "schemaOrgTag": null,
                        "total": 429.49916999999846,
                        "hasRDI": true,
                        "daily": 47.72212999999983,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin C",
                        "tag": "VITC",
                        "schemaOrgTag": null,
                        "total": 228.6821999999948,
                        "hasRDI": true,
                        "daily": 254.09133333332755,
                        "unit": "mg"
                    },
                    {
                        "label": "Thiamin (B1)",
                        "tag": "THIA",
                        "schemaOrgTag": null,
                        "total": 0.2509282799999713,
                        "hasRDI": true,
                        "daily": 20.910689999997608,
                        "unit": "mg"
                    },
                    {
                        "label": "Riboflavin (B2)",
                        "tag": "RIBF",
                        "schemaOrgTag": null,
                        "total": 0.2950414833332958,
                        "hasRDI": true,
                        "daily": 22.695498717945828,
                        "unit": "mg"
                    },
                    {
                        "label": "Niacin (B3)",
                        "tag": "NIA",
                        "schemaOrgTag": null,
                        "total": 7.713878229999202,
                        "hasRDI": true,
                        "daily": 48.211738937495014,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin B6",
                        "tag": "VITB6A",
                        "schemaOrgTag": null,
                        "total": 1.1598100099998225,
                        "hasRDI": true,
                        "daily": 89.21615461537097,
                        "unit": "mg"
                    },
                    {
                        "label": "Folate equivalent (total)",
                        "tag": "FOLDFE",
                        "schemaOrgTag": null,
                        "total": 308.1991699999873,
                        "hasRDI": true,
                        "daily": 77.04979249999683,
                        "unit": "µg"
                    },
                    {
                        "label": "Folate (food)",
                        "tag": "FOLFD",
                        "schemaOrgTag": null,
                        "total": 308.1991699999873,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Folic acid",
                        "tag": "FOLAC",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin B12",
                        "tag": "VITB12",
                        "schemaOrgTag": null,
                        "total": 1.9980000000000002,
                        "hasRDI": true,
                        "daily": 83.25000000000001,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin D",
                        "tag": "VITD",
                        "schemaOrgTag": null,
                        "total": 0.18000000000000002,
                        "hasRDI": true,
                        "daily": 1.2000000000000002,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin E",
                        "tag": "TOCPHA",
                        "schemaOrgTag": null,
                        "total": 27.471146399999718,
                        "hasRDI": true,
                        "daily": 183.14097599999812,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin K",
                        "tag": "VITK1",
                        "schemaOrgTag": null,
                        "total": 190.19386366665736,
                        "hasRDI": true,
                        "daily": 158.49488638888116,
                        "unit": "µg"
                    },
                    {
                        "label": "Sugar alcohols",
                        "tag": "Sugar.alcohol",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    },
                    {
                        "label": "Water",
                        "tag": "WATER",
                        "schemaOrgTag": null,
                        "total": 686.7716424401098,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    }
                ]
            },
            "_links": {
                "self": {
                    "href": "https://api.edamam.com/api/recipes/v2/e2a04a8cd05720a8105047614b73dd9c?type=public&app_id=ea1d37d5&app_key=fd382a172ba8d6668c0430dc9c14a181",
                    "title": "Self"
                }
            }
        },
        {
            "recipe": {
                "uri": "http://www.edamam.com/ontologies/edamam.owl#recipe_af6176f4ddf57e471537a303490af4bb",
                "label": "Heart-Shaped Salad",
                "image": "https://www.edamam.com/web-img/a1d/a1d996360fbe7f5c074b16783a99f223.jpg",
                "source": "Delish",
                "url": "http://www.delish.com/cooking/recipe-ideas/recipes/a36367/heart-shaped-salad-recipe-ghk0214/",
                "shareAs": "http://www.edamam.com/recipe/heart-shaped-salad-af6176f4ddf57e471537a303490af4bb/salad",
                "yield": 4,
                "dietLabels": [
                    "Low-Carb"
                ],
                "healthLabels": [
                    "Sugar-Conscious",
                    "Kidney-Friendly",
                    "Keto-Friendly",
                    "Vegan",
                    "Vegetarian",
                    "Pescatarian",
                    "DASH",
                    "Dairy-Free",
                    "Gluten-Free",
                    "Wheat-Free",
                    "Egg-Free",
                    "Peanut-Free",
                    "Tree-Nut-Free",
                    "Soy-Free",
                    "Fish-Free",
                    "Shellfish-Free",
                    "Pork-Free",
                    "Red-Meat-Free",
                    "Crustacean-Free",
                    "Celery-Free",
                    "Mustard-Free",
                    "Sesame-Free",
                    "Lupine-Free",
                    "Mollusk-Free",
                    "Alcohol-Free",
                    "Sulfite-Free",
                    "FODMAP-Free",
                    "Kosher"
                ],
                "cautions": [
                    "Sulfites",
                    "FODMAP"
                ],
                "ingredientLines": [
                    "1 head iceberg lettuce",
                    "¼ c. your favorite salad dressing",
                    "salt",
                    "Freshly ground pepper"
                ],
                "ingredients": [
                    {
                        "text": "1 head iceberg lettuce",
                        "weight": 525,
                        "foodCategory": "vegetables",
                        "foodId": "food_advhqk1a09o2noblosrg6a4z10xv",
                        "image": "https://www.edamam.com/food-img/3c0/3c00c5ba27678b2f8e1c58b342bd98c7.jpg"
                    },
                    {
                        "text": "¼ c. your favorite salad dressing",
                        "weight": 62.5,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_a67f1v3boelh4wasob4qib34t5bv",
                        "image": "https://www.edamam.com/food-img/241/24178db68d42001caf980f8f209534cb.jpg"
                    },
                    {
                        "text": "salt",
                        "weight": 3.525,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_btxz81db72hwbra2pncvebzzzum9",
                        "image": "https://www.edamam.com/food-img/694/6943ea510918c6025795e8dc6e6eaaeb.jpg"
                    },
                    {
                        "text": "Freshly ground pepper",
                        "weight": 1.7625,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_b6ywzluaaxv02wad7s1r9ag4py89",
                        "image": "https://www.edamam.com/food-img/c6e/c6e5c3bd8d3bc15175d9766971a4d1b2.jpg"
                    }
                ],
                "calories": 358.548875,
                "totalWeight": 592.6600970341607,
                "totalTime": 0,
                "cuisineType": [
                    "mediterranean"
                ],
                "mealType": [
                    "lunch/dinner"
                ],
                "dishType": [
                    "salad"
                ],
                "totalNutrients": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 358.548875,
                        "unit": "kcal"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 32.1049575,
                        "unit": "g"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 5.806534,
                        "unit": "g"
                    },
                    "FATRN": {
                        "label": "Trans",
                        "quantity": 0,
                        "unit": "g"
                    },
                    "FAMS": {
                        "label": "Monounsaturated",
                        "quantity": 9.294524874999999,
                        "unit": "g"
                    },
                    "FAPU": {
                        "label": "Polyunsaturated",
                        "quantity": 15.468589750000001,
                        "unit": "g"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 18.282118750000002,
                        "unit": "g"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 6.7459125,
                        "unit": "g"
                    },
                    "SUGAR": {
                        "label": "Sugars",
                        "quantity": 11.916279999999999,
                        "unit": "g"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 4.908123750000001,
                        "unit": "g"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 0,
                        "unit": "mg"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 1370.3181585000004,
                        "unit": "mg"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 103.12329828819855,
                        "unit": "mg"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 39.79785097034161,
                        "unit": "mg"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 768.9454327627328,
                        "unit": "mg"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 2.33485082021273,
                        "unit": "mg"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 0.8118713470341606,
                        "unit": "mg"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 107.78475,
                        "unit": "mg"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 131.725875,
                        "unit": "µg"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 14.7,
                        "unit": "mg"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 0.2171535,
                        "unit": "mg"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 0.1344225,
                        "unit": "mg"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 0.6658953750000001,
                        "unit": "mg"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 0.225628875,
                        "unit": "mg"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 152.549625,
                        "unit": "µg"
                    },
                    "FOLFD": {
                        "label": "Folate (food)",
                        "quantity": 152.549625,
                        "unit": "µg"
                    },
                    "FOLAC": {
                        "label": "Folic acid",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 3.84458,
                        "unit": "mg"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 191.1602125,
                        "unit": "µg"
                    },
                    "WATER": {
                        "label": "Water",
                        "quantity": 531.9614026940684,
                        "unit": "g"
                    }
                },
                "totalDaily": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 17.927443750000002,
                        "unit": "%"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 49.3922423076923,
                        "unit": "%"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 29.032670000000003,
                        "unit": "%"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 6.094039583333334,
                        "unit": "%"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 26.98365,
                        "unit": "%"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 9.816247500000001,
                        "unit": "%"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 0,
                        "unit": "%"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 57.09658993750002,
                        "unit": "%"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 10.312329828819855,
                        "unit": "%"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 9.475678802462287,
                        "unit": "%"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 16.360541122611338,
                        "unit": "%"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 12.971393445626278,
                        "unit": "%"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 7.380648609401461,
                        "unit": "%"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 15.39782142857143,
                        "unit": "%"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 14.636208333333332,
                        "unit": "%"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 16.333333333333332,
                        "unit": "%"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 18.096125,
                        "unit": "%"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 10.340192307692307,
                        "unit": "%"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 4.16184609375,
                        "unit": "%"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 17.35606730769231,
                        "unit": "%"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 38.13740625,
                        "unit": "%"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 0,
                        "unit": "%"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 0,
                        "unit": "%"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 25.630533333333336,
                        "unit": "%"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 159.30017708333335,
                        "unit": "%"
                    }
                },
                "digest": [
                    {
                        "label": "Fat",
                        "tag": "FAT",
                        "schemaOrgTag": "fatContent",
                        "total": 32.1049575,
                        "hasRDI": true,
                        "daily": 49.3922423076923,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Saturated",
                                "tag": "FASAT",
                                "schemaOrgTag": "saturatedFatContent",
                                "total": 5.806534,
                                "hasRDI": true,
                                "daily": 29.032670000000003,
                                "unit": "g"
                            },
                            {
                                "label": "Trans",
                                "tag": "FATRN",
                                "schemaOrgTag": "transFatContent",
                                "total": 0,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Monounsaturated",
                                "tag": "FAMS",
                                "schemaOrgTag": null,
                                "total": 9.294524874999999,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Polyunsaturated",
                                "tag": "FAPU",
                                "schemaOrgTag": null,
                                "total": 15.468589750000001,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Carbs",
                        "tag": "CHOCDF",
                        "schemaOrgTag": "carbohydrateContent",
                        "total": 18.282118750000002,
                        "hasRDI": true,
                        "daily": 6.094039583333334,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Carbs (net)",
                                "tag": "CHOCDF.net",
                                "schemaOrgTag": null,
                                "total": 11.536206250000003,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Fiber",
                                "tag": "FIBTG",
                                "schemaOrgTag": "fiberContent",
                                "total": 6.7459125,
                                "hasRDI": true,
                                "daily": 26.98365,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars",
                                "tag": "SUGAR",
                                "schemaOrgTag": "sugarContent",
                                "total": 11.916279999999999,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars, added",
                                "tag": "SUGAR.added",
                                "schemaOrgTag": null,
                                "total": 0,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Protein",
                        "tag": "PROCNT",
                        "schemaOrgTag": "proteinContent",
                        "total": 4.908123750000001,
                        "hasRDI": true,
                        "daily": 9.816247500000001,
                        "unit": "g"
                    },
                    {
                        "label": "Cholesterol",
                        "tag": "CHOLE",
                        "schemaOrgTag": "cholesterolContent",
                        "total": 0,
                        "hasRDI": true,
                        "daily": 0,
                        "unit": "mg"
                    },
                    {
                        "label": "Sodium",
                        "tag": "NA",
                        "schemaOrgTag": "sodiumContent",
                        "total": 1370.3181585000004,
                        "hasRDI": true,
                        "daily": 57.09658993750002,
                        "unit": "mg"
                    },
                    {
                        "label": "Calcium",
                        "tag": "CA",
                        "schemaOrgTag": null,
                        "total": 103.12329828819855,
                        "hasRDI": true,
                        "daily": 10.312329828819855,
                        "unit": "mg"
                    },
                    {
                        "label": "Magnesium",
                        "tag": "MG",
                        "schemaOrgTag": null,
                        "total": 39.79785097034161,
                        "hasRDI": true,
                        "daily": 9.475678802462287,
                        "unit": "mg"
                    },
                    {
                        "label": "Potassium",
                        "tag": "K",
                        "schemaOrgTag": null,
                        "total": 768.9454327627328,
                        "hasRDI": true,
                        "daily": 16.360541122611338,
                        "unit": "mg"
                    },
                    {
                        "label": "Iron",
                        "tag": "FE",
                        "schemaOrgTag": null,
                        "total": 2.33485082021273,
                        "hasRDI": true,
                        "daily": 12.971393445626278,
                        "unit": "mg"
                    },
                    {
                        "label": "Zinc",
                        "tag": "ZN",
                        "schemaOrgTag": null,
                        "total": 0.8118713470341606,
                        "hasRDI": true,
                        "daily": 7.380648609401461,
                        "unit": "mg"
                    },
                    {
                        "label": "Phosphorus",
                        "tag": "P",
                        "schemaOrgTag": null,
                        "total": 107.78475,
                        "hasRDI": true,
                        "daily": 15.39782142857143,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin A",
                        "tag": "VITA_RAE",
                        "schemaOrgTag": null,
                        "total": 131.725875,
                        "hasRDI": true,
                        "daily": 14.636208333333332,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin C",
                        "tag": "VITC",
                        "schemaOrgTag": null,
                        "total": 14.7,
                        "hasRDI": true,
                        "daily": 16.333333333333332,
                        "unit": "mg"
                    },
                    {
                        "label": "Thiamin (B1)",
                        "tag": "THIA",
                        "schemaOrgTag": null,
                        "total": 0.2171535,
                        "hasRDI": true,
                        "daily": 18.096125,
                        "unit": "mg"
                    },
                    {
                        "label": "Riboflavin (B2)",
                        "tag": "RIBF",
                        "schemaOrgTag": null,
                        "total": 0.1344225,
                        "hasRDI": true,
                        "daily": 10.340192307692307,
                        "unit": "mg"
                    },
                    {
                        "label": "Niacin (B3)",
                        "tag": "NIA",
                        "schemaOrgTag": null,
                        "total": 0.6658953750000001,
                        "hasRDI": true,
                        "daily": 4.16184609375,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin B6",
                        "tag": "VITB6A",
                        "schemaOrgTag": null,
                        "total": 0.225628875,
                        "hasRDI": true,
                        "daily": 17.35606730769231,
                        "unit": "mg"
                    },
                    {
                        "label": "Folate equivalent (total)",
                        "tag": "FOLDFE",
                        "schemaOrgTag": null,
                        "total": 152.549625,
                        "hasRDI": true,
                        "daily": 38.13740625,
                        "unit": "µg"
                    },
                    {
                        "label": "Folate (food)",
                        "tag": "FOLFD",
                        "schemaOrgTag": null,
                        "total": 152.549625,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Folic acid",
                        "tag": "FOLAC",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin B12",
                        "tag": "VITB12",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": true,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin D",
                        "tag": "VITD",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": true,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin E",
                        "tag": "TOCPHA",
                        "schemaOrgTag": null,
                        "total": 3.84458,
                        "hasRDI": true,
                        "daily": 25.630533333333336,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin K",
                        "tag": "VITK1",
                        "schemaOrgTag": null,
                        "total": 191.1602125,
                        "hasRDI": true,
                        "daily": 159.30017708333335,
                        "unit": "µg"
                    },
                    {
                        "label": "Sugar alcohols",
                        "tag": "Sugar.alcohol",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    },
                    {
                        "label": "Water",
                        "tag": "WATER",
                        "schemaOrgTag": null,
                        "total": 531.9614026940684,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    }
                ]
            },
            "_links": {
                "self": {
                    "href": "https://api.edamam.com/api/recipes/v2/af6176f4ddf57e471537a303490af4bb?type=public&app_id=ea1d37d5&app_key=fd382a172ba8d6668c0430dc9c14a181",
                    "title": "Self"
                }
            }
        },
        {
            "recipe": {
                "uri": "http://www.edamam.com/ontologies/edamam.owl#recipe_9293163b09aa19bcd8839e2efbc75cd0",
                "label": "Orange & Avocado Salad",
                "image": "https://www.edamam.com/web-img/24d/24df479bed91d41bf133c24c092a4e44.jpg",
                "source": "EatingWell",
                "url": "http://www.eatingwell.com/recipes/orange_avocado_salad.html",
                "shareAs": "http://www.edamam.com/recipe/orange-avocado-salad-9293163b09aa19bcd8839e2efbc75cd0/salad",
                "yield": 4,
                "dietLabels": [
                    "High-Fiber",
                    "Low-Sodium"
                ],
                "healthLabels": [
                    "Vegan",
                    "Vegetarian",
                    "Pescatarian",
                    "DASH",
                    "Dairy-Free",
                    "Gluten-Free",
                    "Wheat-Free",
                    "Egg-Free",
                    "Peanut-Free",
                    "Tree-Nut-Free",
                    "Soy-Free",
                    "Fish-Free",
                    "Shellfish-Free",
                    "Pork-Free",
                    "Red-Meat-Free",
                    "Crustacean-Free",
                    "Celery-Free",
                    "Mustard-Free",
                    "Sesame-Free",
                    "Lupine-Free",
                    "Mollusk-Free",
                    "Alcohol-Free",
                    "Sulfite-Free",
                    "Kosher"
                ],
                "cautions": [
                    "Sulfites"
                ],
                "ingredientLines": [
                    "This recipe calls for:",
                    "Cilantro-Lime Vinaigrette",
                    "1/2 cup Cilantro-Lime Vinaigrette, (recipe follows)",
                    "8 cups mixed salad greens",
                    "1 cup orange segments",
                    "1 avocado, diced",
                    "1/4 cup slivered red onion"
                ],
                "ingredients": [
                    {
                        "text": "Cilantro-Lime Vinaigrette",
                        "weight": 7.09,
                        "foodCategory": "vegetables",
                        "foodId": "food_alhzhuwb4lc7jnb5s6f02by60bzp",
                        "image": "https://www.edamam.com/food-img/d57/d57e375b6ff99a90c7ee2b1990a1af36.jpg"
                    },
                    {
                        "text": "8 cups mixed salad greens",
                        "weight": 288,
                        "foodCategory": "vegetables",
                        "foodId": "food_bqalyxzbzu04hcb8xj930bzar7xg",
                        "image": "https://www.edamam.com/food-img/b6d/b6d9f3052d27a3c71220cfa55c6f0a42.jpg"
                    },
                    {
                        "text": "1 cup orange segments",
                        "weight": 180,
                        "foodCategory": "fruit",
                        "foodId": "food_b0bnl8oayiqhs2at63ifxbm6i3o3",
                        "image": "https://www.edamam.com/food-img/8ea/8ea264a802d6e643c1a340a77863c6ef.jpg"
                    },
                    {
                        "text": "1 avocado, diced",
                        "weight": 201,
                        "foodCategory": "fruit",
                        "foodId": "food_b0yuze4b1g3afpanijno5abtiu28",
                        "image": "https://www.edamam.com/food-img/984/984a707ea8e9c6bf5f6498970a9e6d9d.jpg"
                    },
                    {
                        "text": "1/4 cup slivered red onion",
                        "weight": 40,
                        "foodCategory": "vegetables",
                        "foodId": "food_bmrvi4ob4binw9a5m7l07amlfcoy",
                        "image": "https://www.edamam.com/food-img/205/205e6bf2399b85d34741892ef91cc603.jpg"
                    }
                ],
                "calories": 467.0307,
                "totalWeight": 716.0899999999999,
                "totalTime": 0,
                "cuisineType": [
                    "american"
                ],
                "mealType": [
                    "lunch/dinner"
                ],
                "dishType": [
                    "salad"
                ],
                "totalNutrients": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 467.0307,
                        "unit": "kcal"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 30.191468000000004,
                        "unit": "g"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 4.3756526000000004,
                        "unit": "g"
                    },
                    "FAMS": {
                        "label": "Monounsaturated",
                        "quantity": 19.7793675,
                        "unit": "g"
                    },
                    "FAPU": {
                        "label": "Polyunsaturated",
                        "quantity": 3.940956000000001,
                        "unit": "g"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 50.557103000000005,
                        "unit": "g"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 22.40952,
                        "unit": "g"
                    },
                    "SUGAR": {
                        "label": "Sugars",
                        "quantity": 22.160683,
                        "unit": "g"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 10.219817,
                        "unit": "g"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 0,
                        "unit": "mg"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 99.5714,
                        "unit": "mg"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 213.75029999999998,
                        "unit": "mg"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 119.5734,
                        "unit": "mg"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 1954.7089000000003,
                        "unit": "mg"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 3.9717930000000004,
                        "unit": "mg"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 2.03425,
                        "unit": "mg"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 228.2432,
                        "unit": "mg"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 1123.3632999999998,
                        "unit": "µg"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 147.2303,
                        "unit": "mg"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 0.5160203,
                        "unit": "mg"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 0.5859858000000001,
                        "unit": "mg"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 5.2063626,
                        "unit": "mg"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 0.9423341000000001,
                        "unit": "mg"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 338.24580000000003,
                        "unit": "µg"
                    },
                    "FOLFD": {
                        "label": "Folate (food)",
                        "quantity": 338.24580000000003,
                        "unit": "µg"
                    },
                    "FOLAC": {
                        "label": "Folic acid",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 5.30355,
                        "unit": "mg"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 428.093,
                        "unit": "µg"
                    },
                    "WATER": {
                        "label": "Water",
                        "quantity": 619.0663890000001,
                        "unit": "g"
                    }
                },
                "totalDaily": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 23.351535,
                        "unit": "%"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 46.448412307692315,
                        "unit": "%"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 21.878263,
                        "unit": "%"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 16.85236766666667,
                        "unit": "%"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 89.63808,
                        "unit": "%"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 20.439634,
                        "unit": "%"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 0,
                        "unit": "%"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 4.148808333333333,
                        "unit": "%"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 21.37503,
                        "unit": "%"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 28.469857142857144,
                        "unit": "%"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 41.589551063829795,
                        "unit": "%"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 22.065516666666667,
                        "unit": "%"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 18.49318181818182,
                        "unit": "%"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 32.60617142857143,
                        "unit": "%"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 124.81814444444441,
                        "unit": "%"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 163.58922222222222,
                        "unit": "%"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 43.001691666666666,
                        "unit": "%"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 45.07583076923078,
                        "unit": "%"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 32.53976625,
                        "unit": "%"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 72.48723846153847,
                        "unit": "%"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 84.56145000000001,
                        "unit": "%"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 0,
                        "unit": "%"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 0,
                        "unit": "%"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 35.357,
                        "unit": "%"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 356.7441666666667,
                        "unit": "%"
                    }
                },
                "digest": [
                    {
                        "label": "Fat",
                        "tag": "FAT",
                        "schemaOrgTag": "fatContent",
                        "total": 30.191468000000004,
                        "hasRDI": true,
                        "daily": 46.448412307692315,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Saturated",
                                "tag": "FASAT",
                                "schemaOrgTag": "saturatedFatContent",
                                "total": 4.3756526000000004,
                                "hasRDI": true,
                                "daily": 21.878263,
                                "unit": "g"
                            },
                            {
                                "label": "Trans",
                                "tag": "FATRN",
                                "schemaOrgTag": "transFatContent",
                                "total": 0,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Monounsaturated",
                                "tag": "FAMS",
                                "schemaOrgTag": null,
                                "total": 19.7793675,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Polyunsaturated",
                                "tag": "FAPU",
                                "schemaOrgTag": null,
                                "total": 3.940956000000001,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Carbs",
                        "tag": "CHOCDF",
                        "schemaOrgTag": "carbohydrateContent",
                        "total": 50.557103000000005,
                        "hasRDI": true,
                        "daily": 16.85236766666667,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Carbs (net)",
                                "tag": "CHOCDF.net",
                                "schemaOrgTag": null,
                                "total": 28.147583000000004,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Fiber",
                                "tag": "FIBTG",
                                "schemaOrgTag": "fiberContent",
                                "total": 22.40952,
                                "hasRDI": true,
                                "daily": 89.63808,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars",
                                "tag": "SUGAR",
                                "schemaOrgTag": "sugarContent",
                                "total": 22.160683,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars, added",
                                "tag": "SUGAR.added",
                                "schemaOrgTag": null,
                                "total": 0,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Protein",
                        "tag": "PROCNT",
                        "schemaOrgTag": "proteinContent",
                        "total": 10.219817,
                        "hasRDI": true,
                        "daily": 20.439634,
                        "unit": "g"
                    },
                    {
                        "label": "Cholesterol",
                        "tag": "CHOLE",
                        "schemaOrgTag": "cholesterolContent",
                        "total": 0,
                        "hasRDI": true,
                        "daily": 0,
                        "unit": "mg"
                    },
                    {
                        "label": "Sodium",
                        "tag": "NA",
                        "schemaOrgTag": "sodiumContent",
                        "total": 99.5714,
                        "hasRDI": true,
                        "daily": 4.148808333333333,
                        "unit": "mg"
                    },
                    {
                        "label": "Calcium",
                        "tag": "CA",
                        "schemaOrgTag": null,
                        "total": 213.75029999999998,
                        "hasRDI": true,
                        "daily": 21.37503,
                        "unit": "mg"
                    },
                    {
                        "label": "Magnesium",
                        "tag": "MG",
                        "schemaOrgTag": null,
                        "total": 119.5734,
                        "hasRDI": true,
                        "daily": 28.469857142857144,
                        "unit": "mg"
                    },
                    {
                        "label": "Potassium",
                        "tag": "K",
                        "schemaOrgTag": null,
                        "total": 1954.7089000000003,
                        "hasRDI": true,
                        "daily": 41.589551063829795,
                        "unit": "mg"
                    },
                    {
                        "label": "Iron",
                        "tag": "FE",
                        "schemaOrgTag": null,
                        "total": 3.9717930000000004,
                        "hasRDI": true,
                        "daily": 22.065516666666667,
                        "unit": "mg"
                    },
                    {
                        "label": "Zinc",
                        "tag": "ZN",
                        "schemaOrgTag": null,
                        "total": 2.03425,
                        "hasRDI": true,
                        "daily": 18.49318181818182,
                        "unit": "mg"
                    },
                    {
                        "label": "Phosphorus",
                        "tag": "P",
                        "schemaOrgTag": null,
                        "total": 228.2432,
                        "hasRDI": true,
                        "daily": 32.60617142857143,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin A",
                        "tag": "VITA_RAE",
                        "schemaOrgTag": null,
                        "total": 1123.3632999999998,
                        "hasRDI": true,
                        "daily": 124.81814444444441,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin C",
                        "tag": "VITC",
                        "schemaOrgTag": null,
                        "total": 147.2303,
                        "hasRDI": true,
                        "daily": 163.58922222222222,
                        "unit": "mg"
                    },
                    {
                        "label": "Thiamin (B1)",
                        "tag": "THIA",
                        "schemaOrgTag": null,
                        "total": 0.5160203,
                        "hasRDI": true,
                        "daily": 43.001691666666666,
                        "unit": "mg"
                    },
                    {
                        "label": "Riboflavin (B2)",
                        "tag": "RIBF",
                        "schemaOrgTag": null,
                        "total": 0.5859858000000001,
                        "hasRDI": true,
                        "daily": 45.07583076923078,
                        "unit": "mg"
                    },
                    {
                        "label": "Niacin (B3)",
                        "tag": "NIA",
                        "schemaOrgTag": null,
                        "total": 5.2063626,
                        "hasRDI": true,
                        "daily": 32.53976625,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin B6",
                        "tag": "VITB6A",
                        "schemaOrgTag": null,
                        "total": 0.9423341000000001,
                        "hasRDI": true,
                        "daily": 72.48723846153847,
                        "unit": "mg"
                    },
                    {
                        "label": "Folate equivalent (total)",
                        "tag": "FOLDFE",
                        "schemaOrgTag": null,
                        "total": 338.24580000000003,
                        "hasRDI": true,
                        "daily": 84.56145000000001,
                        "unit": "µg"
                    },
                    {
                        "label": "Folate (food)",
                        "tag": "FOLFD",
                        "schemaOrgTag": null,
                        "total": 338.24580000000003,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Folic acid",
                        "tag": "FOLAC",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin B12",
                        "tag": "VITB12",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": true,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin D",
                        "tag": "VITD",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": true,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin E",
                        "tag": "TOCPHA",
                        "schemaOrgTag": null,
                        "total": 5.30355,
                        "hasRDI": true,
                        "daily": 35.357,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin K",
                        "tag": "VITK1",
                        "schemaOrgTag": null,
                        "total": 428.093,
                        "hasRDI": true,
                        "daily": 356.7441666666667,
                        "unit": "µg"
                    },
                    {
                        "label": "Sugar alcohols",
                        "tag": "Sugar.alcohol",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    },
                    {
                        "label": "Water",
                        "tag": "WATER",
                        "schemaOrgTag": null,
                        "total": 619.0663890000001,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    }
                ]
            },
            "_links": {
                "self": {
                    "href": "https://api.edamam.com/api/recipes/v2/9293163b09aa19bcd8839e2efbc75cd0?type=public&app_id=ea1d37d5&app_key=fd382a172ba8d6668c0430dc9c14a181",
                    "title": "Self"
                }
            }
        }
    ]
};

export const veganRecipes = {
    "from": 1,
    "to": 20,
    "count": 10000,
    "_links": {
        "next": {
            "href": "https://api.edamam.com/api/recipes/v2?q=vegan&app_key=fd382a172ba8d6668c0430dc9c14a181&_cont=CHcVQBtNNQphDmgVQntAEX4BYl1tAwcPQGBIAGoQYlJ7AwIVX3dFVWQWZ11xAQoBEmERUTAbNVZyAQZRQWJAVmpCZQQgBhFqX3cWQT1OcV9xBB8VADQWVhFCPwoxXVZEITQeVDcBaR4-SQ%3D%3D&type=public&app_id=ea1d37d5",
            "title": "Next page"
        }
    },
    "hits": [
        {
            "recipe": {
                "uri": "http://www.edamam.com/ontologies/edamam.owl#recipe_225c6ad5a2b909c3f2bdca88fcaf8aee",
                "label": "Vegan cupcakes",
                "image": "https://www.edamam.com/web-img/73f/73f15b90b6e64653c77ef759ed9ccdea.jpg",
                "source": "BBC Good Food",
                "url": "https://www.bbcgoodfood.com/recipes/vegan-cupcakes",
                "shareAs": "http://www.edamam.com/recipe/vegan-cupcakes-225c6ad5a2b909c3f2bdca88fcaf8aee/vegan",
                "yield": 12,
                "dietLabels": [
                    "Low-Sodium"
                ],
                "healthLabels": [
                    "Low Potassium",
                    "Kidney-Friendly",
                    "Vegan",
                    "Vegetarian",
                    "Pescatarian",
                    "Dairy-Free",
                    "Egg-Free",
                    "Peanut-Free",
                    "Fish-Free",
                    "Shellfish-Free",
                    "Pork-Free",
                    "Red-Meat-Free",
                    "Crustacean-Free",
                    "Celery-Free",
                    "Mustard-Free",
                    "Sesame-Free",
                    "Lupine-Free",
                    "Mollusk-Free",
                    "Alcohol-Free",
                    "Kosher"
                ],
                "cautions": [
                    "FODMAP"
                ],
                "ingredientLines": [
                    "150ml almond or soy milk",
                    "½ tsp cider vinegar",
                    "110g vegan butter or sunflower spread",
                    "110g caster sugar",
                    "1 tsp vanilla extract",
                    "110g self-raising flour",
                    "½ tsp baking powder",
                    "125g vegan butter",
                    "250g icing sugar",
                    "1¼ tsp vanilla extract",
                    "a few drops of vegan food colourings (check the label)"
                ],
                "ingredients": [
                    {
                        "text": "150ml almond or soy milk",
                        "weight": 90.66384836931654,
                        "foodCategory": "plant-based protein",
                        "foodId": "food_bq4d2wras281i0br37nrnaglo3yc",
                        "image": "https://www.edamam.com/food-img/6c2/6c2dc21adf11afc4c8d390ee2f651e56.jpg"
                    },
                    {
                        "text": "½ tsp cider vinegar",
                        "weight": 2.5,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_ar8m7esapmfvf8bnhfzdlabndh6v",
                        "image": "https://www.edamam.com/food-img/c7d/c7dbd1846c5d08e9739930d70a404d50.jpg"
                    },
                    {
                        "text": "110g vegan butter or sunflower spread",
                        "weight": 110,
                        "foodCategory": "Oils",
                        "foodId": "food_bn7cczea5psahcbaqvd2ob43qksr",
                        "image": "https://www.edamam.com/food-img/330/3302cd340e3d2dcf7f02e72fdfe8b209.jpg"
                    },
                    {
                        "text": "110g caster sugar",
                        "weight": 110,
                        "foodCategory": "sugars",
                        "foodId": "food_b83hz1dbrydiwzag8btahb15lu4l",
                        "image": "https://www.edamam.com/food-img/ecb/ecb3f5aaed96d0188c21b8369be07765.jpg"
                    },
                    {
                        "text": "1 tsp vanilla extract",
                        "weight": 4.2,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_bh1wvnqaw3q7ciascfoygaabax2a",
                        "image": "https://www.edamam.com/food-img/90f/90f910b0bf82750d4f6528263e014cca.jpg"
                    },
                    {
                        "text": "110g self-raising flour",
                        "weight": 110,
                        "foodCategory": "grains",
                        "foodId": "food_ahebfs0a985an4aubqaebbipra58",
                        "image": "https://www.edamam.com/food-img/b4c/b4c739e76a6f2172b7ad49d0aa41d5aa.jpg"
                    },
                    {
                        "text": "½ tsp baking powder",
                        "weight": 2.3,
                        "foodCategory": "condiments and sauces",
                        "foodId": "food_bad4zycbt4w60dbut111vaub2g3e",
                        "image": "https://www.edamam.com/food-img/a84/a8410ec57a2e62a1ad9955ac14d40af6.jpg"
                    },
                    {
                        "text": "125g vegan butter",
                        "weight": 125,
                        "foodCategory": "Oils",
                        "foodId": "food_bn7cczea5psahcbaqvd2ob43qksr",
                        "image": "https://www.edamam.com/food-img/330/3302cd340e3d2dcf7f02e72fdfe8b209.jpg"
                    },
                    {
                        "text": "250g icing sugar",
                        "weight": 250,
                        "foodCategory": "sugars",
                        "foodId": "food_b7rbtshahirxisbtyc77sbv8jdue",
                        "image": "https://www.edamam.com/food-img/290/290624aa4c0e279551e462443e38bb40.jpg"
                    },
                    {
                        "text": "1¼ tsp vanilla extract",
                        "weight": 5.25,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_bh1wvnqaw3q7ciascfoygaabax2a",
                        "image": "https://www.edamam.com/food-img/90f/90f910b0bf82750d4f6528263e014cca.jpg"
                    },
                    {
                        "text": "a few drops of vegan food colourings (check the label)",
                        "weight": 0.06161152,
                        "foodCategory": "water",
                        "foodId": "food_avcjo2fattdi8eafpf0ujatvwb7i",
                        "image": "https://www.edamam.com/food-img/5dd/5dd9d1361847b2ca53c4b19a8f92627e.jpg"
                    }
                ],
                "calories": 4429.857682058343,
                "totalWeight": 809.9754598893167,
                "totalTime": 50,
                "cuisineType": [
                    "american"
                ],
                "mealType": [
                    "snack"
                ],
                "dishType": [
                    "desserts"
                ],
                "totalNutrients": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 4429.857682058343,
                        "unit": "kcal"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 281.35212949079977,
                        "unit": "g"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 223.81583451500146,
                        "unit": "g"
                    },
                    "FATRN": {
                        "label": "Trans",
                        "quantity": 0.6175495772553975,
                        "unit": "g"
                    },
                    "FAMS": {
                        "label": "Monounsaturated",
                        "quantity": 29.30594579900306,
                        "unit": "g"
                    },
                    "FAPU": {
                        "label": "Polyunsaturated",
                        "quantity": 11.632623865453038,
                        "unit": "g"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 464.65503432358776,
                        "unit": "g"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 14.307581046164568,
                        "unit": "g"
                    },
                    "SUGAR": {
                        "label": "Sugars",
                        "quantity": 359.7513024040653,
                        "unit": "g"
                    },
                    "SUGAR.added": {
                        "label": "Sugars, added",
                        "quantity": 354.305,
                        "unit": "g"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 30.546373930110455,
                        "unit": "g"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 0,
                        "unit": "mg"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 205.82360294449316,
                        "unit": "mg"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 436.9241004590615,
                        "unit": "mg"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 271.14900671235466,
                        "unit": "mg"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 807.7420085470904,
                        "unit": "mg"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 5.483678774501645,
                        "unit": "mg"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 3.8345732302746764,
                        "unit": "mg"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 783.7741106564126,
                        "unit": "mg"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 0,
                        "unit": "mg"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 0.31890038915709895,
                        "unit": "mg"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 1.153132094442822,
                        "unit": "mg"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 4.695380534001872,
                        "unit": "mg"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 0.1750664722659637,
                        "unit": "mg"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 68.49209328249928,
                        "unit": "µg"
                    },
                    "FOLFD": {
                        "label": "Folate (food)",
                        "quantity": 68.49209328249928,
                        "unit": "µg"
                    },
                    "FOLAC": {
                        "label": "Folic acid",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 32.25664433705583,
                        "unit": "mg"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 58.375,
                        "unit": "µg"
                    },
                    "WATER": {
                        "label": "Water",
                        "quantity": 25.292385621566858,
                        "unit": "g"
                    }
                },
                "totalDaily": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 221.49288410291717,
                        "unit": "%"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 432.8494299858458,
                        "unit": "%"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 1119.0791725750073,
                        "unit": "%"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 154.88501144119593,
                        "unit": "%"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 57.23032418465827,
                        "unit": "%"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 61.0927478602209,
                        "unit": "%"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 0,
                        "unit": "%"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 8.575983456020548,
                        "unit": "%"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 43.69241004590615,
                        "unit": "%"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 64.5592873124654,
                        "unit": "%"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 17.18600018185299,
                        "unit": "%"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 30.464882080564696,
                        "unit": "%"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 34.859756638860695,
                        "unit": "%"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 111.96773009377324,
                        "unit": "%"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 0,
                        "unit": "%"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 0,
                        "unit": "%"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 26.575032429758245,
                        "unit": "%"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 88.702468803294,
                        "unit": "%"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 29.3461283375117,
                        "unit": "%"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 13.466651712766438,
                        "unit": "%"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 17.12302332062482,
                        "unit": "%"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 0,
                        "unit": "%"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 0,
                        "unit": "%"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 215.04429558037222,
                        "unit": "%"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 48.645833333333336,
                        "unit": "%"
                    }
                },
                "digest": [
                    {
                        "label": "Fat",
                        "tag": "FAT",
                        "schemaOrgTag": "fatContent",
                        "total": 281.35212949079977,
                        "hasRDI": true,
                        "daily": 432.8494299858458,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Saturated",
                                "tag": "FASAT",
                                "schemaOrgTag": "saturatedFatContent",
                                "total": 223.81583451500146,
                                "hasRDI": true,
                                "daily": 1119.0791725750073,
                                "unit": "g"
                            },
                            {
                                "label": "Trans",
                                "tag": "FATRN",
                                "schemaOrgTag": "transFatContent",
                                "total": 0.6175495772553975,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Monounsaturated",
                                "tag": "FAMS",
                                "schemaOrgTag": null,
                                "total": 29.30594579900306,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Polyunsaturated",
                                "tag": "FAPU",
                                "schemaOrgTag": null,
                                "total": 11.632623865453038,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Carbs",
                        "tag": "CHOCDF",
                        "schemaOrgTag": "carbohydrateContent",
                        "total": 464.65503432358776,
                        "hasRDI": true,
                        "daily": 154.88501144119593,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Carbs (net)",
                                "tag": "CHOCDF.net",
                                "schemaOrgTag": null,
                                "total": 450.3474532774232,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Fiber",
                                "tag": "FIBTG",
                                "schemaOrgTag": "fiberContent",
                                "total": 14.307581046164568,
                                "hasRDI": true,
                                "daily": 57.23032418465827,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars",
                                "tag": "SUGAR",
                                "schemaOrgTag": "sugarContent",
                                "total": 359.7513024040653,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars, added",
                                "tag": "SUGAR.added",
                                "schemaOrgTag": null,
                                "total": 354.305,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Protein",
                        "tag": "PROCNT",
                        "schemaOrgTag": "proteinContent",
                        "total": 30.546373930110455,
                        "hasRDI": true,
                        "daily": 61.0927478602209,
                        "unit": "g"
                    },
                    {
                        "label": "Cholesterol",
                        "tag": "CHOLE",
                        "schemaOrgTag": "cholesterolContent",
                        "total": 0,
                        "hasRDI": true,
                        "daily": 0,
                        "unit": "mg"
                    },
                    {
                        "label": "Sodium",
                        "tag": "NA",
                        "schemaOrgTag": "sodiumContent",
                        "total": 205.82360294449316,
                        "hasRDI": true,
                        "daily": 8.575983456020548,
                        "unit": "mg"
                    },
                    {
                        "label": "Calcium",
                        "tag": "CA",
                        "schemaOrgTag": null,
                        "total": 436.9241004590615,
                        "hasRDI": true,
                        "daily": 43.69241004590615,
                        "unit": "mg"
                    },
                    {
                        "label": "Magnesium",
                        "tag": "MG",
                        "schemaOrgTag": null,
                        "total": 271.14900671235466,
                        "hasRDI": true,
                        "daily": 64.5592873124654,
                        "unit": "mg"
                    },
                    {
                        "label": "Potassium",
                        "tag": "K",
                        "schemaOrgTag": null,
                        "total": 807.7420085470904,
                        "hasRDI": true,
                        "daily": 17.18600018185299,
                        "unit": "mg"
                    },
                    {
                        "label": "Iron",
                        "tag": "FE",
                        "schemaOrgTag": null,
                        "total": 5.483678774501645,
                        "hasRDI": true,
                        "daily": 30.464882080564696,
                        "unit": "mg"
                    },
                    {
                        "label": "Zinc",
                        "tag": "ZN",
                        "schemaOrgTag": null,
                        "total": 3.8345732302746764,
                        "hasRDI": true,
                        "daily": 34.859756638860695,
                        "unit": "mg"
                    },
                    {
                        "label": "Phosphorus",
                        "tag": "P",
                        "schemaOrgTag": null,
                        "total": 783.7741106564126,
                        "hasRDI": true,
                        "daily": 111.96773009377324,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin A",
                        "tag": "VITA_RAE",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": true,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin C",
                        "tag": "VITC",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": true,
                        "daily": 0,
                        "unit": "mg"
                    },
                    {
                        "label": "Thiamin (B1)",
                        "tag": "THIA",
                        "schemaOrgTag": null,
                        "total": 0.31890038915709895,
                        "hasRDI": true,
                        "daily": 26.575032429758245,
                        "unit": "mg"
                    },
                    {
                        "label": "Riboflavin (B2)",
                        "tag": "RIBF",
                        "schemaOrgTag": null,
                        "total": 1.153132094442822,
                        "hasRDI": true,
                        "daily": 88.702468803294,
                        "unit": "mg"
                    },
                    {
                        "label": "Niacin (B3)",
                        "tag": "NIA",
                        "schemaOrgTag": null,
                        "total": 4.695380534001872,
                        "hasRDI": true,
                        "daily": 29.3461283375117,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin B6",
                        "tag": "VITB6A",
                        "schemaOrgTag": null,
                        "total": 0.1750664722659637,
                        "hasRDI": true,
                        "daily": 13.466651712766438,
                        "unit": "mg"
                    },
                    {
                        "label": "Folate equivalent (total)",
                        "tag": "FOLDFE",
                        "schemaOrgTag": null,
                        "total": 68.49209328249928,
                        "hasRDI": true,
                        "daily": 17.12302332062482,
                        "unit": "µg"
                    },
                    {
                        "label": "Folate (food)",
                        "tag": "FOLFD",
                        "schemaOrgTag": null,
                        "total": 68.49209328249928,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Folic acid",
                        "tag": "FOLAC",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin B12",
                        "tag": "VITB12",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": true,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin D",
                        "tag": "VITD",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": true,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin E",
                        "tag": "TOCPHA",
                        "schemaOrgTag": null,
                        "total": 32.25664433705583,
                        "hasRDI": true,
                        "daily": 215.04429558037222,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin K",
                        "tag": "VITK1",
                        "schemaOrgTag": null,
                        "total": 58.375,
                        "hasRDI": true,
                        "daily": 48.645833333333336,
                        "unit": "µg"
                    },
                    {
                        "label": "Sugar alcohols",
                        "tag": "Sugar.alcohol",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    },
                    {
                        "label": "Water",
                        "tag": "WATER",
                        "schemaOrgTag": null,
                        "total": 25.292385621566858,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    }
                ]
            },
            "_links": {
                "self": {
                    "href": "https://api.edamam.com/api/recipes/v2/225c6ad5a2b909c3f2bdca88fcaf8aee?type=public&app_id=ea1d37d5&app_key=fd382a172ba8d6668c0430dc9c14a181",
                    "title": "Self"
                }
            }
        },
        {
            "recipe": {
                "uri": "http://www.edamam.com/ontologies/edamam.owl#recipe_3fad4068268ff8385e1cb926dbfe02ab",
                "label": "Vegan Chocolate-Coffee Muffins Recipe",
                "image": "https://www.edamam.com/web-img/cd0/cd0f763c1566ec5a0f0ae099ecebc5a7.jpg",
                "source": "Serious Eats",
                "url": "http://www.seriouseats.com/recipes/2014/04/vegan-chocolate-coffee-muffins.html",
                "shareAs": "http://www.edamam.com/recipe/vegan-chocolate-coffee-muffins-recipe-3fad4068268ff8385e1cb926dbfe02ab/vegan",
                "yield": 12,
                "dietLabels": [],
                "healthLabels": [
                    "Low Potassium",
                    "Kidney-Friendly",
                    "Vegan",
                    "Vegetarian",
                    "Pescatarian",
                    "Dairy-Free",
                    "Egg-Free",
                    "Peanut-Free",
                    "Tree-Nut-Free",
                    "Fish-Free",
                    "Shellfish-Free",
                    "Pork-Free",
                    "Red-Meat-Free",
                    "Crustacean-Free",
                    "Celery-Free",
                    "Mustard-Free",
                    "Sesame-Free",
                    "Lupine-Free",
                    "Mollusk-Free",
                    "Alcohol-Free",
                    "Kosher"
                ],
                "cautions": [
                    "Sulfites"
                ],
                "ingredientLines": [
                    "1 1/2 cups all purpose flour",
                    "1/3 cup unsweetened cocoa powder",
                    "1 teaspoon baking soda",
                    "1/2 teaspoon salt",
                    "1 1/4 cups sugar",
                    "1 teaspoon instant espresso powder",
                    "1 cup freshly brewed coffee",
                    "1 teaspoon vanilla extract",
                    "1 teaspoon white vinegar",
                    "3/4 cup vegan chocolate chips or vegan chocolate, chopped"
                ],
                "ingredients": [
                    {
                        "text": "1 1/2 cups all purpose flour",
                        "weight": 187.5,
                        "foodCategory": "grains",
                        "foodId": "food_ar3x97tbq9o9p6b6gzwj0am0c81l",
                        "image": "https://www.edamam.com/food-img/368/368077bbcab62f862a8c766a56ea5dd1.jpg"
                    },
                    {
                        "text": "1/3 cup unsweetened cocoa powder",
                        "weight": 28.666666666666664,
                        "foodCategory": "chocolate",
                        "foodId": "food_afcmkjjaqwjkezbfz7htdb7mpkwz",
                        "image": "https://www.edamam.com/food-img/89a/89af89595db3cf2c3007f2b064c5fef6.jpg"
                    },
                    {
                        "text": "1 teaspoon baking soda",
                        "weight": 4.6,
                        "foodCategory": "condiments and sauces",
                        "foodId": "food_asa4cjoa3lmt8ibwdg0cpblheo69",
                        "image": "https://www.edamam.com/food-img/7e5/7e55e4482cc2fde91f427fc568e6f5b8.jpeg"
                    },
                    {
                        "text": "1/2 teaspoon salt",
                        "weight": 3,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_btxz81db72hwbra2pncvebzzzum9",
                        "image": "https://www.edamam.com/food-img/694/6943ea510918c6025795e8dc6e6eaaeb.jpg"
                    },
                    {
                        "text": "1 1/4 cups sugar",
                        "weight": 250,
                        "foodCategory": "sugars",
                        "foodId": "food_axi2ijobrk819yb0adceobnhm1c2",
                        "image": "https://www.edamam.com/food-img/ecb/ecb3f5aaed96d0188c21b8369be07765.jpg"
                    },
                    {
                        "text": "1 teaspoon instant espresso powder",
                        "weight": 5.000000000253605,
                        "foodCategory": "coffee and tea",
                        "foodId": "food_bwvztweawd5emqbcu3dqua2ts9ol",
                        "image": "https://www.edamam.com/food-img/433/43301ebd4f7c5903aa6bac567a890ac3.jpg"
                    },
                    {
                        "text": "1 cup freshly brewed coffee",
                        "weight": 237,
                        "foodCategory": "coffee and tea",
                        "foodId": "food_ax0a0yxbbe4hx0apiz1tla01s2w7",
                        "image": "https://www.edamam.com/food-img/ee9/ee9566349cb84dfd9ddac1fdf8cbc907.jpg"
                    },
                    {
                        "text": "1 teaspoon vanilla extract",
                        "weight": 4.2,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_bh1wvnqaw3q7ciascfoygaabax2a",
                        "image": "https://www.edamam.com/food-img/90f/90f910b0bf82750d4f6528263e014cca.jpg"
                    },
                    {
                        "text": "1 teaspoon white vinegar",
                        "weight": 5,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_am3vwadag9arxtadrwyfcau2w3b2",
                        "image": "https://www.edamam.com/food-img/5f6/5f69b84c399d778c4728e9ab4f8065a2.jpg"
                    },
                    {
                        "text": "3/4 cup vegan chocolate chips or vegan chocolate, chopped",
                        "weight": 126,
                        "foodCategory": "candy",
                        "foodId": "food_bwowd1qbt8nrwzad9zwn7aptem0g",
                        "image": "https://www.edamam.com/food-img/1fd/1fdf37e875d26b6b50e57c61bac12c02.jpg"
                    }
                ],
                "calories": 2411.5760000000228,
                "totalWeight": 849.4124624355372,
                "totalTime": 35,
                "cuisineType": [
                    "american"
                ],
                "mealType": [
                    "lunch/dinner"
                ],
                "dishType": [
                    "desserts"
                ],
                "totalNutrients": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 2411.5760000000228,
                        "unit": "kcal"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 45.33735333333379,
                        "unit": "g"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 39.176465000000235,
                        "unit": "g"
                    },
                    "FATRN": {
                        "label": "Trans",
                        "quantity": 0,
                        "unit": "g"
                    },
                    "FAMS": {
                        "label": "Monounsaturated",
                        "quantity": 2.1177416666666664,
                        "unit": "g"
                    },
                    "FAPU": {
                        "label": "Polyunsaturated",
                        "quantity": 1.2793463333335664,
                        "unit": "g"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 481.17145000000426,
                        "unit": "g"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 20.457166666666666,
                        "unit": "g"
                    },
                    "SUGAR": {
                        "label": "Sugars",
                        "quantity": 294.01981666666666,
                        "unit": "g"
                    },
                    "SUGAR.added": {
                        "label": "Sugars, added",
                        "quantity": 292.47860000000003,
                        "unit": "g"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 35.549336666666974,
                        "unit": "g"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 1.26,
                        "unit": "mg"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 1971.9295240005895,
                        "unit": "mg"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 455.0473243178065,
                        "unit": "mg"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 241.3351246245557,
                        "unit": "mg"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 1568.396663661781,
                        "unit": "mg"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 14.465111126036764,
                        "unit": "mg"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 7.793965795768743,
                        "unit": "mg"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 579.5853333333511,
                        "unit": "mg"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 1.26,
                        "unit": "µg"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 0.6400000000005072,
                        "unit": "mg"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 1.6539270000000026,
                        "unit": "mg"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 1.4600766666671154,
                        "unit": "mg"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 13.737636666679869,
                        "unit": "mg"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 0.2836886666666717,
                        "unit": "mg"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 586.0483333333359,
                        "unit": "µg"
                    },
                    "FOLFD": {
                        "label": "Folate (food)",
                        "quantity": 94.79833333333588,
                        "unit": "µg"
                    },
                    "FOLAC": {
                        "label": "Folic acid",
                        "quantity": 288.75,
                        "unit": "µg"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 0.35280000000000006,
                        "unit": "µg"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 2.462316666666692,
                        "unit": "mg"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 11.22316666666692,
                        "unit": "µg"
                    },
                    "WATER": {
                        "label": "Water",
                        "quantity": 272.6041515917853,
                        "unit": "g"
                    }
                },
                "totalDaily": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 120.57880000000114,
                        "unit": "%"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 69.74977435897506,
                        "unit": "%"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 195.88232500000117,
                        "unit": "%"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 160.39048333333474,
                        "unit": "%"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 81.82866666666666,
                        "unit": "%"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 71.09867333333395,
                        "unit": "%"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 0.42,
                        "unit": "%"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 82.16373016669122,
                        "unit": "%"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 45.504732431780646,
                        "unit": "%"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 57.46074395822755,
                        "unit": "%"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 33.3701417800379,
                        "unit": "%"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 80.36172847798201,
                        "unit": "%"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 70.85423450698858,
                        "unit": "%"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 82.7979047619073,
                        "unit": "%"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 0.14,
                        "unit": "%"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 0.7111111111116747,
                        "unit": "%"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 137.82725000000022,
                        "unit": "%"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 112.31358974362426,
                        "unit": "%"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 85.86022916674918,
                        "unit": "%"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 21.822205128205514,
                        "unit": "%"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 146.51208333333398,
                        "unit": "%"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 14.700000000000005,
                        "unit": "%"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 0,
                        "unit": "%"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 16.415444444444613,
                        "unit": "%"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 9.3526388888891,
                        "unit": "%"
                    }
                },
                "digest": [
                    {
                        "label": "Fat",
                        "tag": "FAT",
                        "schemaOrgTag": "fatContent",
                        "total": 45.33735333333379,
                        "hasRDI": true,
                        "daily": 69.74977435897506,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Saturated",
                                "tag": "FASAT",
                                "schemaOrgTag": "saturatedFatContent",
                                "total": 39.176465000000235,
                                "hasRDI": true,
                                "daily": 195.88232500000117,
                                "unit": "g"
                            },
                            {
                                "label": "Trans",
                                "tag": "FATRN",
                                "schemaOrgTag": "transFatContent",
                                "total": 0,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Monounsaturated",
                                "tag": "FAMS",
                                "schemaOrgTag": null,
                                "total": 2.1177416666666664,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Polyunsaturated",
                                "tag": "FAPU",
                                "schemaOrgTag": null,
                                "total": 1.2793463333335664,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Carbs",
                        "tag": "CHOCDF",
                        "schemaOrgTag": "carbohydrateContent",
                        "total": 481.17145000000426,
                        "hasRDI": true,
                        "daily": 160.39048333333474,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Carbs (net)",
                                "tag": "CHOCDF.net",
                                "schemaOrgTag": null,
                                "total": 460.71428333333756,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Fiber",
                                "tag": "FIBTG",
                                "schemaOrgTag": "fiberContent",
                                "total": 20.457166666666666,
                                "hasRDI": true,
                                "daily": 81.82866666666666,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars",
                                "tag": "SUGAR",
                                "schemaOrgTag": "sugarContent",
                                "total": 294.01981666666666,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars, added",
                                "tag": "SUGAR.added",
                                "schemaOrgTag": null,
                                "total": 292.47860000000003,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Protein",
                        "tag": "PROCNT",
                        "schemaOrgTag": "proteinContent",
                        "total": 35.549336666666974,
                        "hasRDI": true,
                        "daily": 71.09867333333395,
                        "unit": "g"
                    },
                    {
                        "label": "Cholesterol",
                        "tag": "CHOLE",
                        "schemaOrgTag": "cholesterolContent",
                        "total": 1.26,
                        "hasRDI": true,
                        "daily": 0.42,
                        "unit": "mg"
                    },
                    {
                        "label": "Sodium",
                        "tag": "NA",
                        "schemaOrgTag": "sodiumContent",
                        "total": 1971.9295240005895,
                        "hasRDI": true,
                        "daily": 82.16373016669122,
                        "unit": "mg"
                    },
                    {
                        "label": "Calcium",
                        "tag": "CA",
                        "schemaOrgTag": null,
                        "total": 455.0473243178065,
                        "hasRDI": true,
                        "daily": 45.504732431780646,
                        "unit": "mg"
                    },
                    {
                        "label": "Magnesium",
                        "tag": "MG",
                        "schemaOrgTag": null,
                        "total": 241.3351246245557,
                        "hasRDI": true,
                        "daily": 57.46074395822755,
                        "unit": "mg"
                    },
                    {
                        "label": "Potassium",
                        "tag": "K",
                        "schemaOrgTag": null,
                        "total": 1568.396663661781,
                        "hasRDI": true,
                        "daily": 33.3701417800379,
                        "unit": "mg"
                    },
                    {
                        "label": "Iron",
                        "tag": "FE",
                        "schemaOrgTag": null,
                        "total": 14.465111126036764,
                        "hasRDI": true,
                        "daily": 80.36172847798201,
                        "unit": "mg"
                    },
                    {
                        "label": "Zinc",
                        "tag": "ZN",
                        "schemaOrgTag": null,
                        "total": 7.793965795768743,
                        "hasRDI": true,
                        "daily": 70.85423450698858,
                        "unit": "mg"
                    },
                    {
                        "label": "Phosphorus",
                        "tag": "P",
                        "schemaOrgTag": null,
                        "total": 579.5853333333511,
                        "hasRDI": true,
                        "daily": 82.7979047619073,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin A",
                        "tag": "VITA_RAE",
                        "schemaOrgTag": null,
                        "total": 1.26,
                        "hasRDI": true,
                        "daily": 0.14,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin C",
                        "tag": "VITC",
                        "schemaOrgTag": null,
                        "total": 0.6400000000005072,
                        "hasRDI": true,
                        "daily": 0.7111111111116747,
                        "unit": "mg"
                    },
                    {
                        "label": "Thiamin (B1)",
                        "tag": "THIA",
                        "schemaOrgTag": null,
                        "total": 1.6539270000000026,
                        "hasRDI": true,
                        "daily": 137.82725000000022,
                        "unit": "mg"
                    },
                    {
                        "label": "Riboflavin (B2)",
                        "tag": "RIBF",
                        "schemaOrgTag": null,
                        "total": 1.4600766666671154,
                        "hasRDI": true,
                        "daily": 112.31358974362426,
                        "unit": "mg"
                    },
                    {
                        "label": "Niacin (B3)",
                        "tag": "NIA",
                        "schemaOrgTag": null,
                        "total": 13.737636666679869,
                        "hasRDI": true,
                        "daily": 85.86022916674918,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin B6",
                        "tag": "VITB6A",
                        "schemaOrgTag": null,
                        "total": 0.2836886666666717,
                        "hasRDI": true,
                        "daily": 21.822205128205514,
                        "unit": "mg"
                    },
                    {
                        "label": "Folate equivalent (total)",
                        "tag": "FOLDFE",
                        "schemaOrgTag": null,
                        "total": 586.0483333333359,
                        "hasRDI": true,
                        "daily": 146.51208333333398,
                        "unit": "µg"
                    },
                    {
                        "label": "Folate (food)",
                        "tag": "FOLFD",
                        "schemaOrgTag": null,
                        "total": 94.79833333333588,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Folic acid",
                        "tag": "FOLAC",
                        "schemaOrgTag": null,
                        "total": 288.75,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin B12",
                        "tag": "VITB12",
                        "schemaOrgTag": null,
                        "total": 0.35280000000000006,
                        "hasRDI": true,
                        "daily": 14.700000000000005,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin D",
                        "tag": "VITD",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": true,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin E",
                        "tag": "TOCPHA",
                        "schemaOrgTag": null,
                        "total": 2.462316666666692,
                        "hasRDI": true,
                        "daily": 16.415444444444613,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin K",
                        "tag": "VITK1",
                        "schemaOrgTag": null,
                        "total": 11.22316666666692,
                        "hasRDI": true,
                        "daily": 9.3526388888891,
                        "unit": "µg"
                    },
                    {
                        "label": "Sugar alcohols",
                        "tag": "Sugar.alcohol",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    },
                    {
                        "label": "Water",
                        "tag": "WATER",
                        "schemaOrgTag": null,
                        "total": 272.6041515917853,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    }
                ]
            },
            "_links": {
                "self": {
                    "href": "https://api.edamam.com/api/recipes/v2/3fad4068268ff8385e1cb926dbfe02ab?type=public&app_id=ea1d37d5&app_key=fd382a172ba8d6668c0430dc9c14a181",
                    "title": "Self"
                }
            }
        },
        {
            "recipe": {
                "uri": "http://www.edamam.com/ontologies/edamam.owl#recipe_775abbeffb09d327379f387448b56701",
                "label": "Baked Vegan Mac and Cheese Recipe",
                "image": "https://www.edamam.com/web-img/28a/28a32a73f93b6b002765a204302d6371.jpg",
                "source": "Chowhound",
                "url": "https://www.chowhound.com/recipes/baked-vegan-mac-and-cheese-32141",
                "shareAs": "http://www.edamam.com/recipe/baked-vegan-mac-and-cheese-recipe-775abbeffb09d327379f387448b56701/vegan",
                "yield": 14,
                "dietLabels": [
                    "Balanced"
                ],
                "healthLabels": [
                    "Sugar-Conscious",
                    "Kidney-Friendly",
                    "Vegetarian",
                    "Pescatarian",
                    "Dairy-Free",
                    "Egg-Free",
                    "Peanut-Free",
                    "Tree-Nut-Free",
                    "Fish-Free",
                    "Shellfish-Free",
                    "Pork-Free",
                    "Red-Meat-Free",
                    "Crustacean-Free",
                    "Celery-Free",
                    "Sesame-Free",
                    "Lupine-Free",
                    "Mollusk-Free",
                    "Alcohol-Free",
                    "Sulfite-Free",
                    "Kosher"
                ],
                "cautions": [
                    "Tree-Nuts",
                    "Soy",
                    "Sulfites",
                    "FODMAP"
                ],
                "ingredientLines": [
                    "16 ounces elbow macaroni",
                    "Olive oil or vegan butter, for preparing the baking dish",
                    "4 tablespoons vegan butter",
                    "1/4 cup all-purpose flour",
                    "5 cups plain unsweetened nondairy milk",
                    "1 teaspoon salt",
                    "1/3 cup nutritional yeast, plus more as needed",
                    "1 teaspoon dry mustard",
                    "1 teaspoon onion powder",
                    "1/4 teaspoon ground black pepper",
                    "1 cup shredded vegan cheese (optional)",
                    "1 cup finely crushed Ritz crackers",
                    "1/2 teaspoon paprika",
                    "1 tablespoon melted vegan butter"
                ],
                "ingredients": [
                    {
                        "text": "16 ounces elbow macaroni",
                        "weight": 453.59237,
                        "foodCategory": "grains",
                        "foodId": "food_a8hs60uayl5icia1qe8qoba1kwp8",
                        "image": "https://www.edamam.com/food-img/296/296ff2b02ef3822928c3c923e22c7d19.jpg"
                    },
                    {
                        "text": "Olive oil or vegan butter, for preparing the baking dish",
                        "weight": 29.39640956538557,
                        "foodCategory": "Oils",
                        "foodId": "food_b1d1icuad3iktrbqby0hiagafaz7",
                        "image": "https://www.edamam.com/food-img/4d6/4d651eaa8a353647746290c7a9b29d84.jpg"
                    },
                    {
                        "text": "4 tablespoons vegan butter",
                        "weight": 54.4,
                        "foodCategory": "Oils",
                        "foodId": "food_bn7cczea5psahcbaqvd2ob43qksr",
                        "image": "https://www.edamam.com/food-img/330/3302cd340e3d2dcf7f02e72fdfe8b209.jpg"
                    },
                    {
                        "text": "1/4 cup all-purpose flour",
                        "weight": 31.25,
                        "foodCategory": "grains",
                        "foodId": "food_ar3x97tbq9o9p6b6gzwj0am0c81l",
                        "image": "https://www.edamam.com/food-img/368/368077bbcab62f862a8c766a56ea5dd1.jpg"
                    },
                    {
                        "text": "5 cups plain unsweetened nondairy milk",
                        "weight": 1220,
                        "foodCategory": "Milk",
                        "foodId": "food_aldsn8sa3rioenar1lwhob4bpdj2",
                        "image": "https://www.edamam.com/food-img/694/6944c7790a123419b8500a7db252eb15.jpg"
                    },
                    {
                        "text": "1 teaspoon salt",
                        "weight": 6,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_btxz81db72hwbra2pncvebzzzum9",
                        "image": "https://www.edamam.com/food-img/694/6943ea510918c6025795e8dc6e6eaaeb.jpg"
                    },
                    {
                        "text": "1/3 cup nutritional yeast, plus more as needed",
                        "weight": 85.33333333333333,
                        "foodCategory": "Vegan products",
                        "foodId": "food_abjagi2b7qlt18aryyugvbnm0tlu",
                        "image": null
                    },
                    {
                        "text": "1 teaspoon dry mustard",
                        "weight": 2,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_b0xqxo3a93nsz8a6ppdilau4ujwt",
                        "image": "https://www.edamam.com/food-img/9ff/9ff9e6d04cbc71ff884f3212afa0adfd.jpg"
                    },
                    {
                        "text": "1 teaspoon onion powder",
                        "weight": 2.4,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_bmv8z27b1o25vcbu41ooyawd2zj4",
                        "image": "https://www.edamam.com/food-img/1e7/1e73e6f5dd96bb233abc0fcc05fb0ec8.jpg"
                    },
                    {
                        "text": "1/4 teaspoon ground black pepper",
                        "weight": 0.575,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_b6ywzluaaxv02wad7s1r9ag4py89",
                        "image": "https://www.edamam.com/food-img/c6e/c6e5c3bd8d3bc15175d9766971a4d1b2.jpg"
                    },
                    {
                        "text": "1 cup shredded vegan cheese (optional)",
                        "weight": 227.20000000384124,
                        "foodCategory": "Vegan products",
                        "foodId": "food_bo3fs72aqydlwzadxjbykaahvx3v",
                        "image": "https://www.edamam.com/food-img/cc3/cc3c4827d251d79eed1ff87c1861aa34.jpg"
                    },
                    {
                        "text": "1 cup finely crushed Ritz crackers",
                        "weight": 64,
                        "foodCategory": "crackers",
                        "foodId": "food_a7e70joahmaymibybmv10buc9vxy",
                        "image": "https://www.edamam.com/food-img/752/7526e07c93cab399169fad9a7c04d7a1.png"
                    },
                    {
                        "text": "1/2 teaspoon paprika",
                        "weight": 1.15,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_a9dpcnjb883g67b3lq82ca0421ql",
                        "image": "https://www.edamam.com/food-img/474/474d63763b9d8b9da98c5f43a114648c.jpg"
                    },
                    {
                        "text": "1 tablespoon melted vegan butter",
                        "weight": 13.6,
                        "foodCategory": "Oils",
                        "foodId": "food_bn7cczea5psahcbaqvd2ob43qksr",
                        "image": "https://www.edamam.com/food-img/330/3302cd340e3d2dcf7f02e72fdfe8b209.jpg"
                    }
                ],
                "calories": 4547.458869934279,
                "totalWeight": 2189.9572412228085,
                "totalTime": 0,
                "cuisineType": [
                    "american"
                ],
                "mealType": [
                    "lunch/dinner"
                ],
                "dishType": [
                    "starter"
                ],
                "totalNutrients": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 4547.458869934279,
                        "unit": "kcal"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 221.28504435334588,
                        "unit": "g"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 109.69767459768842,
                        "unit": "g"
                    },
                    "FATRN": {
                        "label": "Trans",
                        "quantity": 0.8467600000000001,
                        "unit": "g"
                    },
                    "FAMS": {
                        "label": "Monounsaturated",
                        "quantity": 29.068294585700965,
                        "unit": "g"
                    },
                    "FAPU": {
                        "label": "Polyunsaturated",
                        "quantity": 13.155995145365525,
                        "unit": "g"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 524.3765085126062,
                        "unit": "g"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 47.498864173471624,
                        "unit": "g"
                    },
                    "SUGAR": {
                        "label": "Sugars",
                        "quantity": 22.942401279000002,
                        "unit": "g"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 140.19342921480495,
                        "unit": "g"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 0,
                        "unit": "mg"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 5080.934538112646,
                        "unit": "mg"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 623.0070425925134,
                        "unit": "mg"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 473.8318073832025,
                        "unit": "mg"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 2585.5490094612733,
                        "unit": "mg"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 19.66556162702298,
                        "unit": "mg"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 37.77836671198692,
                        "unit": "mg"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 1997.3670793000003,
                        "unit": "mg"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 28.519750000000002,
                        "unit": "µg"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 0.71395,
                        "unit": "mg"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 52.31430963299999,
                        "unit": "mg"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 53.404050422,
                        "unit": "mg"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 311.5705632066665,
                        "unit": "mg"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 51.9477179154,
                        "unit": "mg"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 249.0613766,
                        "unit": "µg"
                    },
                    "FOLFD": {
                        "label": "Folate (food)",
                        "quantity": 107.0263766,
                        "unit": "µg"
                    },
                    "FOLAC": {
                        "label": "Folic acid",
                        "quantity": 1363.325,
                        "unit": "µg"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 41.55733333333333,
                        "unit": "µg"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 10.06212137963283,
                        "unit": "mg"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 69.11110592836211,
                        "unit": "µg"
                    },
                    "WATER": {
                        "label": "Water",
                        "quantity": 1126.9032298866405,
                        "unit": "g"
                    }
                },
                "totalDaily": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 227.37294349671396,
                        "unit": "%"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 340.43852977437825,
                        "unit": "%"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 548.488372988442,
                        "unit": "%"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 174.79216950420206,
                        "unit": "%"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 189.99545669388647,
                        "unit": "%"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 280.3868584296099,
                        "unit": "%"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 0,
                        "unit": "%"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 211.70560575469358,
                        "unit": "%"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 62.30070425925134,
                        "unit": "%"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 112.81709699600059,
                        "unit": "%"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 55.01168105236752,
                        "unit": "%"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 109.25312015012767,
                        "unit": "%"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 343.43969738169926,
                        "unit": "%"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 285.33815418571436,
                        "unit": "%"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 3.1688611111111116,
                        "unit": "%"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 0.7932777777777777,
                        "unit": "%"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 4359.5258027499995,
                        "unit": "%"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 4108.003878615385,
                        "unit": "%"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 1947.3160200416658,
                        "unit": "%"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 3995.9783011846152,
                        "unit": "%"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 62.265344150000004,
                        "unit": "%"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 1731.5555555555557,
                        "unit": "%"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 0,
                        "unit": "%"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 67.0808091975522,
                        "unit": "%"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 57.59258827363509,
                        "unit": "%"
                    }
                },
                "digest": [
                    {
                        "label": "Fat",
                        "tag": "FAT",
                        "schemaOrgTag": "fatContent",
                        "total": 221.28504435334588,
                        "hasRDI": true,
                        "daily": 340.43852977437825,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Saturated",
                                "tag": "FASAT",
                                "schemaOrgTag": "saturatedFatContent",
                                "total": 109.69767459768842,
                                "hasRDI": true,
                                "daily": 548.488372988442,
                                "unit": "g"
                            },
                            {
                                "label": "Trans",
                                "tag": "FATRN",
                                "schemaOrgTag": "transFatContent",
                                "total": 0.8467600000000001,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Monounsaturated",
                                "tag": "FAMS",
                                "schemaOrgTag": null,
                                "total": 29.068294585700965,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Polyunsaturated",
                                "tag": "FAPU",
                                "schemaOrgTag": null,
                                "total": 13.155995145365525,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Carbs",
                        "tag": "CHOCDF",
                        "schemaOrgTag": "carbohydrateContent",
                        "total": 524.3765085126062,
                        "hasRDI": true,
                        "daily": 174.79216950420206,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Carbs (net)",
                                "tag": "CHOCDF.net",
                                "schemaOrgTag": null,
                                "total": 476.8776443391345,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Fiber",
                                "tag": "FIBTG",
                                "schemaOrgTag": "fiberContent",
                                "total": 47.498864173471624,
                                "hasRDI": true,
                                "daily": 189.99545669388647,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars",
                                "tag": "SUGAR",
                                "schemaOrgTag": "sugarContent",
                                "total": 22.942401279000002,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars, added",
                                "tag": "SUGAR.added",
                                "schemaOrgTag": null,
                                "total": 0,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Protein",
                        "tag": "PROCNT",
                        "schemaOrgTag": "proteinContent",
                        "total": 140.19342921480495,
                        "hasRDI": true,
                        "daily": 280.3868584296099,
                        "unit": "g"
                    },
                    {
                        "label": "Cholesterol",
                        "tag": "CHOLE",
                        "schemaOrgTag": "cholesterolContent",
                        "total": 0,
                        "hasRDI": true,
                        "daily": 0,
                        "unit": "mg"
                    },
                    {
                        "label": "Sodium",
                        "tag": "NA",
                        "schemaOrgTag": "sodiumContent",
                        "total": 5080.934538112646,
                        "hasRDI": true,
                        "daily": 211.70560575469358,
                        "unit": "mg"
                    },
                    {
                        "label": "Calcium",
                        "tag": "CA",
                        "schemaOrgTag": null,
                        "total": 623.0070425925134,
                        "hasRDI": true,
                        "daily": 62.30070425925134,
                        "unit": "mg"
                    },
                    {
                        "label": "Magnesium",
                        "tag": "MG",
                        "schemaOrgTag": null,
                        "total": 473.8318073832025,
                        "hasRDI": true,
                        "daily": 112.81709699600059,
                        "unit": "mg"
                    },
                    {
                        "label": "Potassium",
                        "tag": "K",
                        "schemaOrgTag": null,
                        "total": 2585.5490094612733,
                        "hasRDI": true,
                        "daily": 55.01168105236752,
                        "unit": "mg"
                    },
                    {
                        "label": "Iron",
                        "tag": "FE",
                        "schemaOrgTag": null,
                        "total": 19.66556162702298,
                        "hasRDI": true,
                        "daily": 109.25312015012767,
                        "unit": "mg"
                    },
                    {
                        "label": "Zinc",
                        "tag": "ZN",
                        "schemaOrgTag": null,
                        "total": 37.77836671198692,
                        "hasRDI": true,
                        "daily": 343.43969738169926,
                        "unit": "mg"
                    },
                    {
                        "label": "Phosphorus",
                        "tag": "P",
                        "schemaOrgTag": null,
                        "total": 1997.3670793000003,
                        "hasRDI": true,
                        "daily": 285.33815418571436,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin A",
                        "tag": "VITA_RAE",
                        "schemaOrgTag": null,
                        "total": 28.519750000000002,
                        "hasRDI": true,
                        "daily": 3.1688611111111116,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin C",
                        "tag": "VITC",
                        "schemaOrgTag": null,
                        "total": 0.71395,
                        "hasRDI": true,
                        "daily": 0.7932777777777777,
                        "unit": "mg"
                    },
                    {
                        "label": "Thiamin (B1)",
                        "tag": "THIA",
                        "schemaOrgTag": null,
                        "total": 52.31430963299999,
                        "hasRDI": true,
                        "daily": 4359.5258027499995,
                        "unit": "mg"
                    },
                    {
                        "label": "Riboflavin (B2)",
                        "tag": "RIBF",
                        "schemaOrgTag": null,
                        "total": 53.404050422,
                        "hasRDI": true,
                        "daily": 4108.003878615385,
                        "unit": "mg"
                    },
                    {
                        "label": "Niacin (B3)",
                        "tag": "NIA",
                        "schemaOrgTag": null,
                        "total": 311.5705632066665,
                        "hasRDI": true,
                        "daily": 1947.3160200416658,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin B6",
                        "tag": "VITB6A",
                        "schemaOrgTag": null,
                        "total": 51.9477179154,
                        "hasRDI": true,
                        "daily": 3995.9783011846152,
                        "unit": "mg"
                    },
                    {
                        "label": "Folate equivalent (total)",
                        "tag": "FOLDFE",
                        "schemaOrgTag": null,
                        "total": 249.0613766,
                        "hasRDI": true,
                        "daily": 62.265344150000004,
                        "unit": "µg"
                    },
                    {
                        "label": "Folate (food)",
                        "tag": "FOLFD",
                        "schemaOrgTag": null,
                        "total": 107.0263766,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Folic acid",
                        "tag": "FOLAC",
                        "schemaOrgTag": null,
                        "total": 1363.325,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin B12",
                        "tag": "VITB12",
                        "schemaOrgTag": null,
                        "total": 41.55733333333333,
                        "hasRDI": true,
                        "daily": 1731.5555555555557,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin D",
                        "tag": "VITD",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": true,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin E",
                        "tag": "TOCPHA",
                        "schemaOrgTag": null,
                        "total": 10.06212137963283,
                        "hasRDI": true,
                        "daily": 67.0808091975522,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin K",
                        "tag": "VITK1",
                        "schemaOrgTag": null,
                        "total": 69.11110592836211,
                        "hasRDI": true,
                        "daily": 57.59258827363509,
                        "unit": "µg"
                    },
                    {
                        "label": "Sugar alcohols",
                        "tag": "Sugar.alcohol",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    },
                    {
                        "label": "Water",
                        "tag": "WATER",
                        "schemaOrgTag": null,
                        "total": 1126.9032298866405,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    }
                ]
            },
            "_links": {
                "self": {
                    "href": "https://api.edamam.com/api/recipes/v2/775abbeffb09d327379f387448b56701?type=public&app_id=ea1d37d5&app_key=fd382a172ba8d6668c0430dc9c14a181",
                    "title": "Self"
                }
            }
        },
        {
            "recipe": {
                "uri": "http://www.edamam.com/ontologies/edamam.owl#recipe_2a4929c8467a3abc21672e195b200ee4",
                "label": "Marbled Chocolate Protein Cookies (Vegan)",
                "image": "https://www.edamam.com/web-img/717/71733c4f84613e42b48ab33249bf838f.png",
                "source": "Food52",
                "url": "https://food52.com/recipes/77222-marbled-chocolate-protein-cookies-vegan",
                "shareAs": "http://www.edamam.com/recipe/marbled-chocolate-protein-cookies-vegan-2a4929c8467a3abc21672e195b200ee4/vegan",
                "yield": 12,
                "dietLabels": [
                    "Balanced"
                ],
                "healthLabels": [
                    "Vegetarian",
                    "Pescatarian",
                    "Egg-Free",
                    "Peanut-Free",
                    "Fish-Free",
                    "Shellfish-Free",
                    "Pork-Free",
                    "Red-Meat-Free",
                    "Crustacean-Free",
                    "Celery-Free",
                    "Mustard-Free",
                    "Sesame-Free",
                    "Lupine-Free",
                    "Mollusk-Free",
                    "Alcohol-Free",
                    "Kosher"
                ],
                "cautions": [
                    "Gluten",
                    "Wheat",
                    "Soy",
                    "Sulfites",
                    "FODMAP"
                ],
                "ingredientLines": [
                    "1/4 cup vegan butter",
                    "scant 1/2 cups granulated sugar",
                    "1 tablespoon brown sugar",
                    "2 tablespoons ground flaxseed",
                    "7 tablespoons water",
                    "1 teaspoon vanilla extract",
                    "2 cups all-purpose flour",
                    "1 1/4 teaspoons baking soda",
                    "1 teaspoon cornstarch",
                    "1/2 teaspoon salt",
                    "scant 1/2 cups vegan chocolate protein powder",
                    "1/4 cup applesauce",
                    "1 cup vegan chocolate chips",
                    "1/2 cup all-natural chocolate hazelnut spread (not Nutella)"
                ],
                "ingredients": [
                    {
                        "text": "1/4 cup vegan butter",
                        "weight": 54.5,
                        "foodCategory": "Oils",
                        "foodId": "food_bn7cczea5psahcbaqvd2ob43qksr",
                        "image": "https://www.edamam.com/food-img/330/3302cd340e3d2dcf7f02e72fdfe8b209.jpg"
                    },
                    {
                        "text": "scant 1/2 cups granulated sugar",
                        "weight": 100,
                        "foodCategory": "sugars",
                        "foodId": "food_axi2ijobrk819yb0adceobnhm1c2",
                        "image": "https://www.edamam.com/food-img/ecb/ecb3f5aaed96d0188c21b8369be07765.jpg"
                    },
                    {
                        "text": "1 tablespoon brown sugar",
                        "weight": 9.06249999984678,
                        "foodCategory": "sugars",
                        "foodId": "food_aodgtqwbmeu5f6bxeffn0art3bga",
                        "image": "https://www.edamam.com/food-img/8c6/8c6662bd73900645c6385b51a95d9b03.jpg"
                    },
                    {
                        "text": "2 tablespoons ground flaxseed",
                        "weight": 12.9999999997802,
                        "foodCategory": "grains",
                        "foodId": "food_auaq2zsa87h332b65eo4ib7dz1qx",
                        "image": null
                    },
                    {
                        "text": "7 tablespoons water",
                        "weight": 103.507353467,
                        "foodCategory": "water",
                        "foodId": "food_a99vzubbk1ayrsad318rvbzr3dh0",
                        "image": "https://www.edamam.com/food-img/5dd/5dd9d1361847b2ca53c4b19a8f92627e.jpg"
                    },
                    {
                        "text": "1 teaspoon vanilla extract",
                        "weight": 4.2,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_bh1wvnqaw3q7ciascfoygaabax2a",
                        "image": "https://www.edamam.com/food-img/90f/90f910b0bf82750d4f6528263e014cca.jpg"
                    },
                    {
                        "text": "2 cups all-purpose flour",
                        "weight": 250,
                        "foodCategory": "grains",
                        "foodId": "food_ar3x97tbq9o9p6b6gzwj0am0c81l",
                        "image": "https://www.edamam.com/food-img/368/368077bbcab62f862a8c766a56ea5dd1.jpg"
                    },
                    {
                        "text": "1 1/4 teaspoons baking soda",
                        "weight": 5.75,
                        "foodCategory": "condiments and sauces",
                        "foodId": "food_asa4cjoa3lmt8ibwdg0cpblheo69",
                        "image": "https://www.edamam.com/food-img/7e5/7e55e4482cc2fde91f427fc568e6f5b8.jpeg"
                    },
                    {
                        "text": "1 teaspoon cornstarch",
                        "weight": 2.66666666680192,
                        "foodCategory": null,
                        "foodId": "food_bevnfkfbvjm45pbbgj9nsb3ypntm",
                        "image": "https://www.edamam.com/food-img/f9b/f9b74d9495b40c0aea955c37a1fc39dc.jpg"
                    },
                    {
                        "text": "1/2 teaspoon salt",
                        "weight": 3,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_btxz81db72hwbra2pncvebzzzum9",
                        "image": "https://www.edamam.com/food-img/694/6943ea510918c6025795e8dc6e6eaaeb.jpg"
                    },
                    {
                        "text": "scant 1/2 cups vegan chocolate protein powder",
                        "weight": 177.441177375,
                        "foodCategory": "protein and nutritional powders",
                        "foodId": "food_bakks6hadovz21bbgb85oa1iycf3",
                        "image": "https://www.edamam.com/food-img/76a/76ab108398f84ad08fe841d3409ab70a.jpg"
                    },
                    {
                        "text": "1/4 cup applesauce",
                        "weight": 61,
                        "foodCategory": "canned fruit",
                        "foodId": "food_a42ufi8ben9zhqbzqv66lab1lwvd",
                        "image": "https://www.edamam.com/food-img/c59/c59e749347516e4aa0aaa3ea25925426.jpg"
                    },
                    {
                        "text": "1 cup vegan chocolate chips",
                        "weight": 168,
                        "foodCategory": "candy",
                        "foodId": "food_bwowd1qbt8nrwzad9zwn7aptem0g",
                        "image": "https://www.edamam.com/food-img/1fd/1fdf37e875d26b6b50e57c61bac12c02.jpg"
                    },
                    {
                        "text": "1/2 cup all-natural chocolate hazelnut spread (not Nutella)",
                        "weight": 148,
                        "foodCategory": "chocolate",
                        "foodId": "food_aaz5y9abcv9nupabqhgm4a7hozy6",
                        "image": "https://www.edamam.com/food-img/375/37567989ef8d6f7392094111de56f62b.jpg"
                    }
                ],
                "calories": 4317.505268213918,
                "totalWeight": 1097.1276975084288,
                "totalTime": 30,
                "cuisineType": [
                    "american"
                ],
                "mealType": [
                    "teatime"
                ],
                "dishType": [
                    "biscuits and cookies"
                ],
                "totalNutrients": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 4317.505268213918,
                        "unit": "kcal"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 168.06378279530736,
                        "unit": "g"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 144.7417364806279,
                        "unit": "g"
                    },
                    "FATRN": {
                        "label": "Trans",
                        "quantity": 0.14006500000000002,
                        "unit": "g"
                    },
                    "FAMS": {
                        "label": "Monounsaturated",
                        "quantity": 4.086624911502855,
                        "unit": "g"
                    },
                    "FAPU": {
                        "label": "Polyunsaturated",
                        "quantity": 9.840160867506103,
                        "unit": "g"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 551.3410290602092,
                        "unit": "g"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 37.73955888405808,
                        "unit": "g"
                    },
                    "SUGAR": {
                        "label": "Sugars",
                        "quantity": 292.2528671125764,
                        "unit": "g"
                    },
                    "SUGAR.added": {
                        "label": "Sugars, added",
                        "quantity": 245.89123749985134,
                        "unit": "g"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 149.22414648283296,
                        "unit": "g"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 1.68,
                        "unit": "mg"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 3132.0696242973986,
                        "unit": "mg"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 1056.9047246643881,
                        "unit": "mg"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 328.02705205466026,
                        "unit": "mg"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 3654.860309908551,
                        "unit": "mg"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 42.59850836832102,
                        "unit": "mg"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 21.051507192096732,
                        "unit": "mg"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 2967.702942876678,
                        "unit": "mg"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 3.77,
                        "unit": "µg"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 13.771999999999998,
                        "unit": "mg"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 2.78365259084,
                        "unit": "mg"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 2.117933530895,
                        "unit": "mg"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 21.40050730072858,
                        "unit": "mg"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 0.7620411558949373,
                        "unit": "mg"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 1298.2256276137484,
                        "unit": "µg"
                    },
                    "FOLFD": {
                        "label": "Folate (food)",
                        "quantity": 643.2256276137485,
                        "unit": "µg"
                    },
                    "FOLAC": {
                        "label": "Folic acid",
                        "quantity": 385,
                        "unit": "µg"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 0.8700000000000001,
                        "unit": "µg"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 12.727450000000001,
                        "unit": "mg"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 30.2645,
                        "unit": "µg"
                    },
                    "WATER": {
                        "label": "Water",
                        "quantity": 201.12758090579638,
                        "unit": "g"
                    }
                },
                "totalDaily": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 215.87526341069588,
                        "unit": "%"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 258.5596658389344,
                        "unit": "%"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 723.7086824031396,
                        "unit": "%"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 183.78034302006972,
                        "unit": "%"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 150.9582355362323,
                        "unit": "%"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 298.4482929656659,
                        "unit": "%"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 0.56,
                        "unit": "%"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 130.50290101239162,
                        "unit": "%"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 105.69047246643882,
                        "unit": "%"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 78.10167906063339,
                        "unit": "%"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 77.7629853172032,
                        "unit": "%"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 236.65837982400566,
                        "unit": "%"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 191.3773381099703,
                        "unit": "%"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 423.9575632680969,
                        "unit": "%"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 0.41888888888888887,
                        "unit": "%"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 15.30222222222222,
                        "unit": "%"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 231.9710492366667,
                        "unit": "%"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 162.91796391499997,
                        "unit": "%"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 133.75317062955364,
                        "unit": "%"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 58.618550453456706,
                        "unit": "%"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 324.5564069034371,
                        "unit": "%"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 36.25000000000001,
                        "unit": "%"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 0,
                        "unit": "%"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 84.84966666666668,
                        "unit": "%"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 25.22041666666667,
                        "unit": "%"
                    }
                },
                "digest": [
                    {
                        "label": "Fat",
                        "tag": "FAT",
                        "schemaOrgTag": "fatContent",
                        "total": 168.06378279530736,
                        "hasRDI": true,
                        "daily": 258.5596658389344,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Saturated",
                                "tag": "FASAT",
                                "schemaOrgTag": "saturatedFatContent",
                                "total": 144.7417364806279,
                                "hasRDI": true,
                                "daily": 723.7086824031396,
                                "unit": "g"
                            },
                            {
                                "label": "Trans",
                                "tag": "FATRN",
                                "schemaOrgTag": "transFatContent",
                                "total": 0.14006500000000002,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Monounsaturated",
                                "tag": "FAMS",
                                "schemaOrgTag": null,
                                "total": 4.086624911502855,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Polyunsaturated",
                                "tag": "FAPU",
                                "schemaOrgTag": null,
                                "total": 9.840160867506103,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Carbs",
                        "tag": "CHOCDF",
                        "schemaOrgTag": "carbohydrateContent",
                        "total": 551.3410290602092,
                        "hasRDI": true,
                        "daily": 183.78034302006972,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Carbs (net)",
                                "tag": "CHOCDF.net",
                                "schemaOrgTag": null,
                                "total": 513.6014701761511,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Fiber",
                                "tag": "FIBTG",
                                "schemaOrgTag": "fiberContent",
                                "total": 37.73955888405808,
                                "hasRDI": true,
                                "daily": 150.9582355362323,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars",
                                "tag": "SUGAR",
                                "schemaOrgTag": "sugarContent",
                                "total": 292.2528671125764,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars, added",
                                "tag": "SUGAR.added",
                                "schemaOrgTag": null,
                                "total": 245.89123749985134,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Protein",
                        "tag": "PROCNT",
                        "schemaOrgTag": "proteinContent",
                        "total": 149.22414648283296,
                        "hasRDI": true,
                        "daily": 298.4482929656659,
                        "unit": "g"
                    },
                    {
                        "label": "Cholesterol",
                        "tag": "CHOLE",
                        "schemaOrgTag": "cholesterolContent",
                        "total": 1.68,
                        "hasRDI": true,
                        "daily": 0.56,
                        "unit": "mg"
                    },
                    {
                        "label": "Sodium",
                        "tag": "NA",
                        "schemaOrgTag": "sodiumContent",
                        "total": 3132.0696242973986,
                        "hasRDI": true,
                        "daily": 130.50290101239162,
                        "unit": "mg"
                    },
                    {
                        "label": "Calcium",
                        "tag": "CA",
                        "schemaOrgTag": null,
                        "total": 1056.9047246643881,
                        "hasRDI": true,
                        "daily": 105.69047246643882,
                        "unit": "mg"
                    },
                    {
                        "label": "Magnesium",
                        "tag": "MG",
                        "schemaOrgTag": null,
                        "total": 328.02705205466026,
                        "hasRDI": true,
                        "daily": 78.10167906063339,
                        "unit": "mg"
                    },
                    {
                        "label": "Potassium",
                        "tag": "K",
                        "schemaOrgTag": null,
                        "total": 3654.860309908551,
                        "hasRDI": true,
                        "daily": 77.7629853172032,
                        "unit": "mg"
                    },
                    {
                        "label": "Iron",
                        "tag": "FE",
                        "schemaOrgTag": null,
                        "total": 42.59850836832102,
                        "hasRDI": true,
                        "daily": 236.65837982400566,
                        "unit": "mg"
                    },
                    {
                        "label": "Zinc",
                        "tag": "ZN",
                        "schemaOrgTag": null,
                        "total": 21.051507192096732,
                        "hasRDI": true,
                        "daily": 191.3773381099703,
                        "unit": "mg"
                    },
                    {
                        "label": "Phosphorus",
                        "tag": "P",
                        "schemaOrgTag": null,
                        "total": 2967.702942876678,
                        "hasRDI": true,
                        "daily": 423.9575632680969,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin A",
                        "tag": "VITA_RAE",
                        "schemaOrgTag": null,
                        "total": 3.77,
                        "hasRDI": true,
                        "daily": 0.41888888888888887,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin C",
                        "tag": "VITC",
                        "schemaOrgTag": null,
                        "total": 13.771999999999998,
                        "hasRDI": true,
                        "daily": 15.30222222222222,
                        "unit": "mg"
                    },
                    {
                        "label": "Thiamin (B1)",
                        "tag": "THIA",
                        "schemaOrgTag": null,
                        "total": 2.78365259084,
                        "hasRDI": true,
                        "daily": 231.9710492366667,
                        "unit": "mg"
                    },
                    {
                        "label": "Riboflavin (B2)",
                        "tag": "RIBF",
                        "schemaOrgTag": null,
                        "total": 2.117933530895,
                        "hasRDI": true,
                        "daily": 162.91796391499997,
                        "unit": "mg"
                    },
                    {
                        "label": "Niacin (B3)",
                        "tag": "NIA",
                        "schemaOrgTag": null,
                        "total": 21.40050730072858,
                        "hasRDI": true,
                        "daily": 133.75317062955364,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin B6",
                        "tag": "VITB6A",
                        "schemaOrgTag": null,
                        "total": 0.7620411558949373,
                        "hasRDI": true,
                        "daily": 58.618550453456706,
                        "unit": "mg"
                    },
                    {
                        "label": "Folate equivalent (total)",
                        "tag": "FOLDFE",
                        "schemaOrgTag": null,
                        "total": 1298.2256276137484,
                        "hasRDI": true,
                        "daily": 324.5564069034371,
                        "unit": "µg"
                    },
                    {
                        "label": "Folate (food)",
                        "tag": "FOLFD",
                        "schemaOrgTag": null,
                        "total": 643.2256276137485,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Folic acid",
                        "tag": "FOLAC",
                        "schemaOrgTag": null,
                        "total": 385,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin B12",
                        "tag": "VITB12",
                        "schemaOrgTag": null,
                        "total": 0.8700000000000001,
                        "hasRDI": true,
                        "daily": 36.25000000000001,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin D",
                        "tag": "VITD",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": true,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin E",
                        "tag": "TOCPHA",
                        "schemaOrgTag": null,
                        "total": 12.727450000000001,
                        "hasRDI": true,
                        "daily": 84.84966666666668,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin K",
                        "tag": "VITK1",
                        "schemaOrgTag": null,
                        "total": 30.2645,
                        "hasRDI": true,
                        "daily": 25.22041666666667,
                        "unit": "µg"
                    },
                    {
                        "label": "Sugar alcohols",
                        "tag": "Sugar.alcohol",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    },
                    {
                        "label": "Water",
                        "tag": "WATER",
                        "schemaOrgTag": null,
                        "total": 201.12758090579638,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    }
                ]
            },
            "_links": {
                "self": {
                    "href": "https://api.edamam.com/api/recipes/v2/2a4929c8467a3abc21672e195b200ee4?type=public&app_id=ea1d37d5&app_key=fd382a172ba8d6668c0430dc9c14a181",
                    "title": "Self"
                }
            }
        },
        {
            "recipe": {
                "uri": "http://www.edamam.com/ontologies/edamam.owl#recipe_0f2552085e2640b870d623d72fb87f6c",
                "label": "Vegan Cucumber Tea Sandwiches",
                "image": "https://www.edamam.com/web-img/266/266b131b87cf6b01417b0515a2a7b41d",
                "source": "Martha Stewart",
                "url": "https://www.marthastewart.com/1526080/vegan-cucumber-tea-sandwiches",
                "shareAs": "http://www.edamam.com/recipe/vegan-cucumber-tea-sandwiches-0f2552085e2640b870d623d72fb87f6c/vegan",
                "yield": 6,
                "dietLabels": [],
                "healthLabels": [
                    "Sugar-Conscious",
                    "Low Potassium",
                    "Kidney-Friendly",
                    "Vegan",
                    "Vegetarian",
                    "Pescatarian",
                    "Mediterranean",
                    "Dairy-Free",
                    "Egg-Free",
                    "Peanut-Free",
                    "Tree-Nut-Free",
                    "Soy-Free",
                    "Fish-Free",
                    "Shellfish-Free",
                    "Pork-Free",
                    "Red-Meat-Free",
                    "Crustacean-Free",
                    "Celery-Free",
                    "Mustard-Free",
                    "Sesame-Free",
                    "Lupine-Free",
                    "Mollusk-Free",
                    "Alcohol-Free",
                    "Sulfite-Free",
                    "Kosher"
                ],
                "cautions": [
                    "Tree-Nuts",
                    "Soy",
                    "FODMAP"
                ],
                "ingredientLines": [
                    "1 (8-ounce) container vegan cream cheese, such as Kite Hill",
                    "2 tablespoons finely chopped fresh chives, plus more for serving",
                    "2 tablespoons finely chopped fresh flat-leaf parsley",
                    "1 tablespoon finely chopped fresh tarragon",
                    "Kosher salt and freshly ground pepper",
                    "8 slices vegan white or pumpernickel sandwich bread, or a combination",
                    "2 mini cucumbers, thinly sliced into rounds"
                ],
                "ingredients": [
                    {
                        "text": "1 (8-ounce) container vegan cream cheese, such as Kite Hill",
                        "weight": 226.796185,
                        "foodCategory": "Plant-based protein",
                        "foodId": "food_afw1vv1ac3l17wbn9gcq2autcc91",
                        "image": "https://www.edamam.com/food-img/fc7/fc77c17a6b7310e939f328b32dc64e81.jpg"
                    },
                    {
                        "text": "2 tablespoons finely chopped fresh chives, plus more for serving",
                        "weight": 6,
                        "foodCategory": "vegetables",
                        "foodId": "food_btg1uzjak79lawbirsitkaeai60l",
                        "image": "https://www.edamam.com/food-img/f3f/f3f48643a924ba174b894e979cb48620.jpg"
                    },
                    {
                        "text": "2 tablespoons finely chopped fresh flat-leaf parsley",
                        "weight": 7.6,
                        "foodCategory": "vegetables",
                        "foodId": "food_b244pqdazw24zobr5vqu2bf0uid8",
                        "image": "https://www.edamam.com/food-img/46a/46a132e96626d7989b4d6ed8c91f4da0.jpg"
                    },
                    {
                        "text": "1 tablespoon finely chopped fresh tarragon",
                        "weight": 2.49999999995773,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_bcae9pdaob9i69bo94oxramms336",
                        "image": "https://www.edamam.com/food-img/22f/22f8945d157d8b759c30e6738639991b.jpg"
                    },
                    {
                        "text": "Kosher salt and freshly ground pepper",
                        "weight": 3.8093771099997467,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_a1vgrj1bs8rd1majvmd9ubz8ttkg",
                        "image": "https://www.edamam.com/food-img/694/6943ea510918c6025795e8dc6e6eaaeb.jpg"
                    },
                    {
                        "text": "Kosher salt and freshly ground pepper",
                        "weight": 1.9046885549998733,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_b6ywzluaaxv02wad7s1r9ag4py89",
                        "image": "https://www.edamam.com/food-img/c6e/c6e5c3bd8d3bc15175d9766971a4d1b2.jpg"
                    },
                    {
                        "text": "8 slices vegan white or pumpernickel sandwich bread, or a combination",
                        "weight": 232,
                        "foodCategory": "bread, rolls and tortillas",
                        "foodId": "food_a3049hmbqj5wstaeeb3udaz6uaqv",
                        "image": "https://www.edamam.com/food-img/886/886960f6ce6ccec5b9163bacf2996853.jpg"
                    },
                    {
                        "text": "2 mini cucumbers, thinly sliced into rounds",
                        "weight": 160,
                        "foodCategory": "vegetables",
                        "foodId": "food_bv7aggjag9rxsaatklqzobca5fzn",
                        "image": "https://www.edamam.com/food-img/501/5015da0e5fc2b384696b3d949aefef86.jpg"
                    }
                ],
                "calories": 1318.5723053696993,
                "totalWeight": 636.8008735549577,
                "totalTime": 15,
                "cuisineType": [
                    "american"
                ],
                "mealType": [
                    "lunch/dinner"
                ],
                "dishType": [
                    "sandwiches"
                ],
                "totalNutrients": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 1318.5723053696993,
                        "unit": "kcal"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 73.88378655656737,
                        "unit": "g"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 23.902188167910612,
                        "unit": "g"
                    },
                    "FATRN": {
                        "label": "Trans",
                        "quantity": 0.06031999999999999,
                        "unit": "g"
                    },
                    "FAMS": {
                        "label": "Monounsaturated",
                        "quantity": 1.4702856484212488,
                        "unit": "g"
                    },
                    "FAPU": {
                        "label": "Polyunsaturated",
                        "quantity": 3.665782791777336,
                        "unit": "g"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 143.90924623412698,
                        "unit": "g"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 25.77969813989571,
                        "unit": "g"
                    },
                    "SUGAR": {
                        "label": "Sugars",
                        "quantity": 23.886995974493935,
                        "unit": "g"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 41.731479076338736,
                        "unit": "g"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 0,
                        "unit": "mg"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 2066.0476538400058,
                        "unit": "mg"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 533.4008896530067,
                        "unit": "mg"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 143.4520174289031,
                        "unit": "mg"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 806.5173108946718,
                        "unit": "mg"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 13.030847645773608,
                        "unit": "mg"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 3.31588579380285,
                        "unit": "mg"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 402.8024079167675,
                        "unit": "mg"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 58.8402659097612,
                        "unit": "µg"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 19.787999999978865,
                        "unit": "mg"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 1.0255480636392935,
                        "unit": "mg"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 0.6910114393984337,
                        "unit": "mg"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 13.579328590179864,
                        "unit": "mg"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 0.4024326436940309,
                        "unit": "mg"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 265.90579705423414,
                        "unit": "µg"
                    },
                    "FOLFD": {
                        "label": "Folate (food)",
                        "quantity": 187.02579705423412,
                        "unit": "µg"
                    },
                    "FOLAC": {
                        "label": "Folic acid",
                        "quantity": 46.4,
                        "unit": "µg"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 0.5782087609719987,
                        "unit": "mg"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 178.12797516453477,
                        "unit": "µg"
                    },
                    "WATER": {
                        "label": "Water",
                        "quantity": 246.56778419394973,
                        "unit": "g"
                    }
                },
                "totalDaily": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 65.92861526848496,
                        "unit": "%"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 113.66736393318058,
                        "unit": "%"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 119.51094083955306,
                        "unit": "%"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 47.969748744708994,
                        "unit": "%"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 103.11879255958283,
                        "unit": "%"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 83.46295815267747,
                        "unit": "%"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 0,
                        "unit": "%"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 86.08531891000024,
                        "unit": "%"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 53.34008896530067,
                        "unit": "%"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 34.15524224497693,
                        "unit": "%"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 17.159942784993017,
                        "unit": "%"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 72.3935980320756,
                        "unit": "%"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 30.144416307298638,
                        "unit": "%"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 57.543201130966786,
                        "unit": "%"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 6.5378073233068,
                        "unit": "%"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 21.986666666643185,
                        "unit": "%"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 85.4623386366078,
                        "unit": "%"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 53.15472610757182,
                        "unit": "%"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 84.87080368862415,
                        "unit": "%"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 30.956357207233147,
                        "unit": "%"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 66.47644926355854,
                        "unit": "%"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 0,
                        "unit": "%"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 0,
                        "unit": "%"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 3.8547250731466582,
                        "unit": "%"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 148.43997930377898,
                        "unit": "%"
                    }
                },
                "digest": [
                    {
                        "label": "Fat",
                        "tag": "FAT",
                        "schemaOrgTag": "fatContent",
                        "total": 73.88378655656737,
                        "hasRDI": true,
                        "daily": 113.66736393318058,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Saturated",
                                "tag": "FASAT",
                                "schemaOrgTag": "saturatedFatContent",
                                "total": 23.902188167910612,
                                "hasRDI": true,
                                "daily": 119.51094083955306,
                                "unit": "g"
                            },
                            {
                                "label": "Trans",
                                "tag": "FATRN",
                                "schemaOrgTag": "transFatContent",
                                "total": 0.06031999999999999,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Monounsaturated",
                                "tag": "FAMS",
                                "schemaOrgTag": null,
                                "total": 1.4702856484212488,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Polyunsaturated",
                                "tag": "FAPU",
                                "schemaOrgTag": null,
                                "total": 3.665782791777336,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Carbs",
                        "tag": "CHOCDF",
                        "schemaOrgTag": "carbohydrateContent",
                        "total": 143.90924623412698,
                        "hasRDI": true,
                        "daily": 47.969748744708994,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Carbs (net)",
                                "tag": "CHOCDF.net",
                                "schemaOrgTag": null,
                                "total": 118.12954809423127,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Fiber",
                                "tag": "FIBTG",
                                "schemaOrgTag": "fiberContent",
                                "total": 25.77969813989571,
                                "hasRDI": true,
                                "daily": 103.11879255958283,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars",
                                "tag": "SUGAR",
                                "schemaOrgTag": "sugarContent",
                                "total": 23.886995974493935,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars, added",
                                "tag": "SUGAR.added",
                                "schemaOrgTag": null,
                                "total": 0,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Protein",
                        "tag": "PROCNT",
                        "schemaOrgTag": "proteinContent",
                        "total": 41.731479076338736,
                        "hasRDI": true,
                        "daily": 83.46295815267747,
                        "unit": "g"
                    },
                    {
                        "label": "Cholesterol",
                        "tag": "CHOLE",
                        "schemaOrgTag": "cholesterolContent",
                        "total": 0,
                        "hasRDI": true,
                        "daily": 0,
                        "unit": "mg"
                    },
                    {
                        "label": "Sodium",
                        "tag": "NA",
                        "schemaOrgTag": "sodiumContent",
                        "total": 2066.0476538400058,
                        "hasRDI": true,
                        "daily": 86.08531891000024,
                        "unit": "mg"
                    },
                    {
                        "label": "Calcium",
                        "tag": "CA",
                        "schemaOrgTag": null,
                        "total": 533.4008896530067,
                        "hasRDI": true,
                        "daily": 53.34008896530067,
                        "unit": "mg"
                    },
                    {
                        "label": "Magnesium",
                        "tag": "MG",
                        "schemaOrgTag": null,
                        "total": 143.4520174289031,
                        "hasRDI": true,
                        "daily": 34.15524224497693,
                        "unit": "mg"
                    },
                    {
                        "label": "Potassium",
                        "tag": "K",
                        "schemaOrgTag": null,
                        "total": 806.5173108946718,
                        "hasRDI": true,
                        "daily": 17.159942784993017,
                        "unit": "mg"
                    },
                    {
                        "label": "Iron",
                        "tag": "FE",
                        "schemaOrgTag": null,
                        "total": 13.030847645773608,
                        "hasRDI": true,
                        "daily": 72.3935980320756,
                        "unit": "mg"
                    },
                    {
                        "label": "Zinc",
                        "tag": "ZN",
                        "schemaOrgTag": null,
                        "total": 3.31588579380285,
                        "hasRDI": true,
                        "daily": 30.144416307298638,
                        "unit": "mg"
                    },
                    {
                        "label": "Phosphorus",
                        "tag": "P",
                        "schemaOrgTag": null,
                        "total": 402.8024079167675,
                        "hasRDI": true,
                        "daily": 57.543201130966786,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin A",
                        "tag": "VITA_RAE",
                        "schemaOrgTag": null,
                        "total": 58.8402659097612,
                        "hasRDI": true,
                        "daily": 6.5378073233068,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin C",
                        "tag": "VITC",
                        "schemaOrgTag": null,
                        "total": 19.787999999978865,
                        "hasRDI": true,
                        "daily": 21.986666666643185,
                        "unit": "mg"
                    },
                    {
                        "label": "Thiamin (B1)",
                        "tag": "THIA",
                        "schemaOrgTag": null,
                        "total": 1.0255480636392935,
                        "hasRDI": true,
                        "daily": 85.4623386366078,
                        "unit": "mg"
                    },
                    {
                        "label": "Riboflavin (B2)",
                        "tag": "RIBF",
                        "schemaOrgTag": null,
                        "total": 0.6910114393984337,
                        "hasRDI": true,
                        "daily": 53.15472610757182,
                        "unit": "mg"
                    },
                    {
                        "label": "Niacin (B3)",
                        "tag": "NIA",
                        "schemaOrgTag": null,
                        "total": 13.579328590179864,
                        "hasRDI": true,
                        "daily": 84.87080368862415,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin B6",
                        "tag": "VITB6A",
                        "schemaOrgTag": null,
                        "total": 0.4024326436940309,
                        "hasRDI": true,
                        "daily": 30.956357207233147,
                        "unit": "mg"
                    },
                    {
                        "label": "Folate equivalent (total)",
                        "tag": "FOLDFE",
                        "schemaOrgTag": null,
                        "total": 265.90579705423414,
                        "hasRDI": true,
                        "daily": 66.47644926355854,
                        "unit": "µg"
                    },
                    {
                        "label": "Folate (food)",
                        "tag": "FOLFD",
                        "schemaOrgTag": null,
                        "total": 187.02579705423412,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Folic acid",
                        "tag": "FOLAC",
                        "schemaOrgTag": null,
                        "total": 46.4,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin B12",
                        "tag": "VITB12",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": true,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin D",
                        "tag": "VITD",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": true,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin E",
                        "tag": "TOCPHA",
                        "schemaOrgTag": null,
                        "total": 0.5782087609719987,
                        "hasRDI": true,
                        "daily": 3.8547250731466582,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin K",
                        "tag": "VITK1",
                        "schemaOrgTag": null,
                        "total": 178.12797516453477,
                        "hasRDI": true,
                        "daily": 148.43997930377898,
                        "unit": "µg"
                    },
                    {
                        "label": "Sugar alcohols",
                        "tag": "Sugar.alcohol",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    },
                    {
                        "label": "Water",
                        "tag": "WATER",
                        "schemaOrgTag": null,
                        "total": 246.56778419394973,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    }
                ]
            },
            "_links": {
                "self": {
                    "href": "https://api.edamam.com/api/recipes/v2/0f2552085e2640b870d623d72fb87f6c?type=public&app_id=ea1d37d5&app_key=fd382a172ba8d6668c0430dc9c14a181",
                    "title": "Self"
                }
            }
        },
        {
            "recipe": {
                "uri": "http://www.edamam.com/ontologies/edamam.owl#recipe_fb2c2aff0392eb951d3b220b16f5a54a",
                "label": "Classic American Fare, Now In Vegan! recipes",
                "image": "https://www.edamam.com/web-img/bee/beea3f58e66dbe7ab6e6923fdb4ba670",
                "source": "Food Republic",
                "url": "http://www.foodrepublic.com/recipes/classic-american-fare-now-in-vegan/",
                "shareAs": "http://www.edamam.com/recipe/classic-american-fare-now-in-vegan-recipes-fb2c2aff0392eb951d3b220b16f5a54a/vegan",
                "yield": 4,
                "dietLabels": [
                    "High-Fiber",
                    "Low-Carb"
                ],
                "healthLabels": [
                    "Vegetarian",
                    "Pescatarian",
                    "Gluten-Free",
                    "Wheat-Free",
                    "Egg-Free",
                    "Peanut-Free",
                    "Fish-Free",
                    "Shellfish-Free",
                    "Pork-Free",
                    "Red-Meat-Free",
                    "Crustacean-Free",
                    "Celery-Free",
                    "Mustard-Free",
                    "Sesame-Free",
                    "Lupine-Free",
                    "Mollusk-Free",
                    "Alcohol-Free",
                    "Kosher"
                ],
                "cautions": [
                    "Gluten",
                    "Wheat",
                    "Sulfites",
                    "FODMAP"
                ],
                "ingredientLines": [
                    "1/4 cup vegan butter",
                    "1 cup onion, diced finely",
                    "1/2 tablespoon garlic, minced",
                    "16 ounces broccoli, fresh or frozen, chopped",
                    "1 quart water or vegetable stock",
                    "1/4 teaspoon white pepper",
                    "1 tablespoon cornstarch, mixed with 1/2 cup water",
                    "1/4 cup nutritional yeast",
                    "1 1/2 cups unsweetened unflavored soy or almond milk",
                    "8 ounces vegan cheddar cheese"
                ],
                "ingredients": [
                    {
                        "text": "1/4 cup vegan butter",
                        "weight": 54.5,
                        "foodCategory": "Oils",
                        "foodId": "food_bn7cczea5psahcbaqvd2ob43qksr",
                        "image": "https://www.edamam.com/food-img/330/3302cd340e3d2dcf7f02e72fdfe8b209.jpg"
                    },
                    {
                        "text": "1 cup onion, diced finely",
                        "weight": 160,
                        "foodCategory": "vegetables",
                        "foodId": "food_bmrvi4ob4binw9a5m7l07amlfcoy",
                        "image": "https://www.edamam.com/food-img/205/205e6bf2399b85d34741892ef91cc603.jpg"
                    },
                    {
                        "text": "1/2 tablespoon garlic, minced",
                        "weight": 4.2499999999281455,
                        "foodCategory": "vegetables",
                        "foodId": "food_avtcmx6bgjv1jvay6s6stan8dnyp",
                        "image": "https://www.edamam.com/food-img/6ee/6ee142951f48aaf94f4312409f8d133d.jpg"
                    },
                    {
                        "text": "16 ounces broccoli, fresh or frozen, chopped",
                        "weight": 453.59237,
                        "foodCategory": "vegetables",
                        "foodId": "food_aahw0jha9f8337ajbopx9aec6z7i",
                        "image": "https://www.edamam.com/food-img/3e4/3e47317a3dd54dc911b9c44122285df1.jpg"
                    },
                    {
                        "text": "1 quart water or vegetable stock",
                        "weight": 908,
                        "foodCategory": "Vegan products",
                        "foodId": "food_bb2qjrjamst0vmam39stubtkmrs4",
                        "image": "https://www.edamam.com/food-img/e61/e6184a8681b772e5198ef0ca1919e1b7.jpg"
                    },
                    {
                        "text": "1/4 teaspoon white pepper",
                        "weight": 0.6,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_a443px0bncpqa5avv80p3anrp26k",
                        "image": "https://www.edamam.com/food-img/4f0/4f0e35fe6c042996408b337fb550324a.jpg"
                    },
                    {
                        "text": "1 tablespoon cornstarch, mixed with 1/2 cup water",
                        "weight": 7.999999999864745,
                        "foodCategory": null,
                        "foodId": "food_bevnfkfbvjm45pbbgj9nsb3ypntm",
                        "image": "https://www.edamam.com/food-img/f9b/f9b74d9495b40c0aea955c37a1fc39dc.jpg"
                    },
                    {
                        "text": "1/4 cup nutritional yeast",
                        "weight": 64,
                        "foodCategory": "Vegan products",
                        "foodId": "food_abjagi2b7qlt18aryyugvbnm0tlu",
                        "image": null
                    },
                    {
                        "text": "1 1/2 cups unsweetened unflavored soy or almond milk",
                        "weight": 360,
                        "foodCategory": "Vegan products",
                        "foodId": "food_aa8o4pkbhgkey4btmg1daaclqmww",
                        "image": "https://www.edamam.com/food-img/b26/b267bf598feaabd7349fddda7a481f00.jpg"
                    },
                    {
                        "text": "8 ounces vegan cheddar cheese",
                        "weight": 226.796185,
                        "foodCategory": "Cheese",
                        "foodId": "food_bhppgmha1u27voagb8eptbp9g376",
                        "image": "https://www.edamam.com/food-img/bcd/bcd94dde1fcde1475b5bf0540f821c5d.jpg"
                    }
                ],
                "calories": 1901.9693739764975,
                "totalWeight": 2239.738554999793,
                "totalTime": 30,
                "cuisineType": [
                    "american"
                ],
                "mealType": [
                    "lunch/dinner"
                ],
                "dishType": [
                    "condiments and sauces"
                ],
                "totalNutrients": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 1901.9693739764975,
                        "unit": "kcal"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 139.3007603446796,
                        "unit": "g"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 96.55440278517993,
                        "unit": "g"
                    },
                    "FATRN": {
                        "label": "Trans",
                        "quantity": 2.8189600211500005,
                        "unit": "g"
                    },
                    "FAMS": {
                        "label": "Monounsaturated",
                        "quantity": 30.003606335539974,
                        "unit": "g"
                    },
                    "FAPU": {
                        "label": "Polyunsaturated",
                        "quantity": 7.5957624323297885,
                        "unit": "g"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 82.5420217955128,
                        "unit": "g"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 33.30345605071727,
                        "unit": "g"
                    },
                    "SUGAR": {
                        "label": "Sugars",
                        "quantity": 19.498202902119285,
                        "unit": "g"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 103.82611551051508,
                        "unit": "g"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 231.33210870000002,
                        "unit": "mg"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 2040.583967079976,
                        "unit": "mg"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 2535.3955413187873,
                        "unit": "mg"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 307.35320357641797,
                        "unit": "mg"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 2143.3565484383084,
                        "unit": "mg"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 8.632664609958143,
                        "unit": "mg"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 22.446218406419085,
                        "unit": "mg"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 1593.3419118684324,
                        "unit": "mg"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 768.6046964057601,
                        "unit": "µg"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 420.4114421562176,
                        "unit": "mg"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 39.089834832649856,
                        "unit": "mg"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 40.53235108571992,
                        "unit": "mg"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 227.6165479078895,
                        "unit": "mg"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 39.62673228994911,
                        "unit": "mg"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 394.9976509208379,
                        "unit": "µg"
                    },
                    "FOLFD": {
                        "label": "Folate (food)",
                        "quantity": 394.9976509208379,
                        "unit": "µg"
                    },
                    "FOLAC": {
                        "label": "Folic acid",
                        "quantity": 960,
                        "unit": "µg"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 33.164361216,
                        "unit": "µg"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 1.3641003900000002,
                        "unit": "µg"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 16.013970327959942,
                        "unit": "mg"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 495.53018455115887,
                        "unit": "µg"
                    },
                    "WATER": {
                        "label": "Water",
                        "quantity": 1881.7480144597466,
                        "unit": "g"
                    }
                },
                "totalDaily": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 95.09846869882487,
                        "unit": "%"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 214.30886206873782,
                        "unit": "%"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 482.77201392589967,
                        "unit": "%"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 27.51400726517093,
                        "unit": "%"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 133.2138242028691,
                        "unit": "%"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 207.65223102103016,
                        "unit": "%"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 77.1107029,
                        "unit": "%"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 85.02433196166567,
                        "unit": "%"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 253.53955413187873,
                        "unit": "%"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 73.17933418486142,
                        "unit": "%"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 45.60333081783635,
                        "unit": "%"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 47.9592478331008,
                        "unit": "%"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 204.0565309674462,
                        "unit": "%"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 227.62027312406175,
                        "unit": "%"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 85.40052182286225,
                        "unit": "%"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 467.12382461801957,
                        "unit": "%"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 3257.486236054155,
                        "unit": "%"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 3117.873160439993,
                        "unit": "%"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 1422.6034244243094,
                        "unit": "%"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 3048.210176149931,
                        "unit": "%"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 98.74941273020949,
                        "unit": "%"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 1381.8483840000001,
                        "unit": "%"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 9.094002600000001,
                        "unit": "%"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 106.75980218639961,
                        "unit": "%"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 412.9418204592991,
                        "unit": "%"
                    }
                },
                "digest": [
                    {
                        "label": "Fat",
                        "tag": "FAT",
                        "schemaOrgTag": "fatContent",
                        "total": 139.3007603446796,
                        "hasRDI": true,
                        "daily": 214.30886206873782,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Saturated",
                                "tag": "FASAT",
                                "schemaOrgTag": "saturatedFatContent",
                                "total": 96.55440278517993,
                                "hasRDI": true,
                                "daily": 482.77201392589967,
                                "unit": "g"
                            },
                            {
                                "label": "Trans",
                                "tag": "FATRN",
                                "schemaOrgTag": "transFatContent",
                                "total": 2.8189600211500005,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Monounsaturated",
                                "tag": "FAMS",
                                "schemaOrgTag": null,
                                "total": 30.003606335539974,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Polyunsaturated",
                                "tag": "FAPU",
                                "schemaOrgTag": null,
                                "total": 7.5957624323297885,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Carbs",
                        "tag": "CHOCDF",
                        "schemaOrgTag": "carbohydrateContent",
                        "total": 82.5420217955128,
                        "hasRDI": true,
                        "daily": 27.51400726517093,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Carbs (net)",
                                "tag": "CHOCDF.net",
                                "schemaOrgTag": null,
                                "total": 49.23856574479552,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Fiber",
                                "tag": "FIBTG",
                                "schemaOrgTag": "fiberContent",
                                "total": 33.30345605071727,
                                "hasRDI": true,
                                "daily": 133.2138242028691,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars",
                                "tag": "SUGAR",
                                "schemaOrgTag": "sugarContent",
                                "total": 19.498202902119285,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars, added",
                                "tag": "SUGAR.added",
                                "schemaOrgTag": null,
                                "total": 0,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Protein",
                        "tag": "PROCNT",
                        "schemaOrgTag": "proteinContent",
                        "total": 103.82611551051508,
                        "hasRDI": true,
                        "daily": 207.65223102103016,
                        "unit": "g"
                    },
                    {
                        "label": "Cholesterol",
                        "tag": "CHOLE",
                        "schemaOrgTag": "cholesterolContent",
                        "total": 231.33210870000002,
                        "hasRDI": true,
                        "daily": 77.1107029,
                        "unit": "mg"
                    },
                    {
                        "label": "Sodium",
                        "tag": "NA",
                        "schemaOrgTag": "sodiumContent",
                        "total": 2040.583967079976,
                        "hasRDI": true,
                        "daily": 85.02433196166567,
                        "unit": "mg"
                    },
                    {
                        "label": "Calcium",
                        "tag": "CA",
                        "schemaOrgTag": null,
                        "total": 2535.3955413187873,
                        "hasRDI": true,
                        "daily": 253.53955413187873,
                        "unit": "mg"
                    },
                    {
                        "label": "Magnesium",
                        "tag": "MG",
                        "schemaOrgTag": null,
                        "total": 307.35320357641797,
                        "hasRDI": true,
                        "daily": 73.17933418486142,
                        "unit": "mg"
                    },
                    {
                        "label": "Potassium",
                        "tag": "K",
                        "schemaOrgTag": null,
                        "total": 2143.3565484383084,
                        "hasRDI": true,
                        "daily": 45.60333081783635,
                        "unit": "mg"
                    },
                    {
                        "label": "Iron",
                        "tag": "FE",
                        "schemaOrgTag": null,
                        "total": 8.632664609958143,
                        "hasRDI": true,
                        "daily": 47.9592478331008,
                        "unit": "mg"
                    },
                    {
                        "label": "Zinc",
                        "tag": "ZN",
                        "schemaOrgTag": null,
                        "total": 22.446218406419085,
                        "hasRDI": true,
                        "daily": 204.0565309674462,
                        "unit": "mg"
                    },
                    {
                        "label": "Phosphorus",
                        "tag": "P",
                        "schemaOrgTag": null,
                        "total": 1593.3419118684324,
                        "hasRDI": true,
                        "daily": 227.62027312406175,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin A",
                        "tag": "VITA_RAE",
                        "schemaOrgTag": null,
                        "total": 768.6046964057601,
                        "hasRDI": true,
                        "daily": 85.40052182286225,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin C",
                        "tag": "VITC",
                        "schemaOrgTag": null,
                        "total": 420.4114421562176,
                        "hasRDI": true,
                        "daily": 467.12382461801957,
                        "unit": "mg"
                    },
                    {
                        "label": "Thiamin (B1)",
                        "tag": "THIA",
                        "schemaOrgTag": null,
                        "total": 39.089834832649856,
                        "hasRDI": true,
                        "daily": 3257.486236054155,
                        "unit": "mg"
                    },
                    {
                        "label": "Riboflavin (B2)",
                        "tag": "RIBF",
                        "schemaOrgTag": null,
                        "total": 40.53235108571992,
                        "hasRDI": true,
                        "daily": 3117.873160439993,
                        "unit": "mg"
                    },
                    {
                        "label": "Niacin (B3)",
                        "tag": "NIA",
                        "schemaOrgTag": null,
                        "total": 227.6165479078895,
                        "hasRDI": true,
                        "daily": 1422.6034244243094,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin B6",
                        "tag": "VITB6A",
                        "schemaOrgTag": null,
                        "total": 39.62673228994911,
                        "hasRDI": true,
                        "daily": 3048.210176149931,
                        "unit": "mg"
                    },
                    {
                        "label": "Folate equivalent (total)",
                        "tag": "FOLDFE",
                        "schemaOrgTag": null,
                        "total": 394.9976509208379,
                        "hasRDI": true,
                        "daily": 98.74941273020949,
                        "unit": "µg"
                    },
                    {
                        "label": "Folate (food)",
                        "tag": "FOLFD",
                        "schemaOrgTag": null,
                        "total": 394.9976509208379,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Folic acid",
                        "tag": "FOLAC",
                        "schemaOrgTag": null,
                        "total": 960,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin B12",
                        "tag": "VITB12",
                        "schemaOrgTag": null,
                        "total": 33.164361216,
                        "hasRDI": true,
                        "daily": 1381.8483840000001,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin D",
                        "tag": "VITD",
                        "schemaOrgTag": null,
                        "total": 1.3641003900000002,
                        "hasRDI": true,
                        "daily": 9.094002600000001,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin E",
                        "tag": "TOCPHA",
                        "schemaOrgTag": null,
                        "total": 16.013970327959942,
                        "hasRDI": true,
                        "daily": 106.75980218639961,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin K",
                        "tag": "VITK1",
                        "schemaOrgTag": null,
                        "total": 495.53018455115887,
                        "hasRDI": true,
                        "daily": 412.9418204592991,
                        "unit": "µg"
                    },
                    {
                        "label": "Sugar alcohols",
                        "tag": "Sugar.alcohol",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    },
                    {
                        "label": "Water",
                        "tag": "WATER",
                        "schemaOrgTag": null,
                        "total": 1881.7480144597466,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    }
                ]
            },
            "_links": {
                "self": {
                    "href": "https://api.edamam.com/api/recipes/v2/fb2c2aff0392eb951d3b220b16f5a54a?type=public&app_id=ea1d37d5&app_key=fd382a172ba8d6668c0430dc9c14a181",
                    "title": "Self"
                }
            }
        },
        {
            "recipe": {
                "uri": "http://www.edamam.com/ontologies/edamam.owl#recipe_c6aff06888db5a3c4b6d47878d03eee2",
                "label": "Vegan Nachos",
                "image": "https://www.edamam.com/web-img/ed3/ed32750be9cc9b518e464a812c533f59.jpg",
                "source": "Honest Cooking",
                "url": "http://honestcooking.com/dairy-free-vegan-nachos-recipe/",
                "shareAs": "http://www.edamam.com/recipe/vegan-nachos-c6aff06888db5a3c4b6d47878d03eee2/vegan",
                "yield": 4,
                "dietLabels": [
                    "High-Fiber"
                ],
                "healthLabels": [
                    "Vegetarian",
                    "Pescatarian",
                    "Gluten-Free",
                    "Wheat-Free",
                    "Egg-Free",
                    "Peanut-Free",
                    "Tree-Nut-Free",
                    "Soy-Free",
                    "Fish-Free",
                    "Shellfish-Free",
                    "Pork-Free",
                    "Red-Meat-Free",
                    "Crustacean-Free",
                    "Celery-Free",
                    "Mustard-Free",
                    "Lupine-Free",
                    "Mollusk-Free",
                    "Alcohol-Free",
                    "Sulfite-Free",
                    "Kosher"
                ],
                "cautions": [
                    "Sulfites",
                    "FODMAP"
                ],
                "ingredientLines": [
                    "1 bag corn tortilla chips",
                    "1½ cups go veggie! vegan mexican cheese shreds",
                    "1 cup fresh salsa",
                    "½ cup packed baby spinach",
                    "1 extra ripe avocado, peeled, pitted and mashed",
                    "½ tsp. sea salt",
                    "½ tsp. freshly ground pepper",
                    "½ tsp. crushed red pepper flakes",
                    "1 tbsp. sesame seeds",
                    "½ cup finely chopped cilantro, for topping"
                ],
                "ingredients": [
                    {
                        "text": "1 bag corn tortilla chips",
                        "weight": 335,
                        "foodCategory": "savory snacks",
                        "foodId": "food_bkxl9s9bpcxmenbef89qbbofifnr",
                        "image": "https://www.edamam.com/food-img/24e/24eea039cad825c1745263674e9879df.jpg"
                    },
                    {
                        "text": "1½ cups go veggie! vegan mexican cheese shreds",
                        "weight": 169.5,
                        "foodCategory": "Cheese",
                        "foodId": "food_bhppgmha1u27voagb8eptbp9g376",
                        "image": "https://www.edamam.com/food-img/bcd/bcd94dde1fcde1475b5bf0540f821c5d.jpg"
                    },
                    {
                        "text": "1 cup fresh salsa",
                        "weight": 260,
                        "foodCategory": "canned soup",
                        "foodId": "food_b0t3obfawlm5k2b6erxscacez35u",
                        "image": "https://www.edamam.com/food-img/995/995d0f166754a0475c181b9c156fec43.jpg"
                    },
                    {
                        "text": "½ cup packed baby spinach",
                        "weight": 4.999999999999995,
                        "foodCategory": "vegetables",
                        "foodId": "food_aoceuc6bshdej1bbsdammbnj6l6o",
                        "image": "https://www.edamam.com/food-img/e6e/e6e4be375c4554ce01c8ea75232efaa6.jpg"
                    },
                    {
                        "text": "1 extra ripe avocado, peeled, pitted and mashed",
                        "weight": 201,
                        "foodCategory": "fruit",
                        "foodId": "food_b0yuze4b1g3afpanijno5abtiu28",
                        "image": "https://www.edamam.com/food-img/984/984a707ea8e9c6bf5f6498970a9e6d9d.jpg"
                    },
                    {
                        "text": "½ tsp. sea salt",
                        "weight": 2.4270833334564377,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_a1vgrj1bs8rd1majvmd9ubz8ttkg",
                        "image": "https://www.edamam.com/food-img/694/6943ea510918c6025795e8dc6e6eaaeb.jpg"
                    },
                    {
                        "text": "½ tsp. freshly ground pepper",
                        "weight": 1.45,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_b6ywzluaaxv02wad7s1r9ag4py89",
                        "image": "https://www.edamam.com/food-img/c6e/c6e5c3bd8d3bc15175d9766971a4d1b2.jpg"
                    },
                    {
                        "text": "½ tsp. crushed red pepper flakes",
                        "weight": 0.38541666668621544,
                        "foodCategory": "vegetables",
                        "foodId": "food_bispmxiaijcuxcagex14mbhk2o48",
                        "image": "https://www.edamam.com/food-img/6cb/6cb8e4510251a322178f6e191b3a7b1b.jpeg"
                    },
                    {
                        "text": "1 tbsp. sesame seeds",
                        "weight": 9,
                        "foodCategory": "plant-based protein",
                        "foodId": "food_bvxfnx8bwz2q3abs04kd6bbuf9w8",
                        "image": "https://www.edamam.com/food-img/291/291b355a7a0948716243164427697279.jpg"
                    },
                    {
                        "text": "½ cup finely chopped cilantro, for topping",
                        "weight": 8,
                        "foodCategory": "vegetables",
                        "foodId": "food_alhzhuwb4lc7jnb5s6f02by60bzp",
                        "image": "https://www.edamam.com/food-img/d57/d57e375b6ff99a90c7ee2b1990a1af36.jpg"
                    }
                ],
                "calories": 2809.568250000064,
                "totalWeight": 989.3354166666862,
                "totalTime": 15,
                "cuisineType": [
                    "american"
                ],
                "mealType": [
                    "lunch/dinner"
                ],
                "dishType": [
                    "condiments and sauces"
                ],
                "totalNutrients": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 2809.568250000064,
                        "unit": "kcal"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 166.64006270833448,
                        "unit": "g"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 47.13333743750016,
                        "unit": "g"
                    },
                    "FATRN": {
                        "label": "Trans",
                        "quantity": 2.2195050000000003,
                        "unit": "g"
                    },
                    "FAMS": {
                        "label": "Monounsaturated",
                        "quantity": 64.5261792500001,
                        "unit": "g"
                    },
                    "FAPU": {
                        "label": "Polyunsaturated",
                        "quantity": 39.125102979167266,
                        "unit": "g"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 266.376777083347,
                        "unit": "g"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 35.76546458333894,
                        "unit": "g"
                    },
                    "SUGAR": {
                        "label": "Sugars",
                        "quantity": 16.38383208334136,
                        "unit": "g"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 73.04933208333539,
                        "unit": "g"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 172.89000000000001,
                        "unit": "mg"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 3986.4107291666837,
                        "unit": "mg"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 1699.301937500009,
                        "unit": "mg"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 464.8936666666838,
                        "unit": "mg"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 2672.947791667032,
                        "unit": "mg"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 8.589374166667849,
                        "unit": "mg"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 13.2704362500002,
                        "unit": "mg"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 1844.358812500031,
                        "unit": "mg"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 604.9594166669254,
                        "unit": "µg"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 28.726020833339472,
                        "unit": "mg"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 0.7892631875000159,
                        "unit": "mg"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 1.276074270833569,
                        "unit": "mg"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 12.071440270835028,
                        "unit": "mg"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 1.8340363750001583,
                        "unit": "mg"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 314.81306250001006,
                        "unit": "µg"
                    },
                    "FOLFD": {
                        "label": "Folate (food)",
                        "quantity": 314.81306250001006,
                        "unit": "µg"
                    },
                    "FOLAC": {
                        "label": "Folic acid",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 1.4916,
                        "unit": "µg"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 1.017,
                        "unit": "µg"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 18.95548208333395,
                        "unit": "mg"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 111.79117083335446,
                        "unit": "µg"
                    },
                    "WATER": {
                        "label": "Water",
                        "quantity": 461.02092729166816,
                        "unit": "g"
                    }
                },
                "totalDaily": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 140.4784125000032,
                        "unit": "%"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 256.3693272435915,
                        "unit": "%"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 235.6666871875008,
                        "unit": "%"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 88.79225902778234,
                        "unit": "%"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 143.06185833335576,
                        "unit": "%"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 146.09866416667077,
                        "unit": "%"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 57.63,
                        "unit": "%"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 166.1004470486118,
                        "unit": "%"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 169.9301937500009,
                        "unit": "%"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 110.68896825397235,
                        "unit": "%"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 56.871229609936854,
                        "unit": "%"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 47.718745370376936,
                        "unit": "%"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 120.64032954545637,
                        "unit": "%"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 263.47983035714725,
                        "unit": "%"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 67.21771296299171,
                        "unit": "%"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 31.917800925932745,
                        "unit": "%"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 65.771932291668,
                        "unit": "%"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 98.15955929488993,
                        "unit": "%"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 75.44650169271893,
                        "unit": "%"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 141.07972115385832,
                        "unit": "%"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 78.70326562500252,
                        "unit": "%"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 62.15,
                        "unit": "%"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 6.779999999999999,
                        "unit": "%"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 126.36988055555967,
                        "unit": "%"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 93.15930902779539,
                        "unit": "%"
                    }
                },
                "digest": [
                    {
                        "label": "Fat",
                        "tag": "FAT",
                        "schemaOrgTag": "fatContent",
                        "total": 166.64006270833448,
                        "hasRDI": true,
                        "daily": 256.3693272435915,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Saturated",
                                "tag": "FASAT",
                                "schemaOrgTag": "saturatedFatContent",
                                "total": 47.13333743750016,
                                "hasRDI": true,
                                "daily": 235.6666871875008,
                                "unit": "g"
                            },
                            {
                                "label": "Trans",
                                "tag": "FATRN",
                                "schemaOrgTag": "transFatContent",
                                "total": 2.2195050000000003,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Monounsaturated",
                                "tag": "FAMS",
                                "schemaOrgTag": null,
                                "total": 64.5261792500001,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Polyunsaturated",
                                "tag": "FAPU",
                                "schemaOrgTag": null,
                                "total": 39.125102979167266,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Carbs",
                        "tag": "CHOCDF",
                        "schemaOrgTag": "carbohydrateContent",
                        "total": 266.376777083347,
                        "hasRDI": true,
                        "daily": 88.79225902778234,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Carbs (net)",
                                "tag": "CHOCDF.net",
                                "schemaOrgTag": null,
                                "total": 230.61131250000807,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Fiber",
                                "tag": "FIBTG",
                                "schemaOrgTag": "fiberContent",
                                "total": 35.76546458333894,
                                "hasRDI": true,
                                "daily": 143.06185833335576,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars",
                                "tag": "SUGAR",
                                "schemaOrgTag": "sugarContent",
                                "total": 16.38383208334136,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars, added",
                                "tag": "SUGAR.added",
                                "schemaOrgTag": null,
                                "total": 0,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Protein",
                        "tag": "PROCNT",
                        "schemaOrgTag": "proteinContent",
                        "total": 73.04933208333539,
                        "hasRDI": true,
                        "daily": 146.09866416667077,
                        "unit": "g"
                    },
                    {
                        "label": "Cholesterol",
                        "tag": "CHOLE",
                        "schemaOrgTag": "cholesterolContent",
                        "total": 172.89000000000001,
                        "hasRDI": true,
                        "daily": 57.63,
                        "unit": "mg"
                    },
                    {
                        "label": "Sodium",
                        "tag": "NA",
                        "schemaOrgTag": "sodiumContent",
                        "total": 3986.4107291666837,
                        "hasRDI": true,
                        "daily": 166.1004470486118,
                        "unit": "mg"
                    },
                    {
                        "label": "Calcium",
                        "tag": "CA",
                        "schemaOrgTag": null,
                        "total": 1699.301937500009,
                        "hasRDI": true,
                        "daily": 169.9301937500009,
                        "unit": "mg"
                    },
                    {
                        "label": "Magnesium",
                        "tag": "MG",
                        "schemaOrgTag": null,
                        "total": 464.8936666666838,
                        "hasRDI": true,
                        "daily": 110.68896825397235,
                        "unit": "mg"
                    },
                    {
                        "label": "Potassium",
                        "tag": "K",
                        "schemaOrgTag": null,
                        "total": 2672.947791667032,
                        "hasRDI": true,
                        "daily": 56.871229609936854,
                        "unit": "mg"
                    },
                    {
                        "label": "Iron",
                        "tag": "FE",
                        "schemaOrgTag": null,
                        "total": 8.589374166667849,
                        "hasRDI": true,
                        "daily": 47.718745370376936,
                        "unit": "mg"
                    },
                    {
                        "label": "Zinc",
                        "tag": "ZN",
                        "schemaOrgTag": null,
                        "total": 13.2704362500002,
                        "hasRDI": true,
                        "daily": 120.64032954545637,
                        "unit": "mg"
                    },
                    {
                        "label": "Phosphorus",
                        "tag": "P",
                        "schemaOrgTag": null,
                        "total": 1844.358812500031,
                        "hasRDI": true,
                        "daily": 263.47983035714725,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin A",
                        "tag": "VITA_RAE",
                        "schemaOrgTag": null,
                        "total": 604.9594166669254,
                        "hasRDI": true,
                        "daily": 67.21771296299171,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin C",
                        "tag": "VITC",
                        "schemaOrgTag": null,
                        "total": 28.726020833339472,
                        "hasRDI": true,
                        "daily": 31.917800925932745,
                        "unit": "mg"
                    },
                    {
                        "label": "Thiamin (B1)",
                        "tag": "THIA",
                        "schemaOrgTag": null,
                        "total": 0.7892631875000159,
                        "hasRDI": true,
                        "daily": 65.771932291668,
                        "unit": "mg"
                    },
                    {
                        "label": "Riboflavin (B2)",
                        "tag": "RIBF",
                        "schemaOrgTag": null,
                        "total": 1.276074270833569,
                        "hasRDI": true,
                        "daily": 98.15955929488993,
                        "unit": "mg"
                    },
                    {
                        "label": "Niacin (B3)",
                        "tag": "NIA",
                        "schemaOrgTag": null,
                        "total": 12.071440270835028,
                        "hasRDI": true,
                        "daily": 75.44650169271893,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin B6",
                        "tag": "VITB6A",
                        "schemaOrgTag": null,
                        "total": 1.8340363750001583,
                        "hasRDI": true,
                        "daily": 141.07972115385832,
                        "unit": "mg"
                    },
                    {
                        "label": "Folate equivalent (total)",
                        "tag": "FOLDFE",
                        "schemaOrgTag": null,
                        "total": 314.81306250001006,
                        "hasRDI": true,
                        "daily": 78.70326562500252,
                        "unit": "µg"
                    },
                    {
                        "label": "Folate (food)",
                        "tag": "FOLFD",
                        "schemaOrgTag": null,
                        "total": 314.81306250001006,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Folic acid",
                        "tag": "FOLAC",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin B12",
                        "tag": "VITB12",
                        "schemaOrgTag": null,
                        "total": 1.4916,
                        "hasRDI": true,
                        "daily": 62.15,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin D",
                        "tag": "VITD",
                        "schemaOrgTag": null,
                        "total": 1.017,
                        "hasRDI": true,
                        "daily": 6.779999999999999,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin E",
                        "tag": "TOCPHA",
                        "schemaOrgTag": null,
                        "total": 18.95548208333395,
                        "hasRDI": true,
                        "daily": 126.36988055555967,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin K",
                        "tag": "VITK1",
                        "schemaOrgTag": null,
                        "total": 111.79117083335446,
                        "hasRDI": true,
                        "daily": 93.15930902779539,
                        "unit": "µg"
                    },
                    {
                        "label": "Sugar alcohols",
                        "tag": "Sugar.alcohol",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    },
                    {
                        "label": "Water",
                        "tag": "WATER",
                        "schemaOrgTag": null,
                        "total": 461.02092729166816,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    }
                ]
            },
            "_links": {
                "self": {
                    "href": "https://api.edamam.com/api/recipes/v2/c6aff06888db5a3c4b6d47878d03eee2?type=public&app_id=ea1d37d5&app_key=fd382a172ba8d6668c0430dc9c14a181",
                    "title": "Self"
                }
            }
        },
        {
            "recipe": {
                "uri": "http://www.edamam.com/ontologies/edamam.owl#recipe_9559557a0cc426dfd7d7aca79a0bce98",
                "label": "The Best Vegan Breakfast Sandwich",
                "image": "https://www.edamam.com/web-img/a73/a73159b4affa3460299feea42c4430be.jpg",
                "source": "Epicurious",
                "url": "https://www.epicurious.com/recipes/food/views/the-best-vegan-tofu-breakfast-sandwich",
                "shareAs": "http://www.edamam.com/recipe/the-best-vegan-breakfast-sandwich-9559557a0cc426dfd7d7aca79a0bce98/vegan",
                "yield": 12,
                "dietLabels": [],
                "healthLabels": [
                    "Egg-Free",
                    "Peanut-Free",
                    "Tree-Nut-Free",
                    "Fish-Free",
                    "Shellfish-Free",
                    "Crustacean-Free",
                    "Celery-Free",
                    "Mustard-Free",
                    "Sesame-Free",
                    "Lupine-Free",
                    "Mollusk-Free",
                    "Alcohol-Free"
                ],
                "cautions": [
                    "Gluten",
                    "Wheat",
                    "Sulfites",
                    "FODMAP"
                ],
                "ingredientLines": [
                    "1 (16 oz/450 g) brick medium-firm tofu",
                    "3/4 cup unsweetened nondairy milk",
                    "1/3 cup nutritional yeast",
                    "1/4 cup tapioca flour",
                    "1 teaspoon ground turmeric",
                    "1 teaspoon garlic powder",
                    "1 teaspoon onion powder",
                    "1 teaspoon sea salt",
                    "1/2 teaspoon ground pepper",
                    "2 tablespoons finely chopped chives",
                    "3 tablespoons vegan butter, for frying",
                    "5 English muffins, split in half",
                    "5 tablespoons vegan butter",
                    "5 vegan cheddar cheese slices",
                    "Cassava Bacon",
                    "2 vine tomatoes, sliced thick"
                ],
                "ingredients": [
                    {
                        "text": "1 (16 oz/450 g) brick medium-firm tofu",
                        "weight": 453.59237,
                        "foodCategory": "plant-based protein",
                        "foodId": "food_a269ixea1yf51xbfwgnq2boiwc7x",
                        "image": "https://www.edamam.com/food-img/b6a/b6ae13c3cfe37e16f820840f90231bff.jpg"
                    },
                    {
                        "text": "3/4 cup unsweetened nondairy milk",
                        "weight": 183,
                        "foodCategory": "Milk",
                        "foodId": "food_aldsn8sa3rioenar1lwhob4bpdj2",
                        "image": "https://www.edamam.com/food-img/694/6944c7790a123419b8500a7db252eb15.jpg"
                    },
                    {
                        "text": "1/3 cup nutritional yeast",
                        "weight": 85.33333333333333,
                        "foodCategory": "Vegan products",
                        "foodId": "food_abjagi2b7qlt18aryyugvbnm0tlu",
                        "image": null
                    },
                    {
                        "text": "1/4 cup tapioca flour",
                        "weight": 30,
                        "foodCategory": "grains",
                        "foodId": "food_a2j0fzta3x3yg9azedc0xb5wccng",
                        "image": "https://www.edamam.com/food-img/a30/a3063ea98ee3270b27743406d5536880.jpg"
                    },
                    {
                        "text": "1 teaspoon ground turmeric",
                        "weight": 3,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_bc3ig84amucgmwba3vixyatnyd9b",
                        "image": "https://www.edamam.com/food-img/03e/03eb469286b3caf1ae9c13e4eba13587.jpg"
                    },
                    {
                        "text": "1 teaspoon garlic powder",
                        "weight": 3.1,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_boq94r1a036492bdup9u1beyph0l",
                        "image": "https://www.edamam.com/food-img/5c3/5c3db1d5a1a16b1f0a74796f74dd5985.jpg"
                    },
                    {
                        "text": "1 teaspoon onion powder",
                        "weight": 2.4,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_bmv8z27b1o25vcbu41ooyawd2zj4",
                        "image": "https://www.edamam.com/food-img/1e7/1e73e6f5dd96bb233abc0fcc05fb0ec8.jpg"
                    },
                    {
                        "text": "1 teaspoon sea salt",
                        "weight": 4.854166666912875,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_a1vgrj1bs8rd1majvmd9ubz8ttkg",
                        "image": "https://www.edamam.com/food-img/694/6943ea510918c6025795e8dc6e6eaaeb.jpg"
                    },
                    {
                        "text": "1/2 teaspoon ground pepper",
                        "weight": 1.45,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_b6ywzluaaxv02wad7s1r9ag4py89",
                        "image": "https://www.edamam.com/food-img/c6e/c6e5c3bd8d3bc15175d9766971a4d1b2.jpg"
                    },
                    {
                        "text": "2 tablespoons finely chopped chives",
                        "weight": 6,
                        "foodCategory": "vegetables",
                        "foodId": "food_btg1uzjak79lawbirsitkaeai60l",
                        "image": "https://www.edamam.com/food-img/f3f/f3f48643a924ba174b894e979cb48620.jpg"
                    },
                    {
                        "text": "3 tablespoons vegan butter, for frying",
                        "weight": 40.8,
                        "foodCategory": "Oils",
                        "foodId": "food_bn7cczea5psahcbaqvd2ob43qksr",
                        "image": "https://www.edamam.com/food-img/330/3302cd340e3d2dcf7f02e72fdfe8b209.jpg"
                    },
                    {
                        "text": "5 English muffins, split in half",
                        "weight": 285,
                        "foodCategory": "bread, rolls and tortillas",
                        "foodId": "food_a2cnfomb05l36abpxyronby1slmi",
                        "image": "https://www.edamam.com/food-img/27b/27be1e4962864c7ac5ef87013879a352.jpg"
                    },
                    {
                        "text": "5 tablespoons vegan butter",
                        "weight": 68,
                        "foodCategory": "Oils",
                        "foodId": "food_bn7cczea5psahcbaqvd2ob43qksr",
                        "image": "https://www.edamam.com/food-img/330/3302cd340e3d2dcf7f02e72fdfe8b209.jpg"
                    },
                    {
                        "text": "5 vegan cheddar cheese slices",
                        "weight": 140,
                        "foodCategory": "Cheese",
                        "foodId": "food_bhppgmha1u27voagb8eptbp9g376",
                        "image": "https://www.edamam.com/food-img/bcd/bcd94dde1fcde1475b5bf0540f821c5d.jpg"
                    },
                    {
                        "text": "Cassava Bacon",
                        "weight": 0,
                        "foodCategory": "vegetables",
                        "foodId": "food_b3imt6vbxvc1xeaot5kwgbqn8uyt",
                        "image": "https://www.edamam.com/food-img/a3e/a3e1d2a45a123ff2393a75a20dc75d2b.jpg"
                    },
                    {
                        "text": "Cassava Bacon",
                        "weight": 0,
                        "foodCategory": "cured meats",
                        "foodId": "food_av0awb0bgs18qub01sd9kbx44b61",
                        "image": "https://www.edamam.com/food-img/d42/d426884a125fa39a70d5a5d7217864ec.jpg"
                    },
                    {
                        "text": "2 vine tomatoes, sliced thick",
                        "weight": 246,
                        "foodCategory": "vegetables",
                        "foodId": "food_a6k79rrahp8fe2b26zussa3wtkqh",
                        "image": "https://www.edamam.com/food-img/23e/23e727a14f1035bdc2733bb0477efbd2.jpg"
                    }
                ],
                "calories": 3008.1978256666666,
                "totalWeight": 1551.4016295339998,
                "totalTime": 0,
                "cuisineType": [
                    "american"
                ],
                "mealType": [
                    "breakfast"
                ],
                "dishType": [
                    "sandwiches"
                ],
                "totalNutrients": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 3008.1978256666666,
                        "unit": "kcal"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 190.291261829,
                        "unit": "g"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 139.5179891531,
                        "unit": "g"
                    },
                    "FATRN": {
                        "label": "Trans",
                        "quantity": 1.9318960000000003,
                        "unit": "g"
                    },
                    "FAMS": {
                        "label": "Monounsaturated",
                        "quantity": 18.874496956200005,
                        "unit": "g"
                    },
                    "FAPU": {
                        "label": "Polyunsaturated",
                        "quantity": 12.805496117799999,
                        "unit": "g"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 216.81922938633335,
                        "unit": "g"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 43.31931466333333,
                        "unit": "g"
                    },
                    "SUGAR": {
                        "label": "Sugars",
                        "quantity": 19.60038422,
                        "unit": "g"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 145.0343267696667,
                        "unit": "g"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 142.8,
                        "unit": "mg"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 3599.0888945876004,
                        "unit": "mg"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 2479.64138598816,
                        "unit": "mg"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 493.49493616200664,
                        "unit": "mg"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 2260.896281696054,
                        "unit": "mg"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 23.585277713462204,
                        "unit": "mg"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 30.703094263867335,
                        "unit": "mg"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 1745.7597677,
                        "unit": "mg"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 484.99150000000003,
                        "unit": "µg"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 38.71498474,
                        "unit": "mg"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 52.883724421999986,
                        "unit": "mg"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 53.66564419309999,
                        "unit": "mg"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 310.33350846036655,
                        "unit": "mg"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 52.119616082700006,
                        "unit": "mg"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 400.4720503,
                        "unit": "µg"
                    },
                    "FOLFD": {
                        "label": "Folate (food)",
                        "quantity": 280.7720503,
                        "unit": "µg"
                    },
                    "FOLAC": {
                        "label": "Folic acid",
                        "quantity": 1351.25,
                        "unit": "µg"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 42.78933333333333,
                        "unit": "µg"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 0.8400000000000001,
                        "unit": "µg"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 8.081369237,
                        "unit": "mg"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 79.18226688,
                        "unit": "µg"
                    },
                    "WATER": {
                        "label": "Water",
                        "quantity": 958.1066501674012,
                        "unit": "g"
                    }
                },
                "totalDaily": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 150.40989128333334,
                        "unit": "%"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 292.75578742923074,
                        "unit": "%"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 697.5899457654999,
                        "unit": "%"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 72.27307646211112,
                        "unit": "%"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 173.27725865333335,
                        "unit": "%"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 290.0686535393334,
                        "unit": "%"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 47.60000000000001,
                        "unit": "%"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 149.96203727448335,
                        "unit": "%"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 247.964138598816,
                        "unit": "%"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 117.49879432428729,
                        "unit": "%"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 48.10417620629902,
                        "unit": "%"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 131.02932063034558,
                        "unit": "%"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 279.1190387624303,
                        "unit": "%"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 249.39425252857143,
                        "unit": "%"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 53.88794444444444,
                        "unit": "%"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 43.016649711111114,
                        "unit": "%"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 4406.977035166666,
                        "unit": "%"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 4128.126476392307,
                        "unit": "%"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 1939.5844278772909,
                        "unit": "%"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 4009.201237130769,
                        "unit": "%"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 100.118012575,
                        "unit": "%"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 1782.888888888889,
                        "unit": "%"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 5.6000000000000005,
                        "unit": "%"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 53.87579491333334,
                        "unit": "%"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 65.9852224,
                        "unit": "%"
                    }
                },
                "digest": [
                    {
                        "label": "Fat",
                        "tag": "FAT",
                        "schemaOrgTag": "fatContent",
                        "total": 190.291261829,
                        "hasRDI": true,
                        "daily": 292.75578742923074,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Saturated",
                                "tag": "FASAT",
                                "schemaOrgTag": "saturatedFatContent",
                                "total": 139.5179891531,
                                "hasRDI": true,
                                "daily": 697.5899457654999,
                                "unit": "g"
                            },
                            {
                                "label": "Trans",
                                "tag": "FATRN",
                                "schemaOrgTag": "transFatContent",
                                "total": 1.9318960000000003,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Monounsaturated",
                                "tag": "FAMS",
                                "schemaOrgTag": null,
                                "total": 18.874496956200005,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Polyunsaturated",
                                "tag": "FAPU",
                                "schemaOrgTag": null,
                                "total": 12.805496117799999,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Carbs",
                        "tag": "CHOCDF",
                        "schemaOrgTag": "carbohydrateContent",
                        "total": 216.81922938633335,
                        "hasRDI": true,
                        "daily": 72.27307646211112,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Carbs (net)",
                                "tag": "CHOCDF.net",
                                "schemaOrgTag": null,
                                "total": 173.49991472300002,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Fiber",
                                "tag": "FIBTG",
                                "schemaOrgTag": "fiberContent",
                                "total": 43.31931466333333,
                                "hasRDI": true,
                                "daily": 173.27725865333335,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars",
                                "tag": "SUGAR",
                                "schemaOrgTag": "sugarContent",
                                "total": 19.60038422,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars, added",
                                "tag": "SUGAR.added",
                                "schemaOrgTag": null,
                                "total": 0,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Protein",
                        "tag": "PROCNT",
                        "schemaOrgTag": "proteinContent",
                        "total": 145.0343267696667,
                        "hasRDI": true,
                        "daily": 290.0686535393334,
                        "unit": "g"
                    },
                    {
                        "label": "Cholesterol",
                        "tag": "CHOLE",
                        "schemaOrgTag": "cholesterolContent",
                        "total": 142.8,
                        "hasRDI": true,
                        "daily": 47.60000000000001,
                        "unit": "mg"
                    },
                    {
                        "label": "Sodium",
                        "tag": "NA",
                        "schemaOrgTag": "sodiumContent",
                        "total": 3599.0888945876004,
                        "hasRDI": true,
                        "daily": 149.96203727448335,
                        "unit": "mg"
                    },
                    {
                        "label": "Calcium",
                        "tag": "CA",
                        "schemaOrgTag": null,
                        "total": 2479.64138598816,
                        "hasRDI": true,
                        "daily": 247.964138598816,
                        "unit": "mg"
                    },
                    {
                        "label": "Magnesium",
                        "tag": "MG",
                        "schemaOrgTag": null,
                        "total": 493.49493616200664,
                        "hasRDI": true,
                        "daily": 117.49879432428729,
                        "unit": "mg"
                    },
                    {
                        "label": "Potassium",
                        "tag": "K",
                        "schemaOrgTag": null,
                        "total": 2260.896281696054,
                        "hasRDI": true,
                        "daily": 48.10417620629902,
                        "unit": "mg"
                    },
                    {
                        "label": "Iron",
                        "tag": "FE",
                        "schemaOrgTag": null,
                        "total": 23.585277713462204,
                        "hasRDI": true,
                        "daily": 131.02932063034558,
                        "unit": "mg"
                    },
                    {
                        "label": "Zinc",
                        "tag": "ZN",
                        "schemaOrgTag": null,
                        "total": 30.703094263867335,
                        "hasRDI": true,
                        "daily": 279.1190387624303,
                        "unit": "mg"
                    },
                    {
                        "label": "Phosphorus",
                        "tag": "P",
                        "schemaOrgTag": null,
                        "total": 1745.7597677,
                        "hasRDI": true,
                        "daily": 249.39425252857143,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin A",
                        "tag": "VITA_RAE",
                        "schemaOrgTag": null,
                        "total": 484.99150000000003,
                        "hasRDI": true,
                        "daily": 53.88794444444444,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin C",
                        "tag": "VITC",
                        "schemaOrgTag": null,
                        "total": 38.71498474,
                        "hasRDI": true,
                        "daily": 43.016649711111114,
                        "unit": "mg"
                    },
                    {
                        "label": "Thiamin (B1)",
                        "tag": "THIA",
                        "schemaOrgTag": null,
                        "total": 52.883724421999986,
                        "hasRDI": true,
                        "daily": 4406.977035166666,
                        "unit": "mg"
                    },
                    {
                        "label": "Riboflavin (B2)",
                        "tag": "RIBF",
                        "schemaOrgTag": null,
                        "total": 53.66564419309999,
                        "hasRDI": true,
                        "daily": 4128.126476392307,
                        "unit": "mg"
                    },
                    {
                        "label": "Niacin (B3)",
                        "tag": "NIA",
                        "schemaOrgTag": null,
                        "total": 310.33350846036655,
                        "hasRDI": true,
                        "daily": 1939.5844278772909,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin B6",
                        "tag": "VITB6A",
                        "schemaOrgTag": null,
                        "total": 52.119616082700006,
                        "hasRDI": true,
                        "daily": 4009.201237130769,
                        "unit": "mg"
                    },
                    {
                        "label": "Folate equivalent (total)",
                        "tag": "FOLDFE",
                        "schemaOrgTag": null,
                        "total": 400.4720503,
                        "hasRDI": true,
                        "daily": 100.118012575,
                        "unit": "µg"
                    },
                    {
                        "label": "Folate (food)",
                        "tag": "FOLFD",
                        "schemaOrgTag": null,
                        "total": 280.7720503,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Folic acid",
                        "tag": "FOLAC",
                        "schemaOrgTag": null,
                        "total": 1351.25,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin B12",
                        "tag": "VITB12",
                        "schemaOrgTag": null,
                        "total": 42.78933333333333,
                        "hasRDI": true,
                        "daily": 1782.888888888889,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin D",
                        "tag": "VITD",
                        "schemaOrgTag": null,
                        "total": 0.8400000000000001,
                        "hasRDI": true,
                        "daily": 5.6000000000000005,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin E",
                        "tag": "TOCPHA",
                        "schemaOrgTag": null,
                        "total": 8.081369237,
                        "hasRDI": true,
                        "daily": 53.87579491333334,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin K",
                        "tag": "VITK1",
                        "schemaOrgTag": null,
                        "total": 79.18226688,
                        "hasRDI": true,
                        "daily": 65.9852224,
                        "unit": "µg"
                    },
                    {
                        "label": "Sugar alcohols",
                        "tag": "Sugar.alcohol",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    },
                    {
                        "label": "Water",
                        "tag": "WATER",
                        "schemaOrgTag": null,
                        "total": 958.1066501674012,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    }
                ]
            },
            "_links": {
                "self": {
                    "href": "https://api.edamam.com/api/recipes/v2/9559557a0cc426dfd7d7aca79a0bce98?type=public&app_id=ea1d37d5&app_key=fd382a172ba8d6668c0430dc9c14a181",
                    "title": "Self"
                }
            }
        },
        {
            "recipe": {
                "uri": "http://www.edamam.com/ontologies/edamam.owl#recipe_c88419507e9b9f4e963b4b0df3e4c1e1",
                "label": "{Vegan} Peanut Butter & Honey Muffins recipes",
                "image": "https://www.edamam.com/web-img/389/389330863fe0a761d97a1b138e00bb0d",
                "source": "Pinch of Yum",
                "url": "http://pinchofyum.com/peanut-butter-honey-muffins",
                "shareAs": "http://www.edamam.com/recipe/vegan-peanut-butter-honey-muffins-recipes-c88419507e9b9f4e963b4b0df3e4c1e1/vegan",
                "yield": 6,
                "dietLabels": [
                    "Low-Sodium"
                ],
                "healthLabels": [
                    "Low Potassium",
                    "Kidney-Friendly",
                    "Vegetarian",
                    "Pescatarian",
                    "Egg-Free",
                    "Fish-Free",
                    "Shellfish-Free",
                    "Pork-Free",
                    "Red-Meat-Free",
                    "Crustacean-Free",
                    "Celery-Free",
                    "Mustard-Free",
                    "Sesame-Free",
                    "Lupine-Free",
                    "Mollusk-Free",
                    "Alcohol-Free",
                    "Kosher"
                ],
                "cautions": [
                    "Sulfites"
                ],
                "ingredientLines": [
                    "1 cup flour",
                    "1½ teaspoons baking powder",
                    "pinch of salt",
                    "3 tablespoons peanut butter (crunchy or smooth)",
                    "2 tablespoons oil",
                    "3 tablespoons honey (agave nectar if vegan)",
                    "¾ cup milk (almond, soy, etc. if vegan)"
                ],
                "ingredients": [
                    {
                        "text": "1 cup flour",
                        "weight": 125,
                        "foodCategory": "grains",
                        "foodId": "food_ahebfs0a985an4aubqaebbipra58",
                        "image": "https://www.edamam.com/food-img/b4c/b4c739e76a6f2172b7ad49d0aa41d5aa.jpg"
                    },
                    {
                        "text": "1½ teaspoons baking powder",
                        "weight": 6.8999999999999995,
                        "foodCategory": "condiments and sauces",
                        "foodId": "food_bad4zycbt4w60dbut111vaub2g3e",
                        "image": "https://www.edamam.com/food-img/a84/a8410ec57a2e62a1ad9955ac14d40af6.jpg"
                    },
                    {
                        "text": "pinch of salt",
                        "weight": 0.380208333815447,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_btxz81db72hwbra2pncvebzzzum9",
                        "image": "https://www.edamam.com/food-img/694/6943ea510918c6025795e8dc6e6eaaeb.jpg"
                    },
                    {
                        "text": "3 tablespoons peanut butter (crunchy or smooth)",
                        "weight": 48,
                        "foodCategory": "plant-based protein",
                        "foodId": "food_bz6b8fsbccyn3zaij72f7av8dl9m",
                        "image": "https://www.edamam.com/food-img/d74/d740276ae1409472a8714b2cee88a310.jpg"
                    },
                    {
                        "text": "2 tablespoons oil",
                        "weight": 28,
                        "foodCategory": "Oils",
                        "foodId": "food_bk9p9aaavhvoq4bqsnprobpsiuxs",
                        "image": "https://www.edamam.com/food-img/07e/07e106ab3536d57428e5c46d009038f8.jpg"
                    },
                    {
                        "text": "3 tablespoons honey (agave nectar if vegan)",
                        "weight": 63,
                        "foodCategory": null,
                        "foodId": "food_bn6aoj9atkqx8fbkli859bbbxx62",
                        "image": "https://www.edamam.com/food-img/198/198c7b25c23b4235b4cc33818c7b335f.jpg"
                    },
                    {
                        "text": "¾ cup milk (almond, soy, etc. if vegan)",
                        "weight": 183,
                        "foodCategory": "Milk",
                        "foodId": "food_b49rs1kaw0jktabzkg2vvanvvsis",
                        "image": "https://www.edamam.com/food-img/7c9/7c9962acf83654a8d98ea6a2ade93735.jpg"
                    }
                ],
                "calories": 1296.229,
                "totalWeight": 454.2802083338155,
                "totalTime": 25,
                "cuisineType": [
                    "american"
                ],
                "mealType": [
                    "lunch/dinner"
                ],
                "dishType": [
                    "desserts"
                ],
                "totalNutrients": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 1296.229,
                        "unit": "kcal"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 59.825300000000006,
                        "unit": "g"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 10.6249,
                        "unit": "g"
                    },
                    "FATRN": {
                        "label": "Trans",
                        "quantity": 0.1466,
                        "unit": "g"
                    },
                    "FAMS": {
                        "label": "Monounsaturated",
                        "quantity": 31.76367,
                        "unit": "g"
                    },
                    "FAPU": {
                        "label": "Polyunsaturated",
                        "quantity": 14.76966,
                        "unit": "g"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 168.4552,
                        "unit": "g"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 5.9148000000000005,
                        "unit": "g"
                    },
                    "SUGAR": {
                        "label": "Sugars",
                        "quantity": 66.3498,
                        "unit": "g"
                    },
                    "SUGAR.added": {
                        "label": "Sugars, added",
                        "quantity": 51.735600000000005,
                        "unit": "g"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 29.533699999999996,
                        "unit": "g"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 18.3,
                        "unit": "mg"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 783.8481460201908,
                        "unit": "mg"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 761.0472500001156,
                        "unit": "mg"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 130.39480208333816,
                        "unit": "mg"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 676.2854166667053,
                        "unit": "mg"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 3.396084687501591,
                        "unit": "mg"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 2.8972602083338153,
                        "unit": "mg"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 1136.3819999999998,
                        "unit": "mg"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 84.18,
                        "unit": "µg"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 0.315,
                        "unit": "mg"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 0.30618,
                        "unit": "mg"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 0.47537000000000007,
                        "unit": "mg"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 8.09536,
                        "unit": "mg"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 0.34768000000000004,
                        "unit": "mg"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 84.67,
                        "unit": "µg"
                    },
                    "FOLFD": {
                        "label": "Folate (food)",
                        "quantity": 84.67,
                        "unit": "µg"
                    },
                    "FOLAC": {
                        "label": "Folic acid",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 0.8235,
                        "unit": "µg"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 2.379,
                        "unit": "µg"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 9.459900000000001,
                        "unit": "mg"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 21.032,
                        "unit": "µg"
                    },
                    "WATER": {
                        "label": "Water",
                        "quantity": 187.8180604166676,
                        "unit": "g"
                    }
                },
                "totalDaily": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 64.81145000000001,
                        "unit": "%"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 92.03892307692308,
                        "unit": "%"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 53.1245,
                        "unit": "%"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 56.15173333333333,
                        "unit": "%"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 23.659200000000002,
                        "unit": "%"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 59.06739999999999,
                        "unit": "%"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 6.1,
                        "unit": "%"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 32.66033941750795,
                        "unit": "%"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 76.10472500001156,
                        "unit": "%"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 31.046381448413847,
                        "unit": "%"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 14.389051418440538,
                        "unit": "%"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 18.867137152786615,
                        "unit": "%"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 26.338729166671047,
                        "unit": "%"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 162.3402857142857,
                        "unit": "%"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 9.353333333333333,
                        "unit": "%"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 0.35,
                        "unit": "%"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 25.515000000000004,
                        "unit": "%"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 36.56692307692308,
                        "unit": "%"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 50.596,
                        "unit": "%"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 26.74461538461539,
                        "unit": "%"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 21.1675,
                        "unit": "%"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 34.3125,
                        "unit": "%"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 15.860000000000001,
                        "unit": "%"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 63.06600000000001,
                        "unit": "%"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 17.526666666666664,
                        "unit": "%"
                    }
                },
                "digest": [
                    {
                        "label": "Fat",
                        "tag": "FAT",
                        "schemaOrgTag": "fatContent",
                        "total": 59.825300000000006,
                        "hasRDI": true,
                        "daily": 92.03892307692308,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Saturated",
                                "tag": "FASAT",
                                "schemaOrgTag": "saturatedFatContent",
                                "total": 10.6249,
                                "hasRDI": true,
                                "daily": 53.1245,
                                "unit": "g"
                            },
                            {
                                "label": "Trans",
                                "tag": "FATRN",
                                "schemaOrgTag": "transFatContent",
                                "total": 0.1466,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Monounsaturated",
                                "tag": "FAMS",
                                "schemaOrgTag": null,
                                "total": 31.76367,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Polyunsaturated",
                                "tag": "FAPU",
                                "schemaOrgTag": null,
                                "total": 14.76966,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Carbs",
                        "tag": "CHOCDF",
                        "schemaOrgTag": "carbohydrateContent",
                        "total": 168.4552,
                        "hasRDI": true,
                        "daily": 56.15173333333333,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Carbs (net)",
                                "tag": "CHOCDF.net",
                                "schemaOrgTag": null,
                                "total": 162.54039999999998,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Fiber",
                                "tag": "FIBTG",
                                "schemaOrgTag": "fiberContent",
                                "total": 5.9148000000000005,
                                "hasRDI": true,
                                "daily": 23.659200000000002,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars",
                                "tag": "SUGAR",
                                "schemaOrgTag": "sugarContent",
                                "total": 66.3498,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars, added",
                                "tag": "SUGAR.added",
                                "schemaOrgTag": null,
                                "total": 51.735600000000005,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Protein",
                        "tag": "PROCNT",
                        "schemaOrgTag": "proteinContent",
                        "total": 29.533699999999996,
                        "hasRDI": true,
                        "daily": 59.06739999999999,
                        "unit": "g"
                    },
                    {
                        "label": "Cholesterol",
                        "tag": "CHOLE",
                        "schemaOrgTag": "cholesterolContent",
                        "total": 18.3,
                        "hasRDI": true,
                        "daily": 6.1,
                        "unit": "mg"
                    },
                    {
                        "label": "Sodium",
                        "tag": "NA",
                        "schemaOrgTag": "sodiumContent",
                        "total": 783.8481460201908,
                        "hasRDI": true,
                        "daily": 32.66033941750795,
                        "unit": "mg"
                    },
                    {
                        "label": "Calcium",
                        "tag": "CA",
                        "schemaOrgTag": null,
                        "total": 761.0472500001156,
                        "hasRDI": true,
                        "daily": 76.10472500001156,
                        "unit": "mg"
                    },
                    {
                        "label": "Magnesium",
                        "tag": "MG",
                        "schemaOrgTag": null,
                        "total": 130.39480208333816,
                        "hasRDI": true,
                        "daily": 31.046381448413847,
                        "unit": "mg"
                    },
                    {
                        "label": "Potassium",
                        "tag": "K",
                        "schemaOrgTag": null,
                        "total": 676.2854166667053,
                        "hasRDI": true,
                        "daily": 14.389051418440538,
                        "unit": "mg"
                    },
                    {
                        "label": "Iron",
                        "tag": "FE",
                        "schemaOrgTag": null,
                        "total": 3.396084687501591,
                        "hasRDI": true,
                        "daily": 18.867137152786615,
                        "unit": "mg"
                    },
                    {
                        "label": "Zinc",
                        "tag": "ZN",
                        "schemaOrgTag": null,
                        "total": 2.8972602083338153,
                        "hasRDI": true,
                        "daily": 26.338729166671047,
                        "unit": "mg"
                    },
                    {
                        "label": "Phosphorus",
                        "tag": "P",
                        "schemaOrgTag": null,
                        "total": 1136.3819999999998,
                        "hasRDI": true,
                        "daily": 162.3402857142857,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin A",
                        "tag": "VITA_RAE",
                        "schemaOrgTag": null,
                        "total": 84.18,
                        "hasRDI": true,
                        "daily": 9.353333333333333,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin C",
                        "tag": "VITC",
                        "schemaOrgTag": null,
                        "total": 0.315,
                        "hasRDI": true,
                        "daily": 0.35,
                        "unit": "mg"
                    },
                    {
                        "label": "Thiamin (B1)",
                        "tag": "THIA",
                        "schemaOrgTag": null,
                        "total": 0.30618,
                        "hasRDI": true,
                        "daily": 25.515000000000004,
                        "unit": "mg"
                    },
                    {
                        "label": "Riboflavin (B2)",
                        "tag": "RIBF",
                        "schemaOrgTag": null,
                        "total": 0.47537000000000007,
                        "hasRDI": true,
                        "daily": 36.56692307692308,
                        "unit": "mg"
                    },
                    {
                        "label": "Niacin (B3)",
                        "tag": "NIA",
                        "schemaOrgTag": null,
                        "total": 8.09536,
                        "hasRDI": true,
                        "daily": 50.596,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin B6",
                        "tag": "VITB6A",
                        "schemaOrgTag": null,
                        "total": 0.34768000000000004,
                        "hasRDI": true,
                        "daily": 26.74461538461539,
                        "unit": "mg"
                    },
                    {
                        "label": "Folate equivalent (total)",
                        "tag": "FOLDFE",
                        "schemaOrgTag": null,
                        "total": 84.67,
                        "hasRDI": true,
                        "daily": 21.1675,
                        "unit": "µg"
                    },
                    {
                        "label": "Folate (food)",
                        "tag": "FOLFD",
                        "schemaOrgTag": null,
                        "total": 84.67,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Folic acid",
                        "tag": "FOLAC",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin B12",
                        "tag": "VITB12",
                        "schemaOrgTag": null,
                        "total": 0.8235,
                        "hasRDI": true,
                        "daily": 34.3125,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin D",
                        "tag": "VITD",
                        "schemaOrgTag": null,
                        "total": 2.379,
                        "hasRDI": true,
                        "daily": 15.860000000000001,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin E",
                        "tag": "TOCPHA",
                        "schemaOrgTag": null,
                        "total": 9.459900000000001,
                        "hasRDI": true,
                        "daily": 63.06600000000001,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin K",
                        "tag": "VITK1",
                        "schemaOrgTag": null,
                        "total": 21.032,
                        "hasRDI": true,
                        "daily": 17.526666666666664,
                        "unit": "µg"
                    },
                    {
                        "label": "Sugar alcohols",
                        "tag": "Sugar.alcohol",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    },
                    {
                        "label": "Water",
                        "tag": "WATER",
                        "schemaOrgTag": null,
                        "total": 187.8180604166676,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    }
                ]
            },
            "_links": {
                "self": {
                    "href": "https://api.edamam.com/api/recipes/v2/c88419507e9b9f4e963b4b0df3e4c1e1?type=public&app_id=ea1d37d5&app_key=fd382a172ba8d6668c0430dc9c14a181",
                    "title": "Self"
                }
            }
        },
        {
            "recipe": {
                "uri": "http://www.edamam.com/ontologies/edamam.owl#recipe_32d874b63d84dd76081f024ae98caa14",
                "label": "Vegan Pots de Crème",
                "image": "https://www.edamam.com/web-img/77d/77da20635b276eda8615dfd197efdccf.jpg",
                "source": "PBS Food",
                "url": "http://www.pbs.org/food/recipes/pots-de-creme/",
                "shareAs": "http://www.edamam.com/recipe/vegan-pots-de-cr%C3%A8me-32d874b63d84dd76081f024ae98caa14/vegan",
                "yield": 6,
                "dietLabels": [
                    "Low-Sodium"
                ],
                "healthLabels": [
                    "Vegetarian",
                    "Pescatarian",
                    "Gluten-Free",
                    "Wheat-Free",
                    "Egg-Free",
                    "Peanut-Free",
                    "Tree-Nut-Free",
                    "Fish-Free",
                    "Shellfish-Free",
                    "Pork-Free",
                    "Red-Meat-Free",
                    "Crustacean-Free",
                    "Celery-Free",
                    "Mustard-Free",
                    "Sesame-Free",
                    "Lupine-Free",
                    "Mollusk-Free",
                    "Alcohol-Free",
                    "Kosher"
                ],
                "cautions": [
                    "Gluten",
                    "Wheat",
                    "Sulfites"
                ],
                "ingredientLines": [
                    "3⁄4 cup vanilla nondairy milk",
                    "12 ounces soft regular or silken tofu, drained and cubed",
                    "2 teaspoons brown sugar",
                    "1 cup vegan dark chocolate chips"
                ],
                "ingredients": [
                    {
                        "text": "3⁄4 cup vanilla nondairy milk",
                        "weight": 183,
                        "foodCategory": "Milk",
                        "foodId": "food_aldsn8sa3rioenar1lwhob4bpdj2",
                        "image": "https://www.edamam.com/food-img/694/6944c7790a123419b8500a7db252eb15.jpg"
                    },
                    {
                        "text": "12 ounces soft regular or silken tofu, drained and cubed",
                        "weight": 340.1942775,
                        "foodCategory": "plant-based protein",
                        "foodId": "food_a269ixea1yf51xbfwgnq2boiwc7x",
                        "image": "https://www.edamam.com/food-img/b6a/b6ae13c3cfe37e16f820840f90231bff.jpg"
                    },
                    {
                        "text": "2 teaspoons brown sugar",
                        "weight": 6,
                        "foodCategory": "sugars",
                        "foodId": "food_aodgtqwbmeu5f6bxeffn0art3bga",
                        "image": "https://www.edamam.com/food-img/8c6/8c6662bd73900645c6385b51a95d9b03.jpg"
                    },
                    {
                        "text": "1 cup vegan dark chocolate chips",
                        "weight": 182,
                        "foodCategory": "chocolate",
                        "foodId": "food_afwurvlasugs4ibig02xbblph5bn",
                        "image": "https://www.edamam.com/food-img/3cf/3cf0e13350f43392dc13c07d27ad145d.jpg"
                    }
                ],
                "calories": 1460.9259942500003,
                "totalWeight": 711.1942775,
                "totalTime": 172,
                "cuisineType": [
                    "american"
                ],
                "mealType": [
                    "lunch/dinner"
                ],
                "dishType": [
                    "desserts"
                ],
                "totalNutrients": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 1460.9259942500003,
                        "unit": "kcal"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 98.01300137175001,
                        "unit": "g"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 53.063566614825,
                        "unit": "g"
                    },
                    "FATRN": {
                        "label": "Trans",
                        "quantity": 0.0546,
                        "unit": "g"
                    },
                    "FAMS": {
                        "label": "Monounsaturated",
                        "quantity": 27.75428184215,
                        "unit": "g"
                    },
                    "FAPU": {
                        "label": "Polyunsaturated",
                        "quantity": 8.40546533835,
                        "unit": "g"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 106.44548328975,
                        "unit": "g"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 22.899748497500003,
                        "unit": "g"
                    },
                    "SUGAR": {
                        "label": "Sugars",
                        "quantity": 51.524165665,
                        "unit": "g"
                    },
                    "SUGAR.added": {
                        "label": "Sugars, added",
                        "quantity": 49.483,
                        "unit": "g"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 45.24941132725,
                        "unit": "g"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 5.46,
                        "unit": "mg"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 221.64331330000002,
                        "unit": "mg"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 882.0204977750001,
                        "unit": "mg"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 552.3518826750001,
                        "unit": "mg"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 2021.3875307,
                        "unit": "mg"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 27.891427867750004,
                        "unit": "mg"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 11.009012503250002,
                        "unit": "mg"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 1107.855075775,
                        "unit": "mg"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 3.64,
                        "unit": "µg"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 0.6803885550000001,
                        "unit": "mg"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 0.2879565665,
                        "unit": "mg"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 0.517322394825,
                        "unit": "mg"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 2.268476220275,
                        "unit": "mg"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 0.31315793702499994,
                        "unit": "mg"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 64.696912725,
                        "unit": "µg"
                    },
                    "FOLFD": {
                        "label": "Folate (food)",
                        "quantity": 64.696912725,
                        "unit": "µg"
                    },
                    "FOLAC": {
                        "label": "Folic acid",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 0.5096,
                        "unit": "µg"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 1.1078194277500002,
                        "unit": "mg"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 21.45066266,
                        "unit": "µg"
                    },
                    "WATER": {
                        "label": "Water",
                        "quantity": 452.93823873625,
                        "unit": "g"
                    }
                },
                "totalDaily": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 73.04629971250002,
                        "unit": "%"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 150.7892328796154,
                        "unit": "%"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 265.317833074125,
                        "unit": "%"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 35.48182776325,
                        "unit": "%"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 91.59899399000001,
                        "unit": "%"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 90.4988226545,
                        "unit": "%"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 1.82,
                        "unit": "%"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 9.235138054166667,
                        "unit": "%"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 88.20204977750001,
                        "unit": "%"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 131.51235301785715,
                        "unit": "%"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 43.008245334042556,
                        "unit": "%"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 154.95237704305558,
                        "unit": "%"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 100.08193184772728,
                        "unit": "%"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 158.265010825,
                        "unit": "%"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 0.40444444444444444,
                        "unit": "%"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 0.7559872833333334,
                        "unit": "%"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 23.996380541666667,
                        "unit": "%"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 39.794030371153845,
                        "unit": "%"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 14.177976376718751,
                        "unit": "%"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 24.08907207884615,
                        "unit": "%"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 16.17422818125,
                        "unit": "%"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 21.233333333333338,
                        "unit": "%"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 0,
                        "unit": "%"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 7.385462851666668,
                        "unit": "%"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 17.875552216666666,
                        "unit": "%"
                    }
                },
                "digest": [
                    {
                        "label": "Fat",
                        "tag": "FAT",
                        "schemaOrgTag": "fatContent",
                        "total": 98.01300137175001,
                        "hasRDI": true,
                        "daily": 150.7892328796154,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Saturated",
                                "tag": "FASAT",
                                "schemaOrgTag": "saturatedFatContent",
                                "total": 53.063566614825,
                                "hasRDI": true,
                                "daily": 265.317833074125,
                                "unit": "g"
                            },
                            {
                                "label": "Trans",
                                "tag": "FATRN",
                                "schemaOrgTag": "transFatContent",
                                "total": 0.0546,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Monounsaturated",
                                "tag": "FAMS",
                                "schemaOrgTag": null,
                                "total": 27.75428184215,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Polyunsaturated",
                                "tag": "FAPU",
                                "schemaOrgTag": null,
                                "total": 8.40546533835,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Carbs",
                        "tag": "CHOCDF",
                        "schemaOrgTag": "carbohydrateContent",
                        "total": 106.44548328975,
                        "hasRDI": true,
                        "daily": 35.48182776325,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Carbs (net)",
                                "tag": "CHOCDF.net",
                                "schemaOrgTag": null,
                                "total": 83.54573479225,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Fiber",
                                "tag": "FIBTG",
                                "schemaOrgTag": "fiberContent",
                                "total": 22.899748497500003,
                                "hasRDI": true,
                                "daily": 91.59899399000001,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars",
                                "tag": "SUGAR",
                                "schemaOrgTag": "sugarContent",
                                "total": 51.524165665,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars, added",
                                "tag": "SUGAR.added",
                                "schemaOrgTag": null,
                                "total": 49.483,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Protein",
                        "tag": "PROCNT",
                        "schemaOrgTag": "proteinContent",
                        "total": 45.24941132725,
                        "hasRDI": true,
                        "daily": 90.4988226545,
                        "unit": "g"
                    },
                    {
                        "label": "Cholesterol",
                        "tag": "CHOLE",
                        "schemaOrgTag": "cholesterolContent",
                        "total": 5.46,
                        "hasRDI": true,
                        "daily": 1.82,
                        "unit": "mg"
                    },
                    {
                        "label": "Sodium",
                        "tag": "NA",
                        "schemaOrgTag": "sodiumContent",
                        "total": 221.64331330000002,
                        "hasRDI": true,
                        "daily": 9.235138054166667,
                        "unit": "mg"
                    },
                    {
                        "label": "Calcium",
                        "tag": "CA",
                        "schemaOrgTag": null,
                        "total": 882.0204977750001,
                        "hasRDI": true,
                        "daily": 88.20204977750001,
                        "unit": "mg"
                    },
                    {
                        "label": "Magnesium",
                        "tag": "MG",
                        "schemaOrgTag": null,
                        "total": 552.3518826750001,
                        "hasRDI": true,
                        "daily": 131.51235301785715,
                        "unit": "mg"
                    },
                    {
                        "label": "Potassium",
                        "tag": "K",
                        "schemaOrgTag": null,
                        "total": 2021.3875307,
                        "hasRDI": true,
                        "daily": 43.008245334042556,
                        "unit": "mg"
                    },
                    {
                        "label": "Iron",
                        "tag": "FE",
                        "schemaOrgTag": null,
                        "total": 27.891427867750004,
                        "hasRDI": true,
                        "daily": 154.95237704305558,
                        "unit": "mg"
                    },
                    {
                        "label": "Zinc",
                        "tag": "ZN",
                        "schemaOrgTag": null,
                        "total": 11.009012503250002,
                        "hasRDI": true,
                        "daily": 100.08193184772728,
                        "unit": "mg"
                    },
                    {
                        "label": "Phosphorus",
                        "tag": "P",
                        "schemaOrgTag": null,
                        "total": 1107.855075775,
                        "hasRDI": true,
                        "daily": 158.265010825,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin A",
                        "tag": "VITA_RAE",
                        "schemaOrgTag": null,
                        "total": 3.64,
                        "hasRDI": true,
                        "daily": 0.40444444444444444,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin C",
                        "tag": "VITC",
                        "schemaOrgTag": null,
                        "total": 0.6803885550000001,
                        "hasRDI": true,
                        "daily": 0.7559872833333334,
                        "unit": "mg"
                    },
                    {
                        "label": "Thiamin (B1)",
                        "tag": "THIA",
                        "schemaOrgTag": null,
                        "total": 0.2879565665,
                        "hasRDI": true,
                        "daily": 23.996380541666667,
                        "unit": "mg"
                    },
                    {
                        "label": "Riboflavin (B2)",
                        "tag": "RIBF",
                        "schemaOrgTag": null,
                        "total": 0.517322394825,
                        "hasRDI": true,
                        "daily": 39.794030371153845,
                        "unit": "mg"
                    },
                    {
                        "label": "Niacin (B3)",
                        "tag": "NIA",
                        "schemaOrgTag": null,
                        "total": 2.268476220275,
                        "hasRDI": true,
                        "daily": 14.177976376718751,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin B6",
                        "tag": "VITB6A",
                        "schemaOrgTag": null,
                        "total": 0.31315793702499994,
                        "hasRDI": true,
                        "daily": 24.08907207884615,
                        "unit": "mg"
                    },
                    {
                        "label": "Folate equivalent (total)",
                        "tag": "FOLDFE",
                        "schemaOrgTag": null,
                        "total": 64.696912725,
                        "hasRDI": true,
                        "daily": 16.17422818125,
                        "unit": "µg"
                    },
                    {
                        "label": "Folate (food)",
                        "tag": "FOLFD",
                        "schemaOrgTag": null,
                        "total": 64.696912725,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Folic acid",
                        "tag": "FOLAC",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin B12",
                        "tag": "VITB12",
                        "schemaOrgTag": null,
                        "total": 0.5096,
                        "hasRDI": true,
                        "daily": 21.233333333333338,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin D",
                        "tag": "VITD",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": true,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin E",
                        "tag": "TOCPHA",
                        "schemaOrgTag": null,
                        "total": 1.1078194277500002,
                        "hasRDI": true,
                        "daily": 7.385462851666668,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin K",
                        "tag": "VITK1",
                        "schemaOrgTag": null,
                        "total": 21.45066266,
                        "hasRDI": true,
                        "daily": 17.875552216666666,
                        "unit": "µg"
                    },
                    {
                        "label": "Sugar alcohols",
                        "tag": "Sugar.alcohol",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    },
                    {
                        "label": "Water",
                        "tag": "WATER",
                        "schemaOrgTag": null,
                        "total": 452.93823873625,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    }
                ]
            },
            "_links": {
                "self": {
                    "href": "https://api.edamam.com/api/recipes/v2/32d874b63d84dd76081f024ae98caa14?type=public&app_id=ea1d37d5&app_key=fd382a172ba8d6668c0430dc9c14a181",
                    "title": "Self"
                }
            }
        },
        {
            "recipe": {
                "uri": "http://www.edamam.com/ontologies/edamam.owl#recipe_c827bdb9611f72ccf8c235dc6986e928",
                "label": "Vegan Macaroni Salad",
                "image": "https://www.edamam.com/web-img/57b/57b5d98c7ce021814a0b625018a48460",
                "source": "EatingWell",
                "url": "http://www.eatingwell.com/recipe/278403/vegan-macaroni-salad/",
                "shareAs": "http://www.edamam.com/recipe/vegan-macaroni-salad-c827bdb9611f72ccf8c235dc6986e928/vegan",
                "yield": 8,
                "dietLabels": [
                    "Balanced"
                ],
                "healthLabels": [
                    "Sugar-Conscious",
                    "Kidney-Friendly",
                    "Vegan",
                    "Vegetarian",
                    "Pescatarian",
                    "Dairy-Free",
                    "Egg-Free",
                    "Peanut-Free",
                    "Tree-Nut-Free",
                    "Soy-Free",
                    "Fish-Free",
                    "Shellfish-Free",
                    "Pork-Free",
                    "Red-Meat-Free",
                    "Crustacean-Free",
                    "Sesame-Free",
                    "Lupine-Free",
                    "Mollusk-Free",
                    "Alcohol-Free",
                    "Sulfite-Free",
                    "Kosher"
                ],
                "cautions": [
                    "Soy",
                    "Sulfites",
                    "FODMAP"
                ],
                "ingredientLines": [
                    "1 ½ cups whole-wheat elbow macaroni (about 6 ounces)",
                    "1 ½ cups frozen peas, thawed",
                    "1 cup thinly sliced celery",
                    "½ cup diced red bell pepper",
                    "⅓ cup thinly sliced scallions",
                    "½ cup vegan mayonnaise",
                    "1 teaspoon grated lemon zest",
                    "2 tablespoons lemon juice",
                    "¾ teaspoon salt",
                    "¼ teaspoon ground pepper"
                ],
                "ingredients": [
                    {
                        "text": "1 ½ cups whole-wheat elbow macaroni (about 6 ounces)",
                        "weight": 170.09713875,
                        "foodCategory": "grains",
                        "foodId": "food_a8hs60uayl5icia1qe8qoba1kwp8",
                        "image": "https://www.edamam.com/food-img/296/296ff2b02ef3822928c3c923e22c7d19.jpg"
                    },
                    {
                        "text": "1 ½ cups frozen peas, thawed",
                        "weight": 201,
                        "foodCategory": "vegetables",
                        "foodId": "food_aqrct01b4nxw5eaxoo8woaxc3xd7",
                        "image": "https://www.edamam.com/food-img/c91/c9130a361d5c5b279bf48c69e2466ec2.jpg"
                    },
                    {
                        "text": "1 cup thinly sliced celery",
                        "weight": 101,
                        "foodCategory": "vegetables",
                        "foodId": "food_bffeoksbyyur8ja4da73ub2xs57g",
                        "image": "https://www.edamam.com/food-img/d91/d91d2aed1c36d8fad54c4d7dc58f5a18.jpg"
                    },
                    {
                        "text": "½ cup diced red bell pepper",
                        "weight": 74.5,
                        "foodCategory": "vegetables",
                        "foodId": "food_a8g63g7ak6bnmvbu7agxibp4a0dy",
                        "image": "https://www.edamam.com/food-img/4dc/4dc48b1a506d334b4ab6671b9d56a18f.jpeg"
                    },
                    {
                        "text": "⅓ cup thinly sliced scallions",
                        "weight": 33.33333333333333,
                        "foodCategory": "vegetables",
                        "foodId": "food_bknlkyzbuzo27pb11whr4bttkuy6",
                        "image": "https://www.edamam.com/food-img/b89/b89986ed6aa466285bdd99bac34b3c46.jpg"
                    },
                    {
                        "text": "½ cup vegan mayonnaise",
                        "weight": 120,
                        "foodCategory": "condiments and sauces",
                        "foodId": "food_adwabpvayhkfdbaz07tv6b68sgd1",
                        "image": "https://www.edamam.com/food-img/443/443b9f86c8a9ddb82d157e267212aeb6.jpg"
                    },
                    {
                        "text": "1 teaspoon grated lemon zest",
                        "weight": 2,
                        "foodCategory": "fruit",
                        "foodId": "food_bpg66j3a5vjuuga36uiiyaqeazpd",
                        "image": "https://www.edamam.com/food-img/540/5405605c8e9b284243f06c0b1587ab6f.jpg"
                    },
                    {
                        "text": "2 tablespoons lemon juice",
                        "weight": 30.4999999994844,
                        "foodCategory": "100% juice",
                        "foodId": "food_bglm6vxahuauteb0n6ynfbg9eryu",
                        "image": "https://www.edamam.com/food-img/e31/e310952d214e78a4cb8b73f30ceeaaf2.jpg"
                    },
                    {
                        "text": "¾ teaspoon salt",
                        "weight": 4.5,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_btxz81db72hwbra2pncvebzzzum9",
                        "image": "https://www.edamam.com/food-img/694/6943ea510918c6025795e8dc6e6eaaeb.jpg"
                    },
                    {
                        "text": "¼ teaspoon ground pepper",
                        "weight": 0.725,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_b6ywzluaaxv02wad7s1r9ag4py89",
                        "image": "https://www.edamam.com/food-img/c6e/c6e5c3bd8d3bc15175d9766971a4d1b2.jpg"
                    }
                ],
                "calories": 1231.6218014290532,
                "totalWeight": 734.3432764730362,
                "totalTime": 20,
                "cuisineType": [
                    "american"
                ],
                "mealType": [
                    "lunch/dinner"
                ],
                "dishType": [
                    "salad"
                ],
                "totalNutrients": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 1231.6218014290532,
                        "unit": "kcal"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 42.081835128457094,
                        "unit": "g"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 4.205302741003961,
                        "unit": "g"
                    },
                    "FATRN": {
                        "label": "Trans",
                        "quantity": 0.18359999999999999,
                        "unit": "g"
                    },
                    "FAMS": {
                        "label": "Monounsaturated",
                        "quantity": 6.703358857262469,
                        "unit": "g"
                    },
                    "FAPU": {
                        "label": "Polyunsaturated",
                        "quantity": 21.391125029216557,
                        "unit": "g"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 170.88658767125605,
                        "unit": "g"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 20.34220010666512,
                        "unit": "g"
                    },
                    "SUGAR": {
                        "label": "Sugars",
                        "quantity": 21.727300271278676,
                        "unit": "g"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 42.0693943929982,
                        "unit": "g"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 0,
                        "unit": "mg"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 1704.938387219151,
                        "unit": "mg"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 221.1622221911215,
                        "unit": "mg"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 234.9097782480379,
                        "unit": "mg"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 1322.1868937631868,
                        "unit": "mg"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 6.740963391570642,
                        "unit": "mg"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 5.004184960764961,
                        "unit": "mg"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 604.8724255707922,
                        "unit": "mg"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 365.5374166666667,
                        "unit": "µg"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 155.09766666646715,
                        "unit": "mg"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 0.8227537582082096,
                        "unit": "mg"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 0.5060999499165894,
                        "unit": "mg"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 7.734478108749531,
                        "unit": "mg"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 0.7638160203580961,
                        "unit": "mg"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 245.19406830823024,
                        "unit": "µg"
                    },
                    "FOLFD": {
                        "label": "Folate (food)",
                        "quantity": 245.19406830823024,
                        "unit": "µg"
                    },
                    "FOLAC": {
                        "label": "Folic acid",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 4.7987301859575595,
                        "unit": "mg"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 223.75942213874998,
                        "unit": "µg"
                    },
                    "WATER": {
                        "label": "Water",
                        "quantity": 470.09876067788787,
                        "unit": "g"
                    }
                },
                "totalDaily": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 61.58109007145266,
                        "unit": "%"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 64.74128481301092,
                        "unit": "%"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 21.026513705019802,
                        "unit": "%"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 56.962195890418684,
                        "unit": "%"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 81.36880042666048,
                        "unit": "%"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 84.1387887859964,
                        "unit": "%"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 0,
                        "unit": "%"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 71.03909946746464,
                        "unit": "%"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 22.116222219112146,
                        "unit": "%"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 55.93089958286617,
                        "unit": "%"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 28.131636037514614,
                        "unit": "%"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 37.4497966198369,
                        "unit": "%"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 45.492590552408736,
                        "unit": "%"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 86.41034651011317,
                        "unit": "%"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 40.61526851851852,
                        "unit": "%"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 172.33074074051908,
                        "unit": "%"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 68.56281318401747,
                        "unit": "%"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 38.93076537819918,
                        "unit": "%"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 48.34048817968457,
                        "unit": "%"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 58.75507848908432,
                        "unit": "%"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 61.29851707705756,
                        "unit": "%"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 0,
                        "unit": "%"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 0,
                        "unit": "%"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 31.991534573050398,
                        "unit": "%"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 186.466185115625,
                        "unit": "%"
                    }
                },
                "digest": [
                    {
                        "label": "Fat",
                        "tag": "FAT",
                        "schemaOrgTag": "fatContent",
                        "total": 42.081835128457094,
                        "hasRDI": true,
                        "daily": 64.74128481301092,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Saturated",
                                "tag": "FASAT",
                                "schemaOrgTag": "saturatedFatContent",
                                "total": 4.205302741003961,
                                "hasRDI": true,
                                "daily": 21.026513705019802,
                                "unit": "g"
                            },
                            {
                                "label": "Trans",
                                "tag": "FATRN",
                                "schemaOrgTag": "transFatContent",
                                "total": 0.18359999999999999,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Monounsaturated",
                                "tag": "FAMS",
                                "schemaOrgTag": null,
                                "total": 6.703358857262469,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Polyunsaturated",
                                "tag": "FAPU",
                                "schemaOrgTag": null,
                                "total": 21.391125029216557,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Carbs",
                        "tag": "CHOCDF",
                        "schemaOrgTag": "carbohydrateContent",
                        "total": 170.88658767125605,
                        "hasRDI": true,
                        "daily": 56.962195890418684,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Carbs (net)",
                                "tag": "CHOCDF.net",
                                "schemaOrgTag": null,
                                "total": 150.54438756459092,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Fiber",
                                "tag": "FIBTG",
                                "schemaOrgTag": "fiberContent",
                                "total": 20.34220010666512,
                                "hasRDI": true,
                                "daily": 81.36880042666048,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars",
                                "tag": "SUGAR",
                                "schemaOrgTag": "sugarContent",
                                "total": 21.727300271278676,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars, added",
                                "tag": "SUGAR.added",
                                "schemaOrgTag": null,
                                "total": 0,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Protein",
                        "tag": "PROCNT",
                        "schemaOrgTag": "proteinContent",
                        "total": 42.0693943929982,
                        "hasRDI": true,
                        "daily": 84.1387887859964,
                        "unit": "g"
                    },
                    {
                        "label": "Cholesterol",
                        "tag": "CHOLE",
                        "schemaOrgTag": "cholesterolContent",
                        "total": 0,
                        "hasRDI": true,
                        "daily": 0,
                        "unit": "mg"
                    },
                    {
                        "label": "Sodium",
                        "tag": "NA",
                        "schemaOrgTag": "sodiumContent",
                        "total": 1704.938387219151,
                        "hasRDI": true,
                        "daily": 71.03909946746464,
                        "unit": "mg"
                    },
                    {
                        "label": "Calcium",
                        "tag": "CA",
                        "schemaOrgTag": null,
                        "total": 221.1622221911215,
                        "hasRDI": true,
                        "daily": 22.116222219112146,
                        "unit": "mg"
                    },
                    {
                        "label": "Magnesium",
                        "tag": "MG",
                        "schemaOrgTag": null,
                        "total": 234.9097782480379,
                        "hasRDI": true,
                        "daily": 55.93089958286617,
                        "unit": "mg"
                    },
                    {
                        "label": "Potassium",
                        "tag": "K",
                        "schemaOrgTag": null,
                        "total": 1322.1868937631868,
                        "hasRDI": true,
                        "daily": 28.131636037514614,
                        "unit": "mg"
                    },
                    {
                        "label": "Iron",
                        "tag": "FE",
                        "schemaOrgTag": null,
                        "total": 6.740963391570642,
                        "hasRDI": true,
                        "daily": 37.4497966198369,
                        "unit": "mg"
                    },
                    {
                        "label": "Zinc",
                        "tag": "ZN",
                        "schemaOrgTag": null,
                        "total": 5.004184960764961,
                        "hasRDI": true,
                        "daily": 45.492590552408736,
                        "unit": "mg"
                    },
                    {
                        "label": "Phosphorus",
                        "tag": "P",
                        "schemaOrgTag": null,
                        "total": 604.8724255707922,
                        "hasRDI": true,
                        "daily": 86.41034651011317,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin A",
                        "tag": "VITA_RAE",
                        "schemaOrgTag": null,
                        "total": 365.5374166666667,
                        "hasRDI": true,
                        "daily": 40.61526851851852,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin C",
                        "tag": "VITC",
                        "schemaOrgTag": null,
                        "total": 155.09766666646715,
                        "hasRDI": true,
                        "daily": 172.33074074051908,
                        "unit": "mg"
                    },
                    {
                        "label": "Thiamin (B1)",
                        "tag": "THIA",
                        "schemaOrgTag": null,
                        "total": 0.8227537582082096,
                        "hasRDI": true,
                        "daily": 68.56281318401747,
                        "unit": "mg"
                    },
                    {
                        "label": "Riboflavin (B2)",
                        "tag": "RIBF",
                        "schemaOrgTag": null,
                        "total": 0.5060999499165894,
                        "hasRDI": true,
                        "daily": 38.93076537819918,
                        "unit": "mg"
                    },
                    {
                        "label": "Niacin (B3)",
                        "tag": "NIA",
                        "schemaOrgTag": null,
                        "total": 7.734478108749531,
                        "hasRDI": true,
                        "daily": 48.34048817968457,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin B6",
                        "tag": "VITB6A",
                        "schemaOrgTag": null,
                        "total": 0.7638160203580961,
                        "hasRDI": true,
                        "daily": 58.75507848908432,
                        "unit": "mg"
                    },
                    {
                        "label": "Folate equivalent (total)",
                        "tag": "FOLDFE",
                        "schemaOrgTag": null,
                        "total": 245.19406830823024,
                        "hasRDI": true,
                        "daily": 61.29851707705756,
                        "unit": "µg"
                    },
                    {
                        "label": "Folate (food)",
                        "tag": "FOLFD",
                        "schemaOrgTag": null,
                        "total": 245.19406830823024,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Folic acid",
                        "tag": "FOLAC",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin B12",
                        "tag": "VITB12",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": true,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin D",
                        "tag": "VITD",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": true,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin E",
                        "tag": "TOCPHA",
                        "schemaOrgTag": null,
                        "total": 4.7987301859575595,
                        "hasRDI": true,
                        "daily": 31.991534573050398,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin K",
                        "tag": "VITK1",
                        "schemaOrgTag": null,
                        "total": 223.75942213874998,
                        "hasRDI": true,
                        "daily": 186.466185115625,
                        "unit": "µg"
                    },
                    {
                        "label": "Sugar alcohols",
                        "tag": "Sugar.alcohol",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    },
                    {
                        "label": "Water",
                        "tag": "WATER",
                        "schemaOrgTag": null,
                        "total": 470.09876067788787,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    }
                ]
            },
            "_links": {
                "self": {
                    "href": "https://api.edamam.com/api/recipes/v2/c827bdb9611f72ccf8c235dc6986e928?type=public&app_id=ea1d37d5&app_key=fd382a172ba8d6668c0430dc9c14a181",
                    "title": "Self"
                }
            }
        },
        {
            "recipe": {
                "uri": "http://www.edamam.com/ontologies/edamam.owl#recipe_7c8233c7de34cb4e919050d77378d1ea",
                "label": "Vegan toffee apple upside-down cake",
                "image": "https://www.edamam.com/web-img/3fd/3fdc78b639068ebbcf08f8cc564a1569.jpg",
                "source": "Jamie Oliver",
                "url": "http://www.jamieoliver.com/recipes/fruit-recipes/vegan-toffee-apple-upside-down-cake/",
                "shareAs": "http://www.edamam.com/recipe/vegan-toffee-apple-upside-down-cake-7c8233c7de34cb4e919050d77378d1ea/vegan",
                "yield": 9,
                "dietLabels": [],
                "healthLabels": [
                    "Low Potassium",
                    "Kidney-Friendly",
                    "Vegan",
                    "Vegetarian",
                    "Pescatarian",
                    "Dairy-Free",
                    "Egg-Free",
                    "Peanut-Free",
                    "Fish-Free",
                    "Shellfish-Free",
                    "Pork-Free",
                    "Red-Meat-Free",
                    "Crustacean-Free",
                    "Celery-Free",
                    "Mustard-Free",
                    "Sesame-Free",
                    "Lupine-Free",
                    "Mollusk-Free",
                    "Alcohol-Free",
                    "Kosher"
                ],
                "cautions": [
                    "Sulfites",
                    "FODMAP"
                ],
                "ingredientLines": [
                    "25 g vegan margarine , plus extra for greasing",
                    "3 dessert apples",
                    "195 g muscovado sugar",
                    "180 g plain flour",
                    "1 teaspoon bicarbonate of soda",
                    "1½ teaspoons mixed spice",
                    "80 ml sunflower oil",
                    "1 tesapoon vinegar",
                    "1 lemon",
                    "85 g walnuts"
                ],
                "ingredients": [
                    {
                        "text": "25 g vegan margarine , plus extra for greasing",
                        "weight": 25,
                        "foodCategory": "oils",
                        "foodId": "food_bmgvd8ebe85l7ybbyb7gob2y2w1k",
                        "image": "https://www.edamam.com/food-img/e1d/e1deed85a7d1c9132466ea4513ee3070.jpg"
                    },
                    {
                        "text": "3 dessert apples",
                        "weight": 546,
                        "foodCategory": "fruit",
                        "foodId": "food_a1gb9ubb72c7snbuxr3weagwv0dd",
                        "image": "https://www.edamam.com/food-img/42c/42c006401027d35add93113548eeaae6.jpg"
                    },
                    {
                        "text": "195 g muscovado sugar",
                        "weight": 195,
                        "foodCategory": "sugars",
                        "foodId": "food_axi2ijobrk819yb0adceobnhm1c2",
                        "image": "https://www.edamam.com/food-img/ecb/ecb3f5aaed96d0188c21b8369be07765.jpg"
                    },
                    {
                        "text": "180 g plain flour",
                        "weight": 180,
                        "foodCategory": "grains",
                        "foodId": "food_ahebfs0a985an4aubqaebbipra58",
                        "image": "https://www.edamam.com/food-img/b4c/b4c739e76a6f2172b7ad49d0aa41d5aa.jpg"
                    },
                    {
                        "text": "1 teaspoon bicarbonate of soda",
                        "weight": 4.6,
                        "foodCategory": "condiments and sauces",
                        "foodId": "food_asa4cjoa3lmt8ibwdg0cpblheo69",
                        "image": "https://www.edamam.com/food-img/7e5/7e55e4482cc2fde91f427fc568e6f5b8.jpeg"
                    },
                    {
                        "text": "1½ teaspoons mixed spice",
                        "weight": 1.5,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_avsq22zadwyb5cb5sl1byaa4mbo8",
                        "image": "https://www.edamam.com/food-img/89b/89b37a04e46e052671d73addcb84aa51.jpg"
                    },
                    {
                        "text": "80 ml sunflower oil",
                        "weight": 73.71456949001774,
                        "foodCategory": "Oils",
                        "foodId": "food_b09yz1nbx49rv1bss5kgxat77cvn",
                        "image": "https://www.edamam.com/food-img/be4/be4dba2bb618ecda2213ac422ae05289.jpg"
                    },
                    {
                        "text": "1 tesapoon vinegar",
                        "weight": 15,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_am3vwadag9arxtadrwyfcau2w3b2",
                        "image": "https://www.edamam.com/food-img/5f6/5f69b84c399d778c4728e9ab4f8065a2.jpg"
                    },
                    {
                        "text": "1 lemon",
                        "weight": 58,
                        "foodCategory": "fruit",
                        "foodId": "food_a6uzc62astrxcgbtzyq59b6fncrr",
                        "image": "https://www.edamam.com/food-img/70a/70acba3d4c734d7c70ef4efeed85dc8f.jpg"
                    },
                    {
                        "text": "85 g walnuts",
                        "weight": 85,
                        "foodCategory": "plant-based protein",
                        "foodId": "food_acqkmojaw4fltga9jad8mb85u9z2",
                        "image": "https://www.edamam.com/food-img/624/6243d320d94b15ebaece2634cc5b40c5.jpg"
                    }
                ],
                "calories": 3103.5382228631856,
                "totalWeight": 1183.8145694900177,
                "totalTime": 50,
                "cuisineType": [
                    "british"
                ],
                "mealType": [
                    "lunch/dinner"
                ],
                "dishType": [
                    "desserts"
                ],
                "totalNutrients": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 3103.5382228631856,
                        "unit": "kcal"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 151.76357663287487,
                        "unit": "g"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 20.642586890845163,
                        "unit": "g"
                    },
                    "FATRN": {
                        "label": "Trans",
                        "quantity": 0,
                        "unit": "g"
                    },
                    "FAMS": {
                        "label": "Monounsaturated",
                        "quantity": 50.78600253295962,
                        "unit": "g"
                    },
                    "FAPU": {
                        "label": "Polyunsaturated",
                        "quantity": 72.48561900865217,
                        "unit": "g"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 425.7458,
                        "unit": "g"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 25.837999999999997,
                        "unit": "g"
                    },
                    "SUGAR": {
                        "label": "Sugars",
                        "quantity": 255.52554999999998,
                        "unit": "g"
                    },
                    "SUGAR.added": {
                        "label": "Sugars, added",
                        "quantity": 194.60999999999999,
                        "unit": "g"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 33.73375,
                        "unit": "g"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 0,
                        "unit": "mg"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 1461.055,
                        "unit": "mg"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 189.34,
                        "unit": "mg"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 209.29,
                        "unit": "mg"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 1248.12,
                        "unit": "mg"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 7.5387,
                        "unit": "mg"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 4.253399999999999,
                        "unit": "mg"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 561.4549999999999,
                        "unit": "mg"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 20.66,
                        "unit": "µg"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 57.71099999999999,
                        "unit": "mg"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 0.6295649999999999,
                        "unit": "mg"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 0.39609500000000003,
                        "unit": "mg"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 3.8352099999999996,
                        "unit": "mg"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 0.81416,
                        "unit": "mg"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 156.97,
                        "unit": "µg"
                    },
                    "FOLFD": {
                        "label": "Folate (food)",
                        "quantity": 156.97,
                        "unit": "µg"
                    },
                    "FOLAC": {
                        "label": "Folic acid",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 33.59551657507071,
                        "unit": "mg"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 44.54508675246095,
                        "unit": "µg"
                    },
                    "WATER": {
                        "label": "Water",
                        "quantity": 558.0635500000001,
                        "unit": "g"
                    }
                },
                "totalDaily": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 155.1769111431593,
                        "unit": "%"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 233.48242558903826,
                        "unit": "%"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 103.21293445422582,
                        "unit": "%"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 141.91526666666664,
                        "unit": "%"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 103.35199999999999,
                        "unit": "%"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 67.4675,
                        "unit": "%"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 0,
                        "unit": "%"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 60.877291666666665,
                        "unit": "%"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 18.934,
                        "unit": "%"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 49.83095238095238,
                        "unit": "%"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 26.55574468085106,
                        "unit": "%"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 41.88166666666667,
                        "unit": "%"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 38.66727272727272,
                        "unit": "%"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 80.20785714285714,
                        "unit": "%"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 2.2955555555555556,
                        "unit": "%"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 64.12333333333332,
                        "unit": "%"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 52.46375,
                        "unit": "%"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 30.468846153846155,
                        "unit": "%"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 23.970062499999997,
                        "unit": "%"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 62.6276923076923,
                        "unit": "%"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 39.2425,
                        "unit": "%"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 0,
                        "unit": "%"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 0,
                        "unit": "%"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 223.9701105004714,
                        "unit": "%"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 37.120905627050796,
                        "unit": "%"
                    }
                },
                "digest": [
                    {
                        "label": "Fat",
                        "tag": "FAT",
                        "schemaOrgTag": "fatContent",
                        "total": 151.76357663287487,
                        "hasRDI": true,
                        "daily": 233.48242558903826,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Saturated",
                                "tag": "FASAT",
                                "schemaOrgTag": "saturatedFatContent",
                                "total": 20.642586890845163,
                                "hasRDI": true,
                                "daily": 103.21293445422582,
                                "unit": "g"
                            },
                            {
                                "label": "Trans",
                                "tag": "FATRN",
                                "schemaOrgTag": "transFatContent",
                                "total": 0,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Monounsaturated",
                                "tag": "FAMS",
                                "schemaOrgTag": null,
                                "total": 50.78600253295962,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Polyunsaturated",
                                "tag": "FAPU",
                                "schemaOrgTag": null,
                                "total": 72.48561900865217,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Carbs",
                        "tag": "CHOCDF",
                        "schemaOrgTag": "carbohydrateContent",
                        "total": 425.7458,
                        "hasRDI": true,
                        "daily": 141.91526666666664,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Carbs (net)",
                                "tag": "CHOCDF.net",
                                "schemaOrgTag": null,
                                "total": 399.90779999999995,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Fiber",
                                "tag": "FIBTG",
                                "schemaOrgTag": "fiberContent",
                                "total": 25.837999999999997,
                                "hasRDI": true,
                                "daily": 103.35199999999999,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars",
                                "tag": "SUGAR",
                                "schemaOrgTag": "sugarContent",
                                "total": 255.52554999999998,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars, added",
                                "tag": "SUGAR.added",
                                "schemaOrgTag": null,
                                "total": 194.60999999999999,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Protein",
                        "tag": "PROCNT",
                        "schemaOrgTag": "proteinContent",
                        "total": 33.73375,
                        "hasRDI": true,
                        "daily": 67.4675,
                        "unit": "g"
                    },
                    {
                        "label": "Cholesterol",
                        "tag": "CHOLE",
                        "schemaOrgTag": "cholesterolContent",
                        "total": 0,
                        "hasRDI": true,
                        "daily": 0,
                        "unit": "mg"
                    },
                    {
                        "label": "Sodium",
                        "tag": "NA",
                        "schemaOrgTag": "sodiumContent",
                        "total": 1461.055,
                        "hasRDI": true,
                        "daily": 60.877291666666665,
                        "unit": "mg"
                    },
                    {
                        "label": "Calcium",
                        "tag": "CA",
                        "schemaOrgTag": null,
                        "total": 189.34,
                        "hasRDI": true,
                        "daily": 18.934,
                        "unit": "mg"
                    },
                    {
                        "label": "Magnesium",
                        "tag": "MG",
                        "schemaOrgTag": null,
                        "total": 209.29,
                        "hasRDI": true,
                        "daily": 49.83095238095238,
                        "unit": "mg"
                    },
                    {
                        "label": "Potassium",
                        "tag": "K",
                        "schemaOrgTag": null,
                        "total": 1248.12,
                        "hasRDI": true,
                        "daily": 26.55574468085106,
                        "unit": "mg"
                    },
                    {
                        "label": "Iron",
                        "tag": "FE",
                        "schemaOrgTag": null,
                        "total": 7.5387,
                        "hasRDI": true,
                        "daily": 41.88166666666667,
                        "unit": "mg"
                    },
                    {
                        "label": "Zinc",
                        "tag": "ZN",
                        "schemaOrgTag": null,
                        "total": 4.253399999999999,
                        "hasRDI": true,
                        "daily": 38.66727272727272,
                        "unit": "mg"
                    },
                    {
                        "label": "Phosphorus",
                        "tag": "P",
                        "schemaOrgTag": null,
                        "total": 561.4549999999999,
                        "hasRDI": true,
                        "daily": 80.20785714285714,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin A",
                        "tag": "VITA_RAE",
                        "schemaOrgTag": null,
                        "total": 20.66,
                        "hasRDI": true,
                        "daily": 2.2955555555555556,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin C",
                        "tag": "VITC",
                        "schemaOrgTag": null,
                        "total": 57.71099999999999,
                        "hasRDI": true,
                        "daily": 64.12333333333332,
                        "unit": "mg"
                    },
                    {
                        "label": "Thiamin (B1)",
                        "tag": "THIA",
                        "schemaOrgTag": null,
                        "total": 0.6295649999999999,
                        "hasRDI": true,
                        "daily": 52.46375,
                        "unit": "mg"
                    },
                    {
                        "label": "Riboflavin (B2)",
                        "tag": "RIBF",
                        "schemaOrgTag": null,
                        "total": 0.39609500000000003,
                        "hasRDI": true,
                        "daily": 30.468846153846155,
                        "unit": "mg"
                    },
                    {
                        "label": "Niacin (B3)",
                        "tag": "NIA",
                        "schemaOrgTag": null,
                        "total": 3.8352099999999996,
                        "hasRDI": true,
                        "daily": 23.970062499999997,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin B6",
                        "tag": "VITB6A",
                        "schemaOrgTag": null,
                        "total": 0.81416,
                        "hasRDI": true,
                        "daily": 62.6276923076923,
                        "unit": "mg"
                    },
                    {
                        "label": "Folate equivalent (total)",
                        "tag": "FOLDFE",
                        "schemaOrgTag": null,
                        "total": 156.97,
                        "hasRDI": true,
                        "daily": 39.2425,
                        "unit": "µg"
                    },
                    {
                        "label": "Folate (food)",
                        "tag": "FOLFD",
                        "schemaOrgTag": null,
                        "total": 156.97,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Folic acid",
                        "tag": "FOLAC",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin B12",
                        "tag": "VITB12",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": true,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin D",
                        "tag": "VITD",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": true,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin E",
                        "tag": "TOCPHA",
                        "schemaOrgTag": null,
                        "total": 33.59551657507071,
                        "hasRDI": true,
                        "daily": 223.9701105004714,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin K",
                        "tag": "VITK1",
                        "schemaOrgTag": null,
                        "total": 44.54508675246095,
                        "hasRDI": true,
                        "daily": 37.120905627050796,
                        "unit": "µg"
                    },
                    {
                        "label": "Sugar alcohols",
                        "tag": "Sugar.alcohol",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    },
                    {
                        "label": "Water",
                        "tag": "WATER",
                        "schemaOrgTag": null,
                        "total": 558.0635500000001,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    }
                ]
            },
            "_links": {
                "self": {
                    "href": "https://api.edamam.com/api/recipes/v2/7c8233c7de34cb4e919050d77378d1ea?type=public&app_id=ea1d37d5&app_key=fd382a172ba8d6668c0430dc9c14a181",
                    "title": "Self"
                }
            }
        },
        {
            "recipe": {
                "uri": "http://www.edamam.com/ontologies/edamam.owl#recipe_577e48e77c3aa6ee7d65d2ac6386048a",
                "label": "Vegan tiffin",
                "image": "https://www.edamam.com/web-img/a43/a43db847370d83e605ecac50b53a969a.jpg",
                "source": "BBC Good Food",
                "url": "https://www.bbcgoodfood.com/recipes/vegan-tiffin",
                "shareAs": "http://www.edamam.com/recipe/vegan-tiffin-577e48e77c3aa6ee7d65d2ac6386048a/vegan",
                "yield": 25,
                "dietLabels": [
                    "Low-Sodium"
                ],
                "healthLabels": [
                    "Low Potassium",
                    "Kidney-Friendly",
                    "Vegetarian",
                    "Pescatarian",
                    "Gluten-Free",
                    "Wheat-Free",
                    "Egg-Free",
                    "Soy-Free",
                    "Fish-Free",
                    "Shellfish-Free",
                    "Pork-Free",
                    "Red-Meat-Free",
                    "Crustacean-Free",
                    "Celery-Free",
                    "Mustard-Free",
                    "Sesame-Free",
                    "Lupine-Free",
                    "Mollusk-Free",
                    "Alcohol-Free",
                    "Kosher"
                ],
                "cautions": [
                    "Tree-Nuts",
                    "Sulfites"
                ],
                "ingredientLines": [
                    "75g coconut oil, plus extra for the tin",
                    "200g vegan dark chocolate (at least 70%), roughly chopped",
                    "2 tbsp golden syrup",
                    "200g vegan ginger nuts",
                    "100g dried cranberries",
                    "50g pistachios, toasted and chopped"
                ],
                "ingredients": [
                    {
                        "text": "75g coconut oil, plus extra for the tin",
                        "weight": 75,
                        "foodCategory": "Oils",
                        "foodId": "food_b40ubq8a0enoidbcr1tmfbwgs6aw",
                        "image": "https://www.edamam.com/food-img/3c9/3c97284c57e76e16093d51572b558be8.jpg"
                    },
                    {
                        "text": "200g vegan dark chocolate (at least 70%), roughly chopped",
                        "weight": 200,
                        "foodCategory": "chocolate",
                        "foodId": "food_afwurvlasugs4ibig02xbblph5bn",
                        "image": "https://www.edamam.com/food-img/3cf/3cf0e13350f43392dc13c07d27ad145d.jpg"
                    },
                    {
                        "text": "2 tbsp golden syrup",
                        "weight": 40,
                        "foodCategory": "sugars",
                        "foodId": "food_bo79gpza83y5i8a3ze96lb0pan32",
                        "image": "https://www.edamam.com/food-img/8c0/8c0be6812a605404c0bcebf2fd2a27cd.jpg"
                    },
                    {
                        "text": "200g vegan ginger nuts",
                        "weight": 200,
                        "foodCategory": "plant-based protein",
                        "foodId": "food_amqspy5ap567v6bun60usbgsaor7",
                        "image": "https://www.edamam.com/food-img/e29/e2985d3585a6950c276e204ba7ba9b2e.jpg"
                    },
                    {
                        "text": "100g dried cranberries",
                        "weight": 100,
                        "foodCategory": "sugar jam",
                        "foodId": "food_atvsjvja2h9xyfblcy3pzaienr8a",
                        "image": "https://www.edamam.com/food-img/8aa/8aa3935a527394e1568079a489759221.jpg"
                    },
                    {
                        "text": "50g pistachios, toasted and chopped",
                        "weight": 50,
                        "foodCategory": "plant-based protein",
                        "foodId": "food_apsiasib4lwjivakg7bouakq9l6s",
                        "image": "https://www.edamam.com/food-img/1ed/1eda10468a9c3df61f8208fe156e832d.jpg"
                    }
                ],
                "calories": 3747.1,
                "totalWeight": 665,
                "totalTime": 18,
                "cuisineType": [
                    "american"
                ],
                "mealType": [
                    "teatime"
                ],
                "dishType": [
                    "dessert"
                ],
                "totalNutrients": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 3747.1,
                        "unit": "kcal"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 287.22499999999997,
                        "unit": "g"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 130.532,
                        "unit": "g"
                    },
                    "FATRN": {
                        "label": "Trans",
                        "quantity": 0.06,
                        "unit": "g"
                    },
                    "FAMS": {
                        "label": "Monounsaturated",
                        "quantity": 104.80999999999999,
                        "unit": "g"
                    },
                    "FAPU": {
                        "label": "Polyunsaturated",
                        "quantity": 32.93000000000001,
                        "unit": "g"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 272.175,
                        "unit": "g"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 50.65,
                        "unit": "g"
                    },
                    "SUGAR": {
                        "label": "Sugars",
                        "quantity": 116.80999999999999,
                        "unit": "g"
                    },
                    "SUGAR.added": {
                        "label": "Sugars, added",
                        "quantity": 47.98,
                        "unit": "g"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 60.385,
                        "unit": "g"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 6,
                        "unit": "mg"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 95.9,
                        "unit": "mg"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 357.7,
                        "unit": "mg"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 975.1,
                        "unit": "mg"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 3201.7,
                        "unit": "mg"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 34.016000000000005,
                        "unit": "mg"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 15.441999999999998,
                        "unit": "mg"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 1742.2,
                        "unit": "mg"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 16.5,
                        "unit": "µg"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 3.8,
                        "unit": "mg"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 0.9124000000000001,
                        "unit": "mg"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 0.6708,
                        "unit": "mg"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 13.156,
                        "unit": "mg"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 1.5596,
                        "unit": "mg"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 126.7,
                        "unit": "µg"
                    },
                    "FOLFD": {
                        "label": "Folate (food)",
                        "quantity": 126.7,
                        "unit": "µg"
                    },
                    "FOLAC": {
                        "label": "Folic acid",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 0.56,
                        "unit": "µg"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 3.4675,
                        "unit": "mg"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 18.775,
                        "unit": "µg"
                    },
                    "WATER": {
                        "label": "Water",
                        "quantity": 30.435000000000002,
                        "unit": "g"
                    }
                },
                "totalDaily": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 187.355,
                        "unit": "%"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 441.8846153846153,
                        "unit": "%"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 652.6600000000001,
                        "unit": "%"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 90.725,
                        "unit": "%"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 202.6,
                        "unit": "%"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 120.77,
                        "unit": "%"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 2,
                        "unit": "%"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 3.995833333333333,
                        "unit": "%"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 35.77,
                        "unit": "%"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 232.16666666666666,
                        "unit": "%"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 68.12127659574467,
                        "unit": "%"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 188.9777777777778,
                        "unit": "%"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 140.38181818181818,
                        "unit": "%"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 248.88571428571427,
                        "unit": "%"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 1.8333333333333333,
                        "unit": "%"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 4.222222222222222,
                        "unit": "%"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 76.03333333333335,
                        "unit": "%"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 51.599999999999994,
                        "unit": "%"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 82.22500000000001,
                        "unit": "%"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 119.96923076923078,
                        "unit": "%"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 31.675,
                        "unit": "%"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 23.333333333333336,
                        "unit": "%"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 0,
                        "unit": "%"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 23.116666666666667,
                        "unit": "%"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 15.645833333333332,
                        "unit": "%"
                    }
                },
                "digest": [
                    {
                        "label": "Fat",
                        "tag": "FAT",
                        "schemaOrgTag": "fatContent",
                        "total": 287.22499999999997,
                        "hasRDI": true,
                        "daily": 441.8846153846153,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Saturated",
                                "tag": "FASAT",
                                "schemaOrgTag": "saturatedFatContent",
                                "total": 130.532,
                                "hasRDI": true,
                                "daily": 652.6600000000001,
                                "unit": "g"
                            },
                            {
                                "label": "Trans",
                                "tag": "FATRN",
                                "schemaOrgTag": "transFatContent",
                                "total": 0.06,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Monounsaturated",
                                "tag": "FAMS",
                                "schemaOrgTag": null,
                                "total": 104.80999999999999,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Polyunsaturated",
                                "tag": "FAPU",
                                "schemaOrgTag": null,
                                "total": 32.93000000000001,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Carbs",
                        "tag": "CHOCDF",
                        "schemaOrgTag": "carbohydrateContent",
                        "total": 272.175,
                        "hasRDI": true,
                        "daily": 90.725,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Carbs (net)",
                                "tag": "CHOCDF.net",
                                "schemaOrgTag": null,
                                "total": 221.525,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Fiber",
                                "tag": "FIBTG",
                                "schemaOrgTag": "fiberContent",
                                "total": 50.65,
                                "hasRDI": true,
                                "daily": 202.6,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars",
                                "tag": "SUGAR",
                                "schemaOrgTag": "sugarContent",
                                "total": 116.80999999999999,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars, added",
                                "tag": "SUGAR.added",
                                "schemaOrgTag": null,
                                "total": 47.98,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Protein",
                        "tag": "PROCNT",
                        "schemaOrgTag": "proteinContent",
                        "total": 60.385,
                        "hasRDI": true,
                        "daily": 120.77,
                        "unit": "g"
                    },
                    {
                        "label": "Cholesterol",
                        "tag": "CHOLE",
                        "schemaOrgTag": "cholesterolContent",
                        "total": 6,
                        "hasRDI": true,
                        "daily": 2,
                        "unit": "mg"
                    },
                    {
                        "label": "Sodium",
                        "tag": "NA",
                        "schemaOrgTag": "sodiumContent",
                        "total": 95.9,
                        "hasRDI": true,
                        "daily": 3.995833333333333,
                        "unit": "mg"
                    },
                    {
                        "label": "Calcium",
                        "tag": "CA",
                        "schemaOrgTag": null,
                        "total": 357.7,
                        "hasRDI": true,
                        "daily": 35.77,
                        "unit": "mg"
                    },
                    {
                        "label": "Magnesium",
                        "tag": "MG",
                        "schemaOrgTag": null,
                        "total": 975.1,
                        "hasRDI": true,
                        "daily": 232.16666666666666,
                        "unit": "mg"
                    },
                    {
                        "label": "Potassium",
                        "tag": "K",
                        "schemaOrgTag": null,
                        "total": 3201.7,
                        "hasRDI": true,
                        "daily": 68.12127659574467,
                        "unit": "mg"
                    },
                    {
                        "label": "Iron",
                        "tag": "FE",
                        "schemaOrgTag": null,
                        "total": 34.016000000000005,
                        "hasRDI": true,
                        "daily": 188.9777777777778,
                        "unit": "mg"
                    },
                    {
                        "label": "Zinc",
                        "tag": "ZN",
                        "schemaOrgTag": null,
                        "total": 15.441999999999998,
                        "hasRDI": true,
                        "daily": 140.38181818181818,
                        "unit": "mg"
                    },
                    {
                        "label": "Phosphorus",
                        "tag": "P",
                        "schemaOrgTag": null,
                        "total": 1742.2,
                        "hasRDI": true,
                        "daily": 248.88571428571427,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin A",
                        "tag": "VITA_RAE",
                        "schemaOrgTag": null,
                        "total": 16.5,
                        "hasRDI": true,
                        "daily": 1.8333333333333333,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin C",
                        "tag": "VITC",
                        "schemaOrgTag": null,
                        "total": 3.8,
                        "hasRDI": true,
                        "daily": 4.222222222222222,
                        "unit": "mg"
                    },
                    {
                        "label": "Thiamin (B1)",
                        "tag": "THIA",
                        "schemaOrgTag": null,
                        "total": 0.9124000000000001,
                        "hasRDI": true,
                        "daily": 76.03333333333335,
                        "unit": "mg"
                    },
                    {
                        "label": "Riboflavin (B2)",
                        "tag": "RIBF",
                        "schemaOrgTag": null,
                        "total": 0.6708,
                        "hasRDI": true,
                        "daily": 51.599999999999994,
                        "unit": "mg"
                    },
                    {
                        "label": "Niacin (B3)",
                        "tag": "NIA",
                        "schemaOrgTag": null,
                        "total": 13.156,
                        "hasRDI": true,
                        "daily": 82.22500000000001,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin B6",
                        "tag": "VITB6A",
                        "schemaOrgTag": null,
                        "total": 1.5596,
                        "hasRDI": true,
                        "daily": 119.96923076923078,
                        "unit": "mg"
                    },
                    {
                        "label": "Folate equivalent (total)",
                        "tag": "FOLDFE",
                        "schemaOrgTag": null,
                        "total": 126.7,
                        "hasRDI": true,
                        "daily": 31.675,
                        "unit": "µg"
                    },
                    {
                        "label": "Folate (food)",
                        "tag": "FOLFD",
                        "schemaOrgTag": null,
                        "total": 126.7,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Folic acid",
                        "tag": "FOLAC",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin B12",
                        "tag": "VITB12",
                        "schemaOrgTag": null,
                        "total": 0.56,
                        "hasRDI": true,
                        "daily": 23.333333333333336,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin D",
                        "tag": "VITD",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": true,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin E",
                        "tag": "TOCPHA",
                        "schemaOrgTag": null,
                        "total": 3.4675,
                        "hasRDI": true,
                        "daily": 23.116666666666667,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin K",
                        "tag": "VITK1",
                        "schemaOrgTag": null,
                        "total": 18.775,
                        "hasRDI": true,
                        "daily": 15.645833333333332,
                        "unit": "µg"
                    },
                    {
                        "label": "Sugar alcohols",
                        "tag": "Sugar.alcohol",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    },
                    {
                        "label": "Water",
                        "tag": "WATER",
                        "schemaOrgTag": null,
                        "total": 30.435000000000002,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    }
                ]
            },
            "_links": {
                "self": {
                    "href": "https://api.edamam.com/api/recipes/v2/577e48e77c3aa6ee7d65d2ac6386048a?type=public&app_id=ea1d37d5&app_key=fd382a172ba8d6668c0430dc9c14a181",
                    "title": "Self"
                }
            }
        },
        {
            "recipe": {
                "uri": "http://www.edamam.com/ontologies/edamam.owl#recipe_296651641ed9f6eb29705f3d7fdb22da",
                "label": "Vegan Nanaimo Bars recipes",
                "image": "https://www.edamam.com/web-img/f8d/f8dee5f79be517624d1a8040c90790c5",
                "source": "Oh She Glows",
                "url": "http://ohsheglows.com/2010/12/16/vegan-nanaimo-bars/",
                "shareAs": "http://www.edamam.com/recipe/vegan-nanaimo-bars-recipes-296651641ed9f6eb29705f3d7fdb22da/vegan",
                "yield": 8,
                "dietLabels": [],
                "healthLabels": [
                    "Vegetarian",
                    "Pescatarian",
                    "Peanut-Free",
                    "Fish-Free",
                    "Shellfish-Free",
                    "Pork-Free",
                    "Red-Meat-Free",
                    "Crustacean-Free",
                    "Celery-Free",
                    "Mustard-Free",
                    "Sesame-Free",
                    "Lupine-Free",
                    "Mollusk-Free",
                    "Alcohol-Free",
                    "Kosher"
                ],
                "cautions": [
                    "Tree-Nuts",
                    "Sulfites",
                    "FODMAP"
                ],
                "ingredientLines": [
                    "1/2 cup vegan butter (or regular butter)",
                    "1/4 cup sugar",
                    "5 tbsp unsweetened cocoa powder, sifted",
                    "1 flax egg (1 tbsp ground flax + 3 tbsp warm water, mixed)",
                    "1 and ¼ cup vegan graham crackers or store bought, processed into a crumb",
                    "1/4 cup almonds, processed fine",
                    "1 cup unsweetened coconut",
                    "1/2 cup vegan butter (or regular butter)",
                    "2 tbsp coconut milk, full-fat (not light)",
                    "1 tsp pure vanilla extract",
                    "2 tbsp vanilla custard powder",
                    "2 cups icing/confectioner’s sugar, sifted",
                    "4 oz non-dairy dark chocolate or semi-sweet plus 2 tbsp vegan butter (or regular butter)",
                    "shredded coconut"
                ],
                "ingredients": [
                    {
                        "text": "1/2 cup vegan butter (or regular butter)",
                        "weight": 109,
                        "foodCategory": "Oils",
                        "foodId": "food_bn7cczea5psahcbaqvd2ob43qksr",
                        "image": "https://www.edamam.com/food-img/330/3302cd340e3d2dcf7f02e72fdfe8b209.jpg"
                    },
                    {
                        "text": "1/4 cup sugar",
                        "weight": 50,
                        "foodCategory": "sugars",
                        "foodId": "food_axi2ijobrk819yb0adceobnhm1c2",
                        "image": "https://www.edamam.com/food-img/ecb/ecb3f5aaed96d0188c21b8369be07765.jpg"
                    },
                    {
                        "text": "5 tbsp unsweetened cocoa powder, sifted",
                        "weight": 27,
                        "foodCategory": "chocolate",
                        "foodId": "food_afcmkjjaqwjkezbfz7htdb7mpkwz",
                        "image": "https://www.edamam.com/food-img/89a/89af89595db3cf2c3007f2b064c5fef6.jpg"
                    },
                    {
                        "text": "1 flax egg (1 tbsp ground flax + 3 tbsp warm water, mixed)",
                        "weight": 43,
                        "foodCategory": "Eggs",
                        "foodId": "food_bhpradua77pk16aipcvzeayg732r",
                        "image": "https://www.edamam.com/food-img/a7e/a7ec7c337cb47c6550b3b118e357f077.jpg"
                    },
                    {
                        "text": "1 and ¼ cup vegan graham crackers or store bought, processed into a crumb",
                        "weight": 105,
                        "foodCategory": "pastries",
                        "foodId": "food_aipm8mobslonobbbkxmhbb8a4iox",
                        "image": "https://www.edamam.com/food-img/448/448b5544a8ac969e88525f6bc44f5c12.jpg"
                    },
                    {
                        "text": "1/4 cup almonds, processed fine",
                        "weight": 35.75,
                        "foodCategory": "plant-based protein",
                        "foodId": "food_bq4d2wras281i0br37nrnaglo3yc",
                        "image": "https://www.edamam.com/food-img/6c2/6c2dc21adf11afc4c8d390ee2f651e56.jpg"
                    },
                    {
                        "text": "1 cup unsweetened coconut",
                        "weight": 85,
                        "foodCategory": "plant-based protein",
                        "foodId": "food_a9ua70bboyd4rebvrdwb0benu8pn",
                        "image": "https://www.edamam.com/food-img/d76/d76b9333b99d55d69b023d81d179aa39.jpg"
                    },
                    {
                        "text": "1/2 cup vegan butter (or regular butter)",
                        "weight": 109,
                        "foodCategory": "Oils",
                        "foodId": "food_bn7cczea5psahcbaqvd2ob43qksr",
                        "image": "https://www.edamam.com/food-img/330/3302cd340e3d2dcf7f02e72fdfe8b209.jpg"
                    },
                    {
                        "text": "2 tbsp coconut milk, full-fat (not light)",
                        "weight": 30,
                        "foodCategory": "non-dairy beverages",
                        "foodId": "food_by1k6v2adj7drhbq9w1rpbpen9ms",
                        "image": "https://www.edamam.com/food-img/671/671f7528eadb1b01efb53243d0ef0f80.JPG"
                    },
                    {
                        "text": "1 tsp pure vanilla extract",
                        "weight": 4.2,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_bh1wvnqaw3q7ciascfoygaabax2a",
                        "image": "https://www.edamam.com/food-img/90f/90f910b0bf82750d4f6528263e014cca.jpg"
                    },
                    {
                        "text": "2 tbsp vanilla custard powder",
                        "weight": 35.24999999940403,
                        "foodCategory": "chocolate",
                        "foodId": "food_aqftc79a23qh42af8c2nva87li25",
                        "image": "https://www.edamam.com/food-img/932/932b2776ea9cd734c5986d3d013017ee.jpg"
                    },
                    {
                        "text": "2 cups icing/confectioner’s sugar, sifted",
                        "weight": 200,
                        "foodCategory": "sugars",
                        "foodId": "food_b7rbtshahirxisbtyc77sbv8jdue",
                        "image": "https://www.edamam.com/food-img/290/290624aa4c0e279551e462443e38bb40.jpg"
                    },
                    {
                        "text": "4 oz non-dairy dark chocolate or semi-sweet plus 2 tbsp vegan butter (or regular butter)",
                        "weight": 113.3980925,
                        "foodCategory": "Oils",
                        "foodId": "food_bn7cczea5psahcbaqvd2ob43qksr",
                        "image": "https://www.edamam.com/food-img/330/3302cd340e3d2dcf7f02e72fdfe8b209.jpg"
                    },
                    {
                        "text": "shredded coconut",
                        "weight": 0,
                        "foodCategory": "plant-based protein",
                        "foodId": "food_a9ua70bboyd4rebvrdwb0benu8pn",
                        "image": "https://www.edamam.com/food-img/d76/d76b9333b99d55d69b023d81d179aa39.jpg"
                    }
                ],
                "calories": 5351.45763769938,
                "totalWeight": 946.5980924994041,
                "totalTime": 85,
                "cuisineType": [
                    "american"
                ],
                "mealType": [
                    "teatime"
                ],
                "dishType": [
                    "desserts"
                ],
                "totalNutrients": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 5351.45763769938,
                        "unit": "kcal"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 431.03283749997274,
                        "unit": "g"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 372.19330165341216,
                        "unit": "g"
                    },
                    "FATRN": {
                        "label": "Trans",
                        "quantity": 0.9311455977250002,
                        "unit": "g"
                    },
                    "FAMS": {
                        "label": "Monounsaturated",
                        "quantity": 20.664333097716778,
                        "unit": "g"
                    },
                    "FAPU": {
                        "label": "Polyunsaturated",
                        "quantity": 11.820240499997556,
                        "unit": "g"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 380.0740249999344,
                        "unit": "g"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 31.883750000000003,
                        "unit": "g"
                    },
                    "SUGAR": {
                        "label": "Sugars",
                        "quantity": 284.4555249999345,
                        "unit": "g"
                    },
                    "SUGAR.added": {
                        "label": "Sugars, added",
                        "quantity": 249.39749999993444,
                        "unit": "g"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 33.504494999970085,
                        "unit": "g"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 189.5699999994994,
                        "unit": "mg"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 630.6518855496365,
                        "unit": "mg"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 307.1509809243623,
                        "unit": "mg"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 373.0964999999345,
                        "unit": "mg"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 1505.6174809241177,
                        "unit": "mg"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 14.372537138747912,
                        "unit": "mg"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 6.8783884739967815,
                        "unit": "mg"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 893.5119999993263,
                        "unit": "mg"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 86.07249999970797,
                        "unit": "µg"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 1.575,
                        "unit": "mg"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 0.4612544999997736,
                        "unit": "mg"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 1.2223549999985697,
                        "unit": "mg"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 7.3350974999993745,
                        "unit": "mg"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 0.5991494999997139,
                        "unit": "mg"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 209.05499999994038,
                        "unit": "µg"
                    },
                    "FOLFD": {
                        "label": "Folate (food)",
                        "quantity": 79.90499999994042,
                        "unit": "µg"
                    },
                    "FOLAC": {
                        "label": "Folic acid",
                        "quantity": 75.60000000000001,
                        "unit": "µg"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 0.5201749999976757,
                        "unit": "µg"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 0.86,
                        "unit": "µg"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 24.30454232424869,
                        "unit": "mg"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 97.99982884749882,
                        "unit": "µg"
                    },
                    "WATER": {
                        "label": "Water",
                        "quantity": 93.74678404578002,
                        "unit": "g"
                    }
                },
                "totalDaily": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 267.57288188496904,
                        "unit": "%"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 663.1274423076503,
                        "unit": "%"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 1860.966508267061,
                        "unit": "%"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 126.6913416666448,
                        "unit": "%"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 127.53500000000003,
                        "unit": "%"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 67.00898999994017,
                        "unit": "%"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 63.18999999983314,
                        "unit": "%"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 26.27716189790152,
                        "unit": "%"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 30.715098092436225,
                        "unit": "%"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 88.8324999999844,
                        "unit": "%"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 32.034414487747185,
                        "unit": "%"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 79.84742854859951,
                        "unit": "%"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 62.530804309061644,
                        "unit": "%"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 127.64457142847519,
                        "unit": "%"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 9.563611111078664,
                        "unit": "%"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 1.75,
                        "unit": "%"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 38.43787499998113,
                        "unit": "%"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 94.02730769219767,
                        "unit": "%"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 45.84435937499609,
                        "unit": "%"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 46.088423076901066,
                        "unit": "%"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 52.263749999985095,
                        "unit": "%"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 21.673958333236488,
                        "unit": "%"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 5.733333333333333,
                        "unit": "%"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 162.03028216165794,
                        "unit": "%"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 81.66652403958234,
                        "unit": "%"
                    }
                },
                "digest": [
                    {
                        "label": "Fat",
                        "tag": "FAT",
                        "schemaOrgTag": "fatContent",
                        "total": 431.03283749997274,
                        "hasRDI": true,
                        "daily": 663.1274423076503,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Saturated",
                                "tag": "FASAT",
                                "schemaOrgTag": "saturatedFatContent",
                                "total": 372.19330165341216,
                                "hasRDI": true,
                                "daily": 1860.966508267061,
                                "unit": "g"
                            },
                            {
                                "label": "Trans",
                                "tag": "FATRN",
                                "schemaOrgTag": "transFatContent",
                                "total": 0.9311455977250002,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Monounsaturated",
                                "tag": "FAMS",
                                "schemaOrgTag": null,
                                "total": 20.664333097716778,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Polyunsaturated",
                                "tag": "FAPU",
                                "schemaOrgTag": null,
                                "total": 11.820240499997556,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Carbs",
                        "tag": "CHOCDF",
                        "schemaOrgTag": "carbohydrateContent",
                        "total": 380.0740249999344,
                        "hasRDI": true,
                        "daily": 126.6913416666448,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Carbs (net)",
                                "tag": "CHOCDF.net",
                                "schemaOrgTag": null,
                                "total": 348.1902749999344,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Fiber",
                                "tag": "FIBTG",
                                "schemaOrgTag": "fiberContent",
                                "total": 31.883750000000003,
                                "hasRDI": true,
                                "daily": 127.53500000000003,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars",
                                "tag": "SUGAR",
                                "schemaOrgTag": "sugarContent",
                                "total": 284.4555249999345,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars, added",
                                "tag": "SUGAR.added",
                                "schemaOrgTag": null,
                                "total": 249.39749999993444,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Protein",
                        "tag": "PROCNT",
                        "schemaOrgTag": "proteinContent",
                        "total": 33.504494999970085,
                        "hasRDI": true,
                        "daily": 67.00898999994017,
                        "unit": "g"
                    },
                    {
                        "label": "Cholesterol",
                        "tag": "CHOLE",
                        "schemaOrgTag": "cholesterolContent",
                        "total": 189.5699999994994,
                        "hasRDI": true,
                        "daily": 63.18999999983314,
                        "unit": "mg"
                    },
                    {
                        "label": "Sodium",
                        "tag": "NA",
                        "schemaOrgTag": "sodiumContent",
                        "total": 630.6518855496365,
                        "hasRDI": true,
                        "daily": 26.27716189790152,
                        "unit": "mg"
                    },
                    {
                        "label": "Calcium",
                        "tag": "CA",
                        "schemaOrgTag": null,
                        "total": 307.1509809243623,
                        "hasRDI": true,
                        "daily": 30.715098092436225,
                        "unit": "mg"
                    },
                    {
                        "label": "Magnesium",
                        "tag": "MG",
                        "schemaOrgTag": null,
                        "total": 373.0964999999345,
                        "hasRDI": true,
                        "daily": 88.8324999999844,
                        "unit": "mg"
                    },
                    {
                        "label": "Potassium",
                        "tag": "K",
                        "schemaOrgTag": null,
                        "total": 1505.6174809241177,
                        "hasRDI": true,
                        "daily": 32.034414487747185,
                        "unit": "mg"
                    },
                    {
                        "label": "Iron",
                        "tag": "FE",
                        "schemaOrgTag": null,
                        "total": 14.372537138747912,
                        "hasRDI": true,
                        "daily": 79.84742854859951,
                        "unit": "mg"
                    },
                    {
                        "label": "Zinc",
                        "tag": "ZN",
                        "schemaOrgTag": null,
                        "total": 6.8783884739967815,
                        "hasRDI": true,
                        "daily": 62.530804309061644,
                        "unit": "mg"
                    },
                    {
                        "label": "Phosphorus",
                        "tag": "P",
                        "schemaOrgTag": null,
                        "total": 893.5119999993263,
                        "hasRDI": true,
                        "daily": 127.64457142847519,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin A",
                        "tag": "VITA_RAE",
                        "schemaOrgTag": null,
                        "total": 86.07249999970797,
                        "hasRDI": true,
                        "daily": 9.563611111078664,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin C",
                        "tag": "VITC",
                        "schemaOrgTag": null,
                        "total": 1.575,
                        "hasRDI": true,
                        "daily": 1.75,
                        "unit": "mg"
                    },
                    {
                        "label": "Thiamin (B1)",
                        "tag": "THIA",
                        "schemaOrgTag": null,
                        "total": 0.4612544999997736,
                        "hasRDI": true,
                        "daily": 38.43787499998113,
                        "unit": "mg"
                    },
                    {
                        "label": "Riboflavin (B2)",
                        "tag": "RIBF",
                        "schemaOrgTag": null,
                        "total": 1.2223549999985697,
                        "hasRDI": true,
                        "daily": 94.02730769219767,
                        "unit": "mg"
                    },
                    {
                        "label": "Niacin (B3)",
                        "tag": "NIA",
                        "schemaOrgTag": null,
                        "total": 7.3350974999993745,
                        "hasRDI": true,
                        "daily": 45.84435937499609,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin B6",
                        "tag": "VITB6A",
                        "schemaOrgTag": null,
                        "total": 0.5991494999997139,
                        "hasRDI": true,
                        "daily": 46.088423076901066,
                        "unit": "mg"
                    },
                    {
                        "label": "Folate equivalent (total)",
                        "tag": "FOLDFE",
                        "schemaOrgTag": null,
                        "total": 209.05499999994038,
                        "hasRDI": true,
                        "daily": 52.263749999985095,
                        "unit": "µg"
                    },
                    {
                        "label": "Folate (food)",
                        "tag": "FOLFD",
                        "schemaOrgTag": null,
                        "total": 79.90499999994042,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Folic acid",
                        "tag": "FOLAC",
                        "schemaOrgTag": null,
                        "total": 75.60000000000001,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin B12",
                        "tag": "VITB12",
                        "schemaOrgTag": null,
                        "total": 0.5201749999976757,
                        "hasRDI": true,
                        "daily": 21.673958333236488,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin D",
                        "tag": "VITD",
                        "schemaOrgTag": null,
                        "total": 0.86,
                        "hasRDI": true,
                        "daily": 5.733333333333333,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin E",
                        "tag": "TOCPHA",
                        "schemaOrgTag": null,
                        "total": 24.30454232424869,
                        "hasRDI": true,
                        "daily": 162.03028216165794,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin K",
                        "tag": "VITK1",
                        "schemaOrgTag": null,
                        "total": 97.99982884749882,
                        "hasRDI": true,
                        "daily": 81.66652403958234,
                        "unit": "µg"
                    },
                    {
                        "label": "Sugar alcohols",
                        "tag": "Sugar.alcohol",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    },
                    {
                        "label": "Water",
                        "tag": "WATER",
                        "schemaOrgTag": null,
                        "total": 93.74678404578002,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    }
                ]
            },
            "_links": {
                "self": {
                    "href": "https://api.edamam.com/api/recipes/v2/296651641ed9f6eb29705f3d7fdb22da?type=public&app_id=ea1d37d5&app_key=fd382a172ba8d6668c0430dc9c14a181",
                    "title": "Self"
                }
            }
        },
        {
            "recipe": {
                "uri": "http://www.edamam.com/ontologies/edamam.owl#recipe_2b83575867c1f5f3e6e001db1e6c5fbc",
                "label": "Vegan Stovetop Lasagna",
                "image": "https://www.edamam.com/web-img/3b5/3b5b3ba26f08f288f451f7e6e95fb429.jpg",
                "source": "The Daily Meal",
                "url": "http://www.thedailymeal.com/recipes/vegan-stovetop-lasagna-recipe",
                "shareAs": "http://www.edamam.com/recipe/vegan-stovetop-lasagna-2b83575867c1f5f3e6e001db1e6c5fbc/vegan",
                "yield": 12,
                "dietLabels": [
                    "Balanced"
                ],
                "healthLabels": [
                    "Vegetarian",
                    "Pescatarian",
                    "Dairy-Free",
                    "Egg-Free",
                    "Peanut-Free",
                    "Tree-Nut-Free",
                    "Soy-Free",
                    "Fish-Free",
                    "Shellfish-Free",
                    "Pork-Free",
                    "Red-Meat-Free",
                    "Crustacean-Free",
                    "Celery-Free",
                    "Mustard-Free",
                    "Sesame-Free",
                    "Lupine-Free",
                    "Mollusk-Free",
                    "Alcohol-Free",
                    "Sulfite-Free",
                    "Kosher"
                ],
                "cautions": [
                    "Tree-Nuts",
                    "Soy",
                    "Sulfites",
                    "FODMAP"
                ],
                "ingredientLines": [
                    "2 Tablespoons olive oil",
                    "1 Pound portabella mushroom, chopped",
                    "Salt, to taste",
                    "Pepper, to taste",
                    "2 Tablespoons herbes de Provence",
                    "2 cloves of garlic, minced",
                    "1 twenty-six ounce jar of marinara sauce, (about three and a half cups), divided",
                    "1 package no-boil lasagna noodles",
                    "8 Ounces vegan mozzarella cheese, shredded",
                    "1 Cup vegan cream cheese"
                ],
                "ingredients": [
                    {
                        "text": "2 Tablespoons olive oil",
                        "weight": 27,
                        "foodCategory": "Oils",
                        "foodId": "food_b1d1icuad3iktrbqby0hiagafaz7",
                        "image": "https://www.edamam.com/food-img/4d6/4d651eaa8a353647746290c7a9b29d84.jpg"
                    },
                    {
                        "text": "1 Pound portabella mushroom, chopped",
                        "weight": 453.59237,
                        "foodCategory": "vegetables",
                        "foodId": "food_bikaydza0r1y3ja1c2nxxbqnynlg",
                        "image": "https://www.edamam.com/food-img/245/2457f8850f43817dfeb967825467ef1e.jpg"
                    },
                    {
                        "text": "Salt, to taste",
                        "weight": 14.01473133,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_btxz81db72hwbra2pncvebzzzum9",
                        "image": "https://www.edamam.com/food-img/694/6943ea510918c6025795e8dc6e6eaaeb.jpg"
                    },
                    {
                        "text": "Pepper, to taste",
                        "weight": 7.007365665,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_b6ywzluaaxv02wad7s1r9ag4py89",
                        "image": "https://www.edamam.com/food-img/c6e/c6e5c3bd8d3bc15175d9766971a4d1b2.jpg"
                    },
                    {
                        "text": "2 Tablespoons herbes de Provence",
                        "weight": 5.4,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_avsq22zadwyb5cb5sl1byaa4mbo8",
                        "image": "https://www.edamam.com/food-img/89b/89b37a04e46e052671d73addcb84aa51.jpg"
                    },
                    {
                        "text": "2 cloves of garlic, minced",
                        "weight": 6,
                        "foodCategory": "vegetables",
                        "foodId": "food_avtcmx6bgjv1jvay6s6stan8dnyp",
                        "image": "https://www.edamam.com/food-img/6ee/6ee142951f48aaf94f4312409f8d133d.jpg"
                    },
                    {
                        "text": "1 twenty-six ounce jar of marinara sauce, (about three and a half cups), divided",
                        "weight": 924,
                        "foodCategory": "canned soup",
                        "foodId": "food_a7hv5mybkkrs3ub78yhtxafs67bu",
                        "image": "https://www.edamam.com/food-img/08b/08b3bb49c006689a458a8b9c4a4e0057.jpg"
                    },
                    {
                        "text": "1 package no-boil lasagna noodles",
                        "weight": 453,
                        "foodCategory": "grains",
                        "foodId": "food_a8hs60uayl5icia1qe8qoba1kwp8",
                        "image": "https://www.edamam.com/food-img/296/296ff2b02ef3822928c3c923e22c7d19.jpg"
                    },
                    {
                        "text": "8 Ounces vegan mozzarella cheese, shredded",
                        "weight": 226.796185,
                        "foodCategory": "Cheese",
                        "foodId": "food_bdofwyyb2xhmb1bx3uyz9broefm7",
                        "image": "https://www.edamam.com/food-img/8dc/8dcc66cd29b3f5c76d55cdbe046ad860.jpg"
                    },
                    {
                        "text": "1 Cup vegan cream cheese",
                        "weight": 240,
                        "foodCategory": "Plant-based protein",
                        "foodId": "food_afw1vv1ac3l17wbn9gcq2autcc91",
                        "image": "https://www.edamam.com/food-img/fc7/fc77c17a6b7310e939f328b32dc64e81.jpg"
                    }
                ],
                "calories": 3772.5215415675375,
                "totalWeight": 2342.7959206650003,
                "totalTime": 0,
                "cuisineType": [
                    "american"
                ],
                "mealType": [
                    "lunch/dinner"
                ],
                "dishType": [
                    "main course"
                ],
                "totalNutrients": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 3772.5215415675375,
                        "unit": "kcal"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 147.15464657751772,
                        "unit": "g"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 38.718440829019706,
                        "unit": "g"
                    },
                    "FATRN": {
                        "label": "Trans",
                        "quantity": 0.0643436948,
                        "unit": "g"
                    },
                    "FAMS": {
                        "label": "Monounsaturated",
                        "quantity": 38.28500873581435,
                        "unit": "g"
                    },
                    "FAPU": {
                        "label": "Polyunsaturated",
                        "quantity": 14.7116042775367,
                        "unit": "g"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 512.2123585028804,
                        "unit": "g"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 56.405435290986944,
                        "unit": "g"
                    },
                    "SUGAR": {
                        "label": "Sugars",
                        "quantity": 135.87668886362698,
                        "unit": "g"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 124.76939768683545,
                        "unit": "g"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 18.48,
                        "unit": "mg"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 6428.0809117475155,
                        "unit": "mg"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 2040.7458391733696,
                        "unit": "mg"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 524.75903113715,
                        "unit": "mg"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 6802.1627582378505,
                        "unit": "mg"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 26.11431048661989,
                        "unit": "mg"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 15.4805339644135,
                        "unit": "mg"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 3013.5371559007003,
                        "unit": "mg"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 1308.1713171795502,
                        "unit": "µg"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 23.278796185,
                        "unit": "mg"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 1.0033164613182,
                        "unit": "mg"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 2.4728444005970003,
                        "unit": "mg"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 65.38631920380095,
                        "unit": "mg"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 3.15295419603515,
                        "unit": "mg"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 369.78069611305006,
                        "unit": "µg"
                    },
                    "FOLFD": {
                        "label": "Folate (food)",
                        "quantity": 369.78069611305006,
                        "unit": "µg"
                    },
                    "FOLAC": {
                        "label": "Folic acid",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 2.0638452835000005,
                        "unit": "µg"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 1.3607771100000001,
                        "unit": "µg"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 27.370590880416,
                        "unit": "mg"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 251.56701944360503,
                        "unit": "µg"
                    },
                    "WATER": {
                        "label": "Water",
                        "quantity": 1385.574288811859,
                        "unit": "g"
                    }
                },
                "totalDaily": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 188.62607707837688,
                        "unit": "%"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 226.39176396541188,
                        "unit": "%"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 193.59220414509852,
                        "unit": "%"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 170.7374528342935,
                        "unit": "%"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 225.62174116394777,
                        "unit": "%"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 249.53879537367092,
                        "unit": "%"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 6.16,
                        "unit": "%"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 267.8367046561465,
                        "unit": "%"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 204.07458391733698,
                        "unit": "%"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 124.9426264612262,
                        "unit": "%"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 144.72686719655002,
                        "unit": "%"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 145.07950270344384,
                        "unit": "%"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 140.73212694921364,
                        "unit": "%"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 430.5053079858144,
                        "unit": "%"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 145.35236857550558,
                        "unit": "%"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 25.865329094444444,
                        "unit": "%"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 83.60970510985,
                        "unit": "%"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 190.21880004592308,
                        "unit": "%"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 408.66449502375593,
                        "unit": "%"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 242.53493815655003,
                        "unit": "%"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 92.44517402826251,
                        "unit": "%"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 85.99355347916669,
                        "unit": "%"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 9.071847400000001,
                        "unit": "%"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 182.47060586944,
                        "unit": "%"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 209.63918286967086,
                        "unit": "%"
                    }
                },
                "digest": [
                    {
                        "label": "Fat",
                        "tag": "FAT",
                        "schemaOrgTag": "fatContent",
                        "total": 147.15464657751772,
                        "hasRDI": true,
                        "daily": 226.39176396541188,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Saturated",
                                "tag": "FASAT",
                                "schemaOrgTag": "saturatedFatContent",
                                "total": 38.718440829019706,
                                "hasRDI": true,
                                "daily": 193.59220414509852,
                                "unit": "g"
                            },
                            {
                                "label": "Trans",
                                "tag": "FATRN",
                                "schemaOrgTag": "transFatContent",
                                "total": 0.0643436948,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Monounsaturated",
                                "tag": "FAMS",
                                "schemaOrgTag": null,
                                "total": 38.28500873581435,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Polyunsaturated",
                                "tag": "FAPU",
                                "schemaOrgTag": null,
                                "total": 14.7116042775367,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Carbs",
                        "tag": "CHOCDF",
                        "schemaOrgTag": "carbohydrateContent",
                        "total": 512.2123585028804,
                        "hasRDI": true,
                        "daily": 170.7374528342935,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Carbs (net)",
                                "tag": "CHOCDF.net",
                                "schemaOrgTag": null,
                                "total": 455.8069232118935,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Fiber",
                                "tag": "FIBTG",
                                "schemaOrgTag": "fiberContent",
                                "total": 56.405435290986944,
                                "hasRDI": true,
                                "daily": 225.62174116394777,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars",
                                "tag": "SUGAR",
                                "schemaOrgTag": "sugarContent",
                                "total": 135.87668886362698,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars, added",
                                "tag": "SUGAR.added",
                                "schemaOrgTag": null,
                                "total": 0,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Protein",
                        "tag": "PROCNT",
                        "schemaOrgTag": "proteinContent",
                        "total": 124.76939768683545,
                        "hasRDI": true,
                        "daily": 249.53879537367092,
                        "unit": "g"
                    },
                    {
                        "label": "Cholesterol",
                        "tag": "CHOLE",
                        "schemaOrgTag": "cholesterolContent",
                        "total": 18.48,
                        "hasRDI": true,
                        "daily": 6.16,
                        "unit": "mg"
                    },
                    {
                        "label": "Sodium",
                        "tag": "NA",
                        "schemaOrgTag": "sodiumContent",
                        "total": 6428.0809117475155,
                        "hasRDI": true,
                        "daily": 267.8367046561465,
                        "unit": "mg"
                    },
                    {
                        "label": "Calcium",
                        "tag": "CA",
                        "schemaOrgTag": null,
                        "total": 2040.7458391733696,
                        "hasRDI": true,
                        "daily": 204.07458391733698,
                        "unit": "mg"
                    },
                    {
                        "label": "Magnesium",
                        "tag": "MG",
                        "schemaOrgTag": null,
                        "total": 524.75903113715,
                        "hasRDI": true,
                        "daily": 124.9426264612262,
                        "unit": "mg"
                    },
                    {
                        "label": "Potassium",
                        "tag": "K",
                        "schemaOrgTag": null,
                        "total": 6802.1627582378505,
                        "hasRDI": true,
                        "daily": 144.72686719655002,
                        "unit": "mg"
                    },
                    {
                        "label": "Iron",
                        "tag": "FE",
                        "schemaOrgTag": null,
                        "total": 26.11431048661989,
                        "hasRDI": true,
                        "daily": 145.07950270344384,
                        "unit": "mg"
                    },
                    {
                        "label": "Zinc",
                        "tag": "ZN",
                        "schemaOrgTag": null,
                        "total": 15.4805339644135,
                        "hasRDI": true,
                        "daily": 140.73212694921364,
                        "unit": "mg"
                    },
                    {
                        "label": "Phosphorus",
                        "tag": "P",
                        "schemaOrgTag": null,
                        "total": 3013.5371559007003,
                        "hasRDI": true,
                        "daily": 430.5053079858144,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin A",
                        "tag": "VITA_RAE",
                        "schemaOrgTag": null,
                        "total": 1308.1713171795502,
                        "hasRDI": true,
                        "daily": 145.35236857550558,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin C",
                        "tag": "VITC",
                        "schemaOrgTag": null,
                        "total": 23.278796185,
                        "hasRDI": true,
                        "daily": 25.865329094444444,
                        "unit": "mg"
                    },
                    {
                        "label": "Thiamin (B1)",
                        "tag": "THIA",
                        "schemaOrgTag": null,
                        "total": 1.0033164613182,
                        "hasRDI": true,
                        "daily": 83.60970510985,
                        "unit": "mg"
                    },
                    {
                        "label": "Riboflavin (B2)",
                        "tag": "RIBF",
                        "schemaOrgTag": null,
                        "total": 2.4728444005970003,
                        "hasRDI": true,
                        "daily": 190.21880004592308,
                        "unit": "mg"
                    },
                    {
                        "label": "Niacin (B3)",
                        "tag": "NIA",
                        "schemaOrgTag": null,
                        "total": 65.38631920380095,
                        "hasRDI": true,
                        "daily": 408.66449502375593,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin B6",
                        "tag": "VITB6A",
                        "schemaOrgTag": null,
                        "total": 3.15295419603515,
                        "hasRDI": true,
                        "daily": 242.53493815655003,
                        "unit": "mg"
                    },
                    {
                        "label": "Folate equivalent (total)",
                        "tag": "FOLDFE",
                        "schemaOrgTag": null,
                        "total": 369.78069611305006,
                        "hasRDI": true,
                        "daily": 92.44517402826251,
                        "unit": "µg"
                    },
                    {
                        "label": "Folate (food)",
                        "tag": "FOLFD",
                        "schemaOrgTag": null,
                        "total": 369.78069611305006,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Folic acid",
                        "tag": "FOLAC",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin B12",
                        "tag": "VITB12",
                        "schemaOrgTag": null,
                        "total": 2.0638452835000005,
                        "hasRDI": true,
                        "daily": 85.99355347916669,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin D",
                        "tag": "VITD",
                        "schemaOrgTag": null,
                        "total": 1.3607771100000001,
                        "hasRDI": true,
                        "daily": 9.071847400000001,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin E",
                        "tag": "TOCPHA",
                        "schemaOrgTag": null,
                        "total": 27.370590880416,
                        "hasRDI": true,
                        "daily": 182.47060586944,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin K",
                        "tag": "VITK1",
                        "schemaOrgTag": null,
                        "total": 251.56701944360503,
                        "hasRDI": true,
                        "daily": 209.63918286967086,
                        "unit": "µg"
                    },
                    {
                        "label": "Sugar alcohols",
                        "tag": "Sugar.alcohol",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    },
                    {
                        "label": "Water",
                        "tag": "WATER",
                        "schemaOrgTag": null,
                        "total": 1385.574288811859,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    }
                ]
            },
            "_links": {
                "self": {
                    "href": "https://api.edamam.com/api/recipes/v2/2b83575867c1f5f3e6e001db1e6c5fbc?type=public&app_id=ea1d37d5&app_key=fd382a172ba8d6668c0430dc9c14a181",
                    "title": "Self"
                }
            }
        },
        {
            "recipe": {
                "uri": "http://www.edamam.com/ontologies/edamam.owl#recipe_7c43fc541413fd0e5f1688b195df9573",
                "label": "Vegan Chocolate Chocolate Chip Cookies",
                "image": "https://www.edamam.com/web-img/471/471b73021785f73d5a5165eadb0a27b6.jpg",
                "source": "Joy the Baker",
                "url": "http://www.joythebaker.com/blog/2011/04/vegan-chocolate-chocolate-chip-cookies/",
                "shareAs": "http://www.edamam.com/recipe/vegan-chocolate-chocolate-chip-cookies-7c43fc541413fd0e5f1688b195df9573/vegan",
                "yield": 24,
                "dietLabels": [
                    "Low-Sodium"
                ],
                "healthLabels": [
                    "Low Potassium",
                    "Kidney-Friendly",
                    "Kosher"
                ],
                "cautions": [
                    "Sulfites"
                ],
                "ingredientLines": [
                    "2 1/2 cups all-purpose flour",
                    "1/2 cup unsweetened cocoa powder",
                    "1 teaspoon baking powder",
                    "1/2 teaspoon baking soda",
                    "1/2 teaspoon salt",
                    "1 cup sugar (vegan)",
                    "2 tablespoons flax seed meal",
                    "1/2 cup applesauce",
                    "1/4 cup canola oil",
                    "1/2 cup chocolate coated sunflower seeds",
                    "1/2 cup chocolate chips (or 1 cup vegan chocolate chips)",
                    "1 teaspoon pure vanilla extract"
                ],
                "ingredients": [
                    {
                        "text": "2 1/2 cups all-purpose flour",
                        "weight": 312.5,
                        "foodCategory": "grains",
                        "foodId": "food_ar3x97tbq9o9p6b6gzwj0am0c81l",
                        "image": "https://www.edamam.com/food-img/368/368077bbcab62f862a8c766a56ea5dd1.jpg"
                    },
                    {
                        "text": "1/2 cup unsweetened cocoa powder",
                        "weight": 43,
                        "foodCategory": "chocolate",
                        "foodId": "food_afcmkjjaqwjkezbfz7htdb7mpkwz",
                        "image": "https://www.edamam.com/food-img/89a/89af89595db3cf2c3007f2b064c5fef6.jpg"
                    },
                    {
                        "text": "1 teaspoon baking powder",
                        "weight": 4.6,
                        "foodCategory": "condiments and sauces",
                        "foodId": "food_bad4zycbt4w60dbut111vaub2g3e",
                        "image": "https://www.edamam.com/food-img/a84/a8410ec57a2e62a1ad9955ac14d40af6.jpg"
                    },
                    {
                        "text": "1/2 teaspoon baking soda",
                        "weight": 2.3,
                        "foodCategory": "condiments and sauces",
                        "foodId": "food_asa4cjoa3lmt8ibwdg0cpblheo69",
                        "image": "https://www.edamam.com/food-img/7e5/7e55e4482cc2fde91f427fc568e6f5b8.jpeg"
                    },
                    {
                        "text": "1/2 teaspoon salt",
                        "weight": 3,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_btxz81db72hwbra2pncvebzzzum9",
                        "image": "https://www.edamam.com/food-img/694/6943ea510918c6025795e8dc6e6eaaeb.jpg"
                    },
                    {
                        "text": "1 cup sugar (vegan)",
                        "weight": 200,
                        "foodCategory": "sugars",
                        "foodId": "food_axi2ijobrk819yb0adceobnhm1c2",
                        "image": "https://www.edamam.com/food-img/ecb/ecb3f5aaed96d0188c21b8369be07765.jpg"
                    },
                    {
                        "text": "2 tablespoons flax seed meal",
                        "weight": 20.6,
                        "foodCategory": "plant-based protein",
                        "foodId": "food_ahetcthajw7myuay9fe2jbwgxqx9",
                        "image": "https://www.edamam.com/food-img/e9b/e9bd9cc62d0dbe0753911e295a0ba0ca.jpg"
                    },
                    {
                        "text": "1/2 cup applesauce",
                        "weight": 122,
                        "foodCategory": "canned fruit",
                        "foodId": "food_a42ufi8ben9zhqbzqv66lab1lwvd",
                        "image": "https://www.edamam.com/food-img/c59/c59e749347516e4aa0aaa3ea25925426.jpg"
                    },
                    {
                        "text": "1/4 cup canola oil",
                        "weight": 54.5,
                        "foodCategory": "Oils",
                        "foodId": "food_bk9p9aaavhvoq4bqsnprobpsiuxs",
                        "image": "https://www.edamam.com/food-img/07e/07e106ab3536d57428e5c46d009038f8.jpg"
                    },
                    {
                        "text": "1/2 cup chocolate coated sunflower seeds",
                        "weight": 23,
                        "foodCategory": "plant-based protein",
                        "foodId": "food_ay6dklzbwv5bbfbw3dayyauiaznx",
                        "image": "https://www.edamam.com/food-img/c03/c035107b6716331396e91f7c2c0f2a04.jpg"
                    },
                    {
                        "text": "1/2 cup chocolate chips (or 1 cup vegan chocolate chips)",
                        "weight": 112,
                        "foodCategory": "chocolate",
                        "foodId": "food_b0camz2asgzienbko2epvbzzv6qj",
                        "image": "https://www.edamam.com/food-img/36c/36ce336d10d51259f365ec2dbc1e28c4.jpg"
                    },
                    {
                        "text": "1 teaspoon pure vanilla extract",
                        "weight": 4.2,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_bh1wvnqaw3q7ciascfoygaabax2a",
                        "image": "https://www.edamam.com/food-img/90f/90f910b0bf82750d4f6528263e014cca.jpg"
                    }
                ],
                "calories": 3363.5660000000003,
                "totalWeight": 901.2621623303577,
                "totalTime": 0,
                "cuisineType": [
                    "american"
                ],
                "mealType": [
                    "teatime"
                ],
                "dishType": [
                    "biscuits and cookies"
                ],
                "totalNutrients": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 3363.5660000000003,
                        "unit": "kcal"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 110.26198000000002,
                        "unit": "g"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 25.959728,
                        "unit": "g"
                    },
                    "FATRN": {
                        "label": "Trans",
                        "quantity": 0.42135500000000004,
                        "unit": "g"
                    },
                    "FAMS": {
                        "label": "Monounsaturated",
                        "quantity": 42.537257000000004,
                        "unit": "g"
                    },
                    "FAPU": {
                        "label": "Polyunsaturated",
                        "quantity": 28.074353000000002,
                        "unit": "g"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 565.87233,
                        "unit": "g"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 36.3245,
                        "unit": "g"
                    },
                    "SUGAR": {
                        "label": "Sugars",
                        "quantity": 284.15004999999996,
                        "unit": "g"
                    },
                    "SUGAR.added": {
                        "label": "Sugars, added",
                        "quantity": 269.64480000000003,
                        "unit": "g"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 54.824510000000004,
                        "unit": "g"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 16.8,
                        "unit": "mg"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 2089.9088760000004,
                        "unit": "mg"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 649.005918959286,
                        "unit": "mg"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 444.8056216233036,
                        "unit": "mg"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 1406.4539729864284,
                        "unit": "mg"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 25.13779513569018,
                        "unit": "mg"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 7.224542162330358,
                        "unit": "mg"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 1399.7519999999997,
                        "unit": "mg"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 1.9100000000000001,
                        "unit": "µg"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 26.981599999999997,
                        "unit": "mg"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 3.197911,
                        "unit": "mg"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 1.840786,
                        "unit": "mg"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 22.06141,
                        "unit": "mg"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 0.62906,
                        "unit": "mg"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 996.927,
                        "unit": "µg"
                    },
                    "FOLFD": {
                        "label": "Folate (food)",
                        "quantity": 178.177,
                        "unit": "µg"
                    },
                    "FOLAC": {
                        "label": "Folic acid",
                        "quantity": 481.25,
                        "unit": "µg"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 18.62561,
                        "unit": "mg"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 42.3668,
                        "unit": "µg"
                    },
                    "WATER": {
                        "label": "Water",
                        "quantity": 152.8121443246607,
                        "unit": "g"
                    }
                },
                "totalDaily": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 168.1783,
                        "unit": "%"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 169.63381538461542,
                        "unit": "%"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 129.79864,
                        "unit": "%"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 188.62411,
                        "unit": "%"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 145.298,
                        "unit": "%"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 109.64902000000001,
                        "unit": "%"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 5.6,
                        "unit": "%"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 87.07953650000002,
                        "unit": "%"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 64.9005918959286,
                        "unit": "%"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 105.90610038650085,
                        "unit": "%"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 29.92455261673252,
                        "unit": "%"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 139.654417420501,
                        "unit": "%"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 65.67765602118506,
                        "unit": "%"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 199.96457142857142,
                        "unit": "%"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 0.21222222222222223,
                        "unit": "%"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 29.979555555555553,
                        "unit": "%"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 266.4925833333333,
                        "unit": "%"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 141.59892307692306,
                        "unit": "%"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 137.8838125,
                        "unit": "%"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 48.389230769230764,
                        "unit": "%"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 249.23175,
                        "unit": "%"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 0,
                        "unit": "%"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 0,
                        "unit": "%"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 124.17073333333335,
                        "unit": "%"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 35.30566666666666,
                        "unit": "%"
                    }
                },
                "digest": [
                    {
                        "label": "Fat",
                        "tag": "FAT",
                        "schemaOrgTag": "fatContent",
                        "total": 110.26198000000002,
                        "hasRDI": true,
                        "daily": 169.63381538461542,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Saturated",
                                "tag": "FASAT",
                                "schemaOrgTag": "saturatedFatContent",
                                "total": 25.959728,
                                "hasRDI": true,
                                "daily": 129.79864,
                                "unit": "g"
                            },
                            {
                                "label": "Trans",
                                "tag": "FATRN",
                                "schemaOrgTag": "transFatContent",
                                "total": 0.42135500000000004,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Monounsaturated",
                                "tag": "FAMS",
                                "schemaOrgTag": null,
                                "total": 42.537257000000004,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Polyunsaturated",
                                "tag": "FAPU",
                                "schemaOrgTag": null,
                                "total": 28.074353000000002,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Carbs",
                        "tag": "CHOCDF",
                        "schemaOrgTag": "carbohydrateContent",
                        "total": 565.87233,
                        "hasRDI": true,
                        "daily": 188.62411,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Carbs (net)",
                                "tag": "CHOCDF.net",
                                "schemaOrgTag": null,
                                "total": 529.54783,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Fiber",
                                "tag": "FIBTG",
                                "schemaOrgTag": "fiberContent",
                                "total": 36.3245,
                                "hasRDI": true,
                                "daily": 145.298,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars",
                                "tag": "SUGAR",
                                "schemaOrgTag": "sugarContent",
                                "total": 284.15004999999996,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars, added",
                                "tag": "SUGAR.added",
                                "schemaOrgTag": null,
                                "total": 269.64480000000003,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Protein",
                        "tag": "PROCNT",
                        "schemaOrgTag": "proteinContent",
                        "total": 54.824510000000004,
                        "hasRDI": true,
                        "daily": 109.64902000000001,
                        "unit": "g"
                    },
                    {
                        "label": "Cholesterol",
                        "tag": "CHOLE",
                        "schemaOrgTag": "cholesterolContent",
                        "total": 16.8,
                        "hasRDI": true,
                        "daily": 5.6,
                        "unit": "mg"
                    },
                    {
                        "label": "Sodium",
                        "tag": "NA",
                        "schemaOrgTag": "sodiumContent",
                        "total": 2089.9088760000004,
                        "hasRDI": true,
                        "daily": 87.07953650000002,
                        "unit": "mg"
                    },
                    {
                        "label": "Calcium",
                        "tag": "CA",
                        "schemaOrgTag": null,
                        "total": 649.005918959286,
                        "hasRDI": true,
                        "daily": 64.9005918959286,
                        "unit": "mg"
                    },
                    {
                        "label": "Magnesium",
                        "tag": "MG",
                        "schemaOrgTag": null,
                        "total": 444.8056216233036,
                        "hasRDI": true,
                        "daily": 105.90610038650085,
                        "unit": "mg"
                    },
                    {
                        "label": "Potassium",
                        "tag": "K",
                        "schemaOrgTag": null,
                        "total": 1406.4539729864284,
                        "hasRDI": true,
                        "daily": 29.92455261673252,
                        "unit": "mg"
                    },
                    {
                        "label": "Iron",
                        "tag": "FE",
                        "schemaOrgTag": null,
                        "total": 25.13779513569018,
                        "hasRDI": true,
                        "daily": 139.654417420501,
                        "unit": "mg"
                    },
                    {
                        "label": "Zinc",
                        "tag": "ZN",
                        "schemaOrgTag": null,
                        "total": 7.224542162330358,
                        "hasRDI": true,
                        "daily": 65.67765602118506,
                        "unit": "mg"
                    },
                    {
                        "label": "Phosphorus",
                        "tag": "P",
                        "schemaOrgTag": null,
                        "total": 1399.7519999999997,
                        "hasRDI": true,
                        "daily": 199.96457142857142,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin A",
                        "tag": "VITA_RAE",
                        "schemaOrgTag": null,
                        "total": 1.9100000000000001,
                        "hasRDI": true,
                        "daily": 0.21222222222222223,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin C",
                        "tag": "VITC",
                        "schemaOrgTag": null,
                        "total": 26.981599999999997,
                        "hasRDI": true,
                        "daily": 29.979555555555553,
                        "unit": "mg"
                    },
                    {
                        "label": "Thiamin (B1)",
                        "tag": "THIA",
                        "schemaOrgTag": null,
                        "total": 3.197911,
                        "hasRDI": true,
                        "daily": 266.4925833333333,
                        "unit": "mg"
                    },
                    {
                        "label": "Riboflavin (B2)",
                        "tag": "RIBF",
                        "schemaOrgTag": null,
                        "total": 1.840786,
                        "hasRDI": true,
                        "daily": 141.59892307692306,
                        "unit": "mg"
                    },
                    {
                        "label": "Niacin (B3)",
                        "tag": "NIA",
                        "schemaOrgTag": null,
                        "total": 22.06141,
                        "hasRDI": true,
                        "daily": 137.8838125,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin B6",
                        "tag": "VITB6A",
                        "schemaOrgTag": null,
                        "total": 0.62906,
                        "hasRDI": true,
                        "daily": 48.389230769230764,
                        "unit": "mg"
                    },
                    {
                        "label": "Folate equivalent (total)",
                        "tag": "FOLDFE",
                        "schemaOrgTag": null,
                        "total": 996.927,
                        "hasRDI": true,
                        "daily": 249.23175,
                        "unit": "µg"
                    },
                    {
                        "label": "Folate (food)",
                        "tag": "FOLFD",
                        "schemaOrgTag": null,
                        "total": 178.177,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Folic acid",
                        "tag": "FOLAC",
                        "schemaOrgTag": null,
                        "total": 481.25,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin B12",
                        "tag": "VITB12",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": true,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin D",
                        "tag": "VITD",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": true,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin E",
                        "tag": "TOCPHA",
                        "schemaOrgTag": null,
                        "total": 18.62561,
                        "hasRDI": true,
                        "daily": 124.17073333333335,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin K",
                        "tag": "VITK1",
                        "schemaOrgTag": null,
                        "total": 42.3668,
                        "hasRDI": true,
                        "daily": 35.30566666666666,
                        "unit": "µg"
                    },
                    {
                        "label": "Sugar alcohols",
                        "tag": "Sugar.alcohol",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    },
                    {
                        "label": "Water",
                        "tag": "WATER",
                        "schemaOrgTag": null,
                        "total": 152.8121443246607,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    }
                ]
            },
            "_links": {
                "self": {
                    "href": "https://api.edamam.com/api/recipes/v2/7c43fc541413fd0e5f1688b195df9573?type=public&app_id=ea1d37d5&app_key=fd382a172ba8d6668c0430dc9c14a181",
                    "title": "Self"
                }
            }
        },
        {
            "recipe": {
                "uri": "http://www.edamam.com/ontologies/edamam.owl#recipe_5e34d2ed523eb868ade82f08d70b4720",
                "label": "Vegan Peanut Butter Cookies",
                "image": "https://www.edamam.com/web-img/4a0/4a0d3831ca63faa70490870212526a26.jpg",
                "source": "Elana's Pantry",
                "url": "http://www.elanaspantry.com/vegan-peanut-butter-cookies/",
                "shareAs": "http://www.edamam.com/recipe/vegan-peanut-butter-cookies-5e34d2ed523eb868ade82f08d70b4720/vegan",
                "yield": 8,
                "dietLabels": [
                    "Low-Carb",
                    "Low-Sodium"
                ],
                "healthLabels": [
                    "Kidney-Friendly",
                    "Vegan",
                    "Vegetarian",
                    "Pescatarian",
                    "Dairy-Free",
                    "Gluten-Free",
                    "Wheat-Free",
                    "Egg-Free",
                    "Soy-Free",
                    "Fish-Free",
                    "Shellfish-Free",
                    "Pork-Free",
                    "Red-Meat-Free",
                    "Crustacean-Free",
                    "Celery-Free",
                    "Mustard-Free",
                    "Sesame-Free",
                    "Lupine-Free",
                    "Mollusk-Free",
                    "Alcohol-Free",
                    "Sulfite-Free",
                    "FODMAP-Free",
                    "Kosher"
                ],
                "cautions": [
                    "Soy",
                    "Sulfites",
                    "FODMAP"
                ],
                "ingredientLines": [
                    "1 cup blanched almond flour",
                    "½ teaspoon celtic sea salt",
                    "¼ teaspoon baking soda",
                    "½ cup creamy roasted peanut butter",
                    "¼ cup agave nectar",
                    "2 tablespoons Spectrum vegan shortening",
                    "1 teaspoon vanilla extract"
                ],
                "ingredients": [
                    {
                        "text": "1 cup blanched almond flour",
                        "weight": 112,
                        "foodCategory": "grains",
                        "foodId": "food_aquymekalw81cfbcaho71btv3lnt",
                        "image": "https://www.edamam.com/food-img/4ce/4ce26863cf14ffeb473cc6f9edcc60f0.jpg"
                    },
                    {
                        "text": "½ teaspoon celtic sea salt",
                        "weight": 2.4270833334564377,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_a1vgrj1bs8rd1majvmd9ubz8ttkg",
                        "image": "https://www.edamam.com/food-img/694/6943ea510918c6025795e8dc6e6eaaeb.jpg"
                    },
                    {
                        "text": "¼ teaspoon baking soda",
                        "weight": 1.15,
                        "foodCategory": "condiments and sauces",
                        "foodId": "food_asa4cjoa3lmt8ibwdg0cpblheo69",
                        "image": "https://www.edamam.com/food-img/7e5/7e55e4482cc2fde91f427fc568e6f5b8.jpeg"
                    },
                    {
                        "text": "½ cup creamy roasted peanut butter",
                        "weight": 129,
                        "foodCategory": "plant-based protein",
                        "foodId": "food_bz6b8fsbccyn3zaij72f7av8dl9m",
                        "image": "https://www.edamam.com/food-img/d74/d740276ae1409472a8714b2cee88a310.jpg"
                    },
                    {
                        "text": "¼ cup agave nectar",
                        "weight": 83.2,
                        "foodCategory": "sugar syrups",
                        "foodId": "food_bj8pkd1bgey1rlbp58zagbjhpfi0",
                        "image": "https://www.edamam.com/food-img/3b5/3b5425ed8e35a486b4138cc8720ae9e4.jpg"
                    },
                    {
                        "text": "2 tablespoons Spectrum vegan shortening",
                        "weight": 25.6,
                        "foodCategory": "Oils",
                        "foodId": "food_aat37lwavnxkoobjwwu8fad9n917",
                        "image": null
                    },
                    {
                        "text": "1 teaspoon vanilla extract",
                        "weight": 4.2,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_bh1wvnqaw3q7ciascfoygaabax2a",
                        "image": "https://www.edamam.com/food-img/90f/90f910b0bf82750d4f6528263e014cca.jpg"
                    }
                ],
                "calories": 1903.3080000000002,
                "totalWeight": 356.40372161102226,
                "totalTime": 0,
                "cuisineType": [
                    "american"
                ],
                "mealType": [
                    "teatime"
                ],
                "dishType": [
                    "biscuits and cookies"
                ],
                "totalNutrients": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 1903.3080000000002,
                        "unit": "kcal"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 147.80444,
                        "unit": "g"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 23.57855,
                        "unit": "g"
                    },
                    "FATRN": {
                        "label": "Trans",
                        "quantity": 3.466734,
                        "unit": "g"
                    },
                    "FAMS": {
                        "label": "Monounsaturated",
                        "quantity": 44.007926,
                        "unit": "g"
                    },
                    "FAPU": {
                        "label": "Polyunsaturated",
                        "quantity": 23.363149999999997,
                        "unit": "g"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 113.86800000000001,
                        "unit": "g"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 22.202,
                        "unit": "g"
                    },
                    "SUGAR": {
                        "label": "Sugars",
                        "quantity": 76.99940000000001,
                        "unit": "g"
                    },
                    "SUGAR.added": {
                        "label": "Sugars, added",
                        "quantity": 59.072,
                        "unit": "g"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 53.707820000000005,
                        "unit": "g"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 0,
                        "unit": "mg"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 825.894222,
                        "unit": "mg"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 142.62889318664534,
                        "unit": "mg"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 217.2365372161102,
                        "unit": "mg"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 1541.8098977288819,
                        "unit": "mg"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 3.4812972813163743,
                        "unit": "mg"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 3.243773721611022,
                        "unit": "mg"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 964.1892,
                        "unit": "mg"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 0,
                        "unit": "mg"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 0.199082,
                        "unit": "mg"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 0.25167,
                        "unit": "mg"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 16.93233,
                        "unit": "mg"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 0.570238,
                        "unit": "mg"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 112.23,
                        "unit": "µg"
                    },
                    "FOLFD": {
                        "label": "Folate (food)",
                        "quantity": 112.23,
                        "unit": "µg"
                    },
                    "FOLAC": {
                        "label": "Folic acid",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 13.30828,
                        "unit": "mg"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 14.006200000000002,
                        "unit": "µg"
                    },
                    "WATER": {
                        "label": "Water",
                        "quantity": 3.7998674432220443,
                        "unit": "g"
                    }
                },
                "totalDaily": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 95.1654,
                        "unit": "%"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 227.39144615384615,
                        "unit": "%"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 117.89275,
                        "unit": "%"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 37.956,
                        "unit": "%"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 88.808,
                        "unit": "%"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 107.41564,
                        "unit": "%"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 0,
                        "unit": "%"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 34.41225925,
                        "unit": "%"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 14.262889318664534,
                        "unit": "%"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 51.722985051454806,
                        "unit": "%"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 32.80446590912515,
                        "unit": "%"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 19.340540451757633,
                        "unit": "%"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 29.488852014645655,
                        "unit": "%"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 137.74131428571428,
                        "unit": "%"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 0,
                        "unit": "%"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 0,
                        "unit": "%"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 16.59016666666667,
                        "unit": "%"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 19.35923076923077,
                        "unit": "%"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 105.8270625,
                        "unit": "%"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 43.86446153846154,
                        "unit": "%"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 28.0575,
                        "unit": "%"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 0,
                        "unit": "%"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 0,
                        "unit": "%"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 88.72186666666667,
                        "unit": "%"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 11.671833333333334,
                        "unit": "%"
                    }
                },
                "digest": [
                    {
                        "label": "Fat",
                        "tag": "FAT",
                        "schemaOrgTag": "fatContent",
                        "total": 147.80444,
                        "hasRDI": true,
                        "daily": 227.39144615384615,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Saturated",
                                "tag": "FASAT",
                                "schemaOrgTag": "saturatedFatContent",
                                "total": 23.57855,
                                "hasRDI": true,
                                "daily": 117.89275,
                                "unit": "g"
                            },
                            {
                                "label": "Trans",
                                "tag": "FATRN",
                                "schemaOrgTag": "transFatContent",
                                "total": 3.466734,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Monounsaturated",
                                "tag": "FAMS",
                                "schemaOrgTag": null,
                                "total": 44.007926,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Polyunsaturated",
                                "tag": "FAPU",
                                "schemaOrgTag": null,
                                "total": 23.363149999999997,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Carbs",
                        "tag": "CHOCDF",
                        "schemaOrgTag": "carbohydrateContent",
                        "total": 113.86800000000001,
                        "hasRDI": true,
                        "daily": 37.956,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Carbs (net)",
                                "tag": "CHOCDF.net",
                                "schemaOrgTag": null,
                                "total": 91.66600000000001,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Fiber",
                                "tag": "FIBTG",
                                "schemaOrgTag": "fiberContent",
                                "total": 22.202,
                                "hasRDI": true,
                                "daily": 88.808,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars",
                                "tag": "SUGAR",
                                "schemaOrgTag": "sugarContent",
                                "total": 76.99940000000001,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars, added",
                                "tag": "SUGAR.added",
                                "schemaOrgTag": null,
                                "total": 59.072,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Protein",
                        "tag": "PROCNT",
                        "schemaOrgTag": "proteinContent",
                        "total": 53.707820000000005,
                        "hasRDI": true,
                        "daily": 107.41564,
                        "unit": "g"
                    },
                    {
                        "label": "Cholesterol",
                        "tag": "CHOLE",
                        "schemaOrgTag": "cholesterolContent",
                        "total": 0,
                        "hasRDI": true,
                        "daily": 0,
                        "unit": "mg"
                    },
                    {
                        "label": "Sodium",
                        "tag": "NA",
                        "schemaOrgTag": "sodiumContent",
                        "total": 825.894222,
                        "hasRDI": true,
                        "daily": 34.41225925,
                        "unit": "mg"
                    },
                    {
                        "label": "Calcium",
                        "tag": "CA",
                        "schemaOrgTag": null,
                        "total": 142.62889318664534,
                        "hasRDI": true,
                        "daily": 14.262889318664534,
                        "unit": "mg"
                    },
                    {
                        "label": "Magnesium",
                        "tag": "MG",
                        "schemaOrgTag": null,
                        "total": 217.2365372161102,
                        "hasRDI": true,
                        "daily": 51.722985051454806,
                        "unit": "mg"
                    },
                    {
                        "label": "Potassium",
                        "tag": "K",
                        "schemaOrgTag": null,
                        "total": 1541.8098977288819,
                        "hasRDI": true,
                        "daily": 32.80446590912515,
                        "unit": "mg"
                    },
                    {
                        "label": "Iron",
                        "tag": "FE",
                        "schemaOrgTag": null,
                        "total": 3.4812972813163743,
                        "hasRDI": true,
                        "daily": 19.340540451757633,
                        "unit": "mg"
                    },
                    {
                        "label": "Zinc",
                        "tag": "ZN",
                        "schemaOrgTag": null,
                        "total": 3.243773721611022,
                        "hasRDI": true,
                        "daily": 29.488852014645655,
                        "unit": "mg"
                    },
                    {
                        "label": "Phosphorus",
                        "tag": "P",
                        "schemaOrgTag": null,
                        "total": 964.1892,
                        "hasRDI": true,
                        "daily": 137.74131428571428,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin A",
                        "tag": "VITA_RAE",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": true,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin C",
                        "tag": "VITC",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": true,
                        "daily": 0,
                        "unit": "mg"
                    },
                    {
                        "label": "Thiamin (B1)",
                        "tag": "THIA",
                        "schemaOrgTag": null,
                        "total": 0.199082,
                        "hasRDI": true,
                        "daily": 16.59016666666667,
                        "unit": "mg"
                    },
                    {
                        "label": "Riboflavin (B2)",
                        "tag": "RIBF",
                        "schemaOrgTag": null,
                        "total": 0.25167,
                        "hasRDI": true,
                        "daily": 19.35923076923077,
                        "unit": "mg"
                    },
                    {
                        "label": "Niacin (B3)",
                        "tag": "NIA",
                        "schemaOrgTag": null,
                        "total": 16.93233,
                        "hasRDI": true,
                        "daily": 105.8270625,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin B6",
                        "tag": "VITB6A",
                        "schemaOrgTag": null,
                        "total": 0.570238,
                        "hasRDI": true,
                        "daily": 43.86446153846154,
                        "unit": "mg"
                    },
                    {
                        "label": "Folate equivalent (total)",
                        "tag": "FOLDFE",
                        "schemaOrgTag": null,
                        "total": 112.23,
                        "hasRDI": true,
                        "daily": 28.0575,
                        "unit": "µg"
                    },
                    {
                        "label": "Folate (food)",
                        "tag": "FOLFD",
                        "schemaOrgTag": null,
                        "total": 112.23,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Folic acid",
                        "tag": "FOLAC",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin B12",
                        "tag": "VITB12",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": true,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin D",
                        "tag": "VITD",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": true,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin E",
                        "tag": "TOCPHA",
                        "schemaOrgTag": null,
                        "total": 13.30828,
                        "hasRDI": true,
                        "daily": 88.72186666666667,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin K",
                        "tag": "VITK1",
                        "schemaOrgTag": null,
                        "total": 14.006200000000002,
                        "hasRDI": true,
                        "daily": 11.671833333333334,
                        "unit": "µg"
                    },
                    {
                        "label": "Sugar alcohols",
                        "tag": "Sugar.alcohol",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    },
                    {
                        "label": "Water",
                        "tag": "WATER",
                        "schemaOrgTag": null,
                        "total": 3.7998674432220443,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    }
                ]
            },
            "_links": {
                "self": {
                    "href": "https://api.edamam.com/api/recipes/v2/5e34d2ed523eb868ade82f08d70b4720?type=public&app_id=ea1d37d5&app_key=fd382a172ba8d6668c0430dc9c14a181",
                    "title": "Self"
                }
            }
        },
        {
            "recipe": {
                "uri": "http://www.edamam.com/ontologies/edamam.owl#recipe_c605065c1f35288532c1ad312b7af40d",
                "label": "Vegan Italian Cold Cut Sandwich",
                "image": "https://www.edamam.com/web-img/525/5258c214636c54eea2e53ca19bf11273.jpeg",
                "source": "Food Network",
                "url": "https://www.foodnetwork.com/recipes/vegan-italian-cold-cut-sandwich-3373748",
                "shareAs": "http://www.edamam.com/recipe/vegan-italian-cold-cut-sandwich-c605065c1f35288532c1ad312b7af40d/vegan",
                "yield": 8,
                "dietLabels": [],
                "healthLabels": [
                    "Sugar-Conscious",
                    "Low Potassium",
                    "Kidney-Friendly",
                    "Dairy-Free",
                    "Egg-Free",
                    "Peanut-Free",
                    "Tree-Nut-Free",
                    "Soy-Free",
                    "Fish-Free",
                    "Shellfish-Free",
                    "Crustacean-Free",
                    "Celery-Free",
                    "Sesame-Free",
                    "Lupine-Free",
                    "Mollusk-Free",
                    "Alcohol-Free",
                    "Sulfite-Free"
                ],
                "cautions": [
                    "Soy",
                    "Sulfites"
                ],
                "ingredientLines": [
                    "One 8-ounce hoagie roll",
                    "2 tablespoons vegan mayonnaise",
                    "2 ounces vegan pastrami",
                    "2 ounces vegan capicola",
                    "2 ounces vegan pepperoni",
                    "2 ounces vegan mozzarella cheese",
                    "1/8 red onion, sliced thin",
                    "4 thin slices tomato",
                    "1/3 cup shredded lettuce",
                    "2 tablespoons sweet pepper relish",
                    "1/8 teaspoon salt",
                    "1/4 teaspoon black pepper",
                    "1/4 teaspoon oregano",
                    "2 tablespoons sunflower oil",
                    "2 tablespoons red wine vinegar"
                ],
                "ingredients": [
                    {
                        "text": "One 8-ounce hoagie roll",
                        "weight": 226.796185,
                        "foodCategory": "bread, rolls and tortillas",
                        "foodId": "food_bjgi1gya7g98bva7qbz2ebwmd5we",
                        "image": "https://www.edamam.com/food-img/889/889777c512071dc12fab0721bb871905.jpg"
                    },
                    {
                        "text": "2 tablespoons vegan mayonnaise",
                        "weight": 30,
                        "foodCategory": "condiments and sauces",
                        "foodId": "food_adwabpvayhkfdbaz07tv6b68sgd1",
                        "image": "https://www.edamam.com/food-img/443/443b9f86c8a9ddb82d157e267212aeb6.jpg"
                    },
                    {
                        "text": "2 ounces vegan pastrami",
                        "weight": 56.69904625,
                        "foodCategory": "cured meats",
                        "foodId": "food_aygla9eaza2uk2a99v1gka2fgimf",
                        "image": "https://www.edamam.com/food-img/740/740b2bb48a103bedadfceebde8d68b83.jpg"
                    },
                    {
                        "text": "2 ounces vegan pepperoni",
                        "weight": 56.69904625,
                        "foodCategory": "Cured meats",
                        "foodId": "food_al5qjzna5bpefha4cy7odah0wwt2",
                        "image": "https://www.edamam.com/food-img/10b/10b28aa71cbe520aef944186f2b365b9.jpg"
                    },
                    {
                        "text": "2 ounces vegan mozzarella cheese",
                        "weight": 56.69904625,
                        "foodCategory": "Cheese",
                        "foodId": "food_bdofwyyb2xhmb1bx3uyz9broefm7",
                        "image": "https://www.edamam.com/food-img/8dc/8dcc66cd29b3f5c76d55cdbe046ad860.jpg"
                    },
                    {
                        "text": "1/8 red onion, sliced thin",
                        "weight": 7.8125,
                        "foodCategory": "vegetables",
                        "foodId": "food_bmrvi4ob4binw9a5m7l07amlfcoy",
                        "image": "https://www.edamam.com/food-img/205/205e6bf2399b85d34741892ef91cc603.jpg"
                    },
                    {
                        "text": "4 thin slices tomato",
                        "weight": 60,
                        "foodCategory": "vegetables",
                        "foodId": "food_a6k79rrahp8fe2b26zussa3wtkqh",
                        "image": "https://www.edamam.com/food-img/23e/23e727a14f1035bdc2733bb0477efbd2.jpg"
                    },
                    {
                        "text": "1/3 cup shredded lettuce",
                        "weight": 18.333333333333332,
                        "foodCategory": "vegetables",
                        "foodId": "food_bf5fxtkbc9alwoajuvsi7amonr5w",
                        "image": "https://www.edamam.com/food-img/719/71996625d0cb47e197093ecd52c97dc2.jpg"
                    },
                    {
                        "text": "2 tablespoons sweet pepper relish",
                        "weight": 30,
                        "foodCategory": "condiments and sauces",
                        "foodId": "food_bdpk447bepyyfma1ali5qbk50zqp",
                        "image": "https://www.edamam.com/food-img/210/210a09427be497df1915356d63d91d8b.jpeg"
                    },
                    {
                        "text": "1/8 teaspoon salt",
                        "weight": 0.75,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_btxz81db72hwbra2pncvebzzzum9",
                        "image": "https://www.edamam.com/food-img/694/6943ea510918c6025795e8dc6e6eaaeb.jpg"
                    },
                    {
                        "text": "1/4 teaspoon black pepper",
                        "weight": 0.725,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_b6ywzluaaxv02wad7s1r9ag4py89",
                        "image": "https://www.edamam.com/food-img/c6e/c6e5c3bd8d3bc15175d9766971a4d1b2.jpg"
                    },
                    {
                        "text": "1/4 teaspoon oregano",
                        "weight": 0.25,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_bkkw6v3bdf0sqiazmzyuiax7i8jr",
                        "image": "https://www.edamam.com/food-img/1b0/1b0eaffb1c261606e0d82fed8e9747a7.jpg"
                    },
                    {
                        "text": "2 tablespoons sunflower oil",
                        "weight": 27.2,
                        "foodCategory": "Oils",
                        "foodId": "food_b09yz1nbx49rv1bss5kgxat77cvn",
                        "image": "https://www.edamam.com/food-img/be4/be4dba2bb618ecda2213ac422ae05289.jpg"
                    },
                    {
                        "text": "2 tablespoons red wine vinegar",
                        "weight": 29.8,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_ad6iyy1anmzb49a817rgnabnz8c9",
                        "image": "https://www.edamam.com/food-img/dc8/dc8e998b32b8d45ba15c1b1e6711e958.jpg"
                    }
                ],
                "calories": 1532.7805369458335,
                "totalWeight": 601.0141570833333,
                "totalTime": 10,
                "cuisineType": [
                    "italian",
                    "american"
                ],
                "mealType": [
                    "lunch/dinner"
                ],
                "dishType": [
                    "sandwiches"
                ],
                "totalNutrients": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 1532.7805369458335,
                        "unit": "kcal"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 81.72530985058333,
                        "unit": "g"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 18.69932802541667,
                        "unit": "g"
                    },
                    "FATRN": {
                        "label": "Trans",
                        "quantity": 0.9723624157250002,
                        "unit": "g"
                    },
                    "FAMS": {
                        "label": "Monounsaturated",
                        "quantity": 33.15216876575417,
                        "unit": "g"
                    },
                    "FAPU": {
                        "label": "Polyunsaturated",
                        "quantity": 19.8992686733125,
                        "unit": "g"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 143.10138401720837,
                        "unit": "g"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 9.261632086666667,
                        "unit": "g"
                    },
                    "SUGAR": {
                        "label": "Sugars",
                        "quantity": 25.270879800458335,
                        "unit": "g"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 54.21951118862501,
                        "unit": "g"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 98.0893500125,
                        "unit": "mg"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 3781.9051584166673,
                        "unit": "mg"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 610.3981969416667,
                        "unit": "mg"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 120.12281687083335,
                        "unit": "mg"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 1042.7334808333335,
                        "unit": "mg"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 9.594453257833335,
                        "unit": "mg"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 7.709116429166669,
                        "unit": "mg"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 766.1600028375,
                        "unit": "mg"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 323.8503963708333,
                        "unit": "µg"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 10.554897842083333,
                        "unit": "mg"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 1.4841201678125002,
                        "unit": "mg"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 1.2519878126291668,
                        "unit": "mg"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 15.643820314062504,
                        "unit": "mg"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 0.5304476345458334,
                        "unit": "mg"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 423.0428011583333,
                        "unit": "µg"
                    },
                    "FOLFD": {
                        "label": "Folate (food)",
                        "quantity": 114.59998955833336,
                        "unit": "µg"
                    },
                    "FOLAC": {
                        "label": "Folic acid",
                        "quantity": 181.43694800000003,
                        "unit": "µg"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 2.500427939625,
                        "unit": "µg"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 0.17009713875000004,
                        "unit": "µg"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 13.290308861375,
                        "unit": "mg"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 77.23088479875,
                        "unit": "µg"
                    },
                    "WATER": {
                        "label": "Water",
                        "quantity": 306.9766106482916,
                        "unit": "g"
                    }
                },
                "totalDaily": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 76.63902684729167,
                        "unit": "%"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 125.73124592397434,
                        "unit": "%"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 93.49664012708334,
                        "unit": "%"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 47.700461339069456,
                        "unit": "%"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 37.04652834666667,
                        "unit": "%"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 108.43902237725003,
                        "unit": "%"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 32.696450004166664,
                        "unit": "%"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 157.57938160069446,
                        "unit": "%"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 61.03981969416667,
                        "unit": "%"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 28.600670683531746,
                        "unit": "%"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 22.185818741134753,
                        "unit": "%"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 53.302518099074085,
                        "unit": "%"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 70.0828766287879,
                        "unit": "%"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 109.4514289767857,
                        "unit": "%"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 35.983377374537035,
                        "unit": "%"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 11.727664268981481,
                        "unit": "%"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 123.67668065104169,
                        "unit": "%"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 96.30675481762822,
                        "unit": "%"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 97.77387696289065,
                        "unit": "%"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 40.80366419583334,
                        "unit": "%"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 105.76070028958333,
                        "unit": "%"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 104.18449748437502,
                        "unit": "%"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 1.1339809250000001,
                        "unit": "%"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 88.60205907583332,
                        "unit": "%"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 64.359070665625,
                        "unit": "%"
                    }
                },
                "digest": [
                    {
                        "label": "Fat",
                        "tag": "FAT",
                        "schemaOrgTag": "fatContent",
                        "total": 81.72530985058333,
                        "hasRDI": true,
                        "daily": 125.73124592397434,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Saturated",
                                "tag": "FASAT",
                                "schemaOrgTag": "saturatedFatContent",
                                "total": 18.69932802541667,
                                "hasRDI": true,
                                "daily": 93.49664012708334,
                                "unit": "g"
                            },
                            {
                                "label": "Trans",
                                "tag": "FATRN",
                                "schemaOrgTag": "transFatContent",
                                "total": 0.9723624157250002,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Monounsaturated",
                                "tag": "FAMS",
                                "schemaOrgTag": null,
                                "total": 33.15216876575417,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Polyunsaturated",
                                "tag": "FAPU",
                                "schemaOrgTag": null,
                                "total": 19.8992686733125,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Carbs",
                        "tag": "CHOCDF",
                        "schemaOrgTag": "carbohydrateContent",
                        "total": 143.10138401720837,
                        "hasRDI": true,
                        "daily": 47.700461339069456,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Carbs (net)",
                                "tag": "CHOCDF.net",
                                "schemaOrgTag": null,
                                "total": 133.8397519305417,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Fiber",
                                "tag": "FIBTG",
                                "schemaOrgTag": "fiberContent",
                                "total": 9.261632086666667,
                                "hasRDI": true,
                                "daily": 37.04652834666667,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars",
                                "tag": "SUGAR",
                                "schemaOrgTag": "sugarContent",
                                "total": 25.270879800458335,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars, added",
                                "tag": "SUGAR.added",
                                "schemaOrgTag": null,
                                "total": 0,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Protein",
                        "tag": "PROCNT",
                        "schemaOrgTag": "proteinContent",
                        "total": 54.21951118862501,
                        "hasRDI": true,
                        "daily": 108.43902237725003,
                        "unit": "g"
                    },
                    {
                        "label": "Cholesterol",
                        "tag": "CHOLE",
                        "schemaOrgTag": "cholesterolContent",
                        "total": 98.0893500125,
                        "hasRDI": true,
                        "daily": 32.696450004166664,
                        "unit": "mg"
                    },
                    {
                        "label": "Sodium",
                        "tag": "NA",
                        "schemaOrgTag": "sodiumContent",
                        "total": 3781.9051584166673,
                        "hasRDI": true,
                        "daily": 157.57938160069446,
                        "unit": "mg"
                    },
                    {
                        "label": "Calcium",
                        "tag": "CA",
                        "schemaOrgTag": null,
                        "total": 610.3981969416667,
                        "hasRDI": true,
                        "daily": 61.03981969416667,
                        "unit": "mg"
                    },
                    {
                        "label": "Magnesium",
                        "tag": "MG",
                        "schemaOrgTag": null,
                        "total": 120.12281687083335,
                        "hasRDI": true,
                        "daily": 28.600670683531746,
                        "unit": "mg"
                    },
                    {
                        "label": "Potassium",
                        "tag": "K",
                        "schemaOrgTag": null,
                        "total": 1042.7334808333335,
                        "hasRDI": true,
                        "daily": 22.185818741134753,
                        "unit": "mg"
                    },
                    {
                        "label": "Iron",
                        "tag": "FE",
                        "schemaOrgTag": null,
                        "total": 9.594453257833335,
                        "hasRDI": true,
                        "daily": 53.302518099074085,
                        "unit": "mg"
                    },
                    {
                        "label": "Zinc",
                        "tag": "ZN",
                        "schemaOrgTag": null,
                        "total": 7.709116429166669,
                        "hasRDI": true,
                        "daily": 70.0828766287879,
                        "unit": "mg"
                    },
                    {
                        "label": "Phosphorus",
                        "tag": "P",
                        "schemaOrgTag": null,
                        "total": 766.1600028375,
                        "hasRDI": true,
                        "daily": 109.4514289767857,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin A",
                        "tag": "VITA_RAE",
                        "schemaOrgTag": null,
                        "total": 323.8503963708333,
                        "hasRDI": true,
                        "daily": 35.983377374537035,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin C",
                        "tag": "VITC",
                        "schemaOrgTag": null,
                        "total": 10.554897842083333,
                        "hasRDI": true,
                        "daily": 11.727664268981481,
                        "unit": "mg"
                    },
                    {
                        "label": "Thiamin (B1)",
                        "tag": "THIA",
                        "schemaOrgTag": null,
                        "total": 1.4841201678125002,
                        "hasRDI": true,
                        "daily": 123.67668065104169,
                        "unit": "mg"
                    },
                    {
                        "label": "Riboflavin (B2)",
                        "tag": "RIBF",
                        "schemaOrgTag": null,
                        "total": 1.2519878126291668,
                        "hasRDI": true,
                        "daily": 96.30675481762822,
                        "unit": "mg"
                    },
                    {
                        "label": "Niacin (B3)",
                        "tag": "NIA",
                        "schemaOrgTag": null,
                        "total": 15.643820314062504,
                        "hasRDI": true,
                        "daily": 97.77387696289065,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin B6",
                        "tag": "VITB6A",
                        "schemaOrgTag": null,
                        "total": 0.5304476345458334,
                        "hasRDI": true,
                        "daily": 40.80366419583334,
                        "unit": "mg"
                    },
                    {
                        "label": "Folate equivalent (total)",
                        "tag": "FOLDFE",
                        "schemaOrgTag": null,
                        "total": 423.0428011583333,
                        "hasRDI": true,
                        "daily": 105.76070028958333,
                        "unit": "µg"
                    },
                    {
                        "label": "Folate (food)",
                        "tag": "FOLFD",
                        "schemaOrgTag": null,
                        "total": 114.59998955833336,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Folic acid",
                        "tag": "FOLAC",
                        "schemaOrgTag": null,
                        "total": 181.43694800000003,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin B12",
                        "tag": "VITB12",
                        "schemaOrgTag": null,
                        "total": 2.500427939625,
                        "hasRDI": true,
                        "daily": 104.18449748437502,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin D",
                        "tag": "VITD",
                        "schemaOrgTag": null,
                        "total": 0.17009713875000004,
                        "hasRDI": true,
                        "daily": 1.1339809250000001,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin E",
                        "tag": "TOCPHA",
                        "schemaOrgTag": null,
                        "total": 13.290308861375,
                        "hasRDI": true,
                        "daily": 88.60205907583332,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin K",
                        "tag": "VITK1",
                        "schemaOrgTag": null,
                        "total": 77.23088479875,
                        "hasRDI": true,
                        "daily": 64.359070665625,
                        "unit": "µg"
                    },
                    {
                        "label": "Sugar alcohols",
                        "tag": "Sugar.alcohol",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    },
                    {
                        "label": "Water",
                        "tag": "WATER",
                        "schemaOrgTag": null,
                        "total": 306.9766106482916,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    }
                ]
            },
            "_links": {
                "self": {
                    "href": "https://api.edamam.com/api/recipes/v2/c605065c1f35288532c1ad312b7af40d?type=public&app_id=ea1d37d5&app_key=fd382a172ba8d6668c0430dc9c14a181",
                    "title": "Self"
                }
            }
        },
        {
            "recipe": {
                "uri": "http://www.edamam.com/ontologies/edamam.owl#recipe_25ad6f957a7e91ad513a9bbc9dae95f5",
                "label": "Vegan Chocolate Pie",
                "image": "https://www.edamam.com/web-img/02f/02f619a93a4f6e1789359c3b5bad6368.jpg",
                "source": "Food52",
                "url": "https://food52.com/recipes/25316-vegan-chocolate-pie",
                "shareAs": "http://www.edamam.com/recipe/vegan-chocolate-pie-25ad6f957a7e91ad513a9bbc9dae95f5/vegan",
                "yield": 10,
                "dietLabels": [],
                "healthLabels": [
                    "Vegetarian",
                    "Pescatarian",
                    "Egg-Free",
                    "Peanut-Free",
                    "Fish-Free",
                    "Shellfish-Free",
                    "Pork-Free",
                    "Red-Meat-Free",
                    "Crustacean-Free",
                    "Celery-Free",
                    "Mustard-Free",
                    "Sesame-Free",
                    "Lupine-Free",
                    "Mollusk-Free",
                    "Alcohol-Free",
                    "Kosher"
                ],
                "cautions": [
                    "Gluten",
                    "Wheat",
                    "Tree-Nuts",
                    "Sulfites"
                ],
                "ingredientLines": [
                    "1 12.3-ounce package of extra firm, silken tofu",
                    "1 1/2 teaspoons vanilla extract",
                    "3 tablespoons almond, rice, or soy milk",
                    "1 pinch sea salt",
                    "2 tablespoons maple syrup (or to taste)",
                    "1 1/2 cups vegan dark chocolate chips (semi-sweet)",
                    "1 easy vegan graham cracker crust, recipe to follow",
                    "12 graham cracker sheets",
                    "2 tablespoons organic brown sugar",
                    "1/4 cup melted coconut oil"
                ],
                "ingredients": [
                    {
                        "text": "1 12.3-ounce package of extra firm, silken tofu",
                        "weight": 348.69913984474243,
                        "foodCategory": "plant-based protein",
                        "foodId": "food_a269ixea1yf51xbfwgnq2boiwc7x",
                        "image": "https://www.edamam.com/food-img/b6a/b6ae13c3cfe37e16f820840f90231bff.jpg"
                    },
                    {
                        "text": "1 1/2 teaspoons vanilla extract",
                        "weight": 6.300000000000001,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_bh1wvnqaw3q7ciascfoygaabax2a",
                        "image": "https://www.edamam.com/food-img/90f/90f910b0bf82750d4f6528263e014cca.jpg"
                    },
                    {
                        "text": "3 tablespoons almond, rice, or soy milk",
                        "weight": 36.56249999938184,
                        "foodCategory": "grains",
                        "foodId": "food_bpumdjzb5rtqaeabb0kbgbcgr4t9",
                        "image": "https://www.edamam.com/food-img/0fc/0fc9fa8a3e0276198d75b2e259068f8a.jpg"
                    },
                    {
                        "text": "1 pinch sea salt",
                        "weight": 0.30338541705136723,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_a1vgrj1bs8rd1majvmd9ubz8ttkg",
                        "image": "https://www.edamam.com/food-img/694/6943ea510918c6025795e8dc6e6eaaeb.jpg"
                    },
                    {
                        "text": "2 tablespoons maple syrup (or to taste)",
                        "weight": 40,
                        "foodCategory": "sugars",
                        "foodId": "food_bo37p69bopqshvaul0bn4bv0kqni",
                        "image": "https://www.edamam.com/food-img/ced/ced25c45453a118e531c8aaf33e2ee38.jpg"
                    },
                    {
                        "text": "1 1/2 cups vegan dark chocolate chips (semi-sweet)",
                        "weight": 273,
                        "foodCategory": "chocolate",
                        "foodId": "food_afwurvlasugs4ibig02xbblph5bn",
                        "image": "https://www.edamam.com/food-img/3cf/3cf0e13350f43392dc13c07d27ad145d.jpg"
                    },
                    {
                        "text": "1 easy vegan graham cracker crust, recipe to follow",
                        "weight": 183,
                        "foodCategory": "quick breads and pastries",
                        "foodId": "food_b8vrgr0brtdwj0b3m6qo0a2ychpk",
                        "image": "https://www.edamam.com/food-img/50b/50b797ae3aebfd0e60bf592ca2cec80e.jpg"
                    },
                    {
                        "text": "12 graham cracker sheets",
                        "weight": 168,
                        "foodCategory": "pastries",
                        "foodId": "food_aipm8mobslonobbbkxmhbb8a4iox",
                        "image": "https://www.edamam.com/food-img/448/448b5544a8ac969e88525f6bc44f5c12.jpg"
                    },
                    {
                        "text": "2 tablespoons organic brown sugar",
                        "weight": 18.12499999969356,
                        "foodCategory": "sugars",
                        "foodId": "food_aodgtqwbmeu5f6bxeffn0art3bga",
                        "image": "https://www.edamam.com/food-img/8c6/8c6662bd73900645c6385b51a95d9b03.jpg"
                    },
                    {
                        "text": "1/4 cup melted coconut oil",
                        "weight": 54.5,
                        "foodCategory": "Oils",
                        "foodId": "food_b40ubq8a0enoidbcr1tmfbwgs6aw",
                        "image": "https://www.edamam.com/food-img/3c9/3c97284c57e76e16093d51572b558be8.jpg"
                    }
                ],
                "calories": 4308.29339788793,
                "totalWeight": 1128.490025260869,
                "totalTime": 0,
                "cuisineType": [
                    "american"
                ],
                "mealType": [
                    "lunch/dinner"
                ],
                "dishType": [
                    "desserts"
                ],
                "totalNutrients": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 4308.29339788793,
                        "unit": "kcal"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 248.90739663152218,
                        "unit": "g"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 128.95955232685915,
                        "unit": "g"
                    },
                    "FATRN": {
                        "label": "Trans",
                        "quantity": 0.1743,
                        "unit": "g"
                    },
                    "FAMS": {
                        "label": "Monounsaturated",
                        "quantity": 77.59274957949543,
                        "unit": "g"
                    },
                    "FAPU": {
                        "label": "Polyunsaturated",
                        "quantity": 22.841766443813725,
                        "unit": "g"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 453.7382654625851,
                        "unit": "g"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 42.08429225860267,
                        "unit": "g"
                    },
                    "SUGAR": {
                        "label": "Sugars",
                        "quantity": 185.07661983877114,
                        "unit": "g"
                    },
                    "SUGAR.added": {
                        "label": "Sugars, added",
                        "quantity": 107.26157499970269,
                        "unit": "g"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 72.85567080324317,
                        "unit": "g"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 8.19,
                        "unit": "mg"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 1857.887641722046,
                        "unit": "mg"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 1142.5054585877147,
                        "unit": "mg"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 884.3358405964813,
                        "unit": "mg"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 3110.1129978026433,
                        "unit": "mg"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 49.70500482336951,
                        "unit": "mg"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 16.85559874612115,
                        "unit": "mg"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 1829.0664592114583,
                        "unit": "mg"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 5.46,
                        "unit": "µg"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 0.697398279689485,
                        "unit": "mg"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 1.1366462339064127,
                        "unit": "mg"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 1.8865054581018912,
                        "unit": "mg"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 17.243838631232965,
                        "unit": "mg"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 0.8153612642887451,
                        "unit": "mg"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 485.79471157044236,
                        "unit": "µg"
                    },
                    "FOLFD": {
                        "label": "Folate (food)",
                        "quantity": 136.41471157044236,
                        "unit": "µg"
                    },
                    "FOLAC": {
                        "label": "Folic acid",
                        "quantity": 205.14,
                        "unit": "µg"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 0.7644000000000001,
                        "unit": "µg"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 0,
                        "unit": "µg"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 7.616919913984474,
                        "unit": "mg"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 92.48827935627382,
                        "unit": "µg"
                    },
                    "WATER": {
                        "label": "Water",
                        "quantity": 334.877247318859,
                        "unit": "g"
                    }
                },
                "totalDaily": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 215.4146698943965,
                        "unit": "%"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 382.934456356188,
                        "unit": "%"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 644.7977616342957,
                        "unit": "%"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 151.24608848752837,
                        "unit": "%"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 168.3371690344107,
                        "unit": "%"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 145.71134160648634,
                        "unit": "%"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 2.73,
                        "unit": "%"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 77.41198507175191,
                        "unit": "%"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 114.25054585877147,
                        "unit": "%"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 210.55615252297173,
                        "unit": "%"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 66.17261697452432,
                        "unit": "%"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 276.13891568538617,
                        "unit": "%"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 153.23271587382862,
                        "unit": "%"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 261.29520845877977,
                        "unit": "%"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 0.6066666666666667,
                        "unit": "%"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 0.7748869774327611,
                        "unit": "%"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 94.72051949220106,
                        "unit": "%"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 145.11580446937626,
                        "unit": "%"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 107.77399144520604,
                        "unit": "%"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 62.72009725298039,
                        "unit": "%"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 121.44867789261059,
                        "unit": "%"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 31.850000000000005,
                        "unit": "%"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 0,
                        "unit": "%"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 50.77946609322983,
                        "unit": "%"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 77.07356613022817,
                        "unit": "%"
                    }
                },
                "digest": [
                    {
                        "label": "Fat",
                        "tag": "FAT",
                        "schemaOrgTag": "fatContent",
                        "total": 248.90739663152218,
                        "hasRDI": true,
                        "daily": 382.934456356188,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Saturated",
                                "tag": "FASAT",
                                "schemaOrgTag": "saturatedFatContent",
                                "total": 128.95955232685915,
                                "hasRDI": true,
                                "daily": 644.7977616342957,
                                "unit": "g"
                            },
                            {
                                "label": "Trans",
                                "tag": "FATRN",
                                "schemaOrgTag": "transFatContent",
                                "total": 0.1743,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Monounsaturated",
                                "tag": "FAMS",
                                "schemaOrgTag": null,
                                "total": 77.59274957949543,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Polyunsaturated",
                                "tag": "FAPU",
                                "schemaOrgTag": null,
                                "total": 22.841766443813725,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Carbs",
                        "tag": "CHOCDF",
                        "schemaOrgTag": "carbohydrateContent",
                        "total": 453.7382654625851,
                        "hasRDI": true,
                        "daily": 151.24608848752837,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Carbs (net)",
                                "tag": "CHOCDF.net",
                                "schemaOrgTag": null,
                                "total": 411.65397320398245,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Fiber",
                                "tag": "FIBTG",
                                "schemaOrgTag": "fiberContent",
                                "total": 42.08429225860267,
                                "hasRDI": true,
                                "daily": 168.3371690344107,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars",
                                "tag": "SUGAR",
                                "schemaOrgTag": "sugarContent",
                                "total": 185.07661983877114,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars, added",
                                "tag": "SUGAR.added",
                                "schemaOrgTag": null,
                                "total": 107.26157499970269,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Protein",
                        "tag": "PROCNT",
                        "schemaOrgTag": "proteinContent",
                        "total": 72.85567080324317,
                        "hasRDI": true,
                        "daily": 145.71134160648634,
                        "unit": "g"
                    },
                    {
                        "label": "Cholesterol",
                        "tag": "CHOLE",
                        "schemaOrgTag": "cholesterolContent",
                        "total": 8.19,
                        "hasRDI": true,
                        "daily": 2.73,
                        "unit": "mg"
                    },
                    {
                        "label": "Sodium",
                        "tag": "NA",
                        "schemaOrgTag": "sodiumContent",
                        "total": 1857.887641722046,
                        "hasRDI": true,
                        "daily": 77.41198507175191,
                        "unit": "mg"
                    },
                    {
                        "label": "Calcium",
                        "tag": "CA",
                        "schemaOrgTag": null,
                        "total": 1142.5054585877147,
                        "hasRDI": true,
                        "daily": 114.25054585877147,
                        "unit": "mg"
                    },
                    {
                        "label": "Magnesium",
                        "tag": "MG",
                        "schemaOrgTag": null,
                        "total": 884.3358405964813,
                        "hasRDI": true,
                        "daily": 210.55615252297173,
                        "unit": "mg"
                    },
                    {
                        "label": "Potassium",
                        "tag": "K",
                        "schemaOrgTag": null,
                        "total": 3110.1129978026433,
                        "hasRDI": true,
                        "daily": 66.17261697452432,
                        "unit": "mg"
                    },
                    {
                        "label": "Iron",
                        "tag": "FE",
                        "schemaOrgTag": null,
                        "total": 49.70500482336951,
                        "hasRDI": true,
                        "daily": 276.13891568538617,
                        "unit": "mg"
                    },
                    {
                        "label": "Zinc",
                        "tag": "ZN",
                        "schemaOrgTag": null,
                        "total": 16.85559874612115,
                        "hasRDI": true,
                        "daily": 153.23271587382862,
                        "unit": "mg"
                    },
                    {
                        "label": "Phosphorus",
                        "tag": "P",
                        "schemaOrgTag": null,
                        "total": 1829.0664592114583,
                        "hasRDI": true,
                        "daily": 261.29520845877977,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin A",
                        "tag": "VITA_RAE",
                        "schemaOrgTag": null,
                        "total": 5.46,
                        "hasRDI": true,
                        "daily": 0.6066666666666667,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin C",
                        "tag": "VITC",
                        "schemaOrgTag": null,
                        "total": 0.697398279689485,
                        "hasRDI": true,
                        "daily": 0.7748869774327611,
                        "unit": "mg"
                    },
                    {
                        "label": "Thiamin (B1)",
                        "tag": "THIA",
                        "schemaOrgTag": null,
                        "total": 1.1366462339064127,
                        "hasRDI": true,
                        "daily": 94.72051949220106,
                        "unit": "mg"
                    },
                    {
                        "label": "Riboflavin (B2)",
                        "tag": "RIBF",
                        "schemaOrgTag": null,
                        "total": 1.8865054581018912,
                        "hasRDI": true,
                        "daily": 145.11580446937626,
                        "unit": "mg"
                    },
                    {
                        "label": "Niacin (B3)",
                        "tag": "NIA",
                        "schemaOrgTag": null,
                        "total": 17.243838631232965,
                        "hasRDI": true,
                        "daily": 107.77399144520604,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin B6",
                        "tag": "VITB6A",
                        "schemaOrgTag": null,
                        "total": 0.8153612642887451,
                        "hasRDI": true,
                        "daily": 62.72009725298039,
                        "unit": "mg"
                    },
                    {
                        "label": "Folate equivalent (total)",
                        "tag": "FOLDFE",
                        "schemaOrgTag": null,
                        "total": 485.79471157044236,
                        "hasRDI": true,
                        "daily": 121.44867789261059,
                        "unit": "µg"
                    },
                    {
                        "label": "Folate (food)",
                        "tag": "FOLFD",
                        "schemaOrgTag": null,
                        "total": 136.41471157044236,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Folic acid",
                        "tag": "FOLAC",
                        "schemaOrgTag": null,
                        "total": 205.14,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin B12",
                        "tag": "VITB12",
                        "schemaOrgTag": null,
                        "total": 0.7644000000000001,
                        "hasRDI": true,
                        "daily": 31.850000000000005,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin D",
                        "tag": "VITD",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": true,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin E",
                        "tag": "TOCPHA",
                        "schemaOrgTag": null,
                        "total": 7.616919913984474,
                        "hasRDI": true,
                        "daily": 50.77946609322983,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin K",
                        "tag": "VITK1",
                        "schemaOrgTag": null,
                        "total": 92.48827935627382,
                        "hasRDI": true,
                        "daily": 77.07356613022817,
                        "unit": "µg"
                    },
                    {
                        "label": "Sugar alcohols",
                        "tag": "Sugar.alcohol",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    },
                    {
                        "label": "Water",
                        "tag": "WATER",
                        "schemaOrgTag": null,
                        "total": 334.877247318859,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    }
                ]
            },
            "_links": {
                "self": {
                    "href": "https://api.edamam.com/api/recipes/v2/25ad6f957a7e91ad513a9bbc9dae95f5?type=public&app_id=ea1d37d5&app_key=fd382a172ba8d6668c0430dc9c14a181",
                    "title": "Self"
                }
            }
        },
        {
            "recipe": {
                "uri": "http://www.edamam.com/ontologies/edamam.owl#recipe_c8be54ad2789641fd8e28f5cf86e57aa",
                "label": "Vegan Mushroom Tea Sandwiches",
                "image": "https://www.edamam.com/web-img/02e/02e0b2f027fc35439ccc3ed33cd5bf46",
                "source": "Martha Stewart",
                "url": "https://www.marthastewart.com/1526081/vegan-mushroom-tea-sandwiches",
                "shareAs": "http://www.edamam.com/recipe/vegan-mushroom-tea-sandwiches-c8be54ad2789641fd8e28f5cf86e57aa/vegan",
                "yield": 6,
                "dietLabels": [],
                "healthLabels": [
                    "Sugar-Conscious",
                    "Kidney-Friendly",
                    "Vegan",
                    "Vegetarian",
                    "Pescatarian",
                    "Dairy-Free",
                    "Egg-Free",
                    "Peanut-Free",
                    "Tree-Nut-Free",
                    "Soy-Free",
                    "Fish-Free",
                    "Shellfish-Free",
                    "Pork-Free",
                    "Red-Meat-Free",
                    "Crustacean-Free",
                    "Celery-Free",
                    "Sesame-Free",
                    "Lupine-Free",
                    "Mollusk-Free",
                    "Alcohol-Free",
                    "Sulfite-Free",
                    "Kosher"
                ],
                "cautions": [
                    "Soy",
                    "Sulfites",
                    "FODMAP"
                ],
                "ingredientLines": [
                    "1 tablespoon extra-virgin olive oil",
                    "2 portobello mushrooms, stems and gills removed, finely chopped",
                    "Kosher salt and freshly ground pepper",
                    "2 teaspoons fresh lemon juice",
                    "1/2 cup vegan mayonnaise, such as Sir Kensington's",
                    "2 teaspoons wasabi paste",
                    "2 tablespoons finely chopped fresh chives",
                    "8 slices vegan white or pumpernickel sandwich bread, or a combination",
                    "1 cup arugula or micro-arugula"
                ],
                "ingredients": [
                    {
                        "text": "1 tablespoon extra-virgin olive oil",
                        "weight": 13.5,
                        "foodCategory": "Oils",
                        "foodId": "food_b1d1icuad3iktrbqby0hiagafaz7",
                        "image": "https://www.edamam.com/food-img/4d6/4d651eaa8a353647746290c7a9b29d84.jpg"
                    },
                    {
                        "text": "2 portobello mushrooms, stems and gills removed, finely chopped",
                        "weight": 168,
                        "foodCategory": "vegetables",
                        "foodId": "food_bikaydza0r1y3ja1c2nxxbqnynlg",
                        "image": "https://www.edamam.com/food-img/245/2457f8850f43817dfeb967825467ef1e.jpg"
                    },
                    {
                        "text": "Kosher salt and freshly ground pepper",
                        "weight": 3.4505000000047423,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_a1vgrj1bs8rd1majvmd9ubz8ttkg",
                        "image": "https://www.edamam.com/food-img/694/6943ea510918c6025795e8dc6e6eaaeb.jpg"
                    },
                    {
                        "text": "Kosher salt and freshly ground pepper",
                        "weight": 1.7252500000023712,
                        "foodCategory": "Condiments and sauces",
                        "foodId": "food_b6ywzluaaxv02wad7s1r9ag4py89",
                        "image": "https://www.edamam.com/food-img/c6e/c6e5c3bd8d3bc15175d9766971a4d1b2.jpg"
                    },
                    {
                        "text": "2 teaspoons fresh lemon juice",
                        "weight": 10.166666667182332,
                        "foodCategory": "100% juice",
                        "foodId": "food_bglm6vxahuauteb0n6ynfbg9eryu",
                        "image": "https://www.edamam.com/food-img/e31/e310952d214e78a4cb8b73f30ceeaaf2.jpg"
                    },
                    {
                        "text": "1/2 cup vegan mayonnaise, such as Sir Kensington's",
                        "weight": 120,
                        "foodCategory": "condiments and sauces",
                        "foodId": "food_adwabpvayhkfdbaz07tv6b68sgd1",
                        "image": "https://www.edamam.com/food-img/443/443b9f86c8a9ddb82d157e267212aeb6.jpg"
                    },
                    {
                        "text": "2 teaspoons wasabi paste",
                        "weight": 5.4166666669414,
                        "foodCategory": "vegetables",
                        "foodId": "food_b18ctxdbw2ktnpbejotkwbnalyrj",
                        "image": "https://www.edamam.com/food-img/0c6/0c67d35d19e2e49178846d3afa89ccd5.jpg"
                    },
                    {
                        "text": "2 tablespoons finely chopped fresh chives",
                        "weight": 6,
                        "foodCategory": "vegetables",
                        "foodId": "food_btg1uzjak79lawbirsitkaeai60l",
                        "image": "https://www.edamam.com/food-img/f3f/f3f48643a924ba174b894e979cb48620.jpg"
                    },
                    {
                        "text": "8 slices vegan white or pumpernickel sandwich bread, or a combination",
                        "weight": 232,
                        "foodCategory": "bread, rolls and tortillas",
                        "foodId": "food_a3049hmbqj5wstaeeb3udaz6uaqv",
                        "image": "https://www.edamam.com/food-img/886/886960f6ce6ccec5b9163bacf2996853.jpg"
                    },
                    {
                        "text": "1 cup arugula or micro-arugula",
                        "weight": 20,
                        "foodCategory": "vegetables",
                        "foodId": "food_a8z1kzrawhksuzav2g1irb6zf4zc",
                        "image": "https://www.edamam.com/food-img/fa7/fa761a311efc0ec361a5eba4ed71870e.jpeg"
                    }
                ],
                "calories": 1181.4112108337522,
                "totalWeight": 576.8085833341261,
                "totalTime": 25,
                "cuisineType": [
                    "american"
                ],
                "mealType": [
                    "lunch/dinner"
                ],
                "dishType": [
                    "sandwiches"
                ],
                "totalNutrients": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 1181.4112108337522,
                        "unit": "kcal"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 60.04336815000304,
                        "unit": "g"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 7.326762146666906,
                        "unit": "g"
                    },
                    "FATRN": {
                        "label": "Trans",
                        "quantity": 0.25064,
                        "unit": "g"
                    },
                    "FAMS": {
                        "label": "Monounsaturated",
                        "quantity": 17.615634597500048,
                        "unit": "g"
                    },
                    "FAPU": {
                        "label": "Polyunsaturated",
                        "quantity": 25.102017995000132,
                        "unit": "g"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 127.1820807084351,
                        "unit": "g"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 14.143488250023577,
                        "unit": "g"
                    },
                    "SUGAR": {
                        "label": "Sugars",
                        "quantity": 19.71944160001301,
                        "unit": "g"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 36.74223680834857,
                        "unit": "g"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 0,
                        "unit": "mg"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 2128.4975500000523,
                        "unit": "mg"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 430.04119083372643,
                        "unit": "mg"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 186.01767750022455,
                        "unit": "mg"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 1257.2219058354565,
                        "unit": "mg"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 9.636646775003472,
                        "unit": "mg"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 4.37216380833807,
                        "unit": "mg"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 607.6725616669314,
                        "unit": "mg"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 39.854150833339475,
                        "unit": "µg"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 13.154083333648009,
                        "unit": "mg"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 1.1467991033338194,
                        "unit": "mg"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 0.8882654500003947,
                        "unit": "mg"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 20.865357107502536,
                        "unit": "mg"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 0.57757881083433,
                        "unit": "mg"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 315.3216258334863,
                        "unit": "µg"
                    },
                    "FOLFD": {
                        "label": "Folate (food)",
                        "quantity": 236.4416258334863,
                        "unit": "µg"
                    },
                    "FOLAC": {
                        "label": "Folic acid",
                        "quantity": 46.4,
                        "unit": "µg"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 0.084,
                        "unit": "µg"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 0.504,
                        "unit": "µg"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 5.423442600000799,
                        "unit": "mg"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 120.88123425000387,
                        "unit": "µg"
                    },
                    "WATER": {
                        "label": "Water",
                        "quantity": 342.3218744839994,
                        "unit": "g"
                    }
                },
                "totalDaily": {
                    "ENERC_KCAL": {
                        "label": "Energy",
                        "quantity": 59.070560541687605,
                        "unit": "%"
                    },
                    "FAT": {
                        "label": "Fat",
                        "quantity": 92.37441253846622,
                        "unit": "%"
                    },
                    "FASAT": {
                        "label": "Saturated",
                        "quantity": 36.63381073333453,
                        "unit": "%"
                    },
                    "CHOCDF": {
                        "label": "Carbs",
                        "quantity": 42.394026902811696,
                        "unit": "%"
                    },
                    "FIBTG": {
                        "label": "Fiber",
                        "quantity": 56.573953000094306,
                        "unit": "%"
                    },
                    "PROCNT": {
                        "label": "Protein",
                        "quantity": 73.48447361669714,
                        "unit": "%"
                    },
                    "CHOLE": {
                        "label": "Cholesterol",
                        "quantity": 0,
                        "unit": "%"
                    },
                    "NA": {
                        "label": "Sodium",
                        "quantity": 88.68739791666886,
                        "unit": "%"
                    },
                    "CA": {
                        "label": "Calcium",
                        "quantity": 43.00411908337264,
                        "unit": "%"
                    },
                    "MG": {
                        "label": "Magnesium",
                        "quantity": 44.28992321433918,
                        "unit": "%"
                    },
                    "K": {
                        "label": "Potassium",
                        "quantity": 26.74940225181822,
                        "unit": "%"
                    },
                    "FE": {
                        "label": "Iron",
                        "quantity": 53.53692652779707,
                        "unit": "%"
                    },
                    "ZN": {
                        "label": "Zinc",
                        "quantity": 39.74694371216427,
                        "unit": "%"
                    },
                    "P": {
                        "label": "Phosphorus",
                        "quantity": 86.81036595241878,
                        "unit": "%"
                    },
                    "VITA_RAE": {
                        "label": "Vitamin A",
                        "quantity": 4.428238981482163,
                        "unit": "%"
                    },
                    "VITC": {
                        "label": "Vitamin C",
                        "quantity": 14.615648148497788,
                        "unit": "%"
                    },
                    "THIA": {
                        "label": "Thiamin (B1)",
                        "quantity": 95.56659194448495,
                        "unit": "%"
                    },
                    "RIBF": {
                        "label": "Riboflavin (B2)",
                        "quantity": 68.3281115384919,
                        "unit": "%"
                    },
                    "NIA": {
                        "label": "Niacin (B3)",
                        "quantity": 130.40848192189085,
                        "unit": "%"
                    },
                    "VITB6A": {
                        "label": "Vitamin B6",
                        "quantity": 44.42913929494846,
                        "unit": "%"
                    },
                    "FOLDFE": {
                        "label": "Folate equivalent (total)",
                        "quantity": 78.83040645837157,
                        "unit": "%"
                    },
                    "VITB12": {
                        "label": "Vitamin B12",
                        "quantity": 3.5000000000000004,
                        "unit": "%"
                    },
                    "VITD": {
                        "label": "Vitamin D",
                        "quantity": 3.36,
                        "unit": "%"
                    },
                    "TOCPHA": {
                        "label": "Vitamin E",
                        "quantity": 36.15628400000533,
                        "unit": "%"
                    },
                    "VITK1": {
                        "label": "Vitamin K",
                        "quantity": 100.73436187500323,
                        "unit": "%"
                    }
                },
                "digest": [
                    {
                        "label": "Fat",
                        "tag": "FAT",
                        "schemaOrgTag": "fatContent",
                        "total": 60.04336815000304,
                        "hasRDI": true,
                        "daily": 92.37441253846622,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Saturated",
                                "tag": "FASAT",
                                "schemaOrgTag": "saturatedFatContent",
                                "total": 7.326762146666906,
                                "hasRDI": true,
                                "daily": 36.63381073333453,
                                "unit": "g"
                            },
                            {
                                "label": "Trans",
                                "tag": "FATRN",
                                "schemaOrgTag": "transFatContent",
                                "total": 0.25064,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Monounsaturated",
                                "tag": "FAMS",
                                "schemaOrgTag": null,
                                "total": 17.615634597500048,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Polyunsaturated",
                                "tag": "FAPU",
                                "schemaOrgTag": null,
                                "total": 25.102017995000132,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Carbs",
                        "tag": "CHOCDF",
                        "schemaOrgTag": "carbohydrateContent",
                        "total": 127.1820807084351,
                        "hasRDI": true,
                        "daily": 42.394026902811696,
                        "unit": "g",
                        "sub": [
                            {
                                "label": "Carbs (net)",
                                "tag": "CHOCDF.net",
                                "schemaOrgTag": null,
                                "total": 113.03859245841151,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Fiber",
                                "tag": "FIBTG",
                                "schemaOrgTag": "fiberContent",
                                "total": 14.143488250023577,
                                "hasRDI": true,
                                "daily": 56.573953000094306,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars",
                                "tag": "SUGAR",
                                "schemaOrgTag": "sugarContent",
                                "total": 19.71944160001301,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            },
                            {
                                "label": "Sugars, added",
                                "tag": "SUGAR.added",
                                "schemaOrgTag": null,
                                "total": 0,
                                "hasRDI": false,
                                "daily": 0,
                                "unit": "g"
                            }
                        ]
                    },
                    {
                        "label": "Protein",
                        "tag": "PROCNT",
                        "schemaOrgTag": "proteinContent",
                        "total": 36.74223680834857,
                        "hasRDI": true,
                        "daily": 73.48447361669714,
                        "unit": "g"
                    },
                    {
                        "label": "Cholesterol",
                        "tag": "CHOLE",
                        "schemaOrgTag": "cholesterolContent",
                        "total": 0,
                        "hasRDI": true,
                        "daily": 0,
                        "unit": "mg"
                    },
                    {
                        "label": "Sodium",
                        "tag": "NA",
                        "schemaOrgTag": "sodiumContent",
                        "total": 2128.4975500000523,
                        "hasRDI": true,
                        "daily": 88.68739791666886,
                        "unit": "mg"
                    },
                    {
                        "label": "Calcium",
                        "tag": "CA",
                        "schemaOrgTag": null,
                        "total": 430.04119083372643,
                        "hasRDI": true,
                        "daily": 43.00411908337264,
                        "unit": "mg"
                    },
                    {
                        "label": "Magnesium",
                        "tag": "MG",
                        "schemaOrgTag": null,
                        "total": 186.01767750022455,
                        "hasRDI": true,
                        "daily": 44.28992321433918,
                        "unit": "mg"
                    },
                    {
                        "label": "Potassium",
                        "tag": "K",
                        "schemaOrgTag": null,
                        "total": 1257.2219058354565,
                        "hasRDI": true,
                        "daily": 26.74940225181822,
                        "unit": "mg"
                    },
                    {
                        "label": "Iron",
                        "tag": "FE",
                        "schemaOrgTag": null,
                        "total": 9.636646775003472,
                        "hasRDI": true,
                        "daily": 53.53692652779707,
                        "unit": "mg"
                    },
                    {
                        "label": "Zinc",
                        "tag": "ZN",
                        "schemaOrgTag": null,
                        "total": 4.37216380833807,
                        "hasRDI": true,
                        "daily": 39.74694371216427,
                        "unit": "mg"
                    },
                    {
                        "label": "Phosphorus",
                        "tag": "P",
                        "schemaOrgTag": null,
                        "total": 607.6725616669314,
                        "hasRDI": true,
                        "daily": 86.81036595241878,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin A",
                        "tag": "VITA_RAE",
                        "schemaOrgTag": null,
                        "total": 39.854150833339475,
                        "hasRDI": true,
                        "daily": 4.428238981482163,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin C",
                        "tag": "VITC",
                        "schemaOrgTag": null,
                        "total": 13.154083333648009,
                        "hasRDI": true,
                        "daily": 14.615648148497788,
                        "unit": "mg"
                    },
                    {
                        "label": "Thiamin (B1)",
                        "tag": "THIA",
                        "schemaOrgTag": null,
                        "total": 1.1467991033338194,
                        "hasRDI": true,
                        "daily": 95.56659194448495,
                        "unit": "mg"
                    },
                    {
                        "label": "Riboflavin (B2)",
                        "tag": "RIBF",
                        "schemaOrgTag": null,
                        "total": 0.8882654500003947,
                        "hasRDI": true,
                        "daily": 68.3281115384919,
                        "unit": "mg"
                    },
                    {
                        "label": "Niacin (B3)",
                        "tag": "NIA",
                        "schemaOrgTag": null,
                        "total": 20.865357107502536,
                        "hasRDI": true,
                        "daily": 130.40848192189085,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin B6",
                        "tag": "VITB6A",
                        "schemaOrgTag": null,
                        "total": 0.57757881083433,
                        "hasRDI": true,
                        "daily": 44.42913929494846,
                        "unit": "mg"
                    },
                    {
                        "label": "Folate equivalent (total)",
                        "tag": "FOLDFE",
                        "schemaOrgTag": null,
                        "total": 315.3216258334863,
                        "hasRDI": true,
                        "daily": 78.83040645837157,
                        "unit": "µg"
                    },
                    {
                        "label": "Folate (food)",
                        "tag": "FOLFD",
                        "schemaOrgTag": null,
                        "total": 236.4416258334863,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Folic acid",
                        "tag": "FOLAC",
                        "schemaOrgTag": null,
                        "total": 46.4,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin B12",
                        "tag": "VITB12",
                        "schemaOrgTag": null,
                        "total": 0.084,
                        "hasRDI": true,
                        "daily": 3.5000000000000004,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin D",
                        "tag": "VITD",
                        "schemaOrgTag": null,
                        "total": 0.504,
                        "hasRDI": true,
                        "daily": 3.36,
                        "unit": "µg"
                    },
                    {
                        "label": "Vitamin E",
                        "tag": "TOCPHA",
                        "schemaOrgTag": null,
                        "total": 5.423442600000799,
                        "hasRDI": true,
                        "daily": 36.15628400000533,
                        "unit": "mg"
                    },
                    {
                        "label": "Vitamin K",
                        "tag": "VITK1",
                        "schemaOrgTag": null,
                        "total": 120.88123425000387,
                        "hasRDI": true,
                        "daily": 100.73436187500323,
                        "unit": "µg"
                    },
                    {
                        "label": "Sugar alcohols",
                        "tag": "Sugar.alcohol",
                        "schemaOrgTag": null,
                        "total": 0,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    },
                    {
                        "label": "Water",
                        "tag": "WATER",
                        "schemaOrgTag": null,
                        "total": 342.3218744839994,
                        "hasRDI": false,
                        "daily": 0,
                        "unit": "g"
                    }
                ]
            },
            "_links": {
                "self": {
                    "href": "https://api.edamam.com/api/recipes/v2/c8be54ad2789641fd8e28f5cf86e57aa?type=public&app_id=ea1d37d5&app_key=fd382a172ba8d6668c0430dc9c14a181",
                    "title": "Self"
                }
            }
        }
    ]
};

export const recipes = {

    chicken: chickenRecipes,
    beef: beefRecipes,
    fish: fishRecipes,
    salad: saladRecipes,
    fruit: fruitRecipes,
    vegan: veganRecipes
};